(function polyfill() {
  const relList = document.createElement("link").relList;
  if (relList && relList.supports && relList.supports("modulepreload")) {
    return;
  }
  for (const link of document.querySelectorAll('link[rel="modulepreload"]')) {
    processPreload(link);
  }
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== "childList") {
        continue;
      }
      for (const node of mutation.addedNodes) {
        if (node.tagName === "LINK" && node.rel === "modulepreload")
          processPreload(node);
      }
    }
  }).observe(document, { childList: true, subtree: true });
  function getFetchOpts(link) {
    const fetchOpts = {};
    if (link.integrity) fetchOpts.integrity = link.integrity;
    if (link.referrerPolicy) fetchOpts.referrerPolicy = link.referrerPolicy;
    if (link.crossOrigin === "use-credentials")
      fetchOpts.credentials = "include";
    else if (link.crossOrigin === "anonymous") fetchOpts.credentials = "omit";
    else fetchOpts.credentials = "same-origin";
    return fetchOpts;
  }
  function processPreload(link) {
    if (link.ep)
      return;
    link.ep = true;
    const fetchOpts = getFetchOpts(link);
    fetch(link.href, fetchOpts);
  }
})();
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
  if (typeof f == "function") {
    var a = function a2() {
      if (this instanceof a2) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, "__esModule", { value: true });
  Object.keys(n).forEach(function(k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a;
}
var fabric = {};
const __viteBrowserExternal = {};
const __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" }));
const require$$2 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
/*! Fabric.js Copyright 2008-2015, Printio (Juriy Zaytsev, Maxim Chernyak) */
(function(exports) {
  var fabric2 = fabric2 || { version: "5.3.0" };
  {
    exports.fabric = fabric2;
  }
  if (typeof document !== "undefined" && typeof window !== "undefined") {
    if (document instanceof (typeof HTMLDocument !== "undefined" ? HTMLDocument : Document)) {
      fabric2.document = document;
    } else {
      fabric2.document = document.implementation.createHTMLDocument("");
    }
    fabric2.window = window;
  } else {
    var jsdom = require$$2;
    var virtualWindow = new jsdom.JSDOM(
      decodeURIComponent("%3C!DOCTYPE%20html%3E%3Chtml%3E%3Chead%3E%3C%2Fhead%3E%3Cbody%3E%3C%2Fbody%3E%3C%2Fhtml%3E"),
      {
        features: {
          FetchExternalResources: ["img"]
        },
        resources: "usable"
      }
    ).window;
    fabric2.document = virtualWindow.document;
    fabric2.jsdomImplForWrapper = require$$2.implForWrapper;
    fabric2.nodeCanvas = require$$2.Canvas;
    fabric2.window = virtualWindow;
    DOMParser = fabric2.window.DOMParser;
  }
  fabric2.isTouchSupported = "ontouchstart" in fabric2.window || "ontouchstart" in fabric2.document || fabric2.window && fabric2.window.navigator && fabric2.window.navigator.maxTouchPoints > 0;
  fabric2.isLikelyNode = typeof Buffer !== "undefined" && typeof window === "undefined";
  fabric2.SHARED_ATTRIBUTES = [
    "display",
    "transform",
    "fill",
    "fill-opacity",
    "fill-rule",
    "opacity",
    "stroke",
    "stroke-dasharray",
    "stroke-linecap",
    "stroke-dashoffset",
    "stroke-linejoin",
    "stroke-miterlimit",
    "stroke-opacity",
    "stroke-width",
    "id",
    "paint-order",
    "vector-effect",
    "instantiated_by_use",
    "clip-path"
  ];
  fabric2.DPI = 96;
  fabric2.reNum = "(?:[-+]?(?:\\d+|\\d*\\.\\d+)(?:[eE][-+]?\\d+)?)";
  fabric2.commaWsp = "(?:\\s+,?\\s*|,\\s*)";
  fabric2.rePathCommand = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:[eE][-+]?\d+)?)/ig;
  fabric2.reNonWord = /[ \n\.,;!\?\-]/;
  fabric2.fontPaths = {};
  fabric2.iMatrix = [1, 0, 0, 1, 0, 0];
  fabric2.svgNS = "http://www.w3.org/2000/svg";
  fabric2.perfLimitSizeTotal = 2097152;
  fabric2.maxCacheSideLimit = 4096;
  fabric2.minCacheSideLimit = 256;
  fabric2.charWidthsCache = {};
  fabric2.textureSize = 2048;
  fabric2.disableStyleCopyPaste = false;
  fabric2.enableGLFiltering = true;
  fabric2.devicePixelRatio = fabric2.window.devicePixelRatio || fabric2.window.webkitDevicePixelRatio || fabric2.window.mozDevicePixelRatio || 1;
  fabric2.browserShadowBlurConstant = 1;
  fabric2.arcToSegmentsCache = {};
  fabric2.boundsOfCurveCache = {};
  fabric2.cachesBoundsOfCurve = true;
  fabric2.forceGLPutImageData = false;
  fabric2.initFilterBackend = function() {
    if (fabric2.enableGLFiltering && fabric2.isWebglSupported && fabric2.isWebglSupported(fabric2.textureSize)) {
      return new fabric2.WebglFilterBackend({ tileSize: fabric2.textureSize });
    } else if (fabric2.Canvas2dFilterBackend) {
      return new fabric2.Canvas2dFilterBackend();
    }
  };
  if (typeof document !== "undefined" && typeof window !== "undefined") {
    window.fabric = fabric2;
  }
  (function() {
    function _removeEventListener(eventName, handler) {
      if (!this.__eventListeners[eventName]) {
        return;
      }
      var eventListener = this.__eventListeners[eventName];
      if (handler) {
        eventListener[eventListener.indexOf(handler)] = false;
      } else {
        fabric2.util.array.fill(eventListener, false);
      }
    }
    function on(eventName, handler) {
      if (!this.__eventListeners) {
        this.__eventListeners = {};
      }
      if (arguments.length === 1) {
        for (var prop in eventName) {
          this.on(prop, eventName[prop]);
        }
      } else {
        if (!this.__eventListeners[eventName]) {
          this.__eventListeners[eventName] = [];
        }
        this.__eventListeners[eventName].push(handler);
      }
      return this;
    }
    function _once(eventName, handler) {
      var _handler = (function() {
        handler.apply(this, arguments);
        this.off(eventName, _handler);
      }).bind(this);
      this.on(eventName, _handler);
    }
    function once3(eventName, handler) {
      if (arguments.length === 1) {
        for (var prop in eventName) {
          _once.call(this, prop, eventName[prop]);
        }
      } else {
        _once.call(this, eventName, handler);
      }
      return this;
    }
    function off(eventName, handler) {
      if (!this.__eventListeners) {
        return this;
      }
      if (arguments.length === 0) {
        for (eventName in this.__eventListeners) {
          _removeEventListener.call(this, eventName);
        }
      } else if (arguments.length === 1 && typeof arguments[0] === "object") {
        for (var prop in eventName) {
          _removeEventListener.call(this, prop, eventName[prop]);
        }
      } else {
        _removeEventListener.call(this, eventName, handler);
      }
      return this;
    }
    function fire(eventName, options) {
      if (!this.__eventListeners) {
        return this;
      }
      var listenersForEvent = this.__eventListeners[eventName];
      if (!listenersForEvent) {
        return this;
      }
      for (var i = 0, len = listenersForEvent.length; i < len; i++) {
        listenersForEvent[i] && listenersForEvent[i].call(this, options || {});
      }
      this.__eventListeners[eventName] = listenersForEvent.filter(function(value) {
        return value !== false;
      });
      return this;
    }
    fabric2.Observable = {
      fire,
      on,
      once: once3,
      off
    };
  })();
  fabric2.Collection = {
    _objects: [],
    /**
     * Adds objects to collection, Canvas or Group, then renders canvas
     * (if `renderOnAddRemove` is not `false`).
     * in case of Group no changes to bounding box are made.
     * Objects should be instances of (or inherit from) fabric.Object
     * Use of this function is highly discouraged for groups.
     * you can add a bunch of objects with the add method but then you NEED
     * to run a addWithUpdate call for the Group class or position/bbox will be wrong.
     * @param {...fabric.Object} object Zero or more fabric instances
     * @return {Self} thisArg
     * @chainable
     */
    add: function() {
      this._objects.push.apply(this._objects, arguments);
      if (this._onObjectAdded) {
        for (var i = 0, length = arguments.length; i < length; i++) {
          this._onObjectAdded(arguments[i]);
        }
      }
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },
    /**
     * Inserts an object into collection at specified index, then renders canvas (if `renderOnAddRemove` is not `false`)
     * An object should be an instance of (or inherit from) fabric.Object
     * Use of this function is highly discouraged for groups.
     * you can add a bunch of objects with the insertAt method but then you NEED
     * to run a addWithUpdate call for the Group class or position/bbox will be wrong.
     * @param {Object} object Object to insert
     * @param {Number} index Index to insert object at
     * @param {Boolean} nonSplicing When `true`, no splicing (shifting) of objects occurs
     * @return {Self} thisArg
     * @chainable
     */
    insertAt: function(object, index, nonSplicing) {
      var objects = this._objects;
      if (nonSplicing) {
        objects[index] = object;
      } else {
        objects.splice(index, 0, object);
      }
      this._onObjectAdded && this._onObjectAdded(object);
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },
    /**
     * Removes objects from a collection, then renders canvas (if `renderOnAddRemove` is not `false`)
     * @param {...fabric.Object} object Zero or more fabric instances
     * @return {Self} thisArg
     * @chainable
     */
    remove: function() {
      var objects = this._objects, index, somethingRemoved = false;
      for (var i = 0, length = arguments.length; i < length; i++) {
        index = objects.indexOf(arguments[i]);
        if (index !== -1) {
          somethingRemoved = true;
          objects.splice(index, 1);
          this._onObjectRemoved && this._onObjectRemoved(arguments[i]);
        }
      }
      this.renderOnAddRemove && somethingRemoved && this.requestRenderAll();
      return this;
    },
    /**
     * Executes given function for each object in this group
     * @param {Function} callback
     *                   Callback invoked with current object as first argument,
     *                   index - as second and an array of all objects - as third.
     *                   Callback is invoked in a context of Global Object (e.g. `window`)
     *                   when no `context` argument is given
     *
     * @param {Object} context Context (aka thisObject)
     * @return {Self} thisArg
     * @chainable
     */
    forEachObject: function(callback, context) {
      var objects = this.getObjects();
      for (var i = 0, len = objects.length; i < len; i++) {
        callback.call(context, objects[i], i, objects);
      }
      return this;
    },
    /**
     * Returns an array of children objects of this instance
     * Type parameter introduced in 1.3.10
     * since 2.3.5 this method return always a COPY of the array;
     * @param {String} [type] When specified, only objects of this type are returned
     * @return {Array}
     */
    getObjects: function(type) {
      if (typeof type === "undefined") {
        return this._objects.concat();
      }
      return this._objects.filter(function(o) {
        return o.type === type;
      });
    },
    /**
     * Returns object at specified index
     * @param {Number} index
     * @return {Self} thisArg
     */
    item: function(index) {
      return this._objects[index];
    },
    /**
     * Returns true if collection contains no objects
     * @return {Boolean} true if collection is empty
     */
    isEmpty: function() {
      return this._objects.length === 0;
    },
    /**
     * Returns a size of a collection (i.e: length of an array containing its objects)
     * @return {Number} Collection size
     */
    size: function() {
      return this._objects.length;
    },
    /**
     * Returns true if collection contains an object
     * @param {Object} object Object to check against
     * @param {Boolean} [deep=false] `true` to check all descendants, `false` to check only `_objects`
     * @return {Boolean} `true` if collection contains an object
     */
    contains: function(object, deep) {
      if (this._objects.indexOf(object) > -1) {
        return true;
      } else if (deep) {
        return this._objects.some(function(obj) {
          return typeof obj.contains === "function" && obj.contains(object, true);
        });
      }
      return false;
    },
    /**
     * Returns number representation of a collection complexity
     * @return {Number} complexity
     */
    complexity: function() {
      return this._objects.reduce(function(memo, current) {
        memo += current.complexity ? current.complexity() : 0;
        return memo;
      }, 0);
    }
  };
  fabric2.CommonMethods = {
    /**
     * Sets object's properties from options
     * @param {Object} [options] Options object
     */
    _setOptions: function(options) {
      for (var prop in options) {
        this.set(prop, options[prop]);
      }
    },
    /**
     * @private
     * @param {Object} [filler] Options object
     * @param {String} [property] property to set the Gradient to
     */
    _initGradient: function(filler, property) {
      if (filler && filler.colorStops && !(filler instanceof fabric2.Gradient)) {
        this.set(property, new fabric2.Gradient(filler));
      }
    },
    /**
     * @private
     * @param {Object} [filler] Options object
     * @param {String} [property] property to set the Pattern to
     * @param {Function} [callback] callback to invoke after pattern load
     */
    _initPattern: function(filler, property, callback) {
      if (filler && filler.source && !(filler instanceof fabric2.Pattern)) {
        this.set(property, new fabric2.Pattern(filler, callback));
      } else {
        callback && callback();
      }
    },
    /**
     * @private
     */
    _setObject: function(obj) {
      for (var prop in obj) {
        this._set(prop, obj[prop]);
      }
    },
    /**
     * Sets property to a given value. When changing position/dimension -related properties (left, top, scale, angle, etc.) `set` does not update position of object's borders/controls. If you need to update those, call `setCoords()`.
     * @param {String|Object} key Property name or object (if object, iterate over the object properties)
     * @param {Object|Function} value Property value (if function, the value is passed into it and its return value is used as a new one)
     * @return {fabric.Object} thisArg
     * @chainable
     */
    set: function(key, value) {
      if (typeof key === "object") {
        this._setObject(key);
      } else {
        this._set(key, value);
      }
      return this;
    },
    _set: function(key, value) {
      this[key] = value;
    },
    /**
     * Toggles specified property from `true` to `false` or from `false` to `true`
     * @param {String} property Property to toggle
     * @return {fabric.Object} thisArg
     * @chainable
     */
    toggle: function(property) {
      var value = this.get(property);
      if (typeof value === "boolean") {
        this.set(property, !value);
      }
      return this;
    },
    /**
     * Basic getter
     * @param {String} property Property name
     * @return {*} value of a property
     */
    get: function(property) {
      return this[property];
    }
  };
  (function(global) {
    var sqrt2 = Math.sqrt, atan22 = Math.atan2, pow2 = Math.pow, PiBy180 = Math.PI / 180, PiBy2 = Math.PI / 2;
    fabric2.util = {
      /**
       * Calculate the cos of an angle, avoiding returning floats for known results
       * @static
       * @memberOf fabric.util
       * @param {Number} angle the angle in radians or in degree
       * @return {Number}
       */
      cos: function(angle) {
        if (angle === 0) {
          return 1;
        }
        if (angle < 0) {
          angle = -angle;
        }
        var angleSlice = angle / PiBy2;
        switch (angleSlice) {
          case 1:
          case 3:
            return 0;
          case 2:
            return -1;
        }
        return Math.cos(angle);
      },
      /**
       * Calculate the sin of an angle, avoiding returning floats for known results
       * @static
       * @memberOf fabric.util
       * @param {Number} angle the angle in radians or in degree
       * @return {Number}
       */
      sin: function(angle) {
        if (angle === 0) {
          return 0;
        }
        var angleSlice = angle / PiBy2, sign2 = 1;
        if (angle < 0) {
          sign2 = -1;
        }
        switch (angleSlice) {
          case 1:
            return sign2;
          case 2:
            return 0;
          case 3:
            return -sign2;
        }
        return Math.sin(angle);
      },
      /**
       * Removes value from an array.
       * Presence of value (and its position in an array) is determined via `Array.prototype.indexOf`
       * @static
       * @memberOf fabric.util
       * @param {Array} array
       * @param {*} value
       * @return {Array} original array
       */
      removeFromArray: function(array, value) {
        var idx = array.indexOf(value);
        if (idx !== -1) {
          array.splice(idx, 1);
        }
        return array;
      },
      /**
       * Returns random number between 2 specified ones.
       * @static
       * @memberOf fabric.util
       * @param {Number} min lower limit
       * @param {Number} max upper limit
       * @return {Number} random value (between min and max)
       */
      getRandomInt: function(min2, max2) {
        return Math.floor(Math.random() * (max2 - min2 + 1)) + min2;
      },
      /**
       * Transforms degrees to radians.
       * @static
       * @memberOf fabric.util
       * @param {Number} degrees value in degrees
       * @return {Number} value in radians
       */
      degreesToRadians: function(degrees) {
        return degrees * PiBy180;
      },
      /**
       * Transforms radians to degrees.
       * @static
       * @memberOf fabric.util
       * @param {Number} radians value in radians
       * @return {Number} value in degrees
       */
      radiansToDegrees: function(radians) {
        return radians / PiBy180;
      },
      /**
       * Rotates `point` around `origin` with `radians`
       * @static
       * @memberOf fabric.util
       * @param {fabric.Point} point The point to rotate
       * @param {fabric.Point} origin The origin of the rotation
       * @param {Number} radians The radians of the angle for the rotation
       * @return {fabric.Point} The new rotated point
       */
      rotatePoint: function(point, origin, radians) {
        var newPoint = new fabric2.Point(point.x - origin.x, point.y - origin.y), v = fabric2.util.rotateVector(newPoint, radians);
        return new fabric2.Point(v.x, v.y).addEquals(origin);
      },
      /**
       * Rotates `vector` with `radians`
       * @static
       * @memberOf fabric.util
       * @param {Object} vector The vector to rotate (x and y)
       * @param {Number} radians The radians of the angle for the rotation
       * @return {Object} The new rotated point
       */
      rotateVector: function(vector, radians) {
        var sin2 = fabric2.util.sin(radians), cos2 = fabric2.util.cos(radians), rx = vector.x * cos2 - vector.y * sin2, ry = vector.x * sin2 + vector.y * cos2;
        return {
          x: rx,
          y: ry
        };
      },
      /**
       * Creates a vetor from points represented as a point
       * @static
       * @memberOf fabric.util
       *
       * @typedef {Object} Point
       * @property {number} x
       * @property {number} y
       *
       * @param {Point} from
       * @param {Point} to
       * @returns {Point} vector
       */
      createVector: function(from, to) {
        return new fabric2.Point(to.x - from.x, to.y - from.y);
      },
      /**
       * Calculates angle between 2 vectors using dot product
       * @static
       * @memberOf fabric.util
       * @param {Point} a
       * @param {Point} b
       * @returns the angle in radian between the vectors
       */
      calcAngleBetweenVectors: function(a, b) {
        return Math.acos((a.x * b.x + a.y * b.y) / (Math.hypot(a.x, a.y) * Math.hypot(b.x, b.y)));
      },
      /**
       * @static
       * @memberOf fabric.util
       * @param {Point} v
       * @returns {Point} vector representing the unit vector of pointing to the direction of `v`
       */
      getHatVector: function(v) {
        return new fabric2.Point(v.x, v.y).multiply(1 / Math.hypot(v.x, v.y));
      },
      /**
       * @static
       * @memberOf fabric.util
       * @param {Point} A
       * @param {Point} B
       * @param {Point} C
       * @returns {{ vector: Point, angle: number }} vector representing the bisector of A and A's angle
       */
      getBisector: function(A, B, C) {
        var AB = fabric2.util.createVector(A, B), AC = fabric2.util.createVector(A, C);
        var alpha = fabric2.util.calcAngleBetweenVectors(AB, AC);
        var ro = fabric2.util.calcAngleBetweenVectors(fabric2.util.rotateVector(AB, alpha), AC);
        var phi = alpha * (ro === 0 ? 1 : -1) / 2;
        return {
          vector: fabric2.util.getHatVector(fabric2.util.rotateVector(AB, phi)),
          angle: alpha
        };
      },
      /**
       * Project stroke width on points returning 2 projections for each point as follows:
       * - `miter`: 2 points corresponding to the outer boundary and the inner boundary of stroke.
       * - `bevel`: 2 points corresponding to the bevel boundaries, tangent to the bisector.
       * - `round`: same as `bevel`
       * Used to calculate object's bounding box
       * @static
       * @memberOf fabric.util
       * @param {Point[]} points
       * @param {Object} options
       * @param {number} options.strokeWidth
       * @param {'miter'|'bevel'|'round'} options.strokeLineJoin
       * @param {number} options.strokeMiterLimit https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke-miterlimit
       * @param {boolean} options.strokeUniform
       * @param {number} options.scaleX
       * @param {number} options.scaleY
       * @param {boolean} [openPath] whether the shape is open or not, affects the calculations of the first and last points
       * @returns {fabric.Point[]} array of size 2n/4n of all suspected points
       */
      projectStrokeOnPoints: function(points, options, openPath) {
        var coords = [], s = options.strokeWidth / 2, strokeUniformScalar = options.strokeUniform ? new fabric2.Point(1 / options.scaleX, 1 / options.scaleY) : new fabric2.Point(1, 1), getStrokeHatVector = function(v) {
          var scalar = s / Math.hypot(v.x, v.y);
          return new fabric2.Point(v.x * scalar * strokeUniformScalar.x, v.y * scalar * strokeUniformScalar.y);
        };
        if (points.length <= 1) {
          return coords;
        }
        points.forEach(function(p, index) {
          var A = new fabric2.Point(p.x, p.y), B, C;
          if (index === 0) {
            C = points[index + 1];
            B = openPath ? getStrokeHatVector(fabric2.util.createVector(C, A)).addEquals(A) : points[points.length - 1];
          } else if (index === points.length - 1) {
            B = points[index - 1];
            C = openPath ? getStrokeHatVector(fabric2.util.createVector(B, A)).addEquals(A) : points[0];
          } else {
            B = points[index - 1];
            C = points[index + 1];
          }
          var bisector = fabric2.util.getBisector(A, B, C), bisectorVector = bisector.vector, alpha = bisector.angle, scalar, miterVector;
          if (options.strokeLineJoin === "miter") {
            scalar = -s / Math.sin(alpha / 2);
            miterVector = new fabric2.Point(
              bisectorVector.x * scalar * strokeUniformScalar.x,
              bisectorVector.y * scalar * strokeUniformScalar.y
            );
            if (Math.hypot(miterVector.x, miterVector.y) / s <= options.strokeMiterLimit) {
              coords.push(A.add(miterVector));
              coords.push(A.subtract(miterVector));
              return;
            }
          }
          scalar = -s * Math.SQRT2;
          miterVector = new fabric2.Point(
            bisectorVector.x * scalar * strokeUniformScalar.x,
            bisectorVector.y * scalar * strokeUniformScalar.y
          );
          coords.push(A.add(miterVector));
          coords.push(A.subtract(miterVector));
        });
        return coords;
      },
      /**
       * Apply transform t to point p
       * @static
       * @memberOf fabric.util
       * @param  {fabric.Point} p The point to transform
       * @param  {Array} t The transform
       * @param  {Boolean} [ignoreOffset] Indicates that the offset should not be applied
       * @return {fabric.Point} The transformed point
       */
      transformPoint: function(p, t, ignoreOffset) {
        if (ignoreOffset) {
          return new fabric2.Point(
            t[0] * p.x + t[2] * p.y,
            t[1] * p.x + t[3] * p.y
          );
        }
        return new fabric2.Point(
          t[0] * p.x + t[2] * p.y + t[4],
          t[1] * p.x + t[3] * p.y + t[5]
        );
      },
      /**
       * Returns coordinates of points's bounding rectangle (left, top, width, height)
       * @param {Array} points 4 points array
       * @param {Array} [transform] an array of 6 numbers representing a 2x3 transform matrix
       * @return {Object} Object with left, top, width, height properties
       */
      makeBoundingBoxFromPoints: function(points, transform) {
        if (transform) {
          for (var i = 0; i < points.length; i++) {
            points[i] = fabric2.util.transformPoint(points[i], transform);
          }
        }
        var xPoints = [points[0].x, points[1].x, points[2].x, points[3].x], minX = fabric2.util.array.min(xPoints), maxX = fabric2.util.array.max(xPoints), width = maxX - minX, yPoints = [points[0].y, points[1].y, points[2].y, points[3].y], minY = fabric2.util.array.min(yPoints), maxY = fabric2.util.array.max(yPoints), height = maxY - minY;
        return {
          left: minX,
          top: minY,
          width,
          height
        };
      },
      /**
       * Invert transformation t
       * @static
       * @memberOf fabric.util
       * @param {Array} t The transform
       * @return {Array} The inverted transform
       */
      invertTransform: function(t) {
        var a = 1 / (t[0] * t[3] - t[1] * t[2]), r = [a * t[3], -a * t[1], -a * t[2], a * t[0]], o = fabric2.util.transformPoint({ x: t[4], y: t[5] }, r, true);
        r[4] = -o.x;
        r[5] = -o.y;
        return r;
      },
      /**
       * A wrapper around Number#toFixed, which contrary to native method returns number, not string.
       * @static
       * @memberOf fabric.util
       * @param {Number|String} number number to operate on
       * @param {Number} fractionDigits number of fraction digits to "leave"
       * @return {Number}
       */
      toFixed: function(number, fractionDigits) {
        return parseFloat(Number(number).toFixed(fractionDigits));
      },
      /**
       * Converts from attribute value to pixel value if applicable.
       * Returns converted pixels or original value not converted.
       * @param {Number|String} value number to operate on
       * @param {Number} fontSize
       * @return {Number|String}
       */
      parseUnit: function(value, fontSize) {
        var unit = /\D{0,2}$/.exec(value), number = parseFloat(value);
        if (!fontSize) {
          fontSize = fabric2.Text.DEFAULT_SVG_FONT_SIZE;
        }
        switch (unit[0]) {
          case "mm":
            return number * fabric2.DPI / 25.4;
          case "cm":
            return number * fabric2.DPI / 2.54;
          case "in":
            return number * fabric2.DPI;
          case "pt":
            return number * fabric2.DPI / 72;
          case "pc":
            return number * fabric2.DPI / 72 * 12;
          case "em":
            return number * fontSize;
          default:
            return number;
        }
      },
      /**
       * Function which always returns `false`.
       * @static
       * @memberOf fabric.util
       * @return {Boolean}
       */
      falseFunction: function() {
        return false;
      },
      /**
       * Returns klass "Class" object of given namespace
       * @memberOf fabric.util
       * @param {String} type Type of object (eg. 'circle')
       * @param {String} namespace Namespace to get klass "Class" object from
       * @return {Object} klass "Class"
       */
      getKlass: function(type, namespace) {
        type = fabric2.util.string.camelize(type.charAt(0).toUpperCase() + type.slice(1));
        return fabric2.util.resolveNamespace(namespace)[type];
      },
      /**
       * Returns array of attributes for given svg that fabric parses
       * @memberOf fabric.util
       * @param {String} type Type of svg element (eg. 'circle')
       * @return {Array} string names of supported attributes
       */
      getSvgAttributes: function(type) {
        var attributes = [
          "instantiated_by_use",
          "style",
          "id",
          "class"
        ];
        switch (type) {
          case "linearGradient":
            attributes = attributes.concat(["x1", "y1", "x2", "y2", "gradientUnits", "gradientTransform"]);
            break;
          case "radialGradient":
            attributes = attributes.concat(["gradientUnits", "gradientTransform", "cx", "cy", "r", "fx", "fy", "fr"]);
            break;
          case "stop":
            attributes = attributes.concat(["offset", "stop-color", "stop-opacity"]);
            break;
        }
        return attributes;
      },
      /**
       * Returns object of given namespace
       * @memberOf fabric.util
       * @param {String} namespace Namespace string e.g. 'fabric.Image.filter' or 'fabric'
       * @return {Object} Object for given namespace (default fabric)
       */
      resolveNamespace: function(namespace) {
        if (!namespace) {
          return fabric2;
        }
        var parts = namespace.split("."), len = parts.length, i, obj = global || fabric2.window;
        for (i = 0; i < len; ++i) {
          obj = obj[parts[i]];
        }
        return obj;
      },
      /**
       * Loads image element from given url and passes it to a callback
       * @memberOf fabric.util
       * @param {String} url URL representing an image
       * @param {Function} callback Callback; invoked with loaded image
       * @param {*} [context] Context to invoke callback in
       * @param {Object} [crossOrigin] crossOrigin value to set image element to
       */
      loadImage: function(url, callback, context, crossOrigin) {
        if (!url) {
          callback && callback.call(context, url);
          return;
        }
        var img = fabric2.util.createImage();
        var onLoadCallback = function() {
          callback && callback.call(context, img, false);
          img = img.onload = img.onerror = null;
        };
        img.onload = onLoadCallback;
        img.onerror = function() {
          fabric2.log("Error loading " + img.src);
          callback && callback.call(context, null, true);
          img = img.onload = img.onerror = null;
        };
        if (url.indexOf("data") !== 0 && crossOrigin !== void 0 && crossOrigin !== null) {
          img.crossOrigin = crossOrigin;
        }
        if (url.substring(0, 14) === "data:image/svg") {
          img.onload = null;
          fabric2.util.loadImageInDom(img, onLoadCallback);
        }
        img.src = url;
      },
      /**
       * Attaches SVG image with data: URL to the dom
       * @memberOf fabric.util
       * @param {Object} img Image object with data:image/svg src
       * @param {Function} callback Callback; invoked with loaded image
       * @return {Object} DOM element (div containing the SVG image)
       */
      loadImageInDom: function(img, onLoadCallback) {
        var div2 = fabric2.document.createElement("div");
        div2.style.width = div2.style.height = "1px";
        div2.style.left = div2.style.top = "-100%";
        div2.style.position = "absolute";
        div2.appendChild(img);
        fabric2.document.querySelector("body").appendChild(div2);
        img.onload = function() {
          onLoadCallback();
          div2.parentNode.removeChild(div2);
          div2 = null;
        };
      },
      /**
       * Creates corresponding fabric instances from their object representations
       * @static
       * @memberOf fabric.util
       * @param {Array} objects Objects to enliven
       * @param {Function} callback Callback to invoke when all objects are created
       * @param {String} namespace Namespace to get klass "Class" object from
       * @param {Function} reviver Method for further parsing of object elements,
       * called after each fabric object created.
       */
      enlivenObjects: function(objects, callback, namespace, reviver) {
        objects = objects || [];
        var enlivenedObjects = [], numLoadedObjects = 0, numTotalObjects = objects.length;
        function onLoaded() {
          if (++numLoadedObjects === numTotalObjects) {
            callback && callback(enlivenedObjects.filter(function(obj) {
              return obj;
            }));
          }
        }
        if (!numTotalObjects) {
          callback && callback(enlivenedObjects);
          return;
        }
        objects.forEach(function(o, index) {
          if (!o || !o.type) {
            onLoaded();
            return;
          }
          var klass = fabric2.util.getKlass(o.type, namespace);
          klass.fromObject(o, function(obj, error) {
            error || (enlivenedObjects[index] = obj);
            reviver && reviver(o, obj, error);
            onLoaded();
          });
        });
      },
      /**
       * Creates corresponding fabric instances residing in an object, e.g. `clipPath`
       * @see {@link fabric.Object.ENLIVEN_PROPS}
       * @param {Object} object
       * @param {Object} [context] assign enlived props to this object (pass null to skip this)
       * @param {(objects:fabric.Object[]) => void} callback
       */
      enlivenObjectEnlivables: function(object, context, callback) {
        var enlivenProps = fabric2.Object.ENLIVEN_PROPS.filter(function(key) {
          return !!object[key];
        });
        fabric2.util.enlivenObjects(enlivenProps.map(function(key) {
          return object[key];
        }), function(enlivedProps) {
          var objects = {};
          enlivenProps.forEach(function(key, index) {
            objects[key] = enlivedProps[index];
            context && (context[key] = enlivedProps[index]);
          });
          callback && callback(objects);
        });
      },
      /**
       * Create and wait for loading of patterns
       * @static
       * @memberOf fabric.util
       * @param {Array} patterns Objects to enliven
       * @param {Function} callback Callback to invoke when all objects are created
       * called after each fabric object created.
       */
      enlivenPatterns: function(patterns, callback) {
        patterns = patterns || [];
        function onLoaded() {
          if (++numLoadedPatterns === numPatterns) {
            callback && callback(enlivenedPatterns);
          }
        }
        var enlivenedPatterns = [], numLoadedPatterns = 0, numPatterns = patterns.length;
        if (!numPatterns) {
          callback && callback(enlivenedPatterns);
          return;
        }
        patterns.forEach(function(p, index) {
          if (p && p.source) {
            new fabric2.Pattern(p, function(pattern) {
              enlivenedPatterns[index] = pattern;
              onLoaded();
            });
          } else {
            enlivenedPatterns[index] = p;
            onLoaded();
          }
        });
      },
      /**
       * Groups SVG elements (usually those retrieved from SVG document)
       * @static
       * @memberOf fabric.util
       * @param {Array} elements SVG elements to group
       * @param {Object} [options] Options object
       * @param {String} path Value to set sourcePath to
       * @return {fabric.Object|fabric.Group}
       */
      groupSVGElements: function(elements, options, path) {
        var object;
        if (elements && elements.length === 1) {
          if (typeof path !== "undefined") {
            elements[0].sourcePath = path;
          }
          return elements[0];
        }
        if (options) {
          if (options.width && options.height) {
            options.centerPoint = {
              x: options.width / 2,
              y: options.height / 2
            };
          } else {
            delete options.width;
            delete options.height;
          }
        }
        object = new fabric2.Group(elements, options);
        if (typeof path !== "undefined") {
          object.sourcePath = path;
        }
        return object;
      },
      /**
       * Populates an object with properties of another object
       * @static
       * @memberOf fabric.util
       * @param {Object} source Source object
       * @param {Object} destination Destination object
       * @return {Array} properties Properties names to include
       */
      populateWithProperties: function(source, destination, properties) {
        if (properties && Array.isArray(properties)) {
          for (var i = 0, len = properties.length; i < len; i++) {
            if (properties[i] in source) {
              destination[properties[i]] = source[properties[i]];
            }
          }
        }
      },
      /**
       * Creates canvas element
       * @static
       * @memberOf fabric.util
       * @return {CanvasElement} initialized canvas element
       */
      createCanvasElement: function() {
        return fabric2.document.createElement("canvas");
      },
      /**
       * Creates a canvas element that is a copy of another and is also painted
       * @param {CanvasElement} canvas to copy size and content of
       * @static
       * @memberOf fabric.util
       * @return {CanvasElement} initialized canvas element
       */
      copyCanvasElement: function(canvas) {
        var newCanvas = fabric2.util.createCanvasElement();
        newCanvas.width = canvas.width;
        newCanvas.height = canvas.height;
        newCanvas.getContext("2d").drawImage(canvas, 0, 0);
        return newCanvas;
      },
      /**
       * since 2.6.0 moved from canvas instance to utility.
       * @param {CanvasElement} canvasEl to copy size and content of
       * @param {String} format 'jpeg' or 'png', in some browsers 'webp' is ok too
       * @param {Number} quality <= 1 and > 0
       * @static
       * @memberOf fabric.util
       * @return {String} data url
       */
      toDataURL: function(canvasEl, format, quality) {
        return canvasEl.toDataURL("image/" + format, quality);
      },
      /**
       * Creates image element (works on client and node)
       * @static
       * @memberOf fabric.util
       * @return {HTMLImageElement} HTML image element
       */
      createImage: function() {
        return fabric2.document.createElement("img");
      },
      /**
       * Multiply matrix A by matrix B to nest transformations
       * @static
       * @memberOf fabric.util
       * @param  {Array} a First transformMatrix
       * @param  {Array} b Second transformMatrix
       * @param  {Boolean} is2x2 flag to multiply matrices as 2x2 matrices
       * @return {Array} The product of the two transform matrices
       */
      multiplyTransformMatrices: function(a, b, is2x2) {
        return [
          a[0] * b[0] + a[2] * b[1],
          a[1] * b[0] + a[3] * b[1],
          a[0] * b[2] + a[2] * b[3],
          a[1] * b[2] + a[3] * b[3],
          is2x2 ? 0 : a[0] * b[4] + a[2] * b[5] + a[4],
          is2x2 ? 0 : a[1] * b[4] + a[3] * b[5] + a[5]
        ];
      },
      /**
       * Decomposes standard 2x3 matrix into transform components
       * @static
       * @memberOf fabric.util
       * @param  {Array} a transformMatrix
       * @return {Object} Components of transform
       */
      qrDecompose: function(a) {
        var angle = atan22(a[1], a[0]), denom = pow2(a[0], 2) + pow2(a[1], 2), scaleX = sqrt2(denom), scaleY = (a[0] * a[3] - a[2] * a[1]) / scaleX, skewX = atan22(a[0] * a[2] + a[1] * a[3], denom);
        return {
          angle: angle / PiBy180,
          scaleX,
          scaleY,
          skewX: skewX / PiBy180,
          skewY: 0,
          translateX: a[4],
          translateY: a[5]
        };
      },
      /**
       * Returns a transform matrix starting from an object of the same kind of
       * the one returned from qrDecompose, useful also if you want to calculate some
       * transformations from an object that is not enlived yet
       * @static
       * @memberOf fabric.util
       * @param  {Object} options
       * @param  {Number} [options.angle] angle in degrees
       * @return {Number[]} transform matrix
       */
      calcRotateMatrix: function(options) {
        if (!options.angle) {
          return fabric2.iMatrix.concat();
        }
        var theta = fabric2.util.degreesToRadians(options.angle), cos2 = fabric2.util.cos(theta), sin2 = fabric2.util.sin(theta);
        return [cos2, sin2, -sin2, cos2, 0, 0];
      },
      /**
       * Returns a transform matrix starting from an object of the same kind of
       * the one returned from qrDecompose, useful also if you want to calculate some
       * transformations from an object that is not enlived yet.
       * is called DimensionsTransformMatrix because those properties are the one that influence
       * the size of the resulting box of the object.
       * @static
       * @memberOf fabric.util
       * @param  {Object} options
       * @param  {Number} [options.scaleX]
       * @param  {Number} [options.scaleY]
       * @param  {Boolean} [options.flipX]
       * @param  {Boolean} [options.flipY]
       * @param  {Number} [options.skewX]
       * @param  {Number} [options.skewY]
       * @return {Number[]} transform matrix
       */
      calcDimensionsMatrix: function(options) {
        var scaleX = typeof options.scaleX === "undefined" ? 1 : options.scaleX, scaleY = typeof options.scaleY === "undefined" ? 1 : options.scaleY, scaleMatrix = [
          options.flipX ? -scaleX : scaleX,
          0,
          0,
          options.flipY ? -scaleY : scaleY,
          0,
          0
        ], multiply = fabric2.util.multiplyTransformMatrices, degreesToRadians = fabric2.util.degreesToRadians;
        if (options.skewX) {
          scaleMatrix = multiply(
            scaleMatrix,
            [1, 0, Math.tan(degreesToRadians(options.skewX)), 1],
            true
          );
        }
        if (options.skewY) {
          scaleMatrix = multiply(
            scaleMatrix,
            [1, Math.tan(degreesToRadians(options.skewY)), 0, 1],
            true
          );
        }
        return scaleMatrix;
      },
      /**
       * Returns a transform matrix starting from an object of the same kind of
       * the one returned from qrDecompose, useful also if you want to calculate some
       * transformations from an object that is not enlived yet
       * @static
       * @memberOf fabric.util
       * @param  {Object} options
       * @param  {Number} [options.angle]
       * @param  {Number} [options.scaleX]
       * @param  {Number} [options.scaleY]
       * @param  {Boolean} [options.flipX]
       * @param  {Boolean} [options.flipY]
       * @param  {Number} [options.skewX]
       * @param  {Number} [options.skewX]
       * @param  {Number} [options.translateX]
       * @param  {Number} [options.translateY]
       * @return {Number[]} transform matrix
       */
      composeMatrix: function(options) {
        var matrix2 = [1, 0, 0, 1, options.translateX || 0, options.translateY || 0], multiply = fabric2.util.multiplyTransformMatrices;
        if (options.angle) {
          matrix2 = multiply(matrix2, fabric2.util.calcRotateMatrix(options));
        }
        if (options.scaleX !== 1 || options.scaleY !== 1 || options.skewX || options.skewY || options.flipX || options.flipY) {
          matrix2 = multiply(matrix2, fabric2.util.calcDimensionsMatrix(options));
        }
        return matrix2;
      },
      /**
       * reset an object transform state to neutral. Top and left are not accounted for
       * @static
       * @memberOf fabric.util
       * @param  {fabric.Object} target object to transform
       */
      resetObjectTransform: function(target) {
        target.scaleX = 1;
        target.scaleY = 1;
        target.skewX = 0;
        target.skewY = 0;
        target.flipX = false;
        target.flipY = false;
        target.rotate(0);
      },
      /**
       * Extract Object transform values
       * @static
       * @memberOf fabric.util
       * @param  {fabric.Object} target object to read from
       * @return {Object} Components of transform
       */
      saveObjectTransform: function(target) {
        return {
          scaleX: target.scaleX,
          scaleY: target.scaleY,
          skewX: target.skewX,
          skewY: target.skewY,
          angle: target.angle,
          left: target.left,
          flipX: target.flipX,
          flipY: target.flipY,
          top: target.top
        };
      },
      /**
       * Returns true if context has transparent pixel
       * at specified location (taking tolerance into account)
       * @param {CanvasRenderingContext2D} ctx context
       * @param {Number} x x coordinate
       * @param {Number} y y coordinate
       * @param {Number} tolerance Tolerance
       */
      isTransparent: function(ctx, x, y, tolerance) {
        if (tolerance > 0) {
          if (x > tolerance) {
            x -= tolerance;
          } else {
            x = 0;
          }
          if (y > tolerance) {
            y -= tolerance;
          } else {
            y = 0;
          }
        }
        var _isTransparent = true, i, temp, imageData = ctx.getImageData(x, y, tolerance * 2 || 1, tolerance * 2 || 1), l = imageData.data.length;
        for (i = 3; i < l; i += 4) {
          temp = imageData.data[i];
          _isTransparent = temp <= 0;
          if (_isTransparent === false) {
            break;
          }
        }
        imageData = null;
        return _isTransparent;
      },
      /**
       * Parse preserveAspectRatio attribute from element
       * @param {string} attribute to be parsed
       * @return {Object} an object containing align and meetOrSlice attribute
       */
      parsePreserveAspectRatioAttribute: function(attribute) {
        var meetOrSlice = "meet", alignX = "Mid", alignY = "Mid", aspectRatioAttrs = attribute.split(" "), align;
        if (aspectRatioAttrs && aspectRatioAttrs.length) {
          meetOrSlice = aspectRatioAttrs.pop();
          if (meetOrSlice !== "meet" && meetOrSlice !== "slice") {
            align = meetOrSlice;
            meetOrSlice = "meet";
          } else if (aspectRatioAttrs.length) {
            align = aspectRatioAttrs.pop();
          }
        }
        alignX = align !== "none" ? align.slice(1, 4) : "none";
        alignY = align !== "none" ? align.slice(5, 8) : "none";
        return {
          meetOrSlice,
          alignX,
          alignY
        };
      },
      /**
       * Clear char widths cache for the given font family or all the cache if no
       * fontFamily is specified.
       * Use it if you know you are loading fonts in a lazy way and you are not waiting
       * for custom fonts to load properly when adding text objects to the canvas.
       * If a text object is added when its own font is not loaded yet, you will get wrong
       * measurement and so wrong bounding boxes.
       * After the font cache is cleared, either change the textObject text content or call
       * initDimensions() to trigger a recalculation
       * @memberOf fabric.util
       * @param {String} [fontFamily] font family to clear
       */
      clearFabricFontCache: function(fontFamily) {
        fontFamily = (fontFamily || "").toLowerCase();
        if (!fontFamily) {
          fabric2.charWidthsCache = {};
        } else if (fabric2.charWidthsCache[fontFamily]) {
          delete fabric2.charWidthsCache[fontFamily];
        }
      },
      /**
       * Given current aspect ratio, determines the max width and height that can
       * respect the total allowed area for the cache.
       * @memberOf fabric.util
       * @param {Number} ar aspect ratio
       * @param {Number} maximumArea Maximum area you want to achieve
       * @return {Object.x} Limited dimensions by X
       * @return {Object.y} Limited dimensions by Y
       */
      limitDimsByArea: function(ar, maximumArea) {
        var roughWidth = Math.sqrt(maximumArea * ar), perfLimitSizeY = Math.floor(maximumArea / roughWidth);
        return { x: Math.floor(roughWidth), y: perfLimitSizeY };
      },
      capValue: function(min2, value, max2) {
        return Math.max(min2, Math.min(value, max2));
      },
      /**
       * Finds the scale for the object source to fit inside the object destination,
       * keeping aspect ratio intact.
       * respect the total allowed area for the cache.
       * @memberOf fabric.util
       * @param {Object | fabric.Object} source
       * @param {Number} source.height natural unscaled height of the object
       * @param {Number} source.width natural unscaled width of the object
       * @param {Object | fabric.Object} destination
       * @param {Number} destination.height natural unscaled height of the object
       * @param {Number} destination.width natural unscaled width of the object
       * @return {Number} scale factor to apply to source to fit into destination
       */
      findScaleToFit: function(source, destination) {
        return Math.min(destination.width / source.width, destination.height / source.height);
      },
      /**
       * Finds the scale for the object source to cover entirely the object destination,
       * keeping aspect ratio intact.
       * respect the total allowed area for the cache.
       * @memberOf fabric.util
       * @param {Object | fabric.Object} source
       * @param {Number} source.height natural unscaled height of the object
       * @param {Number} source.width natural unscaled width of the object
       * @param {Object | fabric.Object} destination
       * @param {Number} destination.height natural unscaled height of the object
       * @param {Number} destination.width natural unscaled width of the object
       * @return {Number} scale factor to apply to source to cover destination
       */
      findScaleToCover: function(source, destination) {
        return Math.max(destination.width / source.width, destination.height / source.height);
      },
      /**
       * given an array of 6 number returns something like `"matrix(...numbers)"`
       * @memberOf fabric.util
       * @param {Array} transform an array with 6 numbers
       * @return {String} transform matrix for svg
       * @return {Object.y} Limited dimensions by Y
       */
      matrixToSVG: function(transform) {
        return "matrix(" + transform.map(function(value) {
          return fabric2.util.toFixed(value, fabric2.Object.NUM_FRACTION_DIGITS);
        }).join(" ") + ")";
      },
      /**
       * given an object and a transform, apply the inverse transform to the object,
       * this is equivalent to remove from that object that transformation, so that
       * added in a space with the removed transform, the object will be the same as before.
       * Removing from an object a transform that scale by 2 is like scaling it by 1/2.
       * Removing from an object a transfrom that rotate by 30deg is like rotating by 30deg
       * in the opposite direction.
       * This util is used to add objects inside transformed groups or nested groups.
       * @memberOf fabric.util
       * @param {fabric.Object} object the object you want to transform
       * @param {Array} transform the destination transform
       */
      removeTransformFromObject: function(object, transform) {
        var inverted = fabric2.util.invertTransform(transform), finalTransform = fabric2.util.multiplyTransformMatrices(inverted, object.calcOwnMatrix());
        fabric2.util.applyTransformToObject(object, finalTransform);
      },
      /**
       * given an object and a transform, apply the transform to the object.
       * this is equivalent to change the space where the object is drawn.
       * Adding to an object a transform that scale by 2 is like scaling it by 2.
       * This is used when removing an object from an active selection for example.
       * @memberOf fabric.util
       * @param {fabric.Object} object the object you want to transform
       * @param {Array} transform the destination transform
       */
      addTransformToObject: function(object, transform) {
        fabric2.util.applyTransformToObject(
          object,
          fabric2.util.multiplyTransformMatrices(transform, object.calcOwnMatrix())
        );
      },
      /**
       * discard an object transform state and apply the one from the matrix.
       * @memberOf fabric.util
       * @param {fabric.Object} object the object you want to transform
       * @param {Array} transform the destination transform
       */
      applyTransformToObject: function(object, transform) {
        var options = fabric2.util.qrDecompose(transform), center = new fabric2.Point(options.translateX, options.translateY);
        object.flipX = false;
        object.flipY = false;
        object.set("scaleX", options.scaleX);
        object.set("scaleY", options.scaleY);
        object.skewX = options.skewX;
        object.skewY = options.skewY;
        object.angle = options.angle;
        object.setPositionByOrigin(center, "center", "center");
      },
      /**
       * given a width and height, return the size of the bounding box
       * that can contains the box with width/height with applied transform
       * described in options.
       * Use to calculate the boxes around objects for controls.
       * @memberOf fabric.util
       * @param {Number} width
       * @param {Number} height
       * @param {Object} options
       * @param {Number} options.scaleX
       * @param {Number} options.scaleY
       * @param {Number} options.skewX
       * @param {Number} options.skewY
       * @return {Object.x} width of containing
       * @return {Object.y} height of containing
       */
      sizeAfterTransform: function(width, height, options) {
        var dimX = width / 2, dimY = height / 2, points = [
          {
            x: -dimX,
            y: -dimY
          },
          {
            x: dimX,
            y: -dimY
          },
          {
            x: -dimX,
            y: dimY
          },
          {
            x: dimX,
            y: dimY
          }
        ], transformMatrix = fabric2.util.calcDimensionsMatrix(options), bbox = fabric2.util.makeBoundingBoxFromPoints(points, transformMatrix);
        return {
          x: bbox.width,
          y: bbox.height
        };
      },
      /**
       * Merges 2 clip paths into one visually equal clip path
       *
       * **IMPORTANT**:\
       * Does **NOT** clone the arguments, clone them proir if necessary.
       *
       * Creates a wrapper (group) that contains one clip path and is clipped by the other so content is kept where both overlap.
       * Use this method if both the clip paths may have nested clip paths of their own, so assigning one to the other's clip path property is not possible.
       *
       * In order to handle the `inverted` property we follow logic described in the following cases:\
       * **(1)** both clip paths are inverted - the clip paths pass the inverted prop to the wrapper and loose it themselves.\
       * **(2)** one is inverted and the other isn't - the wrapper shouldn't become inverted and the inverted clip path must clip the non inverted one to produce an identical visual effect.\
       * **(3)** both clip paths are not inverted - wrapper and clip paths remain unchanged.
       *
       * @memberOf fabric.util
       * @param {fabric.Object} c1
       * @param {fabric.Object} c2
       * @returns {fabric.Object} merged clip path
       */
      mergeClipPaths: function(c1, c2) {
        var a = c1, b = c2;
        if (a.inverted && !b.inverted) {
          a = c2;
          b = c1;
        }
        fabric2.util.applyTransformToObject(
          b,
          fabric2.util.multiplyTransformMatrices(
            fabric2.util.invertTransform(a.calcTransformMatrix()),
            b.calcTransformMatrix()
          )
        );
        var inverted = a.inverted && b.inverted;
        if (inverted) {
          a.inverted = b.inverted = false;
        }
        return new fabric2.Group([a], { clipPath: b, inverted });
      },
      /**
       * @memberOf fabric.util
       * @param {Object} prevStyle first style to compare
       * @param {Object} thisStyle second style to compare
       * @param {boolean} forTextSpans whether to check overline, underline, and line-through properties
       * @return {boolean} true if the style changed
       */
      hasStyleChanged: function(prevStyle, thisStyle, forTextSpans) {
        forTextSpans = forTextSpans || false;
        return prevStyle.fill !== thisStyle.fill || prevStyle.stroke !== thisStyle.stroke || prevStyle.strokeWidth !== thisStyle.strokeWidth || prevStyle.fontSize !== thisStyle.fontSize || prevStyle.fontFamily !== thisStyle.fontFamily || prevStyle.fontWeight !== thisStyle.fontWeight || prevStyle.fontStyle !== thisStyle.fontStyle || prevStyle.textBackgroundColor !== thisStyle.textBackgroundColor || prevStyle.deltaY !== thisStyle.deltaY || forTextSpans && (prevStyle.overline !== thisStyle.overline || prevStyle.underline !== thisStyle.underline || prevStyle.linethrough !== thisStyle.linethrough);
      },
      /**
       * Returns the array form of a text object's inline styles property with styles grouped in ranges
       * rather than per character. This format is less verbose, and is better suited for storage
       * so it is used in serialization (not during runtime).
       * @memberOf fabric.util
       * @param {object} styles per character styles for a text object
       * @param {String} text the text string that the styles are applied to
       * @return {{start: number, end: number, style: object}[]}
       */
      stylesToArray: function(styles, text) {
        var styles = fabric2.util.object.clone(styles, true), textLines = text.split("\n"), charIndex = -1, prevStyle = {}, stylesArray = [];
        for (var i = 0; i < textLines.length; i++) {
          if (!styles[i]) {
            charIndex += textLines[i].length;
            continue;
          }
          for (var c = 0; c < textLines[i].length; c++) {
            charIndex++;
            var thisStyle = styles[i][c];
            if (thisStyle && Object.keys(thisStyle).length > 0) {
              var styleChanged = fabric2.util.hasStyleChanged(prevStyle, thisStyle, true);
              if (styleChanged) {
                stylesArray.push({
                  start: charIndex,
                  end: charIndex + 1,
                  style: thisStyle
                });
              } else {
                stylesArray[stylesArray.length - 1].end++;
              }
            }
            prevStyle = thisStyle || {};
          }
        }
        return stylesArray;
      },
      /**
       * Returns the object form of the styles property with styles that are assigned per
       * character rather than grouped by range. This format is more verbose, and is
       * only used during runtime (not for serialization/storage)
       * @memberOf fabric.util
       * @param {Array} styles the serialized form of a text object's styles
       * @param {String} text the text string that the styles are applied to
       * @return {Object}
       */
      stylesFromArray: function(styles, text) {
        if (!Array.isArray(styles)) {
          return styles;
        }
        var textLines = text.split("\n"), charIndex = -1, styleIndex = 0, stylesObject = {};
        for (var i = 0; i < textLines.length; i++) {
          for (var c = 0; c < textLines[i].length; c++) {
            charIndex++;
            if (styles[styleIndex] && styles[styleIndex].start <= charIndex && charIndex < styles[styleIndex].end) {
              stylesObject[i] = stylesObject[i] || {};
              stylesObject[i][c] = Object.assign({}, styles[styleIndex].style);
              if (charIndex === styles[styleIndex].end - 1) {
                styleIndex++;
              }
            }
          }
        }
        return stylesObject;
      }
    };
  })(exports);
  (function() {
    var _join = Array.prototype.join, commandLengths = {
      m: 2,
      l: 2,
      h: 1,
      v: 1,
      c: 6,
      s: 4,
      q: 4,
      t: 2,
      a: 7
    }, repeatedCommands = {
      m: "l",
      M: "L"
    };
    function segmentToBezier(th2, th3, cosTh, sinTh, rx, ry, cx1, cy1, mT, fromX, fromY) {
      var costh2 = fabric2.util.cos(th2), sinth2 = fabric2.util.sin(th2), costh3 = fabric2.util.cos(th3), sinth3 = fabric2.util.sin(th3), toX = cosTh * rx * costh3 - sinTh * ry * sinth3 + cx1, toY = sinTh * rx * costh3 + cosTh * ry * sinth3 + cy1, cp1X = fromX + mT * (-cosTh * rx * sinth2 - sinTh * ry * costh2), cp1Y = fromY + mT * (-sinTh * rx * sinth2 + cosTh * ry * costh2), cp2X = toX + mT * (cosTh * rx * sinth3 + sinTh * ry * costh3), cp2Y = toY + mT * (sinTh * rx * sinth3 - cosTh * ry * costh3);
      return [
        "C",
        cp1X,
        cp1Y,
        cp2X,
        cp2Y,
        toX,
        toY
      ];
    }
    function arcToSegments(toX, toY, rx, ry, large, sweep, rotateX) {
      var PI2 = Math.PI, th = rotateX * PI2 / 180, sinTh = fabric2.util.sin(th), cosTh = fabric2.util.cos(th), fromX = 0, fromY = 0;
      rx = Math.abs(rx);
      ry = Math.abs(ry);
      var px = -cosTh * toX * 0.5 - sinTh * toY * 0.5, py = -cosTh * toY * 0.5 + sinTh * toX * 0.5, rx2 = rx * rx, ry2 = ry * ry, py2 = py * py, px2 = px * px, pl = rx2 * ry2 - rx2 * py2 - ry2 * px2, root = 0;
      if (pl < 0) {
        var s = Math.sqrt(1 - pl / (rx2 * ry2));
        rx *= s;
        ry *= s;
      } else {
        root = (large === sweep ? -1 : 1) * Math.sqrt(pl / (rx2 * py2 + ry2 * px2));
      }
      var cx = root * rx * py / ry, cy = -root * ry * px / rx, cx1 = cosTh * cx - sinTh * cy + toX * 0.5, cy1 = sinTh * cx + cosTh * cy + toY * 0.5, mTheta = calcVectorAngle(1, 0, (px - cx) / rx, (py - cy) / ry), dtheta = calcVectorAngle((px - cx) / rx, (py - cy) / ry, (-px - cx) / rx, (-py - cy) / ry);
      if (sweep === 0 && dtheta > 0) {
        dtheta -= 2 * PI2;
      } else if (sweep === 1 && dtheta < 0) {
        dtheta += 2 * PI2;
      }
      var segments = Math.ceil(Math.abs(dtheta / PI2 * 2)), result = [], mDelta = dtheta / segments, mT = 8 / 3 * Math.sin(mDelta / 4) * Math.sin(mDelta / 4) / Math.sin(mDelta / 2), th3 = mTheta + mDelta;
      for (var i = 0; i < segments; i++) {
        result[i] = segmentToBezier(mTheta, th3, cosTh, sinTh, rx, ry, cx1, cy1, mT, fromX, fromY);
        fromX = result[i][5];
        fromY = result[i][6];
        mTheta = th3;
        th3 += mDelta;
      }
      return result;
    }
    function calcVectorAngle(ux, uy, vx, vy) {
      var ta = Math.atan2(uy, ux), tb = Math.atan2(vy, vx);
      if (tb >= ta) {
        return tb - ta;
      } else {
        return 2 * Math.PI - (ta - tb);
      }
    }
    function getBoundsOfCurve(x0, y0, x1, y1, x2, y2, x3, y3) {
      var argsString;
      if (fabric2.cachesBoundsOfCurve) {
        argsString = _join.call(arguments);
        if (fabric2.boundsOfCurveCache[argsString]) {
          return fabric2.boundsOfCurveCache[argsString];
        }
      }
      var sqrt2 = Math.sqrt, min2 = Math.min, max2 = Math.max, abs2 = Math.abs, tvalues = [], bounds = [[], []], a, b, c, t, t1, t2, b2ac, sqrtb2ac;
      b = 6 * x0 - 12 * x1 + 6 * x2;
      a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
      c = 3 * x1 - 3 * x0;
      for (var i = 0; i < 2; ++i) {
        if (i > 0) {
          b = 6 * y0 - 12 * y1 + 6 * y2;
          a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
          c = 3 * y1 - 3 * y0;
        }
        if (abs2(a) < 1e-12) {
          if (abs2(b) < 1e-12) {
            continue;
          }
          t = -c / b;
          if (0 < t && t < 1) {
            tvalues.push(t);
          }
          continue;
        }
        b2ac = b * b - 4 * c * a;
        if (b2ac < 0) {
          continue;
        }
        sqrtb2ac = sqrt2(b2ac);
        t1 = (-b + sqrtb2ac) / (2 * a);
        if (0 < t1 && t1 < 1) {
          tvalues.push(t1);
        }
        t2 = (-b - sqrtb2ac) / (2 * a);
        if (0 < t2 && t2 < 1) {
          tvalues.push(t2);
        }
      }
      var x, y, j = tvalues.length, jlen = j, mt;
      while (j--) {
        t = tvalues[j];
        mt = 1 - t;
        x = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
        bounds[0][j] = x;
        y = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
        bounds[1][j] = y;
      }
      bounds[0][jlen] = x0;
      bounds[1][jlen] = y0;
      bounds[0][jlen + 1] = x3;
      bounds[1][jlen + 1] = y3;
      var result = [
        {
          x: min2.apply(null, bounds[0]),
          y: min2.apply(null, bounds[1])
        },
        {
          x: max2.apply(null, bounds[0]),
          y: max2.apply(null, bounds[1])
        }
      ];
      if (fabric2.cachesBoundsOfCurve) {
        fabric2.boundsOfCurveCache[argsString] = result;
      }
      return result;
    }
    function fromArcToBeziers(fx, fy, coords) {
      var rx = coords[1], ry = coords[2], rot = coords[3], large = coords[4], sweep = coords[5], tx = coords[6], ty = coords[7], segsNorm = arcToSegments(tx - fx, ty - fy, rx, ry, large, sweep, rot);
      for (var i = 0, len = segsNorm.length; i < len; i++) {
        segsNorm[i][1] += fx;
        segsNorm[i][2] += fy;
        segsNorm[i][3] += fx;
        segsNorm[i][4] += fy;
        segsNorm[i][5] += fx;
        segsNorm[i][6] += fy;
      }
      return segsNorm;
    }
    function makePathSimpler(path) {
      var x = 0, y = 0, len = path.length, x1 = 0, y1 = 0, current, i, converted, destinationPath = [], previous, controlX, controlY;
      for (i = 0; i < len; ++i) {
        converted = false;
        current = path[i].slice(0);
        switch (current[0]) {
          case "l":
            current[0] = "L";
            current[1] += x;
            current[2] += y;
          case "L":
            x = current[1];
            y = current[2];
            break;
          case "h":
            current[1] += x;
          case "H":
            current[0] = "L";
            current[2] = y;
            x = current[1];
            break;
          case "v":
            current[1] += y;
          case "V":
            current[0] = "L";
            y = current[1];
            current[1] = x;
            current[2] = y;
            break;
          case "m":
            current[0] = "M";
            current[1] += x;
            current[2] += y;
          case "M":
            x = current[1];
            y = current[2];
            x1 = current[1];
            y1 = current[2];
            break;
          case "c":
            current[0] = "C";
            current[1] += x;
            current[2] += y;
            current[3] += x;
            current[4] += y;
            current[5] += x;
            current[6] += y;
          case "C":
            controlX = current[3];
            controlY = current[4];
            x = current[5];
            y = current[6];
            break;
          case "s":
            current[0] = "S";
            current[1] += x;
            current[2] += y;
            current[3] += x;
            current[4] += y;
          case "S":
            if (previous === "C") {
              controlX = 2 * x - controlX;
              controlY = 2 * y - controlY;
            } else {
              controlX = x;
              controlY = y;
            }
            x = current[3];
            y = current[4];
            current[0] = "C";
            current[5] = current[3];
            current[6] = current[4];
            current[3] = current[1];
            current[4] = current[2];
            current[1] = controlX;
            current[2] = controlY;
            controlX = current[3];
            controlY = current[4];
            break;
          case "q":
            current[0] = "Q";
            current[1] += x;
            current[2] += y;
            current[3] += x;
            current[4] += y;
          case "Q":
            controlX = current[1];
            controlY = current[2];
            x = current[3];
            y = current[4];
            break;
          case "t":
            current[0] = "T";
            current[1] += x;
            current[2] += y;
          case "T":
            if (previous === "Q") {
              controlX = 2 * x - controlX;
              controlY = 2 * y - controlY;
            } else {
              controlX = x;
              controlY = y;
            }
            current[0] = "Q";
            x = current[1];
            y = current[2];
            current[1] = controlX;
            current[2] = controlY;
            current[3] = x;
            current[4] = y;
            break;
          case "a":
            current[0] = "A";
            current[6] += x;
            current[7] += y;
          case "A":
            converted = true;
            destinationPath = destinationPath.concat(fromArcToBeziers(x, y, current));
            x = current[6];
            y = current[7];
            break;
          case "z":
          case "Z":
            x = x1;
            y = y1;
            break;
        }
        if (!converted) {
          destinationPath.push(current);
        }
        previous = current[0];
      }
      return destinationPath;
    }
    function calcLineLength(x1, y1, x2, y2) {
      return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    function CB1(t) {
      return t * t * t;
    }
    function CB2(t) {
      return 3 * t * t * (1 - t);
    }
    function CB3(t) {
      return 3 * t * (1 - t) * (1 - t);
    }
    function CB4(t) {
      return (1 - t) * (1 - t) * (1 - t);
    }
    function getPointOnCubicBezierIterator(p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y) {
      return function(pct) {
        var c1 = CB1(pct), c2 = CB2(pct), c3 = CB3(pct), c4 = CB4(pct);
        return {
          x: p4x * c1 + p3x * c2 + p2x * c3 + p1x * c4,
          y: p4y * c1 + p3y * c2 + p2y * c3 + p1y * c4
        };
      };
    }
    function getTangentCubicIterator(p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y) {
      return function(pct) {
        var invT = 1 - pct, tangentX = 3 * invT * invT * (p2x - p1x) + 6 * invT * pct * (p3x - p2x) + 3 * pct * pct * (p4x - p3x), tangentY = 3 * invT * invT * (p2y - p1y) + 6 * invT * pct * (p3y - p2y) + 3 * pct * pct * (p4y - p3y);
        return Math.atan2(tangentY, tangentX);
      };
    }
    function QB1(t) {
      return t * t;
    }
    function QB2(t) {
      return 2 * t * (1 - t);
    }
    function QB3(t) {
      return (1 - t) * (1 - t);
    }
    function getPointOnQuadraticBezierIterator(p1x, p1y, p2x, p2y, p3x, p3y) {
      return function(pct) {
        var c1 = QB1(pct), c2 = QB2(pct), c3 = QB3(pct);
        return {
          x: p3x * c1 + p2x * c2 + p1x * c3,
          y: p3y * c1 + p2y * c2 + p1y * c3
        };
      };
    }
    function getTangentQuadraticIterator(p1x, p1y, p2x, p2y, p3x, p3y) {
      return function(pct) {
        var invT = 1 - pct, tangentX = 2 * invT * (p2x - p1x) + 2 * pct * (p3x - p2x), tangentY = 2 * invT * (p2y - p1y) + 2 * pct * (p3y - p2y);
        return Math.atan2(tangentY, tangentX);
      };
    }
    function pathIterator(iterator, x1, y1) {
      var tempP = { x: x1, y: y1 }, p, tmpLen = 0, perc;
      for (perc = 1; perc <= 100; perc += 1) {
        p = iterator(perc / 100);
        tmpLen += calcLineLength(tempP.x, tempP.y, p.x, p.y);
        tempP = p;
      }
      return tmpLen;
    }
    function findPercentageForDistance(segInfo, distance) {
      var perc = 0, tmpLen = 0, iterator = segInfo.iterator, tempP = { x: segInfo.x, y: segInfo.y }, p, nextLen, nextStep = 0.01, angleFinder = segInfo.angleFinder, lastPerc;
      while (tmpLen < distance && nextStep > 1e-4) {
        p = iterator(perc);
        lastPerc = perc;
        nextLen = calcLineLength(tempP.x, tempP.y, p.x, p.y);
        if (nextLen + tmpLen > distance) {
          perc -= nextStep;
          nextStep /= 2;
        } else {
          tempP = p;
          perc += nextStep;
          tmpLen += nextLen;
        }
      }
      p.angle = angleFinder(lastPerc);
      return p;
    }
    function getPathSegmentsInfo(path) {
      var totalLength = 0, len = path.length, current, x1 = 0, y1 = 0, x2 = 0, y2 = 0, info = [], iterator, tempInfo, angleFinder;
      for (var i = 0; i < len; i++) {
        current = path[i];
        tempInfo = {
          x: x1,
          y: y1,
          command: current[0]
        };
        switch (current[0]) {
          case "M":
            tempInfo.length = 0;
            x2 = x1 = current[1];
            y2 = y1 = current[2];
            break;
          case "L":
            tempInfo.length = calcLineLength(x1, y1, current[1], current[2]);
            x1 = current[1];
            y1 = current[2];
            break;
          case "C":
            iterator = getPointOnCubicBezierIterator(
              x1,
              y1,
              current[1],
              current[2],
              current[3],
              current[4],
              current[5],
              current[6]
            );
            angleFinder = getTangentCubicIterator(
              x1,
              y1,
              current[1],
              current[2],
              current[3],
              current[4],
              current[5],
              current[6]
            );
            tempInfo.iterator = iterator;
            tempInfo.angleFinder = angleFinder;
            tempInfo.length = pathIterator(iterator, x1, y1);
            x1 = current[5];
            y1 = current[6];
            break;
          case "Q":
            iterator = getPointOnQuadraticBezierIterator(
              x1,
              y1,
              current[1],
              current[2],
              current[3],
              current[4]
            );
            angleFinder = getTangentQuadraticIterator(
              x1,
              y1,
              current[1],
              current[2],
              current[3],
              current[4]
            );
            tempInfo.iterator = iterator;
            tempInfo.angleFinder = angleFinder;
            tempInfo.length = pathIterator(iterator, x1, y1);
            x1 = current[3];
            y1 = current[4];
            break;
          case "Z":
          case "z":
            tempInfo.destX = x2;
            tempInfo.destY = y2;
            tempInfo.length = calcLineLength(x1, y1, x2, y2);
            x1 = x2;
            y1 = y2;
            break;
        }
        totalLength += tempInfo.length;
        info.push(tempInfo);
      }
      info.push({ length: totalLength, x: x1, y: y1 });
      return info;
    }
    function getPointOnPath(path, distance, infos) {
      if (!infos) {
        infos = getPathSegmentsInfo(path);
      }
      var i = 0;
      while (distance - infos[i].length > 0 && i < infos.length - 2) {
        distance -= infos[i].length;
        i++;
      }
      var segInfo = infos[i], segPercent = distance / segInfo.length, command = segInfo.command, segment = path[i], info;
      switch (command) {
        case "M":
          return { x: segInfo.x, y: segInfo.y, angle: 0 };
        case "Z":
        case "z":
          info = new fabric2.Point(segInfo.x, segInfo.y).lerp(
            new fabric2.Point(segInfo.destX, segInfo.destY),
            segPercent
          );
          info.angle = Math.atan2(segInfo.destY - segInfo.y, segInfo.destX - segInfo.x);
          return info;
        case "L":
          info = new fabric2.Point(segInfo.x, segInfo.y).lerp(
            new fabric2.Point(segment[1], segment[2]),
            segPercent
          );
          info.angle = Math.atan2(segment[2] - segInfo.y, segment[1] - segInfo.x);
          return info;
        case "C":
          return findPercentageForDistance(segInfo, distance);
        case "Q":
          return findPercentageForDistance(segInfo, distance);
      }
    }
    function parsePath2(pathString) {
      var result = [], coords = [], currentPath, parsed, re = fabric2.rePathCommand, rNumber = "[-+]?(?:\\d*\\.\\d+|\\d+\\.?)(?:[eE][-+]?\\d+)?\\s*", rNumberCommaWsp = "(" + rNumber + ")" + fabric2.commaWsp, rFlagCommaWsp = "([01])" + fabric2.commaWsp + "?", rArcSeq = rNumberCommaWsp + "?" + rNumberCommaWsp + "?" + rNumberCommaWsp + rFlagCommaWsp + rFlagCommaWsp + rNumberCommaWsp + "?(" + rNumber + ")", regArcArgumentSequence = new RegExp(rArcSeq, "g"), match, coordsStr, path;
      if (!pathString || !pathString.match) {
        return result;
      }
      path = pathString.match(/[mzlhvcsqta][^mzlhvcsqta]*/gi);
      for (var i = 0, coordsParsed, len = path.length; i < len; i++) {
        currentPath = path[i];
        coordsStr = currentPath.slice(1).trim();
        coords.length = 0;
        var command = currentPath.charAt(0);
        coordsParsed = [command];
        if (command.toLowerCase() === "a") {
          for (var args; args = regArcArgumentSequence.exec(coordsStr); ) {
            for (var j = 1; j < args.length; j++) {
              coords.push(args[j]);
            }
          }
        } else {
          while (match = re.exec(coordsStr)) {
            coords.push(match[0]);
          }
        }
        for (var j = 0, jlen = coords.length; j < jlen; j++) {
          parsed = parseFloat(coords[j]);
          if (!isNaN(parsed)) {
            coordsParsed.push(parsed);
          }
        }
        var commandLength = commandLengths[command.toLowerCase()], repeatedCommand = repeatedCommands[command] || command;
        if (coordsParsed.length - 1 > commandLength) {
          for (var k = 1, klen = coordsParsed.length; k < klen; k += commandLength) {
            result.push([command].concat(coordsParsed.slice(k, k + commandLength)));
            command = repeatedCommand;
          }
        } else {
          result.push(coordsParsed);
        }
      }
      return result;
    }
    function getSmoothPathFromPoints(points, correction) {
      var path = [], i, p1 = new fabric2.Point(points[0].x, points[0].y), p2 = new fabric2.Point(points[1].x, points[1].y), len = points.length, multSignX = 1, multSignY = 0, manyPoints = len > 2;
      correction = correction || 0;
      if (manyPoints) {
        multSignX = points[2].x < p2.x ? -1 : points[2].x === p2.x ? 0 : 1;
        multSignY = points[2].y < p2.y ? -1 : points[2].y === p2.y ? 0 : 1;
      }
      path.push(["M", p1.x - multSignX * correction, p1.y - multSignY * correction]);
      for (i = 1; i < len; i++) {
        if (!p1.eq(p2)) {
          var midPoint = p1.midPointFrom(p2);
          path.push(["Q", p1.x, p1.y, midPoint.x, midPoint.y]);
        }
        p1 = points[i];
        if (i + 1 < points.length) {
          p2 = points[i + 1];
        }
      }
      if (manyPoints) {
        multSignX = p1.x > points[i - 2].x ? 1 : p1.x === points[i - 2].x ? 0 : -1;
        multSignY = p1.y > points[i - 2].y ? 1 : p1.y === points[i - 2].y ? 0 : -1;
      }
      path.push(["L", p1.x + multSignX * correction, p1.y + multSignY * correction]);
      return path;
    }
    function transformPath(path, transform, pathOffset) {
      if (pathOffset) {
        transform = fabric2.util.multiplyTransformMatrices(
          transform,
          [1, 0, 0, 1, -pathOffset.x, -pathOffset.y]
        );
      }
      return path.map(function(pathSegment) {
        var newSegment = pathSegment.slice(0), point = {};
        for (var i = 1; i < pathSegment.length - 1; i += 2) {
          point.x = pathSegment[i];
          point.y = pathSegment[i + 1];
          point = fabric2.util.transformPoint(point, transform);
          newSegment[i] = point.x;
          newSegment[i + 1] = point.y;
        }
        return newSegment;
      });
    }
    fabric2.util.joinPath = function(pathData) {
      return pathData.map(function(segment) {
        return segment.join(" ");
      }).join(" ");
    };
    fabric2.util.parsePath = parsePath2;
    fabric2.util.makePathSimpler = makePathSimpler;
    fabric2.util.getSmoothPathFromPoints = getSmoothPathFromPoints;
    fabric2.util.getPathSegmentsInfo = getPathSegmentsInfo;
    fabric2.util.getBoundsOfCurve = getBoundsOfCurve;
    fabric2.util.getPointOnPath = getPointOnPath;
    fabric2.util.transformPath = transformPath;
  })();
  (function() {
    var slice = Array.prototype.slice;
    function invoke(array, method) {
      var args = slice.call(arguments, 2), result = [];
      for (var i = 0, len = array.length; i < len; i++) {
        result[i] = args.length ? array[i][method].apply(array[i], args) : array[i][method].call(array[i]);
      }
      return result;
    }
    function max2(array, byProperty) {
      return find(array, byProperty, function(value1, value2) {
        return value1 >= value2;
      });
    }
    function min2(array, byProperty) {
      return find(array, byProperty, function(value1, value2) {
        return value1 < value2;
      });
    }
    function fill(array, value) {
      var k = array.length;
      while (k--) {
        array[k] = value;
      }
      return array;
    }
    function find(array, byProperty, condition) {
      if (!array || array.length === 0) {
        return;
      }
      var i = array.length - 1, result = byProperty ? array[i][byProperty] : array[i];
      if (byProperty) {
        while (i--) {
          if (condition(array[i][byProperty], result)) {
            result = array[i][byProperty];
          }
        }
      } else {
        while (i--) {
          if (condition(array[i], result)) {
            result = array[i];
          }
        }
      }
      return result;
    }
    fabric2.util.array = {
      fill,
      invoke,
      min: min2,
      max: max2
    };
  })();
  (function() {
    function extend(destination, source, deep) {
      if (deep) {
        if (!fabric2.isLikelyNode && source instanceof Element) {
          destination = source;
        } else if (source instanceof Array) {
          destination = [];
          for (var i = 0, len = source.length; i < len; i++) {
            destination[i] = extend({}, source[i], deep);
          }
        } else if (source && typeof source === "object") {
          for (var property in source) {
            if (property === "canvas" || property === "group") {
              destination[property] = null;
            } else if (source.hasOwnProperty(property)) {
              destination[property] = extend({}, source[property], deep);
            }
          }
        } else {
          destination = source;
        }
      } else {
        for (var property in source) {
          destination[property] = source[property];
        }
      }
      return destination;
    }
    function clone2(object, deep) {
      return extend({}, object, deep);
    }
    fabric2.util.object = {
      extend,
      clone: clone2
    };
    fabric2.util.object.extend(fabric2.util, fabric2.Observable);
  })();
  (function() {
    function camelize(string2) {
      return string2.replace(/-+(.)?/g, function(match, character) {
        return character ? character.toUpperCase() : "";
      });
    }
    function capitalize(string2, firstLetterOnly) {
      return string2.charAt(0).toUpperCase() + (firstLetterOnly ? string2.slice(1) : string2.slice(1).toLowerCase());
    }
    function escapeXml(string2) {
      return string2.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    function graphemeSplit(textstring) {
      var i = 0, chr, graphemes = [];
      for (i = 0, chr; i < textstring.length; i++) {
        if ((chr = getWholeChar(textstring, i)) === false) {
          continue;
        }
        graphemes.push(chr);
      }
      return graphemes;
    }
    function getWholeChar(str, i) {
      var code = str.charCodeAt(i);
      if (isNaN(code)) {
        return "";
      }
      if (code < 55296 || code > 57343) {
        return str.charAt(i);
      }
      if (55296 <= code && code <= 56319) {
        if (str.length <= i + 1) {
          throw "High surrogate without following low surrogate";
        }
        var next = str.charCodeAt(i + 1);
        if (56320 > next || next > 57343) {
          throw "High surrogate without following low surrogate";
        }
        return str.charAt(i) + str.charAt(i + 1);
      }
      if (i === 0) {
        throw "Low surrogate without preceding high surrogate";
      }
      var prev = str.charCodeAt(i - 1);
      if (55296 > prev || prev > 56319) {
        throw "Low surrogate without preceding high surrogate";
      }
      return false;
    }
    fabric2.util.string = {
      camelize,
      capitalize,
      escapeXml,
      graphemeSplit
    };
  })();
  (function() {
    var slice = Array.prototype.slice, emptyFunction = function() {
    }, IS_DONTENUM_BUGGY = function() {
      for (var p in { toString: 1 }) {
        if (p === "toString") {
          return false;
        }
      }
      return true;
    }(), addMethods = function(klass, source, parent) {
      for (var property in source) {
        if (property in klass.prototype && typeof klass.prototype[property] === "function" && (source[property] + "").indexOf("callSuper") > -1) {
          klass.prototype[property] = /* @__PURE__ */ function(property2) {
            return function() {
              var superclass = this.constructor.superclass;
              this.constructor.superclass = parent;
              var returnValue = source[property2].apply(this, arguments);
              this.constructor.superclass = superclass;
              if (property2 !== "initialize") {
                return returnValue;
              }
            };
          }(property);
        } else {
          klass.prototype[property] = source[property];
        }
        if (IS_DONTENUM_BUGGY) {
          if (source.toString !== Object.prototype.toString) {
            klass.prototype.toString = source.toString;
          }
          if (source.valueOf !== Object.prototype.valueOf) {
            klass.prototype.valueOf = source.valueOf;
          }
        }
      }
    };
    function Subclass() {
    }
    function callSuper(methodName) {
      var parentMethod = null, _this = this;
      while (_this.constructor.superclass) {
        var superClassMethod = _this.constructor.superclass.prototype[methodName];
        if (_this[methodName] !== superClassMethod) {
          parentMethod = superClassMethod;
          break;
        }
        _this = _this.constructor.superclass.prototype;
      }
      if (!parentMethod) {
        return void 0;
      }
      return arguments.length > 1 ? parentMethod.apply(this, slice.call(arguments, 1)) : parentMethod.call(this);
    }
    function createClass() {
      var parent = null, properties = slice.call(arguments, 0);
      if (typeof properties[0] === "function") {
        parent = properties.shift();
      }
      function klass() {
        this.initialize.apply(this, arguments);
      }
      klass.superclass = parent;
      klass.subclasses = [];
      if (parent) {
        Subclass.prototype = parent.prototype;
        klass.prototype = new Subclass();
        parent.subclasses.push(klass);
      }
      for (var i = 0, length = properties.length; i < length; i++) {
        addMethods(klass, properties[i], parent);
      }
      if (!klass.prototype.initialize) {
        klass.prototype.initialize = emptyFunction;
      }
      klass.prototype.constructor = klass;
      klass.prototype.callSuper = callSuper;
      return klass;
    }
    fabric2.util.createClass = createClass;
  })();
  (function() {
    var couldUseAttachEvent = !!fabric2.document.createElement("div").attachEvent, touchEvents = ["touchstart", "touchmove", "touchend"];
    fabric2.util.addListener = function(element, eventName, handler, options) {
      element && element.addEventListener(eventName, handler, couldUseAttachEvent ? false : options);
    };
    fabric2.util.removeListener = function(element, eventName, handler, options) {
      element && element.removeEventListener(eventName, handler, couldUseAttachEvent ? false : options);
    };
    function getTouchInfo(event) {
      var touchProp = event.changedTouches;
      if (touchProp && touchProp[0]) {
        return touchProp[0];
      }
      return event;
    }
    fabric2.util.getPointer = function(event) {
      var element = event.target, scroll = fabric2.util.getScrollLeftTop(element), _evt = getTouchInfo(event);
      return {
        x: _evt.clientX + scroll.left,
        y: _evt.clientY + scroll.top
      };
    };
    fabric2.util.isTouchEvent = function(event) {
      return touchEvents.indexOf(event.type) > -1 || event.pointerType === "touch";
    };
  })();
  (function() {
    function setStyle(element, styles) {
      var elementStyle = element.style;
      if (!elementStyle) {
        return element;
      }
      if (typeof styles === "string") {
        element.style.cssText += ";" + styles;
        return styles.indexOf("opacity") > -1 ? setOpacity(element, styles.match(/opacity:\s*(\d?\.?\d*)/)[1]) : element;
      }
      for (var property in styles) {
        if (property === "opacity") {
          setOpacity(element, styles[property]);
        } else {
          var normalizedProperty = property === "float" || property === "cssFloat" ? typeof elementStyle.styleFloat === "undefined" ? "cssFloat" : "styleFloat" : property;
          elementStyle.setProperty(normalizedProperty, styles[property]);
        }
      }
      return element;
    }
    var parseEl = fabric2.document.createElement("div"), supportsOpacity = typeof parseEl.style.opacity === "string", supportsFilters = typeof parseEl.style.filter === "string", reOpacity = /alpha\s*\(\s*opacity\s*=\s*([^\)]+)\)/, setOpacity = function(element) {
      return element;
    };
    if (supportsOpacity) {
      setOpacity = function(element, value) {
        element.style.opacity = value;
        return element;
      };
    } else if (supportsFilters) {
      setOpacity = function(element, value) {
        var es = element.style;
        if (element.currentStyle && !element.currentStyle.hasLayout) {
          es.zoom = 1;
        }
        if (reOpacity.test(es.filter)) {
          value = value >= 0.9999 ? "" : "alpha(opacity=" + value * 100 + ")";
          es.filter = es.filter.replace(reOpacity, value);
        } else {
          es.filter += " alpha(opacity=" + value * 100 + ")";
        }
        return element;
      };
    }
    fabric2.util.setStyle = setStyle;
  })();
  (function() {
    var _slice = Array.prototype.slice;
    function getById(id) {
      return typeof id === "string" ? fabric2.document.getElementById(id) : id;
    }
    var sliceCanConvertNodelists, toArray2 = function(arrayLike) {
      return _slice.call(arrayLike, 0);
    };
    try {
      sliceCanConvertNodelists = toArray2(fabric2.document.childNodes) instanceof Array;
    } catch (err) {
    }
    if (!sliceCanConvertNodelists) {
      toArray2 = function(arrayLike) {
        var arr = new Array(arrayLike.length), i = arrayLike.length;
        while (i--) {
          arr[i] = arrayLike[i];
        }
        return arr;
      };
    }
    function makeElement(tagName, attributes) {
      var el = fabric2.document.createElement(tagName);
      for (var prop in attributes) {
        if (prop === "class") {
          el.className = attributes[prop];
        } else if (prop === "for") {
          el.htmlFor = attributes[prop];
        } else {
          el.setAttribute(prop, attributes[prop]);
        }
      }
      return el;
    }
    function addClass(element, className) {
      if (element && (" " + element.className + " ").indexOf(" " + className + " ") === -1) {
        element.className += (element.className ? " " : "") + className;
      }
    }
    function wrapElement(element, wrapper, attributes) {
      if (typeof wrapper === "string") {
        wrapper = makeElement(wrapper, attributes);
      }
      if (element.parentNode) {
        element.parentNode.replaceChild(wrapper, element);
      }
      wrapper.appendChild(element);
      return wrapper;
    }
    function getScrollLeftTop(element) {
      var left = 0, top = 0, docElement = fabric2.document.documentElement, body = fabric2.document.body || {
        scrollLeft: 0,
        scrollTop: 0
      };
      while (element && (element.parentNode || element.host)) {
        element = element.parentNode || element.host;
        if (element === fabric2.document) {
          left = body.scrollLeft || docElement.scrollLeft || 0;
          top = body.scrollTop || docElement.scrollTop || 0;
        } else {
          left += element.scrollLeft || 0;
          top += element.scrollTop || 0;
        }
        if (element.nodeType === 1 && element.style.position === "fixed") {
          break;
        }
      }
      return { left, top };
    }
    function getElementOffset(element) {
      var docElem, doc = element && element.ownerDocument, box = { left: 0, top: 0 }, offset = { left: 0, top: 0 }, scrollLeftTop, offsetAttributes = {
        borderLeftWidth: "left",
        borderTopWidth: "top",
        paddingLeft: "left",
        paddingTop: "top"
      };
      if (!doc) {
        return offset;
      }
      for (var attr in offsetAttributes) {
        offset[offsetAttributes[attr]] += parseInt(getElementStyle(element, attr), 10) || 0;
      }
      docElem = doc.documentElement;
      if (typeof element.getBoundingClientRect !== "undefined") {
        box = element.getBoundingClientRect();
      }
      scrollLeftTop = getScrollLeftTop(element);
      return {
        left: box.left + scrollLeftTop.left - (docElem.clientLeft || 0) + offset.left,
        top: box.top + scrollLeftTop.top - (docElem.clientTop || 0) + offset.top
      };
    }
    var getElementStyle;
    if (fabric2.document.defaultView && fabric2.document.defaultView.getComputedStyle) {
      getElementStyle = function(element, attr) {
        var style = fabric2.document.defaultView.getComputedStyle(element, null);
        return style ? style[attr] : void 0;
      };
    } else {
      getElementStyle = function(element, attr) {
        var value = element.style[attr];
        if (!value && element.currentStyle) {
          value = element.currentStyle[attr];
        }
        return value;
      };
    }
    (function() {
      var style = fabric2.document.documentElement.style, selectProp = "userSelect" in style ? "userSelect" : "MozUserSelect" in style ? "MozUserSelect" : "WebkitUserSelect" in style ? "WebkitUserSelect" : "KhtmlUserSelect" in style ? "KhtmlUserSelect" : "";
      function makeElementUnselectable(element) {
        if (typeof element.onselectstart !== "undefined") {
          element.onselectstart = fabric2.util.falseFunction;
        }
        if (selectProp) {
          element.style[selectProp] = "none";
        } else if (typeof element.unselectable === "string") {
          element.unselectable = "on";
        }
        return element;
      }
      function makeElementSelectable(element) {
        if (typeof element.onselectstart !== "undefined") {
          element.onselectstart = null;
        }
        if (selectProp) {
          element.style[selectProp] = "";
        } else if (typeof element.unselectable === "string") {
          element.unselectable = "";
        }
        return element;
      }
      fabric2.util.makeElementUnselectable = makeElementUnselectable;
      fabric2.util.makeElementSelectable = makeElementSelectable;
    })();
    function getNodeCanvas(element) {
      var impl = fabric2.jsdomImplForWrapper(element);
      return impl._canvas || impl._image;
    }
    function cleanUpJsdomNode(element) {
      if (!fabric2.isLikelyNode) {
        return;
      }
      var impl = fabric2.jsdomImplForWrapper(element);
      if (impl) {
        impl._image = null;
        impl._canvas = null;
        impl._currentSrc = null;
        impl._attributes = null;
        impl._classList = null;
      }
    }
    function setImageSmoothing(ctx, value) {
      ctx.imageSmoothingEnabled = ctx.imageSmoothingEnabled || ctx.webkitImageSmoothingEnabled || ctx.mozImageSmoothingEnabled || ctx.msImageSmoothingEnabled || ctx.oImageSmoothingEnabled;
      ctx.imageSmoothingEnabled = value;
    }
    fabric2.util.setImageSmoothing = setImageSmoothing;
    fabric2.util.getById = getById;
    fabric2.util.toArray = toArray2;
    fabric2.util.addClass = addClass;
    fabric2.util.makeElement = makeElement;
    fabric2.util.wrapElement = wrapElement;
    fabric2.util.getScrollLeftTop = getScrollLeftTop;
    fabric2.util.getElementOffset = getElementOffset;
    fabric2.util.getNodeCanvas = getNodeCanvas;
    fabric2.util.cleanUpJsdomNode = cleanUpJsdomNode;
  })();
  (function() {
    function addParamToUrl(url, param) {
      return url + (/\?/.test(url) ? "&" : "?") + param;
    }
    function emptyFn() {
    }
    function request(url, options) {
      options || (options = {});
      var method = options.method ? options.method.toUpperCase() : "GET", onComplete = options.onComplete || function() {
      }, xhr = new fabric2.window.XMLHttpRequest(), body = options.body || options.parameters;
      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4) {
          onComplete(xhr);
          xhr.onreadystatechange = emptyFn;
        }
      };
      if (method === "GET") {
        body = null;
        if (typeof options.parameters === "string") {
          url = addParamToUrl(url, options.parameters);
        }
      }
      xhr.open(method, url, true);
      if (method === "POST" || method === "PUT") {
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      }
      xhr.send(body);
      return xhr;
    }
    fabric2.util.request = request;
  })();
  fabric2.log = console.log;
  fabric2.warn = console.warn;
  (function() {
    var extend = fabric2.util.object.extend, clone2 = fabric2.util.object.clone;
    var RUNNING_ANIMATIONS = [];
    fabric2.util.object.extend(RUNNING_ANIMATIONS, {
      /**
       * cancel all running animations at the next requestAnimFrame
       * @returns {AnimationContext[]}
       */
      cancelAll: function() {
        var animations = this.splice(0);
        animations.forEach(function(animation) {
          animation.cancel();
        });
        return animations;
      },
      /**
       * cancel all running animations attached to canvas at the next requestAnimFrame
       * @param {fabric.Canvas} canvas
       * @returns {AnimationContext[]}
       */
      cancelByCanvas: function(canvas) {
        if (!canvas) {
          return [];
        }
        var cancelled = this.filter(function(animation) {
          return typeof animation.target === "object" && animation.target.canvas === canvas;
        });
        cancelled.forEach(function(animation) {
          animation.cancel();
        });
        return cancelled;
      },
      /**
       * cancel all running animations for target at the next requestAnimFrame
       * @param {*} target
       * @returns {AnimationContext[]}
       */
      cancelByTarget: function(target) {
        var cancelled = this.findAnimationsByTarget(target);
        cancelled.forEach(function(animation) {
          animation.cancel();
        });
        return cancelled;
      },
      /**
       *
       * @param {CancelFunction} cancelFunc the function returned by animate
       * @returns {number}
       */
      findAnimationIndex: function(cancelFunc) {
        return this.indexOf(this.findAnimation(cancelFunc));
      },
      /**
       *
       * @param {CancelFunction} cancelFunc the function returned by animate
       * @returns {AnimationContext | undefined} animation's options object
       */
      findAnimation: function(cancelFunc) {
        return this.find(function(animation) {
          return animation.cancel === cancelFunc;
        });
      },
      /**
       *
       * @param {*} target the object that is assigned to the target property of the animation context
       * @returns {AnimationContext[]} array of animation options object associated with target
       */
      findAnimationsByTarget: function(target) {
        if (!target) {
          return [];
        }
        return this.filter(function(animation) {
          return animation.target === target;
        });
      }
    });
    function noop() {
      return false;
    }
    function defaultEasing(t, b, c, d) {
      return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
    }
    function animate(options) {
      options || (options = {});
      var cancel = false, context, removeFromRegistry = function() {
        var index = fabric2.runningAnimations.indexOf(context);
        return index > -1 && fabric2.runningAnimations.splice(index, 1)[0];
      };
      context = extend(clone2(options), {
        cancel: function() {
          cancel = true;
          return removeFromRegistry();
        },
        currentValue: "startValue" in options ? options.startValue : 0,
        completionRate: 0,
        durationRate: 0
      });
      fabric2.runningAnimations.push(context);
      requestAnimFrame(function(timestamp) {
        var start = timestamp || +/* @__PURE__ */ new Date(), duration = options.duration || 500, finish = start + duration, time, onChange = options.onChange || noop, abort = options.abort || noop, onComplete = options.onComplete || noop, easing = options.easing || defaultEasing, isMany = "startValue" in options ? options.startValue.length > 0 : false, startValue = "startValue" in options ? options.startValue : 0, endValue = "endValue" in options ? options.endValue : 100, byValue = options.byValue || (isMany ? startValue.map(function(value, i) {
          return endValue[i] - startValue[i];
        }) : endValue - startValue);
        options.onStart && options.onStart();
        (function tick(ticktime) {
          time = ticktime || +/* @__PURE__ */ new Date();
          var currentTime = time > finish ? duration : time - start, timePerc = currentTime / duration, current = isMany ? startValue.map(function(_value, i) {
            return easing(currentTime, startValue[i], byValue[i], duration);
          }) : easing(currentTime, startValue, byValue, duration), valuePerc = isMany ? Math.abs((current[0] - startValue[0]) / byValue[0]) : Math.abs((current - startValue) / byValue);
          context.currentValue = isMany ? current.slice() : current;
          context.completionRate = valuePerc;
          context.durationRate = timePerc;
          if (cancel) {
            return;
          }
          if (abort(current, valuePerc, timePerc)) {
            removeFromRegistry();
            return;
          }
          if (time > finish) {
            context.currentValue = isMany ? endValue.slice() : endValue;
            context.completionRate = 1;
            context.durationRate = 1;
            onChange(isMany ? endValue.slice() : endValue, 1, 1);
            onComplete(endValue, 1, 1);
            removeFromRegistry();
            return;
          } else {
            onChange(current, valuePerc, timePerc);
            requestAnimFrame(tick);
          }
        })(start);
      });
      return context.cancel;
    }
    var _requestAnimFrame = fabric2.window.requestAnimationFrame || fabric2.window.webkitRequestAnimationFrame || fabric2.window.mozRequestAnimationFrame || fabric2.window.oRequestAnimationFrame || fabric2.window.msRequestAnimationFrame || function(callback) {
      return fabric2.window.setTimeout(callback, 1e3 / 60);
    };
    var _cancelAnimFrame = fabric2.window.cancelAnimationFrame || fabric2.window.clearTimeout;
    function requestAnimFrame() {
      return _requestAnimFrame.apply(fabric2.window, arguments);
    }
    function cancelAnimFrame() {
      return _cancelAnimFrame.apply(fabric2.window, arguments);
    }
    fabric2.util.animate = animate;
    fabric2.util.requestAnimFrame = requestAnimFrame;
    fabric2.util.cancelAnimFrame = cancelAnimFrame;
    fabric2.runningAnimations = RUNNING_ANIMATIONS;
  })();
  (function() {
    function calculateColor(begin, end, pos) {
      var color = "rgba(" + parseInt(begin[0] + pos * (end[0] - begin[0]), 10) + "," + parseInt(begin[1] + pos * (end[1] - begin[1]), 10) + "," + parseInt(begin[2] + pos * (end[2] - begin[2]), 10);
      color += "," + (begin && end ? parseFloat(begin[3] + pos * (end[3] - begin[3])) : 1);
      color += ")";
      return color;
    }
    function animateColor(fromColor, toColor, duration, options) {
      var startColor = new fabric2.Color(fromColor).getSource(), endColor = new fabric2.Color(toColor).getSource(), originalOnComplete = options.onComplete, originalOnChange = options.onChange;
      options = options || {};
      return fabric2.util.animate(fabric2.util.object.extend(options, {
        duration: duration || 500,
        startValue: startColor,
        endValue: endColor,
        byValue: endColor,
        easing: function(currentTime, startValue, byValue, duration2) {
          var posValue = options.colorEasing ? options.colorEasing(currentTime, duration2) : 1 - Math.cos(currentTime / duration2 * (Math.PI / 2));
          return calculateColor(startValue, byValue, posValue);
        },
        // has to take in account for color restoring;
        onComplete: function(current, valuePerc, timePerc) {
          if (originalOnComplete) {
            return originalOnComplete(
              calculateColor(endColor, endColor, 0),
              valuePerc,
              timePerc
            );
          }
        },
        onChange: function(current, valuePerc, timePerc) {
          if (originalOnChange) {
            if (Array.isArray(current)) {
              return originalOnChange(
                calculateColor(current, current, 0),
                valuePerc,
                timePerc
              );
            }
            originalOnChange(current, valuePerc, timePerc);
          }
        }
      }));
    }
    fabric2.util.animateColor = animateColor;
  })();
  (function() {
    function normalize(a, c, p, s) {
      if (a < Math.abs(c)) {
        a = c;
        s = p / 4;
      } else {
        if (c === 0 && a === 0) {
          s = p / (2 * Math.PI) * Math.asin(1);
        } else {
          s = p / (2 * Math.PI) * Math.asin(c / a);
        }
      }
      return { a, c, p, s };
    }
    function elastic(opts, t, d) {
      return opts.a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - opts.s) * (2 * Math.PI) / opts.p);
    }
    function easeOutCubic(t, b, c, d) {
      return c * ((t = t / d - 1) * t * t + 1) + b;
    }
    function easeInOutCubic(t, b, c, d) {
      t /= d / 2;
      if (t < 1) {
        return c / 2 * t * t * t + b;
      }
      return c / 2 * ((t -= 2) * t * t + 2) + b;
    }
    function easeInQuart(t, b, c, d) {
      return c * (t /= d) * t * t * t + b;
    }
    function easeOutQuart(t, b, c, d) {
      return -c * ((t = t / d - 1) * t * t * t - 1) + b;
    }
    function easeInOutQuart(t, b, c, d) {
      t /= d / 2;
      if (t < 1) {
        return c / 2 * t * t * t * t + b;
      }
      return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
    }
    function easeInQuint(t, b, c, d) {
      return c * (t /= d) * t * t * t * t + b;
    }
    function easeOutQuint(t, b, c, d) {
      return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    }
    function easeInOutQuint(t, b, c, d) {
      t /= d / 2;
      if (t < 1) {
        return c / 2 * t * t * t * t * t + b;
      }
      return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    }
    function easeInSine(t, b, c, d) {
      return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
    }
    function easeOutSine(t, b, c, d) {
      return c * Math.sin(t / d * (Math.PI / 2)) + b;
    }
    function easeInOutSine(t, b, c, d) {
      return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
    }
    function easeInExpo(t, b, c, d) {
      return t === 0 ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
    }
    function easeOutExpo(t, b, c, d) {
      return t === d ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
    }
    function easeInOutExpo(t, b, c, d) {
      if (t === 0) {
        return b;
      }
      if (t === d) {
        return b + c;
      }
      t /= d / 2;
      if (t < 1) {
        return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
      }
      return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
    }
    function easeInCirc(t, b, c, d) {
      return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
    }
    function easeOutCirc(t, b, c, d) {
      return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
    }
    function easeInOutCirc(t, b, c, d) {
      t /= d / 2;
      if (t < 1) {
        return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
      }
      return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
    }
    function easeInElastic(t, b, c, d) {
      var s = 1.70158, p = 0, a = c;
      if (t === 0) {
        return b;
      }
      t /= d;
      if (t === 1) {
        return b + c;
      }
      if (!p) {
        p = d * 0.3;
      }
      var opts = normalize(a, c, p, s);
      return -elastic(opts, t, d) + b;
    }
    function easeOutElastic(t, b, c, d) {
      var s = 1.70158, p = 0, a = c;
      if (t === 0) {
        return b;
      }
      t /= d;
      if (t === 1) {
        return b + c;
      }
      if (!p) {
        p = d * 0.3;
      }
      var opts = normalize(a, c, p, s);
      return opts.a * Math.pow(2, -10 * t) * Math.sin((t * d - opts.s) * (2 * Math.PI) / opts.p) + opts.c + b;
    }
    function easeInOutElastic(t, b, c, d) {
      var s = 1.70158, p = 0, a = c;
      if (t === 0) {
        return b;
      }
      t /= d / 2;
      if (t === 2) {
        return b + c;
      }
      if (!p) {
        p = d * (0.3 * 1.5);
      }
      var opts = normalize(a, c, p, s);
      if (t < 1) {
        return -0.5 * elastic(opts, t, d) + b;
      }
      return opts.a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - opts.s) * (2 * Math.PI) / opts.p) * 0.5 + opts.c + b;
    }
    function easeInBack(t, b, c, d, s) {
      if (s === void 0) {
        s = 1.70158;
      }
      return c * (t /= d) * t * ((s + 1) * t - s) + b;
    }
    function easeOutBack(t, b, c, d, s) {
      if (s === void 0) {
        s = 1.70158;
      }
      return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    }
    function easeInOutBack(t, b, c, d, s) {
      if (s === void 0) {
        s = 1.70158;
      }
      t /= d / 2;
      if (t < 1) {
        return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
      }
      return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
    }
    function easeInBounce(t, b, c, d) {
      return c - easeOutBounce(d - t, 0, c, d) + b;
    }
    function easeOutBounce(t, b, c, d) {
      if ((t /= d) < 1 / 2.75) {
        return c * (7.5625 * t * t) + b;
      } else if (t < 2 / 2.75) {
        return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
      } else if (t < 2.5 / 2.75) {
        return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
      } else {
        return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
      }
    }
    function easeInOutBounce(t, b, c, d) {
      if (t < d / 2) {
        return easeInBounce(t * 2, 0, c, d) * 0.5 + b;
      }
      return easeOutBounce(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
    }
    fabric2.util.ease = {
      /**
       * Quadratic easing in
       * @memberOf fabric.util.ease
       */
      easeInQuad: function(t, b, c, d) {
        return c * (t /= d) * t + b;
      },
      /**
       * Quadratic easing out
       * @memberOf fabric.util.ease
       */
      easeOutQuad: function(t, b, c, d) {
        return -c * (t /= d) * (t - 2) + b;
      },
      /**
       * Quadratic easing in and out
       * @memberOf fabric.util.ease
       */
      easeInOutQuad: function(t, b, c, d) {
        t /= d / 2;
        if (t < 1) {
          return c / 2 * t * t + b;
        }
        return -c / 2 * (--t * (t - 2) - 1) + b;
      },
      /**
       * Cubic easing in
       * @memberOf fabric.util.ease
       */
      easeInCubic: function(t, b, c, d) {
        return c * (t /= d) * t * t + b;
      },
      easeOutCubic,
      easeInOutCubic,
      easeInQuart,
      easeOutQuart,
      easeInOutQuart,
      easeInQuint,
      easeOutQuint,
      easeInOutQuint,
      easeInSine,
      easeOutSine,
      easeInOutSine,
      easeInExpo,
      easeOutExpo,
      easeInOutExpo,
      easeInCirc,
      easeOutCirc,
      easeInOutCirc,
      easeInElastic,
      easeOutElastic,
      easeInOutElastic,
      easeInBack,
      easeOutBack,
      easeInOutBack,
      easeInBounce,
      easeOutBounce,
      easeInOutBounce
    };
  })();
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), extend = fabric22.util.object.extend, clone2 = fabric22.util.object.clone, toFixed = fabric22.util.toFixed, parseUnit = fabric22.util.parseUnit, multiplyTransformMatrices = fabric22.util.multiplyTransformMatrices, svgValidTagNames = [
      "path",
      "circle",
      "polygon",
      "polyline",
      "ellipse",
      "rect",
      "line",
      "image",
      "text"
    ], svgViewBoxElements = ["symbol", "image", "marker", "pattern", "view", "svg"], svgInvalidAncestors = ["pattern", "defs", "symbol", "metadata", "clipPath", "mask", "desc"], svgValidParents = ["symbol", "g", "a", "svg", "clipPath", "defs"], attributesMap = {
      cx: "left",
      x: "left",
      r: "radius",
      cy: "top",
      y: "top",
      display: "visible",
      visibility: "visible",
      transform: "transformMatrix",
      "fill-opacity": "fillOpacity",
      "fill-rule": "fillRule",
      "font-family": "fontFamily",
      "font-size": "fontSize",
      "font-style": "fontStyle",
      "font-weight": "fontWeight",
      "letter-spacing": "charSpacing",
      "paint-order": "paintFirst",
      "stroke-dasharray": "strokeDashArray",
      "stroke-dashoffset": "strokeDashOffset",
      "stroke-linecap": "strokeLineCap",
      "stroke-linejoin": "strokeLineJoin",
      "stroke-miterlimit": "strokeMiterLimit",
      "stroke-opacity": "strokeOpacity",
      "stroke-width": "strokeWidth",
      "text-decoration": "textDecoration",
      "text-anchor": "textAnchor",
      opacity: "opacity",
      "clip-path": "clipPath",
      "clip-rule": "clipRule",
      "vector-effect": "strokeUniform",
      "image-rendering": "imageSmoothing"
    }, colorAttributes = {
      stroke: "strokeOpacity",
      fill: "fillOpacity"
    }, fSize = "font-size", cPath = "clip-path";
    fabric22.svgValidTagNamesRegEx = getSvgRegex(svgValidTagNames);
    fabric22.svgViewBoxElementsRegEx = getSvgRegex(svgViewBoxElements);
    fabric22.svgInvalidAncestorsRegEx = getSvgRegex(svgInvalidAncestors);
    fabric22.svgValidParentsRegEx = getSvgRegex(svgValidParents);
    fabric22.cssRules = {};
    fabric22.gradientDefs = {};
    fabric22.clipPaths = {};
    function normalizeAttr(attr) {
      if (attr in attributesMap) {
        return attributesMap[attr];
      }
      return attr;
    }
    function normalizeValue(attr, value, parentAttributes, fontSize) {
      var isArray = Array.isArray(value), parsed;
      if ((attr === "fill" || attr === "stroke") && value === "none") {
        value = "";
      } else if (attr === "strokeUniform") {
        return value === "non-scaling-stroke";
      } else if (attr === "strokeDashArray") {
        if (value === "none") {
          value = null;
        } else {
          value = value.replace(/,/g, " ").split(/\s+/).map(parseFloat);
        }
      } else if (attr === "transformMatrix") {
        if (parentAttributes && parentAttributes.transformMatrix) {
          value = multiplyTransformMatrices(
            parentAttributes.transformMatrix,
            fabric22.parseTransformAttribute(value)
          );
        } else {
          value = fabric22.parseTransformAttribute(value);
        }
      } else if (attr === "visible") {
        value = value !== "none" && value !== "hidden";
        if (parentAttributes && parentAttributes.visible === false) {
          value = false;
        }
      } else if (attr === "opacity") {
        value = parseFloat(value);
        if (parentAttributes && typeof parentAttributes.opacity !== "undefined") {
          value *= parentAttributes.opacity;
        }
      } else if (attr === "textAnchor") {
        value = value === "start" ? "left" : value === "end" ? "right" : "center";
      } else if (attr === "charSpacing") {
        parsed = parseUnit(value, fontSize) / fontSize * 1e3;
      } else if (attr === "paintFirst") {
        var fillIndex = value.indexOf("fill");
        var strokeIndex = value.indexOf("stroke");
        var value = "fill";
        if (fillIndex > -1 && strokeIndex > -1 && strokeIndex < fillIndex) {
          value = "stroke";
        } else if (fillIndex === -1 && strokeIndex > -1) {
          value = "stroke";
        }
      } else if (attr === "href" || attr === "xlink:href" || attr === "font") {
        return value;
      } else if (attr === "imageSmoothing") {
        return value === "optimizeQuality";
      } else {
        parsed = isArray ? value.map(parseUnit) : parseUnit(value, fontSize);
      }
      return !isArray && isNaN(parsed) ? value : parsed;
    }
    function getSvgRegex(arr) {
      return new RegExp("^(" + arr.join("|") + ")\\b", "i");
    }
    function _setStrokeFillOpacity(attributes) {
      for (var attr in colorAttributes) {
        if (typeof attributes[colorAttributes[attr]] === "undefined" || attributes[attr] === "") {
          continue;
        }
        if (typeof attributes[attr] === "undefined") {
          if (!fabric22.Object.prototype[attr]) {
            continue;
          }
          attributes[attr] = fabric22.Object.prototype[attr];
        }
        if (attributes[attr].indexOf("url(") === 0) {
          continue;
        }
        var color = new fabric22.Color(attributes[attr]);
        attributes[attr] = color.setAlpha(toFixed(color.getAlpha() * attributes[colorAttributes[attr]], 2)).toRgba();
      }
      return attributes;
    }
    function _getMultipleNodes(doc, nodeNames) {
      var nodeName, nodeArray = [], nodeList, i, len;
      for (i = 0, len = nodeNames.length; i < len; i++) {
        nodeName = nodeNames[i];
        nodeList = doc.getElementsByTagName(nodeName);
        nodeArray = nodeArray.concat(Array.prototype.slice.call(nodeList));
      }
      return nodeArray;
    }
    fabric22.parseTransformAttribute = function() {
      function rotateMatrix(matrix22, args) {
        var cos2 = fabric22.util.cos(args[0]), sin2 = fabric22.util.sin(args[0]), x = 0, y = 0;
        if (args.length === 3) {
          x = args[1];
          y = args[2];
        }
        matrix22[0] = cos2;
        matrix22[1] = sin2;
        matrix22[2] = -sin2;
        matrix22[3] = cos2;
        matrix22[4] = x - (cos2 * x - sin2 * y);
        matrix22[5] = y - (sin2 * x + cos2 * y);
      }
      function scaleMatrix(matrix22, args) {
        var multiplierX = args[0], multiplierY = args.length === 2 ? args[1] : args[0];
        matrix22[0] = multiplierX;
        matrix22[3] = multiplierY;
      }
      function skewMatrix(matrix22, args, pos) {
        matrix22[pos] = Math.tan(fabric22.util.degreesToRadians(args[0]));
      }
      function translateMatrix(matrix22, args) {
        matrix22[4] = args[0];
        if (args.length === 2) {
          matrix22[5] = args[1];
        }
      }
      var iMatrix = fabric22.iMatrix, number = fabric22.reNum, commaWsp = fabric22.commaWsp, skewX = "(?:(skewX)\\s*\\(\\s*(" + number + ")\\s*\\))", skewY = "(?:(skewY)\\s*\\(\\s*(" + number + ")\\s*\\))", rotate = "(?:(rotate)\\s*\\(\\s*(" + number + ")(?:" + commaWsp + "(" + number + ")" + commaWsp + "(" + number + "))?\\s*\\))", scale = "(?:(scale)\\s*\\(\\s*(" + number + ")(?:" + commaWsp + "(" + number + "))?\\s*\\))", translate = "(?:(translate)\\s*\\(\\s*(" + number + ")(?:" + commaWsp + "(" + number + "))?\\s*\\))", matrix2 = "(?:(matrix)\\s*\\(\\s*(" + number + ")" + commaWsp + "(" + number + ")" + commaWsp + "(" + number + ")" + commaWsp + "(" + number + ")" + commaWsp + "(" + number + ")" + commaWsp + "(" + number + ")\\s*\\))", transform = "(?:" + matrix2 + "|" + translate + "|" + scale + "|" + rotate + "|" + skewX + "|" + skewY + ")", transforms = "(?:" + transform + "(?:" + commaWsp + "*" + transform + ")*)", transformList = "^\\s*(?:" + transforms + "?)\\s*$", reTransformList = new RegExp(transformList), reTransform = new RegExp(transform, "g");
      return function(attributeValue) {
        var matrix22 = iMatrix.concat(), matrices = [];
        if (!attributeValue || attributeValue && !reTransformList.test(attributeValue)) {
          return matrix22;
        }
        attributeValue.replace(reTransform, function(match) {
          var m = new RegExp(transform).exec(match).filter(function(match2) {
            return !!match2;
          }), operation = m[1], args = m.slice(2).map(parseFloat);
          switch (operation) {
            case "translate":
              translateMatrix(matrix22, args);
              break;
            case "rotate":
              args[0] = fabric22.util.degreesToRadians(args[0]);
              rotateMatrix(matrix22, args);
              break;
            case "scale":
              scaleMatrix(matrix22, args);
              break;
            case "skewX":
              skewMatrix(matrix22, args, 2);
              break;
            case "skewY":
              skewMatrix(matrix22, args, 1);
              break;
            case "matrix":
              matrix22 = args;
              break;
          }
          matrices.push(matrix22.concat());
          matrix22 = iMatrix.concat();
        });
        var combinedMatrix = matrices[0];
        while (matrices.length > 1) {
          matrices.shift();
          combinedMatrix = fabric22.util.multiplyTransformMatrices(combinedMatrix, matrices[0]);
        }
        return combinedMatrix;
      };
    }();
    function parseStyleString(style, oStyle) {
      var attr, value;
      style.replace(/;\s*$/, "").split(";").forEach(function(chunk) {
        var pair = chunk.split(":");
        attr = pair[0].trim().toLowerCase();
        value = pair[1].trim();
        oStyle[attr] = value;
      });
    }
    function parseStyleObject(style, oStyle) {
      var attr, value;
      for (var prop in style) {
        if (typeof style[prop] === "undefined") {
          continue;
        }
        attr = prop.toLowerCase();
        value = style[prop];
        oStyle[attr] = value;
      }
    }
    function getGlobalStylesForElement(element, svgUid) {
      var styles = {};
      for (var rule in fabric22.cssRules[svgUid]) {
        if (elementMatchesRule(element, rule.split(" "))) {
          for (var property in fabric22.cssRules[svgUid][rule]) {
            styles[property] = fabric22.cssRules[svgUid][rule][property];
          }
        }
      }
      return styles;
    }
    function elementMatchesRule(element, selectors) {
      var firstMatching, parentMatching = true;
      firstMatching = selectorMatches(element, selectors.pop());
      if (firstMatching && selectors.length) {
        parentMatching = doesSomeParentMatch(element, selectors);
      }
      return firstMatching && parentMatching && selectors.length === 0;
    }
    function doesSomeParentMatch(element, selectors) {
      var selector, parentMatching = true;
      while (element.parentNode && element.parentNode.nodeType === 1 && selectors.length) {
        if (parentMatching) {
          selector = selectors.pop();
        }
        element = element.parentNode;
        parentMatching = selectorMatches(element, selector);
      }
      return selectors.length === 0;
    }
    function selectorMatches(element, selector) {
      var nodeName = element.nodeName, classNames = element.getAttribute("class"), id = element.getAttribute("id"), matcher, i;
      matcher = new RegExp("^" + nodeName, "i");
      selector = selector.replace(matcher, "");
      if (id && selector.length) {
        matcher = new RegExp("#" + id + "(?![a-zA-Z\\-]+)", "i");
        selector = selector.replace(matcher, "");
      }
      if (classNames && selector.length) {
        classNames = classNames.split(" ");
        for (i = classNames.length; i--; ) {
          matcher = new RegExp("\\." + classNames[i] + "(?![a-zA-Z\\-]+)", "i");
          selector = selector.replace(matcher, "");
        }
      }
      return selector.length === 0;
    }
    function elementById(doc, id) {
      var el;
      doc.getElementById && (el = doc.getElementById(id));
      if (el) {
        return el;
      }
      var node, i, len, nodelist = doc.getElementsByTagName("*");
      for (i = 0, len = nodelist.length; i < len; i++) {
        node = nodelist[i];
        if (id === node.getAttribute("id")) {
          return node;
        }
      }
    }
    function parseUseDirectives(doc) {
      var nodelist = _getMultipleNodes(doc, ["use", "svg:use"]), i = 0;
      while (nodelist.length && i < nodelist.length) {
        var el = nodelist[i], xlinkAttribute = el.getAttribute("xlink:href") || el.getAttribute("href");
        if (xlinkAttribute === null) {
          return;
        }
        var xlink = xlinkAttribute.slice(1), x = el.getAttribute("x") || 0, y = el.getAttribute("y") || 0, el2 = elementById(doc, xlink).cloneNode(true), currentTrans = (el2.getAttribute("transform") || "") + " translate(" + x + ", " + y + ")", parentNode, oldLength = nodelist.length, attr, j, attrs, len, namespace = fabric22.svgNS;
        applyViewboxTransform(el2);
        if (/^svg$/i.test(el2.nodeName)) {
          var el3 = el2.ownerDocument.createElementNS(namespace, "g");
          for (j = 0, attrs = el2.attributes, len = attrs.length; j < len; j++) {
            attr = attrs.item(j);
            el3.setAttributeNS(namespace, attr.nodeName, attr.nodeValue);
          }
          while (el2.firstChild) {
            el3.appendChild(el2.firstChild);
          }
          el2 = el3;
        }
        for (j = 0, attrs = el.attributes, len = attrs.length; j < len; j++) {
          attr = attrs.item(j);
          if (attr.nodeName === "x" || attr.nodeName === "y" || attr.nodeName === "xlink:href" || attr.nodeName === "href") {
            continue;
          }
          if (attr.nodeName === "transform") {
            currentTrans = attr.nodeValue + " " + currentTrans;
          } else {
            el2.setAttribute(attr.nodeName, attr.nodeValue);
          }
        }
        el2.setAttribute("transform", currentTrans);
        el2.setAttribute("instantiated_by_use", "1");
        el2.removeAttribute("id");
        parentNode = el.parentNode;
        parentNode.replaceChild(el2, el);
        if (nodelist.length === oldLength) {
          i++;
        }
      }
    }
    var reViewBoxAttrValue = new RegExp(
      "^\\s*(" + fabric22.reNum + "+)\\s*,?\\s*(" + fabric22.reNum + "+)\\s*,?\\s*(" + fabric22.reNum + "+)\\s*,?\\s*(" + fabric22.reNum + "+)\\s*$"
    );
    function applyViewboxTransform(element) {
      if (!fabric22.svgViewBoxElementsRegEx.test(element.nodeName)) {
        return {};
      }
      var viewBoxAttr = element.getAttribute("viewBox"), scaleX = 1, scaleY = 1, minX = 0, minY = 0, viewBoxWidth, viewBoxHeight, matrix2, el, widthAttr = element.getAttribute("width"), heightAttr = element.getAttribute("height"), x = element.getAttribute("x") || 0, y = element.getAttribute("y") || 0, preserveAspectRatio = element.getAttribute("preserveAspectRatio") || "", missingViewBox = !viewBoxAttr || !(viewBoxAttr = viewBoxAttr.match(reViewBoxAttrValue)), missingDimAttr = !widthAttr || !heightAttr || widthAttr === "100%" || heightAttr === "100%", toBeParsed = missingViewBox && missingDimAttr, parsedDim = {}, translateMatrix = "", widthDiff = 0, heightDiff = 0;
      parsedDim.width = 0;
      parsedDim.height = 0;
      parsedDim.toBeParsed = toBeParsed;
      if (missingViewBox) {
        if ((x || y) && element.parentNode && element.parentNode.nodeName !== "#document") {
          translateMatrix = " translate(" + parseUnit(x) + " " + parseUnit(y) + ") ";
          matrix2 = (element.getAttribute("transform") || "") + translateMatrix;
          element.setAttribute("transform", matrix2);
          element.removeAttribute("x");
          element.removeAttribute("y");
        }
      }
      if (toBeParsed) {
        return parsedDim;
      }
      if (missingViewBox) {
        parsedDim.width = parseUnit(widthAttr);
        parsedDim.height = parseUnit(heightAttr);
        return parsedDim;
      }
      minX = -parseFloat(viewBoxAttr[1]);
      minY = -parseFloat(viewBoxAttr[2]);
      viewBoxWidth = parseFloat(viewBoxAttr[3]);
      viewBoxHeight = parseFloat(viewBoxAttr[4]);
      parsedDim.minX = minX;
      parsedDim.minY = minY;
      parsedDim.viewBoxWidth = viewBoxWidth;
      parsedDim.viewBoxHeight = viewBoxHeight;
      if (!missingDimAttr) {
        parsedDim.width = parseUnit(widthAttr);
        parsedDim.height = parseUnit(heightAttr);
        scaleX = parsedDim.width / viewBoxWidth;
        scaleY = parsedDim.height / viewBoxHeight;
      } else {
        parsedDim.width = viewBoxWidth;
        parsedDim.height = viewBoxHeight;
      }
      preserveAspectRatio = fabric22.util.parsePreserveAspectRatioAttribute(preserveAspectRatio);
      if (preserveAspectRatio.alignX !== "none") {
        if (preserveAspectRatio.meetOrSlice === "meet") {
          scaleY = scaleX = scaleX > scaleY ? scaleY : scaleX;
        }
        if (preserveAspectRatio.meetOrSlice === "slice") {
          scaleY = scaleX = scaleX > scaleY ? scaleX : scaleY;
        }
        widthDiff = parsedDim.width - viewBoxWidth * scaleX;
        heightDiff = parsedDim.height - viewBoxHeight * scaleX;
        if (preserveAspectRatio.alignX === "Mid") {
          widthDiff /= 2;
        }
        if (preserveAspectRatio.alignY === "Mid") {
          heightDiff /= 2;
        }
        if (preserveAspectRatio.alignX === "Min") {
          widthDiff = 0;
        }
        if (preserveAspectRatio.alignY === "Min") {
          heightDiff = 0;
        }
      }
      if (scaleX === 1 && scaleY === 1 && minX === 0 && minY === 0 && x === 0 && y === 0) {
        return parsedDim;
      }
      if ((x || y) && element.parentNode.nodeName !== "#document") {
        translateMatrix = " translate(" + parseUnit(x) + " " + parseUnit(y) + ") ";
      }
      matrix2 = translateMatrix + " matrix(" + scaleX + " 0 0 " + scaleY + " " + (minX * scaleX + widthDiff) + " " + (minY * scaleY + heightDiff) + ") ";
      if (element.nodeName === "svg") {
        el = element.ownerDocument.createElementNS(fabric22.svgNS, "g");
        while (element.firstChild) {
          el.appendChild(element.firstChild);
        }
        element.appendChild(el);
      } else {
        el = element;
        el.removeAttribute("x");
        el.removeAttribute("y");
        matrix2 = el.getAttribute("transform") + matrix2;
      }
      el.setAttribute("transform", matrix2);
      return parsedDim;
    }
    function hasAncestorWithNodeName(element, nodeName) {
      while (element && (element = element.parentNode)) {
        if (element.nodeName && nodeName.test(element.nodeName.replace("svg:", "")) && !element.getAttribute("instantiated_by_use")) {
          return true;
        }
      }
      return false;
    }
    fabric22.parseSVGDocument = function(doc, callback, reviver, parsingOptions) {
      if (!doc) {
        return;
      }
      parseUseDirectives(doc);
      var svgUid = fabric22.Object.__uid++, i, len, options = applyViewboxTransform(doc), descendants = fabric22.util.toArray(doc.getElementsByTagName("*"));
      options.crossOrigin = parsingOptions && parsingOptions.crossOrigin;
      options.svgUid = svgUid;
      if (descendants.length === 0 && fabric22.isLikelyNode) {
        descendants = doc.selectNodes('//*[name(.)!="svg"]');
        var arr = [];
        for (i = 0, len = descendants.length; i < len; i++) {
          arr[i] = descendants[i];
        }
        descendants = arr;
      }
      var elements = descendants.filter(function(el) {
        applyViewboxTransform(el);
        return fabric22.svgValidTagNamesRegEx.test(el.nodeName.replace("svg:", "")) && !hasAncestorWithNodeName(el, fabric22.svgInvalidAncestorsRegEx);
      });
      if (!elements || elements && !elements.length) {
        callback && callback([], {});
        return;
      }
      var clipPaths = {};
      descendants.filter(function(el) {
        return el.nodeName.replace("svg:", "") === "clipPath";
      }).forEach(function(el) {
        var id = el.getAttribute("id");
        clipPaths[id] = fabric22.util.toArray(el.getElementsByTagName("*")).filter(function(el2) {
          return fabric22.svgValidTagNamesRegEx.test(el2.nodeName.replace("svg:", ""));
        });
      });
      fabric22.gradientDefs[svgUid] = fabric22.getGradientDefs(doc);
      fabric22.cssRules[svgUid] = fabric22.getCSSRules(doc);
      fabric22.clipPaths[svgUid] = clipPaths;
      fabric22.parseElements(elements, function(instances, elements2) {
        if (callback) {
          callback(instances, options, elements2, descendants);
          delete fabric22.gradientDefs[svgUid];
          delete fabric22.cssRules[svgUid];
          delete fabric22.clipPaths[svgUid];
        }
      }, clone2(options), reviver, parsingOptions);
    };
    function recursivelyParseGradientsXlink(doc, gradient) {
      var gradientsAttrs = ["gradientTransform", "x1", "x2", "y1", "y2", "gradientUnits", "cx", "cy", "r", "fx", "fy"], xlinkAttr = "xlink:href", xLink = gradient.getAttribute(xlinkAttr).slice(1), referencedGradient = elementById(doc, xLink);
      if (referencedGradient && referencedGradient.getAttribute(xlinkAttr)) {
        recursivelyParseGradientsXlink(doc, referencedGradient);
      }
      gradientsAttrs.forEach(function(attr) {
        if (referencedGradient && !gradient.hasAttribute(attr) && referencedGradient.hasAttribute(attr)) {
          gradient.setAttribute(attr, referencedGradient.getAttribute(attr));
        }
      });
      if (!gradient.children.length) {
        var referenceClone = referencedGradient.cloneNode(true);
        while (referenceClone.firstChild) {
          gradient.appendChild(referenceClone.firstChild);
        }
      }
      gradient.removeAttribute(xlinkAttr);
    }
    var reFontDeclaration = new RegExp(
      "(normal|italic)?\\s*(normal|small-caps)?\\s*(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900)?\\s*(" + fabric22.reNum + "(?:px|cm|mm|em|pt|pc|in)*)(?:\\/(normal|" + fabric22.reNum + "))?\\s+(.*)"
    );
    extend(fabric22, {
      /**
       * Parses a short font declaration, building adding its properties to a style object
       * @static
       * @function
       * @memberOf fabric
       * @param {String} value font declaration
       * @param {Object} oStyle definition
       */
      parseFontDeclaration: function(value, oStyle) {
        var match = value.match(reFontDeclaration);
        if (!match) {
          return;
        }
        var fontStyle = match[1], fontWeight = match[3], fontSize = match[4], lineHeight = match[5], fontFamily = match[6];
        if (fontStyle) {
          oStyle.fontStyle = fontStyle;
        }
        if (fontWeight) {
          oStyle.fontWeight = isNaN(parseFloat(fontWeight)) ? fontWeight : parseFloat(fontWeight);
        }
        if (fontSize) {
          oStyle.fontSize = parseUnit(fontSize);
        }
        if (fontFamily) {
          oStyle.fontFamily = fontFamily;
        }
        if (lineHeight) {
          oStyle.lineHeight = lineHeight === "normal" ? 1 : lineHeight;
        }
      },
      /**
       * Parses an SVG document, returning all of the gradient declarations found in it
       * @static
       * @function
       * @memberOf fabric
       * @param {SVGDocument} doc SVG document to parse
       * @return {Object} Gradient definitions; key corresponds to element id, value -- to gradient definition element
       */
      getGradientDefs: function(doc) {
        var tagArray = [
          "linearGradient",
          "radialGradient",
          "svg:linearGradient",
          "svg:radialGradient"
        ], elList = _getMultipleNodes(doc, tagArray), el, j = 0, gradientDefs = {};
        j = elList.length;
        while (j--) {
          el = elList[j];
          if (el.getAttribute("xlink:href")) {
            recursivelyParseGradientsXlink(doc, el);
          }
          gradientDefs[el.getAttribute("id")] = el;
        }
        return gradientDefs;
      },
      /**
       * Returns an object of attributes' name/value, given element and an array of attribute names;
       * Parses parent "g" nodes recursively upwards.
       * @static
       * @memberOf fabric
       * @param {DOMElement} element Element to parse
       * @param {Array} attributes Array of attributes to parse
       * @return {Object} object containing parsed attributes' names/values
       */
      parseAttributes: function(element, attributes, svgUid) {
        if (!element) {
          return;
        }
        var value, parentAttributes = {}, fontSize, parentFontSize;
        if (typeof svgUid === "undefined") {
          svgUid = element.getAttribute("svgUid");
        }
        if (element.parentNode && fabric22.svgValidParentsRegEx.test(element.parentNode.nodeName)) {
          parentAttributes = fabric22.parseAttributes(element.parentNode, attributes, svgUid);
        }
        var ownAttributes = attributes.reduce(function(memo, attr2) {
          value = element.getAttribute(attr2);
          if (value) {
            memo[attr2] = value;
          }
          return memo;
        }, {});
        var cssAttrs = extend(
          getGlobalStylesForElement(element, svgUid),
          fabric22.parseStyleAttribute(element)
        );
        ownAttributes = extend(
          ownAttributes,
          cssAttrs
        );
        if (cssAttrs[cPath]) {
          element.setAttribute(cPath, cssAttrs[cPath]);
        }
        fontSize = parentFontSize = parentAttributes.fontSize || fabric22.Text.DEFAULT_SVG_FONT_SIZE;
        if (ownAttributes[fSize]) {
          ownAttributes[fSize] = fontSize = parseUnit(ownAttributes[fSize], parentFontSize);
        }
        var normalizedAttr, normalizedValue, normalizedStyle = {};
        for (var attr in ownAttributes) {
          normalizedAttr = normalizeAttr(attr);
          normalizedValue = normalizeValue(normalizedAttr, ownAttributes[attr], parentAttributes, fontSize);
          normalizedStyle[normalizedAttr] = normalizedValue;
        }
        if (normalizedStyle && normalizedStyle.font) {
          fabric22.parseFontDeclaration(normalizedStyle.font, normalizedStyle);
        }
        var mergedAttrs = extend(parentAttributes, normalizedStyle);
        return fabric22.svgValidParentsRegEx.test(element.nodeName) ? mergedAttrs : _setStrokeFillOpacity(mergedAttrs);
      },
      /**
       * Transforms an array of svg elements to corresponding fabric.* instances
       * @static
       * @memberOf fabric
       * @param {Array} elements Array of elements to parse
       * @param {Function} callback Being passed an array of fabric instances (transformed from SVG elements)
       * @param {Object} [options] Options object
       * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
       */
      parseElements: function(elements, callback, options, reviver, parsingOptions) {
        new fabric22.ElementsParser(elements, callback, options, reviver, parsingOptions).parse();
      },
      /**
       * Parses "style" attribute, retuning an object with values
       * @static
       * @memberOf fabric
       * @param {SVGElement} element Element to parse
       * @return {Object} Objects with values parsed from style attribute of an element
       */
      parseStyleAttribute: function(element) {
        var oStyle = {}, style = element.getAttribute("style");
        if (!style) {
          return oStyle;
        }
        if (typeof style === "string") {
          parseStyleString(style, oStyle);
        } else {
          parseStyleObject(style, oStyle);
        }
        return oStyle;
      },
      /**
       * Parses "points" attribute, returning an array of values
       * @static
       * @memberOf fabric
       * @param {String} points points attribute string
       * @return {Array} array of points
       */
      parsePointsAttribute: function(points) {
        if (!points) {
          return null;
        }
        points = points.replace(/,/g, " ").trim();
        points = points.split(/\s+/);
        var parsedPoints = [], i, len;
        for (i = 0, len = points.length; i < len; i += 2) {
          parsedPoints.push({
            x: parseFloat(points[i]),
            y: parseFloat(points[i + 1])
          });
        }
        return parsedPoints;
      },
      /**
       * Returns CSS rules for a given SVG document
       * @static
       * @function
       * @memberOf fabric
       * @param {SVGDocument} doc SVG document to parse
       * @return {Object} CSS rules of this document
       */
      getCSSRules: function(doc) {
        var styles = doc.getElementsByTagName("style"), i, len, allRules = {}, rules;
        for (i = 0, len = styles.length; i < len; i++) {
          var styleContents = styles[i].textContent;
          styleContents = styleContents.replace(/\/\*[\s\S]*?\*\//g, "");
          if (styleContents.trim() === "") {
            continue;
          }
          rules = styleContents.split("}");
          rules = rules.filter(function(rule) {
            return rule.trim();
          });
          rules.forEach(function(rule) {
            var match = rule.split("{"), ruleObj = {}, declaration = match[1].trim(), propertyValuePairs = declaration.split(";").filter(function(pair2) {
              return pair2.trim();
            });
            for (i = 0, len = propertyValuePairs.length; i < len; i++) {
              var pair = propertyValuePairs[i].split(":"), property = pair[0].trim(), value = pair[1].trim();
              ruleObj[property] = value;
            }
            rule = match[0].trim();
            rule.split(",").forEach(function(_rule) {
              _rule = _rule.replace(/^svg/i, "").trim();
              if (_rule === "") {
                return;
              }
              if (allRules[_rule]) {
                fabric22.util.object.extend(allRules[_rule], ruleObj);
              } else {
                allRules[_rule] = fabric22.util.object.clone(ruleObj);
              }
            });
          });
        }
        return allRules;
      },
      /**
       * Takes url corresponding to an SVG document, and parses it into a set of fabric objects.
       * Note that SVG is fetched via XMLHttpRequest, so it needs to conform to SOP (Same Origin Policy)
       * @memberOf fabric
       * @param {String} url
       * @param {Function} callback
       * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
       * @param {Object} [options] Object containing options for parsing
       * @param {String} [options.crossOrigin] crossOrigin crossOrigin setting to use for external resources
       */
      loadSVGFromURL: function(url, callback, reviver, options) {
        url = url.replace(/^\n\s*/, "").trim();
        new fabric22.util.request(url, {
          method: "get",
          onComplete
        });
        function onComplete(r) {
          var xml = r.responseXML;
          if (!xml || !xml.documentElement) {
            callback && callback(null);
            return false;
          }
          fabric22.parseSVGDocument(xml.documentElement, function(results, _options, elements, allElements) {
            callback && callback(results, _options, elements, allElements);
          }, reviver, options);
        }
      },
      /**
       * Takes string corresponding to an SVG document, and parses it into a set of fabric objects
       * @memberOf fabric
       * @param {String} string
       * @param {Function} callback
       * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
       * @param {Object} [options] Object containing options for parsing
       * @param {String} [options.crossOrigin] crossOrigin crossOrigin setting to use for external resources
       */
      loadSVGFromString: function(string2, callback, reviver, options) {
        var parser = new fabric22.window.DOMParser(), doc = parser.parseFromString(string2.trim(), "text/xml");
        fabric22.parseSVGDocument(doc.documentElement, function(results, _options, elements, allElements) {
          callback(results, _options, elements, allElements);
        }, reviver, options);
      }
    });
  })(exports);
  fabric2.ElementsParser = function(elements, callback, options, reviver, parsingOptions, doc) {
    this.elements = elements;
    this.callback = callback;
    this.options = options;
    this.reviver = reviver;
    this.svgUid = options && options.svgUid || 0;
    this.parsingOptions = parsingOptions;
    this.regexUrl = /^url\(['"]?#([^'"]+)['"]?\)/g;
    this.doc = doc;
  };
  (function(proto2) {
    proto2.parse = function() {
      this.instances = new Array(this.elements.length);
      this.numElements = this.elements.length;
      this.createObjects();
    };
    proto2.createObjects = function() {
      var _this = this;
      this.elements.forEach(function(element, i) {
        element.setAttribute("svgUid", _this.svgUid);
        _this.createObject(element, i);
      });
    };
    proto2.findTag = function(el) {
      return fabric2[fabric2.util.string.capitalize(el.tagName.replace("svg:", ""))];
    };
    proto2.createObject = function(el, index) {
      var klass = this.findTag(el);
      if (klass && klass.fromElement) {
        try {
          klass.fromElement(el, this.createCallback(index, el), this.options);
        } catch (err) {
          fabric2.log(err);
        }
      } else {
        this.checkIfDone();
      }
    };
    proto2.createCallback = function(index, el) {
      var _this = this;
      return function(obj) {
        var _options;
        _this.resolveGradient(obj, el, "fill");
        _this.resolveGradient(obj, el, "stroke");
        if (obj instanceof fabric2.Image && obj._originalElement) {
          _options = obj.parsePreserveAspectRatioAttribute(el);
        }
        obj._removeTransformMatrix(_options);
        _this.resolveClipPath(obj, el);
        _this.reviver && _this.reviver(el, obj);
        _this.instances[index] = obj;
        _this.checkIfDone();
      };
    };
    proto2.extractPropertyDefinition = function(obj, property, storage) {
      var value = obj[property], regex = this.regexUrl;
      if (!regex.test(value)) {
        return;
      }
      regex.lastIndex = 0;
      var id = regex.exec(value)[1];
      regex.lastIndex = 0;
      return fabric2[storage][this.svgUid][id];
    };
    proto2.resolveGradient = function(obj, el, property) {
      var gradientDef = this.extractPropertyDefinition(obj, property, "gradientDefs");
      if (gradientDef) {
        var opacityAttr = el.getAttribute(property + "-opacity");
        var gradient = fabric2.Gradient.fromElement(gradientDef, obj, opacityAttr, this.options);
        obj.set(property, gradient);
      }
    };
    proto2.createClipPathCallback = function(obj, container) {
      return function(_newObj) {
        _newObj._removeTransformMatrix();
        _newObj.fillRule = _newObj.clipRule;
        container.push(_newObj);
      };
    };
    proto2.resolveClipPath = function(obj, usingElement) {
      var clipPath = this.extractPropertyDefinition(obj, "clipPath", "clipPaths"), element, klass, objTransformInv, container, gTransform, options;
      if (clipPath) {
        container = [];
        objTransformInv = fabric2.util.invertTransform(obj.calcTransformMatrix());
        var clipPathTag = clipPath[0].parentNode;
        var clipPathOwner = usingElement;
        while (clipPathOwner.parentNode && clipPathOwner.getAttribute("clip-path") !== obj.clipPath) {
          clipPathOwner = clipPathOwner.parentNode;
        }
        clipPathOwner.parentNode.appendChild(clipPathTag);
        for (var i = 0; i < clipPath.length; i++) {
          element = clipPath[i];
          klass = this.findTag(element);
          klass.fromElement(
            element,
            this.createClipPathCallback(obj, container),
            this.options
          );
        }
        if (container.length === 1) {
          clipPath = container[0];
        } else {
          clipPath = new fabric2.Group(container);
        }
        gTransform = fabric2.util.multiplyTransformMatrices(
          objTransformInv,
          clipPath.calcTransformMatrix()
        );
        if (clipPath.clipPath) {
          this.resolveClipPath(clipPath, clipPathOwner);
        }
        var options = fabric2.util.qrDecompose(gTransform);
        clipPath.flipX = false;
        clipPath.flipY = false;
        clipPath.set("scaleX", options.scaleX);
        clipPath.set("scaleY", options.scaleY);
        clipPath.angle = options.angle;
        clipPath.skewX = options.skewX;
        clipPath.skewY = 0;
        clipPath.setPositionByOrigin({ x: options.translateX, y: options.translateY }, "center", "center");
        obj.clipPath = clipPath;
      } else {
        delete obj.clipPath;
      }
    };
    proto2.checkIfDone = function() {
      if (--this.numElements === 0) {
        this.instances = this.instances.filter(function(el) {
          return el != null;
        });
        this.callback(this.instances, this.elements);
      }
    };
  })(fabric2.ElementsParser.prototype);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {});
    if (fabric22.Point) {
      fabric22.warn("fabric.Point is already defined");
      return;
    }
    fabric22.Point = Point;
    function Point(x, y) {
      this.x = x;
      this.y = y;
    }
    Point.prototype = /** @lends fabric.Point.prototype */
    {
      type: "point",
      constructor: Point,
      /**
       * Adds another point to this one and returns another one
       * @param {fabric.Point} that
       * @return {fabric.Point} new Point instance with added values
       */
      add: function(that) {
        return new Point(this.x + that.x, this.y + that.y);
      },
      /**
       * Adds another point to this one
       * @param {fabric.Point} that
       * @return {fabric.Point} thisArg
       * @chainable
       */
      addEquals: function(that) {
        this.x += that.x;
        this.y += that.y;
        return this;
      },
      /**
       * Adds value to this point and returns a new one
       * @param {Number} scalar
       * @return {fabric.Point} new Point with added value
       */
      scalarAdd: function(scalar) {
        return new Point(this.x + scalar, this.y + scalar);
      },
      /**
       * Adds value to this point
       * @param {Number} scalar
       * @return {fabric.Point} thisArg
       * @chainable
       */
      scalarAddEquals: function(scalar) {
        this.x += scalar;
        this.y += scalar;
        return this;
      },
      /**
       * Subtracts another point from this point and returns a new one
       * @param {fabric.Point} that
       * @return {fabric.Point} new Point object with subtracted values
       */
      subtract: function(that) {
        return new Point(this.x - that.x, this.y - that.y);
      },
      /**
       * Subtracts another point from this point
       * @param {fabric.Point} that
       * @return {fabric.Point} thisArg
       * @chainable
       */
      subtractEquals: function(that) {
        this.x -= that.x;
        this.y -= that.y;
        return this;
      },
      /**
       * Subtracts value from this point and returns a new one
       * @param {Number} scalar
       * @return {fabric.Point}
       */
      scalarSubtract: function(scalar) {
        return new Point(this.x - scalar, this.y - scalar);
      },
      /**
       * Subtracts value from this point
       * @param {Number} scalar
       * @return {fabric.Point} thisArg
       * @chainable
       */
      scalarSubtractEquals: function(scalar) {
        this.x -= scalar;
        this.y -= scalar;
        return this;
      },
      /**
       * Multiplies this point by a value and returns a new one
       * TODO: rename in scalarMultiply in 2.0
       * @param {Number} scalar
       * @return {fabric.Point}
       */
      multiply: function(scalar) {
        return new Point(this.x * scalar, this.y * scalar);
      },
      /**
       * Multiplies this point by a value
       * TODO: rename in scalarMultiplyEquals in 2.0
       * @param {Number} scalar
       * @return {fabric.Point} thisArg
       * @chainable
       */
      multiplyEquals: function(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
      },
      /**
       * Divides this point by a value and returns a new one
       * TODO: rename in scalarDivide in 2.0
       * @param {Number} scalar
       * @return {fabric.Point}
       */
      divide: function(scalar) {
        return new Point(this.x / scalar, this.y / scalar);
      },
      /**
       * Divides this point by a value
       * TODO: rename in scalarDivideEquals in 2.0
       * @param {Number} scalar
       * @return {fabric.Point} thisArg
       * @chainable
       */
      divideEquals: function(scalar) {
        this.x /= scalar;
        this.y /= scalar;
        return this;
      },
      /**
       * Returns true if this point is equal to another one
       * @param {fabric.Point} that
       * @return {Boolean}
       */
      eq: function(that) {
        return this.x === that.x && this.y === that.y;
      },
      /**
       * Returns true if this point is less than another one
       * @param {fabric.Point} that
       * @return {Boolean}
       */
      lt: function(that) {
        return this.x < that.x && this.y < that.y;
      },
      /**
       * Returns true if this point is less than or equal to another one
       * @param {fabric.Point} that
       * @return {Boolean}
       */
      lte: function(that) {
        return this.x <= that.x && this.y <= that.y;
      },
      /**
      
           * Returns true if this point is greater another one
           * @param {fabric.Point} that
           * @return {Boolean}
           */
      gt: function(that) {
        return this.x > that.x && this.y > that.y;
      },
      /**
       * Returns true if this point is greater than or equal to another one
       * @param {fabric.Point} that
       * @return {Boolean}
       */
      gte: function(that) {
        return this.x >= that.x && this.y >= that.y;
      },
      /**
       * Returns new point which is the result of linear interpolation with this one and another one
       * @param {fabric.Point} that
       * @param {Number} t , position of interpolation, between 0 and 1 default 0.5
       * @return {fabric.Point}
       */
      lerp: function(that, t) {
        if (typeof t === "undefined") {
          t = 0.5;
        }
        t = Math.max(Math.min(1, t), 0);
        return new Point(this.x + (that.x - this.x) * t, this.y + (that.y - this.y) * t);
      },
      /**
       * Returns distance from this point and another one
       * @param {fabric.Point} that
       * @return {Number}
       */
      distanceFrom: function(that) {
        var dx = this.x - that.x, dy = this.y - that.y;
        return Math.sqrt(dx * dx + dy * dy);
      },
      /**
       * Returns the point between this point and another one
       * @param {fabric.Point} that
       * @return {fabric.Point}
       */
      midPointFrom: function(that) {
        return this.lerp(that);
      },
      /**
       * Returns a new point which is the min of this and another one
       * @param {fabric.Point} that
       * @return {fabric.Point}
       */
      min: function(that) {
        return new Point(Math.min(this.x, that.x), Math.min(this.y, that.y));
      },
      /**
       * Returns a new point which is the max of this and another one
       * @param {fabric.Point} that
       * @return {fabric.Point}
       */
      max: function(that) {
        return new Point(Math.max(this.x, that.x), Math.max(this.y, that.y));
      },
      /**
       * Returns string representation of this point
       * @return {String}
       */
      toString: function() {
        return this.x + "," + this.y;
      },
      /**
       * Sets x/y of this point
       * @param {Number} x
       * @param {Number} y
       * @chainable
       */
      setXY: function(x, y) {
        this.x = x;
        this.y = y;
        return this;
      },
      /**
       * Sets x of this point
       * @param {Number} x
       * @chainable
       */
      setX: function(x) {
        this.x = x;
        return this;
      },
      /**
       * Sets y of this point
       * @param {Number} y
       * @chainable
       */
      setY: function(y) {
        this.y = y;
        return this;
      },
      /**
       * Sets x/y of this point from another point
       * @param {fabric.Point} that
       * @chainable
       */
      setFromPoint: function(that) {
        this.x = that.x;
        this.y = that.y;
        return this;
      },
      /**
       * Swaps x/y of this point and another point
       * @param {fabric.Point} that
       */
      swap: function(that) {
        var x = this.x, y = this.y;
        this.x = that.x;
        this.y = that.y;
        that.x = x;
        that.y = y;
      },
      /**
       * return a cloned instance of the point
       * @return {fabric.Point}
       */
      clone: function() {
        return new Point(this.x, this.y);
      }
    };
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {});
    if (fabric22.Intersection) {
      fabric22.warn("fabric.Intersection is already defined");
      return;
    }
    function Intersection(status) {
      this.status = status;
      this.points = [];
    }
    fabric22.Intersection = Intersection;
    fabric22.Intersection.prototype = /** @lends fabric.Intersection.prototype */
    {
      constructor: Intersection,
      /**
       * Appends a point to intersection
       * @param {fabric.Point} point
       * @return {fabric.Intersection} thisArg
       * @chainable
       */
      appendPoint: function(point) {
        this.points.push(point);
        return this;
      },
      /**
       * Appends points to intersection
       * @param {Array} points
       * @return {fabric.Intersection} thisArg
       * @chainable
       */
      appendPoints: function(points) {
        this.points = this.points.concat(points);
        return this;
      }
    };
    fabric22.Intersection.intersectLineLine = function(a1, a2, b1, b2) {
      var result, uaT = (b2.x - b1.x) * (a1.y - b1.y) - (b2.y - b1.y) * (a1.x - b1.x), ubT = (a2.x - a1.x) * (a1.y - b1.y) - (a2.y - a1.y) * (a1.x - b1.x), uB = (b2.y - b1.y) * (a2.x - a1.x) - (b2.x - b1.x) * (a2.y - a1.y);
      if (uB !== 0) {
        var ua = uaT / uB, ub = ubT / uB;
        if (0 <= ua && ua <= 1 && 0 <= ub && ub <= 1) {
          result = new Intersection("Intersection");
          result.appendPoint(new fabric22.Point(a1.x + ua * (a2.x - a1.x), a1.y + ua * (a2.y - a1.y)));
        } else {
          result = new Intersection();
        }
      } else {
        if (uaT === 0 || ubT === 0) {
          result = new Intersection("Coincident");
        } else {
          result = new Intersection("Parallel");
        }
      }
      return result;
    };
    fabric22.Intersection.intersectLinePolygon = function(a1, a2, points) {
      var result = new Intersection(), length = points.length, b1, b2, inter, i;
      for (i = 0; i < length; i++) {
        b1 = points[i];
        b2 = points[(i + 1) % length];
        inter = Intersection.intersectLineLine(a1, a2, b1, b2);
        result.appendPoints(inter.points);
      }
      if (result.points.length > 0) {
        result.status = "Intersection";
      }
      return result;
    };
    fabric22.Intersection.intersectPolygonPolygon = function(points1, points2) {
      var result = new Intersection(), length = points1.length, i;
      for (i = 0; i < length; i++) {
        var a1 = points1[i], a2 = points1[(i + 1) % length], inter = Intersection.intersectLinePolygon(a1, a2, points2);
        result.appendPoints(inter.points);
      }
      if (result.points.length > 0) {
        result.status = "Intersection";
      }
      return result;
    };
    fabric22.Intersection.intersectPolygonRectangle = function(points, r1, r2) {
      var min2 = r1.min(r2), max2 = r1.max(r2), topRight = new fabric22.Point(max2.x, min2.y), bottomLeft = new fabric22.Point(min2.x, max2.y), inter1 = Intersection.intersectLinePolygon(min2, topRight, points), inter2 = Intersection.intersectLinePolygon(topRight, max2, points), inter3 = Intersection.intersectLinePolygon(max2, bottomLeft, points), inter4 = Intersection.intersectLinePolygon(bottomLeft, min2, points), result = new Intersection();
      result.appendPoints(inter1.points);
      result.appendPoints(inter2.points);
      result.appendPoints(inter3.points);
      result.appendPoints(inter4.points);
      if (result.points.length > 0) {
        result.status = "Intersection";
      }
      return result;
    };
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {});
    if (fabric22.Color) {
      fabric22.warn("fabric.Color is already defined.");
      return;
    }
    function Color(color) {
      if (!color) {
        this.setSource([0, 0, 0, 1]);
      } else {
        this._tryParsingColor(color);
      }
    }
    fabric22.Color = Color;
    fabric22.Color.prototype = /** @lends fabric.Color.prototype */
    {
      /**
       * @private
       * @param {String|Array} color Color value to parse
       */
      _tryParsingColor: function(color) {
        var source;
        if (color in Color.colorNameMap) {
          color = Color.colorNameMap[color];
        }
        if (color === "transparent") {
          source = [255, 255, 255, 0];
        }
        if (!source) {
          source = Color.sourceFromHex(color);
        }
        if (!source) {
          source = Color.sourceFromRgb(color);
        }
        if (!source) {
          source = Color.sourceFromHsl(color);
        }
        if (!source) {
          source = [0, 0, 0, 1];
        }
        if (source) {
          this.setSource(source);
        }
      },
      /**
       * Adapted from <a href="https://rawgithub.com/mjijackson/mjijackson.github.com/master/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript.html">https://github.com/mjijackson</a>
       * @private
       * @param {Number} r Red color value
       * @param {Number} g Green color value
       * @param {Number} b Blue color value
       * @return {Array} Hsl color
       */
      _rgbToHsl: function(r, g, b) {
        r /= 255;
        g /= 255;
        b /= 255;
        var h, s, l, max2 = fabric22.util.array.max([r, g, b]), min2 = fabric22.util.array.min([r, g, b]);
        l = (max2 + min2) / 2;
        if (max2 === min2) {
          h = s = 0;
        } else {
          var d = max2 - min2;
          s = l > 0.5 ? d / (2 - max2 - min2) : d / (max2 + min2);
          switch (max2) {
            case r:
              h = (g - b) / d + (g < b ? 6 : 0);
              break;
            case g:
              h = (b - r) / d + 2;
              break;
            case b:
              h = (r - g) / d + 4;
              break;
          }
          h /= 6;
        }
        return [
          Math.round(h * 360),
          Math.round(s * 100),
          Math.round(l * 100)
        ];
      },
      /**
       * Returns source of this color (where source is an array representation; ex: [200, 200, 100, 1])
       * @return {Array}
       */
      getSource: function() {
        return this._source;
      },
      /**
       * Sets source of this color (where source is an array representation; ex: [200, 200, 100, 1])
       * @param {Array} source
       */
      setSource: function(source) {
        this._source = source;
      },
      /**
       * Returns color representation in RGB format
       * @return {String} ex: rgb(0-255,0-255,0-255)
       */
      toRgb: function() {
        var source = this.getSource();
        return "rgb(" + source[0] + "," + source[1] + "," + source[2] + ")";
      },
      /**
       * Returns color representation in RGBA format
       * @return {String} ex: rgba(0-255,0-255,0-255,0-1)
       */
      toRgba: function() {
        var source = this.getSource();
        return "rgba(" + source[0] + "," + source[1] + "," + source[2] + "," + source[3] + ")";
      },
      /**
       * Returns color representation in HSL format
       * @return {String} ex: hsl(0-360,0%-100%,0%-100%)
       */
      toHsl: function() {
        var source = this.getSource(), hsl = this._rgbToHsl(source[0], source[1], source[2]);
        return "hsl(" + hsl[0] + "," + hsl[1] + "%," + hsl[2] + "%)";
      },
      /**
       * Returns color representation in HSLA format
       * @return {String} ex: hsla(0-360,0%-100%,0%-100%,0-1)
       */
      toHsla: function() {
        var source = this.getSource(), hsl = this._rgbToHsl(source[0], source[1], source[2]);
        return "hsla(" + hsl[0] + "," + hsl[1] + "%," + hsl[2] + "%," + source[3] + ")";
      },
      /**
       * Returns color representation in HEX format
       * @return {String} ex: FF5555
       */
      toHex: function() {
        var source = this.getSource(), r, g, b;
        r = source[0].toString(16);
        r = r.length === 1 ? "0" + r : r;
        g = source[1].toString(16);
        g = g.length === 1 ? "0" + g : g;
        b = source[2].toString(16);
        b = b.length === 1 ? "0" + b : b;
        return r.toUpperCase() + g.toUpperCase() + b.toUpperCase();
      },
      /**
       * Returns color representation in HEXA format
       * @return {String} ex: FF5555CC
       */
      toHexa: function() {
        var source = this.getSource(), a;
        a = Math.round(source[3] * 255);
        a = a.toString(16);
        a = a.length === 1 ? "0" + a : a;
        return this.toHex() + a.toUpperCase();
      },
      /**
       * Gets value of alpha channel for this color
       * @return {Number} 0-1
       */
      getAlpha: function() {
        return this.getSource()[3];
      },
      /**
       * Sets value of alpha channel for this color
       * @param {Number} alpha Alpha value 0-1
       * @return {fabric.Color} thisArg
       */
      setAlpha: function(alpha) {
        var source = this.getSource();
        source[3] = alpha;
        this.setSource(source);
        return this;
      },
      /**
       * Transforms color to its grayscale representation
       * @return {fabric.Color} thisArg
       */
      toGrayscale: function() {
        var source = this.getSource(), average = parseInt((source[0] * 0.3 + source[1] * 0.59 + source[2] * 0.11).toFixed(0), 10), currentAlpha = source[3];
        this.setSource([average, average, average, currentAlpha]);
        return this;
      },
      /**
       * Transforms color to its black and white representation
       * @param {Number} threshold
       * @return {fabric.Color} thisArg
       */
      toBlackWhite: function(threshold) {
        var source = this.getSource(), average = (source[0] * 0.3 + source[1] * 0.59 + source[2] * 0.11).toFixed(0), currentAlpha = source[3];
        threshold = threshold || 127;
        average = Number(average) < Number(threshold) ? 0 : 255;
        this.setSource([average, average, average, currentAlpha]);
        return this;
      },
      /**
       * Overlays color with another color
       * @param {String|fabric.Color} otherColor
       * @return {fabric.Color} thisArg
       */
      overlayWith: function(otherColor) {
        if (!(otherColor instanceof Color)) {
          otherColor = new Color(otherColor);
        }
        var result = [], alpha = this.getAlpha(), otherAlpha = 0.5, source = this.getSource(), otherSource = otherColor.getSource(), i;
        for (i = 0; i < 3; i++) {
          result.push(Math.round(source[i] * (1 - otherAlpha) + otherSource[i] * otherAlpha));
        }
        result[3] = alpha;
        this.setSource(result);
        return this;
      }
    };
    fabric22.Color.reRGBa = /^rgba?\(\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*(?:\s*,\s*((?:\d*\.?\d+)?)\s*)?\)$/i;
    fabric22.Color.reHSLa = /^hsla?\(\s*(\d{1,3})\s*,\s*(\d{1,3}\%)\s*,\s*(\d{1,3}\%)\s*(?:\s*,\s*(\d+(?:\.\d+)?)\s*)?\)$/i;
    fabric22.Color.reHex = /^#?([0-9a-f]{8}|[0-9a-f]{6}|[0-9a-f]{4}|[0-9a-f]{3})$/i;
    fabric22.Color.colorNameMap = {
      aliceblue: "#F0F8FF",
      antiquewhite: "#FAEBD7",
      aqua: "#00FFFF",
      aquamarine: "#7FFFD4",
      azure: "#F0FFFF",
      beige: "#F5F5DC",
      bisque: "#FFE4C4",
      black: "#000000",
      blanchedalmond: "#FFEBCD",
      blue: "#0000FF",
      blueviolet: "#8A2BE2",
      brown: "#A52A2A",
      burlywood: "#DEB887",
      cadetblue: "#5F9EA0",
      chartreuse: "#7FFF00",
      chocolate: "#D2691E",
      coral: "#FF7F50",
      cornflowerblue: "#6495ED",
      cornsilk: "#FFF8DC",
      crimson: "#DC143C",
      cyan: "#00FFFF",
      darkblue: "#00008B",
      darkcyan: "#008B8B",
      darkgoldenrod: "#B8860B",
      darkgray: "#A9A9A9",
      darkgrey: "#A9A9A9",
      darkgreen: "#006400",
      darkkhaki: "#BDB76B",
      darkmagenta: "#8B008B",
      darkolivegreen: "#556B2F",
      darkorange: "#FF8C00",
      darkorchid: "#9932CC",
      darkred: "#8B0000",
      darksalmon: "#E9967A",
      darkseagreen: "#8FBC8F",
      darkslateblue: "#483D8B",
      darkslategray: "#2F4F4F",
      darkslategrey: "#2F4F4F",
      darkturquoise: "#00CED1",
      darkviolet: "#9400D3",
      deeppink: "#FF1493",
      deepskyblue: "#00BFFF",
      dimgray: "#696969",
      dimgrey: "#696969",
      dodgerblue: "#1E90FF",
      firebrick: "#B22222",
      floralwhite: "#FFFAF0",
      forestgreen: "#228B22",
      fuchsia: "#FF00FF",
      gainsboro: "#DCDCDC",
      ghostwhite: "#F8F8FF",
      gold: "#FFD700",
      goldenrod: "#DAA520",
      gray: "#808080",
      grey: "#808080",
      green: "#008000",
      greenyellow: "#ADFF2F",
      honeydew: "#F0FFF0",
      hotpink: "#FF69B4",
      indianred: "#CD5C5C",
      indigo: "#4B0082",
      ivory: "#FFFFF0",
      khaki: "#F0E68C",
      lavender: "#E6E6FA",
      lavenderblush: "#FFF0F5",
      lawngreen: "#7CFC00",
      lemonchiffon: "#FFFACD",
      lightblue: "#ADD8E6",
      lightcoral: "#F08080",
      lightcyan: "#E0FFFF",
      lightgoldenrodyellow: "#FAFAD2",
      lightgray: "#D3D3D3",
      lightgrey: "#D3D3D3",
      lightgreen: "#90EE90",
      lightpink: "#FFB6C1",
      lightsalmon: "#FFA07A",
      lightseagreen: "#20B2AA",
      lightskyblue: "#87CEFA",
      lightslategray: "#778899",
      lightslategrey: "#778899",
      lightsteelblue: "#B0C4DE",
      lightyellow: "#FFFFE0",
      lime: "#00FF00",
      limegreen: "#32CD32",
      linen: "#FAF0E6",
      magenta: "#FF00FF",
      maroon: "#800000",
      mediumaquamarine: "#66CDAA",
      mediumblue: "#0000CD",
      mediumorchid: "#BA55D3",
      mediumpurple: "#9370DB",
      mediumseagreen: "#3CB371",
      mediumslateblue: "#7B68EE",
      mediumspringgreen: "#00FA9A",
      mediumturquoise: "#48D1CC",
      mediumvioletred: "#C71585",
      midnightblue: "#191970",
      mintcream: "#F5FFFA",
      mistyrose: "#FFE4E1",
      moccasin: "#FFE4B5",
      navajowhite: "#FFDEAD",
      navy: "#000080",
      oldlace: "#FDF5E6",
      olive: "#808000",
      olivedrab: "#6B8E23",
      orange: "#FFA500",
      orangered: "#FF4500",
      orchid: "#DA70D6",
      palegoldenrod: "#EEE8AA",
      palegreen: "#98FB98",
      paleturquoise: "#AFEEEE",
      palevioletred: "#DB7093",
      papayawhip: "#FFEFD5",
      peachpuff: "#FFDAB9",
      peru: "#CD853F",
      pink: "#FFC0CB",
      plum: "#DDA0DD",
      powderblue: "#B0E0E6",
      purple: "#800080",
      rebeccapurple: "#663399",
      red: "#FF0000",
      rosybrown: "#BC8F8F",
      royalblue: "#4169E1",
      saddlebrown: "#8B4513",
      salmon: "#FA8072",
      sandybrown: "#F4A460",
      seagreen: "#2E8B57",
      seashell: "#FFF5EE",
      sienna: "#A0522D",
      silver: "#C0C0C0",
      skyblue: "#87CEEB",
      slateblue: "#6A5ACD",
      slategray: "#708090",
      slategrey: "#708090",
      snow: "#FFFAFA",
      springgreen: "#00FF7F",
      steelblue: "#4682B4",
      tan: "#D2B48C",
      teal: "#008080",
      thistle: "#D8BFD8",
      tomato: "#FF6347",
      turquoise: "#40E0D0",
      violet: "#EE82EE",
      wheat: "#F5DEB3",
      white: "#FFFFFF",
      whitesmoke: "#F5F5F5",
      yellow: "#FFFF00",
      yellowgreen: "#9ACD32"
    };
    function hue2rgb(p, q, t) {
      if (t < 0) {
        t += 1;
      }
      if (t > 1) {
        t -= 1;
      }
      if (t < 1 / 6) {
        return p + (q - p) * 6 * t;
      }
      if (t < 1 / 2) {
        return q;
      }
      if (t < 2 / 3) {
        return p + (q - p) * (2 / 3 - t) * 6;
      }
      return p;
    }
    fabric22.Color.fromRgb = function(color) {
      return Color.fromSource(Color.sourceFromRgb(color));
    };
    fabric22.Color.sourceFromRgb = function(color) {
      var match = color.match(Color.reRGBa);
      if (match) {
        var r = parseInt(match[1], 10) / (/%$/.test(match[1]) ? 100 : 1) * (/%$/.test(match[1]) ? 255 : 1), g = parseInt(match[2], 10) / (/%$/.test(match[2]) ? 100 : 1) * (/%$/.test(match[2]) ? 255 : 1), b = parseInt(match[3], 10) / (/%$/.test(match[3]) ? 100 : 1) * (/%$/.test(match[3]) ? 255 : 1);
        return [
          parseInt(r, 10),
          parseInt(g, 10),
          parseInt(b, 10),
          match[4] ? parseFloat(match[4]) : 1
        ];
      }
    };
    fabric22.Color.fromRgba = Color.fromRgb;
    fabric22.Color.fromHsl = function(color) {
      return Color.fromSource(Color.sourceFromHsl(color));
    };
    fabric22.Color.sourceFromHsl = function(color) {
      var match = color.match(Color.reHSLa);
      if (!match) {
        return;
      }
      var h = (parseFloat(match[1]) % 360 + 360) % 360 / 360, s = parseFloat(match[2]) / (/%$/.test(match[2]) ? 100 : 1), l = parseFloat(match[3]) / (/%$/.test(match[3]) ? 100 : 1), r, g, b;
      if (s === 0) {
        r = g = b = l;
      } else {
        var q = l <= 0.5 ? l * (s + 1) : l + s - l * s, p = l * 2 - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
      }
      return [
        Math.round(r * 255),
        Math.round(g * 255),
        Math.round(b * 255),
        match[4] ? parseFloat(match[4]) : 1
      ];
    };
    fabric22.Color.fromHsla = Color.fromHsl;
    fabric22.Color.fromHex = function(color) {
      return Color.fromSource(Color.sourceFromHex(color));
    };
    fabric22.Color.sourceFromHex = function(color) {
      if (color.match(Color.reHex)) {
        var value = color.slice(color.indexOf("#") + 1), isShortNotation = value.length === 3 || value.length === 4, isRGBa = value.length === 8 || value.length === 4, r = isShortNotation ? value.charAt(0) + value.charAt(0) : value.substring(0, 2), g = isShortNotation ? value.charAt(1) + value.charAt(1) : value.substring(2, 4), b = isShortNotation ? value.charAt(2) + value.charAt(2) : value.substring(4, 6), a = isRGBa ? isShortNotation ? value.charAt(3) + value.charAt(3) : value.substring(6, 8) : "FF";
        return [
          parseInt(r, 16),
          parseInt(g, 16),
          parseInt(b, 16),
          parseFloat((parseInt(a, 16) / 255).toFixed(2))
        ];
      }
    };
    fabric22.Color.fromSource = function(source) {
      var oColor = new Color();
      oColor.setSource(source);
      return oColor;
    };
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), scaleMap = ["e", "se", "s", "sw", "w", "nw", "n", "ne", "e"], skewMap = ["ns", "nesw", "ew", "nwse"], controls = {}, LEFT2 = "left", TOP2 = "top", RIGHT2 = "right", BOTTOM2 = "bottom", CENTER2 = "center", opposite2 = {
      top: BOTTOM2,
      bottom: TOP2,
      left: RIGHT2,
      right: LEFT2,
      center: CENTER2
    }, radiansToDegrees = fabric22.util.radiansToDegrees, sign2 = Math.sign || function(x) {
      return (x > 0) - (x < 0) || +x;
    };
    function findCornerQuadrant(fabricObject, control) {
      var cornerAngle = fabricObject.angle + radiansToDegrees(Math.atan2(control.y, control.x)) + 360;
      return Math.round(cornerAngle % 360 / 45);
    }
    function fireEvent(eventName, options) {
      var target = options.transform.target, canvas = target.canvas, canvasOptions = fabric22.util.object.clone(options);
      canvasOptions.target = target;
      canvas && canvas.fire("object:" + eventName, canvasOptions);
      target.fire(eventName, options);
    }
    function scaleIsProportional2(eventData, fabricObject) {
      var canvas = fabricObject.canvas, uniScaleKey = canvas.uniScaleKey, uniformIsToggled = eventData[uniScaleKey];
      return canvas.uniformScaling && !uniformIsToggled || !canvas.uniformScaling && uniformIsToggled;
    }
    function isTransformCentered2(transform) {
      return transform.originX === CENTER2 && transform.originY === CENTER2;
    }
    function scalingIsForbidden2(fabricObject, by, scaleProportionally) {
      var lockX = fabricObject.lockScalingX, lockY = fabricObject.lockScalingY;
      if (lockX && lockY) {
        return true;
      }
      if (!by && (lockX || lockY) && scaleProportionally) {
        return true;
      }
      if (lockX && by === "x") {
        return true;
      }
      if (lockY && by === "y") {
        return true;
      }
      return false;
    }
    function scaleCursorStyleHandler(eventData, control, fabricObject) {
      var notAllowed = "not-allowed", scaleProportionally = scaleIsProportional2(eventData, fabricObject), by = "";
      if (control.x !== 0 && control.y === 0) {
        by = "x";
      } else if (control.x === 0 && control.y !== 0) {
        by = "y";
      }
      if (scalingIsForbidden2(fabricObject, by, scaleProportionally)) {
        return notAllowed;
      }
      var n = findCornerQuadrant(fabricObject, control);
      return scaleMap[n] + "-resize";
    }
    function skewCursorStyleHandler(eventData, control, fabricObject) {
      var notAllowed = "not-allowed";
      if (control.x !== 0 && fabricObject.lockSkewingY) {
        return notAllowed;
      }
      if (control.y !== 0 && fabricObject.lockSkewingX) {
        return notAllowed;
      }
      var n = findCornerQuadrant(fabricObject, control) % 4;
      return skewMap[n] + "-resize";
    }
    function scaleSkewCursorStyleHandler(eventData, control, fabricObject) {
      if (eventData[fabricObject.canvas.altActionKey]) {
        return controls.skewCursorStyleHandler(eventData, control, fabricObject);
      }
      return controls.scaleCursorStyleHandler(eventData, control, fabricObject);
    }
    function scaleOrSkewActionName(eventData, control, fabricObject) {
      var isAlternative = eventData[fabricObject.canvas.altActionKey];
      if (control.x === 0) {
        return isAlternative ? "skewX" : "scaleY";
      }
      if (control.y === 0) {
        return isAlternative ? "skewY" : "scaleX";
      }
    }
    function rotationStyleHandler(eventData, control, fabricObject) {
      if (fabricObject.lockRotation) {
        return "not-allowed";
      }
      return control.cursorStyle;
    }
    function commonEventInfo(eventData, transform, x, y) {
      return {
        e: eventData,
        transform,
        pointer: {
          x,
          y
        }
      };
    }
    function wrapWithFixedAnchor(actionHandler) {
      return function(eventData, transform, x, y) {
        var target = transform.target, centerPoint = target.getCenterPoint(), constraint = target.translateToOriginPoint(centerPoint, transform.originX, transform.originY), actionPerformed = actionHandler(eventData, transform, x, y);
        target.setPositionByOrigin(constraint, transform.originX, transform.originY);
        return actionPerformed;
      };
    }
    function wrapWithFireEvent(eventName, actionHandler) {
      return function(eventData, transform, x, y) {
        var actionPerformed = actionHandler(eventData, transform, x, y);
        if (actionPerformed) {
          fireEvent(eventName, commonEventInfo(eventData, transform, x, y));
        }
        return actionPerformed;
      };
    }
    function getLocalPoint2(transform, originX, originY, x, y) {
      var target = transform.target, control = target.controls[transform.corner], zoom = target.canvas.getZoom(), padding = target.padding / zoom, localPoint = target.toLocalPoint(new fabric22.Point(x, y), originX, originY);
      if (localPoint.x >= padding) {
        localPoint.x -= padding;
      }
      if (localPoint.x <= -padding) {
        localPoint.x += padding;
      }
      if (localPoint.y >= padding) {
        localPoint.y -= padding;
      }
      if (localPoint.y <= padding) {
        localPoint.y += padding;
      }
      localPoint.x -= control.offsetX;
      localPoint.y -= control.offsetY;
      return localPoint;
    }
    function targetHasOneFlip(target) {
      return target.flipX !== target.flipY;
    }
    function compensateScaleForSkew(target, oppositeSkew, scaleToCompensate, axis, reference) {
      if (target[oppositeSkew] !== 0) {
        var newDim = target._getTransformedDimensions()[axis];
        var newValue = reference / newDim * target[scaleToCompensate];
        target.set(scaleToCompensate, newValue);
      }
    }
    function skewObjectX(eventData, transform, x, y) {
      var target = transform.target, dimNoSkew = target._getTransformedDimensions(0, target.skewY), localPoint = getLocalPoint2(transform, transform.originX, transform.originY, x, y), totalSkewSize = Math.abs(localPoint.x * 2) - dimNoSkew.x, currentSkew = target.skewX, newSkew;
      if (totalSkewSize < 2) {
        newSkew = 0;
      } else {
        newSkew = radiansToDegrees(
          Math.atan2(totalSkewSize / target.scaleX, dimNoSkew.y / target.scaleY)
        );
        if (transform.originX === LEFT2 && transform.originY === BOTTOM2) {
          newSkew = -newSkew;
        }
        if (transform.originX === RIGHT2 && transform.originY === TOP2) {
          newSkew = -newSkew;
        }
        if (targetHasOneFlip(target)) {
          newSkew = -newSkew;
        }
      }
      var hasSkewed = currentSkew !== newSkew;
      if (hasSkewed) {
        var dimBeforeSkewing = target._getTransformedDimensions().y;
        target.set("skewX", newSkew);
        compensateScaleForSkew(target, "skewY", "scaleY", "y", dimBeforeSkewing);
      }
      return hasSkewed;
    }
    function skewObjectY(eventData, transform, x, y) {
      var target = transform.target, dimNoSkew = target._getTransformedDimensions(target.skewX, 0), localPoint = getLocalPoint2(transform, transform.originX, transform.originY, x, y), totalSkewSize = Math.abs(localPoint.y * 2) - dimNoSkew.y, currentSkew = target.skewY, newSkew;
      if (totalSkewSize < 2) {
        newSkew = 0;
      } else {
        newSkew = radiansToDegrees(
          Math.atan2(totalSkewSize / target.scaleY, dimNoSkew.x / target.scaleX)
        );
        if (transform.originX === LEFT2 && transform.originY === BOTTOM2) {
          newSkew = -newSkew;
        }
        if (transform.originX === RIGHT2 && transform.originY === TOP2) {
          newSkew = -newSkew;
        }
        if (targetHasOneFlip(target)) {
          newSkew = -newSkew;
        }
      }
      var hasSkewed = currentSkew !== newSkew;
      if (hasSkewed) {
        var dimBeforeSkewing = target._getTransformedDimensions().x;
        target.set("skewY", newSkew);
        compensateScaleForSkew(target, "skewX", "scaleX", "x", dimBeforeSkewing);
      }
      return hasSkewed;
    }
    function skewHandlerX(eventData, transform, x, y) {
      var target = transform.target, currentSkew = target.skewX, originX, originY = transform.originY;
      if (target.lockSkewingX) {
        return false;
      }
      if (currentSkew === 0) {
        var localPointFromCenter = getLocalPoint2(transform, CENTER2, CENTER2, x, y);
        if (localPointFromCenter.x > 0) {
          originX = LEFT2;
        } else {
          originX = RIGHT2;
        }
      } else {
        if (currentSkew > 0) {
          originX = originY === TOP2 ? LEFT2 : RIGHT2;
        }
        if (currentSkew < 0) {
          originX = originY === TOP2 ? RIGHT2 : LEFT2;
        }
        if (targetHasOneFlip(target)) {
          originX = originX === LEFT2 ? RIGHT2 : LEFT2;
        }
      }
      transform.originX = originX;
      var finalHandler = wrapWithFireEvent("skewing", wrapWithFixedAnchor(skewObjectX));
      return finalHandler(eventData, transform, x, y);
    }
    function skewHandlerY(eventData, transform, x, y) {
      var target = transform.target, currentSkew = target.skewY, originY, originX = transform.originX;
      if (target.lockSkewingY) {
        return false;
      }
      if (currentSkew === 0) {
        var localPointFromCenter = getLocalPoint2(transform, CENTER2, CENTER2, x, y);
        if (localPointFromCenter.y > 0) {
          originY = TOP2;
        } else {
          originY = BOTTOM2;
        }
      } else {
        if (currentSkew > 0) {
          originY = originX === LEFT2 ? TOP2 : BOTTOM2;
        }
        if (currentSkew < 0) {
          originY = originX === LEFT2 ? BOTTOM2 : TOP2;
        }
        if (targetHasOneFlip(target)) {
          originY = originY === TOP2 ? BOTTOM2 : TOP2;
        }
      }
      transform.originY = originY;
      var finalHandler = wrapWithFireEvent("skewing", wrapWithFixedAnchor(skewObjectY));
      return finalHandler(eventData, transform, x, y);
    }
    function rotationWithSnapping(eventData, transform, x, y) {
      var t = transform, target = t.target, pivotPoint = target.translateToOriginPoint(target.getCenterPoint(), t.originX, t.originY);
      if (target.lockRotation) {
        return false;
      }
      var lastAngle = Math.atan2(t.ey - pivotPoint.y, t.ex - pivotPoint.x), curAngle = Math.atan2(y - pivotPoint.y, x - pivotPoint.x), angle = radiansToDegrees(curAngle - lastAngle + t.theta), hasRotated = true;
      if (target.snapAngle > 0) {
        var snapAngle = target.snapAngle, snapThreshold = target.snapThreshold || snapAngle, rightAngleLocked = Math.ceil(angle / snapAngle) * snapAngle, leftAngleLocked = Math.floor(angle / snapAngle) * snapAngle;
        if (Math.abs(angle - leftAngleLocked) < snapThreshold) {
          angle = leftAngleLocked;
        } else if (Math.abs(angle - rightAngleLocked) < snapThreshold) {
          angle = rightAngleLocked;
        }
      }
      if (angle < 0) {
        angle = 360 + angle;
      }
      angle %= 360;
      hasRotated = target.angle !== angle;
      target.angle = angle;
      return hasRotated;
    }
    function scaleObject2(eventData, transform, x, y, options) {
      options = options || {};
      var target = transform.target, lockScalingX = target.lockScalingX, lockScalingY = target.lockScalingY, by = options.by, newPoint, scaleX, scaleY, dim, scaleProportionally = scaleIsProportional2(eventData, target), forbidScaling = scalingIsForbidden2(target, by, scaleProportionally), signX, signY, gestureScale = transform.gestureScale;
      if (forbidScaling) {
        return false;
      }
      if (gestureScale) {
        scaleX = transform.scaleX * gestureScale;
        scaleY = transform.scaleY * gestureScale;
      } else {
        newPoint = getLocalPoint2(transform, transform.originX, transform.originY, x, y);
        signX = by !== "y" ? sign2(newPoint.x) : 1;
        signY = by !== "x" ? sign2(newPoint.y) : 1;
        if (!transform.signX) {
          transform.signX = signX;
        }
        if (!transform.signY) {
          transform.signY = signY;
        }
        if (target.lockScalingFlip && (transform.signX !== signX || transform.signY !== signY)) {
          return false;
        }
        dim = target._getTransformedDimensions();
        if (scaleProportionally && !by) {
          var distance = Math.abs(newPoint.x) + Math.abs(newPoint.y), original = transform.original, originalDistance = Math.abs(dim.x * original.scaleX / target.scaleX) + Math.abs(dim.y * original.scaleY / target.scaleY), scale = distance / originalDistance;
          scaleX = original.scaleX * scale;
          scaleY = original.scaleY * scale;
        } else {
          scaleX = Math.abs(newPoint.x * target.scaleX / dim.x);
          scaleY = Math.abs(newPoint.y * target.scaleY / dim.y);
        }
        if (isTransformCentered2(transform)) {
          scaleX *= 2;
          scaleY *= 2;
        }
        if (transform.signX !== signX && by !== "y") {
          transform.originX = opposite2[transform.originX];
          scaleX *= -1;
          transform.signX = signX;
        }
        if (transform.signY !== signY && by !== "x") {
          transform.originY = opposite2[transform.originY];
          scaleY *= -1;
          transform.signY = signY;
        }
      }
      var oldScaleX = target.scaleX, oldScaleY = target.scaleY;
      if (!by) {
        !lockScalingX && target.set("scaleX", scaleX);
        !lockScalingY && target.set("scaleY", scaleY);
      } else {
        by === "x" && target.set("scaleX", scaleX);
        by === "y" && target.set("scaleY", scaleY);
      }
      return oldScaleX !== target.scaleX || oldScaleY !== target.scaleY;
    }
    function scaleObjectFromCorner(eventData, transform, x, y) {
      return scaleObject2(eventData, transform, x, y);
    }
    function scaleObjectX(eventData, transform, x, y) {
      return scaleObject2(eventData, transform, x, y, { by: "x" });
    }
    function scaleObjectY(eventData, transform, x, y) {
      return scaleObject2(eventData, transform, x, y, { by: "y" });
    }
    function scalingYOrSkewingX(eventData, transform, x, y) {
      if (eventData[transform.target.canvas.altActionKey]) {
        return controls.skewHandlerX(eventData, transform, x, y);
      }
      return controls.scalingY(eventData, transform, x, y);
    }
    function scalingXOrSkewingY(eventData, transform, x, y) {
      if (eventData[transform.target.canvas.altActionKey]) {
        return controls.skewHandlerY(eventData, transform, x, y);
      }
      return controls.scalingX(eventData, transform, x, y);
    }
    function changeWidth(eventData, transform, x, y) {
      var target = transform.target, localPoint = getLocalPoint2(transform, transform.originX, transform.originY, x, y), strokePadding = target.strokeWidth / (target.strokeUniform ? target.scaleX : 1), multiplier = isTransformCentered2(transform) ? 2 : 1, oldWidth = target.width, newWidth = Math.abs(localPoint.x * multiplier / target.scaleX) - strokePadding;
      target.set("width", Math.max(newWidth, 0));
      return oldWidth !== newWidth;
    }
    function dragHandler(eventData, transform, x, y) {
      var target = transform.target, newLeft = x - transform.offsetX, newTop = y - transform.offsetY, moveX2 = !target.get("lockMovementX") && target.left !== newLeft, moveY2 = !target.get("lockMovementY") && target.top !== newTop;
      moveX2 && target.set("left", newLeft);
      moveY2 && target.set("top", newTop);
      if (moveX2 || moveY2) {
        fireEvent("moving", commonEventInfo(eventData, transform, x, y));
      }
      return moveX2 || moveY2;
    }
    controls.scaleCursorStyleHandler = scaleCursorStyleHandler;
    controls.skewCursorStyleHandler = skewCursorStyleHandler;
    controls.scaleSkewCursorStyleHandler = scaleSkewCursorStyleHandler;
    controls.rotationWithSnapping = wrapWithFireEvent("rotating", wrapWithFixedAnchor(rotationWithSnapping));
    controls.scalingEqually = wrapWithFireEvent("scaling", wrapWithFixedAnchor(scaleObjectFromCorner));
    controls.scalingX = wrapWithFireEvent("scaling", wrapWithFixedAnchor(scaleObjectX));
    controls.scalingY = wrapWithFireEvent("scaling", wrapWithFixedAnchor(scaleObjectY));
    controls.scalingYOrSkewingX = scalingYOrSkewingX;
    controls.scalingXOrSkewingY = scalingXOrSkewingY;
    controls.changeWidth = wrapWithFireEvent("resizing", wrapWithFixedAnchor(changeWidth));
    controls.skewHandlerX = skewHandlerX;
    controls.skewHandlerY = skewHandlerY;
    controls.dragHandler = dragHandler;
    controls.scaleOrSkewActionName = scaleOrSkewActionName;
    controls.rotationStyleHandler = rotationStyleHandler;
    controls.fireEvent = fireEvent;
    controls.wrapWithFixedAnchor = wrapWithFixedAnchor;
    controls.wrapWithFireEvent = wrapWithFireEvent;
    controls.getLocalPoint = getLocalPoint2;
    fabric22.controlsUtils = controls;
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), degreesToRadians = fabric22.util.degreesToRadians, controls = fabric22.controlsUtils;
    function renderCircleControl(ctx, left, top, styleOverride, fabricObject) {
      styleOverride = styleOverride || {};
      var xSize = this.sizeX || styleOverride.cornerSize || fabricObject.cornerSize, ySize = this.sizeY || styleOverride.cornerSize || fabricObject.cornerSize, transparentCorners = typeof styleOverride.transparentCorners !== "undefined" ? styleOverride.transparentCorners : fabricObject.transparentCorners, methodName = transparentCorners ? "stroke" : "fill", stroke = !transparentCorners && (styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor), myLeft = left, myTop = top, size;
      ctx.save();
      ctx.fillStyle = styleOverride.cornerColor || fabricObject.cornerColor;
      ctx.strokeStyle = styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor;
      if (xSize > ySize) {
        size = xSize;
        ctx.scale(1, ySize / xSize);
        myTop = top * xSize / ySize;
      } else if (ySize > xSize) {
        size = ySize;
        ctx.scale(xSize / ySize, 1);
        myLeft = left * ySize / xSize;
      } else {
        size = xSize;
      }
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.arc(myLeft, myTop, size / 2, 0, 2 * Math.PI, false);
      ctx[methodName]();
      if (stroke) {
        ctx.stroke();
      }
      ctx.restore();
    }
    function renderSquareControl(ctx, left, top, styleOverride, fabricObject) {
      styleOverride = styleOverride || {};
      var xSize = this.sizeX || styleOverride.cornerSize || fabricObject.cornerSize, ySize = this.sizeY || styleOverride.cornerSize || fabricObject.cornerSize, transparentCorners = typeof styleOverride.transparentCorners !== "undefined" ? styleOverride.transparentCorners : fabricObject.transparentCorners, methodName = transparentCorners ? "stroke" : "fill", stroke = !transparentCorners && (styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor), xSizeBy2 = xSize / 2, ySizeBy2 = ySize / 2;
      ctx.save();
      ctx.fillStyle = styleOverride.cornerColor || fabricObject.cornerColor;
      ctx.strokeStyle = styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor;
      ctx.lineWidth = 1;
      ctx.translate(left, top);
      ctx.rotate(degreesToRadians(fabricObject.angle));
      ctx[methodName + "Rect"](-xSizeBy2, -ySizeBy2, xSize, ySize);
      if (stroke) {
        ctx.strokeRect(-xSizeBy2, -ySizeBy2, xSize, ySize);
      }
      ctx.restore();
    }
    controls.renderCircleControl = renderCircleControl;
    controls.renderSquareControl = renderSquareControl;
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {});
    function Control(options) {
      for (var i in options) {
        this[i] = options[i];
      }
    }
    fabric22.Control = Control;
    fabric22.Control.prototype = /** @lends fabric.Control.prototype */
    {
      /**
       * keep track of control visibility.
       * mainly for backward compatibility.
       * if you do not want to see a control, you can remove it
       * from the controlset.
       * @type {Boolean}
       * @default true
       */
      visible: true,
      /**
       * Name of the action that the control will likely execute.
       * This is optional. FabricJS uses to identify what the user is doing for some
       * extra optimizations. If you are writing a custom control and you want to know
       * somewhere else in the code what is going on, you can use this string here.
       * you can also provide a custom getActionName if your control run multiple actions
       * depending on some external state.
       * default to scale since is the most common, used on 4 corners by default
       * @type {String}
       * @default 'scale'
       */
      actionName: "scale",
      /**
       * Drawing angle of the control.
       * NOT used for now, but name marked as needed for internal logic
       * example: to reuse the same drawing function for different rotated controls
       * @type {Number}
       * @default 0
       */
      angle: 0,
      /**
       * Relative position of the control. X
       * 0,0 is the center of the Object, while -0.5 (left) or 0.5 (right) are the extremities
       * of the bounding box.
       * @type {Number}
       * @default 0
       */
      x: 0,
      /**
       * Relative position of the control. Y
       * 0,0 is the center of the Object, while -0.5 (top) or 0.5 (bottom) are the extremities
       * of the bounding box.
       * @type {Number}
       * @default 0
       */
      y: 0,
      /**
       * Horizontal offset of the control from the defined position. In pixels
       * Positive offset moves the control to the right, negative to the left.
       * It used when you want to have position of control that does not scale with
       * the bounding box. Example: rotation control is placed at x:0, y: 0.5 on
       * the boundindbox, with an offset of 30 pixels vertically. Those 30 pixels will
       * stay 30 pixels no matter how the object is big. Another example is having 2
       * controls in the corner, that stay in the same position when the object scale.
       * of the bounding box.
       * @type {Number}
       * @default 0
       */
      offsetX: 0,
      /**
       * Vertical offset of the control from the defined position. In pixels
       * Positive offset moves the control to the bottom, negative to the top.
       * @type {Number}
       * @default 0
       */
      offsetY: 0,
      /**
       * Sets the length of the control. If null, defaults to object's cornerSize.
       * Expects both sizeX and sizeY to be set when set.
       * @type {?Number}
       * @default null
       */
      sizeX: null,
      /**
       * Sets the height of the control. If null, defaults to object's cornerSize.
       * Expects both sizeX and sizeY to be set when set.
       * @type {?Number}
       * @default null
       */
      sizeY: null,
      /**
       * Sets the length of the touch area of the control. If null, defaults to object's touchCornerSize.
       * Expects both touchSizeX and touchSizeY to be set when set.
       * @type {?Number}
       * @default null
       */
      touchSizeX: null,
      /**
       * Sets the height of the touch area of the control. If null, defaults to object's touchCornerSize.
       * Expects both touchSizeX and touchSizeY to be set when set.
       * @type {?Number}
       * @default null
       */
      touchSizeY: null,
      /**
       * Css cursor style to display when the control is hovered.
       * if the method `cursorStyleHandler` is provided, this property is ignored.
       * @type {String}
       * @default 'crosshair'
       */
      cursorStyle: "crosshair",
      /**
       * If controls has an offsetY or offsetX, draw a line that connects
       * the control to the bounding box
       * @type {Boolean}
       * @default false
       */
      withConnection: false,
      /**
       * The control actionHandler, provide one to handle action ( control being moved )
       * @param {Event} eventData the native mouse event
       * @param {Object} transformData properties of the current transform
       * @param {Number} x x position of the cursor
       * @param {Number} y y position of the cursor
       * @return {Boolean} true if the action/event modified the object
       */
      actionHandler: function() {
      },
      /**
       * The control handler for mouse down, provide one to handle mouse down on control
       * @param {Event} eventData the native mouse event
       * @param {Object} transformData properties of the current transform
       * @param {Number} x x position of the cursor
       * @param {Number} y y position of the cursor
       * @return {Boolean} true if the action/event modified the object
       */
      mouseDownHandler: function() {
      },
      /**
       * The control mouseUpHandler, provide one to handle an effect on mouse up.
       * @param {Event} eventData the native mouse event
       * @param {Object} transformData properties of the current transform
       * @param {Number} x x position of the cursor
       * @param {Number} y y position of the cursor
       * @return {Boolean} true if the action/event modified the object
       */
      mouseUpHandler: function() {
      },
      /**
       * Returns control actionHandler
       * @param {Event} eventData the native mouse event
       * @param {fabric.Object} fabricObject on which the control is displayed
       * @param {fabric.Control} control control for which the action handler is being asked
       * @return {Function} the action handler
       */
      getActionHandler: function() {
        return this.actionHandler;
      },
      /**
       * Returns control mouseDown handler
       * @param {Event} eventData the native mouse event
       * @param {fabric.Object} fabricObject on which the control is displayed
       * @param {fabric.Control} control control for which the action handler is being asked
       * @return {Function} the action handler
       */
      getMouseDownHandler: function() {
        return this.mouseDownHandler;
      },
      /**
       * Returns control mouseUp handler
       * @param {Event} eventData the native mouse event
       * @param {fabric.Object} fabricObject on which the control is displayed
       * @param {fabric.Control} control control for which the action handler is being asked
       * @return {Function} the action handler
       */
      getMouseUpHandler: function() {
        return this.mouseUpHandler;
      },
      /**
       * Returns control cursorStyle for css using cursorStyle. If you need a more elaborate
       * function you can pass one in the constructor
       * the cursorStyle property
       * @param {Event} eventData the native mouse event
       * @param {fabric.Control} control the current control ( likely this)
       * @param {fabric.Object} object on which the control is displayed
       * @return {String}
       */
      cursorStyleHandler: function(eventData, control) {
        return control.cursorStyle;
      },
      /**
       * Returns the action name. The basic implementation just return the actionName property.
       * @param {Event} eventData the native mouse event
       * @param {fabric.Control} control the current control ( likely this)
       * @param {fabric.Object} object on which the control is displayed
       * @return {String}
       */
      getActionName: function(eventData, control) {
        return control.actionName;
      },
      /**
       * Returns controls visibility
       * @param {fabric.Object} object on which the control is displayed
       * @param {String} controlKey key where the control is memorized on the
       * @return {Boolean}
       */
      getVisibility: function(fabricObject, controlKey) {
        var objectVisibility = fabricObject._controlsVisibility;
        if (objectVisibility && typeof objectVisibility[controlKey] !== "undefined") {
          return objectVisibility[controlKey];
        }
        return this.visible;
      },
      /**
       * Sets controls visibility
       * @param {Boolean} visibility for the object
       * @return {Void}
       */
      setVisibility: function(visibility) {
        this.visible = visibility;
      },
      positionHandler: function(dim, finalMatrix) {
        var point = fabric22.util.transformPoint({
          x: this.x * dim.x + this.offsetX,
          y: this.y * dim.y + this.offsetY
        }, finalMatrix);
        return point;
      },
      /**
       * Returns the coords for this control based on object values.
       * @param {Number} objectAngle angle from the fabric object holding the control
       * @param {Number} objectCornerSize cornerSize from the fabric object holding the control (or touchCornerSize if
       *   isTouch is true)
       * @param {Number} centerX x coordinate where the control center should be
       * @param {Number} centerY y coordinate where the control center should be
       * @param {boolean} isTouch true if touch corner, false if normal corner
       */
      calcCornerCoords: function(objectAngle, objectCornerSize, centerX, centerY, isTouch) {
        var cosHalfOffset, sinHalfOffset, cosHalfOffsetComp, sinHalfOffsetComp, xSize = isTouch ? this.touchSizeX : this.sizeX, ySize = isTouch ? this.touchSizeY : this.sizeY;
        if (xSize && ySize && xSize !== ySize) {
          var controlTriangleAngle = Math.atan2(ySize, xSize);
          var cornerHypotenuse = Math.sqrt(xSize * xSize + ySize * ySize) / 2;
          var newTheta = controlTriangleAngle - fabric22.util.degreesToRadians(objectAngle);
          var newThetaComp = Math.PI / 2 - controlTriangleAngle - fabric22.util.degreesToRadians(objectAngle);
          cosHalfOffset = cornerHypotenuse * fabric22.util.cos(newTheta);
          sinHalfOffset = cornerHypotenuse * fabric22.util.sin(newTheta);
          cosHalfOffsetComp = cornerHypotenuse * fabric22.util.cos(newThetaComp);
          sinHalfOffsetComp = cornerHypotenuse * fabric22.util.sin(newThetaComp);
        } else {
          var cornerSize = xSize && ySize ? xSize : objectCornerSize;
          cornerHypotenuse = cornerSize * 0.7071067812;
          var newTheta = fabric22.util.degreesToRadians(45 - objectAngle);
          cosHalfOffset = cosHalfOffsetComp = cornerHypotenuse * fabric22.util.cos(newTheta);
          sinHalfOffset = sinHalfOffsetComp = cornerHypotenuse * fabric22.util.sin(newTheta);
        }
        return {
          tl: {
            x: centerX - sinHalfOffsetComp,
            y: centerY - cosHalfOffsetComp
          },
          tr: {
            x: centerX + cosHalfOffset,
            y: centerY - sinHalfOffset
          },
          bl: {
            x: centerX - cosHalfOffset,
            y: centerY + sinHalfOffset
          },
          br: {
            x: centerX + sinHalfOffsetComp,
            y: centerY + cosHalfOffsetComp
          }
        };
      },
      /**
      * Render function for the control.
      * When this function runs the context is unscaled. unrotate. Just retina scaled.
      * all the functions will have to translate to the point left,top before starting Drawing
      * if they want to draw a control where the position is detected.
      * left and top are the result of the positionHandler function
      * @param {RenderingContext2D} ctx the context where the control will be drawn
      * @param {Number} left position of the canvas where we are about to render the control.
      * @param {Number} top position of the canvas where we are about to render the control.
      * @param {Object} styleOverride
      * @param {fabric.Object} fabricObject the object where the control is about to be rendered
      */
      render: function(ctx, left, top, styleOverride, fabricObject) {
        styleOverride = styleOverride || {};
        switch (styleOverride.cornerStyle || fabricObject.cornerStyle) {
          case "circle":
            fabric22.controlsUtils.renderCircleControl.call(this, ctx, left, top, styleOverride, fabricObject);
            break;
          default:
            fabric22.controlsUtils.renderSquareControl.call(this, ctx, left, top, styleOverride, fabricObject);
        }
      }
    };
  })(exports);
  (function() {
    function getColorStop(el, multiplier) {
      var style = el.getAttribute("style"), offset = el.getAttribute("offset") || 0, color, colorAlpha, opacity, i;
      offset = parseFloat(offset) / (/%$/.test(offset) ? 100 : 1);
      offset = offset < 0 ? 0 : offset > 1 ? 1 : offset;
      if (style) {
        var keyValuePairs = style.split(/\s*;\s*/);
        if (keyValuePairs[keyValuePairs.length - 1] === "") {
          keyValuePairs.pop();
        }
        for (i = keyValuePairs.length; i--; ) {
          var split = keyValuePairs[i].split(/\s*:\s*/), key = split[0].trim(), value = split[1].trim();
          if (key === "stop-color") {
            color = value;
          } else if (key === "stop-opacity") {
            opacity = value;
          }
        }
      }
      if (!color) {
        color = el.getAttribute("stop-color") || "rgb(0,0,0)";
      }
      if (!opacity) {
        opacity = el.getAttribute("stop-opacity");
      }
      color = new fabric2.Color(color);
      colorAlpha = color.getAlpha();
      opacity = isNaN(parseFloat(opacity)) ? 1 : parseFloat(opacity);
      opacity *= colorAlpha * multiplier;
      return {
        offset,
        color: color.toRgb(),
        opacity
      };
    }
    function getLinearCoords(el) {
      return {
        x1: el.getAttribute("x1") || 0,
        y1: el.getAttribute("y1") || 0,
        x2: el.getAttribute("x2") || "100%",
        y2: el.getAttribute("y2") || 0
      };
    }
    function getRadialCoords(el) {
      return {
        x1: el.getAttribute("fx") || el.getAttribute("cx") || "50%",
        y1: el.getAttribute("fy") || el.getAttribute("cy") || "50%",
        r1: 0,
        x2: el.getAttribute("cx") || "50%",
        y2: el.getAttribute("cy") || "50%",
        r2: el.getAttribute("r") || "50%"
      };
    }
    var clone2 = fabric2.util.object.clone;
    fabric2.Gradient = fabric2.util.createClass(
      /** @lends fabric.Gradient.prototype */
      {
        /**
         * Horizontal offset for aligning gradients coming from SVG when outside pathgroups
         * @type Number
         * @default 0
         */
        offsetX: 0,
        /**
         * Vertical offset for aligning gradients coming from SVG when outside pathgroups
         * @type Number
         * @default 0
         */
        offsetY: 0,
        /**
         * A transform matrix to apply to the gradient before painting.
         * Imported from svg gradients, is not applied with the current transform in the center.
         * Before this transform is applied, the origin point is at the top left corner of the object
         * plus the addition of offsetY and offsetX.
         * @type Number[]
         * @default null
         */
        gradientTransform: null,
        /**
         * coordinates units for coords.
         * If `pixels`, the number of coords are in the same unit of width / height.
         * If set as `percentage` the coords are still a number, but 1 means 100% of width
         * for the X and 100% of the height for the y. It can be bigger than 1 and negative.
         * allowed values pixels or percentage.
         * @type String
         * @default 'pixels'
         */
        gradientUnits: "pixels",
        /**
         * Gradient type linear or radial
         * @type String
         * @default 'pixels'
         */
        type: "linear",
        /**
         * Constructor
         * @param {Object} options Options object with type, coords, gradientUnits and colorStops
         * @param {Object} [options.type] gradient type linear or radial
         * @param {Object} [options.gradientUnits] gradient units
         * @param {Object} [options.offsetX] SVG import compatibility
         * @param {Object} [options.offsetY] SVG import compatibility
         * @param {Object[]} options.colorStops contains the colorstops.
         * @param {Object} options.coords contains the coords of the gradient
         * @param {Number} [options.coords.x1] X coordiante of the first point for linear or of the focal point for radial
         * @param {Number} [options.coords.y1] Y coordiante of the first point for linear or of the focal point for radial
         * @param {Number} [options.coords.x2] X coordiante of the second point for linear or of the center point for radial
         * @param {Number} [options.coords.y2] Y coordiante of the second point for linear or of the center point for radial
         * @param {Number} [options.coords.r1] only for radial gradient, radius of the inner circle
         * @param {Number} [options.coords.r2] only for radial gradient, radius of the external circle
         * @return {fabric.Gradient} thisArg
         */
        initialize: function(options) {
          options || (options = {});
          options.coords || (options.coords = {});
          var coords, _this = this;
          Object.keys(options).forEach(function(option) {
            _this[option] = options[option];
          });
          if (this.id) {
            this.id += "_" + fabric2.Object.__uid++;
          } else {
            this.id = fabric2.Object.__uid++;
          }
          coords = {
            x1: options.coords.x1 || 0,
            y1: options.coords.y1 || 0,
            x2: options.coords.x2 || 0,
            y2: options.coords.y2 || 0
          };
          if (this.type === "radial") {
            coords.r1 = options.coords.r1 || 0;
            coords.r2 = options.coords.r2 || 0;
          }
          this.coords = coords;
          this.colorStops = options.colorStops.slice();
        },
        /**
         * Adds another colorStop
         * @param {Object} colorStop Object with offset and color
         * @return {fabric.Gradient} thisArg
         */
        addColorStop: function(colorStops) {
          for (var position in colorStops) {
            var color = new fabric2.Color(colorStops[position]);
            this.colorStops.push({
              offset: parseFloat(position),
              color: color.toRgb(),
              opacity: color.getAlpha()
            });
          }
          return this;
        },
        /**
         * Returns object representation of a gradient
         * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
         * @return {Object}
         */
        toObject: function(propertiesToInclude) {
          var object = {
            type: this.type,
            coords: this.coords,
            colorStops: this.colorStops,
            offsetX: this.offsetX,
            offsetY: this.offsetY,
            gradientUnits: this.gradientUnits,
            gradientTransform: this.gradientTransform ? this.gradientTransform.concat() : this.gradientTransform
          };
          fabric2.util.populateWithProperties(this, object, propertiesToInclude);
          return object;
        },
        /* _TO_SVG_START_ */
        /**
         * Returns SVG representation of an gradient
         * @param {Object} object Object to create a gradient for
         * @return {String} SVG representation of an gradient (linear/radial)
         */
        toSVG: function(object, options) {
          var coords = clone2(this.coords, true), i, len, options = options || {}, markup, commonAttributes, colorStops = clone2(this.colorStops, true), needsSwap = coords.r1 > coords.r2, transform = this.gradientTransform ? this.gradientTransform.concat() : fabric2.iMatrix.concat(), offsetX = -this.offsetX, offsetY = -this.offsetY, withViewport = !!options.additionalTransform, gradientUnits = this.gradientUnits === "pixels" ? "userSpaceOnUse" : "objectBoundingBox";
          colorStops.sort(function(a, b) {
            return a.offset - b.offset;
          });
          if (gradientUnits === "objectBoundingBox") {
            offsetX /= object.width;
            offsetY /= object.height;
          } else {
            offsetX += object.width / 2;
            offsetY += object.height / 2;
          }
          if (object.type === "path" && this.gradientUnits !== "percentage") {
            offsetX -= object.pathOffset.x;
            offsetY -= object.pathOffset.y;
          }
          transform[4] -= offsetX;
          transform[5] -= offsetY;
          commonAttributes = 'id="SVGID_' + this.id + '" gradientUnits="' + gradientUnits + '"';
          commonAttributes += ' gradientTransform="' + (withViewport ? options.additionalTransform + " " : "") + fabric2.util.matrixToSVG(transform) + '" ';
          if (this.type === "linear") {
            markup = [
              "<linearGradient ",
              commonAttributes,
              ' x1="',
              coords.x1,
              '" y1="',
              coords.y1,
              '" x2="',
              coords.x2,
              '" y2="',
              coords.y2,
              '">\n'
            ];
          } else if (this.type === "radial") {
            markup = [
              "<radialGradient ",
              commonAttributes,
              ' cx="',
              needsSwap ? coords.x1 : coords.x2,
              '" cy="',
              needsSwap ? coords.y1 : coords.y2,
              '" r="',
              needsSwap ? coords.r1 : coords.r2,
              '" fx="',
              needsSwap ? coords.x2 : coords.x1,
              '" fy="',
              needsSwap ? coords.y2 : coords.y1,
              '">\n'
            ];
          }
          if (this.type === "radial") {
            if (needsSwap) {
              colorStops = colorStops.concat();
              colorStops.reverse();
              for (i = 0, len = colorStops.length; i < len; i++) {
                colorStops[i].offset = 1 - colorStops[i].offset;
              }
            }
            var minRadius = Math.min(coords.r1, coords.r2);
            if (minRadius > 0) {
              var maxRadius = Math.max(coords.r1, coords.r2), percentageShift = minRadius / maxRadius;
              for (i = 0, len = colorStops.length; i < len; i++) {
                colorStops[i].offset += percentageShift * (1 - colorStops[i].offset);
              }
            }
          }
          for (i = 0, len = colorStops.length; i < len; i++) {
            var colorStop = colorStops[i];
            markup.push(
              "<stop ",
              'offset="',
              colorStop.offset * 100 + "%",
              '" style="stop-color:',
              colorStop.color,
              typeof colorStop.opacity !== "undefined" ? ";stop-opacity: " + colorStop.opacity : ";",
              '"/>\n'
            );
          }
          markup.push(this.type === "linear" ? "</linearGradient>\n" : "</radialGradient>\n");
          return markup.join("");
        },
        /* _TO_SVG_END_ */
        /**
         * Returns an instance of CanvasGradient
         * @param {CanvasRenderingContext2D} ctx Context to render on
         * @return {CanvasGradient}
         */
        toLive: function(ctx) {
          var gradient, coords = fabric2.util.object.clone(this.coords), i, len;
          if (!this.type) {
            return;
          }
          if (this.type === "linear") {
            gradient = ctx.createLinearGradient(
              coords.x1,
              coords.y1,
              coords.x2,
              coords.y2
            );
          } else if (this.type === "radial") {
            gradient = ctx.createRadialGradient(
              coords.x1,
              coords.y1,
              coords.r1,
              coords.x2,
              coords.y2,
              coords.r2
            );
          }
          for (i = 0, len = this.colorStops.length; i < len; i++) {
            var color = this.colorStops[i].color, opacity = this.colorStops[i].opacity, offset = this.colorStops[i].offset;
            if (typeof opacity !== "undefined") {
              color = new fabric2.Color(color).setAlpha(opacity).toRgba();
            }
            gradient.addColorStop(offset, color);
          }
          return gradient;
        }
      }
    );
    fabric2.util.object.extend(fabric2.Gradient, {
      /* _FROM_SVG_START_ */
      /**
       * Returns {@link fabric.Gradient} instance from an SVG element
       * @static
       * @memberOf fabric.Gradient
       * @param {SVGGradientElement} el SVG gradient element
       * @param {fabric.Object} instance
       * @param {String} opacityAttr A fill-opacity or stroke-opacity attribute to multiply to each stop's opacity.
       * @param {Object} svgOptions an object containing the size of the SVG in order to parse correctly gradients
       * that uses gradientUnits as 'userSpaceOnUse' and percentages.
       * @param {Object.number} viewBoxWidth width part of the viewBox attribute on svg
       * @param {Object.number} viewBoxHeight height part of the viewBox attribute on svg
       * @param {Object.number} width width part of the svg tag if viewBox is not specified
       * @param {Object.number} height height part of the svg tag if viewBox is not specified
       * @return {fabric.Gradient} Gradient instance
       * @see http://www.w3.org/TR/SVG/pservers.html#LinearGradientElement
       * @see http://www.w3.org/TR/SVG/pservers.html#RadialGradientElement
       */
      fromElement: function(el, instance, opacityAttr, svgOptions) {
        var multiplier = parseFloat(opacityAttr) / (/%$/.test(opacityAttr) ? 100 : 1);
        multiplier = multiplier < 0 ? 0 : multiplier > 1 ? 1 : multiplier;
        if (isNaN(multiplier)) {
          multiplier = 1;
        }
        var colorStopEls = el.getElementsByTagName("stop"), type, gradientUnits = el.getAttribute("gradientUnits") === "userSpaceOnUse" ? "pixels" : "percentage", gradientTransform = el.getAttribute("gradientTransform") || "", colorStops = [], coords, i, offsetX = 0, offsetY = 0, transformMatrix;
        if (el.nodeName === "linearGradient" || el.nodeName === "LINEARGRADIENT") {
          type = "linear";
          coords = getLinearCoords(el);
        } else {
          type = "radial";
          coords = getRadialCoords(el);
        }
        for (i = colorStopEls.length; i--; ) {
          colorStops.push(getColorStop(colorStopEls[i], multiplier));
        }
        transformMatrix = fabric2.parseTransformAttribute(gradientTransform);
        __convertPercentUnitsToValues(instance, coords, svgOptions, gradientUnits);
        if (gradientUnits === "pixels") {
          offsetX = -instance.left;
          offsetY = -instance.top;
        }
        var gradient = new fabric2.Gradient({
          id: el.getAttribute("id"),
          type,
          coords,
          colorStops,
          gradientUnits,
          gradientTransform: transformMatrix,
          offsetX,
          offsetY
        });
        return gradient;
      }
      /* _FROM_SVG_END_ */
    });
    function __convertPercentUnitsToValues(instance, options, svgOptions, gradientUnits) {
      var propValue, finalValue;
      Object.keys(options).forEach(function(prop) {
        propValue = options[prop];
        if (propValue === "Infinity") {
          finalValue = 1;
        } else if (propValue === "-Infinity") {
          finalValue = 0;
        } else {
          finalValue = parseFloat(options[prop], 10);
          if (typeof propValue === "string" && /^(\d+\.\d+)%|(\d+)%$/.test(propValue)) {
            finalValue *= 0.01;
            if (gradientUnits === "pixels") {
              if (prop === "x1" || prop === "x2" || prop === "r2") {
                finalValue *= svgOptions.viewBoxWidth || svgOptions.width;
              }
              if (prop === "y1" || prop === "y2") {
                finalValue *= svgOptions.viewBoxHeight || svgOptions.height;
              }
            }
          }
        }
        options[prop] = finalValue;
      });
    }
  })();
  (function() {
    var toFixed = fabric2.util.toFixed;
    fabric2.Pattern = fabric2.util.createClass(
      /** @lends fabric.Pattern.prototype */
      {
        /**
         * Repeat property of a pattern (one of repeat, repeat-x, repeat-y or no-repeat)
         * @type String
         * @default
         */
        repeat: "repeat",
        /**
         * Pattern horizontal offset from object's left/top corner
         * @type Number
         * @default
         */
        offsetX: 0,
        /**
         * Pattern vertical offset from object's left/top corner
         * @type Number
         * @default
         */
        offsetY: 0,
        /**
         * crossOrigin value (one of "", "anonymous", "use-credentials")
         * @see https://developer.mozilla.org/en-US/docs/HTML/CORS_settings_attributes
         * @type String
         * @default
         */
        crossOrigin: "",
        /**
         * transform matrix to change the pattern, imported from svgs.
         * @type Array
         * @default
         */
        patternTransform: null,
        /**
         * Constructor
         * @param {Object} [options] Options object
         * @param {Function} [callback] function to invoke after callback init.
         * @return {fabric.Pattern} thisArg
         */
        initialize: function(options, callback) {
          options || (options = {});
          this.id = fabric2.Object.__uid++;
          this.setOptions(options);
          if (!options.source || options.source && typeof options.source !== "string") {
            callback && callback(this);
            return;
          } else {
            var _this = this;
            this.source = fabric2.util.createImage();
            fabric2.util.loadImage(options.source, function(img, isError) {
              _this.source = img;
              callback && callback(_this, isError);
            }, null, this.crossOrigin);
          }
        },
        /**
         * Returns object representation of a pattern
         * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
         * @return {Object} Object representation of a pattern instance
         */
        toObject: function(propertiesToInclude) {
          var NUM_FRACTION_DIGITS = fabric2.Object.NUM_FRACTION_DIGITS, source, object;
          if (typeof this.source.src === "string") {
            source = this.source.src;
          } else if (typeof this.source === "object" && this.source.toDataURL) {
            source = this.source.toDataURL();
          }
          object = {
            type: "pattern",
            source,
            repeat: this.repeat,
            crossOrigin: this.crossOrigin,
            offsetX: toFixed(this.offsetX, NUM_FRACTION_DIGITS),
            offsetY: toFixed(this.offsetY, NUM_FRACTION_DIGITS),
            patternTransform: this.patternTransform ? this.patternTransform.concat() : null
          };
          fabric2.util.populateWithProperties(this, object, propertiesToInclude);
          return object;
        },
        /* _TO_SVG_START_ */
        /**
         * Returns SVG representation of a pattern
         * @param {fabric.Object} object
         * @return {String} SVG representation of a pattern
         */
        toSVG: function(object) {
          var patternSource = typeof this.source === "function" ? this.source() : this.source, patternWidth = patternSource.width / object.width, patternHeight = patternSource.height / object.height, patternOffsetX = this.offsetX / object.width, patternOffsetY = this.offsetY / object.height, patternImgSrc = "";
          if (this.repeat === "repeat-x" || this.repeat === "no-repeat") {
            patternHeight = 1;
            if (patternOffsetY) {
              patternHeight += Math.abs(patternOffsetY);
            }
          }
          if (this.repeat === "repeat-y" || this.repeat === "no-repeat") {
            patternWidth = 1;
            if (patternOffsetX) {
              patternWidth += Math.abs(patternOffsetX);
            }
          }
          if (patternSource.src) {
            patternImgSrc = patternSource.src;
          } else if (patternSource.toDataURL) {
            patternImgSrc = patternSource.toDataURL();
          }
          return '<pattern id="SVGID_' + this.id + '" x="' + patternOffsetX + '" y="' + patternOffsetY + '" width="' + patternWidth + '" height="' + patternHeight + '">\n<image x="0" y="0" width="' + patternSource.width + '" height="' + patternSource.height + '" xlink:href="' + patternImgSrc + '"></image>\n</pattern>\n';
        },
        /* _TO_SVG_END_ */
        setOptions: function(options) {
          for (var prop in options) {
            this[prop] = options[prop];
          }
        },
        /**
         * Returns an instance of CanvasPattern
         * @param {CanvasRenderingContext2D} ctx Context to create pattern
         * @return {CanvasPattern}
         */
        toLive: function(ctx) {
          var source = this.source;
          if (!source) {
            return "";
          }
          if (typeof source.src !== "undefined") {
            if (!source.complete) {
              return "";
            }
            if (source.naturalWidth === 0 || source.naturalHeight === 0) {
              return "";
            }
          }
          return ctx.createPattern(source, this.repeat);
        }
      }
    );
  })();
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), toFixed = fabric22.util.toFixed;
    if (fabric22.Shadow) {
      fabric22.warn("fabric.Shadow is already defined.");
      return;
    }
    fabric22.Shadow = fabric22.util.createClass(
      /** @lends fabric.Shadow.prototype */
      {
        /**
         * Shadow color
         * @type String
         * @default
         */
        color: "rgb(0,0,0)",
        /**
         * Shadow blur
         * @type Number
         */
        blur: 0,
        /**
         * Shadow horizontal offset
         * @type Number
         * @default
         */
        offsetX: 0,
        /**
         * Shadow vertical offset
         * @type Number
         * @default
         */
        offsetY: 0,
        /**
         * Whether the shadow should affect stroke operations
         * @type Boolean
         * @default
         */
        affectStroke: false,
        /**
         * Indicates whether toObject should include default values
         * @type Boolean
         * @default
         */
        includeDefaultValues: true,
        /**
         * When `false`, the shadow will scale with the object.
         * When `true`, the shadow's offsetX, offsetY, and blur will not be affected by the object's scale.
         * default to false
         * @type Boolean
         * @default
         */
        nonScaling: false,
        /**
         * Constructor
         * @param {Object|String} [options] Options object with any of color, blur, offsetX, offsetY properties or string (e.g. "rgba(0,0,0,0.2) 2px 2px 10px")
         * @return {fabric.Shadow} thisArg
         */
        initialize: function(options) {
          if (typeof options === "string") {
            options = this._parseShadow(options);
          }
          for (var prop in options) {
            this[prop] = options[prop];
          }
          this.id = fabric22.Object.__uid++;
        },
        /**
         * @private
         * @param {String} shadow Shadow value to parse
         * @return {Object} Shadow object with color, offsetX, offsetY and blur
         */
        _parseShadow: function(shadow) {
          var shadowStr = shadow.trim(), offsetsAndBlur = fabric22.Shadow.reOffsetsAndBlur.exec(shadowStr) || [], color = shadowStr.replace(fabric22.Shadow.reOffsetsAndBlur, "") || "rgb(0,0,0)";
          return {
            color: color.trim(),
            offsetX: parseFloat(offsetsAndBlur[1], 10) || 0,
            offsetY: parseFloat(offsetsAndBlur[2], 10) || 0,
            blur: parseFloat(offsetsAndBlur[3], 10) || 0
          };
        },
        /**
         * Returns a string representation of an instance
         * @see http://www.w3.org/TR/css-text-decor-3/#text-shadow
         * @return {String} Returns CSS3 text-shadow declaration
         */
        toString: function() {
          return [this.offsetX, this.offsetY, this.blur, this.color].join("px ");
        },
        /* _TO_SVG_START_ */
        /**
         * Returns SVG representation of a shadow
         * @param {fabric.Object} object
         * @return {String} SVG representation of a shadow
         */
        toSVG: function(object) {
          var fBoxX = 40, fBoxY = 40, NUM_FRACTION_DIGITS = fabric22.Object.NUM_FRACTION_DIGITS, offset = fabric22.util.rotateVector(
            { x: this.offsetX, y: this.offsetY },
            fabric22.util.degreesToRadians(-object.angle)
          ), BLUR_BOX = 20, color = new fabric22.Color(this.color);
          if (object.width && object.height) {
            fBoxX = toFixed((Math.abs(offset.x) + this.blur) / object.width, NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
            fBoxY = toFixed((Math.abs(offset.y) + this.blur) / object.height, NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
          }
          if (object.flipX) {
            offset.x *= -1;
          }
          if (object.flipY) {
            offset.y *= -1;
          }
          return '<filter id="SVGID_' + this.id + '" y="-' + fBoxY + '%" height="' + (100 + 2 * fBoxY) + '%" x="-' + fBoxX + '%" width="' + (100 + 2 * fBoxX) + '%" >\n	<feGaussianBlur in="SourceAlpha" stdDeviation="' + toFixed(this.blur ? this.blur / 2 : 0, NUM_FRACTION_DIGITS) + '"></feGaussianBlur>\n	<feOffset dx="' + toFixed(offset.x, NUM_FRACTION_DIGITS) + '" dy="' + toFixed(offset.y, NUM_FRACTION_DIGITS) + '" result="oBlur" ></feOffset>\n	<feFlood flood-color="' + color.toRgb() + '" flood-opacity="' + color.getAlpha() + '"/>\n	<feComposite in2="oBlur" operator="in" />\n	<feMerge>\n		<feMergeNode></feMergeNode>\n		<feMergeNode in="SourceGraphic"></feMergeNode>\n	</feMerge>\n</filter>\n';
        },
        /* _TO_SVG_END_ */
        /**
         * Returns object representation of a shadow
         * @return {Object} Object representation of a shadow instance
         */
        toObject: function() {
          if (this.includeDefaultValues) {
            return {
              color: this.color,
              blur: this.blur,
              offsetX: this.offsetX,
              offsetY: this.offsetY,
              affectStroke: this.affectStroke,
              nonScaling: this.nonScaling
            };
          }
          var obj = {}, proto2 = fabric22.Shadow.prototype;
          ["color", "blur", "offsetX", "offsetY", "affectStroke", "nonScaling"].forEach(function(prop) {
            if (this[prop] !== proto2[prop]) {
              obj[prop] = this[prop];
            }
          }, this);
          return obj;
        }
      }
    );
    fabric22.Shadow.reOffsetsAndBlur = /(?:\s|^)(-?\d+(?:\.\d*)?(?:px)?(?:\s?|$))?(-?\d+(?:\.\d*)?(?:px)?(?:\s?|$))?(\d+(?:\.\d*)?(?:px)?)?(?:\s?|$)(?:$|\s)/;
  })(exports);
  (function() {
    if (fabric2.StaticCanvas) {
      fabric2.warn("fabric.StaticCanvas is already defined.");
      return;
    }
    var extend = fabric2.util.object.extend, getElementOffset = fabric2.util.getElementOffset, removeFromArray = fabric2.util.removeFromArray, toFixed = fabric2.util.toFixed, transformPoint = fabric2.util.transformPoint, invertTransform = fabric2.util.invertTransform, getNodeCanvas = fabric2.util.getNodeCanvas, createCanvasElement = fabric2.util.createCanvasElement, CANVAS_INIT_ERROR = new Error("Could not initialize `canvas` element");
    fabric2.StaticCanvas = fabric2.util.createClass(
      fabric2.CommonMethods,
      /** @lends fabric.StaticCanvas.prototype */
      {
        /**
         * Constructor
         * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
         * @param {Object} [options] Options object
         * @return {Object} thisArg
         */
        initialize: function(el, options) {
          options || (options = {});
          this.renderAndResetBound = this.renderAndReset.bind(this);
          this.requestRenderAllBound = this.requestRenderAll.bind(this);
          this._initStatic(el, options);
        },
        /**
         * Background color of canvas instance.
         * Should be set via {@link fabric.StaticCanvas#setBackgroundColor}.
         * @type {(String|fabric.Pattern)}
         * @default
         */
        backgroundColor: "",
        /**
         * Background image of canvas instance.
         * since 2.4.0 image caching is active, please when putting an image as background, add to the
         * canvas property a reference to the canvas it is on. Otherwise the image cannot detect the zoom
         * vale. As an alternative you can disable image objectCaching
         * @type fabric.Image
         * @default
         */
        backgroundImage: null,
        /**
         * Overlay color of canvas instance.
         * Should be set via {@link fabric.StaticCanvas#setOverlayColor}
         * @since 1.3.9
         * @type {(String|fabric.Pattern)}
         * @default
         */
        overlayColor: "",
        /**
         * Overlay image of canvas instance.
         * since 2.4.0 image caching is active, please when putting an image as overlay, add to the
         * canvas property a reference to the canvas it is on. Otherwise the image cannot detect the zoom
         * vale. As an alternative you can disable image objectCaching
         * @type fabric.Image
         * @default
         */
        overlayImage: null,
        /**
         * Indicates whether toObject/toDatalessObject should include default values
         * if set to false, takes precedence over the object value.
         * @type Boolean
         * @default
         */
        includeDefaultValues: true,
        /**
         * Indicates whether objects' state should be saved
         * @type Boolean
         * @default
         */
        stateful: false,
        /**
         * Indicates whether {@link fabric.Collection.add}, {@link fabric.Collection.insertAt} and {@link fabric.Collection.remove},
         * {@link fabric.StaticCanvas.moveTo}, {@link fabric.StaticCanvas.clear} and many more, should also re-render canvas.
         * Disabling this option will not give a performance boost when adding/removing a lot of objects to/from canvas at once
         * since the renders are quequed and executed one per frame.
         * Disabling is suggested anyway and managing the renders of the app manually is not a big effort ( canvas.requestRenderAll() )
         * Left default to true to do not break documentation and old app, fiddles.
         * @type Boolean
         * @default
         */
        renderOnAddRemove: true,
        /**
         * Indicates whether object controls (borders/controls) are rendered above overlay image
         * @type Boolean
         * @default
         */
        controlsAboveOverlay: false,
        /**
         * Indicates whether the browser can be scrolled when using a touchscreen and dragging on the canvas
         * @type Boolean
         * @default
         */
        allowTouchScrolling: false,
        /**
         * Indicates whether this canvas will use image smoothing, this is on by default in browsers
         * @type Boolean
         * @default
         */
        imageSmoothingEnabled: true,
        /**
         * The transformation (a Canvas 2D API transform matrix) which focuses the viewport
         * @type Array
         * @example <caption>Default transform</caption>
         * canvas.viewportTransform = [1, 0, 0, 1, 0, 0];
         * @example <caption>Scale by 70% and translate toward bottom-right by 50, without skewing</caption>
         * canvas.viewportTransform = [0.7, 0, 0, 0.7, 50, 50];
         * @default
         */
        viewportTransform: fabric2.iMatrix.concat(),
        /**
         * if set to false background image is not affected by viewport transform
         * @since 1.6.3
         * @type Boolean
         * @default
         */
        backgroundVpt: true,
        /**
         * if set to false overlya image is not affected by viewport transform
         * @since 1.6.3
         * @type Boolean
         * @default
         */
        overlayVpt: true,
        /**
         * When true, canvas is scaled by devicePixelRatio for better rendering on retina screens
         * @type Boolean
         * @default
         */
        enableRetinaScaling: true,
        /**
         * Describe canvas element extension over design
         * properties are tl,tr,bl,br.
         * if canvas is not zoomed/panned those points are the four corner of canvas
         * if canvas is viewportTransformed you those points indicate the extension
         * of canvas element in plain untrasformed coordinates
         * The coordinates get updated with @method calcViewportBoundaries.
         * @memberOf fabric.StaticCanvas.prototype
         */
        vptCoords: {},
        /**
         * Based on vptCoords and object.aCoords, skip rendering of objects that
         * are not included in current viewport.
         * May greatly help in applications with crowded canvas and use of zoom/pan
         * If One of the corner of the bounding box of the object is on the canvas
         * the objects get rendered.
         * @memberOf fabric.StaticCanvas.prototype
         * @type Boolean
         * @default
         */
        skipOffscreen: true,
        /**
         * a fabricObject that, without stroke define a clipping area with their shape. filled in black
         * the clipPath object gets used when the canvas has rendered, and the context is placed in the
         * top left corner of the canvas.
         * clipPath will clip away controls, if you do not want this to happen use controlsAboveOverlay = true
         * @type fabric.Object
         */
        clipPath: void 0,
        /**
         * @private
         * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
         * @param {Object} [options] Options object
         */
        _initStatic: function(el, options) {
          var cb = this.requestRenderAllBound;
          this._objects = [];
          this._createLowerCanvas(el);
          this._initOptions(options);
          if (!this.interactive) {
            this._initRetinaScaling();
          }
          if (options.overlayImage) {
            this.setOverlayImage(options.overlayImage, cb);
          }
          if (options.backgroundImage) {
            this.setBackgroundImage(options.backgroundImage, cb);
          }
          if (options.backgroundColor) {
            this.setBackgroundColor(options.backgroundColor, cb);
          }
          if (options.overlayColor) {
            this.setOverlayColor(options.overlayColor, cb);
          }
          this.calcOffset();
        },
        /**
         * @private
         */
        _isRetinaScaling: function() {
          return fabric2.devicePixelRatio > 1 && this.enableRetinaScaling;
        },
        /**
         * @private
         * @return {Number} retinaScaling if applied, otherwise 1;
         */
        getRetinaScaling: function() {
          return this._isRetinaScaling() ? Math.max(1, fabric2.devicePixelRatio) : 1;
        },
        /**
         * @private
         */
        _initRetinaScaling: function() {
          if (!this._isRetinaScaling()) {
            return;
          }
          var scaleRatio = fabric2.devicePixelRatio;
          this.__initRetinaScaling(scaleRatio, this.lowerCanvasEl, this.contextContainer);
          if (this.upperCanvasEl) {
            this.__initRetinaScaling(scaleRatio, this.upperCanvasEl, this.contextTop);
          }
        },
        __initRetinaScaling: function(scaleRatio, canvas, context) {
          canvas.setAttribute("width", this.width * scaleRatio);
          canvas.setAttribute("height", this.height * scaleRatio);
          context.scale(scaleRatio, scaleRatio);
        },
        /**
         * Calculates canvas element offset relative to the document
         * This method is also attached as "resize" event handler of window
         * @return {fabric.Canvas} instance
         * @chainable
         */
        calcOffset: function() {
          this._offset = getElementOffset(this.lowerCanvasEl);
          return this;
        },
        /**
         * Sets {@link fabric.StaticCanvas#overlayImage|overlay image} for this canvas
         * @param {(fabric.Image|String)} image fabric.Image instance or URL of an image to set overlay to
         * @param {Function} callback callback to invoke when image is loaded and set as an overlay
         * @param {Object} [options] Optional options to set for the {@link fabric.Image|overlay image}.
         * @return {fabric.Canvas} thisArg
         * @chainable
         * @see {@link http://jsfiddle.net/fabricjs/MnzHT/|jsFiddle demo}
         * @example <caption>Normal overlayImage with left/top = 0</caption>
         * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
         *   // Needed to position overlayImage at 0/0
         *   originX: 'left',
         *   originY: 'top'
         * });
         * @example <caption>overlayImage with different properties</caption>
         * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
         *   opacity: 0.5,
         *   angle: 45,
         *   left: 400,
         *   top: 400,
         *   originX: 'left',
         *   originY: 'top'
         * });
         * @example <caption>Stretched overlayImage #1 - width/height correspond to canvas width/height</caption>
         * fabric.Image.fromURL('http://fabricjs.com/assets/jail_cell_bars.png', function(img, isError) {
         *    img.set({width: canvas.width, height: canvas.height, originX: 'left', originY: 'top'});
         *    canvas.setOverlayImage(img, canvas.renderAll.bind(canvas));
         * });
         * @example <caption>Stretched overlayImage #2 - width/height correspond to canvas width/height</caption>
         * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
         *   width: canvas.width,
         *   height: canvas.height,
         *   // Needed to position overlayImage at 0/0
         *   originX: 'left',
         *   originY: 'top'
         * });
         * @example <caption>overlayImage loaded from cross-origin</caption>
         * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
         *   opacity: 0.5,
         *   angle: 45,
         *   left: 400,
         *   top: 400,
         *   originX: 'left',
         *   originY: 'top',
         *   crossOrigin: 'anonymous'
         * });
         */
        setOverlayImage: function(image, callback, options) {
          return this.__setBgOverlayImage("overlayImage", image, callback, options);
        },
        /**
         * Sets {@link fabric.StaticCanvas#backgroundImage|background image} for this canvas
         * @param {(fabric.Image|String)} image fabric.Image instance or URL of an image to set background to
         * @param {Function} callback Callback to invoke when image is loaded and set as background
         * @param {Object} [options] Optional options to set for the {@link fabric.Image|background image}.
         * @return {fabric.Canvas} thisArg
         * @chainable
         * @see {@link http://jsfiddle.net/djnr8o7a/28/|jsFiddle demo}
         * @example <caption>Normal backgroundImage with left/top = 0</caption>
         * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
         *   // Needed to position backgroundImage at 0/0
         *   originX: 'left',
         *   originY: 'top'
         * });
         * @example <caption>backgroundImage with different properties</caption>
         * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
         *   opacity: 0.5,
         *   angle: 45,
         *   left: 400,
         *   top: 400,
         *   originX: 'left',
         *   originY: 'top'
         * });
         * @example <caption>Stretched backgroundImage #1 - width/height correspond to canvas width/height</caption>
         * fabric.Image.fromURL('http://fabricjs.com/assets/honey_im_subtle.png', function(img, isError) {
         *    img.set({width: canvas.width, height: canvas.height, originX: 'left', originY: 'top'});
         *    canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas));
         * });
         * @example <caption>Stretched backgroundImage #2 - width/height correspond to canvas width/height</caption>
         * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
         *   width: canvas.width,
         *   height: canvas.height,
         *   // Needed to position backgroundImage at 0/0
         *   originX: 'left',
         *   originY: 'top'
         * });
         * @example <caption>backgroundImage loaded from cross-origin</caption>
         * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
         *   opacity: 0.5,
         *   angle: 45,
         *   left: 400,
         *   top: 400,
         *   originX: 'left',
         *   originY: 'top',
         *   crossOrigin: 'anonymous'
         * });
         */
        // TODO: fix stretched examples
        setBackgroundImage: function(image, callback, options) {
          return this.__setBgOverlayImage("backgroundImage", image, callback, options);
        },
        /**
         * Sets {@link fabric.StaticCanvas#overlayColor|foreground color} for this canvas
         * @param {(String|fabric.Pattern)} overlayColor Color or pattern to set foreground color to
         * @param {Function} callback Callback to invoke when foreground color is set
         * @return {fabric.Canvas} thisArg
         * @chainable
         * @see {@link http://jsfiddle.net/fabricjs/pB55h/|jsFiddle demo}
         * @example <caption>Normal overlayColor - color value</caption>
         * canvas.setOverlayColor('rgba(255, 73, 64, 0.6)', canvas.renderAll.bind(canvas));
         * @example <caption>fabric.Pattern used as overlayColor</caption>
         * canvas.setOverlayColor({
         *   source: 'http://fabricjs.com/assets/escheresque_ste.png'
         * }, canvas.renderAll.bind(canvas));
         * @example <caption>fabric.Pattern used as overlayColor with repeat and offset</caption>
         * canvas.setOverlayColor({
         *   source: 'http://fabricjs.com/assets/escheresque_ste.png',
         *   repeat: 'repeat',
         *   offsetX: 200,
         *   offsetY: 100
         * }, canvas.renderAll.bind(canvas));
         */
        setOverlayColor: function(overlayColor, callback) {
          return this.__setBgOverlayColor("overlayColor", overlayColor, callback);
        },
        /**
         * Sets {@link fabric.StaticCanvas#backgroundColor|background color} for this canvas
         * @param {(String|fabric.Pattern)} backgroundColor Color or pattern to set background color to
         * @param {Function} callback Callback to invoke when background color is set
         * @return {fabric.Canvas} thisArg
         * @chainable
         * @see {@link http://jsfiddle.net/fabricjs/hXzvk/|jsFiddle demo}
         * @example <caption>Normal backgroundColor - color value</caption>
         * canvas.setBackgroundColor('rgba(255, 73, 64, 0.6)', canvas.renderAll.bind(canvas));
         * @example <caption>fabric.Pattern used as backgroundColor</caption>
         * canvas.setBackgroundColor({
         *   source: 'http://fabricjs.com/assets/escheresque_ste.png'
         * }, canvas.renderAll.bind(canvas));
         * @example <caption>fabric.Pattern used as backgroundColor with repeat and offset</caption>
         * canvas.setBackgroundColor({
         *   source: 'http://fabricjs.com/assets/escheresque_ste.png',
         *   repeat: 'repeat',
         *   offsetX: 200,
         *   offsetY: 100
         * }, canvas.renderAll.bind(canvas));
         */
        setBackgroundColor: function(backgroundColor, callback) {
          return this.__setBgOverlayColor("backgroundColor", backgroundColor, callback);
        },
        /**
         * @private
         * @param {String} property Property to set ({@link fabric.StaticCanvas#backgroundImage|backgroundImage}
         * or {@link fabric.StaticCanvas#overlayImage|overlayImage})
         * @param {(fabric.Image|String|null)} image fabric.Image instance, URL of an image or null to set background or overlay to
         * @param {Function} callback Callback to invoke when image is loaded and set as background or overlay. The first argument is the created image, the second argument is a flag indicating whether an error occurred or not.
         * @param {Object} [options] Optional options to set for the {@link fabric.Image|image}.
         */
        __setBgOverlayImage: function(property, image, callback, options) {
          if (typeof image === "string") {
            fabric2.util.loadImage(image, function(img, isError) {
              if (img) {
                var instance = new fabric2.Image(img, options);
                this[property] = instance;
                instance.canvas = this;
              }
              callback && callback(img, isError);
            }, this, options && options.crossOrigin);
          } else {
            options && image.setOptions(options);
            this[property] = image;
            image && (image.canvas = this);
            callback && callback(image, false);
          }
          return this;
        },
        /**
         * @private
         * @param {String} property Property to set ({@link fabric.StaticCanvas#backgroundColor|backgroundColor}
         * or {@link fabric.StaticCanvas#overlayColor|overlayColor})
         * @param {(Object|String|null)} color Object with pattern information, color value or null
         * @param {Function} [callback] Callback is invoked when color is set
         */
        __setBgOverlayColor: function(property, color, callback) {
          this[property] = color;
          this._initGradient(color, property);
          this._initPattern(color, property, callback);
          return this;
        },
        /**
         * @private
         */
        _createCanvasElement: function() {
          var element = createCanvasElement();
          if (!element) {
            throw CANVAS_INIT_ERROR;
          }
          if (!element.style) {
            element.style = {};
          }
          if (typeof element.getContext === "undefined") {
            throw CANVAS_INIT_ERROR;
          }
          return element;
        },
        /**
         * @private
         * @param {Object} [options] Options object
         */
        _initOptions: function(options) {
          var lowerCanvasEl = this.lowerCanvasEl;
          this._setOptions(options);
          this.width = this.width || parseInt(lowerCanvasEl.width, 10) || 0;
          this.height = this.height || parseInt(lowerCanvasEl.height, 10) || 0;
          if (!this.lowerCanvasEl.style) {
            return;
          }
          lowerCanvasEl.width = this.width;
          lowerCanvasEl.height = this.height;
          lowerCanvasEl.style.width = this.width + "px";
          lowerCanvasEl.style.height = this.height + "px";
          this.viewportTransform = this.viewportTransform.slice();
        },
        /**
         * Creates a bottom canvas
         * @private
         * @param {HTMLElement} [canvasEl]
         */
        _createLowerCanvas: function(canvasEl) {
          if (canvasEl && canvasEl.getContext) {
            this.lowerCanvasEl = canvasEl;
          } else {
            this.lowerCanvasEl = fabric2.util.getById(canvasEl) || this._createCanvasElement();
          }
          fabric2.util.addClass(this.lowerCanvasEl, "lower-canvas");
          this._originalCanvasStyle = this.lowerCanvasEl.style;
          if (this.interactive) {
            this._applyCanvasStyle(this.lowerCanvasEl);
          }
          this.contextContainer = this.lowerCanvasEl.getContext("2d");
        },
        /**
         * Returns canvas width (in px)
         * @return {Number}
         */
        getWidth: function() {
          return this.width;
        },
        /**
         * Returns canvas height (in px)
         * @return {Number}
         */
        getHeight: function() {
          return this.height;
        },
        /**
         * Sets width of this canvas instance
         * @param {Number|String} value                         Value to set width to
         * @param {Object}        [options]                     Options object
         * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
         * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
         * @return {fabric.Canvas} instance
         * @chainable true
         */
        setWidth: function(value, options) {
          return this.setDimensions({ width: value }, options);
        },
        /**
         * Sets height of this canvas instance
         * @param {Number|String} value                         Value to set height to
         * @param {Object}        [options]                     Options object
         * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
         * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
         * @return {fabric.Canvas} instance
         * @chainable true
         */
        setHeight: function(value, options) {
          return this.setDimensions({ height: value }, options);
        },
        /**
         * Sets dimensions (width, height) of this canvas instance. when options.cssOnly flag active you should also supply the unit of measure (px/%/em)
         * @param {Object}        dimensions                    Object with width/height properties
         * @param {Number|String} [dimensions.width]            Width of canvas element
         * @param {Number|String} [dimensions.height]           Height of canvas element
         * @param {Object}        [options]                     Options object
         * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
         * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
         * @return {fabric.Canvas} thisArg
         * @chainable
         */
        setDimensions: function(dimensions, options) {
          var cssValue;
          options = options || {};
          for (var prop in dimensions) {
            cssValue = dimensions[prop];
            if (!options.cssOnly) {
              this._setBackstoreDimension(prop, dimensions[prop]);
              cssValue += "px";
              this.hasLostContext = true;
            }
            if (!options.backstoreOnly) {
              this._setCssDimension(prop, cssValue);
            }
          }
          if (this._isCurrentlyDrawing) {
            this.freeDrawingBrush && this.freeDrawingBrush._setBrushStyles(this.contextTop);
          }
          this._initRetinaScaling();
          this.calcOffset();
          if (!options.cssOnly) {
            this.requestRenderAll();
          }
          return this;
        },
        /**
         * Helper for setting width/height
         * @private
         * @param {String} prop property (width|height)
         * @param {Number} value value to set property to
         * @return {fabric.Canvas} instance
         * @chainable true
         */
        _setBackstoreDimension: function(prop, value) {
          this.lowerCanvasEl[prop] = value;
          if (this.upperCanvasEl) {
            this.upperCanvasEl[prop] = value;
          }
          if (this.cacheCanvasEl) {
            this.cacheCanvasEl[prop] = value;
          }
          this[prop] = value;
          return this;
        },
        /**
         * Helper for setting css width/height
         * @private
         * @param {String} prop property (width|height)
         * @param {String} value value to set property to
         * @return {fabric.Canvas} instance
         * @chainable true
         */
        _setCssDimension: function(prop, value) {
          this.lowerCanvasEl.style[prop] = value;
          if (this.upperCanvasEl) {
            this.upperCanvasEl.style[prop] = value;
          }
          if (this.wrapperEl) {
            this.wrapperEl.style[prop] = value;
          }
          return this;
        },
        /**
         * Returns canvas zoom level
         * @return {Number}
         */
        getZoom: function() {
          return this.viewportTransform[0];
        },
        /**
         * Sets viewport transformation of this canvas instance
         * @param {Array} vpt a Canvas 2D API transform matrix
         * @return {fabric.Canvas} instance
         * @chainable true
         */
        setViewportTransform: function(vpt) {
          var activeObject = this._activeObject, backgroundObject = this.backgroundImage, overlayObject = this.overlayImage, object, i, len;
          this.viewportTransform = vpt;
          for (i = 0, len = this._objects.length; i < len; i++) {
            object = this._objects[i];
            object.group || object.setCoords(true);
          }
          if (activeObject) {
            activeObject.setCoords();
          }
          if (backgroundObject) {
            backgroundObject.setCoords(true);
          }
          if (overlayObject) {
            overlayObject.setCoords(true);
          }
          this.calcViewportBoundaries();
          this.renderOnAddRemove && this.requestRenderAll();
          return this;
        },
        /**
         * Sets zoom level of this canvas instance, the zoom centered around point
         * meaning that following zoom to point with the same point will have the visual
         * effect of the zoom originating from that point. The point won't move.
         * It has nothing to do with canvas center or visual center of the viewport.
         * @param {fabric.Point} point to zoom with respect to
         * @param {Number} value to set zoom to, less than 1 zooms out
         * @return {fabric.Canvas} instance
         * @chainable true
         */
        zoomToPoint: function(point, value) {
          var before = point, vpt = this.viewportTransform.slice(0);
          point = transformPoint(point, invertTransform(this.viewportTransform));
          vpt[0] = value;
          vpt[3] = value;
          var after = transformPoint(point, vpt);
          vpt[4] += before.x - after.x;
          vpt[5] += before.y - after.y;
          return this.setViewportTransform(vpt);
        },
        /**
         * Sets zoom level of this canvas instance
         * @param {Number} value to set zoom to, less than 1 zooms out
         * @return {fabric.Canvas} instance
         * @chainable true
         */
        setZoom: function(value) {
          this.zoomToPoint(new fabric2.Point(0, 0), value);
          return this;
        },
        /**
         * Pan viewport so as to place point at top left corner of canvas
         * @param {fabric.Point} point to move to
         * @return {fabric.Canvas} instance
         * @chainable true
         */
        absolutePan: function(point) {
          var vpt = this.viewportTransform.slice(0);
          vpt[4] = -point.x;
          vpt[5] = -point.y;
          return this.setViewportTransform(vpt);
        },
        /**
         * Pans viewpoint relatively
         * @param {fabric.Point} point (position vector) to move by
         * @return {fabric.Canvas} instance
         * @chainable true
         */
        relativePan: function(point) {
          return this.absolutePan(new fabric2.Point(
            -point.x - this.viewportTransform[4],
            -point.y - this.viewportTransform[5]
          ));
        },
        /**
         * Returns &lt;canvas> element corresponding to this instance
         * @return {HTMLCanvasElement}
         */
        getElement: function() {
          return this.lowerCanvasEl;
        },
        /**
         * @private
         * @param {fabric.Object} obj Object that was added
         */
        _onObjectAdded: function(obj) {
          this.stateful && obj.setupState();
          obj._set("canvas", this);
          obj.setCoords();
          this.fire("object:added", { target: obj });
          obj.fire("added");
        },
        /**
         * @private
         * @param {fabric.Object} obj Object that was removed
         */
        _onObjectRemoved: function(obj) {
          this.fire("object:removed", { target: obj });
          obj.fire("removed");
          delete obj.canvas;
        },
        /**
         * Clears specified context of canvas element
         * @param {CanvasRenderingContext2D} ctx Context to clear
         * @return {fabric.Canvas} thisArg
         * @chainable
         */
        clearContext: function(ctx) {
          ctx.clearRect(0, 0, this.width, this.height);
          return this;
        },
        /**
         * Returns context of canvas where objects are drawn
         * @return {CanvasRenderingContext2D}
         */
        getContext: function() {
          return this.contextContainer;
        },
        /**
         * Clears all contexts (background, main, top) of an instance
         * @return {fabric.Canvas} thisArg
         * @chainable
         */
        clear: function() {
          this.remove.apply(this, this.getObjects());
          this.backgroundImage = null;
          this.overlayImage = null;
          this.backgroundColor = "";
          this.overlayColor = "";
          if (this._hasITextHandlers) {
            this.off("mouse:up", this._mouseUpITextHandler);
            this._iTextInstances = null;
            this._hasITextHandlers = false;
          }
          this.clearContext(this.contextContainer);
          this.fire("canvas:cleared");
          this.renderOnAddRemove && this.requestRenderAll();
          return this;
        },
        /**
         * Renders the canvas
         * @return {fabric.Canvas} instance
         * @chainable
         */
        renderAll: function() {
          var canvasToDrawOn = this.contextContainer;
          this.renderCanvas(canvasToDrawOn, this._objects);
          return this;
        },
        /**
         * Function created to be instance bound at initialization
         * used in requestAnimationFrame rendering
         * Let the fabricJS call it. If you call it manually you could have more
         * animationFrame stacking on to of each other
         * for an imperative rendering, use canvas.renderAll
         * @private
         * @return {fabric.Canvas} instance
         * @chainable
         */
        renderAndReset: function() {
          this.isRendering = 0;
          this.renderAll();
        },
        /**
         * Append a renderAll request to next animation frame.
         * unless one is already in progress, in that case nothing is done
         * a boolean flag will avoid appending more.
         * @return {fabric.Canvas} instance
         * @chainable
         */
        requestRenderAll: function() {
          if (!this.isRendering) {
            this.isRendering = fabric2.util.requestAnimFrame(this.renderAndResetBound);
          }
          return this;
        },
        /**
         * Calculate the position of the 4 corner of canvas with current viewportTransform.
         * helps to determinate when an object is in the current rendering viewport using
         * object absolute coordinates ( aCoords )
         * @return {Object} points.tl
         * @chainable
         */
        calcViewportBoundaries: function() {
          var points = {}, width = this.width, height = this.height, iVpt = invertTransform(this.viewportTransform);
          points.tl = transformPoint({ x: 0, y: 0 }, iVpt);
          points.br = transformPoint({ x: width, y: height }, iVpt);
          points.tr = new fabric2.Point(points.br.x, points.tl.y);
          points.bl = new fabric2.Point(points.tl.x, points.br.y);
          this.vptCoords = points;
          return points;
        },
        cancelRequestedRender: function() {
          if (this.isRendering) {
            fabric2.util.cancelAnimFrame(this.isRendering);
            this.isRendering = 0;
          }
        },
        /**
         * Renders background, objects, overlay and controls.
         * @param {CanvasRenderingContext2D} ctx
         * @param {Array} objects to render
         * @return {fabric.Canvas} instance
         * @chainable
         */
        renderCanvas: function(ctx, objects) {
          var v = this.viewportTransform, path = this.clipPath;
          this.cancelRequestedRender();
          this.calcViewportBoundaries();
          this.clearContext(ctx);
          fabric2.util.setImageSmoothing(ctx, this.imageSmoothingEnabled);
          this.fire("before:render", { ctx });
          this._renderBackground(ctx);
          ctx.save();
          ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
          this._renderObjects(ctx, objects);
          ctx.restore();
          if (!this.controlsAboveOverlay && this.interactive) {
            this.drawControls(ctx);
          }
          if (path) {
            path.canvas = this;
            path.shouldCache();
            path._transformDone = true;
            path.renderCache({ forClipping: true });
            this.drawClipPathOnCanvas(ctx);
          }
          this._renderOverlay(ctx);
          if (this.controlsAboveOverlay && this.interactive) {
            this.drawControls(ctx);
          }
          this.fire("after:render", { ctx });
        },
        /**
         * Paint the cached clipPath on the lowerCanvasEl
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        drawClipPathOnCanvas: function(ctx) {
          var v = this.viewportTransform, path = this.clipPath;
          ctx.save();
          ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
          ctx.globalCompositeOperation = "destination-in";
          path.transform(ctx);
          ctx.scale(1 / path.zoomX, 1 / path.zoomY);
          ctx.drawImage(path._cacheCanvas, -path.cacheTranslationX, -path.cacheTranslationY);
          ctx.restore();
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         * @param {Array} objects to render
         */
        _renderObjects: function(ctx, objects) {
          var i, len;
          for (i = 0, len = objects.length; i < len; ++i) {
            objects[i] && objects[i].render(ctx);
          }
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         * @param {string} property 'background' or 'overlay'
         */
        _renderBackgroundOrOverlay: function(ctx, property) {
          var fill = this[property + "Color"], object = this[property + "Image"], v = this.viewportTransform, needsVpt = this[property + "Vpt"];
          if (!fill && !object) {
            return;
          }
          if (fill) {
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(0, 0);
            ctx.lineTo(this.width, 0);
            ctx.lineTo(this.width, this.height);
            ctx.lineTo(0, this.height);
            ctx.closePath();
            ctx.fillStyle = fill.toLive ? fill.toLive(ctx, this) : fill;
            if (needsVpt) {
              ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
            }
            ctx.transform(1, 0, 0, 1, fill.offsetX || 0, fill.offsetY || 0);
            var m = fill.gradientTransform || fill.patternTransform;
            m && ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            ctx.fill();
            ctx.restore();
          }
          if (object) {
            ctx.save();
            if (needsVpt) {
              ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
            }
            object.render(ctx);
            ctx.restore();
          }
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _renderBackground: function(ctx) {
          this._renderBackgroundOrOverlay(ctx, "background");
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _renderOverlay: function(ctx) {
          this._renderBackgroundOrOverlay(ctx, "overlay");
        },
        /**
         * Returns coordinates of a center of canvas.
         * Returned value is an object with top and left properties
         * @return {Object} object with "top" and "left" number values
         * @deprecated migrate to `getCenterPoint`
         */
        getCenter: function() {
          return {
            top: this.height / 2,
            left: this.width / 2
          };
        },
        /**
         * Returns coordinates of a center of canvas.
         * @return {fabric.Point} 
         */
        getCenterPoint: function() {
          return new fabric2.Point(this.width / 2, this.height / 2);
        },
        /**
         * Centers object horizontally in the canvas
         * @param {fabric.Object} object Object to center horizontally
         * @return {fabric.Canvas} thisArg
         */
        centerObjectH: function(object) {
          return this._centerObject(object, new fabric2.Point(this.getCenterPoint().x, object.getCenterPoint().y));
        },
        /**
         * Centers object vertically in the canvas
         * @param {fabric.Object} object Object to center vertically
         * @return {fabric.Canvas} thisArg
         * @chainable
         */
        centerObjectV: function(object) {
          return this._centerObject(object, new fabric2.Point(object.getCenterPoint().x, this.getCenterPoint().y));
        },
        /**
         * Centers object vertically and horizontally in the canvas
         * @param {fabric.Object} object Object to center vertically and horizontally
         * @return {fabric.Canvas} thisArg
         * @chainable
         */
        centerObject: function(object) {
          var center = this.getCenterPoint();
          return this._centerObject(object, center);
        },
        /**
         * Centers object vertically and horizontally in the viewport
         * @param {fabric.Object} object Object to center vertically and horizontally
         * @return {fabric.Canvas} thisArg
         * @chainable
         */
        viewportCenterObject: function(object) {
          var vpCenter = this.getVpCenter();
          return this._centerObject(object, vpCenter);
        },
        /**
         * Centers object horizontally in the viewport, object.top is unchanged
         * @param {fabric.Object} object Object to center vertically and horizontally
         * @return {fabric.Canvas} thisArg
         * @chainable
         */
        viewportCenterObjectH: function(object) {
          var vpCenter = this.getVpCenter();
          this._centerObject(object, new fabric2.Point(vpCenter.x, object.getCenterPoint().y));
          return this;
        },
        /**
         * Centers object Vertically in the viewport, object.top is unchanged
         * @param {fabric.Object} object Object to center vertically and horizontally
         * @return {fabric.Canvas} thisArg
         * @chainable
         */
        viewportCenterObjectV: function(object) {
          var vpCenter = this.getVpCenter();
          return this._centerObject(object, new fabric2.Point(object.getCenterPoint().x, vpCenter.y));
        },
        /**
         * Calculate the point in canvas that correspond to the center of actual viewport.
         * @return {fabric.Point} vpCenter, viewport center
         * @chainable
         */
        getVpCenter: function() {
          var center = this.getCenterPoint(), iVpt = invertTransform(this.viewportTransform);
          return transformPoint(center, iVpt);
        },
        /**
         * @private
         * @param {fabric.Object} object Object to center
         * @param {fabric.Point} center Center point
         * @return {fabric.Canvas} thisArg
         * @chainable
         */
        _centerObject: function(object, center) {
          object.setPositionByOrigin(center, "center", "center");
          object.setCoords();
          this.renderOnAddRemove && this.requestRenderAll();
          return this;
        },
        /**
         * Returns dataless JSON representation of canvas
         * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
         * @return {String} json string
         */
        toDatalessJSON: function(propertiesToInclude) {
          return this.toDatalessObject(propertiesToInclude);
        },
        /**
         * Returns object representation of canvas
         * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
         * @return {Object} object representation of an instance
         */
        toObject: function(propertiesToInclude) {
          return this._toObjectMethod("toObject", propertiesToInclude);
        },
        /**
         * Returns dataless object representation of canvas
         * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
         * @return {Object} object representation of an instance
         */
        toDatalessObject: function(propertiesToInclude) {
          return this._toObjectMethod("toDatalessObject", propertiesToInclude);
        },
        /**
         * @private
         */
        _toObjectMethod: function(methodName, propertiesToInclude) {
          var clipPath = this.clipPath, data = {
            version: fabric2.version,
            objects: this._toObjects(methodName, propertiesToInclude)
          };
          if (clipPath && !clipPath.excludeFromExport) {
            data.clipPath = this._toObject(this.clipPath, methodName, propertiesToInclude);
          }
          extend(data, this.__serializeBgOverlay(methodName, propertiesToInclude));
          fabric2.util.populateWithProperties(this, data, propertiesToInclude);
          return data;
        },
        /**
         * @private
         */
        _toObjects: function(methodName, propertiesToInclude) {
          return this._objects.filter(function(object) {
            return !object.excludeFromExport;
          }).map(function(instance) {
            return this._toObject(instance, methodName, propertiesToInclude);
          }, this);
        },
        /**
         * @private
         */
        _toObject: function(instance, methodName, propertiesToInclude) {
          var originalValue;
          if (!this.includeDefaultValues) {
            originalValue = instance.includeDefaultValues;
            instance.includeDefaultValues = false;
          }
          var object = instance[methodName](propertiesToInclude);
          if (!this.includeDefaultValues) {
            instance.includeDefaultValues = originalValue;
          }
          return object;
        },
        /**
         * @private
         */
        __serializeBgOverlay: function(methodName, propertiesToInclude) {
          var data = {}, bgImage = this.backgroundImage, overlayImage = this.overlayImage, bgColor = this.backgroundColor, overlayColor = this.overlayColor;
          if (bgColor && bgColor.toObject) {
            if (!bgColor.excludeFromExport) {
              data.background = bgColor.toObject(propertiesToInclude);
            }
          } else if (bgColor) {
            data.background = bgColor;
          }
          if (overlayColor && overlayColor.toObject) {
            if (!overlayColor.excludeFromExport) {
              data.overlay = overlayColor.toObject(propertiesToInclude);
            }
          } else if (overlayColor) {
            data.overlay = overlayColor;
          }
          if (bgImage && !bgImage.excludeFromExport) {
            data.backgroundImage = this._toObject(bgImage, methodName, propertiesToInclude);
          }
          if (overlayImage && !overlayImage.excludeFromExport) {
            data.overlayImage = this._toObject(overlayImage, methodName, propertiesToInclude);
          }
          return data;
        },
        /* _TO_SVG_START_ */
        /**
         * When true, getSvgTransform() will apply the StaticCanvas.viewportTransform to the SVG transformation. When true,
         * a zoomed canvas will then produce zoomed SVG output.
         * @type Boolean
         * @default
         */
        svgViewportTransformation: true,
        /**
         * Returns SVG representation of canvas
         * @function
         * @param {Object} [options] Options object for SVG output
         * @param {Boolean} [options.suppressPreamble=false] If true xml tag is not included
         * @param {Object} [options.viewBox] SVG viewbox object
         * @param {Number} [options.viewBox.x] x-coordinate of viewbox
         * @param {Number} [options.viewBox.y] y-coordinate of viewbox
         * @param {Number} [options.viewBox.width] Width of viewbox
         * @param {Number} [options.viewBox.height] Height of viewbox
         * @param {String} [options.encoding=UTF-8] Encoding of SVG output
         * @param {String} [options.width] desired width of svg with or without units
         * @param {String} [options.height] desired height of svg with or without units
         * @param {Function} [reviver] Method for further parsing of svg elements, called after each fabric object converted into svg representation.
         * @return {String} SVG string
         * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#serialization}
         * @see {@link http://jsfiddle.net/fabricjs/jQ3ZZ/|jsFiddle demo}
         * @example <caption>Normal SVG output</caption>
         * var svg = canvas.toSVG();
         * @example <caption>SVG output without preamble (without &lt;?xml ../>)</caption>
         * var svg = canvas.toSVG({suppressPreamble: true});
         * @example <caption>SVG output with viewBox attribute</caption>
         * var svg = canvas.toSVG({
         *   viewBox: {
         *     x: 100,
         *     y: 100,
         *     width: 200,
         *     height: 300
         *   }
         * });
         * @example <caption>SVG output with different encoding (default: UTF-8)</caption>
         * var svg = canvas.toSVG({encoding: 'ISO-8859-1'});
         * @example <caption>Modify SVG output with reviver function</caption>
         * var svg = canvas.toSVG(null, function(svg) {
         *   return svg.replace('stroke-dasharray: ; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; ', '');
         * });
         */
        toSVG: function(options, reviver) {
          options || (options = {});
          options.reviver = reviver;
          var markup = [];
          this._setSVGPreamble(markup, options);
          this._setSVGHeader(markup, options);
          if (this.clipPath) {
            markup.push('<g clip-path="url(#' + this.clipPath.clipPathId + ')" >\n');
          }
          this._setSVGBgOverlayColor(markup, "background");
          this._setSVGBgOverlayImage(markup, "backgroundImage", reviver);
          this._setSVGObjects(markup, reviver);
          if (this.clipPath) {
            markup.push("</g>\n");
          }
          this._setSVGBgOverlayColor(markup, "overlay");
          this._setSVGBgOverlayImage(markup, "overlayImage", reviver);
          markup.push("</svg>");
          return markup.join("");
        },
        /**
         * @private
         */
        _setSVGPreamble: function(markup, options) {
          if (options.suppressPreamble) {
            return;
          }
          markup.push(
            '<?xml version="1.0" encoding="',
            options.encoding || "UTF-8",
            '" standalone="no" ?>\n',
            '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" ',
            '"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n'
          );
        },
        /**
         * @private
         */
        _setSVGHeader: function(markup, options) {
          var width = options.width || this.width, height = options.height || this.height, vpt, viewBox = 'viewBox="0 0 ' + this.width + " " + this.height + '" ', NUM_FRACTION_DIGITS = fabric2.Object.NUM_FRACTION_DIGITS;
          if (options.viewBox) {
            viewBox = 'viewBox="' + options.viewBox.x + " " + options.viewBox.y + " " + options.viewBox.width + " " + options.viewBox.height + '" ';
          } else {
            if (this.svgViewportTransformation) {
              vpt = this.viewportTransform;
              viewBox = 'viewBox="' + toFixed(-vpt[4] / vpt[0], NUM_FRACTION_DIGITS) + " " + toFixed(-vpt[5] / vpt[3], NUM_FRACTION_DIGITS) + " " + toFixed(this.width / vpt[0], NUM_FRACTION_DIGITS) + " " + toFixed(this.height / vpt[3], NUM_FRACTION_DIGITS) + '" ';
            }
          }
          markup.push(
            "<svg ",
            'xmlns="http://www.w3.org/2000/svg" ',
            'xmlns:xlink="http://www.w3.org/1999/xlink" ',
            'version="1.1" ',
            'width="',
            width,
            '" ',
            'height="',
            height,
            '" ',
            viewBox,
            'xml:space="preserve">\n',
            "<desc>Created with Fabric.js ",
            fabric2.version,
            "</desc>\n",
            "<defs>\n",
            this.createSVGFontFacesMarkup(),
            this.createSVGRefElementsMarkup(),
            this.createSVGClipPathMarkup(options),
            "</defs>\n"
          );
        },
        createSVGClipPathMarkup: function(options) {
          var clipPath = this.clipPath;
          if (clipPath) {
            clipPath.clipPathId = "CLIPPATH_" + fabric2.Object.__uid++;
            return '<clipPath id="' + clipPath.clipPathId + '" >\n' + this.clipPath.toClipPathSVG(options.reviver) + "</clipPath>\n";
          }
          return "";
        },
        /**
         * Creates markup containing SVG referenced elements like patterns, gradients etc.
         * @return {String}
         */
        createSVGRefElementsMarkup: function() {
          var _this = this, markup = ["background", "overlay"].map(function(prop) {
            var fill = _this[prop + "Color"];
            if (fill && fill.toLive) {
              var shouldTransform = _this[prop + "Vpt"], vpt = _this.viewportTransform, object = {
                width: _this.width / (shouldTransform ? vpt[0] : 1),
                height: _this.height / (shouldTransform ? vpt[3] : 1)
              };
              return fill.toSVG(
                object,
                { additionalTransform: shouldTransform ? fabric2.util.matrixToSVG(vpt) : "" }
              );
            }
          });
          return markup.join("");
        },
        /**
         * Creates markup containing SVG font faces,
         * font URLs for font faces must be collected by developers
         * and are not extracted from the DOM by fabricjs
         * @param {Array} objects Array of fabric objects
         * @return {String}
         */
        createSVGFontFacesMarkup: function() {
          var markup = "", fontList = {}, obj, fontFamily, style, row, rowIndex, _char, charIndex, i, len, fontPaths = fabric2.fontPaths, objects = [];
          this._objects.forEach(function add2(object) {
            objects.push(object);
            if (object._objects) {
              object._objects.forEach(add2);
            }
          });
          for (i = 0, len = objects.length; i < len; i++) {
            obj = objects[i];
            fontFamily = obj.fontFamily;
            if (obj.type.indexOf("text") === -1 || fontList[fontFamily] || !fontPaths[fontFamily]) {
              continue;
            }
            fontList[fontFamily] = true;
            if (!obj.styles) {
              continue;
            }
            style = obj.styles;
            for (rowIndex in style) {
              row = style[rowIndex];
              for (charIndex in row) {
                _char = row[charIndex];
                fontFamily = _char.fontFamily;
                if (!fontList[fontFamily] && fontPaths[fontFamily]) {
                  fontList[fontFamily] = true;
                }
              }
            }
          }
          for (var j in fontList) {
            markup += [
              "		@font-face {\n",
              "			font-family: '",
              j,
              "';\n",
              "			src: url('",
              fontPaths[j],
              "');\n",
              "		}\n"
            ].join("");
          }
          if (markup) {
            markup = [
              '	<style type="text/css">',
              "<![CDATA[\n",
              markup,
              "]]>",
              "</style>\n"
            ].join("");
          }
          return markup;
        },
        /**
         * @private
         */
        _setSVGObjects: function(markup, reviver) {
          var instance, i, len, objects = this._objects;
          for (i = 0, len = objects.length; i < len; i++) {
            instance = objects[i];
            if (instance.excludeFromExport) {
              continue;
            }
            this._setSVGObject(markup, instance, reviver);
          }
        },
        /**
         * @private
         */
        _setSVGObject: function(markup, instance, reviver) {
          markup.push(instance.toSVG(reviver));
        },
        /**
         * @private
         */
        _setSVGBgOverlayImage: function(markup, property, reviver) {
          if (this[property] && !this[property].excludeFromExport && this[property].toSVG) {
            markup.push(this[property].toSVG(reviver));
          }
        },
        /**
         * @private
         */
        _setSVGBgOverlayColor: function(markup, property) {
          var filler = this[property + "Color"], vpt = this.viewportTransform, finalWidth = this.width, finalHeight = this.height;
          if (!filler) {
            return;
          }
          if (filler.toLive) {
            var repeat2 = filler.repeat, iVpt = fabric2.util.invertTransform(vpt), shouldInvert = this[property + "Vpt"], additionalTransform = shouldInvert ? fabric2.util.matrixToSVG(iVpt) : "";
            markup.push(
              '<rect transform="' + additionalTransform + " translate(",
              finalWidth / 2,
              ",",
              finalHeight / 2,
              ')"',
              ' x="',
              filler.offsetX - finalWidth / 2,
              '" y="',
              filler.offsetY - finalHeight / 2,
              '" ',
              'width="',
              repeat2 === "repeat-y" || repeat2 === "no-repeat" ? filler.source.width : finalWidth,
              '" height="',
              repeat2 === "repeat-x" || repeat2 === "no-repeat" ? filler.source.height : finalHeight,
              '" fill="url(#SVGID_' + filler.id + ')"',
              "></rect>\n"
            );
          } else {
            markup.push(
              '<rect x="0" y="0" width="100%" height="100%" ',
              'fill="',
              filler,
              '"',
              "></rect>\n"
            );
          }
        },
        /* _TO_SVG_END_ */
        /**
         * Moves an object or the objects of a multiple selection
         * to the bottom of the stack of drawn objects
         * @param {fabric.Object} object Object to send to back
         * @return {fabric.Canvas} thisArg
         * @chainable
         */
        sendToBack: function(object) {
          if (!object) {
            return this;
          }
          var activeSelection = this._activeObject, i, obj, objs;
          if (object === activeSelection && object.type === "activeSelection") {
            objs = activeSelection._objects;
            for (i = objs.length; i--; ) {
              obj = objs[i];
              removeFromArray(this._objects, obj);
              this._objects.unshift(obj);
            }
          } else {
            removeFromArray(this._objects, object);
            this._objects.unshift(object);
          }
          this.renderOnAddRemove && this.requestRenderAll();
          return this;
        },
        /**
         * Moves an object or the objects of a multiple selection
         * to the top of the stack of drawn objects
         * @param {fabric.Object} object Object to send
         * @return {fabric.Canvas} thisArg
         * @chainable
         */
        bringToFront: function(object) {
          if (!object) {
            return this;
          }
          var activeSelection = this._activeObject, i, obj, objs;
          if (object === activeSelection && object.type === "activeSelection") {
            objs = activeSelection._objects;
            for (i = 0; i < objs.length; i++) {
              obj = objs[i];
              removeFromArray(this._objects, obj);
              this._objects.push(obj);
            }
          } else {
            removeFromArray(this._objects, object);
            this._objects.push(object);
          }
          this.renderOnAddRemove && this.requestRenderAll();
          return this;
        },
        /**
         * Moves an object or a selection down in stack of drawn objects
         * An optional parameter, intersecting allows to move the object in behind
         * the first intersecting object. Where intersection is calculated with
         * bounding box. If no intersection is found, there will not be change in the
         * stack.
         * @param {fabric.Object} object Object to send
         * @param {Boolean} [intersecting] If `true`, send object behind next lower intersecting object
         * @return {fabric.Canvas} thisArg
         * @chainable
         */
        sendBackwards: function(object, intersecting) {
          if (!object) {
            return this;
          }
          var activeSelection = this._activeObject, i, obj, idx, newIdx, objs, objsMoved = 0;
          if (object === activeSelection && object.type === "activeSelection") {
            objs = activeSelection._objects;
            for (i = 0; i < objs.length; i++) {
              obj = objs[i];
              idx = this._objects.indexOf(obj);
              if (idx > 0 + objsMoved) {
                newIdx = idx - 1;
                removeFromArray(this._objects, obj);
                this._objects.splice(newIdx, 0, obj);
              }
              objsMoved++;
            }
          } else {
            idx = this._objects.indexOf(object);
            if (idx !== 0) {
              newIdx = this._findNewLowerIndex(object, idx, intersecting);
              removeFromArray(this._objects, object);
              this._objects.splice(newIdx, 0, object);
            }
          }
          this.renderOnAddRemove && this.requestRenderAll();
          return this;
        },
        /**
         * @private
         */
        _findNewLowerIndex: function(object, idx, intersecting) {
          var newIdx, i;
          if (intersecting) {
            newIdx = idx;
            for (i = idx - 1; i >= 0; --i) {
              var isIntersecting = object.intersectsWithObject(this._objects[i]) || object.isContainedWithinObject(this._objects[i]) || this._objects[i].isContainedWithinObject(object);
              if (isIntersecting) {
                newIdx = i;
                break;
              }
            }
          } else {
            newIdx = idx - 1;
          }
          return newIdx;
        },
        /**
         * Moves an object or a selection up in stack of drawn objects
         * An optional parameter, intersecting allows to move the object in front
         * of the first intersecting object. Where intersection is calculated with
         * bounding box. If no intersection is found, there will not be change in the
         * stack.
         * @param {fabric.Object} object Object to send
         * @param {Boolean} [intersecting] If `true`, send object in front of next upper intersecting object
         * @return {fabric.Canvas} thisArg
         * @chainable
         */
        bringForward: function(object, intersecting) {
          if (!object) {
            return this;
          }
          var activeSelection = this._activeObject, i, obj, idx, newIdx, objs, objsMoved = 0;
          if (object === activeSelection && object.type === "activeSelection") {
            objs = activeSelection._objects;
            for (i = objs.length; i--; ) {
              obj = objs[i];
              idx = this._objects.indexOf(obj);
              if (idx < this._objects.length - 1 - objsMoved) {
                newIdx = idx + 1;
                removeFromArray(this._objects, obj);
                this._objects.splice(newIdx, 0, obj);
              }
              objsMoved++;
            }
          } else {
            idx = this._objects.indexOf(object);
            if (idx !== this._objects.length - 1) {
              newIdx = this._findNewUpperIndex(object, idx, intersecting);
              removeFromArray(this._objects, object);
              this._objects.splice(newIdx, 0, object);
            }
          }
          this.renderOnAddRemove && this.requestRenderAll();
          return this;
        },
        /**
         * @private
         */
        _findNewUpperIndex: function(object, idx, intersecting) {
          var newIdx, i, len;
          if (intersecting) {
            newIdx = idx;
            for (i = idx + 1, len = this._objects.length; i < len; ++i) {
              var isIntersecting = object.intersectsWithObject(this._objects[i]) || object.isContainedWithinObject(this._objects[i]) || this._objects[i].isContainedWithinObject(object);
              if (isIntersecting) {
                newIdx = i;
                break;
              }
            }
          } else {
            newIdx = idx + 1;
          }
          return newIdx;
        },
        /**
         * Moves an object to specified level in stack of drawn objects
         * @param {fabric.Object} object Object to send
         * @param {Number} index Position to move to
         * @return {fabric.Canvas} thisArg
         * @chainable
         */
        moveTo: function(object, index) {
          removeFromArray(this._objects, object);
          this._objects.splice(index, 0, object);
          return this.renderOnAddRemove && this.requestRenderAll();
        },
        /**
         * Clears a canvas element and dispose objects
         * @return {fabric.Canvas} thisArg
         * @chainable
         */
        dispose: function() {
          if (this.isRendering) {
            fabric2.util.cancelAnimFrame(this.isRendering);
            this.isRendering = 0;
          }
          this.forEachObject(function(object) {
            object.dispose && object.dispose();
          });
          this._objects = [];
          if (this.backgroundImage && this.backgroundImage.dispose) {
            this.backgroundImage.dispose();
          }
          this.backgroundImage = null;
          if (this.overlayImage && this.overlayImage.dispose) {
            this.overlayImage.dispose();
          }
          this.overlayImage = null;
          this._iTextInstances = null;
          this.contextContainer = null;
          this.lowerCanvasEl.classList.remove("lower-canvas");
          fabric2.util.setStyle(this.lowerCanvasEl, this._originalCanvasStyle);
          delete this._originalCanvasStyle;
          this.lowerCanvasEl.setAttribute("width", this.width);
          this.lowerCanvasEl.setAttribute("height", this.height);
          fabric2.util.cleanUpJsdomNode(this.lowerCanvasEl);
          this.lowerCanvasEl = void 0;
          return this;
        },
        /**
         * Returns a string representation of an instance
         * @return {String} string representation of an instance
         */
        toString: function() {
          return "#<fabric.Canvas (" + this.complexity() + "): { objects: " + this._objects.length + " }>";
        }
      }
    );
    extend(fabric2.StaticCanvas.prototype, fabric2.Observable);
    extend(fabric2.StaticCanvas.prototype, fabric2.Collection);
    extend(fabric2.StaticCanvas.prototype, fabric2.DataURLExporter);
    extend(
      fabric2.StaticCanvas,
      /** @lends fabric.StaticCanvas */
      {
        /**
         * @static
         * @type String
         * @default
         */
        EMPTY_JSON: '{"objects": [], "background": "white"}',
        /**
         * Provides a way to check support of some of the canvas methods
         * (either those of HTMLCanvasElement itself, or rendering context)
         *
         * @param {String} methodName Method to check support for;
         *                            Could be one of "setLineDash"
         * @return {Boolean | null} `true` if method is supported (or at least exists),
         *                          `null` if canvas element or context can not be initialized
         */
        supports: function(methodName) {
          var el = createCanvasElement();
          if (!el || !el.getContext) {
            return null;
          }
          var ctx = el.getContext("2d");
          if (!ctx) {
            return null;
          }
          switch (methodName) {
            case "setLineDash":
              return typeof ctx.setLineDash !== "undefined";
            default:
              return null;
          }
        }
      }
    );
    fabric2.StaticCanvas.prototype.toJSON = fabric2.StaticCanvas.prototype.toObject;
    if (fabric2.isLikelyNode) {
      fabric2.StaticCanvas.prototype.createPNGStream = function() {
        var impl = getNodeCanvas(this.lowerCanvasEl);
        return impl && impl.createPNGStream();
      };
      fabric2.StaticCanvas.prototype.createJPEGStream = function(opts) {
        var impl = getNodeCanvas(this.lowerCanvasEl);
        return impl && impl.createJPEGStream(opts);
      };
    }
  })();
  fabric2.BaseBrush = fabric2.util.createClass(
    /** @lends fabric.BaseBrush.prototype */
    {
      /**
       * Color of a brush
       * @type String
       * @default
       */
      color: "rgb(0, 0, 0)",
      /**
       * Width of a brush, has to be a Number, no string literals
       * @type Number
       * @default
       */
      width: 1,
      /**
       * Shadow object representing shadow of this shape.
       * <b>Backwards incompatibility note:</b> This property replaces "shadowColor" (String), "shadowOffsetX" (Number),
       * "shadowOffsetY" (Number) and "shadowBlur" (Number) since v1.2.12
       * @type fabric.Shadow
       * @default
       */
      shadow: null,
      /**
       * Line endings style of a brush (one of "butt", "round", "square")
       * @type String
       * @default
       */
      strokeLineCap: "round",
      /**
       * Corner style of a brush (one of "bevel", "round", "miter")
       * @type String
       * @default
       */
      strokeLineJoin: "round",
      /**
       * Maximum miter length (used for strokeLineJoin = "miter") of a brush's
       * @type Number
       * @default
       */
      strokeMiterLimit: 10,
      /**
       * Stroke Dash Array.
       * @type Array
       * @default
       */
      strokeDashArray: null,
      /**
       * When `true`, the free drawing is limited to the whiteboard size. Default to false.
       * @type Boolean
       * @default false
      */
      limitedToCanvasSize: false,
      /**
       * Sets brush styles
       * @private
       * @param {CanvasRenderingContext2D} ctx
       */
      _setBrushStyles: function(ctx) {
        ctx.strokeStyle = this.color;
        ctx.lineWidth = this.width;
        ctx.lineCap = this.strokeLineCap;
        ctx.miterLimit = this.strokeMiterLimit;
        ctx.lineJoin = this.strokeLineJoin;
        ctx.setLineDash(this.strokeDashArray || []);
      },
      /**
       * Sets the transformation on given context
       * @param {RenderingContext2d} ctx context to render on
       * @private
       */
      _saveAndTransform: function(ctx) {
        var v = this.canvas.viewportTransform;
        ctx.save();
        ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
      },
      /**
       * Sets brush shadow styles
       * @private
       */
      _setShadow: function() {
        if (!this.shadow) {
          return;
        }
        var canvas = this.canvas, shadow = this.shadow, ctx = canvas.contextTop, zoom = canvas.getZoom();
        if (canvas && canvas._isRetinaScaling()) {
          zoom *= fabric2.devicePixelRatio;
        }
        ctx.shadowColor = shadow.color;
        ctx.shadowBlur = shadow.blur * zoom;
        ctx.shadowOffsetX = shadow.offsetX * zoom;
        ctx.shadowOffsetY = shadow.offsetY * zoom;
      },
      needsFullRender: function() {
        var color = new fabric2.Color(this.color);
        return color.getAlpha() < 1 || !!this.shadow;
      },
      /**
       * Removes brush shadow styles
       * @private
       */
      _resetShadow: function() {
        var ctx = this.canvas.contextTop;
        ctx.shadowColor = "";
        ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
      },
      /**
       * Check is pointer is outside canvas boundaries
       * @param {Object} pointer
       * @private
      */
      _isOutSideCanvas: function(pointer) {
        return pointer.x < 0 || pointer.x > this.canvas.getWidth() || pointer.y < 0 || pointer.y > this.canvas.getHeight();
      }
    }
  );
  (function() {
    fabric2.PencilBrush = fabric2.util.createClass(
      fabric2.BaseBrush,
      /** @lends fabric.PencilBrush.prototype */
      {
        /**
         * Discard points that are less than `decimate` pixel distant from each other
         * @type Number
         * @default 0.4
         */
        decimate: 0.4,
        /**
         * Draws a straight line between last recorded point to current pointer
         * Used for `shift` functionality
         *
         * @type boolean
         * @default false
         */
        drawStraightLine: false,
        /**
         * The event modifier key that makes the brush draw a straight line.
         * If `null` or 'none' or any other string that is not a modifier key the feature is disabled.
         * @type {'altKey' | 'shiftKey' | 'ctrlKey' | 'none' | undefined | null}
         */
        straightLineKey: "shiftKey",
        /**
         * Constructor
         * @param {fabric.Canvas} canvas
         * @return {fabric.PencilBrush} Instance of a pencil brush
         */
        initialize: function(canvas) {
          this.canvas = canvas;
          this._points = [];
        },
        needsFullRender: function() {
          return this.callSuper("needsFullRender") || this._hasStraightLine;
        },
        /**
         * Invoked inside on mouse down and mouse move
         * @param {Object} pointer
         */
        _drawSegment: function(ctx, p1, p2) {
          var midPoint = p1.midPointFrom(p2);
          ctx.quadraticCurveTo(p1.x, p1.y, midPoint.x, midPoint.y);
          return midPoint;
        },
        /**
         * Invoked on mouse down
         * @param {Object} pointer
         */
        onMouseDown: function(pointer, options) {
          if (!this.canvas._isMainEvent(options.e)) {
            return;
          }
          this.drawStraightLine = options.e[this.straightLineKey];
          this._prepareForDrawing(pointer);
          this._captureDrawingPath(pointer);
          this._render();
        },
        /**
         * Invoked on mouse move
         * @param {Object} pointer
         */
        onMouseMove: function(pointer, options) {
          if (!this.canvas._isMainEvent(options.e)) {
            return;
          }
          this.drawStraightLine = options.e[this.straightLineKey];
          if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) {
            return;
          }
          if (this._captureDrawingPath(pointer) && this._points.length > 1) {
            if (this.needsFullRender()) {
              this.canvas.clearContext(this.canvas.contextTop);
              this._render();
            } else {
              var points = this._points, length = points.length, ctx = this.canvas.contextTop;
              this._saveAndTransform(ctx);
              if (this.oldEnd) {
                ctx.beginPath();
                ctx.moveTo(this.oldEnd.x, this.oldEnd.y);
              }
              this.oldEnd = this._drawSegment(ctx, points[length - 2], points[length - 1], true);
              ctx.stroke();
              ctx.restore();
            }
          }
        },
        /**
         * Invoked on mouse up
         */
        onMouseUp: function(options) {
          if (!this.canvas._isMainEvent(options.e)) {
            return true;
          }
          this.drawStraightLine = false;
          this.oldEnd = void 0;
          this._finalizeAndAddPath();
          return false;
        },
        /**
         * @private
         * @param {Object} pointer Actual mouse position related to the canvas.
         */
        _prepareForDrawing: function(pointer) {
          var p = new fabric2.Point(pointer.x, pointer.y);
          this._reset();
          this._addPoint(p);
          this.canvas.contextTop.moveTo(p.x, p.y);
        },
        /**
         * @private
         * @param {fabric.Point} point Point to be added to points array
         */
        _addPoint: function(point) {
          if (this._points.length > 1 && point.eq(this._points[this._points.length - 1])) {
            return false;
          }
          if (this.drawStraightLine && this._points.length > 1) {
            this._hasStraightLine = true;
            this._points.pop();
          }
          this._points.push(point);
          return true;
        },
        /**
         * Clear points array and set contextTop canvas style.
         * @private
         */
        _reset: function() {
          this._points = [];
          this._setBrushStyles(this.canvas.contextTop);
          this._setShadow();
          this._hasStraightLine = false;
        },
        /**
         * @private
         * @param {Object} pointer Actual mouse position related to the canvas.
         */
        _captureDrawingPath: function(pointer) {
          var pointerPoint = new fabric2.Point(pointer.x, pointer.y);
          return this._addPoint(pointerPoint);
        },
        /**
         * Draw a smooth path on the topCanvas using quadraticCurveTo
         * @private
         * @param {CanvasRenderingContext2D} [ctx]
         */
        _render: function(ctx) {
          var i, len, p1 = this._points[0], p2 = this._points[1];
          ctx = ctx || this.canvas.contextTop;
          this._saveAndTransform(ctx);
          ctx.beginPath();
          if (this._points.length === 2 && p1.x === p2.x && p1.y === p2.y) {
            var width = this.width / 1e3;
            p1 = new fabric2.Point(p1.x, p1.y);
            p2 = new fabric2.Point(p2.x, p2.y);
            p1.x -= width;
            p2.x += width;
          }
          ctx.moveTo(p1.x, p1.y);
          for (i = 1, len = this._points.length; i < len; i++) {
            this._drawSegment(ctx, p1, p2);
            p1 = this._points[i];
            p2 = this._points[i + 1];
          }
          ctx.lineTo(p1.x, p1.y);
          ctx.stroke();
          ctx.restore();
        },
        /**
         * Converts points to SVG path
         * @param {Array} points Array of points
         * @return {(string|number)[][]} SVG path commands
         */
        convertPointsToSVGPath: function(points) {
          var correction = this.width / 1e3;
          return fabric2.util.getSmoothPathFromPoints(points, correction);
        },
        /**
         * @private
         * @param {(string|number)[][]} pathData SVG path commands
         * @returns {boolean}
         */
        _isEmptySVGPath: function(pathData) {
          var pathString = fabric2.util.joinPath(pathData);
          return pathString === "M 0 0 Q 0 0 0 0 L 0 0";
        },
        /**
         * Creates fabric.Path object to add on canvas
         * @param {(string|number)[][]} pathData Path data
         * @return {fabric.Path} Path to add on canvas
         */
        createPath: function(pathData) {
          var path = new fabric2.Path(pathData, {
            fill: null,
            stroke: this.color,
            strokeWidth: this.width,
            strokeLineCap: this.strokeLineCap,
            strokeMiterLimit: this.strokeMiterLimit,
            strokeLineJoin: this.strokeLineJoin,
            strokeDashArray: this.strokeDashArray
          });
          if (this.shadow) {
            this.shadow.affectStroke = true;
            path.shadow = new fabric2.Shadow(this.shadow);
          }
          return path;
        },
        /**
         * Decimate points array with the decimate value
         */
        decimatePoints: function(points, distance) {
          if (points.length <= 2) {
            return points;
          }
          var zoom = this.canvas.getZoom(), adjustedDistance = Math.pow(distance / zoom, 2), i, l = points.length - 1, lastPoint = points[0], newPoints = [lastPoint], cDistance;
          for (i = 1; i < l - 1; i++) {
            cDistance = Math.pow(lastPoint.x - points[i].x, 2) + Math.pow(lastPoint.y - points[i].y, 2);
            if (cDistance >= adjustedDistance) {
              lastPoint = points[i];
              newPoints.push(lastPoint);
            }
          }
          newPoints.push(points[l]);
          return newPoints;
        },
        /**
         * On mouseup after drawing the path on contextTop canvas
         * we use the points captured to create an new fabric path object
         * and add it to the fabric canvas.
         */
        _finalizeAndAddPath: function() {
          var ctx = this.canvas.contextTop;
          ctx.closePath();
          if (this.decimate) {
            this._points = this.decimatePoints(this._points, this.decimate);
          }
          var pathData = this.convertPointsToSVGPath(this._points);
          if (this._isEmptySVGPath(pathData)) {
            this.canvas.requestRenderAll();
            return;
          }
          var path = this.createPath(pathData);
          this.canvas.clearContext(this.canvas.contextTop);
          this.canvas.fire("before:path:created", { path });
          this.canvas.add(path);
          this.canvas.requestRenderAll();
          path.setCoords();
          this._resetShadow();
          this.canvas.fire("path:created", { path });
        }
      }
    );
  })();
  fabric2.CircleBrush = fabric2.util.createClass(
    fabric2.BaseBrush,
    /** @lends fabric.CircleBrush.prototype */
    {
      /**
       * Width of a brush
       * @type Number
       * @default
       */
      width: 10,
      /**
       * Constructor
       * @param {fabric.Canvas} canvas
       * @return {fabric.CircleBrush} Instance of a circle brush
       */
      initialize: function(canvas) {
        this.canvas = canvas;
        this.points = [];
      },
      /**
       * Invoked inside on mouse down and mouse move
       * @param {Object} pointer
       */
      drawDot: function(pointer) {
        var point = this.addPoint(pointer), ctx = this.canvas.contextTop;
        this._saveAndTransform(ctx);
        this.dot(ctx, point);
        ctx.restore();
      },
      dot: function(ctx, point) {
        ctx.fillStyle = point.fill;
        ctx.beginPath();
        ctx.arc(point.x, point.y, point.radius, 0, Math.PI * 2, false);
        ctx.closePath();
        ctx.fill();
      },
      /**
       * Invoked on mouse down
       */
      onMouseDown: function(pointer) {
        this.points.length = 0;
        this.canvas.clearContext(this.canvas.contextTop);
        this._setShadow();
        this.drawDot(pointer);
      },
      /**
       * Render the full state of the brush
       * @private
       */
      _render: function() {
        var ctx = this.canvas.contextTop, i, len, points = this.points;
        this._saveAndTransform(ctx);
        for (i = 0, len = points.length; i < len; i++) {
          this.dot(ctx, points[i]);
        }
        ctx.restore();
      },
      /**
       * Invoked on mouse move
       * @param {Object} pointer
       */
      onMouseMove: function(pointer) {
        if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) {
          return;
        }
        if (this.needsFullRender()) {
          this.canvas.clearContext(this.canvas.contextTop);
          this.addPoint(pointer);
          this._render();
        } else {
          this.drawDot(pointer);
        }
      },
      /**
       * Invoked on mouse up
       */
      onMouseUp: function() {
        var originalRenderOnAddRemove = this.canvas.renderOnAddRemove, i, len;
        this.canvas.renderOnAddRemove = false;
        var circles = [];
        for (i = 0, len = this.points.length; i < len; i++) {
          var point = this.points[i], circle = new fabric2.Circle({
            radius: point.radius,
            left: point.x,
            top: point.y,
            originX: "center",
            originY: "center",
            fill: point.fill
          });
          this.shadow && (circle.shadow = new fabric2.Shadow(this.shadow));
          circles.push(circle);
        }
        var group = new fabric2.Group(circles);
        group.canvas = this.canvas;
        this.canvas.fire("before:path:created", { path: group });
        this.canvas.add(group);
        this.canvas.fire("path:created", { path: group });
        this.canvas.clearContext(this.canvas.contextTop);
        this._resetShadow();
        this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
        this.canvas.requestRenderAll();
      },
      /**
       * @param {Object} pointer
       * @return {fabric.Point} Just added pointer point
       */
      addPoint: function(pointer) {
        var pointerPoint = new fabric2.Point(pointer.x, pointer.y), circleRadius = fabric2.util.getRandomInt(
          Math.max(0, this.width - 20),
          this.width + 20
        ) / 2, circleColor = new fabric2.Color(this.color).setAlpha(fabric2.util.getRandomInt(0, 100) / 100).toRgba();
        pointerPoint.radius = circleRadius;
        pointerPoint.fill = circleColor;
        this.points.push(pointerPoint);
        return pointerPoint;
      }
    }
  );
  fabric2.SprayBrush = fabric2.util.createClass(
    fabric2.BaseBrush,
    /** @lends fabric.SprayBrush.prototype */
    {
      /**
       * Width of a spray
       * @type Number
       * @default
       */
      width: 10,
      /**
       * Density of a spray (number of dots per chunk)
       * @type Number
       * @default
       */
      density: 20,
      /**
       * Width of spray dots
       * @type Number
       * @default
       */
      dotWidth: 1,
      /**
       * Width variance of spray dots
       * @type Number
       * @default
       */
      dotWidthVariance: 1,
      /**
       * Whether opacity of a dot should be random
       * @type Boolean
       * @default
       */
      randomOpacity: false,
      /**
       * Whether overlapping dots (rectangles) should be removed (for performance reasons)
       * @type Boolean
       * @default
       */
      optimizeOverlapping: true,
      /**
       * Constructor
       * @param {fabric.Canvas} canvas
       * @return {fabric.SprayBrush} Instance of a spray brush
       */
      initialize: function(canvas) {
        this.canvas = canvas;
        this.sprayChunks = [];
      },
      /**
       * Invoked on mouse down
       * @param {Object} pointer
       */
      onMouseDown: function(pointer) {
        this.sprayChunks.length = 0;
        this.canvas.clearContext(this.canvas.contextTop);
        this._setShadow();
        this.addSprayChunk(pointer);
        this.render(this.sprayChunkPoints);
      },
      /**
       * Invoked on mouse move
       * @param {Object} pointer
       */
      onMouseMove: function(pointer) {
        if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) {
          return;
        }
        this.addSprayChunk(pointer);
        this.render(this.sprayChunkPoints);
      },
      /**
       * Invoked on mouse up
       */
      onMouseUp: function() {
        var originalRenderOnAddRemove = this.canvas.renderOnAddRemove;
        this.canvas.renderOnAddRemove = false;
        var rects = [];
        for (var i = 0, ilen = this.sprayChunks.length; i < ilen; i++) {
          var sprayChunk = this.sprayChunks[i];
          for (var j = 0, jlen = sprayChunk.length; j < jlen; j++) {
            var rect = new fabric2.Rect({
              width: sprayChunk[j].width,
              height: sprayChunk[j].width,
              left: sprayChunk[j].x + 1,
              top: sprayChunk[j].y + 1,
              originX: "center",
              originY: "center",
              fill: this.color
            });
            rects.push(rect);
          }
        }
        if (this.optimizeOverlapping) {
          rects = this._getOptimizedRects(rects);
        }
        var group = new fabric2.Group(rects);
        this.shadow && group.set("shadow", new fabric2.Shadow(this.shadow));
        this.canvas.fire("before:path:created", { path: group });
        this.canvas.add(group);
        this.canvas.fire("path:created", { path: group });
        this.canvas.clearContext(this.canvas.contextTop);
        this._resetShadow();
        this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
        this.canvas.requestRenderAll();
      },
      /**
       * @private
       * @param {Array} rects
       */
      _getOptimizedRects: function(rects) {
        var uniqueRects = {}, key, i, len;
        for (i = 0, len = rects.length; i < len; i++) {
          key = rects[i].left + "" + rects[i].top;
          if (!uniqueRects[key]) {
            uniqueRects[key] = rects[i];
          }
        }
        var uniqueRectsArray = [];
        for (key in uniqueRects) {
          uniqueRectsArray.push(uniqueRects[key]);
        }
        return uniqueRectsArray;
      },
      /**
       * Render new chunk of spray brush
       */
      render: function(sprayChunk) {
        var ctx = this.canvas.contextTop, i, len;
        ctx.fillStyle = this.color;
        this._saveAndTransform(ctx);
        for (i = 0, len = sprayChunk.length; i < len; i++) {
          var point = sprayChunk[i];
          if (typeof point.opacity !== "undefined") {
            ctx.globalAlpha = point.opacity;
          }
          ctx.fillRect(point.x, point.y, point.width, point.width);
        }
        ctx.restore();
      },
      /**
       * Render all spray chunks
       */
      _render: function() {
        var ctx = this.canvas.contextTop, i, ilen;
        ctx.fillStyle = this.color;
        this._saveAndTransform(ctx);
        for (i = 0, ilen = this.sprayChunks.length; i < ilen; i++) {
          this.render(this.sprayChunks[i]);
        }
        ctx.restore();
      },
      /**
       * @param {Object} pointer
       */
      addSprayChunk: function(pointer) {
        this.sprayChunkPoints = [];
        var x, y, width, radius = this.width / 2, i;
        for (i = 0; i < this.density; i++) {
          x = fabric2.util.getRandomInt(pointer.x - radius, pointer.x + radius);
          y = fabric2.util.getRandomInt(pointer.y - radius, pointer.y + radius);
          if (this.dotWidthVariance) {
            width = fabric2.util.getRandomInt(
              // bottom clamp width to 1
              Math.max(1, this.dotWidth - this.dotWidthVariance),
              this.dotWidth + this.dotWidthVariance
            );
          } else {
            width = this.dotWidth;
          }
          var point = new fabric2.Point(x, y);
          point.width = width;
          if (this.randomOpacity) {
            point.opacity = fabric2.util.getRandomInt(0, 100) / 100;
          }
          this.sprayChunkPoints.push(point);
        }
        this.sprayChunks.push(this.sprayChunkPoints);
      }
    }
  );
  fabric2.PatternBrush = fabric2.util.createClass(
    fabric2.PencilBrush,
    /** @lends fabric.PatternBrush.prototype */
    {
      getPatternSrc: function() {
        var dotWidth = 20, dotDistance = 5, patternCanvas = fabric2.util.createCanvasElement(), patternCtx = patternCanvas.getContext("2d");
        patternCanvas.width = patternCanvas.height = dotWidth + dotDistance;
        patternCtx.fillStyle = this.color;
        patternCtx.beginPath();
        patternCtx.arc(dotWidth / 2, dotWidth / 2, dotWidth / 2, 0, Math.PI * 2, false);
        patternCtx.closePath();
        patternCtx.fill();
        return patternCanvas;
      },
      getPatternSrcFunction: function() {
        return String(this.getPatternSrc).replace("this.color", '"' + this.color + '"');
      },
      /**
       * Creates "pattern" instance property
       * @param {CanvasRenderingContext2D} ctx
       */
      getPattern: function(ctx) {
        return ctx.createPattern(this.source || this.getPatternSrc(), "repeat");
      },
      /**
       * Sets brush styles
       * @param {CanvasRenderingContext2D} ctx
       */
      _setBrushStyles: function(ctx) {
        this.callSuper("_setBrushStyles", ctx);
        ctx.strokeStyle = this.getPattern(ctx);
      },
      /**
       * Creates path
       */
      createPath: function(pathData) {
        var path = this.callSuper("createPath", pathData), topLeft = path._getLeftTopCoords().scalarAdd(path.strokeWidth / 2);
        path.stroke = new fabric2.Pattern({
          source: this.source || this.getPatternSrcFunction(),
          offsetX: -topLeft.x,
          offsetY: -topLeft.y
        });
        return path;
      }
    }
  );
  (function() {
    var getPointer = fabric2.util.getPointer, degreesToRadians = fabric2.util.degreesToRadians, isTouchEvent = fabric2.util.isTouchEvent;
    fabric2.Canvas = fabric2.util.createClass(
      fabric2.StaticCanvas,
      /** @lends fabric.Canvas.prototype */
      {
        /**
         * Constructor
         * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
         * @param {Object} [options] Options object
         * @return {Object} thisArg
         */
        initialize: function(el, options) {
          options || (options = {});
          this.renderAndResetBound = this.renderAndReset.bind(this);
          this.requestRenderAllBound = this.requestRenderAll.bind(this);
          this._initStatic(el, options);
          this._initInteractive();
          this._createCacheCanvas();
        },
        /**
         * When true, objects can be transformed by one side (unproportionally)
         * when dragged on the corners that normally would not do that.
         * @type Boolean
         * @default
         * @since fabric 4.0 // changed name and default value
         */
        uniformScaling: true,
        /**
         * Indicates which key switches uniform scaling.
         * values: 'altKey', 'shiftKey', 'ctrlKey'.
         * If `null` or 'none' or any other string that is not a modifier key
         * feature is disabled.
         * totally wrong named. this sounds like `uniform scaling`
         * if Canvas.uniformScaling is true, pressing this will set it to false
         * and viceversa.
         * @since 1.6.2
         * @type String
         * @default
         */
        uniScaleKey: "shiftKey",
        /**
         * When true, objects use center point as the origin of scale transformation.
         * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
         * @since 1.3.4
         * @type Boolean
         * @default
         */
        centeredScaling: false,
        /**
         * When true, objects use center point as the origin of rotate transformation.
         * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
         * @since 1.3.4
         * @type Boolean
         * @default
         */
        centeredRotation: false,
        /**
         * Indicates which key enable centered Transform
         * values: 'altKey', 'shiftKey', 'ctrlKey'.
         * If `null` or 'none' or any other string that is not a modifier key
         * feature is disabled feature disabled.
         * @since 1.6.2
         * @type String
         * @default
         */
        centeredKey: "altKey",
        /**
         * Indicates which key enable alternate action on corner
         * values: 'altKey', 'shiftKey', 'ctrlKey'.
         * If `null` or 'none' or any other string that is not a modifier key
         * feature is disabled feature disabled.
         * @since 1.6.2
         * @type String
         * @default
         */
        altActionKey: "shiftKey",
        /**
         * Indicates that canvas is interactive. This property should not be changed.
         * @type Boolean
         * @default
         */
        interactive: true,
        /**
         * Indicates whether group selection should be enabled
         * @type Boolean
         * @default
         */
        selection: true,
        /**
         * Indicates which key or keys enable multiple click selection
         * Pass value as a string or array of strings
         * values: 'altKey', 'shiftKey', 'ctrlKey'.
         * If `null` or empty or containing any other string that is not a modifier key
         * feature is disabled.
         * @since 1.6.2
         * @type String|Array
         * @default
         */
        selectionKey: "shiftKey",
        /**
         * Indicates which key enable alternative selection
         * in case of target overlapping with active object
         * values: 'altKey', 'shiftKey', 'ctrlKey'.
         * For a series of reason that come from the general expectations on how
         * things should work, this feature works only for preserveObjectStacking true.
         * If `null` or 'none' or any other string that is not a modifier key
         * feature is disabled.
         * @since 1.6.5
         * @type null|String
         * @default
         */
        altSelectionKey: null,
        /**
         * Color of selection
         * @type String
         * @default
         */
        selectionColor: "rgba(100, 100, 255, 0.3)",
        // blue
        /**
         * Default dash array pattern
         * If not empty the selection border is dashed
         * @type Array
         */
        selectionDashArray: [],
        /**
         * Color of the border of selection (usually slightly darker than color of selection itself)
         * @type String
         * @default
         */
        selectionBorderColor: "rgba(255, 255, 255, 0.3)",
        /**
         * Width of a line used in object/group selection
         * @type Number
         * @default
         */
        selectionLineWidth: 1,
        /**
         * Select only shapes that are fully contained in the dragged selection rectangle.
         * @type Boolean
         * @default
         */
        selectionFullyContained: false,
        /**
         * Default cursor value used when hovering over an object on canvas
         * @type String
         * @default
         */
        hoverCursor: "move",
        /**
         * Default cursor value used when moving an object on canvas
         * @type String
         * @default
         */
        moveCursor: "move",
        /**
         * Default cursor value used for the entire canvas
         * @type String
         * @default
         */
        defaultCursor: "default",
        /**
         * Cursor value used during free drawing
         * @type String
         * @default
         */
        freeDrawingCursor: "crosshair",
        /**
         * Cursor value used for disabled elements ( corners with disabled action )
         * @type String
         * @since 2.0.0
         * @default
         */
        notAllowedCursor: "not-allowed",
        /**
         * Default element class that's given to wrapper (div) element of canvas
         * @type String
         * @default
         */
        containerClass: "canvas-container",
        /**
         * When true, object detection happens on per-pixel basis rather than on per-bounding-box
         * @type Boolean
         * @default
         */
        perPixelTargetFind: false,
        /**
         * Number of pixels around target pixel to tolerate (consider active) during object detection
         * @type Number
         * @default
         */
        targetFindTolerance: 0,
        /**
         * When true, target detection is skipped. Target detection will return always undefined.
         * click selection won't work anymore, events will fire with no targets.
         * if something is selected before setting it to true, it will be deselected at the first click.
         * area selection will still work. check the `selection` property too.
         * if you deactivate both, you should look into staticCanvas.
         * @type Boolean
         * @default
         */
        skipTargetFind: false,
        /**
         * When true, mouse events on canvas (mousedown/mousemove/mouseup) result in free drawing.
         * After mousedown, mousemove creates a shape,
         * and then mouseup finalizes it and adds an instance of `fabric.Path` onto canvas.
         * @tutorial {@link http://fabricjs.com/fabric-intro-part-4#free_drawing}
         * @type Boolean
         * @default
         */
        isDrawingMode: false,
        /**
         * Indicates whether objects should remain in current stack position when selected.
         * When false objects are brought to top and rendered as part of the selection group
         * @type Boolean
         * @default
         */
        preserveObjectStacking: false,
        /**
         * Indicates the angle that an object will lock to while rotating.
         * @type Number
         * @since 1.6.7
         * @default
         */
        snapAngle: 0,
        /**
         * Indicates the distance from the snapAngle the rotation will lock to the snapAngle.
         * When `null`, the snapThreshold will default to the snapAngle.
         * @type null|Number
         * @since 1.6.7
         * @default
         */
        snapThreshold: null,
        /**
         * Indicates if the right click on canvas can output the context menu or not
         * @type Boolean
         * @since 1.6.5
         * @default
         */
        stopContextMenu: false,
        /**
         * Indicates if the canvas can fire right click events
         * @type Boolean
         * @since 1.6.5
         * @default
         */
        fireRightClick: false,
        /**
         * Indicates if the canvas can fire middle click events
         * @type Boolean
         * @since 1.7.8
         * @default
         */
        fireMiddleClick: false,
        /**
         * Keep track of the subTargets for Mouse Events
         * @type fabric.Object[]
         */
        targets: [],
        /**
         * When the option is enabled, PointerEvent is used instead of MouseEvent.
         * @type Boolean
         * @default
         */
        enablePointerEvents: false,
        /**
         * Keep track of the hovered target
         * @type fabric.Object
         * @private
         */
        _hoveredTarget: null,
        /**
         * hold the list of nested targets hovered
         * @type fabric.Object[]
         * @private
         */
        _hoveredTargets: [],
        /**
         * @private
         */
        _initInteractive: function() {
          this._currentTransform = null;
          this._groupSelector = null;
          this._initWrapperElement();
          this._createUpperCanvas();
          this._initEventListeners();
          this._initRetinaScaling();
          this.freeDrawingBrush = fabric2.PencilBrush && new fabric2.PencilBrush(this);
          this.calcOffset();
        },
        /**
         * Divides objects in two groups, one to render immediately
         * and one to render as activeGroup.
         * @return {Array} objects to render immediately and pushes the other in the activeGroup.
         */
        _chooseObjectsToRender: function() {
          var activeObjects = this.getActiveObjects(), object, objsToRender, activeGroupObjects;
          if (activeObjects.length > 0 && !this.preserveObjectStacking) {
            objsToRender = [];
            activeGroupObjects = [];
            for (var i = 0, length = this._objects.length; i < length; i++) {
              object = this._objects[i];
              if (activeObjects.indexOf(object) === -1) {
                objsToRender.push(object);
              } else {
                activeGroupObjects.push(object);
              }
            }
            if (activeObjects.length > 1) {
              this._activeObject._objects = activeGroupObjects;
            }
            objsToRender.push.apply(objsToRender, activeGroupObjects);
          } else {
            objsToRender = this._objects;
          }
          return objsToRender;
        },
        /**
         * Renders both the top canvas and the secondary container canvas.
         * @return {fabric.Canvas} instance
         * @chainable
         */
        renderAll: function() {
          if (this.contextTopDirty && !this._groupSelector && !this.isDrawingMode) {
            this.clearContext(this.contextTop);
            this.contextTopDirty = false;
          }
          if (this.hasLostContext) {
            this.renderTopLayer(this.contextTop);
            this.hasLostContext = false;
          }
          var canvasToDrawOn = this.contextContainer;
          this.renderCanvas(canvasToDrawOn, this._chooseObjectsToRender());
          return this;
        },
        renderTopLayer: function(ctx) {
          ctx.save();
          if (this.isDrawingMode && this._isCurrentlyDrawing) {
            this.freeDrawingBrush && this.freeDrawingBrush._render();
            this.contextTopDirty = true;
          }
          if (this.selection && this._groupSelector) {
            this._drawSelection(ctx);
            this.contextTopDirty = true;
          }
          ctx.restore();
        },
        /**
         * Method to render only the top canvas.
         * Also used to render the group selection box.
         * @return {fabric.Canvas} thisArg
         * @chainable
         */
        renderTop: function() {
          var ctx = this.contextTop;
          this.clearContext(ctx);
          this.renderTopLayer(ctx);
          this.fire("after:render");
          return this;
        },
        /**
         * @private
         */
        _normalizePointer: function(object, pointer) {
          var m = object.calcTransformMatrix(), invertedM = fabric2.util.invertTransform(m), vptPointer = this.restorePointerVpt(pointer);
          return fabric2.util.transformPoint(vptPointer, invertedM);
        },
        /**
         * Returns true if object is transparent at a certain location
         * @param {fabric.Object} target Object to check
         * @param {Number} x Left coordinate
         * @param {Number} y Top coordinate
         * @return {Boolean}
         */
        isTargetTransparent: function(target, x, y) {
          if (target.shouldCache() && target._cacheCanvas && target !== this._activeObject) {
            var normalizedPointer = this._normalizePointer(target, { x, y }), targetRelativeX = Math.max(target.cacheTranslationX + normalizedPointer.x * target.zoomX, 0), targetRelativeY = Math.max(target.cacheTranslationY + normalizedPointer.y * target.zoomY, 0);
            var isTransparent = fabric2.util.isTransparent(
              target._cacheContext,
              Math.round(targetRelativeX),
              Math.round(targetRelativeY),
              this.targetFindTolerance
            );
            return isTransparent;
          }
          var ctx = this.contextCache, originalColor = target.selectionBackgroundColor, v = this.viewportTransform;
          target.selectionBackgroundColor = "";
          this.clearContext(ctx);
          ctx.save();
          ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
          target.render(ctx);
          ctx.restore();
          target.selectionBackgroundColor = originalColor;
          var isTransparent = fabric2.util.isTransparent(
            ctx,
            x,
            y,
            this.targetFindTolerance
          );
          return isTransparent;
        },
        /**
         * takes an event and determines if selection key has been pressed
         * @private
         * @param {Event} e Event object
         */
        _isSelectionKeyPressed: function(e) {
          var selectionKeyPressed = false;
          if (Array.isArray(this.selectionKey)) {
            selectionKeyPressed = !!this.selectionKey.find(function(key) {
              return e[key] === true;
            });
          } else {
            selectionKeyPressed = e[this.selectionKey];
          }
          return selectionKeyPressed;
        },
        /**
         * @private
         * @param {Event} e Event object
         * @param {fabric.Object} target
         */
        _shouldClearSelection: function(e, target) {
          var activeObjects = this.getActiveObjects(), activeObject = this._activeObject;
          return !target || target && activeObject && activeObjects.length > 1 && activeObjects.indexOf(target) === -1 && activeObject !== target && !this._isSelectionKeyPressed(e) || target && !target.evented || target && !target.selectable && activeObject && activeObject !== target;
        },
        /**
         * centeredScaling from object can't override centeredScaling from canvas.
         * this should be fixed, since object setting should take precedence over canvas.
         * also this should be something that will be migrated in the control properties.
         * as ability to define the origin of the transformation that the control provide.
         * @private
         * @param {fabric.Object} target
         * @param {String} action
         * @param {Boolean} altKey
         */
        _shouldCenterTransform: function(target, action, altKey) {
          if (!target) {
            return;
          }
          var centerTransform;
          if (action === "scale" || action === "scaleX" || action === "scaleY" || action === "resizing") {
            centerTransform = this.centeredScaling || target.centeredScaling;
          } else if (action === "rotate") {
            centerTransform = this.centeredRotation || target.centeredRotation;
          }
          return centerTransform ? !altKey : altKey;
        },
        /**
         * should disappear before release 4.0
         * @private
         */
        _getOriginFromCorner: function(target, corner) {
          var origin = {
            x: target.originX,
            y: target.originY
          };
          if (corner === "ml" || corner === "tl" || corner === "bl") {
            origin.x = "right";
          } else if (corner === "mr" || corner === "tr" || corner === "br") {
            origin.x = "left";
          }
          if (corner === "tl" || corner === "mt" || corner === "tr") {
            origin.y = "bottom";
          } else if (corner === "bl" || corner === "mb" || corner === "br") {
            origin.y = "top";
          }
          return origin;
        },
        /**
         * @private
         * @param {Boolean} alreadySelected true if target is already selected
         * @param {String} corner a string representing the corner ml, mr, tl ...
         * @param {Event} e Event object
         * @param {fabric.Object} [target] inserted back to help overriding. Unused
         */
        _getActionFromCorner: function(alreadySelected, corner, e, target) {
          if (!corner || !alreadySelected) {
            return "drag";
          }
          var control = target.controls[corner];
          return control.getActionName(e, control, target);
        },
        /**
         * @private
         * @param {Event} e Event object
         * @param {fabric.Object} target
         */
        _setupCurrentTransform: function(e, target, alreadySelected) {
          if (!target) {
            return;
          }
          var pointer = this.getPointer(e), corner = target.__corner, control = target.controls[corner], actionHandler = alreadySelected && corner ? control.getActionHandler(e, target, control) : fabric2.controlsUtils.dragHandler, action = this._getActionFromCorner(alreadySelected, corner, e, target), origin = this._getOriginFromCorner(target, corner), altKey = e[this.centeredKey], transform = {
            target,
            action,
            actionHandler,
            corner,
            scaleX: target.scaleX,
            scaleY: target.scaleY,
            skewX: target.skewX,
            skewY: target.skewY,
            // used by transation
            offsetX: pointer.x - target.left,
            offsetY: pointer.y - target.top,
            originX: origin.x,
            originY: origin.y,
            ex: pointer.x,
            ey: pointer.y,
            lastX: pointer.x,
            lastY: pointer.y,
            // unsure they are useful anymore.
            // left: target.left,
            // top: target.top,
            theta: degreesToRadians(target.angle),
            // end of unsure
            width: target.width * target.scaleX,
            shiftKey: e.shiftKey,
            altKey,
            original: fabric2.util.saveObjectTransform(target)
          };
          if (this._shouldCenterTransform(target, action, altKey)) {
            transform.originX = "center";
            transform.originY = "center";
          }
          transform.original.originX = origin.x;
          transform.original.originY = origin.y;
          this._currentTransform = transform;
          this._beforeTransform(e);
        },
        /**
         * Set the cursor type of the canvas element
         * @param {String} value Cursor type of the canvas element.
         * @see http://www.w3.org/TR/css3-ui/#cursor
         */
        setCursor: function(value) {
          this.upperCanvasEl.style.cursor = value;
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx to draw the selection on
         */
        _drawSelection: function(ctx) {
          var selector = this._groupSelector, viewportStart = new fabric2.Point(selector.ex, selector.ey), start = fabric2.util.transformPoint(viewportStart, this.viewportTransform), viewportExtent = new fabric2.Point(selector.ex + selector.left, selector.ey + selector.top), extent = fabric2.util.transformPoint(viewportExtent, this.viewportTransform), minX = Math.min(start.x, extent.x), minY = Math.min(start.y, extent.y), maxX = Math.max(start.x, extent.x), maxY = Math.max(start.y, extent.y), strokeOffset = this.selectionLineWidth / 2;
          if (this.selectionColor) {
            ctx.fillStyle = this.selectionColor;
            ctx.fillRect(minX, minY, maxX - minX, maxY - minY);
          }
          if (!this.selectionLineWidth || !this.selectionBorderColor) {
            return;
          }
          ctx.lineWidth = this.selectionLineWidth;
          ctx.strokeStyle = this.selectionBorderColor;
          minX += strokeOffset;
          minY += strokeOffset;
          maxX -= strokeOffset;
          maxY -= strokeOffset;
          fabric2.Object.prototype._setLineDash.call(this, ctx, this.selectionDashArray);
          ctx.strokeRect(minX, minY, maxX - minX, maxY - minY);
        },
        /**
         * Method that determines what object we are clicking on
         * the skipGroup parameter is for internal use, is needed for shift+click action
         * 11/09/2018 TODO: would be cool if findTarget could discern between being a full target
         * or the outside part of the corner.
         * @param {Event} e mouse event
         * @param {Boolean} skipGroup when true, activeGroup is skipped and only objects are traversed through
         * @return {fabric.Object} the target found
         */
        findTarget: function(e, skipGroup) {
          if (this.skipTargetFind) {
            return;
          }
          var ignoreZoom = true, pointer = this.getPointer(e, ignoreZoom), activeObject = this._activeObject, aObjects = this.getActiveObjects(), activeTarget, activeTargetSubs, isTouch = isTouchEvent(e), shouldLookForActive = aObjects.length > 1 && !skipGroup || aObjects.length === 1;
          this.targets = [];
          if (shouldLookForActive && activeObject._findTargetCorner(pointer, isTouch)) {
            return activeObject;
          }
          if (aObjects.length > 1 && !skipGroup && activeObject === this._searchPossibleTargets([activeObject], pointer)) {
            return activeObject;
          }
          if (aObjects.length === 1 && activeObject === this._searchPossibleTargets([activeObject], pointer)) {
            if (!this.preserveObjectStacking) {
              return activeObject;
            } else {
              activeTarget = activeObject;
              activeTargetSubs = this.targets;
              this.targets = [];
            }
          }
          var target = this._searchPossibleTargets(this._objects, pointer);
          if (e[this.altSelectionKey] && target && activeTarget && target !== activeTarget) {
            target = activeTarget;
            this.targets = activeTargetSubs;
          }
          return target;
        },
        /**
         * Checks point is inside the object.
         * @param {Object} [pointer] x,y object of point coordinates we want to check.
         * @param {fabric.Object} obj Object to test against
         * @param {Object} [globalPointer] x,y object of point coordinates relative to canvas used to search per pixel target.
         * @return {Boolean} true if point is contained within an area of given object
         * @private
         */
        _checkTarget: function(pointer, obj, globalPointer) {
          if (obj && obj.visible && obj.evented && // http://www.geog.ubc.ca/courses/klink/gis.notes/ncgia/u32.html
          // http://idav.ucdavis.edu/~okreylos/TAship/Spring2000/PointInPolygon.html
          obj.containsPoint(pointer)) {
            if ((this.perPixelTargetFind || obj.perPixelTargetFind) && !obj.isEditing) {
              var isTransparent = this.isTargetTransparent(obj, globalPointer.x, globalPointer.y);
              if (!isTransparent) {
                return true;
              }
            } else {
              return true;
            }
          }
        },
        /**
         * Function used to search inside objects an object that contains pointer in bounding box or that contains pointerOnCanvas when painted
         * @param {Array} [objects] objects array to look into
         * @param {Object} [pointer] x,y object of point coordinates we want to check.
         * @return {fabric.Object} object that contains pointer
         * @private
         */
        _searchPossibleTargets: function(objects, pointer) {
          var target, i = objects.length, subTarget;
          while (i--) {
            var objToCheck = objects[i];
            var pointerToUse = objToCheck.group ? this._normalizePointer(objToCheck.group, pointer) : pointer;
            if (this._checkTarget(pointerToUse, objToCheck, pointer)) {
              target = objects[i];
              if (target.subTargetCheck && target instanceof fabric2.Group) {
                subTarget = this._searchPossibleTargets(target._objects, pointer);
                subTarget && this.targets.push(subTarget);
              }
              break;
            }
          }
          return target;
        },
        /**
         * Returns pointer coordinates without the effect of the viewport
         * @param {Object} pointer with "x" and "y" number values
         * @return {Object} object with "x" and "y" number values
         */
        restorePointerVpt: function(pointer) {
          return fabric2.util.transformPoint(
            pointer,
            fabric2.util.invertTransform(this.viewportTransform)
          );
        },
        /**
         * Returns pointer coordinates relative to canvas.
         * Can return coordinates with or without viewportTransform.
         * ignoreZoom false gives back coordinates that represent
         * the point clicked on canvas element.
         * ignoreZoom true gives back coordinates after being processed
         * by the viewportTransform ( sort of coordinates of what is displayed
         * on the canvas where you are clicking.
         * ignoreZoom true = HTMLElement coordinates relative to top,left
         * ignoreZoom false, default = fabric space coordinates, the same used for shape position
         * To interact with your shapes top and left you want to use ignoreZoom true
         * most of the time, while ignoreZoom false will give you coordinates
         * compatible with the object.oCoords system.
         * of the time.
         * @param {Event} e
         * @param {Boolean} ignoreZoom
         * @return {Object} object with "x" and "y" number values
         */
        getPointer: function(e, ignoreZoom) {
          if (this._absolutePointer && !ignoreZoom) {
            return this._absolutePointer;
          }
          if (this._pointer && ignoreZoom) {
            return this._pointer;
          }
          var pointer = getPointer(e), upperCanvasEl = this.upperCanvasEl, bounds = upperCanvasEl.getBoundingClientRect(), boundsWidth = bounds.width || 0, boundsHeight = bounds.height || 0, cssScale;
          if (!boundsWidth || !boundsHeight) {
            if ("top" in bounds && "bottom" in bounds) {
              boundsHeight = Math.abs(bounds.top - bounds.bottom);
            }
            if ("right" in bounds && "left" in bounds) {
              boundsWidth = Math.abs(bounds.right - bounds.left);
            }
          }
          this.calcOffset();
          pointer.x = pointer.x - this._offset.left;
          pointer.y = pointer.y - this._offset.top;
          if (!ignoreZoom) {
            pointer = this.restorePointerVpt(pointer);
          }
          var retinaScaling = this.getRetinaScaling();
          if (retinaScaling !== 1) {
            pointer.x /= retinaScaling;
            pointer.y /= retinaScaling;
          }
          if (boundsWidth === 0 || boundsHeight === 0) {
            cssScale = { width: 1, height: 1 };
          } else {
            cssScale = {
              width: upperCanvasEl.width / boundsWidth,
              height: upperCanvasEl.height / boundsHeight
            };
          }
          return {
            x: pointer.x * cssScale.width,
            y: pointer.y * cssScale.height
          };
        },
        /**
         * @private
         * @throws {CANVAS_INIT_ERROR} If canvas can not be initialized
         */
        _createUpperCanvas: function() {
          var lowerCanvasClass = this.lowerCanvasEl.className.replace(/\s*lower-canvas\s*/, ""), lowerCanvasEl = this.lowerCanvasEl, upperCanvasEl = this.upperCanvasEl;
          if (upperCanvasEl) {
            upperCanvasEl.className = "";
          } else {
            upperCanvasEl = this._createCanvasElement();
            this.upperCanvasEl = upperCanvasEl;
          }
          fabric2.util.addClass(upperCanvasEl, "upper-canvas " + lowerCanvasClass);
          this.wrapperEl.appendChild(upperCanvasEl);
          this._copyCanvasStyle(lowerCanvasEl, upperCanvasEl);
          this._applyCanvasStyle(upperCanvasEl);
          this.contextTop = upperCanvasEl.getContext("2d");
        },
        /**
         * Returns context of top canvas where interactions are drawn
         * @returns {CanvasRenderingContext2D}
         */
        getTopContext: function() {
          return this.contextTop;
        },
        /**
         * @private
         */
        _createCacheCanvas: function() {
          this.cacheCanvasEl = this._createCanvasElement();
          this.cacheCanvasEl.setAttribute("width", this.width);
          this.cacheCanvasEl.setAttribute("height", this.height);
          this.contextCache = this.cacheCanvasEl.getContext("2d");
        },
        /**
         * @private
         */
        _initWrapperElement: function() {
          this.wrapperEl = fabric2.util.wrapElement(this.lowerCanvasEl, "div", {
            "class": this.containerClass
          });
          fabric2.util.setStyle(this.wrapperEl, {
            width: this.width + "px",
            height: this.height + "px",
            position: "relative"
          });
          fabric2.util.makeElementUnselectable(this.wrapperEl);
        },
        /**
         * @private
         * @param {HTMLElement} element canvas element to apply styles on
         */
        _applyCanvasStyle: function(element) {
          var width = this.width || element.width, height = this.height || element.height;
          fabric2.util.setStyle(element, {
            position: "absolute",
            width: width + "px",
            height: height + "px",
            left: 0,
            top: 0,
            "touch-action": this.allowTouchScrolling ? "manipulation" : "none",
            "-ms-touch-action": this.allowTouchScrolling ? "manipulation" : "none"
          });
          element.width = width;
          element.height = height;
          fabric2.util.makeElementUnselectable(element);
        },
        /**
         * Copy the entire inline style from one element (fromEl) to another (toEl)
         * @private
         * @param {Element} fromEl Element style is copied from
         * @param {Element} toEl Element copied style is applied to
         */
        _copyCanvasStyle: function(fromEl, toEl) {
          toEl.style.cssText = fromEl.style.cssText;
        },
        /**
         * Returns context of canvas where object selection is drawn
         * @return {CanvasRenderingContext2D}
         */
        getSelectionContext: function() {
          return this.contextTop;
        },
        /**
         * Returns &lt;canvas> element on which object selection is drawn
         * @return {HTMLCanvasElement}
         */
        getSelectionElement: function() {
          return this.upperCanvasEl;
        },
        /**
         * Returns currently active object
         * @return {fabric.Object} active object
         */
        getActiveObject: function() {
          return this._activeObject;
        },
        /**
         * Returns an array with the current selected objects
         * @return {fabric.Object} active object
         */
        getActiveObjects: function() {
          var active = this._activeObject;
          if (active) {
            if (active.type === "activeSelection" && active._objects) {
              return active._objects.slice(0);
            } else {
              return [active];
            }
          }
          return [];
        },
        /**
         * @private
         * @param {fabric.Object} obj Object that was removed
         */
        _onObjectRemoved: function(obj) {
          if (obj === this._activeObject) {
            this.fire("before:selection:cleared", { target: obj });
            this._discardActiveObject();
            this.fire("selection:cleared", { target: obj });
            obj.fire("deselected");
          }
          if (obj === this._hoveredTarget) {
            this._hoveredTarget = null;
            this._hoveredTargets = [];
          }
          this.callSuper("_onObjectRemoved", obj);
        },
        /**
         * @private
         * Compares the old activeObject with the current one and fires correct events
         * @param {fabric.Object} obj old activeObject
         */
        _fireSelectionEvents: function(oldObjects, e) {
          var somethingChanged = false, objects = this.getActiveObjects(), added = [], removed = [];
          oldObjects.forEach(function(oldObject) {
            if (objects.indexOf(oldObject) === -1) {
              somethingChanged = true;
              oldObject.fire("deselected", {
                e,
                target: oldObject
              });
              removed.push(oldObject);
            }
          });
          objects.forEach(function(object) {
            if (oldObjects.indexOf(object) === -1) {
              somethingChanged = true;
              object.fire("selected", {
                e,
                target: object
              });
              added.push(object);
            }
          });
          if (oldObjects.length > 0 && objects.length > 0) {
            somethingChanged && this.fire("selection:updated", {
              e,
              selected: added,
              deselected: removed
            });
          } else if (objects.length > 0) {
            this.fire("selection:created", {
              e,
              selected: added
            });
          } else if (oldObjects.length > 0) {
            this.fire("selection:cleared", {
              e,
              deselected: removed
            });
          }
        },
        /**
         * Sets given object as the only active object on canvas
         * @param {fabric.Object} object Object to set as an active one
         * @param {Event} [e] Event (passed along when firing "object:selected")
         * @return {fabric.Canvas} thisArg
         * @chainable
         */
        setActiveObject: function(object, e) {
          var currentActives = this.getActiveObjects();
          this._setActiveObject(object, e);
          this._fireSelectionEvents(currentActives, e);
          return this;
        },
        /**
         * This is a private method for now.
         * This is supposed to be equivalent to setActiveObject but without firing
         * any event. There is commitment to have this stay this way.
         * This is the functional part of setActiveObject.
         * @private
         * @param {Object} object to set as active
         * @param {Event} [e] Event (passed along when firing "object:selected")
         * @return {Boolean} true if the selection happened
         */
        _setActiveObject: function(object, e) {
          if (this._activeObject === object) {
            return false;
          }
          if (!this._discardActiveObject(e, object)) {
            return false;
          }
          if (object.onSelect({ e })) {
            return false;
          }
          this._activeObject = object;
          return true;
        },
        /**
         * This is a private method for now.
         * This is supposed to be equivalent to discardActiveObject but without firing
         * any events. There is commitment to have this stay this way.
         * This is the functional part of discardActiveObject.
         * @param {Event} [e] Event (passed along when firing "object:deselected")
         * @param {Object} object to set as active
         * @return {Boolean} true if the selection happened
         * @private
         */
        _discardActiveObject: function(e, object) {
          var obj = this._activeObject;
          if (obj) {
            if (obj.onDeselect({ e, object })) {
              return false;
            }
            this._activeObject = null;
          }
          return true;
        },
        /**
         * Discards currently active object and fire events. If the function is called by fabric
         * as a consequence of a mouse event, the event is passed as a parameter and
         * sent to the fire function for the custom events. When used as a method the
         * e param does not have any application.
         * @param {event} e
         * @return {fabric.Canvas} thisArg
         * @chainable
         */
        discardActiveObject: function(e) {
          var currentActives = this.getActiveObjects(), activeObject = this.getActiveObject();
          if (currentActives.length) {
            this.fire("before:selection:cleared", { target: activeObject, e });
          }
          this._discardActiveObject(e);
          this._fireSelectionEvents(currentActives, e);
          return this;
        },
        /**
         * Clears a canvas element and removes all event listeners
         * @return {fabric.Canvas} thisArg
         * @chainable
         */
        dispose: function() {
          var wrapper = this.wrapperEl;
          this.removeListeners();
          wrapper.removeChild(this.upperCanvasEl);
          wrapper.removeChild(this.lowerCanvasEl);
          this.contextCache = null;
          this.contextTop = null;
          ["upperCanvasEl", "cacheCanvasEl"].forEach((function(element) {
            fabric2.util.cleanUpJsdomNode(this[element]);
            this[element] = void 0;
          }).bind(this));
          if (wrapper.parentNode) {
            wrapper.parentNode.replaceChild(this.lowerCanvasEl, this.wrapperEl);
          }
          delete this.wrapperEl;
          fabric2.StaticCanvas.prototype.dispose.call(this);
          return this;
        },
        /**
         * Clears all contexts (background, main, top) of an instance
         * @return {fabric.Canvas} thisArg
         * @chainable
         */
        clear: function() {
          this.discardActiveObject();
          this.clearContext(this.contextTop);
          return this.callSuper("clear");
        },
        /**
         * Draws objects' controls (borders/controls)
         * @param {CanvasRenderingContext2D} ctx Context to render controls on
         */
        drawControls: function(ctx) {
          var activeObject = this._activeObject;
          if (activeObject) {
            activeObject._renderControls(ctx);
          }
        },
        /**
         * @private
         */
        _toObject: function(instance, methodName, propertiesToInclude) {
          var originalProperties = this._realizeGroupTransformOnObject(instance), object = this.callSuper("_toObject", instance, methodName, propertiesToInclude);
          this._unwindGroupTransformOnObject(instance, originalProperties);
          return object;
        },
        /**
         * Realises an object's group transformation on it
         * @private
         * @param {fabric.Object} [instance] the object to transform (gets mutated)
         * @returns the original values of instance which were changed
         */
        _realizeGroupTransformOnObject: function(instance) {
          if (instance.group && instance.group.type === "activeSelection" && this._activeObject === instance.group) {
            var layoutProps = ["angle", "flipX", "flipY", "left", "scaleX", "scaleY", "skewX", "skewY", "top"];
            var originalValues = {};
            layoutProps.forEach(function(prop2) {
              originalValues[prop2] = instance[prop2];
            });
            fabric2.util.addTransformToObject(instance, this._activeObject.calcOwnMatrix());
            return originalValues;
          } else {
            return null;
          }
        },
        /**
         * Restores the changed properties of instance
         * @private
         * @param {fabric.Object} [instance] the object to un-transform (gets mutated)
         * @param {Object} [originalValues] the original values of instance, as returned by _realizeGroupTransformOnObject
         */
        _unwindGroupTransformOnObject: function(instance, originalValues) {
          if (originalValues) {
            instance.set(originalValues);
          }
        },
        /**
         * @private
         */
        _setSVGObject: function(markup, instance, reviver) {
          var originalProperties = this._realizeGroupTransformOnObject(instance);
          this.callSuper("_setSVGObject", markup, instance, reviver);
          this._unwindGroupTransformOnObject(instance, originalProperties);
        },
        setViewportTransform: function(vpt) {
          if (this.renderOnAddRemove && this._activeObject && this._activeObject.isEditing) {
            this._activeObject.clearContextTop();
          }
          fabric2.StaticCanvas.prototype.setViewportTransform.call(this, vpt);
        }
      }
    );
    for (var prop in fabric2.StaticCanvas) {
      if (prop !== "prototype") {
        fabric2.Canvas[prop] = fabric2.StaticCanvas[prop];
      }
    }
  })();
  (function() {
    var addListener2 = fabric2.util.addListener, removeListener2 = fabric2.util.removeListener, RIGHT_CLICK = 3, MIDDLE_CLICK = 2, LEFT_CLICK = 1, addEventOptions = { passive: false };
    function checkClick(e, value) {
      return e.button && e.button === value - 1;
    }
    fabric2.util.object.extend(
      fabric2.Canvas.prototype,
      /** @lends fabric.Canvas.prototype */
      {
        /**
         * Contains the id of the touch event that owns the fabric transform
         * @type Number
         * @private
         */
        mainTouchId: null,
        /**
         * Adds mouse listeners to canvas
         * @private
         */
        _initEventListeners: function() {
          this.removeListeners();
          this._bindEvents();
          this.addOrRemove(addListener2, "add");
        },
        /**
         * return an event prefix pointer or mouse.
         * @private
         */
        _getEventPrefix: function() {
          return this.enablePointerEvents ? "pointer" : "mouse";
        },
        addOrRemove: function(functor, eventjsFunctor) {
          var canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
          functor(fabric2.window, "resize", this._onResize);
          functor(canvasElement, eventTypePrefix + "down", this._onMouseDown);
          functor(canvasElement, eventTypePrefix + "move", this._onMouseMove, addEventOptions);
          functor(canvasElement, eventTypePrefix + "out", this._onMouseOut);
          functor(canvasElement, eventTypePrefix + "enter", this._onMouseEnter);
          functor(canvasElement, "wheel", this._onMouseWheel);
          functor(canvasElement, "contextmenu", this._onContextMenu);
          functor(canvasElement, "dblclick", this._onDoubleClick);
          functor(canvasElement, "dragover", this._onDragOver);
          functor(canvasElement, "dragenter", this._onDragEnter);
          functor(canvasElement, "dragleave", this._onDragLeave);
          functor(canvasElement, "drop", this._onDrop);
          if (!this.enablePointerEvents) {
            functor(canvasElement, "touchstart", this._onTouchStart, addEventOptions);
          }
          if (typeof eventjs !== "undefined" && eventjsFunctor in eventjs) {
            eventjs[eventjsFunctor](canvasElement, "gesture", this._onGesture);
            eventjs[eventjsFunctor](canvasElement, "drag", this._onDrag);
            eventjs[eventjsFunctor](canvasElement, "orientation", this._onOrientationChange);
            eventjs[eventjsFunctor](canvasElement, "shake", this._onShake);
            eventjs[eventjsFunctor](canvasElement, "longpress", this._onLongPress);
          }
        },
        /**
         * Removes all event listeners
         */
        removeListeners: function() {
          this.addOrRemove(removeListener2, "remove");
          var eventTypePrefix = this._getEventPrefix();
          removeListener2(fabric2.document, eventTypePrefix + "up", this._onMouseUp);
          removeListener2(fabric2.document, "touchend", this._onTouchEnd, addEventOptions);
          removeListener2(fabric2.document, eventTypePrefix + "move", this._onMouseMove, addEventOptions);
          removeListener2(fabric2.document, "touchmove", this._onMouseMove, addEventOptions);
        },
        /**
         * @private
         */
        _bindEvents: function() {
          if (this.eventsBound) {
            return;
          }
          this._onMouseDown = this._onMouseDown.bind(this);
          this._onTouchStart = this._onTouchStart.bind(this);
          this._onMouseMove = this._onMouseMove.bind(this);
          this._onMouseUp = this._onMouseUp.bind(this);
          this._onTouchEnd = this._onTouchEnd.bind(this);
          this._onResize = this._onResize.bind(this);
          this._onGesture = this._onGesture.bind(this);
          this._onDrag = this._onDrag.bind(this);
          this._onShake = this._onShake.bind(this);
          this._onLongPress = this._onLongPress.bind(this);
          this._onOrientationChange = this._onOrientationChange.bind(this);
          this._onMouseWheel = this._onMouseWheel.bind(this);
          this._onMouseOut = this._onMouseOut.bind(this);
          this._onMouseEnter = this._onMouseEnter.bind(this);
          this._onContextMenu = this._onContextMenu.bind(this);
          this._onDoubleClick = this._onDoubleClick.bind(this);
          this._onDragOver = this._onDragOver.bind(this);
          this._onDragEnter = this._simpleEventHandler.bind(this, "dragenter");
          this._onDragLeave = this._simpleEventHandler.bind(this, "dragleave");
          this._onDrop = this._onDrop.bind(this);
          this.eventsBound = true;
        },
        /**
         * @private
         * @param {Event} [e] Event object fired on Event.js gesture
         * @param {Event} [self] Inner Event object
         */
        _onGesture: function(e, self2) {
          this.__onTransformGesture && this.__onTransformGesture(e, self2);
        },
        /**
         * @private
         * @param {Event} [e] Event object fired on Event.js drag
         * @param {Event} [self] Inner Event object
         */
        _onDrag: function(e, self2) {
          this.__onDrag && this.__onDrag(e, self2);
        },
        /**
         * @private
         * @param {Event} [e] Event object fired on wheel event
         */
        _onMouseWheel: function(e) {
          this.__onMouseWheel(e);
        },
        /**
         * @private
         * @param {Event} e Event object fired on mousedown
         */
        _onMouseOut: function(e) {
          var target = this._hoveredTarget;
          this.fire("mouse:out", { target, e });
          this._hoveredTarget = null;
          target && target.fire("mouseout", { e });
          var _this = this;
          this._hoveredTargets.forEach(function(_target) {
            _this.fire("mouse:out", { target, e });
            _target && target.fire("mouseout", { e });
          });
          this._hoveredTargets = [];
        },
        /**
         * @private
         * @param {Event} e Event object fired on mouseenter
         */
        _onMouseEnter: function(e) {
          if (!this._currentTransform && !this.findTarget(e)) {
            this.fire("mouse:over", { target: null, e });
            this._hoveredTarget = null;
            this._hoveredTargets = [];
          }
        },
        /**
         * @private
         * @param {Event} [e] Event object fired on Event.js orientation change
         * @param {Event} [self] Inner Event object
         */
        _onOrientationChange: function(e, self2) {
          this.__onOrientationChange && this.__onOrientationChange(e, self2);
        },
        /**
         * @private
         * @param {Event} [e] Event object fired on Event.js shake
         * @param {Event} [self] Inner Event object
         */
        _onShake: function(e, self2) {
          this.__onShake && this.__onShake(e, self2);
        },
        /**
         * @private
         * @param {Event} [e] Event object fired on Event.js shake
         * @param {Event} [self] Inner Event object
         */
        _onLongPress: function(e, self2) {
          this.__onLongPress && this.__onLongPress(e, self2);
        },
        /**
         * prevent default to allow drop event to be fired
         * @private
         * @param {Event} [e] Event object fired on Event.js shake
         */
        _onDragOver: function(e) {
          e.preventDefault();
          var target = this._simpleEventHandler("dragover", e);
          this._fireEnterLeaveEvents(target, e);
        },
        /**
         * `drop:before` is a an event that allow you to schedule logic
         * before the `drop` event. Prefer `drop` event always, but if you need
         * to run some drop-disabling logic on an event, since there is no way
         * to handle event handlers ordering, use `drop:before`
         * @param {Event} e
         */
        _onDrop: function(e) {
          this._simpleEventHandler("drop:before", e);
          return this._simpleEventHandler("drop", e);
        },
        /**
         * @private
         * @param {Event} e Event object fired on mousedown
         */
        _onContextMenu: function(e) {
          if (this.stopContextMenu) {
            e.stopPropagation();
            e.preventDefault();
          }
          return false;
        },
        /**
         * @private
         * @param {Event} e Event object fired on mousedown
         */
        _onDoubleClick: function(e) {
          this._cacheTransformEventData(e);
          this._handleEvent(e, "dblclick");
          this._resetTransformEventData(e);
        },
        /**
         * Return a the id of an event.
         * returns either the pointerId or the identifier or 0 for the mouse event
         * @private
         * @param {Event} evt Event object
         */
        getPointerId: function(evt) {
          var changedTouches = evt.changedTouches;
          if (changedTouches) {
            return changedTouches[0] && changedTouches[0].identifier;
          }
          if (this.enablePointerEvents) {
            return evt.pointerId;
          }
          return -1;
        },
        /**
         * Determines if an event has the id of the event that is considered main
         * @private
         * @param {evt} event Event object
         */
        _isMainEvent: function(evt) {
          if (evt.isPrimary === true) {
            return true;
          }
          if (evt.isPrimary === false) {
            return false;
          }
          if (evt.type === "touchend" && evt.touches.length === 0) {
            return true;
          }
          if (evt.changedTouches) {
            return evt.changedTouches[0].identifier === this.mainTouchId;
          }
          return true;
        },
        /**
         * @private
         * @param {Event} e Event object fired on mousedown
         */
        _onTouchStart: function(e) {
          e.preventDefault();
          if (this.mainTouchId === null) {
            this.mainTouchId = this.getPointerId(e);
          }
          this.__onMouseDown(e);
          this._resetTransformEventData();
          var canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
          addListener2(fabric2.document, "touchend", this._onTouchEnd, addEventOptions);
          addListener2(fabric2.document, "touchmove", this._onMouseMove, addEventOptions);
          removeListener2(canvasElement, eventTypePrefix + "down", this._onMouseDown);
        },
        /**
         * @private
         * @param {Event} e Event object fired on mousedown
         */
        _onMouseDown: function(e) {
          this.__onMouseDown(e);
          this._resetTransformEventData();
          var canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
          removeListener2(canvasElement, eventTypePrefix + "move", this._onMouseMove, addEventOptions);
          addListener2(fabric2.document, eventTypePrefix + "up", this._onMouseUp);
          addListener2(fabric2.document, eventTypePrefix + "move", this._onMouseMove, addEventOptions);
        },
        /**
         * @private
         * @param {Event} e Event object fired on mousedown
         */
        _onTouchEnd: function(e) {
          if (e.touches.length > 0) {
            return;
          }
          this.__onMouseUp(e);
          this._resetTransformEventData();
          this.mainTouchId = null;
          var eventTypePrefix = this._getEventPrefix();
          removeListener2(fabric2.document, "touchend", this._onTouchEnd, addEventOptions);
          removeListener2(fabric2.document, "touchmove", this._onMouseMove, addEventOptions);
          var _this = this;
          if (this._willAddMouseDown) {
            clearTimeout(this._willAddMouseDown);
          }
          this._willAddMouseDown = setTimeout(function() {
            addListener2(_this.upperCanvasEl, eventTypePrefix + "down", _this._onMouseDown);
            _this._willAddMouseDown = 0;
          }, 400);
        },
        /**
         * @private
         * @param {Event} e Event object fired on mouseup
         */
        _onMouseUp: function(e) {
          this.__onMouseUp(e);
          this._resetTransformEventData();
          var canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
          if (this._isMainEvent(e)) {
            removeListener2(fabric2.document, eventTypePrefix + "up", this._onMouseUp);
            removeListener2(fabric2.document, eventTypePrefix + "move", this._onMouseMove, addEventOptions);
            addListener2(canvasElement, eventTypePrefix + "move", this._onMouseMove, addEventOptions);
          }
        },
        /**
         * @private
         * @param {Event} e Event object fired on mousemove
         */
        _onMouseMove: function(e) {
          !this.allowTouchScrolling && e.preventDefault && e.preventDefault();
          this.__onMouseMove(e);
        },
        /**
         * @private
         */
        _onResize: function() {
          this.calcOffset();
        },
        /**
         * Decides whether the canvas should be redrawn in mouseup and mousedown events.
         * @private
         * @param {Object} target
         */
        _shouldRender: function(target) {
          var activeObject = this._activeObject;
          if (!!activeObject !== !!target || activeObject && target && activeObject !== target) {
            return true;
          } else if (activeObject && activeObject.isEditing) {
            return false;
          }
          return false;
        },
        /**
         * Method that defines the actions when mouse is released on canvas.
         * The method resets the currentTransform parameters, store the image corner
         * position in the image object and render the canvas on top.
         * @private
         * @param {Event} e Event object fired on mouseup
         */
        __onMouseUp: function(e) {
          var target, transform = this._currentTransform, groupSelector = this._groupSelector, shouldRender = false, isClick = !groupSelector || groupSelector.left === 0 && groupSelector.top === 0;
          this._cacheTransformEventData(e);
          target = this._target;
          this._handleEvent(e, "up:before");
          if (checkClick(e, RIGHT_CLICK)) {
            if (this.fireRightClick) {
              this._handleEvent(e, "up", RIGHT_CLICK, isClick);
            }
            return;
          }
          if (checkClick(e, MIDDLE_CLICK)) {
            if (this.fireMiddleClick) {
              this._handleEvent(e, "up", MIDDLE_CLICK, isClick);
            }
            this._resetTransformEventData();
            return;
          }
          if (this.isDrawingMode && this._isCurrentlyDrawing) {
            this._onMouseUpInDrawingMode(e);
            return;
          }
          if (!this._isMainEvent(e)) {
            return;
          }
          if (transform) {
            this._finalizeCurrentTransform(e);
            shouldRender = transform.actionPerformed;
          }
          if (!isClick) {
            var targetWasActive = target === this._activeObject;
            this._maybeGroupObjects(e);
            if (!shouldRender) {
              shouldRender = this._shouldRender(target) || !targetWasActive && target === this._activeObject;
            }
          }
          var corner, pointer;
          if (target) {
            corner = target._findTargetCorner(
              this.getPointer(e, true),
              fabric2.util.isTouchEvent(e)
            );
            if (target.selectable && target !== this._activeObject && target.activeOn === "up") {
              this.setActiveObject(target, e);
              shouldRender = true;
            } else {
              var control = target.controls[corner], mouseUpHandler = control && control.getMouseUpHandler(e, target, control);
              if (mouseUpHandler) {
                pointer = this.getPointer(e);
                mouseUpHandler(e, transform, pointer.x, pointer.y);
              }
            }
            target.isMoving = false;
          }
          if (transform && (transform.target !== target || transform.corner !== corner)) {
            var originalControl = transform.target && transform.target.controls[transform.corner], originalMouseUpHandler = originalControl && originalControl.getMouseUpHandler(e, target, control);
            pointer = pointer || this.getPointer(e);
            originalMouseUpHandler && originalMouseUpHandler(e, transform, pointer.x, pointer.y);
          }
          this._setCursorFromEvent(e, target);
          this._handleEvent(e, "up", LEFT_CLICK, isClick);
          this._groupSelector = null;
          this._currentTransform = null;
          target && (target.__corner = 0);
          if (shouldRender) {
            this.requestRenderAll();
          } else if (!isClick) {
            this.renderTop();
          }
        },
        /**
         * @private
         * Handle event firing for target and subtargets
         * @param {Event} e event from mouse
         * @param {String} eventType event to fire (up, down or move)
         * @return {Fabric.Object} target return the the target found, for internal reasons.
         */
        _simpleEventHandler: function(eventType, e) {
          var target = this.findTarget(e), targets = this.targets, options = {
            e,
            target,
            subTargets: targets
          };
          this.fire(eventType, options);
          target && target.fire(eventType, options);
          if (!targets) {
            return target;
          }
          for (var i = 0; i < targets.length; i++) {
            targets[i].fire(eventType, options);
          }
          return target;
        },
        /**
         * @private
         * Handle event firing for target and subtargets
         * @param {Event} e event from mouse
         * @param {String} eventType event to fire (up, down or move)
         * @param {fabric.Object} targetObj receiving event
         * @param {Number} [button] button used in the event 1 = left, 2 = middle, 3 = right
         * @param {Boolean} isClick for left button only, indicates that the mouse up happened without move.
         */
        _handleEvent: function(e, eventType, button, isClick) {
          var target = this._target, targets = this.targets || [], options = {
            e,
            target,
            subTargets: targets,
            button: button || LEFT_CLICK,
            isClick: isClick || false,
            pointer: this._pointer,
            absolutePointer: this._absolutePointer,
            transform: this._currentTransform
          };
          if (eventType === "up") {
            options.currentTarget = this.findTarget(e);
            options.currentSubTargets = this.targets;
          }
          this.fire("mouse:" + eventType, options);
          target && target.fire("mouse" + eventType, options);
          for (var i = 0; i < targets.length; i++) {
            targets[i].fire("mouse" + eventType, options);
          }
        },
        /**
         * @private
         * @param {Event} e send the mouse event that generate the finalize down, so it can be used in the event
         */
        _finalizeCurrentTransform: function(e) {
          var transform = this._currentTransform, target = transform.target, options = {
            e,
            target,
            transform,
            action: transform.action
          };
          if (target._scaling) {
            target._scaling = false;
          }
          target.setCoords();
          if (transform.actionPerformed || this.stateful && target.hasStateChanged()) {
            this._fire("modified", options);
          }
        },
        /**
         * @private
         * @param {Event} e Event object fired on mousedown
         */
        _onMouseDownInDrawingMode: function(e) {
          this._isCurrentlyDrawing = true;
          if (this.getActiveObject()) {
            this.discardActiveObject(e).requestRenderAll();
          }
          var pointer = this.getPointer(e);
          this.freeDrawingBrush.onMouseDown(pointer, { e, pointer });
          this._handleEvent(e, "down");
        },
        /**
         * @private
         * @param {Event} e Event object fired on mousemove
         */
        _onMouseMoveInDrawingMode: function(e) {
          if (this._isCurrentlyDrawing) {
            var pointer = this.getPointer(e);
            this.freeDrawingBrush.onMouseMove(pointer, { e, pointer });
          }
          this.setCursor(this.freeDrawingCursor);
          this._handleEvent(e, "move");
        },
        /**
         * @private
         * @param {Event} e Event object fired on mouseup
         */
        _onMouseUpInDrawingMode: function(e) {
          var pointer = this.getPointer(e);
          this._isCurrentlyDrawing = this.freeDrawingBrush.onMouseUp({ e, pointer });
          this._handleEvent(e, "up");
        },
        /**
         * Method that defines the actions when mouse is clicked on canvas.
         * The method inits the currentTransform parameters and renders all the
         * canvas so the current image can be placed on the top canvas and the rest
         * in on the container one.
         * @private
         * @param {Event} e Event object fired on mousedown
         */
        __onMouseDown: function(e) {
          this._cacheTransformEventData(e);
          this._handleEvent(e, "down:before");
          var target = this._target;
          if (checkClick(e, RIGHT_CLICK)) {
            if (this.fireRightClick) {
              this._handleEvent(e, "down", RIGHT_CLICK);
            }
            return;
          }
          if (checkClick(e, MIDDLE_CLICK)) {
            if (this.fireMiddleClick) {
              this._handleEvent(e, "down", MIDDLE_CLICK);
            }
            return;
          }
          if (this.isDrawingMode) {
            this._onMouseDownInDrawingMode(e);
            return;
          }
          if (!this._isMainEvent(e)) {
            return;
          }
          if (this._currentTransform) {
            return;
          }
          var pointer = this._pointer;
          this._previousPointer = pointer;
          var shouldRender = this._shouldRender(target), shouldGroup = this._shouldGroup(e, target);
          if (this._shouldClearSelection(e, target)) {
            this.discardActiveObject(e);
          } else if (shouldGroup) {
            this._handleGrouping(e, target);
            target = this._activeObject;
          }
          if (this.selection && (!target || !target.selectable && !target.isEditing && target !== this._activeObject)) {
            this._groupSelector = {
              ex: this._absolutePointer.x,
              ey: this._absolutePointer.y,
              top: 0,
              left: 0
            };
          }
          if (target) {
            var alreadySelected = target === this._activeObject;
            if (target.selectable && target.activeOn === "down") {
              this.setActiveObject(target, e);
            }
            var corner = target._findTargetCorner(
              this.getPointer(e, true),
              fabric2.util.isTouchEvent(e)
            );
            target.__corner = corner;
            if (target === this._activeObject && (corner || !shouldGroup)) {
              this._setupCurrentTransform(e, target, alreadySelected);
              var control = target.controls[corner], pointer = this.getPointer(e), mouseDownHandler = control && control.getMouseDownHandler(e, target, control);
              if (mouseDownHandler) {
                mouseDownHandler(e, this._currentTransform, pointer.x, pointer.y);
              }
            }
          }
          this._handleEvent(e, "down");
          (shouldRender || shouldGroup) && this.requestRenderAll();
        },
        /**
         * reset cache form common information needed during event processing
         * @private
         */
        _resetTransformEventData: function() {
          this._target = null;
          this._pointer = null;
          this._absolutePointer = null;
        },
        /**
         * Cache common information needed during event processing
         * @private
         * @param {Event} e Event object fired on event
         */
        _cacheTransformEventData: function(e) {
          this._resetTransformEventData();
          this._pointer = this.getPointer(e, true);
          this._absolutePointer = this.restorePointerVpt(this._pointer);
          this._target = this._currentTransform ? this._currentTransform.target : this.findTarget(e) || null;
        },
        /**
         * @private
         */
        _beforeTransform: function(e) {
          var t = this._currentTransform;
          this.stateful && t.target.saveState();
          this.fire("before:transform", {
            e,
            transform: t
          });
        },
        /**
         * Method that defines the actions when mouse is hovering the canvas.
         * The currentTransform parameter will define whether the user is rotating/scaling/translating
         * an image or neither of them (only hovering). A group selection is also possible and would cancel
         * all any other type of action.
         * In case of an image transformation only the top canvas will be rendered.
         * @private
         * @param {Event} e Event object fired on mousemove
         */
        __onMouseMove: function(e) {
          this._handleEvent(e, "move:before");
          this._cacheTransformEventData(e);
          var target, pointer;
          if (this.isDrawingMode) {
            this._onMouseMoveInDrawingMode(e);
            return;
          }
          if (!this._isMainEvent(e)) {
            return;
          }
          var groupSelector = this._groupSelector;
          if (groupSelector) {
            pointer = this._absolutePointer;
            groupSelector.left = pointer.x - groupSelector.ex;
            groupSelector.top = pointer.y - groupSelector.ey;
            this.renderTop();
          } else if (!this._currentTransform) {
            target = this.findTarget(e) || null;
            this._setCursorFromEvent(e, target);
            this._fireOverOutEvents(target, e);
          } else {
            this._transformObject(e);
          }
          this._handleEvent(e, "move");
          this._resetTransformEventData();
        },
        /**
         * Manage the mouseout, mouseover events for the fabric object on the canvas
         * @param {Fabric.Object} target the target where the target from the mousemove event
         * @param {Event} e Event object fired on mousemove
         * @private
         */
        _fireOverOutEvents: function(target, e) {
          var _hoveredTarget = this._hoveredTarget, _hoveredTargets = this._hoveredTargets, targets = this.targets, length = Math.max(_hoveredTargets.length, targets.length);
          this.fireSyntheticInOutEvents(target, e, {
            oldTarget: _hoveredTarget,
            evtOut: "mouseout",
            canvasEvtOut: "mouse:out",
            evtIn: "mouseover",
            canvasEvtIn: "mouse:over"
          });
          for (var i = 0; i < length; i++) {
            this.fireSyntheticInOutEvents(targets[i], e, {
              oldTarget: _hoveredTargets[i],
              evtOut: "mouseout",
              evtIn: "mouseover"
            });
          }
          this._hoveredTarget = target;
          this._hoveredTargets = this.targets.concat();
        },
        /**
         * Manage the dragEnter, dragLeave events for the fabric objects on the canvas
         * @param {Fabric.Object} target the target where the target from the onDrag event
         * @param {Event} e Event object fired on ondrag
         * @private
         */
        _fireEnterLeaveEvents: function(target, e) {
          var _draggedoverTarget = this._draggedoverTarget, _hoveredTargets = this._hoveredTargets, targets = this.targets, length = Math.max(_hoveredTargets.length, targets.length);
          this.fireSyntheticInOutEvents(target, e, {
            oldTarget: _draggedoverTarget,
            evtOut: "dragleave",
            evtIn: "dragenter"
          });
          for (var i = 0; i < length; i++) {
            this.fireSyntheticInOutEvents(targets[i], e, {
              oldTarget: _hoveredTargets[i],
              evtOut: "dragleave",
              evtIn: "dragenter"
            });
          }
          this._draggedoverTarget = target;
        },
        /**
         * Manage the synthetic in/out events for the fabric objects on the canvas
         * @param {Fabric.Object} target the target where the target from the supported events
         * @param {Event} e Event object fired
         * @param {Object} config configuration for the function to work
         * @param {String} config.targetName property on the canvas where the old target is stored
         * @param {String} [config.canvasEvtOut] name of the event to fire at canvas level for out
         * @param {String} config.evtOut name of the event to fire for out
         * @param {String} [config.canvasEvtIn] name of the event to fire at canvas level for in
         * @param {String} config.evtIn name of the event to fire for in
         * @private
         */
        fireSyntheticInOutEvents: function(target, e, config2) {
          var inOpt, outOpt, oldTarget = config2.oldTarget, outFires, inFires, targetChanged = oldTarget !== target, canvasEvtIn = config2.canvasEvtIn, canvasEvtOut = config2.canvasEvtOut;
          if (targetChanged) {
            inOpt = { e, target, previousTarget: oldTarget };
            outOpt = { e, target: oldTarget, nextTarget: target };
          }
          inFires = target && targetChanged;
          outFires = oldTarget && targetChanged;
          if (outFires) {
            canvasEvtOut && this.fire(canvasEvtOut, outOpt);
            oldTarget.fire(config2.evtOut, outOpt);
          }
          if (inFires) {
            canvasEvtIn && this.fire(canvasEvtIn, inOpt);
            target.fire(config2.evtIn, inOpt);
          }
        },
        /**
         * Method that defines actions when an Event Mouse Wheel
         * @param {Event} e Event object fired on mouseup
         */
        __onMouseWheel: function(e) {
          this._cacheTransformEventData(e);
          this._handleEvent(e, "wheel");
          this._resetTransformEventData();
        },
        /**
         * @private
         * @param {Event} e Event fired on mousemove
         */
        _transformObject: function(e) {
          var pointer = this.getPointer(e), transform = this._currentTransform;
          transform.reset = false;
          transform.shiftKey = e.shiftKey;
          transform.altKey = e[this.centeredKey];
          this._performTransformAction(e, transform, pointer);
          transform.actionPerformed && this.requestRenderAll();
        },
        /**
         * @private
         */
        _performTransformAction: function(e, transform, pointer) {
          var x = pointer.x, y = pointer.y, action = transform.action, actionPerformed = false, actionHandler = transform.actionHandler;
          if (actionHandler) {
            actionPerformed = actionHandler(e, transform, x, y);
          }
          if (action === "drag" && actionPerformed) {
            transform.target.isMoving = true;
            this.setCursor(transform.target.moveCursor || this.moveCursor);
          }
          transform.actionPerformed = transform.actionPerformed || actionPerformed;
        },
        /**
         * @private
         */
        _fire: fabric2.controlsUtils.fireEvent,
        /**
         * Sets the cursor depending on where the canvas is being hovered.
         * Note: very buggy in Opera
         * @param {Event} e Event object
         * @param {Object} target Object that the mouse is hovering, if so.
         */
        _setCursorFromEvent: function(e, target) {
          if (!target) {
            this.setCursor(this.defaultCursor);
            return false;
          }
          var hoverCursor = target.hoverCursor || this.hoverCursor, activeSelection = this._activeObject && this._activeObject.type === "activeSelection" ? this._activeObject : null, corner = (!activeSelection || !activeSelection.contains(target)) && target._findTargetCorner(this.getPointer(e, true));
          if (!corner) {
            if (target.subTargetCheck) {
              this.targets.concat().reverse().map(function(_target) {
                hoverCursor = _target.hoverCursor || hoverCursor;
              });
            }
            this.setCursor(hoverCursor);
          } else {
            this.setCursor(this.getCornerCursor(corner, target, e));
          }
        },
        /**
         * @private
         */
        getCornerCursor: function(corner, target, e) {
          var control = target.controls[corner];
          return control.cursorStyleHandler(e, control, target);
        }
      }
    );
  })();
  (function() {
    var min2 = Math.min, max2 = Math.max;
    fabric2.util.object.extend(
      fabric2.Canvas.prototype,
      /** @lends fabric.Canvas.prototype */
      {
        /**
         * @private
         * @param {Event} e Event object
         * @param {fabric.Object} target
         * @return {Boolean}
         */
        _shouldGroup: function(e, target) {
          var activeObject = this._activeObject;
          return activeObject && this._isSelectionKeyPressed(e) && target && target.selectable && this.selection && (activeObject !== target || activeObject.type === "activeSelection") && !target.onSelect({ e });
        },
        /**
         * @private
         * @param {Event} e Event object
         * @param {fabric.Object} target
         */
        _handleGrouping: function(e, target) {
          var activeObject = this._activeObject;
          if (activeObject.__corner) {
            return;
          }
          if (target === activeObject) {
            target = this.findTarget(e, true);
            if (!target || !target.selectable) {
              return;
            }
          }
          if (activeObject && activeObject.type === "activeSelection") {
            this._updateActiveSelection(target, e);
          } else {
            this._createActiveSelection(target, e);
          }
        },
        /**
         * @private
         */
        _updateActiveSelection: function(target, e) {
          var activeSelection = this._activeObject, currentActiveObjects = activeSelection._objects.slice(0);
          if (activeSelection.contains(target)) {
            activeSelection.removeWithUpdate(target);
            this._hoveredTarget = target;
            this._hoveredTargets = this.targets.concat();
            if (activeSelection.size() === 1) {
              this._setActiveObject(activeSelection.item(0), e);
            }
          } else {
            activeSelection.addWithUpdate(target);
            this._hoveredTarget = activeSelection;
            this._hoveredTargets = this.targets.concat();
          }
          this._fireSelectionEvents(currentActiveObjects, e);
        },
        /**
         * @private
         */
        _createActiveSelection: function(target, e) {
          var currentActives = this.getActiveObjects(), group = this._createGroup(target);
          this._hoveredTarget = group;
          this._setActiveObject(group, e);
          this._fireSelectionEvents(currentActives, e);
        },
        /**
         * @private
         * @param {Object} target
         */
        _createGroup: function(target) {
          var objects = this._objects, isActiveLower = objects.indexOf(this._activeObject) < objects.indexOf(target), groupObjects = isActiveLower ? [this._activeObject, target] : [target, this._activeObject];
          this._activeObject.isEditing && this._activeObject.exitEditing();
          return new fabric2.ActiveSelection(groupObjects, {
            canvas: this
          });
        },
        /**
         * @private
         * @param {Event} e mouse event
         */
        _groupSelectedObjects: function(e) {
          var group = this._collectObjects(e), aGroup;
          if (group.length === 1) {
            this.setActiveObject(group[0], e);
          } else if (group.length > 1) {
            aGroup = new fabric2.ActiveSelection(group.reverse(), {
              canvas: this
            });
            this.setActiveObject(aGroup, e);
          }
        },
        /**
         * @private
         */
        _collectObjects: function(e) {
          var group = [], currentObject, x1 = this._groupSelector.ex, y1 = this._groupSelector.ey, x2 = x1 + this._groupSelector.left, y2 = y1 + this._groupSelector.top, selectionX1Y1 = new fabric2.Point(min2(x1, x2), min2(y1, y2)), selectionX2Y2 = new fabric2.Point(max2(x1, x2), max2(y1, y2)), allowIntersect = !this.selectionFullyContained, isClick = x1 === x2 && y1 === y2;
          for (var i = this._objects.length; i--; ) {
            currentObject = this._objects[i];
            if (!currentObject || !currentObject.selectable || !currentObject.visible) {
              continue;
            }
            if (allowIntersect && currentObject.intersectsWithRect(selectionX1Y1, selectionX2Y2, true) || currentObject.isContainedWithinRect(selectionX1Y1, selectionX2Y2, true) || allowIntersect && currentObject.containsPoint(selectionX1Y1, null, true) || allowIntersect && currentObject.containsPoint(selectionX2Y2, null, true)) {
              group.push(currentObject);
              if (isClick) {
                break;
              }
            }
          }
          if (group.length > 1) {
            group = group.filter(function(object) {
              return !object.onSelect({ e });
            });
          }
          return group;
        },
        /**
         * @private
         */
        _maybeGroupObjects: function(e) {
          if (this.selection && this._groupSelector) {
            this._groupSelectedObjects(e);
          }
          this.setCursor(this.defaultCursor);
          this._groupSelector = null;
        }
      }
    );
  })();
  (function() {
    fabric2.util.object.extend(
      fabric2.StaticCanvas.prototype,
      /** @lends fabric.StaticCanvas.prototype */
      {
        /**
         * Exports canvas element to a dataurl image. Note that when multiplier is used, cropping is scaled appropriately
         * @param {Object} [options] Options object
         * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
         * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
         * @param {Number} [options.multiplier=1] Multiplier to scale by, to have consistent
         * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
         * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
         * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
         * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
         * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 2.0.0
         * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
         * @see {@link http://jsfiddle.net/fabricjs/NfZVb/|jsFiddle demo}
         * @example <caption>Generate jpeg dataURL with lower quality</caption>
         * var dataURL = canvas.toDataURL({
         *   format: 'jpeg',
         *   quality: 0.8
         * });
         * @example <caption>Generate cropped png dataURL (clipping of canvas)</caption>
         * var dataURL = canvas.toDataURL({
         *   format: 'png',
         *   left: 100,
         *   top: 100,
         *   width: 200,
         *   height: 200
         * });
         * @example <caption>Generate double scaled png dataURL</caption>
         * var dataURL = canvas.toDataURL({
         *   format: 'png',
         *   multiplier: 2
         * });
         */
        toDataURL: function(options) {
          options || (options = {});
          var format = options.format || "png", quality = options.quality || 1, multiplier = (options.multiplier || 1) * (options.enableRetinaScaling ? this.getRetinaScaling() : 1), canvasEl = this.toCanvasElement(multiplier, options);
          return fabric2.util.toDataURL(canvasEl, format, quality);
        },
        /**
         * Create a new HTMLCanvas element painted with the current canvas content.
         * No need to resize the actual one or repaint it.
         * Will transfer object ownership to a new canvas, paint it, and set everything back.
         * This is an intermediary step used to get to a dataUrl but also it is useful to
         * create quick image copies of a canvas without passing for the dataUrl string
         * @param {Number} [multiplier] a zoom factor.
         * @param {Object} [cropping] Cropping informations
         * @param {Number} [cropping.left] Cropping left offset.
         * @param {Number} [cropping.top] Cropping top offset.
         * @param {Number} [cropping.width] Cropping width.
         * @param {Number} [cropping.height] Cropping height.
         */
        toCanvasElement: function(multiplier, cropping) {
          multiplier = multiplier || 1;
          cropping = cropping || {};
          var scaledWidth = (cropping.width || this.width) * multiplier, scaledHeight = (cropping.height || this.height) * multiplier, zoom = this.getZoom(), originalWidth = this.width, originalHeight = this.height, newZoom = zoom * multiplier, vp = this.viewportTransform, translateX = (vp[4] - (cropping.left || 0)) * multiplier, translateY = (vp[5] - (cropping.top || 0)) * multiplier, originalInteractive = this.interactive, newVp = [newZoom, 0, 0, newZoom, translateX, translateY], originalRetina = this.enableRetinaScaling, canvasEl = fabric2.util.createCanvasElement(), originalContextTop = this.contextTop;
          canvasEl.width = scaledWidth;
          canvasEl.height = scaledHeight;
          this.contextTop = null;
          this.enableRetinaScaling = false;
          this.interactive = false;
          this.viewportTransform = newVp;
          this.width = scaledWidth;
          this.height = scaledHeight;
          this.calcViewportBoundaries();
          this.renderCanvas(canvasEl.getContext("2d"), this._objects);
          this.viewportTransform = vp;
          this.width = originalWidth;
          this.height = originalHeight;
          this.calcViewportBoundaries();
          this.interactive = originalInteractive;
          this.enableRetinaScaling = originalRetina;
          this.contextTop = originalContextTop;
          return canvasEl;
        }
      }
    );
  })();
  fabric2.util.object.extend(
    fabric2.StaticCanvas.prototype,
    /** @lends fabric.StaticCanvas.prototype */
    {
      /**
       * Populates canvas with data from the specified JSON.
       * JSON format must conform to the one of {@link fabric.Canvas#toJSON}
       * @param {String|Object} json JSON string or object
       * @param {Function} callback Callback, invoked when json is parsed
       *                            and corresponding objects (e.g: {@link fabric.Image})
       *                            are initialized
       * @param {Function} [reviver] Method for further parsing of JSON elements, called after each fabric object created.
       * @return {fabric.Canvas} instance
       * @chainable
       * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#deserialization}
       * @see {@link http://jsfiddle.net/fabricjs/fmgXt/|jsFiddle demo}
       * @example <caption>loadFromJSON</caption>
       * canvas.loadFromJSON(json, canvas.renderAll.bind(canvas));
       * @example <caption>loadFromJSON with reviver</caption>
       * canvas.loadFromJSON(json, canvas.renderAll.bind(canvas), function(o, object) {
       *   // `o` = json object
       *   // `object` = fabric.Object instance
       *   // ... do some stuff ...
       * });
       */
      loadFromJSON: function(json, callback, reviver) {
        if (!json) {
          return;
        }
        var serialized = typeof json === "string" ? JSON.parse(json) : fabric2.util.object.clone(json);
        var _this = this, clipPath = serialized.clipPath, renderOnAddRemove = this.renderOnAddRemove;
        this.renderOnAddRemove = false;
        delete serialized.clipPath;
        this._enlivenObjects(serialized.objects, function(enlivenedObjects) {
          _this.clear();
          _this._setBgOverlay(serialized, function() {
            if (clipPath) {
              _this._enlivenObjects([clipPath], function(enlivenedCanvasClip) {
                _this.clipPath = enlivenedCanvasClip[0];
                _this.__setupCanvas.call(_this, serialized, enlivenedObjects, renderOnAddRemove, callback);
              });
            } else {
              _this.__setupCanvas.call(_this, serialized, enlivenedObjects, renderOnAddRemove, callback);
            }
          });
        }, reviver);
        return this;
      },
      /**
       * @private
       * @param {Object} serialized Object with background and overlay information
       * @param {Array} restored canvas objects
       * @param {Function} cached renderOnAddRemove callback
       * @param {Function} callback Invoked after all background and overlay images/patterns loaded
       */
      __setupCanvas: function(serialized, enlivenedObjects, renderOnAddRemove, callback) {
        var _this = this;
        enlivenedObjects.forEach(function(obj, index) {
          _this.insertAt(obj, index);
        });
        this.renderOnAddRemove = renderOnAddRemove;
        delete serialized.objects;
        delete serialized.backgroundImage;
        delete serialized.overlayImage;
        delete serialized.background;
        delete serialized.overlay;
        this._setOptions(serialized);
        this.renderAll();
        callback && callback();
      },
      /**
       * @private
       * @param {Object} serialized Object with background and overlay information
       * @param {Function} callback Invoked after all background and overlay images/patterns loaded
       */
      _setBgOverlay: function(serialized, callback) {
        var loaded = {
          backgroundColor: false,
          overlayColor: false,
          backgroundImage: false,
          overlayImage: false
        };
        if (!serialized.backgroundImage && !serialized.overlayImage && !serialized.background && !serialized.overlay) {
          callback && callback();
          return;
        }
        var cbIfLoaded = function() {
          if (loaded.backgroundImage && loaded.overlayImage && loaded.backgroundColor && loaded.overlayColor) {
            callback && callback();
          }
        };
        this.__setBgOverlay("backgroundImage", serialized.backgroundImage, loaded, cbIfLoaded);
        this.__setBgOverlay("overlayImage", serialized.overlayImage, loaded, cbIfLoaded);
        this.__setBgOverlay("backgroundColor", serialized.background, loaded, cbIfLoaded);
        this.__setBgOverlay("overlayColor", serialized.overlay, loaded, cbIfLoaded);
      },
      /**
       * @private
       * @param {String} property Property to set (backgroundImage, overlayImage, backgroundColor, overlayColor)
       * @param {(Object|String)} value Value to set
       * @param {Object} loaded Set loaded property to true if property is set
       * @param {Object} callback Callback function to invoke after property is set
       */
      __setBgOverlay: function(property, value, loaded, callback) {
        var _this = this;
        if (!value) {
          loaded[property] = true;
          callback && callback();
          return;
        }
        if (property === "backgroundImage" || property === "overlayImage") {
          fabric2.util.enlivenObjects([value], function(enlivedObject) {
            _this[property] = enlivedObject[0];
            loaded[property] = true;
            callback && callback();
          });
        } else {
          this["set" + fabric2.util.string.capitalize(property, true)](value, function() {
            loaded[property] = true;
            callback && callback();
          });
        }
      },
      /**
       * @private
       * @param {Array} objects
       * @param {Function} callback
       * @param {Function} [reviver]
       */
      _enlivenObjects: function(objects, callback, reviver) {
        if (!objects || objects.length === 0) {
          callback && callback([]);
          return;
        }
        fabric2.util.enlivenObjects(objects, function(enlivenedObjects) {
          callback && callback(enlivenedObjects);
        }, null, reviver);
      },
      /**
       * @private
       * @param {String} format
       * @param {Function} callback
       */
      _toDataURL: function(format, callback) {
        this.clone(function(clone2) {
          callback(clone2.toDataURL(format));
        });
      },
      /**
       * @private
       * @param {String} format
       * @param {Number} multiplier
       * @param {Function} callback
       */
      _toDataURLWithMultiplier: function(format, multiplier, callback) {
        this.clone(function(clone2) {
          callback(clone2.toDataURLWithMultiplier(format, multiplier));
        });
      },
      /**
       * Clones canvas instance
       * @param {Object} [callback] Receives cloned instance as a first argument
       * @param {Array} [properties] Array of properties to include in the cloned canvas and children
       */
      clone: function(callback, properties) {
        var data = JSON.stringify(this.toJSON(properties));
        this.cloneWithoutData(function(clone2) {
          clone2.loadFromJSON(data, function() {
            callback && callback(clone2);
          });
        });
      },
      /**
       * Clones canvas instance without cloning existing data.
       * This essentially copies canvas dimensions, clipping properties, etc.
       * but leaves data empty (so that you can populate it with your own)
       * @param {Object} [callback] Receives cloned instance as a first argument
       */
      cloneWithoutData: function(callback) {
        var el = fabric2.util.createCanvasElement();
        el.width = this.width;
        el.height = this.height;
        var clone2 = new fabric2.Canvas(el);
        if (this.backgroundImage) {
          clone2.setBackgroundImage(this.backgroundImage.src, function() {
            clone2.renderAll();
            callback && callback(clone2);
          });
          clone2.backgroundImageOpacity = this.backgroundImageOpacity;
          clone2.backgroundImageStretch = this.backgroundImageStretch;
        } else {
          callback && callback(clone2);
        }
      }
    }
  );
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), extend = fabric22.util.object.extend, clone2 = fabric22.util.object.clone, toFixed = fabric22.util.toFixed, capitalize = fabric22.util.string.capitalize, degreesToRadians = fabric22.util.degreesToRadians, objectCaching = !fabric22.isLikelyNode, ALIASING_LIMIT = 2;
    if (fabric22.Object) {
      return;
    }
    fabric22.Object = fabric22.util.createClass(
      fabric22.CommonMethods,
      /** @lends fabric.Object.prototype */
      {
        /**
         * Type of an object (rect, circle, path, etc.).
         * Note that this property is meant to be read-only and not meant to be modified.
         * If you modify, certain parts of Fabric (such as JSON loading) won't work correctly.
         * @type String
         * @default
         */
        type: "object",
        /**
         * Horizontal origin of transformation of an object (one of "left", "right", "center")
         * See http://jsfiddle.net/1ow02gea/244/ on how originX/originY affect objects in groups
         * @type String
         * @default
         */
        originX: "left",
        /**
         * Vertical origin of transformation of an object (one of "top", "bottom", "center")
         * See http://jsfiddle.net/1ow02gea/244/ on how originX/originY affect objects in groups
         * @type String
         * @default
         */
        originY: "top",
        /**
         * Top position of an object. Note that by default it's relative to object top. You can change this by setting originY={top/center/bottom}
         * @type Number
         * @default
         */
        top: 0,
        /**
         * Left position of an object. Note that by default it's relative to object left. You can change this by setting originX={left/center/right}
         * @type Number
         * @default
         */
        left: 0,
        /**
         * Object width
         * @type Number
         * @default
         */
        width: 0,
        /**
         * Object height
         * @type Number
         * @default
         */
        height: 0,
        /**
         * Object scale factor (horizontal)
         * @type Number
         * @default
         */
        scaleX: 1,
        /**
         * Object scale factor (vertical)
         * @type Number
         * @default
         */
        scaleY: 1,
        /**
         * When true, an object is rendered as flipped horizontally
         * @type Boolean
         * @default
         */
        flipX: false,
        /**
         * When true, an object is rendered as flipped vertically
         * @type Boolean
         * @default
         */
        flipY: false,
        /**
         * Opacity of an object
         * @type Number
         * @default
         */
        opacity: 1,
        /**
         * Angle of rotation of an object (in degrees)
         * @type Number
         * @default
         */
        angle: 0,
        /**
         * Angle of skew on x axes of an object (in degrees)
         * @type Number
         * @default
         */
        skewX: 0,
        /**
         * Angle of skew on y axes of an object (in degrees)
         * @type Number
         * @default
         */
        skewY: 0,
        /**
         * Size of object's controlling corners (in pixels)
         * @type Number
         * @default
         */
        cornerSize: 13,
        /**
         * Size of object's controlling corners when touch interaction is detected
         * @type Number
         * @default
         */
        touchCornerSize: 24,
        /**
         * When true, object's controlling corners are rendered as transparent inside (i.e. stroke instead of fill)
         * @type Boolean
         * @default
         */
        transparentCorners: true,
        /**
         * Default cursor value used when hovering over this object on canvas
         * @type String
         * @default
         */
        hoverCursor: null,
        /**
         * Default cursor value used when moving this object on canvas
         * @type String
         * @default
         */
        moveCursor: null,
        /**
         * Padding between object and its controlling borders (in pixels)
         * @type Number
         * @default
         */
        padding: 0,
        /**
         * Color of controlling borders of an object (when it's active)
         * @type String
         * @default
         */
        borderColor: "rgb(178,204,255)",
        /**
         * Array specifying dash pattern of an object's borders (hasBorder must be true)
         * @since 1.6.2
         * @type Array
         */
        borderDashArray: null,
        /**
         * Color of controlling corners of an object (when it's active)
         * @type String
         * @default
         */
        cornerColor: "rgb(178,204,255)",
        /**
         * Color of controlling corners of an object (when it's active and transparentCorners false)
         * @since 1.6.2
         * @type String
         * @default
         */
        cornerStrokeColor: null,
        /**
         * Specify style of control, 'rect' or 'circle'
         * @since 1.6.2
         * @type String
         */
        cornerStyle: "rect",
        /**
         * Array specifying dash pattern of an object's control (hasBorder must be true)
         * @since 1.6.2
         * @type Array
         */
        cornerDashArray: null,
        /**
         * When true, this object will use center point as the origin of transformation
         * when being scaled via the controls.
         * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
         * @since 1.3.4
         * @type Boolean
         * @default
         */
        centeredScaling: false,
        /**
         * When true, this object will use center point as the origin of transformation
         * when being rotated via the controls.
         * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
         * @since 1.3.4
         * @type Boolean
         * @default
         */
        centeredRotation: true,
        /**
         * Color of object's fill
         * takes css colors https://www.w3.org/TR/css-color-3/
         * @type String
         * @default
         */
        fill: "rgb(0,0,0)",
        /**
         * Fill rule used to fill an object
         * accepted values are nonzero, evenodd
         * <b>Backwards incompatibility note:</b> This property was used for setting globalCompositeOperation until v1.4.12 (use `fabric.Object#globalCompositeOperation` instead)
         * @type String
         * @default
         */
        fillRule: "nonzero",
        /**
         * Composite rule used for canvas globalCompositeOperation
         * @type String
         * @default
         */
        globalCompositeOperation: "source-over",
        /**
         * Background color of an object.
         * takes css colors https://www.w3.org/TR/css-color-3/
         * @type String
         * @default
         */
        backgroundColor: "",
        /**
         * Selection Background color of an object. colored layer behind the object when it is active.
         * does not mix good with globalCompositeOperation methods.
         * @type String
         * @default
         */
        selectionBackgroundColor: "",
        /**
         * When defined, an object is rendered via stroke and this property specifies its color
         * takes css colors https://www.w3.org/TR/css-color-3/
         * @type String
         * @default
         */
        stroke: null,
        /**
         * Width of a stroke used to render this object
         * @type Number
         * @default
         */
        strokeWidth: 1,
        /**
         * Array specifying dash pattern of an object's stroke (stroke must be defined)
         * @type Array
         */
        strokeDashArray: null,
        /**
         * Line offset of an object's stroke
         * @type Number
         * @default
         */
        strokeDashOffset: 0,
        /**
         * Line endings style of an object's stroke (one of "butt", "round", "square")
         * @type String
         * @default
         */
        strokeLineCap: "butt",
        /**
         * Corner style of an object's stroke (one of "bevel", "round", "miter")
         * @type String
         * @default
         */
        strokeLineJoin: "miter",
        /**
         * Maximum miter length (used for strokeLineJoin = "miter") of an object's stroke
         * @type Number
         * @default
         */
        strokeMiterLimit: 4,
        /**
         * Shadow object representing shadow of this shape
         * @type fabric.Shadow
         * @default
         */
        shadow: null,
        /**
         * Opacity of object's controlling borders when object is active and moving
         * @type Number
         * @default
         */
        borderOpacityWhenMoving: 0.4,
        /**
         * Scale factor of object's controlling borders
         * bigger number will make a thicker border
         * border is 1, so this is basically a border thickness
         * since there is no way to change the border itself.
         * @type Number
         * @default
         */
        borderScaleFactor: 1,
        /**
         * Minimum allowed scale value of an object
         * @type Number
         * @default
         */
        minScaleLimit: 0,
        /**
         * When set to `false`, an object can not be selected for modification (using either point-click-based or group-based selection).
         * But events still fire on it.
         * @type Boolean
         * @default
         */
        selectable: true,
        /**
         * When set to `false`, an object can not be a target of events. All events propagate through it. Introduced in v1.3.4
         * @type Boolean
         * @default
         */
        evented: true,
        /**
         * When set to `false`, an object is not rendered on canvas
         * @type Boolean
         * @default
         */
        visible: true,
        /**
         * When set to `false`, object's controls are not displayed and can not be used to manipulate object
         * @type Boolean
         * @default
         */
        hasControls: true,
        /**
         * When set to `false`, object's controlling borders are not rendered
         * @type Boolean
         * @default
         */
        hasBorders: true,
        /**
         * When set to `true`, objects are "found" on canvas on per-pixel basis rather than according to bounding box
         * @type Boolean
         * @default
         */
        perPixelTargetFind: false,
        /**
         * When `false`, default object's values are not included in its serialization
         * @type Boolean
         * @default
         */
        includeDefaultValues: true,
        /**
         * When `true`, object horizontal movement is locked
         * @type Boolean
         * @default
         */
        lockMovementX: false,
        /**
         * When `true`, object vertical movement is locked
         * @type Boolean
         * @default
         */
        lockMovementY: false,
        /**
         * When `true`, object rotation is locked
         * @type Boolean
         * @default
         */
        lockRotation: false,
        /**
         * When `true`, object horizontal scaling is locked
         * @type Boolean
         * @default
         */
        lockScalingX: false,
        /**
         * When `true`, object vertical scaling is locked
         * @type Boolean
         * @default
         */
        lockScalingY: false,
        /**
         * When `true`, object horizontal skewing is locked
         * @type Boolean
         * @default
         */
        lockSkewingX: false,
        /**
         * When `true`, object vertical skewing is locked
         * @type Boolean
         * @default
         */
        lockSkewingY: false,
        /**
         * When `true`, object cannot be flipped by scaling into negative values
         * @type Boolean
         * @default
         */
        lockScalingFlip: false,
        /**
         * When `true`, object is not exported in OBJECT/JSON
         * @since 1.6.3
         * @type Boolean
         * @default
         */
        excludeFromExport: false,
        /**
         * When `true`, object is cached on an additional canvas.
         * When `false`, object is not cached unless necessary ( clipPath )
         * default to true
         * @since 1.7.0
         * @type Boolean
         * @default true
         */
        objectCaching,
        /**
         * When `true`, object properties are checked for cache invalidation. In some particular
         * situation you may want this to be disabled ( spray brush, very big, groups)
         * or if your application does not allow you to modify properties for groups child you want
         * to disable it for groups.
         * default to false
         * since 1.7.0
         * @type Boolean
         * @default false
         */
        statefullCache: false,
        /**
         * When `true`, cache does not get updated during scaling. The picture will get blocky if scaled
         * too much and will be redrawn with correct details at the end of scaling.
         * this setting is performance and application dependant.
         * default to true
         * since 1.7.0
         * @type Boolean
         * @default true
         */
        noScaleCache: true,
        /**
         * When `false`, the stoke width will scale with the object.
         * When `true`, the stroke will always match the exact pixel size entered for stroke width.
         * this Property does not work on Text classes or drawing call that uses strokeText,fillText methods
         * default to false
         * @since 2.6.0
         * @type Boolean
         * @default false
         * @type Boolean
         * @default false
         */
        strokeUniform: false,
        /**
         * When set to `true`, object's cache will be rerendered next render call.
         * since 1.7.0
         * @type Boolean
         * @default true
         */
        dirty: true,
        /**
         * keeps the value of the last hovered corner during mouse move.
         * 0 is no corner, or 'mt', 'ml', 'mtr' etc..
         * It should be private, but there is no harm in using it as
         * a read-only property.
         * @type number|string|any
         * @default 0
         */
        __corner: 0,
        /**
         * Determines if the fill or the stroke is drawn first (one of "fill" or "stroke")
         * @type String
         * @default
         */
        paintFirst: "fill",
        /**
         * When 'down', object is set to active on mousedown/touchstart
         * When 'up', object is set to active on mouseup/touchend
         * Experimental. Let's see if this breaks anything before supporting officially
         * @private
         * since 4.4.0
         * @type String
         * @default 'down'
         */
        activeOn: "down",
        /**
         * List of properties to consider when checking if state
         * of an object is changed (fabric.Object#hasStateChanged)
         * as well as for history (undo/redo) purposes
         * @type Array
         */
        stateProperties: "top left width height scaleX scaleY flipX flipY originX originY transformMatrix stroke strokeWidth strokeDashArray strokeLineCap strokeDashOffset strokeLineJoin strokeMiterLimit angle opacity fill globalCompositeOperation shadow visible backgroundColor skewX skewY fillRule paintFirst clipPath strokeUniform".split(" "),
        /**
         * List of properties to consider when checking if cache needs refresh
         * Those properties are checked by statefullCache ON ( or lazy mode if we want ) or from single
         * calls to Object.set(key, value). If the key is in this list, the object is marked as dirty
         * and refreshed at the next render
         * @type Array
         */
        cacheProperties: "fill stroke strokeWidth strokeDashArray width height paintFirst strokeUniform strokeLineCap strokeDashOffset strokeLineJoin strokeMiterLimit backgroundColor clipPath".split(" "),
        /**
         * List of properties to consider for animating colors.
         * @type Array
         */
        colorProperties: "fill stroke backgroundColor".split(" "),
        /**
         * a fabricObject that, without stroke define a clipping area with their shape. filled in black
         * the clipPath object gets used when the object has rendered, and the context is placed in the center
         * of the object cacheCanvas.
         * If you want 0,0 of a clipPath to align with an object center, use clipPath.originX/Y to 'center'
         * @type fabric.Object
         */
        clipPath: void 0,
        /**
         * Meaningful ONLY when the object is used as clipPath.
         * if true, the clipPath will make the object clip to the outside of the clipPath
         * since 2.4.0
         * @type boolean
         * @default false
         */
        inverted: false,
        /**
         * Meaningful ONLY when the object is used as clipPath.
         * if true, the clipPath will have its top and left relative to canvas, and will
         * not be influenced by the object transform. This will make the clipPath relative
         * to the canvas, but clipping just a particular object.
         * WARNING this is beta, this feature may change or be renamed.
         * since 2.4.0
         * @type boolean
         * @default false
         */
        absolutePositioned: false,
        /**
         * Constructor
         * @param {Object} [options] Options object
         */
        initialize: function(options) {
          if (options) {
            this.setOptions(options);
          }
        },
        /**
         * Create a the canvas used to keep the cached copy of the object
         * @private
         */
        _createCacheCanvas: function() {
          this._cacheProperties = {};
          this._cacheCanvas = fabric22.util.createCanvasElement();
          this._cacheContext = this._cacheCanvas.getContext("2d");
          this._updateCacheCanvas();
          this.dirty = true;
        },
        /**
         * Limit the cache dimensions so that X * Y do not cross fabric.perfLimitSizeTotal
         * and each side do not cross fabric.cacheSideLimit
         * those numbers are configurable so that you can get as much detail as you want
         * making bargain with performances.
         * @param {Object} dims
         * @param {Object} dims.width width of canvas
         * @param {Object} dims.height height of canvas
         * @param {Object} dims.zoomX zoomX zoom value to unscale the canvas before drawing cache
         * @param {Object} dims.zoomY zoomY zoom value to unscale the canvas before drawing cache
         * @return {Object}.width width of canvas
         * @return {Object}.height height of canvas
         * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
         * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
         */
        _limitCacheSize: function(dims) {
          var perfLimitSizeTotal = fabric22.perfLimitSizeTotal, width = dims.width, height = dims.height, max2 = fabric22.maxCacheSideLimit, min2 = fabric22.minCacheSideLimit;
          if (width <= max2 && height <= max2 && width * height <= perfLimitSizeTotal) {
            if (width < min2) {
              dims.width = min2;
            }
            if (height < min2) {
              dims.height = min2;
            }
            return dims;
          }
          var ar = width / height, limitedDims = fabric22.util.limitDimsByArea(ar, perfLimitSizeTotal), capValue = fabric22.util.capValue, x = capValue(min2, limitedDims.x, max2), y = capValue(min2, limitedDims.y, max2);
          if (width > x) {
            dims.zoomX /= width / x;
            dims.width = x;
            dims.capped = true;
          }
          if (height > y) {
            dims.zoomY /= height / y;
            dims.height = y;
            dims.capped = true;
          }
          return dims;
        },
        /**
         * Return the dimension and the zoom level needed to create a cache canvas
         * big enough to host the object to be cached.
         * @private
         * @return {Object}.x width of object to be cached
         * @return {Object}.y height of object to be cached
         * @return {Object}.width width of canvas
         * @return {Object}.height height of canvas
         * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
         * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
         */
        _getCacheCanvasDimensions: function() {
          var objectScale = this.getTotalObjectScaling(), dim = this._getTransformedDimensions(0, 0), neededX = dim.x * objectScale.scaleX / this.scaleX, neededY = dim.y * objectScale.scaleY / this.scaleY;
          return {
            // for sure this ALIASING_LIMIT is slightly creating problem
            // in situation in which the cache canvas gets an upper limit
            // also objectScale contains already scaleX and scaleY
            width: neededX + ALIASING_LIMIT,
            height: neededY + ALIASING_LIMIT,
            zoomX: objectScale.scaleX,
            zoomY: objectScale.scaleY,
            x: neededX,
            y: neededY
          };
        },
        /**
         * Update width and height of the canvas for cache
         * returns true or false if canvas needed resize.
         * @private
         * @return {Boolean} true if the canvas has been resized
         */
        _updateCacheCanvas: function() {
          var targetCanvas = this.canvas;
          if (this.noScaleCache && targetCanvas && targetCanvas._currentTransform) {
            var target = targetCanvas._currentTransform.target, action = targetCanvas._currentTransform.action;
            if (this === target && action.slice && action.slice(0, 5) === "scale") {
              return false;
            }
          }
          var canvas = this._cacheCanvas, dims = this._limitCacheSize(this._getCacheCanvasDimensions()), minCacheSize = fabric22.minCacheSideLimit, width = dims.width, height = dims.height, drawingWidth, drawingHeight, zoomX = dims.zoomX, zoomY = dims.zoomY, dimensionsChanged = width !== this.cacheWidth || height !== this.cacheHeight, zoomChanged = this.zoomX !== zoomX || this.zoomY !== zoomY, shouldRedraw = dimensionsChanged || zoomChanged, additionalWidth = 0, additionalHeight = 0, shouldResizeCanvas = false;
          if (dimensionsChanged) {
            var canvasWidth = this._cacheCanvas.width, canvasHeight = this._cacheCanvas.height, sizeGrowing = width > canvasWidth || height > canvasHeight, sizeShrinking = (width < canvasWidth * 0.9 || height < canvasHeight * 0.9) && canvasWidth > minCacheSize && canvasHeight > minCacheSize;
            shouldResizeCanvas = sizeGrowing || sizeShrinking;
            if (sizeGrowing && !dims.capped && (width > minCacheSize || height > minCacheSize)) {
              additionalWidth = width * 0.1;
              additionalHeight = height * 0.1;
            }
          }
          if (this instanceof fabric22.Text && this.path) {
            shouldRedraw = true;
            shouldResizeCanvas = true;
            additionalWidth += this.getHeightOfLine(0) * this.zoomX;
            additionalHeight += this.getHeightOfLine(0) * this.zoomY;
          }
          if (shouldRedraw) {
            if (shouldResizeCanvas) {
              canvas.width = Math.ceil(width + additionalWidth);
              canvas.height = Math.ceil(height + additionalHeight);
            } else {
              this._cacheContext.setTransform(1, 0, 0, 1, 0, 0);
              this._cacheContext.clearRect(0, 0, canvas.width, canvas.height);
            }
            drawingWidth = dims.x / 2;
            drawingHeight = dims.y / 2;
            this.cacheTranslationX = Math.round(canvas.width / 2 - drawingWidth) + drawingWidth;
            this.cacheTranslationY = Math.round(canvas.height / 2 - drawingHeight) + drawingHeight;
            this.cacheWidth = width;
            this.cacheHeight = height;
            this._cacheContext.translate(this.cacheTranslationX, this.cacheTranslationY);
            this._cacheContext.scale(zoomX, zoomY);
            this.zoomX = zoomX;
            this.zoomY = zoomY;
            return true;
          }
          return false;
        },
        /**
         * Sets object's properties from options
         * @param {Object} [options] Options object
         */
        setOptions: function(options) {
          this._setOptions(options);
          this._initGradient(options.fill, "fill");
          this._initGradient(options.stroke, "stroke");
          this._initPattern(options.fill, "fill");
          this._initPattern(options.stroke, "stroke");
        },
        /**
         * Transforms context when rendering an object
         * @param {CanvasRenderingContext2D} ctx Context
         */
        transform: function(ctx) {
          var needFullTransform = this.group && !this.group._transformDone || this.group && this.canvas && ctx === this.canvas.contextTop;
          var m = this.calcTransformMatrix(!needFullTransform);
          ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        },
        /**
         * Returns an object representation of an instance
         * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
         * @return {Object} Object representation of an instance
         */
        toObject: function(propertiesToInclude) {
          var NUM_FRACTION_DIGITS = fabric22.Object.NUM_FRACTION_DIGITS, object = {
            type: this.type,
            version: fabric22.version,
            originX: this.originX,
            originY: this.originY,
            left: toFixed(this.left, NUM_FRACTION_DIGITS),
            top: toFixed(this.top, NUM_FRACTION_DIGITS),
            width: toFixed(this.width, NUM_FRACTION_DIGITS),
            height: toFixed(this.height, NUM_FRACTION_DIGITS),
            fill: this.fill && this.fill.toObject ? this.fill.toObject() : this.fill,
            stroke: this.stroke && this.stroke.toObject ? this.stroke.toObject() : this.stroke,
            strokeWidth: toFixed(this.strokeWidth, NUM_FRACTION_DIGITS),
            strokeDashArray: this.strokeDashArray ? this.strokeDashArray.concat() : this.strokeDashArray,
            strokeLineCap: this.strokeLineCap,
            strokeDashOffset: this.strokeDashOffset,
            strokeLineJoin: this.strokeLineJoin,
            strokeUniform: this.strokeUniform,
            strokeMiterLimit: toFixed(this.strokeMiterLimit, NUM_FRACTION_DIGITS),
            scaleX: toFixed(this.scaleX, NUM_FRACTION_DIGITS),
            scaleY: toFixed(this.scaleY, NUM_FRACTION_DIGITS),
            angle: toFixed(this.angle, NUM_FRACTION_DIGITS),
            flipX: this.flipX,
            flipY: this.flipY,
            opacity: toFixed(this.opacity, NUM_FRACTION_DIGITS),
            shadow: this.shadow && this.shadow.toObject ? this.shadow.toObject() : this.shadow,
            visible: this.visible,
            backgroundColor: this.backgroundColor,
            fillRule: this.fillRule,
            paintFirst: this.paintFirst,
            globalCompositeOperation: this.globalCompositeOperation,
            skewX: toFixed(this.skewX, NUM_FRACTION_DIGITS),
            skewY: toFixed(this.skewY, NUM_FRACTION_DIGITS)
          };
          if (this.clipPath && !this.clipPath.excludeFromExport) {
            object.clipPath = this.clipPath.toObject(propertiesToInclude);
            object.clipPath.inverted = this.clipPath.inverted;
            object.clipPath.absolutePositioned = this.clipPath.absolutePositioned;
          }
          fabric22.util.populateWithProperties(this, object, propertiesToInclude);
          if (!this.includeDefaultValues) {
            object = this._removeDefaultValues(object);
          }
          return object;
        },
        /**
         * Returns (dataless) object representation of an instance
         * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
         * @return {Object} Object representation of an instance
         */
        toDatalessObject: function(propertiesToInclude) {
          return this.toObject(propertiesToInclude);
        },
        /**
         * @private
         * @param {Object} object
         */
        _removeDefaultValues: function(object) {
          var prototype = fabric22.util.getKlass(object.type).prototype, stateProperties = prototype.stateProperties;
          stateProperties.forEach(function(prop) {
            if (prop === "left" || prop === "top") {
              return;
            }
            if (object[prop] === prototype[prop]) {
              delete object[prop];
            }
            if (Array.isArray(object[prop]) && Array.isArray(prototype[prop]) && object[prop].length === 0 && prototype[prop].length === 0) {
              delete object[prop];
            }
          });
          return object;
        },
        /**
         * Returns a string representation of an instance
         * @return {String}
         */
        toString: function() {
          return "#<fabric." + capitalize(this.type) + ">";
        },
        /**
         * Return the object scale factor counting also the group scaling
         * @return {Object} object with scaleX and scaleY properties
         */
        getObjectScaling: function() {
          if (!this.group) {
            return {
              scaleX: this.scaleX,
              scaleY: this.scaleY
            };
          }
          var options = fabric22.util.qrDecompose(this.calcTransformMatrix());
          return { scaleX: Math.abs(options.scaleX), scaleY: Math.abs(options.scaleY) };
        },
        /**
         * Return the object scale factor counting also the group scaling, zoom and retina
         * @return {Object} object with scaleX and scaleY properties
         */
        getTotalObjectScaling: function() {
          var scale = this.getObjectScaling(), scaleX = scale.scaleX, scaleY = scale.scaleY;
          if (this.canvas) {
            var zoom = this.canvas.getZoom();
            var retina = this.canvas.getRetinaScaling();
            scaleX *= zoom * retina;
            scaleY *= zoom * retina;
          }
          return { scaleX, scaleY };
        },
        /**
         * Return the object opacity counting also the group property
         * @return {Number}
         */
        getObjectOpacity: function() {
          var opacity = this.opacity;
          if (this.group) {
            opacity *= this.group.getObjectOpacity();
          }
          return opacity;
        },
        /**
         * @private
         * @param {String} key
         * @param {*} value
         * @return {fabric.Object} thisArg
         */
        _set: function(key, value) {
          var shouldConstrainValue = key === "scaleX" || key === "scaleY", isChanged = this[key] !== value, groupNeedsUpdate = false;
          if (shouldConstrainValue) {
            value = this._constrainScale(value);
          }
          if (key === "scaleX" && value < 0) {
            this.flipX = !this.flipX;
            value *= -1;
          } else if (key === "scaleY" && value < 0) {
            this.flipY = !this.flipY;
            value *= -1;
          } else if (key === "shadow" && value && !(value instanceof fabric22.Shadow)) {
            value = new fabric22.Shadow(value);
          } else if (key === "dirty" && this.group) {
            this.group.set("dirty", value);
          }
          this[key] = value;
          if (isChanged) {
            groupNeedsUpdate = this.group && this.group.isOnACache();
            if (this.cacheProperties.indexOf(key) > -1) {
              this.dirty = true;
              groupNeedsUpdate && this.group.set("dirty", true);
            } else if (groupNeedsUpdate && this.stateProperties.indexOf(key) > -1) {
              this.group.set("dirty", true);
            }
          }
          return this;
        },
        /**
         * This callback function is called by the parent group of an object every
         * time a non-delegated property changes on the group. It is passed the key
         * and value as parameters. Not adding in this function's signature to avoid
         * Travis build error about unused variables.
         */
        setOnGroup: function() {
        },
        /**
         * Retrieves viewportTransform from Object's canvas if possible
         * @method getViewportTransform
         * @memberOf fabric.Object.prototype
         * @return {Array}
         */
        getViewportTransform: function() {
          if (this.canvas && this.canvas.viewportTransform) {
            return this.canvas.viewportTransform;
          }
          return fabric22.iMatrix.concat();
        },
        /*
         * @private
         * return if the object would be visible in rendering
         * @memberOf fabric.Object.prototype
         * @return {Boolean}
         */
        isNotVisible: function() {
          return this.opacity === 0 || !this.width && !this.height && this.strokeWidth === 0 || !this.visible;
        },
        /**
         * Renders an object on a specified context
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        render: function(ctx) {
          if (this.isNotVisible()) {
            return;
          }
          if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) {
            return;
          }
          ctx.save();
          this._setupCompositeOperation(ctx);
          this.drawSelectionBackground(ctx);
          this.transform(ctx);
          this._setOpacity(ctx);
          this._setShadow(ctx, this);
          if (this.shouldCache()) {
            this.renderCache();
            this.drawCacheOnCanvas(ctx);
          } else {
            this._removeCacheCanvas();
            this.dirty = false;
            this.drawObject(ctx);
            if (this.objectCaching && this.statefullCache) {
              this.saveState({ propertySet: "cacheProperties" });
            }
          }
          ctx.restore();
        },
        renderCache: function(options) {
          options = options || {};
          if (!this._cacheCanvas || !this._cacheContext) {
            this._createCacheCanvas();
          }
          if (this.isCacheDirty()) {
            this.statefullCache && this.saveState({ propertySet: "cacheProperties" });
            this.drawObject(this._cacheContext, options.forClipping);
            this.dirty = false;
          }
        },
        /**
         * Remove cacheCanvas and its dimensions from the objects
         */
        _removeCacheCanvas: function() {
          this._cacheCanvas = null;
          this._cacheContext = null;
          this.cacheWidth = 0;
          this.cacheHeight = 0;
        },
        /**
         * return true if the object will draw a stroke
         * Does not consider text styles. This is just a shortcut used at rendering time
         * We want it to be an approximation and be fast.
         * wrote to avoid extra caching, it has to return true when stroke happens,
         * can guess when it will not happen at 100% chance, does not matter if it misses
         * some use case where the stroke is invisible.
         * @since 3.0.0
         * @returns Boolean
         */
        hasStroke: function() {
          return this.stroke && this.stroke !== "transparent" && this.strokeWidth !== 0;
        },
        /**
         * return true if the object will draw a fill
         * Does not consider text styles. This is just a shortcut used at rendering time
         * We want it to be an approximation and be fast.
         * wrote to avoid extra caching, it has to return true when fill happens,
         * can guess when it will not happen at 100% chance, does not matter if it misses
         * some use case where the fill is invisible.
         * @since 3.0.0
         * @returns Boolean
         */
        hasFill: function() {
          return this.fill && this.fill !== "transparent";
        },
        /**
         * When set to `true`, force the object to have its own cache, even if it is inside a group
         * it may be needed when your object behave in a particular way on the cache and always needs
         * its own isolated canvas to render correctly.
         * Created to be overridden
         * since 1.7.12
         * @returns Boolean
         */
        needsItsOwnCache: function() {
          if (this.paintFirst === "stroke" && this.hasFill() && this.hasStroke() && typeof this.shadow === "object") {
            return true;
          }
          if (this.clipPath) {
            return true;
          }
          return false;
        },
        /**
         * Decide if the object should cache or not. Create its own cache level
         * objectCaching is a global flag, wins over everything
         * needsItsOwnCache should be used when the object drawing method requires
         * a cache step. None of the fabric classes requires it.
         * Generally you do not cache objects in groups because the group outside is cached.
         * Read as: cache if is needed, or if the feature is enabled but we are not already caching.
         * @return {Boolean}
         */
        shouldCache: function() {
          this.ownCaching = this.needsItsOwnCache() || this.objectCaching && (!this.group || !this.group.isOnACache());
          return this.ownCaching;
        },
        /**
         * Check if this object or a child object will cast a shadow
         * used by Group.shouldCache to know if child has a shadow recursively
         * @return {Boolean}
         */
        willDrawShadow: function() {
          return !!this.shadow && (this.shadow.offsetX !== 0 || this.shadow.offsetY !== 0);
        },
        /**
         * Execute the drawing operation for an object clipPath
         * @param {CanvasRenderingContext2D} ctx Context to render on
         * @param {fabric.Object} clipPath
         */
        drawClipPathOnCache: function(ctx, clipPath) {
          ctx.save();
          if (clipPath.inverted) {
            ctx.globalCompositeOperation = "destination-out";
          } else {
            ctx.globalCompositeOperation = "destination-in";
          }
          if (clipPath.absolutePositioned) {
            var m = fabric22.util.invertTransform(this.calcTransformMatrix());
            ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
          }
          clipPath.transform(ctx);
          ctx.scale(1 / clipPath.zoomX, 1 / clipPath.zoomY);
          ctx.drawImage(clipPath._cacheCanvas, -clipPath.cacheTranslationX, -clipPath.cacheTranslationY);
          ctx.restore();
        },
        /**
         * Execute the drawing operation for an object on a specified context
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        drawObject: function(ctx, forClipping) {
          var originalFill = this.fill, originalStroke = this.stroke;
          if (forClipping) {
            this.fill = "black";
            this.stroke = "";
            this._setClippingProperties(ctx);
          } else {
            this._renderBackground(ctx);
          }
          this._render(ctx);
          this._drawClipPath(ctx, this.clipPath);
          this.fill = originalFill;
          this.stroke = originalStroke;
        },
        /**
         * Prepare clipPath state and cache and draw it on instance's cache
         * @param {CanvasRenderingContext2D} ctx
         * @param {fabric.Object} clipPath
         */
        _drawClipPath: function(ctx, clipPath) {
          if (!clipPath) {
            return;
          }
          clipPath.canvas = this.canvas;
          clipPath.shouldCache();
          clipPath._transformDone = true;
          clipPath.renderCache({ forClipping: true });
          this.drawClipPathOnCache(ctx, clipPath);
        },
        /**
         * Paint the cached copy of the object on the target context.
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        drawCacheOnCanvas: function(ctx) {
          ctx.scale(1 / this.zoomX, 1 / this.zoomY);
          ctx.drawImage(this._cacheCanvas, -this.cacheTranslationX, -this.cacheTranslationY);
        },
        /**
         * Check if cache is dirty
         * @param {Boolean} skipCanvas skip canvas checks because this object is painted
         * on parent canvas.
         */
        isCacheDirty: function(skipCanvas) {
          if (this.isNotVisible()) {
            return false;
          }
          if (this._cacheCanvas && this._cacheContext && !skipCanvas && this._updateCacheCanvas()) {
            return true;
          } else {
            if (this.dirty || this.clipPath && this.clipPath.absolutePositioned || this.statefullCache && this.hasStateChanged("cacheProperties")) {
              if (this._cacheCanvas && this._cacheContext && !skipCanvas) {
                var width = this.cacheWidth / this.zoomX;
                var height = this.cacheHeight / this.zoomY;
                this._cacheContext.clearRect(-width / 2, -height / 2, width, height);
              }
              return true;
            }
          }
          return false;
        },
        /**
         * Draws a background for the object big as its untransformed dimensions
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _renderBackground: function(ctx) {
          if (!this.backgroundColor) {
            return;
          }
          var dim = this._getNonTransformedDimensions();
          ctx.fillStyle = this.backgroundColor;
          ctx.fillRect(
            -dim.x / 2,
            -dim.y / 2,
            dim.x,
            dim.y
          );
          this._removeShadow(ctx);
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _setOpacity: function(ctx) {
          if (this.group && !this.group._transformDone) {
            ctx.globalAlpha = this.getObjectOpacity();
          } else {
            ctx.globalAlpha *= this.opacity;
          }
        },
        _setStrokeStyles: function(ctx, decl) {
          var stroke = decl.stroke;
          if (stroke) {
            ctx.lineWidth = decl.strokeWidth;
            ctx.lineCap = decl.strokeLineCap;
            ctx.lineDashOffset = decl.strokeDashOffset;
            ctx.lineJoin = decl.strokeLineJoin;
            ctx.miterLimit = decl.strokeMiterLimit;
            if (stroke.toLive) {
              if (stroke.gradientUnits === "percentage" || stroke.gradientTransform || stroke.patternTransform) {
                this._applyPatternForTransformedGradient(ctx, stroke);
              } else {
                ctx.strokeStyle = stroke.toLive(ctx, this);
                this._applyPatternGradientTransform(ctx, stroke);
              }
            } else {
              ctx.strokeStyle = decl.stroke;
            }
          }
        },
        _setFillStyles: function(ctx, decl) {
          var fill = decl.fill;
          if (fill) {
            if (fill.toLive) {
              ctx.fillStyle = fill.toLive(ctx, this);
              this._applyPatternGradientTransform(ctx, decl.fill);
            } else {
              ctx.fillStyle = fill;
            }
          }
        },
        _setClippingProperties: function(ctx) {
          ctx.globalAlpha = 1;
          ctx.strokeStyle = "transparent";
          ctx.fillStyle = "#000000";
        },
        /**
         * @private
         * Sets line dash
         * @param {CanvasRenderingContext2D} ctx Context to set the dash line on
         * @param {Array} dashArray array representing dashes
         */
        _setLineDash: function(ctx, dashArray) {
          if (!dashArray || dashArray.length === 0) {
            return;
          }
          if (1 & dashArray.length) {
            dashArray.push.apply(dashArray, dashArray);
          }
          ctx.setLineDash(dashArray);
        },
        /**
         * Renders controls and borders for the object
         * the context here is not transformed
         * @param {CanvasRenderingContext2D} ctx Context to render on
         * @param {Object} [styleOverride] properties to override the object style
         */
        _renderControls: function(ctx, styleOverride) {
          var vpt = this.getViewportTransform(), matrix2 = this.calcTransformMatrix(), options, drawBorders, drawControls;
          styleOverride = styleOverride || {};
          drawBorders = typeof styleOverride.hasBorders !== "undefined" ? styleOverride.hasBorders : this.hasBorders;
          drawControls = typeof styleOverride.hasControls !== "undefined" ? styleOverride.hasControls : this.hasControls;
          matrix2 = fabric22.util.multiplyTransformMatrices(vpt, matrix2);
          options = fabric22.util.qrDecompose(matrix2);
          ctx.save();
          ctx.translate(options.translateX, options.translateY);
          ctx.lineWidth = 1 * this.borderScaleFactor;
          if (!this.group) {
            ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
          }
          if (this.flipX) {
            options.angle -= 180;
          }
          ctx.rotate(degreesToRadians(this.group ? options.angle : this.angle));
          if (styleOverride.forActiveSelection || this.group) {
            drawBorders && this.drawBordersInGroup(ctx, options, styleOverride);
          } else {
            drawBorders && this.drawBorders(ctx, styleOverride);
          }
          drawControls && this.drawControls(ctx, styleOverride);
          ctx.restore();
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _setShadow: function(ctx) {
          if (!this.shadow) {
            return;
          }
          var shadow = this.shadow, canvas = this.canvas, scaling, multX = canvas && canvas.viewportTransform[0] || 1, multY = canvas && canvas.viewportTransform[3] || 1;
          if (shadow.nonScaling) {
            scaling = { scaleX: 1, scaleY: 1 };
          } else {
            scaling = this.getObjectScaling();
          }
          if (canvas && canvas._isRetinaScaling()) {
            multX *= fabric22.devicePixelRatio;
            multY *= fabric22.devicePixelRatio;
          }
          ctx.shadowColor = shadow.color;
          ctx.shadowBlur = shadow.blur * fabric22.browserShadowBlurConstant * (multX + multY) * (scaling.scaleX + scaling.scaleY) / 4;
          ctx.shadowOffsetX = shadow.offsetX * multX * scaling.scaleX;
          ctx.shadowOffsetY = shadow.offsetY * multY * scaling.scaleY;
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _removeShadow: function(ctx) {
          if (!this.shadow) {
            return;
          }
          ctx.shadowColor = "";
          ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         * @param {Object} filler fabric.Pattern or fabric.Gradient
         * @return {Object} offset.offsetX offset for text rendering
         * @return {Object} offset.offsetY offset for text rendering
         */
        _applyPatternGradientTransform: function(ctx, filler) {
          if (!filler || !filler.toLive) {
            return { offsetX: 0, offsetY: 0 };
          }
          var t = filler.gradientTransform || filler.patternTransform;
          var offsetX = -this.width / 2 + filler.offsetX || 0, offsetY = -this.height / 2 + filler.offsetY || 0;
          if (filler.gradientUnits === "percentage") {
            ctx.transform(this.width, 0, 0, this.height, offsetX, offsetY);
          } else {
            ctx.transform(1, 0, 0, 1, offsetX, offsetY);
          }
          if (t) {
            ctx.transform(t[0], t[1], t[2], t[3], t[4], t[5]);
          }
          return { offsetX, offsetY };
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _renderPaintInOrder: function(ctx) {
          if (this.paintFirst === "stroke") {
            this._renderStroke(ctx);
            this._renderFill(ctx);
          } else {
            this._renderFill(ctx);
            this._renderStroke(ctx);
          }
        },
        /**
         * @private
         * function that actually render something on the context.
         * empty here to allow Obects to work on tests to benchmark fabric functionalites
         * not related to rendering
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _render: function() {
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _renderFill: function(ctx) {
          if (!this.fill) {
            return;
          }
          ctx.save();
          this._setFillStyles(ctx, this);
          if (this.fillRule === "evenodd") {
            ctx.fill("evenodd");
          } else {
            ctx.fill();
          }
          ctx.restore();
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _renderStroke: function(ctx) {
          if (!this.stroke || this.strokeWidth === 0) {
            return;
          }
          if (this.shadow && !this.shadow.affectStroke) {
            this._removeShadow(ctx);
          }
          ctx.save();
          if (this.strokeUniform && this.group) {
            var scaling = this.getObjectScaling();
            ctx.scale(1 / scaling.scaleX, 1 / scaling.scaleY);
          } else if (this.strokeUniform) {
            ctx.scale(1 / this.scaleX, 1 / this.scaleY);
          }
          this._setLineDash(ctx, this.strokeDashArray);
          this._setStrokeStyles(ctx, this);
          ctx.stroke();
          ctx.restore();
        },
        /**
         * This function try to patch the missing gradientTransform on canvas gradients.
         * transforming a context to transform the gradient, is going to transform the stroke too.
         * we want to transform the gradient but not the stroke operation, so we create
         * a transformed gradient on a pattern and then we use the pattern instead of the gradient.
         * this method has drwabacks: is slow, is in low resolution, needs a patch for when the size
         * is limited.
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         * @param {fabric.Gradient} filler a fabric gradient instance
         */
        _applyPatternForTransformedGradient: function(ctx, filler) {
          var dims = this._limitCacheSize(this._getCacheCanvasDimensions()), pCanvas = fabric22.util.createCanvasElement(), pCtx, retinaScaling = this.canvas.getRetinaScaling(), width = dims.x / this.scaleX / retinaScaling, height = dims.y / this.scaleY / retinaScaling;
          pCanvas.width = width;
          pCanvas.height = height;
          pCtx = pCanvas.getContext("2d");
          pCtx.beginPath();
          pCtx.moveTo(0, 0);
          pCtx.lineTo(width, 0);
          pCtx.lineTo(width, height);
          pCtx.lineTo(0, height);
          pCtx.closePath();
          pCtx.translate(width / 2, height / 2);
          pCtx.scale(
            dims.zoomX / this.scaleX / retinaScaling,
            dims.zoomY / this.scaleY / retinaScaling
          );
          this._applyPatternGradientTransform(pCtx, filler);
          pCtx.fillStyle = filler.toLive(ctx);
          pCtx.fill();
          ctx.translate(-this.width / 2 - this.strokeWidth / 2, -this.height / 2 - this.strokeWidth / 2);
          ctx.scale(
            retinaScaling * this.scaleX / dims.zoomX,
            retinaScaling * this.scaleY / dims.zoomY
          );
          ctx.strokeStyle = pCtx.createPattern(pCanvas, "no-repeat");
        },
        /**
         * This function is an helper for svg import. it returns the center of the object in the svg
         * untransformed coordinates
         * @private
         * @return {Object} center point from element coordinates
         */
        _findCenterFromElement: function() {
          return { x: this.left + this.width / 2, y: this.top + this.height / 2 };
        },
        /**
         * This function is an helper for svg import. it decompose the transformMatrix
         * and assign properties to object.
         * untransformed coordinates
         * @private
         * @chainable
         */
        _assignTransformMatrixProps: function() {
          if (this.transformMatrix) {
            var options = fabric22.util.qrDecompose(this.transformMatrix);
            this.flipX = false;
            this.flipY = false;
            this.set("scaleX", options.scaleX);
            this.set("scaleY", options.scaleY);
            this.angle = options.angle;
            this.skewX = options.skewX;
            this.skewY = 0;
          }
        },
        /**
         * This function is an helper for svg import. it removes the transform matrix
         * and set to object properties that fabricjs can handle
         * @private
         * @param {Object} preserveAspectRatioOptions
         * @return {thisArg}
         */
        _removeTransformMatrix: function(preserveAspectRatioOptions) {
          var center = this._findCenterFromElement();
          if (this.transformMatrix) {
            this._assignTransformMatrixProps();
            center = fabric22.util.transformPoint(center, this.transformMatrix);
          }
          this.transformMatrix = null;
          if (preserveAspectRatioOptions) {
            this.scaleX *= preserveAspectRatioOptions.scaleX;
            this.scaleY *= preserveAspectRatioOptions.scaleY;
            this.cropX = preserveAspectRatioOptions.cropX;
            this.cropY = preserveAspectRatioOptions.cropY;
            center.x += preserveAspectRatioOptions.offsetLeft;
            center.y += preserveAspectRatioOptions.offsetTop;
            this.width = preserveAspectRatioOptions.width;
            this.height = preserveAspectRatioOptions.height;
          }
          this.setPositionByOrigin(center, "center", "center");
        },
        /**
         * Clones an instance, using a callback method will work for every object.
         * @param {Function} callback Callback is invoked with a clone as a first argument
         * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
         */
        clone: function(callback, propertiesToInclude) {
          var objectForm = this.toObject(propertiesToInclude);
          if (this.constructor.fromObject) {
            this.constructor.fromObject(objectForm, callback);
          } else {
            fabric22.Object._fromObject("Object", objectForm, callback);
          }
        },
        /**
         * Creates an instance of fabric.Image out of an object
         * makes use of toCanvasElement.
         * Once this method was based on toDataUrl and loadImage, so it also had a quality
         * and format option. toCanvasElement is faster and produce no loss of quality.
         * If you need to get a real Jpeg or Png from an object, using toDataURL is the right way to do it.
         * toCanvasElement and then toBlob from the obtained canvas is also a good option.
         * This method is sync now, but still support the callback because we did not want to break.
         * When fabricJS 5.0 will be planned, this will probably be changed to not have a callback.
         * @param {Function} callback callback, invoked with an instance as a first argument
         * @param {Object} [options] for clone as image, passed to toDataURL
         * @param {Number} [options.multiplier=1] Multiplier to scale by
         * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
         * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
         * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
         * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
         * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
         * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
         * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
         * @return {fabric.Object} thisArg
         */
        cloneAsImage: function(callback, options) {
          var canvasEl = this.toCanvasElement(options);
          if (callback) {
            callback(new fabric22.Image(canvasEl));
          }
          return this;
        },
        /**
         * Converts an object into a HTMLCanvas element
         * @param {Object} options Options object
         * @param {Number} [options.multiplier=1] Multiplier to scale by
         * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
         * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
         * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
         * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
         * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
         * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
         * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
         * @return {HTMLCanvasElement} Returns DOM element <canvas> with the fabric.Object
         */
        toCanvasElement: function(options) {
          options || (options = {});
          var utils = fabric22.util, origParams = utils.saveObjectTransform(this), originalGroup = this.group, originalShadow = this.shadow, abs2 = Math.abs, multiplier = (options.multiplier || 1) * (options.enableRetinaScaling ? fabric22.devicePixelRatio : 1);
          delete this.group;
          if (options.withoutTransform) {
            utils.resetObjectTransform(this);
          }
          if (options.withoutShadow) {
            this.shadow = null;
          }
          var el = fabric22.util.createCanvasElement(), boundingRect = this.getBoundingRect(true, true), shadow = this.shadow, scaling, shadowOffset = { x: 0, y: 0 }, shadowBlur, width, height;
          if (shadow) {
            shadowBlur = shadow.blur;
            if (shadow.nonScaling) {
              scaling = { scaleX: 1, scaleY: 1 };
            } else {
              scaling = this.getObjectScaling();
            }
            shadowOffset.x = 2 * Math.round(abs2(shadow.offsetX) + shadowBlur) * abs2(scaling.scaleX);
            shadowOffset.y = 2 * Math.round(abs2(shadow.offsetY) + shadowBlur) * abs2(scaling.scaleY);
          }
          width = boundingRect.width + shadowOffset.x;
          height = boundingRect.height + shadowOffset.y;
          el.width = Math.ceil(width);
          el.height = Math.ceil(height);
          var canvas = new fabric22.StaticCanvas(el, {
            enableRetinaScaling: false,
            renderOnAddRemove: false,
            skipOffscreen: false
          });
          if (options.format === "jpeg") {
            canvas.backgroundColor = "#fff";
          }
          this.setPositionByOrigin(new fabric22.Point(canvas.width / 2, canvas.height / 2), "center", "center");
          var originalCanvas = this.canvas;
          canvas.add(this);
          var canvasEl = canvas.toCanvasElement(multiplier || 1, options);
          this.shadow = originalShadow;
          this.set("canvas", originalCanvas);
          if (originalGroup) {
            this.group = originalGroup;
          }
          this.set(origParams).setCoords();
          canvas._objects = [];
          canvas.dispose();
          canvas = null;
          return canvasEl;
        },
        /**
         * Converts an object into a data-url-like string
         * @param {Object} options Options object
         * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
         * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
         * @param {Number} [options.multiplier=1] Multiplier to scale by
         * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
         * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
         * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
         * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
         * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
         * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
         * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
         * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
         */
        toDataURL: function(options) {
          options || (options = {});
          return fabric22.util.toDataURL(this.toCanvasElement(options), options.format || "png", options.quality || 1);
        },
        /**
         * Returns true if specified type is identical to the type of an instance
         * @param {String} type Type to check against
         * @return {Boolean}
         */
        isType: function(type) {
          return arguments.length > 1 ? Array.from(arguments).includes(this.type) : this.type === type;
        },
        /**
         * Returns complexity of an instance
         * @return {Number} complexity of this instance (is 1 unless subclassed)
         */
        complexity: function() {
          return 1;
        },
        /**
         * Returns a JSON representation of an instance
         * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
         * @return {Object} JSON
         */
        toJSON: function(propertiesToInclude) {
          return this.toObject(propertiesToInclude);
        },
        /**
         * Sets "angle" of an instance with centered rotation
         * @param {Number} angle Angle value (in degrees)
         * @return {fabric.Object} thisArg
         * @chainable
         */
        rotate: function(angle) {
          var shouldCenterOrigin = (this.originX !== "center" || this.originY !== "center") && this.centeredRotation;
          if (shouldCenterOrigin) {
            this._setOriginToCenter();
          }
          this.set("angle", angle);
          if (shouldCenterOrigin) {
            this._resetOrigin();
          }
          return this;
        },
        /**
         * Centers object horizontally on canvas to which it was added last.
         * You might need to call `setCoords` on an object after centering, to update controls area.
         * @return {fabric.Object} thisArg
         * @chainable
         */
        centerH: function() {
          this.canvas && this.canvas.centerObjectH(this);
          return this;
        },
        /**
         * Centers object horizontally on current viewport of canvas to which it was added last.
         * You might need to call `setCoords` on an object after centering, to update controls area.
         * @return {fabric.Object} thisArg
         * @chainable
         */
        viewportCenterH: function() {
          this.canvas && this.canvas.viewportCenterObjectH(this);
          return this;
        },
        /**
         * Centers object vertically on canvas to which it was added last.
         * You might need to call `setCoords` on an object after centering, to update controls area.
         * @return {fabric.Object} thisArg
         * @chainable
         */
        centerV: function() {
          this.canvas && this.canvas.centerObjectV(this);
          return this;
        },
        /**
         * Centers object vertically on current viewport of canvas to which it was added last.
         * You might need to call `setCoords` on an object after centering, to update controls area.
         * @return {fabric.Object} thisArg
         * @chainable
         */
        viewportCenterV: function() {
          this.canvas && this.canvas.viewportCenterObjectV(this);
          return this;
        },
        /**
         * Centers object vertically and horizontally on canvas to which is was added last
         * You might need to call `setCoords` on an object after centering, to update controls area.
         * @return {fabric.Object} thisArg
         * @chainable
         */
        center: function() {
          this.canvas && this.canvas.centerObject(this);
          return this;
        },
        /**
         * Centers object on current viewport of canvas to which it was added last.
         * You might need to call `setCoords` on an object after centering, to update controls area.
         * @return {fabric.Object} thisArg
         * @chainable
         */
        viewportCenter: function() {
          this.canvas && this.canvas.viewportCenterObject(this);
          return this;
        },
        /**
         * Returns coordinates of a pointer relative to an object
         * @param {Event} e Event to operate upon
         * @param {Object} [pointer] Pointer to operate upon (instead of event)
         * @return {Object} Coordinates of a pointer (x, y)
         */
        getLocalPointer: function(e, pointer) {
          pointer = pointer || this.canvas.getPointer(e);
          var pClicked = new fabric22.Point(pointer.x, pointer.y), objectLeftTop = this._getLeftTopCoords();
          if (this.angle) {
            pClicked = fabric22.util.rotatePoint(
              pClicked,
              objectLeftTop,
              degreesToRadians(-this.angle)
            );
          }
          return {
            x: pClicked.x - objectLeftTop.x,
            y: pClicked.y - objectLeftTop.y
          };
        },
        /**
         * Sets canvas globalCompositeOperation for specific object
         * custom composition operation for the particular object can be specified using globalCompositeOperation property
         * @param {CanvasRenderingContext2D} ctx Rendering canvas context
         */
        _setupCompositeOperation: function(ctx) {
          if (this.globalCompositeOperation) {
            ctx.globalCompositeOperation = this.globalCompositeOperation;
          }
        },
        /**
         * cancel instance's running animations
         * override if necessary to dispose artifacts such as `clipPath`
         */
        dispose: function() {
          if (fabric22.runningAnimations) {
            fabric22.runningAnimations.cancelByTarget(this);
          }
        }
      }
    );
    fabric22.util.createAccessors && fabric22.util.createAccessors(fabric22.Object);
    extend(fabric22.Object.prototype, fabric22.Observable);
    fabric22.Object.NUM_FRACTION_DIGITS = 2;
    fabric22.Object.ENLIVEN_PROPS = ["clipPath"];
    fabric22.Object._fromObject = function(className, object, callback, extraParam) {
      var klass = fabric22[className];
      object = clone2(object, true);
      fabric22.util.enlivenPatterns([object.fill, object.stroke], function(patterns) {
        if (typeof patterns[0] !== "undefined") {
          object.fill = patterns[0];
        }
        if (typeof patterns[1] !== "undefined") {
          object.stroke = patterns[1];
        }
        fabric22.util.enlivenObjectEnlivables(object, object, function() {
          var instance = extraParam ? new klass(object[extraParam], object) : new klass(object);
          callback && callback(instance);
        });
      });
    };
    fabric22.Object.__uid = 0;
  })(exports);
  (function() {
    var degreesToRadians = fabric2.util.degreesToRadians, originXOffset = {
      left: -0.5,
      center: 0,
      right: 0.5
    }, originYOffset = {
      top: -0.5,
      center: 0,
      bottom: 0.5
    };
    fabric2.util.object.extend(
      fabric2.Object.prototype,
      /** @lends fabric.Object.prototype */
      {
        /**
         * Translates the coordinates from a set of origin to another (based on the object's dimensions)
         * @param {fabric.Point} point The point which corresponds to the originX and originY params
         * @param {String} fromOriginX Horizontal origin: 'left', 'center' or 'right'
         * @param {String} fromOriginY Vertical origin: 'top', 'center' or 'bottom'
         * @param {String} toOriginX Horizontal origin: 'left', 'center' or 'right'
         * @param {String} toOriginY Vertical origin: 'top', 'center' or 'bottom'
         * @return {fabric.Point}
         */
        translateToGivenOrigin: function(point, fromOriginX, fromOriginY, toOriginX, toOriginY) {
          var x = point.x, y = point.y, offsetX, offsetY, dim;
          if (typeof fromOriginX === "string") {
            fromOriginX = originXOffset[fromOriginX];
          } else {
            fromOriginX -= 0.5;
          }
          if (typeof toOriginX === "string") {
            toOriginX = originXOffset[toOriginX];
          } else {
            toOriginX -= 0.5;
          }
          offsetX = toOriginX - fromOriginX;
          if (typeof fromOriginY === "string") {
            fromOriginY = originYOffset[fromOriginY];
          } else {
            fromOriginY -= 0.5;
          }
          if (typeof toOriginY === "string") {
            toOriginY = originYOffset[toOriginY];
          } else {
            toOriginY -= 0.5;
          }
          offsetY = toOriginY - fromOriginY;
          if (offsetX || offsetY) {
            dim = this._getTransformedDimensions();
            x = point.x + offsetX * dim.x;
            y = point.y + offsetY * dim.y;
          }
          return new fabric2.Point(x, y);
        },
        /**
         * Translates the coordinates from origin to center coordinates (based on the object's dimensions)
         * @param {fabric.Point} point The point which corresponds to the originX and originY params
         * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
         * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
         * @return {fabric.Point}
         */
        translateToCenterPoint: function(point, originX, originY) {
          var p = this.translateToGivenOrigin(point, originX, originY, "center", "center");
          if (this.angle) {
            return fabric2.util.rotatePoint(p, point, degreesToRadians(this.angle));
          }
          return p;
        },
        /**
         * Translates the coordinates from center to origin coordinates (based on the object's dimensions)
         * @param {fabric.Point} center The point which corresponds to center of the object
         * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
         * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
         * @return {fabric.Point}
         */
        translateToOriginPoint: function(center, originX, originY) {
          var p = this.translateToGivenOrigin(center, "center", "center", originX, originY);
          if (this.angle) {
            return fabric2.util.rotatePoint(p, center, degreesToRadians(this.angle));
          }
          return p;
        },
        /**
         * Returns the real center coordinates of the object
         * @return {fabric.Point}
         */
        getCenterPoint: function() {
          var leftTop = new fabric2.Point(this.left, this.top);
          return this.translateToCenterPoint(leftTop, this.originX, this.originY);
        },
        /**
         * Returns the coordinates of the object based on center coordinates
         * @param {fabric.Point} point The point which corresponds to the originX and originY params
         * @return {fabric.Point}
         */
        // getOriginPoint: function(center) {
        //   return this.translateToOriginPoint(center, this.originX, this.originY);
        // },
        /**
         * Returns the coordinates of the object as if it has a different origin
         * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
         * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
         * @return {fabric.Point}
         */
        getPointByOrigin: function(originX, originY) {
          var center = this.getCenterPoint();
          return this.translateToOriginPoint(center, originX, originY);
        },
        /**
         * Returns the point in local coordinates
         * @param {fabric.Point} point The point relative to the global coordinate system
         * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
         * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
         * @return {fabric.Point}
         */
        toLocalPoint: function(point, originX, originY) {
          var center = this.getCenterPoint(), p, p2;
          if (typeof originX !== "undefined" && typeof originY !== "undefined") {
            p = this.translateToGivenOrigin(center, "center", "center", originX, originY);
          } else {
            p = new fabric2.Point(this.left, this.top);
          }
          p2 = new fabric2.Point(point.x, point.y);
          if (this.angle) {
            p2 = fabric2.util.rotatePoint(p2, center, -degreesToRadians(this.angle));
          }
          return p2.subtractEquals(p);
        },
        /**
         * Returns the point in global coordinates
         * @param {fabric.Point} The point relative to the local coordinate system
         * @return {fabric.Point}
         */
        // toGlobalPoint: function(point) {
        //   return fabric.util.rotatePoint(point, this.getCenterPoint(), degreesToRadians(this.angle)).addEquals(new fabric.Point(this.left, this.top));
        // },
        /**
         * Sets the position of the object taking into consideration the object's origin
         * @param {fabric.Point} pos The new position of the object
         * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
         * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
         * @return {void}
         */
        setPositionByOrigin: function(pos, originX, originY) {
          var center = this.translateToCenterPoint(pos, originX, originY), position = this.translateToOriginPoint(center, this.originX, this.originY);
          this.set("left", position.x);
          this.set("top", position.y);
        },
        /**
         * @param {String} to One of 'left', 'center', 'right'
         */
        adjustPosition: function(to) {
          var angle = degreesToRadians(this.angle), hypotFull = this.getScaledWidth(), xFull = fabric2.util.cos(angle) * hypotFull, yFull = fabric2.util.sin(angle) * hypotFull, offsetFrom, offsetTo;
          if (typeof this.originX === "string") {
            offsetFrom = originXOffset[this.originX];
          } else {
            offsetFrom = this.originX - 0.5;
          }
          if (typeof to === "string") {
            offsetTo = originXOffset[to];
          } else {
            offsetTo = to - 0.5;
          }
          this.left += xFull * (offsetTo - offsetFrom);
          this.top += yFull * (offsetTo - offsetFrom);
          this.setCoords();
          this.originX = to;
        },
        /**
         * Sets the origin/position of the object to it's center point
         * @private
         * @return {void}
         */
        _setOriginToCenter: function() {
          this._originalOriginX = this.originX;
          this._originalOriginY = this.originY;
          var center = this.getCenterPoint();
          this.originX = "center";
          this.originY = "center";
          this.left = center.x;
          this.top = center.y;
        },
        /**
         * Resets the origin/position of the object to it's original origin
         * @private
         * @return {void}
         */
        _resetOrigin: function() {
          var originPoint = this.translateToOriginPoint(
            this.getCenterPoint(),
            this._originalOriginX,
            this._originalOriginY
          );
          this.originX = this._originalOriginX;
          this.originY = this._originalOriginY;
          this.left = originPoint.x;
          this.top = originPoint.y;
          this._originalOriginX = null;
          this._originalOriginY = null;
        },
        /**
         * @private
         */
        _getLeftTopCoords: function() {
          return this.translateToOriginPoint(this.getCenterPoint(), "left", "top");
        }
      }
    );
  })();
  (function() {
    function arrayFromCoords(coords) {
      return [
        new fabric2.Point(coords.tl.x, coords.tl.y),
        new fabric2.Point(coords.tr.x, coords.tr.y),
        new fabric2.Point(coords.br.x, coords.br.y),
        new fabric2.Point(coords.bl.x, coords.bl.y)
      ];
    }
    var util = fabric2.util, degreesToRadians = util.degreesToRadians, multiplyMatrices = util.multiplyTransformMatrices, transformPoint = util.transformPoint;
    util.object.extend(
      fabric2.Object.prototype,
      /** @lends fabric.Object.prototype */
      {
        /**
         * Describe object's corner position in canvas element coordinates.
         * properties are depending on control keys and padding the main controls.
         * each property is an object with x, y and corner.
         * The `corner` property contains in a similar manner the 4 points of the
         * interactive area of the corner.
         * The coordinates depends from the controls positionHandler and are used
         * to draw and locate controls
         * @memberOf fabric.Object.prototype
         */
        oCoords: null,
        /**
         * Describe object's corner position in canvas object absolute coordinates
         * properties are tl,tr,bl,br and describe the four main corner.
         * each property is an object with x, y, instance of Fabric.Point.
         * The coordinates depends from this properties: width, height, scaleX, scaleY
         * skewX, skewY, angle, strokeWidth, top, left.
         * Those coordinates are useful to understand where an object is. They get updated
         * with oCoords but they do not need to be updated when zoom or panning change.
         * The coordinates get updated with @method setCoords.
         * You can calculate them without updating with @method calcACoords();
         * @memberOf fabric.Object.prototype
         */
        aCoords: null,
        /**
         * Describe object's corner position in canvas element coordinates.
         * includes padding. Used of object detection.
         * set and refreshed with setCoords.
         * @memberOf fabric.Object.prototype
         */
        lineCoords: null,
        /**
         * storage for object transform matrix
         */
        ownMatrixCache: null,
        /**
         * storage for object full transform matrix
         */
        matrixCache: null,
        /**
         * custom controls interface
         * controls are added by default_controls.js
         */
        controls: {},
        /**
         * return correct set of coordinates for intersection
         * this will return either aCoords or lineCoords.
         * @param {Boolean} absolute will return aCoords if true or lineCoords
         * @return {Object} {tl, tr, br, bl} points
         */
        _getCoords: function(absolute, calculate) {
          if (calculate) {
            return absolute ? this.calcACoords() : this.calcLineCoords();
          }
          if (!this.aCoords || !this.lineCoords) {
            this.setCoords(true);
          }
          return absolute ? this.aCoords : this.lineCoords;
        },
        /**
         * return correct set of coordinates for intersection
         * this will return either aCoords or lineCoords.
         * The coords are returned in an array.
         * @return {Array} [tl, tr, br, bl] of points
         */
        getCoords: function(absolute, calculate) {
          return arrayFromCoords(this._getCoords(absolute, calculate));
        },
        /**
         * Checks if object intersects with an area formed by 2 points
         * @param {Object} pointTL top-left point of area
         * @param {Object} pointBR bottom-right point of area
         * @param {Boolean} [absolute] use coordinates without viewportTransform
         * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
         * @return {Boolean} true if object intersects with an area formed by 2 points
         */
        intersectsWithRect: function(pointTL, pointBR, absolute, calculate) {
          var coords = this.getCoords(absolute, calculate), intersection = fabric2.Intersection.intersectPolygonRectangle(
            coords,
            pointTL,
            pointBR
          );
          return intersection.status === "Intersection";
        },
        /**
         * Checks if object intersects with another object
         * @param {Object} other Object to test
         * @param {Boolean} [absolute] use coordinates without viewportTransform
         * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
         * @return {Boolean} true if object intersects with another object
         */
        intersectsWithObject: function(other, absolute, calculate) {
          var intersection = fabric2.Intersection.intersectPolygonPolygon(
            this.getCoords(absolute, calculate),
            other.getCoords(absolute, calculate)
          );
          return intersection.status === "Intersection" || other.isContainedWithinObject(this, absolute, calculate) || this.isContainedWithinObject(other, absolute, calculate);
        },
        /**
         * Checks if object is fully contained within area of another object
         * @param {Object} other Object to test
         * @param {Boolean} [absolute] use coordinates without viewportTransform
         * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
         * @return {Boolean} true if object is fully contained within area of another object
         */
        isContainedWithinObject: function(other, absolute, calculate) {
          var points = this.getCoords(absolute, calculate), otherCoords = absolute ? other.aCoords : other.lineCoords, i = 0, lines = other._getImageLines(otherCoords);
          for (; i < 4; i++) {
            if (!other.containsPoint(points[i], lines)) {
              return false;
            }
          }
          return true;
        },
        /**
         * Checks if object is fully contained within area formed by 2 points
         * @param {Object} pointTL top-left point of area
         * @param {Object} pointBR bottom-right point of area
         * @param {Boolean} [absolute] use coordinates without viewportTransform
         * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
         * @return {Boolean} true if object is fully contained within area formed by 2 points
         */
        isContainedWithinRect: function(pointTL, pointBR, absolute, calculate) {
          var boundingRect = this.getBoundingRect(absolute, calculate);
          return boundingRect.left >= pointTL.x && boundingRect.left + boundingRect.width <= pointBR.x && boundingRect.top >= pointTL.y && boundingRect.top + boundingRect.height <= pointBR.y;
        },
        /**
         * Checks if point is inside the object
         * @param {fabric.Point} point Point to check against
         * @param {Object} [lines] object returned from @method _getImageLines
         * @param {Boolean} [absolute] use coordinates without viewportTransform
         * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
         * @return {Boolean} true if point is inside the object
         */
        containsPoint: function(point, lines, absolute, calculate) {
          var coords = this._getCoords(absolute, calculate), lines = lines || this._getImageLines(coords), xPoints = this._findCrossPoints(point, lines);
          return xPoints !== 0 && xPoints % 2 === 1;
        },
        /**
         * Checks if object is contained within the canvas with current viewportTransform
         * the check is done stopping at first point that appears on screen
         * @param {Boolean} [calculate] use coordinates of current position instead of .aCoords
         * @return {Boolean} true if object is fully or partially contained within canvas
         */
        isOnScreen: function(calculate) {
          if (!this.canvas) {
            return false;
          }
          var pointTL = this.canvas.vptCoords.tl, pointBR = this.canvas.vptCoords.br;
          var points = this.getCoords(true, calculate);
          if (points.some(function(point) {
            return point.x <= pointBR.x && point.x >= pointTL.x && point.y <= pointBR.y && point.y >= pointTL.y;
          })) {
            return true;
          }
          if (this.intersectsWithRect(pointTL, pointBR, true, calculate)) {
            return true;
          }
          return this._containsCenterOfCanvas(pointTL, pointBR, calculate);
        },
        /**
         * Checks if the object contains the midpoint between canvas extremities
         * Does not make sense outside the context of isOnScreen and isPartiallyOnScreen
         * @private
         * @param {Fabric.Point} pointTL Top Left point
         * @param {Fabric.Point} pointBR Top Right point
         * @param {Boolean} calculate use coordinates of current position instead of .oCoords
         * @return {Boolean} true if the object contains the point
         */
        _containsCenterOfCanvas: function(pointTL, pointBR, calculate) {
          var centerPoint = { x: (pointTL.x + pointBR.x) / 2, y: (pointTL.y + pointBR.y) / 2 };
          if (this.containsPoint(centerPoint, null, true, calculate)) {
            return true;
          }
          return false;
        },
        /**
         * Checks if object is partially contained within the canvas with current viewportTransform
         * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
         * @return {Boolean} true if object is partially contained within canvas
         */
        isPartiallyOnScreen: function(calculate) {
          if (!this.canvas) {
            return false;
          }
          var pointTL = this.canvas.vptCoords.tl, pointBR = this.canvas.vptCoords.br;
          if (this.intersectsWithRect(pointTL, pointBR, true, calculate)) {
            return true;
          }
          var allPointsAreOutside = this.getCoords(true, calculate).every(function(point) {
            return (point.x >= pointBR.x || point.x <= pointTL.x) && (point.y >= pointBR.y || point.y <= pointTL.y);
          });
          return allPointsAreOutside && this._containsCenterOfCanvas(pointTL, pointBR, calculate);
        },
        /**
         * Method that returns an object with the object edges in it, given the coordinates of the corners
         * @private
         * @param {Object} oCoords Coordinates of the object corners
         */
        _getImageLines: function(oCoords) {
          var lines = {
            topline: {
              o: oCoords.tl,
              d: oCoords.tr
            },
            rightline: {
              o: oCoords.tr,
              d: oCoords.br
            },
            bottomline: {
              o: oCoords.br,
              d: oCoords.bl
            },
            leftline: {
              o: oCoords.bl,
              d: oCoords.tl
            }
          };
          return lines;
        },
        /**
         * Helper method to determine how many cross points are between the 4 object edges
         * and the horizontal line determined by a point on canvas
         * @private
         * @param {fabric.Point} point Point to check
         * @param {Object} lines Coordinates of the object being evaluated
         */
        // remove yi, not used but left code here just in case.
        _findCrossPoints: function(point, lines) {
          var b1, b2, a1, a2, xi, xcount = 0, iLine;
          for (var lineKey in lines) {
            iLine = lines[lineKey];
            if (iLine.o.y < point.y && iLine.d.y < point.y) {
              continue;
            }
            if (iLine.o.y >= point.y && iLine.d.y >= point.y) {
              continue;
            }
            if (iLine.o.x === iLine.d.x && iLine.o.x >= point.x) {
              xi = iLine.o.x;
            } else {
              b1 = 0;
              b2 = (iLine.d.y - iLine.o.y) / (iLine.d.x - iLine.o.x);
              a1 = point.y - b1 * point.x;
              a2 = iLine.o.y - b2 * iLine.o.x;
              xi = -(a1 - a2) / (b1 - b2);
            }
            if (xi >= point.x) {
              xcount += 1;
            }
            if (xcount === 2) {
              break;
            }
          }
          return xcount;
        },
        /**
         * Returns coordinates of object's bounding rectangle (left, top, width, height)
         * the box is intended as aligned to axis of canvas.
         * @param {Boolean} [absolute] use coordinates without viewportTransform
         * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords / .aCoords
         * @return {Object} Object with left, top, width, height properties
         */
        getBoundingRect: function(absolute, calculate) {
          var coords = this.getCoords(absolute, calculate);
          return util.makeBoundingBoxFromPoints(coords);
        },
        /**
         * Returns width of an object's bounding box counting transformations
         * before 2.0 it was named getWidth();
         * @return {Number} width value
         */
        getScaledWidth: function() {
          return this._getTransformedDimensions().x;
        },
        /**
         * Returns height of an object bounding box counting transformations
         * before 2.0 it was named getHeight();
         * @return {Number} height value
         */
        getScaledHeight: function() {
          return this._getTransformedDimensions().y;
        },
        /**
         * Makes sure the scale is valid and modifies it if necessary
         * @private
         * @param {Number} value
         * @return {Number}
         */
        _constrainScale: function(value) {
          if (Math.abs(value) < this.minScaleLimit) {
            if (value < 0) {
              return -this.minScaleLimit;
            } else {
              return this.minScaleLimit;
            }
          } else if (value === 0) {
            return 1e-4;
          }
          return value;
        },
        /**
         * Scales an object (equally by x and y)
         * @param {Number} value Scale factor
         * @return {fabric.Object} thisArg
         * @chainable
         */
        scale: function(value) {
          this._set("scaleX", value);
          this._set("scaleY", value);
          return this.setCoords();
        },
        /**
         * Scales an object to a given width, with respect to bounding box (scaling by x/y equally)
         * @param {Number} value New width value
         * @param {Boolean} absolute ignore viewport
         * @return {fabric.Object} thisArg
         * @chainable
         */
        scaleToWidth: function(value, absolute) {
          var boundingRectFactor = this.getBoundingRect(absolute).width / this.getScaledWidth();
          return this.scale(value / this.width / boundingRectFactor);
        },
        /**
         * Scales an object to a given height, with respect to bounding box (scaling by x/y equally)
         * @param {Number} value New height value
         * @param {Boolean} absolute ignore viewport
         * @return {fabric.Object} thisArg
         * @chainable
         */
        scaleToHeight: function(value, absolute) {
          var boundingRectFactor = this.getBoundingRect(absolute).height / this.getScaledHeight();
          return this.scale(value / this.height / boundingRectFactor);
        },
        calcLineCoords: function() {
          var vpt = this.getViewportTransform(), padding = this.padding, angle = degreesToRadians(this.angle), cos2 = util.cos(angle), sin2 = util.sin(angle), cosP = cos2 * padding, sinP = sin2 * padding, cosPSinP = cosP + sinP, cosPMinusSinP = cosP - sinP, aCoords = this.calcACoords();
          var lineCoords = {
            tl: transformPoint(aCoords.tl, vpt),
            tr: transformPoint(aCoords.tr, vpt),
            bl: transformPoint(aCoords.bl, vpt),
            br: transformPoint(aCoords.br, vpt)
          };
          if (padding) {
            lineCoords.tl.x -= cosPMinusSinP;
            lineCoords.tl.y -= cosPSinP;
            lineCoords.tr.x += cosPSinP;
            lineCoords.tr.y -= cosPMinusSinP;
            lineCoords.bl.x -= cosPSinP;
            lineCoords.bl.y += cosPMinusSinP;
            lineCoords.br.x += cosPMinusSinP;
            lineCoords.br.y += cosPSinP;
          }
          return lineCoords;
        },
        calcOCoords: function() {
          var rotateMatrix = this._calcRotateMatrix(), translateMatrix = this._calcTranslateMatrix(), vpt = this.getViewportTransform(), startMatrix = multiplyMatrices(vpt, translateMatrix), finalMatrix = multiplyMatrices(startMatrix, rotateMatrix), finalMatrix = multiplyMatrices(finalMatrix, [1 / vpt[0], 0, 0, 1 / vpt[3], 0, 0]), dim = this._calculateCurrentDimensions(), coords = {};
          this.forEachControl(function(control, key, fabricObject) {
            coords[key] = control.positionHandler(dim, finalMatrix, fabricObject);
          });
          return coords;
        },
        calcACoords: function() {
          var rotateMatrix = this._calcRotateMatrix(), translateMatrix = this._calcTranslateMatrix(), finalMatrix = multiplyMatrices(translateMatrix, rotateMatrix), dim = this._getTransformedDimensions(), w = dim.x / 2, h = dim.y / 2;
          return {
            // corners
            tl: transformPoint({ x: -w, y: -h }, finalMatrix),
            tr: transformPoint({ x: w, y: -h }, finalMatrix),
            bl: transformPoint({ x: -w, y: h }, finalMatrix),
            br: transformPoint({ x: w, y: h }, finalMatrix)
          };
        },
        /**
         * Sets corner and controls position coordinates based on current angle, width and height, left and top.
         * oCoords are used to find the corners
         * aCoords are used to quickly find an object on the canvas
         * lineCoords are used to quickly find object during pointer events.
         * See {@link https://github.com/fabricjs/fabric.js/wiki/When-to-call-setCoords} and {@link http://fabricjs.com/fabric-gotchas}
         *
         * @param {Boolean} [skipCorners] skip calculation of oCoords.
         * @return {fabric.Object} thisArg
         * @chainable
         */
        setCoords: function(skipCorners) {
          this.aCoords = this.calcACoords();
          this.lineCoords = this.group ? this.aCoords : this.calcLineCoords();
          if (skipCorners) {
            return this;
          }
          this.oCoords = this.calcOCoords();
          this._setCornerCoords && this._setCornerCoords();
          return this;
        },
        /**
         * calculate rotation matrix of an object
         * @return {Array} rotation matrix for the object
         */
        _calcRotateMatrix: function() {
          return util.calcRotateMatrix(this);
        },
        /**
         * calculate the translation matrix for an object transform
         * @return {Array} rotation matrix for the object
         */
        _calcTranslateMatrix: function() {
          var center = this.getCenterPoint();
          return [1, 0, 0, 1, center.x, center.y];
        },
        transformMatrixKey: function(skipGroup) {
          var sep = "_", prefix = "";
          if (!skipGroup && this.group) {
            prefix = this.group.transformMatrixKey(skipGroup) + sep;
          }
          return prefix + this.top + sep + this.left + sep + this.scaleX + sep + this.scaleY + sep + this.skewX + sep + this.skewY + sep + this.angle + sep + this.originX + sep + this.originY + sep + this.width + sep + this.height + sep + this.strokeWidth + this.flipX + this.flipY;
        },
        /**
         * calculate transform matrix that represents the current transformations from the
         * object's properties.
         * @param {Boolean} [skipGroup] return transform matrix for object not counting parent transformations
         * There are some situation in which this is useful to avoid the fake rotation.
         * @return {Array} transform matrix for the object
         */
        calcTransformMatrix: function(skipGroup) {
          var matrix2 = this.calcOwnMatrix();
          if (skipGroup || !this.group) {
            return matrix2;
          }
          var key = this.transformMatrixKey(skipGroup), cache2 = this.matrixCache || (this.matrixCache = {});
          if (cache2.key === key) {
            return cache2.value;
          }
          if (this.group) {
            matrix2 = multiplyMatrices(this.group.calcTransformMatrix(false), matrix2);
          }
          cache2.key = key;
          cache2.value = matrix2;
          return matrix2;
        },
        /**
         * calculate transform matrix that represents the current transformations from the
         * object's properties, this matrix does not include the group transformation
         * @return {Array} transform matrix for the object
         */
        calcOwnMatrix: function() {
          var key = this.transformMatrixKey(true), cache2 = this.ownMatrixCache || (this.ownMatrixCache = {});
          if (cache2.key === key) {
            return cache2.value;
          }
          var tMatrix = this._calcTranslateMatrix(), options = {
            angle: this.angle,
            translateX: tMatrix[4],
            translateY: tMatrix[5],
            scaleX: this.scaleX,
            scaleY: this.scaleY,
            skewX: this.skewX,
            skewY: this.skewY,
            flipX: this.flipX,
            flipY: this.flipY
          };
          cache2.key = key;
          cache2.value = util.composeMatrix(options);
          return cache2.value;
        },
        /*
         * Calculate object dimensions from its properties
         * @private
         * @return {Object} .x width dimension
         * @return {Object} .y height dimension
         */
        _getNonTransformedDimensions: function() {
          var strokeWidth = this.strokeWidth, w = this.width + strokeWidth, h = this.height + strokeWidth;
          return { x: w, y: h };
        },
        /*
         * Calculate object bounding box dimensions from its properties scale, skew.
         * @param {Number} skewX, a value to override current skewX
         * @param {Number} skewY, a value to override current skewY
         * @private
         * @return {Object} .x width dimension
         * @return {Object} .y height dimension
         */
        _getTransformedDimensions: function(skewX, skewY) {
          if (typeof skewX === "undefined") {
            skewX = this.skewX;
          }
          if (typeof skewY === "undefined") {
            skewY = this.skewY;
          }
          var dimensions, dimX, dimY, noSkew = skewX === 0 && skewY === 0;
          if (this.strokeUniform) {
            dimX = this.width;
            dimY = this.height;
          } else {
            dimensions = this._getNonTransformedDimensions();
            dimX = dimensions.x;
            dimY = dimensions.y;
          }
          if (noSkew) {
            return this._finalizeDimensions(dimX * this.scaleX, dimY * this.scaleY);
          }
          var bbox = util.sizeAfterTransform(dimX, dimY, {
            scaleX: this.scaleX,
            scaleY: this.scaleY,
            skewX,
            skewY
          });
          return this._finalizeDimensions(bbox.x, bbox.y);
        },
        /*
         * Calculate object bounding box dimensions from its properties scale, skew.
         * @param Number width width of the bbox
         * @param Number height height of the bbox
         * @private
         * @return {Object} .x finalized width dimension
         * @return {Object} .y finalized height dimension
         */
        _finalizeDimensions: function(width, height) {
          return this.strokeUniform ? { x: width + this.strokeWidth, y: height + this.strokeWidth } : { x: width, y: height };
        },
        /*
         * Calculate object dimensions for controls box, including padding and canvas zoom.
         * and active selection
         * private
         */
        _calculateCurrentDimensions: function() {
          var vpt = this.getViewportTransform(), dim = this._getTransformedDimensions(), p = transformPoint(dim, vpt, true);
          return p.scalarAdd(2 * this.padding);
        }
      }
    );
  })();
  fabric2.util.object.extend(
    fabric2.Object.prototype,
    /** @lends fabric.Object.prototype */
    {
      /**
       * Moves an object to the bottom of the stack of drawn objects
       * @return {fabric.Object} thisArg
       * @chainable
       */
      sendToBack: function() {
        if (this.group) {
          fabric2.StaticCanvas.prototype.sendToBack.call(this.group, this);
        } else if (this.canvas) {
          this.canvas.sendToBack(this);
        }
        return this;
      },
      /**
       * Moves an object to the top of the stack of drawn objects
       * @return {fabric.Object} thisArg
       * @chainable
       */
      bringToFront: function() {
        if (this.group) {
          fabric2.StaticCanvas.prototype.bringToFront.call(this.group, this);
        } else if (this.canvas) {
          this.canvas.bringToFront(this);
        }
        return this;
      },
      /**
       * Moves an object down in stack of drawn objects
       * @param {Boolean} [intersecting] If `true`, send object behind next lower intersecting object
       * @return {fabric.Object} thisArg
       * @chainable
       */
      sendBackwards: function(intersecting) {
        if (this.group) {
          fabric2.StaticCanvas.prototype.sendBackwards.call(this.group, this, intersecting);
        } else if (this.canvas) {
          this.canvas.sendBackwards(this, intersecting);
        }
        return this;
      },
      /**
       * Moves an object up in stack of drawn objects
       * @param {Boolean} [intersecting] If `true`, send object in front of next upper intersecting object
       * @return {fabric.Object} thisArg
       * @chainable
       */
      bringForward: function(intersecting) {
        if (this.group) {
          fabric2.StaticCanvas.prototype.bringForward.call(this.group, this, intersecting);
        } else if (this.canvas) {
          this.canvas.bringForward(this, intersecting);
        }
        return this;
      },
      /**
       * Moves an object to specified level in stack of drawn objects
       * @param {Number} index New position of object
       * @return {fabric.Object} thisArg
       * @chainable
       */
      moveTo: function(index) {
        if (this.group && this.group.type !== "activeSelection") {
          fabric2.StaticCanvas.prototype.moveTo.call(this.group, this, index);
        } else if (this.canvas) {
          this.canvas.moveTo(this, index);
        }
        return this;
      }
    }
  );
  (function() {
    function getSvgColorString(prop, value) {
      if (!value) {
        return prop + ": none; ";
      } else if (value.toLive) {
        return prop + ": url(#SVGID_" + value.id + "); ";
      } else {
        var color = new fabric2.Color(value), str = prop + ": " + color.toRgb() + "; ", opacity = color.getAlpha();
        if (opacity !== 1) {
          str += prop + "-opacity: " + opacity.toString() + "; ";
        }
        return str;
      }
    }
    var toFixed = fabric2.util.toFixed;
    fabric2.util.object.extend(
      fabric2.Object.prototype,
      /** @lends fabric.Object.prototype */
      {
        /**
         * Returns styles-string for svg-export
         * @param {Boolean} skipShadow a boolean to skip shadow filter output
         * @return {String}
         */
        getSvgStyles: function(skipShadow) {
          var fillRule = this.fillRule ? this.fillRule : "nonzero", strokeWidth = this.strokeWidth ? this.strokeWidth : "0", strokeDashArray = this.strokeDashArray ? this.strokeDashArray.join(" ") : "none", strokeDashOffset = this.strokeDashOffset ? this.strokeDashOffset : "0", strokeLineCap = this.strokeLineCap ? this.strokeLineCap : "butt", strokeLineJoin = this.strokeLineJoin ? this.strokeLineJoin : "miter", strokeMiterLimit = this.strokeMiterLimit ? this.strokeMiterLimit : "4", opacity = typeof this.opacity !== "undefined" ? this.opacity : "1", visibility = this.visible ? "" : " visibility: hidden;", filter = skipShadow ? "" : this.getSvgFilter(), fill = getSvgColorString("fill", this.fill), stroke = getSvgColorString("stroke", this.stroke);
          return [
            stroke,
            "stroke-width: ",
            strokeWidth,
            "; ",
            "stroke-dasharray: ",
            strokeDashArray,
            "; ",
            "stroke-linecap: ",
            strokeLineCap,
            "; ",
            "stroke-dashoffset: ",
            strokeDashOffset,
            "; ",
            "stroke-linejoin: ",
            strokeLineJoin,
            "; ",
            "stroke-miterlimit: ",
            strokeMiterLimit,
            "; ",
            fill,
            "fill-rule: ",
            fillRule,
            "; ",
            "opacity: ",
            opacity,
            ";",
            filter,
            visibility
          ].join("");
        },
        /**
         * Returns styles-string for svg-export
         * @param {Object} style the object from which to retrieve style properties
         * @param {Boolean} useWhiteSpace a boolean to include an additional attribute in the style.
         * @return {String}
         */
        getSvgSpanStyles: function(style, useWhiteSpace) {
          var term = "; ";
          var fontFamily = style.fontFamily ? "font-family: " + (style.fontFamily.indexOf("'") === -1 && style.fontFamily.indexOf('"') === -1 ? "'" + style.fontFamily + "'" : style.fontFamily) + term : "";
          var strokeWidth = style.strokeWidth ? "stroke-width: " + style.strokeWidth + term : "", fontFamily = fontFamily, fontSize = style.fontSize ? "font-size: " + style.fontSize + "px" + term : "", fontStyle = style.fontStyle ? "font-style: " + style.fontStyle + term : "", fontWeight = style.fontWeight ? "font-weight: " + style.fontWeight + term : "", fill = style.fill ? getSvgColorString("fill", style.fill) : "", stroke = style.stroke ? getSvgColorString("stroke", style.stroke) : "", textDecoration = this.getSvgTextDecoration(style), deltaY = style.deltaY ? "baseline-shift: " + -style.deltaY + "; " : "";
          if (textDecoration) {
            textDecoration = "text-decoration: " + textDecoration + term;
          }
          return [
            stroke,
            strokeWidth,
            fontFamily,
            fontSize,
            fontStyle,
            fontWeight,
            textDecoration,
            fill,
            deltaY,
            useWhiteSpace ? "white-space: pre; " : ""
          ].join("");
        },
        /**
         * Returns text-decoration property for svg-export
         * @param {Object} style the object from which to retrieve style properties
         * @return {String}
         */
        getSvgTextDecoration: function(style) {
          return ["overline", "underline", "line-through"].filter(function(decoration) {
            return style[decoration.replace("-", "")];
          }).join(" ");
        },
        /**
         * Returns filter for svg shadow
         * @return {String}
         */
        getSvgFilter: function() {
          return this.shadow ? "filter: url(#SVGID_" + this.shadow.id + ");" : "";
        },
        /**
         * Returns id attribute for svg output
         * @return {String}
         */
        getSvgCommons: function() {
          return [
            this.id ? 'id="' + this.id + '" ' : "",
            this.clipPath ? 'clip-path="url(#' + this.clipPath.clipPathId + ')" ' : ""
          ].join("");
        },
        /**
         * Returns transform-string for svg-export
         * @param {Boolean} use the full transform or the single object one.
         * @return {String}
         */
        getSvgTransform: function(full, additionalTransform) {
          var transform = full ? this.calcTransformMatrix() : this.calcOwnMatrix(), svgTransform = 'transform="' + fabric2.util.matrixToSVG(transform);
          return svgTransform + (additionalTransform || "") + '" ';
        },
        _setSVGBg: function(textBgRects) {
          if (this.backgroundColor) {
            var NUM_FRACTION_DIGITS = fabric2.Object.NUM_FRACTION_DIGITS;
            textBgRects.push(
              "		<rect ",
              this._getFillAttributes(this.backgroundColor),
              ' x="',
              toFixed(-this.width / 2, NUM_FRACTION_DIGITS),
              '" y="',
              toFixed(-this.height / 2, NUM_FRACTION_DIGITS),
              '" width="',
              toFixed(this.width, NUM_FRACTION_DIGITS),
              '" height="',
              toFixed(this.height, NUM_FRACTION_DIGITS),
              '"></rect>\n'
            );
          }
        },
        /**
         * Returns svg representation of an instance
         * @param {Function} [reviver] Method for further parsing of svg representation.
         * @return {String} svg representation of an instance
         */
        toSVG: function(reviver) {
          return this._createBaseSVGMarkup(this._toSVG(reviver), { reviver });
        },
        /**
         * Returns svg clipPath representation of an instance
         * @param {Function} [reviver] Method for further parsing of svg representation.
         * @return {String} svg representation of an instance
         */
        toClipPathSVG: function(reviver) {
          return "	" + this._createBaseClipPathSVGMarkup(this._toSVG(reviver), { reviver });
        },
        /**
         * @private
         */
        _createBaseClipPathSVGMarkup: function(objectMarkup, options) {
          options = options || {};
          var reviver = options.reviver, additionalTransform = options.additionalTransform || "", commonPieces = [
            this.getSvgTransform(true, additionalTransform),
            this.getSvgCommons()
          ].join(""), index = objectMarkup.indexOf("COMMON_PARTS");
          objectMarkup[index] = commonPieces;
          return reviver ? reviver(objectMarkup.join("")) : objectMarkup.join("");
        },
        /**
         * @private
         */
        _createBaseSVGMarkup: function(objectMarkup, options) {
          options = options || {};
          var noStyle = options.noStyle, reviver = options.reviver, styleInfo = noStyle ? "" : 'style="' + this.getSvgStyles() + '" ', shadowInfo = options.withShadow ? 'style="' + this.getSvgFilter() + '" ' : "", clipPath = this.clipPath, vectorEffect = this.strokeUniform ? 'vector-effect="non-scaling-stroke" ' : "", absoluteClipPath = clipPath && clipPath.absolutePositioned, stroke = this.stroke, fill = this.fill, shadow = this.shadow, commonPieces, markup = [], clipPathMarkup, index = objectMarkup.indexOf("COMMON_PARTS"), additionalTransform = options.additionalTransform;
          if (clipPath) {
            clipPath.clipPathId = "CLIPPATH_" + fabric2.Object.__uid++;
            clipPathMarkup = '<clipPath id="' + clipPath.clipPathId + '" >\n' + clipPath.toClipPathSVG(reviver) + "</clipPath>\n";
          }
          if (absoluteClipPath) {
            markup.push(
              "<g ",
              shadowInfo,
              this.getSvgCommons(),
              " >\n"
            );
          }
          markup.push(
            "<g ",
            this.getSvgTransform(false),
            !absoluteClipPath ? shadowInfo + this.getSvgCommons() : "",
            " >\n"
          );
          commonPieces = [
            styleInfo,
            vectorEffect,
            noStyle ? "" : this.addPaintOrder(),
            " ",
            additionalTransform ? 'transform="' + additionalTransform + '" ' : ""
          ].join("");
          objectMarkup[index] = commonPieces;
          if (fill && fill.toLive) {
            markup.push(fill.toSVG(this));
          }
          if (stroke && stroke.toLive) {
            markup.push(stroke.toSVG(this));
          }
          if (shadow) {
            markup.push(shadow.toSVG(this));
          }
          if (clipPath) {
            markup.push(clipPathMarkup);
          }
          markup.push(objectMarkup.join(""));
          markup.push("</g>\n");
          absoluteClipPath && markup.push("</g>\n");
          return reviver ? reviver(markup.join("")) : markup.join("");
        },
        addPaintOrder: function() {
          return this.paintFirst !== "fill" ? ' paint-order="' + this.paintFirst + '" ' : "";
        }
      }
    );
  })();
  (function() {
    var extend = fabric2.util.object.extend, originalSet = "stateProperties";
    function saveProps(origin, destination, props) {
      var tmpObj = {}, deep = true;
      props.forEach(function(prop) {
        tmpObj[prop] = origin[prop];
      });
      extend(origin[destination], tmpObj, deep);
    }
    function _isEqual(origValue, currentValue, firstPass) {
      if (origValue === currentValue) {
        return true;
      } else if (Array.isArray(origValue)) {
        if (!Array.isArray(currentValue) || origValue.length !== currentValue.length) {
          return false;
        }
        for (var i = 0, len = origValue.length; i < len; i++) {
          if (!_isEqual(origValue[i], currentValue[i])) {
            return false;
          }
        }
        return true;
      } else if (origValue && typeof origValue === "object") {
        var keys = Object.keys(origValue), key;
        if (!currentValue || typeof currentValue !== "object" || !firstPass && keys.length !== Object.keys(currentValue).length) {
          return false;
        }
        for (var i = 0, len = keys.length; i < len; i++) {
          key = keys[i];
          if (key === "canvas" || key === "group") {
            continue;
          }
          if (!_isEqual(origValue[key], currentValue[key])) {
            return false;
          }
        }
        return true;
      }
    }
    fabric2.util.object.extend(
      fabric2.Object.prototype,
      /** @lends fabric.Object.prototype */
      {
        /**
         * Returns true if object state (one of its state properties) was changed
         * @param {String} [propertySet] optional name for the set of property we want to save
         * @return {Boolean} true if instance' state has changed since `{@link fabric.Object#saveState}` was called
         */
        hasStateChanged: function(propertySet) {
          propertySet = propertySet || originalSet;
          var dashedPropertySet = "_" + propertySet;
          if (Object.keys(this[dashedPropertySet]).length < this[propertySet].length) {
            return true;
          }
          return !_isEqual(this[dashedPropertySet], this, true);
        },
        /**
         * Saves state of an object
         * @param {Object} [options] Object with additional `stateProperties` array to include when saving state
         * @return {fabric.Object} thisArg
         */
        saveState: function(options) {
          var propertySet = options && options.propertySet || originalSet, destination = "_" + propertySet;
          if (!this[destination]) {
            return this.setupState(options);
          }
          saveProps(this, destination, this[propertySet]);
          if (options && options.stateProperties) {
            saveProps(this, destination, options.stateProperties);
          }
          return this;
        },
        /**
         * Setups state of an object
         * @param {Object} [options] Object with additional `stateProperties` array to include when saving state
         * @return {fabric.Object} thisArg
         */
        setupState: function(options) {
          options = options || {};
          var propertySet = options.propertySet || originalSet;
          options.propertySet = propertySet;
          this["_" + propertySet] = {};
          this.saveState(options);
          return this;
        }
      }
    );
  })();
  (function() {
    var degreesToRadians = fabric2.util.degreesToRadians;
    fabric2.util.object.extend(
      fabric2.Object.prototype,
      /** @lends fabric.Object.prototype */
      {
        /**
         * Determines which corner has been clicked
         * @private
         * @param {Object} pointer The pointer indicating the mouse position
         * @return {String|Boolean} corner code (tl, tr, bl, br, etc.), or false if nothing is found
         */
        _findTargetCorner: function(pointer, forTouch) {
          if (!this.hasControls || this.group || (!this.canvas || this.canvas._activeObject !== this)) {
            return false;
          }
          var ex = pointer.x, ey = pointer.y, xPoints, lines, keys = Object.keys(this.oCoords), j = keys.length - 1, i;
          this.__corner = 0;
          for (; j >= 0; j--) {
            i = keys[j];
            if (!this.isControlVisible(i)) {
              continue;
            }
            lines = this._getImageLines(forTouch ? this.oCoords[i].touchCorner : this.oCoords[i].corner);
            xPoints = this._findCrossPoints({ x: ex, y: ey }, lines);
            if (xPoints !== 0 && xPoints % 2 === 1) {
              this.__corner = i;
              return i;
            }
          }
          return false;
        },
        /**
         * Calls a function for each control. The function gets called,
         * with the control, the object that is calling the iterator and the control's key
         * @param {Function} fn function to iterate over the controls over
         */
        forEachControl: function(fn) {
          for (var i in this.controls) {
            fn(this.controls[i], i, this);
          }
        },
        /**
         * Sets the coordinates of the draggable boxes in the corners of
         * the image used to scale/rotate it.
         * note: if we would switch to ROUND corner area, all of this would disappear.
         * everything would resolve to a single point and a pythagorean theorem for the distance
         * @private
         */
        _setCornerCoords: function() {
          var coords = this.oCoords;
          for (var control in coords) {
            var controlObject = this.controls[control];
            coords[control].corner = controlObject.calcCornerCoords(
              this.angle,
              this.cornerSize,
              coords[control].x,
              coords[control].y,
              false
            );
            coords[control].touchCorner = controlObject.calcCornerCoords(
              this.angle,
              this.touchCornerSize,
              coords[control].x,
              coords[control].y,
              true
            );
          }
        },
        /**
         * Draws a colored layer behind the object, inside its selection borders.
         * Requires public options: padding, selectionBackgroundColor
         * this function is called when the context is transformed
         * has checks to be skipped when the object is on a staticCanvas
         * @param {CanvasRenderingContext2D} ctx Context to draw on
         * @return {fabric.Object} thisArg
         * @chainable
         */
        drawSelectionBackground: function(ctx) {
          if (!this.selectionBackgroundColor || this.canvas && !this.canvas.interactive || this.canvas && this.canvas._activeObject !== this) {
            return this;
          }
          ctx.save();
          var center = this.getCenterPoint(), wh = this._calculateCurrentDimensions(), vpt = this.canvas.viewportTransform;
          ctx.translate(center.x, center.y);
          ctx.scale(1 / vpt[0], 1 / vpt[3]);
          ctx.rotate(degreesToRadians(this.angle));
          ctx.fillStyle = this.selectionBackgroundColor;
          ctx.fillRect(-wh.x / 2, -wh.y / 2, wh.x, wh.y);
          ctx.restore();
          return this;
        },
        /**
         * Draws borders of an object's bounding box.
         * Requires public properties: width, height
         * Requires public options: padding, borderColor
         * @param {CanvasRenderingContext2D} ctx Context to draw on
         * @param {Object} styleOverride object to override the object style
         * @return {fabric.Object} thisArg
         * @chainable
         */
        drawBorders: function(ctx, styleOverride) {
          styleOverride = styleOverride || {};
          var wh = this._calculateCurrentDimensions(), strokeWidth = this.borderScaleFactor, width = wh.x + strokeWidth, height = wh.y + strokeWidth, hasControls = typeof styleOverride.hasControls !== "undefined" ? styleOverride.hasControls : this.hasControls, shouldStroke = false;
          ctx.save();
          ctx.strokeStyle = styleOverride.borderColor || this.borderColor;
          this._setLineDash(ctx, styleOverride.borderDashArray || this.borderDashArray);
          ctx.strokeRect(
            -width / 2,
            -height / 2,
            width,
            height
          );
          if (hasControls) {
            ctx.beginPath();
            this.forEachControl(function(control, key, fabricObject) {
              if (control.withConnection && control.getVisibility(fabricObject, key)) {
                shouldStroke = true;
                ctx.moveTo(control.x * width, control.y * height);
                ctx.lineTo(
                  control.x * width + control.offsetX,
                  control.y * height + control.offsetY
                );
              }
            });
            if (shouldStroke) {
              ctx.stroke();
            }
          }
          ctx.restore();
          return this;
        },
        /**
         * Draws borders of an object's bounding box when it is inside a group.
         * Requires public properties: width, height
         * Requires public options: padding, borderColor
         * @param {CanvasRenderingContext2D} ctx Context to draw on
         * @param {object} options object representing current object parameters
         * @param {Object} styleOverride object to override the object style
         * @return {fabric.Object} thisArg
         * @chainable
         */
        drawBordersInGroup: function(ctx, options, styleOverride) {
          styleOverride = styleOverride || {};
          var bbox = fabric2.util.sizeAfterTransform(this.width, this.height, options), strokeWidth = this.strokeWidth, strokeUniform = this.strokeUniform, borderScaleFactor = this.borderScaleFactor, width = bbox.x + strokeWidth * (strokeUniform ? this.canvas.getZoom() : options.scaleX) + borderScaleFactor, height = bbox.y + strokeWidth * (strokeUniform ? this.canvas.getZoom() : options.scaleY) + borderScaleFactor;
          ctx.save();
          this._setLineDash(ctx, styleOverride.borderDashArray || this.borderDashArray);
          ctx.strokeStyle = styleOverride.borderColor || this.borderColor;
          ctx.strokeRect(
            -width / 2,
            -height / 2,
            width,
            height
          );
          ctx.restore();
          return this;
        },
        /**
         * Draws corners of an object's bounding box.
         * Requires public properties: width, height
         * Requires public options: cornerSize, padding
         * @param {CanvasRenderingContext2D} ctx Context to draw on
         * @param {Object} styleOverride object to override the object style
         * @return {fabric.Object} thisArg
         * @chainable
         */
        drawControls: function(ctx, styleOverride) {
          styleOverride = styleOverride || {};
          ctx.save();
          var retinaScaling = this.canvas.getRetinaScaling(), matrix2, p;
          ctx.setTransform(retinaScaling, 0, 0, retinaScaling, 0, 0);
          ctx.strokeStyle = ctx.fillStyle = styleOverride.cornerColor || this.cornerColor;
          if (!this.transparentCorners) {
            ctx.strokeStyle = styleOverride.cornerStrokeColor || this.cornerStrokeColor;
          }
          this._setLineDash(ctx, styleOverride.cornerDashArray || this.cornerDashArray);
          this.setCoords();
          if (this.group) {
            matrix2 = this.group.calcTransformMatrix();
          }
          this.forEachControl(function(control, key, fabricObject) {
            p = fabricObject.oCoords[key];
            if (control.getVisibility(fabricObject, key)) {
              if (matrix2) {
                p = fabric2.util.transformPoint(p, matrix2);
              }
              control.render(ctx, p.x, p.y, styleOverride, fabricObject);
            }
          });
          ctx.restore();
          return this;
        },
        /**
         * Returns true if the specified control is visible, false otherwise.
         * @param {String} controlKey The key of the control. Possible values are 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr'.
         * @returns {Boolean} true if the specified control is visible, false otherwise
         */
        isControlVisible: function(controlKey) {
          return this.controls[controlKey] && this.controls[controlKey].getVisibility(this, controlKey);
        },
        /**
         * Sets the visibility of the specified control.
         * @param {String} controlKey The key of the control. Possible values are 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr'.
         * @param {Boolean} visible true to set the specified control visible, false otherwise
         * @return {fabric.Object} thisArg
         * @chainable
         */
        setControlVisible: function(controlKey, visible) {
          if (!this._controlsVisibility) {
            this._controlsVisibility = {};
          }
          this._controlsVisibility[controlKey] = visible;
          return this;
        },
        /**
         * Sets the visibility state of object controls.
         * @param {Object} [options] Options object
         * @param {Boolean} [options.bl] true to enable the bottom-left control, false to disable it
         * @param {Boolean} [options.br] true to enable the bottom-right control, false to disable it
         * @param {Boolean} [options.mb] true to enable the middle-bottom control, false to disable it
         * @param {Boolean} [options.ml] true to enable the middle-left control, false to disable it
         * @param {Boolean} [options.mr] true to enable the middle-right control, false to disable it
         * @param {Boolean} [options.mt] true to enable the middle-top control, false to disable it
         * @param {Boolean} [options.tl] true to enable the top-left control, false to disable it
         * @param {Boolean} [options.tr] true to enable the top-right control, false to disable it
         * @param {Boolean} [options.mtr] true to enable the middle-top-rotate control, false to disable it
         * @return {fabric.Object} thisArg
         * @chainable
         */
        setControlsVisibility: function(options) {
          options || (options = {});
          for (var p in options) {
            this.setControlVisible(p, options[p]);
          }
          return this;
        },
        /**
         * This callback function is called every time _discardActiveObject or _setActiveObject
         * try to to deselect this object. If the function returns true, the process is cancelled
         * @param {Object} [options] options sent from the upper functions
         * @param {Event} [options.e] event if the process is generated by an event
         */
        onDeselect: function() {
        },
        /**
         * This callback function is called every time _discardActiveObject or _setActiveObject
         * try to to select this object. If the function returns true, the process is cancelled
         * @param {Object} [options] options sent from the upper functions
         * @param {Event} [options.e] event if the process is generated by an event
         */
        onSelect: function() {
        }
      }
    );
  })();
  fabric2.util.object.extend(
    fabric2.StaticCanvas.prototype,
    /** @lends fabric.StaticCanvas.prototype */
    {
      /**
       * Animation duration (in ms) for fx* methods
       * @type Number
       * @default
       */
      FX_DURATION: 500,
      /**
       * Centers object horizontally with animation.
       * @param {fabric.Object} object Object to center
       * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
       * @param {Function} [callbacks.onComplete] Invoked on completion
       * @param {Function} [callbacks.onChange] Invoked on every step of animation
       * @return {fabric.AnimationContext} context
       */
      fxCenterObjectH: function(object, callbacks) {
        callbacks = callbacks || {};
        var empty = function() {
        }, onComplete = callbacks.onComplete || empty, onChange = callbacks.onChange || empty, _this = this;
        return fabric2.util.animate({
          target: this,
          startValue: object.left,
          endValue: this.getCenterPoint().x,
          duration: this.FX_DURATION,
          onChange: function(value) {
            object.set("left", value);
            _this.requestRenderAll();
            onChange();
          },
          onComplete: function() {
            object.setCoords();
            onComplete();
          }
        });
      },
      /**
       * Centers object vertically with animation.
       * @param {fabric.Object} object Object to center
       * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
       * @param {Function} [callbacks.onComplete] Invoked on completion
       * @param {Function} [callbacks.onChange] Invoked on every step of animation
       * @return {fabric.AnimationContext} context
       */
      fxCenterObjectV: function(object, callbacks) {
        callbacks = callbacks || {};
        var empty = function() {
        }, onComplete = callbacks.onComplete || empty, onChange = callbacks.onChange || empty, _this = this;
        return fabric2.util.animate({
          target: this,
          startValue: object.top,
          endValue: this.getCenterPoint().y,
          duration: this.FX_DURATION,
          onChange: function(value) {
            object.set("top", value);
            _this.requestRenderAll();
            onChange();
          },
          onComplete: function() {
            object.setCoords();
            onComplete();
          }
        });
      },
      /**
       * Same as `fabric.Canvas#remove` but animated
       * @param {fabric.Object} object Object to remove
       * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
       * @param {Function} [callbacks.onComplete] Invoked on completion
       * @param {Function} [callbacks.onChange] Invoked on every step of animation
       * @return {fabric.AnimationContext} context
       */
      fxRemove: function(object, callbacks) {
        callbacks = callbacks || {};
        var empty = function() {
        }, onComplete = callbacks.onComplete || empty, onChange = callbacks.onChange || empty, _this = this;
        return fabric2.util.animate({
          target: this,
          startValue: object.opacity,
          endValue: 0,
          duration: this.FX_DURATION,
          onChange: function(value) {
            object.set("opacity", value);
            _this.requestRenderAll();
            onChange();
          },
          onComplete: function() {
            _this.remove(object);
            onComplete();
          }
        });
      }
    }
  );
  fabric2.util.object.extend(
    fabric2.Object.prototype,
    /** @lends fabric.Object.prototype */
    {
      /**
       * Animates object's properties
       * @param {String|Object} property Property to animate (if string) or properties to animate (if object)
       * @param {Number|Object} value Value to animate property to (if string was given first) or options object
       * @return {fabric.Object} thisArg
       * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#animation}
       * @return {fabric.AnimationContext | fabric.AnimationContext[]} animation context (or an array if passed multiple properties)
       *
       * As object — multiple properties
       *
       * object.animate({ left: ..., top: ... });
       * object.animate({ left: ..., top: ... }, { duration: ... });
       *
       * As string — one property
       *
       * object.animate('left', ...);
       * object.animate('left', { duration: ... });
       *
       */
      animate: function() {
        if (arguments[0] && typeof arguments[0] === "object") {
          var propsToAnimate = [], prop, skipCallbacks, out = [];
          for (prop in arguments[0]) {
            propsToAnimate.push(prop);
          }
          for (var i = 0, len = propsToAnimate.length; i < len; i++) {
            prop = propsToAnimate[i];
            skipCallbacks = i !== len - 1;
            out.push(this._animate(prop, arguments[0][prop], arguments[1], skipCallbacks));
          }
          return out;
        } else {
          return this._animate.apply(this, arguments);
        }
      },
      /**
       * @private
       * @param {String} property Property to animate
       * @param {String} to Value to animate to
       * @param {Object} [options] Options object
       * @param {Boolean} [skipCallbacks] When true, callbacks like onchange and oncomplete are not invoked
       */
      _animate: function(property, to, options, skipCallbacks) {
        var _this = this, propPair;
        to = to.toString();
        if (!options) {
          options = {};
        } else {
          options = fabric2.util.object.clone(options);
        }
        if (~property.indexOf(".")) {
          propPair = property.split(".");
        }
        var propIsColor = _this.colorProperties.indexOf(property) > -1 || propPair && _this.colorProperties.indexOf(propPair[1]) > -1;
        var currentValue = propPair ? this.get(propPair[0])[propPair[1]] : this.get(property);
        if (!("from" in options)) {
          options.from = currentValue;
        }
        if (!propIsColor) {
          if (~to.indexOf("=")) {
            to = currentValue + parseFloat(to.replace("=", ""));
          } else {
            to = parseFloat(to);
          }
        }
        var _options = {
          target: this,
          startValue: options.from,
          endValue: to,
          byValue: options.by,
          easing: options.easing,
          duration: options.duration,
          abort: options.abort && function(value, valueProgress, timeProgress) {
            return options.abort.call(_this, value, valueProgress, timeProgress);
          },
          onChange: function(value, valueProgress, timeProgress) {
            if (propPair) {
              _this[propPair[0]][propPair[1]] = value;
            } else {
              _this.set(property, value);
            }
            if (skipCallbacks) {
              return;
            }
            options.onChange && options.onChange(value, valueProgress, timeProgress);
          },
          onComplete: function(value, valueProgress, timeProgress) {
            if (skipCallbacks) {
              return;
            }
            _this.setCoords();
            options.onComplete && options.onComplete(value, valueProgress, timeProgress);
          }
        };
        if (propIsColor) {
          return fabric2.util.animateColor(_options.startValue, _options.endValue, _options.duration, _options);
        } else {
          return fabric2.util.animate(_options);
        }
      }
    }
  );
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), extend = fabric22.util.object.extend, clone2 = fabric22.util.object.clone, coordProps = { x1: 1, x2: 1, y1: 1, y2: 1 };
    if (fabric22.Line) {
      fabric22.warn("fabric.Line is already defined");
      return;
    }
    fabric22.Line = fabric22.util.createClass(
      fabric22.Object,
      /** @lends fabric.Line.prototype */
      {
        /**
         * Type of an object
         * @type String
         * @default
         */
        type: "line",
        /**
         * x value or first line edge
         * @type Number
         * @default
         */
        x1: 0,
        /**
         * y value or first line edge
         * @type Number
         * @default
         */
        y1: 0,
        /**
         * x value or second line edge
         * @type Number
         * @default
         */
        x2: 0,
        /**
         * y value or second line edge
         * @type Number
         * @default
         */
        y2: 0,
        cacheProperties: fabric22.Object.prototype.cacheProperties.concat("x1", "x2", "y1", "y2"),
        /**
         * Constructor
         * @param {Array} [points] Array of points
         * @param {Object} [options] Options object
         * @return {fabric.Line} thisArg
         */
        initialize: function(points, options) {
          if (!points) {
            points = [0, 0, 0, 0];
          }
          this.callSuper("initialize", options);
          this.set("x1", points[0]);
          this.set("y1", points[1]);
          this.set("x2", points[2]);
          this.set("y2", points[3]);
          this._setWidthHeight(options);
        },
        /**
         * @private
         * @param {Object} [options] Options
         */
        _setWidthHeight: function(options) {
          options || (options = {});
          this.width = Math.abs(this.x2 - this.x1);
          this.height = Math.abs(this.y2 - this.y1);
          this.left = "left" in options ? options.left : this._getLeftToOriginX();
          this.top = "top" in options ? options.top : this._getTopToOriginY();
        },
        /**
         * @private
         * @param {String} key
         * @param {*} value
         */
        _set: function(key, value) {
          this.callSuper("_set", key, value);
          if (typeof coordProps[key] !== "undefined") {
            this._setWidthHeight();
          }
          return this;
        },
        /**
         * @private
         * @return {Number} leftToOriginX Distance from left edge of canvas to originX of Line.
         */
        _getLeftToOriginX: makeEdgeToOriginGetter(
          {
            // property names
            origin: "originX",
            axis1: "x1",
            axis2: "x2",
            dimension: "width"
          },
          {
            // possible values of origin
            nearest: "left",
            center: "center",
            farthest: "right"
          }
        ),
        /**
         * @private
         * @return {Number} topToOriginY Distance from top edge of canvas to originY of Line.
         */
        _getTopToOriginY: makeEdgeToOriginGetter(
          {
            // property names
            origin: "originY",
            axis1: "y1",
            axis2: "y2",
            dimension: "height"
          },
          {
            // possible values of origin
            nearest: "top",
            center: "center",
            farthest: "bottom"
          }
        ),
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _render: function(ctx) {
          ctx.beginPath();
          var p = this.calcLinePoints();
          ctx.moveTo(p.x1, p.y1);
          ctx.lineTo(p.x2, p.y2);
          ctx.lineWidth = this.strokeWidth;
          var origStrokeStyle = ctx.strokeStyle;
          ctx.strokeStyle = this.stroke || ctx.fillStyle;
          this.stroke && this._renderStroke(ctx);
          ctx.strokeStyle = origStrokeStyle;
        },
        /**
         * This function is an helper for svg import. it returns the center of the object in the svg
         * untransformed coordinates
         * @private
         * @return {Object} center point from element coordinates
         */
        _findCenterFromElement: function() {
          return {
            x: (this.x1 + this.x2) / 2,
            y: (this.y1 + this.y2) / 2
          };
        },
        /**
         * Returns object representation of an instance
         * @method toObject
         * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
         * @return {Object} object representation of an instance
         */
        toObject: function(propertiesToInclude) {
          return extend(this.callSuper("toObject", propertiesToInclude), this.calcLinePoints());
        },
        /*
         * Calculate object dimensions from its properties
         * @private
         */
        _getNonTransformedDimensions: function() {
          var dim = this.callSuper("_getNonTransformedDimensions");
          if (this.strokeLineCap === "butt") {
            if (this.width === 0) {
              dim.y -= this.strokeWidth;
            }
            if (this.height === 0) {
              dim.x -= this.strokeWidth;
            }
          }
          return dim;
        },
        /**
         * Recalculates line points given width and height
         * @private
         */
        calcLinePoints: function() {
          var xMult = this.x1 <= this.x2 ? -1 : 1, yMult = this.y1 <= this.y2 ? -1 : 1, x1 = xMult * this.width * 0.5, y1 = yMult * this.height * 0.5, x2 = xMult * this.width * -0.5, y2 = yMult * this.height * -0.5;
          return {
            x1,
            x2,
            y1,
            y2
          };
        },
        /* _TO_SVG_START_ */
        /**
         * Returns svg representation of an instance
         * @return {Array} an array of strings with the specific svg representation
         * of the instance
         */
        _toSVG: function() {
          var p = this.calcLinePoints();
          return [
            "<line ",
            "COMMON_PARTS",
            'x1="',
            p.x1,
            '" y1="',
            p.y1,
            '" x2="',
            p.x2,
            '" y2="',
            p.y2,
            '" />\n'
          ];
        }
        /* _TO_SVG_END_ */
      }
    );
    fabric22.Line.ATTRIBUTE_NAMES = fabric22.SHARED_ATTRIBUTES.concat("x1 y1 x2 y2".split(" "));
    fabric22.Line.fromElement = function(element, callback, options) {
      options = options || {};
      var parsedAttributes = fabric22.parseAttributes(element, fabric22.Line.ATTRIBUTE_NAMES), points = [
        parsedAttributes.x1 || 0,
        parsedAttributes.y1 || 0,
        parsedAttributes.x2 || 0,
        parsedAttributes.y2 || 0
      ];
      callback(new fabric22.Line(points, extend(parsedAttributes, options)));
    };
    fabric22.Line.fromObject = function(object, callback) {
      function _callback(instance) {
        delete instance.points;
        callback && callback(instance);
      }
      var options = clone2(object, true);
      options.points = [object.x1, object.y1, object.x2, object.y2];
      fabric22.Object._fromObject("Line", options, _callback, "points");
    };
    function makeEdgeToOriginGetter(propertyNames, originValues) {
      var origin = propertyNames.origin, axis1 = propertyNames.axis1, axis2 = propertyNames.axis2, dimension = propertyNames.dimension, nearest = originValues.nearest, center = originValues.center, farthest = originValues.farthest;
      return function() {
        switch (this.get(origin)) {
          case nearest:
            return Math.min(this.get(axis1), this.get(axis2));
          case center:
            return Math.min(this.get(axis1), this.get(axis2)) + 0.5 * this.get(dimension);
          case farthest:
            return Math.max(this.get(axis1), this.get(axis2));
        }
      };
    }
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), degreesToRadians = fabric22.util.degreesToRadians;
    if (fabric22.Circle) {
      fabric22.warn("fabric.Circle is already defined.");
      return;
    }
    fabric22.Circle = fabric22.util.createClass(
      fabric22.Object,
      /** @lends fabric.Circle.prototype */
      {
        /**
         * Type of an object
         * @type String
         * @default
         */
        type: "circle",
        /**
         * Radius of this circle
         * @type Number
         * @default
         */
        radius: 0,
        /**
         * degrees of start of the circle.
         * probably will change to degrees in next major version
         * @type Number 0 - 359
         * @default 0
         */
        startAngle: 0,
        /**
         * End angle of the circle
         * probably will change to degrees in next major version
         * @type Number 1 - 360
         * @default 360
         */
        endAngle: 360,
        cacheProperties: fabric22.Object.prototype.cacheProperties.concat("radius", "startAngle", "endAngle"),
        /**
         * @private
         * @param {String} key
         * @param {*} value
         * @return {fabric.Circle} thisArg
         */
        _set: function(key, value) {
          this.callSuper("_set", key, value);
          if (key === "radius") {
            this.setRadius(value);
          }
          return this;
        },
        /**
         * Returns object representation of an instance
         * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
         * @return {Object} object representation of an instance
         */
        toObject: function(propertiesToInclude) {
          return this.callSuper("toObject", ["radius", "startAngle", "endAngle"].concat(propertiesToInclude));
        },
        /* _TO_SVG_START_ */
        /**
         * Returns svg representation of an instance
         * @return {Array} an array of strings with the specific svg representation
         * of the instance
         */
        _toSVG: function() {
          var svgString, x = 0, y = 0, angle = (this.endAngle - this.startAngle) % 360;
          if (angle === 0) {
            svgString = [
              "<circle ",
              "COMMON_PARTS",
              'cx="' + x + '" cy="' + y + '" ',
              'r="',
              this.radius,
              '" />\n'
            ];
          } else {
            var start = degreesToRadians(this.startAngle), end = degreesToRadians(this.endAngle), radius = this.radius, startX = fabric22.util.cos(start) * radius, startY = fabric22.util.sin(start) * radius, endX = fabric22.util.cos(end) * radius, endY = fabric22.util.sin(end) * radius, largeFlag = angle > 180 ? "1" : "0";
            svgString = [
              '<path d="M ' + startX + " " + startY,
              " A " + radius + " " + radius,
              " 0 ",
              +largeFlag + " 1",
              " " + endX + " " + endY,
              '" ',
              "COMMON_PARTS",
              " />\n"
            ];
          }
          return svgString;
        },
        /* _TO_SVG_END_ */
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx context to render on
         */
        _render: function(ctx) {
          ctx.beginPath();
          ctx.arc(
            0,
            0,
            this.radius,
            degreesToRadians(this.startAngle),
            degreesToRadians(this.endAngle),
            false
          );
          this._renderPaintInOrder(ctx);
        },
        /**
         * Returns horizontal radius of an object (according to how an object is scaled)
         * @return {Number}
         */
        getRadiusX: function() {
          return this.get("radius") * this.get("scaleX");
        },
        /**
         * Returns vertical radius of an object (according to how an object is scaled)
         * @return {Number}
         */
        getRadiusY: function() {
          return this.get("radius") * this.get("scaleY");
        },
        /**
         * Sets radius of an object (and updates width accordingly)
         * @return {fabric.Circle} thisArg
         */
        setRadius: function(value) {
          this.radius = value;
          return this.set("width", value * 2).set("height", value * 2);
        }
      }
    );
    fabric22.Circle.ATTRIBUTE_NAMES = fabric22.SHARED_ATTRIBUTES.concat("cx cy r".split(" "));
    fabric22.Circle.fromElement = function(element, callback) {
      var parsedAttributes = fabric22.parseAttributes(element, fabric22.Circle.ATTRIBUTE_NAMES);
      if (!isValidRadius(parsedAttributes)) {
        throw new Error("value of `r` attribute is required and can not be negative");
      }
      parsedAttributes.left = (parsedAttributes.left || 0) - parsedAttributes.radius;
      parsedAttributes.top = (parsedAttributes.top || 0) - parsedAttributes.radius;
      callback(new fabric22.Circle(parsedAttributes));
    };
    function isValidRadius(attributes) {
      return "radius" in attributes && attributes.radius >= 0;
    }
    fabric22.Circle.fromObject = function(object, callback) {
      fabric22.Object._fromObject("Circle", object, callback);
    };
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {});
    if (fabric22.Triangle) {
      fabric22.warn("fabric.Triangle is already defined");
      return;
    }
    fabric22.Triangle = fabric22.util.createClass(
      fabric22.Object,
      /** @lends fabric.Triangle.prototype */
      {
        /**
         * Type of an object
         * @type String
         * @default
         */
        type: "triangle",
        /**
         * Width is set to 100 to compensate the old initialize code that was setting it to 100
         * @type Number
         * @default
         */
        width: 100,
        /**
         * Height is set to 100 to compensate the old initialize code that was setting it to 100
         * @type Number
         * @default
         */
        height: 100,
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _render: function(ctx) {
          var widthBy2 = this.width / 2, heightBy2 = this.height / 2;
          ctx.beginPath();
          ctx.moveTo(-widthBy2, heightBy2);
          ctx.lineTo(0, -heightBy2);
          ctx.lineTo(widthBy2, heightBy2);
          ctx.closePath();
          this._renderPaintInOrder(ctx);
        },
        /* _TO_SVG_START_ */
        /**
         * Returns svg representation of an instance
         * @return {Array} an array of strings with the specific svg representation
         * of the instance
         */
        _toSVG: function() {
          var widthBy2 = this.width / 2, heightBy2 = this.height / 2, points = [
            -widthBy2 + " " + heightBy2,
            "0 " + -heightBy2,
            widthBy2 + " " + heightBy2
          ].join(",");
          return [
            "<polygon ",
            "COMMON_PARTS",
            'points="',
            points,
            '" />'
          ];
        }
        /* _TO_SVG_END_ */
      }
    );
    fabric22.Triangle.fromObject = function(object, callback) {
      return fabric22.Object._fromObject("Triangle", object, callback);
    };
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), piBy2 = Math.PI * 2;
    if (fabric22.Ellipse) {
      fabric22.warn("fabric.Ellipse is already defined.");
      return;
    }
    fabric22.Ellipse = fabric22.util.createClass(
      fabric22.Object,
      /** @lends fabric.Ellipse.prototype */
      {
        /**
         * Type of an object
         * @type String
         * @default
         */
        type: "ellipse",
        /**
         * Horizontal radius
         * @type Number
         * @default
         */
        rx: 0,
        /**
         * Vertical radius
         * @type Number
         * @default
         */
        ry: 0,
        cacheProperties: fabric22.Object.prototype.cacheProperties.concat("rx", "ry"),
        /**
         * Constructor
         * @param {Object} [options] Options object
         * @return {fabric.Ellipse} thisArg
         */
        initialize: function(options) {
          this.callSuper("initialize", options);
          this.set("rx", options && options.rx || 0);
          this.set("ry", options && options.ry || 0);
        },
        /**
         * @private
         * @param {String} key
         * @param {*} value
         * @return {fabric.Ellipse} thisArg
         */
        _set: function(key, value) {
          this.callSuper("_set", key, value);
          switch (key) {
            case "rx":
              this.rx = value;
              this.set("width", value * 2);
              break;
            case "ry":
              this.ry = value;
              this.set("height", value * 2);
              break;
          }
          return this;
        },
        /**
         * Returns horizontal radius of an object (according to how an object is scaled)
         * @return {Number}
         */
        getRx: function() {
          return this.get("rx") * this.get("scaleX");
        },
        /**
         * Returns Vertical radius of an object (according to how an object is scaled)
         * @return {Number}
         */
        getRy: function() {
          return this.get("ry") * this.get("scaleY");
        },
        /**
         * Returns object representation of an instance
         * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
         * @return {Object} object representation of an instance
         */
        toObject: function(propertiesToInclude) {
          return this.callSuper("toObject", ["rx", "ry"].concat(propertiesToInclude));
        },
        /* _TO_SVG_START_ */
        /**
         * Returns svg representation of an instance
         * @return {Array} an array of strings with the specific svg representation
         * of the instance
         */
        _toSVG: function() {
          return [
            "<ellipse ",
            "COMMON_PARTS",
            'cx="0" cy="0" ',
            'rx="',
            this.rx,
            '" ry="',
            this.ry,
            '" />\n'
          ];
        },
        /* _TO_SVG_END_ */
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx context to render on
         */
        _render: function(ctx) {
          ctx.beginPath();
          ctx.save();
          ctx.transform(1, 0, 0, this.ry / this.rx, 0, 0);
          ctx.arc(
            0,
            0,
            this.rx,
            0,
            piBy2,
            false
          );
          ctx.restore();
          this._renderPaintInOrder(ctx);
        }
      }
    );
    fabric22.Ellipse.ATTRIBUTE_NAMES = fabric22.SHARED_ATTRIBUTES.concat("cx cy rx ry".split(" "));
    fabric22.Ellipse.fromElement = function(element, callback) {
      var parsedAttributes = fabric22.parseAttributes(element, fabric22.Ellipse.ATTRIBUTE_NAMES);
      parsedAttributes.left = (parsedAttributes.left || 0) - parsedAttributes.rx;
      parsedAttributes.top = (parsedAttributes.top || 0) - parsedAttributes.ry;
      callback(new fabric22.Ellipse(parsedAttributes));
    };
    fabric22.Ellipse.fromObject = function(object, callback) {
      fabric22.Object._fromObject("Ellipse", object, callback);
    };
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), extend = fabric22.util.object.extend;
    if (fabric22.Rect) {
      fabric22.warn("fabric.Rect is already defined");
      return;
    }
    fabric22.Rect = fabric22.util.createClass(
      fabric22.Object,
      /** @lends fabric.Rect.prototype */
      {
        /**
         * List of properties to consider when checking if state of an object is changed ({@link fabric.Object#hasStateChanged})
         * as well as for history (undo/redo) purposes
         * @type Array
         */
        stateProperties: fabric22.Object.prototype.stateProperties.concat("rx", "ry"),
        /**
         * Type of an object
         * @type String
         * @default
         */
        type: "rect",
        /**
         * Horizontal border radius
         * @type Number
         * @default
         */
        rx: 0,
        /**
         * Vertical border radius
         * @type Number
         * @default
         */
        ry: 0,
        cacheProperties: fabric22.Object.prototype.cacheProperties.concat("rx", "ry"),
        /**
         * Constructor
         * @param {Object} [options] Options object
         * @return {Object} thisArg
         */
        initialize: function(options) {
          this.callSuper("initialize", options);
          this._initRxRy();
        },
        /**
         * Initializes rx/ry attributes
         * @private
         */
        _initRxRy: function() {
          if (this.rx && !this.ry) {
            this.ry = this.rx;
          } else if (this.ry && !this.rx) {
            this.rx = this.ry;
          }
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _render: function(ctx) {
          var rx = this.rx ? Math.min(this.rx, this.width / 2) : 0, ry = this.ry ? Math.min(this.ry, this.height / 2) : 0, w = this.width, h = this.height, x = -this.width / 2, y = -this.height / 2, isRounded = rx !== 0 || ry !== 0, k = 1 - 0.5522847498;
          ctx.beginPath();
          ctx.moveTo(x + rx, y);
          ctx.lineTo(x + w - rx, y);
          isRounded && ctx.bezierCurveTo(x + w - k * rx, y, x + w, y + k * ry, x + w, y + ry);
          ctx.lineTo(x + w, y + h - ry);
          isRounded && ctx.bezierCurveTo(x + w, y + h - k * ry, x + w - k * rx, y + h, x + w - rx, y + h);
          ctx.lineTo(x + rx, y + h);
          isRounded && ctx.bezierCurveTo(x + k * rx, y + h, x, y + h - k * ry, x, y + h - ry);
          ctx.lineTo(x, y + ry);
          isRounded && ctx.bezierCurveTo(x, y + k * ry, x + k * rx, y, x + rx, y);
          ctx.closePath();
          this._renderPaintInOrder(ctx);
        },
        /**
         * Returns object representation of an instance
         * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
         * @return {Object} object representation of an instance
         */
        toObject: function(propertiesToInclude) {
          return this.callSuper("toObject", ["rx", "ry"].concat(propertiesToInclude));
        },
        /* _TO_SVG_START_ */
        /**
         * Returns svg representation of an instance
         * @return {Array} an array of strings with the specific svg representation
         * of the instance
         */
        _toSVG: function() {
          var x = -this.width / 2, y = -this.height / 2;
          return [
            "<rect ",
            "COMMON_PARTS",
            'x="',
            x,
            '" y="',
            y,
            '" rx="',
            this.rx,
            '" ry="',
            this.ry,
            '" width="',
            this.width,
            '" height="',
            this.height,
            '" />\n'
          ];
        }
        /* _TO_SVG_END_ */
      }
    );
    fabric22.Rect.ATTRIBUTE_NAMES = fabric22.SHARED_ATTRIBUTES.concat("x y rx ry width height".split(" "));
    fabric22.Rect.fromElement = function(element, callback, options) {
      if (!element) {
        return callback(null);
      }
      options = options || {};
      var parsedAttributes = fabric22.parseAttributes(element, fabric22.Rect.ATTRIBUTE_NAMES);
      parsedAttributes.left = parsedAttributes.left || 0;
      parsedAttributes.top = parsedAttributes.top || 0;
      parsedAttributes.height = parsedAttributes.height || 0;
      parsedAttributes.width = parsedAttributes.width || 0;
      var rect = new fabric22.Rect(extend(options ? fabric22.util.object.clone(options) : {}, parsedAttributes));
      rect.visible = rect.visible && rect.width > 0 && rect.height > 0;
      callback(rect);
    };
    fabric22.Rect.fromObject = function(object, callback) {
      return fabric22.Object._fromObject("Rect", object, callback);
    };
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), extend = fabric22.util.object.extend, min2 = fabric22.util.array.min, max2 = fabric22.util.array.max, toFixed = fabric22.util.toFixed, projectStrokeOnPoints = fabric22.util.projectStrokeOnPoints;
    if (fabric22.Polyline) {
      fabric22.warn("fabric.Polyline is already defined");
      return;
    }
    fabric22.Polyline = fabric22.util.createClass(
      fabric22.Object,
      /** @lends fabric.Polyline.prototype */
      {
        /**
         * Type of an object
         * @type String
         * @default
         */
        type: "polyline",
        /**
         * Points array
         * @type Array
         * @default
         */
        points: null,
        /**
         * WARNING: Feature in progress
         * Calculate the exact bounding box taking in account strokeWidth on acute angles
         * this will be turned to true by default on fabric 6.0
         * maybe will be left in as an optimization since calculations may be slow
         * @deprecated
         * @type Boolean
         * @default false
         */
        exactBoundingBox: false,
        cacheProperties: fabric22.Object.prototype.cacheProperties.concat("points"),
        /**
         * Constructor
         * @param {Array} points Array of points (where each point is an object with x and y)
         * @param {Object} [options] Options object
         * @return {fabric.Polyline} thisArg
         * @example
         * var poly = new fabric.Polyline([
         *     { x: 10, y: 10 },
         *     { x: 50, y: 30 },
         *     { x: 40, y: 70 },
         *     { x: 60, y: 50 },
         *     { x: 100, y: 150 },
         *     { x: 40, y: 100 }
         *   ], {
         *   stroke: 'red',
         *   left: 100,
         *   top: 100
         * });
         */
        initialize: function(points, options) {
          options = options || {};
          this.points = points || [];
          this.callSuper("initialize", options);
          this._setPositionDimensions(options);
        },
        /**
         * @private
         */
        _projectStrokeOnPoints: function() {
          return projectStrokeOnPoints(this.points, this, true);
        },
        _setPositionDimensions: function(options) {
          var calcDim = this._calcDimensions(options), correctLeftTop, correctSize = this.exactBoundingBox ? this.strokeWidth : 0;
          this.width = calcDim.width - correctSize;
          this.height = calcDim.height - correctSize;
          if (!options.fromSVG) {
            correctLeftTop = this.translateToGivenOrigin(
              {
                // this looks bad, but is one way to keep it optional for now.
                x: calcDim.left - this.strokeWidth / 2 + correctSize / 2,
                y: calcDim.top - this.strokeWidth / 2 + correctSize / 2
              },
              "left",
              "top",
              this.originX,
              this.originY
            );
          }
          if (typeof options.left === "undefined") {
            this.left = options.fromSVG ? calcDim.left : correctLeftTop.x;
          }
          if (typeof options.top === "undefined") {
            this.top = options.fromSVG ? calcDim.top : correctLeftTop.y;
          }
          this.pathOffset = {
            x: calcDim.left + this.width / 2 + correctSize / 2,
            y: calcDim.top + this.height / 2 + correctSize / 2
          };
        },
        /**
         * Calculate the polygon min and max point from points array,
         * returning an object with left, top, width, height to measure the
         * polygon size
         * @return {Object} object.left X coordinate of the polygon leftmost point
         * @return {Object} object.top Y coordinate of the polygon topmost point
         * @return {Object} object.width distance between X coordinates of the polygon leftmost and rightmost point
         * @return {Object} object.height distance between Y coordinates of the polygon topmost and bottommost point
         * @private
         */
        _calcDimensions: function() {
          var points = this.exactBoundingBox ? this._projectStrokeOnPoints() : this.points, minX = min2(points, "x") || 0, minY = min2(points, "y") || 0, maxX = max2(points, "x") || 0, maxY = max2(points, "y") || 0, width = maxX - minX, height = maxY - minY;
          return {
            left: minX,
            top: minY,
            width,
            height
          };
        },
        /**
         * Returns object representation of an instance
         * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
         * @return {Object} Object representation of an instance
         */
        toObject: function(propertiesToInclude) {
          return extend(this.callSuper("toObject", propertiesToInclude), {
            points: this.points.concat()
          });
        },
        /* _TO_SVG_START_ */
        /**
         * Returns svg representation of an instance
         * @return {Array} an array of strings with the specific svg representation
         * of the instance
         */
        _toSVG: function() {
          var points = [], diffX = this.pathOffset.x, diffY = this.pathOffset.y, NUM_FRACTION_DIGITS = fabric22.Object.NUM_FRACTION_DIGITS;
          for (var i = 0, len = this.points.length; i < len; i++) {
            points.push(
              toFixed(this.points[i].x - diffX, NUM_FRACTION_DIGITS),
              ",",
              toFixed(this.points[i].y - diffY, NUM_FRACTION_DIGITS),
              " "
            );
          }
          return [
            "<" + this.type + " ",
            "COMMON_PARTS",
            'points="',
            points.join(""),
            '" />\n'
          ];
        },
        /* _TO_SVG_END_ */
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        commonRender: function(ctx) {
          var point, len = this.points.length, x = this.pathOffset.x, y = this.pathOffset.y;
          if (!len || isNaN(this.points[len - 1].y)) {
            return false;
          }
          ctx.beginPath();
          ctx.moveTo(this.points[0].x - x, this.points[0].y - y);
          for (var i = 0; i < len; i++) {
            point = this.points[i];
            ctx.lineTo(point.x - x, point.y - y);
          }
          return true;
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _render: function(ctx) {
          if (!this.commonRender(ctx)) {
            return;
          }
          this._renderPaintInOrder(ctx);
        },
        /**
         * Returns complexity of an instance
         * @return {Number} complexity of this instance
         */
        complexity: function() {
          return this.get("points").length;
        }
      }
    );
    fabric22.Polyline.ATTRIBUTE_NAMES = fabric22.SHARED_ATTRIBUTES.concat();
    fabric22.Polyline.fromElementGenerator = function(_class) {
      return function(element, callback, options) {
        if (!element) {
          return callback(null);
        }
        options || (options = {});
        var points = fabric22.parsePointsAttribute(element.getAttribute("points")), parsedAttributes = fabric22.parseAttributes(element, fabric22[_class].ATTRIBUTE_NAMES);
        parsedAttributes.fromSVG = true;
        callback(new fabric22[_class](points, extend(parsedAttributes, options)));
      };
    };
    fabric22.Polyline.fromElement = fabric22.Polyline.fromElementGenerator("Polyline");
    fabric22.Polyline.fromObject = function(object, callback) {
      return fabric22.Object._fromObject("Polyline", object, callback, "points");
    };
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), projectStrokeOnPoints = fabric22.util.projectStrokeOnPoints;
    if (fabric22.Polygon) {
      fabric22.warn("fabric.Polygon is already defined");
      return;
    }
    fabric22.Polygon = fabric22.util.createClass(
      fabric22.Polyline,
      /** @lends fabric.Polygon.prototype */
      {
        /**
         * Type of an object
         * @type String
         * @default
         */
        type: "polygon",
        /**
         * @private
         */
        _projectStrokeOnPoints: function() {
          return projectStrokeOnPoints(this.points, this);
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _render: function(ctx) {
          if (!this.commonRender(ctx)) {
            return;
          }
          ctx.closePath();
          this._renderPaintInOrder(ctx);
        }
      }
    );
    fabric22.Polygon.ATTRIBUTE_NAMES = fabric22.SHARED_ATTRIBUTES.concat();
    fabric22.Polygon.fromElement = fabric22.Polyline.fromElementGenerator("Polygon");
    fabric22.Polygon.fromObject = function(object, callback) {
      fabric22.Object._fromObject("Polygon", object, callback, "points");
    };
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), min2 = fabric22.util.array.min, max2 = fabric22.util.array.max, extend = fabric22.util.object.extend, clone2 = fabric22.util.object.clone, toFixed = fabric22.util.toFixed;
    if (fabric22.Path) {
      fabric22.warn("fabric.Path is already defined");
      return;
    }
    fabric22.Path = fabric22.util.createClass(
      fabric22.Object,
      /** @lends fabric.Path.prototype */
      {
        /**
         * Type of an object
         * @type String
         * @default
         */
        type: "path",
        /**
         * Array of path points
         * @type Array
         * @default
         */
        path: null,
        cacheProperties: fabric22.Object.prototype.cacheProperties.concat("path", "fillRule"),
        stateProperties: fabric22.Object.prototype.stateProperties.concat("path"),
        /**
         * Constructor
         * @param {Array|String} path Path data (sequence of coordinates and corresponding "command" tokens)
         * @param {Object} [options] Options object
         * @return {fabric.Path} thisArg
         */
        initialize: function(path, options) {
          options = clone2(options || {});
          delete options.path;
          this.callSuper("initialize", options);
          this._setPath(path || [], options);
        },
        /**
        * @private
        * @param {Array|String} path Path data (sequence of coordinates and corresponding "command" tokens)
        * @param {Object} [options] Options object
        */
        _setPath: function(path, options) {
          this.path = fabric22.util.makePathSimpler(
            Array.isArray(path) ? path : fabric22.util.parsePath(path)
          );
          fabric22.Polyline.prototype._setPositionDimensions.call(this, options || {});
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx context to render path on
         */
        _renderPathCommands: function(ctx) {
          var current, subpathStartX = 0, subpathStartY = 0, x = 0, y = 0, controlX = 0, controlY = 0, l = -this.pathOffset.x, t = -this.pathOffset.y;
          ctx.beginPath();
          for (var i = 0, len = this.path.length; i < len; ++i) {
            current = this.path[i];
            switch (current[0]) {
              case "L":
                x = current[1];
                y = current[2];
                ctx.lineTo(x + l, y + t);
                break;
              case "M":
                x = current[1];
                y = current[2];
                subpathStartX = x;
                subpathStartY = y;
                ctx.moveTo(x + l, y + t);
                break;
              case "C":
                x = current[5];
                y = current[6];
                controlX = current[3];
                controlY = current[4];
                ctx.bezierCurveTo(
                  current[1] + l,
                  current[2] + t,
                  controlX + l,
                  controlY + t,
                  x + l,
                  y + t
                );
                break;
              case "Q":
                ctx.quadraticCurveTo(
                  current[1] + l,
                  current[2] + t,
                  current[3] + l,
                  current[4] + t
                );
                x = current[3];
                y = current[4];
                controlX = current[1];
                controlY = current[2];
                break;
              case "z":
              case "Z":
                x = subpathStartX;
                y = subpathStartY;
                ctx.closePath();
                break;
            }
          }
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx context to render path on
         */
        _render: function(ctx) {
          this._renderPathCommands(ctx);
          this._renderPaintInOrder(ctx);
        },
        /**
         * Returns string representation of an instance
         * @return {String} string representation of an instance
         */
        toString: function() {
          return "#<fabric.Path (" + this.complexity() + '): { "top": ' + this.top + ', "left": ' + this.left + " }>";
        },
        /**
         * Returns object representation of an instance
         * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
         * @return {Object} object representation of an instance
         */
        toObject: function(propertiesToInclude) {
          return extend(this.callSuper("toObject", propertiesToInclude), {
            path: this.path.map(function(item) {
              return item.slice();
            })
          });
        },
        /**
         * Returns dataless object representation of an instance
         * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
         * @return {Object} object representation of an instance
         */
        toDatalessObject: function(propertiesToInclude) {
          var o = this.toObject(["sourcePath"].concat(propertiesToInclude));
          if (o.sourcePath) {
            delete o.path;
          }
          return o;
        },
        /* _TO_SVG_START_ */
        /**
         * Returns svg representation of an instance
         * @return {Array} an array of strings with the specific svg representation
         * of the instance
         */
        _toSVG: function() {
          var path = fabric22.util.joinPath(this.path);
          return [
            "<path ",
            "COMMON_PARTS",
            'd="',
            path,
            '" stroke-linecap="round" ',
            "/>\n"
          ];
        },
        _getOffsetTransform: function() {
          var digits = fabric22.Object.NUM_FRACTION_DIGITS;
          return " translate(" + toFixed(-this.pathOffset.x, digits) + ", " + toFixed(-this.pathOffset.y, digits) + ")";
        },
        /**
         * Returns svg clipPath representation of an instance
         * @param {Function} [reviver] Method for further parsing of svg representation.
         * @return {String} svg representation of an instance
         */
        toClipPathSVG: function(reviver) {
          var additionalTransform = this._getOffsetTransform();
          return "	" + this._createBaseClipPathSVGMarkup(
            this._toSVG(),
            { reviver, additionalTransform }
          );
        },
        /**
         * Returns svg representation of an instance
         * @param {Function} [reviver] Method for further parsing of svg representation.
         * @return {String} svg representation of an instance
         */
        toSVG: function(reviver) {
          var additionalTransform = this._getOffsetTransform();
          return this._createBaseSVGMarkup(this._toSVG(), { reviver, additionalTransform });
        },
        /* _TO_SVG_END_ */
        /**
         * Returns number representation of an instance complexity
         * @return {Number} complexity of this instance
         */
        complexity: function() {
          return this.path.length;
        },
        /**
         * @private
         */
        _calcDimensions: function() {
          var aX = [], aY = [], current, subpathStartX = 0, subpathStartY = 0, x = 0, y = 0, bounds;
          for (var i = 0, len = this.path.length; i < len; ++i) {
            current = this.path[i];
            switch (current[0]) {
              case "L":
                x = current[1];
                y = current[2];
                bounds = [];
                break;
              case "M":
                x = current[1];
                y = current[2];
                subpathStartX = x;
                subpathStartY = y;
                bounds = [];
                break;
              case "C":
                bounds = fabric22.util.getBoundsOfCurve(
                  x,
                  y,
                  current[1],
                  current[2],
                  current[3],
                  current[4],
                  current[5],
                  current[6]
                );
                x = current[5];
                y = current[6];
                break;
              case "Q":
                bounds = fabric22.util.getBoundsOfCurve(
                  x,
                  y,
                  current[1],
                  current[2],
                  current[1],
                  current[2],
                  current[3],
                  current[4]
                );
                x = current[3];
                y = current[4];
                break;
              case "z":
              case "Z":
                x = subpathStartX;
                y = subpathStartY;
                break;
            }
            bounds.forEach(function(point) {
              aX.push(point.x);
              aY.push(point.y);
            });
            aX.push(x);
            aY.push(y);
          }
          var minX = min2(aX) || 0, minY = min2(aY) || 0, maxX = max2(aX) || 0, maxY = max2(aY) || 0, deltaX = maxX - minX, deltaY = maxY - minY;
          return {
            left: minX,
            top: minY,
            width: deltaX,
            height: deltaY
          };
        }
      }
    );
    fabric22.Path.fromObject = function(object, callback) {
      if (typeof object.sourcePath === "string") {
        var pathUrl = object.sourcePath;
        fabric22.loadSVGFromURL(pathUrl, function(elements) {
          var path = elements[0];
          path.setOptions(object);
          if (object.clipPath) {
            fabric22.util.enlivenObjects([object.clipPath], function(elivenedObjects) {
              path.clipPath = elivenedObjects[0];
              callback && callback(path);
            });
          } else {
            callback && callback(path);
          }
        });
      } else {
        fabric22.Object._fromObject("Path", object, callback, "path");
      }
    };
    fabric22.Path.ATTRIBUTE_NAMES = fabric22.SHARED_ATTRIBUTES.concat(["d"]);
    fabric22.Path.fromElement = function(element, callback, options) {
      var parsedAttributes = fabric22.parseAttributes(element, fabric22.Path.ATTRIBUTE_NAMES);
      parsedAttributes.fromSVG = true;
      callback(new fabric22.Path(parsedAttributes.d, extend(parsedAttributes, options)));
    };
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), min2 = fabric22.util.array.min, max2 = fabric22.util.array.max;
    if (fabric22.Group) {
      return;
    }
    fabric22.Group = fabric22.util.createClass(
      fabric22.Object,
      fabric22.Collection,
      /** @lends fabric.Group.prototype */
      {
        /**
         * Type of an object
         * @type String
         * @default
         */
        type: "group",
        /**
         * Width of stroke
         * @type Number
         * @default
         */
        strokeWidth: 0,
        /**
         * Indicates if click, mouseover, mouseout events & hoverCursor should also check for subtargets
         * @type Boolean
         * @default
         */
        subTargetCheck: false,
        /**
         * Groups are container, do not render anything on theyr own, ence no cache properties
         * @type Array
         * @default
         */
        cacheProperties: [],
        /**
         * setOnGroup is a method used for TextBox that is no more used since 2.0.0 The behavior is still
         * available setting this boolean to true.
         * @type Boolean
         * @since 2.0.0
         * @default
         */
        useSetOnGroup: false,
        /**
         * Constructor
         * @param {Object} objects Group objects
         * @param {Object} [options] Options object
         * @param {Boolean} [isAlreadyGrouped] if true, objects have been grouped already.
         * @return {Object} thisArg
         */
        initialize: function(objects, options, isAlreadyGrouped) {
          options = options || {};
          this._objects = [];
          isAlreadyGrouped && this.callSuper("initialize", options);
          this._objects = objects || [];
          for (var i = this._objects.length; i--; ) {
            this._objects[i].group = this;
          }
          if (!isAlreadyGrouped) {
            var center = options && options.centerPoint;
            if (options.originX !== void 0) {
              this.originX = options.originX;
            }
            if (options.originY !== void 0) {
              this.originY = options.originY;
            }
            center || this._calcBounds();
            this._updateObjectsCoords(center);
            delete options.centerPoint;
            this.callSuper("initialize", options);
          } else {
            this._updateObjectsACoords();
          }
          this.setCoords();
        },
        /**
         * @private
         */
        _updateObjectsACoords: function() {
          var skipControls = true;
          for (var i = this._objects.length; i--; ) {
            this._objects[i].setCoords(skipControls);
          }
        },
        /**
         * @private
         * @param {Boolean} [skipCoordsChange] if true, coordinates of objects enclosed in a group do not change
         */
        _updateObjectsCoords: function(center) {
          var center = center || this.getCenterPoint();
          for (var i = this._objects.length; i--; ) {
            this._updateObjectCoords(this._objects[i], center);
          }
        },
        /**
         * @private
         * @param {Object} object
         * @param {fabric.Point} center, current center of group.
         */
        _updateObjectCoords: function(object, center) {
          var objectLeft = object.left, objectTop = object.top, skipControls = true;
          object.set({
            left: objectLeft - center.x,
            top: objectTop - center.y
          });
          object.group = this;
          object.setCoords(skipControls);
        },
        /**
         * Returns string represenation of a group
         * @return {String}
         */
        toString: function() {
          return "#<fabric.Group: (" + this.complexity() + ")>";
        },
        /**
         * Adds an object to a group; Then recalculates group's dimension, position.
         * @param {Object} object
         * @return {fabric.Group} thisArg
         * @chainable
         */
        addWithUpdate: function(object) {
          var nested = !!this.group;
          this._restoreObjectsState();
          fabric22.util.resetObjectTransform(this);
          if (object) {
            if (nested) {
              fabric22.util.removeTransformFromObject(object, this.group.calcTransformMatrix());
            }
            this._objects.push(object);
            object.group = this;
            object._set("canvas", this.canvas);
          }
          this._calcBounds();
          this._updateObjectsCoords();
          this.dirty = true;
          if (nested) {
            this.group.addWithUpdate();
          } else {
            this.setCoords();
          }
          return this;
        },
        /**
         * Removes an object from a group; Then recalculates group's dimension, position.
         * @param {Object} object
         * @return {fabric.Group} thisArg
         * @chainable
         */
        removeWithUpdate: function(object) {
          this._restoreObjectsState();
          fabric22.util.resetObjectTransform(this);
          this.remove(object);
          this._calcBounds();
          this._updateObjectsCoords();
          this.setCoords();
          this.dirty = true;
          return this;
        },
        /**
         * @private
         */
        _onObjectAdded: function(object) {
          this.dirty = true;
          object.group = this;
          object._set("canvas", this.canvas);
        },
        /**
         * @private
         */
        _onObjectRemoved: function(object) {
          this.dirty = true;
          delete object.group;
        },
        /**
         * @private
         */
        _set: function(key, value) {
          var i = this._objects.length;
          if (this.useSetOnGroup) {
            while (i--) {
              this._objects[i].setOnGroup(key, value);
            }
          }
          if (key === "canvas") {
            while (i--) {
              this._objects[i]._set(key, value);
            }
          }
          fabric22.Object.prototype._set.call(this, key, value);
        },
        /**
         * Returns object representation of an instance
         * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
         * @return {Object} object representation of an instance
         */
        toObject: function(propertiesToInclude) {
          var _includeDefaultValues = this.includeDefaultValues;
          var objsToObject = this._objects.filter(function(obj2) {
            return !obj2.excludeFromExport;
          }).map(function(obj2) {
            var originalDefaults = obj2.includeDefaultValues;
            obj2.includeDefaultValues = _includeDefaultValues;
            var _obj = obj2.toObject(propertiesToInclude);
            obj2.includeDefaultValues = originalDefaults;
            return _obj;
          });
          var obj = fabric22.Object.prototype.toObject.call(this, propertiesToInclude);
          obj.objects = objsToObject;
          return obj;
        },
        /**
         * Returns object representation of an instance, in dataless mode.
         * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
         * @return {Object} object representation of an instance
         */
        toDatalessObject: function(propertiesToInclude) {
          var objsToObject, sourcePath = this.sourcePath;
          if (sourcePath) {
            objsToObject = sourcePath;
          } else {
            var _includeDefaultValues = this.includeDefaultValues;
            objsToObject = this._objects.map(function(obj2) {
              var originalDefaults = obj2.includeDefaultValues;
              obj2.includeDefaultValues = _includeDefaultValues;
              var _obj = obj2.toDatalessObject(propertiesToInclude);
              obj2.includeDefaultValues = originalDefaults;
              return _obj;
            });
          }
          var obj = fabric22.Object.prototype.toDatalessObject.call(this, propertiesToInclude);
          obj.objects = objsToObject;
          return obj;
        },
        /**
         * Renders instance on a given context
         * @param {CanvasRenderingContext2D} ctx context to render instance on
         */
        render: function(ctx) {
          this._transformDone = true;
          this.callSuper("render", ctx);
          this._transformDone = false;
        },
        /**
         * Decide if the object should cache or not. Create its own cache level
         * needsItsOwnCache should be used when the object drawing method requires
         * a cache step. None of the fabric classes requires it.
         * Generally you do not cache objects in groups because the group is already cached.
         * @return {Boolean}
         */
        shouldCache: function() {
          var ownCache = fabric22.Object.prototype.shouldCache.call(this);
          if (ownCache) {
            for (var i = 0, len = this._objects.length; i < len; i++) {
              if (this._objects[i].willDrawShadow()) {
                this.ownCaching = false;
                return false;
              }
            }
          }
          return ownCache;
        },
        /**
         * Check if this object or a child object will cast a shadow
         * @return {Boolean}
         */
        willDrawShadow: function() {
          if (fabric22.Object.prototype.willDrawShadow.call(this)) {
            return true;
          }
          for (var i = 0, len = this._objects.length; i < len; i++) {
            if (this._objects[i].willDrawShadow()) {
              return true;
            }
          }
          return false;
        },
        /**
         * Check if this group or its parent group are caching, recursively up
         * @return {Boolean}
         */
        isOnACache: function() {
          return this.ownCaching || this.group && this.group.isOnACache();
        },
        /**
         * Execute the drawing operation for an object on a specified context
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        drawObject: function(ctx) {
          for (var i = 0, len = this._objects.length; i < len; i++) {
            this._objects[i].render(ctx);
          }
          this._drawClipPath(ctx, this.clipPath);
        },
        /**
         * Check if cache is dirty
         */
        isCacheDirty: function(skipCanvas) {
          if (this.callSuper("isCacheDirty", skipCanvas)) {
            return true;
          }
          if (!this.statefullCache) {
            return false;
          }
          for (var i = 0, len = this._objects.length; i < len; i++) {
            if (this._objects[i].isCacheDirty(true)) {
              if (this._cacheCanvas) {
                var x = this.cacheWidth / this.zoomX, y = this.cacheHeight / this.zoomY;
                this._cacheContext.clearRect(-x / 2, -y / 2, x, y);
              }
              return true;
            }
          }
          return false;
        },
        /**
         * Restores original state of each of group objects (original state is that which was before group was created).
         * if the nested boolean is true, the original state will be restored just for the
         * first group and not for all the group chain
         * @private
         * @param {Boolean} nested tell the function to restore object state up to the parent group and not more
         * @return {fabric.Group} thisArg
         * @chainable
         */
        _restoreObjectsState: function() {
          var groupMatrix = this.calcOwnMatrix();
          this._objects.forEach(function(object) {
            fabric22.util.addTransformToObject(object, groupMatrix);
            delete object.group;
            object.setCoords();
          });
          return this;
        },
        /**
         * Destroys a group (restoring state of its objects)
         * @return {fabric.Group} thisArg
         * @chainable
         */
        destroy: function() {
          this._objects.forEach(function(object) {
            object.set("dirty", true);
          });
          return this._restoreObjectsState();
        },
        dispose: function() {
          this.callSuper("dispose");
          this.forEachObject(function(object) {
            object.dispose && object.dispose();
          });
          this._objects = [];
        },
        /**
         * make a group an active selection, remove the group from canvas
         * the group has to be on canvas for this to work.
         * @return {fabric.ActiveSelection} thisArg
         * @chainable
         */
        toActiveSelection: function() {
          if (!this.canvas) {
            return;
          }
          var objects = this._objects, canvas = this.canvas;
          this._objects = [];
          var options = this.toObject();
          delete options.objects;
          var activeSelection = new fabric22.ActiveSelection([]);
          activeSelection.set(options);
          activeSelection.type = "activeSelection";
          canvas.remove(this);
          objects.forEach(function(object) {
            object.group = activeSelection;
            object.dirty = true;
            canvas.add(object);
          });
          activeSelection.canvas = canvas;
          activeSelection._objects = objects;
          canvas._activeObject = activeSelection;
          activeSelection.setCoords();
          return activeSelection;
        },
        /**
         * Destroys a group (restoring state of its objects)
         * @return {fabric.Group} thisArg
         * @chainable
         */
        ungroupOnCanvas: function() {
          return this._restoreObjectsState();
        },
        /**
         * Sets coordinates of all objects inside group
         * @return {fabric.Group} thisArg
         * @chainable
         */
        setObjectsCoords: function() {
          var skipControls = true;
          this.forEachObject(function(object) {
            object.setCoords(skipControls);
          });
          return this;
        },
        /**
         * @private
         */
        _calcBounds: function(onlyWidthHeight) {
          var aX = [], aY = [], o, prop, coords, props = ["tr", "br", "bl", "tl"], i = 0, iLen = this._objects.length, j, jLen = props.length;
          for (; i < iLen; ++i) {
            o = this._objects[i];
            coords = o.calcACoords();
            for (j = 0; j < jLen; j++) {
              prop = props[j];
              aX.push(coords[prop].x);
              aY.push(coords[prop].y);
            }
            o.aCoords = coords;
          }
          this._getBounds(aX, aY, onlyWidthHeight);
        },
        /**
         * @private
         */
        _getBounds: function(aX, aY, onlyWidthHeight) {
          var minXY = new fabric22.Point(min2(aX), min2(aY)), maxXY = new fabric22.Point(max2(aX), max2(aY)), top = minXY.y || 0, left = minXY.x || 0, width = maxXY.x - minXY.x || 0, height = maxXY.y - minXY.y || 0;
          this.width = width;
          this.height = height;
          if (!onlyWidthHeight) {
            this.setPositionByOrigin({ x: left, y: top }, "left", "top");
          }
        },
        /* _TO_SVG_START_ */
        /**
         * Returns svg representation of an instance
         * @param {Function} [reviver] Method for further parsing of svg representation.
         * @return {String} svg representation of an instance
         */
        _toSVG: function(reviver) {
          var svgString = ["<g ", "COMMON_PARTS", " >\n"];
          for (var i = 0, len = this._objects.length; i < len; i++) {
            svgString.push("		", this._objects[i].toSVG(reviver));
          }
          svgString.push("</g>\n");
          return svgString;
        },
        /**
         * Returns styles-string for svg-export, specific version for group
         * @return {String}
         */
        getSvgStyles: function() {
          var opacity = typeof this.opacity !== "undefined" && this.opacity !== 1 ? "opacity: " + this.opacity + ";" : "", visibility = this.visible ? "" : " visibility: hidden;";
          return [
            opacity,
            this.getSvgFilter(),
            visibility
          ].join("");
        },
        /**
         * Returns svg clipPath representation of an instance
         * @param {Function} [reviver] Method for further parsing of svg representation.
         * @return {String} svg representation of an instance
         */
        toClipPathSVG: function(reviver) {
          var svgString = [];
          for (var i = 0, len = this._objects.length; i < len; i++) {
            svgString.push("	", this._objects[i].toClipPathSVG(reviver));
          }
          return this._createBaseClipPathSVGMarkup(svgString, { reviver });
        }
        /* _TO_SVG_END_ */
      }
    );
    fabric22.Group.fromObject = function(object, callback) {
      var objects = object.objects, options = fabric22.util.object.clone(object, true);
      delete options.objects;
      if (typeof objects === "string") {
        fabric22.loadSVGFromURL(objects, function(elements) {
          var group = fabric22.util.groupSVGElements(elements, object, objects);
          var clipPath = options.clipPath;
          delete options.clipPath;
          group.set(options);
          if (clipPath) {
            fabric22.util.enlivenObjects([clipPath], function(elivenedObjects) {
              group.clipPath = elivenedObjects[0];
              callback && callback(group);
            });
          } else {
            callback && callback(group);
          }
        });
        return;
      }
      fabric22.util.enlivenObjects(objects, function(enlivenedObjects) {
        fabric22.util.enlivenObjectEnlivables(object, options, function() {
          callback && callback(new fabric22.Group(enlivenedObjects, options, true));
        });
      });
    };
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {});
    if (fabric22.ActiveSelection) {
      return;
    }
    fabric22.ActiveSelection = fabric22.util.createClass(
      fabric22.Group,
      /** @lends fabric.ActiveSelection.prototype */
      {
        /**
         * Type of an object
         * @type String
         * @default
         */
        type: "activeSelection",
        /**
         * Constructor
         * @param {Object} objects ActiveSelection objects
         * @param {Object} [options] Options object
         * @return {Object} thisArg
         */
        initialize: function(objects, options) {
          options = options || {};
          this._objects = objects || [];
          for (var i = this._objects.length; i--; ) {
            this._objects[i].group = this;
          }
          if (options.originX) {
            this.originX = options.originX;
          }
          if (options.originY) {
            this.originY = options.originY;
          }
          this._calcBounds();
          this._updateObjectsCoords();
          fabric22.Object.prototype.initialize.call(this, options);
          this.setCoords();
        },
        /**
         * Change te activeSelection to a normal group,
         * High level function that automatically adds it to canvas as
         * active object. no events fired.
         * @since 2.0.0
         * @return {fabric.Group}
         */
        toGroup: function() {
          var objects = this._objects.concat();
          this._objects = [];
          var options = fabric22.Object.prototype.toObject.call(this);
          var newGroup = new fabric22.Group([]);
          delete options.type;
          newGroup.set(options);
          objects.forEach(function(object) {
            object.canvas.remove(object);
            object.group = newGroup;
          });
          newGroup._objects = objects;
          if (!this.canvas) {
            return newGroup;
          }
          var canvas = this.canvas;
          canvas.add(newGroup);
          canvas._activeObject = newGroup;
          newGroup.setCoords();
          return newGroup;
        },
        /**
         * If returns true, deselection is cancelled.
         * @since 2.0.0
         * @return {Boolean} [cancel]
         */
        onDeselect: function() {
          this.destroy();
          return false;
        },
        /**
         * Returns string representation of a group
         * @return {String}
         */
        toString: function() {
          return "#<fabric.ActiveSelection: (" + this.complexity() + ")>";
        },
        /**
         * Decide if the object should cache or not. Create its own cache level
         * objectCaching is a global flag, wins over everything
         * needsItsOwnCache should be used when the object drawing method requires
         * a cache step. None of the fabric classes requires it.
         * Generally you do not cache objects in groups because the group outside is cached.
         * @return {Boolean}
         */
        shouldCache: function() {
          return false;
        },
        /**
         * Check if this group or its parent group are caching, recursively up
         * @return {Boolean}
         */
        isOnACache: function() {
          return false;
        },
        /**
         * Renders controls and borders for the object
         * @param {CanvasRenderingContext2D} ctx Context to render on
         * @param {Object} [styleOverride] properties to override the object style
         * @param {Object} [childrenOverride] properties to override the children overrides
         */
        _renderControls: function(ctx, styleOverride, childrenOverride) {
          ctx.save();
          ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
          this.callSuper("_renderControls", ctx, styleOverride);
          childrenOverride = childrenOverride || {};
          if (typeof childrenOverride.hasControls === "undefined") {
            childrenOverride.hasControls = false;
          }
          childrenOverride.forActiveSelection = true;
          for (var i = 0, len = this._objects.length; i < len; i++) {
            this._objects[i]._renderControls(ctx, childrenOverride);
          }
          ctx.restore();
        }
      }
    );
    fabric22.ActiveSelection.fromObject = function(object, callback) {
      fabric22.util.enlivenObjects(object.objects, function(enlivenedObjects) {
        delete object.objects;
        callback && callback(new fabric22.ActiveSelection(enlivenedObjects, object, true));
      });
    };
  })(exports);
  (function(global) {
    var extend = fabric2.util.object.extend;
    if (!global.fabric) {
      global.fabric = {};
    }
    if (global.fabric.Image) {
      fabric2.warn("fabric.Image is already defined.");
      return;
    }
    fabric2.Image = fabric2.util.createClass(
      fabric2.Object,
      /** @lends fabric.Image.prototype */
      {
        /**
         * Type of an object
         * @type String
         * @default
         */
        type: "image",
        /**
         * Width of a stroke.
         * For image quality a stroke multiple of 2 gives better results.
         * @type Number
         * @default
         */
        strokeWidth: 0,
        /**
         * When calling {@link fabric.Image.getSrc}, return value from element src with `element.getAttribute('src')`.
         * This allows for relative urls as image src.
         * @since 2.7.0
         * @type Boolean
         * @default
         */
        srcFromAttribute: false,
        /**
         * private
         * contains last value of scaleX to detect
         * if the Image got resized after the last Render
         * @type Number
         */
        _lastScaleX: 1,
        /**
         * private
         * contains last value of scaleY to detect
         * if the Image got resized after the last Render
         * @type Number
         */
        _lastScaleY: 1,
        /**
         * private
         * contains last value of scaling applied by the apply filter chain
         * @type Number
         */
        _filterScalingX: 1,
        /**
         * private
         * contains last value of scaling applied by the apply filter chain
         * @type Number
         */
        _filterScalingY: 1,
        /**
         * minimum scale factor under which any resizeFilter is triggered to resize the image
         * 0 will disable the automatic resize. 1 will trigger automatically always.
         * number bigger than 1 are not implemented yet.
         * @type Number
         */
        minimumScaleTrigger: 0.5,
        /**
         * List of properties to consider when checking if
         * state of an object is changed ({@link fabric.Object#hasStateChanged})
         * as well as for history (undo/redo) purposes
         * @type Array
         */
        stateProperties: fabric2.Object.prototype.stateProperties.concat("cropX", "cropY"),
        /**
         * List of properties to consider when checking if cache needs refresh
         * Those properties are checked by statefullCache ON ( or lazy mode if we want ) or from single
         * calls to Object.set(key, value). If the key is in this list, the object is marked as dirty
         * and refreshed at the next render
         * @type Array
         */
        cacheProperties: fabric2.Object.prototype.cacheProperties.concat("cropX", "cropY"),
        /**
         * key used to retrieve the texture representing this image
         * @since 2.0.0
         * @type String
         * @default
         */
        cacheKey: "",
        /**
         * Image crop in pixels from original image size.
         * @since 2.0.0
         * @type Number
         * @default
         */
        cropX: 0,
        /**
         * Image crop in pixels from original image size.
         * @since 2.0.0
         * @type Number
         * @default
         */
        cropY: 0,
        /**
         * Indicates whether this canvas will use image smoothing when painting this image.
         * Also influence if the cacheCanvas for this image uses imageSmoothing
         * @since 4.0.0-beta.11
         * @type Boolean
         * @default
         */
        imageSmoothing: true,
        /**
         * Constructor
         * Image can be initialized with any canvas drawable or a string.
         * The string should be a url and will be loaded as an image.
         * Canvas and Image element work out of the box, while videos require extra code to work.
         * Please check video element events for seeking.
         * @param {HTMLImageElement | HTMLCanvasElement | HTMLVideoElement | String} element Image element
         * @param {Object} [options] Options object
         * @param {function} [callback] callback function to call after eventual filters applied.
         * @return {fabric.Image} thisArg
         */
        initialize: function(element, options) {
          options || (options = {});
          this.filters = [];
          this.cacheKey = "texture" + fabric2.Object.__uid++;
          this.callSuper("initialize", options);
          this._initElement(element, options);
        },
        /**
         * Returns image element which this instance if based on
         * @return {HTMLImageElement} Image element
         */
        getElement: function() {
          return this._element || {};
        },
        /**
         * Sets image element for this instance to a specified one.
         * If filters defined they are applied to new image.
         * You might need to call `canvas.renderAll` and `object.setCoords` after replacing, to render new image and update controls area.
         * @param {HTMLImageElement} element
         * @param {Object} [options] Options object
         * @return {fabric.Image} thisArg
         * @chainable
         */
        setElement: function(element, options) {
          this.removeTexture(this.cacheKey);
          this.removeTexture(this.cacheKey + "_filtered");
          this._element = element;
          this._originalElement = element;
          this._initConfig(options);
          if (this.filters.length !== 0) {
            this.applyFilters();
          }
          if (this.resizeFilter) {
            this.applyResizeFilters();
          }
          return this;
        },
        /**
         * Delete a single texture if in webgl mode
         */
        removeTexture: function(key) {
          var backend = fabric2.filterBackend;
          if (backend && backend.evictCachesForKey) {
            backend.evictCachesForKey(key);
          }
        },
        /**
         * Delete textures, reference to elements and eventually JSDOM cleanup
         */
        dispose: function() {
          this.callSuper("dispose");
          this.removeTexture(this.cacheKey);
          this.removeTexture(this.cacheKey + "_filtered");
          this._cacheContext = void 0;
          ["_originalElement", "_element", "_filteredEl", "_cacheCanvas"].forEach((function(element) {
            fabric2.util.cleanUpJsdomNode(this[element]);
            this[element] = void 0;
          }).bind(this));
        },
        /**
         * Get the crossOrigin value (of the corresponding image element)
         */
        getCrossOrigin: function() {
          return this._originalElement && (this._originalElement.crossOrigin || null);
        },
        /**
         * Returns original size of an image
         * @return {Object} Object with "width" and "height" properties
         */
        getOriginalSize: function() {
          var element = this.getElement();
          return {
            width: element.naturalWidth || element.width,
            height: element.naturalHeight || element.height
          };
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _stroke: function(ctx) {
          if (!this.stroke || this.strokeWidth === 0) {
            return;
          }
          var w = this.width / 2, h = this.height / 2;
          ctx.beginPath();
          ctx.moveTo(-w, -h);
          ctx.lineTo(w, -h);
          ctx.lineTo(w, h);
          ctx.lineTo(-w, h);
          ctx.lineTo(-w, -h);
          ctx.closePath();
        },
        /**
         * Returns object representation of an instance
         * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
         * @return {Object} Object representation of an instance
         */
        toObject: function(propertiesToInclude) {
          var filters = [];
          this.filters.forEach(function(filterObj) {
            if (filterObj) {
              filters.push(filterObj.toObject());
            }
          });
          var object = extend(
            this.callSuper(
              "toObject",
              ["cropX", "cropY"].concat(propertiesToInclude)
            ),
            {
              src: this.getSrc(),
              crossOrigin: this.getCrossOrigin(),
              filters
            }
          );
          if (this.resizeFilter) {
            object.resizeFilter = this.resizeFilter.toObject();
          }
          return object;
        },
        /**
         * Returns true if an image has crop applied, inspecting values of cropX,cropY,width,height.
         * @return {Boolean}
         */
        hasCrop: function() {
          return this.cropX || this.cropY || this.width < this._element.width || this.height < this._element.height;
        },
        /* _TO_SVG_START_ */
        /**
         * Returns svg representation of an instance
         * @return {Array} an array of strings with the specific svg representation
         * of the instance
         */
        _toSVG: function() {
          var svgString = [], imageMarkup = [], strokeSvg, element = this._element, x = -this.width / 2, y = -this.height / 2, clipPath = "", imageRendering = "";
          if (!element) {
            return [];
          }
          if (this.hasCrop()) {
            var clipPathId = fabric2.Object.__uid++;
            svgString.push(
              '<clipPath id="imageCrop_' + clipPathId + '">\n',
              '	<rect x="' + x + '" y="' + y + '" width="' + this.width + '" height="' + this.height + '" />\n',
              "</clipPath>\n"
            );
            clipPath = ' clip-path="url(#imageCrop_' + clipPathId + ')" ';
          }
          if (!this.imageSmoothing) {
            imageRendering = '" image-rendering="optimizeSpeed';
          }
          imageMarkup.push(
            "	<image ",
            "COMMON_PARTS",
            'xlink:href="',
            this.getSvgSrc(true),
            '" x="',
            x - this.cropX,
            '" y="',
            y - this.cropY,
            // we're essentially moving origin of transformation from top/left corner to the center of the shape
            // by wrapping it in container <g> element with actual transformation, then offsetting object to the top/left
            // so that object's center aligns with container's left/top
            '" width="',
            element.width || element.naturalWidth,
            '" height="',
            element.height || element.height,
            imageRendering,
            '"',
            clipPath,
            "></image>\n"
          );
          if (this.stroke || this.strokeDashArray) {
            var origFill = this.fill;
            this.fill = null;
            strokeSvg = [
              "	<rect ",
              'x="',
              x,
              '" y="',
              y,
              '" width="',
              this.width,
              '" height="',
              this.height,
              '" style="',
              this.getSvgStyles(),
              '"/>\n'
            ];
            this.fill = origFill;
          }
          if (this.paintFirst !== "fill") {
            svgString = svgString.concat(strokeSvg, imageMarkup);
          } else {
            svgString = svgString.concat(imageMarkup, strokeSvg);
          }
          return svgString;
        },
        /* _TO_SVG_END_ */
        /**
         * Returns source of an image
         * @param {Boolean} filtered indicates if the src is needed for svg
         * @return {String} Source of an image
         */
        getSrc: function(filtered) {
          var element = filtered ? this._element : this._originalElement;
          if (element) {
            if (element.toDataURL) {
              return element.toDataURL();
            }
            if (this.srcFromAttribute) {
              return element.getAttribute("src");
            } else {
              return element.src;
            }
          } else {
            return this.src || "";
          }
        },
        /**
         * Sets source of an image
         * @param {String} src Source string (URL)
         * @param {Function} [callback] Callback is invoked when image has been loaded (and all filters have been applied)
         * @param {Object} [options] Options object
         * @param {String} [options.crossOrigin] crossOrigin value (one of "", "anonymous", "use-credentials")
         * @see https://developer.mozilla.org/en-US/docs/HTML/CORS_settings_attributes
         * @return {fabric.Image} thisArg
         * @chainable
         */
        setSrc: function(src, callback, options) {
          fabric2.util.loadImage(src, function(img, isError) {
            this.setElement(img, options);
            this._setWidthHeight();
            callback && callback(this, isError);
          }, this, options && options.crossOrigin);
          return this;
        },
        /**
         * Returns string representation of an instance
         * @return {String} String representation of an instance
         */
        toString: function() {
          return '#<fabric.Image: { src: "' + this.getSrc() + '" }>';
        },
        applyResizeFilters: function() {
          var filter = this.resizeFilter, minimumScale = this.minimumScaleTrigger, objectScale = this.getTotalObjectScaling(), scaleX = objectScale.scaleX, scaleY = objectScale.scaleY, elementToFilter = this._filteredEl || this._originalElement;
          if (this.group) {
            this.set("dirty", true);
          }
          if (!filter || scaleX > minimumScale && scaleY > minimumScale) {
            this._element = elementToFilter;
            this._filterScalingX = 1;
            this._filterScalingY = 1;
            this._lastScaleX = scaleX;
            this._lastScaleY = scaleY;
            return;
          }
          if (!fabric2.filterBackend) {
            fabric2.filterBackend = fabric2.initFilterBackend();
          }
          var canvasEl = fabric2.util.createCanvasElement(), cacheKey = this._filteredEl ? this.cacheKey + "_filtered" : this.cacheKey, sourceWidth = elementToFilter.width, sourceHeight = elementToFilter.height;
          canvasEl.width = sourceWidth;
          canvasEl.height = sourceHeight;
          this._element = canvasEl;
          this._lastScaleX = filter.scaleX = scaleX;
          this._lastScaleY = filter.scaleY = scaleY;
          fabric2.filterBackend.applyFilters(
            [filter],
            elementToFilter,
            sourceWidth,
            sourceHeight,
            this._element,
            cacheKey
          );
          this._filterScalingX = canvasEl.width / this._originalElement.width;
          this._filterScalingY = canvasEl.height / this._originalElement.height;
        },
        /**
         * Applies filters assigned to this image (from "filters" array) or from filter param
         * @method applyFilters
         * @param {Array} filters to be applied
         * @param {Boolean} forResizing specify if the filter operation is a resize operation
         * @return {thisArg} return the fabric.Image object
         * @chainable
         */
        applyFilters: function(filters) {
          filters = filters || this.filters || [];
          filters = filters.filter(function(filter) {
            return filter && !filter.isNeutralState();
          });
          this.set("dirty", true);
          this.removeTexture(this.cacheKey + "_filtered");
          if (filters.length === 0) {
            this._element = this._originalElement;
            this._filteredEl = null;
            this._filterScalingX = 1;
            this._filterScalingY = 1;
            return this;
          }
          var imgElement = this._originalElement, sourceWidth = imgElement.naturalWidth || imgElement.width, sourceHeight = imgElement.naturalHeight || imgElement.height;
          if (this._element === this._originalElement) {
            var canvasEl = fabric2.util.createCanvasElement();
            canvasEl.width = sourceWidth;
            canvasEl.height = sourceHeight;
            this._element = canvasEl;
            this._filteredEl = canvasEl;
          } else {
            this._element = this._filteredEl;
            this._filteredEl.getContext("2d").clearRect(0, 0, sourceWidth, sourceHeight);
            this._lastScaleX = 1;
            this._lastScaleY = 1;
          }
          if (!fabric2.filterBackend) {
            fabric2.filterBackend = fabric2.initFilterBackend();
          }
          fabric2.filterBackend.applyFilters(
            filters,
            this._originalElement,
            sourceWidth,
            sourceHeight,
            this._element,
            this.cacheKey
          );
          if (this._originalElement.width !== this._element.width || this._originalElement.height !== this._element.height) {
            this._filterScalingX = this._element.width / this._originalElement.width;
            this._filterScalingY = this._element.height / this._originalElement.height;
          }
          return this;
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _render: function(ctx) {
          fabric2.util.setImageSmoothing(ctx, this.imageSmoothing);
          if (this.isMoving !== true && this.resizeFilter && this._needsResize()) {
            this.applyResizeFilters();
          }
          this._stroke(ctx);
          this._renderPaintInOrder(ctx);
        },
        /**
         * Paint the cached copy of the object on the target context.
         * it will set the imageSmoothing for the draw operation
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        drawCacheOnCanvas: function(ctx) {
          fabric2.util.setImageSmoothing(ctx, this.imageSmoothing);
          fabric2.Object.prototype.drawCacheOnCanvas.call(this, ctx);
        },
        /**
         * Decide if the object should cache or not. Create its own cache level
         * needsItsOwnCache should be used when the object drawing method requires
         * a cache step. None of the fabric classes requires it.
         * Generally you do not cache objects in groups because the group outside is cached.
         * This is the special image version where we would like to avoid caching where possible.
         * Essentially images do not benefit from caching. They may require caching, and in that
         * case we do it. Also caching an image usually ends in a loss of details.
         * A full performance audit should be done.
         * @return {Boolean}
         */
        shouldCache: function() {
          return this.needsItsOwnCache();
        },
        _renderFill: function(ctx) {
          var elementToDraw = this._element;
          if (!elementToDraw) {
            return;
          }
          var scaleX = this._filterScalingX, scaleY = this._filterScalingY, w = this.width, h = this.height, min2 = Math.min, max2 = Math.max, cropX = max2(this.cropX, 0), cropY = max2(this.cropY, 0), elWidth = elementToDraw.naturalWidth || elementToDraw.width, elHeight = elementToDraw.naturalHeight || elementToDraw.height, sX = cropX * scaleX, sY = cropY * scaleY, sW = min2(w * scaleX, elWidth - sX), sH = min2(h * scaleY, elHeight - sY), x = -w / 2, y = -h / 2, maxDestW = min2(w, elWidth / scaleX - cropX), maxDestH = min2(h, elHeight / scaleY - cropY);
          elementToDraw && ctx.drawImage(elementToDraw, sX, sY, sW, sH, x, y, maxDestW, maxDestH);
        },
        /**
         * needed to check if image needs resize
         * @private
         */
        _needsResize: function() {
          var scale = this.getTotalObjectScaling();
          return scale.scaleX !== this._lastScaleX || scale.scaleY !== this._lastScaleY;
        },
        /**
         * @private
         */
        _resetWidthHeight: function() {
          this.set(this.getOriginalSize());
        },
        /**
         * The Image class's initialization method. This method is automatically
         * called by the constructor.
         * @private
         * @param {HTMLImageElement|String} element The element representing the image
         * @param {Object} [options] Options object
         */
        _initElement: function(element, options) {
          this.setElement(fabric2.util.getById(element), options);
          fabric2.util.addClass(this.getElement(), fabric2.Image.CSS_CANVAS);
        },
        /**
         * @private
         * @param {Object} [options] Options object
         */
        _initConfig: function(options) {
          options || (options = {});
          this.setOptions(options);
          this._setWidthHeight(options);
        },
        /**
         * @private
         * @param {Array} filters to be initialized
         * @param {Function} callback Callback to invoke when all fabric.Image.filters instances are created
         */
        _initFilters: function(filters, callback) {
          if (filters && filters.length) {
            fabric2.util.enlivenObjects(filters, function(enlivenedObjects) {
              callback && callback(enlivenedObjects);
            }, "fabric.Image.filters");
          } else {
            callback && callback();
          }
        },
        /**
         * @private
         * Set the width and the height of the image object, using the element or the
         * options.
         * @param {Object} [options] Object with width/height properties
         */
        _setWidthHeight: function(options) {
          options || (options = {});
          var el = this.getElement();
          this.width = options.width || el.naturalWidth || el.width || 0;
          this.height = options.height || el.naturalHeight || el.height || 0;
        },
        /**
         * Calculate offset for center and scale factor for the image in order to respect
         * the preserveAspectRatio attribute
         * @private
         * @return {Object}
         */
        parsePreserveAspectRatioAttribute: function() {
          var pAR = fabric2.util.parsePreserveAspectRatioAttribute(this.preserveAspectRatio || ""), rWidth = this._element.width, rHeight = this._element.height, scaleX = 1, scaleY = 1, offsetLeft = 0, offsetTop = 0, cropX = 0, cropY = 0, offset, pWidth = this.width, pHeight = this.height, parsedAttributes = { width: pWidth, height: pHeight };
          if (pAR && (pAR.alignX !== "none" || pAR.alignY !== "none")) {
            if (pAR.meetOrSlice === "meet") {
              scaleX = scaleY = fabric2.util.findScaleToFit(this._element, parsedAttributes);
              offset = (pWidth - rWidth * scaleX) / 2;
              if (pAR.alignX === "Min") {
                offsetLeft = -offset;
              }
              if (pAR.alignX === "Max") {
                offsetLeft = offset;
              }
              offset = (pHeight - rHeight * scaleY) / 2;
              if (pAR.alignY === "Min") {
                offsetTop = -offset;
              }
              if (pAR.alignY === "Max") {
                offsetTop = offset;
              }
            }
            if (pAR.meetOrSlice === "slice") {
              scaleX = scaleY = fabric2.util.findScaleToCover(this._element, parsedAttributes);
              offset = rWidth - pWidth / scaleX;
              if (pAR.alignX === "Mid") {
                cropX = offset / 2;
              }
              if (pAR.alignX === "Max") {
                cropX = offset;
              }
              offset = rHeight - pHeight / scaleY;
              if (pAR.alignY === "Mid") {
                cropY = offset / 2;
              }
              if (pAR.alignY === "Max") {
                cropY = offset;
              }
              rWidth = pWidth / scaleX;
              rHeight = pHeight / scaleY;
            }
          } else {
            scaleX = pWidth / rWidth;
            scaleY = pHeight / rHeight;
          }
          return {
            width: rWidth,
            height: rHeight,
            scaleX,
            scaleY,
            offsetLeft,
            offsetTop,
            cropX,
            cropY
          };
        }
      }
    );
    fabric2.Image.CSS_CANVAS = "canvas-img";
    fabric2.Image.prototype.getSvgSrc = fabric2.Image.prototype.getSrc;
    fabric2.Image.fromObject = function(_object, callback) {
      var object = fabric2.util.object.clone(_object);
      fabric2.util.loadImage(object.src, function(img, isError) {
        if (isError) {
          callback && callback(null, true);
          return;
        }
        fabric2.Image.prototype._initFilters.call(object, object.filters, function(filters) {
          object.filters = filters || [];
          fabric2.Image.prototype._initFilters.call(object, [object.resizeFilter], function(resizeFilters) {
            object.resizeFilter = resizeFilters[0];
            fabric2.util.enlivenObjectEnlivables(object, object, function() {
              var image = new fabric2.Image(img, object);
              callback(image, false);
            });
          });
        });
      }, null, object.crossOrigin);
    };
    fabric2.Image.fromURL = function(url, callback, imgOptions) {
      fabric2.util.loadImage(url, function(img, isError) {
        callback && callback(new fabric2.Image(img, imgOptions), isError);
      }, null, imgOptions && imgOptions.crossOrigin);
    };
    fabric2.Image.ATTRIBUTE_NAMES = fabric2.SHARED_ATTRIBUTES.concat(
      "x y width height preserveAspectRatio xlink:href crossOrigin image-rendering".split(" ")
    );
    fabric2.Image.fromElement = function(element, callback, options) {
      var parsedAttributes = fabric2.parseAttributes(element, fabric2.Image.ATTRIBUTE_NAMES);
      fabric2.Image.fromURL(
        parsedAttributes["xlink:href"],
        callback,
        extend(options ? fabric2.util.object.clone(options) : {}, parsedAttributes)
      );
    };
  })(exports);
  fabric2.util.object.extend(
    fabric2.Object.prototype,
    /** @lends fabric.Object.prototype */
    {
      /**
       * @private
       * @return {Number} angle value
       */
      _getAngleValueForStraighten: function() {
        var angle = this.angle % 360;
        if (angle > 0) {
          return Math.round((angle - 1) / 90) * 90;
        }
        return Math.round(angle / 90) * 90;
      },
      /**
       * Straightens an object (rotating it from current angle to one of 0, 90, 180, 270, etc. depending on which is closer)
       * @return {fabric.Object} thisArg
       * @chainable
       */
      straighten: function() {
        return this.rotate(this._getAngleValueForStraighten());
      },
      /**
       * Same as {@link fabric.Object.prototype.straighten} but with animation
       * @param {Object} callbacks Object with callback functions
       * @param {Function} [callbacks.onComplete] Invoked on completion
       * @param {Function} [callbacks.onChange] Invoked on every step of animation
       * @return {fabric.Object} thisArg
       */
      fxStraighten: function(callbacks) {
        callbacks = callbacks || {};
        var empty = function() {
        }, onComplete = callbacks.onComplete || empty, onChange = callbacks.onChange || empty, _this = this;
        return fabric2.util.animate({
          target: this,
          startValue: this.get("angle"),
          endValue: this._getAngleValueForStraighten(),
          duration: this.FX_DURATION,
          onChange: function(value) {
            _this.rotate(value);
            onChange();
          },
          onComplete: function() {
            _this.setCoords();
            onComplete();
          }
        });
      }
    }
  );
  fabric2.util.object.extend(
    fabric2.StaticCanvas.prototype,
    /** @lends fabric.StaticCanvas.prototype */
    {
      /**
       * Straightens object, then rerenders canvas
       * @param {fabric.Object} object Object to straighten
       * @return {fabric.Canvas} thisArg
       * @chainable
       */
      straightenObject: function(object) {
        object.straighten();
        this.requestRenderAll();
        return this;
      },
      /**
       * Same as {@link fabric.Canvas.prototype.straightenObject}, but animated
       * @param {fabric.Object} object Object to straighten
       * @return {fabric.Canvas} thisArg
       */
      fxStraightenObject: function(object) {
        return object.fxStraighten({
          onChange: this.requestRenderAllBound
        });
      }
    }
  );
  (function() {
    function testPrecision(gl, precision) {
      var fragmentSource = "precision " + precision + " float;\nvoid main(){}";
      var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
      gl.shaderSource(fragmentShader, fragmentSource);
      gl.compileShader(fragmentShader);
      if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) {
        return false;
      }
      return true;
    }
    fabric2.isWebglSupported = function(tileSize) {
      if (fabric2.isLikelyNode) {
        return false;
      }
      tileSize = tileSize || fabric2.WebglFilterBackend.prototype.tileSize;
      var canvas = document.createElement("canvas");
      var gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
      var isSupported = false;
      if (gl) {
        fabric2.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
        isSupported = fabric2.maxTextureSize >= tileSize;
        var precisions = ["highp", "mediump", "lowp"];
        for (var i = 0; i < 3; i++) {
          if (testPrecision(gl, precisions[i])) {
            fabric2.webGlPrecision = precisions[i];
            break;
          }
        }
      }
      this.isSupported = isSupported;
      return isSupported;
    };
    fabric2.WebglFilterBackend = WebglFilterBackend;
    function WebglFilterBackend(options) {
      if (options && options.tileSize) {
        this.tileSize = options.tileSize;
      }
      this.setupGLContext(this.tileSize, this.tileSize);
      this.captureGPUInfo();
    }
    WebglFilterBackend.prototype = /** @lends fabric.WebglFilterBackend.prototype */
    {
      tileSize: 2048,
      /**
       * Experimental. This object is a sort of repository of help layers used to avoid
       * of recreating them during frequent filtering. If you are previewing a filter with
       * a slider you probably do not want to create help layers every filter step.
       * in this object there will be appended some canvases, created once, resized sometimes
       * cleared never. Clearing is left to the developer.
       **/
      resources: {},
      /**
       * Setup a WebGL context suitable for filtering, and bind any needed event handlers.
       */
      setupGLContext: function(width, height) {
        this.dispose();
        this.createWebGLCanvas(width, height);
        this.aPosition = new Float32Array([0, 0, 0, 1, 1, 0, 1, 1]);
        this.chooseFastestCopyGLTo2DMethod(width, height);
      },
      /**
       * Pick a method to copy data from GL context to 2d canvas.  In some browsers using
       * putImageData is faster than drawImage for that specific operation.
       */
      chooseFastestCopyGLTo2DMethod: function(width, height) {
        var canMeasurePerf = typeof window.performance !== "undefined", canUseImageData;
        try {
          new ImageData(1, 1);
          canUseImageData = true;
        } catch (e) {
          canUseImageData = false;
        }
        var canUseArrayBuffer = typeof ArrayBuffer !== "undefined";
        var canUseUint8Clamped = typeof Uint8ClampedArray !== "undefined";
        if (!(canMeasurePerf && canUseImageData && canUseArrayBuffer && canUseUint8Clamped)) {
          return;
        }
        var targetCanvas = fabric2.util.createCanvasElement();
        var imageBuffer = new ArrayBuffer(width * height * 4);
        if (fabric2.forceGLPutImageData) {
          this.imageBuffer = imageBuffer;
          this.copyGLTo2D = copyGLTo2DPutImageData;
          return;
        }
        var testContext = {
          imageBuffer,
          destinationWidth: width,
          destinationHeight: height,
          targetCanvas
        };
        var startTime, drawImageTime, putImageDataTime;
        targetCanvas.width = width;
        targetCanvas.height = height;
        startTime = window.performance.now();
        copyGLTo2DDrawImage.call(testContext, this.gl, testContext);
        drawImageTime = window.performance.now() - startTime;
        startTime = window.performance.now();
        copyGLTo2DPutImageData.call(testContext, this.gl, testContext);
        putImageDataTime = window.performance.now() - startTime;
        if (drawImageTime > putImageDataTime) {
          this.imageBuffer = imageBuffer;
          this.copyGLTo2D = copyGLTo2DPutImageData;
        } else {
          this.copyGLTo2D = copyGLTo2DDrawImage;
        }
      },
      /**
       * Create a canvas element and associated WebGL context and attaches them as
       * class properties to the GLFilterBackend class.
       */
      createWebGLCanvas: function(width, height) {
        var canvas = fabric2.util.createCanvasElement();
        canvas.width = width;
        canvas.height = height;
        var glOptions = {
          alpha: true,
          premultipliedAlpha: false,
          depth: false,
          stencil: false,
          antialias: false
        }, gl = canvas.getContext("webgl", glOptions);
        if (!gl) {
          gl = canvas.getContext("experimental-webgl", glOptions);
        }
        if (!gl) {
          return;
        }
        gl.clearColor(0, 0, 0, 0);
        this.canvas = canvas;
        this.gl = gl;
      },
      /**
       * Attempts to apply the requested filters to the source provided, drawing the filtered output
       * to the provided target canvas.
       *
       * @param {Array} filters The filters to apply.
       * @param {HTMLImageElement|HTMLCanvasElement} source The source to be filtered.
       * @param {Number} width The width of the source input.
       * @param {Number} height The height of the source input.
       * @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
       * @param {String|undefined} cacheKey A key used to cache resources related to the source. If
       * omitted, caching will be skipped.
       */
      applyFilters: function(filters, source, width, height, targetCanvas, cacheKey) {
        var gl = this.gl;
        var cachedTexture;
        if (cacheKey) {
          cachedTexture = this.getCachedTexture(cacheKey, source);
        }
        var pipelineState = {
          originalWidth: source.width || source.originalWidth,
          originalHeight: source.height || source.originalHeight,
          sourceWidth: width,
          sourceHeight: height,
          destinationWidth: width,
          destinationHeight: height,
          context: gl,
          sourceTexture: this.createTexture(gl, width, height, !cachedTexture && source),
          targetTexture: this.createTexture(gl, width, height),
          originalTexture: cachedTexture || this.createTexture(gl, width, height, !cachedTexture && source),
          passes: filters.length,
          webgl: true,
          aPosition: this.aPosition,
          programCache: this.programCache,
          pass: 0,
          filterBackend: this,
          targetCanvas
        };
        var tempFbo = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, tempFbo);
        filters.forEach(function(filter) {
          filter && filter.applyTo(pipelineState);
        });
        resizeCanvasIfNeeded(pipelineState);
        this.copyGLTo2D(gl, pipelineState);
        gl.bindTexture(gl.TEXTURE_2D, null);
        gl.deleteTexture(pipelineState.sourceTexture);
        gl.deleteTexture(pipelineState.targetTexture);
        gl.deleteFramebuffer(tempFbo);
        targetCanvas.getContext("2d").setTransform(1, 0, 0, 1, 0, 0);
        return pipelineState;
      },
      /**
       * Detach event listeners, remove references, and clean up caches.
       */
      dispose: function() {
        if (this.canvas) {
          this.canvas = null;
          this.gl = null;
        }
        this.clearWebGLCaches();
      },
      /**
       * Wipe out WebGL-related caches.
       */
      clearWebGLCaches: function() {
        this.programCache = {};
        this.textureCache = {};
      },
      /**
       * Create a WebGL texture object.
       *
       * Accepts specific dimensions to initialize the texture to or a source image.
       *
       * @param {WebGLRenderingContext} gl The GL context to use for creating the texture.
       * @param {Number} width The width to initialize the texture at.
       * @param {Number} height The height to initialize the texture.
       * @param {HTMLImageElement|HTMLCanvasElement} textureImageSource A source for the texture data.
       * @param {Number} filterType gl.NEAREST or gl.LINEAR usually, webgl numeri constants
       * @returns {WebGLTexture}
       */
      createTexture: function(gl, width, height, textureImageSource, filterType) {
        var texture2 = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture2);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, filterType || gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filterType || gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        if (textureImageSource) {
          gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, textureImageSource);
        } else {
          gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
        }
        return texture2;
      },
      /**
       * Can be optionally used to get a texture from the cache array
       *
       * If an existing texture is not found, a new texture is created and cached.
       *
       * @param {String} uniqueId A cache key to use to find an existing texture.
       * @param {HTMLImageElement|HTMLCanvasElement} textureImageSource A source to use to create the
       * texture cache entry if one does not already exist.
       */
      getCachedTexture: function(uniqueId, textureImageSource) {
        if (this.textureCache[uniqueId]) {
          return this.textureCache[uniqueId];
        } else {
          var texture2 = this.createTexture(
            this.gl,
            textureImageSource.width,
            textureImageSource.height,
            textureImageSource
          );
          this.textureCache[uniqueId] = texture2;
          return texture2;
        }
      },
      /**
       * Clear out cached resources related to a source image that has been
       * filtered previously.
       *
       * @param {String} cacheKey The cache key provided when the source image was filtered.
       */
      evictCachesForKey: function(cacheKey) {
        if (this.textureCache[cacheKey]) {
          this.gl.deleteTexture(this.textureCache[cacheKey]);
          delete this.textureCache[cacheKey];
        }
      },
      copyGLTo2D: copyGLTo2DDrawImage,
      /**
       * Attempt to extract GPU information strings from a WebGL context.
       *
       * Useful information when debugging or blacklisting specific GPUs.
       *
       * @returns {Object} A GPU info object with renderer and vendor strings.
       */
      captureGPUInfo: function() {
        if (this.gpuInfo) {
          return this.gpuInfo;
        }
        var gl = this.gl, gpuInfo = { renderer: "", vendor: "" };
        if (!gl) {
          return gpuInfo;
        }
        var ext = gl.getExtension("WEBGL_debug_renderer_info");
        if (ext) {
          var renderer = gl.getParameter(ext.UNMASKED_RENDERER_WEBGL);
          var vendor = gl.getParameter(ext.UNMASKED_VENDOR_WEBGL);
          if (renderer) {
            gpuInfo.renderer = renderer.toLowerCase();
          }
          if (vendor) {
            gpuInfo.vendor = vendor.toLowerCase();
          }
        }
        this.gpuInfo = gpuInfo;
        return gpuInfo;
      }
    };
  })();
  function resizeCanvasIfNeeded(pipelineState) {
    var targetCanvas = pipelineState.targetCanvas, width = targetCanvas.width, height = targetCanvas.height, dWidth = pipelineState.destinationWidth, dHeight = pipelineState.destinationHeight;
    if (width !== dWidth || height !== dHeight) {
      targetCanvas.width = dWidth;
      targetCanvas.height = dHeight;
    }
  }
  function copyGLTo2DDrawImage(gl, pipelineState) {
    var glCanvas = gl.canvas, targetCanvas = pipelineState.targetCanvas, ctx = targetCanvas.getContext("2d");
    ctx.translate(0, targetCanvas.height);
    ctx.scale(1, -1);
    var sourceY = glCanvas.height - targetCanvas.height;
    ctx.drawImage(
      glCanvas,
      0,
      sourceY,
      targetCanvas.width,
      targetCanvas.height,
      0,
      0,
      targetCanvas.width,
      targetCanvas.height
    );
  }
  function copyGLTo2DPutImageData(gl, pipelineState) {
    var targetCanvas = pipelineState.targetCanvas, ctx = targetCanvas.getContext("2d"), dWidth = pipelineState.destinationWidth, dHeight = pipelineState.destinationHeight, numBytes = dWidth * dHeight * 4;
    var u8 = new Uint8Array(this.imageBuffer, 0, numBytes);
    var u8Clamped = new Uint8ClampedArray(this.imageBuffer, 0, numBytes);
    gl.readPixels(0, 0, dWidth, dHeight, gl.RGBA, gl.UNSIGNED_BYTE, u8);
    var imgData = new ImageData(u8Clamped, dWidth, dHeight);
    ctx.putImageData(imgData, 0, 0);
  }
  (function() {
    var noop = function() {
    };
    fabric2.Canvas2dFilterBackend = Canvas2dFilterBackend;
    function Canvas2dFilterBackend() {
    }
    Canvas2dFilterBackend.prototype = /** @lends fabric.Canvas2dFilterBackend.prototype */
    {
      evictCachesForKey: noop,
      dispose: noop,
      clearWebGLCaches: noop,
      /**
       * Experimental. This object is a sort of repository of help layers used to avoid
       * of recreating them during frequent filtering. If you are previewing a filter with
       * a slider you probably do not want to create help layers every filter step.
       * in this object there will be appended some canvases, created once, resized sometimes
       * cleared never. Clearing is left to the developer.
       **/
      resources: {},
      /**
       * Apply a set of filters against a source image and draw the filtered output
       * to the provided destination canvas.
       *
       * @param {EnhancedFilter} filters The filter to apply.
       * @param {HTMLImageElement|HTMLCanvasElement} sourceElement The source to be filtered.
       * @param {Number} sourceWidth The width of the source input.
       * @param {Number} sourceHeight The height of the source input.
       * @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
       */
      applyFilters: function(filters, sourceElement, sourceWidth, sourceHeight, targetCanvas) {
        var ctx = targetCanvas.getContext("2d");
        ctx.drawImage(sourceElement, 0, 0, sourceWidth, sourceHeight);
        var imageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
        var originalImageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
        var pipelineState = {
          sourceWidth,
          sourceHeight,
          imageData,
          originalEl: sourceElement,
          originalImageData,
          canvasEl: targetCanvas,
          ctx,
          filterBackend: this
        };
        filters.forEach(function(filter) {
          filter.applyTo(pipelineState);
        });
        if (pipelineState.imageData.width !== sourceWidth || pipelineState.imageData.height !== sourceHeight) {
          targetCanvas.width = pipelineState.imageData.width;
          targetCanvas.height = pipelineState.imageData.height;
        }
        ctx.putImageData(pipelineState.imageData, 0, 0);
        return pipelineState;
      }
    };
  })();
  fabric2.Image = fabric2.Image || {};
  fabric2.Image.filters = fabric2.Image.filters || {};
  fabric2.Image.filters.BaseFilter = fabric2.util.createClass(
    /** @lends fabric.Image.filters.BaseFilter.prototype */
    {
      /**
       * Filter type
       * @param {String} type
       * @default
       */
      type: "BaseFilter",
      /**
       * Array of attributes to send with buffers. do not modify
       * @private
       */
      vertexSource: "attribute vec2 aPosition;\nvarying vec2 vTexCoord;\nvoid main() {\nvTexCoord = aPosition;\ngl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n}",
      fragmentSource: "precision highp float;\nvarying vec2 vTexCoord;\nuniform sampler2D uTexture;\nvoid main() {\ngl_FragColor = texture2D(uTexture, vTexCoord);\n}",
      /**
       * Constructor
       * @param {Object} [options] Options object
       */
      initialize: function(options) {
        if (options) {
          this.setOptions(options);
        }
      },
      /**
       * Sets filter's properties from options
       * @param {Object} [options] Options object
       */
      setOptions: function(options) {
        for (var prop in options) {
          this[prop] = options[prop];
        }
      },
      /**
       * Compile this filter's shader program.
       *
       * @param {WebGLRenderingContext} gl The GL canvas context to use for shader compilation.
       * @param {String} fragmentSource fragmentShader source for compilation
       * @param {String} vertexSource vertexShader source for compilation
       */
      createProgram: function(gl, fragmentSource, vertexSource) {
        fragmentSource = fragmentSource || this.fragmentSource;
        vertexSource = vertexSource || this.vertexSource;
        if (fabric2.webGlPrecision !== "highp") {
          fragmentSource = fragmentSource.replace(
            /precision highp float/g,
            "precision " + fabric2.webGlPrecision + " float"
          );
        }
        var vertexShader = gl.createShader(gl.VERTEX_SHADER);
        gl.shaderSource(vertexShader, vertexSource);
        gl.compileShader(vertexShader);
        if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) {
          throw new Error(
            // eslint-disable-next-line prefer-template
            "Vertex shader compile error for " + this.type + ": " + gl.getShaderInfoLog(vertexShader)
          );
        }
        var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
        gl.shaderSource(fragmentShader, fragmentSource);
        gl.compileShader(fragmentShader);
        if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) {
          throw new Error(
            // eslint-disable-next-line prefer-template
            "Fragment shader compile error for " + this.type + ": " + gl.getShaderInfoLog(fragmentShader)
          );
        }
        var program = gl.createProgram();
        gl.attachShader(program, vertexShader);
        gl.attachShader(program, fragmentShader);
        gl.linkProgram(program);
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
          throw new Error(
            // eslint-disable-next-line prefer-template
            'Shader link error for "${this.type}" ' + gl.getProgramInfoLog(program)
          );
        }
        var attributeLocations = this.getAttributeLocations(gl, program);
        var uniformLocations = this.getUniformLocations(gl, program) || {};
        uniformLocations.uStepW = gl.getUniformLocation(program, "uStepW");
        uniformLocations.uStepH = gl.getUniformLocation(program, "uStepH");
        return {
          program,
          attributeLocations,
          uniformLocations
        };
      },
      /**
       * Return a map of attribute names to WebGLAttributeLocation objects.
       *
       * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
       * @param {WebGLShaderProgram} program The shader program from which to take attribute locations.
       * @returns {Object} A map of attribute names to attribute locations.
       */
      getAttributeLocations: function(gl, program) {
        return {
          aPosition: gl.getAttribLocation(program, "aPosition")
        };
      },
      /**
       * Return a map of uniform names to WebGLUniformLocation objects.
       *
       * Intended to be overridden by subclasses.
       *
       * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
       * @param {WebGLShaderProgram} program The shader program from which to take uniform locations.
       * @returns {Object} A map of uniform names to uniform locations.
       */
      getUniformLocations: function() {
        return {};
      },
      /**
       * Send attribute data from this filter to its shader program on the GPU.
       *
       * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
       * @param {Object} attributeLocations A map of shader attribute names to their locations.
       */
      sendAttributeData: function(gl, attributeLocations, aPositionData) {
        var attributeLocation = attributeLocations.aPosition;
        var buffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        gl.enableVertexAttribArray(attributeLocation);
        gl.vertexAttribPointer(attributeLocation, 2, gl.FLOAT, false, 0, 0);
        gl.bufferData(gl.ARRAY_BUFFER, aPositionData, gl.STATIC_DRAW);
      },
      _setupFrameBuffer: function(options) {
        var gl = options.context, width, height;
        if (options.passes > 1) {
          width = options.destinationWidth;
          height = options.destinationHeight;
          if (options.sourceWidth !== width || options.sourceHeight !== height) {
            gl.deleteTexture(options.targetTexture);
            options.targetTexture = options.filterBackend.createTexture(gl, width, height);
          }
          gl.framebufferTexture2D(
            gl.FRAMEBUFFER,
            gl.COLOR_ATTACHMENT0,
            gl.TEXTURE_2D,
            options.targetTexture,
            0
          );
        } else {
          gl.bindFramebuffer(gl.FRAMEBUFFER, null);
          gl.finish();
        }
      },
      _swapTextures: function(options) {
        options.passes--;
        options.pass++;
        var temp = options.targetTexture;
        options.targetTexture = options.sourceTexture;
        options.sourceTexture = temp;
      },
      /**
       * Generic isNeutral implementation for one parameter based filters.
       * Used only in image applyFilters to discard filters that will not have an effect
       * on the image
       * Other filters may need their own version ( ColorMatrix, HueRotation, gamma, ComposedFilter )
       * @param {Object} options
       **/
      isNeutralState: function() {
        var main = this.mainParameter, _class = fabric2.Image.filters[this.type].prototype;
        if (main) {
          if (Array.isArray(_class[main])) {
            for (var i = _class[main].length; i--; ) {
              if (this[main][i] !== _class[main][i]) {
                return false;
              }
            }
            return true;
          } else {
            return _class[main] === this[main];
          }
        } else {
          return false;
        }
      },
      /**
       * Apply this filter to the input image data provided.
       *
       * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
       *
       * @param {Object} options
       * @param {Number} options.passes The number of filters remaining to be executed
       * @param {Boolean} options.webgl Whether to use webgl to render the filter.
       * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
       * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
       * @param {WebGLRenderingContext} options.context The GL context used for rendering.
       * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
       */
      applyTo: function(options) {
        if (options.webgl) {
          this._setupFrameBuffer(options);
          this.applyToWebGL(options);
          this._swapTextures(options);
        } else {
          this.applyTo2d(options);
        }
      },
      /**
       * Retrieves the cached shader.
       * @param {Object} options
       * @param {WebGLRenderingContext} options.context The GL context used for rendering.
       * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
       */
      retrieveShader: function(options) {
        if (!options.programCache.hasOwnProperty(this.type)) {
          options.programCache[this.type] = this.createProgram(options.context);
        }
        return options.programCache[this.type];
      },
      /**
       * Apply this filter using webgl.
       *
       * @param {Object} options
       * @param {Number} options.passes The number of filters remaining to be executed
       * @param {Boolean} options.webgl Whether to use webgl to render the filter.
       * @param {WebGLTexture} options.originalTexture The texture of the original input image.
       * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
       * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
       * @param {WebGLRenderingContext} options.context The GL context used for rendering.
       * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
       */
      applyToWebGL: function(options) {
        var gl = options.context;
        var shader = this.retrieveShader(options);
        if (options.pass === 0 && options.originalTexture) {
          gl.bindTexture(gl.TEXTURE_2D, options.originalTexture);
        } else {
          gl.bindTexture(gl.TEXTURE_2D, options.sourceTexture);
        }
        gl.useProgram(shader.program);
        this.sendAttributeData(gl, shader.attributeLocations, options.aPosition);
        gl.uniform1f(shader.uniformLocations.uStepW, 1 / options.sourceWidth);
        gl.uniform1f(shader.uniformLocations.uStepH, 1 / options.sourceHeight);
        this.sendUniformData(gl, shader.uniformLocations);
        gl.viewport(0, 0, options.destinationWidth, options.destinationHeight);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      },
      bindAdditionalTexture: function(gl, texture2, textureUnit) {
        gl.activeTexture(textureUnit);
        gl.bindTexture(gl.TEXTURE_2D, texture2);
        gl.activeTexture(gl.TEXTURE0);
      },
      unbindAdditionalTexture: function(gl, textureUnit) {
        gl.activeTexture(textureUnit);
        gl.bindTexture(gl.TEXTURE_2D, null);
        gl.activeTexture(gl.TEXTURE0);
      },
      getMainParameter: function() {
        return this[this.mainParameter];
      },
      setMainParameter: function(value) {
        this[this.mainParameter] = value;
      },
      /**
       * Send uniform data from this filter to its shader program on the GPU.
       *
       * Intended to be overridden by subclasses.
       *
       * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
       * @param {Object} uniformLocations A map of shader uniform names to their locations.
       */
      sendUniformData: function() {
      },
      /**
       * If needed by a 2d filter, this functions can create an helper canvas to be used
       * remember that options.targetCanvas is available for use till end of chain.
       */
      createHelpLayer: function(options) {
        if (!options.helpLayer) {
          var helpLayer = document.createElement("canvas");
          helpLayer.width = options.sourceWidth;
          helpLayer.height = options.sourceHeight;
          options.helpLayer = helpLayer;
        }
      },
      /**
       * Returns object representation of an instance
       * @return {Object} Object representation of an instance
       */
      toObject: function() {
        var object = { type: this.type }, mainP = this.mainParameter;
        if (mainP) {
          object[mainP] = this[mainP];
        }
        return object;
      },
      /**
       * Returns a JSON representation of an instance
       * @return {Object} JSON
       */
      toJSON: function() {
        return this.toObject();
      }
    }
  );
  fabric2.Image.filters.BaseFilter.fromObject = function(object, callback) {
    var filter = new fabric2.Image.filters[object.type](object);
    callback && callback(filter);
    return filter;
  };
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), filters = fabric22.Image.filters, createClass = fabric22.util.createClass;
    filters.ColorMatrix = createClass(
      filters.BaseFilter,
      /** @lends fabric.Image.filters.ColorMatrix.prototype */
      {
        /**
         * Filter type
         * @param {String} type
         * @default
         */
        type: "ColorMatrix",
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nvarying vec2 vTexCoord;\nuniform mat4 uColorMatrix;\nuniform vec4 uConstants;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\ncolor *= uColorMatrix;\ncolor += uConstants;\ngl_FragColor = color;\n}",
        /**
         * Colormatrix for pixels.
         * array of 20 floats. Numbers in positions 4, 9, 14, 19 loose meaning
         * outside the -1, 1 range.
         * 0.0039215686 is the part of 1 that get translated to 1 in 2d
         * @param {Array} matrix array of 20 numbers.
         * @default
         */
        matrix: [
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0
        ],
        mainParameter: "matrix",
        /**
         * Lock the colormatrix on the color part, skipping alpha, mainly for non webgl scenario
         * to save some calculation
         * @type Boolean
         * @default true
         */
        colorsOnly: true,
        /**
         * Constructor
         * @param {Object} [options] Options object
         */
        initialize: function(options) {
          this.callSuper("initialize", options);
          this.matrix = this.matrix.slice(0);
        },
        /**
         * Apply the ColorMatrix operation to a Uint8Array representing the pixels of an image.
         *
         * @param {Object} options
         * @param {ImageData} options.imageData The Uint8Array to be filtered.
         */
        applyTo2d: function(options) {
          var imageData = options.imageData, data = imageData.data, iLen = data.length, m = this.matrix, r, g, b, a, i, colorsOnly = this.colorsOnly;
          for (i = 0; i < iLen; i += 4) {
            r = data[i];
            g = data[i + 1];
            b = data[i + 2];
            if (colorsOnly) {
              data[i] = r * m[0] + g * m[1] + b * m[2] + m[4] * 255;
              data[i + 1] = r * m[5] + g * m[6] + b * m[7] + m[9] * 255;
              data[i + 2] = r * m[10] + g * m[11] + b * m[12] + m[14] * 255;
            } else {
              a = data[i + 3];
              data[i] = r * m[0] + g * m[1] + b * m[2] + a * m[3] + m[4] * 255;
              data[i + 1] = r * m[5] + g * m[6] + b * m[7] + a * m[8] + m[9] * 255;
              data[i + 2] = r * m[10] + g * m[11] + b * m[12] + a * m[13] + m[14] * 255;
              data[i + 3] = r * m[15] + g * m[16] + b * m[17] + a * m[18] + m[19] * 255;
            }
          }
        },
        /**
         * Return WebGL uniform locations for this filter's shader.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {WebGLShaderProgram} program This filter's compiled shader program.
         */
        getUniformLocations: function(gl, program) {
          return {
            uColorMatrix: gl.getUniformLocation(program, "uColorMatrix"),
            uConstants: gl.getUniformLocation(program, "uConstants")
          };
        },
        /**
         * Send data from this filter to its shader program's uniforms.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
         */
        sendUniformData: function(gl, uniformLocations) {
          var m = this.matrix, matrix2 = [
            m[0],
            m[1],
            m[2],
            m[3],
            m[5],
            m[6],
            m[7],
            m[8],
            m[10],
            m[11],
            m[12],
            m[13],
            m[15],
            m[16],
            m[17],
            m[18]
          ], constants = [m[4], m[9], m[14], m[19]];
          gl.uniformMatrix4fv(uniformLocations.uColorMatrix, false, matrix2);
          gl.uniform4fv(uniformLocations.uConstants, constants);
        }
      }
    );
    fabric22.Image.filters.ColorMatrix.fromObject = fabric22.Image.filters.BaseFilter.fromObject;
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), filters = fabric22.Image.filters, createClass = fabric22.util.createClass;
    filters.Brightness = createClass(
      filters.BaseFilter,
      /** @lends fabric.Image.filters.Brightness.prototype */
      {
        /**
         * Filter type
         * @param {String} type
         * @default
         */
        type: "Brightness",
        /**
         * Fragment source for the brightness program
         */
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uBrightness;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\ncolor.rgb += uBrightness;\ngl_FragColor = color;\n}",
        /**
         * Brightness value, from -1 to 1.
         * translated to -255 to 255 for 2d
         * 0.0039215686 is the part of 1 that get translated to 1 in 2d
         * @param {Number} brightness
         * @default
         */
        brightness: 0,
        /**
         * Describe the property that is the filter parameter
         * @param {String} m
         * @default
         */
        mainParameter: "brightness",
        /**
        * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
        *
        * @param {Object} options
        * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
        */
        applyTo2d: function(options) {
          if (this.brightness === 0) {
            return;
          }
          var imageData = options.imageData, data = imageData.data, i, len = data.length, brightness = Math.round(this.brightness * 255);
          for (i = 0; i < len; i += 4) {
            data[i] = data[i] + brightness;
            data[i + 1] = data[i + 1] + brightness;
            data[i + 2] = data[i + 2] + brightness;
          }
        },
        /**
         * Return WebGL uniform locations for this filter's shader.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {WebGLShaderProgram} program This filter's compiled shader program.
         */
        getUniformLocations: function(gl, program) {
          return {
            uBrightness: gl.getUniformLocation(program, "uBrightness")
          };
        },
        /**
         * Send data from this filter to its shader program's uniforms.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
         */
        sendUniformData: function(gl, uniformLocations) {
          gl.uniform1f(uniformLocations.uBrightness, this.brightness);
        }
      }
    );
    fabric22.Image.filters.Brightness.fromObject = fabric22.Image.filters.BaseFilter.fromObject;
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), extend = fabric22.util.object.extend, filters = fabric22.Image.filters, createClass = fabric22.util.createClass;
    filters.Convolute = createClass(
      filters.BaseFilter,
      /** @lends fabric.Image.filters.Convolute.prototype */
      {
        /**
         * Filter type
         * @param {String} type
         * @default
         */
        type: "Convolute",
        /*
         * Opaque value (true/false)
         */
        opaque: false,
        /*
         * matrix for the filter, max 9x9
         */
        matrix: [0, 0, 0, 0, 1, 0, 0, 0, 0],
        /**
         * Fragment source for the brightness program
         */
        fragmentSource: {
          Convolute_3_1: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[9];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 0);\nfor (float h = 0.0; h < 3.0; h+=1.0) {\nfor (float w = 0.0; w < 3.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 1), uStepH * (h - 1));\ncolor += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 3.0 + w)];\n}\n}\ngl_FragColor = color;\n}",
          Convolute_3_0: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[9];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 1);\nfor (float h = 0.0; h < 3.0; h+=1.0) {\nfor (float w = 0.0; w < 3.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 1.0), uStepH * (h - 1.0));\ncolor.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 3.0 + w)];\n}\n}\nfloat alpha = texture2D(uTexture, vTexCoord).a;\ngl_FragColor = color;\ngl_FragColor.a = alpha;\n}",
          Convolute_5_1: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[25];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 0);\nfor (float h = 0.0; h < 5.0; h+=1.0) {\nfor (float w = 0.0; w < 5.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\ncolor += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 5.0 + w)];\n}\n}\ngl_FragColor = color;\n}",
          Convolute_5_0: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[25];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 1);\nfor (float h = 0.0; h < 5.0; h+=1.0) {\nfor (float w = 0.0; w < 5.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\ncolor.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 5.0 + w)];\n}\n}\nfloat alpha = texture2D(uTexture, vTexCoord).a;\ngl_FragColor = color;\ngl_FragColor.a = alpha;\n}",
          Convolute_7_1: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[49];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 0);\nfor (float h = 0.0; h < 7.0; h+=1.0) {\nfor (float w = 0.0; w < 7.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\ncolor += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 7.0 + w)];\n}\n}\ngl_FragColor = color;\n}",
          Convolute_7_0: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[49];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 1);\nfor (float h = 0.0; h < 7.0; h+=1.0) {\nfor (float w = 0.0; w < 7.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\ncolor.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 7.0 + w)];\n}\n}\nfloat alpha = texture2D(uTexture, vTexCoord).a;\ngl_FragColor = color;\ngl_FragColor.a = alpha;\n}",
          Convolute_9_1: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[81];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 0);\nfor (float h = 0.0; h < 9.0; h+=1.0) {\nfor (float w = 0.0; w < 9.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\ncolor += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 9.0 + w)];\n}\n}\ngl_FragColor = color;\n}",
          Convolute_9_0: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[81];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 1);\nfor (float h = 0.0; h < 9.0; h+=1.0) {\nfor (float w = 0.0; w < 9.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\ncolor.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 9.0 + w)];\n}\n}\nfloat alpha = texture2D(uTexture, vTexCoord).a;\ngl_FragColor = color;\ngl_FragColor.a = alpha;\n}"
        },
        /**
         * Constructor
         * @memberOf fabric.Image.filters.Convolute.prototype
         * @param {Object} [options] Options object
         * @param {Boolean} [options.opaque=false] Opaque value (true/false)
         * @param {Array} [options.matrix] Filter matrix
         */
        /**
        * Retrieves the cached shader.
        * @param {Object} options
        * @param {WebGLRenderingContext} options.context The GL context used for rendering.
        * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
        */
        retrieveShader: function(options) {
          var size = Math.sqrt(this.matrix.length);
          var cacheKey = this.type + "_" + size + "_" + (this.opaque ? 1 : 0);
          var shaderSource = this.fragmentSource[cacheKey];
          if (!options.programCache.hasOwnProperty(cacheKey)) {
            options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
          }
          return options.programCache[cacheKey];
        },
        /**
         * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
         *
         * @param {Object} options
         * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
         */
        applyTo2d: function(options) {
          var imageData = options.imageData, data = imageData.data, weights = this.matrix, side = Math.round(Math.sqrt(weights.length)), halfSide = Math.floor(side / 2), sw = imageData.width, sh = imageData.height, output = options.ctx.createImageData(sw, sh), dst = output.data, alphaFac = this.opaque ? 1 : 0, r, g, b, a, dstOff, scx, scy, srcOff, wt, x, y, cx, cy;
          for (y = 0; y < sh; y++) {
            for (x = 0; x < sw; x++) {
              dstOff = (y * sw + x) * 4;
              r = 0;
              g = 0;
              b = 0;
              a = 0;
              for (cy = 0; cy < side; cy++) {
                for (cx = 0; cx < side; cx++) {
                  scy = y + cy - halfSide;
                  scx = x + cx - halfSide;
                  if (scy < 0 || scy >= sh || scx < 0 || scx >= sw) {
                    continue;
                  }
                  srcOff = (scy * sw + scx) * 4;
                  wt = weights[cy * side + cx];
                  r += data[srcOff] * wt;
                  g += data[srcOff + 1] * wt;
                  b += data[srcOff + 2] * wt;
                  if (!alphaFac) {
                    a += data[srcOff + 3] * wt;
                  }
                }
              }
              dst[dstOff] = r;
              dst[dstOff + 1] = g;
              dst[dstOff + 2] = b;
              if (!alphaFac) {
                dst[dstOff + 3] = a;
              } else {
                dst[dstOff + 3] = data[dstOff + 3];
              }
            }
          }
          options.imageData = output;
        },
        /**
         * Return WebGL uniform locations for this filter's shader.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {WebGLShaderProgram} program This filter's compiled shader program.
         */
        getUniformLocations: function(gl, program) {
          return {
            uMatrix: gl.getUniformLocation(program, "uMatrix"),
            uOpaque: gl.getUniformLocation(program, "uOpaque"),
            uHalfSize: gl.getUniformLocation(program, "uHalfSize"),
            uSize: gl.getUniformLocation(program, "uSize")
          };
        },
        /**
         * Send data from this filter to its shader program's uniforms.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
         */
        sendUniformData: function(gl, uniformLocations) {
          gl.uniform1fv(uniformLocations.uMatrix, this.matrix);
        },
        /**
         * Returns object representation of an instance
         * @return {Object} Object representation of an instance
         */
        toObject: function() {
          return extend(this.callSuper("toObject"), {
            opaque: this.opaque,
            matrix: this.matrix
          });
        }
      }
    );
    fabric22.Image.filters.Convolute.fromObject = fabric22.Image.filters.BaseFilter.fromObject;
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), filters = fabric22.Image.filters, createClass = fabric22.util.createClass;
    filters.Grayscale = createClass(
      filters.BaseFilter,
      /** @lends fabric.Image.filters.Grayscale.prototype */
      {
        /**
         * Filter type
         * @param {String} type
         * @default
         */
        type: "Grayscale",
        fragmentSource: {
          average: "precision highp float;\nuniform sampler2D uTexture;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nfloat average = (color.r + color.b + color.g) / 3.0;\ngl_FragColor = vec4(average, average, average, color.a);\n}",
          lightness: "precision highp float;\nuniform sampler2D uTexture;\nuniform int uMode;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 col = texture2D(uTexture, vTexCoord);\nfloat average = (max(max(col.r, col.g),col.b) + min(min(col.r, col.g),col.b)) / 2.0;\ngl_FragColor = vec4(average, average, average, col.a);\n}",
          luminosity: "precision highp float;\nuniform sampler2D uTexture;\nuniform int uMode;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 col = texture2D(uTexture, vTexCoord);\nfloat average = 0.21 * col.r + 0.72 * col.g + 0.07 * col.b;\ngl_FragColor = vec4(average, average, average, col.a);\n}"
        },
        /**
         * Grayscale mode, between 'average', 'lightness', 'luminosity'
         * @param {String} type
         * @default
         */
        mode: "average",
        mainParameter: "mode",
        /**
         * Apply the Grayscale operation to a Uint8Array representing the pixels of an image.
         *
         * @param {Object} options
         * @param {ImageData} options.imageData The Uint8Array to be filtered.
         */
        applyTo2d: function(options) {
          var imageData = options.imageData, data = imageData.data, i, len = data.length, value, mode = this.mode;
          for (i = 0; i < len; i += 4) {
            if (mode === "average") {
              value = (data[i] + data[i + 1] + data[i + 2]) / 3;
            } else if (mode === "lightness") {
              value = (Math.min(data[i], data[i + 1], data[i + 2]) + Math.max(data[i], data[i + 1], data[i + 2])) / 2;
            } else if (mode === "luminosity") {
              value = 0.21 * data[i] + 0.72 * data[i + 1] + 0.07 * data[i + 2];
            }
            data[i] = value;
            data[i + 1] = value;
            data[i + 2] = value;
          }
        },
        /**
         * Retrieves the cached shader.
         * @param {Object} options
         * @param {WebGLRenderingContext} options.context The GL context used for rendering.
         * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
         */
        retrieveShader: function(options) {
          var cacheKey = this.type + "_" + this.mode;
          if (!options.programCache.hasOwnProperty(cacheKey)) {
            var shaderSource = this.fragmentSource[this.mode];
            options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
          }
          return options.programCache[cacheKey];
        },
        /**
         * Return WebGL uniform locations for this filter's shader.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {WebGLShaderProgram} program This filter's compiled shader program.
         */
        getUniformLocations: function(gl, program) {
          return {
            uMode: gl.getUniformLocation(program, "uMode")
          };
        },
        /**
         * Send data from this filter to its shader program's uniforms.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
         */
        sendUniformData: function(gl, uniformLocations) {
          var mode = 1;
          gl.uniform1i(uniformLocations.uMode, mode);
        },
        /**
         * Grayscale filter isNeutralState implementation
         * The filter is never neutral
         * on the image
         **/
        isNeutralState: function() {
          return false;
        }
      }
    );
    fabric22.Image.filters.Grayscale.fromObject = fabric22.Image.filters.BaseFilter.fromObject;
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), filters = fabric22.Image.filters, createClass = fabric22.util.createClass;
    filters.Invert = createClass(
      filters.BaseFilter,
      /** @lends fabric.Image.filters.Invert.prototype */
      {
        /**
         * Filter type
         * @param {String} type
         * @default
         */
        type: "Invert",
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform int uInvert;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nif (uInvert == 1) {\ngl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,color.a);\n} else {\ngl_FragColor = color;\n}\n}",
        /**
         * Filter invert. if false, does nothing
         * @param {Boolean} invert
         * @default
         */
        invert: true,
        mainParameter: "invert",
        /**
         * Apply the Invert operation to a Uint8Array representing the pixels of an image.
         *
         * @param {Object} options
         * @param {ImageData} options.imageData The Uint8Array to be filtered.
         */
        applyTo2d: function(options) {
          var imageData = options.imageData, data = imageData.data, i, len = data.length;
          for (i = 0; i < len; i += 4) {
            data[i] = 255 - data[i];
            data[i + 1] = 255 - data[i + 1];
            data[i + 2] = 255 - data[i + 2];
          }
        },
        /**
         * Invert filter isNeutralState implementation
         * Used only in image applyFilters to discard filters that will not have an effect
         * on the image
         * @param {Object} options
         **/
        isNeutralState: function() {
          return !this.invert;
        },
        /**
         * Return WebGL uniform locations for this filter's shader.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {WebGLShaderProgram} program This filter's compiled shader program.
         */
        getUniformLocations: function(gl, program) {
          return {
            uInvert: gl.getUniformLocation(program, "uInvert")
          };
        },
        /**
         * Send data from this filter to its shader program's uniforms.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
         */
        sendUniformData: function(gl, uniformLocations) {
          gl.uniform1i(uniformLocations.uInvert, this.invert);
        }
      }
    );
    fabric22.Image.filters.Invert.fromObject = fabric22.Image.filters.BaseFilter.fromObject;
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), extend = fabric22.util.object.extend, filters = fabric22.Image.filters, createClass = fabric22.util.createClass;
    filters.Noise = createClass(
      filters.BaseFilter,
      /** @lends fabric.Image.filters.Noise.prototype */
      {
        /**
         * Filter type
         * @param {String} type
         * @default
         */
        type: "Noise",
        /**
         * Fragment source for the noise program
         */
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uStepH;\nuniform float uNoise;\nuniform float uSeed;\nvarying vec2 vTexCoord;\nfloat rand(vec2 co, float seed, float vScale) {\nreturn fract(sin(dot(co.xy * vScale ,vec2(12.9898 , 78.233))) * 43758.5453 * (seed + 0.01) / 2.0);\n}\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\ncolor.rgb += (0.5 - rand(vTexCoord, uSeed, 0.1 / uStepH)) * uNoise;\ngl_FragColor = color;\n}",
        /**
         * Describe the property that is the filter parameter
         * @param {String} m
         * @default
         */
        mainParameter: "noise",
        /**
         * Noise value, from
         * @param {Number} noise
         * @default
         */
        noise: 0,
        /**
         * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
         *
         * @param {Object} options
         * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
         */
        applyTo2d: function(options) {
          if (this.noise === 0) {
            return;
          }
          var imageData = options.imageData, data = imageData.data, i, len = data.length, noise = this.noise, rand;
          for (i = 0, len = data.length; i < len; i += 4) {
            rand = (0.5 - Math.random()) * noise;
            data[i] += rand;
            data[i + 1] += rand;
            data[i + 2] += rand;
          }
        },
        /**
         * Return WebGL uniform locations for this filter's shader.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {WebGLShaderProgram} program This filter's compiled shader program.
         */
        getUniformLocations: function(gl, program) {
          return {
            uNoise: gl.getUniformLocation(program, "uNoise"),
            uSeed: gl.getUniformLocation(program, "uSeed")
          };
        },
        /**
         * Send data from this filter to its shader program's uniforms.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
         */
        sendUniformData: function(gl, uniformLocations) {
          gl.uniform1f(uniformLocations.uNoise, this.noise / 255);
          gl.uniform1f(uniformLocations.uSeed, Math.random());
        },
        /**
         * Returns object representation of an instance
         * @return {Object} Object representation of an instance
         */
        toObject: function() {
          return extend(this.callSuper("toObject"), {
            noise: this.noise
          });
        }
      }
    );
    fabric22.Image.filters.Noise.fromObject = fabric22.Image.filters.BaseFilter.fromObject;
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), filters = fabric22.Image.filters, createClass = fabric22.util.createClass;
    filters.Pixelate = createClass(
      filters.BaseFilter,
      /** @lends fabric.Image.filters.Pixelate.prototype */
      {
        /**
         * Filter type
         * @param {String} type
         * @default
         */
        type: "Pixelate",
        blocksize: 4,
        mainParameter: "blocksize",
        /**
         * Fragment source for the Pixelate program
         */
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uBlocksize;\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nfloat blockW = uBlocksize * uStepW;\nfloat blockH = uBlocksize * uStepW;\nint posX = int(vTexCoord.x / blockW);\nint posY = int(vTexCoord.y / blockH);\nfloat fposX = float(posX);\nfloat fposY = float(posY);\nvec2 squareCoords = vec2(fposX * blockW, fposY * blockH);\nvec4 color = texture2D(uTexture, squareCoords);\ngl_FragColor = color;\n}",
        /**
         * Apply the Pixelate operation to a Uint8ClampedArray representing the pixels of an image.
         *
         * @param {Object} options
         * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
         */
        applyTo2d: function(options) {
          var imageData = options.imageData, data = imageData.data, iLen = imageData.height, jLen = imageData.width, index, i, j, r, g, b, a, _i, _j, _iLen, _jLen;
          for (i = 0; i < iLen; i += this.blocksize) {
            for (j = 0; j < jLen; j += this.blocksize) {
              index = i * 4 * jLen + j * 4;
              r = data[index];
              g = data[index + 1];
              b = data[index + 2];
              a = data[index + 3];
              _iLen = Math.min(i + this.blocksize, iLen);
              _jLen = Math.min(j + this.blocksize, jLen);
              for (_i = i; _i < _iLen; _i++) {
                for (_j = j; _j < _jLen; _j++) {
                  index = _i * 4 * jLen + _j * 4;
                  data[index] = r;
                  data[index + 1] = g;
                  data[index + 2] = b;
                  data[index + 3] = a;
                }
              }
            }
          }
        },
        /**
         * Indicate when the filter is not gonna apply changes to the image
         **/
        isNeutralState: function() {
          return this.blocksize === 1;
        },
        /**
         * Return WebGL uniform locations for this filter's shader.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {WebGLShaderProgram} program This filter's compiled shader program.
         */
        getUniformLocations: function(gl, program) {
          return {
            uBlocksize: gl.getUniformLocation(program, "uBlocksize"),
            uStepW: gl.getUniformLocation(program, "uStepW"),
            uStepH: gl.getUniformLocation(program, "uStepH")
          };
        },
        /**
         * Send data from this filter to its shader program's uniforms.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
         */
        sendUniformData: function(gl, uniformLocations) {
          gl.uniform1f(uniformLocations.uBlocksize, this.blocksize);
        }
      }
    );
    fabric22.Image.filters.Pixelate.fromObject = fabric22.Image.filters.BaseFilter.fromObject;
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), extend = fabric22.util.object.extend, filters = fabric22.Image.filters, createClass = fabric22.util.createClass;
    filters.RemoveColor = createClass(
      filters.BaseFilter,
      /** @lends fabric.Image.filters.RemoveColor.prototype */
      {
        /**
         * Filter type
         * @param {String} type
         * @default
         */
        type: "RemoveColor",
        /**
         * Color to remove, in any format understood by fabric.Color.
         * @param {String} type
         * @default
         */
        color: "#FFFFFF",
        /**
         * Fragment source for the brightness program
         */
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform vec4 uLow;\nuniform vec4 uHigh;\nvarying vec2 vTexCoord;\nvoid main() {\ngl_FragColor = texture2D(uTexture, vTexCoord);\nif(all(greaterThan(gl_FragColor.rgb,uLow.rgb)) && all(greaterThan(uHigh.rgb,gl_FragColor.rgb))) {\ngl_FragColor.a = 0.0;\n}\n}",
        /**
         * distance to actual color, as value up or down from each r,g,b
         * between 0 and 1
         **/
        distance: 0.02,
        /**
         * For color to remove inside distance, use alpha channel for a smoother deletion
         * NOT IMPLEMENTED YET
         **/
        useAlpha: false,
        /**
         * Constructor
         * @memberOf fabric.Image.filters.RemoveWhite.prototype
         * @param {Object} [options] Options object
         * @param {Number} [options.color=#RRGGBB] Threshold value
         * @param {Number} [options.distance=10] Distance value
         */
        /**
         * Applies filter to canvas element
         * @param {Object} canvasEl Canvas element to apply filter to
         */
        applyTo2d: function(options) {
          var imageData = options.imageData, data = imageData.data, i, distance = this.distance * 255, r, g, b, source = new fabric22.Color(this.color).getSource(), lowC = [
            source[0] - distance,
            source[1] - distance,
            source[2] - distance
          ], highC = [
            source[0] + distance,
            source[1] + distance,
            source[2] + distance
          ];
          for (i = 0; i < data.length; i += 4) {
            r = data[i];
            g = data[i + 1];
            b = data[i + 2];
            if (r > lowC[0] && g > lowC[1] && b > lowC[2] && r < highC[0] && g < highC[1] && b < highC[2]) {
              data[i + 3] = 0;
            }
          }
        },
        /**
         * Return WebGL uniform locations for this filter's shader.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {WebGLShaderProgram} program This filter's compiled shader program.
         */
        getUniformLocations: function(gl, program) {
          return {
            uLow: gl.getUniformLocation(program, "uLow"),
            uHigh: gl.getUniformLocation(program, "uHigh")
          };
        },
        /**
         * Send data from this filter to its shader program's uniforms.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
         */
        sendUniformData: function(gl, uniformLocations) {
          var source = new fabric22.Color(this.color).getSource(), distance = parseFloat(this.distance), lowC = [
            0 + source[0] / 255 - distance,
            0 + source[1] / 255 - distance,
            0 + source[2] / 255 - distance,
            1
          ], highC = [
            source[0] / 255 + distance,
            source[1] / 255 + distance,
            source[2] / 255 + distance,
            1
          ];
          gl.uniform4fv(uniformLocations.uLow, lowC);
          gl.uniform4fv(uniformLocations.uHigh, highC);
        },
        /**
         * Returns object representation of an instance
         * @return {Object} Object representation of an instance
         */
        toObject: function() {
          return extend(this.callSuper("toObject"), {
            color: this.color,
            distance: this.distance
          });
        }
      }
    );
    fabric22.Image.filters.RemoveColor.fromObject = fabric22.Image.filters.BaseFilter.fromObject;
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), filters = fabric22.Image.filters, createClass = fabric22.util.createClass;
    var matrices = {
      Brownie: [
        0.5997,
        0.34553,
        -0.27082,
        0,
        0.186,
        -0.0377,
        0.86095,
        0.15059,
        0,
        -0.1449,
        0.24113,
        -0.07441,
        0.44972,
        0,
        -0.02965,
        0,
        0,
        0,
        1,
        0
      ],
      Vintage: [
        0.62793,
        0.32021,
        -0.03965,
        0,
        0.03784,
        0.02578,
        0.64411,
        0.03259,
        0,
        0.02926,
        0.0466,
        -0.08512,
        0.52416,
        0,
        0.02023,
        0,
        0,
        0,
        1,
        0
      ],
      Kodachrome: [
        1.12855,
        -0.39673,
        -0.03992,
        0,
        0.24991,
        -0.16404,
        1.08352,
        -0.05498,
        0,
        0.09698,
        -0.16786,
        -0.56034,
        1.60148,
        0,
        0.13972,
        0,
        0,
        0,
        1,
        0
      ],
      Technicolor: [
        1.91252,
        -0.85453,
        -0.09155,
        0,
        0.04624,
        -0.30878,
        1.76589,
        -0.10601,
        0,
        -0.27589,
        -0.2311,
        -0.75018,
        1.84759,
        0,
        0.12137,
        0,
        0,
        0,
        1,
        0
      ],
      Polaroid: [
        1.438,
        -0.062,
        -0.062,
        0,
        0,
        -0.122,
        1.378,
        -0.122,
        0,
        0,
        -0.016,
        -0.016,
        1.483,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ],
      Sepia: [
        0.393,
        0.769,
        0.189,
        0,
        0,
        0.349,
        0.686,
        0.168,
        0,
        0,
        0.272,
        0.534,
        0.131,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ],
      BlackWhite: [
        1.5,
        1.5,
        1.5,
        0,
        -1,
        1.5,
        1.5,
        1.5,
        0,
        -1,
        1.5,
        1.5,
        1.5,
        0,
        -1,
        0,
        0,
        0,
        1,
        0
      ]
    };
    for (var key in matrices) {
      filters[key] = createClass(
        filters.ColorMatrix,
        /** @lends fabric.Image.filters.Sepia.prototype */
        {
          /**
           * Filter type
           * @param {String} type
           * @default
           */
          type: key,
          /**
           * Colormatrix for the effect
           * array of 20 floats. Numbers in positions 4, 9, 14, 19 loose meaning
           * outside the -1, 1 range.
           * @param {Array} matrix array of 20 numbers.
           * @default
           */
          matrix: matrices[key],
          /**
           * Lock the matrix export for this kind of static, parameter less filters.
           */
          mainParameter: false,
          /**
           * Lock the colormatrix on the color part, skipping alpha
           */
          colorsOnly: true
        }
      );
      fabric22.Image.filters[key].fromObject = fabric22.Image.filters.BaseFilter.fromObject;
    }
  })(exports);
  (function(global) {
    var fabric22 = global.fabric, filters = fabric22.Image.filters, createClass = fabric22.util.createClass;
    filters.BlendColor = createClass(
      filters.BaseFilter,
      /** @lends fabric.Image.filters.Blend.prototype */
      {
        type: "BlendColor",
        /**
         * Color to make the blend operation with. default to a reddish color since black or white
         * gives always strong result.
         * @type String
         * @default
         **/
        color: "#F95C63",
        /**
         * Blend mode for the filter: one of multiply, add, diff, screen, subtract,
         * darken, lighten, overlay, exclusion, tint.
         * @type String
         * @default
         **/
        mode: "multiply",
        /**
         * alpha value. represent the strength of the blend color operation.
         * @type Number
         * @default
         **/
        alpha: 1,
        /**
         * Fragment source for the Multiply program
         */
        fragmentSource: {
          multiply: "gl_FragColor.rgb *= uColor.rgb;\n",
          screen: "gl_FragColor.rgb = 1.0 - (1.0 - gl_FragColor.rgb) * (1.0 - uColor.rgb);\n",
          add: "gl_FragColor.rgb += uColor.rgb;\n",
          diff: "gl_FragColor.rgb = abs(gl_FragColor.rgb - uColor.rgb);\n",
          subtract: "gl_FragColor.rgb -= uColor.rgb;\n",
          lighten: "gl_FragColor.rgb = max(gl_FragColor.rgb, uColor.rgb);\n",
          darken: "gl_FragColor.rgb = min(gl_FragColor.rgb, uColor.rgb);\n",
          exclusion: "gl_FragColor.rgb += uColor.rgb - 2.0 * (uColor.rgb * gl_FragColor.rgb);\n",
          overlay: "if (uColor.r < 0.5) {\ngl_FragColor.r *= 2.0 * uColor.r;\n} else {\ngl_FragColor.r = 1.0 - 2.0 * (1.0 - gl_FragColor.r) * (1.0 - uColor.r);\n}\nif (uColor.g < 0.5) {\ngl_FragColor.g *= 2.0 * uColor.g;\n} else {\ngl_FragColor.g = 1.0 - 2.0 * (1.0 - gl_FragColor.g) * (1.0 - uColor.g);\n}\nif (uColor.b < 0.5) {\ngl_FragColor.b *= 2.0 * uColor.b;\n} else {\ngl_FragColor.b = 1.0 - 2.0 * (1.0 - gl_FragColor.b) * (1.0 - uColor.b);\n}\n",
          tint: "gl_FragColor.rgb *= (1.0 - uColor.a);\ngl_FragColor.rgb += uColor.rgb;\n"
        },
        /**
         * build the fragment source for the filters, joining the common part with
         * the specific one.
         * @param {String} mode the mode of the filter, a key of this.fragmentSource
         * @return {String} the source to be compiled
         * @private
         */
        buildSource: function(mode) {
          return "precision highp float;\nuniform sampler2D uTexture;\nuniform vec4 uColor;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\ngl_FragColor = color;\nif (color.a > 0.0) {\n" + this.fragmentSource[mode] + "}\n}";
        },
        /**
         * Retrieves the cached shader.
         * @param {Object} options
         * @param {WebGLRenderingContext} options.context The GL context used for rendering.
         * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
         */
        retrieveShader: function(options) {
          var cacheKey = this.type + "_" + this.mode, shaderSource;
          if (!options.programCache.hasOwnProperty(cacheKey)) {
            shaderSource = this.buildSource(this.mode);
            options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
          }
          return options.programCache[cacheKey];
        },
        /**
         * Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
         *
         * @param {Object} options
         * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
         */
        applyTo2d: function(options) {
          var imageData = options.imageData, data = imageData.data, iLen = data.length, tr, tg, tb, r, g, b, source, alpha1 = 1 - this.alpha;
          source = new fabric22.Color(this.color).getSource();
          tr = source[0] * this.alpha;
          tg = source[1] * this.alpha;
          tb = source[2] * this.alpha;
          for (var i = 0; i < iLen; i += 4) {
            r = data[i];
            g = data[i + 1];
            b = data[i + 2];
            switch (this.mode) {
              case "multiply":
                data[i] = r * tr / 255;
                data[i + 1] = g * tg / 255;
                data[i + 2] = b * tb / 255;
                break;
              case "screen":
                data[i] = 255 - (255 - r) * (255 - tr) / 255;
                data[i + 1] = 255 - (255 - g) * (255 - tg) / 255;
                data[i + 2] = 255 - (255 - b) * (255 - tb) / 255;
                break;
              case "add":
                data[i] = r + tr;
                data[i + 1] = g + tg;
                data[i + 2] = b + tb;
                break;
              case "diff":
              case "difference":
                data[i] = Math.abs(r - tr);
                data[i + 1] = Math.abs(g - tg);
                data[i + 2] = Math.abs(b - tb);
                break;
              case "subtract":
                data[i] = r - tr;
                data[i + 1] = g - tg;
                data[i + 2] = b - tb;
                break;
              case "darken":
                data[i] = Math.min(r, tr);
                data[i + 1] = Math.min(g, tg);
                data[i + 2] = Math.min(b, tb);
                break;
              case "lighten":
                data[i] = Math.max(r, tr);
                data[i + 1] = Math.max(g, tg);
                data[i + 2] = Math.max(b, tb);
                break;
              case "overlay":
                data[i] = tr < 128 ? 2 * r * tr / 255 : 255 - 2 * (255 - r) * (255 - tr) / 255;
                data[i + 1] = tg < 128 ? 2 * g * tg / 255 : 255 - 2 * (255 - g) * (255 - tg) / 255;
                data[i + 2] = tb < 128 ? 2 * b * tb / 255 : 255 - 2 * (255 - b) * (255 - tb) / 255;
                break;
              case "exclusion":
                data[i] = tr + r - 2 * tr * r / 255;
                data[i + 1] = tg + g - 2 * tg * g / 255;
                data[i + 2] = tb + b - 2 * tb * b / 255;
                break;
              case "tint":
                data[i] = tr + r * alpha1;
                data[i + 1] = tg + g * alpha1;
                data[i + 2] = tb + b * alpha1;
            }
          }
        },
        /**
         * Return WebGL uniform locations for this filter's shader.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {WebGLShaderProgram} program This filter's compiled shader program.
         */
        getUniformLocations: function(gl, program) {
          return {
            uColor: gl.getUniformLocation(program, "uColor")
          };
        },
        /**
         * Send data from this filter to its shader program's uniforms.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
         */
        sendUniformData: function(gl, uniformLocations) {
          var source = new fabric22.Color(this.color).getSource();
          source[0] = this.alpha * source[0] / 255;
          source[1] = this.alpha * source[1] / 255;
          source[2] = this.alpha * source[2] / 255;
          source[3] = this.alpha;
          gl.uniform4fv(uniformLocations.uColor, source);
        },
        /**
         * Returns object representation of an instance
         * @return {Object} Object representation of an instance
         */
        toObject: function() {
          return {
            type: this.type,
            color: this.color,
            mode: this.mode,
            alpha: this.alpha
          };
        }
      }
    );
    fabric22.Image.filters.BlendColor.fromObject = fabric22.Image.filters.BaseFilter.fromObject;
  })(exports);
  (function(global) {
    var fabric22 = global.fabric, filters = fabric22.Image.filters, createClass = fabric22.util.createClass;
    filters.BlendImage = createClass(
      filters.BaseFilter,
      /** @lends fabric.Image.filters.BlendImage.prototype */
      {
        type: "BlendImage",
        /**
         * Color to make the blend operation with. default to a reddish color since black or white
         * gives always strong result.
         **/
        image: null,
        /**
         * Blend mode for the filter (one of "multiply", "mask")
         * @type String
         * @default
         **/
        mode: "multiply",
        /**
         * alpha value. represent the strength of the blend image operation.
         * not implemented.
         **/
        alpha: 1,
        vertexSource: "attribute vec2 aPosition;\nvarying vec2 vTexCoord;\nvarying vec2 vTexCoord2;\nuniform mat3 uTransformMatrix;\nvoid main() {\nvTexCoord = aPosition;\nvTexCoord2 = (uTransformMatrix * vec3(aPosition, 1.0)).xy;\ngl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n}",
        /**
         * Fragment source for the Multiply program
         */
        fragmentSource: {
          multiply: "precision highp float;\nuniform sampler2D uTexture;\nuniform sampler2D uImage;\nuniform vec4 uColor;\nvarying vec2 vTexCoord;\nvarying vec2 vTexCoord2;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nvec4 color2 = texture2D(uImage, vTexCoord2);\ncolor.rgba *= color2.rgba;\ngl_FragColor = color;\n}",
          mask: "precision highp float;\nuniform sampler2D uTexture;\nuniform sampler2D uImage;\nuniform vec4 uColor;\nvarying vec2 vTexCoord;\nvarying vec2 vTexCoord2;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nvec4 color2 = texture2D(uImage, vTexCoord2);\ncolor.a = color2.a;\ngl_FragColor = color;\n}"
        },
        /**
         * Retrieves the cached shader.
         * @param {Object} options
         * @param {WebGLRenderingContext} options.context The GL context used for rendering.
         * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
         */
        retrieveShader: function(options) {
          var cacheKey = this.type + "_" + this.mode;
          var shaderSource = this.fragmentSource[this.mode];
          if (!options.programCache.hasOwnProperty(cacheKey)) {
            options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
          }
          return options.programCache[cacheKey];
        },
        applyToWebGL: function(options) {
          var gl = options.context, texture2 = this.createTexture(options.filterBackend, this.image);
          this.bindAdditionalTexture(gl, texture2, gl.TEXTURE1);
          this.callSuper("applyToWebGL", options);
          this.unbindAdditionalTexture(gl, gl.TEXTURE1);
        },
        createTexture: function(backend, image) {
          return backend.getCachedTexture(image.cacheKey, image._element);
        },
        /**
         * Calculate a transformMatrix to adapt the image to blend over
         * @param {Object} options
         * @param {WebGLRenderingContext} options.context The GL context used for rendering.
         * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
         */
        calculateMatrix: function() {
          var image = this.image, width = image._element.width, height = image._element.height;
          return [
            1 / image.scaleX,
            0,
            0,
            0,
            1 / image.scaleY,
            0,
            -image.left / width,
            -image.top / height,
            1
          ];
        },
        /**
         * Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
         *
         * @param {Object} options
         * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
         */
        applyTo2d: function(options) {
          var imageData = options.imageData, resources = options.filterBackend.resources, data = imageData.data, iLen = data.length, width = imageData.width, height = imageData.height, tr, tg, tb, ta, r, g, b, a, canvas1, context, image = this.image, blendData;
          if (!resources.blendImage) {
            resources.blendImage = fabric22.util.createCanvasElement();
          }
          canvas1 = resources.blendImage;
          context = canvas1.getContext("2d");
          if (canvas1.width !== width || canvas1.height !== height) {
            canvas1.width = width;
            canvas1.height = height;
          } else {
            context.clearRect(0, 0, width, height);
          }
          context.setTransform(image.scaleX, 0, 0, image.scaleY, image.left, image.top);
          context.drawImage(image._element, 0, 0, width, height);
          blendData = context.getImageData(0, 0, width, height).data;
          for (var i = 0; i < iLen; i += 4) {
            r = data[i];
            g = data[i + 1];
            b = data[i + 2];
            a = data[i + 3];
            tr = blendData[i];
            tg = blendData[i + 1];
            tb = blendData[i + 2];
            ta = blendData[i + 3];
            switch (this.mode) {
              case "multiply":
                data[i] = r * tr / 255;
                data[i + 1] = g * tg / 255;
                data[i + 2] = b * tb / 255;
                data[i + 3] = a * ta / 255;
                break;
              case "mask":
                data[i + 3] = ta;
                break;
            }
          }
        },
        /**
         * Return WebGL uniform locations for this filter's shader.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {WebGLShaderProgram} program This filter's compiled shader program.
         */
        getUniformLocations: function(gl, program) {
          return {
            uTransformMatrix: gl.getUniformLocation(program, "uTransformMatrix"),
            uImage: gl.getUniformLocation(program, "uImage")
          };
        },
        /**
         * Send data from this filter to its shader program's uniforms.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
         */
        sendUniformData: function(gl, uniformLocations) {
          var matrix2 = this.calculateMatrix();
          gl.uniform1i(uniformLocations.uImage, 1);
          gl.uniformMatrix3fv(uniformLocations.uTransformMatrix, false, matrix2);
        },
        /**
         * Returns object representation of an instance
         * @return {Object} Object representation of an instance
         */
        toObject: function() {
          return {
            type: this.type,
            image: this.image && this.image.toObject(),
            mode: this.mode,
            alpha: this.alpha
          };
        }
      }
    );
    fabric22.Image.filters.BlendImage.fromObject = function(object, callback) {
      fabric22.Image.fromObject(object.image, function(image) {
        var options = fabric22.util.object.clone(object);
        options.image = image;
        callback(new fabric22.Image.filters.BlendImage(options));
      });
    };
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), pow2 = Math.pow, floor2 = Math.floor, sqrt2 = Math.sqrt, abs2 = Math.abs, round2 = Math.round, sin2 = Math.sin, ceil2 = Math.ceil, filters = fabric22.Image.filters, createClass = fabric22.util.createClass;
    filters.Resize = createClass(
      filters.BaseFilter,
      /** @lends fabric.Image.filters.Resize.prototype */
      {
        /**
         * Filter type
         * @param {String} type
         * @default
         */
        type: "Resize",
        /**
         * Resize type
         * for webgl resizeType is just lanczos, for canvas2d can be:
         * bilinear, hermite, sliceHack, lanczos.
         * @param {String} resizeType
         * @default
         */
        resizeType: "hermite",
        /**
         * Scale factor for resizing, x axis
         * @param {Number} scaleX
         * @default
         */
        scaleX: 1,
        /**
         * Scale factor for resizing, y axis
         * @param {Number} scaleY
         * @default
         */
        scaleY: 1,
        /**
         * LanczosLobes parameter for lanczos filter, valid for resizeType lanczos
         * @param {Number} lanczosLobes
         * @default
         */
        lanczosLobes: 3,
        /**
         * Return WebGL uniform locations for this filter's shader.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {WebGLShaderProgram} program This filter's compiled shader program.
         */
        getUniformLocations: function(gl, program) {
          return {
            uDelta: gl.getUniformLocation(program, "uDelta"),
            uTaps: gl.getUniformLocation(program, "uTaps")
          };
        },
        /**
         * Send data from this filter to its shader program's uniforms.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
         */
        sendUniformData: function(gl, uniformLocations) {
          gl.uniform2fv(uniformLocations.uDelta, this.horizontal ? [1 / this.width, 0] : [0, 1 / this.height]);
          gl.uniform1fv(uniformLocations.uTaps, this.taps);
        },
        /**
         * Retrieves the cached shader.
         * @param {Object} options
         * @param {WebGLRenderingContext} options.context The GL context used for rendering.
         * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
         */
        retrieveShader: function(options) {
          var filterWindow = this.getFilterWindow(), cacheKey = this.type + "_" + filterWindow;
          if (!options.programCache.hasOwnProperty(cacheKey)) {
            var fragmentShader = this.generateShader(filterWindow);
            options.programCache[cacheKey] = this.createProgram(options.context, fragmentShader);
          }
          return options.programCache[cacheKey];
        },
        getFilterWindow: function() {
          var scale = this.tempScale;
          return Math.ceil(this.lanczosLobes / scale);
        },
        getTaps: function() {
          var lobeFunction = this.lanczosCreate(this.lanczosLobes), scale = this.tempScale, filterWindow = this.getFilterWindow(), taps = new Array(filterWindow);
          for (var i = 1; i <= filterWindow; i++) {
            taps[i - 1] = lobeFunction(i * scale);
          }
          return taps;
        },
        /**
         * Generate vertex and shader sources from the necessary steps numbers
         * @param {Number} filterWindow
         */
        generateShader: function(filterWindow) {
          var offsets = new Array(filterWindow), fragmentShader = this.fragmentSourceTOP, filterWindow;
          for (var i = 1; i <= filterWindow; i++) {
            offsets[i - 1] = i + ".0 * uDelta";
          }
          fragmentShader += "uniform float uTaps[" + filterWindow + "];\n";
          fragmentShader += "void main() {\n";
          fragmentShader += "  vec4 color = texture2D(uTexture, vTexCoord);\n";
          fragmentShader += "  float sum = 1.0;\n";
          offsets.forEach(function(offset, i2) {
            fragmentShader += "  color += texture2D(uTexture, vTexCoord + " + offset + ") * uTaps[" + i2 + "];\n";
            fragmentShader += "  color += texture2D(uTexture, vTexCoord - " + offset + ") * uTaps[" + i2 + "];\n";
            fragmentShader += "  sum += 2.0 * uTaps[" + i2 + "];\n";
          });
          fragmentShader += "  gl_FragColor = color / sum;\n";
          fragmentShader += "}";
          return fragmentShader;
        },
        fragmentSourceTOP: "precision highp float;\nuniform sampler2D uTexture;\nuniform vec2 uDelta;\nvarying vec2 vTexCoord;\n",
        /**
         * Apply the resize filter to the image
         * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
         *
         * @param {Object} options
         * @param {Number} options.passes The number of filters remaining to be executed
         * @param {Boolean} options.webgl Whether to use webgl to render the filter.
         * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
         * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
         * @param {WebGLRenderingContext} options.context The GL context used for rendering.
         * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
         */
        applyTo: function(options) {
          if (options.webgl) {
            options.passes++;
            this.width = options.sourceWidth;
            this.horizontal = true;
            this.dW = Math.round(this.width * this.scaleX);
            this.dH = options.sourceHeight;
            this.tempScale = this.dW / this.width;
            this.taps = this.getTaps();
            options.destinationWidth = this.dW;
            this._setupFrameBuffer(options);
            this.applyToWebGL(options);
            this._swapTextures(options);
            options.sourceWidth = options.destinationWidth;
            this.height = options.sourceHeight;
            this.horizontal = false;
            this.dH = Math.round(this.height * this.scaleY);
            this.tempScale = this.dH / this.height;
            this.taps = this.getTaps();
            options.destinationHeight = this.dH;
            this._setupFrameBuffer(options);
            this.applyToWebGL(options);
            this._swapTextures(options);
            options.sourceHeight = options.destinationHeight;
          } else {
            this.applyTo2d(options);
          }
        },
        isNeutralState: function() {
          return this.scaleX === 1 && this.scaleY === 1;
        },
        lanczosCreate: function(lobes) {
          return function(x) {
            if (x >= lobes || x <= -lobes) {
              return 0;
            }
            if (x < 11920929e-14 && x > -11920929e-14) {
              return 1;
            }
            x *= Math.PI;
            var xx = x / lobes;
            return sin2(x) / x * sin2(xx) / xx;
          };
        },
        /**
         * Applies filter to canvas element
         * @memberOf fabric.Image.filters.Resize.prototype
         * @param {Object} canvasEl Canvas element to apply filter to
         * @param {Number} scaleX
         * @param {Number} scaleY
         */
        applyTo2d: function(options) {
          var imageData = options.imageData, scaleX = this.scaleX, scaleY = this.scaleY;
          this.rcpScaleX = 1 / scaleX;
          this.rcpScaleY = 1 / scaleY;
          var oW = imageData.width, oH = imageData.height, dW = round2(oW * scaleX), dH = round2(oH * scaleY), newData;
          if (this.resizeType === "sliceHack") {
            newData = this.sliceByTwo(options, oW, oH, dW, dH);
          } else if (this.resizeType === "hermite") {
            newData = this.hermiteFastResize(options, oW, oH, dW, dH);
          } else if (this.resizeType === "bilinear") {
            newData = this.bilinearFiltering(options, oW, oH, dW, dH);
          } else if (this.resizeType === "lanczos") {
            newData = this.lanczosResize(options, oW, oH, dW, dH);
          }
          options.imageData = newData;
        },
        /**
         * Filter sliceByTwo
         * @param {Object} canvasEl Canvas element to apply filter to
         * @param {Number} oW Original Width
         * @param {Number} oH Original Height
         * @param {Number} dW Destination Width
         * @param {Number} dH Destination Height
         * @returns {ImageData}
         */
        sliceByTwo: function(options, oW, oH, dW, dH) {
          var imageData = options.imageData, mult = 0.5, doneW = false, doneH = false, stepW = oW * mult, stepH = oH * mult, resources = fabric22.filterBackend.resources, tmpCanvas, ctx, sX = 0, sY = 0, dX = oW, dY = 0;
          if (!resources.sliceByTwo) {
            resources.sliceByTwo = document.createElement("canvas");
          }
          tmpCanvas = resources.sliceByTwo;
          if (tmpCanvas.width < oW * 1.5 || tmpCanvas.height < oH) {
            tmpCanvas.width = oW * 1.5;
            tmpCanvas.height = oH;
          }
          ctx = tmpCanvas.getContext("2d");
          ctx.clearRect(0, 0, oW * 1.5, oH);
          ctx.putImageData(imageData, 0, 0);
          dW = floor2(dW);
          dH = floor2(dH);
          while (!doneW || !doneH) {
            oW = stepW;
            oH = stepH;
            if (dW < floor2(stepW * mult)) {
              stepW = floor2(stepW * mult);
            } else {
              stepW = dW;
              doneW = true;
            }
            if (dH < floor2(stepH * mult)) {
              stepH = floor2(stepH * mult);
            } else {
              stepH = dH;
              doneH = true;
            }
            ctx.drawImage(tmpCanvas, sX, sY, oW, oH, dX, dY, stepW, stepH);
            sX = dX;
            sY = dY;
            dY += stepH;
          }
          return ctx.getImageData(sX, sY, dW, dH);
        },
        /**
         * Filter lanczosResize
         * @param {Object} canvasEl Canvas element to apply filter to
         * @param {Number} oW Original Width
         * @param {Number} oH Original Height
         * @param {Number} dW Destination Width
         * @param {Number} dH Destination Height
         * @returns {ImageData}
         */
        lanczosResize: function(options, oW, oH, dW, dH) {
          function process2(u) {
            var v, i, weight, idx, a, red, green, blue, alpha, fX, fY;
            center.x = (u + 0.5) * ratioX;
            icenter.x = floor2(center.x);
            for (v = 0; v < dH; v++) {
              center.y = (v + 0.5) * ratioY;
              icenter.y = floor2(center.y);
              a = 0;
              red = 0;
              green = 0;
              blue = 0;
              alpha = 0;
              for (i = icenter.x - range2X; i <= icenter.x + range2X; i++) {
                if (i < 0 || i >= oW) {
                  continue;
                }
                fX = floor2(1e3 * abs2(i - center.x));
                if (!cacheLanc[fX]) {
                  cacheLanc[fX] = {};
                }
                for (var j = icenter.y - range2Y; j <= icenter.y + range2Y; j++) {
                  if (j < 0 || j >= oH) {
                    continue;
                  }
                  fY = floor2(1e3 * abs2(j - center.y));
                  if (!cacheLanc[fX][fY]) {
                    cacheLanc[fX][fY] = lanczos(sqrt2(pow2(fX * rcpRatioX, 2) + pow2(fY * rcpRatioY, 2)) / 1e3);
                  }
                  weight = cacheLanc[fX][fY];
                  if (weight > 0) {
                    idx = (j * oW + i) * 4;
                    a += weight;
                    red += weight * srcData[idx];
                    green += weight * srcData[idx + 1];
                    blue += weight * srcData[idx + 2];
                    alpha += weight * srcData[idx + 3];
                  }
                }
              }
              idx = (v * dW + u) * 4;
              destData[idx] = red / a;
              destData[idx + 1] = green / a;
              destData[idx + 2] = blue / a;
              destData[idx + 3] = alpha / a;
            }
            if (++u < dW) {
              return process2(u);
            } else {
              return destImg;
            }
          }
          var srcData = options.imageData.data, destImg = options.ctx.createImageData(dW, dH), destData = destImg.data, lanczos = this.lanczosCreate(this.lanczosLobes), ratioX = this.rcpScaleX, ratioY = this.rcpScaleY, rcpRatioX = 2 / this.rcpScaleX, rcpRatioY = 2 / this.rcpScaleY, range2X = ceil2(ratioX * this.lanczosLobes / 2), range2Y = ceil2(ratioY * this.lanczosLobes / 2), cacheLanc = {}, center = {}, icenter = {};
          return process2(0);
        },
        /**
         * bilinearFiltering
         * @param {Object} canvasEl Canvas element to apply filter to
         * @param {Number} oW Original Width
         * @param {Number} oH Original Height
         * @param {Number} dW Destination Width
         * @param {Number} dH Destination Height
         * @returns {ImageData}
         */
        bilinearFiltering: function(options, oW, oH, dW, dH) {
          var a, b, c, d, x, y, i, j, xDiff, yDiff, chnl, color, offset = 0, origPix, ratioX = this.rcpScaleX, ratioY = this.rcpScaleY, w4 = 4 * (oW - 1), img = options.imageData, pixels = img.data, destImage = options.ctx.createImageData(dW, dH), destPixels = destImage.data;
          for (i = 0; i < dH; i++) {
            for (j = 0; j < dW; j++) {
              x = floor2(ratioX * j);
              y = floor2(ratioY * i);
              xDiff = ratioX * j - x;
              yDiff = ratioY * i - y;
              origPix = 4 * (y * oW + x);
              for (chnl = 0; chnl < 4; chnl++) {
                a = pixels[origPix + chnl];
                b = pixels[origPix + 4 + chnl];
                c = pixels[origPix + w4 + chnl];
                d = pixels[origPix + w4 + 4 + chnl];
                color = a * (1 - xDiff) * (1 - yDiff) + b * xDiff * (1 - yDiff) + c * yDiff * (1 - xDiff) + d * xDiff * yDiff;
                destPixels[offset++] = color;
              }
            }
          }
          return destImage;
        },
        /**
         * hermiteFastResize
         * @param {Object} canvasEl Canvas element to apply filter to
         * @param {Number} oW Original Width
         * @param {Number} oH Original Height
         * @param {Number} dW Destination Width
         * @param {Number} dH Destination Height
         * @returns {ImageData}
         */
        hermiteFastResize: function(options, oW, oH, dW, dH) {
          var ratioW = this.rcpScaleX, ratioH = this.rcpScaleY, ratioWHalf = ceil2(ratioW / 2), ratioHHalf = ceil2(ratioH / 2), img = options.imageData, data = img.data, img2 = options.ctx.createImageData(dW, dH), data2 = img2.data;
          for (var j = 0; j < dH; j++) {
            for (var i = 0; i < dW; i++) {
              var x2 = (i + j * dW) * 4, weight = 0, weights = 0, weightsAlpha = 0, gxR = 0, gxG = 0, gxB = 0, gxA = 0, centerY = (j + 0.5) * ratioH;
              for (var yy = floor2(j * ratioH); yy < (j + 1) * ratioH; yy++) {
                var dy = abs2(centerY - (yy + 0.5)) / ratioHHalf, centerX = (i + 0.5) * ratioW, w0 = dy * dy;
                for (var xx = floor2(i * ratioW); xx < (i + 1) * ratioW; xx++) {
                  var dx = abs2(centerX - (xx + 0.5)) / ratioWHalf, w = sqrt2(w0 + dx * dx);
                  if (w > 1 && w < -1) {
                    continue;
                  }
                  weight = 2 * w * w * w - 3 * w * w + 1;
                  if (weight > 0) {
                    dx = 4 * (xx + yy * oW);
                    gxA += weight * data[dx + 3];
                    weightsAlpha += weight;
                    if (data[dx + 3] < 255) {
                      weight = weight * data[dx + 3] / 250;
                    }
                    gxR += weight * data[dx];
                    gxG += weight * data[dx + 1];
                    gxB += weight * data[dx + 2];
                    weights += weight;
                  }
                }
              }
              data2[x2] = gxR / weights;
              data2[x2 + 1] = gxG / weights;
              data2[x2 + 2] = gxB / weights;
              data2[x2 + 3] = gxA / weightsAlpha;
            }
          }
          return img2;
        },
        /**
         * Returns object representation of an instance
         * @return {Object} Object representation of an instance
         */
        toObject: function() {
          return {
            type: this.type,
            scaleX: this.scaleX,
            scaleY: this.scaleY,
            resizeType: this.resizeType,
            lanczosLobes: this.lanczosLobes
          };
        }
      }
    );
    fabric22.Image.filters.Resize.fromObject = fabric22.Image.filters.BaseFilter.fromObject;
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), filters = fabric22.Image.filters, createClass = fabric22.util.createClass;
    filters.Contrast = createClass(
      filters.BaseFilter,
      /** @lends fabric.Image.filters.Contrast.prototype */
      {
        /**
         * Filter type
         * @param {String} type
         * @default
         */
        type: "Contrast",
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uContrast;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nfloat contrastF = 1.015 * (uContrast + 1.0) / (1.0 * (1.015 - uContrast));\ncolor.rgb = contrastF * (color.rgb - 0.5) + 0.5;\ngl_FragColor = color;\n}",
        /**
         * contrast value, range from -1 to 1.
         * @param {Number} contrast
         * @default 0
         */
        contrast: 0,
        mainParameter: "contrast",
        /**
         * Constructor
         * @memberOf fabric.Image.filters.Contrast.prototype
         * @param {Object} [options] Options object
         * @param {Number} [options.contrast=0] Value to contrast the image up (-1...1)
         */
        /**
          * Apply the Contrast operation to a Uint8Array representing the pixels of an image.
          *
          * @param {Object} options
          * @param {ImageData} options.imageData The Uint8Array to be filtered.
          */
        applyTo2d: function(options) {
          if (this.contrast === 0) {
            return;
          }
          var imageData = options.imageData, i, len, data = imageData.data, len = data.length, contrast = Math.floor(this.contrast * 255), contrastF = 259 * (contrast + 255) / (255 * (259 - contrast));
          for (i = 0; i < len; i += 4) {
            data[i] = contrastF * (data[i] - 128) + 128;
            data[i + 1] = contrastF * (data[i + 1] - 128) + 128;
            data[i + 2] = contrastF * (data[i + 2] - 128) + 128;
          }
        },
        /**
         * Return WebGL uniform locations for this filter's shader.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {WebGLShaderProgram} program This filter's compiled shader program.
         */
        getUniformLocations: function(gl, program) {
          return {
            uContrast: gl.getUniformLocation(program, "uContrast")
          };
        },
        /**
         * Send data from this filter to its shader program's uniforms.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
         */
        sendUniformData: function(gl, uniformLocations) {
          gl.uniform1f(uniformLocations.uContrast, this.contrast);
        }
      }
    );
    fabric22.Image.filters.Contrast.fromObject = fabric22.Image.filters.BaseFilter.fromObject;
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), filters = fabric22.Image.filters, createClass = fabric22.util.createClass;
    filters.Saturation = createClass(
      filters.BaseFilter,
      /** @lends fabric.Image.filters.Saturation.prototype */
      {
        /**
         * Filter type
         * @param {String} type
         * @default
         */
        type: "Saturation",
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uSaturation;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nfloat rgMax = max(color.r, color.g);\nfloat rgbMax = max(rgMax, color.b);\ncolor.r += rgbMax != color.r ? (rgbMax - color.r) * uSaturation : 0.00;\ncolor.g += rgbMax != color.g ? (rgbMax - color.g) * uSaturation : 0.00;\ncolor.b += rgbMax != color.b ? (rgbMax - color.b) * uSaturation : 0.00;\ngl_FragColor = color;\n}",
        /**
         * Saturation value, from -1 to 1.
         * Increases/decreases the color saturation.
         * A value of 0 has no effect.
         * 
         * @param {Number} saturation
         * @default
         */
        saturation: 0,
        mainParameter: "saturation",
        /**
         * Constructor
         * @memberOf fabric.Image.filters.Saturate.prototype
         * @param {Object} [options] Options object
         * @param {Number} [options.saturate=0] Value to saturate the image (-1...1)
         */
        /**
         * Apply the Saturation operation to a Uint8ClampedArray representing the pixels of an image.
         *
         * @param {Object} options
         * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
         */
        applyTo2d: function(options) {
          if (this.saturation === 0) {
            return;
          }
          var imageData = options.imageData, data = imageData.data, len = data.length, adjust = -this.saturation, i, max2;
          for (i = 0; i < len; i += 4) {
            max2 = Math.max(data[i], data[i + 1], data[i + 2]);
            data[i] += max2 !== data[i] ? (max2 - data[i]) * adjust : 0;
            data[i + 1] += max2 !== data[i + 1] ? (max2 - data[i + 1]) * adjust : 0;
            data[i + 2] += max2 !== data[i + 2] ? (max2 - data[i + 2]) * adjust : 0;
          }
        },
        /**
         * Return WebGL uniform locations for this filter's shader.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {WebGLShaderProgram} program This filter's compiled shader program.
         */
        getUniformLocations: function(gl, program) {
          return {
            uSaturation: gl.getUniformLocation(program, "uSaturation")
          };
        },
        /**
         * Send data from this filter to its shader program's uniforms.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
         */
        sendUniformData: function(gl, uniformLocations) {
          gl.uniform1f(uniformLocations.uSaturation, -this.saturation);
        }
      }
    );
    fabric22.Image.filters.Saturation.fromObject = fabric22.Image.filters.BaseFilter.fromObject;
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), filters = fabric22.Image.filters, createClass = fabric22.util.createClass;
    filters.Vibrance = createClass(
      filters.BaseFilter,
      /** @lends fabric.Image.filters.Vibrance.prototype */
      {
        /**
         * Filter type
         * @param {String} type
         * @default
         */
        type: "Vibrance",
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uVibrance;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nfloat max = max(color.r, max(color.g, color.b));\nfloat avg = (color.r + color.g + color.b) / 3.0;\nfloat amt = (abs(max - avg) * 2.0) * uVibrance;\ncolor.r += max != color.r ? (max - color.r) * amt : 0.00;\ncolor.g += max != color.g ? (max - color.g) * amt : 0.00;\ncolor.b += max != color.b ? (max - color.b) * amt : 0.00;\ngl_FragColor = color;\n}",
        /**
         * Vibrance value, from -1 to 1.
         * Increases/decreases the saturation of more muted colors with less effect on saturated colors.
         * A value of 0 has no effect.
         * 
         * @param {Number} vibrance
         * @default
         */
        vibrance: 0,
        mainParameter: "vibrance",
        /**
         * Constructor
         * @memberOf fabric.Image.filters.Vibrance.prototype
         * @param {Object} [options] Options object
         * @param {Number} [options.vibrance=0] Vibrance value for the image (between -1 and 1)
         */
        /**
         * Apply the Vibrance operation to a Uint8ClampedArray representing the pixels of an image.
         *
         * @param {Object} options
         * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
         */
        applyTo2d: function(options) {
          if (this.vibrance === 0) {
            return;
          }
          var imageData = options.imageData, data = imageData.data, len = data.length, adjust = -this.vibrance, i, max2, avg, amt;
          for (i = 0; i < len; i += 4) {
            max2 = Math.max(data[i], data[i + 1], data[i + 2]);
            avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
            amt = Math.abs(max2 - avg) * 2 / 255 * adjust;
            data[i] += max2 !== data[i] ? (max2 - data[i]) * amt : 0;
            data[i + 1] += max2 !== data[i + 1] ? (max2 - data[i + 1]) * amt : 0;
            data[i + 2] += max2 !== data[i + 2] ? (max2 - data[i + 2]) * amt : 0;
          }
        },
        /**
         * Return WebGL uniform locations for this filter's shader.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {WebGLShaderProgram} program This filter's compiled shader program.
         */
        getUniformLocations: function(gl, program) {
          return {
            uVibrance: gl.getUniformLocation(program, "uVibrance")
          };
        },
        /**
         * Send data from this filter to its shader program's uniforms.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
         */
        sendUniformData: function(gl, uniformLocations) {
          gl.uniform1f(uniformLocations.uVibrance, -this.vibrance);
        }
      }
    );
    fabric22.Image.filters.Vibrance.fromObject = fabric22.Image.filters.BaseFilter.fromObject;
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), filters = fabric22.Image.filters, createClass = fabric22.util.createClass;
    filters.Blur = createClass(
      filters.BaseFilter,
      /** @lends fabric.Image.filters.Blur.prototype */
      {
        type: "Blur",
        /*
        'gl_FragColor = vec4(0.0);',
        'gl_FragColor += texture2D(texture, vTexCoord + -7 * uDelta)*0.0044299121055113265;',
        'gl_FragColor += texture2D(texture, vTexCoord + -6 * uDelta)*0.00895781211794;',
        'gl_FragColor += texture2D(texture, vTexCoord + -5 * uDelta)*0.0215963866053;',
        'gl_FragColor += texture2D(texture, vTexCoord + -4 * uDelta)*0.0443683338718;',
        'gl_FragColor += texture2D(texture, vTexCoord + -3 * uDelta)*0.0776744219933;',
        'gl_FragColor += texture2D(texture, vTexCoord + -2 * uDelta)*0.115876621105;',
        'gl_FragColor += texture2D(texture, vTexCoord + -1 * uDelta)*0.147308056121;',
        'gl_FragColor += texture2D(texture, vTexCoord              )*0.159576912161;',
        'gl_FragColor += texture2D(texture, vTexCoord + 1 * uDelta)*0.147308056121;',
        'gl_FragColor += texture2D(texture, vTexCoord + 2 * uDelta)*0.115876621105;',
        'gl_FragColor += texture2D(texture, vTexCoord + 3 * uDelta)*0.0776744219933;',
        'gl_FragColor += texture2D(texture, vTexCoord + 4 * uDelta)*0.0443683338718;',
        'gl_FragColor += texture2D(texture, vTexCoord + 5 * uDelta)*0.0215963866053;',
        'gl_FragColor += texture2D(texture, vTexCoord + 6 * uDelta)*0.00895781211794;',
        'gl_FragColor += texture2D(texture, vTexCoord + 7 * uDelta)*0.0044299121055113265;',
        */
        /* eslint-disable max-len */
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform vec2 uDelta;\nvarying vec2 vTexCoord;\nconst float nSamples = 15.0;\nvec3 v3offset = vec3(12.9898, 78.233, 151.7182);\nfloat random(vec3 scale) {\nreturn fract(sin(dot(gl_FragCoord.xyz, scale)) * 43758.5453);\n}\nvoid main() {\nvec4 color = vec4(0.0);\nfloat total = 0.0;\nfloat offset = random(v3offset);\nfor (float t = -nSamples; t <= nSamples; t++) {\nfloat percent = (t + offset - 0.5) / nSamples;\nfloat weight = 1.0 - abs(percent);\ncolor += texture2D(uTexture, vTexCoord + uDelta * percent) * weight;\ntotal += weight;\n}\ngl_FragColor = color / total;\n}",
        /* eslint-enable max-len */
        /**
         * blur value, in percentage of image dimensions.
         * specific to keep the image blur constant at different resolutions
         * range between 0 and 1.
         * @type Number
         * @default
         */
        blur: 0,
        mainParameter: "blur",
        applyTo: function(options) {
          if (options.webgl) {
            this.aspectRatio = options.sourceWidth / options.sourceHeight;
            options.passes++;
            this._setupFrameBuffer(options);
            this.horizontal = true;
            this.applyToWebGL(options);
            this._swapTextures(options);
            this._setupFrameBuffer(options);
            this.horizontal = false;
            this.applyToWebGL(options);
            this._swapTextures(options);
          } else {
            this.applyTo2d(options);
          }
        },
        applyTo2d: function(options) {
          options.imageData = this.simpleBlur(options);
        },
        simpleBlur: function(options) {
          var resources = options.filterBackend.resources, canvas1, canvas2, width = options.imageData.width, height = options.imageData.height;
          if (!resources.blurLayer1) {
            resources.blurLayer1 = fabric22.util.createCanvasElement();
            resources.blurLayer2 = fabric22.util.createCanvasElement();
          }
          canvas1 = resources.blurLayer1;
          canvas2 = resources.blurLayer2;
          if (canvas1.width !== width || canvas1.height !== height) {
            canvas2.width = canvas1.width = width;
            canvas2.height = canvas1.height = height;
          }
          var ctx1 = canvas1.getContext("2d"), ctx2 = canvas2.getContext("2d"), nSamples = 15, random2, percent, j, i, blur = this.blur * 0.06 * 0.5;
          ctx1.putImageData(options.imageData, 0, 0);
          ctx2.clearRect(0, 0, width, height);
          for (i = -nSamples; i <= nSamples; i++) {
            random2 = (Math.random() - 0.5) / 4;
            percent = i / nSamples;
            j = blur * percent * width + random2;
            ctx2.globalAlpha = 1 - Math.abs(percent);
            ctx2.drawImage(canvas1, j, random2);
            ctx1.drawImage(canvas2, 0, 0);
            ctx2.globalAlpha = 1;
            ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
          }
          for (i = -nSamples; i <= nSamples; i++) {
            random2 = (Math.random() - 0.5) / 4;
            percent = i / nSamples;
            j = blur * percent * height + random2;
            ctx2.globalAlpha = 1 - Math.abs(percent);
            ctx2.drawImage(canvas1, random2, j);
            ctx1.drawImage(canvas2, 0, 0);
            ctx2.globalAlpha = 1;
            ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
          }
          options.ctx.drawImage(canvas1, 0, 0);
          var newImageData = options.ctx.getImageData(0, 0, canvas1.width, canvas1.height);
          ctx1.globalAlpha = 1;
          ctx1.clearRect(0, 0, canvas1.width, canvas1.height);
          return newImageData;
        },
        /**
         * Return WebGL uniform locations for this filter's shader.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {WebGLShaderProgram} program This filter's compiled shader program.
         */
        getUniformLocations: function(gl, program) {
          return {
            delta: gl.getUniformLocation(program, "uDelta")
          };
        },
        /**
         * Send data from this filter to its shader program's uniforms.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
         */
        sendUniformData: function(gl, uniformLocations) {
          var delta = this.chooseRightDelta();
          gl.uniform2fv(uniformLocations.delta, delta);
        },
        /**
         * choose right value of image percentage to blur with
         * @returns {Array} a numeric array with delta values
         */
        chooseRightDelta: function() {
          var blurScale = 1, delta = [0, 0], blur;
          if (this.horizontal) {
            if (this.aspectRatio > 1) {
              blurScale = 1 / this.aspectRatio;
            }
          } else {
            if (this.aspectRatio < 1) {
              blurScale = this.aspectRatio;
            }
          }
          blur = blurScale * this.blur * 0.12;
          if (this.horizontal) {
            delta[0] = blur;
          } else {
            delta[1] = blur;
          }
          return delta;
        }
      }
    );
    filters.Blur.fromObject = fabric22.Image.filters.BaseFilter.fromObject;
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), filters = fabric22.Image.filters, createClass = fabric22.util.createClass;
    filters.Gamma = createClass(
      filters.BaseFilter,
      /** @lends fabric.Image.filters.Gamma.prototype */
      {
        /**
         * Filter type
         * @param {String} type
         * @default
         */
        type: "Gamma",
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform vec3 uGamma;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nvec3 correction = (1.0 / uGamma);\ncolor.r = pow(color.r, correction.r);\ncolor.g = pow(color.g, correction.g);\ncolor.b = pow(color.b, correction.b);\ngl_FragColor = color;\ngl_FragColor.rgb *= color.a;\n}",
        /**
         * Gamma array value, from 0.01 to 2.2.
         * @param {Array} gamma
         * @default
         */
        gamma: [1, 1, 1],
        /**
         * Describe the property that is the filter parameter
         * @param {String} m
         * @default
         */
        mainParameter: "gamma",
        /**
         * Constructor
         * @param {Object} [options] Options object
         */
        initialize: function(options) {
          this.gamma = [1, 1, 1];
          filters.BaseFilter.prototype.initialize.call(this, options);
        },
        /**
         * Apply the Gamma operation to a Uint8Array representing the pixels of an image.
         *
         * @param {Object} options
         * @param {ImageData} options.imageData The Uint8Array to be filtered.
         */
        applyTo2d: function(options) {
          var imageData = options.imageData, data = imageData.data, gamma = this.gamma, len = data.length, rInv = 1 / gamma[0], gInv = 1 / gamma[1], bInv = 1 / gamma[2], i;
          if (!this.rVals) {
            this.rVals = new Uint8Array(256);
            this.gVals = new Uint8Array(256);
            this.bVals = new Uint8Array(256);
          }
          for (i = 0, len = 256; i < len; i++) {
            this.rVals[i] = Math.pow(i / 255, rInv) * 255;
            this.gVals[i] = Math.pow(i / 255, gInv) * 255;
            this.bVals[i] = Math.pow(i / 255, bInv) * 255;
          }
          for (i = 0, len = data.length; i < len; i += 4) {
            data[i] = this.rVals[data[i]];
            data[i + 1] = this.gVals[data[i + 1]];
            data[i + 2] = this.bVals[data[i + 2]];
          }
        },
        /**
         * Return WebGL uniform locations for this filter's shader.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {WebGLShaderProgram} program This filter's compiled shader program.
         */
        getUniformLocations: function(gl, program) {
          return {
            uGamma: gl.getUniformLocation(program, "uGamma")
          };
        },
        /**
         * Send data from this filter to its shader program's uniforms.
         *
         * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
         * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
         */
        sendUniformData: function(gl, uniformLocations) {
          gl.uniform3fv(uniformLocations.uGamma, this.gamma);
        }
      }
    );
    fabric22.Image.filters.Gamma.fromObject = fabric22.Image.filters.BaseFilter.fromObject;
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), filters = fabric22.Image.filters, createClass = fabric22.util.createClass;
    filters.Composed = createClass(
      filters.BaseFilter,
      /** @lends fabric.Image.filters.Composed.prototype */
      {
        type: "Composed",
        /**
         * A non sparse array of filters to apply
         */
        subFilters: [],
        /**
         * Constructor
         * @param {Object} [options] Options object
         */
        initialize: function(options) {
          this.callSuper("initialize", options);
          this.subFilters = this.subFilters.slice(0);
        },
        /**
         * Apply this container's filters to the input image provided.
         *
         * @param {Object} options
         * @param {Number} options.passes The number of filters remaining to be applied.
         */
        applyTo: function(options) {
          options.passes += this.subFilters.length - 1;
          this.subFilters.forEach(function(filter) {
            filter.applyTo(options);
          });
        },
        /**
         * Serialize this filter into JSON.
         *
         * @returns {Object} A JSON representation of this filter.
         */
        toObject: function() {
          return fabric22.util.object.extend(this.callSuper("toObject"), {
            subFilters: this.subFilters.map(function(filter) {
              return filter.toObject();
            })
          });
        },
        isNeutralState: function() {
          return !this.subFilters.some(function(filter) {
            return !filter.isNeutralState();
          });
        }
      }
    );
    fabric22.Image.filters.Composed.fromObject = function(object, callback) {
      var filters2 = object.subFilters || [], subFilters = filters2.map(function(filter) {
        return new fabric22.Image.filters[filter.type](filter);
      }), instance = new fabric22.Image.filters.Composed({ subFilters });
      callback && callback(instance);
      return instance;
    };
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), filters = fabric22.Image.filters, createClass = fabric22.util.createClass;
    filters.HueRotation = createClass(
      filters.ColorMatrix,
      /** @lends fabric.Image.filters.HueRotation.prototype */
      {
        /**
         * Filter type
         * @param {String} type
         * @default
         */
        type: "HueRotation",
        /**
         * HueRotation value, from -1 to 1.
         * the unit is radians
         * @param {Number} myParameter
         * @default
         */
        rotation: 0,
        /**
         * Describe the property that is the filter parameter
         * @param {String} m
         * @default
         */
        mainParameter: "rotation",
        calculateMatrix: function() {
          var rad = this.rotation * Math.PI, cos2 = fabric22.util.cos(rad), sin2 = fabric22.util.sin(rad), aThird = 1 / 3, aThirdSqtSin = Math.sqrt(aThird) * sin2, OneMinusCos = 1 - cos2;
          this.matrix = [
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0
          ];
          this.matrix[0] = cos2 + OneMinusCos / 3;
          this.matrix[1] = aThird * OneMinusCos - aThirdSqtSin;
          this.matrix[2] = aThird * OneMinusCos + aThirdSqtSin;
          this.matrix[5] = aThird * OneMinusCos + aThirdSqtSin;
          this.matrix[6] = cos2 + aThird * OneMinusCos;
          this.matrix[7] = aThird * OneMinusCos - aThirdSqtSin;
          this.matrix[10] = aThird * OneMinusCos - aThirdSqtSin;
          this.matrix[11] = aThird * OneMinusCos + aThirdSqtSin;
          this.matrix[12] = cos2 + aThird * OneMinusCos;
        },
        /**
         * HueRotation isNeutralState implementation
         * Used only in image applyFilters to discard filters that will not have an effect
         * on the image
         * @param {Object} options
         **/
        isNeutralState: function(options) {
          this.calculateMatrix();
          return filters.BaseFilter.prototype.isNeutralState.call(this, options);
        },
        /**
         * Apply this filter to the input image data provided.
         *
         * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
         *
         * @param {Object} options
         * @param {Number} options.passes The number of filters remaining to be executed
         * @param {Boolean} options.webgl Whether to use webgl to render the filter.
         * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
         * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
         * @param {WebGLRenderingContext} options.context The GL context used for rendering.
         * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
         */
        applyTo: function(options) {
          this.calculateMatrix();
          filters.BaseFilter.prototype.applyTo.call(this, options);
        }
      }
    );
    fabric22.Image.filters.HueRotation.fromObject = fabric22.Image.filters.BaseFilter.fromObject;
  })(exports);
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {}), clone2 = fabric22.util.object.clone;
    if (fabric22.Text) {
      fabric22.warn("fabric.Text is already defined");
      return;
    }
    var additionalProps = "fontFamily fontWeight fontSize text underline overline linethrough textAlign fontStyle lineHeight textBackgroundColor charSpacing styles direction path pathStartOffset pathSide pathAlign".split(" ");
    fabric22.Text = fabric22.util.createClass(
      fabric22.Object,
      /** @lends fabric.Text.prototype */
      {
        /**
         * Properties which when set cause object to change dimensions
         * @type Array
         * @private
         */
        _dimensionAffectingProps: [
          "fontSize",
          "fontWeight",
          "fontFamily",
          "fontStyle",
          "lineHeight",
          "text",
          "charSpacing",
          "textAlign",
          "styles",
          "path",
          "pathStartOffset",
          "pathSide",
          "pathAlign"
        ],
        /**
         * @private
         */
        _reNewline: /\r?\n/,
        /**
         * Use this regular expression to filter for whitespaces that is not a new line.
         * Mostly used when text is 'justify' aligned.
         * @private
         */
        _reSpacesAndTabs: /[ \t\r]/g,
        /**
         * Use this regular expression to filter for whitespace that is not a new line.
         * Mostly used when text is 'justify' aligned.
         * @private
         */
        _reSpaceAndTab: /[ \t\r]/,
        /**
         * Use this regular expression to filter consecutive groups of non spaces.
         * Mostly used when text is 'justify' aligned.
         * @private
         */
        _reWords: /\S+/g,
        /**
         * Type of an object
         * @type String
         * @default
         */
        type: "text",
        /**
         * Font size (in pixels)
         * @type Number
         * @default
         */
        fontSize: 40,
        /**
         * Font weight (e.g. bold, normal, 400, 600, 800)
         * @type {(Number|String)}
         * @default
         */
        fontWeight: "normal",
        /**
         * Font family
         * @type String
         * @default
         */
        fontFamily: "Times New Roman",
        /**
         * Text decoration underline.
         * @type Boolean
         * @default
         */
        underline: false,
        /**
         * Text decoration overline.
         * @type Boolean
         * @default
         */
        overline: false,
        /**
         * Text decoration linethrough.
         * @type Boolean
         * @default
         */
        linethrough: false,
        /**
         * Text alignment. Possible values: "left", "center", "right", "justify",
         * "justify-left", "justify-center" or "justify-right".
         * @type String
         * @default
         */
        textAlign: "left",
        /**
         * Font style . Possible values: "", "normal", "italic" or "oblique".
         * @type String
         * @default
         */
        fontStyle: "normal",
        /**
         * Line height
         * @type Number
         * @default
         */
        lineHeight: 1.16,
        /**
         * Superscript schema object (minimum overlap)
         * @type {Object}
         * @default
         */
        superscript: {
          size: 0.6,
          // fontSize factor
          baseline: -0.35
          // baseline-shift factor (upwards)
        },
        /**
         * Subscript schema object (minimum overlap)
         * @type {Object}
         * @default
         */
        subscript: {
          size: 0.6,
          // fontSize factor
          baseline: 0.11
          // baseline-shift factor (downwards)
        },
        /**
         * Background color of text lines
         * @type String
         * @default
         */
        textBackgroundColor: "",
        /**
         * List of properties to consider when checking if
         * state of an object is changed ({@link fabric.Object#hasStateChanged})
         * as well as for history (undo/redo) purposes
         * @type Array
         */
        stateProperties: fabric22.Object.prototype.stateProperties.concat(additionalProps),
        /**
         * List of properties to consider when checking if cache needs refresh
         * @type Array
         */
        cacheProperties: fabric22.Object.prototype.cacheProperties.concat(additionalProps),
        /**
         * When defined, an object is rendered via stroke and this property specifies its color.
         * <b>Backwards incompatibility note:</b> This property was named "strokeStyle" until v1.1.6
         * @type String
         * @default
         */
        stroke: null,
        /**
         * Shadow object representing shadow of this shape.
         * <b>Backwards incompatibility note:</b> This property was named "textShadow" (String) until v1.2.11
         * @type fabric.Shadow
         * @default
         */
        shadow: null,
        /**
         * fabric.Path that the text should follow.
         * since 4.6.0 the path will be drawn automatically.
         * if you want to make the path visible, give it a stroke and strokeWidth or fill value
         * if you want it to be hidden, assign visible = false to the path.
         * This feature is in BETA, and SVG import/export is not yet supported.
         * @type fabric.Path
         * @example
         * var textPath = new fabric.Text('Text on a path', {
         *     top: 150,
         *     left: 150,
         *     textAlign: 'center',
         *     charSpacing: -50,
         *     path: new fabric.Path('M 0 0 C 50 -100 150 -100 200 0', {
         *         strokeWidth: 1,
         *         visible: false
         *     }),
         *     pathSide: 'left',
         *     pathStartOffset: 0
         * });
         * @default
         */
        path: null,
        /**
         * Offset amount for text path starting position
         * Only used when text has a path
         * @type Number
         * @default
         */
        pathStartOffset: 0,
        /**
         * Which side of the path the text should be drawn on.
         * Only used when text has a path
         * @type {String} 'left|right'
         * @default
         */
        pathSide: "left",
        /**
         * How text is aligned to the path. This property determines
         * the perpendicular position of each character relative to the path.
         * (one of "baseline", "center", "ascender", "descender")
         * This feature is in BETA, and its behavior may change
         * @type String
         * @default
         */
        pathAlign: "baseline",
        /**
         * @private
         */
        _fontSizeFraction: 0.222,
        /**
         * @private
         */
        offsets: {
          underline: 0.1,
          linethrough: -0.315,
          overline: -0.88
        },
        /**
         * Text Line proportion to font Size (in pixels)
         * @type Number
         * @default
         */
        _fontSizeMult: 1.13,
        /**
         * additional space between characters
         * expressed in thousands of em unit
         * @type Number
         * @default
         */
        charSpacing: 0,
        /**
         * Object containing character styles - top-level properties -> line numbers,
         * 2nd-level properties - character numbers
         * @type Object
         * @default
         */
        styles: null,
        /**
         * Reference to a context to measure text char or couple of chars
         * the cacheContext of the canvas will be used or a freshly created one if the object is not on canvas
         * once created it will be referenced on fabric._measuringContext to avoid creating a canvas for every
         * text object created.
         * @type {CanvasRenderingContext2D}
         * @default
         */
        _measuringContext: null,
        /**
         * Baseline shift, styles only, keep at 0 for the main text object
         * @type {Number}
         * @default
         */
        deltaY: 0,
        /**
         * WARNING: EXPERIMENTAL. NOT SUPPORTED YET
         * determine the direction of the text.
         * This has to be set manually together with textAlign and originX for proper
         * experience.
         * some interesting link for the future
         * https://www.w3.org/International/questions/qa-bidi-unicode-controls
         * @since 4.5.0
         * @type {String} 'ltr|rtl'
         * @default
         */
        direction: "ltr",
        /**
         * Array of properties that define a style unit (of 'styles').
         * @type {Array}
         * @default
         */
        _styleProperties: [
          "stroke",
          "strokeWidth",
          "fill",
          "fontFamily",
          "fontSize",
          "fontWeight",
          "fontStyle",
          "underline",
          "overline",
          "linethrough",
          "deltaY",
          "textBackgroundColor"
        ],
        /**
         * contains characters bounding boxes
         */
        __charBounds: [],
        /**
         * use this size when measuring text. To avoid IE11 rounding errors
         * @type {Number}
         * @default
         * @readonly
         * @private
         */
        CACHE_FONT_SIZE: 400,
        /**
         * contains the min text width to avoid getting 0
         * @type {Number}
         * @default
         */
        MIN_TEXT_WIDTH: 2,
        /**
         * Constructor
         * @param {String} text Text string
         * @param {Object} [options] Options object
         * @return {fabric.Text} thisArg
         */
        initialize: function(text, options) {
          this.styles = options ? options.styles || {} : {};
          this.text = text;
          this.__skipDimension = true;
          this.callSuper("initialize", options);
          if (this.path) {
            this.setPathInfo();
          }
          this.__skipDimension = false;
          this.initDimensions();
          this.setCoords();
          this.setupState({ propertySet: "_dimensionAffectingProps" });
        },
        /**
         * If text has a path, it will add the extra information needed
         * for path and text calculations
         * @return {fabric.Text} thisArg
         */
        setPathInfo: function() {
          var path = this.path;
          if (path) {
            path.segmentsInfo = fabric22.util.getPathSegmentsInfo(path.path);
          }
        },
        /**
         * Return a context for measurement of text string.
         * if created it gets stored for reuse
         * this is for internal use, please do not use it
         * @private
         * @param {String} text Text string
         * @param {Object} [options] Options object
         * @return {fabric.Text} thisArg
         */
        getMeasuringContext: function() {
          if (!fabric22._measuringContext) {
            fabric22._measuringContext = this.canvas && this.canvas.contextCache || fabric22.util.createCanvasElement().getContext("2d");
          }
          return fabric22._measuringContext;
        },
        /**
         * @private
         * Divides text into lines of text and lines of graphemes.
         */
        _splitText: function() {
          var newLines = this._splitTextIntoLines(this.text);
          this.textLines = newLines.lines;
          this._textLines = newLines.graphemeLines;
          this._unwrappedTextLines = newLines._unwrappedLines;
          this._text = newLines.graphemeText;
          return newLines;
        },
        /**
         * Initialize or update text dimensions.
         * Updates this.width and this.height with the proper values.
         * Does not return dimensions.
         */
        initDimensions: function() {
          if (this.__skipDimension) {
            return;
          }
          this._splitText();
          this._clearCache();
          if (this.path) {
            this.width = this.path.width;
            this.height = this.path.height;
          } else {
            this.width = this.calcTextWidth() || this.cursorWidth || this.MIN_TEXT_WIDTH;
            this.height = this.calcTextHeight();
          }
          if (this.textAlign.indexOf("justify") !== -1) {
            this.enlargeSpaces();
          }
          this.saveState({ propertySet: "_dimensionAffectingProps" });
        },
        /**
         * Enlarge space boxes and shift the others
         */
        enlargeSpaces: function() {
          var diffSpace, currentLineWidth, numberOfSpaces, accumulatedSpace, line, charBound, spaces;
          for (var i = 0, len = this._textLines.length; i < len; i++) {
            if (this.textAlign !== "justify" && (i === len - 1 || this.isEndOfWrapping(i))) {
              continue;
            }
            accumulatedSpace = 0;
            line = this._textLines[i];
            currentLineWidth = this.getLineWidth(i);
            if (currentLineWidth < this.width && (spaces = this.textLines[i].match(this._reSpacesAndTabs))) {
              numberOfSpaces = spaces.length;
              diffSpace = (this.width - currentLineWidth) / numberOfSpaces;
              for (var j = 0, jlen = line.length; j <= jlen; j++) {
                charBound = this.__charBounds[i][j];
                if (this._reSpaceAndTab.test(line[j])) {
                  charBound.width += diffSpace;
                  charBound.kernedWidth += diffSpace;
                  charBound.left += accumulatedSpace;
                  accumulatedSpace += diffSpace;
                } else {
                  charBound.left += accumulatedSpace;
                }
              }
            }
          }
        },
        /**
         * Detect if the text line is ended with an hard break
         * text and itext do not have wrapping, return false
         * @return {Boolean}
         */
        isEndOfWrapping: function(lineIndex) {
          return lineIndex === this._textLines.length - 1;
        },
        /**
         * Detect if a line has a linebreak and so we need to account for it when moving
         * and counting style.
         * It return always for text and Itext.
         * @return Number
         */
        missingNewlineOffset: function() {
          return 1;
        },
        /**
         * Returns string representation of an instance
         * @return {String} String representation of text object
         */
        toString: function() {
          return "#<fabric.Text (" + this.complexity() + '): { "text": "' + this.text + '", "fontFamily": "' + this.fontFamily + '" }>';
        },
        /**
         * Return the dimension and the zoom level needed to create a cache canvas
         * big enough to host the object to be cached.
         * @private
         * @param {Object} dim.x width of object to be cached
         * @param {Object} dim.y height of object to be cached
         * @return {Object}.width width of canvas
         * @return {Object}.height height of canvas
         * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
         * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
         */
        _getCacheCanvasDimensions: function() {
          var dims = this.callSuper("_getCacheCanvasDimensions");
          var fontSize = this.fontSize;
          dims.width += fontSize * dims.zoomX;
          dims.height += fontSize * dims.zoomY;
          return dims;
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _render: function(ctx) {
          var path = this.path;
          path && !path.isNotVisible() && path._render(ctx);
          this._setTextStyles(ctx);
          this._renderTextLinesBackground(ctx);
          this._renderTextDecoration(ctx, "underline");
          this._renderText(ctx);
          this._renderTextDecoration(ctx, "overline");
          this._renderTextDecoration(ctx, "linethrough");
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _renderText: function(ctx) {
          if (this.paintFirst === "stroke") {
            this._renderTextStroke(ctx);
            this._renderTextFill(ctx);
          } else {
            this._renderTextFill(ctx);
            this._renderTextStroke(ctx);
          }
        },
        /**
         * Set the font parameter of the context with the object properties or with charStyle
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         * @param {Object} [charStyle] object with font style properties
         * @param {String} [charStyle.fontFamily] Font Family
         * @param {Number} [charStyle.fontSize] Font size in pixels. ( without px suffix )
         * @param {String} [charStyle.fontWeight] Font weight
         * @param {String} [charStyle.fontStyle] Font style (italic|normal)
         */
        _setTextStyles: function(ctx, charStyle, forMeasuring) {
          ctx.textBaseline = "alphabetical";
          if (this.path) {
            switch (this.pathAlign) {
              case "center":
                ctx.textBaseline = "middle";
                break;
              case "ascender":
                ctx.textBaseline = "top";
                break;
              case "descender":
                ctx.textBaseline = "bottom";
                break;
            }
          }
          ctx.font = this._getFontDeclaration(charStyle, forMeasuring);
        },
        /**
         * calculate and return the text Width measuring each line.
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         * @return {Number} Maximum width of fabric.Text object
         */
        calcTextWidth: function() {
          var maxWidth = this.getLineWidth(0);
          for (var i = 1, len = this._textLines.length; i < len; i++) {
            var currentLineWidth = this.getLineWidth(i);
            if (currentLineWidth > maxWidth) {
              maxWidth = currentLineWidth;
            }
          }
          return maxWidth;
        },
        /**
         * @private
         * @param {String} method Method name ("fillText" or "strokeText")
         * @param {CanvasRenderingContext2D} ctx Context to render on
         * @param {String} line Text to render
         * @param {Number} left Left position of text
         * @param {Number} top Top position of text
         * @param {Number} lineIndex Index of a line in a text
         */
        _renderTextLine: function(method, ctx, line, left, top, lineIndex) {
          this._renderChars(method, ctx, line, left, top, lineIndex);
        },
        /**
         * Renders the text background for lines, taking care of style
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _renderTextLinesBackground: function(ctx) {
          if (!this.textBackgroundColor && !this.styleHas("textBackgroundColor")) {
            return;
          }
          var heightOfLine, lineLeftOffset, originalFill = ctx.fillStyle, line, lastColor, leftOffset = this._getLeftOffset(), lineTopOffset = this._getTopOffset(), boxStart = 0, boxWidth = 0, charBox, currentColor, path = this.path, drawStart;
          for (var i = 0, len = this._textLines.length; i < len; i++) {
            heightOfLine = this.getHeightOfLine(i);
            if (!this.textBackgroundColor && !this.styleHas("textBackgroundColor", i)) {
              lineTopOffset += heightOfLine;
              continue;
            }
            line = this._textLines[i];
            lineLeftOffset = this._getLineLeftOffset(i);
            boxWidth = 0;
            boxStart = 0;
            lastColor = this.getValueOfPropertyAt(i, 0, "textBackgroundColor");
            for (var j = 0, jlen = line.length; j < jlen; j++) {
              charBox = this.__charBounds[i][j];
              currentColor = this.getValueOfPropertyAt(i, j, "textBackgroundColor");
              if (path) {
                ctx.save();
                ctx.translate(charBox.renderLeft, charBox.renderTop);
                ctx.rotate(charBox.angle);
                ctx.fillStyle = currentColor;
                currentColor && ctx.fillRect(
                  -charBox.width / 2,
                  -heightOfLine / this.lineHeight * (1 - this._fontSizeFraction),
                  charBox.width,
                  heightOfLine / this.lineHeight
                );
                ctx.restore();
              } else if (currentColor !== lastColor) {
                drawStart = leftOffset + lineLeftOffset + boxStart;
                if (this.direction === "rtl") {
                  drawStart = this.width - drawStart - boxWidth;
                }
                ctx.fillStyle = lastColor;
                lastColor && ctx.fillRect(
                  drawStart,
                  lineTopOffset,
                  boxWidth,
                  heightOfLine / this.lineHeight
                );
                boxStart = charBox.left;
                boxWidth = charBox.width;
                lastColor = currentColor;
              } else {
                boxWidth += charBox.kernedWidth;
              }
            }
            if (currentColor && !path) {
              drawStart = leftOffset + lineLeftOffset + boxStart;
              if (this.direction === "rtl") {
                drawStart = this.width - drawStart - boxWidth;
              }
              ctx.fillStyle = currentColor;
              ctx.fillRect(
                drawStart,
                lineTopOffset,
                boxWidth,
                heightOfLine / this.lineHeight
              );
            }
            lineTopOffset += heightOfLine;
          }
          ctx.fillStyle = originalFill;
          this._removeShadow(ctx);
        },
        /**
         * @private
         * @param {Object} decl style declaration for cache
         * @param {String} decl.fontFamily fontFamily
         * @param {String} decl.fontStyle fontStyle
         * @param {String} decl.fontWeight fontWeight
         * @return {Object} reference to cache
         */
        getFontCache: function(decl) {
          var fontFamily = decl.fontFamily.toLowerCase();
          if (!fabric22.charWidthsCache[fontFamily]) {
            fabric22.charWidthsCache[fontFamily] = {};
          }
          var cache2 = fabric22.charWidthsCache[fontFamily], cacheProp = decl.fontStyle.toLowerCase() + "_" + (decl.fontWeight + "").toLowerCase();
          if (!cache2[cacheProp]) {
            cache2[cacheProp] = {};
          }
          return cache2[cacheProp];
        },
        /**
         * measure and return the width of a single character.
         * possibly overridden to accommodate different measure logic or
         * to hook some external lib for character measurement
         * @private
         * @param {String} _char, char to be measured
         * @param {Object} charStyle style of char to be measured
         * @param {String} [previousChar] previous char
         * @param {Object} [prevCharStyle] style of previous char
         */
        _measureChar: function(_char, charStyle, previousChar, prevCharStyle) {
          var fontCache = this.getFontCache(charStyle), fontDeclaration = this._getFontDeclaration(charStyle), previousFontDeclaration = this._getFontDeclaration(prevCharStyle), couple = previousChar + _char, stylesAreEqual = fontDeclaration === previousFontDeclaration, width, coupleWidth, previousWidth, fontMultiplier = charStyle.fontSize / this.CACHE_FONT_SIZE, kernedWidth;
          if (previousChar && fontCache[previousChar] !== void 0) {
            previousWidth = fontCache[previousChar];
          }
          if (fontCache[_char] !== void 0) {
            kernedWidth = width = fontCache[_char];
          }
          if (stylesAreEqual && fontCache[couple] !== void 0) {
            coupleWidth = fontCache[couple];
            kernedWidth = coupleWidth - previousWidth;
          }
          if (width === void 0 || previousWidth === void 0 || coupleWidth === void 0) {
            var ctx = this.getMeasuringContext();
            this._setTextStyles(ctx, charStyle, true);
          }
          if (width === void 0) {
            kernedWidth = width = ctx.measureText(_char).width;
            fontCache[_char] = width;
          }
          if (previousWidth === void 0 && stylesAreEqual && previousChar) {
            previousWidth = ctx.measureText(previousChar).width;
            fontCache[previousChar] = previousWidth;
          }
          if (stylesAreEqual && coupleWidth === void 0) {
            coupleWidth = ctx.measureText(couple).width;
            fontCache[couple] = coupleWidth;
            kernedWidth = coupleWidth - previousWidth;
          }
          return { width: width * fontMultiplier, kernedWidth: kernedWidth * fontMultiplier };
        },
        /**
         * Computes height of character at given position
         * @param {Number} line the line index number
         * @param {Number} _char the character index number
         * @return {Number} fontSize of the character
         */
        getHeightOfChar: function(line, _char) {
          return this.getValueOfPropertyAt(line, _char, "fontSize");
        },
        /**
         * measure a text line measuring all characters.
         * @param {Number} lineIndex line number
         * @return {Number} Line width
         */
        measureLine: function(lineIndex) {
          var lineInfo = this._measureLine(lineIndex);
          if (this.charSpacing !== 0) {
            lineInfo.width -= this._getWidthOfCharSpacing();
          }
          if (lineInfo.width < 0) {
            lineInfo.width = 0;
          }
          return lineInfo;
        },
        /**
         * measure every grapheme of a line, populating __charBounds
         * @param {Number} lineIndex
         * @return {Object} object.width total width of characters
         * @return {Object} object.widthOfSpaces length of chars that match this._reSpacesAndTabs
         */
        _measureLine: function(lineIndex) {
          var width = 0, i, grapheme, line = this._textLines[lineIndex], prevGrapheme, graphemeInfo, numOfSpaces = 0, lineBounds = new Array(line.length), positionInPath = 0, startingPoint, totalPathLength, path = this.path, reverse = this.pathSide === "right";
          this.__charBounds[lineIndex] = lineBounds;
          for (i = 0; i < line.length; i++) {
            grapheme = line[i];
            graphemeInfo = this._getGraphemeBox(grapheme, lineIndex, i, prevGrapheme);
            lineBounds[i] = graphemeInfo;
            width += graphemeInfo.kernedWidth;
            prevGrapheme = grapheme;
          }
          lineBounds[i] = {
            left: graphemeInfo ? graphemeInfo.left + graphemeInfo.width : 0,
            width: 0,
            kernedWidth: 0,
            height: this.fontSize
          };
          if (path) {
            totalPathLength = path.segmentsInfo[path.segmentsInfo.length - 1].length;
            startingPoint = fabric22.util.getPointOnPath(path.path, 0, path.segmentsInfo);
            startingPoint.x += path.pathOffset.x;
            startingPoint.y += path.pathOffset.y;
            switch (this.textAlign) {
              case "left":
                positionInPath = reverse ? totalPathLength - width : 0;
                break;
              case "center":
                positionInPath = (totalPathLength - width) / 2;
                break;
              case "right":
                positionInPath = reverse ? 0 : totalPathLength - width;
                break;
            }
            positionInPath += this.pathStartOffset * (reverse ? -1 : 1);
            for (i = reverse ? line.length - 1 : 0; reverse ? i >= 0 : i < line.length; reverse ? i-- : i++) {
              graphemeInfo = lineBounds[i];
              if (positionInPath > totalPathLength) {
                positionInPath %= totalPathLength;
              } else if (positionInPath < 0) {
                positionInPath += totalPathLength;
              }
              this._setGraphemeOnPath(positionInPath, graphemeInfo, startingPoint);
              positionInPath += graphemeInfo.kernedWidth;
            }
          }
          return { width, numOfSpaces };
        },
        /**
         * Calculate the angle  and the left,top position of the char that follow a path.
         * It appends it to graphemeInfo to be reused later at rendering
         * @private
         * @param {Number} positionInPath to be measured
         * @param {Object} graphemeInfo current grapheme box information
         * @param {Object} startingPoint position of the point
         */
        _setGraphemeOnPath: function(positionInPath, graphemeInfo, startingPoint) {
          var centerPosition = positionInPath + graphemeInfo.kernedWidth / 2, path = this.path;
          var info = fabric22.util.getPointOnPath(path.path, centerPosition, path.segmentsInfo);
          graphemeInfo.renderLeft = info.x - startingPoint.x;
          graphemeInfo.renderTop = info.y - startingPoint.y;
          graphemeInfo.angle = info.angle + (this.pathSide === "right" ? Math.PI : 0);
        },
        /**
         * Measure and return the info of a single grapheme.
         * needs the the info of previous graphemes already filled
         * @private
         * @param {String} grapheme to be measured
         * @param {Number} lineIndex index of the line where the char is
         * @param {Number} charIndex position in the line
         * @param {String} [prevGrapheme] character preceding the one to be measured
         */
        _getGraphemeBox: function(grapheme, lineIndex, charIndex, prevGrapheme, skipLeft) {
          var style = this.getCompleteStyleDeclaration(lineIndex, charIndex), prevStyle = prevGrapheme ? this.getCompleteStyleDeclaration(lineIndex, charIndex - 1) : {}, info = this._measureChar(grapheme, style, prevGrapheme, prevStyle), kernedWidth = info.kernedWidth, width = info.width, charSpacing;
          if (this.charSpacing !== 0) {
            charSpacing = this._getWidthOfCharSpacing();
            width += charSpacing;
            kernedWidth += charSpacing;
          }
          var box = {
            width,
            left: 0,
            height: style.fontSize,
            kernedWidth,
            deltaY: style.deltaY
          };
          if (charIndex > 0 && !skipLeft) {
            var previousBox = this.__charBounds[lineIndex][charIndex - 1];
            box.left = previousBox.left + previousBox.width + info.kernedWidth - info.width;
          }
          return box;
        },
        /**
         * Calculate height of line at 'lineIndex'
         * @param {Number} lineIndex index of line to calculate
         * @return {Number}
         */
        getHeightOfLine: function(lineIndex) {
          if (this.__lineHeights[lineIndex]) {
            return this.__lineHeights[lineIndex];
          }
          var line = this._textLines[lineIndex], maxHeight = this.getHeightOfChar(lineIndex, 0);
          for (var i = 1, len = line.length; i < len; i++) {
            maxHeight = Math.max(this.getHeightOfChar(lineIndex, i), maxHeight);
          }
          return this.__lineHeights[lineIndex] = maxHeight * this.lineHeight * this._fontSizeMult;
        },
        /**
         * Calculate text box height
         */
        calcTextHeight: function() {
          var lineHeight, height = 0;
          for (var i = 0, len = this._textLines.length; i < len; i++) {
            lineHeight = this.getHeightOfLine(i);
            height += i === len - 1 ? lineHeight / this.lineHeight : lineHeight;
          }
          return height;
        },
        /**
         * @private
         * @return {Number} Left offset
         */
        _getLeftOffset: function() {
          return this.direction === "ltr" ? -this.width / 2 : this.width / 2;
        },
        /**
         * @private
         * @return {Number} Top offset
         */
        _getTopOffset: function() {
          return -this.height / 2;
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         * @param {String} method Method name ("fillText" or "strokeText")
         */
        _renderTextCommon: function(ctx, method) {
          ctx.save();
          var lineHeights = 0, left = this._getLeftOffset(), top = this._getTopOffset();
          for (var i = 0, len = this._textLines.length; i < len; i++) {
            var heightOfLine = this.getHeightOfLine(i), maxHeight = heightOfLine / this.lineHeight, leftOffset = this._getLineLeftOffset(i);
            this._renderTextLine(
              method,
              ctx,
              this._textLines[i],
              left + leftOffset,
              top + lineHeights + maxHeight,
              i
            );
            lineHeights += heightOfLine;
          }
          ctx.restore();
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _renderTextFill: function(ctx) {
          if (!this.fill && !this.styleHas("fill")) {
            return;
          }
          this._renderTextCommon(ctx, "fillText");
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _renderTextStroke: function(ctx) {
          if ((!this.stroke || this.strokeWidth === 0) && this.isEmptyStyles()) {
            return;
          }
          if (this.shadow && !this.shadow.affectStroke) {
            this._removeShadow(ctx);
          }
          ctx.save();
          this._setLineDash(ctx, this.strokeDashArray);
          ctx.beginPath();
          this._renderTextCommon(ctx, "strokeText");
          ctx.closePath();
          ctx.restore();
        },
        /**
         * @private
         * @param {String} method fillText or strokeText.
         * @param {CanvasRenderingContext2D} ctx Context to render on
         * @param {Array} line Content of the line, splitted in an array by grapheme
         * @param {Number} left
         * @param {Number} top
         * @param {Number} lineIndex
         */
        _renderChars: function(method, ctx, line, left, top, lineIndex) {
          var lineHeight = this.getHeightOfLine(lineIndex), isJustify = this.textAlign.indexOf("justify") !== -1, actualStyle, nextStyle, charsToRender = "", charBox, boxWidth = 0, timeToRender, path = this.path, shortCut = !isJustify && this.charSpacing === 0 && this.isEmptyStyles(lineIndex) && !path, isLtr = this.direction === "ltr", sign2 = this.direction === "ltr" ? 1 : -1, drawingLeft, currentDirection = ctx.canvas.getAttribute("dir");
          ctx.save();
          if (currentDirection !== this.direction) {
            ctx.canvas.setAttribute("dir", isLtr ? "ltr" : "rtl");
            ctx.direction = isLtr ? "ltr" : "rtl";
            ctx.textAlign = isLtr ? "left" : "right";
          }
          top -= lineHeight * this._fontSizeFraction / this.lineHeight;
          if (shortCut) {
            this._renderChar(method, ctx, lineIndex, 0, line.join(""), left, top, lineHeight);
            ctx.restore();
            return;
          }
          for (var i = 0, len = line.length - 1; i <= len; i++) {
            timeToRender = i === len || this.charSpacing || path;
            charsToRender += line[i];
            charBox = this.__charBounds[lineIndex][i];
            if (boxWidth === 0) {
              left += sign2 * (charBox.kernedWidth - charBox.width);
              boxWidth += charBox.width;
            } else {
              boxWidth += charBox.kernedWidth;
            }
            if (isJustify && !timeToRender) {
              if (this._reSpaceAndTab.test(line[i])) {
                timeToRender = true;
              }
            }
            if (!timeToRender) {
              actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
              nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
              timeToRender = fabric22.util.hasStyleChanged(actualStyle, nextStyle, false);
            }
            if (timeToRender) {
              if (path) {
                ctx.save();
                ctx.translate(charBox.renderLeft, charBox.renderTop);
                ctx.rotate(charBox.angle);
                this._renderChar(method, ctx, lineIndex, i, charsToRender, -boxWidth / 2, 0, lineHeight);
                ctx.restore();
              } else {
                drawingLeft = left;
                this._renderChar(method, ctx, lineIndex, i, charsToRender, drawingLeft, top, lineHeight);
              }
              charsToRender = "";
              actualStyle = nextStyle;
              left += sign2 * boxWidth;
              boxWidth = 0;
            }
          }
          ctx.restore();
        },
        /**
         * This function try to patch the missing gradientTransform on canvas gradients.
         * transforming a context to transform the gradient, is going to transform the stroke too.
         * we want to transform the gradient but not the stroke operation, so we create
         * a transformed gradient on a pattern and then we use the pattern instead of the gradient.
         * this method has drawbacks: is slow, is in low resolution, needs a patch for when the size
         * is limited.
         * @private
         * @param {fabric.Gradient} filler a fabric gradient instance
         * @return {CanvasPattern} a pattern to use as fill/stroke style
         */
        _applyPatternGradientTransformText: function(filler) {
          var pCanvas = fabric22.util.createCanvasElement(), pCtx, width = this.width + this.strokeWidth, height = this.height + this.strokeWidth;
          pCanvas.width = width;
          pCanvas.height = height;
          pCtx = pCanvas.getContext("2d");
          pCtx.beginPath();
          pCtx.moveTo(0, 0);
          pCtx.lineTo(width, 0);
          pCtx.lineTo(width, height);
          pCtx.lineTo(0, height);
          pCtx.closePath();
          pCtx.translate(width / 2, height / 2);
          pCtx.fillStyle = filler.toLive(pCtx);
          this._applyPatternGradientTransform(pCtx, filler);
          pCtx.fill();
          return pCtx.createPattern(pCanvas, "no-repeat");
        },
        handleFiller: function(ctx, property, filler) {
          var offsetX, offsetY;
          if (filler.toLive) {
            if (filler.gradientUnits === "percentage" || filler.gradientTransform || filler.patternTransform) {
              offsetX = -this.width / 2;
              offsetY = -this.height / 2;
              ctx.translate(offsetX, offsetY);
              ctx[property] = this._applyPatternGradientTransformText(filler);
              return { offsetX, offsetY };
            } else {
              ctx[property] = filler.toLive(ctx, this);
              return this._applyPatternGradientTransform(ctx, filler);
            }
          } else {
            ctx[property] = filler;
          }
          return { offsetX: 0, offsetY: 0 };
        },
        _setStrokeStyles: function(ctx, decl) {
          ctx.lineWidth = decl.strokeWidth;
          ctx.lineCap = this.strokeLineCap;
          ctx.lineDashOffset = this.strokeDashOffset;
          ctx.lineJoin = this.strokeLineJoin;
          ctx.miterLimit = this.strokeMiterLimit;
          return this.handleFiller(ctx, "strokeStyle", decl.stroke);
        },
        _setFillStyles: function(ctx, decl) {
          return this.handleFiller(ctx, "fillStyle", decl.fill);
        },
        /**
         * @private
         * @param {String} method
         * @param {CanvasRenderingContext2D} ctx Context to render on
         * @param {Number} lineIndex
         * @param {Number} charIndex
         * @param {String} _char
         * @param {Number} left Left coordinate
         * @param {Number} top Top coordinate
         * @param {Number} lineHeight Height of the line
         */
        _renderChar: function(method, ctx, lineIndex, charIndex, _char, left, top) {
          var decl = this._getStyleDeclaration(lineIndex, charIndex), fullDecl = this.getCompleteStyleDeclaration(lineIndex, charIndex), shouldFill = method === "fillText" && fullDecl.fill, shouldStroke = method === "strokeText" && fullDecl.stroke && fullDecl.strokeWidth, fillOffsets, strokeOffsets;
          if (!shouldStroke && !shouldFill) {
            return;
          }
          ctx.save();
          shouldFill && (fillOffsets = this._setFillStyles(ctx, fullDecl));
          shouldStroke && (strokeOffsets = this._setStrokeStyles(ctx, fullDecl));
          ctx.font = this._getFontDeclaration(fullDecl);
          if (decl && decl.textBackgroundColor) {
            this._removeShadow(ctx);
          }
          if (decl && decl.deltaY) {
            top += decl.deltaY;
          }
          shouldFill && ctx.fillText(_char, left - fillOffsets.offsetX, top - fillOffsets.offsetY);
          shouldStroke && ctx.strokeText(_char, left - strokeOffsets.offsetX, top - strokeOffsets.offsetY);
          ctx.restore();
        },
        /**
         * Turns the character into a 'superior figure' (i.e. 'superscript')
         * @param {Number} start selection start
         * @param {Number} end selection end
         * @returns {fabric.Text} thisArg
         * @chainable
         */
        setSuperscript: function(start, end) {
          return this._setScript(start, end, this.superscript);
        },
        /**
         * Turns the character into an 'inferior figure' (i.e. 'subscript')
         * @param {Number} start selection start
         * @param {Number} end selection end
         * @returns {fabric.Text} thisArg
         * @chainable
         */
        setSubscript: function(start, end) {
          return this._setScript(start, end, this.subscript);
        },
        /**
         * Applies 'schema' at given position
         * @private
         * @param {Number} start selection start
         * @param {Number} end selection end
         * @param {Number} schema
         * @returns {fabric.Text} thisArg
         * @chainable
         */
        _setScript: function(start, end, schema) {
          var loc = this.get2DCursorLocation(start, true), fontSize = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, "fontSize"), dy = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, "deltaY"), style = { fontSize: fontSize * schema.size, deltaY: dy + fontSize * schema.baseline };
          this.setSelectionStyles(style, start, end);
          return this;
        },
        /**
         * @private
         * @param {Number} lineIndex index text line
         * @return {Number} Line left offset
         */
        _getLineLeftOffset: function(lineIndex) {
          var lineWidth = this.getLineWidth(lineIndex), lineDiff = this.width - lineWidth, textAlign = this.textAlign, direction = this.direction, isEndOfWrapping, leftOffset = 0, isEndOfWrapping = this.isEndOfWrapping(lineIndex);
          if (textAlign === "justify" || textAlign === "justify-center" && !isEndOfWrapping || textAlign === "justify-right" && !isEndOfWrapping || textAlign === "justify-left" && !isEndOfWrapping) {
            return 0;
          }
          if (textAlign === "center") {
            leftOffset = lineDiff / 2;
          }
          if (textAlign === "right") {
            leftOffset = lineDiff;
          }
          if (textAlign === "justify-center") {
            leftOffset = lineDiff / 2;
          }
          if (textAlign === "justify-right") {
            leftOffset = lineDiff;
          }
          if (direction === "rtl") {
            leftOffset -= lineDiff;
          }
          return leftOffset;
        },
        /**
         * @private
         */
        _clearCache: function() {
          this.__lineWidths = [];
          this.__lineHeights = [];
          this.__charBounds = [];
        },
        /**
         * @private
         */
        _shouldClearDimensionCache: function() {
          var shouldClear = this._forceClearCache;
          shouldClear || (shouldClear = this.hasStateChanged("_dimensionAffectingProps"));
          if (shouldClear) {
            this.dirty = true;
            this._forceClearCache = false;
          }
          return shouldClear;
        },
        /**
         * Measure a single line given its index. Used to calculate the initial
         * text bounding box. The values are calculated and stored in __lineWidths cache.
         * @private
         * @param {Number} lineIndex line number
         * @return {Number} Line width
         */
        getLineWidth: function(lineIndex) {
          if (this.__lineWidths[lineIndex] !== void 0) {
            return this.__lineWidths[lineIndex];
          }
          var lineInfo = this.measureLine(lineIndex);
          var width = lineInfo.width;
          this.__lineWidths[lineIndex] = width;
          return width;
        },
        _getWidthOfCharSpacing: function() {
          if (this.charSpacing !== 0) {
            return this.fontSize * this.charSpacing / 1e3;
          }
          return 0;
        },
        /**
         * Retrieves the value of property at given character position
         * @param {Number} lineIndex the line number
         * @param {Number} charIndex the character number
         * @param {String} property the property name
         * @returns the value of 'property'
         */
        getValueOfPropertyAt: function(lineIndex, charIndex, property) {
          var charStyle = this._getStyleDeclaration(lineIndex, charIndex);
          if (charStyle && typeof charStyle[property] !== "undefined") {
            return charStyle[property];
          }
          return this[property];
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _renderTextDecoration: function(ctx, type) {
          if (!this[type] && !this.styleHas(type)) {
            return;
          }
          var heightOfLine, size, _size, lineLeftOffset, dy, _dy, line, lastDecoration, leftOffset = this._getLeftOffset(), topOffset = this._getTopOffset(), top, boxStart, boxWidth, charBox, currentDecoration, maxHeight, currentFill, lastFill, path = this.path, charSpacing = this._getWidthOfCharSpacing(), offsetY = this.offsets[type];
          for (var i = 0, len = this._textLines.length; i < len; i++) {
            heightOfLine = this.getHeightOfLine(i);
            if (!this[type] && !this.styleHas(type, i)) {
              topOffset += heightOfLine;
              continue;
            }
            line = this._textLines[i];
            maxHeight = heightOfLine / this.lineHeight;
            lineLeftOffset = this._getLineLeftOffset(i);
            boxStart = 0;
            boxWidth = 0;
            lastDecoration = this.getValueOfPropertyAt(i, 0, type);
            lastFill = this.getValueOfPropertyAt(i, 0, "fill");
            top = topOffset + maxHeight * (1 - this._fontSizeFraction);
            size = this.getHeightOfChar(i, 0);
            dy = this.getValueOfPropertyAt(i, 0, "deltaY");
            for (var j = 0, jlen = line.length; j < jlen; j++) {
              charBox = this.__charBounds[i][j];
              currentDecoration = this.getValueOfPropertyAt(i, j, type);
              currentFill = this.getValueOfPropertyAt(i, j, "fill");
              _size = this.getHeightOfChar(i, j);
              _dy = this.getValueOfPropertyAt(i, j, "deltaY");
              if (path && currentDecoration && currentFill) {
                ctx.save();
                ctx.fillStyle = lastFill;
                ctx.translate(charBox.renderLeft, charBox.renderTop);
                ctx.rotate(charBox.angle);
                ctx.fillRect(
                  -charBox.kernedWidth / 2,
                  offsetY * _size + _dy,
                  charBox.kernedWidth,
                  this.fontSize / 15
                );
                ctx.restore();
              } else if ((currentDecoration !== lastDecoration || currentFill !== lastFill || _size !== size || _dy !== dy) && boxWidth > 0) {
                var drawStart = leftOffset + lineLeftOffset + boxStart;
                if (this.direction === "rtl") {
                  drawStart = this.width - drawStart - boxWidth;
                }
                if (lastDecoration && lastFill) {
                  ctx.fillStyle = lastFill;
                  ctx.fillRect(
                    drawStart,
                    top + offsetY * size + dy,
                    boxWidth,
                    this.fontSize / 15
                  );
                }
                boxStart = charBox.left;
                boxWidth = charBox.width;
                lastDecoration = currentDecoration;
                lastFill = currentFill;
                size = _size;
                dy = _dy;
              } else {
                boxWidth += charBox.kernedWidth;
              }
            }
            var drawStart = leftOffset + lineLeftOffset + boxStart;
            if (this.direction === "rtl") {
              drawStart = this.width - drawStart - boxWidth;
            }
            ctx.fillStyle = currentFill;
            currentDecoration && currentFill && ctx.fillRect(
              drawStart,
              top + offsetY * size + dy,
              boxWidth - charSpacing,
              this.fontSize / 15
            );
            topOffset += heightOfLine;
          }
          this._removeShadow(ctx);
        },
        /**
         * return font declaration string for canvas context
         * @param {Object} [styleObject] object
         * @returns {String} font declaration formatted for canvas context.
         */
        _getFontDeclaration: function(styleObject, forMeasuring) {
          var style = styleObject || this, family = this.fontFamily, fontIsGeneric = fabric22.Text.genericFonts.indexOf(family.toLowerCase()) > -1;
          var fontFamily = family === void 0 || family.indexOf("'") > -1 || family.indexOf(",") > -1 || family.indexOf('"') > -1 || fontIsGeneric ? style.fontFamily : '"' + style.fontFamily + '"';
          return [
            // node-canvas needs "weight style", while browsers need "style weight"
            // verify if this can be fixed in JSDOM
            fabric22.isLikelyNode ? style.fontWeight : style.fontStyle,
            fabric22.isLikelyNode ? style.fontStyle : style.fontWeight,
            forMeasuring ? this.CACHE_FONT_SIZE + "px" : style.fontSize + "px",
            fontFamily
          ].join(" ");
        },
        /**
         * Renders text instance on a specified context
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        render: function(ctx) {
          if (!this.visible) {
            return;
          }
          if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) {
            return;
          }
          if (this._shouldClearDimensionCache()) {
            this.initDimensions();
          }
          this.callSuper("render", ctx);
        },
        /**
         * Returns the text as an array of lines.
         * @param {String} text text to split
         * @returns {Array} Lines in the text
         */
        _splitTextIntoLines: function(text) {
          var lines = text.split(this._reNewline), newLines = new Array(lines.length), newLine = ["\n"], newText = [];
          for (var i = 0; i < lines.length; i++) {
            newLines[i] = fabric22.util.string.graphemeSplit(lines[i]);
            newText = newText.concat(newLines[i], newLine);
          }
          newText.pop();
          return { _unwrappedLines: newLines, lines, graphemeText: newText, graphemeLines: newLines };
        },
        /**
         * Returns object representation of an instance
         * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
         * @return {Object} Object representation of an instance
         */
        toObject: function(propertiesToInclude) {
          var allProperties = additionalProps.concat(propertiesToInclude);
          var obj = this.callSuper("toObject", allProperties);
          obj.styles = fabric22.util.stylesToArray(this.styles, this.text);
          if (obj.path) {
            obj.path = this.path.toObject();
          }
          return obj;
        },
        /**
         * Sets property to a given value. When changing position/dimension -related properties (left, top, scale, angle, etc.) `set` does not update position of object's borders/controls. If you need to update those, call `setCoords()`.
         * @param {String|Object} key Property name or object (if object, iterate over the object properties)
         * @param {Object|Function} value Property value (if function, the value is passed into it and its return value is used as a new one)
         * @return {fabric.Object} thisArg
         * @chainable
         */
        set: function(key, value) {
          this.callSuper("set", key, value);
          var needsDims = false;
          var isAddingPath = false;
          if (typeof key === "object") {
            for (var _key in key) {
              if (_key === "path") {
                this.setPathInfo();
              }
              needsDims = needsDims || this._dimensionAffectingProps.indexOf(_key) !== -1;
              isAddingPath = isAddingPath || _key === "path";
            }
          } else {
            needsDims = this._dimensionAffectingProps.indexOf(key) !== -1;
            isAddingPath = key === "path";
          }
          if (isAddingPath) {
            this.setPathInfo();
          }
          if (needsDims) {
            this.initDimensions();
            this.setCoords();
          }
          return this;
        },
        /**
         * Returns complexity of an instance
         * @return {Number} complexity
         */
        complexity: function() {
          return 1;
        }
      }
    );
    fabric22.Text.ATTRIBUTE_NAMES = fabric22.SHARED_ATTRIBUTES.concat(
      "x y dx dy font-family font-style font-weight font-size letter-spacing text-decoration text-anchor".split(" ")
    );
    fabric22.Text.DEFAULT_SVG_FONT_SIZE = 16;
    fabric22.Text.fromElement = function(element, callback, options) {
      if (!element) {
        return callback(null);
      }
      var parsedAttributes = fabric22.parseAttributes(element, fabric22.Text.ATTRIBUTE_NAMES), parsedAnchor = parsedAttributes.textAnchor || "left";
      options = fabric22.util.object.extend(options ? clone2(options) : {}, parsedAttributes);
      options.top = options.top || 0;
      options.left = options.left || 0;
      if (parsedAttributes.textDecoration) {
        var textDecoration = parsedAttributes.textDecoration;
        if (textDecoration.indexOf("underline") !== -1) {
          options.underline = true;
        }
        if (textDecoration.indexOf("overline") !== -1) {
          options.overline = true;
        }
        if (textDecoration.indexOf("line-through") !== -1) {
          options.linethrough = true;
        }
        delete options.textDecoration;
      }
      if ("dx" in parsedAttributes) {
        options.left += parsedAttributes.dx;
      }
      if ("dy" in parsedAttributes) {
        options.top += parsedAttributes.dy;
      }
      if (!("fontSize" in options)) {
        options.fontSize = fabric22.Text.DEFAULT_SVG_FONT_SIZE;
      }
      var textContent = "";
      if (!("textContent" in element)) {
        if ("firstChild" in element && element.firstChild !== null) {
          if ("data" in element.firstChild && element.firstChild.data !== null) {
            textContent = element.firstChild.data;
          }
        }
      } else {
        textContent = element.textContent;
      }
      textContent = textContent.replace(/^\s+|\s+$|\n+/g, "").replace(/\s+/g, " ");
      var originalStrokeWidth = options.strokeWidth;
      options.strokeWidth = 0;
      var text = new fabric22.Text(textContent, options), textHeightScaleFactor = text.getScaledHeight() / text.height, lineHeightDiff = (text.height + text.strokeWidth) * text.lineHeight - text.height, scaledDiff = lineHeightDiff * textHeightScaleFactor, textHeight = text.getScaledHeight() + scaledDiff, offX = 0;
      if (parsedAnchor === "center") {
        offX = text.getScaledWidth() / 2;
      }
      if (parsedAnchor === "right") {
        offX = text.getScaledWidth();
      }
      text.set({
        left: text.left - offX,
        top: text.top - (textHeight - text.fontSize * (0.07 + text._fontSizeFraction)) / text.lineHeight,
        strokeWidth: typeof originalStrokeWidth !== "undefined" ? originalStrokeWidth : 1
      });
      callback(text);
    };
    fabric22.Text.fromObject = function(object, callback) {
      var objectCopy = clone2(object), path = object.path;
      delete objectCopy.path;
      return fabric22.Object._fromObject("Text", objectCopy, function(textInstance) {
        textInstance.styles = fabric22.util.stylesFromArray(object.styles, object.text);
        if (path) {
          fabric22.Object._fromObject("Path", path, function(pathInstance) {
            textInstance.set("path", pathInstance);
            callback(textInstance);
          }, "path");
        } else {
          callback(textInstance);
        }
      }, "text");
    };
    fabric22.Text.genericFonts = ["sans-serif", "serif", "cursive", "fantasy", "monospace"];
    fabric22.util.createAccessors && fabric22.util.createAccessors(fabric22.Text);
  })(exports);
  (function() {
    fabric2.util.object.extend(
      fabric2.Text.prototype,
      /** @lends fabric.Text.prototype */
      {
        /**
         * Returns true if object has no styling or no styling in a line
         * @param {Number} lineIndex , lineIndex is on wrapped lines.
         * @return {Boolean}
         */
        isEmptyStyles: function(lineIndex) {
          if (!this.styles) {
            return true;
          }
          if (typeof lineIndex !== "undefined" && !this.styles[lineIndex]) {
            return true;
          }
          var obj = typeof lineIndex === "undefined" ? this.styles : { line: this.styles[lineIndex] };
          for (var p1 in obj) {
            for (var p2 in obj[p1]) {
              for (var p3 in obj[p1][p2]) {
                return false;
              }
            }
          }
          return true;
        },
        /**
         * Returns true if object has a style property or has it ina specified line
         * This function is used to detect if a text will use a particular property or not.
         * @param {String} property to check for
         * @param {Number} lineIndex to check the style on
         * @return {Boolean}
         */
        styleHas: function(property, lineIndex) {
          if (!this.styles || !property || property === "") {
            return false;
          }
          if (typeof lineIndex !== "undefined" && !this.styles[lineIndex]) {
            return false;
          }
          var obj = typeof lineIndex === "undefined" ? this.styles : { 0: this.styles[lineIndex] };
          for (var p1 in obj) {
            for (var p2 in obj[p1]) {
              if (typeof obj[p1][p2][property] !== "undefined") {
                return true;
              }
            }
          }
          return false;
        },
        /**
         * Check if characters in a text have a value for a property
         * whose value matches the textbox's value for that property.  If so,
         * the character-level property is deleted.  If the character
         * has no other properties, then it is also deleted.  Finally,
         * if the line containing that character has no other characters
         * then it also is deleted.
         *
         * @param {string} property The property to compare between characters and text.
         */
        cleanStyle: function(property) {
          if (!this.styles || !property || property === "") {
            return false;
          }
          var obj = this.styles, stylesCount = 0, letterCount, stylePropertyValue, allStyleObjectPropertiesMatch = true, graphemeCount = 0, styleObject;
          for (var p1 in obj) {
            letterCount = 0;
            for (var p2 in obj[p1]) {
              var styleObject = obj[p1][p2], stylePropertyHasBeenSet = styleObject.hasOwnProperty(property);
              stylesCount++;
              if (stylePropertyHasBeenSet) {
                if (!stylePropertyValue) {
                  stylePropertyValue = styleObject[property];
                } else if (styleObject[property] !== stylePropertyValue) {
                  allStyleObjectPropertiesMatch = false;
                }
                if (styleObject[property] === this[property]) {
                  delete styleObject[property];
                }
              } else {
                allStyleObjectPropertiesMatch = false;
              }
              if (Object.keys(styleObject).length !== 0) {
                letterCount++;
              } else {
                delete obj[p1][p2];
              }
            }
            if (letterCount === 0) {
              delete obj[p1];
            }
          }
          for (var i = 0; i < this._textLines.length; i++) {
            graphemeCount += this._textLines[i].length;
          }
          if (allStyleObjectPropertiesMatch && stylesCount === graphemeCount) {
            this[property] = stylePropertyValue;
            this.removeStyle(property);
          }
        },
        /**
         * Remove a style property or properties from all individual character styles
         * in a text object.  Deletes the character style object if it contains no other style
         * props.  Deletes a line style object if it contains no other character styles.
         *
         * @param {String} props The property to remove from character styles.
         */
        removeStyle: function(property) {
          if (!this.styles || !property || property === "") {
            return;
          }
          var obj = this.styles, line, lineNum, charNum;
          for (lineNum in obj) {
            line = obj[lineNum];
            for (charNum in line) {
              delete line[charNum][property];
              if (Object.keys(line[charNum]).length === 0) {
                delete line[charNum];
              }
            }
            if (Object.keys(line).length === 0) {
              delete obj[lineNum];
            }
          }
        },
        /**
         * @private
         */
        _extendStyles: function(index, styles) {
          var loc = this.get2DCursorLocation(index);
          if (!this._getLineStyle(loc.lineIndex)) {
            this._setLineStyle(loc.lineIndex);
          }
          if (!this._getStyleDeclaration(loc.lineIndex, loc.charIndex)) {
            this._setStyleDeclaration(loc.lineIndex, loc.charIndex, {});
          }
          fabric2.util.object.extend(this._getStyleDeclaration(loc.lineIndex, loc.charIndex), styles);
        },
        /**
         * Returns 2d representation (lineIndex and charIndex) of cursor (or selection start)
         * @param {Number} [selectionStart] Optional index. When not given, current selectionStart is used.
         * @param {Boolean} [skipWrapping] consider the location for unwrapped lines. useful to manage styles.
         */
        get2DCursorLocation: function(selectionStart, skipWrapping) {
          if (typeof selectionStart === "undefined") {
            selectionStart = this.selectionStart;
          }
          var lines = skipWrapping ? this._unwrappedTextLines : this._textLines, len = lines.length;
          for (var i = 0; i < len; i++) {
            if (selectionStart <= lines[i].length) {
              return {
                lineIndex: i,
                charIndex: selectionStart
              };
            }
            selectionStart -= lines[i].length + this.missingNewlineOffset(i);
          }
          return {
            lineIndex: i - 1,
            charIndex: lines[i - 1].length < selectionStart ? lines[i - 1].length : selectionStart
          };
        },
        /**
         * Gets style of a current selection/cursor (at the start position)
         * if startIndex or endIndex are not provided, selectionStart or selectionEnd will be used.
         * @param {Number} [startIndex] Start index to get styles at
         * @param {Number} [endIndex] End index to get styles at, if not specified selectionEnd or startIndex + 1
         * @param {Boolean} [complete] get full style or not
         * @return {Array} styles an array with one, zero or more Style objects
         */
        getSelectionStyles: function(startIndex, endIndex, complete) {
          if (typeof startIndex === "undefined") {
            startIndex = this.selectionStart || 0;
          }
          if (typeof endIndex === "undefined") {
            endIndex = this.selectionEnd || startIndex;
          }
          var styles = [];
          for (var i = startIndex; i < endIndex; i++) {
            styles.push(this.getStyleAtPosition(i, complete));
          }
          return styles;
        },
        /**
         * Gets style of a current selection/cursor position
         * @param {Number} position  to get styles at
         * @param {Boolean} [complete] full style if true
         * @return {Object} style Style object at a specified index
         * @private
         */
        getStyleAtPosition: function(position, complete) {
          var loc = this.get2DCursorLocation(position), style = complete ? this.getCompleteStyleDeclaration(loc.lineIndex, loc.charIndex) : this._getStyleDeclaration(loc.lineIndex, loc.charIndex);
          return style || {};
        },
        /**
         * Sets style of a current selection, if no selection exist, do not set anything.
         * @param {Object} [styles] Styles object
         * @param {Number} [startIndex] Start index to get styles at
         * @param {Number} [endIndex] End index to get styles at, if not specified selectionEnd or startIndex + 1
         * @return {fabric.IText} thisArg
         * @chainable
         */
        setSelectionStyles: function(styles, startIndex, endIndex) {
          if (typeof startIndex === "undefined") {
            startIndex = this.selectionStart || 0;
          }
          if (typeof endIndex === "undefined") {
            endIndex = this.selectionEnd || startIndex;
          }
          for (var i = startIndex; i < endIndex; i++) {
            this._extendStyles(i, styles);
          }
          this._forceClearCache = true;
          return this;
        },
        /**
         * get the reference, not a clone, of the style object for a given character
         * @param {Number} lineIndex
         * @param {Number} charIndex
         * @return {Object} style object
         */
        _getStyleDeclaration: function(lineIndex, charIndex) {
          var lineStyle = this.styles && this.styles[lineIndex];
          if (!lineStyle) {
            return null;
          }
          return lineStyle[charIndex];
        },
        /**
         * return a new object that contains all the style property for a character
         * the object returned is newly created
         * @param {Number} lineIndex of the line where the character is
         * @param {Number} charIndex position of the character on the line
         * @return {Object} style object
         */
        getCompleteStyleDeclaration: function(lineIndex, charIndex) {
          var style = this._getStyleDeclaration(lineIndex, charIndex) || {}, styleObject = {}, prop;
          for (var i = 0; i < this._styleProperties.length; i++) {
            prop = this._styleProperties[i];
            styleObject[prop] = typeof style[prop] === "undefined" ? this[prop] : style[prop];
          }
          return styleObject;
        },
        /**
         * @param {Number} lineIndex
         * @param {Number} charIndex
         * @param {Object} style
         * @private
         */
        _setStyleDeclaration: function(lineIndex, charIndex, style) {
          this.styles[lineIndex][charIndex] = style;
        },
        /**
         *
         * @param {Number} lineIndex
         * @param {Number} charIndex
         * @private
         */
        _deleteStyleDeclaration: function(lineIndex, charIndex) {
          delete this.styles[lineIndex][charIndex];
        },
        /**
         * @param {Number} lineIndex
         * @return {Boolean} if the line exists or not
         * @private
         */
        _getLineStyle: function(lineIndex) {
          return !!this.styles[lineIndex];
        },
        /**
         * Set the line style to an empty object so that is initialized
         * @param {Number} lineIndex
         * @private
         */
        _setLineStyle: function(lineIndex) {
          this.styles[lineIndex] = {};
        },
        /**
         * @param {Number} lineIndex
         * @private
         */
        _deleteLineStyle: function(lineIndex) {
          delete this.styles[lineIndex];
        }
      }
    );
  })();
  (function() {
    function parseDecoration(object) {
      if (object.textDecoration) {
        object.textDecoration.indexOf("underline") > -1 && (object.underline = true);
        object.textDecoration.indexOf("line-through") > -1 && (object.linethrough = true);
        object.textDecoration.indexOf("overline") > -1 && (object.overline = true);
        delete object.textDecoration;
      }
    }
    fabric2.IText = fabric2.util.createClass(
      fabric2.Text,
      fabric2.Observable,
      /** @lends fabric.IText.prototype */
      {
        /**
         * Type of an object
         * @type String
         * @default
         */
        type: "i-text",
        /**
         * Index where text selection starts (or where cursor is when there is no selection)
         * @type Number
         * @default
         */
        selectionStart: 0,
        /**
         * Index where text selection ends
         * @type Number
         * @default
         */
        selectionEnd: 0,
        /**
         * Color of text selection
         * @type String
         * @default
         */
        selectionColor: "rgba(17,119,255,0.3)",
        /**
         * Indicates whether text is in editing mode
         * @type Boolean
         * @default
         */
        isEditing: false,
        /**
         * Indicates whether a text can be edited
         * @type Boolean
         * @default
         */
        editable: true,
        /**
         * Border color of text object while it's in editing mode
         * @type String
         * @default
         */
        editingBorderColor: "rgba(102,153,255,0.25)",
        /**
         * Width of cursor (in px)
         * @type Number
         * @default
         */
        cursorWidth: 2,
        /**
         * Color of text cursor color in editing mode.
         * if not set (default) will take color from the text.
         * if set to a color value that fabric can understand, it will
         * be used instead of the color of the text at the current position.
         * @type String
         * @default
         */
        cursorColor: "",
        /**
         * Delay between cursor blink (in ms)
         * @type Number
         * @default
         */
        cursorDelay: 1e3,
        /**
         * Duration of cursor fadein (in ms)
         * @type Number
         * @default
         */
        cursorDuration: 600,
        /**
         * Indicates whether internal text char widths can be cached
         * @type Boolean
         * @default
         */
        caching: true,
        /**
         * DOM container to append the hiddenTextarea.
         * An alternative to attaching to the document.body.
         * Useful to reduce laggish redraw of the full document.body tree and
         * also with modals event capturing that won't let the textarea take focus.
         * @type HTMLElement
         * @default
         */
        hiddenTextareaContainer: null,
        /**
         * @private
         */
        _reSpace: /\s|\n/,
        /**
         * @private
         */
        _currentCursorOpacity: 0,
        /**
         * @private
         */
        _selectionDirection: null,
        /**
         * @private
         */
        _abortCursorAnimation: false,
        /**
         * @private
         */
        __widthOfSpace: [],
        /**
         * Helps determining when the text is in composition, so that the cursor
         * rendering is altered.
         */
        inCompositionMode: false,
        /**
         * Constructor
         * @param {String} text Text string
         * @param {Object} [options] Options object
         * @return {fabric.IText} thisArg
         */
        initialize: function(text, options) {
          this.callSuper("initialize", text, options);
          this.initBehavior();
        },
        /**
         * Sets selection start (left boundary of a selection)
         * @param {Number} index Index to set selection start to
         */
        setSelectionStart: function(index) {
          index = Math.max(index, 0);
          this._updateAndFire("selectionStart", index);
        },
        /**
         * Sets selection end (right boundary of a selection)
         * @param {Number} index Index to set selection end to
         */
        setSelectionEnd: function(index) {
          index = Math.min(index, this.text.length);
          this._updateAndFire("selectionEnd", index);
        },
        /**
         * @private
         * @param {String} property 'selectionStart' or 'selectionEnd'
         * @param {Number} index new position of property
         */
        _updateAndFire: function(property, index) {
          if (this[property] !== index) {
            this._fireSelectionChanged();
            this[property] = index;
          }
          this._updateTextarea();
        },
        /**
         * Fires the even of selection changed
         * @private
         */
        _fireSelectionChanged: function() {
          this.fire("selection:changed");
          this.canvas && this.canvas.fire("text:selection:changed", { target: this });
        },
        /**
         * Initialize text dimensions. Render all text on given context
         * or on a offscreen canvas to get the text width with measureText.
         * Updates this.width and this.height with the proper values.
         * Does not return dimensions.
         * @private
         */
        initDimensions: function() {
          this.isEditing && this.initDelayedCursor();
          this.clearContextTop();
          this.callSuper("initDimensions");
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        render: function(ctx) {
          this.clearContextTop();
          this.callSuper("render", ctx);
          this.cursorOffsetCache = {};
          this.renderCursorOrSelection();
        },
        /**
         * @private
         * @param {CanvasRenderingContext2D} ctx Context to render on
         */
        _render: function(ctx) {
          this.callSuper("_render", ctx);
        },
        /**
         * Prepare and clean the contextTop
         */
        clearContextTop: function(skipRestore) {
          if (!this.isEditing || !this.canvas || !this.canvas.contextTop) {
            return;
          }
          var ctx = this.canvas.contextTop, v = this.canvas.viewportTransform;
          ctx.save();
          ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
          this.transform(ctx);
          this._clearTextArea(ctx);
          skipRestore || ctx.restore();
        },
        /**
         * Renders cursor or selection (depending on what exists)
         * it does on the contextTop. If contextTop is not available, do nothing.
         */
        renderCursorOrSelection: function() {
          if (!this.isEditing || !this.canvas || !this.canvas.contextTop) {
            return;
          }
          var boundaries = this._getCursorBoundaries(), ctx = this.canvas.contextTop;
          this.clearContextTop(true);
          if (this.selectionStart === this.selectionEnd) {
            this.renderCursor(boundaries, ctx);
          } else {
            this.renderSelection(boundaries, ctx);
          }
          ctx.restore();
        },
        _clearTextArea: function(ctx) {
          var width = this.width + 4, height = this.height + 4;
          ctx.clearRect(-width / 2, -height / 2, width, height);
        },
        /**
         * Returns cursor boundaries (left, top, leftOffset, topOffset)
         * @private
         * @param {Array} chars Array of characters
         * @param {String} typeOfBoundaries
         */
        _getCursorBoundaries: function(position) {
          if (typeof position === "undefined") {
            position = this.selectionStart;
          }
          var left = this._getLeftOffset(), top = this._getTopOffset(), offsets = this._getCursorBoundariesOffsets(position);
          return {
            left,
            top,
            leftOffset: offsets.left,
            topOffset: offsets.top
          };
        },
        /**
         * @private
         */
        _getCursorBoundariesOffsets: function(position) {
          if (this.cursorOffsetCache && "top" in this.cursorOffsetCache) {
            return this.cursorOffsetCache;
          }
          var lineLeftOffset, lineIndex, charIndex, topOffset = 0, leftOffset = 0, boundaries, cursorPosition = this.get2DCursorLocation(position);
          charIndex = cursorPosition.charIndex;
          lineIndex = cursorPosition.lineIndex;
          for (var i = 0; i < lineIndex; i++) {
            topOffset += this.getHeightOfLine(i);
          }
          lineLeftOffset = this._getLineLeftOffset(lineIndex);
          var bound = this.__charBounds[lineIndex][charIndex];
          bound && (leftOffset = bound.left);
          if (this.charSpacing !== 0 && charIndex === this._textLines[lineIndex].length) {
            leftOffset -= this._getWidthOfCharSpacing();
          }
          boundaries = {
            top: topOffset,
            left: lineLeftOffset + (leftOffset > 0 ? leftOffset : 0)
          };
          if (this.direction === "rtl") {
            boundaries.left *= -1;
          }
          this.cursorOffsetCache = boundaries;
          return this.cursorOffsetCache;
        },
        /**
         * Renders cursor
         * @param {Object} boundaries
         * @param {CanvasRenderingContext2D} ctx transformed context to draw on
         */
        renderCursor: function(boundaries, ctx) {
          var cursorLocation = this.get2DCursorLocation(), lineIndex = cursorLocation.lineIndex, charIndex = cursorLocation.charIndex > 0 ? cursorLocation.charIndex - 1 : 0, charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, "fontSize"), multiplier = this.scaleX * this.canvas.getZoom(), cursorWidth = this.cursorWidth / multiplier, topOffset = boundaries.topOffset, dy = this.getValueOfPropertyAt(lineIndex, charIndex, "deltaY");
          topOffset += (1 - this._fontSizeFraction) * this.getHeightOfLine(lineIndex) / this.lineHeight - charHeight * (1 - this._fontSizeFraction);
          if (this.inCompositionMode) {
            this.renderSelection(boundaries, ctx);
          }
          ctx.fillStyle = this.cursorColor || this.getValueOfPropertyAt(lineIndex, charIndex, "fill");
          ctx.globalAlpha = this.__isMousedown ? 1 : this._currentCursorOpacity;
          ctx.fillRect(
            boundaries.left + boundaries.leftOffset - cursorWidth / 2,
            topOffset + boundaries.top + dy,
            cursorWidth,
            charHeight
          );
        },
        /**
         * Renders text selection
         * @param {Object} boundaries Object with left/top/leftOffset/topOffset
         * @param {CanvasRenderingContext2D} ctx transformed context to draw on
         */
        renderSelection: function(boundaries, ctx) {
          var selectionStart = this.inCompositionMode ? this.hiddenTextarea.selectionStart : this.selectionStart, selectionEnd = this.inCompositionMode ? this.hiddenTextarea.selectionEnd : this.selectionEnd, isJustify = this.textAlign.indexOf("justify") !== -1, start = this.get2DCursorLocation(selectionStart), end = this.get2DCursorLocation(selectionEnd), startLine = start.lineIndex, endLine = end.lineIndex, startChar = start.charIndex < 0 ? 0 : start.charIndex, endChar = end.charIndex < 0 ? 0 : end.charIndex;
          for (var i = startLine; i <= endLine; i++) {
            var lineOffset = this._getLineLeftOffset(i) || 0, lineHeight = this.getHeightOfLine(i), realLineHeight = 0, boxStart = 0, boxEnd = 0;
            if (i === startLine) {
              boxStart = this.__charBounds[startLine][startChar].left;
            }
            if (i >= startLine && i < endLine) {
              boxEnd = isJustify && !this.isEndOfWrapping(i) ? this.width : this.getLineWidth(i) || 5;
            } else if (i === endLine) {
              if (endChar === 0) {
                boxEnd = this.__charBounds[endLine][endChar].left;
              } else {
                var charSpacing = this._getWidthOfCharSpacing();
                boxEnd = this.__charBounds[endLine][endChar - 1].left + this.__charBounds[endLine][endChar - 1].width - charSpacing;
              }
            }
            realLineHeight = lineHeight;
            if (this.lineHeight < 1 || i === endLine && this.lineHeight > 1) {
              lineHeight /= this.lineHeight;
            }
            var drawStart = boundaries.left + lineOffset + boxStart, drawWidth = boxEnd - boxStart, drawHeight = lineHeight, extraTop = 0;
            if (this.inCompositionMode) {
              ctx.fillStyle = this.compositionColor || "black";
              drawHeight = 1;
              extraTop = lineHeight;
            } else {
              ctx.fillStyle = this.selectionColor;
            }
            if (this.direction === "rtl") {
              drawStart = this.width - drawStart - drawWidth;
            }
            ctx.fillRect(
              drawStart,
              boundaries.top + boundaries.topOffset + extraTop,
              drawWidth,
              drawHeight
            );
            boundaries.topOffset += realLineHeight;
          }
        },
        /**
         * High level function to know the height of the cursor.
         * the currentChar is the one that precedes the cursor
         * Returns fontSize of char at the current cursor
         * Unused from the library, is for the end user
         * @return {Number} Character font size
         */
        getCurrentCharFontSize: function() {
          var cp = this._getCurrentCharIndex();
          return this.getValueOfPropertyAt(cp.l, cp.c, "fontSize");
        },
        /**
         * High level function to know the color of the cursor.
         * the currentChar is the one that precedes the cursor
         * Returns color (fill) of char at the current cursor
         * if the text object has a pattern or gradient for filler, it will return that.
         * Unused by the library, is for the end user
         * @return {String | fabric.Gradient | fabric.Pattern} Character color (fill)
         */
        getCurrentCharColor: function() {
          var cp = this._getCurrentCharIndex();
          return this.getValueOfPropertyAt(cp.l, cp.c, "fill");
        },
        /**
         * Returns the cursor position for the getCurrent.. functions
         * @private
         */
        _getCurrentCharIndex: function() {
          var cursorPosition = this.get2DCursorLocation(this.selectionStart, true), charIndex = cursorPosition.charIndex > 0 ? cursorPosition.charIndex - 1 : 0;
          return { l: cursorPosition.lineIndex, c: charIndex };
        }
      }
    );
    fabric2.IText.fromObject = function(object, callback) {
      var styles = fabric2.util.stylesFromArray(object.styles, object.text);
      var objCopy = Object.assign({}, object, { styles });
      parseDecoration(objCopy);
      if (objCopy.styles) {
        for (var i in objCopy.styles) {
          for (var j in objCopy.styles[i]) {
            parseDecoration(objCopy.styles[i][j]);
          }
        }
      }
      fabric2.Object._fromObject("IText", objCopy, callback, "text");
    };
  })();
  (function() {
    var clone2 = fabric2.util.object.clone;
    fabric2.util.object.extend(
      fabric2.IText.prototype,
      /** @lends fabric.IText.prototype */
      {
        /**
         * Initializes all the interactive behavior of IText
         */
        initBehavior: function() {
          this.initAddedHandler();
          this.initRemovedHandler();
          this.initCursorSelectionHandlers();
          this.initDoubleClickSimulation();
          this.mouseMoveHandler = this.mouseMoveHandler.bind(this);
        },
        onDeselect: function() {
          this.isEditing && this.exitEditing();
          this.selected = false;
        },
        /**
         * Initializes "added" event handler
         */
        initAddedHandler: function() {
          var _this = this;
          this.on("added", function() {
            var canvas = _this.canvas;
            if (canvas) {
              if (!canvas._hasITextHandlers) {
                canvas._hasITextHandlers = true;
                _this._initCanvasHandlers(canvas);
              }
              canvas._iTextInstances = canvas._iTextInstances || [];
              canvas._iTextInstances.push(_this);
            }
          });
        },
        initRemovedHandler: function() {
          var _this = this;
          this.on("removed", function() {
            var canvas = _this.canvas;
            if (canvas) {
              canvas._iTextInstances = canvas._iTextInstances || [];
              fabric2.util.removeFromArray(canvas._iTextInstances, _this);
              if (canvas._iTextInstances.length === 0) {
                canvas._hasITextHandlers = false;
                _this._removeCanvasHandlers(canvas);
              }
            }
          });
        },
        /**
         * register canvas event to manage exiting on other instances
         * @private
         */
        _initCanvasHandlers: function(canvas) {
          canvas._mouseUpITextHandler = function() {
            if (canvas._iTextInstances) {
              canvas._iTextInstances.forEach(function(obj) {
                obj.__isMousedown = false;
              });
            }
          };
          canvas.on("mouse:up", canvas._mouseUpITextHandler);
        },
        /**
         * remove canvas event to manage exiting on other instances
         * @private
         */
        _removeCanvasHandlers: function(canvas) {
          canvas.off("mouse:up", canvas._mouseUpITextHandler);
        },
        /**
         * @private
         */
        _tick: function() {
          this._currentTickState = this._animateCursor(this, 1, this.cursorDuration, "_onTickComplete");
        },
        /**
         * @private
         */
        _animateCursor: function(obj, targetOpacity, duration, completeMethod) {
          var tickState;
          tickState = {
            isAborted: false,
            abort: function() {
              this.isAborted = true;
            }
          };
          obj.animate("_currentCursorOpacity", targetOpacity, {
            duration,
            onComplete: function() {
              if (!tickState.isAborted) {
                obj[completeMethod]();
              }
            },
            onChange: function() {
              if (obj.canvas && obj.selectionStart === obj.selectionEnd) {
                obj.renderCursorOrSelection();
              }
            },
            abort: function() {
              return tickState.isAborted;
            }
          });
          return tickState;
        },
        /**
         * @private
         */
        _onTickComplete: function() {
          var _this = this;
          if (this._cursorTimeout1) {
            clearTimeout(this._cursorTimeout1);
          }
          this._cursorTimeout1 = setTimeout(function() {
            _this._currentTickCompleteState = _this._animateCursor(_this, 0, this.cursorDuration / 2, "_tick");
          }, 100);
        },
        /**
         * Initializes delayed cursor
         */
        initDelayedCursor: function(restart) {
          var _this = this, delay2 = restart ? 0 : this.cursorDelay;
          this.abortCursorAnimation();
          this._currentCursorOpacity = 1;
          this._cursorTimeout2 = setTimeout(function() {
            _this._tick();
          }, delay2);
        },
        /**
         * Aborts cursor animation and clears all timeouts
         */
        abortCursorAnimation: function() {
          var shouldClear = this._currentTickState || this._currentTickCompleteState, canvas = this.canvas;
          this._currentTickState && this._currentTickState.abort();
          this._currentTickCompleteState && this._currentTickCompleteState.abort();
          clearTimeout(this._cursorTimeout1);
          clearTimeout(this._cursorTimeout2);
          this._currentCursorOpacity = 0;
          if (shouldClear && canvas) {
            canvas.clearContext(canvas.contextTop || canvas.contextContainer);
          }
        },
        /**
         * Selects entire text
         * @return {fabric.IText} thisArg
         * @chainable
         */
        selectAll: function() {
          this.selectionStart = 0;
          this.selectionEnd = this._text.length;
          this._fireSelectionChanged();
          this._updateTextarea();
          return this;
        },
        /**
         * Returns selected text
         * @return {String}
         */
        getSelectedText: function() {
          return this._text.slice(this.selectionStart, this.selectionEnd).join("");
        },
        /**
         * Find new selection index representing start of current word according to current selection index
         * @param {Number} startFrom Current selection index
         * @return {Number} New selection index
         */
        findWordBoundaryLeft: function(startFrom) {
          var offset = 0, index = startFrom - 1;
          if (this._reSpace.test(this._text[index])) {
            while (this._reSpace.test(this._text[index])) {
              offset++;
              index--;
            }
          }
          while (/\S/.test(this._text[index]) && index > -1) {
            offset++;
            index--;
          }
          return startFrom - offset;
        },
        /**
         * Find new selection index representing end of current word according to current selection index
         * @param {Number} startFrom Current selection index
         * @return {Number} New selection index
         */
        findWordBoundaryRight: function(startFrom) {
          var offset = 0, index = startFrom;
          if (this._reSpace.test(this._text[index])) {
            while (this._reSpace.test(this._text[index])) {
              offset++;
              index++;
            }
          }
          while (/\S/.test(this._text[index]) && index < this._text.length) {
            offset++;
            index++;
          }
          return startFrom + offset;
        },
        /**
         * Find new selection index representing start of current line according to current selection index
         * @param {Number} startFrom Current selection index
         * @return {Number} New selection index
         */
        findLineBoundaryLeft: function(startFrom) {
          var offset = 0, index = startFrom - 1;
          while (!/\n/.test(this._text[index]) && index > -1) {
            offset++;
            index--;
          }
          return startFrom - offset;
        },
        /**
         * Find new selection index representing end of current line according to current selection index
         * @param {Number} startFrom Current selection index
         * @return {Number} New selection index
         */
        findLineBoundaryRight: function(startFrom) {
          var offset = 0, index = startFrom;
          while (!/\n/.test(this._text[index]) && index < this._text.length) {
            offset++;
            index++;
          }
          return startFrom + offset;
        },
        /**
         * Finds index corresponding to beginning or end of a word
         * @param {Number} selectionStart Index of a character
         * @param {Number} direction 1 or -1
         * @return {Number} Index of the beginning or end of a word
         */
        searchWordBoundary: function(selectionStart, direction) {
          var text = this._text, index = this._reSpace.test(text[selectionStart]) ? selectionStart - 1 : selectionStart, _char = text[index], reNonWord = fabric2.reNonWord;
          while (!reNonWord.test(_char) && index > 0 && index < text.length) {
            index += direction;
            _char = text[index];
          }
          if (reNonWord.test(_char)) {
            index += direction === 1 ? 0 : 1;
          }
          return index;
        },
        /**
         * Selects a word based on the index
         * @param {Number} selectionStart Index of a character
         */
        selectWord: function(selectionStart) {
          selectionStart = selectionStart || this.selectionStart;
          var newSelectionStart = this.searchWordBoundary(selectionStart, -1), newSelectionEnd = this.searchWordBoundary(selectionStart, 1);
          this.selectionStart = newSelectionStart;
          this.selectionEnd = newSelectionEnd;
          this._fireSelectionChanged();
          this._updateTextarea();
          this.renderCursorOrSelection();
        },
        /**
         * Selects a line based on the index
         * @param {Number} selectionStart Index of a character
         * @return {fabric.IText} thisArg
         * @chainable
         */
        selectLine: function(selectionStart) {
          selectionStart = selectionStart || this.selectionStart;
          var newSelectionStart = this.findLineBoundaryLeft(selectionStart), newSelectionEnd = this.findLineBoundaryRight(selectionStart);
          this.selectionStart = newSelectionStart;
          this.selectionEnd = newSelectionEnd;
          this._fireSelectionChanged();
          this._updateTextarea();
          return this;
        },
        /**
         * Enters editing state
         * @return {fabric.IText} thisArg
         * @chainable
         */
        enterEditing: function(e) {
          if (this.isEditing || !this.editable) {
            return;
          }
          if (this.canvas) {
            this.canvas.calcOffset();
            this.exitEditingOnOthers(this.canvas);
          }
          this.isEditing = true;
          this.initHiddenTextarea(e);
          this.hiddenTextarea.focus();
          this.hiddenTextarea.value = this.text;
          this._updateTextarea();
          this._saveEditingProps();
          this._setEditingProps();
          this._textBeforeEdit = this.text;
          this._tick();
          this.fire("editing:entered");
          this._fireSelectionChanged();
          if (!this.canvas) {
            return this;
          }
          this.canvas.fire("text:editing:entered", { target: this });
          this.initMouseMoveHandler();
          this.canvas.requestRenderAll();
          return this;
        },
        exitEditingOnOthers: function(canvas) {
          if (canvas._iTextInstances) {
            canvas._iTextInstances.forEach(function(obj) {
              obj.selected = false;
              if (obj.isEditing) {
                obj.exitEditing();
              }
            });
          }
        },
        /**
         * Initializes "mousemove" event handler
         */
        initMouseMoveHandler: function() {
          this.canvas.on("mouse:move", this.mouseMoveHandler);
        },
        /**
         * @private
         */
        mouseMoveHandler: function(options) {
          if (!this.__isMousedown || !this.isEditing) {
            return;
          }
          document.activeElement !== this.hiddenTextarea && this.hiddenTextarea.focus();
          var newSelectionStart = this.getSelectionStartFromPointer(options.e), currentStart = this.selectionStart, currentEnd = this.selectionEnd;
          if ((newSelectionStart !== this.__selectionStartOnMouseDown || currentStart === currentEnd) && (currentStart === newSelectionStart || currentEnd === newSelectionStart)) {
            return;
          }
          if (newSelectionStart > this.__selectionStartOnMouseDown) {
            this.selectionStart = this.__selectionStartOnMouseDown;
            this.selectionEnd = newSelectionStart;
          } else {
            this.selectionStart = newSelectionStart;
            this.selectionEnd = this.__selectionStartOnMouseDown;
          }
          if (this.selectionStart !== currentStart || this.selectionEnd !== currentEnd) {
            this.restartCursorIfNeeded();
            this._fireSelectionChanged();
            this._updateTextarea();
            this.renderCursorOrSelection();
          }
        },
        /**
         * @private
         */
        _setEditingProps: function() {
          this.hoverCursor = "text";
          if (this.canvas) {
            this.canvas.defaultCursor = this.canvas.moveCursor = "text";
          }
          this.borderColor = this.editingBorderColor;
          this.hasControls = this.selectable = false;
          this.lockMovementX = this.lockMovementY = true;
        },
        /**
         * convert from textarea to grapheme indexes
         */
        fromStringToGraphemeSelection: function(start, end, text) {
          var smallerTextStart = text.slice(0, start), graphemeStart = fabric2.util.string.graphemeSplit(smallerTextStart).length;
          if (start === end) {
            return { selectionStart: graphemeStart, selectionEnd: graphemeStart };
          }
          var smallerTextEnd = text.slice(start, end), graphemeEnd = fabric2.util.string.graphemeSplit(smallerTextEnd).length;
          return { selectionStart: graphemeStart, selectionEnd: graphemeStart + graphemeEnd };
        },
        /**
         * convert from fabric to textarea values
         */
        fromGraphemeToStringSelection: function(start, end, _text) {
          var smallerTextStart = _text.slice(0, start), graphemeStart = smallerTextStart.join("").length;
          if (start === end) {
            return { selectionStart: graphemeStart, selectionEnd: graphemeStart };
          }
          var smallerTextEnd = _text.slice(start, end), graphemeEnd = smallerTextEnd.join("").length;
          return { selectionStart: graphemeStart, selectionEnd: graphemeStart + graphemeEnd };
        },
        /**
         * @private
         */
        _updateTextarea: function() {
          this.cursorOffsetCache = {};
          if (!this.hiddenTextarea) {
            return;
          }
          if (!this.inCompositionMode) {
            var newSelection = this.fromGraphemeToStringSelection(this.selectionStart, this.selectionEnd, this._text);
            this.hiddenTextarea.selectionStart = newSelection.selectionStart;
            this.hiddenTextarea.selectionEnd = newSelection.selectionEnd;
          }
          this.updateTextareaPosition();
        },
        /**
         * @private
         */
        updateFromTextArea: function() {
          if (!this.hiddenTextarea) {
            return;
          }
          this.cursorOffsetCache = {};
          this.text = this.hiddenTextarea.value;
          if (this._shouldClearDimensionCache()) {
            this.initDimensions();
            this.setCoords();
          }
          var newSelection = this.fromStringToGraphemeSelection(
            this.hiddenTextarea.selectionStart,
            this.hiddenTextarea.selectionEnd,
            this.hiddenTextarea.value
          );
          this.selectionEnd = this.selectionStart = newSelection.selectionEnd;
          if (!this.inCompositionMode) {
            this.selectionStart = newSelection.selectionStart;
          }
          this.updateTextareaPosition();
        },
        /**
         * @private
         */
        updateTextareaPosition: function() {
          if (this.selectionStart === this.selectionEnd) {
            var style = this._calcTextareaPosition();
            this.hiddenTextarea.style.left = style.left;
            this.hiddenTextarea.style.top = style.top;
          }
        },
        /**
         * @private
         * @return {Object} style contains style for hiddenTextarea
         */
        _calcTextareaPosition: function() {
          if (!this.canvas) {
            return { x: 1, y: 1 };
          }
          var desiredPosition = this.inCompositionMode ? this.compositionStart : this.selectionStart, boundaries = this._getCursorBoundaries(desiredPosition), cursorLocation = this.get2DCursorLocation(desiredPosition), lineIndex = cursorLocation.lineIndex, charIndex = cursorLocation.charIndex, charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, "fontSize") * this.lineHeight, leftOffset = boundaries.leftOffset, m = this.calcTransformMatrix(), p = {
            x: boundaries.left + leftOffset,
            y: boundaries.top + boundaries.topOffset + charHeight
          }, retinaScaling = this.canvas.getRetinaScaling(), upperCanvas = this.canvas.upperCanvasEl, upperCanvasWidth = upperCanvas.width / retinaScaling, upperCanvasHeight = upperCanvas.height / retinaScaling, maxWidth = upperCanvasWidth - charHeight, maxHeight = upperCanvasHeight - charHeight, scaleX = upperCanvas.clientWidth / upperCanvasWidth, scaleY = upperCanvas.clientHeight / upperCanvasHeight;
          p = fabric2.util.transformPoint(p, m);
          p = fabric2.util.transformPoint(p, this.canvas.viewportTransform);
          p.x *= scaleX;
          p.y *= scaleY;
          if (p.x < 0) {
            p.x = 0;
          }
          if (p.x > maxWidth) {
            p.x = maxWidth;
          }
          if (p.y < 0) {
            p.y = 0;
          }
          if (p.y > maxHeight) {
            p.y = maxHeight;
          }
          p.x += this.canvas._offset.left;
          p.y += this.canvas._offset.top;
          return { left: p.x + "px", top: p.y + "px", fontSize: charHeight + "px", charHeight };
        },
        /**
         * @private
         */
        _saveEditingProps: function() {
          this._savedProps = {
            hasControls: this.hasControls,
            borderColor: this.borderColor,
            lockMovementX: this.lockMovementX,
            lockMovementY: this.lockMovementY,
            hoverCursor: this.hoverCursor,
            selectable: this.selectable,
            defaultCursor: this.canvas && this.canvas.defaultCursor,
            moveCursor: this.canvas && this.canvas.moveCursor
          };
        },
        /**
         * @private
         */
        _restoreEditingProps: function() {
          if (!this._savedProps) {
            return;
          }
          this.hoverCursor = this._savedProps.hoverCursor;
          this.hasControls = this._savedProps.hasControls;
          this.borderColor = this._savedProps.borderColor;
          this.selectable = this._savedProps.selectable;
          this.lockMovementX = this._savedProps.lockMovementX;
          this.lockMovementY = this._savedProps.lockMovementY;
          if (this.canvas) {
            this.canvas.defaultCursor = this._savedProps.defaultCursor;
            this.canvas.moveCursor = this._savedProps.moveCursor;
          }
        },
        /**
         * Exits from editing state
         * @return {fabric.IText} thisArg
         * @chainable
         */
        exitEditing: function() {
          var isTextChanged = this._textBeforeEdit !== this.text;
          var hiddenTextarea = this.hiddenTextarea;
          this.selected = false;
          this.isEditing = false;
          this.selectionEnd = this.selectionStart;
          if (hiddenTextarea) {
            hiddenTextarea.blur && hiddenTextarea.blur();
            hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
          }
          this.hiddenTextarea = null;
          this.abortCursorAnimation();
          this._restoreEditingProps();
          this._currentCursorOpacity = 0;
          if (this._shouldClearDimensionCache()) {
            this.initDimensions();
            this.setCoords();
          }
          this.fire("editing:exited");
          isTextChanged && this.fire("modified");
          if (this.canvas) {
            this.canvas.off("mouse:move", this.mouseMoveHandler);
            this.canvas.fire("text:editing:exited", { target: this });
            isTextChanged && this.canvas.fire("object:modified", { target: this });
          }
          return this;
        },
        /**
         * @private
         */
        _removeExtraneousStyles: function() {
          for (var prop in this.styles) {
            if (!this._textLines[prop]) {
              delete this.styles[prop];
            }
          }
        },
        /**
         * remove and reflow a style block from start to end.
         * @param {Number} start linear start position for removal (included in removal)
         * @param {Number} end linear end position for removal ( excluded from removal )
         */
        removeStyleFromTo: function(start, end) {
          var cursorStart = this.get2DCursorLocation(start, true), cursorEnd = this.get2DCursorLocation(end, true), lineStart = cursorStart.lineIndex, charStart = cursorStart.charIndex, lineEnd = cursorEnd.lineIndex, charEnd = cursorEnd.charIndex, i, styleObj;
          if (lineStart !== lineEnd) {
            if (this.styles[lineStart]) {
              for (i = charStart; i < this._unwrappedTextLines[lineStart].length; i++) {
                delete this.styles[lineStart][i];
              }
            }
            if (this.styles[lineEnd]) {
              for (i = charEnd; i < this._unwrappedTextLines[lineEnd].length; i++) {
                styleObj = this.styles[lineEnd][i];
                if (styleObj) {
                  this.styles[lineStart] || (this.styles[lineStart] = {});
                  this.styles[lineStart][charStart + i - charEnd] = styleObj;
                }
              }
            }
            for (i = lineStart + 1; i <= lineEnd; i++) {
              delete this.styles[i];
            }
            this.shiftLineStyles(lineEnd, lineStart - lineEnd);
          } else {
            if (this.styles[lineStart]) {
              styleObj = this.styles[lineStart];
              var diff = charEnd - charStart, numericChar, _char;
              for (i = charStart; i < charEnd; i++) {
                delete styleObj[i];
              }
              for (_char in this.styles[lineStart]) {
                numericChar = parseInt(_char, 10);
                if (numericChar >= charEnd) {
                  styleObj[numericChar - diff] = styleObj[_char];
                  delete styleObj[_char];
                }
              }
            }
          }
        },
        /**
         * Shifts line styles up or down
         * @param {Number} lineIndex Index of a line
         * @param {Number} offset Can any number?
         */
        shiftLineStyles: function(lineIndex, offset) {
          var clonedStyles = clone2(this.styles);
          for (var line in this.styles) {
            var numericLine = parseInt(line, 10);
            if (numericLine > lineIndex) {
              this.styles[numericLine + offset] = clonedStyles[numericLine];
              if (!clonedStyles[numericLine - offset]) {
                delete this.styles[numericLine];
              }
            }
          }
        },
        restartCursorIfNeeded: function() {
          if (!this._currentTickState || this._currentTickState.isAborted || !this._currentTickCompleteState || this._currentTickCompleteState.isAborted) {
            this.initDelayedCursor();
          }
        },
        /**
         * Handle insertion of more consecutive style lines for when one or more
         * newlines gets added to the text. Since current style needs to be shifted
         * first we shift the current style of the number lines needed, then we add
         * new lines from the last to the first.
         * @param {Number} lineIndex Index of a line
         * @param {Number} charIndex Index of a char
         * @param {Number} qty number of lines to add
         * @param {Array} copiedStyle Array of objects styles
         */
        insertNewlineStyleObject: function(lineIndex, charIndex, qty, copiedStyle) {
          var currentCharStyle, newLineStyles = {}, somethingAdded = false, isEndOfLine = this._unwrappedTextLines[lineIndex].length === charIndex;
          qty || (qty = 1);
          this.shiftLineStyles(lineIndex, qty);
          if (this.styles[lineIndex]) {
            currentCharStyle = this.styles[lineIndex][charIndex === 0 ? charIndex : charIndex - 1];
          }
          for (var index in this.styles[lineIndex]) {
            var numIndex = parseInt(index, 10);
            if (numIndex >= charIndex) {
              somethingAdded = true;
              newLineStyles[numIndex - charIndex] = this.styles[lineIndex][index];
              if (!(isEndOfLine && charIndex === 0)) {
                delete this.styles[lineIndex][index];
              }
            }
          }
          var styleCarriedOver = false;
          if (somethingAdded && !isEndOfLine) {
            this.styles[lineIndex + qty] = newLineStyles;
            styleCarriedOver = true;
          }
          if (styleCarriedOver) {
            qty--;
          }
          while (qty > 0) {
            if (copiedStyle && copiedStyle[qty - 1]) {
              this.styles[lineIndex + qty] = { 0: clone2(copiedStyle[qty - 1]) };
            } else if (currentCharStyle) {
              this.styles[lineIndex + qty] = { 0: clone2(currentCharStyle) };
            } else {
              delete this.styles[lineIndex + qty];
            }
            qty--;
          }
          this._forceClearCache = true;
        },
        /**
         * Inserts style object for a given line/char index
         * @param {Number} lineIndex Index of a line
         * @param {Number} charIndex Index of a char
         * @param {Number} quantity number Style object to insert, if given
         * @param {Array} copiedStyle array of style objects
         */
        insertCharStyleObject: function(lineIndex, charIndex, quantity, copiedStyle) {
          if (!this.styles) {
            this.styles = {};
          }
          var currentLineStyles = this.styles[lineIndex], currentLineStylesCloned = currentLineStyles ? clone2(currentLineStyles) : {};
          quantity || (quantity = 1);
          for (var index in currentLineStylesCloned) {
            var numericIndex = parseInt(index, 10);
            if (numericIndex >= charIndex) {
              currentLineStyles[numericIndex + quantity] = currentLineStylesCloned[numericIndex];
              if (!currentLineStylesCloned[numericIndex - quantity]) {
                delete currentLineStyles[numericIndex];
              }
            }
          }
          this._forceClearCache = true;
          if (copiedStyle) {
            while (quantity--) {
              if (!Object.keys(copiedStyle[quantity]).length) {
                continue;
              }
              if (!this.styles[lineIndex]) {
                this.styles[lineIndex] = {};
              }
              this.styles[lineIndex][charIndex + quantity] = clone2(copiedStyle[quantity]);
            }
            return;
          }
          if (!currentLineStyles) {
            return;
          }
          var newStyle = currentLineStyles[charIndex ? charIndex - 1 : 1];
          while (newStyle && quantity--) {
            this.styles[lineIndex][charIndex + quantity] = clone2(newStyle);
          }
        },
        /**
         * Inserts style object(s)
         * @param {Array} insertedText Characters at the location where style is inserted
         * @param {Number} start cursor index for inserting style
         * @param {Array} [copiedStyle] array of style objects to insert.
         */
        insertNewStyleBlock: function(insertedText, start, copiedStyle) {
          var cursorLoc = this.get2DCursorLocation(start, true), addedLines = [0], linesLength = 0;
          for (var i = 0; i < insertedText.length; i++) {
            if (insertedText[i] === "\n") {
              linesLength++;
              addedLines[linesLength] = 0;
            } else {
              addedLines[linesLength]++;
            }
          }
          if (addedLines[0] > 0) {
            this.insertCharStyleObject(cursorLoc.lineIndex, cursorLoc.charIndex, addedLines[0], copiedStyle);
            copiedStyle = copiedStyle && copiedStyle.slice(addedLines[0] + 1);
          }
          linesLength && this.insertNewlineStyleObject(
            cursorLoc.lineIndex,
            cursorLoc.charIndex + addedLines[0],
            linesLength
          );
          for (var i = 1; i < linesLength; i++) {
            if (addedLines[i] > 0) {
              this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
            } else if (copiedStyle) {
              if (this.styles[cursorLoc.lineIndex + i] && copiedStyle[0]) {
                this.styles[cursorLoc.lineIndex + i][0] = copiedStyle[0];
              }
            }
            copiedStyle = copiedStyle && copiedStyle.slice(addedLines[i] + 1);
          }
          if (addedLines[i] > 0) {
            this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
          }
        },
        /**
         * Set the selectionStart and selectionEnd according to the new position of cursor
         * mimic the key - mouse navigation when shift is pressed.
         */
        setSelectionStartEndWithShift: function(start, end, newSelection) {
          if (newSelection <= start) {
            if (end === start) {
              this._selectionDirection = "left";
            } else if (this._selectionDirection === "right") {
              this._selectionDirection = "left";
              this.selectionEnd = start;
            }
            this.selectionStart = newSelection;
          } else if (newSelection > start && newSelection < end) {
            if (this._selectionDirection === "right") {
              this.selectionEnd = newSelection;
            } else {
              this.selectionStart = newSelection;
            }
          } else {
            if (end === start) {
              this._selectionDirection = "right";
            } else if (this._selectionDirection === "left") {
              this._selectionDirection = "right";
              this.selectionStart = end;
            }
            this.selectionEnd = newSelection;
          }
        },
        setSelectionInBoundaries: function() {
          var length = this.text.length;
          if (this.selectionStart > length) {
            this.selectionStart = length;
          } else if (this.selectionStart < 0) {
            this.selectionStart = 0;
          }
          if (this.selectionEnd > length) {
            this.selectionEnd = length;
          } else if (this.selectionEnd < 0) {
            this.selectionEnd = 0;
          }
        }
      }
    );
  })();
  fabric2.util.object.extend(
    fabric2.IText.prototype,
    /** @lends fabric.IText.prototype */
    {
      /**
       * Initializes "dbclick" event handler
       */
      initDoubleClickSimulation: function() {
        this.__lastClickTime = +/* @__PURE__ */ new Date();
        this.__lastLastClickTime = +/* @__PURE__ */ new Date();
        this.__lastPointer = {};
        this.on("mousedown", this.onMouseDown);
      },
      /**
       * Default event handler to simulate triple click
       * @private
       */
      onMouseDown: function(options) {
        if (!this.canvas) {
          return;
        }
        this.__newClickTime = +/* @__PURE__ */ new Date();
        var newPointer = options.pointer;
        if (this.isTripleClick(newPointer)) {
          this.fire("tripleclick", options);
          this._stopEvent(options.e);
        }
        this.__lastLastClickTime = this.__lastClickTime;
        this.__lastClickTime = this.__newClickTime;
        this.__lastPointer = newPointer;
        this.__lastIsEditing = this.isEditing;
        this.__lastSelected = this.selected;
      },
      isTripleClick: function(newPointer) {
        return this.__newClickTime - this.__lastClickTime < 500 && this.__lastClickTime - this.__lastLastClickTime < 500 && this.__lastPointer.x === newPointer.x && this.__lastPointer.y === newPointer.y;
      },
      /**
       * @private
       */
      _stopEvent: function(e) {
        e.preventDefault && e.preventDefault();
        e.stopPropagation && e.stopPropagation();
      },
      /**
       * Initializes event handlers related to cursor or selection
       */
      initCursorSelectionHandlers: function() {
        this.initMousedownHandler();
        this.initMouseupHandler();
        this.initClicks();
      },
      /**
       * Default handler for double click, select a word
       */
      doubleClickHandler: function(options) {
        if (!this.isEditing) {
          return;
        }
        this.selectWord(this.getSelectionStartFromPointer(options.e));
      },
      /**
       * Default handler for triple click, select a line
       */
      tripleClickHandler: function(options) {
        if (!this.isEditing) {
          return;
        }
        this.selectLine(this.getSelectionStartFromPointer(options.e));
      },
      /**
       * Initializes double and triple click event handlers
       */
      initClicks: function() {
        this.on("mousedblclick", this.doubleClickHandler);
        this.on("tripleclick", this.tripleClickHandler);
      },
      /**
       * Default event handler for the basic functionalities needed on _mouseDown
       * can be overridden to do something different.
       * Scope of this implementation is: find the click position, set selectionStart
       * find selectionEnd, initialize the drawing of either cursor or selection area
       * initializing a mousedDown on a text area will cancel fabricjs knowledge of
       * current compositionMode. It will be set to false.
       */
      _mouseDownHandler: function(options) {
        if (!this.canvas || !this.editable || options.e.button && options.e.button !== 1) {
          return;
        }
        this.__isMousedown = true;
        if (this.selected) {
          this.inCompositionMode = false;
          this.setCursorByClick(options.e);
        }
        if (this.isEditing) {
          this.__selectionStartOnMouseDown = this.selectionStart;
          if (this.selectionStart === this.selectionEnd) {
            this.abortCursorAnimation();
          }
          this.renderCursorOrSelection();
        }
      },
      /**
       * Default event handler for the basic functionalities needed on mousedown:before
       * can be overridden to do something different.
       * Scope of this implementation is: verify the object is already selected when mousing down
       */
      _mouseDownHandlerBefore: function(options) {
        if (!this.canvas || !this.editable || options.e.button && options.e.button !== 1) {
          return;
        }
        this.selected = this === this.canvas._activeObject;
      },
      /**
       * Initializes "mousedown" event handler
       */
      initMousedownHandler: function() {
        this.on("mousedown", this._mouseDownHandler);
        this.on("mousedown:before", this._mouseDownHandlerBefore);
      },
      /**
       * Initializes "mouseup" event handler
       */
      initMouseupHandler: function() {
        this.on("mouseup", this.mouseUpHandler);
      },
      /**
       * standard handler for mouse up, overridable
       * @private
       */
      mouseUpHandler: function(options) {
        this.__isMousedown = false;
        if (!this.editable || this.group || options.transform && options.transform.actionPerformed || options.e.button && options.e.button !== 1) {
          return;
        }
        if (this.canvas) {
          var currentActive = this.canvas._activeObject;
          if (currentActive && currentActive !== this) {
            return;
          }
        }
        if (this.__lastSelected && !this.__corner) {
          this.selected = false;
          this.__lastSelected = false;
          this.enterEditing(options.e);
          if (this.selectionStart === this.selectionEnd) {
            this.initDelayedCursor(true);
          } else {
            this.renderCursorOrSelection();
          }
        } else {
          this.selected = true;
        }
      },
      /**
       * Changes cursor location in a text depending on passed pointer (x/y) object
       * @param {Event} e Event object
       */
      setCursorByClick: function(e) {
        var newSelection = this.getSelectionStartFromPointer(e), start = this.selectionStart, end = this.selectionEnd;
        if (e.shiftKey) {
          this.setSelectionStartEndWithShift(start, end, newSelection);
        } else {
          this.selectionStart = newSelection;
          this.selectionEnd = newSelection;
        }
        if (this.isEditing) {
          this._fireSelectionChanged();
          this._updateTextarea();
        }
      },
      /**
       * Returns index of a character corresponding to where an object was clicked
       * @param {Event} e Event object
       * @return {Number} Index of a character
       */
      getSelectionStartFromPointer: function(e) {
        var mouseOffset = this.getLocalPointer(e), prevWidth = 0, width = 0, height = 0, charIndex = 0, lineIndex = 0, lineLeftOffset, line;
        for (var i = 0, len = this._textLines.length; i < len; i++) {
          if (height <= mouseOffset.y) {
            height += this.getHeightOfLine(i) * this.scaleY;
            lineIndex = i;
            if (i > 0) {
              charIndex += this._textLines[i - 1].length + this.missingNewlineOffset(i - 1);
            }
          } else {
            break;
          }
        }
        lineLeftOffset = this._getLineLeftOffset(lineIndex);
        width = lineLeftOffset * this.scaleX;
        line = this._textLines[lineIndex];
        if (this.direction === "rtl") {
          mouseOffset.x = this.width * this.scaleX - mouseOffset.x + width;
        }
        for (var j = 0, jlen = line.length; j < jlen; j++) {
          prevWidth = width;
          width += this.__charBounds[lineIndex][j].kernedWidth * this.scaleX;
          if (width <= mouseOffset.x) {
            charIndex++;
          } else {
            break;
          }
        }
        return this._getNewSelectionStartFromOffset(mouseOffset, prevWidth, width, charIndex, jlen);
      },
      /**
       * @private
       */
      _getNewSelectionStartFromOffset: function(mouseOffset, prevWidth, width, index, jlen) {
        var distanceBtwLastCharAndCursor = mouseOffset.x - prevWidth, distanceBtwNextCharAndCursor = width - mouseOffset.x, offset = distanceBtwNextCharAndCursor > distanceBtwLastCharAndCursor || distanceBtwNextCharAndCursor < 0 ? 0 : 1, newSelectionStart = index + offset;
        if (this.flipX) {
          newSelectionStart = jlen - newSelectionStart;
        }
        if (newSelectionStart > this._text.length) {
          newSelectionStart = this._text.length;
        }
        return newSelectionStart;
      }
    }
  );
  fabric2.util.object.extend(
    fabric2.IText.prototype,
    /** @lends fabric.IText.prototype */
    {
      /**
       * Initializes hidden textarea (needed to bring up keyboard in iOS)
       */
      initHiddenTextarea: function() {
        this.hiddenTextarea = fabric2.document.createElement("textarea");
        this.hiddenTextarea.setAttribute("autocapitalize", "off");
        this.hiddenTextarea.setAttribute("autocorrect", "off");
        this.hiddenTextarea.setAttribute("autocomplete", "off");
        this.hiddenTextarea.setAttribute("spellcheck", "false");
        this.hiddenTextarea.setAttribute("data-fabric-hiddentextarea", "");
        this.hiddenTextarea.setAttribute("wrap", "off");
        var style = this._calcTextareaPosition();
        this.hiddenTextarea.style.cssText = "position: absolute; top: " + style.top + "; left: " + style.left + "; z-index: -999; opacity: 0; width: 1px; height: 1px; font-size: 1px; padding-top: " + style.fontSize + ";";
        if (this.hiddenTextareaContainer) {
          this.hiddenTextareaContainer.appendChild(this.hiddenTextarea);
        } else {
          fabric2.document.body.appendChild(this.hiddenTextarea);
        }
        fabric2.util.addListener(this.hiddenTextarea, "keydown", this.onKeyDown.bind(this));
        fabric2.util.addListener(this.hiddenTextarea, "keyup", this.onKeyUp.bind(this));
        fabric2.util.addListener(this.hiddenTextarea, "input", this.onInput.bind(this));
        fabric2.util.addListener(this.hiddenTextarea, "copy", this.copy.bind(this));
        fabric2.util.addListener(this.hiddenTextarea, "cut", this.copy.bind(this));
        fabric2.util.addListener(this.hiddenTextarea, "paste", this.paste.bind(this));
        fabric2.util.addListener(this.hiddenTextarea, "compositionstart", this.onCompositionStart.bind(this));
        fabric2.util.addListener(this.hiddenTextarea, "compositionupdate", this.onCompositionUpdate.bind(this));
        fabric2.util.addListener(this.hiddenTextarea, "compositionend", this.onCompositionEnd.bind(this));
        if (!this._clickHandlerInitialized && this.canvas) {
          fabric2.util.addListener(this.canvas.upperCanvasEl, "click", this.onClick.bind(this));
          this._clickHandlerInitialized = true;
        }
      },
      /**
       * For functionalities on keyDown
       * Map a special key to a function of the instance/prototype
       * If you need different behaviour for ESC or TAB or arrows, you have to change
       * this map setting the name of a function that you build on the fabric.Itext or
       * your prototype.
       * the map change will affect all Instances unless you need for only some text Instances
       * in that case you have to clone this object and assign your Instance.
       * this.keysMap = fabric.util.object.clone(this.keysMap);
       * The function must be in fabric.Itext.prototype.myFunction And will receive event as args[0]
       */
      keysMap: {
        9: "exitEditing",
        27: "exitEditing",
        33: "moveCursorUp",
        34: "moveCursorDown",
        35: "moveCursorRight",
        36: "moveCursorLeft",
        37: "moveCursorLeft",
        38: "moveCursorUp",
        39: "moveCursorRight",
        40: "moveCursorDown"
      },
      keysMapRtl: {
        9: "exitEditing",
        27: "exitEditing",
        33: "moveCursorUp",
        34: "moveCursorDown",
        35: "moveCursorLeft",
        36: "moveCursorRight",
        37: "moveCursorRight",
        38: "moveCursorUp",
        39: "moveCursorLeft",
        40: "moveCursorDown"
      },
      /**
       * For functionalities on keyUp + ctrl || cmd
       */
      ctrlKeysMapUp: {
        67: "copy",
        88: "cut"
      },
      /**
       * For functionalities on keyDown + ctrl || cmd
       */
      ctrlKeysMapDown: {
        65: "selectAll"
      },
      onClick: function() {
        this.hiddenTextarea && this.hiddenTextarea.focus();
      },
      /**
       * Handles keydown event
       * only used for arrows and combination of modifier keys.
       * @param {Event} e Event object
       */
      onKeyDown: function(e) {
        if (!this.isEditing) {
          return;
        }
        var keyMap = this.direction === "rtl" ? this.keysMapRtl : this.keysMap;
        if (e.keyCode in keyMap) {
          this[keyMap[e.keyCode]](e);
        } else if (e.keyCode in this.ctrlKeysMapDown && (e.ctrlKey || e.metaKey)) {
          this[this.ctrlKeysMapDown[e.keyCode]](e);
        } else {
          return;
        }
        e.stopImmediatePropagation();
        e.preventDefault();
        if (e.keyCode >= 33 && e.keyCode <= 40) {
          this.inCompositionMode = false;
          this.clearContextTop();
          this.renderCursorOrSelection();
        } else {
          this.canvas && this.canvas.requestRenderAll();
        }
      },
      /**
       * Handles keyup event
       * We handle KeyUp because ie11 and edge have difficulties copy/pasting
       * if a copy/cut event fired, keyup is dismissed
       * @param {Event} e Event object
       */
      onKeyUp: function(e) {
        if (!this.isEditing || this._copyDone || this.inCompositionMode) {
          this._copyDone = false;
          return;
        }
        if (e.keyCode in this.ctrlKeysMapUp && (e.ctrlKey || e.metaKey)) {
          this[this.ctrlKeysMapUp[e.keyCode]](e);
        } else {
          return;
        }
        e.stopImmediatePropagation();
        e.preventDefault();
        this.canvas && this.canvas.requestRenderAll();
      },
      /**
       * Handles onInput event
       * @param {Event} e Event object
       */
      onInput: function(e) {
        var fromPaste = this.fromPaste;
        this.fromPaste = false;
        e && e.stopPropagation();
        if (!this.isEditing) {
          return;
        }
        var nextText = this._splitTextIntoLines(this.hiddenTextarea.value).graphemeText, charCount = this._text.length, nextCharCount = nextText.length, removedText, insertedText, charDiff = nextCharCount - charCount, selectionStart = this.selectionStart, selectionEnd = this.selectionEnd, selection = selectionStart !== selectionEnd, copiedStyle, removeFrom, removeTo;
        if (this.hiddenTextarea.value === "") {
          this.styles = {};
          this.updateFromTextArea();
          this.fire("changed");
          if (this.canvas) {
            this.canvas.fire("text:changed", { target: this });
            this.canvas.requestRenderAll();
          }
          return;
        }
        var textareaSelection = this.fromStringToGraphemeSelection(
          this.hiddenTextarea.selectionStart,
          this.hiddenTextarea.selectionEnd,
          this.hiddenTextarea.value
        );
        var backDelete = selectionStart > textareaSelection.selectionStart;
        if (selection) {
          removedText = this._text.slice(selectionStart, selectionEnd);
          charDiff += selectionEnd - selectionStart;
        } else if (nextCharCount < charCount) {
          if (backDelete) {
            removedText = this._text.slice(selectionEnd + charDiff, selectionEnd);
          } else {
            removedText = this._text.slice(selectionStart, selectionStart - charDiff);
          }
        }
        insertedText = nextText.slice(textareaSelection.selectionEnd - charDiff, textareaSelection.selectionEnd);
        if (removedText && removedText.length) {
          if (insertedText.length) {
            copiedStyle = this.getSelectionStyles(selectionStart, selectionStart + 1, false);
            copiedStyle = insertedText.map(function() {
              return copiedStyle[0];
            });
          }
          if (selection) {
            removeFrom = selectionStart;
            removeTo = selectionEnd;
          } else if (backDelete) {
            removeFrom = selectionEnd - removedText.length;
            removeTo = selectionEnd;
          } else {
            removeFrom = selectionEnd;
            removeTo = selectionEnd + removedText.length;
          }
          this.removeStyleFromTo(removeFrom, removeTo);
        }
        if (insertedText.length) {
          if (fromPaste && insertedText.join("") === fabric2.copiedText && !fabric2.disableStyleCopyPaste) {
            copiedStyle = fabric2.copiedTextStyle;
          }
          this.insertNewStyleBlock(insertedText, selectionStart, copiedStyle);
        }
        this.updateFromTextArea();
        this.fire("changed");
        if (this.canvas) {
          this.canvas.fire("text:changed", { target: this });
          this.canvas.requestRenderAll();
        }
      },
      /**
       * Composition start
       */
      onCompositionStart: function() {
        this.inCompositionMode = true;
      },
      /**
       * Composition end
       */
      onCompositionEnd: function() {
        this.inCompositionMode = false;
      },
      // /**
      //  * Composition update
      //  */
      onCompositionUpdate: function(e) {
        this.compositionStart = e.target.selectionStart;
        this.compositionEnd = e.target.selectionEnd;
        this.updateTextareaPosition();
      },
      /**
       * Copies selected text
       * @param {Event} e Event object
       */
      copy: function() {
        if (this.selectionStart === this.selectionEnd) {
          return;
        }
        fabric2.copiedText = this.getSelectedText();
        if (!fabric2.disableStyleCopyPaste) {
          fabric2.copiedTextStyle = this.getSelectionStyles(this.selectionStart, this.selectionEnd, true);
        } else {
          fabric2.copiedTextStyle = null;
        }
        this._copyDone = true;
      },
      /**
       * Pastes text
       * @param {Event} e Event object
       */
      paste: function() {
        this.fromPaste = true;
      },
      /**
       * @private
       * @param {Event} e Event object
       * @return {Object} Clipboard data object
       */
      _getClipboardData: function(e) {
        return e && e.clipboardData || fabric2.window.clipboardData;
      },
      /**
       * Finds the width in pixels before the cursor on the same line
       * @private
       * @param {Number} lineIndex
       * @param {Number} charIndex
       * @return {Number} widthBeforeCursor width before cursor
       */
      _getWidthBeforeCursor: function(lineIndex, charIndex) {
        var widthBeforeCursor = this._getLineLeftOffset(lineIndex), bound;
        if (charIndex > 0) {
          bound = this.__charBounds[lineIndex][charIndex - 1];
          widthBeforeCursor += bound.left + bound.width;
        }
        return widthBeforeCursor;
      },
      /**
       * Gets start offset of a selection
       * @param {Event} e Event object
       * @param {Boolean} isRight
       * @return {Number}
       */
      getDownCursorOffset: function(e, isRight) {
        var selectionProp = this._getSelectionForOffset(e, isRight), cursorLocation = this.get2DCursorLocation(selectionProp), lineIndex = cursorLocation.lineIndex;
        if (lineIndex === this._textLines.length - 1 || e.metaKey || e.keyCode === 34) {
          return this._text.length - selectionProp;
        }
        var charIndex = cursorLocation.charIndex, widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex), indexOnOtherLine = this._getIndexOnLine(lineIndex + 1, widthBeforeCursor), textAfterCursor = this._textLines[lineIndex].slice(charIndex);
        return textAfterCursor.length + indexOnOtherLine + 1 + this.missingNewlineOffset(lineIndex);
      },
      /**
       * private
       * Helps finding if the offset should be counted from Start or End
       * @param {Event} e Event object
       * @param {Boolean} isRight
       * @return {Number}
       */
      _getSelectionForOffset: function(e, isRight) {
        if (e.shiftKey && this.selectionStart !== this.selectionEnd && isRight) {
          return this.selectionEnd;
        } else {
          return this.selectionStart;
        }
      },
      /**
       * @param {Event} e Event object
       * @param {Boolean} isRight
       * @return {Number}
       */
      getUpCursorOffset: function(e, isRight) {
        var selectionProp = this._getSelectionForOffset(e, isRight), cursorLocation = this.get2DCursorLocation(selectionProp), lineIndex = cursorLocation.lineIndex;
        if (lineIndex === 0 || e.metaKey || e.keyCode === 33) {
          return -selectionProp;
        }
        var charIndex = cursorLocation.charIndex, widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex), indexOnOtherLine = this._getIndexOnLine(lineIndex - 1, widthBeforeCursor), textBeforeCursor = this._textLines[lineIndex].slice(0, charIndex), missingNewlineOffset = this.missingNewlineOffset(lineIndex - 1);
        return -this._textLines[lineIndex - 1].length + indexOnOtherLine - textBeforeCursor.length + (1 - missingNewlineOffset);
      },
      /**
       * for a given width it founds the matching character.
       * @private
       */
      _getIndexOnLine: function(lineIndex, width) {
        var line = this._textLines[lineIndex], lineLeftOffset = this._getLineLeftOffset(lineIndex), widthOfCharsOnLine = lineLeftOffset, indexOnLine = 0, charWidth, foundMatch;
        for (var j = 0, jlen = line.length; j < jlen; j++) {
          charWidth = this.__charBounds[lineIndex][j].width;
          widthOfCharsOnLine += charWidth;
          if (widthOfCharsOnLine > width) {
            foundMatch = true;
            var leftEdge = widthOfCharsOnLine - charWidth, rightEdge = widthOfCharsOnLine, offsetFromLeftEdge = Math.abs(leftEdge - width), offsetFromRightEdge = Math.abs(rightEdge - width);
            indexOnLine = offsetFromRightEdge < offsetFromLeftEdge ? j : j - 1;
            break;
          }
        }
        if (!foundMatch) {
          indexOnLine = line.length - 1;
        }
        return indexOnLine;
      },
      /**
       * Moves cursor down
       * @param {Event} e Event object
       */
      moveCursorDown: function(e) {
        if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) {
          return;
        }
        this._moveCursorUpOrDown("Down", e);
      },
      /**
       * Moves cursor up
       * @param {Event} e Event object
       */
      moveCursorUp: function(e) {
        if (this.selectionStart === 0 && this.selectionEnd === 0) {
          return;
        }
        this._moveCursorUpOrDown("Up", e);
      },
      /**
       * Moves cursor up or down, fires the events
       * @param {String} direction 'Up' or 'Down'
       * @param {Event} e Event object
       */
      _moveCursorUpOrDown: function(direction, e) {
        var action = "get" + direction + "CursorOffset", offset = this[action](e, this._selectionDirection === "right");
        if (e.shiftKey) {
          this.moveCursorWithShift(offset);
        } else {
          this.moveCursorWithoutShift(offset);
        }
        if (offset !== 0) {
          this.setSelectionInBoundaries();
          this.abortCursorAnimation();
          this._currentCursorOpacity = 1;
          this.initDelayedCursor();
          this._fireSelectionChanged();
          this._updateTextarea();
        }
      },
      /**
       * Moves cursor with shift
       * @param {Number} offset
       */
      moveCursorWithShift: function(offset) {
        var newSelection = this._selectionDirection === "left" ? this.selectionStart + offset : this.selectionEnd + offset;
        this.setSelectionStartEndWithShift(this.selectionStart, this.selectionEnd, newSelection);
        return offset !== 0;
      },
      /**
       * Moves cursor up without shift
       * @param {Number} offset
       */
      moveCursorWithoutShift: function(offset) {
        if (offset < 0) {
          this.selectionStart += offset;
          this.selectionEnd = this.selectionStart;
        } else {
          this.selectionEnd += offset;
          this.selectionStart = this.selectionEnd;
        }
        return offset !== 0;
      },
      /**
       * Moves cursor left
       * @param {Event} e Event object
       */
      moveCursorLeft: function(e) {
        if (this.selectionStart === 0 && this.selectionEnd === 0) {
          return;
        }
        this._moveCursorLeftOrRight("Left", e);
      },
      /**
       * @private
       * @return {Boolean} true if a change happened
       */
      _move: function(e, prop, direction) {
        var newValue;
        if (e.altKey) {
          newValue = this["findWordBoundary" + direction](this[prop]);
        } else if (e.metaKey || e.keyCode === 35 || e.keyCode === 36) {
          newValue = this["findLineBoundary" + direction](this[prop]);
        } else {
          this[prop] += direction === "Left" ? -1 : 1;
          return true;
        }
        if (typeof newValue !== "undefined" && this[prop] !== newValue) {
          this[prop] = newValue;
          return true;
        }
      },
      /**
       * @private
       */
      _moveLeft: function(e, prop) {
        return this._move(e, prop, "Left");
      },
      /**
       * @private
       */
      _moveRight: function(e, prop) {
        return this._move(e, prop, "Right");
      },
      /**
       * Moves cursor left without keeping selection
       * @param {Event} e
       */
      moveCursorLeftWithoutShift: function(e) {
        var change = true;
        this._selectionDirection = "left";
        if (this.selectionEnd === this.selectionStart && this.selectionStart !== 0) {
          change = this._moveLeft(e, "selectionStart");
        }
        this.selectionEnd = this.selectionStart;
        return change;
      },
      /**
       * Moves cursor left while keeping selection
       * @param {Event} e
       */
      moveCursorLeftWithShift: function(e) {
        if (this._selectionDirection === "right" && this.selectionStart !== this.selectionEnd) {
          return this._moveLeft(e, "selectionEnd");
        } else if (this.selectionStart !== 0) {
          this._selectionDirection = "left";
          return this._moveLeft(e, "selectionStart");
        }
      },
      /**
       * Moves cursor right
       * @param {Event} e Event object
       */
      moveCursorRight: function(e) {
        if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) {
          return;
        }
        this._moveCursorLeftOrRight("Right", e);
      },
      /**
       * Moves cursor right or Left, fires event
       * @param {String} direction 'Left', 'Right'
       * @param {Event} e Event object
       */
      _moveCursorLeftOrRight: function(direction, e) {
        var actionName = "moveCursor" + direction + "With";
        this._currentCursorOpacity = 1;
        if (e.shiftKey) {
          actionName += "Shift";
        } else {
          actionName += "outShift";
        }
        if (this[actionName](e)) {
          this.abortCursorAnimation();
          this.initDelayedCursor();
          this._fireSelectionChanged();
          this._updateTextarea();
        }
      },
      /**
       * Moves cursor right while keeping selection
       * @param {Event} e
       */
      moveCursorRightWithShift: function(e) {
        if (this._selectionDirection === "left" && this.selectionStart !== this.selectionEnd) {
          return this._moveRight(e, "selectionStart");
        } else if (this.selectionEnd !== this._text.length) {
          this._selectionDirection = "right";
          return this._moveRight(e, "selectionEnd");
        }
      },
      /**
       * Moves cursor right without keeping selection
       * @param {Event} e Event object
       */
      moveCursorRightWithoutShift: function(e) {
        var changed = true;
        this._selectionDirection = "right";
        if (this.selectionStart === this.selectionEnd) {
          changed = this._moveRight(e, "selectionStart");
          this.selectionEnd = this.selectionStart;
        } else {
          this.selectionStart = this.selectionEnd;
        }
        return changed;
      },
      /**
       * Removes characters from start/end
       * start/end ar per grapheme position in _text array.
       *
       * @param {Number} start
       * @param {Number} end default to start + 1
       */
      removeChars: function(start, end) {
        if (typeof end === "undefined") {
          end = start + 1;
        }
        this.removeStyleFromTo(start, end);
        this._text.splice(start, end - start);
        this.text = this._text.join("");
        this.set("dirty", true);
        if (this._shouldClearDimensionCache()) {
          this.initDimensions();
          this.setCoords();
        }
        this._removeExtraneousStyles();
      },
      /**
       * insert characters at start position, before start position.
       * start  equal 1 it means the text get inserted between actual grapheme 0 and 1
       * if style array is provided, it must be as the same length of text in graphemes
       * if end is provided and is bigger than start, old text is replaced.
       * start/end ar per grapheme position in _text array.
       *
       * @param {String} text text to insert
       * @param {Array} style array of style objects
       * @param {Number} start
       * @param {Number} end default to start + 1
       */
      insertChars: function(text, style, start, end) {
        if (typeof end === "undefined") {
          end = start;
        }
        if (end > start) {
          this.removeStyleFromTo(start, end);
        }
        var graphemes = fabric2.util.string.graphemeSplit(text);
        this.insertNewStyleBlock(graphemes, start, style);
        this._text = [].concat(this._text.slice(0, start), graphemes, this._text.slice(end));
        this.text = this._text.join("");
        this.set("dirty", true);
        if (this._shouldClearDimensionCache()) {
          this.initDimensions();
          this.setCoords();
        }
        this._removeExtraneousStyles();
      }
    }
  );
  (function() {
    var toFixed = fabric2.util.toFixed, multipleSpacesRegex = /  +/g;
    fabric2.util.object.extend(
      fabric2.Text.prototype,
      /** @lends fabric.Text.prototype */
      {
        /**
         * Returns SVG representation of an instance
         * @param {Function} [reviver] Method for further parsing of svg representation.
         * @return {String} svg representation of an instance
         */
        _toSVG: function() {
          var offsets = this._getSVGLeftTopOffsets(), textAndBg = this._getSVGTextAndBg(offsets.textTop, offsets.textLeft);
          return this._wrapSVGTextAndBg(textAndBg);
        },
        /**
         * Returns svg representation of an instance
         * @param {Function} [reviver] Method for further parsing of svg representation.
         * @return {String} svg representation of an instance
         */
        toSVG: function(reviver) {
          return this._createBaseSVGMarkup(
            this._toSVG(),
            { reviver, noStyle: true, withShadow: true }
          );
        },
        /**
         * @private
         */
        _getSVGLeftTopOffsets: function() {
          return {
            textLeft: -this.width / 2,
            textTop: -this.height / 2,
            lineTop: this.getHeightOfLine(0)
          };
        },
        /**
         * @private
         */
        _wrapSVGTextAndBg: function(textAndBg) {
          var noShadow = true, textDecoration = this.getSvgTextDecoration(this);
          return [
            textAndBg.textBgRects.join(""),
            '		<text xml:space="preserve" ',
            this.fontFamily ? 'font-family="' + this.fontFamily.replace(/"/g, "'") + '" ' : "",
            this.fontSize ? 'font-size="' + this.fontSize + '" ' : "",
            this.fontStyle ? 'font-style="' + this.fontStyle + '" ' : "",
            this.fontWeight ? 'font-weight="' + this.fontWeight + '" ' : "",
            textDecoration ? 'text-decoration="' + textDecoration + '" ' : "",
            'style="',
            this.getSvgStyles(noShadow),
            '"',
            this.addPaintOrder(),
            " >",
            textAndBg.textSpans.join(""),
            "</text>\n"
          ];
        },
        /**
         * @private
         * @param {Number} textTopOffset Text top offset
         * @param {Number} textLeftOffset Text left offset
         * @return {Object}
         */
        _getSVGTextAndBg: function(textTopOffset, textLeftOffset) {
          var textSpans = [], textBgRects = [], height = textTopOffset, lineOffset;
          this._setSVGBg(textBgRects);
          for (var i = 0, len = this._textLines.length; i < len; i++) {
            lineOffset = this._getLineLeftOffset(i);
            if (this.textBackgroundColor || this.styleHas("textBackgroundColor", i)) {
              this._setSVGTextLineBg(textBgRects, i, textLeftOffset + lineOffset, height);
            }
            this._setSVGTextLineText(textSpans, i, textLeftOffset + lineOffset, height);
            height += this.getHeightOfLine(i);
          }
          return {
            textSpans,
            textBgRects
          };
        },
        /**
         * @private
         */
        _createTextCharSpan: function(_char, styleDecl, left, top) {
          var shouldUseWhitespace = _char !== _char.trim() || _char.match(multipleSpacesRegex), styleProps = this.getSvgSpanStyles(styleDecl, shouldUseWhitespace), fillStyles = styleProps ? 'style="' + styleProps + '"' : "", dy = styleDecl.deltaY, dySpan = "", NUM_FRACTION_DIGITS = fabric2.Object.NUM_FRACTION_DIGITS;
          if (dy) {
            dySpan = ' dy="' + toFixed(dy, NUM_FRACTION_DIGITS) + '" ';
          }
          return [
            '<tspan x="',
            toFixed(left, NUM_FRACTION_DIGITS),
            '" y="',
            toFixed(top, NUM_FRACTION_DIGITS),
            '" ',
            dySpan,
            fillStyles,
            ">",
            fabric2.util.string.escapeXml(_char),
            "</tspan>"
          ].join("");
        },
        _setSVGTextLineText: function(textSpans, lineIndex, textLeftOffset, textTopOffset) {
          var lineHeight = this.getHeightOfLine(lineIndex), isJustify = this.textAlign.indexOf("justify") !== -1, actualStyle, nextStyle, charsToRender = "", charBox, style, boxWidth = 0, line = this._textLines[lineIndex], timeToRender;
          textTopOffset += lineHeight * (1 - this._fontSizeFraction) / this.lineHeight;
          for (var i = 0, len = line.length - 1; i <= len; i++) {
            timeToRender = i === len || this.charSpacing;
            charsToRender += line[i];
            charBox = this.__charBounds[lineIndex][i];
            if (boxWidth === 0) {
              textLeftOffset += charBox.kernedWidth - charBox.width;
              boxWidth += charBox.width;
            } else {
              boxWidth += charBox.kernedWidth;
            }
            if (isJustify && !timeToRender) {
              if (this._reSpaceAndTab.test(line[i])) {
                timeToRender = true;
              }
            }
            if (!timeToRender) {
              actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
              nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
              timeToRender = fabric2.util.hasStyleChanged(actualStyle, nextStyle, true);
            }
            if (timeToRender) {
              style = this._getStyleDeclaration(lineIndex, i) || {};
              textSpans.push(this._createTextCharSpan(charsToRender, style, textLeftOffset, textTopOffset));
              charsToRender = "";
              actualStyle = nextStyle;
              textLeftOffset += boxWidth;
              boxWidth = 0;
            }
          }
        },
        _pushTextBgRect: function(textBgRects, color, left, top, width, height) {
          var NUM_FRACTION_DIGITS = fabric2.Object.NUM_FRACTION_DIGITS;
          textBgRects.push(
            "		<rect ",
            this._getFillAttributes(color),
            ' x="',
            toFixed(left, NUM_FRACTION_DIGITS),
            '" y="',
            toFixed(top, NUM_FRACTION_DIGITS),
            '" width="',
            toFixed(width, NUM_FRACTION_DIGITS),
            '" height="',
            toFixed(height, NUM_FRACTION_DIGITS),
            '"></rect>\n'
          );
        },
        _setSVGTextLineBg: function(textBgRects, i, leftOffset, textTopOffset) {
          var line = this._textLines[i], heightOfLine = this.getHeightOfLine(i) / this.lineHeight, boxWidth = 0, boxStart = 0, charBox, currentColor, lastColor = this.getValueOfPropertyAt(i, 0, "textBackgroundColor");
          for (var j = 0, jlen = line.length; j < jlen; j++) {
            charBox = this.__charBounds[i][j];
            currentColor = this.getValueOfPropertyAt(i, j, "textBackgroundColor");
            if (currentColor !== lastColor) {
              lastColor && this._pushTextBgRect(
                textBgRects,
                lastColor,
                leftOffset + boxStart,
                textTopOffset,
                boxWidth,
                heightOfLine
              );
              boxStart = charBox.left;
              boxWidth = charBox.width;
              lastColor = currentColor;
            } else {
              boxWidth += charBox.kernedWidth;
            }
          }
          currentColor && this._pushTextBgRect(
            textBgRects,
            currentColor,
            leftOffset + boxStart,
            textTopOffset,
            boxWidth,
            heightOfLine
          );
        },
        /**
         * Adobe Illustrator (at least CS5) is unable to render rgba()-based fill values
         * we work around it by "moving" alpha channel into opacity attribute and setting fill's alpha to 1
         *
         * @private
         * @param {*} value
         * @return {String}
         */
        _getFillAttributes: function(value) {
          var fillColor = value && typeof value === "string" ? new fabric2.Color(value) : "";
          if (!fillColor || !fillColor.getSource() || fillColor.getAlpha() === 1) {
            return 'fill="' + value + '"';
          }
          return 'opacity="' + fillColor.getAlpha() + '" fill="' + fillColor.setAlpha(1).toRgb() + '"';
        },
        /**
         * @private
         */
        _getSVGLineTopOffset: function(lineIndex) {
          var lineTopOffset = 0, lastHeight = 0;
          for (var j = 0; j < lineIndex; j++) {
            lineTopOffset += this.getHeightOfLine(j);
          }
          lastHeight = this.getHeightOfLine(j);
          return {
            lineTop: lineTopOffset,
            offset: (this._fontSizeMult - this._fontSizeFraction) * lastHeight / (this.lineHeight * this._fontSizeMult)
          };
        },
        /**
         * Returns styles-string for svg-export
         * @param {Boolean} skipShadow a boolean to skip shadow filter output
         * @return {String}
         */
        getSvgStyles: function(skipShadow) {
          var svgStyle = fabric2.Object.prototype.getSvgStyles.call(this, skipShadow);
          return svgStyle + " white-space: pre;";
        }
      }
    );
  })();
  (function(global) {
    var fabric22 = global.fabric || (global.fabric = {});
    fabric22.Textbox = fabric22.util.createClass(fabric22.IText, fabric22.Observable, {
      /**
       * Type of an object
       * @type String
       * @default
       */
      type: "textbox",
      /**
       * Minimum width of textbox, in pixels.
       * @type Number
       * @default
       */
      minWidth: 20,
      /**
       * Minimum calculated width of a textbox, in pixels.
       * fixed to 2 so that an empty textbox cannot go to 0
       * and is still selectable without text.
       * @type Number
       * @default
       */
      dynamicMinWidth: 2,
      /**
       * Cached array of text wrapping.
       * @type Array
       */
      __cachedLines: null,
      /**
       * Override standard Object class values
       */
      lockScalingFlip: true,
      /**
       * Override standard Object class values
       * Textbox needs this on false
       */
      noScaleCache: false,
      /**
       * Properties which when set cause object to change dimensions
       * @type Object
       * @private
       */
      _dimensionAffectingProps: fabric22.Text.prototype._dimensionAffectingProps.concat("width"),
      /**
       * Use this regular expression to split strings in breakable lines
       * @private
       */
      _wordJoiners: /[ \t\r]/,
      /**
       * Use this boolean property in order to split strings that have no white space concept.
       * this is a cheap way to help with chinese/japanese
       * @type Boolean
       * @since 2.6.0
       */
      splitByGrapheme: false,
      /**
       * Unlike superclass's version of this function, Textbox does not update
       * its width.
       * @private
       * @override
       */
      initDimensions: function() {
        if (this.__skipDimension) {
          return;
        }
        this.isEditing && this.initDelayedCursor();
        this.clearContextTop();
        this._clearCache();
        this.dynamicMinWidth = 0;
        this._styleMap = this._generateStyleMap(this._splitText());
        if (this.dynamicMinWidth > this.width) {
          this._set("width", this.dynamicMinWidth);
        }
        if (this.textAlign.indexOf("justify") !== -1) {
          this.enlargeSpaces();
        }
        this.height = this.calcTextHeight();
        this.saveState({ propertySet: "_dimensionAffectingProps" });
      },
      /**
       * Generate an object that translates the style object so that it is
       * broken up by visual lines (new lines and automatic wrapping).
       * The original text styles object is broken up by actual lines (new lines only),
       * which is only sufficient for Text / IText
       * @private
       */
      _generateStyleMap: function(textInfo) {
        var realLineCount = 0, realLineCharCount = 0, charCount = 0, map2 = {};
        for (var i = 0; i < textInfo.graphemeLines.length; i++) {
          if (textInfo.graphemeText[charCount] === "\n" && i > 0) {
            realLineCharCount = 0;
            charCount++;
            realLineCount++;
          } else if (!this.splitByGrapheme && this._reSpaceAndTab.test(textInfo.graphemeText[charCount]) && i > 0) {
            realLineCharCount++;
            charCount++;
          }
          map2[i] = { line: realLineCount, offset: realLineCharCount };
          charCount += textInfo.graphemeLines[i].length;
          realLineCharCount += textInfo.graphemeLines[i].length;
        }
        return map2;
      },
      /**
       * Returns true if object has a style property or has it on a specified line
       * @param {Number} lineIndex
       * @return {Boolean}
       */
      styleHas: function(property, lineIndex) {
        if (this._styleMap && !this.isWrapping) {
          var map2 = this._styleMap[lineIndex];
          if (map2) {
            lineIndex = map2.line;
          }
        }
        return fabric22.Text.prototype.styleHas.call(this, property, lineIndex);
      },
      /**
       * Returns true if object has no styling or no styling in a line
       * @param {Number} lineIndex , lineIndex is on wrapped lines.
       * @return {Boolean}
       */
      isEmptyStyles: function(lineIndex) {
        if (!this.styles) {
          return true;
        }
        var offset = 0, nextLineIndex = lineIndex + 1, nextOffset, obj, shouldLimit = false, map2 = this._styleMap[lineIndex], mapNextLine = this._styleMap[lineIndex + 1];
        if (map2) {
          lineIndex = map2.line;
          offset = map2.offset;
        }
        if (mapNextLine) {
          nextLineIndex = mapNextLine.line;
          shouldLimit = nextLineIndex === lineIndex;
          nextOffset = mapNextLine.offset;
        }
        obj = typeof lineIndex === "undefined" ? this.styles : { line: this.styles[lineIndex] };
        for (var p1 in obj) {
          for (var p2 in obj[p1]) {
            if (p2 >= offset && (!shouldLimit || p2 < nextOffset)) {
              for (var p3 in obj[p1][p2]) {
                return false;
              }
            }
          }
        }
        return true;
      },
      /**
       * @param {Number} lineIndex
       * @param {Number} charIndex
       * @private
       */
      _getStyleDeclaration: function(lineIndex, charIndex) {
        if (this._styleMap && !this.isWrapping) {
          var map2 = this._styleMap[lineIndex];
          if (!map2) {
            return null;
          }
          lineIndex = map2.line;
          charIndex = map2.offset + charIndex;
        }
        return this.callSuper("_getStyleDeclaration", lineIndex, charIndex);
      },
      /**
       * @param {Number} lineIndex
       * @param {Number} charIndex
       * @param {Object} style
       * @private
       */
      _setStyleDeclaration: function(lineIndex, charIndex, style) {
        var map2 = this._styleMap[lineIndex];
        lineIndex = map2.line;
        charIndex = map2.offset + charIndex;
        this.styles[lineIndex][charIndex] = style;
      },
      /**
       * @param {Number} lineIndex
       * @param {Number} charIndex
       * @private
       */
      _deleteStyleDeclaration: function(lineIndex, charIndex) {
        var map2 = this._styleMap[lineIndex];
        lineIndex = map2.line;
        charIndex = map2.offset + charIndex;
        delete this.styles[lineIndex][charIndex];
      },
      /**
       * probably broken need a fix
       * Returns the real style line that correspond to the wrapped lineIndex line
       * Used just to verify if the line does exist or not.
       * @param {Number} lineIndex
       * @returns {Boolean} if the line exists or not
       * @private
       */
      _getLineStyle: function(lineIndex) {
        var map2 = this._styleMap[lineIndex];
        return !!this.styles[map2.line];
      },
      /**
       * Set the line style to an empty object so that is initialized
       * @param {Number} lineIndex
       * @param {Object} style
       * @private
       */
      _setLineStyle: function(lineIndex) {
        var map2 = this._styleMap[lineIndex];
        this.styles[map2.line] = {};
      },
      /**
       * Wraps text using the 'width' property of Textbox. First this function
       * splits text on newlines, so we preserve newlines entered by the user.
       * Then it wraps each line using the width of the Textbox by calling
       * _wrapLine().
       * @param {Array} lines The string array of text that is split into lines
       * @param {Number} desiredWidth width you want to wrap to
       * @returns {Array} Array of lines
       */
      _wrapText: function(lines, desiredWidth) {
        var wrapped = [], i;
        this.isWrapping = true;
        for (i = 0; i < lines.length; i++) {
          wrapped = wrapped.concat(this._wrapLine(lines[i], i, desiredWidth));
        }
        this.isWrapping = false;
        return wrapped;
      },
      /**
       * Helper function to measure a string of text, given its lineIndex and charIndex offset
       * it gets called when charBounds are not available yet.
       * @param {CanvasRenderingContext2D} ctx
       * @param {String} text
       * @param {number} lineIndex
       * @param {number} charOffset
       * @returns {number}
       * @private
       */
      _measureWord: function(word, lineIndex, charOffset) {
        var width = 0, prevGrapheme, skipLeft = true;
        charOffset = charOffset || 0;
        for (var i = 0, len = word.length; i < len; i++) {
          var box = this._getGraphemeBox(word[i], lineIndex, i + charOffset, prevGrapheme, skipLeft);
          width += box.kernedWidth;
          prevGrapheme = word[i];
        }
        return width;
      },
      /**
       * Wraps a line of text using the width of the Textbox and a context.
       * @param {Array} line The grapheme array that represent the line
       * @param {Number} lineIndex
       * @param {Number} desiredWidth width you want to wrap the line to
       * @param {Number} reservedSpace space to remove from wrapping for custom functionalities
       * @returns {Array} Array of line(s) into which the given text is wrapped
       * to.
       */
      _wrapLine: function(_line, lineIndex, desiredWidth, reservedSpace) {
        var lineWidth = 0, splitByGrapheme = this.splitByGrapheme, graphemeLines = [], line = [], words = splitByGrapheme ? fabric22.util.string.graphemeSplit(_line) : _line.split(this._wordJoiners), word = "", offset = 0, infix = splitByGrapheme ? "" : " ", wordWidth = 0, infixWidth = 0, largestWordWidth = 0, lineJustStarted = true, additionalSpace = this._getWidthOfCharSpacing(), reservedSpace = reservedSpace || 0;
        if (words.length === 0) {
          words.push([]);
        }
        desiredWidth -= reservedSpace;
        for (var i = 0; i < words.length; i++) {
          word = splitByGrapheme ? words[i] : fabric22.util.string.graphemeSplit(words[i]);
          wordWidth = this._measureWord(word, lineIndex, offset);
          offset += word.length;
          lineWidth += infixWidth + wordWidth - additionalSpace;
          if (lineWidth > desiredWidth && !lineJustStarted) {
            graphemeLines.push(line);
            line = [];
            lineWidth = wordWidth;
            lineJustStarted = true;
          } else {
            lineWidth += additionalSpace;
          }
          if (!lineJustStarted && !splitByGrapheme) {
            line.push(infix);
          }
          line = line.concat(word);
          infixWidth = splitByGrapheme ? 0 : this._measureWord([infix], lineIndex, offset);
          offset++;
          lineJustStarted = false;
          if (wordWidth > largestWordWidth) {
            largestWordWidth = wordWidth;
          }
        }
        i && graphemeLines.push(line);
        if (largestWordWidth + reservedSpace > this.dynamicMinWidth) {
          this.dynamicMinWidth = largestWordWidth - additionalSpace + reservedSpace;
        }
        return graphemeLines;
      },
      /**
       * Detect if the text line is ended with an hard break
       * text and itext do not have wrapping, return false
       * @param {Number} lineIndex text to split
       * @return {Boolean}
       */
      isEndOfWrapping: function(lineIndex) {
        if (!this._styleMap[lineIndex + 1]) {
          return true;
        }
        if (this._styleMap[lineIndex + 1].line !== this._styleMap[lineIndex].line) {
          return true;
        }
        return false;
      },
      /**
       * Detect if a line has a linebreak and so we need to account for it when moving
       * and counting style.
       * @return Number
       */
      missingNewlineOffset: function(lineIndex) {
        if (this.splitByGrapheme) {
          return this.isEndOfWrapping(lineIndex) ? 1 : 0;
        }
        return 1;
      },
      /**
      * Gets lines of text to render in the Textbox. This function calculates
      * text wrapping on the fly every time it is called.
      * @param {String} text text to split
      * @returns {Array} Array of lines in the Textbox.
      * @override
      */
      _splitTextIntoLines: function(text) {
        var newText = fabric22.Text.prototype._splitTextIntoLines.call(this, text), graphemeLines = this._wrapText(newText.lines, this.width), lines = new Array(graphemeLines.length);
        for (var i = 0; i < graphemeLines.length; i++) {
          lines[i] = graphemeLines[i].join("");
        }
        newText.lines = lines;
        newText.graphemeLines = graphemeLines;
        return newText;
      },
      getMinWidth: function() {
        return Math.max(this.minWidth, this.dynamicMinWidth);
      },
      _removeExtraneousStyles: function() {
        var linesToKeep = {};
        for (var prop in this._styleMap) {
          if (this._textLines[prop]) {
            linesToKeep[this._styleMap[prop].line] = 1;
          }
        }
        for (var prop in this.styles) {
          if (!linesToKeep[prop]) {
            delete this.styles[prop];
          }
        }
      },
      /**
       * Returns object representation of an instance
       * @method toObject
       * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
       * @return {Object} object representation of an instance
       */
      toObject: function(propertiesToInclude) {
        return this.callSuper("toObject", ["minWidth", "splitByGrapheme"].concat(propertiesToInclude));
      }
    });
    fabric22.Textbox.fromObject = function(object, callback) {
      var styles = fabric22.util.stylesFromArray(object.styles, object.text);
      var objCopy = Object.assign({}, object, { styles });
      return fabric22.Object._fromObject("Textbox", objCopy, callback, "text");
    };
  })(exports);
  (function() {
    var controlsUtils = fabric2.controlsUtils, scaleSkewStyleHandler = controlsUtils.scaleSkewCursorStyleHandler, scaleStyleHandler = controlsUtils.scaleCursorStyleHandler, scalingEqually = controlsUtils.scalingEqually, scalingYOrSkewingX = controlsUtils.scalingYOrSkewingX, scalingXOrSkewingY = controlsUtils.scalingXOrSkewingY, scaleOrSkewActionName = controlsUtils.scaleOrSkewActionName, objectControls = fabric2.Object.prototype.controls;
    objectControls.ml = new fabric2.Control({
      x: -0.5,
      y: 0,
      cursorStyleHandler: scaleSkewStyleHandler,
      actionHandler: scalingXOrSkewingY,
      getActionName: scaleOrSkewActionName
    });
    objectControls.mr = new fabric2.Control({
      x: 0.5,
      y: 0,
      cursorStyleHandler: scaleSkewStyleHandler,
      actionHandler: scalingXOrSkewingY,
      getActionName: scaleOrSkewActionName
    });
    objectControls.mb = new fabric2.Control({
      x: 0,
      y: 0.5,
      cursorStyleHandler: scaleSkewStyleHandler,
      actionHandler: scalingYOrSkewingX,
      getActionName: scaleOrSkewActionName
    });
    objectControls.mt = new fabric2.Control({
      x: 0,
      y: -0.5,
      cursorStyleHandler: scaleSkewStyleHandler,
      actionHandler: scalingYOrSkewingX,
      getActionName: scaleOrSkewActionName
    });
    objectControls.tl = new fabric2.Control({
      x: -0.5,
      y: -0.5,
      cursorStyleHandler: scaleStyleHandler,
      actionHandler: scalingEqually
    });
    objectControls.tr = new fabric2.Control({
      x: 0.5,
      y: -0.5,
      cursorStyleHandler: scaleStyleHandler,
      actionHandler: scalingEqually
    });
    objectControls.bl = new fabric2.Control({
      x: -0.5,
      y: 0.5,
      cursorStyleHandler: scaleStyleHandler,
      actionHandler: scalingEqually
    });
    objectControls.br = new fabric2.Control({
      x: 0.5,
      y: 0.5,
      cursorStyleHandler: scaleStyleHandler,
      actionHandler: scalingEqually
    });
    objectControls.mtr = new fabric2.Control({
      x: 0,
      y: -0.5,
      actionHandler: controlsUtils.rotationWithSnapping,
      cursorStyleHandler: controlsUtils.rotationStyleHandler,
      offsetY: -40,
      withConnection: true,
      actionName: "rotate"
    });
    if (fabric2.Textbox) {
      var textBoxControls = fabric2.Textbox.prototype.controls = {};
      textBoxControls.mtr = objectControls.mtr;
      textBoxControls.tr = objectControls.tr;
      textBoxControls.br = objectControls.br;
      textBoxControls.tl = objectControls.tl;
      textBoxControls.bl = objectControls.bl;
      textBoxControls.mt = objectControls.mt;
      textBoxControls.mb = objectControls.mb;
      textBoxControls.mr = new fabric2.Control({
        x: 0.5,
        y: 0,
        actionHandler: controlsUtils.changeWidth,
        cursorStyleHandler: scaleSkewStyleHandler,
        actionName: "resizing"
      });
      textBoxControls.ml = new fabric2.Control({
        x: -0.5,
        y: 0,
        actionHandler: controlsUtils.changeWidth,
        cursorStyleHandler: scaleSkewStyleHandler,
        actionName: "resizing"
      });
    }
  })();
})(fabric);
function fabricObjToLayerObj(obj) {
  obj.includeDefaultValues = false;
  const data = obj.toDatalessObject();
  return data;
}
async function layerToFabricObj(layer) {
  if (!layer) {
    return;
  }
  const objs = [];
  if (typeof layer === "string") {
    objs.push(JSON.parse(layer));
  } else {
    objs.push(layer);
  }
  return new Promise((resolve) => {
    fabric.fabric.util.enlivenObjects(objs, (result) => resolve(result[0]), "");
  });
}
const defaultAvatarProperty = {
  type: "Avatar",
  version: "5.3.0",
  left: 1224.79354239,
  top: 257.3638853,
  width: 760,
  height: 1080,
  scaleX: 0.39822185,
  scaleY: 0.39822185,
  imgWidth: 760,
  imgHeight: 1080,
  initWidth: 700,
  halfbodyLeft: 1224.793542392999,
  halfbodyTop: 257.36388530384,
  halfbodyAngle: 0,
  halfbodyScaleX: 0.3982218453305828,
  halfbodyScaleY: 0.3982218453305828,
  _avatarType: "halfbody",
  _avatarBg: "#efefff",
  _avatarSquareBg: "rgba(0, 0, 0, 0)",
  _transparent_halfbody: false,
  _transparent_square: true,
  _transparent_circle: true,
  _avatarInfo: {
    name: "cdtanya",
    key: "system/asset/202403/660652f1685e0.png",
    url: "https://static.vidnoz.com/system/asset/202403/660652f1685e0.png",
    _staticUrl: "https://static.vidnoz.com/system/asset/202403/660652f1685e0.png",
    type: 2,
    gender: 2,
    voice_id: "21",
    config: {
      x: 95,
      y: 30,
      width: 560,
      height: 560
    },
    model_name: "cdtanya2_skr",
    _avatarType: "halfbody"
  },
  _version: "1.0.0",
  lockMovementX: false,
  lockMovementY: false,
  lockRotation: false,
  lockScalingFlip: true,
  lockScalingX: false,
  lockScalingY: false,
  objectCaching: false,
  padding: 0,
  absolutePositioned: false,
  //   _roleIndex: 1,
  objects: [
    {
      type: "AvatarImage",
      version: "5.3.0",
      originX: "center",
      originY: "center",
      left: 0,
      top: 0,
      width: 760,
      height: 1080,
      lockMovementX: false,
      lockMovementY: false,
      lockRotation: false,
      lockScalingFlip: false,
      lockScalingX: false,
      lockScalingY: false,
      objectCaching: false,
      padding: 0,
      absolutePositioned: false,
      src: "https://static.vidnoz.com/system/asset/202403/660652f1685e0.png",
      crossOrigin: "anonymous",
      filters: []
    },
    {
      type: "rect",
      version: "5.3.0",
      originX: "center",
      originY: "center",
      left: 0,
      top: 0,
      width: 760,
      height: 1080,
      lockMovementX: false,
      lockMovementY: false,
      lockRotation: false,
      lockScalingFlip: false,
      lockScalingX: false,
      lockScalingY: false,
      objectCaching: false,
      padding: 0,
      absolutePositioned: false
    },
    {
      type: "image",
      version: "5.3.0",
      originX: "center",
      originY: "center",
      left: 0,
      top: 0,
      width: 84,
      height: 83,
      lockMovementX: false,
      lockMovementY: false,
      lockRotation: false,
      lockScalingFlip: false,
      lockScalingX: false,
      lockScalingY: false,
      objectCaching: false,
      padding: 0,
      absolutePositioned: false,
      src: "https://s3.amazonaws.com/video-api-ai/system/app/static/img/avatar_placeholder.png",
      crossOrigin: "anonymous",
      filters: []
    }
  ]
};
function getDefaultAvatarConfig(config2, speechConfig) {
  const oldScaleX = config2.scaleX || 1;
  const oldWidth = config2.width * oldScaleX;
  const left = config2.left;
  const top = config2.top;
  const role = config2._roleIndex;
  const toConfig = JSON.parse(JSON.stringify(defaultAvatarProperty));
  toConfig.left = left;
  toConfig.top = top;
  toConfig.halfbodyLeft = toConfig.left;
  toConfig.halfbodyTop = toConfig.top;
  toConfig.scaleX = oldWidth / toConfig.width;
  toConfig.scaleY = toConfig.scaleX;
  toConfig.halfbodyScaleX = toConfig.scaleX;
  toConfig.halfbodyScaleY = toConfig.scaleY;
  if (config2.visible || !hasKey(config2, "visible")) {
    toConfig.visible = true;
  } else {
    toConfig.visible = false;
  }
  if (typeof role === "number") {
    toConfig._roleIndex = role;
  }
  if (hasKey(toConfig, "_roleIndex")) {
    const role2 = speechConfig.conversation.roles[toConfig._roleIndex];
    role2.key = toConfig._avatarInfo.key;
    role2.name = toConfig._avatarInfo.name;
    role2.gender = toConfig._avatarInfo.gender;
    role2.static_url = toConfig._avatarInfo._staticUrl;
    role2.url = toConfig._avatarInfo.url;
  }
  return toConfig;
}
function setBackgroundImagePromise(obj, cvs) {
  return new Promise((resolve, reject) => {
    cvs.setBackgroundImage(obj, () => {
      cvs.renderAll();
      resolve();
    });
  });
}
function createCustomImagePromise$1(url, options) {
  return new Promise((resolve, reject) => {
    fabric.fabric.CustomImage.fromURL(url, (img) => {
      resolve(img);
    }, {
      ...options
    });
  });
}
const fallbackList = [
  "Lexend",
  "Lato",
  "'Noto Sans'",
  "'Noto Sans Mono'",
  "'Noto Sans Display'",
  "'Noto Sans SC'",
  "'Noto Sans TC'",
  "'Noto Sans JP'",
  "'Noto Sans KR'",
  "'Noto Sans Thai'",
  "'Noto Sans Devanagari'",
  "'Noto Sans Malayalam'",
  "'Noto Sans Mongolian'",
  "'Noto Sans Hebrew'",
  "'Open Sans'",
  "Oswald",
  "Roboto",
  "Ubuntu",
  "Varela",
  "Rubik",
  "'Noto Emoji'",
  "Unicode BMP Fallback SIL"
];
const fonts = {
  "Zen Old Mincho Regular": "ZenOldMincho-Regular.ttf",
  "Zen Old Mincho Bold": "ZenOldMincho-Bold.ttf",
  "Zen Kaku Gothic New Regular": "ZenKakuGothicNew-Regular.ttf",
  "Zen Kaku Gothic New Bold": "ZenKakuGothicNew-Bold.ttf",
  "Ubuntu Regular": "Ubuntu-Regular.ttf",
  "Ubuntu Italic": "Ubuntu-Italic.ttf",
  "Ubuntu Bold Italic": "Ubuntu-BoldItalic.ttf",
  "Ubuntu Bold": "Ubuntu-Bold.ttf",
  "Tahoma Regular": "Tahoma.ttf",
  "Tahoma Bold": "Tahoma-Bold.ttf",
  "Roboto Regular": "Roboto-Regular.ttf",
  "Roboto Italic": "Roboto-Italic.ttf",
  "Roboto Bold Italic": "Roboto-BoldItalic.ttf",
  "Roboto Bold": "Roboto-Bold.ttf",
  "Pridi Regular": "Pridi-Regular.ttf",
  "Pridi Bold": "Pridi-Bold.ttf",
  "Poppins Regular": "Poppins-Regular.ttf",
  "Poppins Italic": "Poppins-Italic.ttf",
  "Poppins Bold Italic": "Poppins-BoldItalic.ttf",
  "Poppins Bold": "Poppins-Bold.ttf",
  "Oswald Regular": "Oswald-Regular.ttf",
  "Oswald Bold": "Oswald-Bold.ttf",
  "Orbitron Regular": "Orbitron-Regular.ttf",
  "Orbitron Bold": "Orbitron-Bold.ttf",
  "Open Sans Regular": "OpenSans-Regular.ttf",
  "Open Sans Italic": "OpenSans-Italic.ttf",
  "Open Sans Bold Italic": "OpenSans-BoldItalic.ttf",
  "Open Sans Bold": "OpenSans-Bold.ttf",
  "Noto Serif SC Regular": "NotoSerifSC-Regular.otf",
  "Noto Serif SC Bold": "NotoSerifSC-Bold.otf",
  "Noto Sans Thai Regular": "NotoSansThai-Regular.ttf",
  "Noto Sans Thai Bold": "NotoSansThai-Bold.ttf",
  "Noto Sans TC Regular": "NotoSansTC-Regular.otf",
  "Noto Sans TC Bold": "NotoSansTC-Bold.otf",
  "Noto Sans SC Regular": "NotoSansSC-Regular.otf",
  "Noto Sans SC Bold": "NotoSansSC-Bold.otf",
  "Noto Sans Mono Regular": "NotoSansMono-Regular.ttf",
  "Noto Sans Mono Bold": "NotoSansMono-Bold.ttf",
  "Noto Sans Malayalam Regular": "NotoSansMalayalam-Regular.ttf",
  "Noto Sans Malayalam Bold": "NotoSansMalayalam-Bold.ttf",
  "Noto Sans KR Regular": "NotoSansKR-Regular.otf",
  "Noto Sans KR Bold": "NotoSansKR-Bold.otf",
  "Noto Sans JP Regular": "NotoSansJP-Regular.ttf",
  "Noto Sans JP Bold": "NotoSansJP-Bold.ttf",
  "Noto Sans Hebrew Regular": "NotoSansHebrew-Regular.ttf",
  "Noto Sans Hebrew Bold": "NotoSansHebrew-Bold.ttf",
  "Noto Sans Display Regular": "NotoSansDisplay-Regular.ttf",
  "Noto Sans Display Italic": "NotoSansDisplay-Italic.ttf",
  "Noto Sans Display Bold Italic": "NotoSansDisplay-BoldItalic.ttf",
  "Noto Sans Display Bold": "NotoSansDisplay-Bold.ttf",
  "Noto Sans Devanagari Regular": "NotoSansDevanagari-Regular.ttf",
  "Noto Sans Devanagari Bold": "NotoSansDevanagari-Bold.ttf",
  "Noto Sans Regular": "NotoSans-Regular.ttf",
  "Noto Sans Italic": "NotoSans-Italic.ttf",
  "Noto Sans Bold Italic": "NotoSans-BoldItalic.ttf",
  "Noto Sans Bold": "NotoSans-Bold.ttf",
  "Noto Emoji Regular": "NotoEmoji-Regular.ttf",
  "Noto Emoji Bold": "NotoEmoji-Bold.ttf",
  "Libre Baskerville Regular": "LibreBaskerville-Regular.ttf",
  "Libre Baskerville Bold": "LibreBaskerville-Bold.ttf",
  "Lexend Deca Regular": "LexendDeca-Regular.ttf",
  "Lexend Deca Bold": "LexendDeca-Bold.ttf",
  "Lexend Regular": "Lexend-Regular.ttf",
  "Lexend Bold": "Lexend-Bold.ttf",
  "League Spartan Regular": "LeagueSpartan-Regular.ttf",
  "League Spartan Bold": "LeagueSpartan-Bold.ttf",
  "Lato Regular": "Lato-Regular.ttf",
  "Lato Italic": "Lato-Italic.ttf",
  "Lato Bold Italic": "Lato-BoldItalic.ttf",
  "Lato Bold": "Lato-Bold.ttf",
  "Josefin Sans Regular": "JosefinSans-Regular.ttf",
  "Josefin Sans Italic": "JosefinSans-Italic.ttf",
  "Josefin Sans Bold Italic": "JosefinSans-BoldItalic.ttf",
  "Josefin Sans Bold": "JosefinSans-Bold.ttf",
  "Fraunces 72pt Regular": "Fraunces72pt-Regular.ttf",
  "Fraunces 72pt Italic": "Fraunces72pt-Italic.ttf",
  "Fraunces 72pt Bold Italic": "Fraunces72pt-BoldItalic.ttf",
  "Fraunces 72pt Bold": "Fraunces72pt-Bold.ttf",
  "Dancing Script Regular": "DancingScript-Regular.ttf",
  "Dancing Script Bold": "DancingScript-Bold.ttf",
  "Comic Sans MS Regular": "ComicSansMS.ttf",
  "Comic Sans MS Italic": "ComicSansMS-Italic.ttf",
  "Comic Sans MS Bold Italic": "ComicSansMS-BoldItalic.ttf",
  "Comic Sans MS Bold": "ComicSansMS-Bold.ttf",
  "Cabin Regular": "Cabin-Regular.ttf",
  "Cabin Italic": "Cabin-Italic.ttf",
  "Cabin Bold Italic": "Cabin-BoldItalic.ttf",
  "Cabin Bold": "Cabin-Bold.ttf",
  "Bodoni Moda Regular": "BodoniModa-Regular.ttf",
  "Bodoni Moda Italic": "BodoniModa-Italic.ttf",
  "Belanosima Regular": "Belanosima-Regular.ttf",
  "Belanosima Bold": "Belanosima-Bold.ttf",
  "Barlow Condensed Regular": "BarlowCondensed-Regular.ttf",
  "Barlow Condensed Italic": "BarlowCondensed-Italic.ttf",
  "Barlow Condensed Bold Italic": "BarlowCondensed-BoldItalic.ttf",
  "Barlow Condensed Bold": "BarlowCondensed-Bold.ttf",
  "Anton Regular": "Anton-Regular.ttf",
  "Bebas Neue Regular": "BebasNeue-Regular.ttf",
  "Belanosima SemiBold Regular": "Belanosima-SemiBold.ttf",
  "Berlin Sans FB Demi Regular": "BerlinSansFBDemi-Bold.ttf",
  "Carter One Regular": "CarterOne.ttf",
  "Chela One Regular": "ChelaOne-Regular.ttf",
  "Chewy Regular": "Chewy-Regular.ttf",
  "Damion Regular": "Damion.ttf",
  "Galada Regular": "Galada-Regular.ttf",
  "HelveticaRounded LT Std Bd Regular": "HelveticaRoundedLTStd-Bd.otf",
  "Leckerli One Regular": "LeckerliOne-Regular.ttf",
  "Lobster Regular": "Lobster-Regular.ttf",
  "Monoton Regular": "Monoton-Regular.ttf",
  "Noto Emoji Light Regular": "NotoEmoji-Light.ttf",
  "Noto Emoji Medium Regular": "NotoEmoji-Medium.ttf",
  "Noto Emoji SemiBold Regular": "NotoEmoji-SemiBold.ttf",
  "Noto Sans Mongolian Regular": "NotoSansMongolian-Regular.ttf",
  "Potta One Regular": "PottaOne-Regular.ttf",
  "Rubik Regular": "Rubik-Regular.ttf",
  "Unicode BMP Fallback SIL Regular": "UnicodeBMPFallbackSIL.ttf",
  "Varela Regular": "Varela.ttf",
  "Yeseva One Regular": "YesevaOne-Regular.ttf",
  "Yesteryear Regular": "Yesteryear-Regular.ttf"
};
class DefApiError extends Error {
  constructor(message, cause) {
    super(message, cause);
    this.name = "DefApiError";
  }
}
function createDefApiError(api, res2) {
  const err = new DefApiError(`${api} error: ${res2 == null ? void 0 : res2.code}`, {
    cause: {
      api,
      res: res2
    }
  });
  return err;
}
var jquery = { exports: {} };
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
(function(module) {
  (function(global, factory) {
    {
      module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) {
          throw new Error("jQuery requires a window with a document");
        }
        return factory(w);
      };
    }
  })(typeof window !== "undefined" ? window : commonjsGlobal, function(window2, noGlobal) {
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
      return arr.flat.call(array);
    } : function(array) {
      return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction2(obj) {
      return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow2(obj) {
      return obj != null && obj === obj.window;
    };
    var document2 = window2.document;
    var preservedScriptAttributes = {
      type: true,
      src: true,
      nonce: true,
      noModule: true
    };
    function DOMEval(code, node, doc) {
      doc = doc || document2;
      var i, val, script = doc.createElement("script");
      script.text = code;
      if (node) {
        for (i in preservedScriptAttributes) {
          val = node[i] || node.getAttribute && node.getAttribute(i);
          if (val) {
            script.setAttribute(i, val);
          }
        }
      }
      doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
      if (obj == null) {
        return obj + "";
      }
      return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, jQuery = function(selector, context) {
      return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
      // The current version of jQuery being used
      jquery: version,
      constructor: jQuery,
      // The default length of a jQuery object is 0
      length: 0,
      toArray: function() {
        return slice.call(this);
      },
      // Get the Nth element in the matched element set OR
      // Get the whole matched element set as a clean array
      get: function(num) {
        if (num == null) {
          return slice.call(this);
        }
        return num < 0 ? this[num + this.length] : this[num];
      },
      // Take an array of elements and push it onto the stack
      // (returning the new matched element set)
      pushStack: function(elems) {
        var ret = jQuery.merge(this.constructor(), elems);
        ret.prevObject = this;
        return ret;
      },
      // Execute a callback for every element in the matched set.
      each: function(callback) {
        return jQuery.each(this, callback);
      },
      map: function(callback) {
        return this.pushStack(jQuery.map(this, function(elem, i) {
          return callback.call(elem, i, elem);
        }));
      },
      slice: function() {
        return this.pushStack(slice.apply(this, arguments));
      },
      first: function() {
        return this.eq(0);
      },
      last: function() {
        return this.eq(-1);
      },
      even: function() {
        return this.pushStack(jQuery.grep(this, function(_elem, i) {
          return (i + 1) % 2;
        }));
      },
      odd: function() {
        return this.pushStack(jQuery.grep(this, function(_elem, i) {
          return i % 2;
        }));
      },
      eq: function(i) {
        var len = this.length, j = +i + (i < 0 ? len : 0);
        return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
      },
      end: function() {
        return this.prevObject || this.constructor();
      },
      // For internal use only.
      // Behaves like an Array's method, not like a jQuery method.
      push,
      sort: arr.sort,
      splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
      var options, name2, src, copy, copyIsArray, clone2, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
      if (typeof target === "boolean") {
        deep = target;
        target = arguments[i] || {};
        i++;
      }
      if (typeof target !== "object" && !isFunction(target)) {
        target = {};
      }
      if (i === length) {
        target = this;
        i--;
      }
      for (; i < length; i++) {
        if ((options = arguments[i]) != null) {
          for (name2 in options) {
            copy = options[name2];
            if (name2 === "__proto__" || target === copy) {
              continue;
            }
            if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
              src = target[name2];
              if (copyIsArray && !Array.isArray(src)) {
                clone2 = [];
              } else if (!copyIsArray && !jQuery.isPlainObject(src)) {
                clone2 = {};
              } else {
                clone2 = src;
              }
              copyIsArray = false;
              target[name2] = jQuery.extend(deep, clone2, copy);
            } else if (copy !== void 0) {
              target[name2] = copy;
            }
          }
        }
      }
      return target;
    };
    jQuery.extend({
      // Unique for each copy of jQuery on the page
      expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
      // Assume jQuery is ready without the ready module
      isReady: true,
      error: function(msg) {
        throw new Error(msg);
      },
      noop: function() {
      },
      isPlainObject: function(obj) {
        var proto2, Ctor;
        if (!obj || toString.call(obj) !== "[object Object]") {
          return false;
        }
        proto2 = getProto(obj);
        if (!proto2) {
          return true;
        }
        Ctor = hasOwn.call(proto2, "constructor") && proto2.constructor;
        return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
      },
      isEmptyObject: function(obj) {
        var name2;
        for (name2 in obj) {
          return false;
        }
        return true;
      },
      // Evaluates a script in a provided context; falls back to the global one
      // if not specified.
      globalEval: function(code, options, doc) {
        DOMEval(code, { nonce: options && options.nonce }, doc);
      },
      each: function(obj, callback) {
        var length, i = 0;
        if (isArrayLike(obj)) {
          length = obj.length;
          for (; i < length; i++) {
            if (callback.call(obj[i], i, obj[i]) === false) {
              break;
            }
          }
        } else {
          for (i in obj) {
            if (callback.call(obj[i], i, obj[i]) === false) {
              break;
            }
          }
        }
        return obj;
      },
      // Retrieve the text value of an array of DOM nodes
      text: function(elem) {
        var node, ret = "", i = 0, nodeType = elem.nodeType;
        if (!nodeType) {
          while (node = elem[i++]) {
            ret += jQuery.text(node);
          }
        }
        if (nodeType === 1 || nodeType === 11) {
          return elem.textContent;
        }
        if (nodeType === 9) {
          return elem.documentElement.textContent;
        }
        if (nodeType === 3 || nodeType === 4) {
          return elem.nodeValue;
        }
        return ret;
      },
      // results is for internal usage only
      makeArray: function(arr2, results) {
        var ret = results || [];
        if (arr2 != null) {
          if (isArrayLike(Object(arr2))) {
            jQuery.merge(
              ret,
              typeof arr2 === "string" ? [arr2] : arr2
            );
          } else {
            push.call(ret, arr2);
          }
        }
        return ret;
      },
      inArray: function(elem, arr2, i) {
        return arr2 == null ? -1 : indexOf.call(arr2, elem, i);
      },
      isXMLDoc: function(elem) {
        var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
        return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
      },
      // Support: Android <=4.0 only, PhantomJS 1 only
      // push.apply(_, arraylike) throws on ancient WebKit
      merge: function(first, second) {
        var len = +second.length, j = 0, i = first.length;
        for (; j < len; j++) {
          first[i++] = second[j];
        }
        first.length = i;
        return first;
      },
      grep: function(elems, callback, invert) {
        var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
        for (; i < length; i++) {
          callbackInverse = !callback(elems[i], i);
          if (callbackInverse !== callbackExpect) {
            matches.push(elems[i]);
          }
        }
        return matches;
      },
      // arg is for internal usage only
      map: function(elems, callback, arg) {
        var length, value, i = 0, ret = [];
        if (isArrayLike(elems)) {
          length = elems.length;
          for (; i < length; i++) {
            value = callback(elems[i], i, arg);
            if (value != null) {
              ret.push(value);
            }
          }
        } else {
          for (i in elems) {
            value = callback(elems[i], i, arg);
            if (value != null) {
              ret.push(value);
            }
          }
        }
        return flat(ret);
      },
      // A global GUID counter for objects
      guid: 1,
      // jQuery.support is not used in Core but other projects attach their
      // properties to it so it needs to exist.
      support
    });
    if (typeof Symbol === "function") {
      jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    }
    jQuery.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),
      function(_i, name2) {
        class2type["[object " + name2 + "]"] = name2.toLowerCase();
      }
    );
    function isArrayLike(obj) {
      var length = !!obj && "length" in obj && obj.length, type = toType(obj);
      if (isFunction(obj) || isWindow(obj)) {
        return false;
      }
      return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name2) {
      return elem.nodeName && elem.nodeName.toLowerCase() === name2.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp(
      "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
      "g"
    );
    jQuery.contains = function(a, b) {
      var bup = b && b.parentNode;
      return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
      // IE doesn't have `contains` on SVG.
      (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
      if (asCodePoint) {
        if (ch === "\0") {
          return "�";
        }
        return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
      }
      return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
      return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document2, pushNative = push;
    (function() {
      var i, Expr, outermostContext, sortInput, hasDuplicate, push2 = pushNative, document22, documentElement2, documentIsHTML, rbuggyQSA, matches, expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
        if (a === b) {
          hasDuplicate = true;
        }
        return 0;
      }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
      "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
      `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` + attributes + ")*)|.*)\\)|)", rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
        ID: new RegExp("^#(" + identifier + ")"),
        CLASS: new RegExp("^\\.(" + identifier + ")"),
        TAG: new RegExp("^(" + identifier + "|[*])"),
        ATTR: new RegExp("^" + attributes),
        PSEUDO: new RegExp("^" + pseudos),
        CHILD: new RegExp(
          "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)",
          "i"
        ),
        bool: new RegExp("^(?:" + booleans + ")$", "i"),
        // For use in libraries implementing .is()
        // We use this for POS matching in `select`
        needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
      }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rquickExpr2 = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
        var high = "0x" + escape.slice(1) - 65536;
        if (nonHex) {
          return nonHex;
        }
        return high < 0 ? String.fromCharCode(high + 65536) : String.fromCharCode(high >> 10 | 55296, high & 1023 | 56320);
      }, unloadHandler = function() {
        setDocument();
      }, inDisabledFieldset = addCombinator(
        function(elem) {
          return elem.disabled === true && nodeName(elem, "fieldset");
        },
        { dir: "parentNode", next: "legend" }
      );
      function safeActiveElement() {
        try {
          return document22.activeElement;
        } catch (err) {
        }
      }
      try {
        push2.apply(
          arr = slice.call(preferredDoc.childNodes),
          preferredDoc.childNodes
        );
        arr[preferredDoc.childNodes.length].nodeType;
      } catch (e) {
        push2 = {
          apply: function(target, els) {
            pushNative.apply(target, slice.call(els));
          },
          call: function(target) {
            pushNative.apply(target, slice.call(arguments, 1));
          }
        };
      }
      function find(selector, context, results, seed) {
        var m, i2, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, nodeType = context ? context.nodeType : 9;
        results = results || [];
        if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {
          return results;
        }
        if (!seed) {
          setDocument(context);
          context = context || document22;
          if (documentIsHTML) {
            if (nodeType !== 11 && (match = rquickExpr2.exec(selector))) {
              if (m = match[1]) {
                if (nodeType === 9) {
                  if (elem = context.getElementById(m)) {
                    if (elem.id === m) {
                      push2.call(results, elem);
                      return results;
                    }
                  } else {
                    return results;
                  }
                } else {
                  if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                    push2.call(results, elem);
                    return results;
                  }
                }
              } else if (match[2]) {
                push2.apply(results, context.getElementsByTagName(selector));
                return results;
              } else if ((m = match[3]) && context.getElementsByClassName) {
                push2.apply(results, context.getElementsByClassName(m));
                return results;
              }
            }
            if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
              newSelector = selector;
              newContext = context;
              if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                if (newContext != context || !support.scope) {
                  if (nid = context.getAttribute("id")) {
                    nid = jQuery.escapeSelector(nid);
                  } else {
                    context.setAttribute("id", nid = expando);
                  }
                }
                groups = tokenize2(selector);
                i2 = groups.length;
                while (i2--) {
                  groups[i2] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i2]);
                }
                newSelector = groups.join(",");
              }
              try {
                push2.apply(
                  results,
                  newContext.querySelectorAll(newSelector)
                );
                return results;
              } catch (qsaError) {
                nonnativeSelectorCache(selector, true);
              } finally {
                if (nid === expando) {
                  context.removeAttribute("id");
                }
              }
            }
          }
        }
        return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
      }
      function createCache() {
        var keys = [];
        function cache2(key, value) {
          if (keys.push(key + " ") > Expr.cacheLength) {
            delete cache2[keys.shift()];
          }
          return cache2[key + " "] = value;
        }
        return cache2;
      }
      function markFunction(fn) {
        fn[expando] = true;
        return fn;
      }
      function assert(fn) {
        var el = document22.createElement("fieldset");
        try {
          return !!fn(el);
        } catch (e) {
          return false;
        } finally {
          if (el.parentNode) {
            el.parentNode.removeChild(el);
          }
          el = null;
        }
      }
      function createInputPseudo(type) {
        return function(elem) {
          return nodeName(elem, "input") && elem.type === type;
        };
      }
      function createButtonPseudo(type) {
        return function(elem) {
          return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
        };
      }
      function createDisabledPseudo(disabled) {
        return function(elem) {
          if ("form" in elem) {
            if (elem.parentNode && elem.disabled === false) {
              if ("label" in elem) {
                if ("label" in elem.parentNode) {
                  return elem.parentNode.disabled === disabled;
                } else {
                  return elem.disabled === disabled;
                }
              }
              return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
              elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
            }
            return elem.disabled === disabled;
          } else if ("label" in elem) {
            return elem.disabled === disabled;
          }
          return false;
        };
      }
      function createPositionalPseudo(fn) {
        return markFunction(function(argument) {
          argument = +argument;
          return markFunction(function(seed, matches2) {
            var j, matchIndexes = fn([], seed.length, argument), i2 = matchIndexes.length;
            while (i2--) {
              if (seed[j = matchIndexes[i2]]) {
                seed[j] = !(matches2[j] = seed[j]);
              }
            }
          });
        });
      }
      function testContext(context) {
        return context && typeof context.getElementsByTagName !== "undefined" && context;
      }
      function setDocument(node) {
        var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
        if (doc == document22 || doc.nodeType !== 9 || !doc.documentElement) {
          return document22;
        }
        document22 = doc;
        documentElement2 = document22.documentElement;
        documentIsHTML = !jQuery.isXMLDoc(document22);
        matches = documentElement2.matches || documentElement2.webkitMatchesSelector || documentElement2.msMatchesSelector;
        if (documentElement2.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        preferredDoc != document22 && (subWindow = document22.defaultView) && subWindow.top !== subWindow) {
          subWindow.addEventListener("unload", unloadHandler);
        }
        support.getById = assert(function(el) {
          documentElement2.appendChild(el).id = jQuery.expando;
          return !document22.getElementsByName || !document22.getElementsByName(jQuery.expando).length;
        });
        support.disconnectedMatch = assert(function(el) {
          return matches.call(el, "*");
        });
        support.scope = assert(function() {
          return document22.querySelectorAll(":scope");
        });
        support.cssHas = assert(function() {
          try {
            document22.querySelector(":has(*,:jqfake)");
            return false;
          } catch (e) {
            return true;
          }
        });
        if (support.getById) {
          Expr.filter.ID = function(id) {
            var attrId = id.replace(runescape, funescape);
            return function(elem) {
              return elem.getAttribute("id") === attrId;
            };
          };
          Expr.find.ID = function(id, context) {
            if (typeof context.getElementById !== "undefined" && documentIsHTML) {
              var elem = context.getElementById(id);
              return elem ? [elem] : [];
            }
          };
        } else {
          Expr.filter.ID = function(id) {
            var attrId = id.replace(runescape, funescape);
            return function(elem) {
              var node2 = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
              return node2 && node2.value === attrId;
            };
          };
          Expr.find.ID = function(id, context) {
            if (typeof context.getElementById !== "undefined" && documentIsHTML) {
              var node2, i2, elems, elem = context.getElementById(id);
              if (elem) {
                node2 = elem.getAttributeNode("id");
                if (node2 && node2.value === id) {
                  return [elem];
                }
                elems = context.getElementsByName(id);
                i2 = 0;
                while (elem = elems[i2++]) {
                  node2 = elem.getAttributeNode("id");
                  if (node2 && node2.value === id) {
                    return [elem];
                  }
                }
              }
              return [];
            }
          };
        }
        Expr.find.TAG = function(tag2, context) {
          if (typeof context.getElementsByTagName !== "undefined") {
            return context.getElementsByTagName(tag2);
          } else {
            return context.querySelectorAll(tag2);
          }
        };
        Expr.find.CLASS = function(className, context) {
          if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
            return context.getElementsByClassName(className);
          }
        };
        rbuggyQSA = [];
        assert(function(el) {
          var input;
          documentElement2.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a><select id='" + expando + "-\r\\' disabled='disabled'><option selected=''></option></select>";
          if (!el.querySelectorAll("[selected]").length) {
            rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
          }
          if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
            rbuggyQSA.push("~=");
          }
          if (!el.querySelectorAll("a#" + expando + "+*").length) {
            rbuggyQSA.push(".#.+[+~]");
          }
          if (!el.querySelectorAll(":checked").length) {
            rbuggyQSA.push(":checked");
          }
          input = document22.createElement("input");
          input.setAttribute("type", "hidden");
          el.appendChild(input).setAttribute("name", "D");
          documentElement2.appendChild(el).disabled = true;
          if (el.querySelectorAll(":disabled").length !== 2) {
            rbuggyQSA.push(":enabled", ":disabled");
          }
          input = document22.createElement("input");
          input.setAttribute("name", "");
          el.appendChild(input);
          if (!el.querySelectorAll("[name='']").length) {
            rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + `*(?:''|"")`);
          }
        });
        if (!support.cssHas) {
          rbuggyQSA.push(":has");
        }
        rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
        sortOrder = function(a, b) {
          if (a === b) {
            hasDuplicate = true;
            return 0;
          }
          var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
          if (compare) {
            return compare;
          }
          compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : (
            // Otherwise we know they are disconnected
            1
          );
          if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
            if (a === document22 || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) {
              return -1;
            }
            if (b === document22 || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) {
              return 1;
            }
            return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
          }
          return compare & 4 ? -1 : 1;
        };
        return document22;
      }
      find.matches = function(expr, elements) {
        return find(expr, null, null, elements);
      };
      find.matchesSelector = function(elem, expr) {
        setDocument(elem);
        if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
          try {
            var ret = matches.call(elem, expr);
            if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
            // fragment in IE 9
            elem.document && elem.document.nodeType !== 11) {
              return ret;
            }
          } catch (e) {
            nonnativeSelectorCache(expr, true);
          }
        }
        return find(expr, document22, null, [elem]).length > 0;
      };
      find.contains = function(context, elem) {
        if ((context.ownerDocument || context) != document22) {
          setDocument(context);
        }
        return jQuery.contains(context, elem);
      };
      find.attr = function(elem, name2) {
        if ((elem.ownerDocument || elem) != document22) {
          setDocument(elem);
        }
        var fn = Expr.attrHandle[name2.toLowerCase()], val = fn && hasOwn.call(Expr.attrHandle, name2.toLowerCase()) ? fn(elem, name2, !documentIsHTML) : void 0;
        if (val !== void 0) {
          return val;
        }
        return elem.getAttribute(name2);
      };
      find.error = function(msg) {
        throw new Error("Syntax error, unrecognized expression: " + msg);
      };
      jQuery.uniqueSort = function(results) {
        var elem, duplicates = [], j = 0, i2 = 0;
        hasDuplicate = !support.sortStable;
        sortInput = !support.sortStable && slice.call(results, 0);
        sort.call(results, sortOrder);
        if (hasDuplicate) {
          while (elem = results[i2++]) {
            if (elem === results[i2]) {
              j = duplicates.push(i2);
            }
          }
          while (j--) {
            splice.call(results, duplicates[j], 1);
          }
        }
        sortInput = null;
        return results;
      };
      jQuery.fn.uniqueSort = function() {
        return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
      };
      Expr = jQuery.expr = {
        // Can be adjusted by the user
        cacheLength: 50,
        createPseudo: markFunction,
        match: matchExpr,
        attrHandle: {},
        find: {},
        relative: {
          ">": { dir: "parentNode", first: true },
          " ": { dir: "parentNode" },
          "+": { dir: "previousSibling", first: true },
          "~": { dir: "previousSibling" }
        },
        preFilter: {
          ATTR: function(match) {
            match[1] = match[1].replace(runescape, funescape);
            match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
            if (match[2] === "~=") {
              match[3] = " " + match[3] + " ";
            }
            return match.slice(0, 4);
          },
          CHILD: function(match) {
            match[1] = match[1].toLowerCase();
            if (match[1].slice(0, 3) === "nth") {
              if (!match[3]) {
                find.error(match[0]);
              }
              match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
              match[5] = +(match[7] + match[8] || match[3] === "odd");
            } else if (match[3]) {
              find.error(match[0]);
            }
            return match;
          },
          PSEUDO: function(match) {
            var excess, unquoted = !match[6] && match[2];
            if (matchExpr.CHILD.test(match[0])) {
              return null;
            }
            if (match[3]) {
              match[2] = match[4] || match[5] || "";
            } else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
            (excess = tokenize2(unquoted, true)) && // advance to the next closing parenthesis
            (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
              match[0] = match[0].slice(0, excess);
              match[2] = unquoted.slice(0, excess);
            }
            return match.slice(0, 3);
          }
        },
        filter: {
          TAG: function(nodeNameSelector) {
            var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
            return nodeNameSelector === "*" ? function() {
              return true;
            } : function(elem) {
              return nodeName(elem, expectedNodeName);
            };
          },
          CLASS: function(className) {
            var pattern = classCache[className + " "];
            return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && classCache(className, function(elem) {
              return pattern.test(
                typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || ""
              );
            });
          },
          ATTR: function(name2, operator, check) {
            return function(elem) {
              var result = find.attr(elem, name2);
              if (result == null) {
                return operator === "!=";
              }
              if (!operator) {
                return true;
              }
              result += "";
              if (operator === "=") {
                return result === check;
              }
              if (operator === "!=") {
                return result !== check;
              }
              if (operator === "^=") {
                return check && result.indexOf(check) === 0;
              }
              if (operator === "*=") {
                return check && result.indexOf(check) > -1;
              }
              if (operator === "$=") {
                return check && result.slice(-check.length) === check;
              }
              if (operator === "~=") {
                return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
              }
              if (operator === "|=") {
                return result === check || result.slice(0, check.length + 1) === check + "-";
              }
              return false;
            };
          },
          CHILD: function(type, what, _argument, first, last) {
            var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
            return first === 1 && last === 0 ? (
              // Shortcut for :nth-*(n)
              function(elem) {
                return !!elem.parentNode;
              }
            ) : function(elem, _context, xml) {
              var cache2, outerCache, node, nodeIndex, start, dir2 = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name2 = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
              if (parent) {
                if (simple) {
                  while (dir2) {
                    node = elem;
                    while (node = node[dir2]) {
                      if (ofType ? nodeName(node, name2) : node.nodeType === 1) {
                        return false;
                      }
                    }
                    start = dir2 = type === "only" && !start && "nextSibling";
                  }
                  return true;
                }
                start = [forward ? parent.firstChild : parent.lastChild];
                if (forward && useCache) {
                  outerCache = parent[expando] || (parent[expando] = {});
                  cache2 = outerCache[type] || [];
                  nodeIndex = cache2[0] === dirruns && cache2[1];
                  diff = nodeIndex && cache2[2];
                  node = nodeIndex && parent.childNodes[nodeIndex];
                  while (node = ++nodeIndex && node && node[dir2] || // Fallback to seeking `elem` from the start
                  (diff = nodeIndex = 0) || start.pop()) {
                    if (node.nodeType === 1 && ++diff && node === elem) {
                      outerCache[type] = [dirruns, nodeIndex, diff];
                      break;
                    }
                  }
                } else {
                  if (useCache) {
                    outerCache = elem[expando] || (elem[expando] = {});
                    cache2 = outerCache[type] || [];
                    nodeIndex = cache2[0] === dirruns && cache2[1];
                    diff = nodeIndex;
                  }
                  if (diff === false) {
                    while (node = ++nodeIndex && node && node[dir2] || (diff = nodeIndex = 0) || start.pop()) {
                      if ((ofType ? nodeName(node, name2) : node.nodeType === 1) && ++diff) {
                        if (useCache) {
                          outerCache = node[expando] || (node[expando] = {});
                          outerCache[type] = [dirruns, diff];
                        }
                        if (node === elem) {
                          break;
                        }
                      }
                    }
                  }
                }
                diff -= last;
                return diff === first || diff % first === 0 && diff / first >= 0;
              }
            };
          },
          PSEUDO: function(pseudo, argument) {
            var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
            if (fn[expando]) {
              return fn(argument);
            }
            if (fn.length > 1) {
              args = [pseudo, pseudo, "", argument];
              return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches2) {
                var idx, matched = fn(seed, argument), i2 = matched.length;
                while (i2--) {
                  idx = indexOf.call(seed, matched[i2]);
                  seed[idx] = !(matches2[idx] = matched[i2]);
                }
              }) : function(elem) {
                return fn(elem, 0, args);
              };
            }
            return fn;
          }
        },
        pseudos: {
          // Potentially complex pseudos
          not: markFunction(function(selector) {
            var input = [], results = [], matcher = compile2(selector.replace(rtrimCSS, "$1"));
            return matcher[expando] ? markFunction(function(seed, matches2, _context, xml) {
              var elem, unmatched = matcher(seed, null, xml, []), i2 = seed.length;
              while (i2--) {
                if (elem = unmatched[i2]) {
                  seed[i2] = !(matches2[i2] = elem);
                }
              }
            }) : function(elem, _context, xml) {
              input[0] = elem;
              matcher(input, null, xml, results);
              input[0] = null;
              return !results.pop();
            };
          }),
          has: markFunction(function(selector) {
            return function(elem) {
              return find(selector, elem).length > 0;
            };
          }),
          contains: markFunction(function(text) {
            text = text.replace(runescape, funescape);
            return function(elem) {
              return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
            };
          }),
          // "Whether an element is represented by a :lang() selector
          // is based solely on the element's language value
          // being equal to the identifier C,
          // or beginning with the identifier C immediately followed by "-".
          // The matching of C against the element's language value is performed case-insensitively.
          // The identifier C does not have to be a valid language name."
          // https://www.w3.org/TR/selectors/#lang-pseudo
          lang: markFunction(function(lang) {
            if (!ridentifier.test(lang || "")) {
              find.error("unsupported lang: " + lang);
            }
            lang = lang.replace(runescape, funescape).toLowerCase();
            return function(elem) {
              var elemLang;
              do {
                if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                  elemLang = elemLang.toLowerCase();
                  return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                }
              } while ((elem = elem.parentNode) && elem.nodeType === 1);
              return false;
            };
          }),
          // Miscellaneous
          target: function(elem) {
            var hash = window2.location && window2.location.hash;
            return hash && hash.slice(1) === elem.id;
          },
          root: function(elem) {
            return elem === documentElement2;
          },
          focus: function(elem) {
            return elem === safeActiveElement() && document22.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
          },
          // Boolean properties
          enabled: createDisabledPseudo(false),
          disabled: createDisabledPseudo(true),
          checked: function(elem) {
            return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
          },
          selected: function(elem) {
            if (elem.parentNode) {
              elem.parentNode.selectedIndex;
            }
            return elem.selected === true;
          },
          // Contents
          empty: function(elem) {
            for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
              if (elem.nodeType < 6) {
                return false;
              }
            }
            return true;
          },
          parent: function(elem) {
            return !Expr.pseudos.empty(elem);
          },
          // Element/input types
          header: function(elem) {
            return rheader.test(elem.nodeName);
          },
          input: function(elem) {
            return rinputs.test(elem.nodeName);
          },
          button: function(elem) {
            return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
          },
          text: function(elem) {
            var attr;
            return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
            // New HTML5 attribute values (e.g., "search") appear
            // with elem.type === "text"
            ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
          },
          // Position-in-collection
          first: createPositionalPseudo(function() {
            return [0];
          }),
          last: createPositionalPseudo(function(_matchIndexes, length) {
            return [length - 1];
          }),
          eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
            return [argument < 0 ? argument + length : argument];
          }),
          even: createPositionalPseudo(function(matchIndexes, length) {
            var i2 = 0;
            for (; i2 < length; i2 += 2) {
              matchIndexes.push(i2);
            }
            return matchIndexes;
          }),
          odd: createPositionalPseudo(function(matchIndexes, length) {
            var i2 = 1;
            for (; i2 < length; i2 += 2) {
              matchIndexes.push(i2);
            }
            return matchIndexes;
          }),
          lt: createPositionalPseudo(function(matchIndexes, length, argument) {
            var i2;
            if (argument < 0) {
              i2 = argument + length;
            } else if (argument > length) {
              i2 = length;
            } else {
              i2 = argument;
            }
            for (; --i2 >= 0; ) {
              matchIndexes.push(i2);
            }
            return matchIndexes;
          }),
          gt: createPositionalPseudo(function(matchIndexes, length, argument) {
            var i2 = argument < 0 ? argument + length : argument;
            for (; ++i2 < length; ) {
              matchIndexes.push(i2);
            }
            return matchIndexes;
          })
        }
      };
      Expr.pseudos.nth = Expr.pseudos.eq;
      for (i in { radio: true, checkbox: true, file: true, password: true, image: true }) {
        Expr.pseudos[i] = createInputPseudo(i);
      }
      for (i in { submit: true, reset: true }) {
        Expr.pseudos[i] = createButtonPseudo(i);
      }
      function setFilters() {
      }
      setFilters.prototype = Expr.filters = Expr.pseudos;
      Expr.setFilters = new setFilters();
      function tokenize2(selector, parseOnly) {
        var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
        if (cached) {
          return parseOnly ? 0 : cached.slice(0);
        }
        soFar = selector;
        groups = [];
        preFilters = Expr.preFilter;
        while (soFar) {
          if (!matched || (match = rcomma.exec(soFar))) {
            if (match) {
              soFar = soFar.slice(match[0].length) || soFar;
            }
            groups.push(tokens = []);
          }
          matched = false;
          if (match = rleadingCombinator.exec(soFar)) {
            matched = match.shift();
            tokens.push({
              value: matched,
              // Cast descendant combinators to space
              type: match[0].replace(rtrimCSS, " ")
            });
            soFar = soFar.slice(matched.length);
          }
          for (type in Expr.filter) {
            if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
              matched = match.shift();
              tokens.push({
                value: matched,
                type,
                matches: match
              });
              soFar = soFar.slice(matched.length);
            }
          }
          if (!matched) {
            break;
          }
        }
        if (parseOnly) {
          return soFar.length;
        }
        return soFar ? find.error(selector) : (
          // Cache the tokens
          tokenCache(selector, groups).slice(0)
        );
      }
      function toSelector(tokens) {
        var i2 = 0, len = tokens.length, selector = "";
        for (; i2 < len; i2++) {
          selector += tokens[i2].value;
        }
        return selector;
      }
      function addCombinator(matcher, combinator, base) {
        var dir2 = combinator.dir, skip = combinator.next, key = skip || dir2, checkNonElements = base && key === "parentNode", doneName = done++;
        return combinator.first ? (
          // Check against closest ancestor/preceding element
          function(elem, context, xml) {
            while (elem = elem[dir2]) {
              if (elem.nodeType === 1 || checkNonElements) {
                return matcher(elem, context, xml);
              }
            }
            return false;
          }
        ) : (
          // Check against all ancestor/preceding elements
          function(elem, context, xml) {
            var oldCache, outerCache, newCache = [dirruns, doneName];
            if (xml) {
              while (elem = elem[dir2]) {
                if (elem.nodeType === 1 || checkNonElements) {
                  if (matcher(elem, context, xml)) {
                    return true;
                  }
                }
              }
            } else {
              while (elem = elem[dir2]) {
                if (elem.nodeType === 1 || checkNonElements) {
                  outerCache = elem[expando] || (elem[expando] = {});
                  if (skip && nodeName(elem, skip)) {
                    elem = elem[dir2] || elem;
                  } else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
                    return newCache[2] = oldCache[2];
                  } else {
                    outerCache[key] = newCache;
                    if (newCache[2] = matcher(elem, context, xml)) {
                      return true;
                    }
                  }
                }
              }
            }
            return false;
          }
        );
      }
      function elementMatcher(matchers) {
        return matchers.length > 1 ? function(elem, context, xml) {
          var i2 = matchers.length;
          while (i2--) {
            if (!matchers[i2](elem, context, xml)) {
              return false;
            }
          }
          return true;
        } : matchers[0];
      }
      function multipleContexts(selector, contexts, results) {
        var i2 = 0, len = contexts.length;
        for (; i2 < len; i2++) {
          find(selector, contexts[i2], results);
        }
        return results;
      }
      function condense(unmatched, map2, filter, context, xml) {
        var elem, newUnmatched = [], i2 = 0, len = unmatched.length, mapped = map2 != null;
        for (; i2 < len; i2++) {
          if (elem = unmatched[i2]) {
            if (!filter || filter(elem, context, xml)) {
              newUnmatched.push(elem);
              if (mapped) {
                map2.push(i2);
              }
            }
          }
        }
        return newUnmatched;
      }
      function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
        if (postFilter && !postFilter[expando]) {
          postFilter = setMatcher(postFilter);
        }
        if (postFinder && !postFinder[expando]) {
          postFinder = setMatcher(postFinder, postSelector);
        }
        return markFunction(function(seed, results, context, xml) {
          var temp, i2, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, elems = seed || multipleContexts(
            selector || "*",
            context.nodeType ? [context] : context,
            []
          ), matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
          if (matcher) {
            matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? (
              // ...intermediate processing is necessary
              []
            ) : (
              // ...otherwise use results directly
              results
            );
            matcher(matcherIn, matcherOut, context, xml);
          } else {
            matcherOut = matcherIn;
          }
          if (postFilter) {
            temp = condense(matcherOut, postMap);
            postFilter(temp, [], context, xml);
            i2 = temp.length;
            while (i2--) {
              if (elem = temp[i2]) {
                matcherOut[postMap[i2]] = !(matcherIn[postMap[i2]] = elem);
              }
            }
          }
          if (seed) {
            if (postFinder || preFilter) {
              if (postFinder) {
                temp = [];
                i2 = matcherOut.length;
                while (i2--) {
                  if (elem = matcherOut[i2]) {
                    temp.push(matcherIn[i2] = elem);
                  }
                }
                postFinder(null, matcherOut = [], temp, xml);
              }
              i2 = matcherOut.length;
              while (i2--) {
                if ((elem = matcherOut[i2]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i2]) > -1) {
                  seed[temp] = !(results[temp] = elem);
                }
              }
            }
          } else {
            matcherOut = condense(
              matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut
            );
            if (postFinder) {
              postFinder(null, results, matcherOut, xml);
            } else {
              push2.apply(results, matcherOut);
            }
          }
        });
      }
      function matcherFromTokens(tokens) {
        var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i2 = leadingRelative ? 1 : 0, matchContext = addCombinator(function(elem) {
          return elem === checkContext;
        }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
          return indexOf.call(checkContext, elem) > -1;
        }, implicitRelative, true), matchers = [function(elem, context, xml) {
          var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
          checkContext = null;
          return ret;
        }];
        for (; i2 < len; i2++) {
          if (matcher = Expr.relative[tokens[i2].type]) {
            matchers = [addCombinator(elementMatcher(matchers), matcher)];
          } else {
            matcher = Expr.filter[tokens[i2].type].apply(null, tokens[i2].matches);
            if (matcher[expando]) {
              j = ++i2;
              for (; j < len; j++) {
                if (Expr.relative[tokens[j].type]) {
                  break;
                }
              }
              return setMatcher(
                i2 > 1 && elementMatcher(matchers),
                i2 > 1 && toSelector(
                  // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                  tokens.slice(0, i2 - 1).concat({ value: tokens[i2 - 2].type === " " ? "*" : "" })
                ).replace(rtrimCSS, "$1"),
                matcher,
                i2 < j && matcherFromTokens(tokens.slice(i2, j)),
                j < len && matcherFromTokens(tokens = tokens.slice(j)),
                j < len && toSelector(tokens)
              );
            }
            matchers.push(matcher);
          }
        }
        return elementMatcher(matchers);
      }
      function matcherFromGroupMatchers(elementMatchers, setMatchers) {
        var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
          var elem, j, matcher, matchedCount = 0, i2 = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, elems = seed || byElement && Expr.find.TAG("*", outermost), dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
          if (outermost) {
            outermostContext = context == document22 || context || outermost;
          }
          for (; i2 !== len && (elem = elems[i2]) != null; i2++) {
            if (byElement && elem) {
              j = 0;
              if (!context && elem.ownerDocument != document22) {
                setDocument(elem);
                xml = !documentIsHTML;
              }
              while (matcher = elementMatchers[j++]) {
                if (matcher(elem, context || document22, xml)) {
                  push2.call(results, elem);
                  break;
                }
              }
              if (outermost) {
                dirruns = dirrunsUnique;
              }
            }
            if (bySet) {
              if (elem = !matcher && elem) {
                matchedCount--;
              }
              if (seed) {
                unmatched.push(elem);
              }
            }
          }
          matchedCount += i2;
          if (bySet && i2 !== matchedCount) {
            j = 0;
            while (matcher = setMatchers[j++]) {
              matcher(unmatched, setMatched, context, xml);
            }
            if (seed) {
              if (matchedCount > 0) {
                while (i2--) {
                  if (!(unmatched[i2] || setMatched[i2])) {
                    setMatched[i2] = pop.call(results);
                  }
                }
              }
              setMatched = condense(setMatched);
            }
            push2.apply(results, setMatched);
            if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {
              jQuery.uniqueSort(results);
            }
          }
          if (outermost) {
            dirruns = dirrunsUnique;
            outermostContext = contextBackup;
          }
          return unmatched;
        };
        return bySet ? markFunction(superMatcher) : superMatcher;
      }
      function compile2(selector, match) {
        var i2, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
        if (!cached) {
          if (!match) {
            match = tokenize2(selector);
          }
          i2 = match.length;
          while (i2--) {
            cached = matcherFromTokens(match[i2]);
            if (cached[expando]) {
              setMatchers.push(cached);
            } else {
              elementMatchers.push(cached);
            }
          }
          cached = compilerCache(
            selector,
            matcherFromGroupMatchers(elementMatchers, setMatchers)
          );
          cached.selector = selector;
        }
        return cached;
      }
      function select(selector, context, results, seed) {
        var i2, tokens, token, type, find2, compiled = typeof selector === "function" && selector, match = !seed && tokenize2(selector = compiled.selector || selector);
        results = results || [];
        if (match.length === 1) {
          tokens = match[0] = match[0].slice(0);
          if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
            context = (Expr.find.ID(
              token.matches[0].replace(runescape, funescape),
              context
            ) || [])[0];
            if (!context) {
              return results;
            } else if (compiled) {
              context = context.parentNode;
            }
            selector = selector.slice(tokens.shift().value.length);
          }
          i2 = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
          while (i2--) {
            token = tokens[i2];
            if (Expr.relative[type = token.type]) {
              break;
            }
            if (find2 = Expr.find[type]) {
              if (seed = find2(
                token.matches[0].replace(runescape, funescape),
                rsibling.test(tokens[0].type) && testContext(context.parentNode) || context
              )) {
                tokens.splice(i2, 1);
                selector = seed.length && toSelector(tokens);
                if (!selector) {
                  push2.apply(results, seed);
                  return results;
                }
                break;
              }
            }
          }
        }
        (compiled || compile2(selector, match))(
          seed,
          context,
          !documentIsHTML,
          results,
          !context || rsibling.test(selector) && testContext(context.parentNode) || context
        );
        return results;
      }
      support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
      setDocument();
      support.sortDetached = assert(function(el) {
        return el.compareDocumentPosition(document22.createElement("fieldset")) & 1;
      });
      jQuery.find = find;
      jQuery.expr[":"] = jQuery.expr.pseudos;
      jQuery.unique = jQuery.uniqueSort;
      find.compile = compile2;
      find.select = select;
      find.setDocument = setDocument;
      find.tokenize = tokenize2;
      find.escape = jQuery.escapeSelector;
      find.getText = jQuery.text;
      find.isXML = jQuery.isXMLDoc;
      find.selectors = jQuery.expr;
      find.support = jQuery.support;
      find.uniqueSort = jQuery.uniqueSort;
    })();
    var dir = function(elem, dir2, until) {
      var matched = [], truncate2 = until !== void 0;
      while ((elem = elem[dir2]) && elem.nodeType !== 9) {
        if (elem.nodeType === 1) {
          if (truncate2 && jQuery(elem).is(until)) {
            break;
          }
          matched.push(elem);
        }
      }
      return matched;
    };
    var siblings = function(n, elem) {
      var matched = [];
      for (; n; n = n.nextSibling) {
        if (n.nodeType === 1 && n !== elem) {
          matched.push(n);
        }
      }
      return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function winnow(elements, qualifier, not) {
      if (isFunction(qualifier)) {
        return jQuery.grep(elements, function(elem, i) {
          return !!qualifier.call(elem, i, elem) !== not;
        });
      }
      if (qualifier.nodeType) {
        return jQuery.grep(elements, function(elem) {
          return elem === qualifier !== not;
        });
      }
      if (typeof qualifier !== "string") {
        return jQuery.grep(elements, function(elem) {
          return indexOf.call(qualifier, elem) > -1 !== not;
        });
      }
      return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
      var elem = elems[0];
      if (not) {
        expr = ":not(" + expr + ")";
      }
      if (elems.length === 1 && elem.nodeType === 1) {
        return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
      }
      return jQuery.find.matches(expr, jQuery.grep(elems, function(elem2) {
        return elem2.nodeType === 1;
      }));
    };
    jQuery.fn.extend({
      find: function(selector) {
        var i, ret, len = this.length, self2 = this;
        if (typeof selector !== "string") {
          return this.pushStack(jQuery(selector).filter(function() {
            for (i = 0; i < len; i++) {
              if (jQuery.contains(self2[i], this)) {
                return true;
              }
            }
          }));
        }
        ret = this.pushStack([]);
        for (i = 0; i < len; i++) {
          jQuery.find(selector, self2[i], ret);
        }
        return len > 1 ? jQuery.uniqueSort(ret) : ret;
      },
      filter: function(selector) {
        return this.pushStack(winnow(this, selector || [], false));
      },
      not: function(selector) {
        return this.pushStack(winnow(this, selector || [], true));
      },
      is: function(selector) {
        return !!winnow(
          this,
          // If this is a positional/relative selector, check membership in the returned set
          // so $("p:first").is("p:last") won't return true for a doc with two "p".
          typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [],
          false
        ).length;
      }
    });
    var rootjQuery, rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
      var match, elem;
      if (!selector) {
        return this;
      }
      root = root || rootjQuery;
      if (typeof selector === "string") {
        if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) {
          match = [null, selector, null];
        } else {
          match = rquickExpr.exec(selector);
        }
        if (match && (match[1] || !context)) {
          if (match[1]) {
            context = context instanceof jQuery ? context[0] : context;
            jQuery.merge(this, jQuery.parseHTML(
              match[1],
              context && context.nodeType ? context.ownerDocument || context : document2,
              true
            ));
            if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
              for (match in context) {
                if (isFunction(this[match])) {
                  this[match](context[match]);
                } else {
                  this.attr(match, context[match]);
                }
              }
            }
            return this;
          } else {
            elem = document2.getElementById(match[2]);
            if (elem) {
              this[0] = elem;
              this.length = 1;
            }
            return this;
          }
        } else if (!context || context.jquery) {
          return (context || root).find(selector);
        } else {
          return this.constructor(context).find(selector);
        }
      } else if (selector.nodeType) {
        this[0] = selector;
        this.length = 1;
        return this;
      } else if (isFunction(selector)) {
        return root.ready !== void 0 ? root.ready(selector) : (
          // Execute immediately if ready is not present
          selector(jQuery)
        );
      }
      return jQuery.makeArray(selector, this);
    };
    init.prototype = jQuery.fn;
    rootjQuery = jQuery(document2);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, guaranteedUnique = {
      children: true,
      contents: true,
      next: true,
      prev: true
    };
    jQuery.fn.extend({
      has: function(target) {
        var targets = jQuery(target, this), l = targets.length;
        return this.filter(function() {
          var i = 0;
          for (; i < l; i++) {
            if (jQuery.contains(this, targets[i])) {
              return true;
            }
          }
        });
      },
      closest: function(selectors, context) {
        var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
        if (!rneedsContext.test(selectors)) {
          for (; i < l; i++) {
            for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {
              if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : (
                // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors)
              ))) {
                matched.push(cur);
                break;
              }
            }
          }
        }
        return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
      },
      // Determine the position of an element within the set
      index: function(elem) {
        if (!elem) {
          return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
        }
        if (typeof elem === "string") {
          return indexOf.call(jQuery(elem), this[0]);
        }
        return indexOf.call(
          this,
          // If it receives a jQuery object, the first element is used
          elem.jquery ? elem[0] : elem
        );
      },
      add: function(selector, context) {
        return this.pushStack(
          jQuery.uniqueSort(
            jQuery.merge(this.get(), jQuery(selector, context))
          )
        );
      },
      addBack: function(selector) {
        return this.add(
          selector == null ? this.prevObject : this.prevObject.filter(selector)
        );
      }
    });
    function sibling(cur, dir2) {
      while ((cur = cur[dir2]) && cur.nodeType !== 1) {
      }
      return cur;
    }
    jQuery.each({
      parent: function(elem) {
        var parent = elem.parentNode;
        return parent && parent.nodeType !== 11 ? parent : null;
      },
      parents: function(elem) {
        return dir(elem, "parentNode");
      },
      parentsUntil: function(elem, _i, until) {
        return dir(elem, "parentNode", until);
      },
      next: function(elem) {
        return sibling(elem, "nextSibling");
      },
      prev: function(elem) {
        return sibling(elem, "previousSibling");
      },
      nextAll: function(elem) {
        return dir(elem, "nextSibling");
      },
      prevAll: function(elem) {
        return dir(elem, "previousSibling");
      },
      nextUntil: function(elem, _i, until) {
        return dir(elem, "nextSibling", until);
      },
      prevUntil: function(elem, _i, until) {
        return dir(elem, "previousSibling", until);
      },
      siblings: function(elem) {
        return siblings((elem.parentNode || {}).firstChild, elem);
      },
      children: function(elem) {
        return siblings(elem.firstChild);
      },
      contents: function(elem) {
        if (elem.contentDocument != null && // Support: IE 11+
        // <object> elements with no `data` attribute has an object
        // `contentDocument` with a `null` prototype.
        getProto(elem.contentDocument)) {
          return elem.contentDocument;
        }
        if (nodeName(elem, "template")) {
          elem = elem.content || elem;
        }
        return jQuery.merge([], elem.childNodes);
      }
    }, function(name2, fn) {
      jQuery.fn[name2] = function(until, selector) {
        var matched = jQuery.map(this, fn, until);
        if (name2.slice(-5) !== "Until") {
          selector = until;
        }
        if (selector && typeof selector === "string") {
          matched = jQuery.filter(selector, matched);
        }
        if (this.length > 1) {
          if (!guaranteedUnique[name2]) {
            jQuery.uniqueSort(matched);
          }
          if (rparentsprev.test(name2)) {
            matched.reverse();
          }
        }
        return this.pushStack(matched);
      };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    function createOptions(options) {
      var object = {};
      jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
        object[flag] = true;
      });
      return object;
    }
    jQuery.Callbacks = function(options) {
      options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
      var firing, memory, fired, locked, list = [], queue = [], firingIndex = -1, fire = function() {
        locked = locked || options.once;
        fired = firing = true;
        for (; queue.length; firingIndex = -1) {
          memory = queue.shift();
          while (++firingIndex < list.length) {
            if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
              firingIndex = list.length;
              memory = false;
            }
          }
        }
        if (!options.memory) {
          memory = false;
        }
        firing = false;
        if (locked) {
          if (memory) {
            list = [];
          } else {
            list = "";
          }
        }
      }, self2 = {
        // Add a callback or a collection of callbacks to the list
        add: function() {
          if (list) {
            if (memory && !firing) {
              firingIndex = list.length - 1;
              queue.push(memory);
            }
            (function add2(args) {
              jQuery.each(args, function(_, arg) {
                if (isFunction(arg)) {
                  if (!options.unique || !self2.has(arg)) {
                    list.push(arg);
                  }
                } else if (arg && arg.length && toType(arg) !== "string") {
                  add2(arg);
                }
              });
            })(arguments);
            if (memory && !firing) {
              fire();
            }
          }
          return this;
        },
        // Remove a callback from the list
        remove: function() {
          jQuery.each(arguments, function(_, arg) {
            var index;
            while ((index = jQuery.inArray(arg, list, index)) > -1) {
              list.splice(index, 1);
              if (index <= firingIndex) {
                firingIndex--;
              }
            }
          });
          return this;
        },
        // Check if a given callback is in the list.
        // If no argument is given, return whether or not list has callbacks attached.
        has: function(fn) {
          return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
        },
        // Remove all callbacks from the list
        empty: function() {
          if (list) {
            list = [];
          }
          return this;
        },
        // Disable .fire and .add
        // Abort any current/pending executions
        // Clear all callbacks and values
        disable: function() {
          locked = queue = [];
          list = memory = "";
          return this;
        },
        disabled: function() {
          return !list;
        },
        // Disable .fire
        // Also disable .add unless we have memory (since it would have no effect)
        // Abort any pending executions
        lock: function() {
          locked = queue = [];
          if (!memory && !firing) {
            list = memory = "";
          }
          return this;
        },
        locked: function() {
          return !!locked;
        },
        // Call all callbacks with the given context and arguments
        fireWith: function(context, args) {
          if (!locked) {
            args = args || [];
            args = [context, args.slice ? args.slice() : args];
            queue.push(args);
            if (!firing) {
              fire();
            }
          }
          return this;
        },
        // Call all the callbacks with the given arguments
        fire: function() {
          self2.fireWith(this, arguments);
          return this;
        },
        // To know if the callbacks have already been called at least once
        fired: function() {
          return !!fired;
        }
      };
      return self2;
    };
    function Identity(v) {
      return v;
    }
    function Thrower(ex) {
      throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
      var method;
      try {
        if (value && isFunction(method = value.promise)) {
          method.call(value).done(resolve).fail(reject);
        } else if (value && isFunction(method = value.then)) {
          method.call(value, resolve, reject);
        } else {
          resolve.apply(void 0, [value].slice(noValue));
        }
      } catch (value2) {
        reject.apply(void 0, [value2]);
      }
    }
    jQuery.extend({
      Deferred: function(func) {
        var tuples = [
          // action, add listener, callbacks,
          // ... .then handlers, argument index, [final state]
          [
            "notify",
            "progress",
            jQuery.Callbacks("memory"),
            jQuery.Callbacks("memory"),
            2
          ],
          [
            "resolve",
            "done",
            jQuery.Callbacks("once memory"),
            jQuery.Callbacks("once memory"),
            0,
            "resolved"
          ],
          [
            "reject",
            "fail",
            jQuery.Callbacks("once memory"),
            jQuery.Callbacks("once memory"),
            1,
            "rejected"
          ]
        ], state = "pending", promise = {
          state: function() {
            return state;
          },
          always: function() {
            deferred.done(arguments).fail(arguments);
            return this;
          },
          "catch": function(fn) {
            return promise.then(null, fn);
          },
          // Keep pipe for back-compat
          pipe: function() {
            var fns = arguments;
            return jQuery.Deferred(function(newDefer) {
              jQuery.each(tuples, function(_i, tuple) {
                var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                deferred[tuple[1]](function() {
                  var returned = fn && fn.apply(this, arguments);
                  if (returned && isFunction(returned.promise)) {
                    returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                  } else {
                    newDefer[tuple[0] + "With"](
                      this,
                      fn ? [returned] : arguments
                    );
                  }
                });
              });
              fns = null;
            }).promise();
          },
          then: function(onFulfilled, onRejected, onProgress) {
            var maxDepth = 0;
            function resolve(depth, deferred2, handler, special) {
              return function() {
                var that = this, args = arguments, mightThrow = function() {
                  var returned, then;
                  if (depth < maxDepth) {
                    return;
                  }
                  returned = handler.apply(that, args);
                  if (returned === deferred2.promise()) {
                    throw new TypeError("Thenable self-resolution");
                  }
                  then = returned && // Support: Promises/A+ section 2.3.4
                  // https://promisesaplus.com/#point-64
                  // Only check objects and functions for thenability
                  (typeof returned === "object" || typeof returned === "function") && returned.then;
                  if (isFunction(then)) {
                    if (special) {
                      then.call(
                        returned,
                        resolve(maxDepth, deferred2, Identity, special),
                        resolve(maxDepth, deferred2, Thrower, special)
                      );
                    } else {
                      maxDepth++;
                      then.call(
                        returned,
                        resolve(maxDepth, deferred2, Identity, special),
                        resolve(maxDepth, deferred2, Thrower, special),
                        resolve(
                          maxDepth,
                          deferred2,
                          Identity,
                          deferred2.notifyWith
                        )
                      );
                    }
                  } else {
                    if (handler !== Identity) {
                      that = void 0;
                      args = [returned];
                    }
                    (special || deferred2.resolveWith)(that, args);
                  }
                }, process2 = special ? mightThrow : function() {
                  try {
                    mightThrow();
                  } catch (e) {
                    if (jQuery.Deferred.exceptionHook) {
                      jQuery.Deferred.exceptionHook(
                        e,
                        process2.error
                      );
                    }
                    if (depth + 1 >= maxDepth) {
                      if (handler !== Thrower) {
                        that = void 0;
                        args = [e];
                      }
                      deferred2.rejectWith(that, args);
                    }
                  }
                };
                if (depth) {
                  process2();
                } else {
                  if (jQuery.Deferred.getErrorHook) {
                    process2.error = jQuery.Deferred.getErrorHook();
                  } else if (jQuery.Deferred.getStackHook) {
                    process2.error = jQuery.Deferred.getStackHook();
                  }
                  window2.setTimeout(process2);
                }
              };
            }
            return jQuery.Deferred(function(newDefer) {
              tuples[0][3].add(
                resolve(
                  0,
                  newDefer,
                  isFunction(onProgress) ? onProgress : Identity,
                  newDefer.notifyWith
                )
              );
              tuples[1][3].add(
                resolve(
                  0,
                  newDefer,
                  isFunction(onFulfilled) ? onFulfilled : Identity
                )
              );
              tuples[2][3].add(
                resolve(
                  0,
                  newDefer,
                  isFunction(onRejected) ? onRejected : Thrower
                )
              );
            }).promise();
          },
          // Get a promise for this deferred
          // If obj is provided, the promise aspect is added to the object
          promise: function(obj) {
            return obj != null ? jQuery.extend(obj, promise) : promise;
          }
        }, deferred = {};
        jQuery.each(tuples, function(i, tuple) {
          var list = tuple[2], stateString = tuple[5];
          promise[tuple[1]] = list.add;
          if (stateString) {
            list.add(
              function() {
                state = stateString;
              },
              // rejected_callbacks.disable
              // fulfilled_callbacks.disable
              tuples[3 - i][2].disable,
              // rejected_handlers.disable
              // fulfilled_handlers.disable
              tuples[3 - i][3].disable,
              // progress_callbacks.lock
              tuples[0][2].lock,
              // progress_handlers.lock
              tuples[0][3].lock
            );
          }
          list.add(tuple[3].fire);
          deferred[tuple[0]] = function() {
            deferred[tuple[0] + "With"](this === deferred ? void 0 : this, arguments);
            return this;
          };
          deferred[tuple[0] + "With"] = list.fireWith;
        });
        promise.promise(deferred);
        if (func) {
          func.call(deferred, deferred);
        }
        return deferred;
      },
      // Deferred helper
      when: function(singleValue) {
        var remaining = arguments.length, i = remaining, resolveContexts = Array(i), resolveValues = slice.call(arguments), primary = jQuery.Deferred(), updateFunc = function(i2) {
          return function(value) {
            resolveContexts[i2] = this;
            resolveValues[i2] = arguments.length > 1 ? slice.call(arguments) : value;
            if (!--remaining) {
              primary.resolveWith(resolveContexts, resolveValues);
            }
          };
        };
        if (remaining <= 1) {
          adoptValue(
            singleValue,
            primary.done(updateFunc(i)).resolve,
            primary.reject,
            !remaining
          );
          if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) {
            return primary.then();
          }
        }
        while (i--) {
          adoptValue(resolveValues[i], updateFunc(i), primary.reject);
        }
        return primary.promise();
      }
    });
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
      if (window2.console && window2.console.warn && error && rerrorNames.test(error.name)) {
        window2.console.warn(
          "jQuery.Deferred exception: " + error.message,
          error.stack,
          asyncError
        );
      }
    };
    jQuery.readyException = function(error) {
      window2.setTimeout(function() {
        throw error;
      });
    };
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
      readyList.then(fn).catch(function(error) {
        jQuery.readyException(error);
      });
      return this;
    };
    jQuery.extend({
      // Is the DOM ready to be used? Set to true once it occurs.
      isReady: false,
      // A counter to track how many items to wait for before
      // the ready event fires. See trac-6781
      readyWait: 1,
      // Handle when the DOM is ready
      ready: function(wait) {
        if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
          return;
        }
        jQuery.isReady = true;
        if (wait !== true && --jQuery.readyWait > 0) {
          return;
        }
        readyList.resolveWith(document2, [jQuery]);
      }
    });
    jQuery.ready.then = readyList.then;
    function completed() {
      document2.removeEventListener("DOMContentLoaded", completed);
      window2.removeEventListener("load", completed);
      jQuery.ready();
    }
    if (document2.readyState === "complete" || document2.readyState !== "loading" && !document2.documentElement.doScroll) {
      window2.setTimeout(jQuery.ready);
    } else {
      document2.addEventListener("DOMContentLoaded", completed);
      window2.addEventListener("load", completed);
    }
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
      var i = 0, len = elems.length, bulk = key == null;
      if (toType(key) === "object") {
        chainable = true;
        for (i in key) {
          access(elems, fn, i, key[i], true, emptyGet, raw);
        }
      } else if (value !== void 0) {
        chainable = true;
        if (!isFunction(value)) {
          raw = true;
        }
        if (bulk) {
          if (raw) {
            fn.call(elems, value);
            fn = null;
          } else {
            bulk = fn;
            fn = function(elem, _key, value2) {
              return bulk.call(jQuery(elem), value2);
            };
          }
        }
        if (fn) {
          for (; i < len; i++) {
            fn(
              elems[i],
              key,
              raw ? value : value.call(elems[i], i, fn(elems[i], key))
            );
          }
        }
      }
      if (chainable) {
        return elems;
      }
      if (bulk) {
        return fn.call(elems);
      }
      return len ? fn(elems[0], key) : emptyGet;
    };
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    function fcamelCase(_all, letter) {
      return letter.toUpperCase();
    }
    function camelCase(string2) {
      return string2.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
      return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data2() {
      this.expando = jQuery.expando + Data2.uid++;
    }
    Data2.uid = 1;
    Data2.prototype = {
      cache: function(owner) {
        var value = owner[this.expando];
        if (!value) {
          value = {};
          if (acceptData(owner)) {
            if (owner.nodeType) {
              owner[this.expando] = value;
            } else {
              Object.defineProperty(owner, this.expando, {
                value,
                configurable: true
              });
            }
          }
        }
        return value;
      },
      set: function(owner, data, value) {
        var prop, cache2 = this.cache(owner);
        if (typeof data === "string") {
          cache2[camelCase(data)] = value;
        } else {
          for (prop in data) {
            cache2[camelCase(prop)] = data[prop];
          }
        }
        return cache2;
      },
      get: function(owner, key) {
        return key === void 0 ? this.cache(owner) : (
          // Always use camelCase key (gh-2257)
          owner[this.expando] && owner[this.expando][camelCase(key)]
        );
      },
      access: function(owner, key, value) {
        if (key === void 0 || key && typeof key === "string" && value === void 0) {
          return this.get(owner, key);
        }
        this.set(owner, key, value);
        return value !== void 0 ? value : key;
      },
      remove: function(owner, key) {
        var i, cache2 = owner[this.expando];
        if (cache2 === void 0) {
          return;
        }
        if (key !== void 0) {
          if (Array.isArray(key)) {
            key = key.map(camelCase);
          } else {
            key = camelCase(key);
            key = key in cache2 ? [key] : key.match(rnothtmlwhite) || [];
          }
          i = key.length;
          while (i--) {
            delete cache2[key[i]];
          }
        }
        if (key === void 0 || jQuery.isEmptyObject(cache2)) {
          if (owner.nodeType) {
            owner[this.expando] = void 0;
          } else {
            delete owner[this.expando];
          }
        }
      },
      hasData: function(owner) {
        var cache2 = owner[this.expando];
        return cache2 !== void 0 && !jQuery.isEmptyObject(cache2);
      }
    };
    var dataPriv = new Data2();
    var dataUser = new Data2();
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
      if (data === "true") {
        return true;
      }
      if (data === "false") {
        return false;
      }
      if (data === "null") {
        return null;
      }
      if (data === +data + "") {
        return +data;
      }
      if (rbrace.test(data)) {
        return JSON.parse(data);
      }
      return data;
    }
    function dataAttr(elem, key, data) {
      var name2;
      if (data === void 0 && elem.nodeType === 1) {
        name2 = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
        data = elem.getAttribute(name2);
        if (typeof data === "string") {
          try {
            data = getData(data);
          } catch (e) {
          }
          dataUser.set(elem, key, data);
        } else {
          data = void 0;
        }
      }
      return data;
    }
    jQuery.extend({
      hasData: function(elem) {
        return dataUser.hasData(elem) || dataPriv.hasData(elem);
      },
      data: function(elem, name2, data) {
        return dataUser.access(elem, name2, data);
      },
      removeData: function(elem, name2) {
        dataUser.remove(elem, name2);
      },
      // TODO: Now that all calls to _data and _removeData have been replaced
      // with direct calls to dataPriv methods, these can be deprecated.
      _data: function(elem, name2, data) {
        return dataPriv.access(elem, name2, data);
      },
      _removeData: function(elem, name2) {
        dataPriv.remove(elem, name2);
      }
    });
    jQuery.fn.extend({
      data: function(key, value) {
        var i, name2, data, elem = this[0], attrs = elem && elem.attributes;
        if (key === void 0) {
          if (this.length) {
            data = dataUser.get(elem);
            if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
              i = attrs.length;
              while (i--) {
                if (attrs[i]) {
                  name2 = attrs[i].name;
                  if (name2.indexOf("data-") === 0) {
                    name2 = camelCase(name2.slice(5));
                    dataAttr(elem, name2, data[name2]);
                  }
                }
              }
              dataPriv.set(elem, "hasDataAttrs", true);
            }
          }
          return data;
        }
        if (typeof key === "object") {
          return this.each(function() {
            dataUser.set(this, key);
          });
        }
        return access(this, function(value2) {
          var data2;
          if (elem && value2 === void 0) {
            data2 = dataUser.get(elem, key);
            if (data2 !== void 0) {
              return data2;
            }
            data2 = dataAttr(elem, key);
            if (data2 !== void 0) {
              return data2;
            }
            return;
          }
          this.each(function() {
            dataUser.set(this, key, value2);
          });
        }, null, value, arguments.length > 1, null, true);
      },
      removeData: function(key) {
        return this.each(function() {
          dataUser.remove(this, key);
        });
      }
    });
    jQuery.extend({
      queue: function(elem, type, data) {
        var queue;
        if (elem) {
          type = (type || "fx") + "queue";
          queue = dataPriv.get(elem, type);
          if (data) {
            if (!queue || Array.isArray(data)) {
              queue = dataPriv.access(elem, type, jQuery.makeArray(data));
            } else {
              queue.push(data);
            }
          }
          return queue || [];
        }
      },
      dequeue: function(elem, type) {
        type = type || "fx";
        var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
          jQuery.dequeue(elem, type);
        };
        if (fn === "inprogress") {
          fn = queue.shift();
          startLength--;
        }
        if (fn) {
          if (type === "fx") {
            queue.unshift("inprogress");
          }
          delete hooks.stop;
          fn.call(elem, next, hooks);
        }
        if (!startLength && hooks) {
          hooks.empty.fire();
        }
      },
      // Not public - generate a queueHooks object, or return the current one
      _queueHooks: function(elem, type) {
        var key = type + "queueHooks";
        return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
          empty: jQuery.Callbacks("once memory").add(function() {
            dataPriv.remove(elem, [type + "queue", key]);
          })
        });
      }
    });
    jQuery.fn.extend({
      queue: function(type, data) {
        var setter = 2;
        if (typeof type !== "string") {
          data = type;
          type = "fx";
          setter--;
        }
        if (arguments.length < setter) {
          return jQuery.queue(this[0], type);
        }
        return data === void 0 ? this : this.each(function() {
          var queue = jQuery.queue(this, type, data);
          jQuery._queueHooks(this, type);
          if (type === "fx" && queue[0] !== "inprogress") {
            jQuery.dequeue(this, type);
          }
        });
      },
      dequeue: function(type) {
        return this.each(function() {
          jQuery.dequeue(this, type);
        });
      },
      clearQueue: function(type) {
        return this.queue(type || "fx", []);
      },
      // Get a promise resolved when queues of a certain type
      // are emptied (fx is the type by default)
      promise: function(type, obj) {
        var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
          if (!--count) {
            defer.resolveWith(elements, [elements]);
          }
        };
        if (typeof type !== "string") {
          obj = type;
          type = void 0;
        }
        type = type || "fx";
        while (i--) {
          tmp = dataPriv.get(elements[i], type + "queueHooks");
          if (tmp && tmp.empty) {
            count++;
            tmp.empty.add(resolve);
          }
        }
        resolve();
        return defer.promise(obj);
      }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = ["Top", "Right", "Bottom", "Left"];
    var documentElement = document2.documentElement;
    var isAttached = function(elem) {
      return jQuery.contains(elem.ownerDocument, elem);
    }, composed = { composed: true };
    if (documentElement.getRootNode) {
      isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
      };
    }
    var isHiddenWithinTree = function(elem, el) {
      elem = el || elem;
      return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
      // Support: Firefox <=43 - 45
      // Disconnected elements can have computed display: none, so first confirm that elem is
      // in the document.
      isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
      var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
        return tween.cur();
      } : function() {
        return jQuery.css(elem, prop, "");
      }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
      if (initialInUnit && initialInUnit[3] !== unit) {
        initial = initial / 2;
        unit = unit || initialInUnit[3];
        initialInUnit = +initial || 1;
        while (maxIterations--) {
          jQuery.style(elem, prop, initialInUnit + unit);
          if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
            maxIterations = 0;
          }
          initialInUnit = initialInUnit / scale;
        }
        initialInUnit = initialInUnit * 2;
        jQuery.style(elem, prop, initialInUnit + unit);
        valueParts = valueParts || [];
      }
      if (valueParts) {
        initialInUnit = +initialInUnit || +initial || 0;
        adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
        if (tween) {
          tween.unit = unit;
          tween.start = initialInUnit;
          tween.end = adjusted;
        }
      }
      return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
      var temp, doc = elem.ownerDocument, nodeName2 = elem.nodeName, display = defaultDisplayMap[nodeName2];
      if (display) {
        return display;
      }
      temp = doc.body.appendChild(doc.createElement(nodeName2));
      display = jQuery.css(temp, "display");
      temp.parentNode.removeChild(temp);
      if (display === "none") {
        display = "block";
      }
      defaultDisplayMap[nodeName2] = display;
      return display;
    }
    function showHide(elements, show) {
      var display, elem, values = [], index = 0, length = elements.length;
      for (; index < length; index++) {
        elem = elements[index];
        if (!elem.style) {
          continue;
        }
        display = elem.style.display;
        if (show) {
          if (display === "none") {
            values[index] = dataPriv.get(elem, "display") || null;
            if (!values[index]) {
              elem.style.display = "";
            }
          }
          if (elem.style.display === "" && isHiddenWithinTree(elem)) {
            values[index] = getDefaultDisplay(elem);
          }
        } else {
          if (display !== "none") {
            values[index] = "none";
            dataPriv.set(elem, "display", display);
          }
        }
      }
      for (index = 0; index < length; index++) {
        if (values[index] != null) {
          elements[index].style.display = values[index];
        }
      }
      return elements;
    }
    jQuery.fn.extend({
      show: function() {
        return showHide(this, true);
      },
      hide: function() {
        return showHide(this);
      },
      toggle: function(state) {
        if (typeof state === "boolean") {
          return state ? this.show() : this.hide();
        }
        return this.each(function() {
          if (isHiddenWithinTree(this)) {
            jQuery(this).show();
          } else {
            jQuery(this).hide();
          }
        });
      }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
      var fragment = document2.createDocumentFragment(), div2 = fragment.appendChild(document2.createElement("div")), input = document2.createElement("input");
      input.setAttribute("type", "radio");
      input.setAttribute("checked", "checked");
      input.setAttribute("name", "t");
      div2.appendChild(input);
      support.checkClone = div2.cloneNode(true).cloneNode(true).lastChild.checked;
      div2.innerHTML = "<textarea>x</textarea>";
      support.noCloneChecked = !!div2.cloneNode(true).lastChild.defaultValue;
      div2.innerHTML = "<option></option>";
      support.option = !!div2.lastChild;
    })();
    var wrapMap = {
      // XHTML parsers do not magically insert elements in the
      // same way that tag soup parsers do. So we cannot shorten
      // this by omitting <tbody> or other required elements.
      thead: [1, "<table>", "</table>"],
      col: [2, "<table><colgroup>", "</colgroup></table>"],
      tr: [2, "<table><tbody>", "</tbody></table>"],
      td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
      _default: [0, "", ""]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    if (!support.option) {
      wrapMap.optgroup = wrapMap.option = [1, "<select multiple='multiple'>", "</select>"];
    }
    function getAll(context, tag2) {
      var ret;
      if (typeof context.getElementsByTagName !== "undefined") {
        ret = context.getElementsByTagName(tag2 || "*");
      } else if (typeof context.querySelectorAll !== "undefined") {
        ret = context.querySelectorAll(tag2 || "*");
      } else {
        ret = [];
      }
      if (tag2 === void 0 || tag2 && nodeName(context, tag2)) {
        return jQuery.merge([context], ret);
      }
      return ret;
    }
    function setGlobalEval(elems, refElements) {
      var i = 0, l = elems.length;
      for (; i < l; i++) {
        dataPriv.set(
          elems[i],
          "globalEval",
          !refElements || dataPriv.get(refElements[i], "globalEval")
        );
      }
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
      var elem, tmp, tag2, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
      for (; i < l; i++) {
        elem = elems[i];
        if (elem || elem === 0) {
          if (toType(elem) === "object") {
            jQuery.merge(nodes, elem.nodeType ? [elem] : elem);
          } else if (!rhtml.test(elem)) {
            nodes.push(context.createTextNode(elem));
          } else {
            tmp = tmp || fragment.appendChild(context.createElement("div"));
            tag2 = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
            wrap = wrapMap[tag2] || wrapMap._default;
            tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
            j = wrap[0];
            while (j--) {
              tmp = tmp.lastChild;
            }
            jQuery.merge(nodes, tmp.childNodes);
            tmp = fragment.firstChild;
            tmp.textContent = "";
          }
        }
      }
      fragment.textContent = "";
      i = 0;
      while (elem = nodes[i++]) {
        if (selection && jQuery.inArray(elem, selection) > -1) {
          if (ignored) {
            ignored.push(elem);
          }
          continue;
        }
        attached = isAttached(elem);
        tmp = getAll(fragment.appendChild(elem), "script");
        if (attached) {
          setGlobalEval(tmp);
        }
        if (scripts) {
          j = 0;
          while (elem = tmp[j++]) {
            if (rscriptType.test(elem.type || "")) {
              scripts.push(elem);
            }
          }
        }
      }
      return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
      return true;
    }
    function returnFalse() {
      return false;
    }
    function on(elem, types, selector, data, fn, one) {
      var origFn, type;
      if (typeof types === "object") {
        if (typeof selector !== "string") {
          data = data || selector;
          selector = void 0;
        }
        for (type in types) {
          on(elem, type, selector, data, types[type], one);
        }
        return elem;
      }
      if (data == null && fn == null) {
        fn = selector;
        data = selector = void 0;
      } else if (fn == null) {
        if (typeof selector === "string") {
          fn = data;
          data = void 0;
        } else {
          fn = data;
          data = selector;
          selector = void 0;
        }
      }
      if (fn === false) {
        fn = returnFalse;
      } else if (!fn) {
        return elem;
      }
      if (one === 1) {
        origFn = fn;
        fn = function(event) {
          jQuery().off(event);
          return origFn.apply(this, arguments);
        };
        fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
      }
      return elem.each(function() {
        jQuery.event.add(this, types, fn, data, selector);
      });
    }
    jQuery.event = {
      global: {},
      add: function(elem, types, handler, data, selector) {
        var handleObjIn, eventHandle, tmp, events2, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
        if (!acceptData(elem)) {
          return;
        }
        if (handler.handler) {
          handleObjIn = handler;
          handler = handleObjIn.handler;
          selector = handleObjIn.selector;
        }
        if (selector) {
          jQuery.find.matchesSelector(documentElement, selector);
        }
        if (!handler.guid) {
          handler.guid = jQuery.guid++;
        }
        if (!(events2 = elemData.events)) {
          events2 = elemData.events = /* @__PURE__ */ Object.create(null);
        }
        if (!(eventHandle = elemData.handle)) {
          eventHandle = elemData.handle = function(e) {
            return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : void 0;
          };
        }
        types = (types || "").match(rnothtmlwhite) || [""];
        t = types.length;
        while (t--) {
          tmp = rtypenamespace.exec(types[t]) || [];
          type = origType = tmp[1];
          namespaces = (tmp[2] || "").split(".").sort();
          if (!type) {
            continue;
          }
          special = jQuery.event.special[type] || {};
          type = (selector ? special.delegateType : special.bindType) || type;
          special = jQuery.event.special[type] || {};
          handleObj = jQuery.extend({
            type,
            origType,
            data,
            handler,
            guid: handler.guid,
            selector,
            needsContext: selector && jQuery.expr.match.needsContext.test(selector),
            namespace: namespaces.join(".")
          }, handleObjIn);
          if (!(handlers = events2[type])) {
            handlers = events2[type] = [];
            handlers.delegateCount = 0;
            if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
              if (elem.addEventListener) {
                elem.addEventListener(type, eventHandle);
              }
            }
          }
          if (special.add) {
            special.add.call(elem, handleObj);
            if (!handleObj.handler.guid) {
              handleObj.handler.guid = handler.guid;
            }
          }
          if (selector) {
            handlers.splice(handlers.delegateCount++, 0, handleObj);
          } else {
            handlers.push(handleObj);
          }
          jQuery.event.global[type] = true;
        }
      },
      // Detach an event or set of events from an element
      remove: function(elem, types, handler, selector, mappedTypes) {
        var j, origCount, tmp, events2, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
        if (!elemData || !(events2 = elemData.events)) {
          return;
        }
        types = (types || "").match(rnothtmlwhite) || [""];
        t = types.length;
        while (t--) {
          tmp = rtypenamespace.exec(types[t]) || [];
          type = origType = tmp[1];
          namespaces = (tmp[2] || "").split(".").sort();
          if (!type) {
            for (type in events2) {
              jQuery.event.remove(elem, type + types[t], handler, selector, true);
            }
            continue;
          }
          special = jQuery.event.special[type] || {};
          type = (selector ? special.delegateType : special.bindType) || type;
          handlers = events2[type] || [];
          tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
          origCount = j = handlers.length;
          while (j--) {
            handleObj = handlers[j];
            if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
              handlers.splice(j, 1);
              if (handleObj.selector) {
                handlers.delegateCount--;
              }
              if (special.remove) {
                special.remove.call(elem, handleObj);
              }
            }
          }
          if (origCount && !handlers.length) {
            if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {
              jQuery.removeEvent(elem, type, elemData.handle);
            }
            delete events2[type];
          }
        }
        if (jQuery.isEmptyObject(events2)) {
          dataPriv.remove(elem, "handle events");
        }
      },
      dispatch: function(nativeEvent) {
        var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || /* @__PURE__ */ Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
        args[0] = event;
        for (i = 1; i < arguments.length; i++) {
          args[i] = arguments[i];
        }
        event.delegateTarget = this;
        if (special.preDispatch && special.preDispatch.call(this, event) === false) {
          return;
        }
        handlerQueue = jQuery.event.handlers.call(this, event, handlers);
        i = 0;
        while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
          event.currentTarget = matched.elem;
          j = 0;
          while ((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped()) {
            if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
              event.handleObj = handleObj;
              event.data = handleObj.data;
              ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
              if (ret !== void 0) {
                if ((event.result = ret) === false) {
                  event.preventDefault();
                  event.stopPropagation();
                }
              }
            }
          }
        }
        if (special.postDispatch) {
          special.postDispatch.call(this, event);
        }
        return event.result;
      },
      handlers: function(event, handlers) {
        var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
        if (delegateCount && // Support: IE <=9
        // Black-hole SVG <use> instance trees (trac-13180)
        cur.nodeType && // Support: Firefox <=42
        // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
        // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
        // Support: IE 11 only
        // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
        !(event.type === "click" && event.button >= 1)) {
          for (; cur !== this; cur = cur.parentNode || this) {
            if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
              matchedHandlers = [];
              matchedSelectors = {};
              for (i = 0; i < delegateCount; i++) {
                handleObj = handlers[i];
                sel = handleObj.selector + " ";
                if (matchedSelectors[sel] === void 0) {
                  matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [cur]).length;
                }
                if (matchedSelectors[sel]) {
                  matchedHandlers.push(handleObj);
                }
              }
              if (matchedHandlers.length) {
                handlerQueue.push({ elem: cur, handlers: matchedHandlers });
              }
            }
          }
        }
        cur = this;
        if (delegateCount < handlers.length) {
          handlerQueue.push({ elem: cur, handlers: handlers.slice(delegateCount) });
        }
        return handlerQueue;
      },
      addProp: function(name2, hook) {
        Object.defineProperty(jQuery.Event.prototype, name2, {
          enumerable: true,
          configurable: true,
          get: isFunction(hook) ? function() {
            if (this.originalEvent) {
              return hook(this.originalEvent);
            }
          } : function() {
            if (this.originalEvent) {
              return this.originalEvent[name2];
            }
          },
          set: function(value) {
            Object.defineProperty(this, name2, {
              enumerable: true,
              configurable: true,
              writable: true,
              value
            });
          }
        });
      },
      fix: function(originalEvent) {
        return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
      },
      special: {
        load: {
          // Prevent triggered image.load events from bubbling to window.load
          noBubble: true
        },
        click: {
          // Utilize native event to ensure correct state for checkable inputs
          setup: function(data) {
            var el = this || data;
            if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {
              leverageNative(el, "click", true);
            }
            return false;
          },
          trigger: function(data) {
            var el = this || data;
            if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {
              leverageNative(el, "click");
            }
            return true;
          },
          // For cross-browser consistency, suppress native .click() on links
          // Also prevent it if we're currently inside a leveraged native-event stack
          _default: function(event) {
            var target = event.target;
            return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
          }
        },
        beforeunload: {
          postDispatch: function(event) {
            if (event.result !== void 0 && event.originalEvent) {
              event.originalEvent.returnValue = event.result;
            }
          }
        }
      }
    };
    function leverageNative(el, type, isSetup) {
      if (!isSetup) {
        if (dataPriv.get(el, type) === void 0) {
          jQuery.event.add(el, type, returnTrue);
        }
        return;
      }
      dataPriv.set(el, type, false);
      jQuery.event.add(el, type, {
        namespace: false,
        handler: function(event) {
          var result, saved = dataPriv.get(this, type);
          if (event.isTrigger & 1 && this[type]) {
            if (!saved) {
              saved = slice.call(arguments);
              dataPriv.set(this, type, saved);
              this[type]();
              result = dataPriv.get(this, type);
              dataPriv.set(this, type, false);
              if (saved !== result) {
                event.stopImmediatePropagation();
                event.preventDefault();
                return result;
              }
            } else if ((jQuery.event.special[type] || {}).delegateType) {
              event.stopPropagation();
            }
          } else if (saved) {
            dataPriv.set(this, type, jQuery.event.trigger(
              saved[0],
              saved.slice(1),
              this
            ));
            event.stopPropagation();
            event.isImmediatePropagationStopped = returnTrue;
          }
        }
      });
    }
    jQuery.removeEvent = function(elem, type, handle) {
      if (elem.removeEventListener) {
        elem.removeEventListener(type, handle);
      }
    };
    jQuery.Event = function(src, props) {
      if (!(this instanceof jQuery.Event)) {
        return new jQuery.Event(src, props);
      }
      if (src && src.type) {
        this.originalEvent = src;
        this.type = src.type;
        this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === void 0 && // Support: Android <=2.3 only
        src.returnValue === false ? returnTrue : returnFalse;
        this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
        this.currentTarget = src.currentTarget;
        this.relatedTarget = src.relatedTarget;
      } else {
        this.type = src;
      }
      if (props) {
        jQuery.extend(this, props);
      }
      this.timeStamp = src && src.timeStamp || Date.now();
      this[jQuery.expando] = true;
    };
    jQuery.Event.prototype = {
      constructor: jQuery.Event,
      isDefaultPrevented: returnFalse,
      isPropagationStopped: returnFalse,
      isImmediatePropagationStopped: returnFalse,
      isSimulated: false,
      preventDefault: function() {
        var e = this.originalEvent;
        this.isDefaultPrevented = returnTrue;
        if (e && !this.isSimulated) {
          e.preventDefault();
        }
      },
      stopPropagation: function() {
        var e = this.originalEvent;
        this.isPropagationStopped = returnTrue;
        if (e && !this.isSimulated) {
          e.stopPropagation();
        }
      },
      stopImmediatePropagation: function() {
        var e = this.originalEvent;
        this.isImmediatePropagationStopped = returnTrue;
        if (e && !this.isSimulated) {
          e.stopImmediatePropagation();
        }
        this.stopPropagation();
      }
    };
    jQuery.each({
      altKey: true,
      bubbles: true,
      cancelable: true,
      changedTouches: true,
      ctrlKey: true,
      detail: true,
      eventPhase: true,
      metaKey: true,
      pageX: true,
      pageY: true,
      shiftKey: true,
      view: true,
      "char": true,
      code: true,
      charCode: true,
      key: true,
      keyCode: true,
      button: true,
      buttons: true,
      clientX: true,
      clientY: true,
      offsetX: true,
      offsetY: true,
      pointerId: true,
      pointerType: true,
      screenX: true,
      screenY: true,
      targetTouches: true,
      toElement: true,
      touches: true,
      which: true
    }, jQuery.event.addProp);
    jQuery.each({ focus: "focusin", blur: "focusout" }, function(type, delegateType) {
      function focusMappedHandler(nativeEvent) {
        if (document2.documentMode) {
          var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
          event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
          event.isSimulated = true;
          handle(nativeEvent);
          if (event.target === event.currentTarget) {
            handle(event);
          }
        } else {
          jQuery.event.simulate(
            delegateType,
            nativeEvent.target,
            jQuery.event.fix(nativeEvent)
          );
        }
      }
      jQuery.event.special[type] = {
        // Utilize native event if possible so blur/focus sequence is correct
        setup: function() {
          var attaches;
          leverageNative(this, type, true);
          if (document2.documentMode) {
            attaches = dataPriv.get(this, delegateType);
            if (!attaches) {
              this.addEventListener(delegateType, focusMappedHandler);
            }
            dataPriv.set(this, delegateType, (attaches || 0) + 1);
          } else {
            return false;
          }
        },
        trigger: function() {
          leverageNative(this, type);
          return true;
        },
        teardown: function() {
          var attaches;
          if (document2.documentMode) {
            attaches = dataPriv.get(this, delegateType) - 1;
            if (!attaches) {
              this.removeEventListener(delegateType, focusMappedHandler);
              dataPriv.remove(this, delegateType);
            } else {
              dataPriv.set(this, delegateType, attaches);
            }
          } else {
            return false;
          }
        },
        // Suppress native focus or blur if we're currently inside
        // a leveraged native-event stack
        _default: function(event) {
          return dataPriv.get(event.target, type);
        },
        delegateType
      };
      jQuery.event.special[delegateType] = {
        setup: function() {
          var doc = this.ownerDocument || this.document || this, dataHolder = document2.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
          if (!attaches) {
            if (document2.documentMode) {
              this.addEventListener(delegateType, focusMappedHandler);
            } else {
              doc.addEventListener(type, focusMappedHandler, true);
            }
          }
          dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
        },
        teardown: function() {
          var doc = this.ownerDocument || this.document || this, dataHolder = document2.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
          if (!attaches) {
            if (document2.documentMode) {
              this.removeEventListener(delegateType, focusMappedHandler);
            } else {
              doc.removeEventListener(type, focusMappedHandler, true);
            }
            dataPriv.remove(dataHolder, delegateType);
          } else {
            dataPriv.set(dataHolder, delegateType, attaches);
          }
        }
      };
    });
    jQuery.each({
      mouseenter: "mouseover",
      mouseleave: "mouseout",
      pointerenter: "pointerover",
      pointerleave: "pointerout"
    }, function(orig, fix) {
      jQuery.event.special[orig] = {
        delegateType: fix,
        bindType: fix,
        handle: function(event) {
          var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
          if (!related || related !== target && !jQuery.contains(target, related)) {
            event.type = handleObj.origType;
            ret = handleObj.handler.apply(this, arguments);
            event.type = fix;
          }
          return ret;
        }
      };
    });
    jQuery.fn.extend({
      on: function(types, selector, data, fn) {
        return on(this, types, selector, data, fn);
      },
      one: function(types, selector, data, fn) {
        return on(this, types, selector, data, fn, 1);
      },
      off: function(types, selector, fn) {
        var handleObj, type;
        if (types && types.preventDefault && types.handleObj) {
          handleObj = types.handleObj;
          jQuery(types.delegateTarget).off(
            handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
            handleObj.selector,
            handleObj.handler
          );
          return this;
        }
        if (typeof types === "object") {
          for (type in types) {
            this.off(type, selector, types[type]);
          }
          return this;
        }
        if (selector === false || typeof selector === "function") {
          fn = selector;
          selector = void 0;
        }
        if (fn === false) {
          fn = returnFalse;
        }
        return this.each(function() {
          jQuery.event.remove(this, types, fn, selector);
        });
      }
    });
    var rnoInnerhtml = /<script|<style|<link/i, rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    function manipulationTarget(elem, content) {
      if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) {
        return jQuery(elem).children("tbody")[0] || elem;
      }
      return elem;
    }
    function disableScript(elem) {
      elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
      return elem;
    }
    function restoreScript(elem) {
      if ((elem.type || "").slice(0, 5) === "true/") {
        elem.type = elem.type.slice(5);
      } else {
        elem.removeAttribute("type");
      }
      return elem;
    }
    function cloneCopyEvent(src, dest) {
      var i, l, type, pdataOld, udataOld, udataCur, events2;
      if (dest.nodeType !== 1) {
        return;
      }
      if (dataPriv.hasData(src)) {
        pdataOld = dataPriv.get(src);
        events2 = pdataOld.events;
        if (events2) {
          dataPriv.remove(dest, "handle events");
          for (type in events2) {
            for (i = 0, l = events2[type].length; i < l; i++) {
              jQuery.event.add(dest, type, events2[type][i]);
            }
          }
        }
      }
      if (dataUser.hasData(src)) {
        udataOld = dataUser.access(src);
        udataCur = jQuery.extend({}, udataOld);
        dataUser.set(dest, udataCur);
      }
    }
    function fixInput(src, dest) {
      var nodeName2 = dest.nodeName.toLowerCase();
      if (nodeName2 === "input" && rcheckableType.test(src.type)) {
        dest.checked = src.checked;
      } else if (nodeName2 === "input" || nodeName2 === "textarea") {
        dest.defaultValue = src.defaultValue;
      }
    }
    function domManip(collection, args, callback, ignored) {
      args = flat(args);
      var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
      if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) {
        return collection.each(function(index) {
          var self2 = collection.eq(index);
          if (valueIsFunction) {
            args[0] = value.call(this, index, self2.html());
          }
          domManip(self2, args, callback, ignored);
        });
      }
      if (l) {
        fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
        first = fragment.firstChild;
        if (fragment.childNodes.length === 1) {
          fragment = first;
        }
        if (first || ignored) {
          scripts = jQuery.map(getAll(fragment, "script"), disableScript);
          hasScripts = scripts.length;
          for (; i < l; i++) {
            node = fragment;
            if (i !== iNoClone) {
              node = jQuery.clone(node, true, true);
              if (hasScripts) {
                jQuery.merge(scripts, getAll(node, "script"));
              }
            }
            callback.call(collection[i], node, i);
          }
          if (hasScripts) {
            doc = scripts[scripts.length - 1].ownerDocument;
            jQuery.map(scripts, restoreScript);
            for (i = 0; i < hasScripts; i++) {
              node = scripts[i];
              if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                if (node.src && (node.type || "").toLowerCase() !== "module") {
                  if (jQuery._evalUrl && !node.noModule) {
                    jQuery._evalUrl(node.src, {
                      nonce: node.nonce || node.getAttribute("nonce")
                    }, doc);
                  }
                } else {
                  DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                }
              }
            }
          }
        }
      }
      return collection;
    }
    function remove(elem, selector, keepData) {
      var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
      for (; (node = nodes[i]) != null; i++) {
        if (!keepData && node.nodeType === 1) {
          jQuery.cleanData(getAll(node));
        }
        if (node.parentNode) {
          if (keepData && isAttached(node)) {
            setGlobalEval(getAll(node, "script"));
          }
          node.parentNode.removeChild(node);
        }
      }
      return elem;
    }
    jQuery.extend({
      htmlPrefilter: function(html) {
        return html;
      },
      clone: function(elem, dataAndEvents, deepDataAndEvents) {
        var i, l, srcElements, destElements, clone2 = elem.cloneNode(true), inPage = isAttached(elem);
        if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
          destElements = getAll(clone2);
          srcElements = getAll(elem);
          for (i = 0, l = srcElements.length; i < l; i++) {
            fixInput(srcElements[i], destElements[i]);
          }
        }
        if (dataAndEvents) {
          if (deepDataAndEvents) {
            srcElements = srcElements || getAll(elem);
            destElements = destElements || getAll(clone2);
            for (i = 0, l = srcElements.length; i < l; i++) {
              cloneCopyEvent(srcElements[i], destElements[i]);
            }
          } else {
            cloneCopyEvent(elem, clone2);
          }
        }
        destElements = getAll(clone2, "script");
        if (destElements.length > 0) {
          setGlobalEval(destElements, !inPage && getAll(elem, "script"));
        }
        return clone2;
      },
      cleanData: function(elems) {
        var data, elem, type, special = jQuery.event.special, i = 0;
        for (; (elem = elems[i]) !== void 0; i++) {
          if (acceptData(elem)) {
            if (data = elem[dataPriv.expando]) {
              if (data.events) {
                for (type in data.events) {
                  if (special[type]) {
                    jQuery.event.remove(elem, type);
                  } else {
                    jQuery.removeEvent(elem, type, data.handle);
                  }
                }
              }
              elem[dataPriv.expando] = void 0;
            }
            if (elem[dataUser.expando]) {
              elem[dataUser.expando] = void 0;
            }
          }
        }
      }
    });
    jQuery.fn.extend({
      detach: function(selector) {
        return remove(this, selector, true);
      },
      remove: function(selector) {
        return remove(this, selector);
      },
      text: function(value) {
        return access(this, function(value2) {
          return value2 === void 0 ? jQuery.text(this) : this.empty().each(function() {
            if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
              this.textContent = value2;
            }
          });
        }, null, value, arguments.length);
      },
      append: function() {
        return domManip(this, arguments, function(elem) {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            var target = manipulationTarget(this, elem);
            target.appendChild(elem);
          }
        });
      },
      prepend: function() {
        return domManip(this, arguments, function(elem) {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            var target = manipulationTarget(this, elem);
            target.insertBefore(elem, target.firstChild);
          }
        });
      },
      before: function() {
        return domManip(this, arguments, function(elem) {
          if (this.parentNode) {
            this.parentNode.insertBefore(elem, this);
          }
        });
      },
      after: function() {
        return domManip(this, arguments, function(elem) {
          if (this.parentNode) {
            this.parentNode.insertBefore(elem, this.nextSibling);
          }
        });
      },
      empty: function() {
        var elem, i = 0;
        for (; (elem = this[i]) != null; i++) {
          if (elem.nodeType === 1) {
            jQuery.cleanData(getAll(elem, false));
            elem.textContent = "";
          }
        }
        return this;
      },
      clone: function(dataAndEvents, deepDataAndEvents) {
        dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
        deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
        return this.map(function() {
          return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
        });
      },
      html: function(value) {
        return access(this, function(value2) {
          var elem = this[0] || {}, i = 0, l = this.length;
          if (value2 === void 0 && elem.nodeType === 1) {
            return elem.innerHTML;
          }
          if (typeof value2 === "string" && !rnoInnerhtml.test(value2) && !wrapMap[(rtagName.exec(value2) || ["", ""])[1].toLowerCase()]) {
            value2 = jQuery.htmlPrefilter(value2);
            try {
              for (; i < l; i++) {
                elem = this[i] || {};
                if (elem.nodeType === 1) {
                  jQuery.cleanData(getAll(elem, false));
                  elem.innerHTML = value2;
                }
              }
              elem = 0;
            } catch (e) {
            }
          }
          if (elem) {
            this.empty().append(value2);
          }
        }, null, value, arguments.length);
      },
      replaceWith: function() {
        var ignored = [];
        return domManip(this, arguments, function(elem) {
          var parent = this.parentNode;
          if (jQuery.inArray(this, ignored) < 0) {
            jQuery.cleanData(getAll(this));
            if (parent) {
              parent.replaceChild(elem, this);
            }
          }
        }, ignored);
      }
    });
    jQuery.each({
      appendTo: "append",
      prependTo: "prepend",
      insertBefore: "before",
      insertAfter: "after",
      replaceAll: "replaceWith"
    }, function(name2, original) {
      jQuery.fn[name2] = function(selector) {
        var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
        for (; i <= last; i++) {
          elems = i === last ? this : this.clone(true);
          jQuery(insert[i])[original](elems);
          push.apply(ret, elems.get());
        }
        return this.pushStack(ret);
      };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
      var view = elem.ownerDocument.defaultView;
      if (!view || !view.opener) {
        view = window2;
      }
      return view.getComputedStyle(elem);
    };
    var swap2 = function(elem, options, callback) {
      var ret, name2, old = {};
      for (name2 in options) {
        old[name2] = elem.style[name2];
        elem.style[name2] = options[name2];
      }
      ret = callback.call(elem);
      for (name2 in options) {
        elem.style[name2] = old[name2];
      }
      return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
      function computeStyleTests() {
        if (!div2) {
          return;
        }
        container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
        div2.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
        documentElement.appendChild(container).appendChild(div2);
        var divStyle = window2.getComputedStyle(div2);
        pixelPositionVal = divStyle.top !== "1%";
        reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
        div2.style.right = "60%";
        pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
        boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
        div2.style.position = "absolute";
        scrollboxSizeVal = roundPixelMeasures(div2.offsetWidth / 3) === 12;
        documentElement.removeChild(container);
        div2 = null;
      }
      function roundPixelMeasures(measure) {
        return Math.round(parseFloat(measure));
      }
      var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document2.createElement("div"), div2 = document2.createElement("div");
      if (!div2.style) {
        return;
      }
      div2.style.backgroundClip = "content-box";
      div2.cloneNode(true).style.backgroundClip = "";
      support.clearCloneStyle = div2.style.backgroundClip === "content-box";
      jQuery.extend(support, {
        boxSizingReliable: function() {
          computeStyleTests();
          return boxSizingReliableVal;
        },
        pixelBoxStyles: function() {
          computeStyleTests();
          return pixelBoxStylesVal;
        },
        pixelPosition: function() {
          computeStyleTests();
          return pixelPositionVal;
        },
        reliableMarginLeft: function() {
          computeStyleTests();
          return reliableMarginLeftVal;
        },
        scrollboxSize: function() {
          computeStyleTests();
          return scrollboxSizeVal;
        },
        // Support: IE 9 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Behavior in IE 9 is more subtle than in newer versions & it passes
        // some versions of this test; make sure not to make it pass there!
        //
        // Support: Firefox 70+
        // Only Firefox includes border widths
        // in computed dimensions. (gh-4529)
        reliableTrDimensions: function() {
          var table, tr, trChild, trStyle;
          if (reliableTrDimensionsVal == null) {
            table = document2.createElement("table");
            tr = document2.createElement("tr");
            trChild = document2.createElement("div");
            table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
            tr.style.cssText = "box-sizing:content-box;border:1px solid";
            tr.style.height = "1px";
            trChild.style.height = "9px";
            trChild.style.display = "block";
            documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
            trStyle = window2.getComputedStyle(tr);
            reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
            documentElement.removeChild(table);
          }
          return reliableTrDimensionsVal;
        }
      });
    })();
    function curCSS(elem, name2, computed) {
      var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name2), style = elem.style;
      computed = computed || getStyles(elem);
      if (computed) {
        ret = computed.getPropertyValue(name2) || computed[name2];
        if (isCustomProp && ret) {
          ret = ret.replace(rtrimCSS, "$1") || void 0;
        }
        if (ret === "" && !isAttached(elem)) {
          ret = jQuery.style(elem, name2);
        }
        if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name2)) {
          width = style.width;
          minWidth = style.minWidth;
          maxWidth = style.maxWidth;
          style.minWidth = style.maxWidth = style.width = ret;
          ret = computed.width;
          style.width = width;
          style.minWidth = minWidth;
          style.maxWidth = maxWidth;
        }
      }
      return ret !== void 0 ? (
        // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + ""
      ) : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
      return {
        get: function() {
          if (conditionFn()) {
            delete this.get;
            return;
          }
          return (this.get = hookFn).apply(this, arguments);
        }
      };
    }
    var cssPrefixes = ["Webkit", "Moz", "ms"], emptyStyle = document2.createElement("div").style, vendorProps = {};
    function vendorPropName(name2) {
      var capName = name2[0].toUpperCase() + name2.slice(1), i = cssPrefixes.length;
      while (i--) {
        name2 = cssPrefixes[i] + capName;
        if (name2 in emptyStyle) {
          return name2;
        }
      }
    }
    function finalPropName(name2) {
      var final = jQuery.cssProps[name2] || vendorProps[name2];
      if (final) {
        return final;
      }
      if (name2 in emptyStyle) {
        return name2;
      }
      return vendorProps[name2] = vendorPropName(name2) || name2;
    }
    var rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = { position: "absolute", visibility: "hidden", display: "block" }, cssNormalTransform = {
      letterSpacing: "0",
      fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
      var matches = rcssNum.exec(value);
      return matches ? (
        // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px")
      ) : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
      var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
      if (box === (isBorderBox ? "border" : "content")) {
        return 0;
      }
      for (; i < 4; i += 2) {
        if (box === "margin") {
          marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
        }
        if (!isBorderBox) {
          delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
          if (box !== "padding") {
            delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
          } else {
            extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
          }
        } else {
          if (box === "content") {
            delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
          }
          if (box !== "margin") {
            delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
          }
        }
      }
      if (!isBorderBox && computedVal >= 0) {
        delta += Math.max(0, Math.ceil(
          elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5
          // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
          // Use an explicit zero to avoid NaN (gh-3964)
        )) || 0;
      }
      return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
      var styles = getStyles(elem), boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
      if (rnumnonpx.test(val)) {
        if (!extra) {
          return val;
        }
        val = "auto";
      }
      if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
      // IE/Edge misreport `getComputedStyle` of table rows with width/height
      // set in CSS while `offset*` properties report correct values.
      // Interestingly, in some cases IE 9 doesn't suffer from this issue.
      !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
      // This happens for inline elements with no explicit setting (gh-3571)
      val === "auto" || // Support: Android <=4.1 - 4.3 only
      // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
      !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
      elem.getClientRects().length) {
        isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
        valueIsBorderBox = offsetProp in elem;
        if (valueIsBorderBox) {
          val = elem[offsetProp];
        }
      }
      val = parseFloat(val) || 0;
      return val + boxModelAdjustment(
        elem,
        dimension,
        extra || (isBorderBox ? "border" : "content"),
        valueIsBorderBox,
        styles,
        // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val
      ) + "px";
    }
    jQuery.extend({
      // Add in style property hooks for overriding the default
      // behavior of getting and setting a style property
      cssHooks: {
        opacity: {
          get: function(elem, computed) {
            if (computed) {
              var ret = curCSS(elem, "opacity");
              return ret === "" ? "1" : ret;
            }
          }
        }
      },
      // Don't automatically add "px" to these possibly-unitless properties
      cssNumber: {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageSlice: true,
        columnCount: true,
        flexGrow: true,
        flexShrink: true,
        fontWeight: true,
        gridArea: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnStart: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowStart: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        scale: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeMiterlimit: true,
        strokeOpacity: true
      },
      // Add in properties whose names you wish to fix before
      // setting or getting the value
      cssProps: {},
      // Get and set the style property on a DOM Node
      style: function(elem, name2, value, extra) {
        if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
          return;
        }
        var ret, type, hooks, origName = camelCase(name2), isCustomProp = rcustomProp.test(name2), style = elem.style;
        if (!isCustomProp) {
          name2 = finalPropName(origName);
        }
        hooks = jQuery.cssHooks[name2] || jQuery.cssHooks[origName];
        if (value !== void 0) {
          type = typeof value;
          if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
            value = adjustCSS(elem, name2, ret);
            type = "number";
          }
          if (value == null || value !== value) {
            return;
          }
          if (type === "number" && !isCustomProp) {
            value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
          }
          if (!support.clearCloneStyle && value === "" && name2.indexOf("background") === 0) {
            style[name2] = "inherit";
          }
          if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== void 0) {
            if (isCustomProp) {
              style.setProperty(name2, value);
            } else {
              style[name2] = value;
            }
          }
        } else {
          if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== void 0) {
            return ret;
          }
          return style[name2];
        }
      },
      css: function(elem, name2, extra, styles) {
        var val, num, hooks, origName = camelCase(name2), isCustomProp = rcustomProp.test(name2);
        if (!isCustomProp) {
          name2 = finalPropName(origName);
        }
        hooks = jQuery.cssHooks[name2] || jQuery.cssHooks[origName];
        if (hooks && "get" in hooks) {
          val = hooks.get(elem, true, extra);
        }
        if (val === void 0) {
          val = curCSS(elem, name2, styles);
        }
        if (val === "normal" && name2 in cssNormalTransform) {
          val = cssNormalTransform[name2];
        }
        if (extra === "" || extra) {
          num = parseFloat(val);
          return extra === true || isFinite(num) ? num || 0 : val;
        }
        return val;
      }
    });
    jQuery.each(["height", "width"], function(_i, dimension) {
      jQuery.cssHooks[dimension] = {
        get: function(elem, computed, extra) {
          if (computed) {
            return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
            // Table columns in Safari have non-zero offsetWidth & zero
            // getBoundingClientRect().width unless display is changed.
            // Support: IE <=11 only
            // Running getBoundingClientRect on a disconnected node
            // in IE throws an error.
            (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap2(elem, cssShow, function() {
              return getWidthOrHeight(elem, dimension, extra);
            }) : getWidthOrHeight(elem, dimension, extra);
          }
        },
        set: function(elem, value, extra) {
          var matches, styles = getStyles(elem), scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(
            elem,
            dimension,
            extra,
            isBorderBox,
            styles
          ) : 0;
          if (isBorderBox && scrollboxSizeBuggy) {
            subtract -= Math.ceil(
              elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5
            );
          }
          if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
            elem.style[dimension] = value;
            value = jQuery.css(elem, dimension);
          }
          return setPositiveNumber(elem, value, subtract);
        }
      };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(
      support.reliableMarginLeft,
      function(elem, computed) {
        if (computed) {
          return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap2(elem, { marginLeft: 0 }, function() {
            return elem.getBoundingClientRect().left;
          })) + "px";
        }
      }
    );
    jQuery.each({
      margin: "",
      padding: "",
      border: "Width"
    }, function(prefix, suffix) {
      jQuery.cssHooks[prefix + suffix] = {
        expand: function(value) {
          var i = 0, expanded = {}, parts = typeof value === "string" ? value.split(" ") : [value];
          for (; i < 4; i++) {
            expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
          }
          return expanded;
        }
      };
      if (prefix !== "margin") {
        jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
      }
    });
    jQuery.fn.extend({
      css: function(name2, value) {
        return access(this, function(elem, name22, value2) {
          var styles, len, map2 = {}, i = 0;
          if (Array.isArray(name22)) {
            styles = getStyles(elem);
            len = name22.length;
            for (; i < len; i++) {
              map2[name22[i]] = jQuery.css(elem, name22[i], false, styles);
            }
            return map2;
          }
          return value2 !== void 0 ? jQuery.style(elem, name22, value2) : jQuery.css(elem, name22);
        }, name2, value, arguments.length > 1);
      }
    });
    function Tween(elem, options, prop, end, easing) {
      return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
      constructor: Tween,
      init: function(elem, options, prop, end, easing, unit) {
        this.elem = elem;
        this.prop = prop;
        this.easing = easing || jQuery.easing._default;
        this.options = options;
        this.start = this.now = this.cur();
        this.end = end;
        this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
      },
      cur: function() {
        var hooks = Tween.propHooks[this.prop];
        return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
      },
      run: function(percent) {
        var eased, hooks = Tween.propHooks[this.prop];
        if (this.options.duration) {
          this.pos = eased = jQuery.easing[this.easing](
            percent,
            this.options.duration * percent,
            0,
            1,
            this.options.duration
          );
        } else {
          this.pos = eased = percent;
        }
        this.now = (this.end - this.start) * eased + this.start;
        if (this.options.step) {
          this.options.step.call(this.elem, this.now, this);
        }
        if (hooks && hooks.set) {
          hooks.set(this);
        } else {
          Tween.propHooks._default.set(this);
        }
        return this;
      }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
      _default: {
        get: function(tween) {
          var result;
          if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
            return tween.elem[tween.prop];
          }
          result = jQuery.css(tween.elem, tween.prop, "");
          return !result || result === "auto" ? 0 : result;
        },
        set: function(tween) {
          if (jQuery.fx.step[tween.prop]) {
            jQuery.fx.step[tween.prop](tween);
          } else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) {
            jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
          } else {
            tween.elem[tween.prop] = tween.now;
          }
        }
      }
    };
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
      set: function(tween) {
        if (tween.elem.nodeType && tween.elem.parentNode) {
          tween.elem[tween.prop] = tween.now;
        }
      }
    };
    jQuery.easing = {
      linear: function(p) {
        return p;
      },
      swing: function(p) {
        return 0.5 - Math.cos(p * Math.PI) / 2;
      },
      _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
      if (inProgress) {
        if (document2.hidden === false && window2.requestAnimationFrame) {
          window2.requestAnimationFrame(schedule);
        } else {
          window2.setTimeout(schedule, jQuery.fx.interval);
        }
        jQuery.fx.tick();
      }
    }
    function createFxNow() {
      window2.setTimeout(function() {
        fxNow = void 0;
      });
      return fxNow = Date.now();
    }
    function genFx(type, includeWidth) {
      var which, i = 0, attrs = { height: type };
      includeWidth = includeWidth ? 1 : 0;
      for (; i < 4; i += 2 - includeWidth) {
        which = cssExpand[i];
        attrs["margin" + which] = attrs["padding" + which] = type;
      }
      if (includeWidth) {
        attrs.opacity = attrs.width = type;
      }
      return attrs;
    }
    function createTween(value, prop, animation) {
      var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
      for (; index < length; index++) {
        if (tween = collection[index].call(animation, prop, value)) {
          return tween;
        }
      }
    }
    function defaultPrefilter(elem, props, opts) {
      var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
      if (!opts.queue) {
        hooks = jQuery._queueHooks(elem, "fx");
        if (hooks.unqueued == null) {
          hooks.unqueued = 0;
          oldfire = hooks.empty.fire;
          hooks.empty.fire = function() {
            if (!hooks.unqueued) {
              oldfire();
            }
          };
        }
        hooks.unqueued++;
        anim.always(function() {
          anim.always(function() {
            hooks.unqueued--;
            if (!jQuery.queue(elem, "fx").length) {
              hooks.empty.fire();
            }
          });
        });
      }
      for (prop in props) {
        value = props[prop];
        if (rfxtypes.test(value)) {
          delete props[prop];
          toggle = toggle || value === "toggle";
          if (value === (hidden ? "hide" : "show")) {
            if (value === "show" && dataShow && dataShow[prop] !== void 0) {
              hidden = true;
            } else {
              continue;
            }
          }
          orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
        }
      }
      propTween = !jQuery.isEmptyObject(props);
      if (!propTween && jQuery.isEmptyObject(orig)) {
        return;
      }
      if (isBox && elem.nodeType === 1) {
        opts.overflow = [style.overflow, style.overflowX, style.overflowY];
        restoreDisplay = dataShow && dataShow.display;
        if (restoreDisplay == null) {
          restoreDisplay = dataPriv.get(elem, "display");
        }
        display = jQuery.css(elem, "display");
        if (display === "none") {
          if (restoreDisplay) {
            display = restoreDisplay;
          } else {
            showHide([elem], true);
            restoreDisplay = elem.style.display || restoreDisplay;
            display = jQuery.css(elem, "display");
            showHide([elem]);
          }
        }
        if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
          if (jQuery.css(elem, "float") === "none") {
            if (!propTween) {
              anim.done(function() {
                style.display = restoreDisplay;
              });
              if (restoreDisplay == null) {
                display = style.display;
                restoreDisplay = display === "none" ? "" : display;
              }
            }
            style.display = "inline-block";
          }
        }
      }
      if (opts.overflow) {
        style.overflow = "hidden";
        anim.always(function() {
          style.overflow = opts.overflow[0];
          style.overflowX = opts.overflow[1];
          style.overflowY = opts.overflow[2];
        });
      }
      propTween = false;
      for (prop in orig) {
        if (!propTween) {
          if (dataShow) {
            if ("hidden" in dataShow) {
              hidden = dataShow.hidden;
            }
          } else {
            dataShow = dataPriv.access(elem, "fxshow", { display: restoreDisplay });
          }
          if (toggle) {
            dataShow.hidden = !hidden;
          }
          if (hidden) {
            showHide([elem], true);
          }
          anim.done(function() {
            if (!hidden) {
              showHide([elem]);
            }
            dataPriv.remove(elem, "fxshow");
            for (prop in orig) {
              jQuery.style(elem, prop, orig[prop]);
            }
          });
        }
        propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
        if (!(prop in dataShow)) {
          dataShow[prop] = propTween.start;
          if (hidden) {
            propTween.end = propTween.start;
            propTween.start = 0;
          }
        }
      }
    }
    function propFilter(props, specialEasing) {
      var index, name2, easing, value, hooks;
      for (index in props) {
        name2 = camelCase(index);
        easing = specialEasing[name2];
        value = props[index];
        if (Array.isArray(value)) {
          easing = value[1];
          value = props[index] = value[0];
        }
        if (index !== name2) {
          props[name2] = value;
          delete props[index];
        }
        hooks = jQuery.cssHooks[name2];
        if (hooks && "expand" in hooks) {
          value = hooks.expand(value);
          delete props[name2];
          for (index in value) {
            if (!(index in props)) {
              props[index] = value[index];
              specialEasing[index] = easing;
            }
          }
        } else {
          specialEasing[name2] = easing;
        }
      }
    }
    function Animation(elem, properties, options) {
      var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
        delete tick.elem;
      }), tick = function() {
        if (stopped) {
          return false;
        }
        var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), temp = remaining / animation.duration || 0, percent = 1 - temp, index2 = 0, length2 = animation.tweens.length;
        for (; index2 < length2; index2++) {
          animation.tweens[index2].run(percent);
        }
        deferred.notifyWith(elem, [animation, percent, remaining]);
        if (percent < 1 && length2) {
          return remaining;
        }
        if (!length2) {
          deferred.notifyWith(elem, [animation, 1, 0]);
        }
        deferred.resolveWith(elem, [animation]);
        return false;
      }, animation = deferred.promise({
        elem,
        props: jQuery.extend({}, properties),
        opts: jQuery.extend(true, {
          specialEasing: {},
          easing: jQuery.easing._default
        }, options),
        originalProperties: properties,
        originalOptions: options,
        startTime: fxNow || createFxNow(),
        duration: options.duration,
        tweens: [],
        createTween: function(prop, end) {
          var tween = jQuery.Tween(
            elem,
            animation.opts,
            prop,
            end,
            animation.opts.specialEasing[prop] || animation.opts.easing
          );
          animation.tweens.push(tween);
          return tween;
        },
        stop: function(gotoEnd) {
          var index2 = 0, length2 = gotoEnd ? animation.tweens.length : 0;
          if (stopped) {
            return this;
          }
          stopped = true;
          for (; index2 < length2; index2++) {
            animation.tweens[index2].run(1);
          }
          if (gotoEnd) {
            deferred.notifyWith(elem, [animation, 1, 0]);
            deferred.resolveWith(elem, [animation, gotoEnd]);
          } else {
            deferred.rejectWith(elem, [animation, gotoEnd]);
          }
          return this;
        }
      }), props = animation.props;
      propFilter(props, animation.opts.specialEasing);
      for (; index < length; index++) {
        result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
        if (result) {
          if (isFunction(result.stop)) {
            jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
          }
          return result;
        }
      }
      jQuery.map(props, createTween, animation);
      if (isFunction(animation.opts.start)) {
        animation.opts.start.call(elem, animation);
      }
      animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
      jQuery.fx.timer(
        jQuery.extend(tick, {
          elem,
          anim: animation,
          queue: animation.opts.queue
        })
      );
      return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
      tweeners: {
        "*": [function(prop, value) {
          var tween = this.createTween(prop, value);
          adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
          return tween;
        }]
      },
      tweener: function(props, callback) {
        if (isFunction(props)) {
          callback = props;
          props = ["*"];
        } else {
          props = props.match(rnothtmlwhite);
        }
        var prop, index = 0, length = props.length;
        for (; index < length; index++) {
          prop = props[index];
          Animation.tweeners[prop] = Animation.tweeners[prop] || [];
          Animation.tweeners[prop].unshift(callback);
        }
      },
      prefilters: [defaultPrefilter],
      prefilter: function(callback, prepend) {
        if (prepend) {
          Animation.prefilters.unshift(callback);
        } else {
          Animation.prefilters.push(callback);
        }
      }
    });
    jQuery.speed = function(speed, easing, fn) {
      var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
        complete: fn || !fn && easing || isFunction(speed) && speed,
        duration: speed,
        easing: fn && easing || easing && !isFunction(easing) && easing
      };
      if (jQuery.fx.off) {
        opt.duration = 0;
      } else {
        if (typeof opt.duration !== "number") {
          if (opt.duration in jQuery.fx.speeds) {
            opt.duration = jQuery.fx.speeds[opt.duration];
          } else {
            opt.duration = jQuery.fx.speeds._default;
          }
        }
      }
      if (opt.queue == null || opt.queue === true) {
        opt.queue = "fx";
      }
      opt.old = opt.complete;
      opt.complete = function() {
        if (isFunction(opt.old)) {
          opt.old.call(this);
        }
        if (opt.queue) {
          jQuery.dequeue(this, opt.queue);
        }
      };
      return opt;
    };
    jQuery.fn.extend({
      fadeTo: function(speed, to, easing, callback) {
        return this.filter(isHiddenWithinTree).css("opacity", 0).show().end().animate({ opacity: to }, speed, easing, callback);
      },
      animate: function(prop, speed, easing, callback) {
        var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
          var anim = Animation(this, jQuery.extend({}, prop), optall);
          if (empty || dataPriv.get(this, "finish")) {
            anim.stop(true);
          }
        };
        doAnimation.finish = doAnimation;
        return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
      },
      stop: function(type, clearQueue, gotoEnd) {
        var stopQueue = function(hooks) {
          var stop = hooks.stop;
          delete hooks.stop;
          stop(gotoEnd);
        };
        if (typeof type !== "string") {
          gotoEnd = clearQueue;
          clearQueue = type;
          type = void 0;
        }
        if (clearQueue) {
          this.queue(type || "fx", []);
        }
        return this.each(function() {
          var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
          if (index) {
            if (data[index] && data[index].stop) {
              stopQueue(data[index]);
            }
          } else {
            for (index in data) {
              if (data[index] && data[index].stop && rrun.test(index)) {
                stopQueue(data[index]);
              }
            }
          }
          for (index = timers.length; index--; ) {
            if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
              timers[index].anim.stop(gotoEnd);
              dequeue = false;
              timers.splice(index, 1);
            }
          }
          if (dequeue || !gotoEnd) {
            jQuery.dequeue(this, type);
          }
        });
      },
      finish: function(type) {
        if (type !== false) {
          type = type || "fx";
        }
        return this.each(function() {
          var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
          data.finish = true;
          jQuery.queue(this, type, []);
          if (hooks && hooks.stop) {
            hooks.stop.call(this, true);
          }
          for (index = timers.length; index--; ) {
            if (timers[index].elem === this && timers[index].queue === type) {
              timers[index].anim.stop(true);
              timers.splice(index, 1);
            }
          }
          for (index = 0; index < length; index++) {
            if (queue[index] && queue[index].finish) {
              queue[index].finish.call(this);
            }
          }
          delete data.finish;
        });
      }
    });
    jQuery.each(["toggle", "show", "hide"], function(_i, name2) {
      var cssFn = jQuery.fn[name2];
      jQuery.fn[name2] = function(speed, easing, callback) {
        return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name2, true), speed, easing, callback);
      };
    });
    jQuery.each({
      slideDown: genFx("show"),
      slideUp: genFx("hide"),
      slideToggle: genFx("toggle"),
      fadeIn: { opacity: "show" },
      fadeOut: { opacity: "hide" },
      fadeToggle: { opacity: "toggle" }
    }, function(name2, props) {
      jQuery.fn[name2] = function(speed, easing, callback) {
        return this.animate(props, speed, easing, callback);
      };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
      var timer, i = 0, timers = jQuery.timers;
      fxNow = Date.now();
      for (; i < timers.length; i++) {
        timer = timers[i];
        if (!timer() && timers[i] === timer) {
          timers.splice(i--, 1);
        }
      }
      if (!timers.length) {
        jQuery.fx.stop();
      }
      fxNow = void 0;
    };
    jQuery.fx.timer = function(timer) {
      jQuery.timers.push(timer);
      jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
      if (inProgress) {
        return;
      }
      inProgress = true;
      schedule();
    };
    jQuery.fx.stop = function() {
      inProgress = null;
    };
    jQuery.fx.speeds = {
      slow: 600,
      fast: 200,
      // Default speed
      _default: 400
    };
    jQuery.fn.delay = function(time, type) {
      time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
      type = type || "fx";
      return this.queue(type, function(next, hooks) {
        var timeout = window2.setTimeout(next, time);
        hooks.stop = function() {
          window2.clearTimeout(timeout);
        };
      });
    };
    (function() {
      var input = document2.createElement("input"), select = document2.createElement("select"), opt = select.appendChild(document2.createElement("option"));
      input.type = "checkbox";
      support.checkOn = input.value !== "";
      support.optSelected = opt.selected;
      input = document2.createElement("input");
      input.value = "t";
      input.type = "radio";
      support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
      attr: function(name2, value) {
        return access(this, jQuery.attr, name2, value, arguments.length > 1);
      },
      removeAttr: function(name2) {
        return this.each(function() {
          jQuery.removeAttr(this, name2);
        });
      }
    });
    jQuery.extend({
      attr: function(elem, name2, value) {
        var ret, hooks, nType = elem.nodeType;
        if (nType === 3 || nType === 8 || nType === 2) {
          return;
        }
        if (typeof elem.getAttribute === "undefined") {
          return jQuery.prop(elem, name2, value);
        }
        if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
          hooks = jQuery.attrHooks[name2.toLowerCase()] || (jQuery.expr.match.bool.test(name2) ? boolHook : void 0);
        }
        if (value !== void 0) {
          if (value === null) {
            jQuery.removeAttr(elem, name2);
            return;
          }
          if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name2)) !== void 0) {
            return ret;
          }
          elem.setAttribute(name2, value + "");
          return value;
        }
        if (hooks && "get" in hooks && (ret = hooks.get(elem, name2)) !== null) {
          return ret;
        }
        ret = jQuery.find.attr(elem, name2);
        return ret == null ? void 0 : ret;
      },
      attrHooks: {
        type: {
          set: function(elem, value) {
            if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
              var val = elem.value;
              elem.setAttribute("type", value);
              if (val) {
                elem.value = val;
              }
              return value;
            }
          }
        }
      },
      removeAttr: function(elem, value) {
        var name2, i = 0, attrNames = value && value.match(rnothtmlwhite);
        if (attrNames && elem.nodeType === 1) {
          while (name2 = attrNames[i++]) {
            elem.removeAttribute(name2);
          }
        }
      }
    });
    boolHook = {
      set: function(elem, value, name2) {
        if (value === false) {
          jQuery.removeAttr(elem, name2);
        } else {
          elem.setAttribute(name2, name2);
        }
        return name2;
      }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name2) {
      var getter = attrHandle[name2] || jQuery.find.attr;
      attrHandle[name2] = function(elem, name22, isXML) {
        var ret, handle, lowercaseName = name22.toLowerCase();
        if (!isXML) {
          handle = attrHandle[lowercaseName];
          attrHandle[lowercaseName] = ret;
          ret = getter(elem, name22, isXML) != null ? lowercaseName : null;
          attrHandle[lowercaseName] = handle;
        }
        return ret;
      };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
      prop: function(name2, value) {
        return access(this, jQuery.prop, name2, value, arguments.length > 1);
      },
      removeProp: function(name2) {
        return this.each(function() {
          delete this[jQuery.propFix[name2] || name2];
        });
      }
    });
    jQuery.extend({
      prop: function(elem, name2, value) {
        var ret, hooks, nType = elem.nodeType;
        if (nType === 3 || nType === 8 || nType === 2) {
          return;
        }
        if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
          name2 = jQuery.propFix[name2] || name2;
          hooks = jQuery.propHooks[name2];
        }
        if (value !== void 0) {
          if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name2)) !== void 0) {
            return ret;
          }
          return elem[name2] = value;
        }
        if (hooks && "get" in hooks && (ret = hooks.get(elem, name2)) !== null) {
          return ret;
        }
        return elem[name2];
      },
      propHooks: {
        tabIndex: {
          get: function(elem) {
            var tabindex = jQuery.find.attr(elem, "tabindex");
            if (tabindex) {
              return parseInt(tabindex, 10);
            }
            if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) {
              return 0;
            }
            return -1;
          }
        }
      },
      propFix: {
        "for": "htmlFor",
        "class": "className"
      }
    });
    if (!support.optSelected) {
      jQuery.propHooks.selected = {
        get: function(elem) {
          var parent = elem.parentNode;
          if (parent && parent.parentNode) {
            parent.parentNode.selectedIndex;
          }
          return null;
        },
        set: function(elem) {
          var parent = elem.parentNode;
          if (parent) {
            parent.selectedIndex;
            if (parent.parentNode) {
              parent.parentNode.selectedIndex;
            }
          }
        }
      };
    }
    jQuery.each([
      "tabIndex",
      "readOnly",
      "maxLength",
      "cellSpacing",
      "cellPadding",
      "rowSpan",
      "colSpan",
      "useMap",
      "frameBorder",
      "contentEditable"
    ], function() {
      jQuery.propFix[this.toLowerCase()] = this;
    });
    function stripAndCollapse(value) {
      var tokens = value.match(rnothtmlwhite) || [];
      return tokens.join(" ");
    }
    function getClass(elem) {
      return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
      if (Array.isArray(value)) {
        return value;
      }
      if (typeof value === "string") {
        return value.match(rnothtmlwhite) || [];
      }
      return [];
    }
    jQuery.fn.extend({
      addClass: function(value) {
        var classNames, cur, curValue, className, i, finalValue;
        if (isFunction(value)) {
          return this.each(function(j) {
            jQuery(this).addClass(value.call(this, j, getClass(this)));
          });
        }
        classNames = classesToArray(value);
        if (classNames.length) {
          return this.each(function() {
            curValue = getClass(this);
            cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
            if (cur) {
              for (i = 0; i < classNames.length; i++) {
                className = classNames[i];
                if (cur.indexOf(" " + className + " ") < 0) {
                  cur += className + " ";
                }
              }
              finalValue = stripAndCollapse(cur);
              if (curValue !== finalValue) {
                this.setAttribute("class", finalValue);
              }
            }
          });
        }
        return this;
      },
      removeClass: function(value) {
        var classNames, cur, curValue, className, i, finalValue;
        if (isFunction(value)) {
          return this.each(function(j) {
            jQuery(this).removeClass(value.call(this, j, getClass(this)));
          });
        }
        if (!arguments.length) {
          return this.attr("class", "");
        }
        classNames = classesToArray(value);
        if (classNames.length) {
          return this.each(function() {
            curValue = getClass(this);
            cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
            if (cur) {
              for (i = 0; i < classNames.length; i++) {
                className = classNames[i];
                while (cur.indexOf(" " + className + " ") > -1) {
                  cur = cur.replace(" " + className + " ", " ");
                }
              }
              finalValue = stripAndCollapse(cur);
              if (curValue !== finalValue) {
                this.setAttribute("class", finalValue);
              }
            }
          });
        }
        return this;
      },
      toggleClass: function(value, stateVal) {
        var classNames, className, i, self2, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
        if (isFunction(value)) {
          return this.each(function(i2) {
            jQuery(this).toggleClass(
              value.call(this, i2, getClass(this), stateVal),
              stateVal
            );
          });
        }
        if (typeof stateVal === "boolean" && isValidValue) {
          return stateVal ? this.addClass(value) : this.removeClass(value);
        }
        classNames = classesToArray(value);
        return this.each(function() {
          if (isValidValue) {
            self2 = jQuery(this);
            for (i = 0; i < classNames.length; i++) {
              className = classNames[i];
              if (self2.hasClass(className)) {
                self2.removeClass(className);
              } else {
                self2.addClass(className);
              }
            }
          } else if (value === void 0 || type === "boolean") {
            className = getClass(this);
            if (className) {
              dataPriv.set(this, "__className__", className);
            }
            if (this.setAttribute) {
              this.setAttribute(
                "class",
                className || value === false ? "" : dataPriv.get(this, "__className__") || ""
              );
            }
          }
        });
      },
      hasClass: function(selector) {
        var className, elem, i = 0;
        className = " " + selector + " ";
        while (elem = this[i++]) {
          if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) {
            return true;
          }
        }
        return false;
      }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
      val: function(value) {
        var hooks, ret, valueIsFunction, elem = this[0];
        if (!arguments.length) {
          if (elem) {
            hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
            if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== void 0) {
              return ret;
            }
            ret = elem.value;
            if (typeof ret === "string") {
              return ret.replace(rreturn, "");
            }
            return ret == null ? "" : ret;
          }
          return;
        }
        valueIsFunction = isFunction(value);
        return this.each(function(i) {
          var val;
          if (this.nodeType !== 1) {
            return;
          }
          if (valueIsFunction) {
            val = value.call(this, i, jQuery(this).val());
          } else {
            val = value;
          }
          if (val == null) {
            val = "";
          } else if (typeof val === "number") {
            val += "";
          } else if (Array.isArray(val)) {
            val = jQuery.map(val, function(value2) {
              return value2 == null ? "" : value2 + "";
            });
          }
          hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
          if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === void 0) {
            this.value = val;
          }
        });
      }
    });
    jQuery.extend({
      valHooks: {
        option: {
          get: function(elem) {
            var val = jQuery.find.attr(elem, "value");
            return val != null ? val : (
              // Support: IE <=10 - 11 only
              // option.text throws exceptions (trac-14686, trac-14858)
              // Strip and collapse whitespace
              // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
              stripAndCollapse(jQuery.text(elem))
            );
          }
        },
        select: {
          get: function(elem) {
            var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max2 = one ? index + 1 : options.length;
            if (index < 0) {
              i = max2;
            } else {
              i = one ? index : 0;
            }
            for (; i < max2; i++) {
              option = options[i];
              if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
              !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                value = jQuery(option).val();
                if (one) {
                  return value;
                }
                values.push(value);
              }
            }
            return values;
          },
          set: function(elem, value) {
            var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
            while (i--) {
              option = options[i];
              if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) {
                optionSet = true;
              }
            }
            if (!optionSet) {
              elem.selectedIndex = -1;
            }
            return values;
          }
        }
      }
    });
    jQuery.each(["radio", "checkbox"], function() {
      jQuery.valHooks[this] = {
        set: function(elem, value) {
          if (Array.isArray(value)) {
            return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
          }
        }
      };
      if (!support.checkOn) {
        jQuery.valHooks[this].get = function(elem) {
          return elem.getAttribute("value") === null ? "on" : elem.value;
        };
      }
    });
    var location2 = window2.location;
    var nonce = { guid: Date.now() };
    var rquery = /\?/;
    jQuery.parseXML = function(data) {
      var xml, parserErrorElem;
      if (!data || typeof data !== "string") {
        return null;
      }
      try {
        xml = new window2.DOMParser().parseFromString(data, "text/xml");
      } catch (e) {
      }
      parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
      if (!xml || parserErrorElem) {
        jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
          return el.textContent;
        }).join("\n") : data));
      }
      return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
      e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
      trigger: function(event, data, elem, onlyHandlers) {
        var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [elem || document2], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
        cur = lastElement = tmp = elem = elem || document2;
        if (elem.nodeType === 3 || elem.nodeType === 8) {
          return;
        }
        if (rfocusMorph.test(type + jQuery.event.triggered)) {
          return;
        }
        if (type.indexOf(".") > -1) {
          namespaces = type.split(".");
          type = namespaces.shift();
          namespaces.sort();
        }
        ontype = type.indexOf(":") < 0 && "on" + type;
        event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
        event.isTrigger = onlyHandlers ? 2 : 3;
        event.namespace = namespaces.join(".");
        event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
        event.result = void 0;
        if (!event.target) {
          event.target = elem;
        }
        data = data == null ? [event] : jQuery.makeArray(data, [event]);
        special = jQuery.event.special[type] || {};
        if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
          return;
        }
        if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
          bubbleType = special.delegateType || type;
          if (!rfocusMorph.test(bubbleType + type)) {
            cur = cur.parentNode;
          }
          for (; cur; cur = cur.parentNode) {
            eventPath.push(cur);
            tmp = cur;
          }
          if (tmp === (elem.ownerDocument || document2)) {
            eventPath.push(tmp.defaultView || tmp.parentWindow || window2);
          }
        }
        i = 0;
        while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
          lastElement = cur;
          event.type = i > 1 ? bubbleType : special.bindType || type;
          handle = (dataPriv.get(cur, "events") || /* @__PURE__ */ Object.create(null))[event.type] && dataPriv.get(cur, "handle");
          if (handle) {
            handle.apply(cur, data);
          }
          handle = ontype && cur[ontype];
          if (handle && handle.apply && acceptData(cur)) {
            event.result = handle.apply(cur, data);
            if (event.result === false) {
              event.preventDefault();
            }
          }
        }
        event.type = type;
        if (!onlyHandlers && !event.isDefaultPrevented()) {
          if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) {
            if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
              tmp = elem[ontype];
              if (tmp) {
                elem[ontype] = null;
              }
              jQuery.event.triggered = type;
              if (event.isPropagationStopped()) {
                lastElement.addEventListener(type, stopPropagationCallback);
              }
              elem[type]();
              if (event.isPropagationStopped()) {
                lastElement.removeEventListener(type, stopPropagationCallback);
              }
              jQuery.event.triggered = void 0;
              if (tmp) {
                elem[ontype] = tmp;
              }
            }
          }
        }
        return event.result;
      },
      // Piggyback on a donor event to simulate a different one
      // Used only for `focus(in | out)` events
      simulate: function(type, elem, event) {
        var e = jQuery.extend(
          new jQuery.Event(),
          event,
          {
            type,
            isSimulated: true
          }
        );
        jQuery.event.trigger(e, null, elem);
      }
    });
    jQuery.fn.extend({
      trigger: function(type, data) {
        return this.each(function() {
          jQuery.event.trigger(type, data, this);
        });
      },
      triggerHandler: function(type, data) {
        var elem = this[0];
        if (elem) {
          return jQuery.event.trigger(type, data, elem, true);
        }
      }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add2) {
      var name2;
      if (Array.isArray(obj)) {
        jQuery.each(obj, function(i, v) {
          if (traditional || rbracket.test(prefix)) {
            add2(prefix, v);
          } else {
            buildParams(
              prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]",
              v,
              traditional,
              add2
            );
          }
        });
      } else if (!traditional && toType(obj) === "object") {
        for (name2 in obj) {
          buildParams(prefix + "[" + name2 + "]", obj[name2], traditional, add2);
        }
      } else {
        add2(prefix, obj);
      }
    }
    jQuery.param = function(a, traditional) {
      var prefix, s = [], add2 = function(key, valueOrFunction) {
        var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
        s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
      };
      if (a == null) {
        return "";
      }
      if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) {
        jQuery.each(a, function() {
          add2(this.name, this.value);
        });
      } else {
        for (prefix in a) {
          buildParams(prefix, a[prefix], traditional, add2);
        }
      }
      return s.join("&");
    };
    jQuery.fn.extend({
      serialize: function() {
        return jQuery.param(this.serializeArray());
      },
      serializeArray: function() {
        return this.map(function() {
          var elements = jQuery.prop(this, "elements");
          return elements ? jQuery.makeArray(elements) : this;
        }).filter(function() {
          var type = this.type;
          return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
        }).map(function(_i, elem) {
          var val = jQuery(this).val();
          if (val == null) {
            return null;
          }
          if (Array.isArray(val)) {
            return jQuery.map(val, function(val2) {
              return { name: elem.name, value: val2.replace(rCRLF, "\r\n") };
            });
          }
          return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
        }).get();
      }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, prefilters = {}, transports = {}, allTypes = "*/".concat("*"), originAnchor = document2.createElement("a");
    originAnchor.href = location2.href;
    function addToPrefiltersOrTransports(structure) {
      return function(dataTypeExpression, func) {
        if (typeof dataTypeExpression !== "string") {
          func = dataTypeExpression;
          dataTypeExpression = "*";
        }
        var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
        if (isFunction(func)) {
          while (dataType = dataTypes[i++]) {
            if (dataType[0] === "+") {
              dataType = dataType.slice(1) || "*";
              (structure[dataType] = structure[dataType] || []).unshift(func);
            } else {
              (structure[dataType] = structure[dataType] || []).push(func);
            }
          }
        }
      };
    }
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
      var inspected = {}, seekingTransport = structure === transports;
      function inspect(dataType) {
        var selected;
        inspected[dataType] = true;
        jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
          var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
          if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
            options.dataTypes.unshift(dataTypeOrTransport);
            inspect(dataTypeOrTransport);
            return false;
          } else if (seekingTransport) {
            return !(selected = dataTypeOrTransport);
          }
        });
        return selected;
      }
      return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    function ajaxExtend(target, src) {
      var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
      for (key in src) {
        if (src[key] !== void 0) {
          (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        }
      }
      if (deep) {
        jQuery.extend(true, target, deep);
      }
      return target;
    }
    function ajaxHandleResponses(s, jqXHR, responses) {
      var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
      while (dataTypes[0] === "*") {
        dataTypes.shift();
        if (ct === void 0) {
          ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
      }
      if (ct) {
        for (type in contents) {
          if (contents[type] && contents[type].test(ct)) {
            dataTypes.unshift(type);
            break;
          }
        }
      }
      if (dataTypes[0] in responses) {
        finalDataType = dataTypes[0];
      } else {
        for (type in responses) {
          if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
            finalDataType = type;
            break;
          }
          if (!firstDataType) {
            firstDataType = type;
          }
        }
        finalDataType = finalDataType || firstDataType;
      }
      if (finalDataType) {
        if (finalDataType !== dataTypes[0]) {
          dataTypes.unshift(finalDataType);
        }
        return responses[finalDataType];
      }
    }
    function ajaxConvert(s, response, jqXHR, isSuccess) {
      var conv2, current, conv, tmp, prev, converters = {}, dataTypes = s.dataTypes.slice();
      if (dataTypes[1]) {
        for (conv in s.converters) {
          converters[conv.toLowerCase()] = s.converters[conv];
        }
      }
      current = dataTypes.shift();
      while (current) {
        if (s.responseFields[current]) {
          jqXHR[s.responseFields[current]] = response;
        }
        if (!prev && isSuccess && s.dataFilter) {
          response = s.dataFilter(response, s.dataType);
        }
        prev = current;
        current = dataTypes.shift();
        if (current) {
          if (current === "*") {
            current = prev;
          } else if (prev !== "*" && prev !== current) {
            conv = converters[prev + " " + current] || converters["* " + current];
            if (!conv) {
              for (conv2 in converters) {
                tmp = conv2.split(" ");
                if (tmp[1] === current) {
                  conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                  if (conv) {
                    if (conv === true) {
                      conv = converters[conv2];
                    } else if (converters[conv2] !== true) {
                      current = tmp[0];
                      dataTypes.unshift(tmp[1]);
                    }
                    break;
                  }
                }
              }
            }
            if (conv !== true) {
              if (conv && s.throws) {
                response = conv(response);
              } else {
                try {
                  response = conv(response);
                } catch (e) {
                  return {
                    state: "parsererror",
                    error: conv ? e : "No conversion from " + prev + " to " + current
                  };
                }
              }
            }
          }
        }
      }
      return { state: "success", data: response };
    }
    jQuery.extend({
      // Counter for holding the number of active queries
      active: 0,
      // Last-Modified header cache for next request
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: location2.href,
        type: "GET",
        isLocal: rlocalProtocol.test(location2.protocol),
        global: true,
        processData: true,
        async: true,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        /*
        timeout: 0,
        data: null,
        dataType: null,
        username: null,
        password: null,
        cache: null,
        throws: false,
        traditional: false,
        headers: {},
        */
        accepts: {
          "*": allTypes,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript"
        },
        contents: {
          xml: /\bxml\b/,
          html: /\bhtml/,
          json: /\bjson\b/
        },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON"
        },
        // Data converters
        // Keys separate source (or catchall "*") and destination types with a single space
        converters: {
          // Convert anything to text
          "* text": String,
          // Text to html (true = no transformation)
          "text html": true,
          // Evaluate text as a json expression
          "text json": JSON.parse,
          // Parse text as xml
          "text xml": jQuery.parseXML
        },
        // For options that shouldn't be deep extended:
        // you can add your own custom options here if
        // and when you create one that shouldn't be
        // deep extended (see ajaxExtend)
        flatOptions: {
          url: true,
          context: true
        }
      },
      // Creates a full fledged settings object into target
      // with both ajaxSettings and settings fields.
      // If target is omitted, writes into ajaxSettings.
      ajaxSetup: function(target, settings) {
        return settings ? (
          // Building a settings object
          ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings)
        ) : (
          // Extending ajaxSettings
          ajaxExtend(jQuery.ajaxSettings, target)
        );
      },
      ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
      ajaxTransport: addToPrefiltersOrTransports(transports),
      // Main method
      ajax: function(url, options) {
        if (typeof url === "object") {
          options = url;
          url = void 0;
        }
        options = options || {};
        var transport, cacheURL, responseHeadersString, responseHeaders, timeoutTimer, urlAnchor, completed2, fireGlobals, i, uncached, s = jQuery.ajaxSetup({}, options), callbackContext = s.context || s, globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), statusCode = s.statusCode || {}, requestHeaders = {}, requestHeadersNames = {}, strAbort = "canceled", jqXHR = {
          readyState: 0,
          // Builds headers hashtable if needed
          getResponseHeader: function(key) {
            var match;
            if (completed2) {
              if (!responseHeaders) {
                responseHeaders = {};
                while (match = rheaders.exec(responseHeadersString)) {
                  responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                }
              }
              match = responseHeaders[key.toLowerCase() + " "];
            }
            return match == null ? null : match.join(", ");
          },
          // Raw string
          getAllResponseHeaders: function() {
            return completed2 ? responseHeadersString : null;
          },
          // Caches the header
          setRequestHeader: function(name2, value) {
            if (completed2 == null) {
              name2 = requestHeadersNames[name2.toLowerCase()] = requestHeadersNames[name2.toLowerCase()] || name2;
              requestHeaders[name2] = value;
            }
            return this;
          },
          // Overrides response content-type header
          overrideMimeType: function(type) {
            if (completed2 == null) {
              s.mimeType = type;
            }
            return this;
          },
          // Status-dependent callbacks
          statusCode: function(map2) {
            var code;
            if (map2) {
              if (completed2) {
                jqXHR.always(map2[jqXHR.status]);
              } else {
                for (code in map2) {
                  statusCode[code] = [statusCode[code], map2[code]];
                }
              }
            }
            return this;
          },
          // Cancel the request
          abort: function(statusText) {
            var finalText = statusText || strAbort;
            if (transport) {
              transport.abort(finalText);
            }
            done(0, finalText);
            return this;
          }
        };
        deferred.promise(jqXHR);
        s.url = ((url || s.url || location2.href) + "").replace(rprotocol, location2.protocol + "//");
        s.type = options.method || options.type || s.method || s.type;
        s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [""];
        if (s.crossDomain == null) {
          urlAnchor = document2.createElement("a");
          try {
            urlAnchor.href = s.url;
            urlAnchor.href = urlAnchor.href;
            s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
          } catch (e) {
            s.crossDomain = true;
          }
        }
        if (s.data && s.processData && typeof s.data !== "string") {
          s.data = jQuery.param(s.data, s.traditional);
        }
        inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
        if (completed2) {
          return jqXHR;
        }
        fireGlobals = jQuery.event && s.global;
        if (fireGlobals && jQuery.active++ === 0) {
          jQuery.event.trigger("ajaxStart");
        }
        s.type = s.type.toUpperCase();
        s.hasContent = !rnoContent.test(s.type);
        cacheURL = s.url.replace(rhash, "");
        if (!s.hasContent) {
          uncached = s.url.slice(cacheURL.length);
          if (s.data && (s.processData || typeof s.data === "string")) {
            cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
            delete s.data;
          }
          if (s.cache === false) {
            cacheURL = cacheURL.replace(rantiCache, "$1");
            uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
          }
          s.url = cacheURL + uncached;
        } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) {
          s.data = s.data.replace(r20, "+");
        }
        if (s.ifModified) {
          if (jQuery.lastModified[cacheURL]) {
            jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
          }
          if (jQuery.etag[cacheURL]) {
            jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
          }
        }
        if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
          jqXHR.setRequestHeader("Content-Type", s.contentType);
        }
        jqXHR.setRequestHeader(
          "Accept",
          s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]
        );
        for (i in s.headers) {
          jqXHR.setRequestHeader(i, s.headers[i]);
        }
        if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed2)) {
          return jqXHR.abort();
        }
        strAbort = "abort";
        completeDeferred.add(s.complete);
        jqXHR.done(s.success);
        jqXHR.fail(s.error);
        transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
        if (!transport) {
          done(-1, "No Transport");
        } else {
          jqXHR.readyState = 1;
          if (fireGlobals) {
            globalEventContext.trigger("ajaxSend", [jqXHR, s]);
          }
          if (completed2) {
            return jqXHR;
          }
          if (s.async && s.timeout > 0) {
            timeoutTimer = window2.setTimeout(function() {
              jqXHR.abort("timeout");
            }, s.timeout);
          }
          try {
            completed2 = false;
            transport.send(requestHeaders, done);
          } catch (e) {
            if (completed2) {
              throw e;
            }
            done(-1, e);
          }
        }
        function done(status, nativeStatusText, responses, headers) {
          var isSuccess, success, error, response, modified, statusText = nativeStatusText;
          if (completed2) {
            return;
          }
          completed2 = true;
          if (timeoutTimer) {
            window2.clearTimeout(timeoutTimer);
          }
          transport = void 0;
          responseHeadersString = headers || "";
          jqXHR.readyState = status > 0 ? 4 : 0;
          isSuccess = status >= 200 && status < 300 || status === 304;
          if (responses) {
            response = ajaxHandleResponses(s, jqXHR, responses);
          }
          if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) {
            s.converters["text script"] = function() {
            };
          }
          response = ajaxConvert(s, response, jqXHR, isSuccess);
          if (isSuccess) {
            if (s.ifModified) {
              modified = jqXHR.getResponseHeader("Last-Modified");
              if (modified) {
                jQuery.lastModified[cacheURL] = modified;
              }
              modified = jqXHR.getResponseHeader("etag");
              if (modified) {
                jQuery.etag[cacheURL] = modified;
              }
            }
            if (status === 204 || s.type === "HEAD") {
              statusText = "nocontent";
            } else if (status === 304) {
              statusText = "notmodified";
            } else {
              statusText = response.state;
              success = response.data;
              error = response.error;
              isSuccess = !error;
            }
          } else {
            error = statusText;
            if (status || !statusText) {
              statusText = "error";
              if (status < 0) {
                status = 0;
              }
            }
          }
          jqXHR.status = status;
          jqXHR.statusText = (nativeStatusText || statusText) + "";
          if (isSuccess) {
            deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
          } else {
            deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
          }
          jqXHR.statusCode(statusCode);
          statusCode = void 0;
          if (fireGlobals) {
            globalEventContext.trigger(
              isSuccess ? "ajaxSuccess" : "ajaxError",
              [jqXHR, s, isSuccess ? success : error]
            );
          }
          completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);
          if (fireGlobals) {
            globalEventContext.trigger("ajaxComplete", [jqXHR, s]);
            if (!--jQuery.active) {
              jQuery.event.trigger("ajaxStop");
            }
          }
        }
        return jqXHR;
      },
      getJSON: function(url, data, callback) {
        return jQuery.get(url, data, callback, "json");
      },
      getScript: function(url, callback) {
        return jQuery.get(url, void 0, callback, "script");
      }
    });
    jQuery.each(["get", "post"], function(_i, method) {
      jQuery[method] = function(url, data, callback, type) {
        if (isFunction(data)) {
          type = type || callback;
          callback = data;
          data = void 0;
        }
        return jQuery.ajax(jQuery.extend({
          url,
          type: method,
          dataType: type,
          data,
          success: callback
        }, jQuery.isPlainObject(url) && url));
      };
    });
    jQuery.ajaxPrefilter(function(s) {
      var i;
      for (i in s.headers) {
        if (i.toLowerCase() === "content-type") {
          s.contentType = s.headers[i] || "";
        }
      }
    });
    jQuery._evalUrl = function(url, options, doc) {
      return jQuery.ajax({
        url,
        // Make this explicit, since user can override this through ajaxSetup (trac-11264)
        type: "GET",
        dataType: "script",
        cache: true,
        async: false,
        global: false,
        // Only evaluate the response if it is successful (gh-4126)
        // dataFilter is not invoked for failure responses, so using it instead
        // of the default converter is kludgy but it works.
        converters: {
          "text script": function() {
          }
        },
        dataFilter: function(response) {
          jQuery.globalEval(response, options, doc);
        }
      });
    };
    jQuery.fn.extend({
      wrapAll: function(html) {
        var wrap;
        if (this[0]) {
          if (isFunction(html)) {
            html = html.call(this[0]);
          }
          wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
          if (this[0].parentNode) {
            wrap.insertBefore(this[0]);
          }
          wrap.map(function() {
            var elem = this;
            while (elem.firstElementChild) {
              elem = elem.firstElementChild;
            }
            return elem;
          }).append(this);
        }
        return this;
      },
      wrapInner: function(html) {
        if (isFunction(html)) {
          return this.each(function(i) {
            jQuery(this).wrapInner(html.call(this, i));
          });
        }
        return this.each(function() {
          var self2 = jQuery(this), contents = self2.contents();
          if (contents.length) {
            contents.wrapAll(html);
          } else {
            self2.append(html);
          }
        });
      },
      wrap: function(html) {
        var htmlIsFunction = isFunction(html);
        return this.each(function(i) {
          jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
        });
      },
      unwrap: function(selector) {
        this.parent(selector).not("body").each(function() {
          jQuery(this).replaceWith(this.childNodes);
        });
        return this;
      }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
      return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
      return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
      try {
        return new window2.XMLHttpRequest();
      } catch (e) {
      }
    };
    var xhrSuccessStatus = {
      // File protocol always yields status code 0, assume 200
      0: 200,
      // Support: IE <=9 only
      // trac-1450: sometimes IE returns 1223 when it should be 204
      1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
      var callback, errorCallback;
      if (support.cors || xhrSupported && !options.crossDomain) {
        return {
          send: function(headers, complete) {
            var i, xhr = options.xhr();
            xhr.open(
              options.type,
              options.url,
              options.async,
              options.username,
              options.password
            );
            if (options.xhrFields) {
              for (i in options.xhrFields) {
                xhr[i] = options.xhrFields[i];
              }
            }
            if (options.mimeType && xhr.overrideMimeType) {
              xhr.overrideMimeType(options.mimeType);
            }
            if (!options.crossDomain && !headers["X-Requested-With"]) {
              headers["X-Requested-With"] = "XMLHttpRequest";
            }
            for (i in headers) {
              xhr.setRequestHeader(i, headers[i]);
            }
            callback = function(type) {
              return function() {
                if (callback) {
                  callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                  if (type === "abort") {
                    xhr.abort();
                  } else if (type === "error") {
                    if (typeof xhr.status !== "number") {
                      complete(0, "error");
                    } else {
                      complete(
                        // File: protocol always yields status 0; see trac-8605, trac-14207
                        xhr.status,
                        xhr.statusText
                      );
                    }
                  } else {
                    complete(
                      xhrSuccessStatus[xhr.status] || xhr.status,
                      xhr.statusText,
                      // Support: IE <=9 only
                      // IE9 has no XHR2 but throws on binary (trac-11426)
                      // For XHR2 non-text, let the caller handle it (gh-2498)
                      (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? { binary: xhr.response } : { text: xhr.responseText },
                      xhr.getAllResponseHeaders()
                    );
                  }
                }
              };
            };
            xhr.onload = callback();
            errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
            if (xhr.onabort !== void 0) {
              xhr.onabort = errorCallback;
            } else {
              xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                  window2.setTimeout(function() {
                    if (callback) {
                      errorCallback();
                    }
                  });
                }
              };
            }
            callback = callback("abort");
            try {
              xhr.send(options.hasContent && options.data || null);
            } catch (e) {
              if (callback) {
                throw e;
              }
            }
          },
          abort: function() {
            if (callback) {
              callback();
            }
          }
        };
      }
    });
    jQuery.ajaxPrefilter(function(s) {
      if (s.crossDomain) {
        s.contents.script = false;
      }
    });
    jQuery.ajaxSetup({
      accepts: {
        script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
      },
      contents: {
        script: /\b(?:java|ecma)script\b/
      },
      converters: {
        "text script": function(text) {
          jQuery.globalEval(text);
          return text;
        }
      }
    });
    jQuery.ajaxPrefilter("script", function(s) {
      if (s.cache === void 0) {
        s.cache = false;
      }
      if (s.crossDomain) {
        s.type = "GET";
      }
    });
    jQuery.ajaxTransport("script", function(s) {
      if (s.crossDomain || s.scriptAttrs) {
        var script, callback;
        return {
          send: function(_, complete) {
            script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({ charset: s.scriptCharset, src: s.url }).on("load error", callback = function(evt) {
              script.remove();
              callback = null;
              if (evt) {
                complete(evt.type === "error" ? 404 : 200, evt.type);
              }
            });
            document2.head.appendChild(script[0]);
          },
          abort: function() {
            if (callback) {
              callback();
            }
          }
        };
      }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    jQuery.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function() {
        var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
        this[callback] = true;
        return callback;
      }
    });
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
      var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
      if (jsonProp || s.dataTypes[0] === "jsonp") {
        callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
        if (jsonProp) {
          s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
        } else if (s.jsonp !== false) {
          s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
        }
        s.converters["script json"] = function() {
          if (!responseContainer) {
            jQuery.error(callbackName + " was not called");
          }
          return responseContainer[0];
        };
        s.dataTypes[0] = "json";
        overwritten = window2[callbackName];
        window2[callbackName] = function() {
          responseContainer = arguments;
        };
        jqXHR.always(function() {
          if (overwritten === void 0) {
            jQuery(window2).removeProp(callbackName);
          } else {
            window2[callbackName] = overwritten;
          }
          if (s[callbackName]) {
            s.jsonpCallback = originalSettings.jsonpCallback;
            oldCallbacks.push(callbackName);
          }
          if (responseContainer && isFunction(overwritten)) {
            overwritten(responseContainer[0]);
          }
          responseContainer = overwritten = void 0;
        });
        return "script";
      }
    });
    support.createHTMLDocument = function() {
      var body = document2.implementation.createHTMLDocument("").body;
      body.innerHTML = "<form></form><form></form>";
      return body.childNodes.length === 2;
    }();
    jQuery.parseHTML = function(data, context, keepScripts) {
      if (typeof data !== "string") {
        return [];
      }
      if (typeof context === "boolean") {
        keepScripts = context;
        context = false;
      }
      var base, parsed, scripts;
      if (!context) {
        if (support.createHTMLDocument) {
          context = document2.implementation.createHTMLDocument("");
          base = context.createElement("base");
          base.href = document2.location.href;
          context.head.appendChild(base);
        } else {
          context = document2;
        }
      }
      parsed = rsingleTag.exec(data);
      scripts = !keepScripts && [];
      if (parsed) {
        return [context.createElement(parsed[1])];
      }
      parsed = buildFragment([data], context, scripts);
      if (scripts && scripts.length) {
        jQuery(scripts).remove();
      }
      return jQuery.merge([], parsed.childNodes);
    };
    jQuery.fn.load = function(url, params, callback) {
      var selector, type, response, self2 = this, off = url.indexOf(" ");
      if (off > -1) {
        selector = stripAndCollapse(url.slice(off));
        url = url.slice(0, off);
      }
      if (isFunction(params)) {
        callback = params;
        params = void 0;
      } else if (params && typeof params === "object") {
        type = "POST";
      }
      if (self2.length > 0) {
        jQuery.ajax({
          url,
          // If "type" variable is undefined, then "GET" method will be used.
          // Make value of this field explicit since
          // user can override it through ajaxSetup method
          type: type || "GET",
          dataType: "html",
          data: params
        }).done(function(responseText) {
          response = arguments;
          self2.html(selector ? (
            // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector)
          ) : (
            // Otherwise use the full result
            responseText
          ));
        }).always(callback && function(jqXHR, status) {
          self2.each(function() {
            callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
          });
        });
      }
      return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
      return jQuery.grep(jQuery.timers, function(fn) {
        return elem === fn.elem;
      }).length;
    };
    jQuery.offset = {
      setOffset: function(elem, options, i) {
        var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
        if (position === "static") {
          elem.style.position = "relative";
        }
        curOffset = curElem.offset();
        curCSSTop = jQuery.css(elem, "top");
        curCSSLeft = jQuery.css(elem, "left");
        calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
        if (calculatePosition) {
          curPosition = curElem.position();
          curTop = curPosition.top;
          curLeft = curPosition.left;
        } else {
          curTop = parseFloat(curCSSTop) || 0;
          curLeft = parseFloat(curCSSLeft) || 0;
        }
        if (isFunction(options)) {
          options = options.call(elem, i, jQuery.extend({}, curOffset));
        }
        if (options.top != null) {
          props.top = options.top - curOffset.top + curTop;
        }
        if (options.left != null) {
          props.left = options.left - curOffset.left + curLeft;
        }
        if ("using" in options) {
          options.using.call(elem, props);
        } else {
          curElem.css(props);
        }
      }
    };
    jQuery.fn.extend({
      // offset() relates an element's border box to the document origin
      offset: function(options) {
        if (arguments.length) {
          return options === void 0 ? this : this.each(function(i) {
            jQuery.offset.setOffset(this, options, i);
          });
        }
        var rect, win, elem = this[0];
        if (!elem) {
          return;
        }
        if (!elem.getClientRects().length) {
          return { top: 0, left: 0 };
        }
        rect = elem.getBoundingClientRect();
        win = elem.ownerDocument.defaultView;
        return {
          top: rect.top + win.pageYOffset,
          left: rect.left + win.pageXOffset
        };
      },
      // position() relates an element's margin box to its offset parent's padding box
      // This corresponds to the behavior of CSS absolute positioning
      position: function() {
        if (!this[0]) {
          return;
        }
        var offsetParent, offset, doc, elem = this[0], parentOffset = { top: 0, left: 0 };
        if (jQuery.css(elem, "position") === "fixed") {
          offset = elem.getBoundingClientRect();
        } else {
          offset = this.offset();
          doc = elem.ownerDocument;
          offsetParent = elem.offsetParent || doc.documentElement;
          while (offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static") {
            offsetParent = offsetParent.parentNode;
          }
          if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
            parentOffset = jQuery(offsetParent).offset();
            parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
            parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
          }
        }
        return {
          top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
          left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
        };
      },
      // This method will return documentElement in the following cases:
      // 1) For the element inside the iframe without offsetParent, this method will return
      //    documentElement of the parent window
      // 2) For the hidden or detached element
      // 3) For body or html element, i.e. in case of the html node - it will return itself
      //
      // but those exceptions were never presented as a real life use-cases
      // and might be considered as more preferable results.
      //
      // This logic, however, is not guaranteed and can change at any point in the future
      offsetParent: function() {
        return this.map(function() {
          var offsetParent = this.offsetParent;
          while (offsetParent && jQuery.css(offsetParent, "position") === "static") {
            offsetParent = offsetParent.offsetParent;
          }
          return offsetParent || documentElement;
        });
      }
    });
    jQuery.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function(method, prop) {
      var top = "pageYOffset" === prop;
      jQuery.fn[method] = function(val) {
        return access(this, function(elem, method2, val2) {
          var win;
          if (isWindow(elem)) {
            win = elem;
          } else if (elem.nodeType === 9) {
            win = elem.defaultView;
          }
          if (val2 === void 0) {
            return win ? win[prop] : elem[method2];
          }
          if (win) {
            win.scrollTo(
              !top ? val2 : win.pageXOffset,
              top ? val2 : win.pageYOffset
            );
          } else {
            elem[method2] = val2;
          }
        }, method, val, arguments.length);
      };
    });
    jQuery.each(["top", "left"], function(_i, prop) {
      jQuery.cssHooks[prop] = addGetHookIf(
        support.pixelPosition,
        function(elem, computed) {
          if (computed) {
            computed = curCSS(elem, prop);
            return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
          }
        }
      );
    });
    jQuery.each({ Height: "height", Width: "width" }, function(name2, type) {
      jQuery.each({
        padding: "inner" + name2,
        content: type,
        "": "outer" + name2
      }, function(defaultExtra, funcName) {
        jQuery.fn[funcName] = function(margin, value) {
          var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
          return access(this, function(elem, type2, value2) {
            var doc;
            if (isWindow(elem)) {
              return funcName.indexOf("outer") === 0 ? elem["inner" + name2] : elem.document.documentElement["client" + name2];
            }
            if (elem.nodeType === 9) {
              doc = elem.documentElement;
              return Math.max(
                elem.body["scroll" + name2],
                doc["scroll" + name2],
                elem.body["offset" + name2],
                doc["offset" + name2],
                doc["client" + name2]
              );
            }
            return value2 === void 0 ? (
              // Get width or height on the element, requesting but not forcing parseFloat
              jQuery.css(elem, type2, extra)
            ) : (
              // Set width or height on the element
              jQuery.style(elem, type2, value2, extra)
            );
          }, type, chainable ? margin : void 0, chainable);
        };
      });
    });
    jQuery.each([
      "ajaxStart",
      "ajaxStop",
      "ajaxComplete",
      "ajaxError",
      "ajaxSuccess",
      "ajaxSend"
    ], function(_i, type) {
      jQuery.fn[type] = function(fn) {
        return this.on(type, fn);
      };
    });
    jQuery.fn.extend({
      bind: function(types, data, fn) {
        return this.on(types, null, data, fn);
      },
      unbind: function(types, fn) {
        return this.off(types, null, fn);
      },
      delegate: function(selector, types, data, fn) {
        return this.on(types, selector, data, fn);
      },
      undelegate: function(selector, types, fn) {
        return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
      },
      hover: function(fnOver, fnOut) {
        return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
      }
    });
    jQuery.each(
      "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),
      function(_i, name2) {
        jQuery.fn[name2] = function(data, fn) {
          return arguments.length > 0 ? this.on(name2, null, data, fn) : this.trigger(name2);
        };
      }
    );
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    jQuery.proxy = function(fn, context) {
      var tmp, args, proxy;
      if (typeof context === "string") {
        tmp = fn[context];
        context = fn;
        fn = tmp;
      }
      if (!isFunction(fn)) {
        return void 0;
      }
      args = slice.call(arguments, 2);
      proxy = function() {
        return fn.apply(context || this, args.concat(slice.call(arguments)));
      };
      proxy.guid = fn.guid = fn.guid || jQuery.guid++;
      return proxy;
    };
    jQuery.holdReady = function(hold) {
      if (hold) {
        jQuery.readyWait++;
      } else {
        jQuery.ready(true);
      }
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
      var type = jQuery.type(obj);
      return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
      // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
      // subtraction forces infinities to NaN
      !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
      return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    var _jQuery = window2.jQuery, _$ = window2.$;
    jQuery.noConflict = function(deep) {
      if (window2.$ === jQuery) {
        window2.$ = _$;
      }
      if (deep && window2.jQuery === jQuery) {
        window2.jQuery = _jQuery;
      }
      return jQuery;
    };
    if (typeof noGlobal === "undefined") {
      window2.jQuery = window2.$ = jQuery;
    }
    return jQuery;
  });
})(jquery);
var jqueryExports = jquery.exports;
const $ = /* @__PURE__ */ getDefaultExportFromCjs(jqueryExports);
let useLan = "en";
let interHost = "https://api.vidnoz.com";
window.setPlayerEnv = (lan, host) => {
  useLan = lan;
  interHost = host;
  window.api_env = host === "https://api-test.vidnoz.com" ? "dev" : "prd";
};
function getCookie(cookieName) {
  const allCookies = document.cookie;
  const cookiesArray = allCookies.split(";");
  for (const cookie of cookiesArray) {
    const [key, value] = cookie.trim().split("=");
    if (key === cookieName) {
      return decodeURIComponent(value);
    }
  }
  return "";
}
function setCookie(cName, value, expiredays) {
  const exdate = /* @__PURE__ */ new Date();
  const host = location.hostname.includes(".vidnoz.com") ? ".vidnoz.com" : location.hostname;
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = cName + "=" + encodeURIComponent(value) + (expiredays == null ? "" : ";expires=" + exdate.toGMTString()) + ";path=/;domain=" + host;
}
function clearCookie(name2) {
  setCookie(name2, "", -1);
}
const VidnozUrlObj = {
  fr: "https://fr.vidnoz.com",
  ar: "https://ar.vidnoz.com",
  en: "https://www.vidnoz.com",
  jp: "https://jp.vidnoz.com",
  de: "https://de.vidnoz.com",
  it: "https://it.vidnoz.com",
  pt: "https://pt.vidnoz.com",
  es: "https://es.vidnoz.com",
  tw: "https://tw.vidnoz.com",
  kr: "https://kr.vidnoz.com",
  nl: "https://nl.vidnoz.com"
};
function signOut({ reload = true } = {}) {
  jqAjaxPromise({ url: "/api/user/sign-out" }).then((res2) => {
    if (res2.code === 200) {
    }
  });
  localStorage.removeItem("user_info");
  localStorage.removeItem("currentMenu");
  clearCookie("access_token");
  clearCookie("refresh_token");
  clearCookie("loginProduct");
  clearCookie("user_info");
  clearCookie("st");
  clearCookie("st2");
  clearCookie("gotoWebsiteBe");
  if (reload) {
    window.location = VidnozUrlObj[useLan];
  }
}
const requestAtoken = (refreshtoken) => {
  const data = {
    refresh_token: refreshToken
  };
  jqAjaxPromise({ url: "/api/user/refresh-token", type: "POST", data }).then((res2) => {
    if (res2.code === 200) {
      setCookie("access_token", res2.data.access_token, 30);
      setCookie("refresh_token", res2.data.refresh_token, 30);
      location.reload();
    } else if (res2.code === 400) {
      if (refreshToken !== getCookie("refresh_token")) return;
      signOut();
    }
  });
};
let accessToken = "";
let refreshToken = "";
async function jqAjaxPromise(param, progressFun = () => {
}, origin = "web", json = false, isAsync = true, signal = null, excuteBefore = true) {
  accessToken = getCookie("access_token") ? getCookie("access_token") : "";
  refreshToken = getCookie("refresh_token") ? getCookie("refresh_token") : "";
  const url = interHost + param.url;
  return new Promise((resolve, reject) => {
    const headers = {
      Authorization: "Bearer " + accessToken,
      // 'Request-Language': requestLanguage,
      // TODO: 语言为变量
      "Request-Language": useLan,
      "Request-App": "ai",
      "Is-Official": 1,
      "X-TASK-VERSION": "2.0.0",
      // TODO：任务版本号为变量
      // 'X-TASK-VERSION': X_TASK_VERSION,
      "Request-Origin": "web",
      "Cache-Control": (param == null ? void 0 : param.noCache) ? "no-cache" : ""
    };
    let data = { origin, ...param.data || "" };
    if (json) {
      headers["Content-Type"] = "application/json";
      data = JSON.stringify(data);
    }
    const ajaxTimeOut = $.ajax({
      url,
      type: param.type || "GET",
      headers,
      data,
      cache: true,
      async: isAsync,
      timeout: 3e5,
      // xhrFields: {
      //   withCredentials: true
      // },
      xhr: () => {
        const xhr = $.ajaxSettings.xhr();
        if (xhr) {
          xhr.onprogress = function(e) {
            if (e.lengthComputable) {
              progressFun(e);
            }
          };
          xhr.onabort = function(e) {
            reject(e);
          };
        }
        return xhr;
      },
      success: function(data2) {
        data2 = typeof data2 === "string" ? JSON.parse(data2) : data2;
        if (data2.code === 401) {
          if (refreshToken && refreshToken !== "") {
            requestAtoken();
          }
        }
        resolve(data2);
      },
      error: function(error, status, err) {
        if (status === "abort") {
          reject(
            new Error("abort", {
              cause: {
                reason: "abort"
              }
            })
          );
        } else {
          reject(error);
        }
      },
      complete: function(XMLHttpREQUEST, status) {
        if (status === "timeout") {
          ajaxTimeOut.abort();
        }
      }
    });
    if (param.cancelToken) {
      param.cancelToken.promise.then(() => {
        reject({ status: "canceled" });
        ajaxTimeOut.abort();
      });
    }
    if (signal) {
      if (signal.aborted) {
        if (ajaxTimeOut) {
          ajaxTimeOut.abort();
        }
      } else {
        signal.addEventListener("abort", (e) => {
          if (ajaxTimeOut) {
            ajaxTimeOut.abort();
          }
        });
      }
    }
  });
}
function jqAjaxPromiseWithHandleException(param, json = false, signal = null) {
  return new Promise((resolve, reject) => {
    jqAjaxPromise(param, () => {
    }, "web", json, true, signal, false).then((res2) => {
      if (res2.code === 200) {
        resolve(res2);
      } else {
        if ([2002, 2003, 2004].includes(res2.code)) {
          return;
        }
        reject(createDefApiError(param.url, res2));
      }
    }).catch((err) => {
      if (!(err instanceof Error)) {
        reject(new Error(`${param.url} ${err == null ? void 0 : err.statusText}`));
      } else {
        reject(err);
      }
    });
  });
}
async function requestAvatarByIdAndType(id, avatarSource) {
  const res2 = await jqAjaxPromiseWithHandleException({
    url: "/ai/avatar/avatar-info",
    type: "POST",
    data: {
      avatar_source: avatarSource,
      id
    }
  });
  if (res2.data === null) {
    throw new Error("The result of seach avatar id is null");
  }
  return res2.data;
}
async function requestUrlByKey(key) {
  const res2 = await jqAjaxPromiseWithHandleException({
    url: "/ai/source/get-access-url",
    type: "POST",
    data: {
      key
    }
  });
  return res2.data;
}
async function requestReouseceUrl(key) {
  const res2 = await jqAjaxPromiseWithHandleException({
    url: "/ai/source/get-access-url",
    type: "POST",
    data: {
      key
    }
  });
  return res2.data;
}
async function requestReouseceUrlTakeSignal(key, signal) {
  const res2 = await jqAjaxPromiseWithHandleException({
    url: "/ai/source/get-access-url",
    type: "POST",
    data: {
      key
    }
  }, false, signal);
  return res2.data;
}
let random$1 = (bytes) => crypto.getRandomValues(new Uint8Array(bytes));
let customRandom = (alphabet, defaultSize, getRandom) => {
  let mask = (2 << Math.log2(alphabet.length - 1)) - 1;
  let step = -~(1.6 * mask * defaultSize / alphabet.length);
  return (size = defaultSize) => {
    let id = "";
    while (true) {
      let bytes = getRandom(step);
      let j = step;
      while (j--) {
        id += alphabet[bytes[j] & mask] || "";
        if (id.length === size) return id;
      }
    }
  };
};
let customAlphabet = (alphabet, size = 21) => customRandom(alphabet, size, random$1);
const fontname2filename = fonts;
function initSubtitleConfig(json) {
  if (Array.isArray(json.subtitleStyle) || !json.subtitleStyle) {
    json.subtitleStyle = {};
    json.subtitleStyle.fontFamily = "Roboto";
    json.subtitleStyle.fontSize = 48;
    json.subtitleStyle.color = "rgba(255, 255, 255, 1.00)";
    json.subtitleStyle.strokeColor = "#000000";
    json.subtitleStyle.strokeWidth = 0;
    json.subtitleStyle.fontWeight = "normal";
    json.subtitleStyle.fontStyle = "normal";
    json.subtitleStyle.underline = false;
    json.subtitleStyle.linethrough = false;
    json.subtitleStyle.opacity = 1;
    json.subtitleStyle.textShadow = "middle";
    json.subtitleStyle.shadowColor = "rgba(0,0,0,0.8)";
    json.subtitleStyle.textTransform = "none";
    json.subtitleStyle.position = "bottom";
    json.subtitleStyle.bottom = 50;
    json.subtitleStyle.top = 50;
    json.subtitleStyle.backgroundColor = "rgba(0,0,0,0)";
    json.subtitleStyle.textAlign = "center";
  } else if (typeof json.subtitleStyle === "object") {
    if (!json.subtitleStyle.backgroundColor) {
      json.subtitleStyle.backgroundColor = "rgba(0,0,0,0)";
    }
    if (json.subtitleStyle.textDecoration === "none") {
      json.subtitleStyle.underline = false;
      json.subtitleStyle.linethrough = false;
    } else if (json.subtitleStyle.textDecoration === "underline") {
      json.subtitleStyle.underline = true;
      json.subtitleStyle.linethrough = false;
    }
    if (!json.subtitleStyle.textAlign) {
      json.subtitleStyle.textAlign = "center";
    }
  }
}
function hasKey(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}
function initClipLayout(layout, fabricCanvas) {
  if (layout === "landscape") {
    fabricCanvas.setDimensions({
      width: 1920,
      height: 1080
    }, {
      backstoreOnly: true
    });
  } else if (layout === "portrait") {
    fabricCanvas.setDimensions({
      width: 1080,
      height: 1920
    }, {
      backstoreOnly: true
    });
  } else if (layout === "square") {
    fabricCanvas.setDimensions({
      width: 1080,
      height: 1080
    }, {
      backstoreOnly: true
    });
  }
}
async function createClipElement(fobj, tempFbric, speechConfig = null) {
  const element = await pretreatmentElement(fobj, speechConfig);
  if (fobj.type === "video") {
    const instance = await createVideo(element.property, element.animation);
    tempFbric.add(instance);
    return instance;
  } else {
    let instance = await layerToFabricObj(fobj.property);
    if (!instance) {
      if (fobj.type === "avatar") {
        const _config = getDefaultAvatarConfig(fobj.property, speechConfig);
        instance = await layerToFabricObj(_config);
      }
    }
    if (!instance) {
      throw new Error("layerToFabricObj return null");
    }
    if (instance.type !== "Avatar" && fobj.animation) {
      instance.animation = JSON.parse(JSON.stringify(fobj.animation));
    }
    tempFbric.add(instance);
    return instance;
  }
}
async function loadBrandFont(url, name2) {
  let loadResolve = null;
  let loadReject = null;
  let needload = true;
  document.fonts.forEach((value) => {
    if (value.family === name2) {
      needload = false;
    }
  });
  if (!needload) {
    if (loadResolve) {
      loadResolve();
      loadResolve = null;
    }
  }
  const font = new FontFace(name2, `url(${url})`, {
    weight: "normal",
    style: "normal"
  });
  document.fonts.add(font);
  font.load().then(() => {
    if (loadResolve) {
      loadResolve();
      loadResolve = null;
    }
  }).catch((err) => {
    if (loadReject) {
      loadReject(err);
      loadReject = null;
    }
  });
  return new Promise((resolve, reject) => {
    loadResolve = resolve;
    loadReject = reject;
  });
}
function formartFont(font) {
  let reFont = font.split(",")[0].trim();
  const regex = /^'+|'+$/g;
  reFont = reFont.replace(regex, "");
  return reFont;
}
function getFontName(name2, bold, italic) {
  let returnName = name2;
  if (!(bold || italic)) {
    returnName = returnName + " Regular";
  }
  if (bold) {
    returnName = returnName + " Bold";
  }
  if (italic) {
    returnName = returnName + " Italic";
  }
  return fontname2filename[returnName];
}
async function loadFont(family, bold, italic) {
  const href = "https://static.vidnoz.com/web/fonts/";
  let loadResolve = null;
  let loadReject = null;
  const realFamily = formartFont(family);
  let fileName = getFontName(realFamily, bold, italic);
  if (!fileName) {
    fileName = getFontName(realFamily, false, false);
  }
  if (!fileName) {
    setTimeout(() => {
      if (loadReject) {
        loadReject(new Error("no font name"));
        loadReject = null;
      }
    }, 10);
    return;
  }
  const url = `${href}${fileName}`;
  let needload = true;
  document.fonts.forEach((value) => {
    if (value.family === realFamily) {
      const tempBold = value.weight === "bold";
      const tempItalic = value.style === "italic";
      if (tempBold === bold && tempItalic === italic) {
        needload = false;
      }
    }
  });
  if (!needload) {
    if (loadResolve) {
      loadResolve();
      loadResolve = null;
    }
  }
  let _realFamily = realFamily;
  if (realFamily === "Fraunces 72pt" && navigator.userAgent.indexOf("Firefox") > -1) {
    _realFamily = `'${realFamily}'`;
  }
  const font = new FontFace(_realFamily, `url(${url})`, {
    weight: bold ? "bold" : "normal",
    style: italic ? "italic" : "normal"
  });
  document.fonts.add(font);
  font.load().then(() => {
    if (loadResolve) {
      loadResolve();
      loadResolve = null;
    }
  }).catch((err) => {
    if (loadReject) {
      loadReject(err);
      loadReject = null;
    }
  });
  return new Promise((resolve, reject) => {
    loadResolve = resolve;
    loadReject = reject;
  });
}
const shapes = [
  "ShapeRect",
  "ShapeLine",
  "ShapeTriangle",
  "ShapeCircle",
  "ShapeArrow",
  "ShapeDoubleArrow",
  "ShapeLine"
];
function isDefShape(shapeType) {
  return shapes.includes(shapeType);
}
async function pretreatmentElement(value, speechConfig = null) {
  if (value.type === "object") {
    if (value.property.type === "CustomImage") {
      const obj = { ...value };
      if (obj.property._staticUrl) {
        obj.property.objects[0].src = obj.property._staticUrl;
        return obj;
      } else {
        if (obj.property._urlkey) {
          const data = await requestReouseceUrl(obj.property._urlkey);
          if (data.static_url) {
            obj.property.objects[0].src = data.static_url;
            obj.property._staticUrl = data.static_url;
          } else {
            obj.property.objects[0].src = data.url;
          }
          return obj;
        } else {
          obj.property._staticUrl = obj.property.objects[0].src;
          return obj;
        }
      }
    } else if (value.property.type === "CustomIcon") {
      return value;
    }
    if (value.property.type === "textbox") {
      if (hasKey(value.property, "_brandId")) {
        const res2 = await requestReouseceUrl(value.property._brandKey);
        const fontUrl = res2.static_url || res2.url;
        await loadBrandFont(fontUrl, value.property._brandType + value.property._brandId);
        const fallbackStr = fallbackList.toString();
        value.property.fontFamily = `${value.property.fontFamily},${fallbackStr}`;
        return value;
      } else {
        if (value.property.fontFamily) {
          const fontFamily = formartFont(value.property.fontFamily);
          const bold = value.property.fontWeight === "bold";
          const italic = value.property.fontStyle === "italic";
          await loadFont(fontFamily, bold, italic);
          const fallbackStr = fallbackList.toString();
          value.property.fontFamily = `${value.property.fontFamily},${fallbackStr}`;
          return value;
        }
      }
    } else if (isDefShape(value.property.type)) {
      return value;
    } else if (value.property.type === "CustomSticker") {
      const obj = { ...value };
      if (obj.property._staticUrl) {
        obj.property.src = obj.property._staticUrl;
        return obj;
      } else {
        if (obj.property._urlkey) {
          const data = await requestReouseceUrl(obj.property._urlkey);
          if (data.static_url) {
            obj.property.src = data.static_url;
            obj.property._staticUrl = data.static_url;
          } else {
            obj.property.src = data.url;
          }
          return obj;
        } else {
          throw new Error("no key and no staticurl");
        }
      }
    }
  } else if (value.type === "avatar") {
    const obj = value;
    const info = obj.property._avatarInfo;
    if (hasKey(info, "id") && info.id && info.type === 1) {
      let doCatch = false;
      const data = await requestAvatarByIdAndType(info.id, info.avatar_source).catch(() => {
        obj.property = getDefaultAvatarConfig(obj.property, speechConfig);
        doCatch = true;
      });
      if (!doCatch) {
        const isTransparent = obj.property[`_transparent_${obj.property._avatarType}`];
        const url = isTransparent ? data.avatar_noback.url : data.avatar.url;
        if (!url) {
          throw new Error("avatar id but no url");
        }
        obj.property.objects[0].src = url;
      }
      return obj;
    } else {
      const staticUrl = obj.property._avatarInfo._staticUrl || obj.property._avatarInfo.static_url;
      if (staticUrl) {
        obj.property.objects[0].src = staticUrl;
        return obj;
      } else {
        if (obj.property._avatarInfo.key) {
          let doCatch = false;
          const data = await requestUrlByKey(obj.property._avatarInfo.key).catch(() => {
            obj.property = getDefaultAvatarConfig(obj.property, speechConfig);
            doCatch = true;
          });
          if (!doCatch) {
            if (data.static_url) {
              obj.property.objects[0].src = data.static_url;
              obj.property._avatarInfo._staticUrl = data.static_url;
            } else {
              obj.property.objects[0].src = data.url;
            }
          }
          return obj;
        } else {
          throw new Error("no key and no staticurl");
        }
      }
    }
  } else if (value.type === "video") {
    const obj = { ...value };
    const vdImg = obj.property.objects[0];
    const vdUrlTask = new Promise((resolve, reject) => {
      if (obj.property._staticUrl) {
        obj.property._videoSrc = obj.property._staticUrl;
        resolve();
      } else {
        if (obj.property._urlkey) {
          requestReouseceUrl(obj.property._urlkey).then((data) => {
            if (data.static_url) {
              obj.property._videoSrc = data.static_url;
              obj.property._staticUrl = data.static_url;
            } else {
              obj.property._videoSrc = data.url;
            }
            resolve();
          }).catch((error) => reject(error));
        } else {
          reject(new Error("no key and no staticurl"));
        }
      }
    });
    const thumbnailUrlTask = new Promise((resolve, reject) => {
      if (obj.property._frontCoverStaticUrl) {
        obj.property._frontCoverUrl = obj.property._frontCoverStaticUrl;
        vdImg.src = obj.property._frontCoverStaticUrl;
        resolve();
      } else {
        if (obj.property._frontCoverKey) {
          requestReouseceUrl(obj.property._frontCoverKey).then((data) => {
            if (data.static_url) {
              vdImg.src = data.static_url;
              obj.property._frontCoverUrl = data.static_url;
              obj.property._frontCoverStaticUrl = data.static_url;
            } else {
              vdImg.src = data.url;
              obj.property._frontCoverUrl = data.url;
            }
            resolve();
          }).catch((error) => reject(error));
        } else {
          reject(new Error("no key and no staticurl"));
        }
      }
    });
    await Promise.all([vdUrlTask, thumbnailUrlTask]);
    return obj;
  }
}
async function compatibleAntiSequenceBackgroundImage(bgMedia, cvs) {
  let _url = "";
  const options = {};
  if (bgMedia.data.key) {
    const resdata = await requestReouseceUrl(bgMedia.data.key);
    _url = resdata.static_url || resdata.url;
    options.static_url = resdata.static_url;
    options._urlkey = bgMedia.data.key;
    options.url = resdata.url;
  } else {
    _url = bgMedia.data._staticUrl || bgMedia.data.url;
    options.static_url = bgMedia.data._staticUrl;
    options.url = bgMedia.data.url;
  }
  options.opacity = bgMedia.opacity;
  options.crossOrigin = "anonymous";
  options._fromTemplate = bgMedia._fromTemplate;
  const img = await createCustomImagePromise$1(_url, options);
  img.padding = 0;
  img.setCoords();
  await setBackgroundImagePromise(img, cvs);
  if (bgMedia.blur > 0) {
    const blur = new fabric.fabric.Image.filters.Blur({
      blur: bgMedia.blur
    });
    img._objects[0].filters.push(blur);
    img._objects[0].applyFilters();
  }
  img.scaleToWidth(this.editer.editer.width);
  if (img.getScaledHeight() < this.editer.editer.height) {
    img.scaleToHeight(this.editer.editer.height);
  }
  img.center();
}
function createVideoElementForCustomVideo(src, options = {}, loadmetadataCallback = function() {
}) {
  const vd = document.createElement("video");
  const tempID = customAlphabet("abcdefghijklmnopqrstuvwxyz", 8)();
  vd.src = src;
  vd.volume = hasKey(options, "volume") ? options.volume : 1;
  vd.style.display = "none";
  vd.setAttribute("preload", "auto");
  vd.setAttribute("crossorigin", "anonymous");
  vd.id = tempID;
  vd.addEventListener("loadedmetadata", (e) => {
    vd.width = vd.videoWidth;
    vd.height = vd.videoHeight;
    loadmetadataCallback();
  });
  return vd;
}
function createVideo(property, animation = null) {
  let videoResolve = null;
  let videoReject = null;
  const vd = createVideoElementForCustomVideo(
    property._videoSrc,
    { volume: property._volume }
  );
  document.body.appendChild(vd);
  layerToFabricObj(property).then((video) => {
    if (!video) {
      if (videoReject) {
        videoReject();
        videoReject = null;
      }
    }
    video.videoId = vd.id;
    video._loaded = false;
    if (animation) {
      video.animation = JSON.parse(JSON.stringify(animation));
    }
    if (videoResolve) {
      videoResolve(video);
      videoResolve = null;
    }
  });
  return new Promise((resolve, reject) => {
    videoResolve = resolve;
    videoReject = reject;
  });
}
async function AntiSequenceBackgroundVideo(bgMedia, cvs) {
  const pretreatmentedBgMedia = await pretreatmentElement(bgMedia);
  const video = await createVideo(pretreatmentedBgMedia.property, pretreatmentedBgMedia.animation);
  await setBackgroundImagePromise(video, cvs);
}
async function AntiSequenceBackgroundImage(bgMedia, cvs) {
  const pretreatmentedBgMedia = await pretreatmentElement(bgMedia);
  const img = await layerToFabricObj(pretreatmentedBgMedia.property);
  await setBackgroundImagePromise(img, cvs);
}
function renderSceneByConfig(config2, cvs, taskArr) {
  for (let j = 0; j < config2.layers.length; j++) {
    const value = config2.layers[j];
    const task = createClipElement(value, cvs, config2.speech);
    taskArr.push(task);
  }
  cvs.setBackgroundColor(config2.bgColor ? config2.bgColor : "#ffffff", () => {
    cvs.renderAll();
  });
  cvs.transition = JSON.parse(JSON.stringify(config2.transition));
  if (config2.bgMedia) {
    if (config2.bgMedia.type === "img") {
      taskArr.push(compatibleAntiSequenceBackgroundImage(config2.bgMedia, cvs));
    } else if (config2.bgMedia.type === "video") {
      taskArr.push(AntiSequenceBackgroundVideo(config2.bgMedia, cvs));
    } else if (config2.bgMedia.type === "object") {
      taskArr.push(AntiSequenceBackgroundImage(config2.bgMedia, cvs));
    }
  }
}
function createAudioElement() {
  const audio = document.createElement("audio");
  audio.loop = true;
  audio.preload = "auto";
  return audio;
}
function normalizeBgmID(audioId) {
  return `bgm_${audioId}`;
}
function normalizeDefaultID(audioId) {
  return `speech-audio${audioId}`;
}
function normalizeConversationID(audioId, idx) {
  return `speech-audio${audioId}-${idx}`;
}
async function addClip(clips, layout) {
  let allClipResolve = null;
  const clipTaskArr = [];
  const fabricCanvasArray = [];
  for (let i = 0; i < clips.length; i++) {
    let loadClipResolve = null;
    clipTaskArr.push(new Promise((resolve) => {
      loadClipResolve = resolve;
    }));
    const taskArr = [];
    const curClip = clips[i];
    const tempFbric = new fabric.fabric.StaticCanvas(null, {
      enableRetinaScaling: false,
      //   width: toRange.width,
      //   height: toRange.height,
      transition: JSON.parse(JSON.stringify(curClip.transition)),
      speechId: curClip.speechId,
      bgmId: curClip.bgmId,
      textStyle: JSON.parse(JSON.stringify(curClip.textStyle)),
      fgColor: curClip.fgColor ? curClip.fgColor : "#000000"
      //   _modeId: curClip._modeId ? curClip._modeId : null,
    });
    fabricCanvasArray.push(tempFbric);
    tempFbric.loadList = ["video", "speech"];
    initClipLayout(layout, tempFbric);
    renderSceneByConfig(curClip, tempFbric, taskArr);
    if (curClip.bgm) {
      if (curClip.bgm._staticUrl || curClip.bgm._urlkey) {
        const audio = createAudioElement();
        audio.id = normalizeBgmID(curClip.bgm.audioId);
        document.body.appendChild(audio);
        if (curClip.bgm._staticUrl) {
          audio.src = curClip.bgm._staticUrl;
        } else if (curClip.bgm._urlkey) {
          requestReouseceUrl(curClip.bgm._urlkey).then((res2) => {
            audio.src = res2.url;
          });
        }
      }
    }
    Promise.allSettled([...taskArr]).then((results) => {
      for (let i2 = 0; i2 < results.length; i2++) {
        if (results[i2].status === "fulfilled") {
          const obj = results[i2].value;
          obj && obj.moveTo(i2);
        }
      }
      if (loadClipResolve) {
        loadClipResolve();
        loadClipResolve = null;
      }
    });
  }
  Promise.allSettled([...clipTaskArr]).then((results) => {
    if (allClipResolve) {
      allClipResolve(fabricCanvasArray);
      allClipResolve = null;
    }
  });
  return new Promise((resolve) => {
    allClipResolve = resolve;
  });
}
async function loadFromJsonAndDoSomething(desCvs, sourceCvs) {
  let loadResolve = null;
  let sourceJson;
  if (typeof sourceCvs === "string") {
    sourceJson = JSON.parse(sourceCvs);
  } else {
    sourceJson = sourceCvs.toJSON();
  }
  const objs = sourceJson.objects;
  for (let i = objs.length - 1; i >= 0; i--) {
    if (objs[i].type === "CustomVideo") {
      const vdImg = objs[i].objects[0];
      vdImg.src = objs[i]._frontCoverUrl;
    }
  }
  const bgVideo = sourceJson.backgroundImage;
  const haveBgVideo = bgVideo && bgVideo.type === "CustomVideo";
  if (haveBgVideo) {
    const vdImg = bgVideo.objects[0];
    vdImg.src = bgVideo._frontCoverUrl;
  }
  desCvs.loadFromJSON(JSON.stringify(sourceJson), async () => {
    const videoObjs = desCvs.getObjects();
    for (let i = 0; i < videoObjs.length; i++) {
      if (videoObjs[i].type === "CustomVideo") {
        const vdImg = videoObjs[i]._objects[0];
        if (videoObjs[i]._loaded) {
          const vd = document.getElementById(videoObjs[i].videoId);
          vdImg.setElement(vd);
        }
      }
    }
    const _bgVideo = desCvs.backgroundImage;
    const _haveBgVideo = _bgVideo && _bgVideo.type === "CustomVideo";
    if (_haveBgVideo && _bgVideo._loaded) {
      const vd = document.getElementById(_bgVideo.videoId);
      _bgVideo._objects[0].setElement(vd);
    }
    desCvs.renderAll();
    setTimeout(() => {
      if (loadResolve) {
        loadResolve();
        loadResolve = null;
      }
    }, 0);
  }, (o, object) => {
  });
  return new Promise((resolve) => {
    loadResolve = resolve;
  });
}
function toFixedNoRound$1(num, decimalPlaces) {
  const _num = Number(num);
  const factor = Math.pow(10, decimalPlaces);
  return Math.floor(_num * factor) / factor;
}
function isIOS() {
  return /iP(hone|od|ad)/.test(navigator.userAgent);
}
function segmentsIntr(a, b, c, d) {
  const denominator = (b.y - a.y) * (d.x - c.x) - (a.x - b.x) * (c.y - d.y);
  if (denominator === 0) {
    return false;
  }
  const x = ((b.x - a.x) * (d.x - c.x) * (c.y - a.y) + (b.y - a.y) * (d.x - c.x) * a.x - (d.y - c.y) * (b.x - a.x) * c.x) / denominator;
  const y = -((b.y - a.y) * (d.y - c.y) * (c.x - a.x) + (b.x - a.x) * (d.y - c.y) * a.y - (d.x - c.x) * (b.y - a.y) * c.y) / denominator;
  return {
    x,
    y
  };
}
function calculateMagnitude2D(x, y) {
  return Math.sqrt(x * x + y * y);
}
const defaultStrokeWidth = 3;
const shapeStrokeColor = "#FFFFFF";
function calculateProjection(A, B) {
  calculateMagnitude2D(A.x, A.y);
  const magnitudeB = calculateMagnitude2D(B.x, B.y);
  const dotProduct = A.x * B.x + A.y * B.y;
  const projectionLength = dotProduct / magnitudeB;
  return projectionLength;
}
function resetOffest(ctr) {
  ctr.tl.offsetX = 0;
  ctr.tl.offsetY = 0;
  ctr.tr.offsetX = 0;
  ctr.tr.offsetY = 0;
  ctr.bl.offsetX = 0;
  ctr.bl.offsetY = 0;
  ctr.br.offsetX = 0;
  ctr.br.offsetY = 0;
}
function cloneFabricObject(obj) {
  return new Promise((resolve, reject) => {
    obj.clone((_obj) => {
      resolve(_obj);
    });
  });
}
const cropType = {
  CIRCLE: "circle",
  // 圆形
  RECT: "rect",
  // 矩形
  TRIANGLE: "triangle",
  // 三角形
  HEART: "heart"
  // 心形
};
const stretchType = {
  Cover: "cover",
  // 完全填充
  Contain: "contain"
  // 画布范围内缩放到最大
};
const position2url = {
  tl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABHNCSVQICAgIfAhkiAAAAD9JREFUOE9j/A8EDFQEjCADe+yoY2LJIQaGIWggyNmUAAwvg8MBCMg1dNRABobRMCQ59YwmmxGTbNDTBiWlDQDdK3QBA5VRbwAAAABJRU5ErkJggg==",
  tr: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABHNCSVQICAgIfAhkiAAAAD1JREFUOE9j/A8EDFQEjCADe+yoY2LJIQaGIWIgJR5GDi6wlykxDD38Rw0kPTRHw5BhNNmMJhsiQgBb9QEAP2ZzxbEFl0cAAAAASUVORK5CYII=",
  bl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABHNCSVQICAgIfAhkiAAAAExJREFUOE9j/A8EDGiAEQjQxYjlM4IM7LFDKC85xMAwaiCxwQdWNxqGDAyjyYakJDOabCDBBUo2lACMrEeJYeA0jF4eDk4DKXEVul4APCZ0AWhtejIAAAAASUVORK5CYII=",
  br: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABHNCSVQICAgIfAhkiAAAAExJREFUOE9jZKAA/AcCdO2MFJjHADKwxw5hQskhBoZRA0kL0dEwZBhNNqQlGZDqIZpssBVBpHgeo7RBDwdSDENXC06HQ8NASryJrhcAP2ZzxQ7axFoAAAAASUVORK5CYII=",
  ml: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAUCAYAAABF5ffbAAAABHNCSVQICAgIfAhkiAAAACBJREFUGFdj/A8EDGiAESTYY4cQLTnEwDAqSK8AQY8OACrdc8X1eDO/AAAAAElFTkSuQmCC",
  mt: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAABHNCSVQICAgIfAhkiAAAACJJREFUGFdj/A8EDFQEjCADe+yoY2LJIQaGIWIgdTwMMQUASlMZ8le17r0AAAAASUVORK5CYII="
};
const initCustomImage = () => {
  fabric.fabric.CustomImage = fabric.fabric.util.createClass(fabric.fabric.Group, {
    type: "CustomImage",
    initialize: function(objects, options, isAlreadyGrouped) {
      this.callSuper("initialize", objects, options, isAlreadyGrouped);
    },
    toObject: function(propertiesToInclude) {
      const _includeDefaultValues = this.includeDefaultValues;
      const objsToObject = this._objects.filter(function(obj2) {
        return !obj2.excludeFromExport;
      }).map(function(obj2) {
        const originalDefaults = obj2.includeDefaultValues;
        obj2.includeDefaultValues = _includeDefaultValues;
        const _obj = obj2.toObject(propertiesToInclude);
        obj2.includeDefaultValues = originalDefaults;
        return _obj;
      });
      const obj = fabric.fabric.Object.prototype.toObject.call(this, propertiesToInclude);
      obj.objects = objsToObject;
      return obj;
    },
    loadControlImg(position) {
      return new Promise((resolve, reject) => {
        const imgName = `${position}Img`;
        this[imgName] = new Image();
        this[imgName].onload = () => {
          resolve();
        };
        this[imgName].src = position2url[position];
      });
    },
    loadAllControlImage() {
      const tlPromise = this.loadControlImg("tl");
      const trPromise = this.loadControlImg("tr");
      const blPromise = this.loadControlImg("bl");
      const brPromise = this.loadControlImg("br");
      const mlPromise = this.loadControlImg("ml");
      const mtPromise = this.loadControlImg("mt");
      return Promise.all([tlPromise, trPromise, blPromise, brPromise, mlPromise, mtPromise]);
    },
    removeCrop() {
      this.lastCropInfo = {
        width: this.width,
        height: this.height,
        left: this.left,
        top: this.top,
        imgLeft: this._objects[0].left,
        imgTop: this._objects[0].top
      };
      const angle = this.angle;
      const radians = fabric.fabric.util.degreesToRadians(this.angle);
      const centerPoint = this.getCenterPoint();
      this.rotate(0);
      const imgOffsetX = this._objects[0].left * this.scaleX;
      const imgOffsetY = this._objects[0].top * this.scaleY;
      const toLeft = centerPoint.x - Math.abs(imgOffsetX);
      const toTop = centerPoint.y - Math.abs(imgOffsetY);
      this.clipPath = null;
      this.dirty = true;
      this.width = this._objects[0].width;
      this.height = this._objects[0].height;
      this._objects[0].left = -this._objects[0].width / 2;
      this._objects[0].top = -this._objects[0].height / 2;
      this._objects[0].dirty = true;
      this.rotate(angle);
      const pointerRotate1 = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(toLeft, toTop), centerPoint, radians);
      this.left = pointerRotate1.x;
      this.top = pointerRotate1.y;
      this.canvas.renderAll();
    },
    /**
     *
     * @param {cropType} [type=cropType.Rect] 剪裁类型
     */
    doCrop: async function(type = cropType.RECT) {
      await this.loadAllControlImage();
      this.lastCropType = this._cropType || cropType.RECT;
      if (type === cropType.RECT) {
        this.isClip = true;
        if (this.clipPath) {
          this.lastClipPath = this.clipPath;
          if (this.lastCropType === cropType.RECT) {
            this.clipPath = null;
            this.dirty = true;
            this.canvas.renderAll();
          } else {
            this.removeCrop();
          }
        }
        this._cropType = cropType.RECT;
        const path = `M ${this.left} ${this.top} H ${this.left + this.width} V ${this.top + this.height} H ${this.left} Z`;
        const clipBox = new fabric.fabric.Path(path, {
          absolutePositioned: true,
          left: this.left,
          top: this.top,
          scaleX: this.scaleX,
          scaleY: this.scaleY,
          angle: this.angle,
          fill: "transparent",
          strokeWidth: 0,
          belongTo: this
        });
        clipBox.setControlsVisibility({
          mtr: false,
          mt: false,
          ml: false,
          mb: false,
          mr: false,
          replace: false,
          lock: false
        });
        const tlAcHandler = clipBox.controls.tl.actionHandler;
        const trAcHandler = clipBox.controls.tr.actionHandler;
        const blAcHandler = clipBox.controls.bl.actionHandler;
        const brAcHandler = clipBox.controls.br.actionHandler;
        const tlRender = clipBox.controls.tl.render;
        const trRender = clipBox.controls.tr.render;
        const blRender = clipBox.controls.bl.render;
        const brRender = clipBox.controls.br.render;
        clipBox.controls.tl.actionHandler = (eventData, transformData, x, y) => {
          if (!this.isClip) {
            tlAcHandler(eventData, transformData, x, y);
            return true;
          }
          const radians = fabric.fabric.util.degreesToRadians(this.angle);
          const img = this._objects[0];
          const imgOffsetLeft = img.left * this.scaleX;
          const imgOffsetTop = img.top * this.scaleY;
          const groupCenterX = this.left + this.getScaledWidth() / 2;
          const groupCenterY = this.top + this.getScaledHeight() / 2;
          img.width * this.scaleX;
          img.height * this.scaleY;
          const imgX = groupCenterX + imgOffsetLeft;
          const imgY = groupCenterY + imgOffsetTop;
          const imgOrigin = new fabric.fabric.Point(imgX, imgY);
          const groupOrigin = new fabric.fabric.Point(this.left, this.top);
          const clipOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(clipBox.left, clipBox.top), groupOrigin, -radians);
          const pointerOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(x, y), groupOrigin, -radians);
          const clipLeft = imgOrigin.x;
          const clipTop = imgOrigin.y;
          const clipRight = clipOrigin.x + clipBox.getScaledWidth();
          const clipBottom = clipOrigin.y + clipBox.getScaledHeight();
          const to = {};
          if (pointerOrigin.x < clipLeft) {
            clipBox.scaleX = (clipRight - clipLeft) / clipBox.width;
            to.x = clipLeft;
          } else if (pointerOrigin.x > clipRight) {
            clipBox.scaleX = 0;
            to.x = clipRight;
          } else {
            clipBox.scaleX = (clipRight - pointerOrigin.x) / clipBox.width;
            to.x = pointerOrigin.x;
          }
          if (pointerOrigin.y < clipTop) {
            clipBox.scaleY = (clipBottom - clipTop) / clipBox.height;
            to.y = clipTop;
          } else if (pointerOrigin.y > clipBottom) {
            clipBox.scaleY = 0;
            to.y = clipBottom;
          } else {
            clipBox.scaleY = (clipBottom - pointerOrigin.y) / clipBox.height;
            to.y = pointerOrigin.y;
          }
          const pointerRotate = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(to.x, to.y), groupOrigin, radians);
          clipBox.left = pointerRotate.x;
          clipBox.top = pointerRotate.y;
          return true;
        };
        clipBox.controls.tr.actionHandler = (eventData, transformData, x, y) => {
          if (!this.isClip) {
            trAcHandler(eventData, transformData, x, y);
            return true;
          }
          const radians = fabric.fabric.util.degreesToRadians(this.angle);
          const img = this._objects[0];
          const imgOffsetLeft = img.left * this.scaleX;
          const imgOffsetTop = img.top * this.scaleY;
          const imgRealWidth = img.width * this.scaleX;
          img.height * this.scaleY;
          const groupCenterX = this.left + this.getScaledWidth() / 2;
          const groupCenterY = this.top + this.getScaledHeight() / 2;
          const imgX = groupCenterX + imgOffsetLeft;
          const imgY = groupCenterY + imgOffsetTop;
          const imgOrigin = new fabric.fabric.Point(imgX, imgY);
          const groupOrigin = new fabric.fabric.Point(this.left, this.top);
          const clipOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(clipBox.left, clipBox.top), groupOrigin, -radians);
          const pointerOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(x, y), groupOrigin, -radians);
          const clipLeft = clipOrigin.x;
          const clipTop = imgOrigin.y;
          const clipRight = imgOrigin.x + imgRealWidth;
          const clipBottom = clipOrigin.y + clipBox.getScaledHeight();
          const to = {};
          to.x = clipOrigin.x;
          if (pointerOrigin.x < clipLeft) {
            clipBox.scaleX = 0;
          } else if (pointerOrigin.x > clipRight) {
            clipBox.scaleX = (clipRight - clipLeft) / clipBox.width;
          } else {
            clipBox.scaleX = (pointerOrigin.x - clipLeft) / clipBox.width;
          }
          if (pointerOrigin.y < clipTop) {
            clipBox.scaleY = (clipBottom - clipTop) / clipBox.height;
            to.y = clipTop;
          } else if (pointerOrigin.y > clipBottom) {
            clipBox.scaleY = 0;
            to.y = clipBottom;
          } else {
            clipBox.scaleY = (clipBottom - pointerOrigin.y) / clipBox.height;
            to.y = pointerOrigin.y;
          }
          const pointerRotate = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(to.x, to.y), groupOrigin, radians);
          clipBox.left = pointerRotate.x;
          clipBox.top = pointerRotate.y;
          return true;
        };
        clipBox.controls.bl.actionHandler = (eventData, transformData, x, y) => {
          if (!this.isClip) {
            blAcHandler(eventData, transformData, x, y);
            return true;
          }
          const radians = fabric.fabric.util.degreesToRadians(this.angle);
          const img = this._objects[0];
          const imgOffsetLeft = img.left * this.scaleX;
          const imgOffsetTop = img.top * this.scaleY;
          img.width * this.scaleX;
          const imgRealHeight = img.height * this.scaleY;
          const groupCenterX = this.left + this.getScaledWidth() / 2;
          const groupCenterY = this.top + this.getScaledHeight() / 2;
          const imgX = groupCenterX + imgOffsetLeft;
          const imgY = groupCenterY + imgOffsetTop;
          const imgOrigin = new fabric.fabric.Point(imgX, imgY);
          const groupOrigin = new fabric.fabric.Point(this.left, this.top);
          const clipOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(clipBox.left, clipBox.top), groupOrigin, -radians);
          const pointerOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(x, y), groupOrigin, -radians);
          const clipLeft = imgOrigin.x;
          const clipTop = clipOrigin.y;
          const clipRight = clipOrigin.x + clipBox.getScaledWidth();
          const clipBottom = imgOrigin.y + imgRealHeight;
          const to = {};
          if (pointerOrigin.x < clipLeft) {
            clipBox.scaleX = (clipRight - clipLeft) / clipBox.width;
            to.x = clipLeft;
          } else if (pointerOrigin.x > clipRight) {
            clipBox.scaleX = 0;
            to.x = clipRight;
          } else {
            clipBox.scaleX = (clipRight - pointerOrigin.x) / clipBox.width;
            to.x = pointerOrigin.x;
          }
          to.y = clipOrigin.y;
          if (pointerOrigin.y < clipTop) {
            clipBox.scaleY = 0;
          } else if (pointerOrigin.y > clipBottom) {
            clipBox.scaleY = (clipBottom - clipTop) / clipBox.height;
          } else {
            clipBox.scaleY = (pointerOrigin.y - clipTop) / clipBox.height;
          }
          const pointerRotate = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(to.x, to.y), groupOrigin, radians);
          clipBox.left = pointerRotate.x;
          clipBox.top = pointerRotate.y;
          return true;
        };
        clipBox.controls.br.actionHandler = (eventData, transformData, x, y) => {
          if (!this.isClip) {
            brAcHandler(eventData, transformData, x, y);
            return true;
          }
          const radians = fabric.fabric.util.degreesToRadians(this.angle);
          const img = this._objects[0];
          const imgOffsetLeft = img.left * this.scaleX;
          const imgOffsetTop = img.top * this.scaleY;
          const imgRealWidth = img.width * this.scaleX;
          const imgRealHeight = img.height * this.scaleY;
          const groupCenterX = this.left + this.getScaledWidth() / 2;
          const groupCenterY = this.top + this.getScaledHeight() / 2;
          const imgX = groupCenterX + imgOffsetLeft;
          const imgY = groupCenterY + imgOffsetTop;
          const imgOrigin = new fabric.fabric.Point(imgX, imgY);
          const groupOrigin = new fabric.fabric.Point(this.left, this.top);
          const clipOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(clipBox.left, clipBox.top), groupOrigin, -radians);
          const pointerOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(x, y), groupOrigin, -radians);
          const clipLeft = clipOrigin.x;
          const clipTop = clipOrigin.y;
          const clipRight = imgOrigin.x + imgRealWidth;
          const clipBottom = imgOrigin.y + imgRealHeight;
          const to = {
            x: clipLeft,
            y: clipTop
          };
          if (pointerOrigin.x < clipLeft) {
            clipBox.scaleX = 0;
          } else if (pointerOrigin.x > clipRight) {
            clipBox.scaleX = (clipRight - clipLeft) / clipBox.width;
          } else {
            clipBox.scaleX = (pointerOrigin.x - clipLeft) / clipBox.width;
          }
          if (pointerOrigin.y < clipTop) {
            clipBox.scaleY = 0;
          } else if (pointerOrigin.y > clipBottom) {
            clipBox.scaleY = (clipBottom - clipTop) / clipBox.height;
          } else {
            clipBox.scaleY = (pointerOrigin.y - clipTop) / clipBox.height;
          }
          const pointerRotate = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(to.x, to.y), groupOrigin, radians);
          clipBox.left = pointerRotate.x;
          clipBox.top = pointerRotate.y;
          return true;
        };
        clipBox.cornerSize = 40;
        clipBox.controls.tl.offsetX = 10;
        clipBox.controls.tl.offsetY = 10;
        clipBox.controls.tr.offsetX = -10;
        clipBox.controls.tr.offsetY = 10;
        clipBox.controls.bl.offsetX = 10;
        clipBox.controls.bl.offsetY = -10;
        clipBox.controls.br.offsetX = -10;
        clipBox.controls.br.offsetY = -10;
        clipBox.controls.tl.render = (ctx, left, top, styleOverride, fabricObject) => {
          if (!this.isClip) {
            tlRender.call(this, ctx, left, top, styleOverride, fabricObject);
            return true;
          } else {
            const size = 40;
            ctx.save();
            ctx.translate(left, top);
            const img = this.tlImg;
            ctx.rotate(fabric.fabric.util.degreesToRadians(fabricObject.angle));
            ctx.drawImage(img, -size / 2, -size / 2, 40, 40);
            ctx.restore();
          }
        };
        clipBox.controls.tr.render = (ctx, left, top, styleOverride, fabricObject) => {
          if (!this.isClip) {
            trRender.call(this, ctx, left, top, styleOverride, fabricObject);
            return true;
          } else {
            const size = 40;
            ctx.save();
            ctx.translate(left, top);
            const img = this.trImg;
            ctx.rotate(fabric.fabric.util.degreesToRadians(fabricObject.angle));
            ctx.drawImage(img, -size / 2, -size / 2, 40, 40);
            ctx.restore();
          }
        };
        clipBox.controls.bl.render = (ctx, left, top, styleOverride, fabricObject) => {
          if (!this.isClip) {
            blRender.call(this, ctx, left, top, styleOverride, fabricObject);
            return true;
          } else {
            const size = 40;
            ctx.save();
            ctx.translate(left, top);
            const img = this.blImg;
            ctx.rotate(fabric.fabric.util.degreesToRadians(fabricObject.angle));
            ctx.drawImage(img, -size / 2, -size / 2, 40, 40);
            ctx.restore();
          }
        };
        clipBox.controls.br.render = (ctx, left, top, styleOverride, fabricObject) => {
          if (!this.isClip) {
            brRender.call(this, ctx, left, top, styleOverride, fabricObject);
            return true;
          } else {
            const size = 40;
            ctx.save();
            ctx.translate(left, top);
            const img = this.brImg;
            ctx.rotate(fabric.fabric.util.degreesToRadians(fabricObject.angle));
            ctx.drawImage(img, -size / 2, -size / 2, 40, 40);
            ctx.restore();
          }
        };
        clipBox.on("moving", ({ e, transform, pointer }) => {
          const img = this._objects[0];
          const radians = fabric.fabric.util.degreesToRadians(this.angle);
          const imgOffsetLeft = img.left * this.scaleX;
          const imgOffsetTop = img.top * this.scaleY;
          const imgRealWidth = img.width * this.scaleX;
          const imgRealHeight = img.height * this.scaleY;
          const groupCenterX = this.left + this.getScaledWidth() / 2;
          const groupCenterY = this.top + this.getScaledHeight() / 2;
          const imgX = groupCenterX + imgOffsetLeft;
          const imgY = groupCenterY + imgOffsetTop;
          const groupOrigin = new fabric.fabric.Point(this.left, this.top);
          const imgOrigin = new fabric.fabric.Point(imgX, imgY);
          const clipOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(clipBox.left, clipBox.top), groupOrigin, -radians);
          if (clipOrigin.x < imgOrigin.x) {
            clipOrigin.x = imgOrigin.x;
          }
          if (clipOrigin.y < imgOrigin.y) {
            clipOrigin.y = imgOrigin.y;
          }
          const clipRight = clipOrigin.x + clipBox.getScaledWidth();
          const imgRight = imgOrigin.x + imgRealWidth;
          if (clipRight > imgRight) {
            clipOrigin.x = imgRight - clipBox.getScaledWidth();
          }
          const clipBottom = clipOrigin.y + clipBox.getScaledHeight();
          const imgBottom = imgOrigin.y + imgRealHeight;
          if (clipBottom > imgBottom) {
            clipOrigin.y = imgBottom - clipBox.getScaledHeight();
          }
          const clipToOrigin = fabric.fabric.util.rotatePoint(clipOrigin, groupOrigin, radians);
          clipBox.set("left", clipToOrigin.x).set("top", clipToOrigin.y);
        });
        this.clipBox = clipBox;
        this.canvas.add(clipBox);
        this.canvas.setActiveObject(clipBox);
        this.canvas.renderAll();
      } else {
        this.doShapeCrop(type);
      }
    },
    cancelCrop: function() {
      if (this.isClip) {
        resetOffest(this.clipBox.controls);
        if (this.lastClipPath) {
          const needRestorePositionAndWH = this.lastCropType !== this._cropType;
          const lastCp = this.lastClipPath;
          this._cropType = this.lastCropType;
          if (needRestorePositionAndWH) {
            this.set({
              clipPath: lastCp,
              width: this.lastCropInfo.width,
              height: this.lastCropInfo.height,
              left: this.lastCropInfo.left,
              top: this.lastCropInfo.top
            });
            this._objects[0].set({
              left: this.lastCropInfo.imgLeft,
              top: this.lastCropInfo.imgTop
            });
          } else {
            this.set({
              clipPath: lastCp
            });
          }
        } else {
          this._cropType = "";
        }
        this.lastCropType = "";
        this.lastClipPath = null;
        this.isClip = false;
        this.canvas.removeWithoutEmit(this.clipBox);
        this.canvas.renderAll();
      }
    },
    doneCrop: async function() {
      if (this.isClip) {
        resetOffest(this.clipBox.controls);
        if (this._cropType === cropType.RECT) {
          const groupOrigin = new fabric.fabric.Point(this.left, this.top);
          const centerX = this.left + this.getScaledWidth() / 2;
          const centerY = this.top + this.getScaledHeight() / 2;
          this.lastClipPath = null;
          this.lastWidth = this.width;
          this.lastHeight = this.height;
          const tempW = this.clipBox.getScaledWidth() / this.scaleX;
          const tempH = this.clipBox.getScaledHeight() / this.scaleY;
          const path = `M ${this.clipBox.left} ${this.clipBox.top} H ${this.clipBox.left + tempW} V ${this.clipBox.top + tempH} H ${this.clipBox.left} Z`;
          const cb = new fabric.fabric.Path(path, {
            originX: "left",
            originY: "top",
            strokeWidth: 0,
            // 取消绝对定位后，剪切框的定位就变为了相对于group的中心点定位
            left: -(tempW / 2),
            top: -(tempH / 2)
          });
          this.set({
            clipPath: cb,
            // 取消绝对定位后，cb 不继承scaleX Y, 这里用 clipBox 的宽高来设置 group 的宽高
            width: this.clipBox.getScaledWidth() / this.scaleX,
            height: this.clipBox.getScaledHeight() / this.scaleY,
            left: this.clipBox.left,
            top: this.clipBox.top,
            _cropType: this._cropType,
            dirty: true
          });
          const radians = fabric.fabric.util.degreesToRadians(this.angle);
          const newGroupOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(this.left, this.top), groupOrigin, -radians);
          const offsetX = newGroupOrigin.x + this.getScaledWidth() / 2 - centerX;
          const offsetY = newGroupOrigin.y + this.getScaledHeight() / 2 - centerY;
          this.item(0).left = this.item(0).left - offsetX / this.scaleX;
          this.item(0).top = this.item(0).top - offsetY / this.scaleY;
          this.setCoords();
          this.isClip = false;
          this.canvas.removeWithoutEmit(this.clipBox);
          this.canvas.renderAll();
        } else {
          await this.confrimShapeCrop();
        }
      }
    },
    doShapeCrop: async function(type) {
      this.lastClipPath = this.clipPath;
      if (this.clipPath) {
        if (this.lastCropType === type) {
          this.clipPath = null;
          this.dirty = true;
          this.canvas.renderAll();
        } else {
          this.removeCrop();
        }
      }
      this._cropType = type;
      this.isClip = true;
      let clipBox = null;
      if (type === cropType.CIRCLE) {
        const needUseLastClipPath = this.lastCropType === type;
        const radius = needUseLastClipPath ? this.lastClipPath.radius - defaultStrokeWidth / 2 : Math.min(this.width, this.height) / 2 - defaultStrokeWidth / 2;
        let toScaleX = 1;
        let toScaleY = 1;
        if (!needUseLastClipPath) {
          let minSide = null;
          if (this.width >= this.height) {
            minSide = this.getScaledHeight();
          } else {
            minSide = this.getScaledWidth();
          }
          toScaleX = toScaleY = (minSide - defaultStrokeWidth) / (radius * 2);
        } else {
          toScaleX = (this.getScaledWidth() - defaultStrokeWidth) / (radius * 2);
          toScaleY = (this.getScaledHeight() - defaultStrokeWidth) / (radius * 2);
        }
        clipBox = new fabric.fabric.Circle({
          radius,
          scaleX: toScaleX,
          scaleY: toScaleY,
          angle: this.angle,
          fill: "transparent",
          stroke: shapeStrokeColor,
          strokeWidth: defaultStrokeWidth,
          strokeUniform: true,
          noScaleCache: false,
          flipX: false,
          flipY: false,
          belongTo: this
        });
      } else if (type === cropType.TRIANGLE) {
        let toH = 20;
        let toW = 20;
        let toScaleX = 1;
        let toScaleY = 1;
        const needUseLastClipPath = this.lastCropType === type;
        if (needUseLastClipPath) {
          toH = this.lastClipPath.height - defaultStrokeWidth;
          toW = this.lastClipPath.width - defaultStrokeWidth;
          toScaleX = (this.getScaledWidth() - defaultStrokeWidth) / toW;
          toScaleY = (this.getScaledHeight() - defaultStrokeWidth) / toH;
        } else {
          if (this.width > this.height) {
            toH = this.height - defaultStrokeWidth;
            toW = toH / Math.tan(Math.PI / 3) * 2;
            toScaleY = (this.getScaledHeight() - defaultStrokeWidth) / toH;
            toScaleX = toScaleY;
          } else {
            toW = this.width;
            toH = toW / 2 / Math.tan(Math.PI / 6);
            toScaleX = (this.getScaledWidth() - defaultStrokeWidth) / toW;
            toScaleY = toScaleX;
          }
        }
        clipBox = new fabric.fabric.Triangle({
          width: toW,
          height: toH,
          scaleX: toScaleX,
          scaleY: toScaleY,
          angle: this.angle,
          fill: "transparent",
          stroke: shapeStrokeColor,
          strokeWidth: defaultStrokeWidth,
          strokeUniform: true,
          noScaleCache: false,
          belongTo: this
        });
      } else if (type === cropType.HEART) {
        if (this.lastCropType === type && this.lastClipPath) {
          clipBox = await cloneFabricObject(this.lastClipPath);
          clipBox.angle = this.angle;
          clipBox.noScaleCache = false;
          clipBox.fill = "transparent";
          clipBox.belongTo = this;
          clipBox.scaleX = (this.getScaledWidth() - defaultStrokeWidth) / clipBox.width;
          clipBox.scaleY = (this.getScaledHeight() - defaultStrokeWidth) / clipBox.height;
        } else {
          const path = "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z";
          clipBox = new fabric.fabric.Path(path, {
            fill: "transparent",
            stroke: shapeStrokeColor,
            strokeWidth: defaultStrokeWidth,
            strokeUniform: true,
            noScaleCache: false,
            belongTo: this
          });
          const thisW = this.getScaledWidth();
          const thisH = this.getScaledHeight();
          if (thisW <= thisH) {
            clipBox.scaleToWidth(thisW - defaultStrokeWidth);
          } else {
            clipBox.scaleToHeight(thisH - defaultStrokeWidth);
          }
          clipBox.angle = this.angle;
        }
      }
      clipBox.setPositionByOrigin(this.getPointByOrigin("center", "center"), "center", "center");
      clipBox.setControlsVisibility({
        mtr: false,
        mt: true,
        ml: true,
        mb: true,
        mr: true,
        replace: false,
        lock: false
      });
      const tlAcHandler = clipBox.controls.tl.actionHandler;
      clipBox.controls.tl.actionHandler = (eventData, transform, x, y) => {
        if (!this.isClip) {
          tlAcHandler(eventData, transform, x, y);
          return true;
        }
        const constraint = {
          x: clipBox.left,
          y: clipBox.top
        };
        const rbPoint = clipBox.getPointByOrigin("right", "bottom");
        clipBox.left = rbPoint.x;
        clipBox.top = rbPoint.y;
        clipBox.originX = "right";
        clipBox.originY = "bottom";
        const radians = fabric.fabric.util.degreesToRadians(this.angle);
        const img = this._objects[0];
        const imgOffsetLeft = img.left * this.scaleX;
        const imgOffsetTop = img.top * this.scaleY;
        const groupCenterX = this.left + this.getScaledWidth() / 2;
        const groupCenterY = this.top + this.getScaledHeight() / 2;
        const imgRealWidth = img.width * this.scaleX;
        const imgRealHeight = img.height * this.scaleY;
        const imgX = groupCenterX + imgOffsetLeft;
        const imgY = groupCenterY + imgOffsetTop;
        const imgOrigin = new fabric.fabric.Point(imgX, imgY);
        const groupOrigin = new fabric.fabric.Point(this.left, this.top);
        const clipOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(clipBox.left, clipBox.top), groupOrigin, -radians);
        const pointerOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(x, y), groupOrigin, -radians);
        const xIntr = segmentsIntr(
          clipOrigin,
          { x: clipOrigin.x - clipBox.getScaledWidth(), y: clipOrigin.y - clipBox.getScaledHeight() },
          imgOrigin,
          { x: imgOrigin.x + imgRealWidth, y: imgOrigin.y }
        );
        const yIntr = segmentsIntr(
          clipOrigin,
          { x: clipOrigin.x - clipBox.getScaledWidth(), y: clipOrigin.y - clipBox.getScaledHeight() },
          imgOrigin,
          { x: imgOrigin.x, y: imgOrigin.y + imgRealHeight }
        );
        let maxMagnitude = 0;
        let tempIntr = null;
        if (!xIntr && yIntr) {
          tempIntr = yIntr;
        } else if (xIntr && !yIntr) {
          tempIntr = xIntr;
        } else if (xIntr && yIntr) {
          if (xIntr.x < imgOrigin.x) {
            tempIntr = yIntr;
          } else {
            tempIntr = xIntr;
          }
        }
        if (pointerOrigin.x >= clipOrigin.x - 20 || pointerOrigin.y >= clipOrigin.y - 20) {
          clipBox.left = constraint.x;
          clipBox.top = constraint.y;
          clipBox.originX = "left";
          clipBox.originY = "top";
          return;
        }
        const currentMagnitude = calculateMagnitude2D(-clipBox.getScaledWidth(), -clipBox.getScaledHeight());
        const maxWidth = tempIntr.x - clipOrigin.x;
        const maxHeight = tempIntr.y - clipOrigin.y;
        maxMagnitude = calculateMagnitude2D(maxWidth, maxHeight);
        const currentPointVector = { x: pointerOrigin.x - clipOrigin.x, y: pointerOrigin.y - clipOrigin.y };
        const topLeftVector = { x: -clipBox.getScaledWidth(), y: -clipBox.getScaledHeight() };
        let scaleMagnitude = calculateProjection(currentPointVector, topLeftVector);
        scaleMagnitude = Math.max(scaleMagnitude, 0);
        if (scaleMagnitude > maxMagnitude) {
          const scaleRate = maxMagnitude / currentMagnitude;
          clipBox.scaleX = clipBox.scaleX * scaleRate;
          clipBox.scaleY = clipBox.scaleY * scaleRate;
        } else {
          const scaleRate = scaleMagnitude / currentMagnitude;
          clipBox.scaleX = clipBox.scaleX * scaleRate;
          clipBox.scaleY = clipBox.scaleY * scaleRate;
        }
        const tlPoint = { x: clipOrigin.x - clipBox.getScaledWidth(), y: clipOrigin.y - clipBox.getScaledHeight() };
        const pointerRotate1 = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(tlPoint.x, tlPoint.y), groupOrigin, radians);
        clipBox.left = pointerRotate1.x;
        clipBox.top = pointerRotate1.y;
        clipBox.originX = "left";
        clipBox.originY = "top";
        return true;
      };
      const trAcHandler = clipBox.controls.tr.actionHandler;
      clipBox.controls.tr.actionHandler = (eventData, transformData, x, y) => {
        if (!this.isClip) {
          trAcHandler(eventData, transformData, x, y);
          return true;
        }
        const constraint = {
          x: clipBox.left,
          y: clipBox.top
        };
        const rbPoint = clipBox.getPointByOrigin("left", "bottom");
        clipBox.left = rbPoint.x;
        clipBox.top = rbPoint.y;
        clipBox.originX = "left";
        clipBox.originY = "bottom";
        const radians = fabric.fabric.util.degreesToRadians(this.angle);
        const img = this._objects[0];
        const imgOffsetLeft = img.left * this.scaleX;
        const imgOffsetTop = img.top * this.scaleY;
        const groupCenterX = this.left + this.getScaledWidth() / 2;
        const groupCenterY = this.top + this.getScaledHeight() / 2;
        const imgRealWidth = img.width * this.scaleX;
        const imgRealHeight = img.height * this.scaleY;
        const imgX = groupCenterX + imgOffsetLeft;
        const imgY = groupCenterY + imgOffsetTop;
        const imgOrigin = new fabric.fabric.Point(imgX, imgY);
        const groupOrigin = new fabric.fabric.Point(this.left, this.top);
        const clipOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(clipBox.left, clipBox.top), groupOrigin, -radians);
        const pointerOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(x, y), groupOrigin, -radians);
        const xIntr = segmentsIntr(
          clipOrigin,
          { x: clipOrigin.x + clipBox.getScaledWidth(), y: clipOrigin.y - clipBox.getScaledHeight() },
          imgOrigin,
          { x: imgOrigin.x + imgRealWidth, y: imgOrigin.y }
        );
        const yIntr = segmentsIntr(
          clipOrigin,
          { x: clipOrigin.x + clipBox.getScaledWidth(), y: clipOrigin.y - clipBox.getScaledHeight() },
          { x: imgOrigin.x + imgRealWidth, y: imgOrigin.y },
          { x: imgOrigin.x + imgRealWidth, y: imgOrigin.y + imgRealHeight }
        );
        let maxMagnitude = 0;
        let tempIntr = null;
        if (!xIntr && yIntr) {
          tempIntr = yIntr;
        } else if (xIntr && !yIntr) {
          tempIntr = xIntr;
        } else if (xIntr && yIntr) {
          if (xIntr.x > imgOrigin.x + imgRealWidth) {
            tempIntr = yIntr;
          } else {
            tempIntr = xIntr;
          }
        }
        if (pointerOrigin.x <= clipOrigin.x + 20 || pointerOrigin.y >= clipOrigin.y + 20) {
          clipBox.left = constraint.x;
          clipBox.top = constraint.y;
          clipBox.originX = "left";
          clipBox.originY = "top";
          return;
        }
        const currentMagnitude = calculateMagnitude2D(clipBox.getScaledWidth(), clipBox.getScaledHeight());
        const maxWidth = tempIntr.x - clipOrigin.x;
        const maxHeight = -(tempIntr.y - clipOrigin.y);
        maxMagnitude = calculateMagnitude2D(maxWidth, maxHeight);
        const currentPointVector = { x: pointerOrigin.x - clipOrigin.x, y: pointerOrigin.y - clipOrigin.y };
        const topRightVector = { x: clipBox.getScaledWidth(), y: -clipBox.getScaledHeight() };
        let scaleMagnitude = calculateProjection(currentPointVector, topRightVector);
        scaleMagnitude = Math.max(scaleMagnitude, 0);
        if (scaleMagnitude > maxMagnitude) {
          const scaleRate = maxMagnitude / currentMagnitude;
          clipBox.scaleX = clipBox.scaleX * scaleRate;
          clipBox.scaleY = clipBox.scaleY * scaleRate;
        } else {
          const scaleRate = scaleMagnitude / currentMagnitude;
          clipBox.scaleX = clipBox.scaleX * scaleRate;
          clipBox.scaleY = clipBox.scaleY * scaleRate;
        }
        const tlPoint = { x: clipOrigin.x, y: clipOrigin.y - clipBox.getScaledHeight() };
        const pointerRotate1 = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(tlPoint.x, tlPoint.y), groupOrigin, radians);
        clipBox.left = pointerRotate1.x;
        clipBox.top = pointerRotate1.y;
        clipBox.originX = "left";
        clipBox.originY = "top";
        return true;
      };
      const blAcHandler = clipBox.controls.bl.actionHandler;
      clipBox.controls.bl.actionHandler = (eventData, transformData, x, y) => {
        if (!this.isClip) {
          blAcHandler(eventData, transformData, x, y);
          return true;
        }
        const constraint = {
          x: clipBox.left,
          y: clipBox.top
        };
        const rbPoint = clipBox.getPointByOrigin("right", "top");
        clipBox.left = rbPoint.x;
        clipBox.top = rbPoint.y;
        clipBox.originX = "right";
        clipBox.originY = "top";
        const radians = fabric.fabric.util.degreesToRadians(this.angle);
        const img = this._objects[0];
        const imgOffsetLeft = img.left * this.scaleX;
        const imgOffsetTop = img.top * this.scaleY;
        const groupCenterX = this.left + this.getScaledWidth() / 2;
        const groupCenterY = this.top + this.getScaledHeight() / 2;
        const imgRealWidth = img.width * this.scaleX;
        const imgRealHeight = img.height * this.scaleY;
        const imgX = groupCenterX + imgOffsetLeft;
        const imgY = groupCenterY + imgOffsetTop;
        const imgOrigin = new fabric.fabric.Point(imgX, imgY);
        const groupOrigin = new fabric.fabric.Point(this.left, this.top);
        const clipOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(clipBox.left, clipBox.top), groupOrigin, -radians);
        const pointerOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(x, y), groupOrigin, -radians);
        const xIntr = segmentsIntr(
          clipOrigin,
          { x: clipOrigin.x - clipBox.getScaledWidth(), y: clipOrigin.y + clipBox.getScaledHeight() },
          { x: imgOrigin.x, y: imgOrigin.y + imgRealHeight },
          { x: imgOrigin.x + imgRealWidth, y: imgOrigin.y + imgRealHeight }
        );
        const yIntr = segmentsIntr(
          clipOrigin,
          { x: clipOrigin.x - clipBox.getScaledWidth(), y: clipOrigin.y + clipBox.getScaledHeight() },
          imgOrigin,
          { x: imgOrigin.x, y: imgOrigin.y + imgRealHeight }
        );
        let maxMagnitude = 0;
        let tempIntr = null;
        if (!xIntr && yIntr) {
          tempIntr = yIntr;
        } else if (xIntr && !yIntr) {
          tempIntr = xIntr;
        } else if (xIntr && yIntr) {
          if (xIntr.x < imgOrigin.x) {
            tempIntr = yIntr;
          } else {
            tempIntr = xIntr;
          }
        }
        if (pointerOrigin.x >= clipOrigin.x - 20 || pointerOrigin.y <= clipOrigin.y + 20) {
          clipBox.left = constraint.x;
          clipBox.top = constraint.y;
          clipBox.originX = "left";
          clipBox.originY = "top";
          return false;
        }
        const currentMagnitude = calculateMagnitude2D(-clipBox.getScaledWidth(), -clipBox.getScaledHeight());
        const maxWidth = tempIntr.x - clipOrigin.x;
        const maxHeight = tempIntr.y - clipOrigin.y;
        maxMagnitude = calculateMagnitude2D(maxWidth, maxHeight);
        const currentPointVector = { x: pointerOrigin.x - clipOrigin.x, y: pointerOrigin.y - clipOrigin.y };
        const bottomLeftVector = { x: -clipBox.getScaledWidth(), y: clipBox.getScaledHeight() };
        let scaleMagnitude = calculateProjection(currentPointVector, bottomLeftVector);
        scaleMagnitude = Math.max(scaleMagnitude, 0);
        if (scaleMagnitude > maxMagnitude) {
          const scaleRate = maxMagnitude / currentMagnitude;
          clipBox.scaleX = clipBox.scaleX * scaleRate;
          clipBox.scaleY = clipBox.scaleY * scaleRate;
        } else {
          const scaleRate = scaleMagnitude / currentMagnitude;
          clipBox.scaleX = clipBox.scaleX * scaleRate;
          clipBox.scaleY = clipBox.scaleY * scaleRate;
        }
        const tlPoint = { x: clipOrigin.x - clipBox.getScaledWidth(), y: clipOrigin.y };
        const pointerRotate1 = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(tlPoint.x, tlPoint.y), groupOrigin, radians);
        clipBox.left = pointerRotate1.x;
        clipBox.top = pointerRotate1.y;
        clipBox.originX = "left";
        clipBox.originY = "top";
        return true;
      };
      const brAcHandler = clipBox.controls.br.actionHandler;
      clipBox.controls.br.actionHandler = (eventData, transformData, x, y) => {
        if (!this.isClip) {
          brAcHandler(eventData, transformData, x, y);
          return true;
        }
        const radians = fabric.fabric.util.degreesToRadians(this.angle);
        const img = this._objects[0];
        const imgOffsetLeft = img.left * this.scaleX;
        const imgOffsetTop = img.top * this.scaleY;
        const groupCenterX = this.left + this.getScaledWidth() / 2;
        const groupCenterY = this.top + this.getScaledHeight() / 2;
        const imgRealWidth = img.width * this.scaleX;
        const imgRealHeight = img.height * this.scaleY;
        const imgX = groupCenterX + imgOffsetLeft;
        const imgY = groupCenterY + imgOffsetTop;
        const imgOrigin = new fabric.fabric.Point(imgX, imgY);
        const groupOrigin = new fabric.fabric.Point(this.left, this.top);
        const clipOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(clipBox.left, clipBox.top), groupOrigin, -radians);
        const pointerOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(x, y), groupOrigin, -radians);
        const xIntr = segmentsIntr(
          clipOrigin,
          { x: clipOrigin.x + clipBox.getScaledWidth(), y: clipOrigin.y + clipBox.getScaledHeight() },
          { x: imgOrigin.x, y: imgOrigin.y + imgRealHeight },
          { x: imgOrigin.x + imgRealWidth, y: imgOrigin.y + imgRealHeight }
        );
        const yIntr = segmentsIntr(
          clipOrigin,
          { x: clipOrigin.x + clipBox.getScaledWidth(), y: clipOrigin.y + clipBox.getScaledHeight() },
          { x: imgOrigin.x + imgRealWidth, y: imgOrigin.y },
          { x: imgOrigin.x + imgRealWidth, y: imgOrigin.y + imgRealHeight }
        );
        let maxMagnitude = 0;
        let tempIntr = null;
        if (!xIntr && yIntr) {
          tempIntr = yIntr;
        } else if (xIntr && !yIntr) {
          tempIntr = xIntr;
        } else if (xIntr && yIntr) {
          if (xIntr.x > imgOrigin.x + imgRealWidth) {
            tempIntr = yIntr;
          } else {
            tempIntr = xIntr;
          }
        }
        if (pointerOrigin.x <= clipOrigin.x + 20 || pointerOrigin.y <= clipOrigin.y + 20) {
          return false;
        }
        const currentMagnitude = calculateMagnitude2D(-clipBox.getScaledWidth(), -clipBox.getScaledHeight());
        const maxWidth = tempIntr.x - clipOrigin.x;
        const maxHeight = tempIntr.y - clipOrigin.y;
        maxMagnitude = calculateMagnitude2D(maxWidth, maxHeight);
        const currentPointVector = { x: pointerOrigin.x - clipOrigin.x, y: pointerOrigin.y - clipOrigin.y };
        const bottomRightVector = { x: clipBox.getScaledWidth(), y: clipBox.getScaledHeight() };
        let scaleMagnitude = calculateProjection(currentPointVector, bottomRightVector);
        scaleMagnitude = Math.max(scaleMagnitude, 0);
        if (scaleMagnitude > maxMagnitude) {
          const scaleRate = maxMagnitude / currentMagnitude;
          clipBox.scaleX = clipBox.scaleX * scaleRate;
          clipBox.scaleY = clipBox.scaleY * scaleRate;
        } else {
          const scaleRate = scaleMagnitude / currentMagnitude;
          clipBox.scaleX = clipBox.scaleX * scaleRate;
          clipBox.scaleY = clipBox.scaleY * scaleRate;
        }
        return true;
      };
      const mlAcHandler = clipBox.controls.ml.actionHandler;
      clipBox.controls.ml.actionHandler = (eventData, transform, x, y) => {
        if (!this.isClip) {
          mlAcHandler(eventData, transform, x, y);
          return true;
        }
        const target = transform.target;
        const centerPoint = target.getCenterPoint();
        const constraint = target.translateToOriginPoint(centerPoint, transform.originX, transform.originY);
        const radians = fabric.fabric.util.degreesToRadians(this.angle);
        const img = this._objects[0];
        const imgOffsetLeft = img.left * this.scaleX;
        const imgOffsetTop = img.top * this.scaleY;
        const groupCenterX = this.left + this.getScaledWidth() / 2;
        const groupCenterY = this.top + this.getScaledHeight() / 2;
        img.width * this.scaleX;
        img.height * this.scaleY;
        const imgX = groupCenterX + imgOffsetLeft;
        const imgY = groupCenterY + imgOffsetTop;
        const imgOrigin = new fabric.fabric.Point(imgX, imgY);
        const groupOrigin = new fabric.fabric.Point(this.left, this.top);
        const clipOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(clipBox.left, clipBox.top), groupOrigin, -radians);
        const pointerOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(x, y), groupOrigin, -radians);
        const clipLeft = imgOrigin.x + defaultStrokeWidth / 2;
        imgOrigin.y;
        const clipRight = clipOrigin.x + clipBox.getScaledWidth() - defaultStrokeWidth / 2;
        clipOrigin.y + clipBox.getScaledHeight();
        if (pointerOrigin.x < clipLeft) {
          clipBox.scaleX = (clipRight - clipLeft) / clipBox.width;
        } else if (pointerOrigin.x > clipRight) {
          clipBox.scaleX = 0;
        } else {
          clipBox.scaleX = (clipRight - pointerOrigin.x) / clipBox.width;
        }
        target.setPositionByOrigin(constraint, transform.originX, transform.originY);
        return true;
      };
      const mrAcHandler = clipBox.controls.mr.actionHandler;
      clipBox.controls.mr.actionHandler = (eventData, transform, x, y) => {
        if (!this.isClip) {
          mrAcHandler(eventData, transform, x, y);
          return true;
        }
        const target = transform.target;
        const centerPoint = target.getCenterPoint();
        const constraint = target.translateToOriginPoint(centerPoint, transform.originX, transform.originY);
        const radians = fabric.fabric.util.degreesToRadians(this.angle);
        const img = this._objects[0];
        const imgOffsetLeft = img.left * this.scaleX;
        const imgOffsetTop = img.top * this.scaleY;
        const groupCenterX = this.left + this.getScaledWidth() / 2;
        const groupCenterY = this.top + this.getScaledHeight() / 2;
        const imgRealWidth = img.width * this.scaleX;
        img.height * this.scaleY;
        const imgX = groupCenterX + imgOffsetLeft;
        const imgY = groupCenterY + imgOffsetTop;
        const imgOrigin = new fabric.fabric.Point(imgX, imgY);
        const groupOrigin = new fabric.fabric.Point(this.left, this.top);
        const clipOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(clipBox.left, clipBox.top), groupOrigin, -radians);
        const pointerOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(x, y), groupOrigin, -radians);
        const clipLeft = clipOrigin.x + defaultStrokeWidth / 2;
        const clipRight = imgOrigin.x + imgRealWidth - defaultStrokeWidth / 2;
        if (pointerOrigin.x <= clipLeft) {
          clipBox.scaleX = 0;
        } else if (pointerOrigin.x >= clipRight) {
          clipBox.scaleX = (clipRight - clipLeft) / clipBox.width;
        } else {
          clipBox.scaleX = (pointerOrigin.x - clipLeft) / clipBox.width;
        }
        target.setPositionByOrigin(constraint, transform.originX, transform.originY);
        return true;
      };
      const mtAcHandler = clipBox.controls.mt.actionHandler;
      clipBox.controls.mt.actionHandler = (eventData, transform, x, y) => {
        if (!this.isClip) {
          mtAcHandler(eventData, transform, x, y);
          return true;
        }
        const target = transform.target;
        const centerPoint = target.getCenterPoint();
        const constraint = target.translateToOriginPoint(centerPoint, transform.originX, transform.originY);
        const radians = fabric.fabric.util.degreesToRadians(this.angle);
        const img = this._objects[0];
        const imgOffsetLeft = img.left * this.scaleX;
        const imgOffsetTop = img.top * this.scaleY;
        const groupCenterX = this.left + this.getScaledWidth() / 2;
        const groupCenterY = this.top + this.getScaledHeight() / 2;
        img.width * this.scaleX;
        img.height * this.scaleY;
        const imgX = groupCenterX + imgOffsetLeft;
        const imgY = groupCenterY + imgOffsetTop;
        const imgOrigin = new fabric.fabric.Point(imgX, imgY);
        const groupOrigin = new fabric.fabric.Point(this.left, this.top);
        const clipOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(clipBox.left, clipBox.top), groupOrigin, -radians);
        const pointerOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(x, y), groupOrigin, -radians);
        const clipTop = imgOrigin.y + defaultStrokeWidth / 2;
        const clipBottom = clipOrigin.y + clipBox.getScaledHeight() - defaultStrokeWidth / 2;
        if (pointerOrigin.y >= clipBottom) {
          clipBox.scaleY = 0;
        } else if (pointerOrigin.y <= clipTop) {
          clipBox.scaleY = -(clipTop - clipBottom) / clipBox.height;
        } else {
          clipBox.scaleY = -(pointerOrigin.y - clipBottom) / clipBox.height;
        }
        target.setPositionByOrigin(constraint, transform.originX, transform.originY);
        return true;
      };
      const mbAcHandler = clipBox.controls.mb.actionHandler;
      clipBox.controls.mb.actionHandler = (eventData, transform, x, y) => {
        if (!this.isClip) {
          mbAcHandler(eventData, transform, x, y);
          return true;
        }
        const target = transform.target;
        const centerPoint = target.getCenterPoint();
        const constraint = target.translateToOriginPoint(centerPoint, transform.originX, transform.originY);
        const radians = fabric.fabric.util.degreesToRadians(this.angle);
        const img = this._objects[0];
        const imgOffsetLeft = img.left * this.scaleX;
        const imgOffsetTop = img.top * this.scaleY;
        const groupCenterX = this.left + this.getScaledWidth() / 2;
        const groupCenterY = this.top + this.getScaledHeight() / 2;
        img.width * this.scaleX;
        const imgRealHeight = img.height * this.scaleY;
        const imgX = groupCenterX + imgOffsetLeft;
        const imgY = groupCenterY + imgOffsetTop;
        const imgOrigin = new fabric.fabric.Point(imgX, imgY);
        const groupOrigin = new fabric.fabric.Point(this.left, this.top);
        const clipOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(clipBox.left, clipBox.top), groupOrigin, -radians);
        const pointerOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(x, y), groupOrigin, -radians);
        const clipTop = clipOrigin.y + defaultStrokeWidth / 2;
        const clipBottom = imgOrigin.y + imgRealHeight - defaultStrokeWidth / 2;
        if (pointerOrigin.y >= clipBottom) {
          clipBox.scaleY = (clipBottom - clipTop) / clipBox.height;
        } else if (pointerOrigin.y <= clipTop) {
          clipBox.scaleY = 0;
        } else {
          clipBox.scaleY = (pointerOrigin.y - clipTop) / clipBox.height;
        }
        target.setPositionByOrigin(constraint, transform.originX, transform.originY);
        return true;
      };
      const offsetWidth = 5.5;
      const middleWidth = 20;
      const middleHeight = 5;
      clipBox.cornerSize = 40;
      clipBox.controls.tl.offsetX = 10;
      clipBox.controls.tl.offsetY = 10;
      clipBox.controls.tr.offsetX = -10;
      clipBox.controls.tr.offsetY = 10;
      clipBox.controls.bl.offsetX = 10;
      clipBox.controls.bl.offsetY = -10;
      clipBox.controls.br.offsetX = -10;
      clipBox.controls.br.offsetY = -10;
      const tlRender = clipBox.controls.tl.render;
      const trRender = clipBox.controls.tr.render;
      const blRender = clipBox.controls.bl.render;
      const brRender = clipBox.controls.br.render;
      const mlRender = clipBox.controls.ml.render;
      const mrRender = clipBox.controls.mr.render;
      const mtRender = clipBox.controls.mt.render;
      const mbRender = clipBox.controls.mb.render;
      clipBox.controls.tl.render = (ctx, left, top, styleOverride, fabricObject) => {
        if (!this.isClip) {
          tlRender.call(this, ctx, left, top, styleOverride, fabricObject);
          return true;
        } else {
          const size = 40;
          ctx.save();
          ctx.translate(left, top);
          const img = this.tlImg;
          ctx.rotate(fabric.fabric.util.degreesToRadians(fabricObject.angle));
          ctx.drawImage(img, -size / 2 + offsetWidth, -size / 2 + offsetWidth, 40, 40);
          ctx.restore();
        }
      };
      clipBox.controls.tr.render = (ctx, left, top, styleOverride, fabricObject) => {
        if (!this.isClip) {
          trRender.call(this, ctx, left, top, styleOverride, fabricObject);
          return true;
        } else {
          const size = 40;
          ctx.save();
          ctx.translate(left, top);
          const img = this.trImg;
          ctx.rotate(fabric.fabric.util.degreesToRadians(fabricObject.angle));
          ctx.drawImage(img, -size / 2 - offsetWidth, -size / 2 + offsetWidth, 40, 40);
          ctx.restore();
        }
      };
      clipBox.controls.bl.render = (ctx, left, top, styleOverride, fabricObject) => {
        if (!this.isClip) {
          blRender.call(this, ctx, left, top, styleOverride, fabricObject);
          return true;
        } else {
          const size = 40;
          ctx.save();
          ctx.translate(left, top);
          const img = this.blImg;
          ctx.rotate(fabric.fabric.util.degreesToRadians(fabricObject.angle));
          ctx.drawImage(img, -size / 2 + offsetWidth, -size / 2 - offsetWidth, 40, 40);
          ctx.restore();
        }
      };
      clipBox.controls.br.render = (ctx, left, top, styleOverride, fabricObject) => {
        if (!this.isClip) {
          brRender.call(this, ctx, left, top, styleOverride, fabricObject);
          return true;
        } else {
          const size = 40;
          ctx.save();
          ctx.translate(left, top);
          const img = this.brImg;
          ctx.rotate(fabric.fabric.util.degreesToRadians(fabricObject.angle));
          ctx.drawImage(img, -size / 2 - offsetWidth, -size / 2 - offsetWidth, 40, 40);
          ctx.restore();
        }
      };
      clipBox.controls.ml.render = (ctx, left, top, styleOverride, fabricObject) => {
        if (!this.isClip) {
          mlRender.call(this, ctx, left, top, styleOverride, fabricObject);
          return true;
        } else {
          ctx.save();
          ctx.translate(left, top);
          const img = this.mlImg;
          ctx.rotate(fabric.fabric.util.degreesToRadians(fabricObject.angle));
          ctx.drawImage(img, -middleHeight, -middleWidth, middleHeight * 2, middleWidth * 2);
          ctx.restore();
        }
      };
      clipBox.controls.mr.render = (ctx, left, top, styleOverride, fabricObject) => {
        if (!this.isClip) {
          mrRender.call(this, ctx, left, top, styleOverride, fabricObject);
          return true;
        } else {
          ctx.save();
          ctx.translate(left, top);
          const img = this.mlImg;
          ctx.rotate(fabric.fabric.util.degreesToRadians(fabricObject.angle));
          ctx.drawImage(img, -middleHeight, -middleWidth, middleHeight * 2, middleWidth * 2);
          ctx.restore();
        }
      };
      clipBox.controls.mt.render = (ctx, left, top, styleOverride, fabricObject) => {
        if (!this.isClip) {
          mtRender.call(this, ctx, left, top, styleOverride, fabricObject);
          return true;
        } else {
          ctx.save();
          ctx.translate(left, top);
          const img = this.mtImg;
          ctx.rotate(fabric.fabric.util.degreesToRadians(fabricObject.angle));
          ctx.drawImage(img, -middleWidth, -middleHeight, middleWidth * 2, middleHeight * 2);
          ctx.restore();
        }
      };
      clipBox.controls.mb.render = (ctx, left, top, styleOverride, fabricObject) => {
        if (!this.isClip) {
          mbRender.call(this, ctx, left, top, styleOverride, fabricObject);
          return true;
        } else {
          ctx.save();
          ctx.translate(left, top);
          const img = this.mtImg;
          ctx.rotate(fabric.fabric.util.degreesToRadians(fabricObject.angle));
          ctx.drawImage(img, -middleWidth, -middleHeight, middleWidth * 2, middleHeight * 2);
          ctx.restore();
        }
      };
      clipBox.on("moving", ({ e, transform, pointer }) => {
        const img = this._objects[0];
        const radians = fabric.fabric.util.degreesToRadians(this.angle);
        const imgOffsetLeft = img.left * this.scaleX;
        const imgOffsetTop = img.top * this.scaleY;
        const imgRealWidth = img.width * this.scaleX;
        const imgRealHeight = img.height * this.scaleY;
        const groupCenterX = this.left + this.getScaledWidth() / 2;
        const groupCenterY = this.top + this.getScaledHeight() / 2;
        const imgX = groupCenterX + imgOffsetLeft;
        const imgY = groupCenterY + imgOffsetTop;
        const groupOrigin = new fabric.fabric.Point(this.left, this.top);
        const imgOrigin = new fabric.fabric.Point(imgX, imgY);
        const clipOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(clipBox.left, clipBox.top), groupOrigin, -radians);
        if (clipOrigin.x < imgOrigin.x) {
          clipOrigin.x = imgOrigin.x;
        }
        if (clipOrigin.y < imgOrigin.y) {
          clipOrigin.y = imgOrigin.y;
        }
        const clipRight = clipOrigin.x + clipBox.getScaledWidth();
        const imgRight = imgOrigin.x + imgRealWidth;
        if (clipRight > imgRight) {
          clipOrigin.x = imgRight - clipBox.getScaledWidth();
        }
        const clipBottom = clipOrigin.y + clipBox.getScaledHeight();
        const imgBottom = imgOrigin.y + imgRealHeight;
        if (clipBottom > imgBottom) {
          clipOrigin.y = imgBottom - clipBox.getScaledHeight();
        }
        const clipToOrigin = fabric.fabric.util.rotatePoint(clipOrigin, groupOrigin, radians);
        clipBox.set("left", clipToOrigin.x).set("top", clipToOrigin.y);
      });
      this.clipBox = clipBox;
      this.canvas.add(clipBox);
      this.canvas.setActiveObject(clipBox);
    },
    confrimShapeCrop: async function() {
      this.lastClipPath = null;
      const groupOrigin = new fabric.fabric.Point(this.left, this.top);
      const centerX = this.left + this.getScaledWidth() / 2;
      const centerY = this.top + this.getScaledHeight() / 2;
      const clipBoxW = this.clipBox.getScaledWidth();
      const clipBoxH = this.clipBox.getScaledHeight();
      let cb = null;
      if (this._cropType === cropType.CIRCLE) {
        const clipBoxRadius = this.clipBox.radius;
        const toRadius = clipBoxRadius + defaultStrokeWidth / 2;
        cb = new fabric.fabric.Circle({
          radius: clipBoxRadius + defaultStrokeWidth / 2,
          scaleX: this.clipBox.getScaledWidth() / (toRadius * 2) / this.scaleX,
          scaleY: this.clipBox.getScaledHeight() / (toRadius * 2) / this.scaleY,
          left: -(clipBoxW / this.scaleX / 2),
          top: -(clipBoxH / this.scaleY / 2),
          strokeWidth: 0
        });
      } else if (this._cropType === cropType.TRIANGLE) {
        const toWidth = this.clipBox.width + defaultStrokeWidth;
        const toHeight = this.clipBox.height + defaultStrokeWidth;
        cb = new fabric.fabric.Triangle({
          width: toWidth,
          height: toHeight,
          scaleX: this.clipBox.getScaledWidth() / toWidth / this.scaleX,
          scaleY: this.clipBox.getScaledHeight() / toHeight / this.scaleY,
          left: -(clipBoxW / this.scaleX) / 2,
          top: -(clipBoxH / this.scaleY) / 2
        });
      } else if (this._cropType === cropType.HEART) {
        cb = await cloneFabricObject(this.clipBox);
        cb.angle = 0;
        cb.fill = "black";
        cb.dirty = true;
        cb.scaleX = this.clipBox.getScaledWidth() / this.clipBox.width / this.scaleX;
        cb.scaleY = this.clipBox.getScaledHeight() / this.clipBox.height / this.scaleY;
        cb.left = -(cb.getScaledWidth() / 2);
        cb.top = -(cb.getScaledHeight() / 2);
      }
      this.set({
        clipPath: cb,
        width: clipBoxW / this.scaleX,
        height: clipBoxH / this.scaleY,
        left: this.clipBox.left,
        top: this.clipBox.top,
        dirty: true,
        _cropType: this._cropType
      });
      const radians = fabric.fabric.util.degreesToRadians(this.angle);
      const newGroupOrigin = fabric.fabric.util.rotatePoint(new fabric.fabric.Point(this.left, this.top), groupOrigin, -radians);
      const offsetX = newGroupOrigin.x + this.getScaledWidth() / 2 - centerX;
      const offsetY = newGroupOrigin.y + this.getScaledHeight() / 2 - centerY;
      this.item(0).left = this.item(0).left - offsetX / this.scaleX;
      this.item(0).top = this.item(0).top - offsetY / this.scaleY;
      this.setCoords();
      this.isClip = false;
      this.canvas.removeWithoutEmit(this.clipBox);
      this.canvas.renderAll();
    },
    __set: function(key, value) {
      if (key === "left" || key === "top") {
        const last = this[key];
        const offset = value - last;
        if (this.clipPath) {
          this.clipPath[key] = this.clipPath[key] + offset;
        }
        if (this.animation) {
          this.animation.to[key] = value;
        }
      } else if (key === "scaleX" || key === "scaleY") {
        if (this.clipPath) {
          this.clipPath[key] = value;
        }
      } else if (key === "angle") {
        this.rotate(value);
        if (this.clipPath) {
          this.clipPath[key] = value;
          this.clipPath.left = this.left;
          this.clipPath.top = this.top;
        }
        return;
      }
      this.set(key, value);
    },
    _doStretch(type) {
      const cvs = this.canvas;
      let toScale = cvs.width / this.width;
      if (type === stretchType.Cover) {
        if (this.height * toScale < cvs.height) {
          toScale = cvs.height / this.height;
        }
      } else if (type === stretchType.Contain) {
        if (this.height * toScale > cvs.height) {
          toScale = cvs.height / this.height;
        }
      }
      const sameScale = this.scaleX === toScale;
      this.set("angle", 0);
      this.set("scaleX", toScale);
      this.set("scaleY", toScale);
      const _left = (cvs.width - this.width * toScale) / 2;
      const sameLeft = this.left === _left;
      this.set("left", _left);
      const _top = (cvs.height - this.height * toScale) / 2;
      const sameTop = this.top === _top;
      this.set("top", _top);
      if (!sameScale || !sameLeft || !sameTop) {
        return true;
      }
      return false;
    }
  });
  fabric.fabric.CustomImage.fromURL = function(url, callback, options) {
    const customImageOption = options || {};
    fabric.fabric.Image.fromURL(url, (img) => {
      const customImage = new fabric.fabric.CustomImage([img], {
        objectCaching: false,
        lockScalingFlip: true,
        padding: 5,
        ...customImageOption
      });
      const scaleCenter = customImageOption.scaleCenter;
      if (customImageOption.initWidth) {
        if (scaleCenter) {
          customImage._setOriginToCenter();
        }
        customImage.scaleToWidth(customImageOption.initWidth);
        if (scaleCenter) {
          customImage._resetOrigin();
        }
      }
      if (customImageOption.initHeight) {
        if (scaleCenter) {
          customImage._setOriginToCenter();
        }
        customImage.scaleToWidth(customImageOption.initHeight);
        if (scaleCenter) {
          customImage._resetOrigin();
        }
      }
      callback && callback(customImage);
    }, {
      crossOrigin: "anonymous",
      objectCaching: false
    });
  };
  fabric.fabric.CustomImage.fromObject = function(object, callback) {
    const objects = object.objects;
    const options = fabric.fabric.util.object.clone(object, true);
    delete options.objects;
    if (typeof objects === "string") {
      fabric.fabric.loadSVGFromURL(objects, function(elements) {
        const group = fabric.fabric.util.groupSVGElements(elements, object, objects);
        const clipPath = options.clipPath;
        delete options.clipPath;
        group.set(options);
        if (clipPath) {
          fabric.fabric.util.enlivenObjects([clipPath], function(elivenedObjects) {
            group.clipPath = elivenedObjects[0];
            callback && callback(group);
          });
        } else {
          callback && callback(group);
        }
      });
      return;
    }
    fabric.fabric.util.enlivenObjects(objects, function(enlivenedObjects) {
      fabric.fabric.util.enlivenObjectEnlivables(object, options, function() {
        if (enlivenedObjects.length) {
          callback && callback(new fabric.fabric.CustomImage(enlivenedObjects, options, true));
        } else {
          callback && callback(null, true);
        }
      });
    });
  };
};
const initAvatarImage = () => {
  fabric.fabric.AvatarImage = fabric.fabric.util.createClass(fabric.fabric.Image, {
    type: "AvatarImage",
    initialize: function(element, options) {
      this.callSuper("initialize", element, options);
    },
    _renderFill: function(ctx) {
      const elementToDraw = this._element;
      if (!elementToDraw) {
        return;
      }
      const scaleX = this._filterScalingX;
      const scaleY = this._filterScalingY;
      const w = this.width;
      const h = this.height;
      const min2 = Math.min;
      const max2 = Math.max;
      const cropX = max2(this.cropX, 0);
      const cropY = max2(this.cropY, 0);
      const elWidth = elementToDraw.naturalWidth || elementToDraw.width;
      const elHeight = elementToDraw.naturalHeight || elementToDraw.height;
      const sX = cropX * scaleX;
      const sY = cropY * scaleY;
      const sW = min2(w * scaleX, elWidth - sX);
      const sH = min2(h * scaleY, elHeight - sY);
      const x = this.cropX < 0 ? -w / 2 - this.cropX : -w / 2;
      const y = this.cropY < 0 ? -h / 2 - this.cropY : -h / 2;
      const maxDestW = min2(w, elWidth / scaleX - cropX);
      const maxDestH = min2(h, elHeight / scaleY - cropY);
      elementToDraw && ctx.drawImage(elementToDraw, sX, sY, sW, sH, x, y, maxDestW, maxDestH);
    }
  });
  fabric.fabric.AvatarImage.fromURL = function(url, callback, imgOptions) {
    fabric.fabric.util.loadImage(url, function(img, isError) {
      callback && callback(new fabric.fabric.AvatarImage(img, imgOptions), isError);
    }, null, imgOptions && imgOptions.crossOrigin);
  };
  fabric.fabric.AvatarImage.fromObject = function(_object, callback) {
    const object = fabric.fabric.util.object.clone(_object);
    fabric.fabric.util.loadImage(object.src, function(img, isError) {
      if (isError) {
        callback && callback(null, true);
        return;
      }
      fabric.fabric.AvatarImage.prototype._initFilters.call(object, object.filters, function(filters) {
        object.filters = filters || [];
        fabric.fabric.AvatarImage.prototype._initFilters.call(object, [object.resizeFilter], function(resizeFilters) {
          object.resizeFilter = resizeFilters[0];
          fabric.fabric.util.enlivenObjectEnlivables(object, object, function() {
            const image = new fabric.fabric.AvatarImage(img, object);
            callback(image, false);
          });
        });
      });
    }, null, object.crossOrigin);
  };
};
const AVATAR_VERSION = "2.0.0";
const TALKING_PHOTO = "Talking Photo";
const AVATAR_PRO = "Avatar Pro";
const AVATAR_LITE = "Avatar Lite";
const CUSTOM_AVATAR_PRO = "Custom Avatar Pro";
const CUSTOM_AVATAR_LITE = "Custom Avatar Lite";
const AVATAR_TYPES = {
  1: TALKING_PHOTO,
  2: AVATAR_PRO,
  3: AVATAR_LITE,
  4: CUSTOM_AVATAR_PRO,
  5: CUSTOM_AVATAR_LITE
};
const reconfigure = (config2, imgWidth, imgHeight) => {
  let maxOver = 0;
  if (config2.x < 0) {
    maxOver = Math.max(Math.abs(config2.x), maxOver);
  }
  if (config2.y < 0) {
    maxOver = Math.max(Math.abs(config2.y), maxOver);
  }
  let x = config2.x + maxOver;
  const y = config2.y + maxOver;
  let width = config2.width - 2 * maxOver;
  let height = config2.height - 2 * maxOver;
  if (imgWidth - x - width < 0 || imgHeight - y - height < 0) {
    height = imgHeight - y < imgWidth - x ? imgHeight - y : imgWidth - x;
    x = x + (width - height) / 2;
    width = height;
  }
  return { x, y, width, height };
};
const getMajorVersion = (version) => {
  if (version == null) {
    return "0";
  }
  const versionNumberList = version.split(".");
  if (versionNumberList.length < 3) {
    return "0";
  }
  return versionNumberList[0];
};
const initAvatar = () => {
  fabric.fabric.Avatar = fabric.fabric.util.createClass(fabric.fabric.CustomImage, {
    type: "Avatar",
    initialize: function(objects, options, isAlreadyGrouped) {
      this.strokeUniform = true;
      this.noScaleCache = false;
      this.callSuper("initialize", objects, options, isAlreadyGrouped);
    },
    _set: function(key, value) {
      this.callSuper("_set", key, value);
      const customAttributes = ["left", "top", "angle", "scaleX", "scaleY"];
      if (customAttributes.includes(key)) {
        switch (key) {
          case "left": {
            switch (this._avatarType) {
              case "voice":
                this.voiceLeft = value;
                break;
              default:
                this._left = value;
                break;
            }
            break;
          }
          case "top": {
            switch (this._avatarType) {
              case "voice":
                this.voiceTop = value;
                break;
              default:
                this._top = value;
                break;
            }
            break;
          }
          case "angle": {
            switch (this._avatarType) {
              case "circle":
                this.circleAngle = value;
                break;
              case "square":
                this.squareAngle = value;
                break;
              case "halfbody":
                this.halfbodyAngle = value;
                break;
              case "voice":
                this.voiceAngle = value;
                break;
            }
            break;
          }
          case "scaleX": {
            switch (this._avatarType) {
              case "circle":
                this.circleScaleX = value;
                break;
              case "square":
                this.squareScaleX = value;
                break;
              case "halfbody":
                this.halfbodyScaleX = value;
                break;
              case "voice":
                this.voiceScaleX = value;
                break;
            }
            break;
          }
          case "scaleY": {
            switch (this._avatarType) {
              case "circle":
                this.circleScaleY = value;
                break;
              case "square":
                this.squareScaleY = value;
                break;
              case "halfbody":
                this.halfbodyScaleY = value;
                break;
              case "voice":
                this.voiceScaleY = value;
                break;
            }
            break;
          }
        }
      }
    },
    toObject: function(propertiesToInclude) {
      const tmpPropertiesToInclude = propertiesToInclude || [];
      return this.callSuper("toObject", [
        "imgWidth",
        "imgHeight",
        "initWidth",
        "initHeight",
        "circleAngle",
        "circleScaleX",
        "circleScaleY",
        "circleStroke",
        "circleStrokeWidth",
        "circleStrokeDashArray",
        "squareAngle",
        "squareScaleX",
        "squareScaleY",
        "squareStroke",
        "squareStrokeWidth",
        "squareStrokeDashArray",
        "halfbodyAngle",
        "halfbodyScaleX",
        "halfbodyScaleY",
        "halfbodyStroke",
        "halfbodyStrokeWidth",
        "halfbodyStrokeDashArray",
        "voiceLeft",
        "voiceTop",
        "voiceAngle",
        "voiceScaleX",
        "voiceScaleY",
        "_left",
        "_top",
        "_avatarType",
        "_avatarBg",
        "_avatarSquareBg",
        "_avatarHalfBodyBg",
        "_transparent_halfbody",
        "_transparent_square",
        "_transparent_circle",
        "_avatarInfo",
        "_version",
        "_cropClipPath",
        "_imageCropLeft",
        "_imageCropTop",
        "_cropWidth",
        "_cropHeight",
        ...tmpPropertiesToInclude
      ]);
    },
    render: function(ctx) {
      let strokeWidth = 0;
      switch (this._avatarType) {
        case "circle": {
          switch (this.getAvatarType()) {
            case TALKING_PHOTO:
            case AVATAR_PRO:
              strokeWidth = this.circleStrokeWidth || 0;
              break;
            case CUSTOM_AVATAR_PRO:
              if (this._avatarInfo.show_back == null || this._avatarInfo.show_back === 2) {
                strokeWidth = this.circleStrokeWidth || 0;
              }
              break;
          }
          this.strokeWidth = strokeWidth * 2;
          break;
        }
        case "square": {
          switch (this.getAvatarType()) {
            case TALKING_PHOTO:
            case AVATAR_PRO:
              strokeWidth = this.squareStrokeWidth || 0;
              break;
            case CUSTOM_AVATAR_PRO:
              if (this._avatarInfo.show_back == null || this._avatarInfo.show_back === 2) {
                strokeWidth = this.squareStrokeWidth || 0;
              }
              break;
          }
          this.strokeWidth = strokeWidth * 2;
          break;
        }
        case "halfbody": {
          switch (this.getAvatarType()) {
            case TALKING_PHOTO:
              strokeWidth = this.halfbodyStrokeWidth || 0;
              break;
          }
          this.strokeWidth = strokeWidth * 2;
          break;
        }
        default:
          this.strokeWidth = 0;
          break;
      }
      this.callSuper("render", ctx);
    },
    /**
     * Execute the drawing operation for an object on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawObject: function(ctx) {
      switch (this._avatarType) {
        case "circle":
        case "square":
          this._objects[1].render(ctx);
          this._objects[0].render(ctx);
          break;
        case "halfbody":
          if (this._avatarHalfBodyBg) {
            this._objects[1].render(ctx);
          }
          this._objects[0].render(ctx);
          break;
        case "voice":
          this._objects[2].render(ctx);
          break;
        default:
          this._objects[0].render(ctx);
          break;
      }
      this._drawClipPath(ctx, this.clipPath);
      this._renderStroke(ctx);
    },
    /**
     * @private
     * Sets line dash
     * @param {CanvasRenderingContext2D} ctx Context to set the dash line on
     * @param {Array} dashArray array representing dashes
     */
    _setLineDash: function(ctx, dashArray) {
      if (!dashArray || dashArray.length === 0) {
        return;
      }
      if (1 & dashArray.length) {
        dashArray.push.apply(dashArray, dashArray);
      }
      ctx.setLineDash(dashArray);
    },
    _setStrokeStyles: function(ctx, decl) {
      const stroke = decl.stroke;
      if (stroke) {
        ctx.lineWidth = decl.strokeWidth;
        ctx.lineCap = decl.strokeLineCap;
        ctx.lineDashOffset = decl.strokeDashOffset;
        ctx.lineJoin = decl.strokeLineJoin;
        ctx.miterLimit = decl.strokeMiterLimit;
        if (stroke.toLive) {
          if (stroke.gradientUnits === "percentage" || stroke.gradientTransform || stroke.patternTransform) {
            this._applyPatternForTransformedGradient(ctx, stroke);
          } else {
            ctx.strokeStyle = stroke.toLive(ctx, this);
            this._applyPatternGradientTransform(ctx, stroke);
          }
        } else {
          ctx.strokeStyle = decl.stroke;
        }
      }
    },
    _renderStroke: function(ctx) {
      let strokeWidth = 0;
      let stroke;
      let strokeDashArray;
      switch (this._avatarType) {
        case "circle": {
          switch (this.getAvatarType()) {
            case TALKING_PHOTO:
            case AVATAR_PRO:
              strokeWidth = this.circleStrokeWidth || 0;
              stroke = this.circleStroke;
              strokeDashArray = this.circleStrokeDashArray;
              break;
            case CUSTOM_AVATAR_PRO:
              if (this._avatarInfo.show_back == null || this._avatarInfo.show_back === 2) {
                strokeWidth = this.circleStrokeWidth || 0;
                stroke = this.circleStroke;
                strokeDashArray = this.circleStrokeDashArray;
              }
              break;
          }
          if (strokeWidth) {
            ctx.save();
            let width = this.width;
            let height = this.height;
            if (this.strokeUniform) {
              const scaling = this.getObjectScaling();
              ctx.scale(1 / scaling.scaleX, 1 / scaling.scaleY);
              width = width * scaling.scaleX + strokeWidth;
              height = height * scaling.scaleY + strokeWidth;
            }
            this._setLineDash(ctx, strokeDashArray);
            this._setStrokeStyles(ctx, { strokeWidth, stroke });
            const radius = Math.max(width, height) / 2;
            ctx.beginPath();
            ctx.arc(0, 0, radius, 0, 2 * Math.PI);
            ctx.stroke();
            ctx.restore();
          }
          break;
        }
        case "square": {
          switch (this.getAvatarType()) {
            case TALKING_PHOTO:
            case AVATAR_PRO:
              strokeWidth = this.squareStrokeWidth || 0;
              stroke = this.squareStroke;
              strokeDashArray = this.squareStrokeDashArray;
              break;
            case CUSTOM_AVATAR_PRO:
              if (this._avatarInfo.show_back == null || this._avatarInfo.show_back === 2) {
                strokeWidth = this.squareStrokeWidth || 0;
                stroke = this.squareStroke;
                strokeDashArray = this.squareStrokeDashArray;
              }
              break;
          }
          if (strokeWidth) {
            ctx.save();
            let width = this.width;
            let height = this.height;
            if (this.strokeUniform) {
              const scaling = this.getObjectScaling();
              ctx.scale(1 / scaling.scaleX, 1 / scaling.scaleY);
              width = width * scaling.scaleX + strokeWidth;
              height = height * scaling.scaleY + strokeWidth;
            }
            this._setLineDash(ctx, strokeDashArray);
            this._setStrokeStyles(ctx, { strokeWidth, stroke });
            ctx.beginPath();
            ctx.rect(-width / 2, -height / 2, width, height);
            ctx.stroke();
            ctx.restore();
          }
          break;
        }
        case "halfbody": {
          switch (this.getAvatarType()) {
            case TALKING_PHOTO:
              strokeWidth = this.halfbodyStrokeWidth || 0;
              stroke = this.halfbodyStroke;
              strokeDashArray = this.halfbodyStrokeDashArray;
              break;
          }
          if (strokeWidth) {
            ctx.save();
            let width = this.width;
            let height = this.height;
            if (this.strokeUniform) {
              const scaling = this.getObjectScaling();
              ctx.scale(1 / scaling.scaleX, 1 / scaling.scaleY);
              width = width * scaling.scaleX + strokeWidth;
              height = height * scaling.scaleY + strokeWidth;
            }
            this._setLineDash(ctx, strokeDashArray);
            this._setStrokeStyles(ctx, { strokeWidth, stroke });
            ctx.beginPath();
            ctx.rect(-width / 2, -height / 2, width, height);
            ctx.stroke();
            ctx.restore();
          }
          break;
        }
      }
    },
    circleAvatar: function() {
      let config2 = this._avatarInfo.config;
      if (this._avatarInfo.type === 1) {
        config2 = reconfigure(this._avatarInfo.config, this.imgWidth, this.imgHeight);
      }
      const circleDiameter = this.initWidth || this.initHeight || 400;
      if (this._left == null) {
        this._left = this.left || 0;
      }
      if (this._top == null) {
        this._top = this.top || 0;
      }
      if (this.circleScaleX == null) {
        this.circleScaleX = circleDiameter / Math.min(config2.width, config2.height);
      }
      if (this.circleScaleY == null) {
        this.circleScaleY = circleDiameter / Math.min(config2.width, config2.height);
      }
      if (this.circleAngle == null) {
        this.circleAngle = 0;
      }
      this._objects[0].set({
        cropX: config2.x,
        cropY: config2.y,
        width: config2.width,
        height: config2.height,
        left: -config2.width / 2,
        top: -config2.height / 2,
        backgroundColor: ""
      });
      const radius = Math.min(config2.width, config2.height) / 2;
      const circle = new fabric.fabric.Circle({
        radius,
        fill: this._avatarBg,
        left: -radius,
        top: -radius,
        objectCaching: false
      });
      this._objects[1] = circle;
      this.set("clipPath", this._objects[1]);
      this.set("width", Math.min(config2.width, config2.height));
      this.set("height", Math.min(config2.width, config2.height));
      this.set("left", this._left);
      this.set("top", this._top);
      this.set("scaleX", this.circleScaleX);
      this.set("scaleY", this.circleScaleY);
      this.set("angle", this.circleAngle);
    },
    squareAvatar: function() {
      let config2 = this._avatarInfo.config;
      if (this._avatarInfo.type === 1) {
        config2 = reconfigure(this._avatarInfo.config, this.imgWidth, this.imgHeight);
      }
      const sideLength = this.initWidth || this.initHeight || 400;
      if (this._left == null) {
        this._left = this.left || 0;
      }
      if (this._top == null) {
        this._top = this.top || 0;
      }
      if (this.squareScaleX == null) {
        this.squareScaleX = sideLength / Math.min(config2.width, config2.height);
      }
      if (this.squareScaleY == null) {
        this.squareScaleY = sideLength / Math.min(config2.width, config2.height);
      }
      if (this.squareAngle == null) {
        this.squareAngle = 0;
      }
      this._objects[0].set({
        cropX: config2.x,
        cropY: config2.y,
        width: config2.width,
        height: config2.height,
        left: -config2.width / 2,
        top: -config2.height / 2,
        backgroundColor: ""
      });
      const square = new fabric.fabric.Rect({
        width: config2.width,
        height: config2.height,
        fill: this._avatarSquareBg,
        left: -config2.width / 2,
        top: -config2.height / 2,
        objectCaching: false
      });
      this._objects[1] = square;
      this.set("clipPath", this._objects[1]);
      this.set("width", Math.min(config2.width, config2.height));
      this.set("height", Math.min(config2.width, config2.height));
      this.set("left", this._left);
      this.set("top", this._top);
      this.set("scaleX", this.squareScaleX);
      this.set("scaleY", this.squareScaleY);
      this.set("angle", this.squareAngle);
    },
    halfbodyAvatar: function() {
      if (this._left == null) {
        this._left = this.left || 0;
      }
      if (this._top == null) {
        this._top = this.top || 0;
      }
      if (this.halfbodyScaleX == null || this.halfbodyScaleY == null) {
        const initWidth = this.initWidth || 0;
        const initHeight = this.initHeight || 0;
        if (initWidth > initHeight) {
          this.halfbodyScaleX = initWidth / this.imgWidth;
          this.halfbodyScaleY = this.halfbodyScaleX;
        } else {
          this.halfbodyScaleY = initHeight / this.imgHeight;
          this.halfbodyScaleX = this.halfbodyScaleY;
        }
      }
      if (this.halfbodyAngle == null) {
        this.halfbodyAngle = 0;
      }
      this._objects[0].set({
        cropX: 0,
        cropY: 0,
        width: this.imgWidth,
        height: this.imgHeight,
        left: this._imageCropLeft != null ? this._imageCropLeft : -this.imgWidth / 2,
        top: this._imageCropTop != null ? this._imageCropTop : -this.imgHeight / 2,
        backgroundColor: ""
      });
      const react = new fabric.fabric.Rect({
        width: this.imgWidth,
        height: this.imgHeight,
        fill: this._avatarHalfBodyBg,
        left: -this.imgWidth / 2,
        top: -this.imgHeight / 2,
        objectCaching: false
      });
      this._objects[1] = react;
      this.set("clipPath", this._cropClipPath ? this._cropClipPath : null);
      this.set("width", this._cropWidth != null ? this._cropWidth : this.imgWidth);
      this.set("height", this._cropHeight != null ? this._cropHeight : this.imgHeight);
      this.set("left", this._left);
      this.set("top", this._top);
      this.set("scaleX", this.halfbodyScaleX);
      this.set("scaleY", this.halfbodyScaleY);
      this.set("angle", this.halfbodyAngle);
    },
    voice: function() {
      const voiceSideLength = this.initVoiceSideLength || 400;
      if (this.voiceLeft == null) {
        this.voiceLeft = this.canvas.width - voiceSideLength - 30;
      }
      if (this.voiceTop == null) {
        this.voiceTop = this.canvas.height - voiceSideLength - 30;
      }
      if (this.voiceScaleX == null) {
        this.voiceScaleX = voiceSideLength / this._objects[2].width;
      }
      if (this.voiceScaleY == null) {
        this.voiceScaleY = voiceSideLength / this._objects[2].width;
      }
      if (this.voiceAngle == null) {
        this.voiceAngle = 0;
      }
      this._objects[2].set({
        left: -this._objects[2].width / 2,
        top: -this._objects[2].height / 2
      });
      this.set("clipPath", null);
      this.set("width", this._objects[2].width);
      this.set("height", this._objects[2].height);
      this.set("left", this.voiceLeft);
      this.set("top", this.voiceTop);
      this.set("scaleX", this.voiceScaleX);
      this.set("scaleY", this.voiceScaleY);
      this.set("angle", this.voiceAngle);
    },
    changeType: async function(type) {
      const lastType = this._avatarType;
      switch (lastType) {
        case "circle":
          this.circleAngle = this.angle;
          break;
        case "square":
          this.squareAngle = this.angle;
          break;
        case "halfbody":
          this.halfbodyAngle = this.angle;
          break;
        case "voice":
          this.voiceAngle = this.angle;
          break;
      }
      this._avatarType = type;
      const isChangeImage = this[`_transparent_${lastType}`] !== this[`_transparent_${type}`];
      switch (this._avatarType) {
        case "circle":
          if (lastType === "voice" && (this._top == null || this._left == null)) {
            const initSideLength = this.initWidth || this.initHeight || 400;
            this._left = (this.canvas.width - initSideLength) / 2;
            this._top = (this.canvas.height - initSideLength) / 2;
          }
          if (this._avatarInfo.type === 1 && this.changeImage && isChangeImage) {
            await this.changeImage(this[`_transparent_${type}`] ? "transparent" : "normal");
          }
          if (this._avatarInfo.type === 2) {
            this[`_transparent_${this._avatarType}`] = true;
          }
          this.circleAvatar();
          break;
        case "square":
          if (lastType === "voice" && (this._top == null || this._left == null)) {
            const initSideLength = this.initWidth || this.initHeight || 400;
            this._left = (this.canvas.width - initSideLength) / 2;
            this._top = (this.canvas.height - initSideLength) / 2;
          }
          if (this._avatarInfo.type === 1 && this.changeImage && isChangeImage) {
            await this.changeImage(this[`_transparent_${type}`] ? "transparent" : "normal");
          }
          if (this._avatarInfo.type === 2) {
            this[`_transparent_${this._avatarType}`] = true;
          }
          this.squareAvatar();
          break;
        case "halfbody":
          if (lastType === "voice" && (this._left == null || this._top == null)) {
            let tempScaleX = 0;
            let tempScaleY = 0;
            const initWidth = this.initWidth || 0;
            const initHeight = this.initHeight || 0;
            if (initWidth > initHeight) {
              tempScaleX = initWidth / this.imgWidth;
              tempScaleY = tempScaleX;
            } else {
              tempScaleY = initHeight / this.imgHeight;
              tempScaleX = tempScaleY;
            }
            const tempWidth = tempScaleX * this.imgWidth;
            const tempHeight = tempScaleY * this.imgHeight;
            this._left = (this.canvas.width - tempWidth) / 2;
            this._top = (this.canvas.height - tempHeight) / 2;
          }
          if (this._avatarInfo.type === 1 && this.changeImage && isChangeImage) {
            await this.changeImage(this[`_transparent_${type}`] ? "transparent" : "normal");
          }
          this.halfbodyAvatar();
          break;
        case "voice":
          this.voice();
          break;
        default:
          this.halfbodyAvatar();
          break;
      }
      this.dirty = true;
      this.setCoords();
      this.canvas && this.canvas.renderAll();
    },
    initScale: function(lastAvatarInfo, avatarInfo, imgWidth, imgHeight, isInitCrop = true) {
      let config2 = avatarInfo.config;
      if (avatarInfo.type === 1) {
        config2 = reconfigure(avatarInfo.config, imgWidth, imgHeight);
      }
      const currentHeight = this.height * this.scaleY;
      switch (this._avatarType) {
        case "circle":
          this.circleScaleY = currentHeight / Math.min(config2.width, config2.height);
          this.circleScaleX = this.circleScaleY;
          if (isInitCrop) {
            this._cropClipPath = null;
            this._imageCropLeft = null;
            this._imageCropTop = null;
            this._cropWidth = null;
            this._cropHeight = null;
          }
          if (this.halfbodyScaleY != null) {
            this.halfbodyScaleY = this.halfbodyScaleY * this.imgHeight / imgHeight;
          }
          if (this.halfbodyScaleX != null) {
            this.halfbodyScaleX = this.halfbodyScaleY;
          }
          if (this.squareScaleY != null) {
            this.squareScaleY = this.squareScaleY * Math.min(lastAvatarInfo.config.width, lastAvatarInfo.config.height) / Math.min(avatarInfo.config.width, avatarInfo.config.height);
          }
          if (this.squareScaleX != null) {
            this.squareScaleX = this.squareScaleY;
          }
          break;
        case "square":
          this.squareScaleY = currentHeight / Math.min(config2.width, config2.height);
          this.squareScaleX = this.squareScaleY;
          if (isInitCrop) {
            this._cropClipPath = null;
            this._imageCropLeft = null;
            this._imageCropTop = null;
            this._cropWidth = null;
            this._cropHeight = null;
          }
          if (this.halfbodyScaleY != null) {
            this.halfbodyScaleY = this.halfbodyScaleY * this.imgHeight / imgHeight;
          }
          if (this.halfbodyScaleX != null) {
            this.halfbodyScaleX = this.halfbodyScaleY;
          }
          if (this.circleScaleY != null) {
            this.circleScaleY = this.circleScaleY * Math.min(lastAvatarInfo.config.width, lastAvatarInfo.config.height) / Math.min(avatarInfo.config.width, avatarInfo.config.height);
          }
          if (this.circleScaleX != null) {
            this.circleScaleX = this.circleScaleY;
          }
          break;
        case "halfbody":
          this.halfbodyScaleY = this.scaleY * this.imgHeight / imgHeight;
          this.halfbodyScaleX = this.halfbodyScaleY;
          if (isInitCrop) {
            this._cropClipPath = null;
            this._imageCropLeft = null;
            this._imageCropTop = null;
            this._cropWidth = null;
            this._cropHeight = null;
          } else {
            if (this._cropClipPath) {
              this._cropWidth = this._cropWidth / (this.imgWidth / imgWidth);
              this._cropHeight = this._cropHeight / (this.imgHeight / imgHeight);
              this._imageCropLeft = this._imageCropLeft / (this.imgWidth / imgWidth);
              this._imageCropTop = this._imageCropTop / (this.imgHeight / imgHeight);
              this._cropClipPath.left = this._cropClipPath.left / (this.imgWidth / imgWidth);
              this._cropClipPath.top = this._cropClipPath.top / (this.imgHeight / imgHeight);
              this._cropClipPath.scaleX = this._cropClipPath.scaleX / (this.imgWidth / imgWidth);
              this._cropClipPath.scaleY = this._cropClipPath.scaleY / (this.imgHeight / imgHeight);
            }
          }
          if (this.circleScaleY != null) {
            this.circleScaleY = this.circleScaleY * Math.min(lastAvatarInfo.config.width, lastAvatarInfo.config.height) / Math.min(avatarInfo.config.width, avatarInfo.config.height);
          }
          if (this.circleScaleX != null) {
            this.circleScaleX = this.circleScaleY;
          }
          if (this.squareScaleY != null) {
            this.squareScaleY = this.squareScaleY * Math.min(lastAvatarInfo.config.width, lastAvatarInfo.config.height) / Math.min(avatarInfo.config.width, avatarInfo.config.height);
          }
          if (this.squareScaleX != null) {
            this.squareScaleX = this.squareScaleY;
          }
          break;
        case "voice":
          if (isInitCrop) {
            this._cropClipPath = null;
            this._imageCropLeft = null;
            this._imageCropTop = null;
            this._cropWidth = null;
            this._cropHeight = null;
          }
          if (this.halfbodyScaleY != null) {
            this.halfbodyScaleY = this.halfbodyScaleY * this.imgHeight / imgHeight;
          }
          if (this.halfbodyScaleX != null) {
            this.halfbodyScaleX = this.halfbodyScaleY;
          }
          if (this.circleScaleY != null) {
            this.circleScaleY = this.circleScaleY * Math.min(lastAvatarInfo.config.width, lastAvatarInfo.config.height) / Math.min(avatarInfo.config.width, avatarInfo.config.height);
          }
          if (this.circleScaleX != null) {
            this.circleScaleX = this.circleScaleY;
          }
          if (this.squareScaleY != null) {
            this.squareScaleY = this.squareScaleY * Math.min(lastAvatarInfo.config.width, lastAvatarInfo.config.height) / Math.min(avatarInfo.config.width, avatarInfo.config.height);
          }
          if (this.squareScaleX != null) {
            this.squareScaleX = this.squareScaleY;
          }
          break;
      }
    },
    replace: async function(src, avatarInfo = null, newAvatarType = null, isInitCrop = true) {
      const promise = new Promise((resolve, reject) => {
        switch (this._avatarType) {
          case "circle":
            this.circleAngle = this.angle;
            break;
          case "square":
            this.squareAngle = this.angle;
            break;
          case "halfbody":
            this.halfbodyAngle = this.angle;
            break;
          case "voice":
            this.voiceAngle = this.angle;
            break;
        }
        this._objects[0].setSrc(src, (replaceImage, isError) => {
          try {
            if (isError) {
              resolve(false);
            }
            if (avatarInfo) {
              if (avatarInfo.type === 2) {
                if (this._avatarType === "circle" || this._avatarType === "square") {
                  this[`_transparent_${this._avatarType}`] = true;
                }
              }
              if (this.getAvatarType() !== TALKING_PHOTO && this.getAvatarType(avatarInfo.type) === TALKING_PHOTO) {
                this[`_transparent_${this._avatarType}`] = avatarInfo.show_back === 2;
              }
              this.initScale(this._avatarInfo, avatarInfo, replaceImage.width, replaceImage.height, isInitCrop);
              this.set("_avatarInfo", avatarInfo);
            }
            this._objects[1].set({
              radius: Math.min(this._avatarInfo.config.width, this._avatarInfo.config.height) / 2
            });
            this.imgWidth = replaceImage.width;
            this.imgHeight = replaceImage.height;
            this._objects[0] = replaceImage;
            this.dirty = true;
            if (newAvatarType) {
              this._avatarType = newAvatarType;
            }
            switch (this._avatarType) {
              case "circle":
                this.circleAvatar();
                break;
              case "square":
                this.squareAvatar();
                break;
              case "halfbody":
                this.halfbodyAvatar();
                break;
              case "voice":
                this.voice();
                break;
              default:
                this.halfbodyAvatar();
                break;
            }
            this.setCoords();
            this.canvas && this.canvas.renderAll();
            resolve(true);
          } catch (error) {
            reject(error);
          }
        }, {
          crossOrigin: "anonymous"
        });
      });
      return await promise;
    },
    setAttributes: function(key, value) {
      const titleCase = (word) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      };
      const customAttribute = ["scaleX", "scaleY", "angle"];
      switch (this._avatarType) {
        case "circle":
          if (customAttribute.includes(key)) {
            this[`circle${titleCase(key)}`] = value;
          }
          break;
        case "square":
          if (customAttribute.includes(key)) {
            this[`square${titleCase(key)}`] = value;
          }
          break;
        case "halfbody":
          if (customAttribute.includes(key)) {
            this[`halfbody${titleCase(key)}`] = value;
          }
          break;
        case "voice":
          if (customAttribute.includes(key)) {
            this[`voice${titleCase(key)}`] = value;
          }
          break;
      }
      if (["left", "top"].includes(key)) {
        this[`_${key}`] = value;
      }
      this.set(key, value);
    },
    setBackgroudColor: async function(color) {
      switch (this._avatarType) {
        case "circle":
          if (this._avatarInfo.type === 1 && !this[`_transparent_${this._avatarType}`]) {
            this[`_transparent_${this._avatarType}`] = true;
            if (this.changeImage) {
              await this.changeImage("transparent");
            }
          }
          this._avatarBg = color;
          this.circleAvatar();
          break;
        case "square":
          if (this._avatarInfo.type === 1 && !this[`_transparent_${this._avatarType}`]) {
            this[`_transparent_${this._avatarType}`] = true;
            if (this.changeImage) {
              await this.changeImage("transparent");
            }
          }
          this._avatarSquareBg = color;
          this.squareAvatar();
          break;
        case "halfbody":
          if (this._avatarInfo.type === 1 && !this[`_transparent_${this._avatarType}`]) {
            this[`_transparent_${this._avatarType}`] = true;
            if (this.changeImage) {
              await this.changeImage("transparent");
            }
          }
          this._avatarHalfBodyBg = color;
          this.halfbodyAvatar();
          break;
      }
      this.dirty = true;
      this.setCoords();
      this.canvas && this.canvas.renderAll();
    },
    getBackgroudColor: function() {
      switch (this._avatarType) {
        case "circle":
          return this._avatarBg;
        case "square":
          return this._avatarSquareBg;
        case "halfbody":
          return this._avatarHalfBodyBg;
        default:
          return null;
      }
    },
    restore: async function() {
      if (this[`_transparent_${this._avatarType}`]) {
        this[`_transparent_${this._avatarType}`] = false;
        if (this.changeImage) {
          await this.changeImage("normal");
        }
        switch (this._avatarType) {
          case "circle":
            this._avatarBg = "#efefff";
            this.circleAvatar();
            break;
          case "square":
            this._avatarSquareBg = "rgba(0, 0, 0, 0)";
            this.squareAvatar();
            break;
          case "halfbody":
            this._avatarHalfBodyBg = "rgba(0, 0, 0, 0)";
            this.halfbodyAvatar();
            break;
        }
        this.dirty = true;
        this.setCoords();
        this.canvas && this.canvas.renderAll();
      }
    },
    setStroke: function(params) {
      const { stroke, strokeWidth, strokeDashArray } = params;
      switch (this._avatarType) {
        case "circle":
          this.circleStroke = stroke || this.circleStroke;
          this.circleStrokeWidth = strokeWidth == null ? this.circleStrokeWidth : strokeWidth;
          this.circleStrokeDashArray = strokeDashArray === void 0 ? this.circleStrokeDashArray : strokeDashArray;
          break;
        case "square":
          this.squareStroke = stroke || this.squareStroke;
          this.squareStrokeWidth = strokeWidth == null ? this.squareStrokeWidth : strokeWidth;
          this.squareStrokeDashArray = strokeDashArray === void 0 ? this.squareStrokeDashArray : strokeDashArray;
          break;
        case "halfbody":
          this.halfbodyStroke = stroke || this.halfbodyStroke;
          this.halfbodyStrokeWidth = strokeWidth == null ? this.halfbodyStrokeWidth : strokeWidth;
          this.halfbodyStrokeDashArray = strokeDashArray === void 0 ? this.halfbodyStrokeDashArray : strokeDashArray;
          break;
      }
      this.dirty = true;
      this.setCoords();
      this.canvas && this.canvas.renderAll();
    },
    getStroke: function() {
      switch (this._avatarType) {
        case "circle":
          return {
            stroke: this.circleStroke,
            strokeWidth: this.circleStrokeWidth || 0,
            strokeDashArray: this.circleStrokeDashArray
          };
        case "square":
          return {
            stroke: this.squareStroke,
            strokeWidth: this.squareStrokeWidth || 0,
            strokeDashArray: this.squareStrokeDashArray
          };
        case "halfbody":
          return {
            stroke: this.halfbodyStroke,
            strokeWidth: this.halfbodyStrokeWidth || 0,
            strokeDashArray: this.halfbodyStrokeDashArray
          };
        default:
          return null;
      }
    },
    getAvatarType: function(type) {
      if (type) {
        return AVATAR_TYPES[type];
      }
      return AVATAR_TYPES[this._avatarInfo.type];
    },
    isAvatarType: function(type) {
      return this.getAvatarType() === type;
    },
    doCrop: async function(type = cropType.RECT) {
      if (this._avatarType !== "halfbody") {
        await this.changeType("halfbody");
      }
      await this.callSuper("doCrop", type);
    },
    doneCrop: async function() {
      await this.callSuper("doneCrop");
      this._cropClipPath = this.clipPath;
      this._imageCropLeft = this._objects[0].left;
      this._imageCropTop = this._objects[0].top;
      this._cropWidth = this.width;
      this._cropHeight = this.height;
      this._left = this.left;
      this._top = this.top;
    }
  });
  fabric.fabric.Avatar.fromURL = function(url, callback, options) {
    const avatarOption = options || {};
    if (avatarOption._transparent_halfbody == null) avatarOption._transparent_halfbody = false;
    if (avatarOption._transparent_square == null) avatarOption._transparent_square = true;
    if (avatarOption._transparent_circle == null) avatarOption._transparent_circle = true;
    let shape = null;
    if (avatarOption._avatarType === "square") {
      shape = new fabric.fabric.Rect({
        width: avatarOption._avatarInfo.config.width,
        height: avatarOption._avatarInfo.config.height,
        fill: avatarOption._avatarSquareBg,
        objectCaching: false
      });
    } else if (avatarOption._avatarType === "halfbody") {
      shape = new fabric.fabric.Rect({
        width: 0,
        height: 0,
        fill: avatarOption._avatarHalfBodyBg,
        objectCaching: false
      });
    } else {
      shape = new fabric.fabric.Circle({
        radius: Math.min(avatarOption._avatarInfo.config.width, avatarOption._avatarInfo.config.height) / 2,
        fill: avatarOption._avatarBg,
        objectCaching: false
      });
    }
    fabric.fabric.AvatarImage.fromURL(url, (img, isError) => {
      fabric.fabric.Image.fromURL("https://s3.amazonaws.com/video-api-ai/system/app/static/img/avatar_placeholder.png", (voiceImg) => {
        const avatar = new fabric.fabric.Avatar([img, shape, voiceImg], {
          imgWidth: img.width,
          imgHeight: img.height,
          left: 0,
          top: 0,
          objectCaching: false,
          _version: AVATAR_VERSION,
          ...avatarOption
        });
        if (avatarOption.initWidth) {
          avatar.scaleToWidth(avatarOption.initWidth);
        }
        if (avatarOption.initHeight) {
          avatar.scaleToHeight(avatarOption.initHeight);
        }
        avatarOption._avatarType && avatar.changeType(avatarOption._avatarType);
        if (isError) {
          throw new Error("AvatarImage load error, key: " + avatarOption._avatarInfo.key);
        }
        callback && callback(avatar);
      }, {
        objectCaching: false,
        crossOrigin: "anonymous"
      });
    }, {
      objectCaching: false,
      crossOrigin: "anonymous"
    });
  };
  fabric.fabric.Avatar.fromObject = function(object, callback) {
    var _a;
    const objects = object.objects;
    const options = fabric.fabric.util.object.clone(object, true);
    delete options.objects;
    switch (getMajorVersion(options._version)) {
      case "2":
        if (options._cropClipPath) {
          fabric.fabric.util.enlivenObjects([options._cropClipPath], function(elivenedObjects) {
            options._cropClipPath = elivenedObjects[0];
          });
        }
        break;
      case "1": {
        options._version = AVATAR_VERSION;
        objects[0].originX = "left";
        objects[0].originY = "top";
        objects[0].left = -objects[0].width / 2;
        objects[0].top = -objects[0].height / 2;
        objects[1].originX = "left";
        objects[1].originY = "top";
        objects[1].left = -objects[1].width / 2;
        objects[1].top = -objects[1].height / 2;
        if (objects.length > 2) {
          objects[2].originX = "left";
          objects[2].originY = "top";
          objects[2].left = -objects[2].width / 2;
          objects[2].top = -objects[2].height / 2;
        }
        break;
      }
      default: {
        options._avatarSquareBg = objects[1].fill;
        options._avatarBg = objects[1].fill;
        options._version = AVATAR_VERSION;
        objects[0].originX = "left";
        objects[0].originY = "top";
        objects[0].left = -objects[0].width / 2;
        objects[0].top = -objects[0].height / 2;
        objects[1].originX = "left";
        objects[1].originY = "top";
        objects[1].left = -objects[1].width / 2;
        objects[1].top = -objects[1].height / 2;
        if (objects.length > 2) {
          objects[2].originX = "left";
          objects[2].originY = "top";
          objects[2].left = -objects[2].width / 2;
          objects[2].top = -objects[2].height / 2;
        }
      }
    }
    if (options._transparent_halfbody == null || options._transparent_square == null || options._transparent_circle == null) {
      if (((_a = options == null ? void 0 : options._avatarInfo) == null ? void 0 : _a.show_back) === 2) {
        options._transparent_halfbody = options._transparent_halfbody == null ? true : options._transparent_halfbody;
        options._transparent_square = options._transparent_square == null ? true : options._transparent_square;
        options._transparent_circle = options._transparent_circle == null ? true : options._transparent_circle;
      } else {
        switch (options._avatarType) {
          case "circle":
            options._transparent_halfbody = options._transparent_halfbody == null ? true : options._transparent_halfbody;
            options._transparent_square = options._transparent_square == null ? true : options._transparent_square;
            options._transparent_circle = options._transparent_circle == null ? false : options._transparent_circle;
            break;
          case "square":
            options._transparent_halfbody = options._transparent_halfbody == null ? true : options._transparent_halfbody;
            options._transparent_square = options._transparent_square == null ? false : options._transparent_square;
            options._transparent_circle = options._transparent_circle == null ? true : options._transparent_circle;
            break;
          case "halfbody":
            options._transparent_halfbody = options._transparent_halfbody == null ? false : options._transparent_halfbody;
            options._transparent_square = options._transparent_square == null ? true : options._transparent_square;
            options._transparent_circle = options._transparent_circle == null ? true : options._transparent_circle;
            break;
        }
      }
    }
    if (options._left == null || options._top == null) {
      switch (options._avatarType) {
        case "circle":
          options._left = options.circleLeft || options.left;
          options._top = options.circleTop || options.top;
          break;
        case "square":
          options._left = options.squareLeft || options.left;
          options._top = options.squareTop || options.top;
          break;
        case "halfbody":
          options._left = options.halfbodyLeft || options.left;
          options._top = options.halfbodyTop || options.top;
          break;
      }
    }
    if (typeof objects === "string") {
      fabric.fabric.loadSVGFromURL(objects, function(elements) {
        const group = fabric.fabric.util.groupSVGElements(elements, object, objects);
        const clipPath = options.clipPath;
        delete options.clipPath;
        group.set(options);
        if (clipPath) {
          fabric.fabric.util.enlivenObjects([clipPath], function(elivenedObjects) {
            group.clipPath = elivenedObjects[0];
            callback && callback(group);
          });
        } else {
          callback && callback(group);
        }
      });
      return;
    }
    fabric.fabric.util.enlivenObjects(objects, function(enlivenedObjects) {
      if (enlivenedObjects[0].type !== "AvatarImage") {
        callback && callback(null);
      } else {
        fabric.fabric.util.enlivenObjectEnlivables(object, options, function() {
          callback && callback(new fabric.fabric.Avatar(enlivenedObjects, options, true));
        });
      }
    });
  };
};
function triangleShape() {
  fabric.fabric.ShapeTriangle = fabric.fabric.util.createClass(fabric.fabric.Triangle, {
    type: "ShapeTriangle",
    initialize: function(options) {
      options || (options = {});
      this.strokeUniform = true;
      this.noScaleCache = false;
      this.callSuper("initialize", options);
    },
    toCanvasElement: function(options) {
      options || (options = {});
      const utils = fabric.fabric.util;
      const origParams = utils.saveObjectTransform(this);
      const originalGroup = this.group;
      const originalShadow = this.shadow;
      const abs2 = Math.abs;
      const multiplier = (options.multiplier || 1) * (options.enableRetinaScaling ? fabric.fabric.devicePixelRatio : 1);
      delete this.group;
      if (options.withoutTransform) {
        utils.resetObjectTransform(this);
      }
      if (options.withoutShadow) {
        this.shadow = null;
      }
      const el = fabric.fabric.util.createCanvasElement();
      const boundingRect = this.getBoundingRect(false, true);
      const shadow = this.shadow;
      let scaling;
      const shadowOffset = { x: 0, y: 0 };
      let shadowBlur;
      let width;
      let height;
      if (shadow) {
        shadowBlur = shadow.blur;
        if (shadow.nonScaling) {
          scaling = { scaleX: 1, scaleY: 1 };
        } else {
          scaling = this.getObjectScaling();
        }
        shadowOffset.x = 2 * Math.round(abs2(shadow.offsetX) + shadowBlur) * abs2(scaling.scaleX);
        shadowOffset.y = 2 * Math.round(abs2(shadow.offsetY) + shadowBlur) * abs2(scaling.scaleY);
      }
      width = boundingRect.width + shadowOffset.x + this.strokeWidth * 1.5;
      height = boundingRect.height + shadowOffset.y + this.strokeWidth * 1.5;
      el.width = Math.ceil(width);
      el.height = Math.ceil(height);
      let canvas = new fabric.fabric.StaticCanvas(el, {
        enableRetinaScaling: false,
        renderOnAddRemove: false,
        skipOffscreen: false
      });
      if (options.format === "jpeg") {
        canvas.backgroundColor = "#fff";
      }
      this.setPositionByOrigin(new fabric.fabric.Point(canvas.width / 2, canvas.height / 2), "center", "center");
      const originalCanvas = this.canvas;
      canvas.add(this);
      const canvasEl = canvas.toCanvasElement(multiplier || 1, options);
      this.shadow = originalShadow;
      this.set("canvas", originalCanvas);
      if (originalGroup) {
        this.group = originalGroup;
      }
      this.set(origParams).setCoords();
      canvas._objects = [];
      canvas.dispose();
      canvas = null;
      return canvasEl;
    },
    toObject: function() {
      return fabric.fabric.util.object.extend(this.callSuper("toObject"), {
        name: this.get("name")
      });
    }
  });
  fabric.fabric.ShapeTriangle.fromObject = function(object, callback) {
    callback && callback(new fabric.fabric.ShapeTriangle(object));
  };
  fabric.fabric.ShapeTriangle.generate = function(options) {
    return new fabric.fabric.ShapeTriangle({
      width: 300,
      height: 300,
      fill: "transparent",
      ...options
    });
  };
}
function circleShape() {
  fabric.fabric.ShapeCircle = fabric.fabric.util.createClass(fabric.fabric.Circle, {
    type: "ShapeCircle",
    initialize: function(options) {
      options || (options = {});
      this.strokeUniform = true;
      this.noScaleCache = false;
      this.callSuper("initialize", options);
    },
    toObject: function() {
      return fabric.fabric.util.object.extend(this.callSuper("toObject"), {
        name: this.get("name")
      });
    }
  });
  fabric.fabric.ShapeCircle.fromObject = function(object, callback) {
    callback && callback(new fabric.fabric.ShapeCircle(object));
  };
  fabric.fabric.ShapeCircle.generate = function(options) {
    return new fabric.fabric.ShapeCircle({
      radius: 150,
      fill: "transparent",
      ...options
    });
  };
}
function initShape() {
  triangleShape();
  circleShape();
}
/*!
 *  decimal.js v10.4.3
 *  An arbitrary-precision Decimal type for JavaScript.
 *  https://github.com/MikeMcl/decimal.js
 *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *  MIT Licence
 */
var EXP_LIMIT = 9e15, MAX_DIGITS = 1e9, NUMERALS = "0123456789abcdef", LN10 = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", PI = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", DEFAULTS = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed at run-time using the `Decimal.config` method.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used when rounding to `precision`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The modulo mode used when calculating the modulus: a mod n.
  // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
  // The remainder (r) is calculated as: r = a - n * q.
  //
  // UP         0 The remainder is positive if the dividend is negative, else is negative.
  // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
  // FLOOR      3 The remainder has the same sign as the divisor (Python %).
  // HALF_EVEN  6 The IEEE 754 remainder function.
  // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
  //
  // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
  // division (9) are commonly used for the modulus operation. The other rounding modes can also
  // be used, but they may not give useful results.
  modulo: 1,
  // 0 to 9
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -EXP_LIMIT
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to EXP_LIMIT
  // The minimum exponent value, beneath which underflow to zero occurs.
  // JavaScript numbers: -324  (5e-324)
  minE: -EXP_LIMIT,
  // -1 to -EXP_LIMIT
  // The maximum exponent value, above which overflow to Infinity occurs.
  // JavaScript numbers: 308  (1.7976931348623157e+308)
  maxE: EXP_LIMIT,
  // 1 to EXP_LIMIT
  // Whether to use cryptographically-secure random number generation, if available.
  crypto: false
  // true/false
}, inexact, quadrant, external = true, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", precisionLimitExceeded = decimalError + "Precision limit exceeded", cryptoUnavailable = decimalError + "crypto unavailable", tag = "[object Decimal]", mathfloor = Math.floor, mathpow = Math.pow, isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, LN10_PRECISION = LN10.length - 1, PI_PRECISION = PI.length - 1, P = { toStringTag: tag };
P.absoluteValue = P.abs = function() {
  var x = new this.constructor(this);
  if (x.s < 0) x.s = 1;
  return finalise(x);
};
P.ceil = function() {
  return finalise(new this.constructor(this), this.e + 1, 2);
};
P.clampedTo = P.clamp = function(min2, max2) {
  var k, x = this, Ctor = x.constructor;
  min2 = new Ctor(min2);
  max2 = new Ctor(max2);
  if (!min2.s || !max2.s) return new Ctor(NaN);
  if (min2.gt(max2)) throw Error(invalidArgument + max2);
  k = x.cmp(min2);
  return k < 0 ? min2 : x.cmp(max2) > 0 ? max2 : new Ctor(x);
};
P.comparedTo = P.cmp = function(y) {
  var i, j, xdL, ydL, x = this, xd = x.d, yd = (y = new x.constructor(y)).d, xs = x.s, ys = y.s;
  if (!xd || !yd) {
    return !xs || !ys ? NaN : xs !== ys ? xs : xd === yd ? 0 : !xd ^ xs < 0 ? 1 : -1;
  }
  if (!xd[0] || !yd[0]) return xd[0] ? xs : yd[0] ? -ys : 0;
  if (xs !== ys) return xs;
  if (x.e !== y.e) return x.e > y.e ^ xs < 0 ? 1 : -1;
  xdL = xd.length;
  ydL = yd.length;
  for (i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i) {
    if (xd[i] !== yd[i]) return xd[i] > yd[i] ^ xs < 0 ? 1 : -1;
  }
  return xdL === ydL ? 0 : xdL > ydL ^ xs < 0 ? 1 : -1;
};
P.cosine = P.cos = function() {
  var pr, rm, x = this, Ctor = x.constructor;
  if (!x.d) return new Ctor(NaN);
  if (!x.d[0]) return new Ctor(1);
  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
  Ctor.rounding = 1;
  x = cosine(Ctor, toLessThanHalfPi(Ctor, x));
  Ctor.precision = pr;
  Ctor.rounding = rm;
  return finalise(quadrant == 2 || quadrant == 3 ? x.neg() : x, pr, rm, true);
};
P.cubeRoot = P.cbrt = function() {
  var e, m, n, r, rep, s, sd, t, t3, t3plusx, x = this, Ctor = x.constructor;
  if (!x.isFinite() || x.isZero()) return new Ctor(x);
  external = false;
  s = x.s * mathpow(x.s * x, 1 / 3);
  if (!s || Math.abs(s) == 1 / 0) {
    n = digitsToString(x.d);
    e = x.e;
    if (s = (e - n.length + 1) % 3) n += s == 1 || s == -2 ? "0" : "00";
    s = mathpow(n, 1 / 3);
    e = mathfloor((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2));
    if (s == 1 / 0) {
      n = "5e" + e;
    } else {
      n = s.toExponential();
      n = n.slice(0, n.indexOf("e") + 1) + e;
    }
    r = new Ctor(n);
    r.s = x.s;
  } else {
    r = new Ctor(s.toString());
  }
  sd = (e = Ctor.precision) + 3;
  for (; ; ) {
    t = r;
    t3 = t.times(t).times(t);
    t3plusx = t3.plus(x);
    r = divide(t3plusx.plus(x).times(t), t3plusx.plus(t3), sd + 2, 1);
    if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
      n = n.slice(sd - 3, sd + 1);
      if (n == "9999" || !rep && n == "4999") {
        if (!rep) {
          finalise(t, e + 1, 0);
          if (t.times(t).times(t).eq(x)) {
            r = t;
            break;
          }
        }
        sd += 4;
        rep = 1;
      } else {
        if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
          finalise(r, e + 1, 1);
          m = !r.times(r).times(r).eq(x);
        }
        break;
      }
    }
  }
  external = true;
  return finalise(r, e, Ctor.rounding, m);
};
P.decimalPlaces = P.dp = function() {
  var w, d = this.d, n = NaN;
  if (d) {
    w = d.length - 1;
    n = (w - mathfloor(this.e / LOG_BASE)) * LOG_BASE;
    w = d[w];
    if (w) for (; w % 10 == 0; w /= 10) n--;
    if (n < 0) n = 0;
  }
  return n;
};
P.dividedBy = P.div = function(y) {
  return divide(this, new this.constructor(y));
};
P.dividedToIntegerBy = P.divToInt = function(y) {
  var x = this, Ctor = x.constructor;
  return finalise(divide(x, new Ctor(y), 0, 1, 1), Ctor.precision, Ctor.rounding);
};
P.equals = P.eq = function(y) {
  return this.cmp(y) === 0;
};
P.floor = function() {
  return finalise(new this.constructor(this), this.e + 1, 3);
};
P.greaterThan = P.gt = function(y) {
  return this.cmp(y) > 0;
};
P.greaterThanOrEqualTo = P.gte = function(y) {
  var k = this.cmp(y);
  return k == 1 || k === 0;
};
P.hyperbolicCosine = P.cosh = function() {
  var k, n, pr, rm, len, x = this, Ctor = x.constructor, one = new Ctor(1);
  if (!x.isFinite()) return new Ctor(x.s ? 1 / 0 : NaN);
  if (x.isZero()) return one;
  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
  Ctor.rounding = 1;
  len = x.d.length;
  if (len < 32) {
    k = Math.ceil(len / 3);
    n = (1 / tinyPow(4, k)).toString();
  } else {
    k = 16;
    n = "2.3283064365386962890625e-10";
  }
  x = taylorSeries(Ctor, 1, x.times(n), new Ctor(1), true);
  var cosh2_x, i = k, d8 = new Ctor(8);
  for (; i--; ) {
    cosh2_x = x.times(x);
    x = one.minus(cosh2_x.times(d8.minus(cosh2_x.times(d8))));
  }
  return finalise(x, Ctor.precision = pr, Ctor.rounding = rm, true);
};
P.hyperbolicSine = P.sinh = function() {
  var k, pr, rm, len, x = this, Ctor = x.constructor;
  if (!x.isFinite() || x.isZero()) return new Ctor(x);
  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
  Ctor.rounding = 1;
  len = x.d.length;
  if (len < 3) {
    x = taylorSeries(Ctor, 2, x, x, true);
  } else {
    k = 1.4 * Math.sqrt(len);
    k = k > 16 ? 16 : k | 0;
    x = x.times(1 / tinyPow(5, k));
    x = taylorSeries(Ctor, 2, x, x, true);
    var sinh2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
    for (; k--; ) {
      sinh2_x = x.times(x);
      x = x.times(d5.plus(sinh2_x.times(d16.times(sinh2_x).plus(d20))));
    }
  }
  Ctor.precision = pr;
  Ctor.rounding = rm;
  return finalise(x, pr, rm, true);
};
P.hyperbolicTangent = P.tanh = function() {
  var pr, rm, x = this, Ctor = x.constructor;
  if (!x.isFinite()) return new Ctor(x.s);
  if (x.isZero()) return new Ctor(x);
  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + 7;
  Ctor.rounding = 1;
  return divide(x.sinh(), x.cosh(), Ctor.precision = pr, Ctor.rounding = rm);
};
P.inverseCosine = P.acos = function() {
  var halfPi, x = this, Ctor = x.constructor, k = x.abs().cmp(1), pr = Ctor.precision, rm = Ctor.rounding;
  if (k !== -1) {
    return k === 0 ? x.isNeg() ? getPi(Ctor, pr, rm) : new Ctor(0) : new Ctor(NaN);
  }
  if (x.isZero()) return getPi(Ctor, pr + 4, rm).times(0.5);
  Ctor.precision = pr + 6;
  Ctor.rounding = 1;
  x = x.asin();
  halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
  Ctor.precision = pr;
  Ctor.rounding = rm;
  return halfPi.minus(x);
};
P.inverseHyperbolicCosine = P.acosh = function() {
  var pr, rm, x = this, Ctor = x.constructor;
  if (x.lte(1)) return new Ctor(x.eq(1) ? 0 : NaN);
  if (!x.isFinite()) return new Ctor(x);
  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + Math.max(Math.abs(x.e), x.sd()) + 4;
  Ctor.rounding = 1;
  external = false;
  x = x.times(x).minus(1).sqrt().plus(x);
  external = true;
  Ctor.precision = pr;
  Ctor.rounding = rm;
  return x.ln();
};
P.inverseHyperbolicSine = P.asinh = function() {
  var pr, rm, x = this, Ctor = x.constructor;
  if (!x.isFinite() || x.isZero()) return new Ctor(x);
  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + 2 * Math.max(Math.abs(x.e), x.sd()) + 6;
  Ctor.rounding = 1;
  external = false;
  x = x.times(x).plus(1).sqrt().plus(x);
  external = true;
  Ctor.precision = pr;
  Ctor.rounding = rm;
  return x.ln();
};
P.inverseHyperbolicTangent = P.atanh = function() {
  var pr, rm, wpr, xsd, x = this, Ctor = x.constructor;
  if (!x.isFinite()) return new Ctor(NaN);
  if (x.e >= 0) return new Ctor(x.abs().eq(1) ? x.s / 0 : x.isZero() ? x : NaN);
  pr = Ctor.precision;
  rm = Ctor.rounding;
  xsd = x.sd();
  if (Math.max(xsd, pr) < 2 * -x.e - 1) return finalise(new Ctor(x), pr, rm, true);
  Ctor.precision = wpr = xsd - x.e;
  x = divide(x.plus(1), new Ctor(1).minus(x), wpr + pr, 1);
  Ctor.precision = pr + 4;
  Ctor.rounding = 1;
  x = x.ln();
  Ctor.precision = pr;
  Ctor.rounding = rm;
  return x.times(0.5);
};
P.inverseSine = P.asin = function() {
  var halfPi, k, pr, rm, x = this, Ctor = x.constructor;
  if (x.isZero()) return new Ctor(x);
  k = x.abs().cmp(1);
  pr = Ctor.precision;
  rm = Ctor.rounding;
  if (k !== -1) {
    if (k === 0) {
      halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
      halfPi.s = x.s;
      return halfPi;
    }
    return new Ctor(NaN);
  }
  Ctor.precision = pr + 6;
  Ctor.rounding = 1;
  x = x.div(new Ctor(1).minus(x.times(x)).sqrt().plus(1)).atan();
  Ctor.precision = pr;
  Ctor.rounding = rm;
  return x.times(2);
};
P.inverseTangent = P.atan = function() {
  var i, j, k, n, px, t, r, wpr, x2, x = this, Ctor = x.constructor, pr = Ctor.precision, rm = Ctor.rounding;
  if (!x.isFinite()) {
    if (!x.s) return new Ctor(NaN);
    if (pr + 4 <= PI_PRECISION) {
      r = getPi(Ctor, pr + 4, rm).times(0.5);
      r.s = x.s;
      return r;
    }
  } else if (x.isZero()) {
    return new Ctor(x);
  } else if (x.abs().eq(1) && pr + 4 <= PI_PRECISION) {
    r = getPi(Ctor, pr + 4, rm).times(0.25);
    r.s = x.s;
    return r;
  }
  Ctor.precision = wpr = pr + 10;
  Ctor.rounding = 1;
  k = Math.min(28, wpr / LOG_BASE + 2 | 0);
  for (i = k; i; --i) x = x.div(x.times(x).plus(1).sqrt().plus(1));
  external = false;
  j = Math.ceil(wpr / LOG_BASE);
  n = 1;
  x2 = x.times(x);
  r = new Ctor(x);
  px = x;
  for (; i !== -1; ) {
    px = px.times(x2);
    t = r.minus(px.div(n += 2));
    px = px.times(x2);
    r = t.plus(px.div(n += 2));
    if (r.d[j] !== void 0) for (i = j; r.d[i] === t.d[i] && i--; ) ;
  }
  if (k) r = r.times(2 << k - 1);
  external = true;
  return finalise(r, Ctor.precision = pr, Ctor.rounding = rm, true);
};
P.isFinite = function() {
  return !!this.d;
};
P.isInteger = P.isInt = function() {
  return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
};
P.isNaN = function() {
  return !this.s;
};
P.isNegative = P.isNeg = function() {
  return this.s < 0;
};
P.isPositive = P.isPos = function() {
  return this.s > 0;
};
P.isZero = function() {
  return !!this.d && this.d[0] === 0;
};
P.lessThan = P.lt = function(y) {
  return this.cmp(y) < 0;
};
P.lessThanOrEqualTo = P.lte = function(y) {
  return this.cmp(y) < 1;
};
P.logarithm = P.log = function(base) {
  var isBase10, d, denominator, k, inf, num, sd, r, arg = this, Ctor = arg.constructor, pr = Ctor.precision, rm = Ctor.rounding, guard = 5;
  if (base == null) {
    base = new Ctor(10);
    isBase10 = true;
  } else {
    base = new Ctor(base);
    d = base.d;
    if (base.s < 0 || !d || !d[0] || base.eq(1)) return new Ctor(NaN);
    isBase10 = base.eq(10);
  }
  d = arg.d;
  if (arg.s < 0 || !d || !d[0] || arg.eq(1)) {
    return new Ctor(d && !d[0] ? -1 / 0 : arg.s != 1 ? NaN : d ? 0 : 1 / 0);
  }
  if (isBase10) {
    if (d.length > 1) {
      inf = true;
    } else {
      for (k = d[0]; k % 10 === 0; ) k /= 10;
      inf = k !== 1;
    }
  }
  external = false;
  sd = pr + guard;
  num = naturalLogarithm(arg, sd);
  denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
  r = divide(num, denominator, sd, 1);
  if (checkRoundingDigits(r.d, k = pr, rm)) {
    do {
      sd += 10;
      num = naturalLogarithm(arg, sd);
      denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
      r = divide(num, denominator, sd, 1);
      if (!inf) {
        if (+digitsToString(r.d).slice(k + 1, k + 15) + 1 == 1e14) {
          r = finalise(r, pr + 1, 0);
        }
        break;
      }
    } while (checkRoundingDigits(r.d, k += 10, rm));
  }
  external = true;
  return finalise(r, pr, rm);
};
P.minus = P.sub = function(y) {
  var d, e, i, j, k, len, pr, rm, xd, xe, xLTy, yd, x = this, Ctor = x.constructor;
  y = new Ctor(y);
  if (!x.d || !y.d) {
    if (!x.s || !y.s) y = new Ctor(NaN);
    else if (x.d) y.s = -y.s;
    else y = new Ctor(y.d || x.s !== y.s ? x : NaN);
    return y;
  }
  if (x.s != y.s) {
    y.s = -y.s;
    return x.plus(y);
  }
  xd = x.d;
  yd = y.d;
  pr = Ctor.precision;
  rm = Ctor.rounding;
  if (!xd[0] || !yd[0]) {
    if (yd[0]) y.s = -y.s;
    else if (xd[0]) y = new Ctor(x);
    else return new Ctor(rm === 3 ? -0 : 0);
    return external ? finalise(y, pr, rm) : y;
  }
  e = mathfloor(y.e / LOG_BASE);
  xe = mathfloor(x.e / LOG_BASE);
  xd = xd.slice();
  k = xe - e;
  if (k) {
    xLTy = k < 0;
    if (xLTy) {
      d = xd;
      k = -k;
      len = yd.length;
    } else {
      d = yd;
      e = xe;
      len = xd.length;
    }
    i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
    if (k > i) {
      k = i;
      d.length = 1;
    }
    d.reverse();
    for (i = k; i--; ) d.push(0);
    d.reverse();
  } else {
    i = xd.length;
    len = yd.length;
    xLTy = i < len;
    if (xLTy) len = i;
    for (i = 0; i < len; i++) {
      if (xd[i] != yd[i]) {
        xLTy = xd[i] < yd[i];
        break;
      }
    }
    k = 0;
  }
  if (xLTy) {
    d = xd;
    xd = yd;
    yd = d;
    y.s = -y.s;
  }
  len = xd.length;
  for (i = yd.length - len; i > 0; --i) xd[len++] = 0;
  for (i = yd.length; i > k; ) {
    if (xd[--i] < yd[i]) {
      for (j = i; j && xd[--j] === 0; ) xd[j] = BASE - 1;
      --xd[j];
      xd[i] += BASE;
    }
    xd[i] -= yd[i];
  }
  for (; xd[--len] === 0; ) xd.pop();
  for (; xd[0] === 0; xd.shift()) --e;
  if (!xd[0]) return new Ctor(rm === 3 ? -0 : 0);
  y.d = xd;
  y.e = getBase10Exponent(xd, e);
  return external ? finalise(y, pr, rm) : y;
};
P.modulo = P.mod = function(y) {
  var q, x = this, Ctor = x.constructor;
  y = new Ctor(y);
  if (!x.d || !y.s || y.d && !y.d[0]) return new Ctor(NaN);
  if (!y.d || x.d && !x.d[0]) {
    return finalise(new Ctor(x), Ctor.precision, Ctor.rounding);
  }
  external = false;
  if (Ctor.modulo == 9) {
    q = divide(x, y.abs(), 0, 3, 1);
    q.s *= y.s;
  } else {
    q = divide(x, y, 0, Ctor.modulo, 1);
  }
  q = q.times(y);
  external = true;
  return x.minus(q);
};
P.naturalExponential = P.exp = function() {
  return naturalExponential(this);
};
P.naturalLogarithm = P.ln = function() {
  return naturalLogarithm(this);
};
P.negated = P.neg = function() {
  var x = new this.constructor(this);
  x.s = -x.s;
  return finalise(x);
};
P.plus = P.add = function(y) {
  var carry, d, e, i, k, len, pr, rm, xd, yd, x = this, Ctor = x.constructor;
  y = new Ctor(y);
  if (!x.d || !y.d) {
    if (!x.s || !y.s) y = new Ctor(NaN);
    else if (!x.d) y = new Ctor(y.d || x.s === y.s ? x : NaN);
    return y;
  }
  if (x.s != y.s) {
    y.s = -y.s;
    return x.minus(y);
  }
  xd = x.d;
  yd = y.d;
  pr = Ctor.precision;
  rm = Ctor.rounding;
  if (!xd[0] || !yd[0]) {
    if (!yd[0]) y = new Ctor(x);
    return external ? finalise(y, pr, rm) : y;
  }
  k = mathfloor(x.e / LOG_BASE);
  e = mathfloor(y.e / LOG_BASE);
  xd = xd.slice();
  i = k - e;
  if (i) {
    if (i < 0) {
      d = xd;
      i = -i;
      len = yd.length;
    } else {
      d = yd;
      e = k;
      len = xd.length;
    }
    k = Math.ceil(pr / LOG_BASE);
    len = k > len ? k + 1 : len + 1;
    if (i > len) {
      i = len;
      d.length = 1;
    }
    d.reverse();
    for (; i--; ) d.push(0);
    d.reverse();
  }
  len = xd.length;
  i = yd.length;
  if (len - i < 0) {
    i = len;
    d = yd;
    yd = xd;
    xd = d;
  }
  for (carry = 0; i; ) {
    carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
    xd[i] %= BASE;
  }
  if (carry) {
    xd.unshift(carry);
    ++e;
  }
  for (len = xd.length; xd[--len] == 0; ) xd.pop();
  y.d = xd;
  y.e = getBase10Exponent(xd, e);
  return external ? finalise(y, pr, rm) : y;
};
P.precision = P.sd = function(z) {
  var k, x = this;
  if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
  if (x.d) {
    k = getPrecision(x.d);
    if (z && x.e + 1 > k) k = x.e + 1;
  } else {
    k = NaN;
  }
  return k;
};
P.round = function() {
  var x = this, Ctor = x.constructor;
  return finalise(new Ctor(x), x.e + 1, Ctor.rounding);
};
P.sine = P.sin = function() {
  var pr, rm, x = this, Ctor = x.constructor;
  if (!x.isFinite()) return new Ctor(NaN);
  if (x.isZero()) return new Ctor(x);
  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
  Ctor.rounding = 1;
  x = sine(Ctor, toLessThanHalfPi(Ctor, x));
  Ctor.precision = pr;
  Ctor.rounding = rm;
  return finalise(quadrant > 2 ? x.neg() : x, pr, rm, true);
};
P.squareRoot = P.sqrt = function() {
  var m, n, sd, r, rep, t, x = this, d = x.d, e = x.e, s = x.s, Ctor = x.constructor;
  if (s !== 1 || !d || !d[0]) {
    return new Ctor(!s || s < 0 && (!d || d[0]) ? NaN : d ? x : 1 / 0);
  }
  external = false;
  s = Math.sqrt(+x);
  if (s == 0 || s == 1 / 0) {
    n = digitsToString(d);
    if ((n.length + e) % 2 == 0) n += "0";
    s = Math.sqrt(n);
    e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
    if (s == 1 / 0) {
      n = "5e" + e;
    } else {
      n = s.toExponential();
      n = n.slice(0, n.indexOf("e") + 1) + e;
    }
    r = new Ctor(n);
  } else {
    r = new Ctor(s.toString());
  }
  sd = (e = Ctor.precision) + 3;
  for (; ; ) {
    t = r;
    r = t.plus(divide(x, t, sd + 2, 1)).times(0.5);
    if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
      n = n.slice(sd - 3, sd + 1);
      if (n == "9999" || !rep && n == "4999") {
        if (!rep) {
          finalise(t, e + 1, 0);
          if (t.times(t).eq(x)) {
            r = t;
            break;
          }
        }
        sd += 4;
        rep = 1;
      } else {
        if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
          finalise(r, e + 1, 1);
          m = !r.times(r).eq(x);
        }
        break;
      }
    }
  }
  external = true;
  return finalise(r, e, Ctor.rounding, m);
};
P.tangent = P.tan = function() {
  var pr, rm, x = this, Ctor = x.constructor;
  if (!x.isFinite()) return new Ctor(NaN);
  if (x.isZero()) return new Ctor(x);
  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + 10;
  Ctor.rounding = 1;
  x = x.sin();
  x.s = 1;
  x = divide(x, new Ctor(1).minus(x.times(x)).sqrt(), pr + 10, 0);
  Ctor.precision = pr;
  Ctor.rounding = rm;
  return finalise(quadrant == 2 || quadrant == 4 ? x.neg() : x, pr, rm, true);
};
P.times = P.mul = function(y) {
  var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
  y.s *= x.s;
  if (!xd || !xd[0] || !yd || !yd[0]) {
    return new Ctor(!y.s || xd && !xd[0] && !yd || yd && !yd[0] && !xd ? NaN : !xd || !yd ? y.s / 0 : y.s * 0);
  }
  e = mathfloor(x.e / LOG_BASE) + mathfloor(y.e / LOG_BASE);
  xdL = xd.length;
  ydL = yd.length;
  if (xdL < ydL) {
    r = xd;
    xd = yd;
    yd = r;
    rL = xdL;
    xdL = ydL;
    ydL = rL;
  }
  r = [];
  rL = xdL + ydL;
  for (i = rL; i--; ) r.push(0);
  for (i = ydL; --i >= 0; ) {
    carry = 0;
    for (k = xdL + i; k > i; ) {
      t = r[k] + yd[i] * xd[k - i - 1] + carry;
      r[k--] = t % BASE | 0;
      carry = t / BASE | 0;
    }
    r[k] = (r[k] + carry) % BASE | 0;
  }
  for (; !r[--rL]; ) r.pop();
  if (carry) ++e;
  else r.shift();
  y.d = r;
  y.e = getBase10Exponent(r, e);
  return external ? finalise(y, Ctor.precision, Ctor.rounding) : y;
};
P.toBinary = function(sd, rm) {
  return toStringBinary(this, 2, sd, rm);
};
P.toDecimalPlaces = P.toDP = function(dp, rm) {
  var x = this, Ctor = x.constructor;
  x = new Ctor(x);
  if (dp === void 0) return x;
  checkInt32(dp, 0, MAX_DIGITS);
  if (rm === void 0) rm = Ctor.rounding;
  else checkInt32(rm, 0, 8);
  return finalise(x, dp + x.e + 1, rm);
};
P.toExponential = function(dp, rm) {
  var str, x = this, Ctor = x.constructor;
  if (dp === void 0) {
    str = finiteToString(x, true);
  } else {
    checkInt32(dp, 0, MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);
    x = finalise(new Ctor(x), dp + 1, rm);
    str = finiteToString(x, true, dp + 1);
  }
  return x.isNeg() && !x.isZero() ? "-" + str : str;
};
P.toFixed = function(dp, rm) {
  var str, y, x = this, Ctor = x.constructor;
  if (dp === void 0) {
    str = finiteToString(x);
  } else {
    checkInt32(dp, 0, MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);
    y = finalise(new Ctor(x), dp + x.e + 1, rm);
    str = finiteToString(y, false, dp + y.e + 1);
  }
  return x.isNeg() && !x.isZero() ? "-" + str : str;
};
P.toFraction = function(maxD) {
  var d, d0, d1, d2, e, k, n, n0, n1, pr, q, r, x = this, xd = x.d, Ctor = x.constructor;
  if (!xd) return new Ctor(x);
  n1 = d0 = new Ctor(1);
  d1 = n0 = new Ctor(0);
  d = new Ctor(d1);
  e = d.e = getPrecision(xd) - x.e - 1;
  k = e % LOG_BASE;
  d.d[0] = mathpow(10, k < 0 ? LOG_BASE + k : k);
  if (maxD == null) {
    maxD = e > 0 ? d : n1;
  } else {
    n = new Ctor(maxD);
    if (!n.isInt() || n.lt(n1)) throw Error(invalidArgument + n);
    maxD = n.gt(d) ? e > 0 ? d : n1 : n;
  }
  external = false;
  n = new Ctor(digitsToString(xd));
  pr = Ctor.precision;
  Ctor.precision = e = xd.length * LOG_BASE * 2;
  for (; ; ) {
    q = divide(n, d, 0, 1, 1);
    d2 = d0.plus(q.times(d1));
    if (d2.cmp(maxD) == 1) break;
    d0 = d1;
    d1 = d2;
    d2 = n1;
    n1 = n0.plus(q.times(d2));
    n0 = d2;
    d2 = d;
    d = n.minus(q.times(d2));
    n = d2;
  }
  d2 = divide(maxD.minus(d0), d1, 0, 1, 1);
  n0 = n0.plus(d2.times(n1));
  d0 = d0.plus(d2.times(d1));
  n0.s = n1.s = x.s;
  r = divide(n1, d1, e, 1).minus(x).abs().cmp(divide(n0, d0, e, 1).minus(x).abs()) < 1 ? [n1, d1] : [n0, d0];
  Ctor.precision = pr;
  external = true;
  return r;
};
P.toHexadecimal = P.toHex = function(sd, rm) {
  return toStringBinary(this, 16, sd, rm);
};
P.toNearest = function(y, rm) {
  var x = this, Ctor = x.constructor;
  x = new Ctor(x);
  if (y == null) {
    if (!x.d) return x;
    y = new Ctor(1);
    rm = Ctor.rounding;
  } else {
    y = new Ctor(y);
    if (rm === void 0) {
      rm = Ctor.rounding;
    } else {
      checkInt32(rm, 0, 8);
    }
    if (!x.d) return y.s ? x : y;
    if (!y.d) {
      if (y.s) y.s = x.s;
      return y;
    }
  }
  if (y.d[0]) {
    external = false;
    x = divide(x, y, 0, rm, 1).times(y);
    external = true;
    finalise(x);
  } else {
    y.s = x.s;
    x = y;
  }
  return x;
};
P.toNumber = function() {
  return +this;
};
P.toOctal = function(sd, rm) {
  return toStringBinary(this, 8, sd, rm);
};
P.toPower = P.pow = function(y) {
  var e, k, pr, r, rm, s, x = this, Ctor = x.constructor, yn = +(y = new Ctor(y));
  if (!x.d || !y.d || !x.d[0] || !y.d[0]) return new Ctor(mathpow(+x, yn));
  x = new Ctor(x);
  if (x.eq(1)) return x;
  pr = Ctor.precision;
  rm = Ctor.rounding;
  if (y.eq(1)) return finalise(x, pr, rm);
  e = mathfloor(y.e / LOG_BASE);
  if (e >= y.d.length - 1 && (k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
    r = intPow(Ctor, x, k, pr);
    return y.s < 0 ? new Ctor(1).div(r) : finalise(r, pr, rm);
  }
  s = x.s;
  if (s < 0) {
    if (e < y.d.length - 1) return new Ctor(NaN);
    if ((y.d[e] & 1) == 0) s = 1;
    if (x.e == 0 && x.d[0] == 1 && x.d.length == 1) {
      x.s = s;
      return x;
    }
  }
  k = mathpow(+x, yn);
  e = k == 0 || !isFinite(k) ? mathfloor(yn * (Math.log("0." + digitsToString(x.d)) / Math.LN10 + x.e + 1)) : new Ctor(k + "").e;
  if (e > Ctor.maxE + 1 || e < Ctor.minE - 1) return new Ctor(e > 0 ? s / 0 : 0);
  external = false;
  Ctor.rounding = x.s = 1;
  k = Math.min(12, (e + "").length);
  r = naturalExponential(y.times(naturalLogarithm(x, pr + k)), pr);
  if (r.d) {
    r = finalise(r, pr + 5, 1);
    if (checkRoundingDigits(r.d, pr, rm)) {
      e = pr + 10;
      r = finalise(naturalExponential(y.times(naturalLogarithm(x, e + k)), e), e + 5, 1);
      if (+digitsToString(r.d).slice(pr + 1, pr + 15) + 1 == 1e14) {
        r = finalise(r, pr + 1, 0);
      }
    }
  }
  r.s = s;
  external = true;
  Ctor.rounding = rm;
  return finalise(r, pr, rm);
};
P.toPrecision = function(sd, rm) {
  var str, x = this, Ctor = x.constructor;
  if (sd === void 0) {
    str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
  } else {
    checkInt32(sd, 1, MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);
    x = finalise(new Ctor(x), sd, rm);
    str = finiteToString(x, sd <= x.e || x.e <= Ctor.toExpNeg, sd);
  }
  return x.isNeg() && !x.isZero() ? "-" + str : str;
};
P.toSignificantDigits = P.toSD = function(sd, rm) {
  var x = this, Ctor = x.constructor;
  if (sd === void 0) {
    sd = Ctor.precision;
    rm = Ctor.rounding;
  } else {
    checkInt32(sd, 1, MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);
  }
  return finalise(new Ctor(x), sd, rm);
};
P.toString = function() {
  var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
  return x.isNeg() && !x.isZero() ? "-" + str : str;
};
P.truncated = P.trunc = function() {
  return finalise(new this.constructor(this), this.e + 1, 1);
};
P.valueOf = P.toJSON = function() {
  var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
  return x.isNeg() ? "-" + str : str;
};
function digitsToString(d) {
  var i, k, ws, indexOfLastWord = d.length - 1, str = "", w = d[0];
  if (indexOfLastWord > 0) {
    str += w;
    for (i = 1; i < indexOfLastWord; i++) {
      ws = d[i] + "";
      k = LOG_BASE - ws.length;
      if (k) str += getZeroString(k);
      str += ws;
    }
    w = d[i];
    ws = w + "";
    k = LOG_BASE - ws.length;
    if (k) str += getZeroString(k);
  } else if (w === 0) {
    return "0";
  }
  for (; w % 10 === 0; ) w /= 10;
  return str + w;
}
function checkInt32(i, min2, max2) {
  if (i !== ~~i || i < min2 || i > max2) {
    throw Error(invalidArgument + i);
  }
}
function checkRoundingDigits(d, i, rm, repeating) {
  var di, k, r, rd;
  for (k = d[0]; k >= 10; k /= 10) --i;
  if (--i < 0) {
    i += LOG_BASE;
    di = 0;
  } else {
    di = Math.ceil((i + 1) / LOG_BASE);
    i %= LOG_BASE;
  }
  k = mathpow(10, LOG_BASE - i);
  rd = d[di] % k | 0;
  if (repeating == null) {
    if (i < 3) {
      if (i == 0) rd = rd / 100 | 0;
      else if (i == 1) rd = rd / 10 | 0;
      r = rm < 4 && rd == 99999 || rm > 3 && rd == 49999 || rd == 5e4 || rd == 0;
    } else {
      r = (rm < 4 && rd + 1 == k || rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 100 | 0) == mathpow(10, i - 2) - 1 || (rd == k / 2 || rd == 0) && (d[di + 1] / k / 100 | 0) == 0;
    }
  } else {
    if (i < 4) {
      if (i == 0) rd = rd / 1e3 | 0;
      else if (i == 1) rd = rd / 100 | 0;
      else if (i == 2) rd = rd / 10 | 0;
      r = (repeating || rm < 4) && rd == 9999 || !repeating && rm > 3 && rd == 4999;
    } else {
      r = ((repeating || rm < 4) && rd + 1 == k || !repeating && rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 1e3 | 0) == mathpow(10, i - 3) - 1;
    }
  }
  return r;
}
function convertBase(str, baseIn, baseOut) {
  var j, arr = [0], arrL, i = 0, strL = str.length;
  for (; i < strL; ) {
    for (arrL = arr.length; arrL--; ) arr[arrL] *= baseIn;
    arr[0] += NUMERALS.indexOf(str.charAt(i++));
    for (j = 0; j < arr.length; j++) {
      if (arr[j] > baseOut - 1) {
        if (arr[j + 1] === void 0) arr[j + 1] = 0;
        arr[j + 1] += arr[j] / baseOut | 0;
        arr[j] %= baseOut;
      }
    }
  }
  return arr.reverse();
}
function cosine(Ctor, x) {
  var k, len, y;
  if (x.isZero()) return x;
  len = x.d.length;
  if (len < 32) {
    k = Math.ceil(len / 3);
    y = (1 / tinyPow(4, k)).toString();
  } else {
    k = 16;
    y = "2.3283064365386962890625e-10";
  }
  Ctor.precision += k;
  x = taylorSeries(Ctor, 1, x.times(y), new Ctor(1));
  for (var i = k; i--; ) {
    var cos2x = x.times(x);
    x = cos2x.times(cos2x).minus(cos2x).times(8).plus(1);
  }
  Ctor.precision -= k;
  return x;
}
var divide = /* @__PURE__ */ function() {
  function multiplyInteger(x, k, base) {
    var temp, carry = 0, i = x.length;
    for (x = x.slice(); i--; ) {
      temp = x[i] * k + carry;
      x[i] = temp % base | 0;
      carry = temp / base | 0;
    }
    if (carry) x.unshift(carry);
    return x;
  }
  function compare(a, b, aL, bL) {
    var i, r;
    if (aL != bL) {
      r = aL > bL ? 1 : -1;
    } else {
      for (i = r = 0; i < aL; i++) {
        if (a[i] != b[i]) {
          r = a[i] > b[i] ? 1 : -1;
          break;
        }
      }
    }
    return r;
  }
  function subtract(a, b, aL, base) {
    var i = 0;
    for (; aL--; ) {
      a[aL] -= i;
      i = a[aL] < b[aL] ? 1 : 0;
      a[aL] = i * base + a[aL] - b[aL];
    }
    for (; !a[0] && a.length > 1; ) a.shift();
  }
  return function(x, y, pr, rm, dp, base) {
    var cmp, e, i, k, logBase, more, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign2 = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
    if (!xd || !xd[0] || !yd || !yd[0]) {
      return new Ctor(
        // Return NaN if either NaN, or both Infinity or 0.
        !x.s || !y.s || (xd ? yd && xd[0] == yd[0] : !yd) ? NaN : (
          // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
          xd && xd[0] == 0 || !yd ? sign2 * 0 : sign2 / 0
        )
      );
    }
    if (base) {
      logBase = 1;
      e = x.e - y.e;
    } else {
      base = BASE;
      logBase = LOG_BASE;
      e = mathfloor(x.e / logBase) - mathfloor(y.e / logBase);
    }
    yL = yd.length;
    xL = xd.length;
    q = new Ctor(sign2);
    qd = q.d = [];
    for (i = 0; yd[i] == (xd[i] || 0); i++) ;
    if (yd[i] > (xd[i] || 0)) e--;
    if (pr == null) {
      sd = pr = Ctor.precision;
      rm = Ctor.rounding;
    } else if (dp) {
      sd = pr + (x.e - y.e) + 1;
    } else {
      sd = pr;
    }
    if (sd < 0) {
      qd.push(1);
      more = true;
    } else {
      sd = sd / logBase + 2 | 0;
      i = 0;
      if (yL == 1) {
        k = 0;
        yd = yd[0];
        sd++;
        for (; (i < xL || k) && sd--; i++) {
          t = k * base + (xd[i] || 0);
          qd[i] = t / yd | 0;
          k = t % yd | 0;
        }
        more = k || i < xL;
      } else {
        k = base / (yd[0] + 1) | 0;
        if (k > 1) {
          yd = multiplyInteger(yd, k, base);
          xd = multiplyInteger(xd, k, base);
          yL = yd.length;
          xL = xd.length;
        }
        xi = yL;
        rem = xd.slice(0, yL);
        remL = rem.length;
        for (; remL < yL; ) rem[remL++] = 0;
        yz = yd.slice();
        yz.unshift(0);
        yd0 = yd[0];
        if (yd[1] >= base / 2) ++yd0;
        do {
          k = 0;
          cmp = compare(yd, rem, yL, remL);
          if (cmp < 0) {
            rem0 = rem[0];
            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
            k = rem0 / yd0 | 0;
            if (k > 1) {
              if (k >= base) k = base - 1;
              prod = multiplyInteger(yd, k, base);
              prodL = prod.length;
              remL = rem.length;
              cmp = compare(prod, rem, prodL, remL);
              if (cmp == 1) {
                k--;
                subtract(prod, yL < prodL ? yz : yd, prodL, base);
              }
            } else {
              if (k == 0) cmp = k = 1;
              prod = yd.slice();
            }
            prodL = prod.length;
            if (prodL < remL) prod.unshift(0);
            subtract(rem, prod, remL, base);
            if (cmp == -1) {
              remL = rem.length;
              cmp = compare(yd, rem, yL, remL);
              if (cmp < 1) {
                k++;
                subtract(rem, yL < remL ? yz : yd, remL, base);
              }
            }
            remL = rem.length;
          } else if (cmp === 0) {
            k++;
            rem = [0];
          }
          qd[i++] = k;
          if (cmp && rem[0]) {
            rem[remL++] = xd[xi] || 0;
          } else {
            rem = [xd[xi]];
            remL = 1;
          }
        } while ((xi++ < xL || rem[0] !== void 0) && sd--);
        more = rem[0] !== void 0;
      }
      if (!qd[0]) qd.shift();
    }
    if (logBase == 1) {
      q.e = e;
      inexact = more;
    } else {
      for (i = 1, k = qd[0]; k >= 10; k /= 10) i++;
      q.e = i + e * logBase - 1;
      finalise(q, dp ? pr + q.e + 1 : pr, rm, more);
    }
    return q;
  };
}();
function finalise(x, sd, rm, isTruncated) {
  var digits, i, j, k, rd, roundUp, w, xd, xdi, Ctor = x.constructor;
  out: if (sd != null) {
    xd = x.d;
    if (!xd) return x;
    for (digits = 1, k = xd[0]; k >= 10; k /= 10) digits++;
    i = sd - digits;
    if (i < 0) {
      i += LOG_BASE;
      j = sd;
      w = xd[xdi = 0];
      rd = w / mathpow(10, digits - j - 1) % 10 | 0;
    } else {
      xdi = Math.ceil((i + 1) / LOG_BASE);
      k = xd.length;
      if (xdi >= k) {
        if (isTruncated) {
          for (; k++ <= xdi; ) xd.push(0);
          w = rd = 0;
          digits = 1;
          i %= LOG_BASE;
          j = i - LOG_BASE + 1;
        } else {
          break out;
        }
      } else {
        w = k = xd[xdi];
        for (digits = 1; k >= 10; k /= 10) digits++;
        i %= LOG_BASE;
        j = i - LOG_BASE + digits;
        rd = j < 0 ? 0 : w / mathpow(10, digits - j - 1) % 10 | 0;
      }
    }
    isTruncated = isTruncated || sd < 0 || xd[xdi + 1] !== void 0 || (j < 0 ? w : w % mathpow(10, digits - j - 1));
    roundUp = rm < 4 ? (rd || isTruncated) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || isTruncated || rm == 6 && // Check whether the digit to the left of the rounding digit is odd.
    (i > 0 ? j > 0 ? w / mathpow(10, digits - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
    if (sd < 1 || !xd[0]) {
      xd.length = 0;
      if (roundUp) {
        sd -= x.e + 1;
        xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
        x.e = -sd || 0;
      } else {
        xd[0] = x.e = 0;
      }
      return x;
    }
    if (i == 0) {
      xd.length = xdi;
      k = 1;
      xdi--;
    } else {
      xd.length = xdi + 1;
      k = mathpow(10, LOG_BASE - i);
      xd[xdi] = j > 0 ? (w / mathpow(10, digits - j) % mathpow(10, j) | 0) * k : 0;
    }
    if (roundUp) {
      for (; ; ) {
        if (xdi == 0) {
          for (i = 1, j = xd[0]; j >= 10; j /= 10) i++;
          j = xd[0] += k;
          for (k = 1; j >= 10; j /= 10) k++;
          if (i != k) {
            x.e++;
            if (xd[0] == BASE) xd[0] = 1;
          }
          break;
        } else {
          xd[xdi] += k;
          if (xd[xdi] != BASE) break;
          xd[xdi--] = 0;
          k = 1;
        }
      }
    }
    for (i = xd.length; xd[--i] === 0; ) xd.pop();
  }
  if (external) {
    if (x.e > Ctor.maxE) {
      x.d = null;
      x.e = NaN;
    } else if (x.e < Ctor.minE) {
      x.e = 0;
      x.d = [0];
    }
  }
  return x;
}
function finiteToString(x, isExp, sd) {
  if (!x.isFinite()) return nonFiniteToString(x);
  var k, e = x.e, str = digitsToString(x.d), len = str.length;
  if (isExp) {
    if (sd && (k = sd - len) > 0) {
      str = str.charAt(0) + "." + str.slice(1) + getZeroString(k);
    } else if (len > 1) {
      str = str.charAt(0) + "." + str.slice(1);
    }
    str = str + (x.e < 0 ? "e" : "e+") + x.e;
  } else if (e < 0) {
    str = "0." + getZeroString(-e - 1) + str;
    if (sd && (k = sd - len) > 0) str += getZeroString(k);
  } else if (e >= len) {
    str += getZeroString(e + 1 - len);
    if (sd && (k = sd - e - 1) > 0) str = str + "." + getZeroString(k);
  } else {
    if ((k = e + 1) < len) str = str.slice(0, k) + "." + str.slice(k);
    if (sd && (k = sd - len) > 0) {
      if (e + 1 === len) str += ".";
      str += getZeroString(k);
    }
  }
  return str;
}
function getBase10Exponent(digits, e) {
  var w = digits[0];
  for (e *= LOG_BASE; w >= 10; w /= 10) e++;
  return e;
}
function getLn10(Ctor, sd, pr) {
  if (sd > LN10_PRECISION) {
    external = true;
    if (pr) Ctor.precision = pr;
    throw Error(precisionLimitExceeded);
  }
  return finalise(new Ctor(LN10), sd, 1, true);
}
function getPi(Ctor, sd, rm) {
  if (sd > PI_PRECISION) throw Error(precisionLimitExceeded);
  return finalise(new Ctor(PI), sd, rm, true);
}
function getPrecision(digits) {
  var w = digits.length - 1, len = w * LOG_BASE + 1;
  w = digits[w];
  if (w) {
    for (; w % 10 == 0; w /= 10) len--;
    for (w = digits[0]; w >= 10; w /= 10) len++;
  }
  return len;
}
function getZeroString(k) {
  var zs = "";
  for (; k--; ) zs += "0";
  return zs;
}
function intPow(Ctor, x, n, pr) {
  var isTruncated, r = new Ctor(1), k = Math.ceil(pr / LOG_BASE + 4);
  external = false;
  for (; ; ) {
    if (n % 2) {
      r = r.times(x);
      if (truncate(r.d, k)) isTruncated = true;
    }
    n = mathfloor(n / 2);
    if (n === 0) {
      n = r.d.length - 1;
      if (isTruncated && r.d[n] === 0) ++r.d[n];
      break;
    }
    x = x.times(x);
    truncate(x.d, k);
  }
  external = true;
  return r;
}
function isOdd(n) {
  return n.d[n.d.length - 1] & 1;
}
function maxOrMin(Ctor, args, ltgt) {
  var y, x = new Ctor(args[0]), i = 0;
  for (; ++i < args.length; ) {
    y = new Ctor(args[i]);
    if (!y.s) {
      x = y;
      break;
    } else if (x[ltgt](y)) {
      x = y;
    }
  }
  return x;
}
function naturalExponential(x, sd) {
  var denominator, guard, j, pow2, sum2, t, wpr, rep = 0, i = 0, k = 0, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
  if (!x.d || !x.d[0] || x.e > 17) {
    return new Ctor(x.d ? !x.d[0] ? 1 : x.s < 0 ? 0 : 1 / 0 : x.s ? x.s < 0 ? 0 : x : 0 / 0);
  }
  if (sd == null) {
    external = false;
    wpr = pr;
  } else {
    wpr = sd;
  }
  t = new Ctor(0.03125);
  while (x.e > -2) {
    x = x.times(t);
    k += 5;
  }
  guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
  wpr += guard;
  denominator = pow2 = sum2 = new Ctor(1);
  Ctor.precision = wpr;
  for (; ; ) {
    pow2 = finalise(pow2.times(x), wpr, 1);
    denominator = denominator.times(++i);
    t = sum2.plus(divide(pow2, denominator, wpr, 1));
    if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum2.d).slice(0, wpr)) {
      j = k;
      while (j--) sum2 = finalise(sum2.times(sum2), wpr, 1);
      if (sd == null) {
        if (rep < 3 && checkRoundingDigits(sum2.d, wpr - guard, rm, rep)) {
          Ctor.precision = wpr += 10;
          denominator = pow2 = t = new Ctor(1);
          i = 0;
          rep++;
        } else {
          return finalise(sum2, Ctor.precision = pr, rm, external = true);
        }
      } else {
        Ctor.precision = pr;
        return sum2;
      }
    }
    sum2 = t;
  }
}
function naturalLogarithm(y, sd) {
  var c, c0, denominator, e, numerator, rep, sum2, t, wpr, x1, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
  if (x.s < 0 || !xd || !xd[0] || !x.e && xd[0] == 1 && xd.length == 1) {
    return new Ctor(xd && !xd[0] ? -1 / 0 : x.s != 1 ? NaN : xd ? 0 : x);
  }
  if (sd == null) {
    external = false;
    wpr = pr;
  } else {
    wpr = sd;
  }
  Ctor.precision = wpr += guard;
  c = digitsToString(xd);
  c0 = c.charAt(0);
  if (Math.abs(e = x.e) < 15e14) {
    while (c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3) {
      x = x.times(y);
      c = digitsToString(x.d);
      c0 = c.charAt(0);
      n++;
    }
    e = x.e;
    if (c0 > 1) {
      x = new Ctor("0." + c);
      e++;
    } else {
      x = new Ctor(c0 + "." + c.slice(1));
    }
  } else {
    t = getLn10(Ctor, wpr + 2, pr).times(e + "");
    x = naturalLogarithm(new Ctor(c0 + "." + c.slice(1)), wpr - guard).plus(t);
    Ctor.precision = pr;
    return sd == null ? finalise(x, pr, rm, external = true) : x;
  }
  x1 = x;
  sum2 = numerator = x = divide(x.minus(1), x.plus(1), wpr, 1);
  x2 = finalise(x.times(x), wpr, 1);
  denominator = 3;
  for (; ; ) {
    numerator = finalise(numerator.times(x2), wpr, 1);
    t = sum2.plus(divide(numerator, new Ctor(denominator), wpr, 1));
    if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum2.d).slice(0, wpr)) {
      sum2 = sum2.times(2);
      if (e !== 0) sum2 = sum2.plus(getLn10(Ctor, wpr + 2, pr).times(e + ""));
      sum2 = divide(sum2, new Ctor(n), wpr, 1);
      if (sd == null) {
        if (checkRoundingDigits(sum2.d, wpr - guard, rm, rep)) {
          Ctor.precision = wpr += guard;
          t = numerator = x = divide(x1.minus(1), x1.plus(1), wpr, 1);
          x2 = finalise(x.times(x), wpr, 1);
          denominator = rep = 1;
        } else {
          return finalise(sum2, Ctor.precision = pr, rm, external = true);
        }
      } else {
        Ctor.precision = pr;
        return sum2;
      }
    }
    sum2 = t;
    denominator += 2;
  }
}
function nonFiniteToString(x) {
  return String(x.s * x.s / 0);
}
function parseDecimal(x, str) {
  var e, i, len;
  if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
  if ((i = str.search(/e/i)) > 0) {
    if (e < 0) e = i;
    e += +str.slice(i + 1);
    str = str.substring(0, i);
  } else if (e < 0) {
    e = str.length;
  }
  for (i = 0; str.charCodeAt(i) === 48; i++) ;
  for (len = str.length; str.charCodeAt(len - 1) === 48; --len) ;
  str = str.slice(i, len);
  if (str) {
    len -= i;
    x.e = e = e - i - 1;
    x.d = [];
    i = (e + 1) % LOG_BASE;
    if (e < 0) i += LOG_BASE;
    if (i < len) {
      if (i) x.d.push(+str.slice(0, i));
      for (len -= LOG_BASE; i < len; ) x.d.push(+str.slice(i, i += LOG_BASE));
      str = str.slice(i);
      i = LOG_BASE - str.length;
    } else {
      i -= len;
    }
    for (; i--; ) str += "0";
    x.d.push(+str);
    if (external) {
      if (x.e > x.constructor.maxE) {
        x.d = null;
        x.e = NaN;
      } else if (x.e < x.constructor.minE) {
        x.e = 0;
        x.d = [0];
      }
    }
  } else {
    x.e = 0;
    x.d = [0];
  }
  return x;
}
function parseOther(x, str) {
  var base, Ctor, divisor, i, isFloat, len, p, xd, xe;
  if (str.indexOf("_") > -1) {
    str = str.replace(/(\d)_(?=\d)/g, "$1");
    if (isDecimal.test(str)) return parseDecimal(x, str);
  } else if (str === "Infinity" || str === "NaN") {
    if (!+str) x.s = NaN;
    x.e = NaN;
    x.d = null;
    return x;
  }
  if (isHex.test(str)) {
    base = 16;
    str = str.toLowerCase();
  } else if (isBinary.test(str)) {
    base = 2;
  } else if (isOctal.test(str)) {
    base = 8;
  } else {
    throw Error(invalidArgument + str);
  }
  i = str.search(/p/i);
  if (i > 0) {
    p = +str.slice(i + 1);
    str = str.substring(2, i);
  } else {
    str = str.slice(2);
  }
  i = str.indexOf(".");
  isFloat = i >= 0;
  Ctor = x.constructor;
  if (isFloat) {
    str = str.replace(".", "");
    len = str.length;
    i = len - i;
    divisor = intPow(Ctor, new Ctor(base), i, i * 2);
  }
  xd = convertBase(str, base, BASE);
  xe = xd.length - 1;
  for (i = xe; xd[i] === 0; --i) xd.pop();
  if (i < 0) return new Ctor(x.s * 0);
  x.e = getBase10Exponent(xd, xe);
  x.d = xd;
  external = false;
  if (isFloat) x = divide(x, divisor, len * 4);
  if (p) x = x.times(Math.abs(p) < 54 ? mathpow(2, p) : Decimal.pow(2, p));
  external = true;
  return x;
}
function sine(Ctor, x) {
  var k, len = x.d.length;
  if (len < 3) {
    return x.isZero() ? x : taylorSeries(Ctor, 2, x, x);
  }
  k = 1.4 * Math.sqrt(len);
  k = k > 16 ? 16 : k | 0;
  x = x.times(1 / tinyPow(5, k));
  x = taylorSeries(Ctor, 2, x, x);
  var sin2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
  for (; k--; ) {
    sin2_x = x.times(x);
    x = x.times(d5.plus(sin2_x.times(d16.times(sin2_x).minus(d20))));
  }
  return x;
}
function taylorSeries(Ctor, n, x, y, isHyperbolic) {
  var j, t, u, x2, pr = Ctor.precision, k = Math.ceil(pr / LOG_BASE);
  external = false;
  x2 = x.times(x);
  u = new Ctor(y);
  for (; ; ) {
    t = divide(u.times(x2), new Ctor(n++ * n++), pr, 1);
    u = isHyperbolic ? y.plus(t) : y.minus(t);
    y = divide(t.times(x2), new Ctor(n++ * n++), pr, 1);
    t = u.plus(y);
    if (t.d[k] !== void 0) {
      for (j = k; t.d[j] === u.d[j] && j--; ) ;
      if (j == -1) break;
    }
    j = u;
    u = y;
    y = t;
    t = j;
  }
  external = true;
  t.d.length = k + 1;
  return t;
}
function tinyPow(b, e) {
  var n = b;
  while (--e) n *= b;
  return n;
}
function toLessThanHalfPi(Ctor, x) {
  var t, isNeg = x.s < 0, pi = getPi(Ctor, Ctor.precision, 1), halfPi = pi.times(0.5);
  x = x.abs();
  if (x.lte(halfPi)) {
    quadrant = isNeg ? 4 : 1;
    return x;
  }
  t = x.divToInt(pi);
  if (t.isZero()) {
    quadrant = isNeg ? 3 : 2;
  } else {
    x = x.minus(t.times(pi));
    if (x.lte(halfPi)) {
      quadrant = isOdd(t) ? isNeg ? 2 : 3 : isNeg ? 4 : 1;
      return x;
    }
    quadrant = isOdd(t) ? isNeg ? 1 : 4 : isNeg ? 3 : 2;
  }
  return x.minus(pi).abs();
}
function toStringBinary(x, baseOut, sd, rm) {
  var base, e, i, k, len, roundUp, str, xd, y, Ctor = x.constructor, isExp = sd !== void 0;
  if (isExp) {
    checkInt32(sd, 1, MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);
  } else {
    sd = Ctor.precision;
    rm = Ctor.rounding;
  }
  if (!x.isFinite()) {
    str = nonFiniteToString(x);
  } else {
    str = finiteToString(x);
    i = str.indexOf(".");
    if (isExp) {
      base = 2;
      if (baseOut == 16) {
        sd = sd * 4 - 3;
      } else if (baseOut == 8) {
        sd = sd * 3 - 2;
      }
    } else {
      base = baseOut;
    }
    if (i >= 0) {
      str = str.replace(".", "");
      y = new Ctor(1);
      y.e = str.length - i;
      y.d = convertBase(finiteToString(y), 10, base);
      y.e = y.d.length;
    }
    xd = convertBase(str, 10, base);
    e = len = xd.length;
    for (; xd[--len] == 0; ) xd.pop();
    if (!xd[0]) {
      str = isExp ? "0p+0" : "0";
    } else {
      if (i < 0) {
        e--;
      } else {
        x = new Ctor(x);
        x.d = xd;
        x.e = e;
        x = divide(x, y, sd, rm, 0, base);
        xd = x.d;
        e = x.e;
        roundUp = inexact;
      }
      i = xd[sd];
      k = base / 2;
      roundUp = roundUp || xd[sd + 1] !== void 0;
      roundUp = rm < 4 ? (i !== void 0 || roundUp) && (rm === 0 || rm === (x.s < 0 ? 3 : 2)) : i > k || i === k && (rm === 4 || roundUp || rm === 6 && xd[sd - 1] & 1 || rm === (x.s < 0 ? 8 : 7));
      xd.length = sd;
      if (roundUp) {
        for (; ++xd[--sd] > base - 1; ) {
          xd[sd] = 0;
          if (!sd) {
            ++e;
            xd.unshift(1);
          }
        }
      }
      for (len = xd.length; !xd[len - 1]; --len) ;
      for (i = 0, str = ""; i < len; i++) str += NUMERALS.charAt(xd[i]);
      if (isExp) {
        if (len > 1) {
          if (baseOut == 16 || baseOut == 8) {
            i = baseOut == 16 ? 4 : 3;
            for (--len; len % i; len++) str += "0";
            xd = convertBase(str, base, baseOut);
            for (len = xd.length; !xd[len - 1]; --len) ;
            for (i = 1, str = "1."; i < len; i++) str += NUMERALS.charAt(xd[i]);
          } else {
            str = str.charAt(0) + "." + str.slice(1);
          }
        }
        str = str + (e < 0 ? "p" : "p+") + e;
      } else if (e < 0) {
        for (; ++e; ) str = "0" + str;
        str = "0." + str;
      } else {
        if (++e > len) for (e -= len; e--; ) str += "0";
        else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
      }
    }
    str = (baseOut == 16 ? "0x" : baseOut == 2 ? "0b" : baseOut == 8 ? "0o" : "") + str;
  }
  return x.s < 0 ? "-" + str : str;
}
function truncate(arr, len) {
  if (arr.length > len) {
    arr.length = len;
    return true;
  }
}
function abs(x) {
  return new this(x).abs();
}
function acos(x) {
  return new this(x).acos();
}
function acosh(x) {
  return new this(x).acosh();
}
function add(x, y) {
  return new this(x).plus(y);
}
function asin(x) {
  return new this(x).asin();
}
function asinh(x) {
  return new this(x).asinh();
}
function atan(x) {
  return new this(x).atan();
}
function atanh(x) {
  return new this(x).atanh();
}
function atan2(y, x) {
  y = new this(y);
  x = new this(x);
  var r, pr = this.precision, rm = this.rounding, wpr = pr + 4;
  if (!y.s || !x.s) {
    r = new this(NaN);
  } else if (!y.d && !x.d) {
    r = getPi(this, wpr, 1).times(x.s > 0 ? 0.25 : 0.75);
    r.s = y.s;
  } else if (!x.d || y.isZero()) {
    r = x.s < 0 ? getPi(this, pr, rm) : new this(0);
    r.s = y.s;
  } else if (!y.d || x.isZero()) {
    r = getPi(this, wpr, 1).times(0.5);
    r.s = y.s;
  } else if (x.s < 0) {
    this.precision = wpr;
    this.rounding = 1;
    r = this.atan(divide(y, x, wpr, 1));
    x = getPi(this, wpr, 1);
    this.precision = pr;
    this.rounding = rm;
    r = y.s < 0 ? r.minus(x) : r.plus(x);
  } else {
    r = this.atan(divide(y, x, wpr, 1));
  }
  return r;
}
function cbrt(x) {
  return new this(x).cbrt();
}
function ceil(x) {
  return finalise(x = new this(x), x.e + 1, 2);
}
function clamp(x, min2, max2) {
  return new this(x).clamp(min2, max2);
}
function config(obj) {
  if (!obj || typeof obj !== "object") throw Error(decimalError + "Object expected");
  var i, p, v, useDefaults = obj.defaults === true, ps = [
    "precision",
    1,
    MAX_DIGITS,
    "rounding",
    0,
    8,
    "toExpNeg",
    -EXP_LIMIT,
    0,
    "toExpPos",
    0,
    EXP_LIMIT,
    "maxE",
    0,
    EXP_LIMIT,
    "minE",
    -EXP_LIMIT,
    0,
    "modulo",
    0,
    9
  ];
  for (i = 0; i < ps.length; i += 3) {
    if (p = ps[i], useDefaults) this[p] = DEFAULTS[p];
    if ((v = obj[p]) !== void 0) {
      if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
      else throw Error(invalidArgument + p + ": " + v);
    }
  }
  if (p = "crypto", useDefaults) this[p] = DEFAULTS[p];
  if ((v = obj[p]) !== void 0) {
    if (v === true || v === false || v === 0 || v === 1) {
      if (v) {
        if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) {
          this[p] = true;
        } else {
          throw Error(cryptoUnavailable);
        }
      } else {
        this[p] = false;
      }
    } else {
      throw Error(invalidArgument + p + ": " + v);
    }
  }
  return this;
}
function cos(x) {
  return new this(x).cos();
}
function cosh(x) {
  return new this(x).cosh();
}
function clone(obj) {
  var i, p, ps;
  function Decimal2(v) {
    var e, i2, t, x = this;
    if (!(x instanceof Decimal2)) return new Decimal2(v);
    x.constructor = Decimal2;
    if (isDecimalInstance(v)) {
      x.s = v.s;
      if (external) {
        if (!v.d || v.e > Decimal2.maxE) {
          x.e = NaN;
          x.d = null;
        } else if (v.e < Decimal2.minE) {
          x.e = 0;
          x.d = [0];
        } else {
          x.e = v.e;
          x.d = v.d.slice();
        }
      } else {
        x.e = v.e;
        x.d = v.d ? v.d.slice() : v.d;
      }
      return;
    }
    t = typeof v;
    if (t === "number") {
      if (v === 0) {
        x.s = 1 / v < 0 ? -1 : 1;
        x.e = 0;
        x.d = [0];
        return;
      }
      if (v < 0) {
        v = -v;
        x.s = -1;
      } else {
        x.s = 1;
      }
      if (v === ~~v && v < 1e7) {
        for (e = 0, i2 = v; i2 >= 10; i2 /= 10) e++;
        if (external) {
          if (e > Decimal2.maxE) {
            x.e = NaN;
            x.d = null;
          } else if (e < Decimal2.minE) {
            x.e = 0;
            x.d = [0];
          } else {
            x.e = e;
            x.d = [v];
          }
        } else {
          x.e = e;
          x.d = [v];
        }
        return;
      } else if (v * 0 !== 0) {
        if (!v) x.s = NaN;
        x.e = NaN;
        x.d = null;
        return;
      }
      return parseDecimal(x, v.toString());
    } else if (t !== "string") {
      throw Error(invalidArgument + v);
    }
    if ((i2 = v.charCodeAt(0)) === 45) {
      v = v.slice(1);
      x.s = -1;
    } else {
      if (i2 === 43) v = v.slice(1);
      x.s = 1;
    }
    return isDecimal.test(v) ? parseDecimal(x, v) : parseOther(x, v);
  }
  Decimal2.prototype = P;
  Decimal2.ROUND_UP = 0;
  Decimal2.ROUND_DOWN = 1;
  Decimal2.ROUND_CEIL = 2;
  Decimal2.ROUND_FLOOR = 3;
  Decimal2.ROUND_HALF_UP = 4;
  Decimal2.ROUND_HALF_DOWN = 5;
  Decimal2.ROUND_HALF_EVEN = 6;
  Decimal2.ROUND_HALF_CEIL = 7;
  Decimal2.ROUND_HALF_FLOOR = 8;
  Decimal2.EUCLID = 9;
  Decimal2.config = Decimal2.set = config;
  Decimal2.clone = clone;
  Decimal2.isDecimal = isDecimalInstance;
  Decimal2.abs = abs;
  Decimal2.acos = acos;
  Decimal2.acosh = acosh;
  Decimal2.add = add;
  Decimal2.asin = asin;
  Decimal2.asinh = asinh;
  Decimal2.atan = atan;
  Decimal2.atanh = atanh;
  Decimal2.atan2 = atan2;
  Decimal2.cbrt = cbrt;
  Decimal2.ceil = ceil;
  Decimal2.clamp = clamp;
  Decimal2.cos = cos;
  Decimal2.cosh = cosh;
  Decimal2.div = div;
  Decimal2.exp = exp;
  Decimal2.floor = floor;
  Decimal2.hypot = hypot;
  Decimal2.ln = ln;
  Decimal2.log = log;
  Decimal2.log10 = log10;
  Decimal2.log2 = log2;
  Decimal2.max = max;
  Decimal2.min = min;
  Decimal2.mod = mod$1;
  Decimal2.mul = mul;
  Decimal2.pow = pow;
  Decimal2.random = random;
  Decimal2.round = round;
  Decimal2.sign = sign;
  Decimal2.sin = sin;
  Decimal2.sinh = sinh;
  Decimal2.sqrt = sqrt;
  Decimal2.sub = sub;
  Decimal2.sum = sum;
  Decimal2.tan = tan;
  Decimal2.tanh = tanh;
  Decimal2.trunc = trunc;
  if (obj === void 0) obj = {};
  if (obj) {
    if (obj.defaults !== true) {
      ps = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"];
      for (i = 0; i < ps.length; ) if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
    }
  }
  Decimal2.config(obj);
  return Decimal2;
}
function div(x, y) {
  return new this(x).div(y);
}
function exp(x) {
  return new this(x).exp();
}
function floor(x) {
  return finalise(x = new this(x), x.e + 1, 3);
}
function hypot() {
  var i, n, t = new this(0);
  external = false;
  for (i = 0; i < arguments.length; ) {
    n = new this(arguments[i++]);
    if (!n.d) {
      if (n.s) {
        external = true;
        return new this(1 / 0);
      }
      t = n;
    } else if (t.d) {
      t = t.plus(n.times(n));
    }
  }
  external = true;
  return t.sqrt();
}
function isDecimalInstance(obj) {
  return obj instanceof Decimal || obj && obj.toStringTag === tag || false;
}
function ln(x) {
  return new this(x).ln();
}
function log(x, y) {
  return new this(x).log(y);
}
function log2(x) {
  return new this(x).log(2);
}
function log10(x) {
  return new this(x).log(10);
}
function max() {
  return maxOrMin(this, arguments, "lt");
}
function min() {
  return maxOrMin(this, arguments, "gt");
}
function mod$1(x, y) {
  return new this(x).mod(y);
}
function mul(x, y) {
  return new this(x).mul(y);
}
function pow(x, y) {
  return new this(x).pow(y);
}
function random(sd) {
  var d, e, k, n, i = 0, r = new this(1), rd = [];
  if (sd === void 0) sd = this.precision;
  else checkInt32(sd, 1, MAX_DIGITS);
  k = Math.ceil(sd / LOG_BASE);
  if (!this.crypto) {
    for (; i < k; ) rd[i++] = Math.random() * 1e7 | 0;
  } else if (crypto.getRandomValues) {
    d = crypto.getRandomValues(new Uint32Array(k));
    for (; i < k; ) {
      n = d[i];
      if (n >= 429e7) {
        d[i] = crypto.getRandomValues(new Uint32Array(1))[0];
      } else {
        rd[i++] = n % 1e7;
      }
    }
  } else if (crypto.randomBytes) {
    d = crypto.randomBytes(k *= 4);
    for (; i < k; ) {
      n = d[i] + (d[i + 1] << 8) + (d[i + 2] << 16) + ((d[i + 3] & 127) << 24);
      if (n >= 214e7) {
        crypto.randomBytes(4).copy(d, i);
      } else {
        rd.push(n % 1e7);
        i += 4;
      }
    }
    i = k / 4;
  } else {
    throw Error(cryptoUnavailable);
  }
  k = rd[--i];
  sd %= LOG_BASE;
  if (k && sd) {
    n = mathpow(10, LOG_BASE - sd);
    rd[i] = (k / n | 0) * n;
  }
  for (; rd[i] === 0; i--) rd.pop();
  if (i < 0) {
    e = 0;
    rd = [0];
  } else {
    e = -1;
    for (; rd[0] === 0; e -= LOG_BASE) rd.shift();
    for (k = 1, n = rd[0]; n >= 10; n /= 10) k++;
    if (k < LOG_BASE) e -= LOG_BASE - k;
  }
  r.e = e;
  r.d = rd;
  return r;
}
function round(x) {
  return finalise(x = new this(x), x.e + 1, this.rounding);
}
function sign(x) {
  x = new this(x);
  return x.d ? x.d[0] ? x.s : 0 * x.s : x.s || NaN;
}
function sin(x) {
  return new this(x).sin();
}
function sinh(x) {
  return new this(x).sinh();
}
function sqrt(x) {
  return new this(x).sqrt();
}
function sub(x, y) {
  return new this(x).sub(y);
}
function sum() {
  var i = 0, args = arguments, x = new this(args[i]);
  external = false;
  for (; x.s && ++i < args.length; ) x = x.plus(args[i]);
  external = true;
  return finalise(x, this.precision, this.rounding);
}
function tan(x) {
  return new this(x).tan();
}
function tanh(x) {
  return new this(x).tanh();
}
function trunc(x) {
  return finalise(x = new this(x), x.e + 1, 1);
}
P[Symbol.for("nodejs.util.inspect.custom")] = P.toString;
P[Symbol.toStringTag] = "Decimal";
var Decimal = P.constructor = clone(DEFAULTS);
LN10 = new Decimal(LN10);
PI = new Decimal(PI);
function toFixedNoRound(num, decimalPlaces) {
  const _num = Number(num);
  const factor = Math.pow(10, decimalPlaces);
  return Math.floor(_num * factor) / factor;
}
function initCustomVideo() {
  fabric.fabric.CustomVideo = fabric.fabric.util.createClass(fabric.fabric.CustomImage, {
    type: "CustomVideo",
    initialize: function(objects, options, isAlreadyGrouped) {
      this.callSuper("initialize", objects, options, isAlreadyGrouped);
      this.setVideoVolume(this._volume);
      this.setVideoSpeed(this._speed);
    },
    toObject: function(propertiesToInclude) {
      return this.callSuper("toObject", propertiesToInclude);
    },
    getVideoElement: function() {
      if (this.videoElement) {
        return this.videoElement;
      }
      const videoElement = document.getElementById(this.videoId);
      this.videoElement = videoElement;
      return this.videoElement;
    },
    mountVideo: function() {
      const img = this._objects[0];
      const videoElement = this.getVideoElement();
      img.setElement(videoElement);
      this.dirty = true;
      this._loaded = true;
    },
    pause: function(zero) {
      const vd = document.querySelector("#" + this.videoId);
      if (!vd) {
        throw new Error("no video");
      }
      vd.pause();
      if (zero) {
        vd.currentTime = this._start;
        this.set("dirty", true);
      }
    },
    play: function() {
      const vd = document.querySelector("#" + this.videoId);
      if (vd.paused) {
        vd.play();
      }
    },
    seek: async function(time) {
      const vd = document.querySelector("#" + this.videoId);
      if (vd.currentTime === time) return;
      let seekResolve = null;
      const waitSeek = new Promise((resolve, reject) => {
        seekResolve = resolve;
      });
      vd.addEventListener("seeked", () => {
        if (seekResolve) {
          seekResolve();
        }
      });
      vd.currentTime = time;
      await waitSeek;
      this.set("dirty", true);
    },
    getNumberSpeed() {
      let speed = this._speed ? this._speed : 1;
      speed = parseFloat(speed);
      return speed;
    },
    getCalcStart() {
      const start = this._start / this.getNumberSpeed();
      if (Number.isInteger(start)) {
        return parseInt(start);
      } else {
        return toFixedNoRound(start, 1);
      }
    },
    getCalcDuration() {
      const clipDuration = parseFloat(new Decimal(this._end).minus(this._start).toString()) / this.getNumberSpeed();
      if (Number.isInteger(clipDuration)) {
        return parseInt(clipDuration);
      } else {
        return toFixedNoRound(clipDuration, 1);
      }
    },
    getCalcVideoDuration() {
      const videoDuration = this._duration / this.getNumberSpeed();
      if (Number.isInteger(videoDuration)) {
        return parseInt(videoDuration);
      } else {
        return toFixedNoRound(videoDuration, 1);
      }
    },
    destroySelf() {
      const vd = document.getElementById(this.videoId);
      if (vd) {
        vd.remove();
      }
      this.destroy();
    },
    setVideoSpeed(value) {
      this._speed = value;
      const videoElement = this.getVideoElement();
      if (videoElement) {
        videoElement.playbackRate = this.getNumberSpeed();
      }
    },
    setVideoVolume(value) {
      this._volume = value;
      const videoElement = this.getVideoElement();
      if (videoElement) {
        videoElement.volume = Object.prototype.hasOwnProperty.call(this, "_volume") ? this._volume : 1;
      }
    }
  });
  fabric.fabric.CustomVideo.fromCoverURL = function(coverUrl, callback, options) {
    const vd = document.createElement("video");
    vd.style.display = "none";
    vd.src = options._staticUrl || options._videoSrc;
    vd.setAttribute("preload", "auto");
    vd.setAttribute("crossorigin", "anonymous");
    const tempID = customAlphabet("abcdefghijklmnopqrstuvwxyz", 8);
    vd.id = tempID();
    vd.addEventListener("loadeddata", (e) => {
      vd.width = vd.videoWidth;
      vd.height = vd.videoHeight;
    });
    document.body.appendChild(vd);
    fabric.fabric.Image.fromURL(coverUrl, (img) => {
      const video = new fabric.fabric.CustomVideo([img], {
        objectCaching: false,
        lockScalingFlip: true,
        videoId: vd.id,
        _loop: true,
        ...options
      });
      if (options.initWidth) {
        video.scaleToWidth(options.initWidth);
      }
      if (options.initHeight) {
        video.scaleToHeight(options.initHeight);
      }
      callback && callback(video);
    }, {
      crossOrigin: "anonymous",
      objectCaching: false
    });
  };
  fabric.fabric.CustomVideo.fromObject = function(object, callback) {
    const objects = object.objects;
    const options = fabric.fabric.util.object.clone(object, true);
    delete options.objects;
    if (typeof objects === "string") {
      fabric.fabric.loadSVGFromURL(objects, function(elements) {
        const group = fabric.fabric.util.groupSVGElements(elements, object, objects);
        const clipPath = options.clipPath;
        delete options.clipPath;
        group.set(options);
        if (clipPath) {
          fabric.fabric.util.enlivenObjects([clipPath], function(elivenedObjects) {
            group.clipPath = elivenedObjects[0];
            callback && callback(group);
          });
        } else {
          callback && callback(group);
        }
      });
      return;
    }
    fabric.fabric.util.enlivenObjects(objects, function(enlivenedObjects) {
      fabric.fabric.util.enlivenObjectEnlivables(object, options, function() {
        if (enlivenedObjects.length) {
          callback && callback(new fabric.fabric.CustomVideo(enlivenedObjects, options, true));
        } else {
          callback && callback(null, true);
        }
      });
    });
  };
}
function createIconFromSVGElements(elements, options, path) {
  let object = null;
  if (options) {
    if (options.width && options.height) {
      options.centerPoint = {
        x: options.width / 2,
        y: options.height / 2
      };
    } else {
      delete options.width;
      delete options.height;
    }
  }
  object = new fabric.fabric.CustomIcon(elements, options);
  if (typeof path !== "undefined") {
    object.sourcePath = path;
  }
  return object;
}
const initCustomIcon = () => {
  fabric.fabric.CustomIcon = fabric.fabric.util.createClass(fabric.fabric.Group, {
    type: "CustomIcon",
    initialize: function(objects, options, isAlreadyGrouped) {
      this.callSuper("initialize", objects, options, isAlreadyGrouped);
    },
    toObject: function(propertiesToInclude) {
      return this.callSuper("toObject", propertiesToInclude);
    }
  });
  fabric.fabric.CustomIcon.fromURL = function(url, callback, options) {
    const customIconOption = options || {};
    customIconOption._src = url;
    fabric.fabric.loadSVGFromURL(url, function(objects, option) {
      customIconOption.width = option.width;
      customIconOption.height = option.height;
      const icon = createIconFromSVGElements(objects, { ...customIconOption });
      if (customIconOption.initColor) {
        const objs = icon._objects;
        for (let i = 0; i <= objs.length - 1; i++) {
          if (objs[i].fill) {
            objs[i].fill = icon.fill ? icon.fill : "";
          }
          if (objs[i].stroke) {
            objs[i].stroke = icon.stroke ? icon.stroke : "";
          }
        }
      }
      callback(icon);
    }, () => {
    }, {
      crossOrigin: "anonymous"
    });
  };
  fabric.fabric.CustomIcon.fromObject = function(object, callback) {
    if (object._src) {
      fabric.fabric.CustomIcon.fromURL(object._src, (icon) => {
        icon.setOptions(object);
        if (!Object.prototype.hasOwnProperty.call(object, "_needFill") || object._needFill) {
          const objs = icon._objects;
          for (let i = 0; i <= objs.length - 1; i++) {
            if (objs[i].fill) {
              objs[i].fill = icon.fill ? icon.fill : "";
            }
            if (objs[i].stroke) {
              objs[i].stroke = icon.stroke ? icon.stroke : "";
            }
          }
        }
        callback(icon);
      });
    } else {
      const objects = object.objects;
      const options = fabric.fabric.util.object.clone(object, true);
      delete options.objects;
      if (typeof objects === "string") {
        fabric.fabric.loadSVGFromURL(objects, function(elements) {
          const group = createIconFromSVGElements(elements, object, options);
          const clipPath = options.clipPath;
          delete options.clipPath;
          group.set(options);
          if (clipPath) {
            fabric.fabric.util.enlivenObjects([clipPath], function(elivenedObjects) {
              group.clipPath = elivenedObjects[0];
              callback && callback(group);
            });
          } else {
            callback && callback(group);
          }
        });
        return;
      }
      fabric.fabric.util.enlivenObjects(objects, function(enlivenedObjects) {
        fabric.fabric.util.enlivenObjectEnlivables(object, options, function() {
          callback && callback(new fabric.fabric.CustomIcon(enlivenedObjects, options, true));
        });
      });
    }
  };
};
const getAngle$1 = (startX, startY, endX, endY) => {
  const initialOffset = 0;
  const dx = endX - startX;
  const dy = endY - startY;
  let angle = Math.atan2(dy, dx);
  angle *= 180 / Math.PI;
  angle += initialOffset;
  return angle;
};
const initShapeLine = () => {
  fabric.fabric.ShapeLine = fabric.fabric.util.createClass(fabric.fabric.Line, {
    type: "ShapeLine",
    initialize: function(points, options) {
      const customOptions = options || {};
      this.startX = customOptions.left || points[0];
      this.startY = customOptions.top || points[1];
      const radians = fabric.fabric.util.degreesToRadians(customOptions.angle || 0);
      const hypotWidth = Math.hypot(points[2] - points[0], points[3] - points[1]);
      this.endX = customOptions.left ? customOptions.left + hypotWidth * Math.cos(radians) : points[2];
      this.endY = customOptions.top ? customOptions.left + hypotWidth * Math.sin(radians) : points[3];
      this.callSuper("initialize", points, {
        hasBorders: false,
        ...customOptions
      });
    },
    _set: function(key, value) {
      this.callSuper("_set", key, value);
      const customAttributes = ["left", "top", "angle", "width", "scaleX"];
      if (customAttributes.includes(key)) {
        this.startX = this.left;
        this.startY = this.top;
        const radians = fabric.fabric.util.degreesToRadians(this.angle);
        this.endX = this.left + this.width * this.scaleX * Math.cos(radians);
        this.endY = this.top + this.width * this.scaleX * Math.sin(radians);
      }
    },
    toObject: function(propertiesToInclude) {
      const tmpPropertiesToInclude = propertiesToInclude || [];
      return this.callSuper("toObject", [
        "startX",
        "startY",
        "endX",
        "endY",
        ...tmpPropertiesToInclude
      ]);
    },
    controls: {
      ml: new fabric.fabric.Control({
        x: -0.5,
        y: 0,
        actionHandler: function(eventData, transform, x, y) {
          const t = transform;
          const target = t.target;
          target.startX = x;
          target.startY = y;
          const lineAngle = getAngle$1(
            target.startX,
            target.startY,
            target.endX,
            target.endY
          );
          const hypotWidth = Math.hypot(target.endX - target.startX, target.endY - target.startY) / target.scaleX;
          target.set({
            width: hypotWidth,
            left: target.startX,
            top: target.startY,
            angle: lineAngle,
            originY: "center",
            startX: x,
            startY: y
          }).setCoords();
          return true;
        },
        render: fabric.fabric.Object.prototype.controls.ml.render
      }),
      mr: new fabric.fabric.Control({
        x: 0.5,
        y: 0,
        actionHandler: function(eventData, transform, x, y) {
          const t = transform;
          const target = t.target;
          target.endX = x;
          target.endY = y;
          const lineAngle = getAngle$1(
            target.startX,
            target.startY,
            target.endX,
            target.endY
          );
          const hypotWidth = Math.hypot(target.endX - target.startX, target.endY - target.startY) / target.scaleX;
          target.set({
            width: hypotWidth,
            left: target.startX,
            top: target.startY,
            angle: lineAngle,
            originY: "center",
            endX: x,
            endY: y
          }).setCoords();
          return true;
        },
        render: fabric.fabric.Object.prototype.controls.mr.render
      }),
      mtr: fabric.fabric.Object.prototype.controls.mtr
    },
    setAttributes: function(key, value) {
      this._set(key, value);
    },
    toCanvasElement: function(options) {
      options || (options = {});
      const utils = fabric.fabric.util;
      const origParams = utils.saveObjectTransform(this);
      const originalGroup = this.group;
      const originalShadow = this.shadow;
      const abs2 = Math.abs;
      const multiplier = (options.multiplier || 1) * (options.enableRetinaScaling ? fabric.fabric.devicePixelRatio : 1);
      delete this.group;
      if (options.withoutTransform) {
        utils.resetObjectTransform(this);
      }
      if (options.withoutShadow) {
        this.shadow = null;
      }
      const el = fabric.fabric.util.createCanvasElement();
      const boundingRect = this.getBoundingRect(false, true);
      const shadow = this.shadow;
      let scaling;
      const shadowOffset = { x: 0, y: 0 };
      let shadowBlur;
      let width;
      let height;
      if (shadow) {
        shadowBlur = shadow.blur;
        if (shadow.nonScaling) {
          scaling = { scaleX: 1, scaleY: 1 };
        } else {
          scaling = this.getObjectScaling();
        }
        shadowOffset.x = 2 * Math.round(abs2(shadow.offsetX) + shadowBlur) * abs2(scaling.scaleX);
        shadowOffset.y = 2 * Math.round(abs2(shadow.offsetY) + shadowBlur) * abs2(scaling.scaleY);
      }
      width = boundingRect.width + shadowOffset.x + this.strokeWidth * 1.5;
      height = boundingRect.height + shadowOffset.y + this.strokeWidth * 1.5;
      el.width = Math.ceil(width);
      el.height = Math.ceil(height);
      let canvas = new fabric.fabric.StaticCanvas(el, {
        enableRetinaScaling: false,
        renderOnAddRemove: false,
        skipOffscreen: false
      });
      if (options.format === "jpeg") {
        canvas.backgroundColor = "#fff";
      }
      this.setPositionByOrigin(new fabric.fabric.Point(canvas.width / 2, canvas.height / 2), "center", "center");
      const originalCanvas = this.canvas;
      canvas.add(this);
      const canvasEl = canvas.toCanvasElement(multiplier || 1, options);
      this.shadow = originalShadow;
      this.set("canvas", originalCanvas);
      if (originalGroup) {
        this.group = originalGroup;
      }
      this.set(origParams).setCoords();
      canvas._objects = [];
      canvas.dispose();
      canvas = null;
      return canvasEl;
    }
  });
  fabric.fabric.ShapeLine.fromObject = function(object, callback) {
    function _callback(instance) {
      delete instance.points;
      callback && callback(instance);
    }
    const options = fabric.fabric.util.object.clone(object, true);
    options.points = [object.x1, object.y1, object.x2, object.y2];
    fabric.fabric.Object._fromObject("ShapeLine", options, _callback, "points");
  };
  fabric.fabric.ShapeLine.generate = function(options) {
    options = options || {};
    const obj = new fabric.fabric.ShapeLine([20, 50, 320, 50], {
      stroke: "red",
      strokeWidth: 10,
      padding: 5,
      objectCaching: false,
      ...options
    });
    return obj;
  };
  if (fabric.fabric.Object.prototype.controls.lock) {
    fabric.fabric.ShapeLine.prototype.controls.lock = fabric.fabric.Object.prototype.controls.lock;
  }
};
const angleToRadian$1 = (angle) => {
  return angle * (Math.PI / 180);
};
const initShapeArrow = () => {
  fabric.fabric.ShapeArrow = fabric.fabric.util.createClass(fabric.fabric.ShapeLine, {
    type: "ShapeArrow",
    initialize: function(points, options) {
      const customOptions = options || {};
      this.callSuper("initialize", points, {
        ...customOptions
      });
    },
    toObject: function(propertiesToInclude) {
      const tmpPropertiesToInclude = propertiesToInclude || [];
      return this.callSuper("toObject", [
        ...tmpPropertiesToInclude
      ]);
    },
    _render: function(ctx) {
      const h = Math.sin(angleToRadian$1(60)) * this.strokeWidth * 3;
      const p = this.calcLinePoints();
      let offsetX = h;
      if (this.width <= h * 2) {
        offsetX = this.width / (2 * h) * h;
      }
      ctx.beginPath();
      ctx.moveTo(p.x1, p.y1);
      ctx.lineTo(p.x2 - offsetX, p.y2);
      ctx.lineWidth = this.strokeWidth;
      const origStrokeStyle = ctx.strokeStyle;
      ctx.strokeStyle = this.stroke || ctx.fillStyle;
      this.stroke && this._renderStroke(ctx);
      ctx.strokeStyle = origStrokeStyle;
      ctx.save();
      const xDiff = this.width;
      const yDiff = this.height;
      const angle = Math.atan2(yDiff, xDiff);
      ctx.translate(p.x2 - offsetX, p.y2);
      ctx.rotate(angle);
      ctx.beginPath();
      ctx.moveTo(h, 0);
      ctx.lineTo(0, -this.strokeWidth * 1.5);
      ctx.lineTo(0, this.strokeWidth * 1.5);
      ctx.closePath();
      ctx.fillStyle = this.stroke;
      ctx.fill();
      ctx.restore();
    }
  });
  fabric.fabric.ShapeArrow.fromObject = function(object, callback) {
    function _callback(instance) {
      delete instance.points;
      callback && callback(instance);
    }
    const options = fabric.fabric.util.object.clone(object, true);
    options.points = [object.x1, object.y1, object.x2, object.y2];
    fabric.fabric.Object._fromObject("ShapeArrow", options, _callback, "points");
  };
  fabric.fabric.ShapeArrow.generate = function(options) {
    options = options || {};
    const obj = new fabric.fabric.ShapeArrow([20, 50, 320, 50], {
      stroke: "red",
      strokeWidth: 10,
      padding: 5,
      objectCaching: false,
      ...options
    });
    return obj;
  };
};
const angleToRadian = (angle) => {
  return angle * (Math.PI / 180);
};
const initShapeDoubleArrow = () => {
  fabric.fabric.ShapeDoubleArrow = fabric.fabric.util.createClass(fabric.fabric.ShapeLine, {
    type: "ShapeDoubleArrow",
    initialize: function(points, options) {
      const customOptions = options || {};
      this.callSuper("initialize", points, {
        ...customOptions
      });
    },
    toObject: function(propertiesToInclude) {
      const tmpPropertiesToInclude = propertiesToInclude || [];
      return this.callSuper("toObject", [
        ...tmpPropertiesToInclude
      ]);
    },
    _render: function(ctx) {
      const h = Math.sin(angleToRadian(60)) * this.strokeWidth * 3;
      const p = this.calcLinePoints();
      let offsetX = h;
      if (this.width <= h * 2) {
        offsetX = this.width / (2 * h) * h;
      }
      ctx.beginPath();
      ctx.moveTo(p.x1 + offsetX, p.y1);
      ctx.lineTo(p.x2 - offsetX, p.y2);
      ctx.lineWidth = this.strokeWidth;
      const origStrokeStyle = ctx.strokeStyle;
      ctx.strokeStyle = this.stroke || ctx.fillStyle;
      this.stroke && this._renderStroke(ctx);
      ctx.strokeStyle = origStrokeStyle;
      ctx.save();
      const xDiff = this.width;
      const yDiff = this.height;
      const angle = Math.atan2(yDiff, xDiff);
      ctx.translate(p.x1 + offsetX, p.y1);
      ctx.rotate(angle + Math.PI);
      ctx.beginPath();
      ctx.moveTo(h, 0);
      ctx.lineTo(0, -this.strokeWidth * 1.5);
      ctx.lineTo(0, this.strokeWidth * 1.5);
      ctx.closePath();
      ctx.fillStyle = this.stroke;
      ctx.fill();
      ctx.restore();
      ctx.save();
      ctx.translate(p.x2 - offsetX, p.y2);
      ctx.rotate(angle);
      ctx.beginPath();
      ctx.moveTo(h, 0);
      ctx.lineTo(0, -this.strokeWidth * 1.5);
      ctx.lineTo(0, this.strokeWidth * 1.5);
      ctx.closePath();
      ctx.fillStyle = this.stroke;
      ctx.fill();
      ctx.restore();
    }
  });
  fabric.fabric.ShapeDoubleArrow.fromObject = function(object, callback) {
    function _callback(instance) {
      delete instance.points;
      callback && callback(instance);
    }
    const options = fabric.fabric.util.object.clone(object, true);
    options.points = [object.x1, object.y1, object.x2, object.y2];
    fabric.fabric.Object._fromObject("ShapeDoubleArrow", options, _callback, "points");
  };
  fabric.fabric.ShapeDoubleArrow.generate = function(options) {
    options = options || {};
    const obj = new fabric.fabric.ShapeDoubleArrow([20, 50, 320, 50], {
      stroke: "red",
      strokeWidth: 10,
      padding: 5,
      objectCaching: false,
      ...options
    });
    return obj;
  };
};
const LEFT$1 = "left";
const TOP$1 = "top";
const RIGHT$1 = "right";
const BOTTOM$1 = "bottom";
const CENTER$1 = "center";
const opposite$1 = {
  top: BOTTOM$1,
  bottom: TOP$1,
  left: RIGHT$1,
  right: LEFT$1,
  center: CENTER$1
};
function scalingIsForbidden$1(fabricObject, by, scaleProportionally) {
  const lockX = fabricObject.lockScalingX;
  const lockY = fabricObject.lockScalingY;
  if (lockX && lockY) {
    return true;
  }
  if (!by && (lockX || lockY) && scaleProportionally) {
    return true;
  }
  if (lockX && by === "x") {
    return true;
  }
  if (lockY && by === "y") {
    return true;
  }
  return false;
}
function scaleIsProportional$1(eventData, fabricObject) {
  const canvas = fabricObject.canvas;
  const uniScaleKey = canvas.uniScaleKey;
  const uniformIsToggled = eventData[uniScaleKey];
  return canvas.uniformScaling && !uniformIsToggled || !canvas.uniformScaling && uniformIsToggled;
}
function getLocalPoint$1(transform, originX, originY, x, y) {
  const target = transform.target;
  const control = target.controls[transform.corner];
  const zoom = target.canvas.getZoom();
  const padding = target.padding / zoom;
  const localPoint = target.toLocalPoint(new fabric.fabric.Point(x, y), originX, originY);
  if (localPoint.x >= padding) {
    localPoint.x -= padding;
  }
  if (localPoint.x <= -padding) {
    localPoint.x += padding;
  }
  if (localPoint.y >= padding) {
    localPoint.y -= padding;
  }
  if (localPoint.y <= padding) {
    localPoint.y += padding;
  }
  localPoint.x -= control.offsetX;
  localPoint.y -= control.offsetY;
  return localPoint;
}
function isTransformCentered$1(transform) {
  return transform.originX === CENTER$1 && transform.originY === CENTER$1;
}
function scaleObject$1(eventData, transform, x, y, options) {
  options = options || {};
  const target = transform.target;
  const lockScalingX = target.lockScalingX;
  const lockScalingY = target.lockScalingY;
  const by = options.by;
  let newPoint;
  let scaleX;
  let scaleY;
  let dim;
  const scaleProportionally = scaleIsProportional$1(eventData, target);
  const forbidScaling = scalingIsForbidden$1(target, by, scaleProportionally);
  let signX;
  let signY;
  const gestureScale = transform.gestureScale;
  if (forbidScaling) {
    return false;
  }
  if (gestureScale) {
    scaleX = transform.scaleX * gestureScale;
    scaleY = transform.scaleY * gestureScale;
  } else {
    newPoint = getLocalPoint$1(transform, transform.originX, transform.originY, x, y);
    signX = by !== "y" ? Math.sign(newPoint.x) : 1;
    signY = by !== "x" ? Math.sign(newPoint.y) : 1;
    if (!transform.signX) {
      transform.signX = signX;
    }
    if (!transform.signY) {
      transform.signY = signY;
    }
    if (transform.signX !== signX || transform.signY !== signY) {
      return false;
    }
    dim = target._getTransformedDimensions();
    if (scaleProportionally && !by) {
      const distance = Math.abs(newPoint.x) + Math.abs(newPoint.y);
      const original = transform.original;
      const originalDistance = Math.abs(dim.x * original.scaleX / target.scaleX) + Math.abs(dim.y * original.scaleY / target.scaleY);
      const scale = distance / originalDistance;
      scaleX = original.scaleX * scale;
      scaleY = original.scaleY * scale;
    } else {
      scaleX = Math.abs(newPoint.x * target.scaleX / dim.x);
      scaleY = Math.abs(newPoint.y * target.scaleY / dim.y);
    }
    if (isTransformCentered$1(transform)) {
      scaleX *= 2;
      scaleY *= 2;
    }
    if (transform.signX !== signX && by !== "y") {
      transform.originX = opposite$1[transform.originX];
      scaleX *= -1;
      transform.signX = signX;
    }
    if (transform.signY !== signY && by !== "x") {
      transform.originY = opposite$1[transform.originY];
      scaleY *= -1;
      transform.signY = signY;
    }
  }
  const oldWidth = target.width;
  const oldHeight = target.height;
  if (!by) {
    !lockScalingX && target.set("width", scaleX * target.width);
    !lockScalingY && target.set("height", scaleY * target.height);
  } else {
    by === "x" && target.set("width", scaleX * target.width);
    by === "y" && target.set("height", scaleY * target.height);
  }
  if (oldWidth !== target.width || oldHeight !== target.height) {
    const radians = fabric.fabric.util.degreesToRadians(target.angle);
    const cosAngle = Math.cos(radians);
    const sinAngle = Math.sin(radians);
    switch (options.control) {
      case "tl": {
        const newLeft = target.left - ((target.width - oldWidth) * cosAngle - (target.height - oldHeight) * sinAngle);
        const newTop = target.top - ((target.width - oldWidth) * sinAngle + (target.height - oldHeight) * cosAngle);
        target.set("left", newLeft);
        target.set("top", newTop);
        break;
      }
      case "tr": {
        const newLeft = target.left + (target.height - oldHeight) * sinAngle;
        const newTop = target.top - (target.height - oldHeight) * cosAngle;
        target.set("left", newLeft);
        target.set("top", newTop);
        break;
      }
      case "bl": {
        const newLeft = target.left - (target.width - oldWidth) * cosAngle;
        const newTop = target.top - (target.width - oldWidth) * sinAngle;
        target.set("left", newLeft);
        target.set("top", newTop);
        break;
      }
    }
  }
  return oldWidth !== target.width || oldHeight !== target.height;
}
const initShapeRect = () => {
  fabric.fabric.ShapeRect = fabric.fabric.util.createClass(fabric.fabric.Rect, {
    type: "ShapeRect",
    initialize: function(options) {
      options = options || {};
      this.callSuper("initialize", {
        strokeUniform: true,
        noScaleCache: false,
        paintFirst: "stroke",
        ...options
      });
    },
    toObject: function(propertiesToInclude) {
      return this.callSuper("toObject", propertiesToInclude);
    },
    _set: function(key, value) {
      switch (key) {
        case "scaleX":
          this.callSuper("_set", "width", this.width * value);
          break;
        case "scaleY":
          this.callSuper("_set", "height", this.height * value);
          break;
        default:
          this.callSuper("_set", key, value);
          break;
      }
    },
    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderFill: function(ctx) {
      if (!this.fill) {
        return;
      }
      ctx.save();
      const strokeWidth = this.group ? this.strokeWidth / this.group.scaleX : this.strokeWidth;
      const _width = this.width - strokeWidth > 0 ? this.width - strokeWidth : 0;
      const _height = this.height - strokeWidth > 0 ? this.height - strokeWidth : 0;
      let rx = this.rx ? Math.min(this.rx, _width / 2) : 0;
      let ry = this.ry ? Math.min(this.ry, _height / 2) : 0;
      rx = rx - strokeWidth / 2 > 0 ? rx - strokeWidth / 2 : 0;
      ry = ry - strokeWidth / 2 > 0 ? ry - strokeWidth / 2 : 0;
      const w = _width;
      const h = _height;
      const x = -_width / 2;
      const y = -_height / 2;
      const isRounded = rx !== 0 || ry !== 0;
      const k = 1 - 0.5522847498;
      ctx.beginPath();
      ctx.moveTo(x + rx, y);
      ctx.lineTo(x + w - rx, y);
      isRounded && ctx.bezierCurveTo(x + w - k * rx, y, x + w, y + k * ry, x + w, y + ry);
      ctx.lineTo(x + w, y + h - ry);
      isRounded && ctx.bezierCurveTo(x + w, y + h - k * ry, x + w - k * rx, y + h, x + w - rx, y + h);
      ctx.lineTo(x + rx, y + h);
      isRounded && ctx.bezierCurveTo(x + k * rx, y + h, x, y + h - k * ry, x, y + h - ry);
      ctx.lineTo(x, y + ry);
      isRounded && ctx.bezierCurveTo(x, y + k * ry, x + k * rx, y, x + rx, y);
      ctx.closePath();
      this._setFillStyles(ctx, this);
      if (this.fillRule === "evenodd") {
        ctx.fill("evenodd");
      } else {
        ctx.fill();
      }
      ctx.restore();
    },
    controls: {
      ml: new fabric.fabric.Control({
        // 左中控制点
        x: -0.5,
        y: 0,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleSkewCursorStyleHandler,
        getActionName: fabric.fabric.controlsUtils.scaleOrSkewActionName,
        actionHandler: function(eventData, transform, x, y) {
          const target = transform.target;
          const radians = fabric.fabric.util.degreesToRadians(target.angle);
          const cosAngle = Math.cos(radians);
          const sinAngle = Math.sin(radians);
          const cvs = target.canvas.getElement();
          const showW = parseFloat(cvs.style.width);
          const realW = cvs.width;
          const ratioW = realW / showW;
          const showH = parseFloat(cvs.style.height);
          const realH = cvs.height;
          const ratioH = realH / showH;
          const mX = ratioW * eventData.movementX;
          const mY = ratioH * eventData.movementY;
          const rotatedMovementX = mX * cosAngle + mY * sinAngle;
          if (target.width - rotatedMovementX >= 1) {
            target.set({
              width: target.width - rotatedMovementX,
              left: target.left + rotatedMovementX * cosAngle,
              top: target.top + rotatedMovementX * sinAngle,
              objectCaching: false
            }).setCoords();
          }
          return true;
        },
        render: fabric.fabric.Object.prototype.controls.ml.render
      }),
      mr: new fabric.fabric.Control({
        // 右中控制点
        x: 0.5,
        y: 0,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleSkewCursorStyleHandler,
        getActionName: fabric.fabric.controlsUtils.scaleOrSkewActionName,
        actionHandler: function(eventData, transform, x, y) {
          const target = transform.target;
          const radians = fabric.fabric.util.degreesToRadians(target.angle);
          const cosAngle = Math.cos(radians);
          const sinAngle = Math.sin(radians);
          const cvs = target.canvas.getElement();
          const showW = parseFloat(cvs.style.width);
          const realW = cvs.width;
          const ratioW = realW / showW;
          const showH = parseFloat(cvs.style.height);
          const realH = cvs.height;
          const ratioH = realH / showH;
          const mX = ratioW * eventData.movementX;
          const mY = ratioH * eventData.movementY;
          const rotatedMovementX = mX * cosAngle + mY * sinAngle;
          if (target.width + rotatedMovementX >= 1) {
            target.set({
              width: target.width + rotatedMovementX,
              objectCaching: false
            }).setCoords();
          }
          return true;
        },
        render: fabric.fabric.Object.prototype.controls.mr.render
      }),
      mt: new fabric.fabric.Control({
        // 上中控制点
        x: 0,
        y: -0.5,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleSkewCursorStyleHandler,
        getActionName: fabric.fabric.controlsUtils.scaleOrSkewActionName,
        actionHandler: function(eventData, transform, x, y) {
          const target = transform.target;
          const radians = fabric.fabric.util.degreesToRadians(target.angle);
          const cosAngle = Math.cos(radians);
          const sinAngle = Math.sin(radians);
          const cvs = target.canvas.getElement();
          const showW = parseFloat(cvs.style.width);
          const realW = cvs.width;
          const ratioW = realW / showW;
          const showH = parseFloat(cvs.style.height);
          const realH = cvs.height;
          const ratioH = realH / showH;
          const mX = ratioW * eventData.movementX;
          const mY = ratioH * eventData.movementY;
          const rotatedMovementY = mY * cosAngle - mX * sinAngle;
          if (target.height - rotatedMovementY >= 1) {
            target.set({
              height: target.height - rotatedMovementY,
              left: target.left - rotatedMovementY * sinAngle,
              top: target.top + rotatedMovementY * cosAngle,
              objectCaching: false
            }).setCoords();
          }
          return true;
        },
        render: fabric.fabric.Object.prototype.controls.mt.render
      }),
      mb: new fabric.fabric.Control({
        // 下中控制点
        x: 0,
        y: 0.5,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleSkewCursorStyleHandler,
        getActionName: fabric.fabric.controlsUtils.scaleOrSkewActionName,
        actionHandler: function(eventData, transform, x, y) {
          const target = transform.target;
          const radians = fabric.fabric.util.degreesToRadians(target.angle);
          const cosAngle = Math.cos(radians);
          const sinAngle = Math.sin(radians);
          const cvs = target.canvas.getElement();
          const showW = parseFloat(cvs.style.width);
          const realW = cvs.width;
          const ratioW = realW / showW;
          const showH = parseFloat(cvs.style.height);
          const realH = cvs.height;
          const ratioH = realH / showH;
          const mX = ratioW * eventData.movementX;
          const mY = ratioH * eventData.movementY;
          const rotatedMovementY = mY * cosAngle - mX * sinAngle;
          if (target.height + rotatedMovementY >= 1) {
            target.set({
              height: target.height + rotatedMovementY,
              objectCaching: false
            }).setCoords();
          }
          return true;
        },
        render: fabric.fabric.Object.prototype.controls.mb.render
      }),
      tl: new fabric.fabric.Control({
        // 左上控制点
        x: -0.5,
        y: -0.5,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleCursorStyleHandler,
        actionHandler: function(eventData, transform, x, y) {
          return scaleObject$1(eventData, transform, x, y, { control: "tl" });
        },
        render: fabric.fabric.Object.prototype.controls.tl.render
      }),
      tr: new fabric.fabric.Control({
        // 右上控制点
        x: 0.5,
        y: -0.5,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleCursorStyleHandler,
        actionHandler: function(eventData, transform, x, y) {
          return scaleObject$1(eventData, transform, x, y, { control: "tr" });
        },
        render: fabric.fabric.Object.prototype.controls.tr.render
      }),
      bl: new fabric.fabric.Control({
        // 左下控制点
        x: -0.5,
        y: 0.5,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleCursorStyleHandler,
        actionHandler: function(eventData, transform, x, y) {
          return scaleObject$1(eventData, transform, x, y, { control: "bl" });
        },
        render: fabric.fabric.Object.prototype.controls.bl.render
      }),
      br: new fabric.fabric.Control({
        // 右下控制点
        x: 0.5,
        y: 0.5,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleCursorStyleHandler,
        actionHandler: function(eventData, transform, x, y) {
          return scaleObject$1(eventData, transform, x, y, { control: "br" });
        },
        render: fabric.fabric.Object.prototype.controls.br.render
      }),
      mtr: fabric.fabric.Object.prototype.controls.mtr
    }
  });
  fabric.fabric.ShapeRect.fromObject = function(object, callback) {
    return fabric.fabric.Object._fromObject("ShapeRect", object, callback);
  };
  fabric.fabric.ShapeRect.generate = function(options) {
    const obj = new fabric.fabric.ShapeRect({
      width: 300,
      height: 300,
      fill: "transparent",
      // 设置填充为透明
      ...options
    });
    return obj;
  };
  if (fabric.fabric.Object.prototype.controls.lock) {
    fabric.fabric.ShapeRect.prototype.controls.lock = fabric.fabric.Object.prototype.controls.lock;
  }
};
const initCustomSticker = () => {
  fabric.fabric.CustomSticker = fabric.fabric.util.createClass(fabric.fabric.Image, {
    type: "CustomSticker",
    initialize: function(element, options) {
      this.callSuper("initialize", element, options);
      if (this._initWidth) {
        this.scaleToWidth(this._initWidth);
      }
      this.displayCoverFrame();
    },
    toObject: function(propertiesToInclude) {
      let properties = [];
      if (propertiesToInclude) {
        properties = properties.concat(propertiesToInclude);
      }
      return this.callSuper("toObject", [...properties, ...[
        "_startTime",
        "_curFrame",
        "_coverFrame",
        "_frameWidth",
        "_frameHeight",
        "_frameRate",
        "_totalFrames",
        "_columns",
        // 服务器使用的资源，仅动图有
        "_backend"
      ]]);
    },
    _startTime: -1,
    _curFrame: -1,
    _coverFrame: 0,
    _frameWidth: 1024,
    _frameHeight: 1024,
    _frameRate: 25,
    _totalFrames: 38,
    _columns: 25,
    _calculXY: function(frams) {
      const x = frams % this._columns;
      const y = Math.floor(frams / this._columns);
      return { x, y };
    },
    isStaticSticker: function() {
      return this._totalFrames === 1;
    },
    doAnimation: function(timestamp) {
      if (!this._startTime || this._startTime === -1) {
        this._startTime = timestamp;
      }
      let currentFrame = this.calculateFrameByTimestamp(timestamp - this._startTime);
      if (this._pauseFrame) {
        currentFrame = (currentFrame + this._pauseFrame) % (this._totalFrames - 1);
      }
      if (currentFrame === 0 && this._pauseFrame) {
        this._pauseFrame = void 0;
        this._startTime = timestamp;
      }
      if (currentFrame !== this._curFrame) {
        this._curFrame = currentFrame;
        this.displayFrame(this._curFrame);
      }
      this.animationId = requestAnimationFrame((timestamp2) => {
        this.doAnimation(timestamp2);
      });
    },
    displayCoverFrame: function() {
      this.displayFrame(this._coverFrame);
    },
    displayFrame: function(frameIdx) {
      const { x, y } = this._calculXY(frameIdx);
      this.cropX = x * this._frameWidth;
      this.cropY = y * this._frameHeight;
      this.set("dirty", true);
      if (this.canvas) {
        this.canvas.renderAll();
      }
    },
    calculateFrameByTimestamp(timestamp) {
      const oneFrameTime = 1e3 / this._frameRate;
      const elapsed = timestamp;
      const roundTime = oneFrameTime * this._totalFrames;
      const currentFrame = Math.floor(elapsed % roundTime / oneFrameTime);
      return currentFrame;
    },
    displayFrameByTimestamp: function(timestamp) {
      if (this.isStaticSticker()) return;
      const currentFrame = this.calculateFrameByTimestamp(timestamp);
      this.displayFrame(currentFrame);
    },
    play: function() {
      if (this.isStaticSticker()) return;
      if (this.animationId) return;
      this._startTime = -1;
      this.animationId = requestAnimationFrame((timestamp) => {
        this.doAnimation(timestamp);
      });
    },
    pause: function(reset = true) {
      if (this.isStaticSticker()) return;
      if (this.animationId) {
        this._startTime = -1;
        window.cancelAnimationFrame(this.animationId);
        this.animationId = void 0;
        if (reset) {
          this._curFrame = 0;
          this.displayCoverFrame();
        } else {
          this._pauseFrame = this._curFrame;
        }
      }
    }
  });
  fabric.fabric.CustomSticker.fromObject = function(_object, callback) {
    const object = fabric.fabric.util.object.clone(_object);
    fabric.fabric.util.loadImage(object.src, function(img, isError) {
      if (isError) {
        callback && callback(null, true);
        return;
      }
      fabric.fabric.AvatarImage.prototype._initFilters.call(object, object.filters, function(filters) {
        object.filters = filters || [];
        fabric.fabric.AvatarImage.prototype._initFilters.call(object, [object.resizeFilter], function(resizeFilters) {
          object.resizeFilter = resizeFilters[0];
          fabric.fabric.util.enlivenObjectEnlivables(object, object, function() {
            const image = new fabric.fabric.CustomSticker(img, object);
            callback(image, false);
          });
        });
      });
    }, null, object.crossOrigin);
  };
  fabric.fabric.CustomSticker.fromURL = function(coverUrl, callback, options) {
    fabric.fabric.util.loadImage(coverUrl, function(img, isError) {
      const sticker = new fabric.fabric.CustomSticker(img, options);
      callback && callback(sticker, isError);
    }, null, { ...options, crossOrigin: "anonymous" });
  };
};
function getPreviousNoZ(e, i, a) {
  const counter = i - 1;
  const previous = a[mod(counter, a.length)];
  if (previous.marker !== "Z") {
    return previous;
  } else {
    return getPreviousNoZ(e, counter, a);
  }
}
function getNextNoZ(e, i, a) {
  const counter = i + 1;
  const next = a[mod(counter, a.length)];
  if (next.marker === "Z") {
    return getNextNoZ(e, counter, a);
  } else {
    return next;
  }
}
function convertToAbsolute(el, index, arr) {
  let prev = arr[index - 1] || { values: { x: 0, y: 0 } };
  if (el.marker === el.marker.toLowerCase()) {
    el.marker = el.marker.toUpperCase();
    switch (el.marker) {
      case "M":
        el.values.x += prev.values.x;
        el.values.y += prev.values.y;
        break;
      case "L":
      case "A":
        el.values.x += prev.values.x;
        el.values.y += prev.values.y;
        break;
      case "H":
        el.marker = "L";
        el.values.x += prev.values.x;
        el.values.y = prev.values.y;
        break;
      case "V":
        el.marker = "L";
        el.values.x = prev.values.x;
        el.values.y += prev.values.y;
        break;
      case "C":
        el.values.x += prev.values.x;
        el.values.y += prev.values.y;
        el.values.x1 += prev.values.x;
        el.values.y1 += prev.values.y;
        el.values.x2 += prev.values.x;
        el.values.y2 += prev.values.y;
        break;
      case "S":
        el.values.x += prev.values.x;
        el.values.y += prev.values.y;
        el.values.x2 += prev.values.x;
        el.values.y2 += prev.values.y;
        break;
      case "Q":
        el.values.x += prev.values.x;
        el.values.y += prev.values.y;
        el.values.x1 += prev.values.x;
        el.values.y1 += prev.values.y;
        break;
      case "T":
        el.values.x += prev.values.x;
        el.values.y += prev.values.y;
        break;
    }
  } else if (el.marker === el.marker.toUpperCase()) {
    switch (el.marker) {
      case "H":
        el.marker = "L";
        el.values.y = prev.values.y;
        break;
      case "V":
        el.marker = "L";
        el.values.x = prev.values.x;
        break;
    }
  }
  if (el.marker === "Z") {
    let rec = function(arr2, i) {
      if (arr2[i].marker === "M") {
        return arr2[i];
      } else {
        return rec(arr2, i - 1);
      }
    };
    let mBefore = rec(arr, index);
    el.values.x = mBefore.values.x;
    el.values.y = mBefore.values.y;
  }
  return el;
}
function newCommands(marker, values) {
  const cmds = [];
  switch (marker.toUpperCase()) {
    case "M":
      for (let i = 0; i < values.length; i += 2) {
        let m;
        if (marker === marker.toUpperCase()) {
          m = i === 0 ? "M" : "L";
        } else {
          m = i === 0 ? "m" : "l";
        }
        cmds.push({
          marker: m,
          values: {
            x: values[i],
            y: values[i + 1]
          }
        });
      }
      break;
    case "L":
      for (let i = 0; i < values.length; i += 2) {
        cmds.push({
          marker,
          values: {
            x: values[i],
            y: values[i + 1]
          }
        });
      }
      break;
    case "H":
      for (let i = 0; i < values.length; i++) {
        cmds.push({
          marker,
          values: {
            x: values[i],
            y: 0
          }
        });
      }
      break;
    case "V":
      for (let i = 0; i < values.length; i++) {
        cmds.push({
          marker,
          values: {
            x: 0,
            y: values[i]
          }
        });
      }
      break;
    case "C":
      for (let i = 0; i < values.length; i += 6) {
        cmds.push({
          marker,
          values: {
            x1: values[i],
            y1: values[i + 1],
            x2: values[i + 2],
            y2: values[i + 3],
            x: values[i + 4],
            y: values[i + 5]
          }
        });
      }
      break;
    case "S":
      for (let i = 0; i < values.length; i += 4) {
        cmds.push({
          marker,
          values: {
            x2: values[i],
            y2: values[i + 1],
            x: values[i + 2],
            y: values[i + 3]
          }
        });
      }
      break;
    case "Q":
      for (let i = 0; i < values.length; i += 4) {
        cmds.push({
          marker,
          values: {
            x1: values[i],
            y1: values[i + 1],
            x: values[i + 2],
            y: values[i + 3]
          }
        });
      }
      break;
    case "T":
      for (let i = 0; i < values.length; i += 2) {
        cmds.push({
          marker,
          values: {
            x: values[i],
            y: values[i + 1]
          }
        });
      }
      break;
    case "A":
      for (let i = 0; i < values.length; i += 7) {
        cmds.push({
          marker,
          values: {
            radiusX: values[i],
            radiusY: values[i + 1],
            rotation: values[i + 2],
            largeArc: values[i + 3],
            sweep: values[i + 4],
            x: values[i + 5],
            y: values[i + 6]
          }
        });
      }
      break;
    case "Z":
      cmds.push({
        marker,
        values: {
          // values will be overriden later by convertToAbsolute()
          x: 0,
          y: 0
        }
      });
      break;
  }
  return cmds;
}
function mod(x, m) {
  return (x % m + m) % m;
}
function markOverlapped(el, index, array) {
  if (index !== 0 && el.marker === "L") {
    let previous = array[index - 1];
    const overlap = ["x", "y"].every((key) => {
      return Math.round(Math.abs(previous.values[key] - el.values[key])) === 0;
    });
    if (overlap) {
      el.overlap = true;
    }
  }
  return el;
}
function reverseMarkOverlapped(cmds, counter) {
  const overlap = ["x", "y"].every((key) => {
    return Math.round(Math.abs(cmds[counter].values[key] - cmds[0].values[key])) === 0;
  });
  if (cmds[counter].marker === "L" && overlap) {
    cmds[counter].overlap = true;
    reverseMarkOverlapped(cmds, counter - 1);
  }
  if (cmds[counter].marker === "Z") {
    reverseMarkOverlapped(cmds, counter - 1);
  }
}
function shortestSide(el, previous, next) {
  const nxtSide = getDistance$1(el.values, next.values);
  const prvSide = getDistance$1(previous.values, el.values);
  return Math.min(prvSide, nxtSide);
}
function getAngle(p1, p2) {
  return Math.atan2(p2.x - p1.x, p2.y - p1.y);
}
function getDistance$1(p1, p2) {
  const xDiff = p1.x - p2.x;
  const yDiff = p1.y - p2.y;
  return Math.sqrt(Math.pow(xDiff, 2) + Math.pow(yDiff, 2));
}
function getOppositeLength(angle, hip) {
  return Math.sin(angle) * hip;
}
function getAdjacentLength(angle, hip) {
  return Math.cos(angle) * hip;
}
function getTangentLength(angle, opposite2) {
  const a = opposite2 / Math.tan(angle);
  if (a === Infinity || a === -Infinity || isNaN(a)) {
    return opposite2;
  }
  return a;
}
function getTangentNoHyp(angle, adjacent) {
  return adjacent * Math.tan(angle);
}
function getOffset(angle, r) {
  let offset;
  let sweepFlag = 0;
  let degrees = angle * (180 / Math.PI);
  if (degrees < 0 && degrees >= -180 || degrees > 180 && degrees < 360) {
    offset = getTangentLength(angle / 2, -r);
  } else {
    offset = getTangentLength(angle / 2, r);
    sweepFlag = 1;
    if (offset === Infinity) {
      offset = r;
    }
  }
  return {
    offset,
    sweepFlag
  };
}
function commandsToSvgPath(cmds) {
  const valuesOrder = [
    "radiusX",
    "radiusY",
    "rotation",
    "largeArc",
    "sweep",
    "x1",
    "y1",
    "x2",
    "y2",
    "x",
    "y"
  ];
  return cmds.map((cmd) => {
    let d = "";
    if (cmd.marker !== "Z") {
      const cmdKeys = Object.keys(cmd.values);
      d = valuesOrder.filter((v) => cmdKeys.indexOf(v) !== -1).map((key) => cmd.values[key]).join();
    }
    return `${cmd.marker}${d}`;
  }).join("").trim();
}
function parsePath(str) {
  const markerRegEx = /[MmLlSsQqLlHhVvCcSsQqTtAaZz]/g;
  const digitRegEx = /-?[0-9]*\.?\d+/g;
  return [...str.matchAll(markerRegEx)].map((match) => {
    return { marker: match[0], index: match.index };
  }).reduceRight((acc, cur) => {
    const chunk = str.substring(
      cur.index,
      acc.length ? acc[acc.length - 1].index : str.length
    );
    return acc.concat([
      {
        marker: cur.marker,
        index: cur.index,
        chunk: chunk.length > 0 ? chunk.substr(1, chunk.length - 1) : chunk
      }
    ]);
  }, []).reverse().flatMap((cmd) => {
    const values = cmd.chunk.match(digitRegEx);
    const vals = values ? values.map(parseFloat) : [];
    return newCommands(cmd.marker, vals);
  }).map(convertToAbsolute);
}
function roundCommands(cmds, r, round2) {
  let subpaths = [];
  let newCmds = [];
  cmds.forEach((e) => {
    if (e.marker === "M") {
      subpaths.push([]);
    }
    subpaths[subpaths.length - 1].push(e);
  });
  subpaths.forEach((subPathCmds) => {
    subPathCmds.map(markOverlapped);
    reverseMarkOverlapped(subPathCmds, subPathCmds.length - 1);
    const closedPath = subPathCmds[subPathCmds.length - 1].marker == "Z";
    subPathCmds.filter((el) => !el.overlap).map((el, i, arr) => {
      const largeArcFlag = 0;
      const prev = getPreviousNoZ(el, i, arr);
      const next = getNextNoZ(el, i, arr);
      const anglePrv = getAngle(el.values, prev.values);
      const angleNxt = getAngle(el.values, next.values);
      const angle = angleNxt - anglePrv;
      const degrees = angle * (180 / Math.PI);
      const shortest = shortestSide(el, prev, next);
      const maxRadius = Math.abs(getTangentNoHyp(angle / 2, shortest / 2));
      const radius = Math.min(r, maxRadius);
      const o = getOffset(angle, radius);
      const offset = o.offset;
      const sweepFlag = o.sweepFlag;
      const openFirstOrLast = (i == 0 || i == arr.length - 1) && !closedPath;
      switch (el.marker) {
        case "M":
        case "L":
          const prevPoint = [
            el.values.x + getOppositeLength(anglePrv, offset),
            el.values.y + getAdjacentLength(anglePrv, offset)
          ];
          const nextPoint = [
            el.values.x + getOppositeLength(angleNxt, offset),
            el.values.y + getAdjacentLength(angleNxt, offset)
          ];
          if (!openFirstOrLast) {
            newCmds.push({
              marker: el.marker,
              values: {
                x: parseFloat(prevPoint[0].toFixed(3)),
                y: parseFloat(prevPoint[1].toFixed(3))
              }
            });
          } else {
            newCmds.push({
              marker: el.marker,
              values: el.values
            });
          }
          if (!openFirstOrLast && (next.marker === "L" || next.marker === "M")) {
            newCmds.push({
              marker: "A",
              radius,
              values: {
                radiusX: parseFloat(radius.toFixed(3)),
                radiusY: parseFloat(radius.toFixed(3)),
                rotation: degrees,
                largeArc: largeArcFlag,
                sweep: sweepFlag,
                x: parseFloat(nextPoint[0].toFixed(3)),
                y: parseFloat(nextPoint[1].toFixed(3))
              }
            });
          }
          break;
        case "C":
        case "S":
        case "Q":
        case "T":
        case "A":
        case "Z":
          newCmds.push({ marker: el.marker, values: el.values });
          break;
      }
    });
  });
  return {
    path: commandsToSvgPath(newCmds),
    commands: newCmds
  };
}
function roundCorners(str, r, round2) {
  return roundCommands([...parsePath(str)], r);
}
var paramCounts = { a: 7, c: 6, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, z: 0 };
var SPECIAL_SPACES = [
  5760,
  6158,
  8192,
  8193,
  8194,
  8195,
  8196,
  8197,
  8198,
  8199,
  8200,
  8201,
  8202,
  8239,
  8287,
  12288,
  65279
];
function isSpace(ch) {
  return ch === 10 || ch === 13 || ch === 8232 || ch === 8233 || // Line terminators
  // White spaces
  ch === 32 || ch === 9 || ch === 11 || ch === 12 || ch === 160 || ch >= 5760 && SPECIAL_SPACES.indexOf(ch) >= 0;
}
function isCommand(code) {
  switch (code | 32) {
    case 109:
    case 122:
    case 108:
    case 104:
    case 118:
    case 99:
    case 115:
    case 113:
    case 116:
    case 97:
    case 114:
      return true;
  }
  return false;
}
function isArc(code) {
  return (code | 32) === 97;
}
function isDigit(code) {
  return code >= 48 && code <= 57;
}
function isDigitStart(code) {
  return code >= 48 && code <= 57 || /* 0..9 */
  code === 43 || /* + */
  code === 45 || /* - */
  code === 46;
}
function State(path) {
  this.index = 0;
  this.path = path;
  this.max = path.length;
  this.result = [];
  this.param = 0;
  this.err = "";
  this.segmentStart = 0;
  this.data = [];
}
function skipSpaces(state) {
  while (state.index < state.max && isSpace(state.path.charCodeAt(state.index))) {
    state.index++;
  }
}
function scanFlag(state) {
  var ch = state.path.charCodeAt(state.index);
  if (ch === 48) {
    state.param = 0;
    state.index++;
    return;
  }
  if (ch === 49) {
    state.param = 1;
    state.index++;
    return;
  }
  state.err = "SvgPath: arc flag can be 0 or 1 only (at pos " + state.index + ")";
}
function scanParam(state) {
  var start = state.index, index = start, max2 = state.max, zeroFirst = false, hasCeiling = false, hasDecimal = false, hasDot = false, ch;
  if (index >= max2) {
    state.err = "SvgPath: missed param (at pos " + index + ")";
    return;
  }
  ch = state.path.charCodeAt(index);
  if (ch === 43 || ch === 45) {
    index++;
    ch = index < max2 ? state.path.charCodeAt(index) : 0;
  }
  if (!isDigit(ch) && ch !== 46) {
    state.err = "SvgPath: param should start with 0..9 or `.` (at pos " + index + ")";
    return;
  }
  if (ch !== 46) {
    zeroFirst = ch === 48;
    index++;
    ch = index < max2 ? state.path.charCodeAt(index) : 0;
    if (zeroFirst && index < max2) {
      if (ch && isDigit(ch)) {
        state.err = "SvgPath: numbers started with `0` such as `09` are illegal (at pos " + start + ")";
        return;
      }
    }
    while (index < max2 && isDigit(state.path.charCodeAt(index))) {
      index++;
      hasCeiling = true;
    }
    ch = index < max2 ? state.path.charCodeAt(index) : 0;
  }
  if (ch === 46) {
    hasDot = true;
    index++;
    while (isDigit(state.path.charCodeAt(index))) {
      index++;
      hasDecimal = true;
    }
    ch = index < max2 ? state.path.charCodeAt(index) : 0;
  }
  if (ch === 101 || ch === 69) {
    if (hasDot && !hasCeiling && !hasDecimal) {
      state.err = "SvgPath: invalid float exponent (at pos " + index + ")";
      return;
    }
    index++;
    ch = index < max2 ? state.path.charCodeAt(index) : 0;
    if (ch === 43 || ch === 45) {
      index++;
    }
    if (index < max2 && isDigit(state.path.charCodeAt(index))) {
      while (index < max2 && isDigit(state.path.charCodeAt(index))) {
        index++;
      }
    } else {
      state.err = "SvgPath: invalid float exponent (at pos " + index + ")";
      return;
    }
  }
  state.index = index;
  state.param = parseFloat(state.path.slice(start, index)) + 0;
}
function finalizeSegment(state) {
  var cmd, cmdLC;
  cmd = state.path[state.segmentStart];
  cmdLC = cmd.toLowerCase();
  var params = state.data;
  if (cmdLC === "m" && params.length > 2) {
    state.result.push([cmd, params[0], params[1]]);
    params = params.slice(2);
    cmdLC = "l";
    cmd = cmd === "m" ? "l" : "L";
  }
  if (cmdLC === "r") {
    state.result.push([cmd].concat(params));
  } else {
    while (params.length >= paramCounts[cmdLC]) {
      state.result.push([cmd].concat(params.splice(0, paramCounts[cmdLC])));
      if (!paramCounts[cmdLC]) {
        break;
      }
    }
  }
}
function scanSegment(state) {
  var max2 = state.max, cmdCode, is_arc, comma_found, need_params, i;
  state.segmentStart = state.index;
  cmdCode = state.path.charCodeAt(state.index);
  is_arc = isArc(cmdCode);
  if (!isCommand(cmdCode)) {
    state.err = "SvgPath: bad command " + state.path[state.index] + " (at pos " + state.index + ")";
    return;
  }
  need_params = paramCounts[state.path[state.index].toLowerCase()];
  state.index++;
  skipSpaces(state);
  state.data = [];
  if (!need_params) {
    finalizeSegment(state);
    return;
  }
  comma_found = false;
  for (; ; ) {
    for (i = need_params; i > 0; i--) {
      if (is_arc && (i === 3 || i === 4)) scanFlag(state);
      else scanParam(state);
      if (state.err.length) {
        finalizeSegment(state);
        return;
      }
      state.data.push(state.param);
      skipSpaces(state);
      comma_found = false;
      if (state.index < max2 && state.path.charCodeAt(state.index) === 44) {
        state.index++;
        skipSpaces(state);
        comma_found = true;
      }
    }
    if (comma_found) {
      continue;
    }
    if (state.index >= state.max) {
      break;
    }
    if (!isDigitStart(state.path.charCodeAt(state.index))) {
      break;
    }
  }
  finalizeSegment(state);
}
var path_parse = function pathParse(svgPath2) {
  var state = new State(svgPath2);
  var max2 = state.max;
  skipSpaces(state);
  while (state.index < max2 && !state.err.length) {
    scanSegment(state);
  }
  if (state.result.length) {
    if ("mM".indexOf(state.result[0][0]) < 0) {
      state.err = "SvgPath: string should start with `M` or `m`";
      state.result = [];
    } else {
      state.result[0][0] = "M";
    }
  }
  return {
    err: state.err,
    segments: state.result
  };
};
function combine(m1, m2) {
  return [
    m1[0] * m2[0] + m1[2] * m2[1],
    m1[1] * m2[0] + m1[3] * m2[1],
    m1[0] * m2[2] + m1[2] * m2[3],
    m1[1] * m2[2] + m1[3] * m2[3],
    m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
    m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
  ];
}
function Matrix$1() {
  if (!(this instanceof Matrix$1)) {
    return new Matrix$1();
  }
  this.queue = [];
  this.cache = null;
}
Matrix$1.prototype.matrix = function(m) {
  if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1 && m[4] === 0 && m[5] === 0) {
    return this;
  }
  this.cache = null;
  this.queue.push(m);
  return this;
};
Matrix$1.prototype.translate = function(tx, ty) {
  if (tx !== 0 || ty !== 0) {
    this.cache = null;
    this.queue.push([1, 0, 0, 1, tx, ty]);
  }
  return this;
};
Matrix$1.prototype.scale = function(sx, sy) {
  if (sx !== 1 || sy !== 1) {
    this.cache = null;
    this.queue.push([sx, 0, 0, sy, 0, 0]);
  }
  return this;
};
Matrix$1.prototype.rotate = function(angle, rx, ry) {
  var rad, cos2, sin2;
  if (angle !== 0) {
    this.translate(rx, ry);
    rad = angle * Math.PI / 180;
    cos2 = Math.cos(rad);
    sin2 = Math.sin(rad);
    this.queue.push([cos2, sin2, -sin2, cos2, 0, 0]);
    this.cache = null;
    this.translate(-rx, -ry);
  }
  return this;
};
Matrix$1.prototype.skewX = function(angle) {
  if (angle !== 0) {
    this.cache = null;
    this.queue.push([1, 0, Math.tan(angle * Math.PI / 180), 1, 0, 0]);
  }
  return this;
};
Matrix$1.prototype.skewY = function(angle) {
  if (angle !== 0) {
    this.cache = null;
    this.queue.push([1, Math.tan(angle * Math.PI / 180), 0, 1, 0, 0]);
  }
  return this;
};
Matrix$1.prototype.toArray = function() {
  if (this.cache) {
    return this.cache;
  }
  if (!this.queue.length) {
    this.cache = [1, 0, 0, 1, 0, 0];
    return this.cache;
  }
  this.cache = this.queue[0];
  if (this.queue.length === 1) {
    return this.cache;
  }
  for (var i = 1; i < this.queue.length; i++) {
    this.cache = combine(this.cache, this.queue[i]);
  }
  return this.cache;
};
Matrix$1.prototype.calc = function(x, y, isRelative) {
  var m;
  if (!this.queue.length) {
    return [x, y];
  }
  if (!this.cache) {
    this.cache = this.toArray();
  }
  m = this.cache;
  return [
    x * m[0] + y * m[2] + (isRelative ? 0 : m[4]),
    x * m[1] + y * m[3] + (isRelative ? 0 : m[5])
  ];
};
var matrix$1 = Matrix$1;
var Matrix = matrix$1;
var operations = {
  matrix: true,
  scale: true,
  rotate: true,
  translate: true,
  skewX: true,
  skewY: true
};
var CMD_SPLIT_RE = /\s*(matrix|translate|scale|rotate|skewX|skewY)\s*\(\s*(.+?)\s*\)[\s,]*/;
var PARAMS_SPLIT_RE = /[\s,]+/;
var transform_parse = function transformParse(transformString) {
  var matrix2 = new Matrix();
  var cmd, params;
  transformString.split(CMD_SPLIT_RE).forEach(function(item) {
    if (!item.length) {
      return;
    }
    if (typeof operations[item] !== "undefined") {
      cmd = item;
      return;
    }
    params = item.split(PARAMS_SPLIT_RE).map(function(i) {
      return +i || 0;
    });
    switch (cmd) {
      case "matrix":
        if (params.length === 6) {
          matrix2.matrix(params);
        }
        return;
      case "scale":
        if (params.length === 1) {
          matrix2.scale(params[0], params[0]);
        } else if (params.length === 2) {
          matrix2.scale(params[0], params[1]);
        }
        return;
      case "rotate":
        if (params.length === 1) {
          matrix2.rotate(params[0], 0, 0);
        } else if (params.length === 3) {
          matrix2.rotate(params[0], params[1], params[2]);
        }
        return;
      case "translate":
        if (params.length === 1) {
          matrix2.translate(params[0], 0);
        } else if (params.length === 2) {
          matrix2.translate(params[0], params[1]);
        }
        return;
      case "skewX":
        if (params.length === 1) {
          matrix2.skewX(params[0]);
        }
        return;
      case "skewY":
        if (params.length === 1) {
          matrix2.skewY(params[0]);
        }
        return;
    }
  });
  return matrix2;
};
var TAU = Math.PI * 2;
function unit_vector_angle(ux, uy, vx, vy) {
  var sign2 = ux * vy - uy * vx < 0 ? -1 : 1;
  var dot = ux * vx + uy * vy;
  if (dot > 1) {
    dot = 1;
  }
  if (dot < -1) {
    dot = -1;
  }
  return sign2 * Math.acos(dot);
}
function get_arc_center(x1, y1, x2, y2, fa, fs, rx, ry, sin_phi, cos_phi) {
  var x1p = cos_phi * (x1 - x2) / 2 + sin_phi * (y1 - y2) / 2;
  var y1p = -sin_phi * (x1 - x2) / 2 + cos_phi * (y1 - y2) / 2;
  var rx_sq = rx * rx;
  var ry_sq = ry * ry;
  var x1p_sq = x1p * x1p;
  var y1p_sq = y1p * y1p;
  var radicant = rx_sq * ry_sq - rx_sq * y1p_sq - ry_sq * x1p_sq;
  if (radicant < 0) {
    radicant = 0;
  }
  radicant /= rx_sq * y1p_sq + ry_sq * x1p_sq;
  radicant = Math.sqrt(radicant) * (fa === fs ? -1 : 1);
  var cxp = radicant * rx / ry * y1p;
  var cyp = radicant * -ry / rx * x1p;
  var cx = cos_phi * cxp - sin_phi * cyp + (x1 + x2) / 2;
  var cy = sin_phi * cxp + cos_phi * cyp + (y1 + y2) / 2;
  var v1x = (x1p - cxp) / rx;
  var v1y = (y1p - cyp) / ry;
  var v2x = (-x1p - cxp) / rx;
  var v2y = (-y1p - cyp) / ry;
  var theta1 = unit_vector_angle(1, 0, v1x, v1y);
  var delta_theta = unit_vector_angle(v1x, v1y, v2x, v2y);
  if (fs === 0 && delta_theta > 0) {
    delta_theta -= TAU;
  }
  if (fs === 1 && delta_theta < 0) {
    delta_theta += TAU;
  }
  return [cx, cy, theta1, delta_theta];
}
function approximate_unit_arc(theta1, delta_theta) {
  var alpha = 4 / 3 * Math.tan(delta_theta / 4);
  var x1 = Math.cos(theta1);
  var y1 = Math.sin(theta1);
  var x2 = Math.cos(theta1 + delta_theta);
  var y2 = Math.sin(theta1 + delta_theta);
  return [x1, y1, x1 - y1 * alpha, y1 + x1 * alpha, x2 + y2 * alpha, y2 - x2 * alpha, x2, y2];
}
var a2c$1 = function a2c(x1, y1, x2, y2, fa, fs, rx, ry, phi) {
  var sin_phi = Math.sin(phi * TAU / 360);
  var cos_phi = Math.cos(phi * TAU / 360);
  var x1p = cos_phi * (x1 - x2) / 2 + sin_phi * (y1 - y2) / 2;
  var y1p = -sin_phi * (x1 - x2) / 2 + cos_phi * (y1 - y2) / 2;
  if (x1p === 0 && y1p === 0) {
    return [];
  }
  if (rx === 0 || ry === 0) {
    return [];
  }
  rx = Math.abs(rx);
  ry = Math.abs(ry);
  var lambda = x1p * x1p / (rx * rx) + y1p * y1p / (ry * ry);
  if (lambda > 1) {
    rx *= Math.sqrt(lambda);
    ry *= Math.sqrt(lambda);
  }
  var cc = get_arc_center(x1, y1, x2, y2, fa, fs, rx, ry, sin_phi, cos_phi);
  var result = [];
  var theta1 = cc[2];
  var delta_theta = cc[3];
  var segments = Math.max(Math.ceil(Math.abs(delta_theta) / (TAU / 4)), 1);
  delta_theta /= segments;
  for (var i = 0; i < segments; i++) {
    result.push(approximate_unit_arc(theta1, delta_theta));
    theta1 += delta_theta;
  }
  return result.map(function(curve) {
    for (var i2 = 0; i2 < curve.length; i2 += 2) {
      var x = curve[i2 + 0];
      var y = curve[i2 + 1];
      x *= rx;
      y *= ry;
      var xp = cos_phi * x - sin_phi * y;
      var yp = sin_phi * x + cos_phi * y;
      curve[i2 + 0] = xp + cc[0];
      curve[i2 + 1] = yp + cc[1];
    }
    return curve;
  });
};
var epsilon = 1e-10;
var torad = Math.PI / 180;
function Ellipse(rx, ry, ax) {
  if (!(this instanceof Ellipse)) {
    return new Ellipse(rx, ry, ax);
  }
  this.rx = rx;
  this.ry = ry;
  this.ax = ax;
}
Ellipse.prototype.transform = function(m) {
  var c = Math.cos(this.ax * torad), s = Math.sin(this.ax * torad);
  var ma = [
    this.rx * (m[0] * c + m[2] * s),
    this.rx * (m[1] * c + m[3] * s),
    this.ry * (-m[0] * s + m[2] * c),
    this.ry * (-m[1] * s + m[3] * c)
  ];
  var J = ma[0] * ma[0] + ma[2] * ma[2], K = ma[1] * ma[1] + ma[3] * ma[3];
  var D = ((ma[0] - ma[3]) * (ma[0] - ma[3]) + (ma[2] + ma[1]) * (ma[2] + ma[1])) * ((ma[0] + ma[3]) * (ma[0] + ma[3]) + (ma[2] - ma[1]) * (ma[2] - ma[1]));
  var JK = (J + K) / 2;
  if (D < epsilon * JK) {
    this.rx = this.ry = Math.sqrt(JK);
    this.ax = 0;
    return this;
  }
  var L = ma[0] * ma[1] + ma[2] * ma[3];
  D = Math.sqrt(D);
  var l1 = JK + D / 2, l2 = JK - D / 2;
  this.ax = Math.abs(L) < epsilon && Math.abs(l1 - K) < epsilon ? 90 : Math.atan(
    Math.abs(L) > Math.abs(l1 - K) ? (l1 - J) / L : L / (l1 - K)
  ) * 180 / Math.PI;
  if (this.ax >= 0) {
    this.rx = Math.sqrt(l1);
    this.ry = Math.sqrt(l2);
  } else {
    this.ax += 90;
    this.rx = Math.sqrt(l2);
    this.ry = Math.sqrt(l1);
  }
  return this;
};
Ellipse.prototype.isDegenerate = function() {
  return this.rx < epsilon * this.ry || this.ry < epsilon * this.rx;
};
var ellipse$1 = Ellipse;
var pathParse2 = path_parse;
var transformParse2 = transform_parse;
var matrix = matrix$1;
var a2c2 = a2c$1;
var ellipse = ellipse$1;
function SvgPath(path) {
  if (!(this instanceof SvgPath)) {
    return new SvgPath(path);
  }
  var pstate = pathParse2(path);
  this.segments = pstate.segments;
  this.err = pstate.err;
  this.__stack = [];
}
SvgPath.from = function(src) {
  if (typeof src === "string") return new SvgPath(src);
  if (src instanceof SvgPath) {
    var s = new SvgPath("");
    s.err = src.err;
    s.segments = src.segments.map(function(sgm) {
      return sgm.slice();
    });
    s.__stack = src.__stack.map(function(m) {
      return matrix().matrix(m.toArray());
    });
    return s;
  }
  throw new Error("SvgPath.from: invalid param type " + src);
};
SvgPath.prototype.__matrix = function(m) {
  var self2 = this, i;
  if (!m.queue.length) {
    return;
  }
  this.iterate(function(s, index, x, y) {
    var p, result, name2, isRelative;
    switch (s[0]) {
      case "v":
        p = m.calc(0, s[1], true);
        result = p[0] === 0 ? ["v", p[1]] : ["l", p[0], p[1]];
        break;
      case "V":
        p = m.calc(x, s[1], false);
        result = p[0] === m.calc(x, y, false)[0] ? ["V", p[1]] : ["L", p[0], p[1]];
        break;
      case "h":
        p = m.calc(s[1], 0, true);
        result = p[1] === 0 ? ["h", p[0]] : ["l", p[0], p[1]];
        break;
      case "H":
        p = m.calc(s[1], y, false);
        result = p[1] === m.calc(x, y, false)[1] ? ["H", p[0]] : ["L", p[0], p[1]];
        break;
      case "a":
      case "A":
        var ma = m.toArray();
        var e = ellipse(s[1], s[2], s[3]).transform(ma);
        if (ma[0] * ma[3] - ma[1] * ma[2] < 0) {
          s[5] = s[5] ? "0" : "1";
        }
        p = m.calc(s[6], s[7], s[0] === "a");
        if (s[0] === "A" && s[6] === x && s[7] === y || s[0] === "a" && s[6] === 0 && s[7] === 0) {
          result = [s[0] === "a" ? "l" : "L", p[0], p[1]];
          break;
        }
        if (e.isDegenerate()) {
          result = [s[0] === "a" ? "l" : "L", p[0], p[1]];
        } else {
          result = [s[0], e.rx, e.ry, e.ax, s[4], s[5], p[0], p[1]];
        }
        break;
      case "m":
        isRelative = index > 0;
        p = m.calc(s[1], s[2], isRelative);
        result = ["m", p[0], p[1]];
        break;
      default:
        name2 = s[0];
        result = [name2];
        isRelative = name2.toLowerCase() === name2;
        for (i = 1; i < s.length; i += 2) {
          p = m.calc(s[i], s[i + 1], isRelative);
          result.push(p[0], p[1]);
        }
    }
    self2.segments[index] = result;
  }, true);
};
SvgPath.prototype.__evaluateStack = function() {
  var m, i;
  if (!this.__stack.length) {
    return;
  }
  if (this.__stack.length === 1) {
    this.__matrix(this.__stack[0]);
    this.__stack = [];
    return;
  }
  m = matrix();
  i = this.__stack.length;
  while (--i >= 0) {
    m.matrix(this.__stack[i].toArray());
  }
  this.__matrix(m);
  this.__stack = [];
};
SvgPath.prototype.toString = function() {
  var result = "", prevCmd = "", cmdSkipped = false;
  this.__evaluateStack();
  for (var i = 0, len = this.segments.length; i < len; i++) {
    var segment = this.segments[i];
    var cmd = segment[0];
    if (cmd !== prevCmd || cmd === "m" || cmd === "M") {
      if (cmd === "m" && prevCmd === "z") result += " ";
      result += cmd;
      cmdSkipped = false;
    } else {
      cmdSkipped = true;
    }
    for (var pos = 1; pos < segment.length; pos++) {
      var val = segment[pos];
      if (pos === 1) {
        if (cmdSkipped && val >= 0) result += " ";
      } else if (val >= 0) result += " ";
      result += val;
    }
    prevCmd = cmd;
  }
  return result;
};
SvgPath.prototype.translate = function(x, y) {
  this.__stack.push(matrix().translate(x, y || 0));
  return this;
};
SvgPath.prototype.scale = function(sx, sy) {
  this.__stack.push(matrix().scale(sx, !sy && sy !== 0 ? sx : sy));
  return this;
};
SvgPath.prototype.rotate = function(angle, rx, ry) {
  this.__stack.push(matrix().rotate(angle, rx || 0, ry || 0));
  return this;
};
SvgPath.prototype.skewX = function(degrees) {
  this.__stack.push(matrix().skewX(degrees));
  return this;
};
SvgPath.prototype.skewY = function(degrees) {
  this.__stack.push(matrix().skewY(degrees));
  return this;
};
SvgPath.prototype.matrix = function(m) {
  this.__stack.push(matrix().matrix(m));
  return this;
};
SvgPath.prototype.transform = function(transformString) {
  if (!transformString.trim()) {
    return this;
  }
  this.__stack.push(transformParse2(transformString));
  return this;
};
SvgPath.prototype.round = function(d) {
  var contourStartDeltaX = 0, contourStartDeltaY = 0, deltaX = 0, deltaY = 0, l;
  d = d || 0;
  this.__evaluateStack();
  this.segments.forEach(function(s) {
    var isRelative = s[0].toLowerCase() === s[0];
    switch (s[0]) {
      case "H":
      case "h":
        if (isRelative) {
          s[1] += deltaX;
        }
        deltaX = s[1] - s[1].toFixed(d);
        s[1] = +s[1].toFixed(d);
        return;
      case "V":
      case "v":
        if (isRelative) {
          s[1] += deltaY;
        }
        deltaY = s[1] - s[1].toFixed(d);
        s[1] = +s[1].toFixed(d);
        return;
      case "Z":
      case "z":
        deltaX = contourStartDeltaX;
        deltaY = contourStartDeltaY;
        return;
      case "M":
      case "m":
        if (isRelative) {
          s[1] += deltaX;
          s[2] += deltaY;
        }
        deltaX = s[1] - s[1].toFixed(d);
        deltaY = s[2] - s[2].toFixed(d);
        contourStartDeltaX = deltaX;
        contourStartDeltaY = deltaY;
        s[1] = +s[1].toFixed(d);
        s[2] = +s[2].toFixed(d);
        return;
      case "A":
      case "a":
        if (isRelative) {
          s[6] += deltaX;
          s[7] += deltaY;
        }
        deltaX = s[6] - s[6].toFixed(d);
        deltaY = s[7] - s[7].toFixed(d);
        s[1] = +s[1].toFixed(d);
        s[2] = +s[2].toFixed(d);
        s[3] = +s[3].toFixed(d + 2);
        s[6] = +s[6].toFixed(d);
        s[7] = +s[7].toFixed(d);
        return;
      default:
        l = s.length;
        if (isRelative) {
          s[l - 2] += deltaX;
          s[l - 1] += deltaY;
        }
        deltaX = s[l - 2] - s[l - 2].toFixed(d);
        deltaY = s[l - 1] - s[l - 1].toFixed(d);
        s.forEach(function(val, i) {
          if (!i) {
            return;
          }
          s[i] = +s[i].toFixed(d);
        });
        return;
    }
  });
  return this;
};
SvgPath.prototype.iterate = function(iterator, keepLazyStack) {
  var segments = this.segments, replacements = {}, needReplace = false, lastX = 0, lastY = 0, countourStartX = 0, countourStartY = 0;
  var i, j, newSegments;
  if (!keepLazyStack) {
    this.__evaluateStack();
  }
  segments.forEach(function(s, index) {
    var res2 = iterator(s, index, lastX, lastY);
    if (Array.isArray(res2)) {
      replacements[index] = res2;
      needReplace = true;
    }
    var isRelative = s[0] === s[0].toLowerCase();
    switch (s[0]) {
      case "m":
      case "M":
        lastX = s[1] + (isRelative ? lastX : 0);
        lastY = s[2] + (isRelative ? lastY : 0);
        countourStartX = lastX;
        countourStartY = lastY;
        return;
      case "h":
      case "H":
        lastX = s[1] + (isRelative ? lastX : 0);
        return;
      case "v":
      case "V":
        lastY = s[1] + (isRelative ? lastY : 0);
        return;
      case "z":
      case "Z":
        lastX = countourStartX;
        lastY = countourStartY;
        return;
      default:
        lastX = s[s.length - 2] + (isRelative ? lastX : 0);
        lastY = s[s.length - 1] + (isRelative ? lastY : 0);
    }
  });
  if (!needReplace) {
    return this;
  }
  newSegments = [];
  for (i = 0; i < segments.length; i++) {
    if (typeof replacements[i] !== "undefined") {
      for (j = 0; j < replacements[i].length; j++) {
        newSegments.push(replacements[i][j]);
      }
    } else {
      newSegments.push(segments[i]);
    }
  }
  this.segments = newSegments;
  return this;
};
SvgPath.prototype.abs = function() {
  this.iterate(function(s, index, x, y) {
    var name2 = s[0], nameUC = name2.toUpperCase(), i;
    if (name2 === nameUC) {
      return;
    }
    s[0] = nameUC;
    switch (name2) {
      case "v":
        s[1] += y;
        return;
      case "a":
        s[6] += x;
        s[7] += y;
        return;
      default:
        for (i = 1; i < s.length; i++) {
          s[i] += i % 2 ? x : y;
        }
    }
  }, true);
  return this;
};
SvgPath.prototype.rel = function() {
  this.iterate(function(s, index, x, y) {
    var name2 = s[0], nameLC = name2.toLowerCase(), i;
    if (name2 === nameLC) {
      return;
    }
    if (index === 0 && name2 === "M") {
      return;
    }
    s[0] = nameLC;
    switch (name2) {
      case "V":
        s[1] -= y;
        return;
      case "A":
        s[6] -= x;
        s[7] -= y;
        return;
      default:
        for (i = 1; i < s.length; i++) {
          s[i] -= i % 2 ? x : y;
        }
    }
  }, true);
  return this;
};
SvgPath.prototype.unarc = function() {
  this.iterate(function(s, index, x, y) {
    var new_segments, nextX, nextY, result = [], name2 = s[0];
    if (name2 !== "A" && name2 !== "a") {
      return null;
    }
    if (name2 === "a") {
      nextX = x + s[6];
      nextY = y + s[7];
    } else {
      nextX = s[6];
      nextY = s[7];
    }
    new_segments = a2c2(x, y, nextX, nextY, s[4], s[5], s[1], s[2], s[3]);
    if (new_segments.length === 0) {
      return [[s[0] === "a" ? "l" : "L", s[6], s[7]]];
    }
    new_segments.forEach(function(s2) {
      result.push(["C", s2[2], s2[3], s2[4], s2[5], s2[6], s2[7]]);
    });
    return result;
  });
  return this;
};
SvgPath.prototype.unshort = function() {
  var segments = this.segments;
  var prevControlX, prevControlY, prevSegment;
  var curControlX, curControlY;
  this.iterate(function(s, idx, x, y) {
    var name2 = s[0], nameUC = name2.toUpperCase(), isRelative;
    if (!idx) {
      return;
    }
    if (nameUC === "T") {
      isRelative = name2 === "t";
      prevSegment = segments[idx - 1];
      if (prevSegment[0] === "Q") {
        prevControlX = prevSegment[1] - x;
        prevControlY = prevSegment[2] - y;
      } else if (prevSegment[0] === "q") {
        prevControlX = prevSegment[1] - prevSegment[3];
        prevControlY = prevSegment[2] - prevSegment[4];
      } else {
        prevControlX = 0;
        prevControlY = 0;
      }
      curControlX = -prevControlX;
      curControlY = -prevControlY;
      if (!isRelative) {
        curControlX += x;
        curControlY += y;
      }
      segments[idx] = [
        isRelative ? "q" : "Q",
        curControlX,
        curControlY,
        s[1],
        s[2]
      ];
    } else if (nameUC === "S") {
      isRelative = name2 === "s";
      prevSegment = segments[idx - 1];
      if (prevSegment[0] === "C") {
        prevControlX = prevSegment[3] - x;
        prevControlY = prevSegment[4] - y;
      } else if (prevSegment[0] === "c") {
        prevControlX = prevSegment[3] - prevSegment[5];
        prevControlY = prevSegment[4] - prevSegment[6];
      } else {
        prevControlX = 0;
        prevControlY = 0;
      }
      curControlX = -prevControlX;
      curControlY = -prevControlY;
      if (!isRelative) {
        curControlX += x;
        curControlY += y;
      }
      segments[idx] = [
        isRelative ? "c" : "C",
        curControlX,
        curControlY,
        s[1],
        s[2],
        s[3],
        s[4]
      ];
    }
  });
  return this;
};
var svgpath$1 = SvgPath;
var svgpath = svgpath$1;
const svgPath = /* @__PURE__ */ getDefaultExportFromCjs(svgpath);
const LEFT = "left";
const TOP = "top";
const RIGHT = "right";
const BOTTOM = "bottom";
const CENTER = "center";
const opposite = {
  top: BOTTOM,
  bottom: TOP,
  left: RIGHT,
  right: LEFT,
  center: CENTER
};
function scalingIsForbidden(fabricObject, by, scaleProportionally) {
  const lockX = fabricObject.lockScalingX;
  const lockY = fabricObject.lockScalingY;
  if (lockX && lockY) {
    return true;
  }
  if (!by && (lockX || lockY) && scaleProportionally) {
    return true;
  }
  if (lockX && by === "x") {
    return true;
  }
  if (lockY && by === "y") {
    return true;
  }
  return false;
}
function scaleIsProportional(eventData, fabricObject) {
  const canvas = fabricObject.canvas;
  const uniScaleKey = canvas.uniScaleKey;
  const uniformIsToggled = eventData[uniScaleKey];
  return canvas.uniformScaling && !uniformIsToggled || !canvas.uniformScaling && uniformIsToggled;
}
function getLocalPoint(transform, originX, originY, x, y) {
  const target = transform.target;
  const control = target.controls[transform.corner];
  const zoom = target.canvas.getZoom();
  const padding = target.padding / zoom;
  const localPoint = target.toLocalPoint(new fabric.fabric.Point(x, y), originX, originY);
  if (localPoint.x >= padding) {
    localPoint.x -= padding;
  }
  if (localPoint.x <= -padding) {
    localPoint.x += padding;
  }
  if (localPoint.y >= padding) {
    localPoint.y -= padding;
  }
  if (localPoint.y <= padding) {
    localPoint.y += padding;
  }
  localPoint.x -= control.offsetX;
  localPoint.y -= control.offsetY;
  return localPoint;
}
function isTransformCentered(transform) {
  return transform.originX === CENTER && transform.originY === CENTER;
}
function scaleObject(eventData, transform, x, y, options) {
  options = options || {};
  const target = transform.target;
  const lockScalingX = target.lockScalingX;
  const lockScalingY = target.lockScalingY;
  const by = options.by;
  let newPoint;
  let scaleX;
  let scaleY;
  let dim;
  const scaleProportionally = scaleIsProportional(eventData, target);
  const forbidScaling = scalingIsForbidden(target, by, scaleProportionally);
  let signX;
  let signY;
  const gestureScale = transform.gestureScale;
  if (forbidScaling) {
    return false;
  }
  if (gestureScale) {
    scaleX = transform.scaleX * gestureScale;
    scaleY = transform.scaleY * gestureScale;
  } else {
    newPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y);
    signX = by !== "y" ? Math.sign(newPoint.x) : 1;
    signY = by !== "x" ? Math.sign(newPoint.y) : 1;
    if (!transform.signX) {
      transform.signX = signX;
    }
    if (!transform.signY) {
      transform.signY = signY;
    }
    if (transform.signX !== signX || transform.signY !== signY) {
      return false;
    }
    dim = target._getTransformedDimensions();
    if (scaleProportionally && !by) {
      const distance = Math.abs(newPoint.x) + Math.abs(newPoint.y);
      const original = transform.original;
      const originalDistance = Math.abs(dim.x * original.scaleX / target.scaleX) + Math.abs(dim.y * original.scaleY / target.scaleY);
      const scale = distance / originalDistance;
      scaleX = original.scaleX * scale;
      scaleY = original.scaleY * scale;
    } else {
      scaleX = Math.abs(newPoint.x * target.scaleX / dim.x);
      scaleY = Math.abs(newPoint.y * target.scaleY / dim.y);
    }
    if (isTransformCentered(transform)) {
      scaleX *= 2;
      scaleY *= 2;
    }
    if (transform.signX !== signX && by !== "y") {
      transform.originX = opposite[transform.originX];
      scaleX *= -1;
      transform.signX = signX;
    }
    if (transform.signY !== signY && by !== "x") {
      transform.originY = opposite[transform.originY];
      scaleY *= -1;
      transform.signY = signY;
    }
  }
  const oldWidth = target.width;
  const oldHeight = target.height;
  if (!by) {
    !lockScalingX && target.setScaleX(scaleX);
    !lockScalingY && target.setScaleY(scaleY);
  } else {
    by === "x" && target.setScaleX(scaleX);
    by === "y" && target.setScaleY(scaleY);
  }
  if (oldWidth !== target.width || oldHeight !== target.height) {
    const radians = fabric.fabric.util.degreesToRadians(target.angle);
    const cosAngle = Math.cos(radians);
    const sinAngle = Math.sin(radians);
    switch (options.control) {
      case "ml": {
        const newLeft = target.left + (oldWidth - target.width) * cosAngle;
        const newTop = target.top + (oldWidth - target.width) * sinAngle;
        target.set("left", newLeft);
        target.set("top", newTop);
        break;
      }
      case "mt": {
        const newLeft = target.left - (oldHeight - target.height) * sinAngle;
        const newTop = target.top + (oldHeight - target.height) * cosAngle;
        target.set("left", newLeft);
        target.set("top", newTop);
        break;
      }
      case "tl": {
        const newLeft = target.left - ((target.width - oldWidth) * cosAngle - (target.height - oldHeight) * sinAngle);
        const newTop = target.top - ((target.width - oldWidth) * sinAngle + (target.height - oldHeight) * cosAngle);
        target.set("left", newLeft);
        target.set("top", newTop);
        break;
      }
      case "tr": {
        const newLeft = target.left + (target.height - oldHeight) * sinAngle;
        const newTop = target.top - (target.height - oldHeight) * cosAngle;
        target.set("left", newLeft);
        target.set("top", newTop);
        break;
      }
      case "bl": {
        const newLeft = target.left - (target.width - oldWidth) * cosAngle;
        const newTop = target.top - (target.width - oldWidth) * sinAngle;
        target.set("left", newLeft);
        target.set("top", newTop);
        break;
      }
    }
  }
  return oldWidth !== target.width || oldHeight !== target.height;
}
const initBasePath = () => {
  fabric.fabric.BasePath = fabric.fabric.util.createClass(fabric.fabric.Path, {
    type: "BasePath",
    _lastPath: "",
    _radius: 0,
    initialize: function(path, options) {
      options = options || {};
      this._lastPath = path;
      this.callSuper("initialize", path, {
        strokeUniform: true,
        noScaleCache: false,
        flipX: false,
        flipY: false,
        ...options
      });
    },
    toObject: function(propertiesToInclude) {
      const tmpPropertiesToInclude = propertiesToInclude || [];
      return this.callSuper("toObject", [
        "_lastPath",
        "_radius",
        ...tmpPropertiesToInclude
      ]);
    },
    setPath: function(path) {
      this._setPath(path, { left: this.left, top: this.top });
      this.dirty = true;
      this.setCoords();
      this.canvas && this.canvas.renderAll();
    },
    setRound: function(r) {
      this._radius = r;
      const rPath = roundCorners(this._lastPath, r).path;
      this.setPath(rPath);
    },
    setScaleX: function(x) {
      if (x < 0) {
        return;
      }
      let resultPath = svgPath(this._lastPath).scale(x, 1).toString();
      this._lastPath = resultPath;
      if (this._radius !== 0) {
        resultPath = roundCorners(resultPath, this._radius).path;
      }
      this.setPath(resultPath);
    },
    setScaleY: function(y) {
      if (y < 0) {
        return;
      }
      let resultPath = svgPath(this._lastPath).scale(1, y).toString();
      this._lastPath = resultPath;
      if (this._radius !== 0) {
        resultPath = roundCorners(resultPath, this._radius).path;
      }
      this.setPath(resultPath);
    },
    controls: {
      ml: new fabric.fabric.Control({
        // 左中控制点
        x: -0.5,
        y: 0,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleSkewCursorStyleHandler,
        getActionName: fabric.fabric.controlsUtils.scaleOrSkewActionName,
        actionHandler: function(eventData, transform, x, y) {
          return scaleObject(eventData, transform, x, y, { by: "x", control: "ml" });
        },
        render: fabric.fabric.Object.prototype.controls.ml.render
      }),
      mr: new fabric.fabric.Control({
        // 右中控制点
        x: 0.5,
        y: 0,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleSkewCursorStyleHandler,
        getActionName: fabric.fabric.controlsUtils.scaleOrSkewActionName,
        actionHandler: function(eventData, transform, x, y) {
          return scaleObject(eventData, transform, x, y, { by: "x" });
        },
        render: fabric.fabric.Object.prototype.controls.mr.render
      }),
      mt: new fabric.fabric.Control({
        // 上中控制点
        x: 0,
        y: -0.5,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleSkewCursorStyleHandler,
        getActionName: fabric.fabric.controlsUtils.scaleOrSkewActionName,
        actionHandler: function(eventData, transform, x, y) {
          return scaleObject(eventData, transform, x, y, { by: "y", control: "mt" });
        },
        render: fabric.fabric.Object.prototype.controls.mt.render
      }),
      mb: new fabric.fabric.Control({
        // 下中控制点
        x: 0,
        y: 0.5,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleSkewCursorStyleHandler,
        getActionName: fabric.fabric.controlsUtils.scaleOrSkewActionName,
        actionHandler: function(eventData, transform, x, y) {
          return scaleObject(eventData, transform, x, y, { by: "y" });
        },
        render: fabric.fabric.Object.prototype.controls.mb.render
      }),
      tl: new fabric.fabric.Control({
        // 左上控制点
        x: -0.5,
        y: -0.5,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleCursorStyleHandler,
        actionHandler: function(eventData, transform, x, y) {
          return scaleObject(eventData, transform, x, y, { control: "tl" });
        },
        render: fabric.fabric.Object.prototype.controls.tl.render
      }),
      tr: new fabric.fabric.Control({
        // 右上控制点
        x: 0.5,
        y: -0.5,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleCursorStyleHandler,
        actionHandler: function(eventData, transform, x, y) {
          return scaleObject(eventData, transform, x, y, { control: "tr" });
        },
        render: fabric.fabric.Object.prototype.controls.tr.render
      }),
      bl: new fabric.fabric.Control({
        // 左下控制点
        x: -0.5,
        y: 0.5,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleCursorStyleHandler,
        actionHandler: function(eventData, transform, x, y) {
          return scaleObject(eventData, transform, x, y, { control: "bl" });
        },
        render: fabric.fabric.Object.prototype.controls.bl.render
      }),
      br: new fabric.fabric.Control({
        // 右下控制点
        x: 0.5,
        y: 0.5,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleCursorStyleHandler,
        actionHandler: function(eventData, transform, x, y) {
          return scaleObject(eventData, transform, x, y, { control: "br" });
        },
        render: fabric.fabric.Object.prototype.controls.br.render
      }),
      mtr: fabric.fabric.Object.prototype.controls.mtr
    }
  });
  fabric.fabric.BasePath.fromObject = function(object, callback) {
    return fabric.fabric.Object._fromObject("BasePath", object, callback);
  };
  if (fabric.fabric.Object.prototype.controls.lock) {
    fabric.fabric.BasePath.prototype.controls.lock = fabric.fabric.Object.prototype.controls.lock;
  }
};
const initArrowBlockConcave = () => {
  fabric.fabric.ArrowBlockConcave = fabric.fabric.util.createClass(fabric.fabric.BasePath, {
    type: "ArrowBlockConcave",
    initialize: function(options) {
      options = options || {};
      const originalPath = "M512,0L0,0L64,128L0,256L512,256L448,128L512,0Z";
      this.callSuper("initialize", originalPath, {
        strokeUniform: true,
        noScaleCache: false,
        ...options
      });
    },
    addWidth: function(width) {
      const pathData = parsePath(this._lastPath);
      if (pathData[5].values.x + width <= pathData[2].values.x) {
        return false;
      }
      const widthPath = svgPath(this._lastPath).iterate((segment, index, x, y) => {
        switch (index) {
          case 0:
          case 4:
          case 5:
          case 6:
          case 7:
            return [[segment[0], segment[1] + width, segment[2]]];
          default:
            return [segment];
        }
      }).toString();
      this._lastPath = widthPath;
      let resultPath = widthPath;
      if (this._radius !== 0) {
        resultPath = roundCorners(resultPath, this._radius).path;
      }
      this.setPath(resultPath);
      return true;
    },
    controls: {
      ml: new fabric.fabric.Control({
        // 左中控制点
        x: -0.5,
        y: 0,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleSkewCursorStyleHandler,
        getActionName: fabric.fabric.controlsUtils.scaleOrSkewActionName,
        actionHandler: function(eventData, transform, x, y) {
          const target = transform.target;
          const radians = fabric.fabric.util.degreesToRadians(target.angle);
          const cosAngle = Math.cos(radians);
          const sinAngle = Math.sin(radians);
          const cvs = target.canvas.getElement();
          const showW = parseFloat(cvs.style.width);
          const realW = cvs.width;
          const ratioW = realW / showW;
          const showH = parseFloat(cvs.style.height);
          const realH = cvs.height;
          const ratioH = realH / showH;
          const mX = ratioW * eventData.movementX;
          const mY = ratioH * eventData.movementY;
          const rotatedMovementX = mX * cosAngle + mY * sinAngle;
          if (target.width - rotatedMovementX >= 0.5) {
            const isSuccess = target.addWidth(-rotatedMovementX);
            if (isSuccess) {
              target.set({
                left: target.left + rotatedMovementX * cosAngle,
                top: target.top + rotatedMovementX * sinAngle,
                objectCaching: false
              }).setCoords();
            }
          }
          return true;
        },
        render: fabric.fabric.Object.prototype.controls.ml.render
      }),
      mr: new fabric.fabric.Control({
        // 右中控制点
        x: 0.5,
        y: 0,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleSkewCursorStyleHandler,
        getActionName: fabric.fabric.controlsUtils.scaleOrSkewActionName,
        actionHandler: function(eventData, transform, x, y) {
          const target = transform.target;
          const radians = fabric.fabric.util.degreesToRadians(target.angle);
          const cosAngle = Math.cos(radians);
          const sinAngle = Math.sin(radians);
          const cvs = target.canvas.getElement();
          const showW = parseFloat(cvs.style.width);
          const realW = cvs.width;
          const ratioW = realW / showW;
          const showH = parseFloat(cvs.style.height);
          const realH = cvs.height;
          const ratioH = realH / showH;
          const mX = ratioW * eventData.movementX;
          const mY = ratioH * eventData.movementY;
          const rotatedMovementX = mX * cosAngle + mY * sinAngle;
          if (target.width + rotatedMovementX >= 0.5) {
            target.addWidth(rotatedMovementX);
          }
          return true;
        },
        render: fabric.fabric.Object.prototype.controls.mr.render
      }),
      mt: fabric.fabric.BasePath.prototype.controls.mt,
      mb: fabric.fabric.BasePath.prototype.controls.mb,
      tl: fabric.fabric.BasePath.prototype.controls.tl,
      tr: fabric.fabric.BasePath.prototype.controls.tr,
      bl: fabric.fabric.BasePath.prototype.controls.bl,
      br: fabric.fabric.BasePath.prototype.controls.br,
      mtr: fabric.fabric.BasePath.prototype.controls.mtr
    }
  });
  fabric.fabric.ArrowBlockConcave.generate = function(options) {
    return new fabric.fabric.ArrowBlockConcave({
      fill: "transparent",
      // 设置填充为透明
      ...options
    });
  };
  if (fabric.fabric.Object.prototype.controls.lock) {
    fabric.fabric.ArrowBlockConcave.prototype.controls.lock = fabric.fabric.Object.prototype.controls.lock;
  }
};
const initCloud = () => {
  fabric.fabric.Cloud = fabric.fabric.util.createClass(fabric.fabric.BasePath, {
    type: "Cloud",
    initialize: function(options) {
      options = options || {};
      const cloudPath = "M221.48754285714284,0C225.76639999999998,0 230.07085714285714,0 234.3411809523809,0C268.38735238095234,4.275736380952381 289.66460952380953,18.50855619047619 299.3560380952381,41.79785142857143C356.1167238095238,38.69202285714285 397.3851428571428,82.72883809523809 372.2349714285714,125.94895238095236C380.5982476190476,135.03085714285714 387.5754666666666,145.18979047619047 390.0952380952381,158.8248380952381C390.0952380952381,162.73066666666665 390.0952380952381,166.62735238095237 390.0952380952381,170.53257142857143C382.58590476190477,205.2352 350.273219047619,228.6848 297.2245333333333,222.3719619047619C283.5754666666666,240.1901714285714 259.2883809523809,258.03398095238094 221.49546666666666,255.81165714285711C201.96083809523807,254.64198095238095 188.37089523809522,247.86651428571426 176.47238095238095,239.63489523809523C163.9399619047619,246.4774095238095 150.3670857142857,251.84731428571428 130.75626666666668,251.9064380952381C85.3863619047619,252.00761904761902 55.03567238095238,225.6463238095238 54.29991619047619,189.48754285714284C25.133043809523805,181.0285714285714 5.378407619047619,165.23885714285714 0,138.22049523809522C0,134.3152761904762 0,130.40152380952378 0,126.5127619047619C5.936542476190477,99.73942857142856 24.617203809523808,82.92205714285714 55.72065523809523,75.79306666666666C53.851733333333335,30.628754285714283 116.06735238095239,2.4072045714285712 167.17897142857143,22.30454857142857C179.34811428571427,12.465310476190476 196.56533333333334,1.7338636190476189 221.48754285714284,0Z";
      this.callSuper("initialize", cloudPath, {
        strokeUniform: true,
        noScaleCache: false,
        ...options
      });
    }
  });
  fabric.fabric.Cloud.generate = function(options) {
    return new fabric.fabric.Cloud({
      fill: "transparent",
      // 设置填充为透明
      ...options
    });
  };
};
const initCross = () => {
  fabric.fabric.Cross = fabric.fabric.util.createClass(fabric.fabric.BasePath, {
    type: "Cross",
    initialize: function(options) {
      options = options || {};
      const path = "M176,0L80,0L80,80L0,80L0,176L80,176L80,256L176,256L176,176L256,176L256,80L176,80L176,0Z";
      this.callSuper("initialize", path, {
        ...options
      });
    }
  });
  fabric.fabric.Cross.generate = function(options) {
    return new fabric.fabric.Cross({
      fill: "transparent",
      // 设置填充为透明
      ...options
    });
  };
};
const initDiamond = () => {
  fabric.fabric.Diamond = fabric.fabric.util.createClass(fabric.fabric.BasePath, {
    type: "Diamond",
    initialize: function(options) {
      options = options || {};
      const originalPath = "M128,0L256,128L128,256L0,128L128,0Z";
      this.callSuper("initialize", originalPath, {
        strokeUniform: true,
        noScaleCache: false,
        ...options
      });
    }
  });
  fabric.fabric.Diamond.generate = function(options) {
    return new fabric.fabric.Diamond({
      fill: "transparent",
      // 设置填充为透明
      ...options
    });
  };
};
const initFivePointedStar = () => {
  fabric.fabric.FivePointedStar = fabric.fabric.util.createClass(fabric.fabric.BasePath, {
    type: "FivePointedStar",
    initialize: function(options) {
      options = options || {};
      const originalPath = "M134.29508196721312,0L165.99795409836068,97.78318688524591L268.59016393442624,97.78318688524591L185.59118688524592,158.2168131147541L217.29405901639345,256L134.29508196721312,195.56679344262295L51.29610491803279,256L82.99897704918034,158.2168131147541L0,97.78318688524591L102.59220983606558,97.78318688524591L134.29508196721312,0Z";
      this.callSuper("initialize", originalPath, {
        strokeUniform: true,
        noScaleCache: false,
        ...options
      });
    }
  });
  fabric.fabric.FivePointedStar.generate = function(options) {
    return new fabric.fabric.FivePointedStar({
      fill: "transparent",
      // 设置填充为透明
      ...options
    });
  };
};
const initHeart = () => {
  fabric.fabric.Heart = fabric.fabric.util.createClass(fabric.fabric.BasePath, {
    type: "Heart",
    initialize: function(options) {
      options = options || {};
      const heartPath = "M11.598857142857142,40.875611428571425C-12.123199999999999,79.95702857142857 4.58912,117.99634285714285 25.59145142857143,138.1856L148.3904,256L268.5974857142857,138.60662857142856C288.1312,116.88822857142856 295.6187428571429,93.85097142857143 291.46011428571427,68.19885714285714C285.71611428571424,32.7136 256.47405714285713,5.18272 220.35062857142856,1.2513188571428573C198.19565714285713,-1.1341165714285715 176.7936,5.135634285714286 160.09005714285715,19.016045714285713C155.59405714285714,22.75072 151.57577142857144,26.925942857142854 148.0736,31.464091428571425C143.9181714285714,26.29705142857143 139.04594285714285,21.57046857142857 133.5350857142857,17.381439999999998C114.32685714285714,2.7834285714285714 89.87611428571428,-3.0125439999999997 66.38994285714286,1.495126857142857C44.145782857142855,5.792228571428571 24.17938285714286,20.14089142857143 11.598857142857142,40.875611428571425Z";
      this.callSuper("initialize", heartPath, {
        strokeUniform: true,
        noScaleCache: false,
        ...options
      });
    }
  });
  fabric.fabric.Heart.generate = function(options) {
    return new fabric.fabric.Heart({
      fill: "transparent",
      // 设置填充为透明
      ...options
    });
  };
};
const initOctagon = () => {
  fabric.fabric.Octagon = fabric.fabric.util.createClass(fabric.fabric.BasePath, {
    type: "Octagon",
    initialize: function(options) {
      options = options || {};
      const originalPath = "M181,0L256,75L256,181L181,256L75,256L0,181L0,75L75,0L181,0Z";
      this.callSuper("initialize", originalPath, {
        strokeUniform: true,
        noScaleCache: false,
        ...options
      });
    },
    addWidth: function(width) {
      const pathData = parsePath(this._lastPath);
      if (pathData[0].values.x + width <= pathData[4].values.x) {
        return false;
      }
      const widthPath = svgPath(this._lastPath).iterate((segment, index, x, y) => {
        switch (index) {
          case 0:
          case 1:
          case 2:
          case 3:
          case 8:
            return [[segment[0], segment[1] + width, segment[2]]];
          default:
            return [segment];
        }
      }).toString();
      this._lastPath = widthPath;
      let resultPath = widthPath;
      if (this._radius !== 0) {
        resultPath = roundCorners(resultPath, this._radius).path;
      }
      this.setPath(resultPath);
      return true;
    },
    addHeight: function(height) {
      const pathData = parsePath(this._lastPath);
      if (pathData[2].values.y + height <= pathData[1].values.y) {
        return false;
      }
      const heightPath = svgPath(this._lastPath).iterate((segment, index, x, y) => {
        switch (index) {
          case 2:
          case 3:
          case 4:
          case 5:
            return [[segment[0], segment[1], segment[2] + height]];
          default:
            return [segment];
        }
      }).toString();
      this._lastPath = heightPath;
      let resultPath = heightPath;
      if (this._radius !== 0) {
        resultPath = roundCorners(heightPath, this._radius).path;
      }
      this.setPath(resultPath);
      return true;
    },
    controls: {
      ml: new fabric.fabric.Control({
        // 左中控制点
        x: -0.5,
        y: 0,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleSkewCursorStyleHandler,
        getActionName: fabric.fabric.controlsUtils.scaleOrSkewActionName,
        actionHandler: function(eventData, transform, x, y) {
          const target = transform.target;
          const radians = fabric.fabric.util.degreesToRadians(target.angle);
          const cosAngle = Math.cos(radians);
          const sinAngle = Math.sin(radians);
          const cvs = target.canvas.getElement();
          const showW = parseFloat(cvs.style.width);
          const realW = cvs.width;
          const ratioW = realW / showW;
          const showH = parseFloat(cvs.style.height);
          const realH = cvs.height;
          const ratioH = realH / showH;
          const mX = ratioW * eventData.movementX;
          const mY = ratioH * eventData.movementY;
          const rotatedMovementX = mX * cosAngle + mY * sinAngle;
          if (target.width - rotatedMovementX >= 0.5) {
            const isSuccess = target.addWidth(-rotatedMovementX);
            if (isSuccess) {
              target.set({
                left: target.left + rotatedMovementX * cosAngle,
                top: target.top + rotatedMovementX * sinAngle,
                objectCaching: false
              }).setCoords();
            }
          }
          return true;
        },
        render: fabric.fabric.Object.prototype.controls.ml.render
      }),
      mr: new fabric.fabric.Control({
        // 右中控制点
        x: 0.5,
        y: 0,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleSkewCursorStyleHandler,
        getActionName: fabric.fabric.controlsUtils.scaleOrSkewActionName,
        actionHandler: function(eventData, transform, x, y) {
          const target = transform.target;
          const radians = fabric.fabric.util.degreesToRadians(target.angle);
          const cosAngle = Math.cos(radians);
          const sinAngle = Math.sin(radians);
          const cvs = target.canvas.getElement();
          const showW = parseFloat(cvs.style.width);
          const realW = cvs.width;
          const ratioW = realW / showW;
          const showH = parseFloat(cvs.style.height);
          const realH = cvs.height;
          const ratioH = realH / showH;
          const mX = ratioW * eventData.movementX;
          const mY = ratioH * eventData.movementY;
          const rotatedMovementX = mX * cosAngle + mY * sinAngle;
          if (target.width + rotatedMovementX >= 0.5) {
            target.addWidth(rotatedMovementX);
          }
          return true;
        },
        render: fabric.fabric.Object.prototype.controls.mr.render
      }),
      mt: new fabric.fabric.Control({
        // 上中控制点
        x: 0,
        y: -0.5,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleSkewCursorStyleHandler,
        getActionName: fabric.fabric.controlsUtils.scaleOrSkewActionName,
        actionHandler: function(eventData, transform, x, y) {
          const target = transform.target;
          const radians = fabric.fabric.util.degreesToRadians(target.angle);
          const cosAngle = Math.cos(radians);
          const sinAngle = Math.sin(radians);
          const cvs = target.canvas.getElement();
          const showW = parseFloat(cvs.style.width);
          const realW = cvs.width;
          const ratioW = realW / showW;
          const showH = parseFloat(cvs.style.height);
          const realH = cvs.height;
          const ratioH = realH / showH;
          const mX = ratioW * eventData.movementX;
          const mY = ratioH * eventData.movementY;
          const rotatedMovementY = mY * cosAngle - mX * sinAngle;
          if (target.height - rotatedMovementY >= 0.5) {
            const isSuccess = target.addHeight(-rotatedMovementY);
            if (isSuccess) {
              target.set({
                left: target.left - rotatedMovementY * sinAngle,
                top: target.top + rotatedMovementY * cosAngle,
                objectCaching: false
              }).setCoords();
            }
          }
          return true;
        },
        render: fabric.fabric.Object.prototype.controls.mt.render
      }),
      mb: new fabric.fabric.Control({
        // 下中控制点
        x: 0,
        y: 0.5,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleSkewCursorStyleHandler,
        getActionName: fabric.fabric.controlsUtils.scaleOrSkewActionName,
        actionHandler: function(eventData, transform, x, y) {
          const target = transform.target;
          const radians = fabric.fabric.util.degreesToRadians(target.angle);
          const cosAngle = Math.cos(radians);
          const sinAngle = Math.sin(radians);
          const cvs = target.canvas.getElement();
          const showW = parseFloat(cvs.style.width);
          const realW = cvs.width;
          const ratioW = realW / showW;
          const showH = parseFloat(cvs.style.height);
          const realH = cvs.height;
          const ratioH = realH / showH;
          const mX = ratioW * eventData.movementX;
          const mY = ratioH * eventData.movementY;
          const rotatedMovementY = mY * cosAngle - mX * sinAngle;
          if (target.height + rotatedMovementY >= 0.5) {
            target.addHeight(rotatedMovementY);
          }
          return true;
        },
        render: fabric.fabric.Object.prototype.controls.mb.render
      }),
      tl: fabric.fabric.BasePath.prototype.controls.tl,
      tr: fabric.fabric.BasePath.prototype.controls.tr,
      bl: fabric.fabric.BasePath.prototype.controls.bl,
      br: fabric.fabric.BasePath.prototype.controls.br,
      mtr: fabric.fabric.BasePath.prototype.controls.mtr
    }
  });
  fabric.fabric.Octagon.generate = function(options) {
    return new fabric.fabric.Octagon({
      fill: "transparent",
      // 设置填充为透明
      ...options
    });
  };
  if (fabric.fabric.Object.prototype.controls.lock) {
    fabric.fabric.Octagon.prototype.controls.lock = fabric.fabric.Object.prototype.controls.lock;
  }
};
const initRoundSpeechBubble = () => {
  fabric.fabric.RoundSpeechBubble = fabric.fabric.util.createClass(fabric.fabric.BasePath, {
    type: "RoundSpeechBubble",
    initialize: function(options) {
      options = options || {};
      const originalPath = "M190.90971428571427,0L101.65394285714285,0C45.50774857142857,0 0,44.45874285714286 0,99.30102857142857C0,139.00342857142857 23.857417142857145,173.24982857142857 58.325942857142856,189.13874285714283L58.325942857142856,256L127.36777142857142,198.59885714285713L190.90971428571427,198.59885714285713C247.05965714285713,198.59885714285713 292.57142857142856,154.1398857142857 292.57142857142856,99.29737142857142C292.57554285714286,44.45874285714286 247.05965714285713,0 190.90971428571427,0Z";
      this.callSuper("initialize", originalPath, {
        strokeUniform: true,
        noScaleCache: false,
        ...options
      });
    },
    addWidth: function(width) {
      const pathData = parsePath(this._lastPath);
      if (pathData[6].values.x + width <= pathData[5].values.x) {
        return false;
      }
      const widthPath = svgPath(this._lastPath).iterate((segment, index, x, y) => {
        switch (index) {
          case 0:
          case 6:
          case 9:
            return [[segment[0], segment[1] + width, segment[2]]];
          case 7:
          case 8:
            return [[segment[0], segment[1] + width, segment[2], segment[3] + width, segment[4], segment[5] + width, segment[6]]];
          default:
            return [segment];
        }
      }).toString();
      this._lastPath = widthPath;
      let resultPath = widthPath;
      if (this._radius !== 0) {
        resultPath = roundCorners(resultPath, this._radius).path;
      }
      this.setPath(resultPath);
      return true;
    },
    addHeight: function(height) {
      const pathData = parsePath(this._lastPath);
      if ((pathData[2].values.y + height) / pathData[2].values.y2 <= 2) {
        return false;
      }
      const heightPath = svgPath(this._lastPath).iterate((segment, index, x, y) => {
        switch (index) {
          case 4:
          case 5:
          case 6:
            return [[segment[0], segment[1], segment[2] + height]];
          case 2:
            return [[segment[0], segment[1], segment[2], segment[3], segment[4], segment[5], segment[6] + height * 0.5]];
          case 3:
            return [[segment[0], segment[1], segment[2] + height, segment[3], segment[4] + height, segment[5], segment[6] + height]];
          case 7:
            return [[segment[0], segment[1], segment[2] + height, segment[3], segment[4] + height, segment[5], segment[6] + height * 0.5]];
          default:
            return [segment];
        }
      }).toString();
      this._lastPath = heightPath;
      let resultPath = heightPath;
      if (this._radius !== 0) {
        resultPath = roundCorners(heightPath, this._radius).path;
      }
      this.setPath(resultPath);
      return true;
    },
    controls: {
      ml: new fabric.fabric.Control({
        // 左中控制点
        x: -0.5,
        y: 0,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleSkewCursorStyleHandler,
        getActionName: fabric.fabric.controlsUtils.scaleOrSkewActionName,
        actionHandler: function(eventData, transform, x, y) {
          const target = transform.target;
          const radians = fabric.fabric.util.degreesToRadians(target.angle);
          const cosAngle = Math.cos(radians);
          const sinAngle = Math.sin(radians);
          const cvs = target.canvas.getElement();
          const showW = parseFloat(cvs.style.width);
          const realW = cvs.width;
          const ratioW = realW / showW;
          const showH = parseFloat(cvs.style.height);
          const realH = cvs.height;
          const ratioH = realH / showH;
          const mX = ratioW * eventData.movementX;
          const mY = ratioH * eventData.movementY;
          const rotatedMovementX = mX * cosAngle + mY * sinAngle;
          if (target.width - rotatedMovementX >= 0.5) {
            const isSuccess = target.addWidth(-rotatedMovementX);
            if (isSuccess) {
              target.set({
                left: target.left + rotatedMovementX * cosAngle,
                top: target.top + rotatedMovementX * sinAngle,
                objectCaching: false
              }).setCoords();
            }
          }
          return true;
        },
        render: fabric.fabric.Object.prototype.controls.ml.render
      }),
      mr: new fabric.fabric.Control({
        // 右中控制点
        x: 0.5,
        y: 0,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleSkewCursorStyleHandler,
        getActionName: fabric.fabric.controlsUtils.scaleOrSkewActionName,
        actionHandler: function(eventData, transform, x, y) {
          const target = transform.target;
          const radians = fabric.fabric.util.degreesToRadians(target.angle);
          const cosAngle = Math.cos(radians);
          const sinAngle = Math.sin(radians);
          const cvs = target.canvas.getElement();
          const showW = parseFloat(cvs.style.width);
          const realW = cvs.width;
          const ratioW = realW / showW;
          const showH = parseFloat(cvs.style.height);
          const realH = cvs.height;
          const ratioH = realH / showH;
          const mX = ratioW * eventData.movementX;
          const mY = ratioH * eventData.movementY;
          const rotatedMovementX = mX * cosAngle + mY * sinAngle;
          if (target.width + rotatedMovementX >= 0.5) {
            target.addWidth(rotatedMovementX);
          }
          return true;
        },
        render: fabric.fabric.Object.prototype.controls.mr.render
      }),
      mt: new fabric.fabric.Control({
        // 上中控制点
        x: 0,
        y: -0.5,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleSkewCursorStyleHandler,
        getActionName: fabric.fabric.controlsUtils.scaleOrSkewActionName,
        actionHandler: function(eventData, transform, x, y) {
          const target = transform.target;
          const radians = fabric.fabric.util.degreesToRadians(target.angle);
          const cosAngle = Math.cos(radians);
          const sinAngle = Math.sin(radians);
          const cvs = target.canvas.getElement();
          const showW = parseFloat(cvs.style.width);
          const realW = cvs.width;
          const ratioW = realW / showW;
          const showH = parseFloat(cvs.style.height);
          const realH = cvs.height;
          const ratioH = realH / showH;
          const mX = ratioW * eventData.movementX;
          const mY = ratioH * eventData.movementY;
          const rotatedMovementY = mY * cosAngle - mX * sinAngle;
          if (target.height - rotatedMovementY >= 0.5) {
            const isSuccess = target.addHeight(-rotatedMovementY);
            if (isSuccess) {
              target.set({
                left: target.left - rotatedMovementY * sinAngle,
                top: target.top + rotatedMovementY * cosAngle,
                objectCaching: false
              }).setCoords();
            }
          }
          return true;
        },
        render: fabric.fabric.Object.prototype.controls.mt.render
      }),
      mb: new fabric.fabric.Control({
        // 下中控制点
        x: 0,
        y: 0.5,
        cursorStyleHandler: fabric.fabric.controlsUtils.scaleSkewCursorStyleHandler,
        getActionName: fabric.fabric.controlsUtils.scaleOrSkewActionName,
        actionHandler: function(eventData, transform, x, y) {
          const target = transform.target;
          const radians = fabric.fabric.util.degreesToRadians(target.angle);
          const cosAngle = Math.cos(radians);
          const sinAngle = Math.sin(radians);
          const cvs = target.canvas.getElement();
          const showW = parseFloat(cvs.style.width);
          const realW = cvs.width;
          const ratioW = realW / showW;
          const showH = parseFloat(cvs.style.height);
          const realH = cvs.height;
          const ratioH = realH / showH;
          const mX = ratioW * eventData.movementX;
          const mY = ratioH * eventData.movementY;
          const rotatedMovementY = mY * cosAngle - mX * sinAngle;
          if (target.height + rotatedMovementY >= 0.5) {
            target.addHeight(rotatedMovementY);
          }
          return true;
        },
        render: fabric.fabric.Object.prototype.controls.mb.render
      }),
      tl: fabric.fabric.BasePath.prototype.controls.tl,
      tr: fabric.fabric.BasePath.prototype.controls.tr,
      bl: fabric.fabric.BasePath.prototype.controls.bl,
      br: fabric.fabric.BasePath.prototype.controls.br,
      mtr: fabric.fabric.BasePath.prototype.controls.mtr
    }
  });
  fabric.fabric.RoundSpeechBubble.generate = function(options) {
    return new fabric.fabric.RoundSpeechBubble({
      fill: "transparent",
      // 设置填充为透明
      ...options
    });
  };
  if (fabric.fabric.Object.prototype.controls.lock) {
    fabric.fabric.RoundSpeechBubble.prototype.controls.lock = fabric.fabric.Object.prototype.controls.lock;
  }
};
const initStarBurst = () => {
  fabric.fabric.StarBurst = fabric.fabric.util.createClass(fabric.fabric.BasePath, {
    type: "StarBurst",
    initialize: function(options) {
      options = options || {};
      const path = "M128,0L146.8964,27.57832L174.4372,8.71776L182.1376,41.2892L214.6024,33.69372L210.0672,66.8596L243.0716,71.5548L226.9128,100.8352L256,117.1872L230.4,138.6284L251.6412,164.4288L220.0572,175.1348L230.584,206.8988L197.282,205.4232L195.672,238.8612L165.1496,225.404L151.6208,256L128,232.3784L104.3792,256L90.8504,225.404L60.328,238.8612L58.718,205.4232L25.4162,206.8988L35.94256,175.1348L4.35888,164.4288L25.6,138.6284L0,117.1872L29.08712,100.8352L12.9282,71.5548L45.9328,66.8596L41.3976,33.69372L73.8624,41.2892L81.5628,8.71776L109.1036,27.57832L128,0Z";
      this.callSuper("initialize", path, {
        strokeUniform: true,
        noScaleCache: false,
        ...options
      });
    }
  });
  fabric.fabric.StarBurst.generate = function(options) {
    return new fabric.fabric.StarBurst({
      fill: "transparent",
      // 设置填充为透明
      ...options
    });
  };
};
function setup() {
  initShapeLine();
  initShapeArrow();
  initShapeDoubleArrow();
  initShapeRect();
  initShape();
  initBasePath();
  initArrowBlockConcave();
  initCloud();
  initCross();
  initDiamond();
  initFivePointedStar();
  initHeart();
  initOctagon();
  initRoundSpeechBubble();
  initStarBurst();
  initCustomImage();
  initCustomVideo();
  initAvatarImage();
  initAvatar();
  initCustomIcon();
  initCustomSticker();
}
const easeFuncs = {
  linear: (x) => x,
  easeInSine: (x) => 1 - Math.cos(x * Math.PI / 2),
  easeInCubic: (x) => x * x * x,
  easeInQuint: (x) => x * x * x * x * x,
  easeInCirc: (x) => 1 - Math.sqrt(1 - Math.pow(x, 2)),
  easeOutSine: (x) => Math.sin(x * Math.PI / 2),
  easeOutCubic: (x) => 1 - Math.pow(1 - x, 3),
  easeOutQuint: (x) => 1 - Math.pow(1 - x, 5),
  easeOutCirc: (x) => Math.sqrt(1 - Math.pow(x - 1, 2)),
  easeInOutSine: (x) => -(Math.cos(Math.PI * x) - 1) / 2,
  easeInOutCubic: (x) => x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
  easeInOutQuint: (x) => x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
  easeInOutCirc: (x) => {
    return x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2;
  },
  easeOutBounce: (x) => {
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) {
      return n1 * x * x;
    } else if (x < 2 / d1) {
      return n1 * (x -= 1.5 / d1) * x + 0.75;
    } else if (x < 2.5 / d1) {
      return n1 * (x -= 2.25 / d1) * x + 0.9375;
    } else {
      return n1 * (x -= 2.625 / d1) * x + 0.984375;
    }
  },
  easeInQuad: (x) => x * x,
  easeInQuart: (x) => x * x * x * x,
  easeInExpo: (x) => x === 0 ? 0 : Math.pow(2, 10 * x - 10),
  easeInBack: (x) => {
    const c1 = 1.70158;
    const c3 = c1 + 1;
    return c3 * x * x * x - c1 * x * x;
  },
  easeOutQuad: (x) => 1 - (1 - x) * (1 - x),
  easeOutQuart: (x) => 1 - Math.pow(1 - x, 4),
  easeOutExpo: (x) => x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
  easeOutBack: (x) => {
    const c1 = 1.70158;
    const c3 = c1 + 1;
    return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
  },
  easeInOutQuad: (x) => x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
  easeInOutQuart: (x) => x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
  easeInOutExpo: (x) => {
    return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2;
  },
  easeInOutBack: (x) => {
    const c1 = 1.70158;
    const c2 = c1 * 1.525;
    return x < 0.5 ? Math.pow(2 * x, 2) * ((c2 + 1) * 2 * x - c2) / 2 : (Math.pow(2 * x - 2, 2) * ((c2 + 1) * (x * 2 - 2) + c2) + 2) / 2;
  }
};
function ease(name2, x) {
  const f = easeFuncs[name2] || ((x2) => x2);
  return f(x);
}
const isNode = typeof process !== "undefined" && process.versions != null && process.versions.node != null;
function doAnimate(obj, animation, progress, width, height) {
  const { props } = animation;
  props.top = props.top || 0;
  props.left = props.left || 0;
  props.opacity = props.opacity || 1;
  props.scaleX = props.scaleX || 1;
  props.scaleY = props.scaleY || 1;
  const toEaseName = {
    linear: "linear",
    smooth: "easeOutCubic",
    bounce: "easeOutBounce"
  };
  const v = ease(toEaseName[animation.ease], progress);
  function doFade(opt) {
    switch (opt) {
      case "in": {
        obj.opacity = props.opacity * v;
        break;
      }
      case "out": {
        obj.opacity = props.opacity * (1 - v);
        break;
      }
    }
  }
  function doSlide(opt, direction) {
    let w = v;
    switch (opt) {
      case "in":
        w = 1 - v;
        break;
      case "out":
        w = v;
        break;
    }
    switch (direction) {
      case "top": {
        const offset = props.top + obj.getScaledHeight();
        obj.top = props.top - offset * w;
        if (obj.clipPath && obj.clipPath.absolutePositioned) {
          obj.clipPath.top = obj.top;
        }
        break;
      }
      case "left": {
        const offset = props.left + obj.getScaledWidth();
        obj.left = props.left - offset * w;
        if (obj.clipPath && obj.clipPath.absolutePositioned) {
          obj.clipPath.left = obj.left;
        }
        break;
      }
      case "right": {
        const offset = width - props.left;
        obj.left = props.left + offset * w;
        if (obj.clipPath && obj.clipPath.absolutePositioned) {
          obj.clipPath.left = obj.left;
        }
        break;
      }
      case "down": {
        const offset = height - props.top;
        obj.top = props.top + offset * w;
        if (obj.clipPath && obj.clipPath.absolutePositioned) {
          obj.clipPath.top = obj.top;
        }
        break;
      }
    }
  }
  function doScale(opt) {
    let _v = v;
    if (opt === "out") {
      _v = 1 - v;
    }
    if (isNode && obj.type === "text") ;
    obj._setOriginToCenter();
    obj.scaleX = Math.max(props.scaleX * _v, 1e-3);
    obj.scaleY = Math.max(props.scaleY * _v, 1e-3);
    obj._resetOrigin();
    if (obj.clipPath && obj.clipPath.absolutePositioned) {
      obj.clipPath._setOriginToCenter();
      obj.clipPath.scaleX = obj.scaleX;
      obj.clipPath.scaleY = obj.scaleY;
      obj.clipPath._resetOrigin();
    }
  }
  switch (animation.name) {
    case "fadein": {
      doFade("in");
      break;
    }
    case "fadein-t": {
      doFade("in");
      doSlide("in", "top");
      break;
    }
    case "fadein-l": {
      doFade("in");
      doSlide("in", "left");
      break;
    }
    case "fadein-r": {
      doFade("in");
      doSlide("in", "right");
      break;
    }
    case "fadein-d": {
      doFade("in");
      doSlide("in", "down");
      break;
    }
    case "slidein-t": {
      doSlide("in", "top");
      break;
    }
    case "slidein-l": {
      doSlide("in", "left");
      break;
    }
    case "slidein-r": {
      doSlide("in", "right");
      break;
    }
    case "slidein-d": {
      doSlide("in", "down");
      break;
    }
    case "scalein": {
      doScale("in");
      break;
    }
    case "fade-scalein": {
      doFade("in");
      doScale("in");
      break;
    }
    case "fadeout": {
      doFade("out");
      break;
    }
    case "fadeout-t": {
      doFade("out");
      doSlide("out", "top");
      break;
    }
    case "fadeout-l": {
      doFade("out");
      doSlide("out", "left");
      break;
    }
    case "fadeout-r": {
      doFade("out");
      doSlide("out", "right");
      break;
    }
    case "fadeout-d": {
      doFade("out");
      doSlide("out", "down");
      break;
    }
    case "slideout-t": {
      doSlide("out", "top");
      break;
    }
    case "slideout-l": {
      doSlide("out", "left");
      break;
    }
    case "slideout-r": {
      doSlide("out", "right");
      break;
    }
    case "slideout-d": {
      doSlide("out", "down");
      break;
    }
    case "scaleout": {
      doScale("out");
      break;
    }
    case "fade-scaleout": {
      doFade("out");
      doScale("out");
      break;
    }
  }
  obj.dirty = true;
}
var cubicSpline = class Spline {
  constructor(xs, ys) {
    this.xs = xs;
    this.ys = ys;
    this.ks = this.getNaturalKs(new Float64Array(this.xs.length));
  }
  getNaturalKs(ks) {
    const n = this.xs.length - 1;
    const A = zerosMat(n + 1, n + 2);
    for (let i = 1; i < n; i++) {
      A[i][i - 1] = 1 / (this.xs[i] - this.xs[i - 1]);
      A[i][i] = 2 * (1 / (this.xs[i] - this.xs[i - 1]) + 1 / (this.xs[i + 1] - this.xs[i]));
      A[i][i + 1] = 1 / (this.xs[i + 1] - this.xs[i]);
      A[i][n + 1] = 3 * ((this.ys[i] - this.ys[i - 1]) / ((this.xs[i] - this.xs[i - 1]) * (this.xs[i] - this.xs[i - 1])) + (this.ys[i + 1] - this.ys[i]) / ((this.xs[i + 1] - this.xs[i]) * (this.xs[i + 1] - this.xs[i])));
    }
    A[0][0] = 2 / (this.xs[1] - this.xs[0]);
    A[0][1] = 1 / (this.xs[1] - this.xs[0]);
    A[0][n + 1] = 3 * (this.ys[1] - this.ys[0]) / ((this.xs[1] - this.xs[0]) * (this.xs[1] - this.xs[0]));
    A[n][n - 1] = 1 / (this.xs[n] - this.xs[n - 1]);
    A[n][n] = 2 / (this.xs[n] - this.xs[n - 1]);
    A[n][n + 1] = 3 * (this.ys[n] - this.ys[n - 1]) / ((this.xs[n] - this.xs[n - 1]) * (this.xs[n] - this.xs[n - 1]));
    return solve(A, ks);
  }
  /**
   * inspired by https://stackoverflow.com/a/40850313/4417327
   */
  getIndexBefore(target) {
    let low = 0;
    let high = this.xs.length;
    let mid = 0;
    while (low < high) {
      mid = Math.floor((low + high) / 2);
      if (this.xs[mid] < target && mid !== low) {
        low = mid;
      } else if (this.xs[mid] >= target && mid !== high) {
        high = mid;
      } else {
        high = low;
      }
    }
    return low + 1;
  }
  at(x) {
    let i = this.getIndexBefore(x);
    const t = (x - this.xs[i - 1]) / (this.xs[i] - this.xs[i - 1]);
    const a = this.ks[i - 1] * (this.xs[i] - this.xs[i - 1]) - (this.ys[i] - this.ys[i - 1]);
    const b = -this.ks[i] * (this.xs[i] - this.xs[i - 1]) + (this.ys[i] - this.ys[i - 1]);
    const q = (1 - t) * this.ys[i - 1] + t * this.ys[i] + t * (1 - t) * (a * (1 - t) + b * t);
    return q;
  }
};
function solve(A, ks) {
  const m = A.length;
  let h = 0;
  let k = 0;
  while (h < m && k <= m) {
    let i_max = 0;
    let max2 = -Infinity;
    for (let i = h; i < m; i++) {
      const v2 = Math.abs(A[i][k]);
      if (v2 > max2) {
        i_max = i;
        max2 = v2;
      }
    }
    if (A[i_max][k] === 0) {
      k++;
    } else {
      swapRows(A, h, i_max);
      for (let i = h + 1; i < m; i++) {
        const f = A[i][k] / A[h][k];
        A[i][k] = 0;
        for (let j = k + 1; j <= m; j++) A[i][j] -= A[h][j] * f;
      }
      h++;
      k++;
    }
  }
  for (let i = m - 1; i >= 0; i--) {
    var v = 0;
    if (A[i][i]) {
      v = A[i][m] / A[i][i];
    }
    ks[i] = v;
    for (let j = i - 1; j >= 0; j--) {
      A[j][m] -= A[j][i] * v;
      A[j][i] = 0;
    }
  }
  return ks;
}
function zerosMat(r, c) {
  const A = [];
  for (let i = 0; i < r; i++) A.push(new Float64Array(c));
  return A;
}
function swapRows(m, k, l) {
  let p = m[k];
  m[k] = m[l];
  m[l] = p;
}
const Spline2 = /* @__PURE__ */ getDefaultExportFromCjs(cubicSpline);
const defaultInstanceSettings = {
  update: null,
  begin: null,
  loopBegin: null,
  changeBegin: null,
  change: null,
  changeComplete: null,
  loopComplete: null,
  complete: null,
  loop: 1,
  direction: "normal",
  autoplay: true,
  timelineOffset: 0
};
const defaultTweenSettings = {
  duration: 1e3,
  delay: 0,
  endDelay: 0,
  easing: "easeOutElastic(1, .5)",
  round: 0
};
const cache$1 = {
  CSS: {},
  springs: {}
};
function minMax(val, min2, max2) {
  return Math.min(Math.max(val, min2), max2);
}
function stringContains(str, text) {
  return str.indexOf(text) > -1;
}
function applyArguments(func, args) {
  return func.apply(null, args);
}
const is = {
  arr: (a) => Array.isArray(a),
  obj: (a) => stringContains(Object.prototype.toString.call(a), "Object"),
  pth: (a) => is.obj(a) && a.hasOwnProperty("totalLength"),
  // svg: a => a instanceof SVGElement,
  svg: (a) => false,
  // inp: a => a instanceof HTMLInputElement,
  inp: (a) => false,
  // dom: a => a.nodeType || is.svg(a),
  dom: (a) => false,
  str: (a) => typeof a === "string",
  fnc: (a) => typeof a === "function",
  und: (a) => typeof a === "undefined",
  nil: (a) => is.und(a) || a === null,
  hex: (a) => /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a),
  rgb: (a) => /^rgb/.test(a),
  hsl: (a) => /^hsl/.test(a),
  col: (a) => is.hex(a) || is.rgb(a) || is.hsl(a),
  key: (a) => !defaultInstanceSettings.hasOwnProperty(a) && !defaultTweenSettings.hasOwnProperty(a) && a !== "targets" && a !== "keyframes"
};
function parseEasingParameters(string2) {
  const match = /\(([^)]+)\)/.exec(string2);
  return match ? match[1].split(",").map((p) => parseFloat(p)) : [];
}
function spring(string2, duration) {
  const params = parseEasingParameters(string2);
  const mass = minMax(is.und(params[0]) ? 1 : params[0], 0.1, 100);
  const stiffness = minMax(is.und(params[1]) ? 100 : params[1], 0.1, 100);
  const damping = minMax(is.und(params[2]) ? 10 : params[2], 0.1, 100);
  const velocity = minMax(is.und(params[3]) ? 0 : params[3], 0.1, 100);
  const w0 = Math.sqrt(stiffness / mass);
  const zeta = damping / (2 * Math.sqrt(stiffness * mass));
  const wd = zeta < 1 ? w0 * Math.sqrt(1 - zeta * zeta) : 0;
  const a = 1;
  const b = zeta < 1 ? (zeta * w0 + -velocity) / wd : -velocity + w0;
  function solver(t) {
    let progress = duration ? duration * t / 1e3 : t;
    if (zeta < 1) {
      progress = Math.exp(-progress * zeta * w0) * (a * Math.cos(wd * progress) + b * Math.sin(wd * progress));
    } else {
      progress = (a + b * progress) * Math.exp(-progress * w0);
    }
    if (t === 0 || t === 1) return t;
    return 1 - progress;
  }
  function getDuration() {
    const cached = cache$1.springs[string2];
    if (cached) return cached;
    const frame = 1 / 6;
    let elapsed = 0;
    let rest = 0;
    while (true) {
      elapsed += frame;
      if (solver(elapsed) === 1) {
        rest++;
        if (rest >= 16) break;
      } else {
        rest = 0;
      }
    }
    const duration2 = elapsed * frame * 1e3;
    cache$1.springs[string2] = duration2;
    return duration2;
  }
  return duration ? solver : getDuration;
}
function steps(steps2 = 10) {
  return (t) => Math.ceil(minMax(t, 1e-6, 1) * steps2) * (1 / steps2);
}
const bezier = (() => {
  const kSplineTableSize = 11;
  const kSampleStepSize = 1 / (kSplineTableSize - 1);
  function A(aA1, aA2) {
    return 1 - 3 * aA2 + 3 * aA1;
  }
  function B(aA1, aA2) {
    return 3 * aA2 - 6 * aA1;
  }
  function C(aA1) {
    return 3 * aA1;
  }
  function calcBezier(aT, aA1, aA2) {
    return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
  }
  function getSlope(aT, aA1, aA2) {
    return 3 * A(aA1, aA2) * aT * aT + 2 * B(aA1, aA2) * aT + C(aA1);
  }
  function binarySubdivide(aX, aA, aB, mX1, mX2) {
    let currentX, currentT, i = 0;
    do {
      currentT = aA + (aB - aA) / 2;
      currentX = calcBezier(currentT, mX1, mX2) - aX;
      if (currentX > 0) {
        aB = currentT;
      } else {
        aA = currentT;
      }
    } while (Math.abs(currentX) > 1e-7 && ++i < 10);
    return currentT;
  }
  function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for (let i = 0; i < 4; ++i) {
      const currentSlope = getSlope(aGuessT, mX1, mX2);
      if (currentSlope === 0) return aGuessT;
      const currentX = calcBezier(aGuessT, mX1, mX2) - aX;
      aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
  }
  function bezier2(mX1, mY1, mX2, mY2) {
    if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) return;
    let sampleValues = new Float32Array(kSplineTableSize);
    if (mX1 !== mY1 || mX2 !== mY2) {
      for (let i = 0; i < kSplineTableSize; ++i) {
        sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
      }
    }
    function getTForX(aX) {
      let intervalStart = 0;
      let currentSample = 1;
      const lastSample = kSplineTableSize - 1;
      for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
        intervalStart += kSampleStepSize;
      }
      --currentSample;
      const dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
      const guessForT = intervalStart + dist * kSampleStepSize;
      const initialSlope = getSlope(guessForT, mX1, mX2);
      if (initialSlope >= 1e-3) {
        return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
      } else if (initialSlope === 0) {
        return guessForT;
      } else {
        return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
      }
    }
    return (x) => {
      if (mX1 === mY1 && mX2 === mY2) return x;
      if (x === 0 || x === 1) return x;
      return calcBezier(getTForX(x), mY1, mY2);
    };
  }
  return bezier2;
})();
const penner = (() => {
  const eases = { linear: () => (t) => t };
  const functionEasings = {
    Sine: () => (t) => 1 - Math.cos(t * Math.PI / 2),
    Expo: () => (t) => t ? Math.pow(2, 10 * t - 10) : 0,
    Circ: () => (t) => 1 - Math.sqrt(1 - t * t),
    Back: () => (t) => t * t * (3 * t - 2),
    Bounce: () => (t) => {
      let pow2, b = 4;
      while (t < ((pow2 = Math.pow(2, --b)) - 1) / 11) {
      }
      return 1 / Math.pow(4, 3 - b) - 7.5625 * Math.pow((pow2 * 3 - 2) / 22 - t, 2);
    },
    Elastic: (amplitude = 1, period = 0.5) => {
      const a = minMax(amplitude, 1, 10);
      const p = minMax(period, 0.1, 2);
      return (t) => {
        return t === 0 || t === 1 ? t : -a * Math.pow(2, 10 * (t - 1)) * Math.sin((t - 1 - p / (Math.PI * 2) * Math.asin(1 / a)) * (Math.PI * 2) / p);
      };
    }
  };
  const baseEasings = ["Quad", "Cubic", "Quart", "Quint"];
  baseEasings.forEach((name2, i) => {
    functionEasings[name2] = () => (t) => Math.pow(t, i + 2);
  });
  Object.keys(functionEasings).forEach((name2) => {
    const easeIn = functionEasings[name2];
    eases["easeIn" + name2] = easeIn;
    eases["easeOut" + name2] = (a, b) => (t) => 1 - easeIn(a, b)(1 - t);
    eases["easeInOut" + name2] = (a, b) => (t) => t < 0.5 ? easeIn(a, b)(t * 2) / 2 : 1 - easeIn(a, b)(t * -2 + 2) / 2;
    eases["easeOutIn" + name2] = (a, b) => (t) => t < 0.5 ? (1 - easeIn(a, b)(1 - t * 2)) / 2 : (easeIn(a, b)(t * 2 - 1) + 1) / 2;
  });
  return eases;
})();
function parseEasings(easing, duration) {
  if (is.fnc(easing)) return easing;
  const name2 = easing.split("(")[0];
  const ease2 = penner[name2];
  const args = parseEasingParameters(easing);
  switch (name2) {
    case "spring":
      return spring(easing, duration);
    case "cubicBezier":
      return applyArguments(bezier, args);
    case "steps":
      return applyArguments(steps, args);
    default:
      return applyArguments(ease2, args);
  }
}
function selectString(str) {
  try {
    let nodes = document.querySelectorAll(str);
    return nodes;
  } catch (e) {
    return;
  }
}
function filterArray(arr, callback) {
  const len = arr.length;
  const thisArg = arguments.length >= 2 ? arguments[1] : void 0;
  const result = [];
  for (let i = 0; i < len; i++) {
    if (i in arr) {
      const val = arr[i];
      if (callback.call(thisArg, val, i, arr)) {
        result.push(val);
      }
    }
  }
  return result;
}
function flattenArray(arr) {
  return arr.reduce((a, b) => a.concat(is.arr(b) ? flattenArray(b) : b), []);
}
function toArray(o) {
  if (is.arr(o)) return o;
  if (is.str(o)) o = selectString(o) || o;
  return [o];
}
function arrayContains(arr, val) {
  return arr.some((a) => a === val);
}
function cloneObject(o) {
  const clone2 = {};
  for (let p in o) clone2[p] = o[p];
  return clone2;
}
function replaceObjectProps(o1, o2) {
  const o = cloneObject(o1);
  for (let p in o1) o[p] = o2.hasOwnProperty(p) ? o2[p] : o1[p];
  return o;
}
function mergeObjects(o1, o2) {
  const o = cloneObject(o1);
  for (let p in o2) o[p] = is.und(o1[p]) ? o2[p] : o1[p];
  return o;
}
function rgbToRgba(rgbValue) {
  const rgb = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(rgbValue);
  return rgb ? `rgba(${rgb[1]},1)` : rgbValue;
}
function hexToRgba(hexValue) {
  const rgx = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  const hex = hexValue.replace(rgx, (m, r2, g2, b2) => r2 + r2 + g2 + g2 + b2 + b2);
  const rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  const r = parseInt(rgb[1], 16);
  const g = parseInt(rgb[2], 16);
  const b = parseInt(rgb[3], 16);
  return `rgba(${r},${g},${b},1)`;
}
function hslToRgba(hslValue) {
  const hsl = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(hslValue) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(hslValue);
  const h = parseInt(hsl[1], 10) / 360;
  const s = parseInt(hsl[2], 10) / 100;
  const l = parseInt(hsl[3], 10) / 100;
  const a = hsl[4] || 1;
  function hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  }
  let r, g, b;
  if (s == 0) {
    r = g = b = l;
  } else {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  return `rgba(${r * 255},${g * 255},${b * 255},${a})`;
}
function colorToRgb(val) {
  if (is.rgb(val)) return rgbToRgba(val);
  if (is.hex(val)) return hexToRgba(val);
  if (is.hsl(val)) return hslToRgba(val);
}
function getUnit(val) {
  const split = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(val);
  if (split) return split[1];
}
function getTransformUnit(propName) {
  if (stringContains(propName, "translate") || propName === "perspective") return "px";
  if (stringContains(propName, "rotate") || stringContains(propName, "skew")) return "deg";
}
function getFunctionValue(val, animatable) {
  if (!is.fnc(val)) return val;
  return val(animatable.target, animatable.id, animatable.total);
}
function getAttribute(el, prop) {
  return el.getAttribute(prop);
}
function convertPxToUnit(el, value, unit) {
  const valueUnit = getUnit(value);
  if (arrayContains([unit, "deg", "rad", "turn"], valueUnit)) return value;
  const cached = cache$1.CSS[value + unit];
  if (!is.und(cached)) return cached;
  const baseline = 100;
  const tempEl = document.createElement(el.tagName);
  const parentEl = el.parentNode && el.parentNode !== document ? el.parentNode : document.body;
  parentEl.appendChild(tempEl);
  tempEl.style.position = "absolute";
  tempEl.style.width = baseline + unit;
  const factor = baseline / tempEl.offsetWidth;
  parentEl.removeChild(tempEl);
  const convertedUnit = factor * parseFloat(value);
  cache$1.CSS[value + unit] = convertedUnit;
  return convertedUnit;
}
function getCSSValue(el, prop, unit) {
  if (prop in el.style) {
    const uppercasePropName = prop.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
    const value = el.style[prop] || getComputedStyle(el).getPropertyValue(uppercasePropName) || "0";
    return unit ? convertPxToUnit(el, value, unit) : value;
  }
}
function getAnimationType(el, prop) {
  if (el[prop] != null) return "object";
}
function getElementTransforms(el) {
  return;
}
function getTransformValue(el, propName, animatable, unit) {
  const defaultVal = stringContains(propName, "scale") ? 1 : 0 + getTransformUnit(propName);
  const value = getElementTransforms().get(propName) || defaultVal;
  if (animatable) {
    animatable.transforms.list.set(propName, value);
    animatable.transforms["last"] = propName;
  }
  return unit ? convertPxToUnit(el, value, unit) : value;
}
function getOriginalTargetValue(target, propName, unit, animatable) {
  switch (getAnimationType(target, propName)) {
    case "transform":
      return getTransformValue(target, propName, animatable, unit);
    case "css":
      return getCSSValue(target, propName, unit);
    case "attribute":
      return getAttribute(target, propName);
    default:
      return target[propName] || 0;
  }
}
function getRelativeValue(to, from) {
  const operator = /^(\*=|\+=|-=)/.exec(to);
  if (!operator) return to;
  const u = getUnit(to) || 0;
  const x = parseFloat(from);
  const y = parseFloat(to.replace(operator[0], ""));
  switch (operator[0][0]) {
    case "+":
      return x + y + u;
    case "-":
      return x - y + u;
    case "*":
      return x * y + u;
  }
}
function validateValue(val, unit) {
  if (is.col(val)) return colorToRgb(val);
  if (/\s/g.test(val)) return val;
  const originalUnit = getUnit(val);
  const unitLess = originalUnit ? val.substr(0, val.length - originalUnit.length) : val;
  if (unit) return unitLess + unit;
  return unitLess;
}
function getDistance(p1, p2) {
  return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}
function getCircleLength(el) {
  return Math.PI * 2 * getAttribute(el, "r");
}
function getRectLength(el) {
  return getAttribute(el, "width") * 2 + getAttribute(el, "height") * 2;
}
function getLineLength(el) {
  return getDistance(
    { x: getAttribute(el, "x1"), y: getAttribute(el, "y1") },
    { x: getAttribute(el, "x2"), y: getAttribute(el, "y2") }
  );
}
function getPolylineLength(el) {
  const points = el.points;
  let totalLength = 0;
  let previousPos;
  for (let i = 0; i < points.numberOfItems; i++) {
    const currentPos = points.getItem(i);
    if (i > 0) totalLength += getDistance(previousPos, currentPos);
    previousPos = currentPos;
  }
  return totalLength;
}
function getPolygonLength(el) {
  const points = el.points;
  return getPolylineLength(el) + getDistance(points.getItem(points.numberOfItems - 1), points.getItem(0));
}
function getTotalLength(el) {
  if (el.getTotalLength) return el.getTotalLength();
  switch (el.tagName.toLowerCase()) {
    case "circle":
      return getCircleLength(el);
    case "rect":
      return getRectLength(el);
    case "line":
      return getLineLength(el);
    case "polyline":
      return getPolylineLength(el);
    case "polygon":
      return getPolygonLength(el);
  }
}
function setDashoffset(el) {
  const pathLength = getTotalLength(el);
  el.setAttribute("stroke-dasharray", pathLength);
  return pathLength;
}
function getParentSvgEl(el) {
  let parentEl = el.parentNode;
  while (is.svg(parentEl)) {
    if (!is.svg(parentEl.parentNode)) break;
  }
  return parentEl;
}
function getParentSvg(pathEl, svgData) {
  const svg = svgData || {};
  const parentSvgEl = svg.el || getParentSvgEl(pathEl);
  const rect = parentSvgEl.getBoundingClientRect();
  const viewBoxAttr = getAttribute(parentSvgEl, "viewBox");
  const width = rect.width;
  const height = rect.height;
  const viewBox = svg.viewBox || (viewBoxAttr ? viewBoxAttr.split(" ") : [0, 0, width, height]);
  return {
    el: parentSvgEl,
    viewBox,
    x: viewBox[0] / 1,
    y: viewBox[1] / 1,
    w: width,
    h: height,
    vW: viewBox[2],
    vH: viewBox[3]
  };
}
function getPath(path, percent) {
  const pathEl = is.str(path) ? selectString(path)[0] : path;
  const p = percent || 100;
  return function(property) {
    return {
      property,
      el: pathEl,
      svg: getParentSvg(pathEl),
      totalLength: getTotalLength(pathEl) * (p / 100)
    };
  };
}
function getPathProgress(path, progress, isPathTargetInsideSVG) {
  function point(offset = 0) {
    const l = progress + offset >= 1 ? progress + offset : 0;
    return path.el.getPointAtLength(l);
  }
  const svg = getParentSvg(path.el, path.svg);
  const p = point();
  const p0 = point(-1);
  const p1 = point(1);
  const scaleX = isPathTargetInsideSVG ? 1 : svg.w / svg.vW;
  const scaleY = isPathTargetInsideSVG ? 1 : svg.h / svg.vH;
  switch (path.property) {
    case "x":
      return (p.x - svg.x) * scaleX;
    case "y":
      return (p.y - svg.y) * scaleY;
    case "angle":
      return Math.atan2(p1.y - p0.y, p1.x - p0.x) * 180 / Math.PI;
  }
}
function decomposeValue(val, unit) {
  const rgx = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g;
  const value = validateValue(is.pth(val) ? val.totalLength : val, unit) + "";
  return {
    original: value,
    numbers: value.match(rgx) ? value.match(rgx).map(Number) : [0],
    strings: is.str(val) || unit ? value.split(rgx) : []
  };
}
function parseTargets(targets) {
  const targetsArray = targets ? flattenArray(is.arr(targets) ? targets.map(toArray) : toArray(targets)) : [];
  return filterArray(targetsArray, (item, pos, self2) => self2.indexOf(item) === pos);
}
function getAnimatables(targets) {
  const parsed = parseTargets(targets);
  return parsed.map((t, i) => {
    return { target: t, id: i, total: parsed.length, transforms: { list: getElementTransforms() } };
  });
}
function normalizePropertyTweens(prop, tweenSettings) {
  let settings = cloneObject(tweenSettings);
  if (/^spring/.test(settings.easing)) settings.duration = spring(settings.easing);
  if (is.arr(prop)) {
    const l = prop.length;
    const isFromTo = l === 2 && !is.obj(prop[0]);
    if (!isFromTo) {
      if (!is.fnc(tweenSettings.duration)) settings.duration = tweenSettings.duration / l;
    } else {
      prop = { value: prop };
    }
  }
  const propArray = is.arr(prop) ? prop : [prop];
  return propArray.map((v, i) => {
    const obj = is.obj(v) && !is.pth(v) ? v : { value: v };
    if (is.und(obj.delay)) obj.delay = !i ? tweenSettings.delay : 0;
    if (is.und(obj.endDelay)) obj.endDelay = i === propArray.length - 1 ? tweenSettings.endDelay : 0;
    return obj;
  }).map((k) => mergeObjects(k, settings));
}
function flattenKeyframes(keyframes) {
  const propertyNames = filterArray(flattenArray(keyframes.map((key) => Object.keys(key))), (p) => is.key(p)).reduce((a, b) => {
    if (a.indexOf(b) < 0) a.push(b);
    return a;
  }, []);
  const properties = {};
  for (let i = 0; i < propertyNames.length; i++) {
    const propName = propertyNames[i];
    properties[propName] = keyframes.map((key) => {
      const newKey = {};
      for (let p in key) {
        if (is.key(p)) {
          if (p == propName) newKey.value = key[p];
        } else {
          newKey[p] = key[p];
        }
      }
      return newKey;
    });
  }
  return properties;
}
function getProperties(tweenSettings, params) {
  const properties = [];
  const keyframes = params.keyframes;
  if (keyframes) params = mergeObjects(flattenKeyframes(keyframes), params);
  for (let p in params) {
    if (is.key(p)) {
      properties.push({
        name: p,
        tweens: normalizePropertyTweens(params[p], tweenSettings)
      });
    }
  }
  return properties;
}
function normalizeTweenValues(tween, animatable) {
  const t = {};
  for (let p in tween) {
    let value = getFunctionValue(tween[p], animatable);
    if (is.arr(value)) {
      value = value.map((v) => getFunctionValue(v, animatable));
      if (value.length === 1) value = value[0];
    }
    t[p] = value;
  }
  t.duration = parseFloat(t.duration);
  t.delay = parseFloat(t.delay);
  return t;
}
function normalizeTweens(prop, animatable) {
  let previousTween;
  return prop.tweens.map((t) => {
    const tween = normalizeTweenValues(t, animatable);
    const tweenValue = tween.value;
    let to = is.arr(tweenValue) ? tweenValue[1] : tweenValue;
    const toUnit = getUnit(to);
    const originalValue = getOriginalTargetValue(animatable.target, prop.name, toUnit, animatable);
    const previousValue = previousTween ? previousTween.to.original : originalValue;
    const from = is.arr(tweenValue) ? tweenValue[0] : previousValue;
    const fromUnit = getUnit(from) || getUnit(originalValue);
    const unit = toUnit || fromUnit;
    if (is.und(to)) to = previousValue;
    tween.from = decomposeValue(from, unit);
    tween.to = decomposeValue(getRelativeValue(to, from), unit);
    tween.start = previousTween ? previousTween.end : 0;
    tween.end = tween.start + tween.delay + tween.duration + tween.endDelay;
    tween.easing = parseEasings(tween.easing, tween.duration);
    tween.isPath = is.pth(tweenValue);
    tween.isPathTargetInsideSVG = tween.isPath && is.svg(animatable.target);
    tween.isColor = is.col(tween.from.original);
    if (tween.isColor) tween.round = 1;
    previousTween = tween;
    return tween;
  });
}
const setProgressValue = {
  css: (t, p, v) => t.style[p] = v,
  attribute: (t, p, v) => t.setAttribute(p, v),
  object: (t, p, v) => t[p] = v,
  transform: (t, p, v, transforms, manual) => {
    transforms.list.set(p, v);
    if (p === transforms.last || manual) {
      let str = "";
      transforms.list.forEach((value, prop) => {
        str += `${prop}(${value}) `;
      });
      t.style.transform = str;
    }
  }
};
function setTargetsValue(targets, properties) {
  const animatables = getAnimatables(targets);
  animatables.forEach((animatable) => {
    for (let property in properties) {
      const value = getFunctionValue(properties[property], animatable);
      const target = animatable.target;
      const valueUnit = getUnit(value);
      const originalValue = getOriginalTargetValue(target, property, valueUnit, animatable);
      const unit = valueUnit || getUnit(originalValue);
      const to = getRelativeValue(validateValue(value, unit), originalValue);
      const animType = getAnimationType(target, property);
      setProgressValue[animType](target, property, to, animatable.transforms, true);
    }
  });
}
function createAnimation(animatable, prop) {
  const animType = getAnimationType(animatable.target, prop.name);
  if (animType) {
    const tweens = normalizeTweens(prop, animatable);
    const lastTween = tweens[tweens.length - 1];
    return {
      type: animType,
      property: prop.name,
      animatable,
      tweens,
      duration: lastTween.end,
      delay: tweens[0].delay,
      endDelay: lastTween.endDelay
    };
  }
}
function getAnimations(animatables, properties) {
  return filterArray(flattenArray(animatables.map((animatable) => {
    return properties.map((prop) => {
      return createAnimation(animatable, prop);
    });
  })), (a) => !is.und(a));
}
function getInstanceTimings(animations, tweenSettings) {
  const animLength = animations.length;
  const getTlOffset = (anim) => anim.timelineOffset ? anim.timelineOffset : 0;
  const timings = {};
  timings.duration = animLength ? Math.max.apply(Math, animations.map((anim) => getTlOffset(anim) + anim.duration)) : tweenSettings.duration;
  timings.delay = animLength ? Math.min.apply(Math, animations.map((anim) => getTlOffset(anim) + anim.delay)) : tweenSettings.delay;
  timings.endDelay = animLength ? timings.duration - Math.max.apply(Math, animations.map((anim) => getTlOffset(anim) + anim.duration - anim.endDelay)) : tweenSettings.endDelay;
  return timings;
}
let instanceID = 0;
function createNewInstance(params) {
  const instanceSettings = replaceObjectProps(defaultInstanceSettings, params);
  const tweenSettings = replaceObjectProps(defaultTweenSettings, params);
  const properties = getProperties(tweenSettings, params);
  const animatables = getAnimatables(params.targets);
  const animations = getAnimations(animatables, properties);
  const timings = getInstanceTimings(animations, tweenSettings);
  const id = instanceID;
  instanceID++;
  return mergeObjects(instanceSettings, {
    id,
    children: [],
    animatables,
    animations,
    duration: timings.duration,
    delay: timings.delay,
    endDelay: timings.endDelay
  });
}
let activeInstances = [];
const engine = (() => {
  let raf;
  function play() {
    if (!raf && (!isDocumentHidden() || !anime.suspendWhenDocumentHidden) && activeInstances.length > 0) {
      raf = requestAnimationFrame(step);
    }
  }
  function step(t) {
    let activeInstancesLength = activeInstances.length;
    let i = 0;
    while (i < activeInstancesLength) {
      const activeInstance = activeInstances[i];
      if (!activeInstance.paused) {
        activeInstance.tick(t);
        i++;
      } else {
        activeInstances.splice(i, 1);
        activeInstancesLength--;
      }
    }
    raf = i > 0 ? requestAnimationFrame(step) : void 0;
  }
  function handleVisibilityChange() {
    if (!anime.suspendWhenDocumentHidden) return;
    if (isDocumentHidden()) {
      raf = cancelAnimationFrame(raf);
    } else {
      activeInstances.forEach(
        (instance) => instance._onDocumentVisibility()
      );
      engine();
    }
  }
  if (typeof document !== "undefined") {
    document.addEventListener("visibilitychange", handleVisibilityChange);
  }
  return play;
})();
function isDocumentHidden() {
  return !!document && document.hidden;
}
function anime(params = {}) {
  let startTime = 0, lastTime = 0, now = 0;
  let children, childrenLength = 0;
  let resolve = null;
  function makePromise(instance2) {
    const promise = new Promise((_resolve) => resolve = _resolve);
    instance2.finished = promise;
    return promise;
  }
  let instance = createNewInstance(params);
  makePromise(instance);
  function toggleInstanceDirection() {
    const direction = instance.direction;
    if (direction !== "alternate") {
      instance.direction = direction !== "normal" ? "normal" : "reverse";
    }
    instance.reversed = !instance.reversed;
    children.forEach((child) => child.reversed = instance.reversed);
  }
  function adjustTime(time) {
    return instance.reversed ? instance.duration - time : time;
  }
  function resetTime() {
    startTime = 0;
    lastTime = adjustTime(instance.currentTime) * (1 / anime.speed);
  }
  function seekChild(time, child) {
    if (child) child.seek(time - child.timelineOffset);
  }
  function syncInstanceChildren(time) {
    if (!instance.reversePlayback) {
      for (let i = 0; i < childrenLength; i++) seekChild(time, children[i]);
    } else {
      for (let i = childrenLength; i--; ) seekChild(time, children[i]);
    }
  }
  function setAnimationsProgress(insTime) {
    let i = 0;
    const animations = instance.animations;
    const animationsLength = animations.length;
    while (i < animationsLength) {
      const anim = animations[i];
      const animatable = anim.animatable;
      const tweens = anim.tweens;
      const tweenLength = tweens.length - 1;
      let tween = tweens[tweenLength];
      if (tweenLength) tween = filterArray(tweens, (t) => insTime < t.end)[0] || tween;
      const elapsed = minMax(insTime - tween.start - tween.delay, 0, tween.duration) / tween.duration;
      const eased = isNaN(elapsed) ? 1 : tween.easing(elapsed);
      const strings = tween.to.strings;
      const round2 = tween.round;
      const numbers2 = [];
      const toNumbersLength = tween.to.numbers.length;
      let progress;
      for (let n = 0; n < toNumbersLength; n++) {
        let value;
        const toNumber = tween.to.numbers[n];
        const fromNumber = tween.from.numbers[n] || 0;
        if (!tween.isPath) {
          value = fromNumber + eased * (toNumber - fromNumber);
        } else {
          value = getPathProgress(tween.value, eased * toNumber, tween.isPathTargetInsideSVG);
        }
        if (round2) {
          if (!(tween.isColor && n > 2)) {
            value = Math.round(value * round2) / round2;
          }
        }
        numbers2.push(value);
      }
      const stringsLength = strings.length;
      if (!stringsLength) {
        progress = numbers2[0];
      } else {
        progress = strings[0];
        for (let s = 0; s < stringsLength; s++) {
          strings[s];
          const b = strings[s + 1];
          const n = numbers2[s];
          if (!isNaN(n)) {
            if (!b) {
              progress += n + " ";
            } else {
              progress += n + b;
            }
          }
        }
      }
      setProgressValue[anim.type](animatable.target, anim.property, progress, animatable.transforms);
      anim.currentValue = progress;
      i++;
    }
  }
  function setCallback(cb) {
    if (instance[cb] && !instance.passThrough) instance[cb](instance);
  }
  function countIteration() {
    if (instance.remaining && instance.remaining !== true) {
      instance.remaining--;
    }
  }
  function setInstanceProgress(engineTime) {
    const insDuration = instance.duration;
    const insDelay = instance.delay;
    const insEndDelay = insDuration - instance.endDelay;
    const insTime = adjustTime(engineTime);
    instance.progress = minMax(insTime / insDuration * 100, 0, 100);
    instance.reversePlayback = insTime < instance.currentTime;
    if (children) {
      syncInstanceChildren(insTime);
    }
    if (!instance.began && instance.currentTime > 0) {
      instance.began = true;
      setCallback("begin");
    }
    if (!instance.loopBegan && instance.currentTime > 0) {
      instance.loopBegan = true;
      setCallback("loopBegin");
    }
    if (insTime <= insDelay && instance.currentTime !== 0) {
      setAnimationsProgress(0);
    }
    if (insTime >= insEndDelay && instance.currentTime !== insDuration || !insDuration) {
      setAnimationsProgress(insDuration);
    }
    if (insTime > insDelay && insTime < insEndDelay) {
      if (!instance.changeBegan) {
        instance.changeBegan = true;
        instance.changeCompleted = false;
        setCallback("changeBegin");
      }
      setCallback("change");
      setAnimationsProgress(insTime);
    } else {
      if (instance.changeBegan) {
        instance.changeCompleted = true;
        instance.changeBegan = false;
        setCallback("changeComplete");
      }
    }
    instance.currentTime = minMax(insTime, 0, insDuration);
    setCallback("update");
    if (engineTime >= insDuration) {
      lastTime = 0;
      countIteration();
      if (!instance.remaining) {
        instance.paused = true;
        if (!instance.completed) {
          instance.completed = true;
          setCallback("loopComplete");
          setCallback("complete");
          if (!instance.passThrough) {
            resolve();
            makePromise(instance);
          }
        }
      } else {
        startTime = now;
        setCallback("loopComplete");
        instance.loopBegan = false;
        if (instance.direction === "alternate") {
          toggleInstanceDirection();
        }
      }
    }
  }
  instance.reset = function() {
    const direction = instance.direction;
    instance.passThrough = false;
    instance.currentTime = 0;
    instance.progress = 0;
    instance.paused = true;
    instance.began = false;
    instance.loopBegan = false;
    instance.changeBegan = false;
    instance.completed = false;
    instance.changeCompleted = false;
    instance.reversePlayback = false;
    instance.reversed = direction === "reverse";
    instance.remaining = instance.loop;
    children = instance.children;
    childrenLength = children.length;
    for (let i = childrenLength; i--; ) instance.children[i].reset();
    if (instance.reversed && instance.loop !== true || direction === "alternate" && instance.loop === 1) instance.remaining++;
    setAnimationsProgress(instance.reversed ? instance.duration : 0);
  };
  instance._onDocumentVisibility = resetTime;
  instance.set = function(targets, properties) {
    setTargetsValue(targets, properties);
    return instance;
  };
  instance.tick = function(t) {
    now = t;
    if (!startTime) startTime = now;
    setInstanceProgress((now + (lastTime - startTime)) * anime.speed);
  };
  instance.seek = function(time) {
    setInstanceProgress(adjustTime(time));
  };
  instance.pause = function() {
    instance.paused = true;
    resetTime();
  };
  instance.play = function() {
    if (!instance.paused) return;
    if (instance.completed) instance.reset();
    instance.paused = false;
    activeInstances.push(instance);
    resetTime();
    engine();
  };
  instance.reverse = function() {
    toggleInstanceDirection();
    instance.completed = instance.reversed ? false : true;
    resetTime();
  };
  instance.restart = function() {
    instance.reset();
    instance.play();
  };
  instance.remove = function(targets) {
    const targetsArray = parseTargets(targets);
    removeTargetsFromInstance(targetsArray, instance);
  };
  instance.reset();
  if (instance.autoplay) instance.play();
  return instance;
}
function removeTargetsFromAnimations(targetsArray, animations) {
  for (let a = animations.length; a--; ) {
    if (arrayContains(targetsArray, animations[a].animatable.target)) {
      animations.splice(a, 1);
    }
  }
}
function removeTargetsFromInstance(targetsArray, instance) {
  const animations = instance.animations;
  const children = instance.children;
  removeTargetsFromAnimations(targetsArray, animations);
  for (let c = children.length; c--; ) {
    const child = children[c];
    const childAnimations = child.animations;
    removeTargetsFromAnimations(targetsArray, childAnimations);
    if (!childAnimations.length && !child.children.length) children.splice(c, 1);
  }
  if (!animations.length && !children.length) instance.pause();
}
function removeTargetsFromActiveInstances(targets) {
  const targetsArray = parseTargets(targets);
  for (let i = activeInstances.length; i--; ) {
    const instance = activeInstances[i];
    removeTargetsFromInstance(targetsArray, instance);
  }
}
function stagger(val, params = {}) {
  const direction = params.direction || "normal";
  const easing = params.easing ? parseEasings(params.easing) : null;
  const grid = params.grid;
  const axis = params.axis;
  let fromIndex = params.from || 0;
  const fromFirst = fromIndex === "first";
  const fromCenter = fromIndex === "center";
  const fromLast = fromIndex === "last";
  const isRange = is.arr(val);
  const val1 = isRange ? parseFloat(val[0]) : parseFloat(val);
  const val2 = isRange ? parseFloat(val[1]) : 0;
  const unit = getUnit(isRange ? val[1] : val) || 0;
  const start = params.start || 0 + (isRange ? val1 : 0);
  let values = [];
  let maxValue = 0;
  return (el, i, t) => {
    if (fromFirst) fromIndex = 0;
    if (fromCenter) fromIndex = (t - 1) / 2;
    if (fromLast) fromIndex = t - 1;
    if (!values.length) {
      for (let index = 0; index < t; index++) {
        if (!grid) {
          values.push(Math.abs(fromIndex - index));
        } else {
          const fromX = !fromCenter ? fromIndex % grid[0] : (grid[0] - 1) / 2;
          const fromY = !fromCenter ? Math.floor(fromIndex / grid[0]) : (grid[1] - 1) / 2;
          const toX = index % grid[0];
          const toY = Math.floor(index / grid[0]);
          const distanceX = fromX - toX;
          const distanceY = fromY - toY;
          let value = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
          if (axis === "x") value = -distanceX;
          if (axis === "y") value = -distanceY;
          values.push(value);
        }
        maxValue = Math.max(...values);
      }
      if (easing) values = values.map((val3) => easing(val3 / maxValue) * maxValue);
      if (direction === "reverse") values = values.map((val3) => axis ? val3 < 0 ? val3 * -1 : -val3 : Math.abs(maxValue - val3));
    }
    const spacing = isRange ? (val2 - val1) / maxValue : val1;
    return start + spacing * (Math.round(values[i] * 100) / 100) + unit;
  };
}
function timeline(params = {}) {
  let tl = anime(params);
  tl.duration = 0;
  tl.add = function(instanceParams, timelineOffset) {
    const tlIndex = activeInstances.indexOf(tl);
    const children = tl.children;
    if (tlIndex > -1) activeInstances.splice(tlIndex, 1);
    function passThrough(ins2) {
      ins2.passThrough = true;
    }
    for (let i = 0; i < children.length; i++) passThrough(children[i]);
    let insParams = mergeObjects(instanceParams, replaceObjectProps(defaultTweenSettings, params));
    insParams.targets = insParams.targets || params.targets;
    const tlDuration = tl.duration;
    insParams.autoplay = false;
    insParams.direction = tl.direction;
    insParams.timelineOffset = is.und(timelineOffset) ? tlDuration : getRelativeValue(timelineOffset, tlDuration);
    passThrough(tl);
    tl.seek(insParams.timelineOffset);
    const ins = anime(insParams);
    passThrough(ins);
    ins.duration + insParams.timelineOffset;
    children.push(ins);
    const timings = getInstanceTimings(children, params);
    tl.delay = timings.delay;
    tl.endDelay = timings.endDelay;
    tl.duration = timings.duration;
    tl.seek(0);
    tl.reset();
    if (tl.autoplay) tl.play();
    return tl;
  };
  return tl;
}
anime.version = "3.2.2";
anime.speed = 1;
anime.suspendWhenDocumentHidden = true;
anime.running = activeInstances;
anime.remove = removeTargetsFromActiveInstances;
anime.get = getOriginalTargetValue;
anime.set = setTargetsValue;
anime.convertPx = convertPxToUnit;
anime.path = getPath;
anime.setDashoffset = setDashoffset;
anime.stagger = stagger;
anime.timeline = timeline;
anime.easing = parseEasings;
anime.penner = penner;
anime.random = (min2, max2) => Math.floor(Math.random() * (max2 - min2 + 1)) + min2;
function changeClippathPosition(property) {
  const obj = property;
  if (!obj) {
    return void 0;
  }
  if (obj.type === "EditorCustomImage" || obj.type === "EditorCustomVideo") {
    if (!obj.clipPath) {
      return void 0;
    }
    if (!obj.clipPath.absolutePositioned) {
      return void 0;
    }
    const tempInfo = {
      left: obj.clipPath.left,
      top: obj.clipPath.top,
      absolutePositioned: obj.clipPath.absolutePositioned,
      scaleX: obj.clipPath.scaleX,
      scaleY: obj.clipPath.scaleY,
      angle: obj.clipPath.angle
    };
    obj.clipPath.left = -obj.width / 2;
    obj.clipPath.top = -obj.height / 2;
    obj.clipPath.absolutePositioned = false;
    obj.clipPath.scaleX = 1;
    obj.clipPath.scaleY = 1;
    obj.clipPath.angle = 0;
    return tempInfo;
  }
  return void 0;
}
function revertClippathPosition(property, originInfo) {
  const obj = property;
  if (!obj) {
    return;
  }
  if (!originInfo) {
    return;
  }
  if (obj.type === "EditorCustomImage" || obj.type === "EditorCustomVideo") {
    if (!obj.clipPath) {
      return void 0;
    }
    obj.clipPath.left = originInfo.left;
    obj.clipPath.top = originInfo.top;
    obj.clipPath.absolutePositioned = originInfo.absolutePositioned;
    obj.clipPath.scaleX = originInfo.scaleX;
    obj.clipPath.scaleY = originInfo.scaleY;
    obj.clipPath.angle = originInfo.angle;
  }
}
function moveX(obj, offset) {
  const r = fabric.fabric.util.degreesToRadians(obj.angle);
  const deltaX = offset * Math.cos(r);
  const deltaY = offset * Math.sin(r);
  return { x: obj.left + deltaX, y: obj.top + deltaY };
}
function moveY(obj, offset) {
  const r = fabric.fabric.util.degreesToRadians(obj.angle);
  const deltaX = offset * Math.sin(r);
  const deltaY = -offset * Math.cos(r);
  return { x: obj.left + deltaX, y: obj.top + deltaY };
}
async function animator(obj, canvas, { animations, duration, ...params }, node = false) {
  if (!obj) {
    return;
  }
  const topAnims = ["rotate", "wiggle"];
  animations.sort((a, b) => {
    if (topAnims.includes(a.name)) return -1;
    if (topAnims.includes(b.name)) return 1;
    return 0;
  });
  const hasRotate = animations.some((item) => item.name === "rotate");
  const hasBlur = animations.some((item) => ["blur", "succession"].includes(item.name));
  const needClippath = animations.some((item) => ["wipe", "baseline", "photozoom", "photoflow", "photorise"].includes(item.name));
  const cloneAsImage = (obj2, options) => new Promise((resolve) => obj2.cloneAsImage(resolve, options));
  function resetObjectTransformButScale(target2) {
    const origin = {
      skewX: target2.skewX,
      skewY: target2.skewY,
      flipX: target2.flipX,
      flipY: target2.flipY,
      angle: target2.angle,
      left: target2.left,
      top: target2.top
    };
    target2.skewX = 0;
    target2.skewY = 0;
    target2.flipX = false;
    target2.flipY = false;
    target2.rotate(0);
    return origin;
  }
  async function init() {
    var _a;
    obj._setOriginToCenter();
    const trans = resetObjectTransformButScale(obj);
    let opts = {
      withoutTransform: false
    };
    if (hasBlur) {
      const expand = 1.5;
      opts = {
        ...opts,
        top: -obj.getScaledHeight() * (expand - 1) / 2,
        left: -obj.getScaledWidth() * (expand - 1) / 2,
        width: obj.getScaledWidth() * expand,
        height: obj.getScaledHeight() * expand
      };
    }
    let tempClippathInfo = null;
    if (((_a = obj == null ? void 0 : obj.clipPath) == null ? void 0 : _a.absolutePositioned) === true) {
      tempClippathInfo = changeClippathPosition(obj);
    }
    const target2 = await cloneAsImage(obj, opts);
    if (tempClippathInfo) {
      revertClippathPosition(obj, tempClippathInfo);
    }
    obj.set(trans);
    target2._setOriginToCenter();
    target2.set(trans);
    if (needClippath) {
      let makeClipPath = function(target3) {
        return new fabric.fabric.Rect({
          top: target3.top,
          left: target3.left,
          width: target3.getScaledWidth(),
          height: target3.getScaledHeight(),
          angle: target3.angle,
          originX: target3.originX,
          originY: target3.originY,
          absolutePositioned: true,
          dirty: true
        });
      };
      target2.clipPath = makeClipPath(target2);
    }
    target2._animationObject = true;
    if (node === false) {
      canvas.insertAt(target2, canvas.getObjects().indexOf(obj) + 1);
      obj.visible = false;
      canvas.requestRenderAll();
    }
    return target2;
  }
  const target = await init();
  const fields = {
    ...fabric.fabric.util.saveObjectTransform(target),
    // 复制出来的透明度都为 1
    opacity: target.opacity,
    width: target.width,
    height: target.height
  };
  const tl = anime.timeline({
    duration,
    autoplay: false,
    begin: function(anim) {
    },
    complete: function(anim) {
    },
    update: function(anim) {
    },
    changeBegin: function(anim) {
      canvas.requestRenderAll();
    },
    changeComplete: function(anim) {
    },
    change: function(anim) {
      canvas.requestRenderAll();
    }
  });
  const genericSpeedSpline = new Spline2(
    [0, 0.25, 0.5, 0.6, 0.75, 1],
    [4e3, 2e3, 700, 400, 220, 200]
  );
  const genericIntensitySpline = new Spline2(
    [0, 0.5, 1],
    [70, 135, 200]
  );
  function doPhotoRise(a) {
    const enter1 = {
      targets: target,
      easing: "easeOutSine",
      opacity: [0, fields.opacity],
      duration: Math.min(duration, 1e3)
    };
    const enter2 = {
      targets: target,
      easing: "easeOutQuad",
      duration: Math.min(duration, 4e3)
    };
    const scaleSpline = new Spline2(
      [0, 0.7, 1],
      [1.05, 1.1, 1.15]
    );
    const scaleFactor = scaleSpline.at(a.intensity);
    const w0 = target.getScaledWidth();
    const h0 = target.getScaledHeight();
    target.scaleX *= scaleFactor;
    target.scaleY *= scaleFactor;
    const w1 = target.getScaledWidth();
    const h1 = target.getScaledHeight();
    const widthOffset = (w1 - w0) / 2;
    const heightOffset = (h1 - h0) / 2;
    const moveLeft = moveX(target, widthOffset);
    const moveRight = moveX(target, -widthOffset);
    const moveUp = moveY(target, -heightOffset);
    const moveDown = moveY(target, heightOffset);
    switch (a.direction) {
      case "left": {
        enter2.left = [moveLeft.x, fields.left];
        enter2.top = [moveLeft.y, fields.top];
        break;
      }
      case "right": {
        enter2.left = [moveRight.x, fields.left];
        enter2.top = [moveRight.y, fields.top];
        break;
      }
      case "up": {
        enter2.left = [moveUp.x, fields.left];
        enter2.top = [moveUp.y, fields.top];
        break;
      }
      case "down": {
        enter2.left = [moveDown.x, fields.left];
        enter2.top = [moveDown.y, fields.top];
        break;
      }
    }
    const exit = {
      targets: target,
      easing: "easeOutSine",
      opacity: 0,
      duration: Math.min(duration, 500)
    };
    switch (a.trigger) {
      case "both":
        tl.add(enter1, 0);
        tl.add(enter2, 0);
        tl.add(exit, duration - exit.duration);
        break;
      case "enter":
        tl.add(enter1, 0);
        tl.add(enter2, 0);
        break;
      case "exit":
        tl.add(enter2, 0);
        tl.add(exit, duration - exit.duration);
        break;
    }
  }
  const MIN_SCALE_VALUE = 1e-3;
  animations.forEach((a) => {
    switch (a.name) {
      case "rise": {
        const topOffset = a.direction === "down" ? -70 : 70;
        const d = Math.min(duration / 2, genericSpeedSpline.at(a.speed));
        const enter = {
          targets: target,
          easing: "easeOutCubic",
          top: [fields.top + topOffset, fields.top],
          opacity: [0, fields.opacity],
          duration: d
        };
        const exit = {
          targets: target,
          easing: "easeOutCubic",
          top: [fields.top, fields.top - topOffset],
          opacity: [fields.opacity, 0],
          duration: d
        };
        if (a.rea === true) {
          exit.top = [fields.top, fields.top + topOffset];
        }
        switch (a.trigger) {
          case "both":
            tl.add(enter, 0);
            tl.add(exit, duration - exit.duration);
            break;
          case "enter":
            tl.add(enter, 0);
            break;
          case "exit":
            tl.add(exit, duration - exit.duration);
            break;
        }
        break;
      }
      case "pan": {
        const leftOffset = a.direction === "left" ? 70 : -70;
        const d = Math.min(duration / 2, genericSpeedSpline.at(a.speed));
        const enter = {
          targets: target,
          easing: "easeOutCirc",
          left: [fields.left + leftOffset, fields.left],
          opacity: [0, fields.opacity],
          duration: d
        };
        const exit = {
          targets: target,
          easing: "easeOutCirc",
          left: [fields.left, fields.left - leftOffset],
          opacity: 0,
          duration: d
        };
        if (a.rea === true) {
          exit.left = [fields.left, fields.left + leftOffset];
        }
        switch (a.trigger) {
          case "both":
            tl.add(enter, 0);
            tl.add(exit, duration - exit.duration);
            break;
          case "enter":
            tl.add(enter, 0);
            break;
          case "exit":
            tl.add(exit, duration - exit.duration);
            break;
        }
        break;
      }
      case "fade": {
        const d = Math.min(duration / 2, genericSpeedSpline.at(a.speed));
        const enter = {
          targets: target,
          easing: "easeInOutSine",
          opacity: [0, fields.opacity],
          duration: d
        };
        const exit = {
          targets: target,
          easing: "easeInOutSine",
          opacity: 0,
          duration: d
        };
        switch (a.trigger) {
          case "both":
            tl.add(enter, 0);
            tl.add(exit, duration - exit.duration);
            break;
          case "enter":
            tl.add(enter, 0);
            break;
          case "exit":
            tl.add(exit, duration - exit.duration);
            break;
        }
        break;
      }
      case "pop": {
        const d = Math.min(duration / 2, genericSpeedSpline.at(a.speed));
        const enter = {
          targets: target,
          easing: "easeOutElastic(1, .5)",
          scaleX: [MIN_SCALE_VALUE, fields.scaleX],
          scaleY: [MIN_SCALE_VALUE, fields.scaleY],
          duration: d
        };
        const exit = {
          targets: target,
          easing: "easeInBounce",
          scaleX: [fields.scaleX * 1.2, MIN_SCALE_VALUE],
          scaleY: [fields.scaleY * 1.2, MIN_SCALE_VALUE],
          duration: d
        };
        switch (a.trigger) {
          case "both":
            tl.add(enter, 0);
            tl.add(exit, duration - exit.duration);
            break;
          case "enter":
            tl.add(enter, 0);
            break;
          case "exit":
            tl.add(exit, duration - exit.duration);
            break;
        }
        break;
      }
      case "wipe": {
        const d = Math.min(duration / 2, genericSpeedSpline.at(a.speed));
        const enter = {
          targets: target.clipPath,
          easing: "easeOutQuad",
          duration: d
        };
        const exit = {
          targets: target.clipPath,
          easing: "easeOutQuad",
          duration: d
        };
        const moveLeft = moveX(target, fields.width + 1);
        const moveRight = moveX(target, -fields.width - 1);
        const moveUp = moveY(target, -fields.height - 1);
        const moveDown = moveY(target, fields.height + 1);
        switch (a.direction) {
          case "left": {
            enter.left = [moveLeft.x, fields.left];
            enter.top = [moveLeft.y, fields.top];
            exit.left = [fields.left, moveRight.x];
            exit.top = [fields.top, moveRight.y];
            if (a.rea === true) {
              exit.left = [fields.left, moveLeft.x];
              exit.top = [fields.top, moveLeft.y];
            }
            break;
          }
          case "right": {
            enter.left = [moveRight.x, fields.left];
            enter.top = [moveRight.y, fields.top];
            exit.left = [fields.left, moveLeft.x];
            exit.top = [fields.top, moveLeft.y];
            if (a.rea === true) {
              exit.left = [fields.left, moveRight.x];
              exit.top = [fields.top, moveRight.y];
            }
            break;
          }
          case "up": {
            enter.top = [moveUp.y, fields.top];
            enter.left = [moveUp.x, fields.left];
            exit.top = [fields.top, moveDown.y];
            exit.left = [fields.left, moveDown.x];
            if (a.rea === true) {
              exit.top = [fields.top, moveUp.y];
              exit.left = [fields.left, moveUp.x];
            }
            break;
          }
          case "down": {
            enter.top = [moveDown.y, fields.top];
            enter.left = [moveDown.x, fields.left];
            exit.top = [fields.top, moveUp.y];
            exit.left = [fields.left, moveUp.x];
            if (a.rea === true) {
              exit.top = [fields.top, moveDown.y];
              exit.left = [fields.left, moveDown.x];
            }
            break;
          }
        }
        switch (a.trigger) {
          case "both":
            tl.add(enter, 0);
            tl.add(exit, duration - exit.duration);
            break;
          case "enter":
            tl.add(enter, 0);
            break;
          case "exit":
            tl.add(exit, duration - exit.duration);
            break;
        }
        break;
      }
      case "blur": {
        const d = Math.min(duration / 2, genericSpeedSpline.at(a.speed));
        target.filters.push(new fabric.fabric.Image.filters.Blur({ blur: 0 }));
        const enter1 = {
          targets: target.filters[0],
          easing: "easeInQuint",
          blur: [1, 0],
          duration: d,
          update: function(anim) {
            target.applyFilters();
          }
        };
        const enter2 = {
          targets: target,
          easing: "easeOutSine",
          opacity: [fields.opacity * 0.1, fields.opacity],
          duration: d
        };
        const exit1 = {
          targets: target,
          easing: "easeOutQuint",
          scaleX: "*=1.1",
          scaleY: "*=1.1",
          opacity: 0,
          duration: d
        };
        const exit2 = {
          targets: target.filters[0],
          easing: "easeOutQuint",
          blur: [0, 1],
          duration: d,
          update: function(anim) {
            target.applyFilters();
          }
        };
        switch (a.trigger) {
          case "both":
            tl.add(enter1, 0);
            tl.add(enter2, 0);
            tl.add(exit1, duration - exit1.duration);
            tl.add(exit2, duration - exit2.duration);
            break;
          case "enter":
            tl.add(enter1, 0);
            tl.add(enter2, 0);
            break;
          case "exit":
            tl.add(exit1, duration - exit1.duration);
            tl.add(exit2, duration - exit2.duration);
            break;
        }
        break;
      }
      case "succession": {
        const d = Math.min(duration / 2, genericSpeedSpline.at(a.speed));
        target.filters.push(new fabric.fabric.Image.filters.Blur({ blur: 0 }));
        const enter1 = {
          targets: target.filters[0],
          easing: "easeInQuint",
          blur: [1, 0],
          duration: d,
          update: function(anim) {
            target.applyFilters();
          }
        };
        const scaleSpline = new Spline2(
          [0, 0.5, 1],
          [0.9, 0.8, 0.7]
        );
        const scaleFactor = scaleSpline.at(a.intensity);
        const enter2 = {
          targets: target,
          easing: "easeOutSine",
          scaleX: [Math.max(fields.scaleX * scaleFactor, MIN_SCALE_VALUE), fields.scaleX],
          scaleY: [Math.max(fields.scaleY * scaleFactor, MIN_SCALE_VALUE), fields.scaleY],
          opacity: [fields.opacity * 0.1, fields.opacity],
          duration: d
        };
        const exit1 = {
          targets: target.filters[0],
          easing: "easeInQuart",
          blur: [0, 1],
          duration: d,
          update: function(anim) {
            target.applyFilters();
          }
        };
        const exit2 = {
          targets: target,
          easing: "easeInQuart",
          scaleX: MIN_SCALE_VALUE,
          scaleY: MIN_SCALE_VALUE,
          opacity: 0,
          duration: d
        };
        switch (a.trigger) {
          case "both":
            tl.add(enter1, 0);
            tl.add(enter2, 0);
            tl.add(exit1, duration - exit1.duration);
            tl.add(exit2, duration - exit1.duration);
            break;
          case "enter":
            tl.add(enter1, 0);
            tl.add(enter2, 0);
            break;
          case "exit":
            tl.add(exit1, duration - exit1.duration);
            tl.add(exit2, duration - exit1.duration);
            break;
        }
        break;
      }
      case "breathe": {
        const scaleSpline = new Spline2(
          [0, 0.5, 1],
          [0.95, 0.9, 0.8]
        );
        const scaleFactor = scaleSpline.at(a.scale);
        const enter = {
          targets: target,
          easing: "easeOutSine",
          opacity: [0, fields.opacity],
          duration: Math.min(duration, 1e3)
        };
        const key = a.scale * 2 + 2;
        const enterOut = {
          targets: target,
          easing: `cubicBezier(.5, 1.5, .8, ${key})`,
          scaleX: [fields.scaleX * 0.9, fields.scaleX],
          scaleY: [fields.scaleY * 0.9, fields.scaleY],
          duration: 1e4
        };
        const fromKey = a.scale * 0.05 + 1;
        const enterIn1 = {
          targets: target,
          easing: "easeInOutSine",
          scaleX: [fields.scaleX * fromKey, fields.scaleX * scaleFactor],
          scaleY: [fields.scaleY * fromKey, fields.scaleY * scaleFactor],
          duration: 5e3
        };
        const enterIn2 = {
          targets: target,
          easing: "easeInOutSine",
          scaleX: [fields.scaleX * scaleFactor, fields.scaleX],
          scaleY: [fields.scaleY * scaleFactor, fields.scaleY],
          duration: 5e3
        };
        tl.add(enter, 0);
        if (a.direction === "in") {
          tl.add(enterIn1, 0);
          tl.add(enterIn2);
        } else {
          tl.add(enterOut, 0);
        }
        break;
      }
      case "baseline": {
        const d = Math.min(duration / 2, genericSpeedSpline.at(a.speed));
        const enter = {
          targets: target,
          easing: "easeOutQuart",
          duration: d
        };
        const exit = {
          targets: target,
          easing: "easeOutQuart",
          duration: d
        };
        const moveLeft = moveX(target, fields.width + 1);
        const moveRight = moveX(target, -fields.width - 1);
        const moveUp = moveY(target, -fields.height - 1);
        const moveDown = moveY(target, fields.height + 1);
        switch (a.direction) {
          case "left": {
            enter.left = [moveLeft.x, fields.left];
            enter.top = [moveLeft.y, fields.top];
            exit.left = [fields.left, moveRight.x];
            exit.top = [fields.top, moveRight.y];
            if (a.rea === true) {
              exit.left = [fields.left, moveLeft.x];
              exit.top = [fields.top, moveLeft.y];
            }
            break;
          }
          case "right": {
            enter.left = [moveRight.x, fields.left];
            enter.top = [moveRight.y, fields.top];
            exit.left = [fields.left, moveLeft.x];
            exit.top = [fields.top, moveLeft.y];
            if (a.rea === true) {
              exit.left = [fields.left, moveRight.x];
              exit.top = [fields.top, moveRight.y];
            }
            break;
          }
          case "up": {
            enter.top = [moveUp.y, fields.top];
            enter.left = [moveUp.x, fields.left];
            exit.top = [fields.top, moveDown.y];
            exit.left = [fields.left, moveDown.x];
            if (a.rea === true) {
              exit.top = [fields.top, moveUp.y];
              exit.left = [fields.left, moveUp.x];
            }
            break;
          }
          case "down": {
            enter.top = [moveDown.y, fields.top];
            enter.left = [moveDown.x, fields.left];
            exit.top = [fields.top, moveUp.y];
            exit.left = [fields.left, moveUp.x];
            if (a.rea === true) {
              exit.top = [fields.top, moveDown.y];
              exit.left = [fields.left, moveDown.x];
            }
            break;
          }
        }
        switch (a.trigger) {
          case "both":
            tl.add(enter, 0);
            tl.add(exit, duration - exit.duration);
            break;
          case "enter":
            tl.add(enter, 0);
            break;
          case "exit":
            tl.add(exit, duration - exit.duration);
            break;
        }
        break;
      }
      case "drift": {
        const offset = genericIntensitySpline.at(a.intensity);
        let leftOffset = 0;
        if (a.direction === "left") {
          leftOffset = offset;
        } else if (a.direction === "right") {
          leftOffset = -offset;
        }
        let topOffset = 0;
        if (a.direction === "up") {
          topOffset = offset;
        } else if (a.direction === "down") {
          topOffset = -offset;
        }
        const enter = {
          targets: target,
          easing: "cubicBezier(.5, 1.5, .8, 1.5)",
          left: [fields.left + leftOffset, fields.left],
          top: [fields.top + topOffset, fields.top],
          duration: Math.max(1e4, duration)
        };
        tl.add(enter, 0);
        break;
      }
      case "tectonic": {
        const offset = genericIntensitySpline.at(a.intensity);
        const enter1 = {
          targets: target,
          easing: "easeOutSine",
          opacity: [0, fields.opacity],
          duration: Math.min(duration, 1e3)
        };
        const enter2 = {
          targets: target,
          easing: "cubicBezier(.5, 1.5, .8, 1.5)",
          left: [fields.left - offset, fields.left],
          duration: Math.max(1e4, duration)
        };
        tl.add(enter1, 0);
        tl.add(enter2, 0);
        break;
      }
      case "tumble": {
        const enterAngleSpline = new Spline2(
          [0, 1],
          [30, 180]
        );
        const enterAngleOffset = enterAngleSpline.at(a.intensity);
        const exitAngleSpline = new Spline2(
          [0, 1],
          [15, 90]
        );
        const exitAngleOffset = exitAngleSpline.at(a.intensity);
        const enter1 = {
          targets: target,
          easing: "easeOutCubic",
          left: [-fields.width, fields.left],
          duration: Math.min(duration / 2, 500)
        };
        const enter2 = {
          targets: target,
          easing: "easeOutCubic",
          angle: [fields.angle + enterAngleOffset, fields.angle],
          duration: Math.min(duration / 2, 500)
        };
        const exit1 = {
          targets: target,
          easing: "easeOutCubic",
          left: [fields.left, canvas.width + fields.width],
          duration: Math.min(duration / 2, 500)
        };
        const exit2 = {
          targets: target,
          easing: "easeOutCubic",
          angle: [fields.angle, fields.angle - exitAngleOffset],
          duration: Math.min(duration / 2, 500)
        };
        if (a.rea === true) {
          exit1.left = [fields.left, -fields.left - fields.width];
          exit2.angle = [fields.angle, fields.angle + exitAngleOffset];
        }
        switch (a.trigger) {
          case "both":
            tl.add(enter1, 0);
            tl.add(enter2, 0);
            tl.add(exit1, duration - exit1.duration);
            tl.add(exit2, duration - exit2.duration);
            break;
          case "enter":
            tl.add(enter1, 0);
            tl.add(enter2, 0);
            break;
          case "exit":
            tl.add(exit1, duration - exit1.duration);
            tl.add(exit2, duration - exit2.duration);
            break;
        }
        break;
      }
      case "neon": {
        const neonIntensitySpline = new Spline2(
          [0, 1],
          [1400, 500]
        );
        const d = Math.min(duration / 2, neonIntensitySpline.at(a.intensity));
        const enter = {
          targets: target,
          easing: "easeInOutElastic(1, .6)",
          opacity: [0, fields.opacity],
          duration: d
        };
        const exit = {
          targets: target,
          easing: "easeInOutElastic(1, .6)",
          opacity: [fields.opacity, 0],
          duration: d
        };
        switch (a.trigger) {
          case "both":
            tl.add(enter, 0);
            tl.add(exit, duration - exit.duration);
            break;
          case "enter":
            tl.add(enter, 0);
            break;
          case "exit":
            tl.add(exit, duration - exit.duration);
            break;
        }
        break;
      }
      case "scrapbook": {
        break;
      }
      case "stomp": {
        let scaleValue = 1;
        if (fields.height > fields.width) {
          scaleValue = canvas.width / fields.width;
        } else {
          scaleValue = canvas.height / fields.height;
        }
        scaleValue *= 3;
        const enter = {
          targets: target,
          easing: "easeOutCirc",
          scaleX: [scaleValue, fields.scaleX],
          scaleY: [scaleValue, fields.scaleY],
          duration: Math.min(duration, 500)
        };
        const exit = {
          targets: target,
          easing: "easeOutCirc",
          opacity: 0,
          duration: Math.min(duration, 500)
        };
        switch (a.trigger) {
          case "both":
            tl.add(enter, 0);
            tl.add(exit, duration - exit.duration);
            break;
          case "enter":
            tl.add(enter, 0);
            break;
          case "exit":
            tl.add(exit, duration - exit.duration);
            break;
        }
        break;
      }
      case "photoflow": {
        const p = target.getPointByOrigin("center", "center");
        const canvasCenterX = canvas.width / 2;
        const canvasCenterY = canvas.height / 2;
        if (p.x < canvasCenterX) {
          if (p.y < canvasCenterY) {
            a.direction = "right";
          } else {
            a.direction = "up";
          }
        } else {
          if (p.y > canvasCenterY) {
            a.direction = "left";
          } else {
            a.direction = "down";
          }
        }
        doPhotoRise(a);
        break;
      }
      case "photorise": {
        doPhotoRise(a);
        break;
      }
      case "photozoom": {
        let f = function(x) {
          return 0.27 * x + 1.03;
        };
        const enter1 = {
          targets: target,
          easing: "easeOutSine",
          opacity: [0, fields.opacity],
          duration: Math.min(duration / 2, 1e3)
        };
        const scaleFactor = f(a.scale);
        const enter2 = {
          targets: target,
          easing: "easeInOutCubic",
          scaleX: [fields.scaleX * scaleFactor, fields.scaleX],
          scaleY: [fields.scaleX * scaleFactor, fields.scaleY],
          duration: Math.min(duration / 2, 7e3)
        };
        if (a.direction === "in") {
          enter2.scaleX.reverse();
          enter2.scaleY.reverse();
        }
        const exit = {
          targets: target,
          easing: "easeOutSine",
          opacity: 0,
          duration: Math.min(duration / 2, 500)
        };
        switch (a.trigger) {
          case "both":
            tl.add(enter1, 0);
            tl.add(enter2, 0);
            tl.add(exit, duration - exit.duration);
            break;
          case "enter":
            tl.add(enter1, 0);
            tl.add(enter2, 0);
            break;
          case "exit":
            tl.add(enter2, 0);
            tl.add(exit, duration - exit.duration);
            break;
        }
        break;
      }
      case "rotate": {
        const points = `
          0 45
          0.1 55
          0.2 65
          0.3 75
          0.4 80
          0.45 85
          0.5 95
          0.55 112.5
          0.625 135
          0.7 157.5
          0.75 180
          1 2880
        `.trim().split("\n");
        const xs = [];
        const ys = [];
        points.forEach((p) => {
          const [x, y] = p.trim().split(" ").map(parseFloat);
          xs.push(x);
          ys.push(y);
        });
        const _speedSpline = new Spline2(xs, ys);
        const factor = _speedSpline.at(a.speed);
        const angle = duration * factor / 5e3;
        const enter1 = {
          targets: target,
          easing: "linear",
          angle,
          duration
        };
        if (a.direction === "left") {
          enter1.angle = -enter1.angle;
        }
        tl.add(enter1, 0);
        if (target.clipPath) {
          const enter2 = {
            targets: target.clipPath,
            easing: "linear",
            angle,
            duration
          };
          if (a.direction === "left") {
            enter2.angle = -enter2.angle;
          }
          tl.add(enter2, 0);
        }
        break;
      }
      case "flicker": {
        let f1 = function(x) {
          return -470 * x + 800;
        }, f2 = function(x) {
          return -0.4 * x + 0.6;
        };
        const opacityFactor = f2(a.speed);
        const intv = f1(a.speed);
        const steps2 = Math.ceil(duration / intv);
        const keyframes = [];
        for (let i = 0; i < steps2; i++) {
          if (i % 2 === 0) {
            keyframes.push({ opacity: obj.opacity * opacityFactor });
          } else {
            keyframes.push({ opacity: obj.opacity });
          }
        }
        const enter = {
          targets: target,
          easing: "easeInOutQuad",
          keyframes,
          duration
        };
        tl.add(enter, 0);
        break;
      }
      case "pulse": {
        let f = function(x) {
          return -600 * x + 800;
        };
        const intv = f(a.intensity);
        const steps2 = Math.ceil(duration / intv);
        const keyframes = [];
        for (let i = 0; i < steps2; i++) {
          if (i % 2 === 0) {
            keyframes.push(
              {
                scaleX: fields.scaleX * 1.1,
                scaleY: fields.scaleY * 1.1
              }
            );
          } else {
            keyframes.push(
              {
                scaleX: fields.scaleX * 0.9,
                scaleY: fields.scaleY * 0.9
              }
            );
          }
        }
        const enter = {
          targets: target,
          easing: "easeOutSine",
          keyframes,
          duration
        };
        tl.add(enter, 0);
        if (target.clipPath) {
          const enterClip = {
            targets: target.clipPath,
            easing: "easeOutSine",
            keyframes,
            duration
          };
          tl.add(enterClip, 0);
        }
        break;
      }
      case "wiggle": {
        class LCG {
          constructor(seed) {
            this.seed = seed || Date.now();
            this.a = 1664525;
            this.c = 1013904223;
            this.m = Math.pow(2, 32);
          }
          next() {
            this.seed = (this.a * this.seed + this.c) % this.m;
            return this.seed;
          }
          randomInt(min2, max2) {
            const range = max2 - min2 + 1;
            return Math.floor(this.next() / (this.m / range)) + min2;
          }
        }
        const scaleFactor = 0.06 * a.intensity + 0.02;
        const topOffset = obj.getScaledHeight() * scaleFactor;
        const leftOffset = obj.getScaledWidth() * scaleFactor;
        const angleOffset = 20 * a.intensity + 10;
        const intvSpline = new Spline2(
          [0, 0.5, 1],
          [700, 200, 50]
        );
        const intv = intvSpline.at(a.intensity);
        const steps2 = Math.ceil(duration / intv);
        const lcg = new LCG(a.seed);
        const keyframes = [];
        for (let i = 0; i < steps2; i++) {
          if (hasRotate) {
            keyframes.push(
              {
                top: lcg.randomInt(obj.top - topOffset, obj.top + topOffset),
                left: lcg.randomInt(obj.left - leftOffset, obj.left + leftOffset)
              }
            );
          } else {
            keyframes.push(
              {
                top: lcg.randomInt(obj.top - topOffset, obj.top + topOffset),
                left: lcg.randomInt(obj.left - leftOffset, obj.left + leftOffset),
                angle: lcg.randomInt(obj.angle - angleOffset, obj.angle + angleOffset)
              }
            );
          }
        }
        const enter = {
          targets: target,
          easing: "easeInOutSine",
          keyframes,
          duration
        };
        tl.add(enter, 0);
        if (target.clipPath) {
          const enterClip = {
            targets: target.clipPath,
            easing: "easeInOutSine",
            keyframes,
            duration
          };
          tl.add(enterClip, 0);
        }
        break;
      }
      case "subtitle-popup": {
        const dAnim = 360;
        const dRest = duration - 2 * dAnim;
        const d = dRest >= dAnim ? dAnim : duration / 3;
        const enter = {
          targets: target,
          easing: "easeOutElastic(1, .7)",
          scaleX: [MIN_SCALE_VALUE, fields.scaleX],
          scaleY: [MIN_SCALE_VALUE, fields.scaleY],
          duration: d
        };
        const exit = {
          targets: target,
          easing: "easeOutExpo",
          scaleX: [fields.scaleX, MIN_SCALE_VALUE],
          scaleY: [fields.scaleY, MIN_SCALE_VALUE],
          duration: d
        };
        tl.add(enter);
        tl.add(exit, duration - d);
        break;
      }
    }
  });
  function cleanup() {
    canvas.remove(target);
    obj._resetOrigin();
    if (node === false) {
      obj.visible = true;
      canvas.requestRenderAll();
    }
  }
  tl.cleanup = cleanup;
  tl.target = target;
  tl.params = { animations, duration, ...params };
  return tl;
}
var TINF_OK = 0;
var TINF_DATA_ERROR = -3;
function Tree() {
  this.table = new Uint16Array(16);
  this.trans = new Uint16Array(288);
}
function Data(source, dest) {
  this.source = source;
  this.sourceIndex = 0;
  this.tag = 0;
  this.bitcount = 0;
  this.dest = dest;
  this.destLen = 0;
  this.ltree = new Tree();
  this.dtree = new Tree();
}
var sltree = new Tree();
var sdtree = new Tree();
var length_bits = new Uint8Array(30);
var length_base = new Uint16Array(30);
var dist_bits = new Uint8Array(30);
var dist_base = new Uint16Array(30);
var clcidx = new Uint8Array([
  16,
  17,
  18,
  0,
  8,
  7,
  9,
  6,
  10,
  5,
  11,
  4,
  12,
  3,
  13,
  2,
  14,
  1,
  15
]);
var code_tree = new Tree();
var lengths = new Uint8Array(288 + 32);
function tinf_build_bits_base(bits2, base, delta, first) {
  var i, sum2;
  for (i = 0; i < delta; ++i) bits2[i] = 0;
  for (i = 0; i < 30 - delta; ++i) bits2[i + delta] = i / delta | 0;
  for (sum2 = first, i = 0; i < 30; ++i) {
    base[i] = sum2;
    sum2 += 1 << bits2[i];
  }
}
function tinf_build_fixed_trees(lt, dt) {
  var i;
  for (i = 0; i < 7; ++i) lt.table[i] = 0;
  lt.table[7] = 24;
  lt.table[8] = 152;
  lt.table[9] = 112;
  for (i = 0; i < 24; ++i) lt.trans[i] = 256 + i;
  for (i = 0; i < 144; ++i) lt.trans[24 + i] = i;
  for (i = 0; i < 8; ++i) lt.trans[24 + 144 + i] = 280 + i;
  for (i = 0; i < 112; ++i) lt.trans[24 + 144 + 8 + i] = 144 + i;
  for (i = 0; i < 5; ++i) dt.table[i] = 0;
  dt.table[5] = 32;
  for (i = 0; i < 32; ++i) dt.trans[i] = i;
}
var offs = new Uint16Array(16);
function tinf_build_tree(t, lengths2, off, num) {
  var i, sum2;
  for (i = 0; i < 16; ++i) t.table[i] = 0;
  for (i = 0; i < num; ++i) t.table[lengths2[off + i]]++;
  t.table[0] = 0;
  for (sum2 = 0, i = 0; i < 16; ++i) {
    offs[i] = sum2;
    sum2 += t.table[i];
  }
  for (i = 0; i < num; ++i) {
    if (lengths2[off + i]) t.trans[offs[lengths2[off + i]]++] = i;
  }
}
function tinf_getbit(d) {
  if (!d.bitcount--) {
    d.tag = d.source[d.sourceIndex++];
    d.bitcount = 7;
  }
  var bit = d.tag & 1;
  d.tag >>>= 1;
  return bit;
}
function tinf_read_bits(d, num, base) {
  if (!num)
    return base;
  while (d.bitcount < 24) {
    d.tag |= d.source[d.sourceIndex++] << d.bitcount;
    d.bitcount += 8;
  }
  var val = d.tag & 65535 >>> 16 - num;
  d.tag >>>= num;
  d.bitcount -= num;
  return val + base;
}
function tinf_decode_symbol(d, t) {
  while (d.bitcount < 24) {
    d.tag |= d.source[d.sourceIndex++] << d.bitcount;
    d.bitcount += 8;
  }
  var sum2 = 0, cur = 0, len = 0;
  var tag2 = d.tag;
  do {
    cur = 2 * cur + (tag2 & 1);
    tag2 >>>= 1;
    ++len;
    sum2 += t.table[len];
    cur -= t.table[len];
  } while (cur >= 0);
  d.tag = tag2;
  d.bitcount -= len;
  return t.trans[sum2 + cur];
}
function tinf_decode_trees(d, lt, dt) {
  var hlit, hdist, hclen;
  var i, num, length;
  hlit = tinf_read_bits(d, 5, 257);
  hdist = tinf_read_bits(d, 5, 1);
  hclen = tinf_read_bits(d, 4, 4);
  for (i = 0; i < 19; ++i) lengths[i] = 0;
  for (i = 0; i < hclen; ++i) {
    var clen = tinf_read_bits(d, 3, 0);
    lengths[clcidx[i]] = clen;
  }
  tinf_build_tree(code_tree, lengths, 0, 19);
  for (num = 0; num < hlit + hdist; ) {
    var sym = tinf_decode_symbol(d, code_tree);
    switch (sym) {
      case 16:
        var prev = lengths[num - 1];
        for (length = tinf_read_bits(d, 2, 3); length; --length) {
          lengths[num++] = prev;
        }
        break;
      case 17:
        for (length = tinf_read_bits(d, 3, 3); length; --length) {
          lengths[num++] = 0;
        }
        break;
      case 18:
        for (length = tinf_read_bits(d, 7, 11); length; --length) {
          lengths[num++] = 0;
        }
        break;
      default:
        lengths[num++] = sym;
        break;
    }
  }
  tinf_build_tree(lt, lengths, 0, hlit);
  tinf_build_tree(dt, lengths, hlit, hdist);
}
function tinf_inflate_block_data(d, lt, dt) {
  while (1) {
    var sym = tinf_decode_symbol(d, lt);
    if (sym === 256) {
      return TINF_OK;
    }
    if (sym < 256) {
      d.dest[d.destLen++] = sym;
    } else {
      var length, dist, offs2;
      var i;
      sym -= 257;
      length = tinf_read_bits(d, length_bits[sym], length_base[sym]);
      dist = tinf_decode_symbol(d, dt);
      offs2 = d.destLen - tinf_read_bits(d, dist_bits[dist], dist_base[dist]);
      for (i = offs2; i < offs2 + length; ++i) {
        d.dest[d.destLen++] = d.dest[i];
      }
    }
  }
}
function tinf_inflate_uncompressed_block(d) {
  var length, invlength;
  var i;
  while (d.bitcount > 8) {
    d.sourceIndex--;
    d.bitcount -= 8;
  }
  length = d.source[d.sourceIndex + 1];
  length = 256 * length + d.source[d.sourceIndex];
  invlength = d.source[d.sourceIndex + 3];
  invlength = 256 * invlength + d.source[d.sourceIndex + 2];
  if (length !== (~invlength & 65535))
    return TINF_DATA_ERROR;
  d.sourceIndex += 4;
  for (i = length; i; --i)
    d.dest[d.destLen++] = d.source[d.sourceIndex++];
  d.bitcount = 0;
  return TINF_OK;
}
function tinf_uncompress(source, dest) {
  var d = new Data(source, dest);
  var bfinal, btype, res2;
  do {
    bfinal = tinf_getbit(d);
    btype = tinf_read_bits(d, 2, 0);
    switch (btype) {
      case 0:
        res2 = tinf_inflate_uncompressed_block(d);
        break;
      case 1:
        res2 = tinf_inflate_block_data(d, sltree, sdtree);
        break;
      case 2:
        tinf_decode_trees(d, d.ltree, d.dtree);
        res2 = tinf_inflate_block_data(d, d.ltree, d.dtree);
        break;
      default:
        res2 = TINF_DATA_ERROR;
    }
    if (res2 !== TINF_OK)
      throw new Error("Data error");
  } while (!bfinal);
  if (d.destLen < d.dest.length) {
    if (typeof d.dest.slice === "function")
      return d.dest.slice(0, d.destLen);
    else
      return d.dest.subarray(0, d.destLen);
  }
  return d.dest;
}
tinf_build_fixed_trees(sltree, sdtree);
tinf_build_bits_base(length_bits, length_base, 4, 3);
tinf_build_bits_base(dist_bits, dist_base, 2, 1);
length_bits[28] = 0;
length_base[28] = 258;
var tinyInflate = tinf_uncompress;
const isBigEndian = new Uint8Array(new Uint32Array([305419896]).buffer)[0] === 18;
const swap = (b, n, m) => {
  let i = b[n];
  b[n] = b[m];
  b[m] = i;
};
const swap32 = (array) => {
  const len = array.length;
  for (let i = 0; i < len; i += 4) {
    swap(array, i, i + 3);
    swap(array, i + 1, i + 2);
  }
};
const swap32LE$1 = (array) => {
  if (isBigEndian) {
    swap32(array);
  }
};
var swap_1 = {
  swap32LE: swap32LE$1
};
const inflate = tinyInflate;
const { swap32LE } = swap_1;
const SHIFT_1 = 6 + 5;
const SHIFT_2 = 5;
const SHIFT_1_2 = SHIFT_1 - SHIFT_2;
const OMITTED_BMP_INDEX_1_LENGTH = 65536 >> SHIFT_1;
const INDEX_2_BLOCK_LENGTH = 1 << SHIFT_1_2;
const INDEX_2_MASK = INDEX_2_BLOCK_LENGTH - 1;
const INDEX_SHIFT = 2;
const DATA_BLOCK_LENGTH = 1 << SHIFT_2;
const DATA_MASK = DATA_BLOCK_LENGTH - 1;
const LSCP_INDEX_2_OFFSET = 65536 >> SHIFT_2;
const LSCP_INDEX_2_LENGTH = 1024 >> SHIFT_2;
const INDEX_2_BMP_LENGTH = LSCP_INDEX_2_OFFSET + LSCP_INDEX_2_LENGTH;
const UTF8_2B_INDEX_2_OFFSET = INDEX_2_BMP_LENGTH;
const UTF8_2B_INDEX_2_LENGTH = 2048 >> 6;
const INDEX_1_OFFSET = UTF8_2B_INDEX_2_OFFSET + UTF8_2B_INDEX_2_LENGTH;
const DATA_GRANULARITY = 1 << INDEX_SHIFT;
class UnicodeTrie {
  constructor(data) {
    const isBuffer2 = typeof data.readUInt32BE === "function" && typeof data.slice === "function";
    if (isBuffer2 || data instanceof Uint8Array) {
      let uncompressedLength;
      if (isBuffer2) {
        this.highStart = data.readUInt32LE(0);
        this.errorValue = data.readUInt32LE(4);
        uncompressedLength = data.readUInt32LE(8);
        data = data.slice(12);
      } else {
        const view = new DataView(data.buffer);
        this.highStart = view.getUint32(0, true);
        this.errorValue = view.getUint32(4, true);
        uncompressedLength = view.getUint32(8, true);
        data = data.subarray(12);
      }
      data = inflate(data, new Uint8Array(uncompressedLength));
      data = inflate(data, new Uint8Array(uncompressedLength));
      swap32LE(data);
      this.data = new Uint32Array(data.buffer);
    } else {
      ({ data: this.data, highStart: this.highStart, errorValue: this.errorValue } = data);
    }
  }
  get(codePoint) {
    let index;
    if (codePoint < 0 || codePoint > 1114111) {
      return this.errorValue;
    }
    if (codePoint < 55296 || codePoint > 56319 && codePoint <= 65535) {
      index = (this.data[codePoint >> SHIFT_2] << INDEX_SHIFT) + (codePoint & DATA_MASK);
      return this.data[index];
    }
    if (codePoint <= 65535) {
      index = (this.data[LSCP_INDEX_2_OFFSET + (codePoint - 55296 >> SHIFT_2)] << INDEX_SHIFT) + (codePoint & DATA_MASK);
      return this.data[index];
    }
    if (codePoint < this.highStart) {
      index = this.data[INDEX_1_OFFSET - OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> SHIFT_1)];
      index = this.data[index + (codePoint >> SHIFT_2 & INDEX_2_MASK)];
      index = (index << INDEX_SHIFT) + (codePoint & DATA_MASK);
      return this.data[index];
    }
    return this.data[this.data.length - DATA_GRANULARITY];
  }
}
var unicodeTrie = UnicodeTrie;
const $hJqJp$unicodetrie = /* @__PURE__ */ getDefaultExportFromCjs(unicodeTrie);
var b64 = {};
(function(exports) {
  var lookup2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  (function(exports2) {
    var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
    var PLUS = "+".charCodeAt(0);
    var SLASH = "/".charCodeAt(0);
    var NUMBER = "0".charCodeAt(0);
    var LOWER = "a".charCodeAt(0);
    var UPPER = "A".charCodeAt(0);
    var PLUS_URL_SAFE = "-".charCodeAt(0);
    var SLASH_URL_SAFE = "_".charCodeAt(0);
    function decode(elt) {
      var code = elt.charCodeAt(0);
      if (code === PLUS || code === PLUS_URL_SAFE)
        return 62;
      if (code === SLASH || code === SLASH_URL_SAFE)
        return 63;
      if (code < NUMBER)
        return -1;
      if (code < NUMBER + 10)
        return code - NUMBER + 26 + 26;
      if (code < UPPER + 26)
        return code - UPPER;
      if (code < LOWER + 26)
        return code - LOWER + 26;
    }
    function b64ToByteArray(b642) {
      var i, j, l, tmp, placeHolders, arr;
      if (b642.length % 4 > 0) {
        throw new Error("Invalid string. Length must be a multiple of 4");
      }
      var len = b642.length;
      placeHolders = "=" === b642.charAt(len - 2) ? 2 : "=" === b642.charAt(len - 1) ? 1 : 0;
      arr = new Arr(b642.length * 3 / 4 - placeHolders);
      l = placeHolders > 0 ? b642.length - 4 : b642.length;
      var L = 0;
      function push(v) {
        arr[L++] = v;
      }
      for (i = 0, j = 0; i < l; i += 4, j += 3) {
        tmp = decode(b642.charAt(i)) << 18 | decode(b642.charAt(i + 1)) << 12 | decode(b642.charAt(i + 2)) << 6 | decode(b642.charAt(i + 3));
        push((tmp & 16711680) >> 16);
        push((tmp & 65280) >> 8);
        push(tmp & 255);
      }
      if (placeHolders === 2) {
        tmp = decode(b642.charAt(i)) << 2 | decode(b642.charAt(i + 1)) >> 4;
        push(tmp & 255);
      } else if (placeHolders === 1) {
        tmp = decode(b642.charAt(i)) << 10 | decode(b642.charAt(i + 1)) << 4 | decode(b642.charAt(i + 2)) >> 2;
        push(tmp >> 8 & 255);
        push(tmp & 255);
      }
      return arr;
    }
    function uint8ToBase64(uint8) {
      var i, extraBytes = uint8.length % 3, output = "", temp, length;
      function encode(num) {
        return lookup2.charAt(num);
      }
      function tripletToBase64(num) {
        return encode(num >> 18 & 63) + encode(num >> 12 & 63) + encode(num >> 6 & 63) + encode(num & 63);
      }
      for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
        temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
        output += tripletToBase64(temp);
      }
      switch (extraBytes) {
        case 1:
          temp = uint8[uint8.length - 1];
          output += encode(temp >> 2);
          output += encode(temp << 4 & 63);
          output += "==";
          break;
        case 2:
          temp = (uint8[uint8.length - 2] << 8) + uint8[uint8.length - 1];
          output += encode(temp >> 10);
          output += encode(temp >> 4 & 63);
          output += encode(temp << 2 & 63);
          output += "=";
          break;
      }
      return output;
    }
    exports2.toByteArray = b64ToByteArray;
    exports2.fromByteArray = uint8ToBase64;
  })(exports);
})(b64);
const $hJqJp$base64js = /* @__PURE__ */ getDefaultExportFromCjs(b64);
const $557adaaeb0c7885f$var$data = $hJqJp$base64js.toByteArray("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");
new $hJqJp$unicodetrie($557adaaeb0c7885f$var$data);
function adjustWebglFilterBackend() {
  fabric.fabric.WebglFilterBackend.prototype.createWebGLCanvas = function(width, height) {
    const canvas = fabric.fabric.util.createCanvasElement();
    canvas.width = width;
    canvas.height = height;
    const glOptions = {
      alpha: true,
      premultipliedAlpha: true,
      depth: false,
      stencil: false,
      antialias: false
    };
    let gl = canvas.getContext("webgl", glOptions);
    if (!gl) {
      gl = canvas.getContext("experimental-webgl", glOptions);
    }
    if (!gl) {
      return;
    }
    gl.clearColor(0, 0, 0, 0);
    this.canvas = canvas;
    this.gl = gl;
  };
}
const transitions = [{ "name": "angular", "paramsTypes": { "startingAngle": "float" }, "defaultParams": { "startingAngle": 90 }, "glsl": "// Author: Fernando Kuteken\r\n// License: MIT\r\n\r\n#define PI 3.141592653589\r\n\r\nuniform float startingAngle; // = 90;\r\n\r\nvec4 transition (vec2 uv) {\r\n  \r\n  float offset = startingAngle * PI / 180.0;\r\n  float angle = atan(uv.y - 0.5, uv.x - 0.5) + offset;\r\n  float normalizedAngle = (angle + PI) / (2.0 * PI);\r\n  \r\n  normalizedAngle = normalizedAngle - floor(normalizedAngle);\r\n\r\n  return mix(\r\n    getFromColor(uv),\r\n    getToColor(uv),\r\n    step(normalizedAngle, progress)\r\n    );\r\n}\r\n", "author": "Fernando Kuteken", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "BookFlip", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author: hong\r\n// License: MIT\r\n\r\nvec2 skewRight(vec2 p) {\r\n  float skewX = (p.x - progress)/(0.5 - progress) * 0.5;\r\n  float skewY =  (p.y - 0.5)/(0.5 + progress * (p.x - 0.5) / 0.5)* 0.5  + 0.5;\r\n  return vec2(skewX, skewY);\r\n}\r\n\r\nvec2 skewLeft(vec2 p) {\r\n  float skewX = (p.x - 0.5)/(progress - 0.5) * 0.5 + 0.5;\r\n  float skewY = (p.y - 0.5) / (0.5 + (1.0 - progress ) * (0.5 - p.x) / 0.5) * 0.5  + 0.5;\r\n  return vec2(skewX, skewY);\r\n}\r\n\r\nvec4 addShade() {\r\n  float shadeVal  =  max(0.7, abs(progress - 0.5) * 2.0);\r\n  return vec4(vec3(shadeVal ), 1.0);\r\n}\r\n\r\nvec4 transition (vec2 p) {\r\n  float pr = step(1.0 - progress, p.x);\r\n\r\n  if (p.x < 0.5) {\r\n    return mix(getFromColor(p), getToColor(skewLeft(p)) * addShade(), pr);\r\n  } else {\r\n    return mix(getFromColor(skewRight(p)) * addShade(), getToColor(p),   pr);\r\n  }\r\n}\r\n", "author": "hong", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "Bounce", "paramsTypes": { "shadow_colour": "vec4", "shadow_height": "float", "bounces": "float" }, "defaultParams": { "shadow_colour": [0, 0, 0, 0.6], "shadow_height": 0.075, "bounces": 3 }, "glsl": "// Author: Adrian Purser\r\n// License: MIT\r\n\r\nuniform vec4 shadow_colour; // = vec4(0.,0.,0.,.6)\r\nuniform float shadow_height; // = 0.075\r\nuniform float bounces; // = 3.0\r\n\r\nconst float PI = 3.14159265358;\r\n\r\nvec4 transition (vec2 uv) {\r\n  float time = progress;\r\n  float stime = sin(time * PI / 2.);\r\n  float phase = time * PI * bounces;\r\n  float y = (abs(cos(phase))) * (1.0 - stime);\r\n  float d = uv.y - y;\r\n  return mix(\r\n    mix(\r\n      getToColor(uv),\r\n      shadow_colour,\r\n      step(d, shadow_height) * (1. - mix(\r\n        ((d / shadow_height) * shadow_colour.a) + (1.0 - shadow_colour.a),\r\n        1.0,\r\n        smoothstep(0.95, 1., progress) // fade-out the shadow at the end\r\n      ))\r\n    ),\r\n    getFromColor(vec2(uv.x, uv.y + (1.0 - y))),\r\n    step(d, 0.0)\r\n  );\r\n}\r\n", "author": "Adrian Purser", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "BowTieHorizontal", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author: huynx\r\n// License: MIT\r\n\r\nvec2 bottom_left = vec2(0.0, 1.0);\r\nvec2 bottom_right = vec2(1.0, 1.0);\r\nvec2 top_left = vec2(0.0, 0.0);\r\nvec2 top_right = vec2(1.0, 0.0);\r\nvec2 center = vec2(0.5, 0.5);\r\n\r\nfloat check(vec2 p1, vec2 p2, vec2 p3)\r\n{\r\n  return (p1.x - p3.x) * (p2.y - p3.y) - (p2.x - p3.x) * (p1.y - p3.y);\r\n}\r\n\r\nbool PointInTriangle (vec2 pt, vec2 p1, vec2 p2, vec2 p3)\r\n{\r\n    bool b1, b2, b3;\r\n    b1 = check(pt, p1, p2) < 0.0;\r\n    b2 = check(pt, p2, p3) < 0.0;\r\n    b3 = check(pt, p3, p1) < 0.0;\r\n    return ((b1 == b2) && (b2 == b3));\r\n}\r\n\r\nbool in_left_triangle(vec2 p){\r\n  vec2 vertex1, vertex2, vertex3;\r\n  vertex1 = vec2(progress, 0.5);\r\n  vertex2 = vec2(0.0, 0.5-progress);\r\n  vertex3 = vec2(0.0, 0.5+progress);\r\n  if (PointInTriangle(p, vertex1, vertex2, vertex3))\r\n  {\r\n    return true;\r\n  }\r\n  return false;\r\n}\r\n\r\nbool in_right_triangle(vec2 p){\r\n  vec2 vertex1, vertex2, vertex3;\r\n  vertex1 = vec2(1.0-progress, 0.5);\r\n  vertex2 = vec2(1.0, 0.5-progress);\r\n  vertex3 = vec2(1.0, 0.5+progress);\r\n  if (PointInTriangle(p, vertex1, vertex2, vertex3))\r\n  {\r\n    return true;\r\n  }\r\n  return false;\r\n}\r\n\r\nfloat blur_edge(vec2 bot1, vec2 bot2, vec2 top, vec2 testPt)\r\n{\r\n  vec2 lineDir = bot1 - top;\r\n  vec2 perpDir = vec2(lineDir.y, -lineDir.x);\r\n  vec2 dirToPt1 = bot1 - testPt;\r\n  float dist1 = abs(dot(normalize(perpDir), dirToPt1));\r\n  \r\n  lineDir = bot2 - top;\r\n  perpDir = vec2(lineDir.y, -lineDir.x);\r\n  dirToPt1 = bot2 - testPt;\r\n  float min_dist = min(abs(dot(normalize(perpDir), dirToPt1)), dist1);\r\n  \r\n  if (min_dist < 0.005) {\r\n    return min_dist / 0.005;\r\n  }\r\n  else  {\r\n    return 1.0;\r\n  };\r\n}\r\n\r\n\r\nvec4 transition (vec2 uv) {\r\n  if (in_left_triangle(uv))\r\n  {\r\n    if (progress < 0.1)\r\n    {\r\n      return getFromColor(uv);\r\n    }\r\n    if (uv.x < 0.5)\r\n    {\r\n      vec2 vertex1 = vec2(progress, 0.5);\r\n      vec2 vertex2 = vec2(0.0, 0.5-progress);\r\n      vec2 vertex3 = vec2(0.0, 0.5+progress);\r\n      return mix(\r\n        getFromColor(uv),\r\n        getToColor(uv),\r\n        blur_edge(vertex2, vertex3, vertex1, uv)\r\n      );\r\n    }\r\n    else\r\n    {\r\n      if (progress > 0.0)\r\n      {\r\n        return getToColor(uv);\r\n      }\r\n      else\r\n      {\r\n        return getFromColor(uv);\r\n      }\r\n    }    \r\n  }\r\n  else if (in_right_triangle(uv))\r\n  {\r\n    if (uv.x >= 0.5)\r\n    {\r\n      vec2 vertex1 = vec2(1.0-progress, 0.5);\r\n      vec2 vertex2 = vec2(1.0, 0.5-progress);\r\n      vec2 vertex3 = vec2(1.0, 0.5+progress);\r\n      return mix(\r\n        getFromColor(uv),\r\n        getToColor(uv),\r\n        blur_edge(vertex2, vertex3, vertex1, uv)\r\n      );  \r\n    }\r\n    else\r\n    {\r\n      return getFromColor(uv);\r\n    }\r\n  }\r\n  else {\r\n    return getFromColor(uv);\r\n  }\r\n}", "author": "huynx", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "BowTieVertical", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author: huynx\r\n// License: MIT\r\n\r\nfloat check(vec2 p1, vec2 p2, vec2 p3)\r\n{\r\n  return (p1.x - p3.x) * (p2.y - p3.y) - (p2.x - p3.x) * (p1.y - p3.y);\r\n}\r\n\r\nbool PointInTriangle (vec2 pt, vec2 p1, vec2 p2, vec2 p3)\r\n{\r\n    bool b1, b2, b3;\r\n    b1 = check(pt, p1, p2) < 0.0;\r\n    b2 = check(pt, p2, p3) < 0.0;\r\n    b3 = check(pt, p3, p1) < 0.0;\r\n    return ((b1 == b2) && (b2 == b3));\r\n}\r\n\r\nbool in_top_triangle(vec2 p){\r\n  vec2 vertex1, vertex2, vertex3;\r\n  vertex1 = vec2(0.5, progress);\r\n  vertex2 = vec2(0.5-progress, 0.0);\r\n  vertex3 = vec2(0.5+progress, 0.0);\r\n  if (PointInTriangle(p, vertex1, vertex2, vertex3))\r\n  {\r\n    return true;\r\n  }\r\n  return false;\r\n}\r\n\r\nbool in_bottom_triangle(vec2 p){\r\n  vec2 vertex1, vertex2, vertex3;\r\n  vertex1 = vec2(0.5, 1.0 - progress);\r\n  vertex2 = vec2(0.5-progress, 1.0);\r\n  vertex3 = vec2(0.5+progress, 1.0);\r\n  if (PointInTriangle(p, vertex1, vertex2, vertex3))\r\n  {\r\n    return true;\r\n  }\r\n  return false;\r\n}\r\n\r\nfloat blur_edge(vec2 bot1, vec2 bot2, vec2 top, vec2 testPt)\r\n{\r\n  vec2 lineDir = bot1 - top;\r\n  vec2 perpDir = vec2(lineDir.y, -lineDir.x);\r\n  vec2 dirToPt1 = bot1 - testPt;\r\n  float dist1 = abs(dot(normalize(perpDir), dirToPt1));\r\n  \r\n  lineDir = bot2 - top;\r\n  perpDir = vec2(lineDir.y, -lineDir.x);\r\n  dirToPt1 = bot2 - testPt;\r\n  float min_dist = min(abs(dot(normalize(perpDir), dirToPt1)), dist1);\r\n  \r\n  if (min_dist < 0.005) {\r\n    return min_dist / 0.005;\r\n  }\r\n  else  {\r\n    return 1.0;\r\n  };\r\n}\r\n\r\n\r\nvec4 transition (vec2 uv) {\r\n  if (in_top_triangle(uv))\r\n  {\r\n    if (progress < 0.1)\r\n    {\r\n      return getFromColor(uv);\r\n    }\r\n    if (uv.y < 0.5)\r\n    {\r\n      vec2 vertex1 = vec2(0.5, progress);\r\n      vec2 vertex2 = vec2(0.5-progress, 0.0);\r\n      vec2 vertex3 = vec2(0.5+progress, 0.0);\r\n      return mix(\r\n        getFromColor(uv),\r\n        getToColor(uv),\r\n        blur_edge(vertex2, vertex3, vertex1, uv)\r\n      );\r\n    }\r\n    else\r\n    {\r\n      if (progress > 0.0)\r\n      {\r\n        return getToColor(uv);\r\n      }\r\n      else\r\n      {\r\n        return getFromColor(uv);\r\n      }\r\n    }    \r\n  }\r\n  else if (in_bottom_triangle(uv))\r\n  {\r\n    if (uv.y >= 0.5)\r\n    {\r\n      vec2 vertex1 = vec2(0.5, 1.0-progress);\r\n      vec2 vertex2 = vec2(0.5-progress, 1.0);\r\n      vec2 vertex3 = vec2(0.5+progress, 1.0);\r\n      return mix(\r\n        getFromColor(uv),\r\n        getToColor(uv),\r\n        blur_edge(vertex2, vertex3, vertex1, uv)\r\n      );  \r\n    }\r\n    else\r\n    {\r\n      return getFromColor(uv);\r\n    }\r\n  }\r\n  else {\r\n    return getFromColor(uv);\r\n  }\r\n}", "author": "huynx", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "BowTieWithParameter", "paramsTypes": { "adjust": "float", "reverse": "bool" }, "defaultParams": { "adjust": 0.5, "reverse": false }, "glsl": "// Author:KMojek\r\n// License: MIT\r\n\r\nuniform float adjust; // = 0.5;\r\nuniform bool reverse; // = false;\r\n\r\nfloat check(vec2 p1, vec2 p2, vec2 p3)\r\n{\r\n  return (p1.x - p3.x) * (p2.y - p3.y) - (p2.x - p3.x) * (p1.y - p3.y);\r\n}\r\n\r\nbool pointInTriangle(vec2 pt, vec2 p1, vec2 p2, vec2 p3)\r\n{\r\n\r\n    bool b1 = check(pt, p1, p2) < 0.0;\r\n    bool b2 = check(pt, p2, p3) < 0.0;\r\n    bool b3 = check(pt, p3, p1) < 0.0;\r\n    return b1 == b2 && b2 == b3;\r\n}\r\n\r\nconst float height = 0.5;\r\n\r\nvec4 transition_firstHalf( vec2 uv, float prog )\r\n{\r\n  if ( uv.y < 0.5 )\r\n  {\r\n    vec2 botLeft = vec2( -0., prog-height );\r\n    vec2 botRight = vec2( 1., prog-height );\r\n    vec2 tip = vec2( adjust, prog );\r\n    if ( pointInTriangle( uv, botLeft, botRight, tip ) )\r\n        return getToColor(uv);\r\n    }\r\n  else\r\n  {\r\n    vec2 topLeft = vec2( -0., 1.-prog+height );\r\n    vec2 topRight = vec2( 1., 1.-prog+height );\r\n    vec2 tip = vec2( adjust, 1.-prog );\r\n    if ( pointInTriangle( uv, topLeft, topRight, tip ) )\r\n      return getToColor( uv );\r\n  }\r\n  return getFromColor( uv );\r\n}\r\n\r\nvec4 transition_secondHalf( vec2 uv, float prog )\r\n{\r\n  if ( uv.x > adjust )\r\n  {\r\n    vec2 top = vec2( prog + height,  1. );\r\n    vec2 bot = vec2( prog + height, -0. );\r\n    vec2 tip = vec2( mix( adjust, 1.0, 2.0 * (prog - 0.5) ), 0.5 );\r\n    if ( pointInTriangle( uv, top, bot, tip) )\r\n      return getFromColor( uv );\r\n  }\r\n  else\r\n  {\r\n    vec2 top = vec2( 1.0-prog - height,  1. );\r\n    vec2 bot = vec2( 1.0-prog - height, -0. );\r\n    vec2 tip = vec2( mix( adjust, 0.0, 2.0 * (prog - 0.5)  ), 0.5 );\r\n    if ( pointInTriangle( uv, top, bot, tip) )\r\n      return getFromColor( uv );\r\n  }\r\n  return getToColor( uv );\r\n}\r\n\r\nvec4 transition (vec2 uv) {\r\n  if ( reverse )\r\n    return ( progress < 0.5 ) ? transition_secondHalf( uv, 1.-progress ) : transition_firstHalf( uv, 1.-progress );\r\n  else\r\n    return ( progress < 0.5 ) ? transition_firstHalf( uv, progress ) : transition_secondHalf( uv, progress );\r\n}", "author": "KMojek", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "burn", "paramsTypes": { "color": "vec3" }, "defaultParams": { "color": [0.9, 0.4, 0.2] }, "glsl": "// author: gre\r\n// License: MIT\r\nuniform vec3 color /* = vec3(0.9, 0.4, 0.2) */;\r\nvec4 transition (vec2 uv) {\r\n  return mix(\r\n    getFromColor(uv) + vec4(progress*color, 1.0),\r\n    getToColor(uv) + vec4((1.0-progress)*color, 1.0),\r\n    progress\r\n  );\r\n}\r\n", "author": "gre", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "ButterflyWaveScrawler", "paramsTypes": { "amplitude": "float", "waves": "float", "colorSeparation": "float" }, "defaultParams": { "amplitude": 1, "waves": 30, "colorSeparation": 0.3 }, "glsl": "// Author: mandubian\r\n// License: MIT\r\nuniform float amplitude; // = 1.0\r\nuniform float waves; // = 30.0\r\nuniform float colorSeparation; // = 0.3\r\nfloat PI = 3.14159265358979323846264;\r\nfloat compute(vec2 p, float progress, vec2 center) {\r\nvec2 o = p*sin(progress * amplitude)-center;\r\n// horizontal vector\r\nvec2 h = vec2(1., 0.);\r\n// butterfly polar function (don't ask me why this one :))\r\nfloat theta = acos(dot(o, h)) * waves;\r\nreturn (exp(cos(theta)) - 2.*cos(4.*theta) + pow(sin((2.*theta - PI) / 24.), 5.)) / 10.;\r\n}\r\nvec4 transition(vec2 uv) {\r\n  vec2 p = uv.xy / vec2(1.0).xy;\r\n  float inv = 1. - progress;\r\n  vec2 dir = p - vec2(.5);\r\n  float dist = length(dir);\r\n  float disp = compute(p, progress, vec2(0.5, 0.5)) ;\r\n  vec4 texTo = getToColor(p + inv*disp);\r\n  vec4 texFrom = vec4(\r\n  getFromColor(p + progress*disp*(1.0 - colorSeparation)).r,\r\n  getFromColor(p + progress*disp).g,\r\n  getFromColor(p + progress*disp*(1.0 + colorSeparation)).b,\r\n  1.0);\r\n  return texTo*progress + texFrom*inv;\r\n}\r\n", "author": "mandubian", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "cannabisleaf", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author: @Flexi23\r\n// License: MIT\r\n\r\n// inspired by http://www.wolframalpha.com/input/?i=cannabis+curve\r\n\r\nvec4 transition (vec2 uv) {\r\n  if(progress == 0.0){\r\n    return getFromColor(uv);\r\n  }\r\n  vec2 leaf_uv = (uv - vec2(0.5))/10./pow(progress,3.5);\r\n	leaf_uv.y += 0.35;\r\n	float r = 0.18;\r\n	float o = atan(leaf_uv.y, leaf_uv.x);\r\n  return mix(getFromColor(uv), getToColor(uv), 1.-step(1. - length(leaf_uv)+r*(1.+sin(o))*(1.+0.9 * cos(8.*o))*(1.+0.1*cos(24.*o))*(0.9+0.05*cos(200.*o)), 1.));\r\n}\r\n", "author": "@Flexi23", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "circle", "paramsTypes": { "center": "vec2", "backColor": "vec3" }, "defaultParams": { "center": [0.5, 0.5], "backColor": [0.1, 0.1, 0.1] }, "glsl": "// Author: Fernando Kuteken\r\n// License: MIT\r\n\r\nuniform vec2 center; // = vec2(0.5, 0.5);\r\nuniform vec3 backColor; // = vec3(0.1, 0.1, 0.1);\r\n\r\nvec4 transition (vec2 uv) {\r\n  \r\n  float distance = length(uv - center);\r\n  float radius = sqrt(8.0) * abs(progress - 0.5);\r\n  \r\n  if (distance > radius) {\r\n    return vec4(backColor, 1.0);\r\n  }\r\n  else {\r\n    if (progress < 0.5) return getFromColor(uv);\r\n    else return getToColor(uv);\r\n  }\r\n}\r\n", "author": "Fernando Kuteken", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "CircleCrop", "paramsTypes": { "bgcolor": "vec4" }, "defaultParams": { "bgcolor": [0, 0, 0, 1] }, "glsl": "// License: MIT\r\n// Author: fkuteken\r\n// ported by gre from https://gist.github.com/fkuteken/f63e3009c1143950dee9063c3b83fb88\r\n\r\nuniform vec4 bgcolor; // = vec4(0.0, 0.0, 0.0, 1.0)\r\n\r\nvec2 ratio2 = vec2(1.0, 1.0 / ratio);\r\nfloat s = pow(2.0 * abs(progress - 0.5), 3.0);\r\n\r\nvec4 transition(vec2 p) {\r\n  float dist = length((vec2(p) - 0.5) * ratio2);\r\n  return mix(\r\n    progress < 0.5 ? getFromColor(p) : getToColor(p), // branching is ok here as we statically depend on progress uniform (branching won't change over pixels)\r\n    bgcolor,\r\n    step(s, dist)\r\n  );\r\n}\r\n", "license": "MIT", "author": "fkuteken", "createdAt": "", "updatedAt": "" }, { "name": "circleopen", "paramsTypes": { "smoothness": "float", "opening": "bool" }, "defaultParams": { "smoothness": 0.3, "opening": true }, "glsl": "// author: gre\r\n// License: MIT\r\nuniform float smoothness; // = 0.3\r\nuniform bool opening; // = true\r\n\r\nconst vec2 center = vec2(0.5, 0.5);\r\nconst float SQRT_2 = 1.414213562373;\r\n\r\nvec4 transition (vec2 uv) {\r\n  float x = opening ? progress : 1.-progress;\r\n  float m = smoothstep(-smoothness, 0.0, SQRT_2*distance(center, uv) - x*(1.+smoothness));\r\n  return mix(getFromColor(uv), getToColor(uv), opening ? 1.-m : m);\r\n}\r\n", "author": "gre", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "colorphase", "paramsTypes": { "fromStep": "vec4", "toStep": "vec4" }, "defaultParams": { "fromStep": [0, 0.2, 0.4, 0], "toStep": [0.6, 0.8, 1, 1] }, "glsl": "// Author: gre\r\n// License: MIT\r\n\r\n// Usage: fromStep and toStep must be in [0.0, 1.0] range \r\n// and all(fromStep) must be < all(toStep)\r\n\r\nuniform vec4 fromStep; // = vec4(0.0, 0.2, 0.4, 0.0)\r\nuniform vec4 toStep; // = vec4(0.6, 0.8, 1.0, 1.0)\r\n\r\nvec4 transition (vec2 uv) {\r\n  vec4 a = getFromColor(uv);\r\n  vec4 b = getToColor(uv);\r\n  return mix(a, b, smoothstep(fromStep, toStep, vec4(progress)));\r\n}\r\n", "author": "gre", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "ColourDistance", "paramsTypes": { "power": "float" }, "defaultParams": { "power": 5 }, "glsl": "// License: MIT\r\n// Author: P-Seebauer\r\n// ported by gre from https://gist.github.com/P-Seebauer/2a5fa2f77c883dd661f9\r\n\r\nuniform float power; // = 5.0\r\n\r\nvec4 transition(vec2 p) {\r\n  vec4 fTex = getFromColor(p);\r\n  vec4 tTex = getToColor(p);\r\n  float m = step(distance(fTex, tTex), progress);\r\n  return mix(\r\n    mix(fTex, tTex, m),\r\n    tTex,\r\n    pow(progress, power)\r\n  );\r\n}\r\n", "license": "MIT", "author": "P-Seebauer", "createdAt": "", "updatedAt": "" }, { "name": "coord-from-in", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author: haiyoucuv\r\n// License: MIT\r\n\r\nvec4 transition (vec2 uv) {\r\n  \r\n  vec4 coordTo = getToColor(uv);\r\n  vec4 coordFrom = getFromColor(uv);\r\n  \r\n  return mix(\r\n    getFromColor(coordTo.rg),\r\n    getToColor(uv),\r\n    progress\r\n  );\r\n\r\n}\r\n", "author": "haiyoucuv", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "CrazyParametricFun", "paramsTypes": { "a": "float", "b": "float", "amplitude": "float", "smoothness": "float" }, "defaultParams": { "a": 4, "b": 1, "amplitude": 120, "smoothness": 0.1 }, "glsl": "// Author: mandubian\r\n// License: MIT\r\n\r\nuniform float a; // = 4\r\nuniform float b; // = 1\r\nuniform float amplitude; // = 120\r\nuniform float smoothness; // = 0.1\r\n\r\nvec4 transition(vec2 uv) {\r\n  vec2 p = uv.xy / vec2(1.0).xy;\r\n  vec2 dir = p - vec2(.5);\r\n  float dist = length(dir);\r\n  float x = (a - b) * cos(progress) + b * cos(progress * ((a / b) - 1.) );\r\n  float y = (a - b) * sin(progress) - b * sin(progress * ((a / b) - 1.));\r\n  vec2 offset = dir * vec2(sin(progress  * dist * amplitude * x), sin(progress * dist * amplitude * y)) / smoothness;\r\n  return mix(getFromColor(p + offset), getToColor(p), smoothstep(0.2, 1.0, progress));\r\n}\r\n", "author": "mandubian", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "crosshatch", "paramsTypes": { "center": "vec2", "threshold": "float", "fadeEdge": "float" }, "defaultParams": { "center": [0.5, 0.5], "threshold": 3, "fadeEdge": 0.1 }, "glsl": "// License: MIT\r\n// Author: pthrasher\r\n// adapted by gre from https://gist.github.com/pthrasher/04fd9a7de4012cbb03f6\r\n\r\nuniform vec2 center; // = vec2(0.5)\r\nuniform float threshold; // = 3.0\r\nuniform float fadeEdge; // = 0.1\r\n\r\nfloat rand(vec2 co) {\r\n  return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453);\r\n}\r\nvec4 transition(vec2 p) {\r\n  float dist = distance(center, p) / threshold;\r\n  float r = progress - min(rand(vec2(p.y, 0.0)), rand(vec2(0.0, p.x)));\r\n  return mix(getFromColor(p), getToColor(p), mix(0.0, mix(step(dist, r), 1.0, smoothstep(1.0-fadeEdge, 1.0, progress)), smoothstep(0.0, fadeEdge, progress)));    \r\n}\r\n", "license": "MIT", "author": "pthrasher", "createdAt": "", "updatedAt": "" }, { "name": "crosswarp", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author: Eke Péter <peterekepeter@gmail.com>\r\n// License: MIT\r\nvec4 transition(vec2 p) {\r\n  float x = progress;\r\n  x=smoothstep(.0,1.0,(x*2.0+p.x-1.0));\r\n  return mix(getFromColor((p-.5)*(1.-x)+.5), getToColor((p-.5)*x+.5), x);\r\n}\r\n", "author": "Eke Péter <peterekepeter@gmail.com>", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "CrossZoom", "paramsTypes": { "strength": "float" }, "defaultParams": { "strength": 0.4 }, "glsl": "// License: MIT\r\n// Author: rectalogic\r\n// ported by gre from https://gist.github.com/rectalogic/b86b90161503a0023231\r\n\r\n// Converted from https://github.com/rectalogic/rendermix-basic-effects/blob/master/assets/com/rendermix/CrossZoom/CrossZoom.frag\r\n// Which is based on https://github.com/evanw/glfx.js/blob/master/src/filters/blur/zoomblur.js\r\n// With additional easing functions from https://github.com/rectalogic/rendermix-basic-effects/blob/master/assets/com/rendermix/Easing/Easing.glsllib\r\n\r\nuniform float strength; // = 0.4\r\n\r\nconst float PI = 3.141592653589793;\r\n\r\nfloat Linear_ease(in float begin, in float change, in float duration, in float time) {\r\n    return change * time / duration + begin;\r\n}\r\n\r\nfloat Exponential_easeInOut(in float begin, in float change, in float duration, in float time) {\r\n    if (time == 0.0)\r\n        return begin;\r\n    else if (time == duration)\r\n        return begin + change;\r\n    time = time / (duration / 2.0);\r\n    if (time < 1.0)\r\n        return change / 2.0 * pow(2.0, 10.0 * (time - 1.0)) + begin;\r\n    return change / 2.0 * (-pow(2.0, -10.0 * (time - 1.0)) + 2.0) + begin;\r\n}\r\n\r\nfloat Sinusoidal_easeInOut(in float begin, in float change, in float duration, in float time) {\r\n    return -change / 2.0 * (cos(PI * time / duration) - 1.0) + begin;\r\n}\r\n\r\nfloat rand (vec2 co) {\r\n  return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453);\r\n}\r\n\r\nvec3 crossFade(in vec2 uv, in float dissolve) {\r\n    return mix(getFromColor(uv).rgb, getToColor(uv).rgb, dissolve);\r\n}\r\n\r\nvec4 transition(vec2 uv) {\r\n    vec2 texCoord = uv.xy / vec2(1.0).xy;\r\n\r\n    // Linear interpolate center across center half of the image\r\n    vec2 center = vec2(Linear_ease(0.25, 0.5, 1.0, progress), 0.5);\r\n    float dissolve = Exponential_easeInOut(0.0, 1.0, 1.0, progress);\r\n\r\n    // Mirrored sinusoidal loop. 0->strength then strength->0\r\n    float strength = Sinusoidal_easeInOut(0.0, strength, 0.5, progress);\r\n\r\n    vec3 color = vec3(0.0);\r\n    float total = 0.0;\r\n    vec2 toCenter = center - texCoord;\r\n\r\n    /* randomize the lookup values to hide the fixed number of samples */\r\n    float offset = rand(uv);\r\n\r\n    for (float t = 0.0; t <= 40.0; t++) {\r\n        float percent = (t + offset) / 40.0;\r\n        float weight = 4.0 * (percent - percent * percent);\r\n        color += crossFade(texCoord + toCenter * percent * strength, dissolve) * weight;\r\n        total += weight;\r\n    }\r\n    return vec4(color / total, 1.0);\r\n}\r\n", "license": "MIT", "author": "rectalogic", "createdAt": "", "updatedAt": "" }, { "name": "cube", "paramsTypes": { "persp": "float", "unzoom": "float", "reflection": "float", "floating": "float" }, "defaultParams": { "persp": 0.7, "unzoom": 0.3, "reflection": 0.4, "floating": 3 }, "glsl": "// Author: gre\r\n// License: MIT\r\nuniform float persp; // = 0.7\r\nuniform float unzoom; // = 0.3\r\nuniform float reflection; // = 0.4\r\nuniform float floating; // = 3.0\r\n\r\nvec2 project (vec2 p) {\r\n  return p * vec2(1.0, -1.2) + vec2(0.0, -floating/100.);\r\n}\r\n\r\nbool inBounds (vec2 p) {\r\n  return all(lessThan(vec2(0.0), p)) && all(lessThan(p, vec2(1.0)));\r\n}\r\n\r\nvec4 bgColor (vec2 p, vec2 pfr, vec2 pto) {\r\n  vec4 c = vec4(0.0, 0.0, 0.0, 1.0);\r\n  pfr = project(pfr);\r\n  // FIXME avoid branching might help perf!\r\n  if (inBounds(pfr)) {\r\n    c += mix(vec4(0.0), getFromColor(pfr), reflection * mix(1.0, 0.0, pfr.y));\r\n  }\r\n  pto = project(pto);\r\n  if (inBounds(pto)) {\r\n    c += mix(vec4(0.0), getToColor(pto), reflection * mix(1.0, 0.0, pto.y));\r\n  }\r\n  return c;\r\n}\r\n\r\n// p : the position\r\n// persp : the perspective in [ 0, 1 ]\r\n// center : the xcenter in [0, 1] \\ 0.5 excluded\r\nvec2 xskew (vec2 p, float persp, float center) {\r\n  float x = mix(p.x, 1.0-p.x, center);\r\n  return (\r\n    (\r\n      vec2( x, (p.y - 0.5*(1.0-persp) * x) / (1.0+(persp-1.0)*x) )\r\n      - vec2(0.5-distance(center, 0.5), 0.0)\r\n    )\r\n    * vec2(0.5 / distance(center, 0.5) * (center<0.5 ? 1.0 : -1.0), 1.0)\r\n    + vec2(center<0.5 ? 0.0 : 1.0, 0.0)\r\n  );\r\n}\r\n\r\nvec4 transition(vec2 op) {\r\n  float uz = unzoom * 2.0*(0.5-distance(0.5, progress));\r\n  vec2 p = -uz*0.5+(1.0+uz) * op;\r\n  vec2 fromP = xskew(\r\n    (p - vec2(progress, 0.0)) / vec2(1.0-progress, 1.0),\r\n    1.0-mix(progress, 0.0, persp),\r\n    0.0\r\n  );\r\n  vec2 toP = xskew(\r\n    p / vec2(progress, 1.0),\r\n    mix(pow(progress, 2.0), 1.0, persp),\r\n    1.0\r\n  );\r\n  // FIXME avoid branching might help perf!\r\n  if (inBounds(fromP)) {\r\n    return getFromColor(fromP);\r\n  }\r\n  else if (inBounds(toP)) {\r\n    return getToColor(toP);\r\n  }\r\n  return bgColor(op, fromP, toP);\r\n}\r\n", "author": "gre", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "directional-easing", "paramsTypes": { "direction": "vec2" }, "defaultParams": { "direction": [0, 1] }, "glsl": "// Author: Max Plotnikov\r\n// License: MIT\r\n\r\nuniform vec2 direction; // = vec2(0.0, 1.0)\r\n\r\nvec4 transition (vec2 uv) {\r\n  float easing = sqrt((2.0 - progress) * progress);\r\n  vec2 p = uv + easing * sign(direction);\r\n  vec2 f = fract(p);\r\n  return mix(\r\n    getToColor(f),\r\n    getFromColor(f),\r\n    step(0.0, p.y) * step(p.y, 1.0) * step(0.0, p.x) * step(p.x, 1.0)\r\n  );\r\n}\r\n", "author": "Max Plotnikov", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "Directional", "paramsTypes": { "direction": "vec2" }, "defaultParams": { "direction": [0, 1] }, "glsl": "// Author: Gaëtan Renaudeau\r\n// License: MIT\r\n\r\nuniform vec2 direction; // = vec2(0.0, 1.0)\r\n\r\nvec4 transition (vec2 uv) {\r\n  vec2 p = uv + progress * sign(direction);\r\n  vec2 f = fract(p);\r\n  return mix(\r\n    getToColor(f),\r\n    getFromColor(f),\r\n    step(0.0, p.y) * step(p.y, 1.0) * step(0.0, p.x) * step(p.x, 1.0)\r\n  );\r\n}\r\n", "author": "Gaëtan Renaudeau", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "DirectionalScaled", "paramsTypes": { "direction": "vec2", "scale": "float" }, "defaultParams": { "direction": [0, 1], "scale": 0.7 }, "glsl": "// Author: Thibaut Foussard\r\n// based on Directional transition by Gaëtan Renaudeau\r\n// https://gl-transitions.com/editor/Directional\r\n// License: MIT\r\n\r\n#define PI acos(-1.0)\r\n\r\nuniform vec2 direction; // = vec2(0.0, 1.0)\r\nuniform float scale; // = .7\r\n\r\nfloat parabola(float x) {\r\n  float y = pow(sin(x * PI), 1.);\r\n  return y;\r\n}\r\n\r\nvec4 transition (vec2 uv) {\r\n  float easedProgress = pow(sin(progress  * PI / 2.), 3.);\r\n  vec2 p = uv + easedProgress * sign(direction);\r\n  vec2 f = fract(p);\r\n  \r\n  float s = 1. - (1. - (1. / scale)) * parabola(progress);\r\n  f = (f - 0.5) * s  + 0.5;\r\n  \r\n  float mixer = step(0.0, p.y) * step(p.y, 1.0) * step(0.0, p.x) * step(p.x, 1.0);\r\n  vec4 col = mix(getToColor(f), getFromColor(f), mixer);\r\n  \r\n  float border = step(0., f.x) * step(0., (1. - f.x)) * step(0., f.y) * step(0., 1. - f.y);\r\n  col *= border;\r\n  \r\n  return col;\r\n}\r\n", "author": "Thibaut Foussard", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "directionalwarp", "paramsTypes": { "smoothness": "float", "direction": "vec2" }, "defaultParams": { "smoothness": 0.1, "direction": [-1, 1] }, "glsl": "// Author: pschroen\r\n// License: MIT\r\n\r\nuniform float smoothness; // = 0.1\r\nuniform vec2 direction; // = vec2(-1.0, 1.0)\r\n\r\nconst vec2 center = vec2(0.5, 0.5);\r\n\r\nvec4 transition (vec2 uv) {\r\n  vec2 v = normalize(direction);\r\n  v /= abs(v.x) + abs(v.y);\r\n  float d = v.x * center.x + v.y * center.y;\r\n  float m = 1.0 - smoothstep(-smoothness, 0.0, v.x * uv.x + v.y * uv.y - (d - 0.5 + progress * (1.0 + smoothness)));\r\n  return mix(getFromColor((uv - 0.5) * (1.0 - m) + 0.5), getToColor((uv - 0.5) * m + 0.5), m);\r\n}\r\n", "author": "pschroen", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "directionalwipe", "paramsTypes": { "direction": "vec2", "smoothness": "float" }, "defaultParams": { "direction": [1, -1], "smoothness": 0.5 }, "glsl": "// Author: gre\r\n// License: MIT\r\n\r\nuniform vec2 direction; // = vec2(1.0, -1.0)\r\nuniform float smoothness; // = 0.5\r\n \r\nconst vec2 center = vec2(0.5, 0.5);\r\n \r\nvec4 transition (vec2 uv) {\r\n  vec2 v = normalize(direction);\r\n  v /= abs(v.x)+abs(v.y);\r\n  float d = v.x * center.x + v.y * center.y;\r\n  float m =\r\n    (1.0-step(progress, 0.0)) * // there is something wrong with our formula that makes m not equals 0.0 with progress is 0.0\r\n    (1.0 - smoothstep(-smoothness, 0.0, v.x * uv.x + v.y * uv.y - (d-0.5+progress*(1.+smoothness))));\r\n  return mix(getFromColor(uv), getToColor(uv), m);\r\n}\r\n", "author": "gre", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "displacement", "paramsTypes": { "displacementMap": "sampler2D", "strength": "float" }, "defaultParams": { "displacementMap": null, "strength": 0.5 }, "glsl": "// Author: Travis Fischer\r\n// License: MIT\r\n//\r\n// Adapted from a Codrops article by Robin Delaporte\r\n// https://tympanus.net/Development/DistortionHoverEffect\r\n\r\nuniform sampler2D displacementMap;\r\n\r\nuniform float strength; // = 0.5\r\n\r\nvec4 transition (vec2 uv) {\r\n  float displacement = texture2D(displacementMap, uv).r * strength;\r\n\r\n  vec2 uvFrom = vec2(uv.x + progress * displacement, uv.y);\r\n  vec2 uvTo = vec2(uv.x - (1.0 - progress) * displacement, uv.y);\r\n\r\n  return mix(\r\n    getFromColor(uvFrom),\r\n    getToColor(uvTo),\r\n    progress\r\n  );\r\n}\r\n", "author": "Travis Fischer", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "dissolve", "paramsTypes": { "uLineWidth": "float", "uSpreadClr": "vec3", "uHotClr": "vec3", "uPow": "float", "uIntensity": "float" }, "defaultParams": { "uLineWidth": 0.1, "uSpreadClr": [1, 0, 0], "uHotClr": [0.9, 0.9, 0.2], "uPow": 5, "uIntensity": 1 }, "glsl": "// Author: hjm1fb\r\n// License: MIT\r\n\r\n#ifdef GL_ES\r\nprecision mediump float;\r\n#endif\r\n\r\nuniform float uLineWidth;// = 0.1\r\nuniform vec3 uSpreadClr;// = vec3(1.0, 0.0, 0.0);\r\nuniform vec3 uHotClr;// = vec3(0.9, 0.9, 0.2);\r\nuniform float uPow;// = 5.0;\r\nuniform float uIntensity;// = 1.0;\r\n\r\nvec2 hash(vec2 p)  // replace this by something better\r\n{\r\n  p = vec2(dot(p, vec2(127.1, 311.7)), dot(p, vec2(269.5, 183.3)));\r\n  return -1.0 + 2.0 * fract(sin(p) * 43758.5453123);\r\n}\r\n\r\nfloat noise(in vec2 p) {\r\n  const float K1 = 0.366025404;  // (sqrt(3)-1)/2;\r\n  const float K2 = 0.211324865;  // (3-sqrt(3))/6;\r\n\r\n  vec2 i = floor(p + (p.x + p.y) * K1);\r\n  vec2 a = p - i + (i.x + i.y) * K2;\r\n  float m = step(a.y, a.x);\r\n  vec2 o = vec2(m, 1.0 - m);\r\n  vec2 b = a - o + K2;\r\n  vec2 c = a - 1.0 + 2.0 * K2;\r\n  vec3 h = max(0.5 - vec3(dot(a, a), dot(b, b), dot(c, c)), 0.0);\r\n  vec3 n = h * h * h * h * vec3(dot(a, hash(i + 0.0)), dot(b, hash(i + o)), dot(c, hash(i + 1.0)));\r\n  return dot(n, vec3(70.0));\r\n}\r\n\r\nvec4 transition(vec2 uv) {\r\n  vec4 from = getFromColor(uv);\r\n  vec4 to = getToColor(uv);\r\n  vec4 outColor;\r\n  float burn;\r\n  burn = 0.5 + 0.5 * (0.299 * from.r + 0.587 * from.g + 0.114 * from.b);\r\n\r\n  float show = burn - progress;\r\n  if (show < 0.001) {\r\n    outColor = to;\r\n  } else {\r\n    float factor = 1.0 - smoothstep(0.0, uLineWidth, show);\r\n    vec3 burnColor = mix(uSpreadClr, uHotClr, factor);\r\n    burnColor = pow(burnColor, vec3(uPow)) * uIntensity;\r\n    vec3 finalRGB = mix(from.rgb, burnColor, factor * step(0.0001, progress));\r\n    outColor = vec4(finalRGB * from.a, from.a);\r\n  }\r\n  return outColor;\r\n}\r\n", "author": "hjm1fb", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "DoomScreenTransition", "paramsTypes": { "bars": "int", "amplitude": "float", "noise": "float", "frequency": "float", "dripScale": "float" }, "defaultParams": { "bars": 30, "amplitude": 2, "noise": 0.1, "frequency": 0.5, "dripScale": 0.5 }, "glsl": '// Author: Zeh Fernando\r\n// License: MIT\r\n\r\n\r\n// Transition parameters --------\r\n\r\n// Number of total bars/columns\r\nuniform int bars; // = 30\r\n\r\n// Multiplier for speed ratio. 0 = no variation when going down, higher = some elements go much faster\r\nuniform float amplitude; // = 2\r\n\r\n// Further variations in speed. 0 = no noise, 1 = super noisy (ignore frequency)\r\nuniform float noise; // = 0.1\r\n\r\n// Speed variation horizontally. the bigger the value, the shorter the waves\r\nuniform float frequency; // = 0.5\r\n\r\n// How much the bars seem to "run" from the middle of the screen first (sticking to the sides). 0 = no drip, 1 = curved drip\r\nuniform float dripScale; // = 0.5\r\n\r\n\r\n// The code proper --------\r\n\r\nfloat rand(int num) {\r\n  return fract(mod(float(num) * 67123.313, 12.0) * sin(float(num) * 10.3) * cos(float(num)));\r\n}\r\n\r\nfloat wave(int num) {\r\n  float fn = float(num) * frequency * 0.1 * float(bars);\r\n  return cos(fn * 0.5) * cos(fn * 0.13) * sin((fn+10.0) * 0.3) / 2.0 + 0.5;\r\n}\r\n\r\nfloat drip(int num) {\r\n  return sin(float(num) / float(bars - 1) * 3.141592) * dripScale;\r\n}\r\n\r\nfloat pos(int num) {\r\n  return (noise == 0.0 ? wave(num) : mix(wave(num), rand(num), noise)) + (dripScale == 0.0 ? 0.0 : drip(num));\r\n}\r\n\r\nvec4 transition(vec2 uv) {\r\n  int bar = int(uv.x * (float(bars)));\r\n  float scale = 1.0 + pos(bar) * amplitude;\r\n  float phase = progress * scale;\r\n  float posY = uv.y / vec2(1.0).y;\r\n  vec2 p;\r\n  vec4 c;\r\n  if (phase + posY < 1.0) {\r\n    p = vec2(uv.x, uv.y + mix(0.0, vec2(1.0).y, phase)) / vec2(1.0).xy;\r\n    c = getFromColor(p);\r\n  } else {\r\n    p = uv.xy / vec2(1.0).xy;\r\n    c = getToColor(p);\r\n  }\r\n\r\n  // Finally, apply the color\r\n  return c;\r\n}\r\n', "author": "Zeh Fernando", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "doorway", "paramsTypes": { "reflection": "float", "perspective": "float", "depth": "float" }, "defaultParams": { "reflection": 0.4, "perspective": 0.4, "depth": 3 }, "glsl": "// author: gre\r\n// License: MIT \r\nuniform float reflection; // = 0.4\r\nuniform float perspective; // = 0.4\r\nuniform float depth; // = 3\r\n\r\nconst vec4 black = vec4(0.0, 0.0, 0.0, 1.0);\r\nconst vec2 boundMin = vec2(0.0, 0.0);\r\nconst vec2 boundMax = vec2(1.0, 1.0);\r\n\r\nbool inBounds (vec2 p) {\r\n  return all(lessThan(boundMin, p)) && all(lessThan(p, boundMax));\r\n}\r\n\r\nvec2 project (vec2 p) {\r\n  return p * vec2(1.0, -1.2) + vec2(0.0, -0.02);\r\n}\r\n\r\nvec4 bgColor (vec2 p, vec2 pto) {\r\n  vec4 c = black;\r\n  pto = project(pto);\r\n  if (inBounds(pto)) {\r\n    c += mix(black, getToColor(pto), reflection * mix(1.0, 0.0, pto.y));\r\n  }\r\n  return c;\r\n}\r\n\r\n\r\nvec4 transition (vec2 p) {\r\n  vec2 pfr = vec2(-1.), pto = vec2(-1.);\r\n  float middleSlit = 2.0 * abs(p.x-0.5) - progress;\r\n  if (middleSlit > 0.0) {\r\n    pfr = p + (p.x > 0.5 ? -1.0 : 1.0) * vec2(0.5*progress, 0.0);\r\n    float d = 1.0/(1.0+perspective*progress*(1.0-middleSlit));\r\n    pfr.y -= d/2.;\r\n    pfr.y *= d;\r\n    pfr.y += d/2.;\r\n  }\r\n  float size = mix(1.0, depth, 1.-progress);\r\n  pto = (p + vec2(-0.5, -0.5)) * vec2(size, size) + vec2(0.5, 0.5);\r\n  if (inBounds(pfr)) {\r\n    return getFromColor(pfr);\r\n  }\r\n  else if (inBounds(pto)) {\r\n    return getToColor(pto);\r\n  }\r\n  else {\r\n    return bgColor(p, pto);\r\n  }\r\n}\r\n", "author": "gre", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "Dreamy", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author: mikolalysenko\r\n// License: MIT\r\n\r\nvec2 offset(float progress, float x, float theta) {\r\n  float phase = progress*progress + progress + theta;\r\n  float shifty = 0.03*progress*cos(10.0*(progress+x));\r\n  return vec2(0, shifty);\r\n}\r\nvec4 transition(vec2 p) {\r\n  return mix(getFromColor(p + offset(progress, p.x, 0.0)), getToColor(p + offset(1.0-progress, p.x, 3.14)), progress);\r\n}\r\n", "author": "mikolalysenko", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "DreamyZoom", "paramsTypes": { "rotation": "float", "scale": "float" }, "defaultParams": { "rotation": 6, "scale": 1.2 }, "glsl": "// Author: Zeh Fernando\r\n// License: MIT\r\n\r\n// Definitions --------\r\n#define DEG2RAD 0.03926990816987241548078304229099 // 1/180*PI\r\n\r\n\r\n// Transition parameters --------\r\n\r\n// In degrees\r\nuniform float rotation; // = 6\r\n\r\n// Multiplier\r\nuniform float scale; // = 1.2\r\n\r\n\r\n// The code proper --------\r\n\r\nvec4 transition(vec2 uv) {\r\n  // Massage parameters\r\n  float phase = progress < 0.5 ? progress * 2.0 : (progress - 0.5) * 2.0;\r\n  float angleOffset = progress < 0.5 ? mix(0.0, rotation * DEG2RAD, phase) : mix(-rotation * DEG2RAD, 0.0, phase);\r\n  float newScale = progress < 0.5 ? mix(1.0, scale, phase) : mix(scale, 1.0, phase);\r\n  \r\n  vec2 center = vec2(0, 0);\r\n\r\n  // Calculate the source point\r\n  vec2 assumedCenter = vec2(0.5, 0.5);\r\n  vec2 p = (uv.xy - vec2(0.5, 0.5)) / newScale * vec2(ratio, 1.0);\r\n\r\n  // This can probably be optimized (with distance())\r\n  float angle = atan(p.y, p.x) + angleOffset;\r\n  float dist = distance(center, p);\r\n  p.x = cos(angle) * dist / ratio + 0.5;\r\n  p.y = sin(angle) * dist + 0.5;\r\n  vec4 c = progress < 0.5 ? getFromColor(p) : getToColor(p);\r\n\r\n  // Finally, apply the color\r\n  return c + (progress < 0.5 ? mix(0.0, 1.0, phase) : mix(1.0, 0.0, phase));\r\n}\r\n", "author": "Zeh Fernando", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "EdgeTransition", "paramsTypes": { "edge_thickness": "float", "edge_brightness": "float" }, "defaultParams": { "edge_thickness": 1e-3, "edge_brightness": 8 }, "glsl": "// Author: Woohyun Kim\r\n// License: MIT\r\n\r\nuniform float edge_thickness; // = 0.001;\r\nuniform float edge_brightness; // = 8.0;\r\n\r\nvec4 detectEdgeColor(vec3[9] c) {\r\n  /* adjacent texel array for texel c[4]\r\n    036\r\n    147\r\n    258\r\n  */\r\n  vec3 dx = 2.0 * abs(c[7]-c[1]) + abs(c[2] - c[6]) + abs(c[8] - c[0]);\r\n	vec3 dy = 2.0 * abs(c[3]-c[5]) + abs(c[6] - c[8]) + abs(c[0] - c[2]);\r\n  float delta = length(0.25 * (dx + dy) * 0.5);\r\n	return vec4(clamp(edge_brightness * delta, 0.0, 1.0) * c[4], 1.0);\r\n}\r\n\r\nvec4 getFromEdgeColor(vec2 uv) {\r\n	vec3 c[9];\r\n	for (int i=0; i < 3; ++i) for (int j=0; j < 3; ++j)\r\n	{\r\n	  vec4 color = getFromColor(uv + edge_thickness * vec2(i-1,j-1));\r\n    c[3*i + j] = color.rgb;\r\n	}\r\n	return detectEdgeColor(c);\r\n}\r\n\r\nvec4 getToEdgeColor(vec2 uv) {\r\n	vec3 c[9];\r\n	for (int i=0; i < 3; ++i) for (int j=0; j < 3; ++j)\r\n	{\r\n	  vec4 color = getToColor(uv + edge_thickness * vec2(i-1,j-1));\r\n    c[3*i + j] = color.rgb;\r\n	}\r\n	return detectEdgeColor(c);\r\n}\r\n\r\nvec4 transition (vec2 uv) {\r\n  vec4 start = mix(getFromColor(uv), getFromEdgeColor(uv), clamp(2.0 * progress, 0.0, 1.0));\r\n  vec4 end = mix(getToEdgeColor(uv), getToColor(uv), clamp(2.0 * (progress - 0.5), 0.0, 1.0));\r\n  return mix(\r\n    start,\r\n    end,\r\n    progress\r\n  );\r\n}\r\n", "author": "Woohyun Kim", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "fade-scale", "paramsTypes": { "zoom_quickness": "float" }, "defaultParams": { "zoom_quickness": 0.8 }, "glsl": "// Author: LYS\r\n// License: MIT\r\n\r\nuniform float zoom_quickness; // = 0.8\r\nfloat nQuick = clamp(zoom_quickness,0.2,1.0);\r\n\r\nvec2 zoom(vec2 uv, float amount) {\r\n  return 0.5 + ((uv - 0.5) * (1.0-amount));	\r\n}\r\n\r\nvec4 transition (vec2 uv) {\r\n  return mix(\r\n    getFromColor(zoom(uv, smoothstep(0.0, nQuick, progress))),\r\n    getToColor(uv),\r\n    progress\r\n  );\r\n}\r\n", "author": "LYS", "license": "MIT", "createdAt": "Fri, 16 Jun 2023 10:41:48 +0800", "updatedAt": "Fri, 16 Jun 2023 10:41:48 +0800" }, { "name": "fade", "paramsTypes": {}, "defaultParams": {}, "glsl": "// author: gre\r\n// license: MIT\r\n\r\nvec4 transition (vec2 uv) {\r\n  return mix(\r\n    getFromColor(uv),\r\n    getToColor(uv),\r\n    progress\r\n  );\r\n}\r\n", "author": "gre", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "fadecolor", "paramsTypes": { "color": "vec3", "colorPhase": "float" }, "defaultParams": { "color": [0, 0, 0], "colorPhase": 0.4 }, "glsl": "// author: gre\r\n// License: MIT\r\nuniform vec3 color;// = vec3(0.0)\r\nuniform float colorPhase; // = 0.4 ; // if 0.0, there is no black phase, if 0.9, the black phase is very important\r\nvec4 transition (vec2 uv) {\r\n  return mix(\r\n    mix(vec4(color, 1.0), getFromColor(uv), smoothstep(1.0-colorPhase, 0.0, progress)),\r\n    mix(vec4(color, 1.0), getToColor(uv), smoothstep(    colorPhase, 1.0, progress)),\r\n    progress);\r\n}\r\n", "author": "gre", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "fadegrayscale", "paramsTypes": { "intensity": "float" }, "defaultParams": { "intensity": 0.3 }, "glsl": "// Author: gre\r\n// License: MIT\r\n\r\nuniform float intensity; // = 0.3; // if 0.0, the image directly turn grayscale, if 0.9, the grayscale transition phase is very important\r\n \r\nvec3 grayscale (vec3 color) {\r\n  return vec3(0.2126*color.r + 0.7152*color.g + 0.0722*color.b);\r\n}\r\n \r\nvec4 transition (vec2 uv) {\r\n  vec4 fc = getFromColor(uv);\r\n  vec4 tc = getToColor(uv);\r\n  return mix(\r\n    mix(vec4(grayscale(fc.rgb), 1.0), fc, smoothstep(1.0-intensity, 0.0, progress)),\r\n    mix(vec4(grayscale(tc.rgb), 1.0), tc, smoothstep(    intensity, 1.0, progress)),\r\n    progress);\r\n}\r\n", "author": "gre", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "FilmBurn", "paramsTypes": { "Seed": "float" }, "defaultParams": { "Seed": 2.31 }, "glsl": "// author: Anastasia Dunbar\r\n// license: MIT\r\nuniform float Seed; // = 2.31\r\nfloat sigmoid(float x, float a) {\r\n    float b = pow(x*2.,a)/2.;\r\n    if (x > .5) {\r\n        b = 1.-pow(2.-(x*2.),a)/2.;\r\n    }\r\n	return b;\r\n}\r\nfloat rand(float co){\r\n    return fract(sin((co*24.9898)+Seed)*43758.5453);\r\n}\r\nfloat rand(vec2 co){\r\n    return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453);\r\n}\r\nfloat apow(float a,float b) { return pow(abs(a),b)*sign(b); }\r\nvec3 pow3(vec3 a,vec3 b) { return vec3(apow(a.r,b.r),apow(a.g,b.g),apow(a.b,b.b)); }\r\nfloat smooth_mix(float a,float b,float c) { return mix(a,b,sigmoid(c,2.)); }\r\nfloat random(vec2 co, float shft){\r\n    co += 10.;\r\n    return smooth_mix(fract(sin(dot(co.xy ,vec2(12.9898+(floor(shft)*.5),78.233+Seed))) * 43758.5453),fract(sin(dot(co.xy ,vec2(12.9898+(floor(shft+1.)*.5),78.233+Seed))) * 43758.5453),fract(shft));\r\n}\r\nfloat smooth_random(vec2 co, float shft) {\r\n	return smooth_mix(smooth_mix(random(floor(co),shft),random(floor(co+vec2(1.,0.)),shft),fract(co.x)),smooth_mix(random(floor(co+vec2(0.,1.)),shft),random(floor(co+vec2(1.,1.)),shft),fract(co.x)),fract(co.y));\r\n}\r\nvec4 texture(vec2 p) {\r\n    return mix(getFromColor(p), getToColor(p), sigmoid(progress,10.));\r\n}\r\n#define pi 3.14159265358979323\r\n#define clamps(x) clamp(x,0.,1.)\r\n\r\nvec4 transition(vec2 p) {\r\n  vec3 f = vec3(0.);\r\n  for (float i = 0.; i < 13.; i++) {\r\n    f += sin(((p.x*rand(i)*6.)+(progress*8.))+rand(i+1.43))*sin(((p.y*rand(i+4.4)*6.)+(progress*6.))+rand(i+2.4));\r\n    f += 1.-clamps(length(p-vec2(smooth_random(vec2(progress*1.3),i+1.),smooth_random(vec2(progress*.5),i+6.25)))*mix(20.,70.,rand(i)));\r\n  }\r\n  f += 4.;\r\n  f /= 11.;\r\n  f = pow3(f*vec3(1.,0.7,0.6),vec3(1.,2.-sin(progress*pi),1.3));\r\n  f *= sin(progress*pi);\r\n  \r\n  p -= .5;\r\n  p *= 1.+(smooth_random(vec2(progress*5.),6.3)*sin(progress*pi)*.05);\r\n  p += .5;\r\n  \r\n  vec4 blurred_image = vec4(0.);\r\n  float bluramount = sin(progress*pi)*.03;\r\n  #define repeats  50.\r\n  for (float i = 0.; i < repeats; i++) { \r\n      vec2 q = vec2(cos(degrees((i/repeats)*360.)),sin(degrees((i/repeats)*360.))) *  (rand(vec2(i,p.x+p.y))+bluramount); \r\n      vec2 uv2 = p+(q*bluramount);\r\n      blurred_image += texture(uv2);\r\n  }\r\n  blurred_image /= repeats;\r\n  \r\n  return blurred_image+vec4(f,0.);\r\n}\r\n", "author": "Anastasia Dunbar", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "flyeye", "paramsTypes": { "size": "float", "zoom": "float", "colorSeparation": "float" }, "defaultParams": { "size": 0.04, "zoom": 50, "colorSeparation": 0.3 }, "glsl": "// Author: gre\r\n// License: MIT\r\nuniform float size; // = 0.04\r\nuniform float zoom; // = 50.0\r\nuniform float colorSeparation; // = 0.3\r\n\r\nvec4 transition(vec2 p) {\r\n  float inv = 1. - progress;\r\n  vec2 disp = size*vec2(cos(zoom*p.x), sin(zoom*p.y));\r\n  vec4 texTo = getToColor(p + inv*disp);\r\n  vec4 texFrom = vec4(\r\n    getFromColor(p + progress*disp*(1.0 - colorSeparation)).r,\r\n    getFromColor(p + progress*disp).g,\r\n    getFromColor(p + progress*disp*(1.0 + colorSeparation)).b,\r\n    1.0);\r\n  return texTo*progress + texFrom*inv;\r\n}\r\n", "author": "gre", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "GlitchDisplace", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author: Matt DesLauriers\r\n// License: MIT\r\n\r\n#ifdef GL_ES\r\nprecision highp float;\r\n#endif\r\n\r\nfloat random(vec2 co)\r\n{\r\n    float a = 12.9898;\r\n    float b = 78.233;\r\n    float c = 43758.5453;\r\n    float dt= dot(co.xy ,vec2(a,b));\r\n    float sn= mod(dt,3.14);\r\n    return fract(sin(sn) * c);\r\n}\r\nfloat voronoi( in vec2 x ) {\r\n    vec2 p = floor( x );\r\n    vec2 f = fract( x );\r\n    float res = 8.0;\r\n    for( float j=-1.; j<=1.; j++ )\r\n    for( float i=-1.; i<=1.; i++ ) {\r\n        vec2  b = vec2( i, j );\r\n        vec2  r = b - f + random( p + b );\r\n        float d = dot( r, r );\r\n        res = min( res, d );\r\n    }\r\n    return sqrt( res );\r\n}\r\n\r\nvec2 displace(vec4 tex, vec2 texCoord, float dotDepth, float textureDepth, float strength) {\r\n    float b = voronoi(.003 * texCoord + 2.0);\r\n    float g = voronoi(0.2 * texCoord);\r\n    float r = voronoi(texCoord - 1.0);\r\n    vec4 dt = tex * 1.0;\r\n    vec4 dis = dt * dotDepth + 1.0 - tex * textureDepth;\r\n\r\n    dis.x = dis.x - 1.0 + textureDepth*dotDepth;\r\n    dis.y = dis.y - 1.0 + textureDepth*dotDepth;\r\n    dis.x *= strength;\r\n    dis.y *= strength;\r\n    vec2 res_uv = texCoord ;\r\n    res_uv.x = res_uv.x + dis.x - 0.0;\r\n    res_uv.y = res_uv.y + dis.y;\r\n    return res_uv;\r\n}\r\n\r\nfloat ease1(float t) {\r\n  return t == 0.0 || t == 1.0\r\n    ? t\r\n    : t < 0.5\r\n      ? +0.5 * pow(2.0, (20.0 * t) - 10.0)\r\n      : -0.5 * pow(2.0, 10.0 - (t * 20.0)) + 1.0;\r\n}\r\nfloat ease2(float t) {\r\n  return t == 1.0 ? t : 1.0 - pow(2.0, -10.0 * t);\r\n}\r\n\r\n\r\n\r\nvec4 transition(vec2 uv) {\r\n  vec2 p = uv.xy / vec2(1.0).xy;\r\n  vec4 color1 = getFromColor(p);\r\n  vec4 color2 = getToColor(p);\r\n  vec2 disp = displace(color1, p, 0.33, 0.7, 1.0-ease1(progress));\r\n  vec2 disp2 = displace(color2, p, 0.33, 0.5, ease2(progress));\r\n  vec4 dColor1 = getToColor(disp);\r\n  vec4 dColor2 = getFromColor(disp2);\r\n  float val = ease1(progress);\r\n  vec3 gray = vec3(dot(min(dColor2, dColor1).rgb, vec3(0.299, 0.587, 0.114)));\r\n  dColor2 = vec4(gray, 1.0);\r\n  dColor2 *= 2.0;\r\n  color1 = mix(color1, dColor2, smoothstep(0.0, 0.5, progress));\r\n  color2 = mix(color2, dColor1, smoothstep(1.0, 0.5, progress));\r\n  return mix(color1, color2, val);\r\n  //gl_FragColor = mix(gl_FragColor, dColor, smoothstep(0.0, 0.5, progress));\r\n\r\n   //gl_FragColor = mix(texture2D(from, p), texture2D(to, p), progress);\r\n}\r\n", "author": "Matt DesLauriers", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "GlitchMemories", "paramsTypes": {}, "defaultParams": {}, "glsl": "// author: Gunnar Roth\r\n// based on work from natewave\r\n// license: MIT\r\nvec4 transition(vec2 p) {\r\n  vec2 block = floor(p.xy / vec2(16));\r\n  vec2 uv_noise = block / vec2(64);\r\n  uv_noise += floor(vec2(progress) * vec2(1200.0, 3500.0)) / vec2(64);\r\n  vec2 dist = progress > 0.0 ? (fract(uv_noise) - 0.5) * 0.3 *(1.0 -progress) : vec2(0.0);\r\n  vec2 red = p + dist * 0.2;\r\n  vec2 green = p + dist * .3;\r\n  vec2 blue = p + dist * .5;\r\n\r\n  return vec4(mix(getFromColor(red), getToColor(red), progress).r,mix(getFromColor(green), getToColor(green), progress).g,mix(getFromColor(blue), getToColor(blue), progress).b,1.0);\r\n}\r\n\r\n", "author": "Gunnar Roth", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "GridFlip", "paramsTypes": { "size": "ivec2", "pause": "float", "dividerWidth": "float", "bgcolor": "vec4", "randomness": "float" }, "defaultParams": { "size": [4, 4], "pause": 0.1, "dividerWidth": 0.05, "bgcolor": [0, 0, 0, 1], "randomness": 0.1 }, "glsl": "// License: MIT\r\n// Author: TimDonselaar\r\n// ported by gre from https://gist.github.com/TimDonselaar/9bcd1c4b5934ba60087bdb55c2ea92e5\r\n\r\nuniform ivec2 size; // = ivec2(4)\r\nuniform float pause; // = 0.1\r\nuniform float dividerWidth; // = 0.05\r\nuniform vec4 bgcolor; // = vec4(0.0, 0.0, 0.0, 1.0)\r\nuniform float randomness; // = 0.1\r\n \r\nfloat rand (vec2 co) {\r\n  return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453);\r\n}\r\n\r\nfloat getDelta(vec2 p) {\r\n  vec2 rectanglePos = floor(vec2(size) * p);\r\n  vec2 rectangleSize = vec2(1.0 / vec2(size).x, 1.0 / vec2(size).y);\r\n  float top = rectangleSize.y * (rectanglePos.y + 1.0);\r\n  float bottom = rectangleSize.y * rectanglePos.y;\r\n  float left = rectangleSize.x * rectanglePos.x;\r\n  float right = rectangleSize.x * (rectanglePos.x + 1.0);\r\n  float minX = min(abs(p.x - left), abs(p.x - right));\r\n  float minY = min(abs(p.y - top), abs(p.y - bottom));\r\n  return min(minX, minY);\r\n}\r\n\r\nfloat getDividerSize() {\r\n  vec2 rectangleSize = vec2(1.0 / vec2(size).x, 1.0 / vec2(size).y);\r\n  return min(rectangleSize.x, rectangleSize.y) * dividerWidth;\r\n}\r\n\r\nvec4 transition(vec2 p) {\r\n  if(progress < pause) {\r\n    float currentProg = progress / pause;\r\n    float a = 1.0;\r\n    if(getDelta(p) < getDividerSize()) {\r\n      a = 1.0 - currentProg;\r\n    }\r\n    return mix(bgcolor, getFromColor(p), a);\r\n  }\r\n  else if(progress < 1.0 - pause){\r\n    if(getDelta(p) < getDividerSize()) {\r\n      return bgcolor;\r\n    } else {\r\n      float currentProg = (progress - pause) / (1.0 - pause * 2.0);\r\n      vec2 q = p;\r\n      vec2 rectanglePos = floor(vec2(size) * q);\r\n      \r\n      float r = rand(rectanglePos) - randomness;\r\n      float cp = smoothstep(0.0, 1.0 - r, currentProg);\r\n    \r\n      float rectangleSize = 1.0 / vec2(size).x;\r\n      float delta = rectanglePos.x * rectangleSize;\r\n      float offset = rectangleSize / 2.0 + delta;\r\n      \r\n      p.x = (p.x - offset)/abs(cp - 0.5)*0.5 + offset;\r\n      vec4 a = getFromColor(p);\r\n      vec4 b = getToColor(p);\r\n      \r\n      float s = step(abs(vec2(size).x * (q.x - delta) - 0.5), abs(cp - 0.5));\r\n      return mix(bgcolor, mix(b, a, step(cp, 0.5)), s);\r\n    }\r\n  }\r\n  else {\r\n    float currentProg = (progress - 1.0 + pause) / pause;\r\n    float a = 1.0;\r\n    if(getDelta(p) < getDividerSize()) {\r\n      a = currentProg;\r\n    }\r\n    return mix(bgcolor, getToColor(p), a);\r\n  }\r\n}\r\n", "license": "MIT", "author": "TimDonselaar", "createdAt": "", "updatedAt": "" }, { "name": "heart", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author: gre\r\n// License: MIT\r\n\r\nfloat inHeart (vec2 p, vec2 center, float size) {\r\n  if (size==0.0) return 0.0;\r\n  vec2 o = (p-center)/(1.6*size);\r\n  float a = o.x*o.x+o.y*o.y-0.3;\r\n  return step(a*a*a, o.x*o.x*o.y*o.y*o.y);\r\n}\r\nvec4 transition (vec2 uv) {\r\n  return mix(\r\n    getFromColor(uv),\r\n    getToColor(uv),\r\n    inHeart(uv, vec2(0.5, 0.4), progress)\r\n  );\r\n}\r\n", "author": "gre", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "hexagonalize", "paramsTypes": { "steps": "int", "horizontalHexagons": "float" }, "defaultParams": { "steps": 50, "horizontalHexagons": 20 }, "glsl": "// Author: Fernando Kuteken\r\n// License: MIT\r\n// Hexagonal math from: http://www.redblobgames.com/grids/hexagons/\r\n\r\nuniform int steps; // = 50;\r\nuniform float horizontalHexagons; //= 20;\r\n\r\nstruct Hexagon {\r\n  float q;\r\n  float r;\r\n  float s;\r\n};\r\n\r\nHexagon createHexagon(float q, float r){\r\n  Hexagon hex;\r\n  hex.q = q;\r\n  hex.r = r;\r\n  hex.s = -q - r;\r\n  return hex;\r\n}\r\n\r\nHexagon roundHexagon(Hexagon hex){\r\n  \r\n  float q = floor(hex.q + 0.5);\r\n  float r = floor(hex.r + 0.5);\r\n  float s = floor(hex.s + 0.5);\r\n\r\n  float deltaQ = abs(q - hex.q);\r\n  float deltaR = abs(r - hex.r);\r\n  float deltaS = abs(s - hex.s);\r\n\r\n  if (deltaQ > deltaR && deltaQ > deltaS)\r\n    q = -r - s;\r\n  else if (deltaR > deltaS)\r\n    r = -q - s;\r\n  else\r\n    s = -q - r;\r\n\r\n  return createHexagon(q, r);\r\n}\r\n\r\nHexagon hexagonFromPoint(vec2 point, float size) {\r\n  \r\n  point.y /= ratio;\r\n  point = (point - 0.5) / size;\r\n  \r\n  float q = (sqrt(3.0) / 3.0) * point.x + (-1.0 / 3.0) * point.y;\r\n  float r = 0.0 * point.x + 2.0 / 3.0 * point.y;\r\n\r\n  Hexagon hex = createHexagon(q, r);\r\n  return roundHexagon(hex);\r\n  \r\n}\r\n\r\nvec2 pointFromHexagon(Hexagon hex, float size) {\r\n  \r\n  float x = (sqrt(3.0) * hex.q + (sqrt(3.0) / 2.0) * hex.r) * size + 0.5;\r\n  float y = (0.0 * hex.q + (3.0 / 2.0) * hex.r) * size + 0.5;\r\n  \r\n  return vec2(x, y * ratio);\r\n}\r\n\r\nvec4 transition (vec2 uv) {\r\n  \r\n  float dist = 2.0 * min(progress, 1.0 - progress);\r\n  dist = steps > 0 ? ceil(dist * float(steps)) / float(steps) : dist;\r\n  \r\n  float size = (sqrt(3.0) / 3.0) * dist / horizontalHexagons;\r\n  \r\n  vec2 point = dist > 0.0 ? pointFromHexagon(hexagonFromPoint(uv, size), size) : uv;\r\n\r\n  return mix(getFromColor(point), getToColor(point), progress);\r\n  \r\n}\r\n", "author": "Fernando Kuteken", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "HorizontalClose", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author: martiniti\r\n// License: MIT\r\n\r\nvec4 transition (vec2 uv) {\r\n\r\n  float s = 2.0 - abs((uv.y - 0.5) / (progress - 1.0)) - 2.0 * progress;\r\n  \r\n  return mix(\r\n    getFromColor(uv),\r\n    getToColor(uv),\r\n    smoothstep(0.5, 0.0, s)\r\n  ); \r\n}\r\n", "author": "martiniti", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "HorizontalOpen", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author: martiniti\r\n// License: MIT\r\n\r\nvec4 transition (vec2 uv) {\r\n  \r\n  float regress = 1.0 - progress;\r\n\r\n  float s = 2.0 - abs((uv.y - 0.5) / (regress - 1.0)) - 2.0 * regress;\r\n  \r\n  return mix(\r\n    getFromColor(uv),\r\n    getToColor(uv),\r\n    smoothstep(0.0, 0.5, s)\r\n  );\r\n}\r\n", "author": "martiniti", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "InvertedPageCurl", "paramsTypes": {}, "defaultParams": {}, "glsl": '// author: Hewlett-Packard\r\n// license: BSD 3 Clause\r\n// Adapted by Sergey Kosarevsky from:\r\n// http://rectalogic.github.io/webvfx/examples_2transition-shader-pagecurl_8html-example.html\r\n\r\n/*\r\nCopyright (c) 2010 Hewlett-Packard Development Company, L.P. All rights reserved.\r\n\r\nRedistribution and use in source and binary forms, with or without\r\nmodification, are permitted provided that the following conditions are\r\nmet:\r\n\r\n   * Redistributions of source code must retain the above copyright\r\n     notice, this list of conditions and the following disclaimer.\r\n   * Redistributions in binary form must reproduce the above\r\n     copyright notice, this list of conditions and the following disclaimer\r\n     in the documentation and/or other materials provided with the\r\n     distribution.\r\n   * Neither the name of Hewlett-Packard nor the names of its\r\n     contributors may be used to endorse or promote products derived from\r\n     this software without specific prior written permission.\r\n\r\nTHIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS\r\n"AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT\r\nLIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR\r\nA PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT\r\nOWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,\r\nSPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT\r\nLIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,\r\nDATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY\r\nTHEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\r\n(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE\r\nOF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\r\nin vec2 texCoord;\r\n*/\r\n\r\nconst float MIN_AMOUNT = -0.16;\r\nconst float MAX_AMOUNT = 1.5;\r\nfloat amount = progress * (MAX_AMOUNT - MIN_AMOUNT) + MIN_AMOUNT;\r\n\r\nconst float PI = 3.141592653589793;\r\n\r\nconst float scale = 512.0;\r\nconst float sharpness = 3.0;\r\n\r\nfloat cylinderCenter = amount;\r\n// 360 degrees * amount\r\nfloat cylinderAngle = 2.0 * PI * amount;\r\n\r\nconst float cylinderRadius = 1.0 / PI / 2.0;\r\n\r\nvec3 hitPoint(float hitAngle, float yc, vec3 point, mat3 rrotation)\r\n{\r\n        float hitPoint = hitAngle / (2.0 * PI);\r\n        point.y = hitPoint;\r\n        return rrotation * point;\r\n}\r\n\r\nvec4 antiAlias(vec4 color1, vec4 color2, float distanc)\r\n{\r\n        distanc *= scale;\r\n        if (distanc < 0.0) return color2;\r\n        if (distanc > 2.0) return color1;\r\n        float dd = pow(1.0 - distanc / 2.0, sharpness);\r\n        return ((color2 - color1) * dd) + color1;\r\n}\r\n\r\nfloat distanceToEdge(vec3 point)\r\n{\r\n        float dx = abs(point.x > 0.5 ? 1.0 - point.x : point.x);\r\n        float dy = abs(point.y > 0.5 ? 1.0 - point.y : point.y);\r\n        if (point.x < 0.0) dx = -point.x;\r\n        if (point.x > 1.0) dx = point.x - 1.0;\r\n        if (point.y < 0.0) dy = -point.y;\r\n        if (point.y > 1.0) dy = point.y - 1.0;\r\n        if ((point.x < 0.0 || point.x > 1.0) && (point.y < 0.0 || point.y > 1.0)) return sqrt(dx * dx + dy * dy);\r\n        return min(dx, dy);\r\n}\r\n\r\nvec4 seeThrough(float yc, vec2 p, mat3 rotation, mat3 rrotation)\r\n{\r\n        float hitAngle = PI - (acos(yc / cylinderRadius) - cylinderAngle);\r\n        vec3 point = hitPoint(hitAngle, yc, rotation * vec3(p, 1.0), rrotation);\r\n        if (yc <= 0.0 && (point.x < 0.0 || point.y < 0.0 || point.x > 1.0 || point.y > 1.0))\r\n        {\r\n            return getToColor(p);\r\n        }\r\n\r\n        if (yc > 0.0) return getFromColor(p);\r\n\r\n        vec4 color = getFromColor(point.xy);\r\n        vec4 tcolor = vec4(0.0);\r\n\r\n        return antiAlias(color, tcolor, distanceToEdge(point));\r\n}\r\n\r\nvec4 seeThroughWithShadow(float yc, vec2 p, vec3 point, mat3 rotation, mat3 rrotation)\r\n{\r\n        float shadow = distanceToEdge(point) * 30.0;\r\n        shadow = (1.0 - shadow) / 3.0;\r\n\r\n        if (shadow < 0.0) shadow = 0.0; else shadow *= amount;\r\n\r\n        vec4 shadowColor = seeThrough(yc, p, rotation, rrotation);\r\n        shadowColor.r -= shadow;\r\n        shadowColor.g -= shadow;\r\n        shadowColor.b -= shadow;\r\n\r\n        return shadowColor;\r\n}\r\n\r\nvec4 backside(float yc, vec3 point)\r\n{\r\n        vec4 color = getFromColor(point.xy);\r\n        float gray = (color.r + color.b + color.g) / 15.0;\r\n        gray += (8.0 / 10.0) * (pow(1.0 - abs(yc / cylinderRadius), 2.0 / 10.0) / 2.0 + (5.0 / 10.0));\r\n        color.rgb = vec3(gray);\r\n        return color;\r\n}\r\n\r\nvec4 behindSurface(vec2 p, float yc, vec3 point, mat3 rrotation)\r\n{\r\n        float shado = (1.0 - ((-cylinderRadius - yc) / amount * 7.0)) / 6.0;\r\n        shado *= 1.0 - abs(point.x - 0.5);\r\n\r\n        yc = (-cylinderRadius - cylinderRadius - yc);\r\n\r\n        float hitAngle = (acos(yc / cylinderRadius) + cylinderAngle) - PI;\r\n        point = hitPoint(hitAngle, yc, point, rrotation);\r\n\r\n        if (yc < 0.0 && point.x >= 0.0 && point.y >= 0.0 && point.x <= 1.0 && point.y <= 1.0 && (hitAngle < PI || amount > 0.5))\r\n        {\r\n                shado = 1.0 - (sqrt(pow(point.x - 0.5, 2.0) + pow(point.y - 0.5, 2.0)) / (71.0 / 100.0));\r\n                shado *= pow(-yc / cylinderRadius, 3.0);\r\n                shado *= 0.5;\r\n        }\r\n        else\r\n        {\r\n                shado = 0.0;\r\n        }\r\n        return vec4(getToColor(p).rgb - shado, 1.0);\r\n}\r\n\r\nvec4 transition(vec2 p) {\r\n\r\n  const float angle = 100.0 * PI / 180.0;\r\n        float c = cos(-angle);\r\n        float s = sin(-angle);\r\n\r\n        mat3 rotation = mat3( c, s, 0,\r\n                                                                -s, c, 0,\r\n                                                                -0.801, 0.8900, 1\r\n                                                                );\r\n        c = cos(angle);\r\n        s = sin(angle);\r\n\r\n        mat3 rrotation = mat3(	c, s, 0,\r\n                                                                        -s, c, 0,\r\n                                                                        0.98500, 0.985, 1\r\n                                                                );\r\n\r\n        vec3 point = rotation * vec3(p, 1.0);\r\n\r\n        float yc = point.y - cylinderCenter;\r\n\r\n        if (yc < -cylinderRadius)\r\n        {\r\n                // Behind surface\r\n                return behindSurface(p,yc, point, rrotation);\r\n        }\r\n\r\n        if (yc > cylinderRadius)\r\n        {\r\n                // Flat surface\r\n                return getFromColor(p);\r\n        }\r\n\r\n        float hitAngle = (acos(yc / cylinderRadius) + cylinderAngle) - PI;\r\n\r\n        float hitAngleMod = mod(hitAngle, 2.0 * PI);\r\n        if ((hitAngleMod > PI && amount < 0.5) || (hitAngleMod > PI/2.0 && amount < 0.0))\r\n        {\r\n                return seeThrough(yc, p, rotation, rrotation);\r\n        }\r\n\r\n        point = hitPoint(hitAngle, yc, point, rrotation);\r\n\r\n        if (point.x < 0.0 || point.y < 0.0 || point.x > 1.0 || point.y > 1.0)\r\n        {\r\n                return seeThroughWithShadow(yc, p, point, rotation, rrotation);\r\n        }\r\n\r\n        vec4 color = backside(yc, point);\r\n\r\n        vec4 otherColor;\r\n        if (yc < 0.0)\r\n        {\r\n                float shado = 1.0 - (sqrt(pow(point.x - 0.5, 2.0) + pow(point.y - 0.5, 2.0)) / 0.71);\r\n                shado *= pow(-yc / cylinderRadius, 3.0);\r\n                shado *= 0.5;\r\n                otherColor = vec4(0.0, 0.0, 0.0, shado);\r\n        }\r\n        else\r\n        {\r\n                otherColor = getFromColor(p);\r\n        }\r\n\r\n        color = antiAlias(color, otherColor, cylinderRadius - abs(yc));\r\n\r\n        vec4 cl = seeThroughWithShadow(yc, p, point, rotation, rrotation);\r\n        float dist = distanceToEdge(point);\r\n\r\n        return antiAlias(color, cl, dist);\r\n}\r\n', "author": "Hewlett-Packard", "license": "BSD 3 Clause", "createdAt": "", "updatedAt": "" }, { "name": "kaleidoscope", "paramsTypes": { "speed": "float", "angle": "float", "power": "float" }, "defaultParams": { "speed": 1, "angle": 1, "power": 1.5 }, "glsl": "// Author: nwoeanhinnogaehr\r\n// License: MIT\r\n\r\nuniform float speed; // = 1.0;\r\nuniform float angle; // = 1.0;\r\nuniform float power; // = 1.5;\r\n\r\nvec4 transition(vec2 uv) {\r\n  vec2 p = uv.xy / vec2(1.0).xy;\r\n  vec2 q = p;\r\n  float t = pow(progress, power)*speed;\r\n  p = p -0.5;\r\n  for (int i = 0; i < 7; i++) {\r\n    p = vec2(sin(t)*p.x + cos(t)*p.y, sin(t)*p.y - cos(t)*p.x);\r\n    t += angle;\r\n    p = abs(mod(p, 2.0) - 1.0);\r\n  }\r\n  abs(mod(p, 1.0));\r\n  return mix(\r\n    mix(getFromColor(q), getToColor(q), progress),\r\n    mix(getFromColor(p), getToColor(p), progress), 1.0 - 2.0*abs(progress - 0.5));\r\n}\r\n", "author": "nwoeanhinnogaehr", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "LeftRight", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author:zhmy\r\n// License: MIT\r\n\r\nconst vec4 black = vec4(0.0, 0.0, 0.0, 1.0);\r\nconst vec2 boundMin = vec2(0.0, 0.0);\r\nconst vec2 boundMax = vec2(1.0, 1.0);\r\n\r\nbool inBounds (vec2 p) {\r\n    return all(lessThan(boundMin, p)) && all(lessThan(p, boundMax));\r\n}\r\n\r\nvec4 transition (vec2 uv) {\r\n    vec2 spfr,spto = vec2(-1.);\r\n\r\n    float size = mix(1.0, 3.0, progress*0.2);\r\n    spto = (uv + vec2(-0.5,-0.5))*vec2(size,size)+vec2(0.5,0.5);\r\n    spfr = (uv - vec2(1.-progress, 0.0));\r\n    if(inBounds(spfr)){\r\n        return getToColor(spfr);\r\n    }else if(inBounds(spto)){\r\n        return getFromColor(spto) * (1.0 - progress);\r\n    } else{\r\n        return black;\r\n    }\r\n}", "author": "zhmy", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "LinearBlur", "paramsTypes": { "intensity": "float" }, "defaultParams": { "intensity": 0.1 }, "glsl": "// author: gre\r\n// license: MIT\r\nuniform float intensity; // = 0.1\r\nconst int passes = 6;\r\n\r\nvec4 transition(vec2 uv) {\r\n    vec4 c1 = vec4(0.0);\r\n    vec4 c2 = vec4(0.0);\r\n\r\n    float disp = intensity*(0.5-distance(0.5, progress));\r\n    for (int xi=0; xi<passes; xi++)\r\n    {\r\n        float x = float(xi) / float(passes) - 0.5;\r\n        for (int yi=0; yi<passes; yi++)\r\n        {\r\n            float y = float(yi) / float(passes) - 0.5;\r\n            vec2 v = vec2(x,y);\r\n            float d = disp;\r\n            c1 += getFromColor( uv + d*v);\r\n            c2 += getToColor( uv + d*v);\r\n        }\r\n    }\r\n    c1 /= float(passes*passes);\r\n    c2 /= float(passes*passes);\r\n    return mix(c1, c2, progress);\r\n}\r\n", "author": "gre", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "luma", "paramsTypes": { "luma": "sampler2D" }, "defaultParams": { "luma": null }, "glsl": "// Author: gre\r\n// License: MIT\r\n\r\nuniform sampler2D luma;\r\n\r\nvec4 transition(vec2 uv) {\r\n  return mix(\r\n    getToColor(uv),\r\n    getFromColor(uv),\r\n    step(progress, texture2D(luma, uv).r)\r\n  );\r\n}\r\n", "author": "gre", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "luminance_melt", "paramsTypes": { "direction": "bool", "l_threshold": "float", "above": "bool" }, "defaultParams": { "direction": true, "l_threshold": 0.8, "above": false }, "glsl": "// Author: 0gust1\r\n// License: MIT\r\n//My own first transition — based on crosshatch code (from pthrasher), using  simplex noise formula (copied and pasted)\r\n//-> cooler with high contrasted images (isolated dark subject on light background f.e.)\r\n//TODO : try to rebase it on DoomTransition (from zeh)?\r\n//optimizations :\r\n//luminance (see http://stackoverflow.com/questions/596216/formula-to-determine-brightness-of-rgb-color#answer-596241)\r\n// Y = (R+R+B+G+G+G)/6\r\n//or Y = (R+R+R+B+G+G+G+G)>>3 \r\n\r\n\r\n//direction of movement :  0 : up, 1, down\r\nuniform bool direction; // = 1 \r\n//luminance threshold\r\nuniform float l_threshold; // = 0.8 \r\n//does the movement takes effect above or below luminance threshold ?\r\nuniform bool above; // = false \r\n\r\n\r\n//Random function borrowed from everywhere\r\nfloat rand(vec2 co){\r\n  return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453);\r\n}\r\n\r\n\r\n// Simplex noise :\r\n// Description : Array and textureless GLSL 2D simplex noise function.\r\n//      Author : Ian McEwan, Ashima Arts.\r\n//  Maintainer : ijm\r\n//     Lastmod : 20110822 (ijm)\r\n//     License : MIT  \r\n//               2011 Ashima Arts. All rights reserved.\r\n//               Distributed under the MIT License. See LICENSE file.\r\n//               https://github.com/ashima/webgl-noise\r\n// \r\n\r\nvec3 mod289(vec3 x) {\r\n  return x - floor(x * (1.0 / 289.0)) * 289.0;\r\n}\r\n\r\nvec2 mod289(vec2 x) {\r\n  return x - floor(x * (1.0 / 289.0)) * 289.0;\r\n}\r\n\r\nvec3 permute(vec3 x) {\r\n  return mod289(((x*34.0)+1.0)*x);\r\n}\r\n\r\nfloat snoise(vec2 v)\r\n  {\r\n  const vec4 C = vec4(0.211324865405187,  // (3.0-sqrt(3.0))/6.0\r\n                      0.366025403784439,  // 0.5*(sqrt(3.0)-1.0)\r\n                     -0.577350269189626,  // -1.0 + 2.0 * C.x\r\n                      0.024390243902439); // 1.0 / 41.0\r\n// First corner\r\n  vec2 i  = floor(v + dot(v, C.yy) );\r\n  vec2 x0 = v -   i + dot(i, C.xx);\r\n\r\n// Other corners\r\n  vec2 i1;\r\n  //i1.x = step( x0.y, x0.x ); // x0.x > x0.y ? 1.0 : 0.0\r\n  //i1.y = 1.0 - i1.x;\r\n  i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);\r\n  // x0 = x0 - 0.0 + 0.0 * C.xx ;\r\n  // x1 = x0 - i1 + 1.0 * C.xx ;\r\n  // x2 = x0 - 1.0 + 2.0 * C.xx ;\r\n  vec4 x12 = x0.xyxy + C.xxzz;\r\n  x12.xy -= i1;\r\n\r\n// Permutations\r\n  i = mod289(i); // Avoid truncation effects in permutation\r\n  vec3 p = permute( permute( i.y + vec3(0.0, i1.y, 1.0 ))\r\n		+ i.x + vec3(0.0, i1.x, 1.0 ));\r\n\r\n  vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy), dot(x12.zw,x12.zw)), 0.0);\r\n  m = m*m ;\r\n  m = m*m ;\r\n\r\n// Gradients: 41 points uniformly over a line, mapped onto a diamond.\r\n// The ring size 17*17 = 289 is close to a multiple of 41 (41*7 = 287)\r\n\r\n  vec3 x = 2.0 * fract(p * C.www) - 1.0;\r\n  vec3 h = abs(x) - 0.5;\r\n  vec3 ox = floor(x + 0.5);\r\n  vec3 a0 = x - ox;\r\n\r\n// Normalise gradients implicitly by scaling m\r\n// Approximation of: m *= inversesqrt( a0*a0 + h*h );\r\n  m *= 1.79284291400159 - 0.85373472095314 * ( a0*a0 + h*h );\r\n\r\n// Compute final noise value at P\r\n  vec3 g;\r\n  g.x  = a0.x  * x0.x  + h.x  * x0.y;\r\n  g.yz = a0.yz * x12.xz + h.yz * x12.yw;\r\n  return 130.0 * dot(m, g);\r\n}\r\n\r\n// Simplex noise -- end\r\n\r\nfloat luminance(vec4 color){\r\n  //(0.299*R + 0.587*G + 0.114*B)\r\n  return color.r*0.299+color.g*0.587+color.b*0.114;\r\n}\r\n\r\nvec2 center = vec2(1.0, direction);\r\n\r\nvec4 transition(vec2 uv) {\r\n  vec2 p = uv.xy / vec2(1.0).xy;\r\n  if (progress == 0.0) {\r\n    return getFromColor(p);\r\n  } else if (progress == 1.0) {\r\n    return getToColor(p);\r\n  } else {\r\n    float x = progress;\r\n    float dist = distance(center, p)- progress*exp(snoise(vec2(p.x, 0.0)));\r\n    float r = x - rand(vec2(p.x, 0.1));\r\n    float m;\r\n    if(above){\r\n     m = dist <= r && luminance(getFromColor(p))>l_threshold ? 1.0 : (progress*progress*progress);\r\n    }\r\n    else{\r\n     m = dist <= r && luminance(getFromColor(p))<l_threshold ? 1.0 : (progress*progress*progress);  \r\n    }\r\n    return mix(getFromColor(p), getToColor(p), m);    \r\n  }\r\n}\r\n", "author": "0gust1", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "morph", "paramsTypes": { "strength": "float" }, "defaultParams": { "strength": 0.1 }, "glsl": "// Author: paniq\r\n// License: MIT\r\nuniform float strength; // = 0.1\r\n\r\nvec4 transition(vec2 p) {\r\n  vec4 ca = getFromColor(p);\r\n  vec4 cb = getToColor(p);\r\n  \r\n  vec2 oa = (((ca.rg+ca.b)*0.5)*2.0-1.0);\r\n  vec2 ob = (((cb.rg+cb.b)*0.5)*2.0-1.0);\r\n  vec2 oc = mix(oa,ob,0.5)*strength;\r\n  \r\n  float w0 = progress;\r\n  float w1 = 1.0-w0;\r\n  return mix(getFromColor(p+oc*w0), getToColor(p-oc*w1), progress);\r\n}\r\n", "author": "paniq", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "Mosaic", "paramsTypes": { "endx": "int", "endy": "int" }, "defaultParams": { "endx": 2, "endy": -1 }, "glsl": "// License: MIT\r\n// Author: Xaychru\r\n// ported by gre from https://gist.github.com/Xaychru/130bb7b7affedbda9df5\r\n\r\n#define PI 3.14159265358979323\r\n#define POW2(X) X*X\r\n#define POW3(X) X*X*X\r\nuniform int endx; // = 2\r\nuniform int endy; // = -1\r\n\r\nfloat Rand(vec2 v) {\r\n  return fract(sin(dot(v.xy ,vec2(12.9898,78.233))) * 43758.5453);\r\n}\r\nvec2 Rotate(vec2 v, float a) {\r\n  mat2 rm = mat2(cos(a), -sin(a),\r\n                 sin(a), cos(a));\r\n  return rm*v;\r\n}\r\nfloat CosInterpolation(float x) {\r\n  return -cos(x*PI)/2.+.5;\r\n}\r\nvec4 transition(vec2 uv) {\r\n  vec2 p = uv.xy / vec2(1.0).xy - .5;\r\n  vec2 rp = p;\r\n  float rpr = (progress*2.-1.);\r\n  float z = -(rpr*rpr*2.) + 3.;\r\n  float az = abs(z);\r\n  rp *= az;\r\n  rp += mix(vec2(.5, .5), vec2(float(endx) + .5, float(endy) + .5), POW2(CosInterpolation(progress)));\r\n  vec2 mrp = mod(rp, 1.);\r\n  vec2 crp = rp;\r\n  bool onEnd = int(floor(crp.x))==endx&&int(floor(crp.y))==endy;\r\n  if(!onEnd) {\r\n    float ang = float(int(Rand(floor(crp))*4.))*.5*PI;\r\n    mrp = vec2(.5) + Rotate(mrp-vec2(.5), ang);\r\n  }\r\n  if(onEnd || Rand(floor(crp))>.5) {\r\n    return getToColor(mrp);\r\n  } else {\r\n    return getFromColor(mrp);\r\n  }\r\n}\r\n", "license": "MIT", "author": "Xaychru", "createdAt": "", "updatedAt": "" }, { "name": "mosaic_transition", "paramsTypes": { "mosaicNum": "float" }, "defaultParams": { "mosaicNum": 10 }, "glsl": "// Author: YueDev\r\n// License: MIT\r\n\r\nuniform float mosaicNum;// = 10.0\r\n\r\nvec2 getMosaicUV(vec2 uv) {\r\n  float mosaicWidth = 2.0 / mosaicNum * min(progress, 1.0 - progress);\r\n  float mX = floor(uv.x / mosaicWidth) + 0.5;\r\n  float mY = floor(uv.y / mosaicWidth) + 0.5;\r\n  return vec2(mX * mosaicWidth, mY * mosaicWidth);\r\n}\r\n\r\nvec4 transition (vec2 uv) {\r\n  vec2 mosaicUV = min(progress, 1.0 - progress) == 0.0 ? uv : getMosaicUV(uv);\r\n  return mix(getFromColor(mosaicUV), getToColor(mosaicUV), progress * progress);\r\n}\r\n", "author": "YueDev", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "multiply_blend", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author: Fernando Kuteken\r\n// License: MIT\r\n\r\nvec4 blend(vec4 a, vec4 b) {\r\n  return a * b;\r\n}\r\n\r\nvec4 transition (vec2 uv) {\r\n  \r\n  vec4 blended = blend(getFromColor(uv), getToColor(uv));\r\n  \r\n  if (progress < 0.5)\r\n    return mix(getFromColor(uv), blended, 2.0 * progress);\r\n  else\r\n    return mix(blended, getToColor(uv), 2.0 * progress - 1.0);\r\n}\r\n\r\n", "author": "Fernando Kuteken", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "Overexposure", "paramsTypes": { "strength": "float" }, "defaultParams": { "strength": 0.6 }, "glsl": "// Author: Ben Zhang\r\n// License: MIT\r\n\r\nuniform float strength; //= 0.6;\r\nconst float PI = 3.141592653589793;\r\n\r\nvec4 transition (vec2 uv) {\r\n  vec4 from = getFromColor(uv);\r\n  vec4 to = getToColor(uv);\r\n\r\n  // Multipliers\r\n  float from_m = 1.0 - progress + sin(PI * progress) * strength;\r\n  float to_m = progress + sin(PI * progress) * strength;\r\n  \r\n  return vec4(\r\n    from.r * from.a * from_m + to.r * to.a * to_m,\r\n    from.g * from.a * from_m + to.g * to.a * to_m,\r\n    from.b * from.a * from_m + to.b * to.a * to_m,\r\n    mix(from.a, to.a, progress)\r\n  );\r\n}\r\n", "author": "Ben Zhang", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "perlin", "paramsTypes": { "scale": "float", "smoothness": "float", "seed": "float" }, "defaultParams": { "scale": 4, "smoothness": 0.01, "seed": 12.9898 }, "glsl": "// Author: Rich Harris\r\n// License: MIT\r\n\r\n#ifdef GL_ES\r\nprecision highp float;\r\n#endif\r\n\r\nuniform float scale; // = 4.0\r\nuniform float smoothness; // = 0.01\r\n\r\nuniform float seed; // = 12.9898\r\n\r\n// http://byteblacksmith.com/improvements-to-the-canonical-one-liner-glsl-rand-for-opengl-es-2-0/\r\nfloat random(vec2 co)\r\n{\r\n    float a = seed;\r\n    float b = 78.233;\r\n    float c = 43758.5453;\r\n    float dt= dot(co.xy ,vec2(a,b));\r\n    float sn= mod(dt,3.14);\r\n    return fract(sin(sn) * c);\r\n}\r\n\r\n// 2D Noise based on Morgan McGuire @morgan3d\r\n// https://www.shadertoy.com/view/4dS3Wd\r\nfloat noise (in vec2 st) {\r\n    vec2 i = floor(st);\r\n    vec2 f = fract(st);\r\n\r\n    // Four corners in 2D of a tile\r\n    float a = random(i);\r\n    float b = random(i + vec2(1.0, 0.0));\r\n    float c = random(i + vec2(0.0, 1.0));\r\n    float d = random(i + vec2(1.0, 1.0));\r\n\r\n    // Smooth Interpolation\r\n\r\n    // Cubic Hermine Curve.  Same as SmoothStep()\r\n    vec2 u = f*f*(3.0-2.0*f);\r\n    // u = smoothstep(0.,1.,f);\r\n\r\n    // Mix 4 coorners porcentages\r\n    return mix(a, b, u.x) +\r\n            (c - a)* u.y * (1.0 - u.x) +\r\n            (d - b) * u.x * u.y;\r\n}\r\n\r\nvec4 transition (vec2 uv) {\r\n  vec4 from = getFromColor(uv);\r\n  vec4 to = getToColor(uv);\r\n  float n = noise(uv * scale);\r\n\r\n  float p = mix(-smoothness, 1.0 + smoothness, progress);\r\n  float lower = p - smoothness;\r\n  float higher = p + smoothness;\r\n\r\n  float q = smoothstep(lower, higher, n);\r\n\r\n  return mix(\r\n    from,\r\n    to,\r\n    1.0 - q\r\n  );\r\n}\r\n", "author": "Rich Harris", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "pinwheel", "paramsTypes": { "speed": "float" }, "defaultParams": { "speed": 2 }, "glsl": "// Author: Mr Speaker\r\n// License: MIT\r\n\r\nuniform float speed; // = 2.0;\r\n\r\nvec4 transition(vec2 uv) {\r\n  \r\n  vec2 p = uv.xy / vec2(1.0).xy;\r\n  \r\n  float circPos = atan(p.y - 0.5, p.x - 0.5) + progress * speed;\r\n  float modPos = mod(circPos, 3.1415 / 4.);\r\n  float signed = sign(progress - modPos);\r\n  \r\n  return mix(getToColor(p), getFromColor(p), step(signed, 0.5));\r\n  \r\n}\r\n", "author": "Mr Speaker", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "pixelize", "paramsTypes": { "squaresMin": "ivec2", "steps": "int" }, "defaultParams": { "squaresMin": [20, 20], "steps": 50 }, "glsl": "// Author: gre\r\n// License: MIT\r\n// forked from https://gist.github.com/benraziel/c528607361d90a072e98\r\n\r\n// minimum number of squares (when the effect is at its higher level)\r\nuniform ivec2 squaresMin; // = ivec2(20)\r\n// zero disable the stepping\r\nuniform int steps; // = 50\r\n\r\nfloat d = min(progress, 1.0 - progress);\r\nfloat dist = steps>0 ? ceil(d * float(steps)) / float(steps) : d;\r\nvec2 squareSize = 2.0 * dist / vec2(squaresMin);\r\n\r\nvec4 transition(vec2 uv) {\r\n  vec2 p = dist>0.0 ? (floor(uv / squareSize) + 0.5) * squareSize : uv;\r\n  return mix(getFromColor(p), getToColor(p), progress);\r\n}\r\n", "author": "gre", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "polar_function", "paramsTypes": { "segments": "int" }, "defaultParams": { "segments": 5 }, "glsl": "// Author: Fernando Kuteken\r\n// License: MIT\r\n\r\n#define PI 3.14159265359\r\n\r\nuniform int segments; // = 5;\r\n\r\nvec4 transition (vec2 uv) {\r\n  \r\n  float angle = atan(uv.y - 0.5, uv.x - 0.5) - 0.5 * PI;\r\n  float normalized = (angle + 1.5 * PI) * (2.0 * PI);\r\n  \r\n  float radius = (cos(float(segments) * angle) + 4.0) / 4.0;\r\n  float difference = length(uv - vec2(0.5, 0.5));\r\n  \r\n  if (difference > radius * progress)\r\n    return getFromColor(uv);\r\n  else\r\n    return getToColor(uv);\r\n}\r\n", "author": "Fernando Kuteken", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "PolkaDotsCurtain", "paramsTypes": { "dots": "float", "center": "vec2" }, "defaultParams": { "dots": 20, "center": [0, 0] }, "glsl": "// author: bobylito\r\n// license: MIT\r\nconst float SQRT_2 = 1.414213562373;\r\nuniform float dots;// = 20.0;\r\nuniform vec2 center;// = vec2(0, 0);\r\n\r\nvec4 transition(vec2 uv) {\r\n  bool nextImage = distance(fract(uv * dots), vec2(0.5, 0.5)) < ( progress / distance(uv, center));\r\n  return nextImage ? getToColor(uv) : getFromColor(uv);\r\n}\r\n", "author": "bobylito", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "powerKaleido", "paramsTypes": { "scale": "float", "z": "float", "speed": "float" }, "defaultParams": { "scale": 2, "z": 1.5, "speed": 5 }, "glsl": "// Name: Power Kaleido\r\n// Author: Boundless\r\n// License: MIT\r\n#define PI 3.14159265358979\r\nconst float rad = 120.; // change this value to get different mirror effects\r\nconst float deg = rad / 180. * PI;\r\nuniform float scale; // = 2.0;\r\nuniform float z; // = 1.5;\r\nfloat dist = scale / 10.;\r\nuniform float speed; // = 5.;\r\nvec2 refl(vec2 p,vec2 o,vec2 n)\r\n{\r\n	return 2.0*o+2.0*n*dot(p-o,n)-p;\r\n}\r\n\r\nvec2 rot(vec2 p, vec2 o, float a)\r\n{\r\n    float s = sin(a);\r\n    float c = cos(a);\r\n	return o + mat2(c, -s, s, c) * (p - o);\r\n}\r\n\r\nvec4 mainImage(vec2 uv)\r\n{\r\n  vec2 uv0 = uv;\r\n	uv -= 0.5;\r\n  uv.x *= ratio;\r\n  uv *= z;\r\n  uv = rot(uv, vec2(0.0), progress*speed);\r\n  // uv.x = fract(uv.x/l/3.0)*l*3.0;\r\n	float theta = progress*6.+PI/.5;\r\n	for(int iter = 0; iter < 10; iter++) {\r\n    for(float i = 0.; i < 2. * PI; i+=deg) {\r\n	    float ts = sign(asin(cos(i))) == 1.0 ? 1.0 : 0.0;\r\n      if(((ts == 1.0) && (uv.y-dist*cos(i) > tan(i)*(uv.x+dist*+sin(i)))) || ((ts == 0.0) && (uv.y-dist*cos(i) < tan(i)*(uv.x+dist*+sin(i))))) {\r\n        uv = refl(vec2(uv.x+sin(i)*dist*2.,uv.y-cos(i)*dist*2.), vec2(0.,0.), vec2(cos(i),sin(i)));\r\n      }\r\n    }\r\n  }\r\n  uv += 0.5;\r\n  uv = rot(uv, vec2(0.5), progress*-speed);\r\n  uv -= 0.5;\r\n  uv.x /= ratio;\r\n  uv += 0.5;\r\n  uv = 2.*abs(uv/2.-floor(uv/2.+0.5));\r\n  vec2 uvMix = mix(uv,uv0,cos(progress*PI*2.)/2.+0.5);\r\n  vec4 color = mix(getFromColor(uvMix),getToColor(uvMix),cos((progress-1.)*PI)/2.+0.5);\r\n	return color;\r\n    \r\n}\r\nvec4 transition (vec2 uv) {\r\n  vec4 color = mainImage(uv);\r\n  return color;\r\n}\r\n", "author": "Boundless", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "Radial", "paramsTypes": { "smoothness": "float" }, "defaultParams": { "smoothness": 1 }, "glsl": "// License: MIT\r\n// Author: Xaychru\r\n// ported by gre from https://gist.github.com/Xaychru/ce1d48f0ce00bb379750\r\n\r\nuniform float smoothness; // = 1.0\r\n\r\nconst float PI = 3.141592653589;\r\n\r\nvec4 transition(vec2 p) {\r\n  vec2 rp = p*2.-1.;\r\n  return mix(\r\n    getToColor(p),\r\n    getFromColor(p),\r\n    smoothstep(0., smoothness, atan(rp.y,rp.x) - (progress-.5) * PI * 2.5)\r\n  );\r\n}\r\n", "license": "MIT", "author": "Xaychru", "createdAt": "", "updatedAt": "" }, { "name": "randomNoisex", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author:towrabbit\r\n// License: MIT\r\n\r\nfloat random (vec2 st) {\r\n    return fract(sin(dot(st.xy,vec2(12.9898,78.233)))*43758.5453123);\r\n}\r\nvec4 transition (vec2 uv) {\r\n  vec4 leftSide = getFromColor(uv);\r\n  vec2 uv1 = uv;\r\n  vec2 uv2 = uv;\r\n  float uvz = floor(random(uv1)+progress);\r\n  vec4 rightSide = getToColor(uv);\r\n  float p = progress*2.0;\r\n  return mix(leftSide,rightSide,uvz);\r\n  return leftSide * ceil(uv.x*2.-p) + rightSide * ceil(-uv.x*2.+p);\r\n}\r\n", "author": "towrabbit", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "randomsquares", "paramsTypes": { "size": "ivec2", "smoothness": "float" }, "defaultParams": { "size": [10, 10], "smoothness": 0.5 }, "glsl": "// Author: gre\r\n// License: MIT\r\n\r\nuniform ivec2 size; // = ivec2(10, 10)\r\nuniform float smoothness; // = 0.5\r\n \r\nfloat rand (vec2 co) {\r\n  return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453);\r\n}\r\n\r\nvec4 transition(vec2 p) {\r\n  float r = rand(floor(vec2(size) * p));\r\n  float m = smoothstep(0.0, -smoothness, r - (progress * (1.0 + smoothness)));\r\n  return mix(getFromColor(p), getToColor(p), m);\r\n}\r\n", "author": "gre", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "Rectangle", "paramsTypes": { "bgcolor": "vec4" }, "defaultParams": { "bgcolor": [0, 0, 0, 1] }, "glsl": "// Author: martiniti\r\n// License: MIT\r\n\r\nuniform vec4 bgcolor; // = vec4(0.0, 0.0, 0.0, 1.0)\r\n\r\nfloat s = pow(2.0 * abs(progress - 0.5), 3.0);\r\n\r\nvec4 transition(vec2 p) {\r\n  \r\n   vec2 sq = p.xy / vec2(1.0).xy;\r\n   \r\n    // bottom-left\r\n    vec2 bl = step(vec2(abs(1. - 2.*progress)), sq + .25);\r\n    float dist = bl.x * bl.y;\r\n\r\n    // top-right\r\n    vec2 tr = step(vec2(abs(1. - 2.*progress)), 1.25-sq);\r\n    dist *= 1. * tr.x * tr.y;\r\n  \r\n  return mix(\r\n    progress < 0.5 ? getFromColor(p) : getToColor(p),\r\n    bgcolor,\r\n    step(s, dist)\r\n  );\r\n  \r\n}\r\n", "author": "martiniti", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "RectangleCrop", "paramsTypes": { "bgcolor": "vec4" }, "defaultParams": { "bgcolor": [0, 0, 0, 1] }, "glsl": "// License: MIT\r\n// Author: martiniti\r\n\r\nuniform vec4 bgcolor; // = vec4(0.0, 0.0, 0.0, 1.0)\r\n\r\nvec4 transition(vec2 uv) {\r\n  \r\n  float s = pow(2.0 * abs(progress - 0.5), 3.0);\r\n              \r\n  vec2 q = uv.xy / vec2(1.0).xy;\r\n  \r\n  // bottom-left\r\n  vec2 bl = step(vec2(1.0 - 2.0*abs(progress - 0.5)), q + 0.25);\r\n  \r\n  // top-right\r\n  vec2 tr = step(vec2(1.0 - 2.0*abs(progress - 0.5)), 1.25 - q);\r\n  \r\n  float dist = length(1.0 - bl.x * bl.y * tr.x * tr.y);\r\n  \r\n  return mix(\r\n    progress < 0.5 ? getFromColor(uv) : getToColor(uv),\r\n    bgcolor,\r\n    step(s, dist)\r\n  );\r\n  \r\n}\r\n", "license": "MIT", "author": "martiniti", "createdAt": "", "updatedAt": "" }, { "name": "ripple", "paramsTypes": { "amplitude": "float", "speed": "float" }, "defaultParams": { "amplitude": 100, "speed": 50 }, "glsl": "// Author: gre\r\n// License: MIT\r\nuniform float amplitude; // = 100.0\r\nuniform float speed; // = 50.0\r\n\r\nvec4 transition (vec2 uv) {\r\n  vec2 dir = uv - vec2(.5);\r\n  float dist = length(dir);\r\n  vec2 offset = dir * (sin(progress * dist * amplitude - progress * speed) + .5) / 30.;\r\n  return mix(\r\n    getFromColor(uv + offset),\r\n    getToColor(uv),\r\n    smoothstep(0.2, 1.0, progress)\r\n  );\r\n}\r\n", "author": "gre", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "Rolls", "paramsTypes": { "type": "int", "RotDown": "bool" }, "defaultParams": { "type": 0, "RotDown": false }, "glsl": "// Author: Mark Craig\r\n// mrmcsoftware on github and youtube ( http://www.youtube.com/MrMcSoftware )\r\n// License: MIT\r\n\r\n// Rolls Transition by Mark Craig (Copyright © 2022)\r\n\r\nuniform int type; // = 0\r\nuniform bool RotDown; // = false\r\n// type (0-3): Rotate/Roll from which corner\r\n// RotDown: if true rotate old image down, otherwise rotate old image up\r\n\r\n#define M_PI 3.14159265358979323846\r\n\r\nvec4 transition(vec2 uv)\r\n{\r\nfloat theta, c1, s1;\r\nvec2 iResolution = vec2(ratio, 1.0);\r\nvec2 uvi;\r\n// I used if/else instead of switch in case it's an old GPU\r\nif (type == 0) { theta = (RotDown ? M_PI : -M_PI) / 2.0 * progress; uvi.x = 1.0 - uv.x; uvi.y = uv.y; }\r\nelse if (type == 1) { theta = (RotDown ? M_PI : -M_PI) / 2.0 * progress; uvi = uv; }\r\nelse if (type == 2) { theta = (RotDown ? -M_PI : M_PI) / 2.0 * progress; uvi.x = uv.x; uvi.y = 1.0 - uv.y; }\r\nelse if (type == 3) { theta = (RotDown ? -M_PI : M_PI) / 2.0 * progress; uvi = 1.0 - uv; }\r\nc1 = cos(theta); s1 = sin(theta);\r\nvec2 uv2;\r\nuv2.x = (uvi.x * iResolution.x * c1 - uvi.y * iResolution.y * s1);\r\nuv2.y = (uvi.x * iResolution.x * s1 + uvi.y * iResolution.y * c1);\r\nif ((uv2.x >= 0.0) && (uv2.x <= iResolution.x) && (uv2.y >= 0.0) && (uv2.y <= iResolution.y))\r\n	{\r\n	uv2 /= iResolution;\r\n	if (type == 0) { uv2.x = 1.0 - uv2.x; }\r\n	else if (type == 2) { uv2.y = 1.0 - uv2.y; }\r\n	else if (type == 3) { uv2 = 1.0 - uv2; }\r\n	return(getFromColor(uv2));\r\n	}\r\nreturn(getToColor(uv));\r\n}\r\n", "author": "Mark Craig", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "RotateScaleVanish", "paramsTypes": { "FadeInSecond": "bool", "ReverseEffect": "bool", "ReverseRotation": "bool" }, "defaultParams": { "FadeInSecond": true, "ReverseEffect": false, "ReverseRotation": false }, "glsl": "// Author: Mark Craig\r\n// mrmcsoftware on github and youtube ( http://www.youtube.com/MrMcSoftware )\r\n// License: MIT\r\n\r\n// RotateScaleVanish Transition by Mark Craig (Copyright © 2022)\r\n\r\nuniform bool FadeInSecond; // = true\r\nuniform bool ReverseEffect; // = false\r\nuniform bool ReverseRotation; // = false\r\n\r\n#define M_PI 3.14159265358979323846\r\n#define _TWOPI 6.283185307179586476925286766559\r\n\r\nvec4 transition(vec2 uv)\r\n{\r\nvec2 iResolution = vec2(ratio, 1.0);\r\nfloat t = ReverseEffect ? 1.0 - progress : progress;\r\nfloat theta = ReverseRotation ? _TWOPI * t : -_TWOPI * t;\r\nfloat c1 = cos(theta);\r\nfloat s1 = sin(theta);\r\nfloat rad = max(0.00001, 1.0 - t);\r\nfloat xc1 = (uv.x - 0.5) * iResolution.x;\r\nfloat yc1 = (uv.y - 0.5) * iResolution.y;\r\nfloat xc2 = (xc1 * c1 - yc1 * s1) / rad;\r\nfloat yc2 = (xc1 * s1 + yc1 * c1) / rad;\r\nvec2 uv2 = vec2(xc2 + iResolution.x / 2.0, yc2 + iResolution.y / 2.0);\r\nvec4 col3;\r\nvec4 ColorTo = ReverseEffect ? getFromColor(uv) : getToColor(uv);\r\nif ((uv2.x >= 0.0) && (uv2.x <= iResolution.x) && (uv2.y >= 0.0) && (uv2.y <= iResolution.y))\r\n	{\r\n	uv2 /= iResolution;\r\n	col3 = ReverseEffect ? getToColor(uv2) : getFromColor(uv2);\r\n	}\r\nelse { col3 = FadeInSecond ? vec4(0.0, 0.0, 0.0, 1.0) : ColorTo; }\r\nreturn((1.0 - t) * col3 + t * ColorTo); // could have used mix\r\n}\r\n", "author": "Mark Craig", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "rotateTransition", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author: haiyoucuv\r\n// License: MIT\r\n\r\n#define PI 3.1415926\r\n\r\nvec2 rotate2D(in vec2 uv, in float angle){\r\n  \r\n  return uv * mat2(cos(angle), -sin(angle), sin(angle), cos(angle));\r\n}\r\nvec4 transition (vec2 uv) {\r\n  \r\n  vec2 p = fract(rotate2D(uv - 0.5, progress * PI * 2.0) + 0.5);\r\n\r\n  return mix(\r\n    getFromColor(p),\r\n    getToColor(p),\r\n    progress\r\n  );\r\n}\r\n", "author": "haiyoucuv", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "rotate_scale_fade", "paramsTypes": { "center": "vec2", "rotations": "float", "scale": "float", "backColor": "vec4" }, "defaultParams": { "center": [0.5, 0.5], "rotations": 1, "scale": 8, "backColor": [0.15, 0.15, 0.15, 1] }, "glsl": "// Author: Fernando Kuteken\r\n// License: MIT\r\n\r\n#define PI 3.14159265359\r\n\r\nuniform vec2 center; // = vec2(0.5, 0.5);\r\nuniform float rotations; // = 1;\r\nuniform float scale; // = 8;\r\nuniform vec4 backColor; // = vec4(0.15, 0.15, 0.15, 1.0);\r\n\r\nvec4 transition (vec2 uv) {\r\n  \r\n  vec2 difference = uv - center;\r\n  vec2 dir = normalize(difference);\r\n  float dist = length(difference);\r\n  \r\n  float angle = 2.0 * PI * rotations * progress;\r\n  \r\n  float c = cos(angle);\r\n  float s = sin(angle);\r\n  \r\n  float currentScale = mix(scale, 1.0, 2.0 * abs(progress - 0.5));\r\n  \r\n  vec2 rotatedDir = vec2(dir.x  * c - dir.y * s, dir.x * s + dir.y * c);\r\n  vec2 rotatedUv = center + rotatedDir * dist / currentScale;\r\n  \r\n  if (rotatedUv.x < 0.0 || rotatedUv.x > 1.0 ||\r\n      rotatedUv.y < 0.0 || rotatedUv.y > 1.0)\r\n    return backColor;\r\n    \r\n  return mix(getFromColor(rotatedUv), getToColor(rotatedUv), progress);\r\n}\r\n", "author": "Fernando Kuteken", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "scale-in", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author:haiyoucuv\r\n// License: MIT\r\n\r\nvec4 scale(in vec2 uv){\r\n    uv = 0.5 + (uv - 0.5) * progress;\r\n    return getToColor(uv);\r\n}\r\n\r\nvec4 transition (vec2 uv) {\r\n  return mix(\r\n    getFromColor(uv),\r\n    scale(uv),\r\n    progress\r\n  );\r\n}\r\n", "author": "haiyoucuv", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "SimpleZoom", "paramsTypes": { "zoom_quickness": "float" }, "defaultParams": { "zoom_quickness": 0.8 }, "glsl": "// Author: 0gust1\r\n// License: MIT\r\n\r\nuniform float zoom_quickness; // = 0.8\r\nfloat nQuick = clamp(zoom_quickness,0.2,1.0);\r\n\r\nvec2 zoom(vec2 uv, float amount) {\r\n  return 0.5 + ((uv - 0.5) * (1.0-amount));	\r\n}\r\n\r\nvec4 transition (vec2 uv) {\r\n  return mix(\r\n    getFromColor(zoom(uv, smoothstep(0.0, nQuick, progress))),\r\n    getToColor(uv),\r\n   smoothstep(nQuick-0.2, 1.0, progress)\r\n  );\r\n}", "author": "0gust1", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "SimpleZoomOut", "paramsTypes": { "zoom_quickness": "float", "fade": "bool" }, "defaultParams": { "zoom_quickness": 0.8, "fade": true }, "glsl": "// Author: Tianshuo\r\n// License: MIT\r\n\r\n\r\nuniform float zoom_quickness; // = 0.8\r\nuniform bool fade; // = true\r\nfloat nQuick = clamp(zoom_quickness,0.2,1.0);\r\n\r\nvec2 zoom(vec2 uv, float amount) {\r\n  return 0.5 + ((uv - 0.5) * (1.0-amount));	\r\n}\r\n\r\nvec4 transition (vec2 uv) {\r\n  return mix(\r\n    getFromColor(uv),\r\n    getToColor(zoom(uv,1.-smoothstep(1.-nQuick, 1., progress))),\r\n   fade?smoothstep(1.0-nQuick, 1., progress):(progress<1.0-nQuick?0.0:1.0)\r\n  );\r\n}\r\n", "author": "Tianshuo", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "slide-over", "paramsTypes": { "direction": "vec2" }, "defaultParams": { "direction": [0, 1] }, "glsl": "// Author: LYS\r\n// License: MIT\r\n\r\nuniform vec2 direction; // = vec2(0.0, 1.0)\r\n\r\nfloat qinticOut(float t) {\r\n  return 1.0 - (pow(1.0 - t, 5.0));\r\n}\r\n\r\nvec4 transition (vec2 uv) {\r\n  vec2 p = uv + qinticOut(progress) * sign(direction);\r\n  vec2 f = fract(p);\r\n  vec2 i = uv + progress * sign(direction);\r\n  vec2 o = fract(i);\r\n  return mix(\r\n    getToColor(f),\r\n    getFromColor(o),\r\n    step(0.0, p.y) * step(p.y, 1.0) * step(0.0, p.x) * step(p.x, 1.0)\r\n  );\r\n}\r\n", "author": "LYS", "license": "MIT", "createdAt": "Fri, 16 Jun 2023 10:41:48 +0800", "updatedAt": "Fri, 16 Jun 2023 10:41:48 +0800" }, { "name": "Slides", "paramsTypes": { "type": "int", "In": "bool" }, "defaultParams": { "type": 0, "In": false }, "glsl": "// Author: Mark Craig\r\n// mrmcsoftware on github and youtube ( http://www.youtube.com/MrMcSoftware )\r\n// License: MIT\r\n\r\n// Slides Transition by Mark Craig (Copyright © 2022)\r\n\r\nuniform int type; // = 0\r\nuniform bool In; // = false\r\n// type: slide to/from which edge, which corner, or center\r\n// In: if true slide new image in, otherwise slide old image out\r\n\r\n#define rad2 rad / 2.0\r\n\r\nvec4 transition(vec2 uv)\r\n{\r\nvec2 uv0 = uv;\r\nfloat rad = In ? progress : 1.0 - progress;\r\nfloat xc1, yc1;\r\n// I used if/else instead of switch in case it's an old GPU\r\nif (type == 0) { xc1 = .5 - rad2; yc1 = 0.0; }\r\nelse if (type == 1) { xc1 = 1.0 - rad; yc1 = .5 - rad2; }\r\nelse if (type == 2) { xc1 = .5 - rad2; yc1 = 1.0 - rad; }\r\nelse if (type == 3) { xc1 = 0.0; yc1 = .5 - rad2; }\r\nelse if (type == 4) { xc1 = 1.0 - rad; yc1 = 0.0; }\r\nelse if (type == 5) { xc1 = 1.0 - rad; yc1 = 1.0 - rad; }\r\nelse if (type == 6) { xc1 = 0.0; yc1 = 1.0 - rad; }\r\nelse if (type == 7) { xc1 = 0.0; yc1 = 0.0; }\r\nelse if (type == 8) { xc1 = .5 - rad2; yc1 = .5 - rad2; }\r\nuv.y = 1.0 - uv.y;\r\nvec2 uv2;\r\nif ((uv.x >= xc1) && (uv.x <= xc1 + rad) && (uv.y >= yc1) && (uv.y <= yc1 + rad))\r\n	{\r\n	uv2 = vec2((uv.x - xc1) / rad, 1.0 - (uv.y - yc1) / rad);\r\n	return(In ? getToColor(uv2) : getFromColor(uv2));\r\n	}\r\nreturn(In ? getFromColor(uv0) : getToColor(uv0));\r\n}\r\n", "author": "Mark Craig", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "squareswire", "paramsTypes": { "squares": "ivec2", "direction": "vec2", "smoothness": "float" }, "defaultParams": { "squares": [10, 10], "direction": [1, -0.5], "smoothness": 1.6 }, "glsl": "// Author: gre\r\n// License: MIT\r\n \r\nuniform ivec2 squares;// = ivec2(10,10)\r\nuniform vec2 direction;// = vec2(1.0, -0.5)\r\nuniform float smoothness; // = 1.6\r\n\r\nconst vec2 center = vec2(0.5, 0.5);\r\nvec4 transition (vec2 p) {\r\n  vec2 v = normalize(direction);\r\n  v /= abs(v.x)+abs(v.y);\r\n  float d = v.x * center.x + v.y * center.y;\r\n  float offset = smoothness;\r\n  float pr = smoothstep(-offset, 0.0, v.x * p.x + v.y * p.y - (d-0.5+progress*(1.+offset)));\r\n  vec2 squarep = fract(p*vec2(squares));\r\n  vec2 squaremin = vec2(pr/2.0);\r\n  vec2 squaremax = vec2(1.0 - pr/2.0);\r\n  float a = (1.0 - step(progress, 0.0)) * step(squaremin.x, squarep.x) * step(squaremin.y, squarep.y) * step(squarep.x, squaremax.x) * step(squarep.y, squaremax.y);\r\n  return mix(getFromColor(p), getToColor(p), a);\r\n}\r\n", "author": "gre", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "squeeze", "paramsTypes": { "colorSeparation": "float" }, "defaultParams": { "colorSeparation": 0.04 }, "glsl": "// Author: gre\r\n// License: MIT\r\n \r\nuniform float colorSeparation; // = 0.04\r\n \r\nvec4 transition (vec2 uv) {\r\n  float y = 0.5 + (uv.y-0.5) / (1.0-progress);\r\n  if (y < 0.0 || y > 1.0) {\r\n     return getToColor(uv);\r\n  }\r\n  else {\r\n    vec2 fp = vec2(uv.x, y);\r\n    vec2 off = progress * vec2(0.0, colorSeparation);\r\n    vec4 c = getFromColor(fp);\r\n    vec4 cn = getFromColor(fp - off);\r\n    vec4 cp = getFromColor(fp + off);\r\n    return vec4(cn.r, c.g, cp.b, c.a);\r\n  }\r\n}\r\n", "author": "gre", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "StaticFade", "paramsTypes": { "n_noise_pixels": "float", "static_luminosity": "float" }, "defaultParams": { "n_noise_pixels": 200, "static_luminosity": 0.8 }, "glsl": "// Author: Ben Lucas\r\n// License: MIT\r\n\r\nuniform float n_noise_pixels ; // = 200.0\r\nuniform float static_luminosity ; // = 0.8\r\n\r\nfloat rnd (vec2 st) {\r\n    return fract(sin(dot(st.xy,\r\n                         vec2(10.5302340293,70.23492931)))*\r\n        12345.5453123);\r\n}\r\n\r\nvec4 staticNoise (vec2 st, float offset, float luminosity) {\r\n  float staticR = luminosity * rnd(st * vec2(offset * 2.0, offset * 3.0));\r\n  float staticG = luminosity * rnd(st * vec2(offset * 3.0, offset * 5.0));\r\n  float staticB = luminosity * rnd(st * vec2(offset * 5.0, offset * 7.0));\r\n  return vec4(staticR, staticG, staticB, 1.0);\r\n}\r\n\r\nfloat staticIntensity(float t)\r\n{\r\n  float transitionProgress = abs(2.0*(t-0.5));\r\n  float transformedThreshold =1.2*(1.0 - transitionProgress)-0.1;\r\n  return min(1.0, transformedThreshold);\r\n}\r\n  \r\nvec4 transition (vec2 uv) {\r\n\r\n  float baseMix = step(0.5, progress);\r\n  vec4 transitionMix = mix(\r\n    getFromColor(uv),\r\n    getToColor(uv),\r\n    baseMix\r\n  );\r\n  \r\n  vec2 uvStatic = floor(uv * n_noise_pixels)/n_noise_pixels;\r\n  \r\n  vec4 staticColor = staticNoise(uvStatic, progress, static_luminosity);\r\n\r\n  float staticThresh = staticIntensity(progress);\r\n  float staticMix = step(rnd(uvStatic), staticThresh);\r\n\r\n  return mix(transitionMix, staticColor, staticMix);\r\n}\r\n", "author": "Ben Lucas", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "static_wipe", "paramsTypes": { "u_transitionUpToDown": "bool", "u_max_static_span": "float" }, "defaultParams": { "u_transitionUpToDown": true, "u_max_static_span": 0.5 }, "glsl": "// Author: Ben Lucas\r\n// License: MIT\r\n\r\n#define PI 3.14159265359\r\n\r\nfloat rnd (vec2 st) {\r\n    return fract(sin(dot(st.xy,\r\n                         vec2(10,70)))*\r\n        12345.5453123);\r\n}\r\n\r\nuniform bool u_transitionUpToDown; // = true;\r\nuniform float u_max_static_span;// = 0.5;\r\n\r\nvec4 transition (vec2 uv) {\r\n  \r\n\r\n  float span = u_max_static_span*pow(sin(PI*progress),0.5);\r\n  \r\n  float transitionEdge = u_transitionUpToDown ? 1.0-uv.y : uv.y;\r\n  float mixRatio = 1.0 - step(progress, transitionEdge);\r\n\r\n  vec4 transitionMix = mix(\r\n    getFromColor(uv),\r\n    getToColor(uv),\r\n    mixRatio\r\n  );\r\n  \r\n  float noiseEnvelope = smoothstep(progress-span, progress, transitionEdge) * (1.0 - smoothstep(progress, progress + span, transitionEdge));\r\n  vec4 noise = vec4(vec3(rnd(uv*(1.0+progress))), 1.0);\r\n  \r\n\r\n  return mix(transitionMix, noise, noiseEnvelope);\r\n}\r\n", "author": "Ben Lucas", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "StereoViewer", "paramsTypes": { "zoom": "float", "corner_radius": "float" }, "defaultParams": { "zoom": 0.88, "corner_radius": 0.22 }, "glsl": `// Tunable parameters\r
// How much to zoom (out) for the effect ~ 0.5 - 1.0\r
uniform float zoom; // = 0.88\r
// Corner radius as a fraction of the image height\r
uniform float corner_radius;  // = 0.22\r
\r
// author: Ted Schundler\r
// license: BSD 2 Clause\r
// Free for use and modification by anyone with credit\r
\r
// Copyright (c) 2016, Theodore K Schundler\r
// All rights reserved.\r
\r
// Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:\r
\r
// 1. Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.\r
\r
// 2. Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.\r
\r
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\r
\r
///////////////////////////////////////////////////////////////////////////////\r
// Stereo Viewer Toy Transition                                              //\r
//                                                                           //\r
// Inspired by ViewMaster / Image3D image viewer devices.                    //\r
// This effect is similar to what you see when you press the device's lever. //\r
// There is a quick zoom in / out to make the transition 'valid' for GLSL.io //\r
///////////////////////////////////////////////////////////////////////////////\r
\r
const vec4 black = vec4(0.0, 0.0, 0.0, 1.0);\r
const vec2 c00 = vec2(0.0, 0.0); // the four corner points\r
const vec2 c01 = vec2(0.0, 1.0);\r
const vec2 c11 = vec2(1.0, 1.0);\r
const vec2 c10 = vec2(1.0, 0.0);\r
\r
// Check if a point is within a given corner\r
bool in_corner(vec2 p, vec2 corner, vec2 radius) {\r
  // determine the direction we want to be filled\r
  vec2 axis = (c11 - corner) - corner;\r
\r
  // warp the point so we are always testing the bottom left point with the\r
  // circle centered on the origin\r
  p = p - (corner + axis * radius);\r
  p *= axis / radius;\r
  return (p.x > 0.0 && p.y > -1.0) || (p.y > 0.0 && p.x > -1.0) || dot(p, p) < 1.0;\r
}\r
\r
// Check all four corners\r
// return a float for v2 for anti-aliasing?\r
bool test_rounded_mask(vec2 p, vec2 corner_size) {\r
  return\r
      in_corner(p, c00, corner_size) &&\r
      in_corner(p, c01, corner_size) &&\r
      in_corner(p, c10, corner_size) &&\r
      in_corner(p, c11, corner_size);\r
}\r
\r
// Screen blend mode - https://en.wikipedia.org/wiki/Blend_modes\r
// This more closely approximates what you see than linear blending\r
vec4 screen(vec4 a, vec4 b) {\r
  return 1.0 - (1.0 - a) * (1.0 -b);\r
}\r
\r
// Given RGBA, find a value that when screened with itself\r
// will yield the original value.\r
vec4 unscreen(vec4 c) {\r
  return 1.0 - sqrt(1.0 - c);\r
}\r
\r
// Grab a pixel, only if it isn't masked out by the rounded corners\r
vec4 sample_with_corners_from(vec2 p, vec2 corner_size) {\r
  p = (p - 0.5) / zoom + 0.5;\r
  if (!test_rounded_mask(p, corner_size)) {\r
    return black;\r
  }\r
  return unscreen(getFromColor(p));\r
}\r
\r
vec4 sample_with_corners_to(vec2 p, vec2 corner_size) {\r
  p = (p - 0.5) / zoom + 0.5;\r
  if (!test_rounded_mask(p, corner_size)) {\r
    return black;\r
  }\r
  return unscreen(getToColor(p));\r
}\r
\r
// special sampling used when zooming - extra zoom parameter and don't unscreen\r
vec4 simple_sample_with_corners_from(vec2 p, vec2 corner_size, float zoom_amt) {\r
  p = (p - 0.5) / (1.0 - zoom_amt + zoom * zoom_amt) + 0.5;\r
  if (!test_rounded_mask(p, corner_size)) {\r
    return black;\r
  }\r
  return getFromColor(p);\r
}\r
\r
vec4 simple_sample_with_corners_to(vec2 p, vec2 corner_size, float zoom_amt) {\r
  p = (p - 0.5) / (1.0 - zoom_amt + zoom * zoom_amt) + 0.5;\r
  if (!test_rounded_mask(p, corner_size)) {\r
    return black;\r
  }\r
  return getToColor(p);\r
}\r
\r
// Basic 2D affine transform matrix helpers\r
// These really shouldn't be used in a fragment shader - I should work out the\r
// the math for a translate & rotate function as a pair of dot products instead\r
\r
mat3 rotate2d(float angle, float ratio) {\r
  float s = sin(angle);\r
  float c = cos(angle);\r
  return mat3(\r
    c, s ,0.0,\r
    -s, c, 0.0,\r
    0.0, 0.0, 1.0);\r
}\r
\r
mat3 translate2d(float x, float y) {\r
  return mat3(\r
    1.0, 0.0, 0,\r
    0.0, 1.0, 0,\r
    -x, -y, 1.0);\r
}\r
\r
mat3 scale2d(float x, float y) {\r
  return mat3(\r
    x, 0.0, 0,\r
    0.0, y, 0,\r
    0, 0, 1.0);\r
}\r
\r
// Split an image and rotate one up and one down along off screen pivot points\r
vec4 get_cross_rotated(vec3 p3, float angle, vec2 corner_size, float ratio) {\r
  angle = angle * angle; // easing\r
  angle /= 2.4; // works out to be a good number of radians\r
\r
  mat3 center_and_scale = translate2d(-0.5, -0.5) * scale2d(1.0, ratio);\r
  mat3 unscale_and_uncenter = scale2d(1.0, 1.0/ratio) * translate2d(0.5,0.5);\r
  mat3 slide_left = translate2d(-2.0,0.0);\r
  mat3 slide_right = translate2d(2.0,0.0);\r
  mat3 rotate = rotate2d(angle, ratio);\r
\r
  mat3 op_a = center_and_scale * slide_right * rotate * slide_left * unscale_and_uncenter;\r
  mat3 op_b = center_and_scale * slide_left * rotate * slide_right * unscale_and_uncenter;\r
\r
  vec4 a = sample_with_corners_from((op_a * p3).xy, corner_size);\r
  vec4 b = sample_with_corners_from((op_b * p3).xy, corner_size);\r
\r
  return screen(a, b);\r
}\r
\r
// Image stays put, but this time move two masks\r
vec4 get_cross_masked(vec3 p3, float angle, vec2 corner_size, float ratio) {\r
  angle = 1.0 - angle;\r
  angle = angle * angle; // easing\r
  angle /= 2.4;\r
\r
  vec4 img;\r
\r
  mat3 center_and_scale = translate2d(-0.5, -0.5) * scale2d(1.0, ratio);\r
  mat3 unscale_and_uncenter = scale2d(1.0 / zoom, 1.0 / (zoom * ratio)) * translate2d(0.5,0.5);\r
  mat3 slide_left = translate2d(-2.0,0.0);\r
  mat3 slide_right = translate2d(2.0,0.0);\r
  mat3 rotate = rotate2d(angle, ratio);\r
\r
  mat3 op_a = center_and_scale * slide_right * rotate * slide_left * unscale_and_uncenter;\r
  mat3 op_b = center_and_scale * slide_left * rotate * slide_right * unscale_and_uncenter;\r
\r
  bool mask_a = test_rounded_mask((op_a * p3).xy, corner_size);\r
  bool mask_b = test_rounded_mask((op_b * p3).xy, corner_size);\r
\r
  if (mask_a || mask_b) {\r
    img = sample_with_corners_to(p3.xy, corner_size);\r
    return screen(mask_a ? img : black, mask_b ? img : black);\r
  } else {\r
    return black;\r
  }\r
}\r
\r
vec4 transition(vec2 uv) {\r
  float a;\r
  vec2 p=uv.xy/vec2(1.0).xy;\r
  vec3 p3 = vec3(p.xy, 1.0); // for 2D matrix transforms\r
\r
  // corner is warped to represent to size after mapping to 1.0, 1.0\r
  vec2 corner_size = vec2(corner_radius / ratio, corner_radius);\r
\r
  if (progress <= 0.0) {\r
    // 0.0: start with the base frame always\r
    return getFromColor(p);\r
  } else if (progress < 0.1) {\r
    // 0.0-0.1: zoom out and add rounded corners\r
    a = progress / 0.1;\r
    return  simple_sample_with_corners_from(p, corner_size * a, a);\r
  } else if (progress < 0.48) {\r
    // 0.1-0.48: Split original image apart\r
    a = (progress - 0.1)/0.38;\r
    return get_cross_rotated(p3, a, corner_size, ratio);\r
  } else if (progress < 0.9) {\r
    // 0.48-0.52: black\r
    // 0.52 - 0.9: unmask new image\r
    return get_cross_masked(p3, (progress - 0.52)/0.38, corner_size, ratio);\r
  } else if (progress < 1.0) {\r
    // zoom out and add rounded corners\r
    a = (1.0 - progress) / 0.1;\r
    return simple_sample_with_corners_to(p, corner_size * a, a);\r
  } else {\r
    // 1.0 end with base frame\r
    return getToColor(p);\r
  }\r
}\r
`, "author": "Ted Schundler", "license": "BSD 2 Clause", "createdAt": "", "updatedAt": "" }, { "name": "swap", "paramsTypes": { "reflection": "float", "perspective": "float", "depth": "float" }, "defaultParams": { "reflection": 0.4, "perspective": 0.2, "depth": 3 }, "glsl": "// Author: gre\r\n// License: MIT\r\n// General parameters\r\nuniform float reflection; // = 0.4\r\nuniform float perspective; // = 0.2\r\nuniform float depth; // = 3.0\r\n \r\nconst vec4 black = vec4(0.0, 0.0, 0.0, 1.0);\r\nconst vec2 boundMin = vec2(0.0, 0.0);\r\nconst vec2 boundMax = vec2(1.0, 1.0);\r\n \r\nbool inBounds (vec2 p) {\r\n  return all(lessThan(boundMin, p)) && all(lessThan(p, boundMax));\r\n}\r\n \r\nvec2 project (vec2 p) {\r\n  return p * vec2(1.0, -1.2) + vec2(0.0, -0.02);\r\n}\r\n \r\nvec4 bgColor (vec2 p, vec2 pfr, vec2 pto) {\r\n  vec4 c = black;\r\n  pfr = project(pfr);\r\n  if (inBounds(pfr)) {\r\n    c += mix(black, getFromColor(pfr), reflection * mix(1.0, 0.0, pfr.y));\r\n  }\r\n  pto = project(pto);\r\n  if (inBounds(pto)) {\r\n    c += mix(black, getToColor(pto), reflection * mix(1.0, 0.0, pto.y));\r\n  }\r\n  return c;\r\n}\r\n \r\nvec4 transition(vec2 p) {\r\n  vec2 pfr, pto = vec2(-1.);\r\n \r\n  float size = mix(1.0, depth, progress);\r\n  float persp = perspective * progress;\r\n  pfr = (p + vec2(-0.0, -0.5)) * vec2(size/(1.0-perspective*progress), size/(1.0-size*persp*p.x)) + vec2(0.0, 0.5);\r\n \r\n  size = mix(1.0, depth, 1.-progress);\r\n  persp = perspective * (1.-progress);\r\n  pto = (p + vec2(-1.0, -0.5)) * vec2(size/(1.0-perspective*(1.0-progress)), size/(1.0-size*persp*(0.5-p.x))) + vec2(1.0, 0.5);\r\n\r\n  if (progress < 0.5) {\r\n    if (inBounds(pfr)) {\r\n      return getFromColor(pfr);\r\n    }\r\n    if (inBounds(pto)) {\r\n      return getToColor(pto);\r\n    }  \r\n  }\r\n  if (inBounds(pto)) {\r\n    return getToColor(pto);\r\n  }\r\n  if (inBounds(pfr)) {\r\n    return getFromColor(pfr);\r\n  }\r\n  return bgColor(p, pfr, pto);\r\n}\r\n", "author": "gre", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "Swirl", "paramsTypes": {}, "defaultParams": {}, "glsl": "// License: MIT\r\n// Author: Sergey Kosarevsky\r\n// ( http://www.linderdaum.com )\r\n// ported by gre from https://gist.github.com/corporateshark/cacfedb8cca0f5ce3f7c\r\n\r\nvec4 transition(vec2 UV)\r\n{\r\n	float Radius = 1.0;\r\n\r\n	float T = progress;\r\n\r\n	UV -= vec2( 0.5, 0.5 );\r\n\r\n	float Dist = length(UV);\r\n\r\n	if ( Dist < Radius )\r\n	{\r\n		float Percent = (Radius - Dist) / Radius;\r\n		float A = ( T <= 0.5 ) ? mix( 0.0, 1.0, T/0.5 ) : mix( 1.0, 0.0, (T-0.5)/0.5 );\r\n		float Theta = Percent * Percent * A * 8.0 * 3.14159;\r\n		float S = sin( Theta );\r\n		float C = cos( Theta );\r\n		UV = vec2( dot(UV, vec2(C, -S)), dot(UV, vec2(S, C)) );\r\n	}\r\n	UV += vec2( 0.5, 0.5 );\r\n\r\n	vec4 C0 = getFromColor(UV);\r\n	vec4 C1 = getToColor(UV);\r\n\r\n	return mix( C0, C1, T );\r\n}\r\n", "license": "MIT", "author": "Sergey Kosarevsky", "createdAt": "", "updatedAt": "" }, { "name": "tangentMotionBlur", "paramsTypes": {}, "defaultParams": {}, "glsl": "\r\n// License: MIT\r\n// Author: chenkai\r\n// ported from https://codertw.com/%E7%A8%8B%E5%BC%8F%E8%AA%9E%E8%A8%80/671116/\r\n\r\nfloat rand (vec2 co) {\r\n  return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453);\r\n}\r\n \r\n// motion blur for texture from\r\nvec4 motionBlurFrom(vec2 _st, vec2 speed) {\r\n    vec2 texCoord = _st.xy / vec2(1.0).xy;\r\n    vec3 color = vec3(0.0);\r\n    float total = 0.0;\r\n    float offset = rand(_st);\r\n    for (float t = 0.0; t <= 20.0; t++) {\r\n        float percent = (t + offset) / 20.0;\r\n        float weight = 4.0 * (percent - percent * percent);\r\n        vec2 newuv = texCoord + speed * percent;\r\n        newuv = fract(newuv);\r\n        color += getFromColor(newuv).rgb * weight;\r\n        total += weight;\r\n    }\r\n    return vec4(color / total, 1.0);\r\n}\r\n\r\n// motion blur for texture to\r\nvec4 motionBlurTo(vec2 _st, vec2 speed) {\r\n    vec2 texCoord = _st.xy / vec2(1.0).xy;\r\n    vec3 color = vec3(0.0);\r\n    float total = 0.0;\r\n    float offset = rand(_st);\r\n    for (float t = 0.0; t <= 20.0; t++) {\r\n        float percent = (t + offset) / 20.0;\r\n        float weight = 4.0 * (percent - percent * percent);\r\n        vec2 newuv = texCoord + speed * percent;\r\n        newuv = fract(newuv);\r\n        color += getToColor(newuv).rgb * weight;\r\n        total += weight;\r\n    }\r\n    return vec4(color / total, 1.0);\r\n}\r\n\r\n\r\n// bezier in gpu\r\nfloat A(float aA1, float aA2) {\r\n    return 1.0 - 3.0 * aA2 + 3.0 * aA1;\r\n}\r\nfloat B(float aA1, float aA2) {\r\n    return 3.0 * aA2 - 6.0 * aA1;\r\n}\r\nfloat C(float aA1) {\r\n    return 3.0 * aA1;\r\n}\r\nfloat GetSlope(float aT, float aA1, float aA2) {\r\n    return 3.0 * A(aA1, aA2)*aT*aT + 2.0 * B(aA1, aA2) * aT + C(aA1);\r\n}\r\nfloat CalcBezier(float aT, float aA1, float aA2) {\r\n    return ((A(aA1, aA2)*aT + B(aA1, aA2))*aT + C(aA1))*aT;\r\n}\r\nfloat GetTForX(float aX, float mX1, float mX2) {\r\n    // iteration to solve\r\n    float aGuessT = aX;\r\n    for (int i = 0; i < 4; ++i) {\r\n        float currentSlope = GetSlope(aGuessT, mX1, mX2);\r\n        if (currentSlope == 0.0) return aGuessT;\r\n        float currentX = CalcBezier(aGuessT, mX1, mX2) - aX;\r\n        aGuessT -= currentX / currentSlope;\r\n    }\r\n    return aGuessT;\r\n}\r\nfloat KeySpline(float aX, float mX1, float mY1, float mX2, float mY2) {\r\n    if (mX1 == mY1 && mX2 == mY2) return aX; // linear\r\n    return CalcBezier(GetTForX(aX, mX1, mX2), mY1, mY2); // x to t, t to y\r\n}\r\n\r\n// norm distribution\r\nfloat normpdf(float x) {\r\n    return exp(-20.*pow(x-.5,2.));\r\n}\r\n\r\nvec2 rotateUv(vec2 uv, float angle, vec2 anchor, float zDirection) {\r\n    uv = uv - anchor; // anchor to origin\r\n    float s = sin(angle);\r\n	float c = cos(angle);\r\n	mat2 m = mat2(c, -s, s, c);\r\n    uv = m * uv;\r\n    uv += anchor; // anchor back\r\n    return uv;\r\n}\r\n\r\n\r\n\r\nvec4 transition (vec2 uv) {\r\n    \r\n    vec2 iResolution = vec2(100.0, 100.0); // screen size\r\n    \r\n    vec2 myst = uv;\r\n    float ratio = iResolution.x / iResolution.y; // screen ratio\r\n    float animationTime = progress; //getAnimationTime();\r\n    float easingTime = KeySpline(animationTime, .68,.01,.17,.98);\r\n    float blur = normpdf(easingTime);\r\n    float r = 0.;\r\n    float rotation = 180./180.*3.14159;\r\n    if (easingTime <= .5) {\r\n        r = rotation * easingTime;\r\n    } else {\r\n        r = -rotation + rotation * easingTime;\r\n    }\r\n\r\n    // rotation for current frame\r\n    vec2 mystCurrent = myst;\r\n    mystCurrent.y *= 1./ratio;\r\n    mystCurrent = rotateUv(mystCurrent, r, vec2(1., 0.), -1.);\r\n    mystCurrent.y *= ratio;\r\n    \r\n    // frame timeInterval by fps=30\r\n    float timeInterval = 0.0167*2.0;\r\n    if (easingTime <= .5) {\r\n        r = rotation * (easingTime+timeInterval);\r\n    } else {\r\n        r = -rotation + rotation * (easingTime+timeInterval);\r\n    }\r\n    \r\n    // rotation for next frame\r\n    vec2 mystNext = myst;\r\n    mystNext.y *= 1./ratio;\r\n    mystNext = rotateUv(mystNext, r, vec2(1., 0.), -1.);\r\n    mystNext.y *= ratio;\r\n    \r\n    // get speed at tagent direction\r\n    vec2 speed  = (mystNext - mystCurrent) / timeInterval * blur * 0.5;\r\n    if (easingTime <= .5) {\r\n        return motionBlurFrom(mystCurrent, speed);\r\n    } else {\r\n        return motionBlurTo(mystCurrent, speed);\r\n    }\r\n}\r\n\r\n", "license": "MIT", "author": "chenkai", "createdAt": "", "updatedAt": "" }, { "name": "TopBottom", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author:zhmy\r\n// License: MIT\r\n\r\nconst vec4 black = vec4(0.0, 0.0, 0.0, 1.0);\r\nconst vec2 boundMin = vec2(0.0, 0.0);\r\nconst vec2 boundMax = vec2(1.0, 1.0);\r\n\r\nbool inBounds (vec2 p) {\r\n    return all(lessThan(boundMin, p)) && all(lessThan(p, boundMax));\r\n}\r\n\r\nvec4 transition (vec2 uv) {\r\n    vec2 spfr,spto = vec2(-1.);\r\n    float size = mix(1.0, 3.0, progress*0.2);\r\n    spto = (uv + vec2(-0.5,-0.5))*vec2(size,size)+vec2(0.5,0.5);\r\n    spfr = (uv + vec2(0.0, 1.0 - progress));\r\n    if(inBounds(spfr)){\r\n        return getToColor(spfr);\r\n    } else if(inBounds(spto)){\r\n        return getFromColor(spto) * (1.0 - progress);\r\n    } else{\r\n        return black;\r\n    }\r\n}", "author": "zhmy", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "TVStatic", "paramsTypes": { "offset": "float" }, "defaultParams": { "offset": 0.05 }, "glsl": "// author: Brandon Anzaldi\r\n// license: MIT\r\nuniform float offset; // = 0.05\r\n\r\n// Pseudo-random noise function\r\n// http://byteblacksmith.com/improvements-to-the-canonical-one-liner-glsl-rand-for-opengl-es-2-0/\r\nhighp float noise(vec2 co)\r\n{\r\n    highp float a = 12.9898;\r\n    highp float b = 78.233;\r\n    highp float c = 43758.5453;\r\n    highp float dt= dot(co.xy * progress, vec2(a, b));\r\n    highp float sn= mod(dt,3.14);\r\n    return fract(sin(sn) * c);\r\n}\r\n\r\nvec4 transition(vec2 p) {\r\n  if (progress < offset) {\r\n    return getFromColor(p);\r\n  } else if (progress > (1.0 - offset)) {\r\n    return getToColor(p);\r\n  } else {\r\n    return vec4(vec3(noise(p)), 1.0);\r\n  }\r\n}\r\n", "author": "Brandon Anzaldi", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "undulatingBurnOut", "paramsTypes": { "smoothness": "float", "center": "vec2", "color": "vec3" }, "defaultParams": { "smoothness": 0.03, "center": [0.5, 0.5], "color": [0, 0, 0] }, "glsl": "// License: MIT\r\n// Author: pthrasher\r\n// adapted by gre from https://gist.github.com/pthrasher/8e6226b215548ba12734\r\n\r\nuniform float smoothness; // = 0.03\r\nuniform vec2 center; // = vec2(0.5)\r\nuniform vec3 color; // = vec3(0.0)\r\n\r\nconst float M_PI = 3.14159265358979323846;\r\n\r\nfloat quadraticInOut(float t) {\r\n  float p = 2.0 * t * t;\r\n  return t < 0.5 ? p : -p + (4.0 * t) - 1.0;\r\n}\r\n\r\nfloat getGradient(float r, float dist) {\r\n  float d = r - dist;\r\n  return mix(\r\n    smoothstep(-smoothness, 0.0, r - dist * (1.0 + smoothness)),\r\n    -1.0 - step(0.005, d),\r\n    step(-0.005, d) * step(d, 0.01)\r\n  );\r\n}\r\n\r\nfloat getWave(vec2 p){\r\n  vec2 _p = p - center; // offset from center\r\n  float rads = atan(_p.y, _p.x);\r\n  float degs = degrees(rads) + 180.0;\r\n  vec2 range = vec2(0.0, M_PI * 30.0);\r\n  vec2 domain = vec2(0.0, 360.0);\r\n  float ratio = (M_PI * 30.0) / 360.0;\r\n  degs = degs * ratio;\r\n  float x = progress;\r\n  float magnitude = mix(0.02, 0.09, smoothstep(0.0, 1.0, x));\r\n  float offset = mix(40.0, 30.0, smoothstep(0.0, 1.0, x));\r\n  float ease_degs = quadraticInOut(sin(degs));\r\n  float deg_wave_pos = (ease_degs * magnitude) * sin(x * offset);\r\n  return x + deg_wave_pos;\r\n}\r\n\r\nvec4 transition(vec2 p) {\r\n  float dist = distance(center, p);\r\n  float m = getGradient(getWave(p), dist);\r\n  vec4 cfrom = getFromColor(p);\r\n  vec4 cto = getToColor(p);\r\n  return mix(mix(cfrom, cto, m), mix(cfrom, vec4(color, 1.0), 0.75), step(m, -2.0));\r\n}\r\n", "license": "MIT", "author": "pthrasher", "createdAt": "", "updatedAt": "" }, { "name": "VerticalClose", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author: martiniti\r\n// License: MIT\r\n\r\nvec4 transition (vec2 uv) {\r\n\r\n  float s = 2.0 - abs((uv.x - 0.5) / (progress - 1.0)) - 2.0 * progress;\r\n  \r\n  return mix(\r\n    getFromColor(uv),\r\n    getToColor(uv),\r\n    smoothstep(0.5, 0.0, s)\r\n  );\r\n}\r\n", "author": "martiniti", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "VerticalOpen", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author: martiniti\r\n// License: MIT\r\n\r\nvec4 transition (vec2 uv) {\r\n\r\n  float regress = 1.0 - progress;\r\n  float s = 2.0 - abs((uv.x - 0.5) / (regress - 1.0)) - 2.0 * regress;\r\n  \r\n  return mix(\r\n    getFromColor(uv),\r\n    getToColor(uv),\r\n    smoothstep(0.0, 0.5, s)\r\n  );\r\n}\r\n", "author": "martiniti", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "WaterDrop", "paramsTypes": { "amplitude": "float", "speed": "float" }, "defaultParams": { "amplitude": 30, "speed": 30 }, "glsl": "// author: Paweł Płóciennik\r\n// license: MIT\r\nuniform float amplitude; // = 30\r\nuniform float speed; // = 30\r\n\r\nvec4 transition(vec2 p) {\r\n  vec2 dir = p - vec2(.5);\r\n  float dist = length(dir);\r\n\r\n  if (dist > progress) {\r\n    return mix(getFromColor( p), getToColor( p), progress);\r\n  } else {\r\n    vec2 offset = dir * sin(dist * amplitude - progress * speed);\r\n    return mix(getFromColor( p + offset), getToColor( p), progress);\r\n  }\r\n}\r\n", "author": "Paweł Płóciennik", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "wind", "paramsTypes": { "size": "float" }, "defaultParams": { "size": 0.2 }, "glsl": "// Author: gre\r\n// License: MIT\r\n\r\n// Custom parameters\r\nuniform float size; // = 0.2\r\n\r\nfloat rand (vec2 co) {\r\n  return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453);\r\n}\r\n\r\nvec4 transition (vec2 uv) {\r\n  float r = rand(vec2(0, uv.y));\r\n  float m = smoothstep(0.0, -size, uv.x*(1.0-size) + size*r - (progress * (1.0 + size)));\r\n  return mix(\r\n    getFromColor(uv),\r\n    getToColor(uv),\r\n    m\r\n  );\r\n}\r\n", "author": "gre", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "windowblinds", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author: Fabien Benetou\r\n// License: MIT\r\n\r\nvec4 transition (vec2 uv) {\r\n  float t = progress;\r\n  \r\n  if (mod(floor(uv.y*100.*progress),2.)==0.)\r\n    t*=2.-.5;\r\n  \r\n  return mix(\r\n    getFromColor(uv),\r\n    getToColor(uv),\r\n    mix(t, progress, smoothstep(0.8, 1.0, progress))\r\n  );\r\n}\r\n", "author": "Fabien Benetou", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "windowslice", "paramsTypes": { "count": "float", "smoothness": "float" }, "defaultParams": { "count": 10, "smoothness": 0.5 }, "glsl": "// Author: gre\r\n// License: MIT\r\n\r\nuniform float count; // = 10.0\r\nuniform float smoothness; // = 0.5\r\n\r\nvec4 transition (vec2 p) {\r\n  float pr = smoothstep(-smoothness, 0.0, p.x - progress * (1.0 + smoothness));\r\n  float s = step(pr, fract(count * p.x));\r\n  return mix(getFromColor(p), getToColor(p), s);\r\n}\r\n", "author": "gre", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "wipeDown", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author: Jake Nelson\r\n// License: MIT\r\n\r\nvec4 transition(vec2 uv) {\r\n  vec2 p=uv.xy/vec2(1.0).xy;\r\n  vec4 a=getFromColor(p);\r\n  vec4 b=getToColor(p);\r\n  return mix(a, b, step(1.0-p.y,progress));\r\n}\r\n", "author": "Jake Nelson", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "wipeLeft", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author: Jake Nelson\r\n// License: MIT\r\n\r\nvec4 transition(vec2 uv) {\r\n  vec2 p=uv.xy/vec2(1.0).xy;\r\n  vec4 a=getFromColor(p);\r\n  vec4 b=getToColor(p);\r\n  return mix(a, b, step(1.0-p.x,progress));\r\n}\r\n", "author": "Jake Nelson", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "wipeRight", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author: Jake Nelson\r\n// License: MIT\r\n\r\nvec4 transition(vec2 uv) {\r\n  vec2 p=uv.xy/vec2(1.0).xy;\r\n  vec4 a=getFromColor(p);\r\n  vec4 b=getToColor(p);\r\n  return mix(a, b, step(0.0+p.x,progress));\r\n}\r\n", "author": "Jake Nelson", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "wipeUp", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author: Jake Nelson\r\n// License: MIT\r\n\r\nvec4 transition(vec2 uv) {\r\n  vec2 p=uv.xy/vec2(1.0).xy;\r\n  vec4 a=getFromColor(p);\r\n  vec4 b=getToColor(p);\r\n  return mix(a, b, step(0.0+p.y,progress));\r\n}\r\n", "author": "Jake Nelson", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "x_axis_translation", "paramsTypes": {}, "defaultParams": {}, "glsl": "// Author:lizhongjian\r\n// License: MIT\r\n\r\nvec4 transition (vec2 uv) {\r\n  vec2 newUV = uv;\r\n  newUV.x -= progress;\r\n  if(uv.x >= progress)\r\n  {\r\n    return getFromColor(newUV);\r\n  }\r\n\r\n  \r\n  return mix(\r\n    getFromColor(uv),\r\n    getToColor(uv),\r\n    progress\r\n  );\r\n}\r\n", "author": "lizhongjian", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "ZoomInCircles", "paramsTypes": {}, "defaultParams": {}, "glsl": "// License: MIT\r\n// Author: dycm8009\r\n// ported by gre from https://gist.github.com/dycm8009/948e99b1800e81ad909a\r\n\r\nvec2 zoom(vec2 uv, float amount) {\r\n  return 0.5 + ((uv - 0.5) * amount);	\r\n}\r\n\r\nvec2 ratio2 = vec2(1.0, 1.0 / ratio);\r\n\r\nvec4 transition(vec2 uv) {\r\n  // TODO: some timing are hardcoded but should be one or many parameters\r\n  // TODO: should also be able to configure how much circles\r\n  // TODO: if() branching should be avoided when possible, prefer use of step() & other functions\r\n  vec2 r = 2.0 * ((vec2(uv.xy) - 0.5) * ratio2);\r\n  float pro = progress / 0.8;\r\n  float z = pro * 0.2;\r\n  float t = 0.0;\r\n  if (pro > 1.0) {\r\n    z = 0.2 + (pro - 1.0) * 5.;\r\n    t = clamp((progress - 0.8) / 0.07, 0.0, 1.0);\r\n  }\r\n  if (length(r) < 0.5+z) {\r\n    // uv = zoom(uv, 0.9 - 0.1 * pro);\r\n  }\r\n  else if (length(r) < 0.8+z*1.5) {\r\n    uv = zoom(uv, 1.0 - 0.15 * pro);\r\n    t = t * 0.5;\r\n  }\r\n  else if (length(r) < 1.2+z*2.5) {\r\n    uv = zoom(uv, 1.0 - 0.2 * pro);\r\n    t = t * 0.2;\r\n  }\r\n  else {\r\n    uv = zoom(uv, 1.0 - 0.25 * pro);\r\n  }\r\n  return mix(getFromColor(uv), getToColor(uv), t);\r\n}\r\n", "license": "MIT", "author": "dycm8009", "createdAt": "", "updatedAt": "" }, { "name": "ZoomLeftWipe", "paramsTypes": { "zoom_quickness": "float" }, "defaultParams": { "zoom_quickness": 0.8 }, "glsl": "// Author: Handk\r\n// License: MIT\r\n\r\nuniform float zoom_quickness; // = 0.8\r\nfloat nQuick = clamp(zoom_quickness,0.0,0.5);\r\n\r\nvec2 zoom(vec2 uv, float amount) {\r\n  if(amount<0.5)\r\n  return 0.5 + ((uv - 0.5) * (1.0-amount));\r\n  else\r\n  return 0.5 + ((uv - 0.5) * (amount));\r\n  \r\n}\r\n\r\nvec4 transition (vec2 uv) {\r\n  if(progress<0.5){\r\n    vec4 c= mix(\r\n      getFromColor(zoom(uv, smoothstep(0.0, nQuick, progress))),\r\n      getToColor(uv),\r\n     step(0.5, progress)\r\n    );\r\n    \r\n    return c;\r\n  }\r\n  else{\r\n    vec2 p=uv.xy/vec2(1.0).xy;\r\n    vec4 d=getFromColor(p);\r\n    vec4 e=getToColor(p);\r\n    vec4 f= mix(d, e, step(1.0-p.x,(progress-0.5)*2.0));\r\n    \r\n    return f;\r\n  }\r\n}\r\n", "author": "Handk", "license": "MIT", "createdAt": "", "updatedAt": "" }, { "name": "ZoomRigthWipe", "paramsTypes": { "zoom_quickness": "float" }, "defaultParams": { "zoom_quickness": 0.8 }, "glsl": "// Author: Handk\r\n// License: MIT\r\n\r\nuniform float zoom_quickness; // = 0.8\r\nfloat nQuick = clamp(zoom_quickness,0.0,0.5);\r\n\r\nvec2 zoom(vec2 uv, float amount) {\r\n  if(amount<0.5)\r\n  return 0.5 + ((uv - 0.5) * (1.0-amount));\r\n  else\r\n  return 0.5 + ((uv - 0.5) * (amount));\r\n  \r\n}\r\n\r\nvec4 transition (vec2 uv) {\r\n  if(progress<0.5){\r\n    vec4 c= mix(\r\n      getFromColor(zoom(uv, smoothstep(0.0, nQuick, progress))),\r\n      getToColor(uv),\r\n     step(0.5, progress)\r\n    );\r\n    \r\n    return c;\r\n  }\r\n  else{\r\n    vec2 p=uv.xy/vec2(1.0).xy;\r\n    vec4 d=getFromColor(p);\r\n    vec4 e=getToColor(p);\r\n    vec4 f= mix(d, e, step(0.0+p.x,(progress-0.5)*2.0));\r\n    \r\n    return f;\r\n  }\r\n}\r\n", "author": "Handk", "license": "MIT", "createdAt": "", "updatedAt": "" }];
function mountDefProperty() {
  fabric.fabric.Object.prototype.toObject = /* @__PURE__ */ function(toObject) {
    return function(propertiesToInclude) {
      propertiesToInclude = (propertiesToInclude || []).concat(
        [
          "animation",
          "animations",
          "lockMovementX",
          "lockMovementY",
          "lockRotation",
          "lockScalingFlip",
          "lockScalingX",
          "lockScalingY",
          "objectCaching",
          "padding",
          "absolutePositioned",
          "_defType",
          "videoId",
          "_volume",
          "_urlkey",
          "_active",
          "_avatarInfo",
          "_avatarBg",
          "_avatarType",
          "_videoSrc",
          "_frontCoverKey",
          "_frontCoverUrl",
          "_loaded",
          "_addIndex",
          "_fromTemplate",
          "_effect",
          "_filter",
          "_loop",
          "_duration",
          "_staticUrl",
          "_frontCoverStaticUrl",
          "_start",
          "_end",
          "_resourceList",
          "_speed",
          "_brandId",
          "_brandFontFamily",
          "_brandKey",
          "_brandType",
          "_roleIndex",
          "_selected",
          "_cropType",
          "_porn",
          "_timelineStart",
          "_timelineEnd"
        ]
      );
      return toObject.apply(this, [propertiesToInclude]);
    };
  }(fabric.fabric.Object.prototype.toObject);
  fabric.fabric.Object.prototype.toJSON = /* @__PURE__ */ function(toJSON) {
    return function(propertiesToInclude) {
      propertiesToInclude = (propertiesToInclude || []).concat(
        [
          "animation",
          "animations",
          "lockMovementX",
          "lockMovementY",
          "lockRotation",
          "lockScalingFlip",
          "lockScalingX",
          "lockScalingY",
          "absolutePositioned",
          "_defType",
          "objectCaching",
          "padding",
          "videoId",
          "_volume",
          "_urlkey",
          "_active",
          "_avatarInfo",
          "_avatarBg",
          "_avatarType",
          // 视频实际路径
          "_videoSrc",
          // 封面资源key
          "_frontCoverKey",
          "_frontCoverUrl",
          // 视频是否加载
          "_loaded",
          // 当前元素的添加顺序
          "_addIndex",
          // 是否为模板元素
          "_fromTemplate",
          "_effect",
          "_filter",
          "_loop",
          "_duration",
          "_staticUrl",
          "_frontCoverStaticUrl",
          // 视频开始和结束时间
          "_start",
          "_end",
          // 视频资源列表
          "_resourceList",
          // 视频播放速度
          "_speed",
          "_brandId",
          "_brandFontFamily",
          "_brandKey",
          "_brandType",
          "_roleIndex",
          "_selected",
          "_cropType",
          "_porn",
          "_timelineStart",
          "_timelineEnd"
        ]
      );
      return toJSON.apply(this, [propertiesToInclude]);
    };
  }(fabric.fabric.Object.prototype.toJSON);
  fabric.fabric.Gradient.prototype.toObject = /* @__PURE__ */ function(toObject) {
    return function(propertiesToInclude) {
      propertiesToInclude = (propertiesToInclude || []).concat(
        [
          "_degrees",
          "_mode"
        ]
      );
      return toObject.apply(this, [propertiesToInclude]);
    };
  }(fabric.fabric.Gradient.prototype.toObject);
  fabric.fabric.StaticCanvas.prototype.toObject = /* @__PURE__ */ function(toObject) {
    return function(propertiesToInclude) {
      propertiesToInclude = (propertiesToInclude || []).concat(
        ["duration", "transition", "fgColor", "textStyle", "speechId", "loadList", "_addTable", "_modeId", "_templateType", "bgmId"]
      );
      return toObject.apply(this, [propertiesToInclude]);
    };
  }(fabric.fabric.StaticCanvas.prototype.toObject);
  fabric.fabric.StaticCanvas.prototype.toJSON = /* @__PURE__ */ function(toJSON) {
    return function(propertiesToInclude) {
      propertiesToInclude = (propertiesToInclude || []).concat(
        ["duration", "transition", "fgColor", "textStyle", "speechId", "loadList", "_addTable", "_modeId", "_templateType", "bgmId"]
      );
      return toJSON.apply(this, [propertiesToInclude]);
    };
  }(fabric.fabric.StaticCanvas.prototype.toJSON);
}
function initDefLockCtr() {
  function renderIcon(ctx, left, top, styleOverride, fabricObject) {
    const size = 30;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.fabric.util.degreesToRadians(fabricObject.angle));
    const img = document.querySelector("#lockimg");
    ctx.drawImage(img, -size / 2, -size / 2, 40, 40);
    ctx.restore();
  }
  function unLockObject(eventData, transform) {
    window.dispatchEvent(new CustomEvent("msgUnlock"));
  }
  fabric.fabric.Object.prototype.controls.lock = new fabric.fabric.Control({
    x: 0.5,
    y: 0.5,
    offsetY: 0,
    cursorStyle: "pointer",
    mouseUpHandler: unLockObject,
    render: renderIcon,
    cornerSize: 30
  });
  fabric.fabric.Textbox.prototype.controls.lock = new fabric.fabric.Control({
    x: 0.5,
    y: 0.5,
    offsetY: 0,
    cursorStyle: "pointer",
    mouseUpHandler: unLockObject,
    render: renderIcon,
    cornerSize: 30
  });
  fabric.fabric.Object.prototype.controls.lock.sizeX = 30;
  fabric.fabric.Object.prototype.controls.lock.sizeY = 30;
  fabric.fabric.Textbox.prototype.controls.lock.sizeX = 30;
  fabric.fabric.Textbox.prototype.controls.lock.sizeY = 30;
}
function initDefReplaceCtr() {
  function renderIcon(ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.fabric.util.degreesToRadians(fabricObject.angle));
    const img = document.querySelector("#replaceimg");
    ctx.drawImage(img, -size / 2, -size / 2, 56, 48);
    ctx.restore();
  }
  function doReplace(eventData, transform) {
    if (transform.target.type === "CustomVideo") {
      window.dispatchEvent(new CustomEvent("msgReplaceVideo"));
    } else {
      window.dispatchEvent(new CustomEvent("msgReplaceImg"));
    }
  }
  fabric.fabric.Object.prototype.controls.replace = new fabric.fabric.Control({
    x: -0.5,
    y: -0.5,
    offsetY: 40,
    offsetX: 40,
    cursorStyle: "pointer",
    mouseUpHandler: doReplace,
    render: renderIcon,
    cornerSize: 50
  });
  fabric.fabric.Object.prototype.controls.replace.sizeX = 56;
  fabric.fabric.Object.prototype.controls.replace.sizeY = 48;
}
function initCtrStyle() {
  fabric.fabric.Object.prototype.controls.mtr.cursorStyle = "alias";
  fabric.fabric.Object.prototype.borderScaleFactor = 2;
  fabric.fabric.Object.prototype.borderColor = "#85A2FF";
  fabric.fabric.Object.prototype.cornerSize = 24;
  fabric.fabric.Object.prototype.controls.mtr.sizeX = 40;
  fabric.fabric.Object.prototype.controls.mtr.sizeY = 40;
  fabric.fabric.Object.prototype.controls.mtr.render = function(ctx, left, top, styleOverride, fabricObject) {
    const size = 40;
    ctx.save();
    ctx.translate(left, top);
    const img = document.querySelector("#mtrimg");
    ctx.rotate(fabric.fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(img, -size / 2, -size / 2, 40, 40);
    ctx.restore();
  };
  function defRender(ctx, left, top, styleOverride, fabricObject) {
    const size = 24;
    ctx.save();
    ctx.translate(left, top);
    const img = document.querySelector("#cornerimg");
    ctx.rotate(fabric.fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(img, -size / 2, -size / 2, 24, 24);
    ctx.restore();
  }
  fabric.fabric.Object.prototype.controls.tl.render = defRender;
  fabric.fabric.Object.prototype.controls.tr.render = defRender;
  fabric.fabric.Object.prototype.controls.bl.render = defRender;
  fabric.fabric.Object.prototype.controls.br.render = defRender;
  fabric.fabric.Object.prototype.controls.ml.render = defRender;
  fabric.fabric.Object.prototype.controls.mr.render = defRender;
  fabric.fabric.Object.prototype.controls.mt.render = defRender;
  fabric.fabric.Object.prototype.controls.mb.render = defRender;
  fabric.fabric.Textbox.prototype.controls.ml.render = defRender;
  fabric.fabric.Textbox.prototype.controls.mr.render = defRender;
}
function initGlobalConfiguration() {
  fabric.fabric.Object.NUM_FRACTION_DIGITS = 8;
}
function initDefFunction() {
  fabric.fabric.Object.prototype.getZIndex = function() {
    return this.canvas.getObjects().indexOf(this);
  };
  fabric.fabric.Canvas.prototype.cvsPoint2webPoint = function(cvsPoint) {
    const xr = this.width / this.lowerCanvasEl.clientWidth;
    const yr = this.height / this.lowerCanvasEl.clientHeight;
    const rect = this.lowerCanvasEl.getBoundingClientRect();
    const toX = cvsPoint.x / xr + rect.x + window.scrollX;
    const toY = cvsPoint.y / yr + rect.y + window.scrollY;
    return new fabric.fabric.Point(toX, toY);
  };
}
function initCustomObjectFunction() {
  fabric.fabric.Avatar.prototype.changeImage = async function(type) {
    const info = this._avatarInfo;
    if (this._avatarInfo.type === 2 || this._avatarInfo.type === 4) return;
    if (Object.hasOwnProperty.apply(info, ["id"])) {
      const data = await requestAvatarByIdAndType(info.id, info.avatar_source);
      let _info = null;
      if (type === "transparent") {
        _info = data.avatar_noback;
      } else if (type === "normal") {
        _info = data.avatar;
      }
      if (_info) {
        await this.replace(_info.url);
      }
    }
  };
}
function initPrototypeFun() {
  fabric.fabric.Textbox.prototype._calcTextareaPosition = function() {
    if (!this.canvas) {
      return { x: 1, y: 1 };
    }
    const desiredPosition = this.inCompositionMode ? this.compositionStart : this.selectionStart;
    const boundaries = this._getCursorBoundaries(desiredPosition);
    const cursorLocation = this.get2DCursorLocation(desiredPosition);
    const lineIndex = cursorLocation.lineIndex;
    const charIndex = cursorLocation.charIndex;
    const charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, "fontSize") * this.lineHeight;
    const leftOffset = boundaries.leftOffset;
    const m = this.calcTransformMatrix();
    let p = {
      x: boundaries.left + leftOffset,
      y: boundaries.top + boundaries.topOffset + charHeight
    };
    const upperCanvas = this.canvas.upperCanvasEl;
    const upperCanvasWidth = parseFloat(upperCanvas.style.width);
    const upperCanvasHeight = parseFloat(upperCanvas.style.height);
    const maxWidth = upperCanvasWidth - charHeight;
    const maxHeight = upperCanvasHeight - charHeight;
    const scaleX = upperCanvas.clientWidth / upperCanvasWidth;
    const scaleY = upperCanvas.clientHeight / upperCanvasHeight;
    p = fabric.fabric.util.transformPoint(p, m);
    p = fabric.fabric.util.transformPoint(p, this.canvas.viewportTransform);
    p.x *= scaleX;
    p.y *= scaleY;
    if (p.x < 0) {
      p.x = 0;
    }
    if (p.x > maxWidth) {
      p.x = maxWidth;
    }
    if (p.y < 0) {
      p.y = 0;
    }
    if (p.y > maxHeight) {
      p.y = maxHeight;
    }
    p.x += this.canvas._offset.left;
    p.y += this.canvas._offset.top;
    return { left: p.x + "px", top: p.y + "px", fontSize: charHeight + "px", charHeight };
  };
  if (fabric.fabric.isWebglSupported()) {
    fabric.fabric.textureSize = fabric.fabric.maxTextureSize;
    if (fabric.fabric.maxTextureSize >= 4096) {
      fabric.fabric.textureSize = 4096;
    }
  }
  fabric.fabric.util.loadVideo = function(url, callback, context, crossOrigin) {
    if (!url) {
      callback && callback.call(context, url);
      return;
    }
    let video = document.createElement("video");
    document.body.appendChild(video);
    video.preload = "auto";
    video.crossOrigin = "anonymous";
    video.style.display = "none";
    const onLoadCallback = function() {
      video.width = video.videoWidth;
      video.height = video.videoHeight;
      callback && callback.call(context, video, false);
      video = video.onload = video.onerror = null;
    };
    video.onloadeddata = onLoadCallback;
    video.onerror = function() {
      fabric.fabric.log("Error loading " + video.src);
      callback && callback.call(context, null, true);
      video = video.onload = video.onerror = null;
    };
    if (url.indexOf("data") !== 0 && crossOrigin !== void 0 && crossOrigin !== null) {
      video.crossOrigin = crossOrigin;
    }
    video.src = url;
  };
  fabric.fabric.StaticCanvas.prototype.__setBgOverlayImage = function(property, image, callback, options) {
    if (typeof image === "string") {
      if (options.atype === "video") {
        fabric.fabric.util.loadVideo(image, function(img, isError) {
          if (img) {
            const instance = new fabric.fabric.Image(img, options);
            instance.dirty = true;
            this[property] = instance;
            instance.canvas = this;
          }
          callback && callback(img, isError);
        }, this, options && options.crossOrigin);
      } else {
        fabric.fabric.util.loadImage(image, function(img, isError) {
          if (img) {
            const instance = new fabric.fabric.Image(img, options);
            this[property] = instance;
            instance.canvas = this;
          }
          callback && callback(img, isError);
        }, this, options && options.crossOrigin);
      }
    } else {
      options && image.setOptions(options);
      this[property] = image;
      image && (image.canvas = this);
      callback && callback(image, false);
    }
    return this;
  };
}
function initDefFabric() {
  mountDefProperty();
  initCtrStyle();
  initDefLockCtr();
  initDefReplaceCtr();
  initGlobalConfiguration();
  initDefFunction();
  initPrototypeFun();
}
async function getCloneVoiceData(id) {
  let res2;
  try {
    res2 = await jqAjaxPromiseWithHandleException({
      url: "/ai/clone-voice/get-info",
      type: "POST",
      data: {
        id
      }
    });
  } catch (error) {
    return null;
  }
  return res2.data;
}
function getLang() {
  let lang = "en";
  if (!lang || lang === "en") {
    const language = navigator.language;
    if (language.includes("-")) {
      lang = language.split("-")[0];
    } else {
      lang = language;
    }
  }
  let newLang;
  switch (lang) {
    case "jp":
      newLang = "ja";
      break;
    case "kr":
      newLang = "ko";
      break;
    case "se":
      newLang = "sv";
      break;
    default:
      newLang = lang;
      break;
  }
  return newLang || "en";
}
function getAllAudioList$1() {
  return new Promise((resolve, reject) => {
    if (allAudioList$1.length > 0) {
      resolve(allAudioList$1);
    } else {
      jqAjaxPromiseWithHandleException({
        url: "/ai/audio/list-v3",
        type: "POST",
        data: {
          audio_type: "app"
        }
      }).then((res2) => {
        resolve(res2.data.list);
      });
    }
  });
}
let allAudioList$1 = [];
async function getAudioList$1(data = {}) {
  if (data.gender === 0) {
    data.gender = 2;
  }
  if (!allAudioList$1.length) {
    allAudioList$1 = await getAllAudioList$1();
  }
  if (data.audio_type) {
    delete data.audio_type;
  }
  const list = [];
  for (let i = 0; i < allAudioList$1.length; i++) {
    const item = allAudioList$1[i];
    let isPush = true;
    for (const key in data) {
      if (Object.hasOwnProperty.call(data, key)) {
        if (data[key] !== item[key]) {
          isPush = false;
          break;
        }
      }
    }
    if (isPush) {
      list.push(item);
    }
  }
  return list;
}
const defaultVoice = {
  man: "Jacob",
  woman: "Cora"
};
function getDefaultVoiceToEn(gender = 2) {
  return new Promise((resolve, reject) => {
    getAudioList$1({
      gender,
      lan: "en"
    }).then((list) => {
      let item = null;
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        if (gender === 1 && defaultVoice.man === element.name || gender === 2 && defaultVoice.woman === element.name) {
          item = element;
          break;
        }
      }
      if (!item) {
        item = list[0];
      }
      resolve(item);
    });
  });
}
function getDefaultVoice(gender = 2) {
  gender = gender || 2;
  const lan = getLang();
  if (lan === "en") {
    return getDefaultVoiceToEn(gender);
  }
  return new Promise((resolve, reject) => {
    const data = { gender, lan };
    getAudioList$1(data).then(async (res2) => {
      if (res2.length) {
        let item;
        for (let i = 0; i < res2.length; i++) {
          const element = res2[i];
          if (gender === element.gender && element.is_free === 1) {
            item = element;
            break;
          }
        }
        if (!item) {
          item = await getDefaultVoiceToEn(gender);
        }
        resolve(item);
      } else {
        const item = await getDefaultVoiceToEn(gender);
        resolve(item);
      }
    }).catch((err) => {
      reject(err);
    });
  });
}
async function dealWithCloneVoice(speech, gender) {
  if (speech.default.property.voiceType === "clone") {
    const voiceData = await getCloneVoiceData(speech.default.property.id);
    if (voiceData && voiceData.status !== 2) {
      speech.default.property.name = voiceData.voice_name;
    } else {
      const voice = await getDefaultVoice(gender);
      speech.default.property = voice;
    }
  }
  if (speech.conversation) {
    const roles = speech.conversation.roles;
    for (let i = 0; i < roles.length; i++) {
      if (roles[i].property.voiceType === "clone") {
        const voiceData = await getCloneVoiceData(roles[i].property.id);
        if (voiceData && voiceData.status !== 2) {
          roles[i].property.name = voiceData.voice_name;
        } else {
          const voice = await getDefaultVoice(roles[i].gender);
          roles[i].property = voice;
        }
      }
    }
  }
}
async function getAudioListByUser(data = {}) {
  const list = await getAudioList$1(data);
  const audioList = [];
  for (let i = 0; i < list.length; i++) {
    const item = list[i];
    if (item.is_free === 1) {
      audioList.push(item);
    }
  }
  return audioList;
}
async function checkAndSetSpeechModel(obj) {
  const id = obj.property.id;
  const audioList = await getAudioList$1({ id });
  const hasModel = audioList.length > 0;
  if (!hasModel) {
    let toModel = null;
    const list = await getAudioListByUser({ gender: obj.property.gender, country_name: obj.property.country_name });
    if (list.length > 0) {
      toModel = list[0];
    } else {
      toModel = await getDefaultVoice(obj.property.gender);
    }
    obj.property = toModel;
    return true;
  }
  return false;
}
function calculateTextDuration2(text, wordsPerMinute, speed = 1) {
  if (!text) {
    return 0;
  }
  const reg = /\{\{pause=\d+(\.\d+)?\}\}/g;
  const res2 = text.match(reg);
  let pauseCount = 0;
  if (res2) {
    for (let i = 0; i < res2.length; i++) {
      pauseCount = pauseCount + parseInt(res2[i].split("=")[1]);
    }
  }
  let _text = text.replace(/\{\{pause=\d+(\.\d+)?\}\}/g, "");
  _text = _text.replace(/\{\{ae=([^{}]+?)\(([^{}]*)\)\}\}/g, function(match, text2, speechText) {
    return speechText;
  });
  const pauseHead = 300;
  const pauseEnd = 300;
  const regex = /[\u4E00-\u9FFF\u3040-\u30FF\u3400-\u4DBF\uAC00-\uD7AF\u0E00-\u0E7F\u0410-\u044F]|[0-9]+|[a-zA-Z]+'*[a-z]*/g;
  const words = _text.match(regex);
  if (!words && pauseCount === 0) {
    return 0;
  }
  const lenth = words ? words.length : 0;
  const duration = lenth / wordsPerMinute * 60 * 1e3;
  return (pauseHead + duration + pauseCount + pauseEnd) / 1e3 / speed;
}
async function initSpeechConfig(clip, speechList2) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q;
  const sId = customAlphabet("abcdefghijklmnopqrstuvwxyz", 8)();
  clip.speechId = sId;
  if (!clip.speech) {
    clip.speech = {
      default: {
        duration: 0,
        property: {},
        speed: 1,
        volume: 1,
        pitch: 0,
        text: ""
      },
      uploadVoice: {
        name: "",
        staticUrl: "",
        duration: 0
      },
      duration: {
        duration: 5
      },
      conversition: {
        roles: [],
        content: []
      },
      type: "duration"
    };
  } else {
    const needPretreatment = !clip.speech.type;
    if (needPretreatment) {
      const _speech = { ...clip.speech };
      clip.speech = {};
      clip.speech.type = "default";
      clip.speech.default = _speech;
      clip.speech.default.pitch = 0;
      clip.speech.default.volume = 1;
      clip.speech.uploadVoice = {
        name: "",
        staticUrl: "",
        duration: 0
      };
      clip.speech.duration = {
        duration: 10
      };
    }
    if (clip.speech.default.text && !clip.speech.default.duration) {
      let wordsPerMinute = 0;
      if ((_d = (_c = (_b = (_a = clip.speech) == null ? void 0 : _a.default) == null ? void 0 : _b.property) == null ? void 0 : _c.tts_config) == null ? void 0 : _d.words_per_minute) {
        wordsPerMinute = Number((_h = (_g = (_f = (_e = clip.speech) == null ? void 0 : _e.default) == null ? void 0 : _f.property) == null ? void 0 : _g.tts_config) == null ? void 0 : _h.words_per_minute);
      }
      if (wordsPerMinute !== 0) {
        clip.speech.default.duration = calculateTextDuration2(clip.speech.default.text, wordsPerMinute);
      } else {
        clip.speech.default.duration = 1;
      }
    }
    if (!needPretreatment && clip.speech.uploadVoice && Array.isArray(clip.speech.uploadVoice)) {
      clip.speech.uploadVoice = {
        name: "",
        staticUrl: "",
        duration: 0
      };
    }
  }
  if (!clip.speech.default.property || Object.keys(clip.speech.default.property).length === 0) {
    const defaultProperty = await getDefaultVoice();
    clip.speech.default.text = ((_i = defaultProperty == null ? void 0 : defaultProperty.app_json) == null ? void 0 : _i.text) || clip.speech.default.text;
    clip.speech.default.property = defaultProperty;
    const wordsPerMinute = Number((_m = (_l = (_k = (_j = clip.speech) == null ? void 0 : _j.default) == null ? void 0 : _k.property) == null ? void 0 : _l.tts_config) == null ? void 0 : _m.words_per_minute);
    clip.speech.default.duration = calculateTextDuration2(clip.speech.default.text, wordsPerMinute);
  }
  let gender = 2;
  for (let i = 0; i <= clip.layers.length - 1; i++) {
    const layer = clip.layers[i];
    if (layer.type === "avatar" && !Object.hasOwnProperty.apply(layer, ["_roleIndex"])) {
      gender = layer.property._avatarInfo.gender;
    }
  }
  await dealWithCloneVoice(clip.speech, gender);
  if (!Object.hasOwnProperty.apply(clip.speech.default, ["pitch"])) {
    clip.speech.default.pitch = 0;
    clip.speech.default.volume = 1;
  }
  if (clip.speech.conversation) {
    clip.speech.conversation.roles.forEach((item) => {
      if (!Object.hasOwnProperty.apply(item, ["pitch"])) {
        item.pitch = 0;
        item.volume = 1;
      }
    });
  }
  const speech = clip.speech;
  if (await checkAndSetSpeechModel(speech.default)) {
    delete speech.default.resourceInfo;
    delete speech.default.subtitles;
  }
  if (((_n = speech == null ? void 0 : speech.conversation) == null ? void 0 : _n.roles) && ((_o = speech == null ? void 0 : speech.conversation) == null ? void 0 : _o.roles.length) > 0) {
    for (let i = 0; i < ((_p = speech == null ? void 0 : speech.conversation) == null ? void 0 : _p.roles.length); i++) {
      if (await checkAndSetSpeechModel((_q = speech == null ? void 0 : speech.conversation) == null ? void 0 : _q.roles[i])) {
        for (let j = 0; j < (speech == null ? void 0 : speech.conversation.content.length); j++) {
          if ((speech == null ? void 0 : speech.conversation.content[j]._roleIndex) === i) {
            speech == null ? true : delete speech.conversation.content[j].resourceInfo;
            speech == null ? true : delete speech.conversation.content[j].subtitles;
          }
        }
      }
    }
  }
  clip.speech.audioId = sId;
  speechList2.set(sId, JSON.parse(JSON.stringify(clip.speech)));
}
function initBgmConfig(clip, bgmList2) {
  const sId = customAlphabet("abcdefghijklmnopqrstuvwxyz", 8)();
  clip.bgmId = sId;
  if (!clip.bgm) {
    clip.bgm = {
      loop: true,
      _urlkey: "",
      _staticUrl: "",
      volume: 0.1,
      enabled: true
    };
  }
  clip.bgm.audioId = sId;
  bgmList2.set(sId, JSON.parse(JSON.stringify(clip.bgm)));
}
function initTransitionConfig(clip) {
  if (!clip.transition) {
    clip.transition = {
      name: "none",
      displayName: "none",
      duration: 0.5
    };
  }
}
function initFgAndBgColor(clip) {
  if (!clip.fgColor) {
    clip.fgColor = "#8b3dff";
  }
  if (!clip.bgColor) {
    clip.bgColor = "#ffffff";
  }
}
function mountAnimation(obj) {
  if (!obj.animation) {
    obj.animation = {
      enter: {
        name: "none",
        ease: "smooth",
        duration: 1,
        delay: 0
      },
      exit: {
        name: "none",
        ease: "smooth",
        duration: 1
      }
    };
  } else {
    if (!obj.animation.enter) {
      obj.animation.enter = {
        name: "none",
        ease: "smooth",
        duration: 1,
        delay: 0
      };
    }
    if (!obj.animation.exit) {
      obj.animation.exit = {
        name: "none",
        ease: "smooth",
        duration: 1
      };
    }
  }
  if (obj.animation.to) {
    obj.animation.to = {
      ...obj.animation.to
    };
  } else {
    obj.animation.to = {
      left: obj.left,
      top: obj.top,
      opacity: obj.opacity,
      scaleX: obj.scaleX,
      scaleY: obj.scaleY
    };
  }
  if (obj.animation.enter.delay > 0) {
    const _delay = obj.animation.enter.delay;
    obj.animation.enter.delay = 0;
    obj.start = _delay;
  }
}
function initAnimationConfig(clip) {
  for (let i = 0; i < clip.layers.length; i++) {
    const obj = clip.layers[i];
    mountAnimation(obj);
  }
}
function getVideoDurationByUrl(src) {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    video.addEventListener("loadedmetadata", () => {
      resolve(video.duration);
    });
    video.preload = true;
    video.src = src;
  });
}
function getVideoWidthHeight(url) {
  return new Promise((resolve, reject) => {
    if (!url) {
      reject(new Error("url is null"));
    }
    const video = document.createElement("video");
    video.setAttribute("preload", "auto");
    video.setAttribute("crossorigin", "anonymous");
    video.src = url;
    video.onloadedmetadata = function() {
      resolve({
        width: video.videoWidth,
        height: video.videoHeight
      });
    };
    video.onerror = function(err) {
      reject(err);
    };
  });
}
async function initVideoConfig(clip) {
  for (let i = 0; i < clip.layers.length; i++) {
    const obj = clip.layers[i];
    if (obj.type === "video") {
      if (!obj.property._speed) {
        obj.property._speed = "1.0";
      }
      if (!obj.property._start) {
        obj.property._start = 0;
      }
      if (!obj.property._end) {
        if (Object.prototype.hasOwnProperty.call(obj.property, "_duration")) {
          obj.property._end = obj.property._duration;
        } else {
          let src = "";
          if (obj.property._staticUrl) {
            src = obj.property._staticUrl;
          } else {
            if (obj.property._urlkey) {
              const res2 = await requestReouseceUrl(obj.property._urlkey);
              src = res2.data.static_url ? res2.data.static_url : res2.data.url;
            }
          }
          const duration = await getVideoDurationByUrl(src);
          obj.property._duration = duration;
          obj.property._end = duration;
        }
      }
      if (obj.property.objects && obj.property.objects.length > 0 && !obj.property.objects[0].crossOrigin) {
        obj.property.objects[0].crossOrigin = "anonymous";
      }
      if (obj.property._resourceList && obj.property._resourceList.source === "pexels") {
        const imgWidth = obj.property.objects[0].width;
        const res2 = await fetch(obj.property._staticUrl, {
          method: "HEAD",
          headers: {
            // 'Access-Control-Allow-Origin': '*'
          }
        });
        if (res2.status !== 200) {
          if (!Object.hasOwnProperty.apply(obj.property._resourceList, ["id"])) break;
          let vdRes = null;
          try {
            vdRes = await jqAjaxPromiseWithHandleException({
              url: "/ai/pexels/info",
              type: "GET",
              data: {
                id: obj.property._resourceList.id
              }
            });
          } catch (error) {
            break;
          }
          const vdFiles = vdRes.data.video_files;
          const _videoFiles = vdFiles.sort((a, b) => b.width - a.width);
          let find = false;
          for (let i2 = _videoFiles.length - 1; i2 >= 0; i2--) {
            const wh = await getVideoWidthHeight(_videoFiles[i2].link);
            if (wh.width === imgWidth) {
              obj.property._resourceList.list = vdFiles;
              obj.property._staticUrl = _videoFiles[i2].link;
              obj.property._videoSrc = _videoFiles[i2].link;
              find = true;
              break;
            }
          }
          if (!find) {
            obj.property._resourceList.list = vdFiles;
            obj.property._staticUrl = _videoFiles[_videoFiles.length - 1].link;
            obj.property._videoSrc = _videoFiles[_videoFiles.length - 1].link;
          }
        }
      }
    }
  }
}
function initIcon(clip) {
  for (let i = clip.layers.length - 1; i >= 0; i--) {
    const obj = clip.layers[i];
    if (obj.type === "object" && obj.property.type === "CustomIcon") {
      if (!Object.hasOwnProperty.apply(obj.property, ["width"]) || obj.property.width === 0) {
        clip.layers.splice(i, 1);
      }
    }
  }
}
function initCrop(clip) {
  for (let i = 0; i < clip.layers.length; i++) {
    const obj = clip.layers[i];
    if (obj.type === "object" && obj.property.type === "CustomImage" || obj.type === "video" && obj.property.type === "CustomVideo") {
      if (!obj.property.clipPath) continue;
      if (!obj.property.clipPath.absolutePositioned) continue;
      obj.property.clipPath.left = -obj.property.width / 2;
      obj.property.clipPath.top = -obj.property.height / 2;
      obj.property.clipPath.absolutePositioned = false;
      obj.property.clipPath.scaleX = 1;
      obj.property.clipPath.scaleY = 1;
      obj.property.clipPath.angle = 0;
    }
  }
}
function initTimeline(clip) {
  for (let i = 0; i < clip.layers.length; i++) {
    const obj = clip.layers[i];
    if (hasKey(obj, "start")) {
      obj.property._timelineStart = obj.start;
    }
    if (hasKey(obj, "stop") && obj.stop !== clip.duration) {
      obj.property._timelineEnd = obj.stop;
    }
  }
}
function initClipTextStyle(clip, firstSceneTextStyle = null) {
  const fallbackStr = fallbackList.toString();
  if (!clip.textStyle) {
    clip.textStyle = {};
  }
  if (Array.isArray(clip.textStyle)) {
    clip.textStyle = {};
  }
  if (!clip.textStyle.title) {
    if (firstSceneTextStyle) {
      clip.textStyle.title = { ...firstSceneTextStyle.title };
    } else {
      clip.textStyle.title = {
        // fill: '#000000',
        fontSize: 120,
        fontWeight: "bold",
        // fontFamily: 'Roboto, UnicodeBMPFallback'
        fontFamily: `Roboto,${fallbackStr}`,
        underline: false,
        fontStyle: "normal",
        opacity: 1,
        align: "left"
      };
    }
  } else {
    clip.textStyle.title.fontFamily = `${clip.textStyle.title.fontFamily},${fallbackStr}`;
  }
  if (!clip.textStyle.subtitle) {
    if (firstSceneTextStyle) {
      clip.textStyle.subtitle = { ...firstSceneTextStyle.subtitle };
    } else {
      clip.textStyle.subtitle = {
        // fill: '#000000',
        fontSize: 90,
        fontFamily: `Roboto,${fallbackStr}`,
        underline: false,
        fontWeight: "normal",
        fontStyle: "normal",
        opacity: 1,
        align: "left"
      };
    }
  } else {
    clip.textStyle.subtitle.fontFamily = `${clip.textStyle.subtitle.fontFamily},${fallbackStr}`;
  }
  if (!clip.textStyle.paragraph) {
    if (firstSceneTextStyle) {
      clip.textStyle.paragraph = { ...firstSceneTextStyle.paragraph };
    } else {
      clip.textStyle.paragraph = {
        // fill: '#000000',
        fontSize: 48,
        fontFamily: `Roboto,${fallbackStr}`,
        underline: false,
        fontWeight: "normal",
        fontStyle: "normal",
        opacity: 1,
        align: "left"
      };
    }
  } else {
    clip.textStyle.paragraph.fontFamily = `${clip.textStyle.paragraph.fontFamily},${fallbackStr}`;
  }
}
async function initConfig(clip, firstSceneTextStyle = null, initSpeech = true, speechList2, bgmList2) {
  initFgAndBgColor(clip);
  if (initSpeech) {
    await initSpeechConfig(clip, speechList2);
  }
  initTransitionConfig(clip);
  initClipTextStyle(clip, firstSceneTextStyle);
  initAnimationConfig(clip);
  await initVideoConfig(clip);
  initIcon(clip);
  initBgmConfig(clip, bgmList2);
  initCrop(clip);
  initTimeline(clip);
}
var events = { exports: {} };
var R = typeof Reflect === "object" ? Reflect : null;
var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply2(target, receiver, args) {
  return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;
if (R && typeof R.ownKeys === "function") {
  ReflectOwnKeys = R.ownKeys;
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys2(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys2(target) {
    return Object.getOwnPropertyNames(target);
  };
}
function ProcessEmitWarning(warning) {
  if (console && console.warn) ;
}
var NumberIsNaN = Number.isNaN || function NumberIsNaN2(value) {
  return value !== value;
};
function EventEmitter() {
  EventEmitter.init.call(this);
}
events.exports = EventEmitter;
events.exports.once = once2;
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = void 0;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = void 0;
var defaultMaxListeners = 10;
function checkListener(listener) {
  if (typeof listener !== "function") {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}
Object.defineProperty(EventEmitter, "defaultMaxListeners", {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
    }
    defaultMaxListeners = arg;
  }
});
EventEmitter.init = function() {
  if (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) {
    this._events = /* @__PURE__ */ Object.create(null);
    this._eventsCount = 0;
  }
  this._maxListeners = this._maxListeners || void 0;
};
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== "number" || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
  }
  this._maxListeners = n;
  return this;
};
function _getMaxListeners(that) {
  if (that._maxListeners === void 0)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = type === "error";
  var events2 = this._events;
  if (events2 !== void 0)
    doError = doError && events2.error === void 0;
  else if (!doError)
    return false;
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      throw er;
    }
    var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
    err.context = er;
    throw err;
  }
  var handler = events2[type];
  if (handler === void 0)
    return false;
  if (typeof handler === "function") {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners2 = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners2[i], this, args);
  }
  return true;
};
function _addListener(target, type, listener, prepend) {
  var m;
  var events2;
  var existing;
  checkListener(listener);
  events2 = target._events;
  if (events2 === void 0) {
    events2 = target._events = /* @__PURE__ */ Object.create(null);
    target._eventsCount = 0;
  } else {
    if (events2.newListener !== void 0) {
      target.emit(
        "newListener",
        type,
        listener.listener ? listener.listener : listener
      );
      events2 = target._events;
    }
    existing = events2[type];
  }
  if (existing === void 0) {
    existing = events2[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === "function") {
      existing = events2[type] = prepend ? [listener, existing] : [existing, listener];
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      w.name = "MaxListenersExceededWarning";
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }
  return target;
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener(type, listener) {
  return _addListener(this, type, listener, true);
};
function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}
function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: void 0, target, type, listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}
EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
  checkListener(listener);
  this.prependListener(type, _onceWrap(this, type, listener));
  return this;
};
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
  var list, events2, position, i, originalListener;
  checkListener(listener);
  events2 = this._events;
  if (events2 === void 0)
    return this;
  list = events2[type];
  if (list === void 0)
    return this;
  if (list === listener || list.listener === listener) {
    if (--this._eventsCount === 0)
      this._events = /* @__PURE__ */ Object.create(null);
    else {
      delete events2[type];
      if (events2.removeListener)
        this.emit("removeListener", type, list.listener || listener);
    }
  } else if (typeof list !== "function") {
    position = -1;
    for (i = list.length - 1; i >= 0; i--) {
      if (list[i] === listener || list[i].listener === listener) {
        originalListener = list[i].listener;
        position = i;
        break;
      }
    }
    if (position < 0)
      return this;
    if (position === 0)
      list.shift();
    else {
      spliceOne(list, position);
    }
    if (list.length === 1)
      events2[type] = list[0];
    if (events2.removeListener !== void 0)
      this.emit("removeListener", type, originalListener || listener);
  }
  return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
  var listeners2, events2, i;
  events2 = this._events;
  if (events2 === void 0)
    return this;
  if (events2.removeListener === void 0) {
    if (arguments.length === 0) {
      this._events = /* @__PURE__ */ Object.create(null);
      this._eventsCount = 0;
    } else if (events2[type] !== void 0) {
      if (--this._eventsCount === 0)
        this._events = /* @__PURE__ */ Object.create(null);
      else
        delete events2[type];
    }
    return this;
  }
  if (arguments.length === 0) {
    var keys = Object.keys(events2);
    var key;
    for (i = 0; i < keys.length; ++i) {
      key = keys[i];
      if (key === "removeListener") continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners("removeListener");
    this._events = /* @__PURE__ */ Object.create(null);
    this._eventsCount = 0;
    return this;
  }
  listeners2 = events2[type];
  if (typeof listeners2 === "function") {
    this.removeListener(type, listeners2);
  } else if (listeners2 !== void 0) {
    for (i = listeners2.length - 1; i >= 0; i--) {
      this.removeListener(type, listeners2[i]);
    }
  }
  return this;
};
function _listeners(target, type, unwrap) {
  var events2 = target._events;
  if (events2 === void 0)
    return [];
  var evlistener = events2[type];
  if (evlistener === void 0)
    return [];
  if (typeof evlistener === "function")
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];
  return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};
EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};
EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === "function") {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events2 = this._events;
  if (events2 !== void 0) {
    var evlistener = events2[type];
    if (typeof evlistener === "function") {
      return 1;
    } else if (evlistener !== void 0) {
      return evlistener.length;
    }
  }
  return 0;
}
EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}
function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}
function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}
function once2(emitter, name2) {
  return new Promise(function(resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name2, resolver);
      reject(err);
    }
    function resolver() {
      if (typeof emitter.removeListener === "function") {
        emitter.removeListener("error", errorListener);
      }
      resolve([].slice.call(arguments));
    }
    eventTargetAgnosticAddListener(emitter, name2, resolver, { once: true });
    if (name2 !== "error") {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}
function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === "function") {
    eventTargetAgnosticAddListener(emitter, "error", handler, flags);
  }
}
function eventTargetAgnosticAddListener(emitter, name2, listener, flags) {
  if (typeof emitter.on === "function") {
    if (flags.once) {
      emitter.once(name2, listener);
    } else {
      emitter.on(name2, listener);
    }
  } else if (typeof emitter.addEventListener === "function") {
    emitter.addEventListener(name2, function wrapListener(arg) {
      if (flags.once) {
        emitter.removeEventListener(name2, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}
var eventsExports = events.exports;
const EventEmitter$1 = /* @__PURE__ */ getDefaultExportFromCjs(eventsExports);
const playStates = {
  initStart: "init:start",
  initEnd: "init:end",
  loadResourceStart: "load:start",
  loadResourceEnd: "load:end",
  // 传递进度
  playing: "play:process",
  playEnd: "play:end",
  seek: "seek",
  pause: "pause"
};
class PlayEvent extends EventEmitter$1 {
}
const playEmitter = new PlayEvent();
window.playEmitter = playEmitter;
window.playStates = playStates;
var lib = {};
var reflect = makeReflectTypes;
function makeReflectTypes(uniforms, useIndex) {
  var obj = {};
  for (var i = 0; i < uniforms.length; ++i) {
    var n = uniforms[i].name;
    var parts = n.split(".");
    var o = obj;
    for (var j = 0; j < parts.length; ++j) {
      var x = parts[j].split("[");
      if (x.length > 1) {
        if (!(x[0] in o)) {
          o[x[0]] = [];
        }
        o = o[x[0]];
        for (var k = 1; k < x.length; ++k) {
          var y = parseInt(x[k]);
          if (k < x.length - 1 || j < parts.length - 1) {
            if (!(y in o)) {
              if (k < x.length - 1) {
                o[y] = [];
              } else {
                o[y] = {};
              }
            }
            o = o[y];
          } else {
            if (useIndex) {
              o[y] = i;
            } else {
              o[y] = uniforms[i].type;
            }
          }
        }
      } else if (j < parts.length - 1) {
        if (!(x[0] in o)) {
          o[x[0]] = {};
        }
        o = o[x[0]];
      } else {
        if (useIndex) {
          o[x[0]] = i;
        } else {
          o[x[0]] = uniforms[i].type;
        }
      }
    }
  }
  return obj;
}
function GLError$4(rawError, shortMessage, longMessage) {
  this.shortMessage = shortMessage || "";
  this.longMessage = longMessage || "";
  this.rawError = rawError || "";
  this.message = "gl-shader: " + (shortMessage || rawError || "") + (longMessage ? "\n" + longMessage : "");
  this.stack = new Error().stack;
}
GLError$4.prototype = new Error();
GLError$4.prototype.name = "GLError";
GLError$4.prototype.constructor = GLError$4;
var GLError_1 = GLError$4;
var coallesceUniforms = reflect;
var GLError$3 = GLError_1;
var createUniforms = createUniformWrapper$1;
function identity(x) {
  return function() {
    return x;
  };
}
function makeVector(length, fill) {
  var result = new Array(length);
  for (var i = 0; i < length; ++i) {
    result[i] = fill;
  }
  return result;
}
function createUniformWrapper$1(gl, wrapper, uniforms, locations) {
  function makeGetter(idx) {
    return function(gl2, wrapper2, locations2) {
      return gl2.getUniform(wrapper2.program, locations2[idx]);
    };
  }
  function makeSetter(type) {
    return function updateProperty(obj) {
      var indices = enumerateIndices("", type);
      for (var i = 0; i < indices.length; ++i) {
        var item = indices[i];
        var path = item[0];
        var idx = item[1];
        if (locations[idx]) {
          var objPath = obj;
          if (typeof path === "string" && (path.indexOf(".") === 0 || path.indexOf("[") === 0)) {
            var key = path;
            if (path.indexOf(".") === 0) {
              key = path.slice(1);
            }
            if (key.indexOf("]") === key.length - 1) {
              var j = key.indexOf("[");
              var k1 = key.slice(0, j);
              var k2 = key.slice(j + 1, key.length - 1);
              objPath = k1 ? obj[k1][k2] : obj[k2];
            } else {
              objPath = obj[key];
            }
          }
          var t = uniforms[idx].type;
          var d;
          switch (t) {
            case "bool":
            case "int":
            case "sampler2D":
            case "samplerCube":
              gl.uniform1i(locations[idx], objPath);
              break;
            case "float":
              gl.uniform1f(locations[idx], objPath);
              break;
            default:
              var vidx = t.indexOf("vec");
              if (0 <= vidx && vidx <= 1 && t.length === 4 + vidx) {
                d = t.charCodeAt(t.length - 1) - 48;
                if (d < 2 || d > 4) {
                  throw new GLError$3("", "Invalid data type");
                }
                switch (t.charAt(0)) {
                  case "b":
                  case "i":
                    gl["uniform" + d + "iv"](locations[idx], objPath);
                    break;
                  case "v":
                    gl["uniform" + d + "fv"](locations[idx], objPath);
                    break;
                  default:
                    throw new GLError$3("", "Unrecognized data type for vector " + name + ": " + t);
                }
              } else if (t.indexOf("mat") === 0 && t.length === 4) {
                d = t.charCodeAt(t.length - 1) - 48;
                if (d < 2 || d > 4) {
                  throw new GLError$3("", "Invalid uniform dimension type for matrix " + name + ": " + t);
                }
                gl["uniformMatrix" + d + "fv"](locations[idx], false, objPath);
                break;
              } else {
                throw new GLError$3("", "Unknown uniform data type for " + name + ": " + t);
              }
          }
        }
      }
    };
  }
  function enumerateIndices(prefix, type) {
    if (typeof type !== "object") {
      return [[prefix, type]];
    }
    var indices = [];
    for (var id in type) {
      var prop = type[id];
      var tprefix = prefix;
      if (parseInt(id) + "" === id) {
        tprefix += "[" + id + "]";
      } else {
        tprefix += "." + id;
      }
      if (typeof prop === "object") {
        indices.push.apply(indices, enumerateIndices(tprefix, prop));
      } else {
        indices.push([tprefix, prop]);
      }
    }
    return indices;
  }
  function defaultValue(type) {
    switch (type) {
      case "bool":
        return false;
      case "int":
      case "sampler2D":
      case "samplerCube":
        return 0;
      case "float":
        return 0;
      default:
        var vidx = type.indexOf("vec");
        if (0 <= vidx && vidx <= 1 && type.length === 4 + vidx) {
          var d = type.charCodeAt(type.length - 1) - 48;
          if (d < 2 || d > 4) {
            throw new GLError$3("", "Invalid data type");
          }
          if (type.charAt(0) === "b") {
            return makeVector(d, false);
          }
          return makeVector(d, 0);
        } else if (type.indexOf("mat") === 0 && type.length === 4) {
          var d = type.charCodeAt(type.length - 1) - 48;
          if (d < 2 || d > 4) {
            throw new GLError$3("", "Invalid uniform dimension type for matrix " + name + ": " + type);
          }
          return makeVector(d * d, 0);
        } else {
          throw new GLError$3("", "Unknown uniform data type for " + name + ": " + type);
        }
    }
  }
  function storeProperty(obj, prop, type) {
    if (typeof type === "object") {
      var child = processObject(type);
      Object.defineProperty(obj, prop, {
        get: identity(child),
        set: makeSetter(type),
        enumerable: true,
        configurable: false
      });
    } else {
      if (locations[type]) {
        Object.defineProperty(obj, prop, {
          get: makeGetter(type),
          set: makeSetter(type),
          enumerable: true,
          configurable: false
        });
      } else {
        obj[prop] = defaultValue(uniforms[type].type);
      }
    }
  }
  function processObject(obj) {
    var result;
    if (Array.isArray(obj)) {
      result = new Array(obj.length);
      for (var i = 0; i < obj.length; ++i) {
        storeProperty(result, i, obj[i]);
      }
    } else {
      result = {};
      for (var id in obj) {
        storeProperty(result, id, obj[id]);
      }
    }
    return result;
  }
  var coallesced = coallesceUniforms(uniforms, true);
  return {
    get: identity(processObject(coallesced)),
    set: makeSetter(coallesced),
    enumerable: true,
    configurable: true
  };
}
var createAttributes = createAttributeWrapper$1;
var GLError$2 = GLError_1;
function ShaderAttribute(gl, wrapper, index, locations, dimension, constFunc) {
  this._gl = gl;
  this._wrapper = wrapper;
  this._index = index;
  this._locations = locations;
  this._dimension = dimension;
  this._constFunc = constFunc;
}
var proto$3 = ShaderAttribute.prototype;
proto$3.pointer = function setAttribPointer(type, normalized, stride, offset) {
  var self2 = this;
  var gl = self2._gl;
  var location2 = self2._locations[self2._index];
  gl.vertexAttribPointer(
    location2,
    self2._dimension,
    type || gl.FLOAT,
    !!normalized,
    stride || 0,
    offset || 0
  );
  gl.enableVertexAttribArray(location2);
};
proto$3.set = function(x0, x1, x2, x3) {
  return this._constFunc(this._locations[this._index], x0, x1, x2, x3);
};
Object.defineProperty(proto$3, "location", {
  get: function() {
    return this._locations[this._index];
  },
  set: function(v) {
    if (v !== this._locations[this._index]) {
      this._locations[this._index] = v | 0;
      this._wrapper.program = null;
    }
    return v | 0;
  }
});
var allFns = [
  function(gl, v, x0) {
    if (x0.length === void 0) {
      return gl.vertexAttrib1f(v, x0);
    } else {
      return gl.vertexAttrib1fv(v, x0);
    }
  },
  function(gl, v, x0, x1) {
    if (x0.length === void 0) {
      return gl.vertexAttrib2f(v, x0, x1);
    } else {
      return gl.vertexAttrib2fv(v, x0);
    }
  },
  function(gl, v, x0, x1, x2) {
    if (x0.length === void 0) {
      return gl.vertexAttrib3f(v, x0, x1, x2);
    } else {
      return gl.vertexAttrib3fv(v, x0);
    }
  },
  function(gl, v, x0, x1, x2, x3) {
    if (x0.length === void 0) {
      return gl.vertexAttrib4f(v, x0, x1, x2, x3);
    } else {
      return gl.vertexAttrib4fv(v, x0);
    }
  }
];
function addVectorAttribute(gl, wrapper, index, locations, dimension, obj, name2) {
  var constFunc = allFns[dimension];
  var attr = new ShaderAttribute(
    gl,
    wrapper,
    index,
    locations,
    dimension,
    constFunc
  );
  Object.defineProperty(obj, name2, {
    set: function(x) {
      gl.disableVertexAttribArray(locations[index]);
      constFunc(gl, locations[index], x);
      return x;
    },
    get: function() {
      return attr;
    },
    enumerable: true
  });
}
function addMatrixAttribute(gl, wrapper, index, locations, dimension, obj, name2) {
  var parts = new Array(dimension);
  var attrs = new Array(dimension);
  for (var i = 0; i < dimension; ++i) {
    addVectorAttribute(
      gl,
      wrapper,
      index[i],
      locations,
      dimension,
      parts,
      i
    );
    attrs[i] = parts[i];
  }
  Object.defineProperty(parts, "location", {
    set: function(v) {
      if (Array.isArray(v)) {
        for (var i2 = 0; i2 < dimension; ++i2) {
          attrs[i2].location = v[i2];
        }
      } else {
        for (var i2 = 0; i2 < dimension; ++i2) {
          attrs[i2].location = v + i2;
        }
      }
      return v;
    },
    get: function() {
      var result = new Array(dimension);
      for (var i2 = 0; i2 < dimension; ++i2) {
        result[i2] = locations[index[i2]];
      }
      return result;
    },
    enumerable: true
  });
  parts.pointer = function(type, normalized, stride, offset) {
    type = type || gl.FLOAT;
    normalized = !!normalized;
    stride = stride || dimension * dimension;
    offset = offset || 0;
    for (var i2 = 0; i2 < dimension; ++i2) {
      var location2 = locations[index[i2]];
      gl.vertexAttribPointer(
        location2,
        dimension,
        type,
        normalized,
        stride,
        offset + i2 * dimension
      );
      gl.enableVertexAttribArray(location2);
    }
  };
  var scratch = new Array(dimension);
  var vertexAttrib = gl["vertexAttrib" + dimension + "fv"];
  Object.defineProperty(obj, name2, {
    set: function(x) {
      for (var i2 = 0; i2 < dimension; ++i2) {
        var loc = locations[index[i2]];
        gl.disableVertexAttribArray(loc);
        if (Array.isArray(x[0])) {
          vertexAttrib.call(gl, loc, x[i2]);
        } else {
          for (var j = 0; j < dimension; ++j) {
            scratch[j] = x[dimension * i2 + j];
          }
          vertexAttrib.call(gl, loc, scratch);
        }
      }
      return x;
    },
    get: function() {
      return parts;
    },
    enumerable: true
  });
}
function createAttributeWrapper$1(gl, wrapper, attributes, locations) {
  var obj = {};
  for (var i = 0, n = attributes.length; i < n; ++i) {
    var a = attributes[i];
    var name2 = a.name;
    var type = a.type;
    var locs = a.locations;
    switch (type) {
      case "bool":
      case "int":
      case "float":
        addVectorAttribute(
          gl,
          wrapper,
          locs[0],
          locations,
          1,
          obj,
          name2
        );
        break;
      default:
        if (type.indexOf("vec") >= 0) {
          var d = type.charCodeAt(type.length - 1) - 48;
          if (d < 2 || d > 4) {
            throw new GLError$2("", "Invalid data type for attribute " + name2 + ": " + type);
          }
          addVectorAttribute(
            gl,
            wrapper,
            locs[0],
            locations,
            d,
            obj,
            name2
          );
        } else if (type.indexOf("mat") >= 0) {
          var d = type.charCodeAt(type.length - 1) - 48;
          if (d < 2 || d > 4) {
            throw new GLError$2("", "Invalid data type for attribute " + name2 + ": " + type);
          }
          addMatrixAttribute(
            gl,
            wrapper,
            locs,
            locations,
            d,
            obj,
            name2
          );
        } else {
          throw new GLError$2("", "Unknown data type for attribute " + name2 + ": " + type);
        }
        break;
    }
  }
  return obj;
}
var shaderCache$1 = {};
var sprintf$1 = {};
(function(exports) {
  !function() {
    var re = {
      not_string: /[^s]/,
      not_bool: /[^t]/,
      not_type: /[^T]/,
      not_primitive: /[^v]/,
      number: /[diefg]/,
      numeric_arg: /[bcdiefguxX]/,
      json: /[j]/,
      not_json: /[^j]/,
      text: /^[^\x25]+/,
      modulo: /^\x25{2}/,
      placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
      key: /^([a-z_][a-z_\d]*)/i,
      key_access: /^\.([a-z_][a-z_\d]*)/i,
      index_access: /^\[(\d+)\]/,
      sign: /^[+-]/
    };
    function sprintf2(key) {
      return sprintf_format(sprintf_parse(key), arguments);
    }
    function vsprintf(fmt, argv) {
      return sprintf2.apply(null, [fmt].concat(argv || []));
    }
    function sprintf_format(parse_tree, argv) {
      var cursor = 1, tree_length = parse_tree.length, arg, output = "", i, k, ph, pad, pad_character, pad_length, is_positive, sign2;
      for (i = 0; i < tree_length; i++) {
        if (typeof parse_tree[i] === "string") {
          output += parse_tree[i];
        } else if (typeof parse_tree[i] === "object") {
          ph = parse_tree[i];
          if (ph.keys) {
            arg = argv[cursor];
            for (k = 0; k < ph.keys.length; k++) {
              if (arg == void 0) {
                throw new Error(sprintf2('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k - 1]));
              }
              arg = arg[ph.keys[k]];
            }
          } else if (ph.param_no) {
            arg = argv[ph.param_no];
          } else {
            arg = argv[cursor++];
          }
          if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) {
            arg = arg();
          }
          if (re.numeric_arg.test(ph.type) && (typeof arg !== "number" && isNaN(arg))) {
            throw new TypeError(sprintf2("[sprintf] expecting number but found %T", arg));
          }
          if (re.number.test(ph.type)) {
            is_positive = arg >= 0;
          }
          switch (ph.type) {
            case "b":
              arg = parseInt(arg, 10).toString(2);
              break;
            case "c":
              arg = String.fromCharCode(parseInt(arg, 10));
              break;
            case "d":
            case "i":
              arg = parseInt(arg, 10);
              break;
            case "j":
              arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0);
              break;
            case "e":
              arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential();
              break;
            case "f":
              arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg);
              break;
            case "g":
              arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg);
              break;
            case "o":
              arg = (parseInt(arg, 10) >>> 0).toString(8);
              break;
            case "s":
              arg = String(arg);
              arg = ph.precision ? arg.substring(0, ph.precision) : arg;
              break;
            case "t":
              arg = String(!!arg);
              arg = ph.precision ? arg.substring(0, ph.precision) : arg;
              break;
            case "T":
              arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase();
              arg = ph.precision ? arg.substring(0, ph.precision) : arg;
              break;
            case "u":
              arg = parseInt(arg, 10) >>> 0;
              break;
            case "v":
              arg = arg.valueOf();
              arg = ph.precision ? arg.substring(0, ph.precision) : arg;
              break;
            case "x":
              arg = (parseInt(arg, 10) >>> 0).toString(16);
              break;
            case "X":
              arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase();
              break;
          }
          if (re.json.test(ph.type)) {
            output += arg;
          } else {
            if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
              sign2 = is_positive ? "+" : "-";
              arg = arg.toString().replace(re.sign, "");
            } else {
              sign2 = "";
            }
            pad_character = ph.pad_char ? ph.pad_char === "0" ? "0" : ph.pad_char.charAt(1) : " ";
            pad_length = ph.width - (sign2 + arg).length;
            pad = ph.width ? pad_length > 0 ? pad_character.repeat(pad_length) : "" : "";
            output += ph.align ? sign2 + arg + pad : pad_character === "0" ? sign2 + pad + arg : pad + sign2 + arg;
          }
        }
      }
      return output;
    }
    var sprintf_cache = /* @__PURE__ */ Object.create(null);
    function sprintf_parse(fmt) {
      if (sprintf_cache[fmt]) {
        return sprintf_cache[fmt];
      }
      var _fmt = fmt, match, parse_tree = [], arg_names = 0;
      while (_fmt) {
        if ((match = re.text.exec(_fmt)) !== null) {
          parse_tree.push(match[0]);
        } else if ((match = re.modulo.exec(_fmt)) !== null) {
          parse_tree.push("%");
        } else if ((match = re.placeholder.exec(_fmt)) !== null) {
          if (match[2]) {
            arg_names |= 1;
            var field_list = [], replacement_field = match[2], field_match = [];
            if ((field_match = re.key.exec(replacement_field)) !== null) {
              field_list.push(field_match[1]);
              while ((replacement_field = replacement_field.substring(field_match[0].length)) !== "") {
                if ((field_match = re.key_access.exec(replacement_field)) !== null) {
                  field_list.push(field_match[1]);
                } else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
                  field_list.push(field_match[1]);
                } else {
                  throw new SyntaxError("[sprintf] failed to parse named argument key");
                }
              }
            } else {
              throw new SyntaxError("[sprintf] failed to parse named argument key");
            }
            match[2] = field_list;
          } else {
            arg_names |= 2;
          }
          if (arg_names === 3) {
            throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
          }
          parse_tree.push(
            {
              placeholder: match[0],
              param_no: match[1],
              keys: match[2],
              sign: match[3],
              pad_char: match[4],
              align: match[5],
              width: match[6],
              precision: match[7],
              type: match[8]
            }
          );
        } else {
          throw new SyntaxError("[sprintf] unexpected placeholder");
        }
        _fmt = _fmt.substring(match[0].length);
      }
      return sprintf_cache[fmt] = parse_tree;
    }
    {
      exports["sprintf"] = sprintf2;
      exports["vsprintf"] = vsprintf;
    }
    if (typeof window !== "undefined") {
      window["sprintf"] = sprintf2;
      window["vsprintf"] = vsprintf;
    }
  }();
})(sprintf$1);
var numbers = {
  0: "NONE",
  1: "ONE",
  2: "LINE_LOOP",
  3: "LINE_STRIP",
  4: "TRIANGLES",
  5: "TRIANGLE_STRIP",
  6: "TRIANGLE_FAN",
  256: "DEPTH_BUFFER_BIT",
  512: "NEVER",
  513: "LESS",
  514: "EQUAL",
  515: "LEQUAL",
  516: "GREATER",
  517: "NOTEQUAL",
  518: "GEQUAL",
  519: "ALWAYS",
  768: "SRC_COLOR",
  769: "ONE_MINUS_SRC_COLOR",
  770: "SRC_ALPHA",
  771: "ONE_MINUS_SRC_ALPHA",
  772: "DST_ALPHA",
  773: "ONE_MINUS_DST_ALPHA",
  774: "DST_COLOR",
  775: "ONE_MINUS_DST_COLOR",
  776: "SRC_ALPHA_SATURATE",
  1024: "STENCIL_BUFFER_BIT",
  1028: "FRONT",
  1029: "BACK",
  1032: "FRONT_AND_BACK",
  1280: "INVALID_ENUM",
  1281: "INVALID_VALUE",
  1282: "INVALID_OPERATION",
  1285: "OUT_OF_MEMORY",
  1286: "INVALID_FRAMEBUFFER_OPERATION",
  2304: "CW",
  2305: "CCW",
  2849: "LINE_WIDTH",
  2884: "CULL_FACE",
  2885: "CULL_FACE_MODE",
  2886: "FRONT_FACE",
  2928: "DEPTH_RANGE",
  2929: "DEPTH_TEST",
  2930: "DEPTH_WRITEMASK",
  2931: "DEPTH_CLEAR_VALUE",
  2932: "DEPTH_FUNC",
  2960: "STENCIL_TEST",
  2961: "STENCIL_CLEAR_VALUE",
  2962: "STENCIL_FUNC",
  2963: "STENCIL_VALUE_MASK",
  2964: "STENCIL_FAIL",
  2965: "STENCIL_PASS_DEPTH_FAIL",
  2966: "STENCIL_PASS_DEPTH_PASS",
  2967: "STENCIL_REF",
  2968: "STENCIL_WRITEMASK",
  2978: "VIEWPORT",
  3024: "DITHER",
  3042: "BLEND",
  3088: "SCISSOR_BOX",
  3089: "SCISSOR_TEST",
  3106: "COLOR_CLEAR_VALUE",
  3107: "COLOR_WRITEMASK",
  3317: "UNPACK_ALIGNMENT",
  3333: "PACK_ALIGNMENT",
  3379: "MAX_TEXTURE_SIZE",
  3386: "MAX_VIEWPORT_DIMS",
  3408: "SUBPIXEL_BITS",
  3410: "RED_BITS",
  3411: "GREEN_BITS",
  3412: "BLUE_BITS",
  3413: "ALPHA_BITS",
  3414: "DEPTH_BITS",
  3415: "STENCIL_BITS",
  3553: "TEXTURE_2D",
  4352: "DONT_CARE",
  4353: "FASTEST",
  4354: "NICEST",
  5120: "BYTE",
  5121: "UNSIGNED_BYTE",
  5122: "SHORT",
  5123: "UNSIGNED_SHORT",
  5124: "INT",
  5125: "UNSIGNED_INT",
  5126: "FLOAT",
  5386: "INVERT",
  5890: "TEXTURE",
  6401: "STENCIL_INDEX",
  6402: "DEPTH_COMPONENT",
  6406: "ALPHA",
  6407: "RGB",
  6408: "RGBA",
  6409: "LUMINANCE",
  6410: "LUMINANCE_ALPHA",
  7680: "KEEP",
  7681: "REPLACE",
  7682: "INCR",
  7683: "DECR",
  7936: "VENDOR",
  7937: "RENDERER",
  7938: "VERSION",
  9728: "NEAREST",
  9729: "LINEAR",
  9984: "NEAREST_MIPMAP_NEAREST",
  9985: "LINEAR_MIPMAP_NEAREST",
  9986: "NEAREST_MIPMAP_LINEAR",
  9987: "LINEAR_MIPMAP_LINEAR",
  10240: "TEXTURE_MAG_FILTER",
  10241: "TEXTURE_MIN_FILTER",
  10242: "TEXTURE_WRAP_S",
  10243: "TEXTURE_WRAP_T",
  10497: "REPEAT",
  10752: "POLYGON_OFFSET_UNITS",
  16384: "COLOR_BUFFER_BIT",
  32769: "CONSTANT_COLOR",
  32770: "ONE_MINUS_CONSTANT_COLOR",
  32771: "CONSTANT_ALPHA",
  32772: "ONE_MINUS_CONSTANT_ALPHA",
  32773: "BLEND_COLOR",
  32774: "FUNC_ADD",
  32777: "BLEND_EQUATION_RGB",
  32778: "FUNC_SUBTRACT",
  32779: "FUNC_REVERSE_SUBTRACT",
  32819: "UNSIGNED_SHORT_4_4_4_4",
  32820: "UNSIGNED_SHORT_5_5_5_1",
  32823: "POLYGON_OFFSET_FILL",
  32824: "POLYGON_OFFSET_FACTOR",
  32854: "RGBA4",
  32855: "RGB5_A1",
  32873: "TEXTURE_BINDING_2D",
  32926: "SAMPLE_ALPHA_TO_COVERAGE",
  32928: "SAMPLE_COVERAGE",
  32936: "SAMPLE_BUFFERS",
  32937: "SAMPLES",
  32938: "SAMPLE_COVERAGE_VALUE",
  32939: "SAMPLE_COVERAGE_INVERT",
  32968: "BLEND_DST_RGB",
  32969: "BLEND_SRC_RGB",
  32970: "BLEND_DST_ALPHA",
  32971: "BLEND_SRC_ALPHA",
  33071: "CLAMP_TO_EDGE",
  33170: "GENERATE_MIPMAP_HINT",
  33189: "DEPTH_COMPONENT16",
  33306: "DEPTH_STENCIL_ATTACHMENT",
  33635: "UNSIGNED_SHORT_5_6_5",
  33648: "MIRRORED_REPEAT",
  33901: "ALIASED_POINT_SIZE_RANGE",
  33902: "ALIASED_LINE_WIDTH_RANGE",
  33984: "TEXTURE0",
  33985: "TEXTURE1",
  33986: "TEXTURE2",
  33987: "TEXTURE3",
  33988: "TEXTURE4",
  33989: "TEXTURE5",
  33990: "TEXTURE6",
  33991: "TEXTURE7",
  33992: "TEXTURE8",
  33993: "TEXTURE9",
  33994: "TEXTURE10",
  33995: "TEXTURE11",
  33996: "TEXTURE12",
  33997: "TEXTURE13",
  33998: "TEXTURE14",
  33999: "TEXTURE15",
  34e3: "TEXTURE16",
  34001: "TEXTURE17",
  34002: "TEXTURE18",
  34003: "TEXTURE19",
  34004: "TEXTURE20",
  34005: "TEXTURE21",
  34006: "TEXTURE22",
  34007: "TEXTURE23",
  34008: "TEXTURE24",
  34009: "TEXTURE25",
  34010: "TEXTURE26",
  34011: "TEXTURE27",
  34012: "TEXTURE28",
  34013: "TEXTURE29",
  34014: "TEXTURE30",
  34015: "TEXTURE31",
  34016: "ACTIVE_TEXTURE",
  34024: "MAX_RENDERBUFFER_SIZE",
  34041: "DEPTH_STENCIL",
  34055: "INCR_WRAP",
  34056: "DECR_WRAP",
  34067: "TEXTURE_CUBE_MAP",
  34068: "TEXTURE_BINDING_CUBE_MAP",
  34069: "TEXTURE_CUBE_MAP_POSITIVE_X",
  34070: "TEXTURE_CUBE_MAP_NEGATIVE_X",
  34071: "TEXTURE_CUBE_MAP_POSITIVE_Y",
  34072: "TEXTURE_CUBE_MAP_NEGATIVE_Y",
  34073: "TEXTURE_CUBE_MAP_POSITIVE_Z",
  34074: "TEXTURE_CUBE_MAP_NEGATIVE_Z",
  34076: "MAX_CUBE_MAP_TEXTURE_SIZE",
  34338: "VERTEX_ATTRIB_ARRAY_ENABLED",
  34339: "VERTEX_ATTRIB_ARRAY_SIZE",
  34340: "VERTEX_ATTRIB_ARRAY_STRIDE",
  34341: "VERTEX_ATTRIB_ARRAY_TYPE",
  34342: "CURRENT_VERTEX_ATTRIB",
  34373: "VERTEX_ATTRIB_ARRAY_POINTER",
  34466: "NUM_COMPRESSED_TEXTURE_FORMATS",
  34467: "COMPRESSED_TEXTURE_FORMATS",
  34660: "BUFFER_SIZE",
  34661: "BUFFER_USAGE",
  34816: "STENCIL_BACK_FUNC",
  34817: "STENCIL_BACK_FAIL",
  34818: "STENCIL_BACK_PASS_DEPTH_FAIL",
  34819: "STENCIL_BACK_PASS_DEPTH_PASS",
  34877: "BLEND_EQUATION_ALPHA",
  34921: "MAX_VERTEX_ATTRIBS",
  34922: "VERTEX_ATTRIB_ARRAY_NORMALIZED",
  34930: "MAX_TEXTURE_IMAGE_UNITS",
  34962: "ARRAY_BUFFER",
  34963: "ELEMENT_ARRAY_BUFFER",
  34964: "ARRAY_BUFFER_BINDING",
  34965: "ELEMENT_ARRAY_BUFFER_BINDING",
  34975: "VERTEX_ATTRIB_ARRAY_BUFFER_BINDING",
  35040: "STREAM_DRAW",
  35044: "STATIC_DRAW",
  35048: "DYNAMIC_DRAW",
  35632: "FRAGMENT_SHADER",
  35633: "VERTEX_SHADER",
  35660: "MAX_VERTEX_TEXTURE_IMAGE_UNITS",
  35661: "MAX_COMBINED_TEXTURE_IMAGE_UNITS",
  35663: "SHADER_TYPE",
  35664: "FLOAT_VEC2",
  35665: "FLOAT_VEC3",
  35666: "FLOAT_VEC4",
  35667: "INT_VEC2",
  35668: "INT_VEC3",
  35669: "INT_VEC4",
  35670: "BOOL",
  35671: "BOOL_VEC2",
  35672: "BOOL_VEC3",
  35673: "BOOL_VEC4",
  35674: "FLOAT_MAT2",
  35675: "FLOAT_MAT3",
  35676: "FLOAT_MAT4",
  35678: "SAMPLER_2D",
  35680: "SAMPLER_CUBE",
  35712: "DELETE_STATUS",
  35713: "COMPILE_STATUS",
  35714: "LINK_STATUS",
  35715: "VALIDATE_STATUS",
  35716: "INFO_LOG_LENGTH",
  35717: "ATTACHED_SHADERS",
  35718: "ACTIVE_UNIFORMS",
  35719: "ACTIVE_UNIFORM_MAX_LENGTH",
  35720: "SHADER_SOURCE_LENGTH",
  35721: "ACTIVE_ATTRIBUTES",
  35722: "ACTIVE_ATTRIBUTE_MAX_LENGTH",
  35724: "SHADING_LANGUAGE_VERSION",
  35725: "CURRENT_PROGRAM",
  36003: "STENCIL_BACK_REF",
  36004: "STENCIL_BACK_VALUE_MASK",
  36005: "STENCIL_BACK_WRITEMASK",
  36006: "FRAMEBUFFER_BINDING",
  36007: "RENDERBUFFER_BINDING",
  36048: "FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE",
  36049: "FRAMEBUFFER_ATTACHMENT_OBJECT_NAME",
  36050: "FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL",
  36051: "FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE",
  36053: "FRAMEBUFFER_COMPLETE",
  36054: "FRAMEBUFFER_INCOMPLETE_ATTACHMENT",
  36055: "FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT",
  36057: "FRAMEBUFFER_INCOMPLETE_DIMENSIONS",
  36061: "FRAMEBUFFER_UNSUPPORTED",
  36064: "COLOR_ATTACHMENT0",
  36096: "DEPTH_ATTACHMENT",
  36128: "STENCIL_ATTACHMENT",
  36160: "FRAMEBUFFER",
  36161: "RENDERBUFFER",
  36162: "RENDERBUFFER_WIDTH",
  36163: "RENDERBUFFER_HEIGHT",
  36164: "RENDERBUFFER_INTERNAL_FORMAT",
  36168: "STENCIL_INDEX8",
  36176: "RENDERBUFFER_RED_SIZE",
  36177: "RENDERBUFFER_GREEN_SIZE",
  36178: "RENDERBUFFER_BLUE_SIZE",
  36179: "RENDERBUFFER_ALPHA_SIZE",
  36180: "RENDERBUFFER_DEPTH_SIZE",
  36181: "RENDERBUFFER_STENCIL_SIZE",
  36194: "RGB565",
  36336: "LOW_FLOAT",
  36337: "MEDIUM_FLOAT",
  36338: "HIGH_FLOAT",
  36339: "LOW_INT",
  36340: "MEDIUM_INT",
  36341: "HIGH_INT",
  36346: "SHADER_COMPILER",
  36347: "MAX_VERTEX_UNIFORM_VECTORS",
  36348: "MAX_VARYING_VECTORS",
  36349: "MAX_FRAGMENT_UNIFORM_VECTORS",
  37440: "UNPACK_FLIP_Y_WEBGL",
  37441: "UNPACK_PREMULTIPLY_ALPHA_WEBGL",
  37442: "CONTEXT_LOST_WEBGL",
  37443: "UNPACK_COLORSPACE_CONVERSION_WEBGL",
  37444: "BROWSER_DEFAULT_WEBGL"
};
var gl10 = numbers;
var lookup = function lookupConstant(number) {
  return gl10[number];
};
var literals = [
  // current
  "precision",
  "highp",
  "mediump",
  "lowp",
  "attribute",
  "const",
  "uniform",
  "varying",
  "break",
  "continue",
  "do",
  "for",
  "while",
  "if",
  "else",
  "in",
  "out",
  "inout",
  "float",
  "int",
  "uint",
  "void",
  "bool",
  "true",
  "false",
  "discard",
  "return",
  "mat2",
  "mat3",
  "mat4",
  "vec2",
  "vec3",
  "vec4",
  "ivec2",
  "ivec3",
  "ivec4",
  "bvec2",
  "bvec3",
  "bvec4",
  "sampler1D",
  "sampler2D",
  "sampler3D",
  "samplerCube",
  "sampler1DShadow",
  "sampler2DShadow",
  "struct",
  "asm",
  "class",
  "union",
  "enum",
  "typedef",
  "template",
  "this",
  "packed",
  "goto",
  "switch",
  "default",
  "inline",
  "noinline",
  "volatile",
  "public",
  "static",
  "extern",
  "external",
  "interface",
  "long",
  "short",
  "double",
  "half",
  "fixed",
  "unsigned",
  "input",
  "output",
  "hvec2",
  "hvec3",
  "hvec4",
  "dvec2",
  "dvec3",
  "dvec4",
  "fvec2",
  "fvec3",
  "fvec4",
  "sampler2DRect",
  "sampler3DRect",
  "sampler2DRectShadow",
  "sizeof",
  "cast",
  "namespace",
  "using"
];
var operators$1 = [
  "<<=",
  ">>=",
  "++",
  "--",
  "<<",
  ">>",
  "<=",
  ">=",
  "==",
  "!=",
  "&&",
  "||",
  "+=",
  "-=",
  "*=",
  "/=",
  "%=",
  "&=",
  "^^",
  "^=",
  "|=",
  "(",
  ")",
  "[",
  "]",
  ".",
  "!",
  "~",
  "*",
  "/",
  "%",
  "+",
  "-",
  "<",
  ">",
  "&",
  "^",
  "|",
  "?",
  ":",
  "=",
  ",",
  ";",
  "{",
  "}"
];
var builtins = [
  // Keep this list sorted
  "abs",
  "acos",
  "all",
  "any",
  "asin",
  "atan",
  "ceil",
  "clamp",
  "cos",
  "cross",
  "dFdx",
  "dFdy",
  "degrees",
  "distance",
  "dot",
  "equal",
  "exp",
  "exp2",
  "faceforward",
  "floor",
  "fract",
  "gl_BackColor",
  "gl_BackLightModelProduct",
  "gl_BackLightProduct",
  "gl_BackMaterial",
  "gl_BackSecondaryColor",
  "gl_ClipPlane",
  "gl_ClipVertex",
  "gl_Color",
  "gl_DepthRange",
  "gl_DepthRangeParameters",
  "gl_EyePlaneQ",
  "gl_EyePlaneR",
  "gl_EyePlaneS",
  "gl_EyePlaneT",
  "gl_Fog",
  "gl_FogCoord",
  "gl_FogFragCoord",
  "gl_FogParameters",
  "gl_FragColor",
  "gl_FragCoord",
  "gl_FragData",
  "gl_FragDepth",
  "gl_FragDepthEXT",
  "gl_FrontColor",
  "gl_FrontFacing",
  "gl_FrontLightModelProduct",
  "gl_FrontLightProduct",
  "gl_FrontMaterial",
  "gl_FrontSecondaryColor",
  "gl_LightModel",
  "gl_LightModelParameters",
  "gl_LightModelProducts",
  "gl_LightProducts",
  "gl_LightSource",
  "gl_LightSourceParameters",
  "gl_MaterialParameters",
  "gl_MaxClipPlanes",
  "gl_MaxCombinedTextureImageUnits",
  "gl_MaxDrawBuffers",
  "gl_MaxFragmentUniformComponents",
  "gl_MaxLights",
  "gl_MaxTextureCoords",
  "gl_MaxTextureImageUnits",
  "gl_MaxTextureUnits",
  "gl_MaxVaryingFloats",
  "gl_MaxVertexAttribs",
  "gl_MaxVertexTextureImageUnits",
  "gl_MaxVertexUniformComponents",
  "gl_ModelViewMatrix",
  "gl_ModelViewMatrixInverse",
  "gl_ModelViewMatrixInverseTranspose",
  "gl_ModelViewMatrixTranspose",
  "gl_ModelViewProjectionMatrix",
  "gl_ModelViewProjectionMatrixInverse",
  "gl_ModelViewProjectionMatrixInverseTranspose",
  "gl_ModelViewProjectionMatrixTranspose",
  "gl_MultiTexCoord0",
  "gl_MultiTexCoord1",
  "gl_MultiTexCoord2",
  "gl_MultiTexCoord3",
  "gl_MultiTexCoord4",
  "gl_MultiTexCoord5",
  "gl_MultiTexCoord6",
  "gl_MultiTexCoord7",
  "gl_Normal",
  "gl_NormalMatrix",
  "gl_NormalScale",
  "gl_ObjectPlaneQ",
  "gl_ObjectPlaneR",
  "gl_ObjectPlaneS",
  "gl_ObjectPlaneT",
  "gl_Point",
  "gl_PointCoord",
  "gl_PointParameters",
  "gl_PointSize",
  "gl_Position",
  "gl_ProjectionMatrix",
  "gl_ProjectionMatrixInverse",
  "gl_ProjectionMatrixInverseTranspose",
  "gl_ProjectionMatrixTranspose",
  "gl_SecondaryColor",
  "gl_TexCoord",
  "gl_TextureEnvColor",
  "gl_TextureMatrix",
  "gl_TextureMatrixInverse",
  "gl_TextureMatrixInverseTranspose",
  "gl_TextureMatrixTranspose",
  "gl_Vertex",
  "greaterThan",
  "greaterThanEqual",
  "inversesqrt",
  "length",
  "lessThan",
  "lessThanEqual",
  "log",
  "log2",
  "matrixCompMult",
  "max",
  "min",
  "mix",
  "mod",
  "normalize",
  "not",
  "notEqual",
  "pow",
  "radians",
  "reflect",
  "refract",
  "sign",
  "sin",
  "smoothstep",
  "sqrt",
  "step",
  "tan",
  "texture2D",
  "texture2DLod",
  "texture2DProj",
  "texture2DProjLod",
  "textureCube",
  "textureCubeLod",
  "texture2DLodEXT",
  "texture2DProjLodEXT",
  "textureCubeLodEXT",
  "texture2DGradEXT",
  "texture2DProjGradEXT",
  "textureCubeGradEXT"
];
var v100$1 = literals;
var literals300es$1 = v100$1.slice().concat([
  "layout",
  "centroid",
  "smooth",
  "case",
  "mat2x2",
  "mat2x3",
  "mat2x4",
  "mat3x2",
  "mat3x3",
  "mat3x4",
  "mat4x2",
  "mat4x3",
  "mat4x4",
  "uvec2",
  "uvec3",
  "uvec4",
  "samplerCubeShadow",
  "sampler2DArray",
  "sampler2DArrayShadow",
  "isampler2D",
  "isampler3D",
  "isamplerCube",
  "isampler2DArray",
  "usampler2D",
  "usampler3D",
  "usamplerCube",
  "usampler2DArray",
  "coherent",
  "restrict",
  "readonly",
  "writeonly",
  "resource",
  "atomic_uint",
  "noperspective",
  "patch",
  "sample",
  "subroutine",
  "common",
  "partition",
  "active",
  "filter",
  "image1D",
  "image2D",
  "image3D",
  "imageCube",
  "iimage1D",
  "iimage2D",
  "iimage3D",
  "iimageCube",
  "uimage1D",
  "uimage2D",
  "uimage3D",
  "uimageCube",
  "image1DArray",
  "image2DArray",
  "iimage1DArray",
  "iimage2DArray",
  "uimage1DArray",
  "uimage2DArray",
  "image1DShadow",
  "image2DShadow",
  "image1DArrayShadow",
  "image2DArrayShadow",
  "imageBuffer",
  "iimageBuffer",
  "uimageBuffer",
  "sampler1DArray",
  "sampler1DArrayShadow",
  "isampler1D",
  "isampler1DArray",
  "usampler1D",
  "usampler1DArray",
  "isampler2DRect",
  "usampler2DRect",
  "samplerBuffer",
  "isamplerBuffer",
  "usamplerBuffer",
  "sampler2DMS",
  "isampler2DMS",
  "usampler2DMS",
  "sampler2DMSArray",
  "isampler2DMSArray",
  "usampler2DMSArray"
]);
var v100 = builtins;
v100 = v100.slice().filter(function(b) {
  return !/^(gl\_|texture)/.test(b);
});
var builtins300es$1 = v100.concat([
  // the updated gl_ constants
  "gl_VertexID",
  "gl_InstanceID",
  "gl_Position",
  "gl_PointSize",
  "gl_FragCoord",
  "gl_FrontFacing",
  "gl_FragDepth",
  "gl_PointCoord",
  "gl_MaxVertexAttribs",
  "gl_MaxVertexUniformVectors",
  "gl_MaxVertexOutputVectors",
  "gl_MaxFragmentInputVectors",
  "gl_MaxVertexTextureImageUnits",
  "gl_MaxCombinedTextureImageUnits",
  "gl_MaxTextureImageUnits",
  "gl_MaxFragmentUniformVectors",
  "gl_MaxDrawBuffers",
  "gl_MinProgramTexelOffset",
  "gl_MaxProgramTexelOffset",
  "gl_DepthRangeParameters",
  "gl_DepthRange",
  "trunc",
  "round",
  "roundEven",
  "isnan",
  "isinf",
  "floatBitsToInt",
  "floatBitsToUint",
  "intBitsToFloat",
  "uintBitsToFloat",
  "packSnorm2x16",
  "unpackSnorm2x16",
  "packUnorm2x16",
  "unpackUnorm2x16",
  "packHalf2x16",
  "unpackHalf2x16",
  "outerProduct",
  "transpose",
  "determinant",
  "inverse",
  "texture",
  "textureSize",
  "textureProj",
  "textureLod",
  "textureOffset",
  "texelFetch",
  "texelFetchOffset",
  "textureProjOffset",
  "textureLodOffset",
  "textureProjLod",
  "textureProjLodOffset",
  "textureGrad",
  "textureGradOffset",
  "textureProjGrad",
  "textureProjGradOffset"
]);
var glslTokenizer = tokenize$2;
var literals100 = literals, operators = operators$1, builtins100 = builtins, literals300es = literals300es$1, builtins300es = builtins300es$1;
var NORMAL = 999, TOKEN = 9999, BLOCK_COMMENT = 0, LINE_COMMENT = 1, PREPROCESSOR = 2, OPERATOR = 3, INTEGER = 4, FLOAT = 5, IDENT = 6, BUILTIN = 7, KEYWORD = 8, WHITESPACE = 9, EOF = 10, HEX = 11;
var map = [
  "block-comment",
  "line-comment",
  "preprocessor",
  "operator",
  "integer",
  "float",
  "ident",
  "builtin",
  "keyword",
  "whitespace",
  "eof",
  "integer"
];
function tokenize$2(opt) {
  var i = 0, total = 0, mode = NORMAL, c, last, content = [], tokens = [], line = 1, col = 0, start = 0, isnum = false, isoperator = false, input = "", len;
  opt = opt || {};
  var allBuiltins = builtins100;
  var allLiterals = literals100;
  if (opt.version === "300 es") {
    allBuiltins = builtins300es;
    allLiterals = literals300es;
  }
  var builtinsDict = {}, literalsDict = {};
  for (var i = 0; i < allBuiltins.length; i++) {
    builtinsDict[allBuiltins[i]] = true;
  }
  for (var i = 0; i < allLiterals.length; i++) {
    literalsDict[allLiterals[i]] = true;
  }
  return function(data) {
    tokens = [];
    if (data !== null) return write(data);
    return end();
  };
  function token(data) {
    if (data.length) {
      tokens.push({
        type: map[mode],
        data,
        position: start,
        line,
        column: col
      });
    }
  }
  function write(chunk) {
    i = 0;
    if (chunk.toString) chunk = chunk.toString();
    input += chunk.replace(/\r\n/g, "\n");
    len = input.length;
    var last2;
    while (c = input[i], i < len) {
      last2 = i;
      switch (mode) {
        case BLOCK_COMMENT:
          i = block_comment();
          break;
        case LINE_COMMENT:
          i = line_comment();
          break;
        case PREPROCESSOR:
          i = preprocessor();
          break;
        case OPERATOR:
          i = operator();
          break;
        case INTEGER:
          i = integer();
          break;
        case HEX:
          i = hex();
          break;
        case FLOAT:
          i = decimal();
          break;
        case TOKEN:
          i = readtoken();
          break;
        case WHITESPACE:
          i = whitespace();
          break;
        case NORMAL:
          i = normal();
          break;
      }
      if (last2 !== i) {
        switch (input[last2]) {
          case "\n":
            col = 0;
            ++line;
            break;
          default:
            ++col;
            break;
        }
      }
    }
    total += i;
    input = input.slice(i);
    return tokens;
  }
  function end(chunk) {
    if (content.length) {
      token(content.join(""));
    }
    mode = EOF;
    token("(eof)");
    return tokens;
  }
  function normal() {
    content = content.length ? [] : content;
    if (last === "/" && c === "*") {
      start = total + i - 1;
      mode = BLOCK_COMMENT;
      last = c;
      return i + 1;
    }
    if (last === "/" && c === "/") {
      start = total + i - 1;
      mode = LINE_COMMENT;
      last = c;
      return i + 1;
    }
    if (c === "#") {
      mode = PREPROCESSOR;
      start = total + i;
      return i;
    }
    if (/\s/.test(c)) {
      mode = WHITESPACE;
      start = total + i;
      return i;
    }
    isnum = /\d/.test(c);
    isoperator = /[^\w_]/.test(c);
    start = total + i;
    mode = isnum ? INTEGER : isoperator ? OPERATOR : TOKEN;
    return i;
  }
  function whitespace() {
    if (/[^\s]/g.test(c)) {
      token(content.join(""));
      mode = NORMAL;
      return i;
    }
    content.push(c);
    last = c;
    return i + 1;
  }
  function preprocessor() {
    if ((c === "\r" || c === "\n") && last !== "\\") {
      token(content.join(""));
      mode = NORMAL;
      return i;
    }
    content.push(c);
    last = c;
    return i + 1;
  }
  function line_comment() {
    return preprocessor();
  }
  function block_comment() {
    if (c === "/" && last === "*") {
      content.push(c);
      token(content.join(""));
      mode = NORMAL;
      return i + 1;
    }
    content.push(c);
    last = c;
    return i + 1;
  }
  function operator() {
    if (last === "." && /\d/.test(c)) {
      mode = FLOAT;
      return i;
    }
    if (last === "/" && c === "*") {
      mode = BLOCK_COMMENT;
      return i;
    }
    if (last === "/" && c === "/") {
      mode = LINE_COMMENT;
      return i;
    }
    if (c === "." && content.length) {
      while (determine_operator(content)) ;
      mode = FLOAT;
      return i;
    }
    if (c === ";" || c === ")" || c === "(") {
      if (content.length) while (determine_operator(content)) ;
      token(c);
      mode = NORMAL;
      return i + 1;
    }
    var is_composite_operator = content.length === 2 && c !== "=";
    if (/[\w_\d\s]/.test(c) || is_composite_operator) {
      while (determine_operator(content)) ;
      mode = NORMAL;
      return i;
    }
    content.push(c);
    last = c;
    return i + 1;
  }
  function determine_operator(buf) {
    var j = 0, idx, res2;
    do {
      idx = operators.indexOf(buf.slice(0, buf.length + j).join(""));
      res2 = operators[idx];
      if (idx === -1) {
        if (j-- + buf.length > 0) continue;
        res2 = buf.slice(0, 1).join("");
      }
      token(res2);
      start += res2.length;
      content = content.slice(res2.length);
      return content.length;
    } while (1);
  }
  function hex() {
    if (/[^a-fA-F0-9]/.test(c)) {
      token(content.join(""));
      mode = NORMAL;
      return i;
    }
    content.push(c);
    last = c;
    return i + 1;
  }
  function integer() {
    if (c === ".") {
      content.push(c);
      mode = FLOAT;
      last = c;
      return i + 1;
    }
    if (/[eE]/.test(c)) {
      content.push(c);
      mode = FLOAT;
      last = c;
      return i + 1;
    }
    if (c === "x" && content.length === 1 && content[0] === "0") {
      mode = HEX;
      content.push(c);
      last = c;
      return i + 1;
    }
    if (/[^\d]/.test(c)) {
      token(content.join(""));
      mode = NORMAL;
      return i;
    }
    content.push(c);
    last = c;
    return i + 1;
  }
  function decimal() {
    if (c === "f") {
      content.push(c);
      last = c;
      i += 1;
    }
    if (/[eE]/.test(c)) {
      content.push(c);
      last = c;
      return i + 1;
    }
    if ((c === "-" || c === "+") && /[eE]/.test(last)) {
      content.push(c);
      last = c;
      return i + 1;
    }
    if (/[^\d]/.test(c)) {
      token(content.join(""));
      mode = NORMAL;
      return i;
    }
    content.push(c);
    last = c;
    return i + 1;
  }
  function readtoken() {
    if (/[^\d\w_]/.test(c)) {
      var contentstr = content.join("");
      if (literalsDict[contentstr]) {
        mode = KEYWORD;
      } else if (builtinsDict[contentstr]) {
        mode = BUILTIN;
      } else {
        mode = IDENT;
      }
      token(content.join(""));
      mode = NORMAL;
      return i;
    }
    content.push(c);
    last = c;
    return i + 1;
  }
}
var tokenize$1 = glslTokenizer;
var string = tokenizeString;
function tokenizeString(str, opt) {
  var generator = tokenize$1(opt);
  var tokens = [];
  tokens = tokens.concat(generator(str));
  tokens = tokens.concat(generator(null));
  return tokens;
}
var atobBrowser = function _atob(str) {
  return atob(str);
};
var tokenize = string;
var atob$1 = atobBrowser;
var glslShaderName = getName;
function getName(src) {
  var tokens = Array.isArray(src) ? src : tokenize(src);
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];
    if (token.type !== "preprocessor") continue;
    var match = token.data.match(/\#define\s+SHADER_NAME(_B64)?\s+(.+)$/);
    if (!match) continue;
    if (!match[2]) continue;
    var b642 = match[1];
    var name2 = match[2];
    return (b642 ? atob$1(name2) : name2).trim();
  }
}
/*!
 * repeat-string <https://github.com/jonschlinkert/repeat-string>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */
var res = "";
var cache;
var repeatString = repeat$1;
function repeat$1(str, num) {
  if (typeof str !== "string") {
    throw new TypeError("expected a string");
  }
  if (num === 1) return str;
  if (num === 2) return str + str;
  var max2 = str.length * num;
  if (cache !== str || typeof cache === "undefined") {
    cache = str;
    res = "";
  } else if (res.length >= max2) {
    return res.substr(0, max2);
  }
  while (max2 > res.length && num > 1) {
    if (num & 1) {
      res += str;
    }
    num >>= 1;
    str += str;
  }
  res += str;
  res = res.substr(0, max2);
  return res;
}
/*!
 * pad-left <https://github.com/jonschlinkert/pad-left>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT license.
 */
var repeat = repeatString;
var padLeft$1 = function padLeft(str, num, ch) {
  ch = typeof ch !== "undefined" ? ch + "" : " ";
  return repeat(ch, num) + str;
};
var padLeft2 = padLeft$1;
var addLineNumbers_1 = addLineNumbers$1;
function addLineNumbers$1(string2, start, delim) {
  start = typeof start === "number" ? start : 1;
  delim = delim || ": ";
  var lines = string2.split(/\r?\n/);
  var totalDigits = String(lines.length + start - 1).length;
  return lines.map(function(line, i) {
    var c = i + start;
    var digits = String(c).length;
    var prefix = padLeft2(c, totalDigits - digits);
    return prefix + delim + line;
  }).join("\n");
}
var sprintf = sprintf$1.sprintf;
var glConstants = lookup;
var shaderName = glslShaderName;
var addLineNumbers = addLineNumbers_1;
var glFormatCompilerError = formatCompilerError$1;
function formatCompilerError$1(errLog, src, type) {
  var name2 = shaderName(src) || "of unknown name (see npm glsl-shader-name)";
  var typeName = "unknown type";
  if (type !== void 0) {
    typeName = type === glConstants.FRAGMENT_SHADER ? "fragment" : "vertex";
  }
  var longForm = sprintf("Error compiling %s shader %s:\n", typeName, name2);
  var shortForm = sprintf("%s%s", longForm, errLog);
  var errorStrings = errLog.split("\n");
  var errors = {};
  for (var i = 0; i < errorStrings.length; i++) {
    var errorString = errorStrings[i];
    if (errorString === "" || errorString === "\0") continue;
    var lineNo = parseInt(errorString.split(":")[2]);
    if (isNaN(lineNo)) {
      throw new Error(sprintf("Could not parse error: %s", errorString));
    }
    errors[lineNo] = errorString;
  }
  var lines = addLineNumbers(src).split("\n");
  for (var i = 0; i < lines.length; i++) {
    if (!errors[i + 3] && !errors[i + 2] && !errors[i + 1]) continue;
    var line = lines[i];
    longForm += line + "\n";
    if (errors[i + 1]) {
      var e = errors[i + 1];
      e = e.substr(e.split(":", 3).join(":").length + 1).trim();
      longForm += sprintf("^^^ %s\n\n", e);
    }
  }
  return {
    long: longForm.trim(),
    short: shortForm.trim()
  };
}
var hiddenStore_1;
var hasRequiredHiddenStore;
function requireHiddenStore() {
  if (hasRequiredHiddenStore) return hiddenStore_1;
  hasRequiredHiddenStore = 1;
  hiddenStore_1 = hiddenStore;
  function hiddenStore(obj, key) {
    var store = { identity: key };
    var valueOf = obj.valueOf;
    Object.defineProperty(obj, "valueOf", {
      value: function(value) {
        return value !== key ? valueOf.apply(this, arguments) : store;
      },
      writable: true
    });
    return store;
  }
  return hiddenStore_1;
}
var createStore_1;
var hasRequiredCreateStore;
function requireCreateStore() {
  if (hasRequiredCreateStore) return createStore_1;
  hasRequiredCreateStore = 1;
  var hiddenStore = requireHiddenStore();
  createStore_1 = createStore;
  function createStore() {
    var key = {};
    return function(obj) {
      if ((typeof obj !== "object" || obj === null) && typeof obj !== "function") {
        throw new Error("Weakmap-shim: Key must be object");
      }
      var store = obj.valueOf(key);
      return store && store.identity === key ? store : hiddenStore(obj, key);
    };
  }
  return createStore_1;
}
var weakmapShim;
var hasRequiredWeakmapShim;
function requireWeakmapShim() {
  if (hasRequiredWeakmapShim) return weakmapShim;
  hasRequiredWeakmapShim = 1;
  var createStore = requireCreateStore();
  weakmapShim = weakMap2;
  function weakMap2() {
    var privates = createStore();
    return {
      "get": function(key, fallback) {
        var store = privates(key);
        return store.hasOwnProperty("value") ? store.value : fallback;
      },
      "set": function(key, value) {
        privates(key).value = value;
        return this;
      },
      "has": function(key) {
        return "value" in privates(key);
      },
      "delete": function(key) {
        return delete privates(key).value;
      }
    };
  }
  return weakmapShim;
}
shaderCache$1.shader = getShaderReference;
shaderCache$1.program = createProgram;
var GLError$1 = GLError_1;
var formatCompilerError = glFormatCompilerError;
var weakMap = typeof WeakMap === "undefined" ? requireWeakmapShim() : WeakMap;
var CACHE = new weakMap();
var SHADER_COUNTER = 0;
function ShaderReference(id, src, type, shader, programs, count, cache2) {
  this.id = id;
  this.src = src;
  this.type = type;
  this.shader = shader;
  this.count = count;
  this.programs = [];
  this.cache = cache2;
}
ShaderReference.prototype.dispose = function() {
  if (--this.count === 0) {
    var cache2 = this.cache;
    var gl = cache2.gl;
    var programs = this.programs;
    for (var i = 0, n = programs.length; i < n; ++i) {
      var p = cache2.programs[programs[i]];
      if (p) {
        delete cache2.programs[i];
        gl.deleteProgram(p);
      }
    }
    gl.deleteShader(this.shader);
    delete cache2.shaders[this.type === gl.FRAGMENT_SHADER | 0][this.src];
  }
};
function ContextCache(gl) {
  this.gl = gl;
  this.shaders = [{}, {}];
  this.programs = {};
}
var proto$2 = ContextCache.prototype;
function compileShader(gl, type, src) {
  var shader = gl.createShader(type);
  gl.shaderSource(shader, src);
  gl.compileShader(shader);
  if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
    var errLog = gl.getShaderInfoLog(shader);
    try {
      var fmt = formatCompilerError(errLog, src, type);
    } catch (e) {
      throw new GLError$1(errLog, "Error compiling shader:\n" + errLog);
    }
    throw new GLError$1(errLog, fmt.short, fmt.long);
  }
  return shader;
}
proto$2.getShaderReference = function(type, src) {
  var gl = this.gl;
  var shaders = this.shaders[type === gl.FRAGMENT_SHADER | 0];
  var shader = shaders[src];
  if (!shader || !gl.isShader(shader.shader)) {
    var shaderObj = compileShader(gl, type, src);
    shader = shaders[src] = new ShaderReference(
      SHADER_COUNTER++,
      src,
      type,
      shaderObj,
      [],
      1,
      this
    );
  } else {
    shader.count += 1;
  }
  return shader;
};
function linkProgram(gl, vshader, fshader, attribs, locations) {
  var program = gl.createProgram();
  gl.attachShader(program, vshader);
  gl.attachShader(program, fshader);
  for (var i = 0; i < attribs.length; ++i) {
    gl.bindAttribLocation(program, locations[i], attribs[i]);
  }
  gl.linkProgram(program);
  if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
    var errLog = gl.getProgramInfoLog(program);
    throw new GLError$1(errLog, "Error linking program: " + errLog);
  }
  return program;
}
proto$2.getProgram = function(vref, fref, attribs, locations) {
  var token = [vref.id, fref.id, attribs.join(":"), locations.join(":")].join("@");
  var prog = this.programs[token];
  if (!prog || !this.gl.isProgram(prog)) {
    this.programs[token] = prog = linkProgram(
      this.gl,
      vref.shader,
      fref.shader,
      attribs,
      locations
    );
    vref.programs.push(token);
    fref.programs.push(token);
  }
  return prog;
};
function getCache(gl) {
  var ctxCache = CACHE.get(gl);
  if (!ctxCache) {
    ctxCache = new ContextCache(gl);
    CACHE.set(gl, ctxCache);
  }
  return ctxCache;
}
function getShaderReference(gl, type, src) {
  return getCache(gl).getShaderReference(type, src);
}
function createProgram(gl, vref, fref, attribs, locations) {
  return getCache(gl).getProgram(vref, fref, attribs, locations);
}
var runtimeReflect = {};
runtimeReflect.uniforms = runtimeUniforms;
runtimeReflect.attributes = runtimeAttributes;
var GL_TO_GLSL_TYPES = {
  "FLOAT": "float",
  "FLOAT_VEC2": "vec2",
  "FLOAT_VEC3": "vec3",
  "FLOAT_VEC4": "vec4",
  "INT": "int",
  "INT_VEC2": "ivec2",
  "INT_VEC3": "ivec3",
  "INT_VEC4": "ivec4",
  "BOOL": "bool",
  "BOOL_VEC2": "bvec2",
  "BOOL_VEC3": "bvec3",
  "BOOL_VEC4": "bvec4",
  "FLOAT_MAT2": "mat2",
  "FLOAT_MAT3": "mat3",
  "FLOAT_MAT4": "mat4",
  "SAMPLER_2D": "sampler2D",
  "SAMPLER_CUBE": "samplerCube"
};
var GL_TABLE = null;
function getType(gl, type) {
  if (!GL_TABLE) {
    var typeNames = Object.keys(GL_TO_GLSL_TYPES);
    GL_TABLE = {};
    for (var i = 0; i < typeNames.length; ++i) {
      var tn = typeNames[i];
      GL_TABLE[gl[tn]] = GL_TO_GLSL_TYPES[tn];
    }
  }
  return GL_TABLE[type];
}
function runtimeUniforms(gl, program) {
  var numUniforms = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
  var result = [];
  for (var i = 0; i < numUniforms; ++i) {
    var info = gl.getActiveUniform(program, i);
    if (info) {
      var type = getType(gl, info.type);
      if (info.size > 1) {
        for (var j = 0; j < info.size; ++j) {
          result.push({
            name: info.name.replace("[0]", "[" + j + "]"),
            type
          });
        }
      } else {
        result.push({
          name: info.name,
          type
        });
      }
    }
  }
  return result;
}
function runtimeAttributes(gl, program) {
  var numAttributes = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
  var result = [];
  for (var i = 0; i < numAttributes; ++i) {
    var info = gl.getActiveAttrib(program, i);
    if (info) {
      result.push({
        name: info.name,
        type: getType(gl, info.type)
      });
    }
  }
  return result;
}
var createUniformWrapper = createUniforms;
var createAttributeWrapper = createAttributes;
var makeReflect = reflect;
var shaderCache = shaderCache$1;
var runtime = runtimeReflect;
var GLError = GLError_1;
function Shader(gl) {
  this.gl = gl;
  this.gl.lastAttribCount = 0;
  this._vref = this._fref = this._relink = this.vertShader = this.fragShader = this.program = this.attributes = this.uniforms = this.types = null;
}
var proto$1 = Shader.prototype;
proto$1.bind = function() {
  if (!this.program) {
    this._relink();
  }
  var i;
  var newAttribCount = this.gl.getProgramParameter(this.program, this.gl.ACTIVE_ATTRIBUTES);
  var oldAttribCount = this.gl.lastAttribCount;
  if (newAttribCount > oldAttribCount) {
    for (i = oldAttribCount; i < newAttribCount; i++) {
      this.gl.enableVertexAttribArray(i);
    }
  } else if (oldAttribCount > newAttribCount) {
    for (i = newAttribCount; i < oldAttribCount; i++) {
      this.gl.disableVertexAttribArray(i);
    }
  }
  this.gl.lastAttribCount = newAttribCount;
  this.gl.useProgram(this.program);
};
proto$1.dispose = function() {
  var oldAttribCount = this.gl.lastAttribCount;
  for (var i = 0; i < oldAttribCount; i++) {
    this.gl.disableVertexAttribArray(i);
  }
  this.gl.lastAttribCount = 0;
  if (this._fref) {
    this._fref.dispose();
  }
  if (this._vref) {
    this._vref.dispose();
  }
  this.attributes = this.types = this.vertShader = this.fragShader = this.program = this._relink = this._fref = this._vref = null;
};
function compareAttributes(a, b) {
  if (a.name < b.name) {
    return -1;
  }
  return 1;
}
proto$1.update = function(vertSource, fragSource, uniforms, attributes) {
  if (!fragSource || arguments.length === 1) {
    var obj = vertSource;
    vertSource = obj.vertex;
    fragSource = obj.fragment;
    uniforms = obj.uniforms;
    attributes = obj.attributes;
  }
  var wrapper = this;
  var gl = wrapper.gl;
  var pvref = wrapper._vref;
  wrapper._vref = shaderCache.shader(gl, gl.VERTEX_SHADER, vertSource);
  if (pvref) {
    pvref.dispose();
  }
  wrapper.vertShader = wrapper._vref.shader;
  var pfref = this._fref;
  wrapper._fref = shaderCache.shader(gl, gl.FRAGMENT_SHADER, fragSource);
  if (pfref) {
    pfref.dispose();
  }
  wrapper.fragShader = wrapper._fref.shader;
  if (!uniforms || !attributes) {
    var testProgram = gl.createProgram();
    gl.attachShader(testProgram, wrapper.fragShader);
    gl.attachShader(testProgram, wrapper.vertShader);
    gl.linkProgram(testProgram);
    if (!gl.getProgramParameter(testProgram, gl.LINK_STATUS)) {
      var errLog = gl.getProgramInfoLog(testProgram);
      throw new GLError(errLog, "Error linking program:" + errLog);
    }
    uniforms = uniforms || runtime.uniforms(gl, testProgram);
    attributes = attributes || runtime.attributes(gl, testProgram);
    gl.deleteProgram(testProgram);
  }
  attributes = attributes.slice();
  attributes.sort(compareAttributes);
  var attributeUnpacked = [];
  var attributeNames = [];
  var attributeLocations = [];
  var i;
  for (i = 0; i < attributes.length; ++i) {
    var attr = attributes[i];
    if (attr.type.indexOf("mat") >= 0) {
      var size = attr.type.charAt(attr.type.length - 1) | 0;
      var locVector = new Array(size);
      for (var j = 0; j < size; ++j) {
        locVector[j] = attributeLocations.length;
        attributeNames.push(attr.name + "[" + j + "]");
        if (typeof attr.location === "number") {
          attributeLocations.push(attr.location + j);
        } else if (Array.isArray(attr.location) && attr.location.length === size && typeof attr.location[j] === "number") {
          attributeLocations.push(attr.location[j] | 0);
        } else {
          attributeLocations.push(-1);
        }
      }
      attributeUnpacked.push({
        name: attr.name,
        type: attr.type,
        locations: locVector
      });
    } else {
      attributeUnpacked.push({
        name: attr.name,
        type: attr.type,
        locations: [attributeLocations.length]
      });
      attributeNames.push(attr.name);
      if (typeof attr.location === "number") {
        attributeLocations.push(attr.location | 0);
      } else {
        attributeLocations.push(-1);
      }
    }
  }
  var curLocation = 0;
  for (i = 0; i < attributeLocations.length; ++i) {
    if (attributeLocations[i] < 0) {
      while (attributeLocations.indexOf(curLocation) >= 0) {
        curLocation += 1;
      }
      attributeLocations[i] = curLocation;
    }
  }
  var uniformLocations = new Array(uniforms.length);
  function relink() {
    wrapper.program = shaderCache.program(
      gl,
      wrapper._vref,
      wrapper._fref,
      attributeNames,
      attributeLocations
    );
    for (var i2 = 0; i2 < uniforms.length; ++i2) {
      uniformLocations[i2] = gl.getUniformLocation(
        wrapper.program,
        uniforms[i2].name
      );
    }
  }
  relink();
  wrapper._relink = relink;
  wrapper.types = {
    uniforms: makeReflect(uniforms),
    attributes: makeReflect(attributes)
  };
  wrapper.attributes = createAttributeWrapper(
    gl,
    wrapper,
    attributeUnpacked,
    attributeLocations
  );
  Object.defineProperty(wrapper, "uniforms", createUniformWrapper(
    gl,
    wrapper,
    uniforms,
    uniformLocations
  ));
};
function createShader(gl, vertSource, fragSource, uniforms, attributes) {
  var shader = new Shader(gl);
  shader.update(
    vertSource,
    fragSource,
    uniforms,
    attributes
  );
  return shader;
}
var glShader = createShader;
Object.defineProperty(lib, "__esModule", {
  value: true
});
var _extends = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _glShader = glShader;
var _glShader2 = _interopRequireDefault(_glShader);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var VERT = "attribute vec2 _p;\nvarying vec2 _uv;\nvoid main() {\ngl_Position = vec4(_p,0.0,1.0);\n_uv = vec2(0.5, 0.5) * (_p+vec2(1.0, 1.0));\n}";
var resizeModes = {
  cover: function cover(r) {
    return ".5+(uv-.5)*vec2(min(ratio/" + r + ",1.),min(" + r + "/ratio,1.))";
  },
  contain: function contain(r) {
    return ".5+(uv-.5)*vec2(max(ratio/" + r + ",1.),max(" + r + "/ratio,1.))";
  },
  stretch: function stretch() {
    return "uv";
  }
};
var makeFrag = function makeFrag2(transitionGlsl, resizeMode) {
  var r = resizeModes[resizeMode];
  if (!r) throw new Error("invalid resizeMode=" + resizeMode);
  return "precision highp float;varying vec2 _uv;uniform sampler2D from, to;uniform float progress, ratio, _fromR, _toR;vec4 getFromColor(vec2 uv){return texture2D(from," + r("_fromR") + ");}vec4 getToColor(vec2 uv){return texture2D(to," + r("_toR") + ");}\n" + transitionGlsl + "\nvoid main(){gl_FragColor=transition(_uv);}";
};
var _default = lib.default = function(gl, transition) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var _resizeMode$options = _extends({ resizeMode: "cover" }, options), resizeMode = _resizeMode$options.resizeMode;
  var shader = (0, _glShader2.default)(gl, VERT, makeFrag(transition.glsl, resizeMode));
  shader.bind();
  shader.attributes._p.pointer();
  return {
    draw: function draw(progress, from, to) {
      var width = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : gl.drawingBufferWidth;
      var height = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : gl.drawingBufferHeight;
      var params = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
      shader.bind();
      shader.uniforms.ratio = width / height;
      shader.uniforms.progress = progress;
      shader.uniforms.from = from.bind(0);
      shader.uniforms.to = to.bind(1);
      shader.uniforms._fromR = from.shape[0] / from.shape[1];
      shader.uniforms._toR = to.shape[0] / to.shape[1];
      var unit = 2;
      for (var _key in transition.paramsTypes) {
        var value = _key in params ? params[_key] : transition.defaultParams[_key];
        if (transition.paramsTypes[_key] === "sampler2D") {
          if (!value) {
          } else if (typeof value.bind !== "function") {
            throw new Error("uniform[" + _key + "]: A gl-texture2d API-like object was expected");
          } else {
            shader.uniforms[_key] = value.bind(unit++);
          }
        } else {
          shader.uniforms[_key] = value;
        }
      }
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    },
    dispose: function dispose() {
      shader.dispose();
    }
  };
};
function iota$1(n) {
  var result = new Array(n);
  for (var i = 0; i < n; ++i) {
    result[i] = i;
  }
  return result;
}
var iota_1 = iota$1;
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var isBuffer_1 = function(obj) {
  return obj != null && (isBuffer$1(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
};
function isBuffer$1(obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
}
function isSlowBuffer(obj) {
  return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isBuffer$1(obj.slice(0, 0));
}
var iota = iota_1;
var isBuffer = isBuffer_1;
var hasTypedArrays = typeof Float64Array !== "undefined";
function compare1st(a, b) {
  return a[0] - b[0];
}
function order() {
  var stride = this.stride;
  var terms = new Array(stride.length);
  var i;
  for (i = 0; i < terms.length; ++i) {
    terms[i] = [Math.abs(stride[i]), i];
  }
  terms.sort(compare1st);
  var result = new Array(terms.length);
  for (i = 0; i < result.length; ++i) {
    result[i] = terms[i][1];
  }
  return result;
}
function compileConstructor(dtype, dimension) {
  var className = ["View", dimension, "d", dtype].join("");
  if (dimension < 0) {
    className = "View_Nil" + dtype;
  }
  var useGetters = dtype === "generic";
  if (dimension === -1) {
    var code = "function " + className + "(a){this.data=a;};var proto=" + className + ".prototype;proto.dtype='" + dtype + "';proto.index=function(){return -1};proto.size=0;proto.dimension=-1;proto.shape=proto.stride=proto.order=[];proto.lo=proto.hi=proto.transpose=proto.step=function(){return new " + className + "(this.data);};proto.get=proto.set=function(){};proto.pick=function(){return null};return function construct_" + className + "(a){return new " + className + "(a);}";
    var procedure = new Function(code);
    return procedure();
  } else if (dimension === 0) {
    var code = "function " + className + "(a,d) {this.data = a;this.offset = d};var proto=" + className + ".prototype;proto.dtype='" + dtype + "';proto.index=function(){return this.offset};proto.dimension=0;proto.size=1;proto.shape=proto.stride=proto.order=[];proto.lo=proto.hi=proto.transpose=proto.step=function " + className + "_copy() {return new " + className + "(this.data,this.offset)};proto.pick=function " + className + "_pick(){return TrivialArray(this.data);};proto.valueOf=proto.get=function " + className + "_get(){return " + (useGetters ? "this.data.get(this.offset)" : "this.data[this.offset]") + "};proto.set=function " + className + "_set(v){return " + (useGetters ? "this.data.set(this.offset,v)" : "this.data[this.offset]=v") + "};return function construct_" + className + "(a,b,c,d){return new " + className + "(a,d)}";
    var procedure = new Function("TrivialArray", code);
    return procedure(CACHED_CONSTRUCTORS[dtype][0]);
  }
  var code = ["'use strict'"];
  var indices = iota(dimension);
  var args = indices.map(function(i2) {
    return "i" + i2;
  });
  var index_str = "this.offset+" + indices.map(function(i2) {
    return "this.stride[" + i2 + "]*i" + i2;
  }).join("+");
  var shapeArg = indices.map(function(i2) {
    return "b" + i2;
  }).join(",");
  var strideArg = indices.map(function(i2) {
    return "c" + i2;
  }).join(",");
  code.push(
    "function " + className + "(a," + shapeArg + "," + strideArg + ",d){this.data=a",
    "this.shape=[" + shapeArg + "]",
    "this.stride=[" + strideArg + "]",
    "this.offset=d|0}",
    "var proto=" + className + ".prototype",
    "proto.dtype='" + dtype + "'",
    "proto.dimension=" + dimension
  );
  code.push(
    "Object.defineProperty(proto,'size',{get:function " + className + "_size(){return " + indices.map(function(i2) {
      return "this.shape[" + i2 + "]";
    }).join("*"),
    "}})"
  );
  if (dimension === 1) {
    code.push("proto.order=[0]");
  } else {
    code.push("Object.defineProperty(proto,'order',{get:");
    if (dimension < 4) {
      code.push("function " + className + "_order(){");
      if (dimension === 2) {
        code.push("return (Math.abs(this.stride[0])>Math.abs(this.stride[1]))?[1,0]:[0,1]}})");
      } else if (dimension === 3) {
        code.push(
          "var s0=Math.abs(this.stride[0]),s1=Math.abs(this.stride[1]),s2=Math.abs(this.stride[2]);if(s0>s1){if(s1>s2){return [2,1,0];}else if(s0>s2){return [1,2,0];}else{return [1,0,2];}}else if(s0>s2){return [2,0,1];}else if(s2>s1){return [0,1,2];}else{return [0,2,1];}}})"
        );
      }
    } else {
      code.push("ORDER})");
    }
  }
  code.push(
    "proto.set=function " + className + "_set(" + args.join(",") + ",v){"
  );
  if (useGetters) {
    code.push("return this.data.set(" + index_str + ",v)}");
  } else {
    code.push("return this.data[" + index_str + "]=v}");
  }
  code.push("proto.get=function " + className + "_get(" + args.join(",") + "){");
  if (useGetters) {
    code.push("return this.data.get(" + index_str + ")}");
  } else {
    code.push("return this.data[" + index_str + "]}");
  }
  code.push(
    "proto.index=function " + className + "_index(",
    args.join(),
    "){return " + index_str + "}"
  );
  code.push("proto.hi=function " + className + "_hi(" + args.join(",") + "){return new " + className + "(this.data," + indices.map(function(i2) {
    return ["(typeof i", i2, "!=='number'||i", i2, "<0)?this.shape[", i2, "]:i", i2, "|0"].join("");
  }).join(",") + "," + indices.map(function(i2) {
    return "this.stride[" + i2 + "]";
  }).join(",") + ",this.offset)}");
  var a_vars = indices.map(function(i2) {
    return "a" + i2 + "=this.shape[" + i2 + "]";
  });
  var c_vars = indices.map(function(i2) {
    return "c" + i2 + "=this.stride[" + i2 + "]";
  });
  code.push("proto.lo=function " + className + "_lo(" + args.join(",") + "){var b=this.offset,d=0," + a_vars.join(",") + "," + c_vars.join(","));
  for (var i = 0; i < dimension; ++i) {
    code.push(
      "if(typeof i" + i + "==='number'&&i" + i + ">=0){d=i" + i + "|0;b+=c" + i + "*d;a" + i + "-=d}"
    );
  }
  code.push("return new " + className + "(this.data," + indices.map(function(i2) {
    return "a" + i2;
  }).join(",") + "," + indices.map(function(i2) {
    return "c" + i2;
  }).join(",") + ",b)}");
  code.push("proto.step=function " + className + "_step(" + args.join(",") + "){var " + indices.map(function(i2) {
    return "a" + i2 + "=this.shape[" + i2 + "]";
  }).join(",") + "," + indices.map(function(i2) {
    return "b" + i2 + "=this.stride[" + i2 + "]";
  }).join(",") + ",c=this.offset,d=0,ceil=Math.ceil");
  for (var i = 0; i < dimension; ++i) {
    code.push(
      "if(typeof i" + i + "==='number'){d=i" + i + "|0;if(d<0){c+=b" + i + "*(a" + i + "-1);a" + i + "=ceil(-a" + i + "/d)}else{a" + i + "=ceil(a" + i + "/d)}b" + i + "*=d}"
    );
  }
  code.push("return new " + className + "(this.data," + indices.map(function(i2) {
    return "a" + i2;
  }).join(",") + "," + indices.map(function(i2) {
    return "b" + i2;
  }).join(",") + ",c)}");
  var tShape = new Array(dimension);
  var tStride = new Array(dimension);
  for (var i = 0; i < dimension; ++i) {
    tShape[i] = "a[i" + i + "]";
    tStride[i] = "b[i" + i + "]";
  }
  code.push(
    "proto.transpose=function " + className + "_transpose(" + args + "){" + args.map(function(n, idx) {
      return n + "=(" + n + "===undefined?" + idx + ":" + n + "|0)";
    }).join(";"),
    "var a=this.shape,b=this.stride;return new " + className + "(this.data," + tShape.join(",") + "," + tStride.join(",") + ",this.offset)}"
  );
  code.push("proto.pick=function " + className + "_pick(" + args + "){var a=[],b=[],c=this.offset");
  for (var i = 0; i < dimension; ++i) {
    code.push("if(typeof i" + i + "==='number'&&i" + i + ">=0){c=(c+this.stride[" + i + "]*i" + i + ")|0}else{a.push(this.shape[" + i + "]);b.push(this.stride[" + i + "])}");
  }
  code.push("var ctor=CTOR_LIST[a.length+1];return ctor(this.data,a,b,c)}");
  code.push("return function construct_" + className + "(data,shape,stride,offset){return new " + className + "(data," + indices.map(function(i2) {
    return "shape[" + i2 + "]";
  }).join(",") + "," + indices.map(function(i2) {
    return "stride[" + i2 + "]";
  }).join(",") + ",offset)}");
  var procedure = new Function("CTOR_LIST", "ORDER", code.join("\n"));
  return procedure(CACHED_CONSTRUCTORS[dtype], order);
}
function arrayDType(data) {
  if (isBuffer(data)) {
    return "buffer";
  }
  if (hasTypedArrays) {
    switch (Object.prototype.toString.call(data)) {
      case "[object Float64Array]":
        return "float64";
      case "[object Float32Array]":
        return "float32";
      case "[object Int8Array]":
        return "int8";
      case "[object Int16Array]":
        return "int16";
      case "[object Int32Array]":
        return "int32";
      case "[object Uint8Array]":
        return "uint8";
      case "[object Uint16Array]":
        return "uint16";
      case "[object Uint32Array]":
        return "uint32";
      case "[object Uint8ClampedArray]":
        return "uint8_clamped";
      case "[object BigInt64Array]":
        return "bigint64";
      case "[object BigUint64Array]":
        return "biguint64";
    }
  }
  if (Array.isArray(data)) {
    return "array";
  }
  return "generic";
}
var CACHED_CONSTRUCTORS = {
  "float32": [],
  "float64": [],
  "int8": [],
  "int16": [],
  "int32": [],
  "uint8": [],
  "uint16": [],
  "uint32": [],
  "array": [],
  "uint8_clamped": [],
  "bigint64": [],
  "biguint64": [],
  "buffer": [],
  "generic": []
};
function wrappedNDArrayCtor(data, shape, stride, offset) {
  if (data === void 0) {
    var ctor = CACHED_CONSTRUCTORS.array[0];
    return ctor([]);
  } else if (typeof data === "number") {
    data = [data];
  }
  if (shape === void 0) {
    shape = [data.length];
  }
  var d = shape.length;
  if (stride === void 0) {
    stride = new Array(d);
    for (var i = d - 1, sz = 1; i >= 0; --i) {
      stride[i] = sz;
      sz *= shape[i];
    }
  }
  if (offset === void 0) {
    offset = 0;
    for (var i = 0; i < d; ++i) {
      if (stride[i] < 0) {
        offset -= (shape[i] - 1) * stride[i];
      }
    }
  }
  var dtype = arrayDType(data);
  var ctor_list = CACHED_CONSTRUCTORS[dtype];
  while (ctor_list.length <= d + 1) {
    ctor_list.push(compileConstructor(dtype, ctor_list.length - 1));
  }
  var ctor = ctor_list[d + 1];
  return ctor(data, shape, stride, offset);
}
var ndarray$1 = wrappedNDArrayCtor;
var ndarrayOps = {};
function unique_pred(list, compare) {
  var ptr = 1, len = list.length, a = list[0], b = list[0];
  for (var i = 1; i < len; ++i) {
    b = a;
    a = list[i];
    if (compare(a, b)) {
      if (i === ptr) {
        ptr++;
        continue;
      }
      list[ptr++] = a;
    }
  }
  list.length = ptr;
  return list;
}
function unique_eq(list) {
  var ptr = 1, len = list.length, a = list[0], b = list[0];
  for (var i = 1; i < len; ++i, b = a) {
    b = a;
    a = list[i];
    if (a !== b) {
      if (i === ptr) {
        ptr++;
        continue;
      }
      list[ptr++] = a;
    }
  }
  list.length = ptr;
  return list;
}
function unique(list, compare, sorted) {
  if (list.length === 0) {
    return list;
  }
  if (compare) {
    if (!sorted) {
      list.sort(compare);
    }
    return unique_pred(list, compare);
  }
  if (!sorted) {
    list.sort();
  }
  return unique_eq(list);
}
var uniq$1 = unique;
var uniq = uniq$1;
function innerFill(order2, proc, body) {
  var dimension = order2.length, nargs = proc.arrayArgs.length, has_index = proc.indexArgs.length > 0, code = [], vars = [], idx = 0, pidx = 0, i, j;
  for (i = 0; i < dimension; ++i) {
    vars.push(["i", i, "=0"].join(""));
  }
  for (j = 0; j < nargs; ++j) {
    for (i = 0; i < dimension; ++i) {
      pidx = idx;
      idx = order2[i];
      if (i === 0) {
        vars.push(["d", j, "s", i, "=t", j, "p", idx].join(""));
      } else {
        vars.push(["d", j, "s", i, "=(t", j, "p", idx, "-s", pidx, "*t", j, "p", pidx, ")"].join(""));
      }
    }
  }
  if (vars.length > 0) {
    code.push("var " + vars.join(","));
  }
  for (i = dimension - 1; i >= 0; --i) {
    idx = order2[i];
    code.push(["for(i", i, "=0;i", i, "<s", idx, ";++i", i, "){"].join(""));
  }
  code.push(body);
  for (i = 0; i < dimension; ++i) {
    pidx = idx;
    idx = order2[i];
    for (j = 0; j < nargs; ++j) {
      code.push(["p", j, "+=d", j, "s", i].join(""));
    }
    if (has_index) {
      if (i > 0) {
        code.push(["index[", pidx, "]-=s", pidx].join(""));
      }
      code.push(["++index[", idx, "]"].join(""));
    }
    code.push("}");
  }
  return code.join("\n");
}
function outerFill(matched, order2, proc, body) {
  var dimension = order2.length, nargs = proc.arrayArgs.length, blockSize = proc.blockSize, has_index = proc.indexArgs.length > 0, code = [];
  for (var i = 0; i < nargs; ++i) {
    code.push(["var offset", i, "=p", i].join(""));
  }
  for (var i = matched; i < dimension; ++i) {
    code.push(["for(var j" + i + "=SS[", order2[i], "]|0;j", i, ">0;){"].join(""));
    code.push(["if(j", i, "<", blockSize, "){"].join(""));
    code.push(["s", order2[i], "=j", i].join(""));
    code.push(["j", i, "=0"].join(""));
    code.push(["}else{s", order2[i], "=", blockSize].join(""));
    code.push(["j", i, "-=", blockSize, "}"].join(""));
    if (has_index) {
      code.push(["index[", order2[i], "]=j", i].join(""));
    }
  }
  for (var i = 0; i < nargs; ++i) {
    var indexStr = ["offset" + i];
    for (var j = matched; j < dimension; ++j) {
      indexStr.push(["j", j, "*t", i, "p", order2[j]].join(""));
    }
    code.push(["p", i, "=(", indexStr.join("+"), ")"].join(""));
  }
  code.push(innerFill(order2, proc, body));
  for (var i = matched; i < dimension; ++i) {
    code.push("}");
  }
  return code.join("\n");
}
function countMatches(orders) {
  var matched = 0, dimension = orders[0].length;
  while (matched < dimension) {
    for (var j = 1; j < orders.length; ++j) {
      if (orders[j][matched] !== orders[0][matched]) {
        return matched;
      }
    }
    ++matched;
  }
  return matched;
}
function processBlock(block, proc, dtypes) {
  var code = block.body;
  var pre = [];
  var post = [];
  for (var i = 0; i < block.args.length; ++i) {
    var carg = block.args[i];
    if (carg.count <= 0) {
      continue;
    }
    var re = new RegExp(carg.name, "g");
    var ptrStr = "";
    var arrNum = proc.arrayArgs.indexOf(i);
    switch (proc.argTypes[i]) {
      case "offset":
        var offArgIndex = proc.offsetArgIndex.indexOf(i);
        var offArg = proc.offsetArgs[offArgIndex];
        arrNum = offArg.array;
        ptrStr = "+q" + offArgIndex;
      case "array":
        ptrStr = "p" + arrNum + ptrStr;
        var localStr = "l" + i;
        var arrStr = "a" + arrNum;
        if (proc.arrayBlockIndices[arrNum] === 0) {
          if (carg.count === 1) {
            if (dtypes[arrNum] === "generic") {
              if (carg.lvalue) {
                pre.push(["var ", localStr, "=", arrStr, ".get(", ptrStr, ")"].join(""));
                code = code.replace(re, localStr);
                post.push([arrStr, ".set(", ptrStr, ",", localStr, ")"].join(""));
              } else {
                code = code.replace(re, [arrStr, ".get(", ptrStr, ")"].join(""));
              }
            } else {
              code = code.replace(re, [arrStr, "[", ptrStr, "]"].join(""));
            }
          } else if (dtypes[arrNum] === "generic") {
            pre.push(["var ", localStr, "=", arrStr, ".get(", ptrStr, ")"].join(""));
            code = code.replace(re, localStr);
            if (carg.lvalue) {
              post.push([arrStr, ".set(", ptrStr, ",", localStr, ")"].join(""));
            }
          } else {
            pre.push(["var ", localStr, "=", arrStr, "[", ptrStr, "]"].join(""));
            code = code.replace(re, localStr);
            if (carg.lvalue) {
              post.push([arrStr, "[", ptrStr, "]=", localStr].join(""));
            }
          }
        } else {
          var reStrArr = [carg.name], ptrStrArr = [ptrStr];
          for (var j = 0; j < Math.abs(proc.arrayBlockIndices[arrNum]); j++) {
            reStrArr.push("\\s*\\[([^\\]]+)\\]");
            ptrStrArr.push("$" + (j + 1) + "*t" + arrNum + "b" + j);
          }
          re = new RegExp(reStrArr.join(""), "g");
          ptrStr = ptrStrArr.join("+");
          if (dtypes[arrNum] === "generic") {
            throw new Error("cwise: Generic arrays not supported in combination with blocks!");
          } else {
            code = code.replace(re, [arrStr, "[", ptrStr, "]"].join(""));
          }
        }
        break;
      case "scalar":
        code = code.replace(re, "Y" + proc.scalarArgs.indexOf(i));
        break;
      case "index":
        code = code.replace(re, "index");
        break;
      case "shape":
        code = code.replace(re, "shape");
        break;
    }
  }
  return [pre.join("\n"), code, post.join("\n")].join("\n").trim();
}
function typeSummary(dtypes) {
  var summary = new Array(dtypes.length);
  var allEqual = true;
  for (var i = 0; i < dtypes.length; ++i) {
    var t = dtypes[i];
    var digits = t.match(/\d+/);
    if (!digits) {
      digits = "";
    } else {
      digits = digits[0];
    }
    if (t.charAt(0) === 0) {
      summary[i] = "u" + t.charAt(1) + digits;
    } else {
      summary[i] = t.charAt(0) + digits;
    }
    if (i > 0) {
      allEqual = allEqual && summary[i] === summary[i - 1];
    }
  }
  if (allEqual) {
    return summary[0];
  }
  return summary.join("");
}
function generateCWiseOp(proc, typesig) {
  var dimension = typesig[1].length - Math.abs(proc.arrayBlockIndices[0]) | 0;
  var orders = new Array(proc.arrayArgs.length);
  var dtypes = new Array(proc.arrayArgs.length);
  for (var i = 0; i < proc.arrayArgs.length; ++i) {
    dtypes[i] = typesig[2 * i];
    orders[i] = typesig[2 * i + 1];
  }
  var blockBegin = [], blockEnd = [];
  var loopBegin = [], loopEnd = [];
  var loopOrders = [];
  for (var i = 0; i < proc.arrayArgs.length; ++i) {
    if (proc.arrayBlockIndices[i] < 0) {
      loopBegin.push(0);
      loopEnd.push(dimension);
      blockBegin.push(dimension);
      blockEnd.push(dimension + proc.arrayBlockIndices[i]);
    } else {
      loopBegin.push(proc.arrayBlockIndices[i]);
      loopEnd.push(proc.arrayBlockIndices[i] + dimension);
      blockBegin.push(0);
      blockEnd.push(proc.arrayBlockIndices[i]);
    }
    var newOrder = [];
    for (var j = 0; j < orders[i].length; j++) {
      if (loopBegin[i] <= orders[i][j] && orders[i][j] < loopEnd[i]) {
        newOrder.push(orders[i][j] - loopBegin[i]);
      }
    }
    loopOrders.push(newOrder);
  }
  var arglist = ["SS"];
  var code = ["'use strict'"];
  var vars = [];
  for (var j = 0; j < dimension; ++j) {
    vars.push(["s", j, "=SS[", j, "]"].join(""));
  }
  for (var i = 0; i < proc.arrayArgs.length; ++i) {
    arglist.push("a" + i);
    arglist.push("t" + i);
    arglist.push("p" + i);
    for (var j = 0; j < dimension; ++j) {
      vars.push(["t", i, "p", j, "=t", i, "[", loopBegin[i] + j, "]"].join(""));
    }
    for (var j = 0; j < Math.abs(proc.arrayBlockIndices[i]); ++j) {
      vars.push(["t", i, "b", j, "=t", i, "[", blockBegin[i] + j, "]"].join(""));
    }
  }
  for (var i = 0; i < proc.scalarArgs.length; ++i) {
    arglist.push("Y" + i);
  }
  if (proc.shapeArgs.length > 0) {
    vars.push("shape=SS.slice(0)");
  }
  if (proc.indexArgs.length > 0) {
    var zeros = new Array(dimension);
    for (var i = 0; i < dimension; ++i) {
      zeros[i] = "0";
    }
    vars.push(["index=[", zeros.join(","), "]"].join(""));
  }
  for (var i = 0; i < proc.offsetArgs.length; ++i) {
    var off_arg = proc.offsetArgs[i];
    var init_string = [];
    for (var j = 0; j < off_arg.offset.length; ++j) {
      if (off_arg.offset[j] === 0) {
        continue;
      } else if (off_arg.offset[j] === 1) {
        init_string.push(["t", off_arg.array, "p", j].join(""));
      } else {
        init_string.push([off_arg.offset[j], "*t", off_arg.array, "p", j].join(""));
      }
    }
    if (init_string.length === 0) {
      vars.push("q" + i + "=0");
    } else {
      vars.push(["q", i, "=", init_string.join("+")].join(""));
    }
  }
  var thisVars = uniq([].concat(proc.pre.thisVars).concat(proc.body.thisVars).concat(proc.post.thisVars));
  vars = vars.concat(thisVars);
  if (vars.length > 0) {
    code.push("var " + vars.join(","));
  }
  for (var i = 0; i < proc.arrayArgs.length; ++i) {
    code.push("p" + i + "|=0");
  }
  if (proc.pre.body.length > 3) {
    code.push(processBlock(proc.pre, proc, dtypes));
  }
  var body = processBlock(proc.body, proc, dtypes);
  var matched = countMatches(loopOrders);
  if (matched < dimension) {
    code.push(outerFill(matched, loopOrders[0], proc, body));
  } else {
    code.push(innerFill(loopOrders[0], proc, body));
  }
  if (proc.post.body.length > 3) {
    code.push(processBlock(proc.post, proc, dtypes));
  }
  if (proc.debug) {
  }
  var loopName = [proc.funcName || "unnamed", "_cwise_loop_", orders[0].join("s"), "m", matched, typeSummary(dtypes)].join("");
  var f = new Function(["function ", loopName, "(", arglist.join(","), "){", code.join("\n"), "} return ", loopName].join(""));
  return f();
}
var compile$1 = generateCWiseOp;
var compile = compile$1;
function createThunk$1(proc) {
  var code = ["'use strict'", "var CACHED={}"];
  var vars = [];
  var thunkName = proc.funcName + "_cwise_thunk";
  code.push(["return function ", thunkName, "(", proc.shimArgs.join(","), "){"].join(""));
  var typesig = [];
  var string_typesig = [];
  var proc_args = [[
    "array",
    proc.arrayArgs[0],
    ".shape.slice(",
    // Slice shape so that we only retain the shape over which we iterate (which gets passed to the cwise operator as SS).
    Math.max(0, proc.arrayBlockIndices[0]),
    proc.arrayBlockIndices[0] < 0 ? "," + proc.arrayBlockIndices[0] + ")" : ")"
  ].join("")];
  var shapeLengthConditions = [], shapeConditions = [];
  for (var i = 0; i < proc.arrayArgs.length; ++i) {
    var j = proc.arrayArgs[i];
    vars.push([
      "t",
      j,
      "=array",
      j,
      ".dtype,",
      "r",
      j,
      "=array",
      j,
      ".order"
    ].join(""));
    typesig.push("t" + j);
    typesig.push("r" + j);
    string_typesig.push("t" + j);
    string_typesig.push("r" + j + ".join()");
    proc_args.push("array" + j + ".data");
    proc_args.push("array" + j + ".stride");
    proc_args.push("array" + j + ".offset|0");
    if (i > 0) {
      shapeLengthConditions.push("array" + proc.arrayArgs[0] + ".shape.length===array" + j + ".shape.length+" + (Math.abs(proc.arrayBlockIndices[0]) - Math.abs(proc.arrayBlockIndices[i])));
      shapeConditions.push("array" + proc.arrayArgs[0] + ".shape[shapeIndex+" + Math.max(0, proc.arrayBlockIndices[0]) + "]===array" + j + ".shape[shapeIndex+" + Math.max(0, proc.arrayBlockIndices[i]) + "]");
    }
  }
  if (proc.arrayArgs.length > 1) {
    code.push("if (!(" + shapeLengthConditions.join(" && ") + ")) throw new Error('cwise: Arrays do not all have the same dimensionality!')");
    code.push("for(var shapeIndex=array" + proc.arrayArgs[0] + ".shape.length-" + Math.abs(proc.arrayBlockIndices[0]) + "; shapeIndex-->0;) {");
    code.push("if (!(" + shapeConditions.join(" && ") + ")) throw new Error('cwise: Arrays do not all have the same shape!')");
    code.push("}");
  }
  for (var i = 0; i < proc.scalarArgs.length; ++i) {
    proc_args.push("scalar" + proc.scalarArgs[i]);
  }
  vars.push(["type=[", string_typesig.join(","), "].join()"].join(""));
  vars.push("proc=CACHED[type]");
  code.push("var " + vars.join(","));
  code.push([
    "if(!proc){",
    "CACHED[type]=proc=compile([",
    typesig.join(","),
    "])}",
    "return proc(",
    proc_args.join(","),
    ")}"
  ].join(""));
  if (proc.debug) {
  }
  var thunk2 = new Function("compile", code.join("\n"));
  return thunk2(compile.bind(void 0, proc));
}
var thunk = createThunk$1;
var createThunk = thunk;
function Procedure() {
  this.argTypes = [];
  this.shimArgs = [];
  this.arrayArgs = [];
  this.arrayBlockIndices = [];
  this.scalarArgs = [];
  this.offsetArgs = [];
  this.offsetArgIndex = [];
  this.indexArgs = [];
  this.shapeArgs = [];
  this.funcName = "";
  this.pre = null;
  this.body = null;
  this.post = null;
  this.debug = false;
}
function compileCwise(user_args) {
  var proc = new Procedure();
  proc.pre = user_args.pre;
  proc.body = user_args.body;
  proc.post = user_args.post;
  var proc_args = user_args.args.slice(0);
  proc.argTypes = proc_args;
  for (var i = 0; i < proc_args.length; ++i) {
    var arg_type = proc_args[i];
    if (arg_type === "array" || typeof arg_type === "object" && arg_type.blockIndices) {
      proc.argTypes[i] = "array";
      proc.arrayArgs.push(i);
      proc.arrayBlockIndices.push(arg_type.blockIndices ? arg_type.blockIndices : 0);
      proc.shimArgs.push("array" + i);
      if (i < proc.pre.args.length && proc.pre.args[i].count > 0) {
        throw new Error("cwise: pre() block may not reference array args");
      }
      if (i < proc.post.args.length && proc.post.args[i].count > 0) {
        throw new Error("cwise: post() block may not reference array args");
      }
    } else if (arg_type === "scalar") {
      proc.scalarArgs.push(i);
      proc.shimArgs.push("scalar" + i);
    } else if (arg_type === "index") {
      proc.indexArgs.push(i);
      if (i < proc.pre.args.length && proc.pre.args[i].count > 0) {
        throw new Error("cwise: pre() block may not reference array index");
      }
      if (i < proc.body.args.length && proc.body.args[i].lvalue) {
        throw new Error("cwise: body() block may not write to array index");
      }
      if (i < proc.post.args.length && proc.post.args[i].count > 0) {
        throw new Error("cwise: post() block may not reference array index");
      }
    } else if (arg_type === "shape") {
      proc.shapeArgs.push(i);
      if (i < proc.pre.args.length && proc.pre.args[i].lvalue) {
        throw new Error("cwise: pre() block may not write to array shape");
      }
      if (i < proc.body.args.length && proc.body.args[i].lvalue) {
        throw new Error("cwise: body() block may not write to array shape");
      }
      if (i < proc.post.args.length && proc.post.args[i].lvalue) {
        throw new Error("cwise: post() block may not write to array shape");
      }
    } else if (typeof arg_type === "object" && arg_type.offset) {
      proc.argTypes[i] = "offset";
      proc.offsetArgs.push({ array: arg_type.array, offset: arg_type.offset });
      proc.offsetArgIndex.push(i);
    } else {
      throw new Error("cwise: Unknown argument type " + proc_args[i]);
    }
  }
  if (proc.arrayArgs.length <= 0) {
    throw new Error("cwise: No array arguments specified");
  }
  if (proc.pre.args.length > proc_args.length) {
    throw new Error("cwise: Too many arguments in pre() block");
  }
  if (proc.body.args.length > proc_args.length) {
    throw new Error("cwise: Too many arguments in body() block");
  }
  if (proc.post.args.length > proc_args.length) {
    throw new Error("cwise: Too many arguments in post() block");
  }
  proc.debug = !!user_args.printCode || !!user_args.debug;
  proc.funcName = user_args.funcName || "cwise";
  proc.blockSize = user_args.blockSize || 64;
  return createThunk(proc);
}
var compiler = compileCwise;
(function(exports) {
  var compile2 = compiler;
  var EmptyProc = {
    body: "",
    args: [],
    thisVars: [],
    localVars: []
  };
  function fixup(x) {
    if (!x) {
      return EmptyProc;
    }
    for (var i = 0; i < x.args.length; ++i) {
      var a = x.args[i];
      if (i === 0) {
        x.args[i] = { name: a, lvalue: true, rvalue: !!x.rvalue, count: x.count || 1 };
      } else {
        x.args[i] = { name: a, lvalue: false, rvalue: true, count: 1 };
      }
    }
    if (!x.thisVars) {
      x.thisVars = [];
    }
    if (!x.localVars) {
      x.localVars = [];
    }
    return x;
  }
  function pcompile(user_args) {
    return compile2({
      args: user_args.args,
      pre: fixup(user_args.pre),
      body: fixup(user_args.body),
      post: fixup(user_args.proc),
      funcName: user_args.funcName
    });
  }
  function makeOp(user_args) {
    var args = [];
    for (var i = 0; i < user_args.args.length; ++i) {
      args.push("a" + i);
    }
    var wrapper = new Function("P", [
      "return function ",
      user_args.funcName,
      "_ndarrayops(",
      args.join(","),
      ") {P(",
      args.join(","),
      ");return a0}"
    ].join(""));
    return wrapper(pcompile(user_args));
  }
  var assign_ops = {
    add: "+",
    sub: "-",
    mul: "*",
    div: "/",
    mod: "%",
    band: "&",
    bor: "|",
    bxor: "^",
    lshift: "<<",
    rshift: ">>",
    rrshift: ">>>"
  };
  (function() {
    for (var id in assign_ops) {
      var op = assign_ops[id];
      exports[id] = makeOp({
        args: ["array", "array", "array"],
        body: {
          args: ["a", "b", "c"],
          body: "a=b" + op + "c"
        },
        funcName: id
      });
      exports[id + "eq"] = makeOp({
        args: ["array", "array"],
        body: {
          args: ["a", "b"],
          body: "a" + op + "=b"
        },
        rvalue: true,
        funcName: id + "eq"
      });
      exports[id + "s"] = makeOp({
        args: ["array", "array", "scalar"],
        body: {
          args: ["a", "b", "s"],
          body: "a=b" + op + "s"
        },
        funcName: id + "s"
      });
      exports[id + "seq"] = makeOp({
        args: ["array", "scalar"],
        body: {
          args: ["a", "s"],
          body: "a" + op + "=s"
        },
        rvalue: true,
        funcName: id + "seq"
      });
    }
  })();
  var unary_ops = {
    not: "!",
    bnot: "~",
    neg: "-",
    recip: "1.0/"
  };
  (function() {
    for (var id in unary_ops) {
      var op = unary_ops[id];
      exports[id] = makeOp({
        args: ["array", "array"],
        body: {
          args: ["a", "b"],
          body: "a=" + op + "b"
        },
        funcName: id
      });
      exports[id + "eq"] = makeOp({
        args: ["array"],
        body: {
          args: ["a"],
          body: "a=" + op + "a"
        },
        rvalue: true,
        count: 2,
        funcName: id + "eq"
      });
    }
  })();
  var binary_ops = {
    and: "&&",
    or: "||",
    eq: "===",
    neq: "!==",
    lt: "<",
    gt: ">",
    leq: "<=",
    geq: ">="
  };
  (function() {
    for (var id in binary_ops) {
      var op = binary_ops[id];
      exports[id] = makeOp({
        args: ["array", "array", "array"],
        body: {
          args: ["a", "b", "c"],
          body: "a=b" + op + "c"
        },
        funcName: id
      });
      exports[id + "s"] = makeOp({
        args: ["array", "array", "scalar"],
        body: {
          args: ["a", "b", "s"],
          body: "a=b" + op + "s"
        },
        funcName: id + "s"
      });
      exports[id + "eq"] = makeOp({
        args: ["array", "array"],
        body: {
          args: ["a", "b"],
          body: "a=a" + op + "b"
        },
        rvalue: true,
        count: 2,
        funcName: id + "eq"
      });
      exports[id + "seq"] = makeOp({
        args: ["array", "scalar"],
        body: {
          args: ["a", "s"],
          body: "a=a" + op + "s"
        },
        rvalue: true,
        count: 2,
        funcName: id + "seq"
      });
    }
  })();
  var math_unary = [
    "abs",
    "acos",
    "asin",
    "atan",
    "ceil",
    "cos",
    "exp",
    "floor",
    "log",
    "round",
    "sin",
    "sqrt",
    "tan"
  ];
  (function() {
    for (var i = 0; i < math_unary.length; ++i) {
      var f = math_unary[i];
      exports[f] = makeOp({
        args: ["array", "array"],
        pre: { args: [], body: "this_f=Math." + f, thisVars: ["this_f"] },
        body: { args: ["a", "b"], body: "a=this_f(b)", thisVars: ["this_f"] },
        funcName: f
      });
      exports[f + "eq"] = makeOp({
        args: ["array"],
        pre: { args: [], body: "this_f=Math." + f, thisVars: ["this_f"] },
        body: { args: ["a"], body: "a=this_f(a)", thisVars: ["this_f"] },
        rvalue: true,
        count: 2,
        funcName: f + "eq"
      });
    }
  })();
  var math_comm = [
    "max",
    "min",
    "atan2",
    "pow"
  ];
  (function() {
    for (var i = 0; i < math_comm.length; ++i) {
      var f = math_comm[i];
      exports[f] = makeOp({
        args: ["array", "array", "array"],
        pre: { args: [], body: "this_f=Math." + f, thisVars: ["this_f"] },
        body: { args: ["a", "b", "c"], body: "a=this_f(b,c)", thisVars: ["this_f"] },
        funcName: f
      });
      exports[f + "s"] = makeOp({
        args: ["array", "array", "scalar"],
        pre: { args: [], body: "this_f=Math." + f, thisVars: ["this_f"] },
        body: { args: ["a", "b", "c"], body: "a=this_f(b,c)", thisVars: ["this_f"] },
        funcName: f + "s"
      });
      exports[f + "eq"] = makeOp({
        args: ["array", "array"],
        pre: { args: [], body: "this_f=Math." + f, thisVars: ["this_f"] },
        body: { args: ["a", "b"], body: "a=this_f(a,b)", thisVars: ["this_f"] },
        rvalue: true,
        count: 2,
        funcName: f + "eq"
      });
      exports[f + "seq"] = makeOp({
        args: ["array", "scalar"],
        pre: { args: [], body: "this_f=Math." + f, thisVars: ["this_f"] },
        body: { args: ["a", "b"], body: "a=this_f(a,b)", thisVars: ["this_f"] },
        rvalue: true,
        count: 2,
        funcName: f + "seq"
      });
    }
  })();
  var math_noncomm = [
    "atan2",
    "pow"
  ];
  (function() {
    for (var i = 0; i < math_noncomm.length; ++i) {
      var f = math_noncomm[i];
      exports[f + "op"] = makeOp({
        args: ["array", "array", "array"],
        pre: { args: [], body: "this_f=Math." + f, thisVars: ["this_f"] },
        body: { args: ["a", "b", "c"], body: "a=this_f(c,b)", thisVars: ["this_f"] },
        funcName: f + "op"
      });
      exports[f + "ops"] = makeOp({
        args: ["array", "array", "scalar"],
        pre: { args: [], body: "this_f=Math." + f, thisVars: ["this_f"] },
        body: { args: ["a", "b", "c"], body: "a=this_f(c,b)", thisVars: ["this_f"] },
        funcName: f + "ops"
      });
      exports[f + "opeq"] = makeOp({
        args: ["array", "array"],
        pre: { args: [], body: "this_f=Math." + f, thisVars: ["this_f"] },
        body: { args: ["a", "b"], body: "a=this_f(b,a)", thisVars: ["this_f"] },
        rvalue: true,
        count: 2,
        funcName: f + "opeq"
      });
      exports[f + "opseq"] = makeOp({
        args: ["array", "scalar"],
        pre: { args: [], body: "this_f=Math." + f, thisVars: ["this_f"] },
        body: { args: ["a", "b"], body: "a=this_f(b,a)", thisVars: ["this_f"] },
        rvalue: true,
        count: 2,
        funcName: f + "opseq"
      });
    }
  })();
  exports.any = compile2({
    args: ["array"],
    pre: EmptyProc,
    body: { args: [{ name: "a", lvalue: false, rvalue: true, count: 1 }], body: "if(a){return true}", localVars: [], thisVars: [] },
    post: { args: [], localVars: [], thisVars: [], body: "return false" },
    funcName: "any"
  });
  exports.all = compile2({
    args: ["array"],
    pre: EmptyProc,
    body: { args: [{ name: "x", lvalue: false, rvalue: true, count: 1 }], body: "if(!x){return false}", localVars: [], thisVars: [] },
    post: { args: [], localVars: [], thisVars: [], body: "return true" },
    funcName: "all"
  });
  exports.sum = compile2({
    args: ["array"],
    pre: { args: [], localVars: [], thisVars: ["this_s"], body: "this_s=0" },
    body: { args: [{ name: "a", lvalue: false, rvalue: true, count: 1 }], body: "this_s+=a", localVars: [], thisVars: ["this_s"] },
    post: { args: [], localVars: [], thisVars: ["this_s"], body: "return this_s" },
    funcName: "sum"
  });
  exports.prod = compile2({
    args: ["array"],
    pre: { args: [], localVars: [], thisVars: ["this_s"], body: "this_s=1" },
    body: { args: [{ name: "a", lvalue: false, rvalue: true, count: 1 }], body: "this_s*=a", localVars: [], thisVars: ["this_s"] },
    post: { args: [], localVars: [], thisVars: ["this_s"], body: "return this_s" },
    funcName: "prod"
  });
  exports.norm2squared = compile2({
    args: ["array"],
    pre: { args: [], localVars: [], thisVars: ["this_s"], body: "this_s=0" },
    body: { args: [{ name: "a", lvalue: false, rvalue: true, count: 2 }], body: "this_s+=a*a", localVars: [], thisVars: ["this_s"] },
    post: { args: [], localVars: [], thisVars: ["this_s"], body: "return this_s" },
    funcName: "norm2squared"
  });
  exports.norm2 = compile2({
    args: ["array"],
    pre: { args: [], localVars: [], thisVars: ["this_s"], body: "this_s=0" },
    body: { args: [{ name: "a", lvalue: false, rvalue: true, count: 2 }], body: "this_s+=a*a", localVars: [], thisVars: ["this_s"] },
    post: { args: [], localVars: [], thisVars: ["this_s"], body: "return Math.sqrt(this_s)" },
    funcName: "norm2"
  });
  exports.norminf = compile2({
    args: ["array"],
    pre: { args: [], localVars: [], thisVars: ["this_s"], body: "this_s=0" },
    body: { args: [{ name: "a", lvalue: false, rvalue: true, count: 4 }], body: "if(-a>this_s){this_s=-a}else if(a>this_s){this_s=a}", localVars: [], thisVars: ["this_s"] },
    post: { args: [], localVars: [], thisVars: ["this_s"], body: "return this_s" },
    funcName: "norminf"
  });
  exports.norm1 = compile2({
    args: ["array"],
    pre: { args: [], localVars: [], thisVars: ["this_s"], body: "this_s=0" },
    body: { args: [{ name: "a", lvalue: false, rvalue: true, count: 3 }], body: "this_s+=a<0?-a:a", localVars: [], thisVars: ["this_s"] },
    post: { args: [], localVars: [], thisVars: ["this_s"], body: "return this_s" },
    funcName: "norm1"
  });
  exports.sup = compile2({
    args: ["array"],
    pre: {
      body: "this_h=-Infinity",
      args: [],
      thisVars: ["this_h"],
      localVars: []
    },
    body: {
      body: "if(_inline_1_arg0_>this_h)this_h=_inline_1_arg0_",
      args: [{ "name": "_inline_1_arg0_", "lvalue": false, "rvalue": true, "count": 2 }],
      thisVars: ["this_h"],
      localVars: []
    },
    post: {
      body: "return this_h",
      args: [],
      thisVars: ["this_h"],
      localVars: []
    }
  });
  exports.inf = compile2({
    args: ["array"],
    pre: {
      body: "this_h=Infinity",
      args: [],
      thisVars: ["this_h"],
      localVars: []
    },
    body: {
      body: "if(_inline_1_arg0_<this_h)this_h=_inline_1_arg0_",
      args: [{ "name": "_inline_1_arg0_", "lvalue": false, "rvalue": true, "count": 2 }],
      thisVars: ["this_h"],
      localVars: []
    },
    post: {
      body: "return this_h",
      args: [],
      thisVars: ["this_h"],
      localVars: []
    }
  });
  exports.argmin = compile2({
    args: ["index", "array", "shape"],
    pre: {
      body: "{this_v=Infinity;this_i=_inline_0_arg2_.slice(0)}",
      args: [
        { name: "_inline_0_arg0_", lvalue: false, rvalue: false, count: 0 },
        { name: "_inline_0_arg1_", lvalue: false, rvalue: false, count: 0 },
        { name: "_inline_0_arg2_", lvalue: false, rvalue: true, count: 1 }
      ],
      thisVars: ["this_i", "this_v"],
      localVars: []
    },
    body: {
      body: "{if(_inline_1_arg1_<this_v){this_v=_inline_1_arg1_;for(var _inline_1_k=0;_inline_1_k<_inline_1_arg0_.length;++_inline_1_k){this_i[_inline_1_k]=_inline_1_arg0_[_inline_1_k]}}}",
      args: [
        { name: "_inline_1_arg0_", lvalue: false, rvalue: true, count: 2 },
        { name: "_inline_1_arg1_", lvalue: false, rvalue: true, count: 2 }
      ],
      thisVars: ["this_i", "this_v"],
      localVars: ["_inline_1_k"]
    },
    post: {
      body: "{return this_i}",
      args: [],
      thisVars: ["this_i"],
      localVars: []
    }
  });
  exports.argmax = compile2({
    args: ["index", "array", "shape"],
    pre: {
      body: "{this_v=-Infinity;this_i=_inline_0_arg2_.slice(0)}",
      args: [
        { name: "_inline_0_arg0_", lvalue: false, rvalue: false, count: 0 },
        { name: "_inline_0_arg1_", lvalue: false, rvalue: false, count: 0 },
        { name: "_inline_0_arg2_", lvalue: false, rvalue: true, count: 1 }
      ],
      thisVars: ["this_i", "this_v"],
      localVars: []
    },
    body: {
      body: "{if(_inline_1_arg1_>this_v){this_v=_inline_1_arg1_;for(var _inline_1_k=0;_inline_1_k<_inline_1_arg0_.length;++_inline_1_k){this_i[_inline_1_k]=_inline_1_arg0_[_inline_1_k]}}}",
      args: [
        { name: "_inline_1_arg0_", lvalue: false, rvalue: true, count: 2 },
        { name: "_inline_1_arg1_", lvalue: false, rvalue: true, count: 2 }
      ],
      thisVars: ["this_i", "this_v"],
      localVars: ["_inline_1_k"]
    },
    post: {
      body: "{return this_i}",
      args: [],
      thisVars: ["this_i"],
      localVars: []
    }
  });
  exports.random = makeOp({
    args: ["array"],
    pre: { args: [], body: "this_f=Math.random", thisVars: ["this_f"] },
    body: { args: ["a"], body: "a=this_f()", thisVars: ["this_f"] },
    funcName: "random"
  });
  exports.assign = makeOp({
    args: ["array", "array"],
    body: { args: ["a", "b"], body: "a=b" },
    funcName: "assign"
  });
  exports.assigns = makeOp({
    args: ["array", "scalar"],
    body: { args: ["a", "b"], body: "a=b" },
    funcName: "assigns"
  });
  exports.equals = compile2({
    args: ["array", "array"],
    pre: EmptyProc,
    body: {
      args: [
        { name: "x", lvalue: false, rvalue: true, count: 1 },
        { name: "y", lvalue: false, rvalue: true, count: 1 }
      ],
      body: "if(x!==y){return false}",
      localVars: [],
      thisVars: []
    },
    post: { args: [], localVars: [], thisVars: [], body: "return true" },
    funcName: "equals"
  });
})(ndarrayOps);
var pool$1 = {};
var twiddle = {};
var INT_BITS = 32;
twiddle.INT_BITS = INT_BITS;
twiddle.INT_MAX = 2147483647;
twiddle.INT_MIN = -1 << INT_BITS - 1;
twiddle.sign = function(v) {
  return (v > 0) - (v < 0);
};
twiddle.abs = function(v) {
  var mask = v >> INT_BITS - 1;
  return (v ^ mask) - mask;
};
twiddle.min = function(x, y) {
  return y ^ (x ^ y) & -(x < y);
};
twiddle.max = function(x, y) {
  return x ^ (x ^ y) & -(x < y);
};
twiddle.isPow2 = function(v) {
  return !(v & v - 1) && !!v;
};
twiddle.log2 = function(v) {
  var r, shift;
  r = (v > 65535) << 4;
  v >>>= r;
  shift = (v > 255) << 3;
  v >>>= shift;
  r |= shift;
  shift = (v > 15) << 2;
  v >>>= shift;
  r |= shift;
  shift = (v > 3) << 1;
  v >>>= shift;
  r |= shift;
  return r | v >> 1;
};
twiddle.log10 = function(v) {
  return v >= 1e9 ? 9 : v >= 1e8 ? 8 : v >= 1e7 ? 7 : v >= 1e6 ? 6 : v >= 1e5 ? 5 : v >= 1e4 ? 4 : v >= 1e3 ? 3 : v >= 100 ? 2 : v >= 10 ? 1 : 0;
};
twiddle.popCount = function(v) {
  v = v - (v >>> 1 & 1431655765);
  v = (v & 858993459) + (v >>> 2 & 858993459);
  return (v + (v >>> 4) & 252645135) * 16843009 >>> 24;
};
function countTrailingZeros(v) {
  var c = 32;
  v &= -v;
  if (v) c--;
  if (v & 65535) c -= 16;
  if (v & 16711935) c -= 8;
  if (v & 252645135) c -= 4;
  if (v & 858993459) c -= 2;
  if (v & 1431655765) c -= 1;
  return c;
}
twiddle.countTrailingZeros = countTrailingZeros;
twiddle.nextPow2 = function(v) {
  v += v === 0;
  --v;
  v |= v >>> 1;
  v |= v >>> 2;
  v |= v >>> 4;
  v |= v >>> 8;
  v |= v >>> 16;
  return v + 1;
};
twiddle.prevPow2 = function(v) {
  v |= v >>> 1;
  v |= v >>> 2;
  v |= v >>> 4;
  v |= v >>> 8;
  v |= v >>> 16;
  return v - (v >>> 1);
};
twiddle.parity = function(v) {
  v ^= v >>> 16;
  v ^= v >>> 8;
  v ^= v >>> 4;
  v &= 15;
  return 27030 >>> v & 1;
};
var REVERSE_TABLE = new Array(256);
(function(tab) {
  for (var i = 0; i < 256; ++i) {
    var v = i, r = i, s = 7;
    for (v >>>= 1; v; v >>>= 1) {
      r <<= 1;
      r |= v & 1;
      --s;
    }
    tab[i] = r << s & 255;
  }
})(REVERSE_TABLE);
twiddle.reverse = function(v) {
  return REVERSE_TABLE[v & 255] << 24 | REVERSE_TABLE[v >>> 8 & 255] << 16 | REVERSE_TABLE[v >>> 16 & 255] << 8 | REVERSE_TABLE[v >>> 24 & 255];
};
twiddle.interleave2 = function(x, y) {
  x &= 65535;
  x = (x | x << 8) & 16711935;
  x = (x | x << 4) & 252645135;
  x = (x | x << 2) & 858993459;
  x = (x | x << 1) & 1431655765;
  y &= 65535;
  y = (y | y << 8) & 16711935;
  y = (y | y << 4) & 252645135;
  y = (y | y << 2) & 858993459;
  y = (y | y << 1) & 1431655765;
  return x | y << 1;
};
twiddle.deinterleave2 = function(v, n) {
  v = v >>> n & 1431655765;
  v = (v | v >>> 1) & 858993459;
  v = (v | v >>> 2) & 252645135;
  v = (v | v >>> 4) & 16711935;
  v = (v | v >>> 16) & 65535;
  return v << 16 >> 16;
};
twiddle.interleave3 = function(x, y, z) {
  x &= 1023;
  x = (x | x << 16) & 4278190335;
  x = (x | x << 8) & 251719695;
  x = (x | x << 4) & 3272356035;
  x = (x | x << 2) & 1227133513;
  y &= 1023;
  y = (y | y << 16) & 4278190335;
  y = (y | y << 8) & 251719695;
  y = (y | y << 4) & 3272356035;
  y = (y | y << 2) & 1227133513;
  x |= y << 1;
  z &= 1023;
  z = (z | z << 16) & 4278190335;
  z = (z | z << 8) & 251719695;
  z = (z | z << 4) & 3272356035;
  z = (z | z << 2) & 1227133513;
  return x | z << 2;
};
twiddle.deinterleave3 = function(v, n) {
  v = v >>> n & 1227133513;
  v = (v | v >>> 2) & 3272356035;
  v = (v | v >>> 4) & 251719695;
  v = (v | v >>> 8) & 4278190335;
  v = (v | v >>> 16) & 1023;
  return v << 22 >> 22;
};
twiddle.nextCombination = function(v) {
  var t = v | v - 1;
  return t + 1 | (~t & -~t) - 1 >>> countTrailingZeros(v) + 1;
};
function dupe_array(count, value, i) {
  var c = count[i] | 0;
  if (c <= 0) {
    return [];
  }
  var result = new Array(c), j;
  if (i === count.length - 1) {
    for (j = 0; j < c; ++j) {
      result[j] = value;
    }
  } else {
    for (j = 0; j < c; ++j) {
      result[j] = dupe_array(count, value, i + 1);
    }
  }
  return result;
}
function dupe_number(count, value) {
  var result, i;
  result = new Array(count);
  for (i = 0; i < count; ++i) {
    result[i] = value;
  }
  return result;
}
function dupe(count, value) {
  if (typeof value === "undefined") {
    value = 0;
  }
  switch (typeof count) {
    case "number":
      if (count > 0) {
        return dupe_number(count | 0, value);
      }
      break;
    case "object":
      if (typeof count.length === "number") {
        return dupe_array(count, value, 0);
      }
      break;
  }
  return [];
}
var dup$1 = dupe;
var bits = twiddle;
var dup = dup$1;
var Buffer$1 = require$$2.Buffer;
if (!window.__TYPEDARRAY_POOL) {
  window.__TYPEDARRAY_POOL = {
    UINT8: dup([32, 0]),
    UINT16: dup([32, 0]),
    UINT32: dup([32, 0]),
    BIGUINT64: dup([32, 0]),
    INT8: dup([32, 0]),
    INT16: dup([32, 0]),
    INT32: dup([32, 0]),
    BIGINT64: dup([32, 0]),
    FLOAT: dup([32, 0]),
    DOUBLE: dup([32, 0]),
    DATA: dup([32, 0]),
    UINT8C: dup([32, 0]),
    BUFFER: dup([32, 0])
  };
}
var hasUint8C = typeof Uint8ClampedArray !== "undefined";
var hasBigUint64 = typeof BigUint64Array !== "undefined";
var hasBigInt64 = typeof BigInt64Array !== "undefined";
var POOL = window.__TYPEDARRAY_POOL;
if (!POOL.UINT8C) {
  POOL.UINT8C = dup([32, 0]);
}
if (!POOL.BIGUINT64) {
  POOL.BIGUINT64 = dup([32, 0]);
}
if (!POOL.BIGINT64) {
  POOL.BIGINT64 = dup([32, 0]);
}
if (!POOL.BUFFER) {
  POOL.BUFFER = dup([32, 0]);
}
var DATA = POOL.DATA, BUFFER = POOL.BUFFER;
pool$1.free = function free(array) {
  if (Buffer$1.isBuffer(array)) {
    BUFFER[bits.log2(array.length)].push(array);
  } else {
    if (Object.prototype.toString.call(array) !== "[object ArrayBuffer]") {
      array = array.buffer;
    }
    if (!array) {
      return;
    }
    var n = array.length || array.byteLength;
    var log_n = bits.log2(n) | 0;
    DATA[log_n].push(array);
  }
};
function freeArrayBuffer(buffer) {
  if (!buffer) {
    return;
  }
  var n = buffer.length || buffer.byteLength;
  var log_n = bits.log2(n);
  DATA[log_n].push(buffer);
}
function freeTypedArray(array) {
  freeArrayBuffer(array.buffer);
}
pool$1.freeUint8 = pool$1.freeUint16 = pool$1.freeUint32 = pool$1.freeBigUint64 = pool$1.freeInt8 = pool$1.freeInt16 = pool$1.freeInt32 = pool$1.freeBigInt64 = pool$1.freeFloat32 = pool$1.freeFloat = pool$1.freeFloat64 = pool$1.freeDouble = pool$1.freeUint8Clamped = pool$1.freeDataView = freeTypedArray;
pool$1.freeArrayBuffer = freeArrayBuffer;
pool$1.freeBuffer = function freeBuffer(array) {
  BUFFER[bits.log2(array.length)].push(array);
};
pool$1.malloc = function malloc(n, dtype) {
  if (dtype === void 0 || dtype === "arraybuffer") {
    return mallocArrayBuffer(n);
  } else {
    switch (dtype) {
      case "uint8":
        return mallocUint8(n);
      case "uint16":
        return mallocUint16(n);
      case "uint32":
        return mallocUint32(n);
      case "int8":
        return mallocInt8(n);
      case "int16":
        return mallocInt16(n);
      case "int32":
        return mallocInt32(n);
      case "float":
      case "float32":
        return mallocFloat(n);
      case "double":
      case "float64":
        return mallocDouble(n);
      case "uint8_clamped":
        return mallocUint8Clamped(n);
      case "bigint64":
        return mallocBigInt64(n);
      case "biguint64":
        return mallocBigUint64(n);
      case "buffer":
        return mallocBuffer(n);
      case "data":
      case "dataview":
        return mallocDataView(n);
      default:
        return null;
    }
  }
  return null;
};
function mallocArrayBuffer(n) {
  var n = bits.nextPow2(n);
  var log_n = bits.log2(n);
  var d = DATA[log_n];
  if (d.length > 0) {
    return d.pop();
  }
  return new ArrayBuffer(n);
}
pool$1.mallocArrayBuffer = mallocArrayBuffer;
function mallocUint8(n) {
  return new Uint8Array(mallocArrayBuffer(n), 0, n);
}
pool$1.mallocUint8 = mallocUint8;
function mallocUint16(n) {
  return new Uint16Array(mallocArrayBuffer(2 * n), 0, n);
}
pool$1.mallocUint16 = mallocUint16;
function mallocUint32(n) {
  return new Uint32Array(mallocArrayBuffer(4 * n), 0, n);
}
pool$1.mallocUint32 = mallocUint32;
function mallocInt8(n) {
  return new Int8Array(mallocArrayBuffer(n), 0, n);
}
pool$1.mallocInt8 = mallocInt8;
function mallocInt16(n) {
  return new Int16Array(mallocArrayBuffer(2 * n), 0, n);
}
pool$1.mallocInt16 = mallocInt16;
function mallocInt32(n) {
  return new Int32Array(mallocArrayBuffer(4 * n), 0, n);
}
pool$1.mallocInt32 = mallocInt32;
function mallocFloat(n) {
  return new Float32Array(mallocArrayBuffer(4 * n), 0, n);
}
pool$1.mallocFloat32 = pool$1.mallocFloat = mallocFloat;
function mallocDouble(n) {
  return new Float64Array(mallocArrayBuffer(8 * n), 0, n);
}
pool$1.mallocFloat64 = pool$1.mallocDouble = mallocDouble;
function mallocUint8Clamped(n) {
  if (hasUint8C) {
    return new Uint8ClampedArray(mallocArrayBuffer(n), 0, n);
  } else {
    return mallocUint8(n);
  }
}
pool$1.mallocUint8Clamped = mallocUint8Clamped;
function mallocBigUint64(n) {
  if (hasBigUint64) {
    return new BigUint64Array(mallocArrayBuffer(8 * n), 0, n);
  } else {
    return null;
  }
}
pool$1.mallocBigUint64 = mallocBigUint64;
function mallocBigInt64(n) {
  if (hasBigInt64) {
    return new BigInt64Array(mallocArrayBuffer(8 * n), 0, n);
  } else {
    return null;
  }
}
pool$1.mallocBigInt64 = mallocBigInt64;
function mallocDataView(n) {
  return new DataView(mallocArrayBuffer(n), 0, n);
}
pool$1.mallocDataView = mallocDataView;
function mallocBuffer(n) {
  n = bits.nextPow2(n);
  var log_n = bits.log2(n);
  var cache2 = BUFFER[log_n];
  if (cache2.length > 0) {
    return cache2.pop();
  }
  return new Buffer$1(n);
}
pool$1.mallocBuffer = mallocBuffer;
pool$1.clearCache = function clearCache() {
  for (var i = 0; i < 32; ++i) {
    POOL.UINT8[i].length = 0;
    POOL.UINT16[i].length = 0;
    POOL.UINT32[i].length = 0;
    POOL.INT8[i].length = 0;
    POOL.INT16[i].length = 0;
    POOL.INT32[i].length = 0;
    POOL.FLOAT[i].length = 0;
    POOL.DOUBLE[i].length = 0;
    POOL.BIGUINT64[i].length = 0;
    POOL.BIGINT64[i].length = 0;
    POOL.UINT8C[i].length = 0;
    DATA[i].length = 0;
    BUFFER[i].length = 0;
  }
};
var ndarray = ndarray$1;
var ops = ndarrayOps;
var pool = pool$1;
var texture = createTexture2D;
var linearTypes = null;
var filterTypes = null;
var wrapTypes = null;
function lazyInitLinearTypes(gl) {
  linearTypes = [
    gl.LINEAR,
    gl.NEAREST_MIPMAP_LINEAR,
    gl.LINEAR_MIPMAP_NEAREST,
    gl.LINEAR_MIPMAP_NEAREST
  ];
  filterTypes = [
    gl.NEAREST,
    gl.LINEAR,
    gl.NEAREST_MIPMAP_NEAREST,
    gl.NEAREST_MIPMAP_LINEAR,
    gl.LINEAR_MIPMAP_NEAREST,
    gl.LINEAR_MIPMAP_LINEAR
  ];
  wrapTypes = [
    gl.REPEAT,
    gl.CLAMP_TO_EDGE,
    gl.MIRRORED_REPEAT
  ];
}
function acceptTextureDOM(obj) {
  return "undefined" != typeof HTMLCanvasElement && obj instanceof HTMLCanvasElement || "undefined" != typeof HTMLImageElement && obj instanceof HTMLImageElement || "undefined" != typeof HTMLVideoElement && obj instanceof HTMLVideoElement || "undefined" != typeof ImageData && obj instanceof ImageData;
}
var convertFloatToUint8 = function(out, inp) {
  ops.muls(out, inp, 255);
};
function reshapeTexture(tex, w, h) {
  var gl = tex.gl;
  var maxSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
  if (w < 0 || w > maxSize || h < 0 || h > maxSize) {
    throw new Error("gl-texture2d: Invalid texture size");
  }
  tex._shape = [w, h];
  tex.bind();
  gl.texImage2D(gl.TEXTURE_2D, 0, tex.format, w, h, 0, tex.format, tex.type, null);
  tex._mipLevels = [0];
  return tex;
}
function Texture2D(gl, handle, width, height, format, type) {
  this.gl = gl;
  this.handle = handle;
  this.format = format;
  this.type = type;
  this._shape = [width, height];
  this._mipLevels = [0];
  this._magFilter = gl.NEAREST;
  this._minFilter = gl.NEAREST;
  this._wrapS = gl.CLAMP_TO_EDGE;
  this._wrapT = gl.CLAMP_TO_EDGE;
  this._anisoSamples = 1;
  var parent = this;
  var wrapVector = [this._wrapS, this._wrapT];
  Object.defineProperties(wrapVector, [
    {
      get: function() {
        return parent._wrapS;
      },
      set: function(v) {
        return parent.wrapS = v;
      }
    },
    {
      get: function() {
        return parent._wrapT;
      },
      set: function(v) {
        return parent.wrapT = v;
      }
    }
  ]);
  this._wrapVector = wrapVector;
  var shapeVector = [this._shape[0], this._shape[1]];
  Object.defineProperties(shapeVector, [
    {
      get: function() {
        return parent._shape[0];
      },
      set: function(v) {
        return parent.width = v;
      }
    },
    {
      get: function() {
        return parent._shape[1];
      },
      set: function(v) {
        return parent.height = v;
      }
    }
  ]);
  this._shapeVector = shapeVector;
}
var proto = Texture2D.prototype;
Object.defineProperties(proto, {
  minFilter: {
    get: function() {
      return this._minFilter;
    },
    set: function(v) {
      this.bind();
      var gl = this.gl;
      if (this.type === gl.FLOAT && linearTypes.indexOf(v) >= 0) {
        if (!gl.getExtension("OES_texture_float_linear")) {
          v = gl.NEAREST;
        }
      }
      if (filterTypes.indexOf(v) < 0) {
        throw new Error("gl-texture2d: Unknown filter mode " + v);
      }
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, v);
      return this._minFilter = v;
    }
  },
  magFilter: {
    get: function() {
      return this._magFilter;
    },
    set: function(v) {
      this.bind();
      var gl = this.gl;
      if (this.type === gl.FLOAT && linearTypes.indexOf(v) >= 0) {
        if (!gl.getExtension("OES_texture_float_linear")) {
          v = gl.NEAREST;
        }
      }
      if (filterTypes.indexOf(v) < 0) {
        throw new Error("gl-texture2d: Unknown filter mode " + v);
      }
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, v);
      return this._magFilter = v;
    }
  },
  mipSamples: {
    get: function() {
      return this._anisoSamples;
    },
    set: function(i) {
      var psamples = this._anisoSamples;
      this._anisoSamples = Math.max(i, 1) | 0;
      if (psamples !== this._anisoSamples) {
        var ext = this.gl.getExtension("EXT_texture_filter_anisotropic");
        if (ext) {
          this.gl.texParameterf(this.gl.TEXTURE_2D, ext.TEXTURE_MAX_ANISOTROPY_EXT, this._anisoSamples);
        }
      }
      return this._anisoSamples;
    }
  },
  wrapS: {
    get: function() {
      return this._wrapS;
    },
    set: function(v) {
      this.bind();
      if (wrapTypes.indexOf(v) < 0) {
        throw new Error("gl-texture2d: Unknown wrap mode " + v);
      }
      this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, v);
      return this._wrapS = v;
    }
  },
  wrapT: {
    get: function() {
      return this._wrapT;
    },
    set: function(v) {
      this.bind();
      if (wrapTypes.indexOf(v) < 0) {
        throw new Error("gl-texture2d: Unknown wrap mode " + v);
      }
      this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, v);
      return this._wrapT = v;
    }
  },
  wrap: {
    get: function() {
      return this._wrapVector;
    },
    set: function(v) {
      if (!Array.isArray(v)) {
        v = [v, v];
      }
      if (v.length !== 2) {
        throw new Error("gl-texture2d: Must specify wrap mode for rows and columns");
      }
      for (var i = 0; i < 2; ++i) {
        if (wrapTypes.indexOf(v[i]) < 0) {
          throw new Error("gl-texture2d: Unknown wrap mode " + v);
        }
      }
      this._wrapS = v[0];
      this._wrapT = v[1];
      var gl = this.gl;
      this.bind();
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, this._wrapS);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, this._wrapT);
      return v;
    }
  },
  shape: {
    get: function() {
      return this._shapeVector;
    },
    set: function(x) {
      if (!Array.isArray(x)) {
        x = [x | 0, x | 0];
      } else {
        if (x.length !== 2) {
          throw new Error("gl-texture2d: Invalid texture shape");
        }
      }
      reshapeTexture(this, x[0] | 0, x[1] | 0);
      return [x[0] | 0, x[1] | 0];
    }
  },
  width: {
    get: function() {
      return this._shape[0];
    },
    set: function(w) {
      w = w | 0;
      reshapeTexture(this, w, this._shape[1]);
      return w;
    }
  },
  height: {
    get: function() {
      return this._shape[1];
    },
    set: function(h) {
      h = h | 0;
      reshapeTexture(this, this._shape[0], h);
      return h;
    }
  }
});
proto.bind = function(unit) {
  var gl = this.gl;
  if (unit !== void 0) {
    gl.activeTexture(gl.TEXTURE0 + (unit | 0));
  }
  gl.bindTexture(gl.TEXTURE_2D, this.handle);
  if (unit !== void 0) {
    return unit | 0;
  }
  return gl.getParameter(gl.ACTIVE_TEXTURE) - gl.TEXTURE0;
};
proto.dispose = function() {
  this.gl.deleteTexture(this.handle);
};
proto.generateMipmap = function() {
  this.bind();
  this.gl.generateMipmap(this.gl.TEXTURE_2D);
  var l = Math.min(this._shape[0], this._shape[1]);
  for (var i = 0; l > 0; ++i, l >>>= 1) {
    if (this._mipLevels.indexOf(i) < 0) {
      this._mipLevels.push(i);
    }
  }
};
proto.setPixels = function(data, x_off, y_off, mip_level) {
  var gl = this.gl;
  this.bind();
  if (Array.isArray(x_off)) {
    mip_level = y_off;
    y_off = x_off[1] | 0;
    x_off = x_off[0] | 0;
  } else {
    x_off = x_off || 0;
    y_off = y_off || 0;
  }
  mip_level = mip_level || 0;
  var directData = acceptTextureDOM(data) ? data : data.raw;
  if (directData) {
    var needsMip = this._mipLevels.indexOf(mip_level) < 0;
    if (needsMip) {
      gl.texImage2D(gl.TEXTURE_2D, 0, this.format, this.format, this.type, directData);
      this._mipLevels.push(mip_level);
    } else {
      gl.texSubImage2D(gl.TEXTURE_2D, mip_level, x_off, y_off, this.format, this.type, directData);
    }
  } else if (data.shape && data.stride && data.data) {
    if (data.shape.length < 2 || x_off + data.shape[1] > this._shape[1] >>> mip_level || y_off + data.shape[0] > this._shape[0] >>> mip_level || x_off < 0 || y_off < 0) {
      throw new Error("gl-texture2d: Texture dimensions are out of bounds");
    }
    texSubImageArray(gl, x_off, y_off, mip_level, this.format, this.type, this._mipLevels, data);
  } else {
    throw new Error("gl-texture2d: Unsupported data type");
  }
};
function isPacked(shape, stride) {
  if (shape.length === 3) {
    return stride[2] === 1 && stride[1] === shape[0] * shape[2] && stride[0] === shape[2];
  }
  return stride[0] === 1 && stride[1] === shape[0];
}
function texSubImageArray(gl, x_off, y_off, mip_level, cformat, ctype, mipLevels, array) {
  var dtype = array.dtype;
  var shape = array.shape.slice();
  if (shape.length < 2 || shape.length > 3) {
    throw new Error("gl-texture2d: Invalid ndarray, must be 2d or 3d");
  }
  var type = 0, format = 0;
  var packed = isPacked(shape, array.stride.slice());
  if (dtype === "float32") {
    type = gl.FLOAT;
  } else if (dtype === "float64") {
    type = gl.FLOAT;
    packed = false;
    dtype = "float32";
  } else if (dtype === "uint8") {
    type = gl.UNSIGNED_BYTE;
  } else {
    type = gl.UNSIGNED_BYTE;
    packed = false;
    dtype = "uint8";
  }
  if (shape.length === 2) {
    format = gl.LUMINANCE;
    shape = [shape[0], shape[1], 1];
    array = ndarray(array.data, shape, [array.stride[0], array.stride[1], 1], array.offset);
  } else if (shape.length === 3) {
    if (shape[2] === 1) {
      format = gl.ALPHA;
    } else if (shape[2] === 2) {
      format = gl.LUMINANCE_ALPHA;
    } else if (shape[2] === 3) {
      format = gl.RGB;
    } else if (shape[2] === 4) {
      format = gl.RGBA;
    } else {
      throw new Error("gl-texture2d: Invalid shape for pixel coords");
    }
    shape[2];
  } else {
    throw new Error("gl-texture2d: Invalid shape for texture");
  }
  if ((format === gl.LUMINANCE || format === gl.ALPHA) && (cformat === gl.LUMINANCE || cformat === gl.ALPHA)) {
    format = cformat;
  }
  if (format !== cformat) {
    throw new Error("gl-texture2d: Incompatible texture format for setPixels");
  }
  var size = array.size;
  var needsMip = mipLevels.indexOf(mip_level) < 0;
  if (needsMip) {
    mipLevels.push(mip_level);
  }
  if (type === ctype && packed) {
    if (array.offset === 0 && array.data.length === size) {
      if (needsMip) {
        gl.texImage2D(gl.TEXTURE_2D, mip_level, cformat, shape[0], shape[1], 0, cformat, ctype, array.data);
      } else {
        gl.texSubImage2D(gl.TEXTURE_2D, mip_level, x_off, y_off, shape[0], shape[1], cformat, ctype, array.data);
      }
    } else {
      if (needsMip) {
        gl.texImage2D(gl.TEXTURE_2D, mip_level, cformat, shape[0], shape[1], 0, cformat, ctype, array.data.subarray(array.offset, array.offset + size));
      } else {
        gl.texSubImage2D(gl.TEXTURE_2D, mip_level, x_off, y_off, shape[0], shape[1], cformat, ctype, array.data.subarray(array.offset, array.offset + size));
      }
    }
  } else {
    var pack_buffer;
    if (ctype === gl.FLOAT) {
      pack_buffer = pool.mallocFloat32(size);
    } else {
      pack_buffer = pool.mallocUint8(size);
    }
    var pack_view = ndarray(pack_buffer, shape, [shape[2], shape[2] * shape[0], 1]);
    if (type === gl.FLOAT && ctype === gl.UNSIGNED_BYTE) {
      convertFloatToUint8(pack_view, array);
    } else {
      ops.assign(pack_view, array);
    }
    if (needsMip) {
      gl.texImage2D(gl.TEXTURE_2D, mip_level, cformat, shape[0], shape[1], 0, cformat, ctype, pack_buffer.subarray(0, size));
    } else {
      gl.texSubImage2D(gl.TEXTURE_2D, mip_level, x_off, y_off, shape[0], shape[1], cformat, ctype, pack_buffer.subarray(0, size));
    }
    if (ctype === gl.FLOAT) {
      pool.freeFloat32(pack_buffer);
    } else {
      pool.freeUint8(pack_buffer);
    }
  }
}
function initTexture(gl) {
  var tex = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, tex);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  return tex;
}
function createTextureShape(gl, width, height, format, type) {
  var maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
  if (width < 0 || width > maxTextureSize || height < 0 || height > maxTextureSize) {
    throw new Error("gl-texture2d: Invalid texture shape");
  }
  if (type === gl.FLOAT && !gl.getExtension("OES_texture_float")) {
    throw new Error("gl-texture2d: Floating point textures not supported on this platform");
  }
  var tex = initTexture(gl);
  gl.texImage2D(gl.TEXTURE_2D, 0, format, width, height, 0, format, type, null);
  return new Texture2D(gl, tex, width, height, format, type);
}
function createTextureDOM(gl, directData, width, height, format, type) {
  var tex = initTexture(gl);
  gl.texImage2D(gl.TEXTURE_2D, 0, format, format, type, directData);
  return new Texture2D(gl, tex, width, height, format, type);
}
function createTextureArray(gl, array) {
  var dtype = array.dtype;
  var shape = array.shape.slice();
  var maxSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
  if (shape[0] < 0 || shape[0] > maxSize || shape[1] < 0 || shape[1] > maxSize) {
    throw new Error("gl-texture2d: Invalid texture size");
  }
  var packed = isPacked(shape, array.stride.slice());
  var type = 0;
  if (dtype === "float32") {
    type = gl.FLOAT;
  } else if (dtype === "float64") {
    type = gl.FLOAT;
    packed = false;
    dtype = "float32";
  } else if (dtype === "uint8") {
    type = gl.UNSIGNED_BYTE;
  } else {
    type = gl.UNSIGNED_BYTE;
    packed = false;
    dtype = "uint8";
  }
  var format = 0;
  if (shape.length === 2) {
    format = gl.LUMINANCE;
    shape = [shape[0], shape[1], 1];
    array = ndarray(array.data, shape, [array.stride[0], array.stride[1], 1], array.offset);
  } else if (shape.length === 3) {
    if (shape[2] === 1) {
      format = gl.ALPHA;
    } else if (shape[2] === 2) {
      format = gl.LUMINANCE_ALPHA;
    } else if (shape[2] === 3) {
      format = gl.RGB;
    } else if (shape[2] === 4) {
      format = gl.RGBA;
    } else {
      throw new Error("gl-texture2d: Invalid shape for pixel coords");
    }
  } else {
    throw new Error("gl-texture2d: Invalid shape for texture");
  }
  if (type === gl.FLOAT && !gl.getExtension("OES_texture_float")) {
    type = gl.UNSIGNED_BYTE;
    packed = false;
  }
  var buffer, buf_store;
  var size = array.size;
  if (!packed) {
    var stride = [shape[2], shape[2] * shape[0], 1];
    buf_store = pool.malloc(size, dtype);
    var buf_array = ndarray(buf_store, shape, stride, 0);
    if ((dtype === "float32" || dtype === "float64") && type === gl.UNSIGNED_BYTE) {
      convertFloatToUint8(buf_array, array);
    } else {
      ops.assign(buf_array, array);
    }
    buffer = buf_store.subarray(0, size);
  } else if (array.offset === 0 && array.data.length === size) {
    buffer = array.data;
  } else {
    buffer = array.data.subarray(array.offset, array.offset + size);
  }
  var tex = initTexture(gl);
  gl.texImage2D(gl.TEXTURE_2D, 0, format, shape[0], shape[1], 0, format, type, buffer);
  if (!packed) {
    pool.free(buf_store);
  }
  return new Texture2D(gl, tex, shape[0], shape[1], format, type);
}
function createTexture2D(gl) {
  if (arguments.length <= 1) {
    throw new Error("gl-texture2d: Missing arguments for texture2d constructor");
  }
  if (!linearTypes) {
    lazyInitLinearTypes(gl);
  }
  if (typeof arguments[1] === "number") {
    return createTextureShape(gl, arguments[1], arguments[2], arguments[3] || gl.RGBA, arguments[4] || gl.UNSIGNED_BYTE);
  }
  if (Array.isArray(arguments[1])) {
    return createTextureShape(gl, arguments[1][0] | 0, arguments[1][1] | 0, arguments[2] || gl.RGBA, arguments[3] || gl.UNSIGNED_BYTE);
  }
  if (typeof arguments[1] === "object") {
    var obj = arguments[1];
    var directData = acceptTextureDOM(obj) ? obj : obj.raw;
    if (directData) {
      return createTextureDOM(gl, directData, obj.width | 0, obj.height | 0, arguments[2] || gl.RGBA, arguments[3] || gl.UNSIGNED_BYTE);
    } else if (obj.shape && obj.data && obj.stride) {
      return createTextureArray(gl, obj);
    }
  }
  throw new Error("gl-texture2d: Invalid arguments for texture2d constructor");
}
const createTexture = /* @__PURE__ */ getDefaultExportFromCjs(texture);
const Constants = {
  MaximumDurationOfVideo: 60 * 60,
  MaximumDurationOfVideoInFree: 3 * 60,
  CONVERSATION_INTERVAL: 0,
  CONVERSATION_PAUSE: 0.5,
  // ConversationFirstAvatarId: VITE_API_URL === 'api-test.vidnoz.com' ? 316 : 736,
  // ConversationSecondAvatarId: VITE_API_URL === 'api-test.vidnoz.com' ? 312 : 716,
  BgMusicId: "bgMusic",
  TransparentAvatarPercent: 20,
  heartInterval: 60 * 1e3
};
Object.freeze(Constants);
initDefFabric();
setup();
adjustWebglFilterBackend();
initCustomObjectFunction();
let fabCanvasArray = [];
const speechList = /* @__PURE__ */ new Map();
const bgmList = /* @__PURE__ */ new Map();
let displayCvs = null;
let backgroundAudioVolume = 0.1;
async function loadFromJson(json, canvas) {
  playEmitter.emit(playStates.initStart);
  const tempClips = json.clips;
  let firstSceneTextStyle = null;
  initSubtitleConfig(json);
  for (let i = 0; i < tempClips.length; i++) {
    await initConfig(tempClips[i], firstSceneTextStyle, true, speechList, bgmList);
    if (i === 0) {
      firstSceneTextStyle = { ...tempClips[i].textStyle };
    }
  }
  backgroundAudioVolume = hasKey(json, "backgroundAudioVolume") ? json.backgroundAudioVolume : 0.1;
  if ((json.audioFileStaticUrl || json.audioFilePath) && (json == null ? void 0 : json.bgMusicId)) {
    const audio = createAudioElement();
    audio.id = Constants.BgMusicId;
    audio.volume = backgroundAudioVolume;
    document.body.appendChild(audio);
    if (json.audioFileStaticUrl) {
      audio.src = json.audioFileStaticUrl;
    } else if (json.audioFilePath) {
      requestReouseceUrl(json.audioFilePath).then((data) => {
        audio.src = data.url;
      });
    }
  }
  const layout = json.layout;
  fabCanvasArray = await addClip(json.clips, layout);
  const desCvs = new fabric.fabric.StaticCanvas(canvas, {
    enableRetinaScaling: false
  });
  displayCvs = desCvs;
  initClipLayout(layout, desCvs);
  window.fabCanvasArray = fabCanvasArray;
  window.fab = desCvs;
  await loadFromJsonAndDoSomething(desCvs, fabCanvasArray[0]);
  playEmitter.emit(playStates.initEnd);
}
function getAbortError(reason = "") {
  return new Error("abort error: " + reason, {
    cause: {
      reason: "abort"
    }
  });
}
function waitMediaLoad(id, signal = null) {
  let timeOut = 0;
  return new Promise((resolve, reject) => {
    const media = document.getElementById(id);
    const handle = setInterval(() => {
      if (signal && signal.aborted) {
        clearInterval(handle);
        reject(getAbortError("loadMedia"));
      }
      timeOut = timeOut + 50;
      if (timeOut > 18e4) {
        clearInterval(handle);
        reject(new Error("media load timeout"));
      }
      const toState = isIOS() ? 1 : 4;
      if (media.readyState === toState || media.readyState === 4) {
        clearInterval(handle);
        resolve();
      }
    }, 50);
  });
}
async function waitBgmLoaded(bgmInfo, signal = null) {
  let audio = document.querySelector(`#${normalizeBgmID(bgmInfo.audioId)}`);
  if (!audio) {
    audio = createAudioElement();
    audio.id = normalizeBgmID(bgmInfo.audioId);
    document.body.appendChild(audio);
    let setUrl = "";
    if (bgmInfo._staticUrl) {
      setUrl = bgmInfo._staticUrl;
    } else {
      const data = await requestReouseceUrlTakeSignal(bgmInfo._urlkey, signal);
      setUrl = data.static_url || data.url;
    }
    audio.src = setUrl;
  } else {
    const toState = isIOS() ? 1 : 4;
    if (audio.readyState === toState || audio.readyState === 4) {
      return;
    }
  }
  await waitMediaLoad(`${normalizeBgmID(bgmInfo.audioId)}`, signal);
}
function createSpeechAudio(id, src, loadController2) {
  return new Promise((resolve, reject) => {
    const curId = normalizeDefaultID(id);
    const audio = document.createElement("audio");
    audio.setAttribute("id", curId);
    audio.preload = "auto";
    audio.addEventListener("canplaythrough", () => {
      const oldEle = document.getElementById(curId);
      if (oldEle) {
        document.body.replaceChild(audio, oldEle);
      } else {
        document.body.appendChild(audio);
      }
      resolve();
    });
    audio.src = src;
    if (loadController2) {
      loadController2.signal.addEventListener("abort", () => {
        reject(getAbortError("audio"));
      });
    }
  });
}
function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
async function loadSpeechAudio(info) {
  const { audioId, resourceInfo, loadController: loadController2 } = { ...info };
  if (resourceInfo.staticUrl) {
    await createSpeechAudio(audioId, resourceInfo.staticUrl, loadController2).catch((reason) => {
      throw reason;
    });
  } else if (resourceInfo.key) {
    const sourceInfo = await requestReouseceUrlTakeSignal(resourceInfo.key, loadController2 == null ? void 0 : loadController2.signal);
    await createSpeechAudio(audioId, sourceInfo.url, loadController2);
  }
}
async function getTaskDetail(taskId, signal = null) {
  const res2 = await jqAjaxPromiseWithHandleException({
    url: "/ai/task/detail",
    type: "GET",
    data: {
      task_id: taskId
    }
  }, false, signal);
  const finishTask = res2.data.status === 0;
  const unexpectedError = res2.data.status === 1;
  if (finishTask) {
    return res2.data.additional_data;
  } else if (unexpectedError) {
    throw new Error("unexpectedError: taskDetail 1");
  } else {
    await delay(1e3);
    return await getTaskDetail(taskId, signal);
  }
}
async function loadTTS(speechInfo, audioId, signal = null) {
  function creaGenerateTask(speechInfo2, signal2) {
    if (speechInfo2.property.voiceType === "clone") {
      return jqAjaxPromiseWithHandleException({
        url: "/ai/task/generate",
        type: "POST",
        data: {
          action: "tts_by_cloned_voice",
          param: {
            model: { ...speechInfo2.property.model },
            ref: { ...speechInfo2.property.ref },
            script: {
              text: speechInfo2.text
            },
            tts_config: { ...speechInfo2.property.tts_config },
            speed: speechInfo2.speed,
            subtitle: true
          }
        }
      }, true, signal2);
    } else {
      return jqAjaxPromiseWithHandleException({
        url: "/ai/task/generate",
        type: "POST",
        data: {
          action: "tts",
          param: {
            tts_config: { ...speechInfo2.property.tts_config },
            text: speechInfo2.text,
            speed: speechInfo2.speed,
            pitch: speechInfo2.pitch,
            subtitle: true
          }
        }
      }, true, signal2);
    }
  }
  function getTimesAndCreateAudio(url, signal2 = null) {
    return new Promise((resolve, reject) => {
      const audioElement = new Audio(url);
      audioElement.setAttribute("id", audioId);
      audioElement.addEventListener("loadedmetadata", () => {
        const duration = audioElement.duration;
        const oldAudioElement = document.getElementById(audioId);
        if (oldAudioElement) {
          document.body.replaceChild(audioElement, oldAudioElement);
        } else {
          document.body.appendChild(audioElement);
        }
        resolve(duration);
      });
      if (signal2) {
        signal2.addEventListener("abort", () => {
          reject(getAbortError("createAudio"));
        });
      }
    });
  }
  async function getFileDetail(key, signal2 = null) {
    const res2 = await jqAjaxPromiseWithHandleException({
      url: "/ai/source/get-access-url",
      type: "POST",
      data: {
        key
      }
    }, false, signal2);
    const audioDuration2 = await getTimesAndCreateAudio(res2.data.url, signal2);
    return audioDuration2;
  }
  const genetateRes = await creaGenerateTask(speechInfo, signal);
  const taskId = genetateRes.data.task_id;
  const taskData = await getTaskDetail(taskId, signal);
  const _url = taskData.static_url ? taskData.static_url : taskData.url;
  let audioDuration = 0;
  if (_url) {
    audioDuration = await getTimesAndCreateAudio(_url, signal);
  } else {
    audioDuration = await getFileDetail(taskData.key, signal);
  }
  if (!speechInfo.resourceInfo) {
    speechInfo.resourceInfo = {};
  }
  speechInfo.resourceInfo.key = taskData.key;
  speechInfo.resourceInfo.url = taskData.url;
  speechInfo.resourceInfo.staticUrl = taskData.static_url;
  speechInfo.subtitles = taskData.subtitles;
  speechInfo.duration = audioDuration;
}
async function waitSpeechVoiceLoad(info, audioId, signal = null) {
  return new Promise((resolve, reject) => {
    const audio = document.createElement("audio");
    audio.id = `speech-audio-upload${audioId}`;
    audio.addEventListener("loadedmetadata", () => {
      const oldAudioElement = document.getElementById(audio.id);
      if (oldAudioElement) {
        document.body.replaceChild(audio, oldAudioElement);
      } else {
        document.body.appendChild(audio);
      }
      resolve();
    });
    if (info.staticUrl) {
      audio.src = info.staticUrl;
    } else if (info.key) {
      requestReouseceUrlTakeSignal(info.key, signal).then((value) => {
        if (value.static_url) {
          info.staticUrl = value.static_url;
          audio.src = value.static_url;
        } else {
          audio.src = value.url;
        }
      }).catch((reson) => {
        reject(reson);
      });
    } else {
      reject(new Error("do not hava staticUrl or key when load uploadVoice"));
    }
  });
}
async function waitWholeBgmLoaded(options, signal = null) {
  const audio = document.querySelector(`#${Constants.BgMusicId}`);
  if (!audio) {
    return;
  }
  const toState = isIOS() ? 1 : 4;
  if (audio.readyState === toState || audio.readyState === 4) {
    return;
  }
  await waitMediaLoad(`${Constants.BgMusicId}`, signal);
}
function waitResourceLoad(currentClip = false, forGenerate = false, includeAllSceneBgm = false, abortController = null) {
  const resourceTask = [];
  let clips = [];
  clips = fabCanvasArray;
  for (let i = 0; i < clips.length; i++) {
    if (clips[i].loadList.includes("video") && !forGenerate) {
      const layers = clips[i].getObjects();
      for (let j = 0; j < layers.length; j++) {
        if (layers[j].type === "CustomVideo") {
          resourceTask.push(waitMediaLoad(layers[j].videoId, abortController == null ? void 0 : abortController.signal));
        }
      }
    }
    const bgmInfo = bgmList.get(fabCanvasArray[i].bgmId);
    if (bgmInfo) {
      const needLoad = Boolean(bgmInfo._urlkey || bgmInfo._staticUrl);
      if (needLoad) {
        resourceTask.push(waitBgmLoaded(bgmInfo, abortController == null ? void 0 : abortController.signal));
      }
    }
    if (clips[i].loadList.includes("speech")) {
      const speechInfo = speechList.get(clips[i].speechId);
      const speechType = speechInfo.type || "default";
      const typeInfo = speechInfo[speechType];
      if (speechType === "default") {
        const haveKey = typeInfo.resourceInfo && (typeInfo.resourceInfo.key || typeInfo.resourceInfo.staticUrl);
        if (haveKey) {
          const options = {
            audioId: speechInfo.audioId,
            resourceInfo: typeInfo.resourceInfo,
            loadController: abortController
          };
          resourceTask.push(loadSpeechAudio(options));
        } else {
          if (typeInfo.text) {
            const id = normalizeDefaultID(speechInfo.audioId);
            resourceTask.push(loadTTS(typeInfo, id, abortController == null ? void 0 : abortController.signal));
          }
        }
      } else if (speechType === "uploadVoice") {
        if (typeInfo.key || typeInfo.staticUrl) {
          resourceTask.push(waitSpeechVoiceLoad(typeInfo, speechInfo.audioId, abortController == null ? void 0 : abortController.signal));
        }
      } else if (speechType === "duration") ;
      else if (speechType === "conversation") {
        const conversationList = [];
        const contents = typeInfo.content;
        for (let i2 = 0; i2 < contents.length; i2++) {
          const hasLoaded = contents[i2].loaded;
          const loadAudio = document.querySelector(`#${normalizeConversationID(speechInfo.audioId, i2)}`);
          if (hasLoaded && loadAudio) {
            continue;
          }
          const haveKey = contents[i2].resourceInfo && (contents[i2].resourceInfo.key || contents[i2].resourceInfo.staticUrl);
          if (haveKey) {
            const options = {
              audioId: speechInfo.audioId + "-" + i2,
              resourceInfo: contents[i2].resourceInfo,
              loadController: abortController
            };
            conversationList.push(loadSpeechAudio(options));
          } else {
            if (contents[i2].text) {
              const _speechInfo = contents[i2];
              _speechInfo.speed = typeInfo.roles[_speechInfo._roleIndex].speed;
              _speechInfo.property = typeInfo.roles[_speechInfo._roleIndex].property;
              _speechInfo.pitch = typeInfo.roles[_speechInfo._roleIndex].pitch;
              const id = normalizeConversationID(speechInfo.audioId, i2);
              conversationList.push(loadTTS(_speechInfo, id, abortController == null ? void 0 : abortController.signal));
            }
          }
        }
        resourceTask.push(Promise.all(conversationList));
      }
    }
  }
  if (!currentClip && includeAllSceneBgm) {
    const hasBgMusic = document.querySelector(`#${Constants.BgMusicId}`);
    if (hasBgMusic) {
      resourceTask.push(waitWholeBgmLoaded({}, abortController == null ? void 0 : abortController.signal));
    }
  }
  return Promise.all([...resourceTask]);
}
function isMediaLoadEnd(id) {
  const _audio = document.querySelector(`#${id}`);
  if (_audio) {
    const toState = isIOS() ? 1 : 4;
    if (_audio.readyState === toState || _audio.readyState === 4) {
      return true;
    }
  }
  return false;
}
function hasEnterAnimation(obj) {
  var _a, _b, _c;
  if (!(obj == null ? void 0 : obj.animation)) return false;
  if (!((_a = obj == null ? void 0 : obj.animation) == null ? void 0 : _a.enter)) return false;
  if (((_c = (_b = obj == null ? void 0 : obj.animation) == null ? void 0 : _b.enter) == null ? void 0 : _c.name) === "none") return false;
  return true;
}
function hasExitAnimation(obj) {
  var _a, _b, _c;
  if (!(obj == null ? void 0 : obj.animation)) return false;
  if (!((_a = obj == null ? void 0 : obj.animation) == null ? void 0 : _a.exit)) return false;
  if (((_c = (_b = obj == null ? void 0 : obj.animation) == null ? void 0 : _b.exit) == null ? void 0 : _c.name) === "none") return false;
  return true;
}
function hasOldAnimation(obj) {
  return hasEnterAnimation(obj) || hasExitAnimation(obj);
}
function calculateDuration(clip, speechList2) {
  const objs = clip.getObjects();
  const defaultDuration = 1;
  let duration = 0;
  for (let i = 0; i < objs.length; i++) {
    const obj = objs[i];
    const animation = obj.animation;
    let tempduration = 0;
    const aniDelay = obj._timelineStart ? obj._timelineStart : 0;
    if (hasOldAnimation(obj)) {
      if (hasEnterAnimation(obj)) {
        tempduration = tempduration + animation.enter.duration;
      }
      if (hasExitAnimation(obj)) {
        tempduration = tempduration + animation.exit.duration;
      }
      tempduration = tempduration + aniDelay;
      if (tempduration > duration) {
        duration = tempduration;
      }
    }
  }
  const speechInfo = speechList2.get(clip.speechId);
  const typeInfo = speechInfo[speechInfo.type];
  let speechDuration = 0;
  if (speechInfo.type === "conversation") {
    typeInfo.content.forEach((item) => {
      speechDuration = speechDuration + item.duration + item.delay;
    });
  } else {
    speechDuration = typeInfo.duration;
  }
  if (speechDuration > duration) {
    duration = speechDuration;
  }
  if (duration) {
    return toFixedNoRound$1(duration, 1);
  } else {
    return defaultDuration;
  }
}
async function setVideoElement(currentClip = false) {
  const clips = fabCanvasArray;
  for (let i = 0; i < clips.length; i++) {
    if (!clips[i].loadList.includes("video")) continue;
    const layers = clips[i].getObjects();
    for (let j = 0; j < layers.length; j++) {
      if (layers[j].type === "CustomVideo") {
        layers[j].mountVideo();
        await layers[j].seek(layers[j]._start);
      }
    }
    if (clips[i].backgroundImage && isMediaLoadEnd(clips[i].backgroundImage.videoId)) {
      clips[i].backgroundImage.mountVideo();
      await clips[i].backgroundImage.seek(clips[i].backgroundImage._start);
    }
    clips[i].renderAll();
  }
}
function dealwithTimeline(scene) {
  const duration = scene.duration;
  const objs = scene.getObjects();
  objs.forEach((obj) => {
    let start = hasKey(obj, "_timelineStart") ? obj._timelineStart : null;
    const end = hasKey(obj, "_timelineEnd") ? obj._timelineEnd : null;
    if (start !== null) {
      if (start >= duration) {
        start = duration - 1;
        obj._timelineStart = start;
      }
    }
    if (end !== null) {
      if (end >= duration) {
        delete obj._timelineEnd;
      }
    }
  });
}
function setSpeechVolumeByConfig(current = true) {
  let arr = [];
  arr = fabCanvasArray;
  arr.forEach((clip, i) => {
    const speechInfo = speechList.get(clip.speechId);
    if (speechInfo.type === "default") {
      const id = normalizeDefaultID(speechInfo.audioId);
      const audio = document.querySelector(`#${id}`);
      if (audio) {
        audio.volume = speechInfo.default.volume;
      }
    } else if (speechInfo.type === "conversation") {
      speechInfo.conversation.content.forEach((item, j) => {
        const id = normalizeConversationID(speechInfo.audioId, j);
        const audio = document.querySelector(`#${id}`);
        if (audio) {
          audio.volume = speechInfo.conversation.roles[item._roleIndex].volume;
        }
      });
    }
  });
}
function setClipDuration(currentClip = false) {
  const clips = fabCanvasArray;
  for (let i = 0; i < clips.length; i++) {
    clips[i].duration = calculateDuration(clips[i], speechList);
    dealwithTimeline(clips[i]);
  }
}
async function waitResourceLoadAndSetUi(currentClip = false, forGenerate = false, includeAllSceneBgm = false, abortController = null) {
  await waitResourceLoad(currentClip, forGenerate, includeAllSceneBgm, abortController);
  setVideoElement(currentClip);
  setClipDuration(currentClip);
  setSpeechVolumeByConfig(currentClip);
}
const elementType = {
  image: "CustomImage",
  video: "CustomVideo",
  icon: "CustomIcon",
  // shape 单独判断
  // shape: isDefShape()
  avatar: "Avatar",
  text: "textbox",
  sticker: "CustomSticker"
};
function setVideoSpeed(clips, setDefault = false) {
  for (let i = 0; i < clips.length; i++) {
    const curClip = clips[i];
    const layers = curClip.getObjects("CustomVideo");
    for (let j = 0; j < layers.length; j++) {
      const videoElement = document.querySelector(`#${layers[j].videoId}`);
      if (!videoElement) continue;
      try {
        videoElement.playbackRate = setDefault ? 1 : parseFloat(layers[j]._speed);
      } catch (error) {
        videoElement.playbackRate = 1;
      }
    }
    const bg = curClip.backgroundImage;
    const isVideoBg = bg && bg.isType(elementType.video);
    if (!isVideoBg) continue;
    const bgVideoElement = document.querySelector(`#${bg.videoId}`);
    if (!bgVideoElement) continue;
    bgVideoElement.playbackRate = setDefault ? 1 : parseFloat(bg._speed);
  }
}
function getClipStartTime(idx) {
  let duration = 0;
  for (let i = 0; i < idx; i++) {
    duration = fabCanvasArray[i].duration + duration;
    if (fabCanvasArray[i].transition && fabCanvasArray[i].transition.name !== "none") {
      duration = duration - fabCanvasArray[i].transition.duration;
    }
  }
  return duration;
}
function getTransitionStartTimeByIdx(idx) {
  return getClipStartTime(idx) + fabCanvasArray[idx].duration - fabCanvasArray[idx].transition.duration;
}
function getVideoDuration() {
  return getClipStartTime(fabCanvasArray.length - 1) + fabCanvasArray[fabCanvasArray.length - 1].duration;
}
function findClipByStart(startTime) {
  const clipList = fabCanvasArray;
  let lastClipEnd = 0;
  let start = 0;
  let end = 0;
  for (let i = 0; i < clipList.length; i++) {
    if (i === 0) {
      end = clipList[i].duration;
    } else {
      start = lastClipEnd;
      if (clipList[i - 1].transition && clipList[i - 1].transition.name !== "none") {
        end = start + clipList[i].duration - clipList[i - 1].transition.duration;
      } else {
        end = start + clipList[i].duration;
      }
    }
    if (startTime >= start && startTime < end) {
      return i;
    }
    lastClipEnd = end;
  }
}
function pauseVideoAndReturnZero(clip, zero = true) {
  const vdObjs = clip.getObjects("CustomVideo");
  for (let i = 0; i < vdObjs.length; i++) {
    vdObjs[i].pause(zero);
    vdObjs[i].dirty = true;
  }
  const bg = clip.backgroundImage;
  const isVideoBg = bg && bg.isType(elementType.video);
  if (isVideoBg) {
    bg.pause(zero);
  }
  if (!clip.speechId) return;
  const speechInfo = speechList.get(clip.speechId);
  const audioId = speechInfo.audioId;
  let _id = "";
  if (speechInfo.type === "default") {
    _id = normalizeDefaultID(audioId);
  } else if (speechInfo.type === "uploadVoice") {
    _id = "speech-audio-upload" + audioId;
  } else if (speechInfo.type === "conversation") {
    const contents = speechInfo.conversation.content;
    for (let i = 0; i < contents.length; i++) {
      _id = normalizeConversationID(audioId, i);
      const audio2 = document.getElementById(_id);
      if (audio2) {
        audio2.pause();
        if (zero) {
          audio2.currentTime = 0;
        }
      }
    }
    return;
  }
  if (!_id) return;
  const audio = document.getElementById(_id);
  if (audio) {
    audio.pause();
    if (zero) {
      audio.currentTime = 0;
    }
  }
}
function pauseStickers(cvs, reset = true) {
  let _cvs = cvs;
  if (!cvs) {
    _cvs = this.editer;
  }
  _cvs.getObjects("CustomSticker").forEach((sticker) => {
    sticker.pause(reset);
  });
}
function getBgmAudioByIndex(idx) {
  const bgmInfo = bgmList.get(fabCanvasArray[idx].bgmId);
  if (bgmInfo._urlkey || bgmInfo._staticUrl) {
    const audio = document.querySelector(`#${normalizeBgmID(bgmInfo.audioId)}`);
    return audio;
  }
  return null;
}
function pauseSceneBgmByIndexAndReturnZero(idx, zero = true) {
  const audio = getBgmAudioByIndex(idx);
  if (audio) {
    audio.pause();
    audio.currentTime = zero ? 0 : audio.currentTime;
  }
}
function pauseVideoBgmAndReturnZero(zero = true) {
  const bgMusic = document.querySelector(`#${Constants.BgMusicId}`);
  if (bgMusic) {
    if (!bgMusic.paused) {
      bgMusic.pause();
    }
    bgMusic.currentTime = zero ? 0 : bgMusic.currentTime;
  }
}
function pauseAllBgmAndReturnZero(zero = true) {
  fabCanvasArray.forEach((item, i) => {
    pauseSceneBgmByIndexAndReturnZero(i, zero);
  });
  pauseVideoBgmAndReturnZero(zero);
}
function playConversation(seekTime, speechInfo, firstPlay = false) {
  const audioId = speechInfo.audioId;
  const contents = speechInfo.conversation.content;
  let voiceStart = 0;
  let voiceEnd = 0;
  for (let i = 0; i < contents.length; i++) {
    if (i === 0) {
      voiceStart = 0;
      voiceEnd = contents[i].duration;
    } else {
      voiceStart = voiceEnd;
      voiceEnd = voiceStart + contents[i].duration;
    }
    if (seekTime >= voiceStart && seekTime < voiceEnd) {
      const tempId = normalizeConversationID(audioId, i);
      const tempAudio = document.getElementById(tempId);
      if (firstPlay) {
        tempAudio.currentTime = seekTime - voiceStart;
      }
      if (tempAudio.paused) {
        tempAudio.play();
      }
    }
  }
}
function playClipAudio(idx, tempTimestamp) {
  const clipSeekTime = tempTimestamp - getClipStartTime(idx);
  const clip = fabCanvasArray[idx];
  const speechInfo = speechList.get(clip.speechId);
  const audioId = speechInfo.audioId;
  if (speechInfo.type === "uploadVoice") {
    const _id = `speech-audio-upload${audioId}`;
    const clipAuido = document.querySelector(`#${_id}`);
    if (speechInfo.uploadVoice.key || speechInfo.uploadVoice.staticUrl) {
      if (clipAuido.paused) {
        if (clipSeekTime < clipAuido.duration) {
          clipAuido.currentTime = clipSeekTime;
          clipAuido.play();
        }
      }
    }
  } else if (speechInfo.type === "default") {
    const _id = normalizeDefaultID(audioId);
    const clipAuido = document.querySelector(`#${_id}`);
    if (clipAuido && speechInfo.default.text) {
      if (clipAuido.paused) {
        if (clipSeekTime < clipAuido.duration) {
          clipAuido.currentTime = clipSeekTime;
          clipAuido.play();
        }
      }
    }
  } else if (speechInfo.type === "conversation") {
    playConversation(clipSeekTime, speechInfo, true);
  }
}
function initObjByAnimation(animateName, obj) {
  switch (animateName) {
    case "fadein":
      obj.opacity = 0;
      break;
    case "fadein-l":
      obj.opacity = 0;
      obj.left = -obj.getScaledWidth();
      break;
    case "fadein-r":
      obj.opacity = 0;
      obj.left = obj.canvas.width;
      break;
    case "fadein-t":
      obj.opacity = 0;
      obj.top = -obj.getScaledHeight();
      break;
    case "fadein-d":
      obj.opacity = 0;
      obj.top = obj.canvas.height;
      break;
    case "slidein-l":
      obj.left = -obj.getScaledWidth();
      break;
    case "slidein-r":
      obj.left = obj.canvas.width;
      break;
    case "slidein-t":
      obj.top = -obj.getScaledHeight();
      break;
    case "slidein-d":
      obj.top = obj.canvas.height;
      break;
    case "fade-scalein":
      obj._setOriginToCenter();
      obj.scaleX = 0.01;
      obj.scaleY = 0.01;
      obj.opacity = 0;
      obj._resetOrigin();
      break;
    case "scalein":
      obj._setOriginToCenter();
      obj.scaleX = 0.01;
      obj.scaleY = 0.01;
      obj._resetOrigin();
      break;
  }
}
async function initClip(idx, cvs) {
  await loadFromJsonAndDoSomething(cvs, fabCanvasArray[idx]);
  const avatars = cvs.getObjects(elementType.avatar);
  const speechInfo = speechList.get(fabCanvasArray[idx].speechId);
  const sceneSpeechIsConversation = speechInfo.type === "conversation";
  const deleteAvatar = [];
  avatars.forEach((avatar) => {
    const isConversationAvatar = hasKey(avatar, "_roleIndex");
    if (sceneSpeechIsConversation) {
      if (!isConversationAvatar) {
        deleteAvatar.push(avatar);
      }
    } else {
      if (isConversationAvatar) {
        deleteAvatar.push(avatar);
      }
    }
  });
  cvs.remove(...deleteAvatar);
  for (let i = 0; i < cvs.getObjects().length; i++) {
    const obj = cvs.getObjects()[i];
    if (obj.animation && obj.animation.enter) {
      const animate = obj.animation.enter;
      initObjByAnimation(animate.name, obj);
    }
    if (!hasOldAnimation(obj)) {
      const start = hasKey(obj, "_timelineStart") ? obj._timelineStart : 0;
      if (start > 0) {
        obj.visible = false;
      }
    }
  }
}
function mergeSubtitleAndMountOnCacheCanvas(cacheCvs) {
  const speechInfo = speechList.get(cacheCvs.speechId);
  if (speechInfo.type === "default") {
    if (speechInfo.default.subtitles) {
      cacheCvs._subtitles = JSON.parse(JSON.stringify(speechInfo.default.subtitles));
    } else {
      cacheCvs._subtitles = [];
    }
  } else if (speechInfo.type === "conversation") {
    const contents = speechInfo.conversation.content;
    let voiceStart = 0;
    let voiceEnd = 0;
    const totleSubtitle = [];
    for (let i = 0; i < contents.length; i++) {
      if (i === 0) {
        voiceStart = 0;
        voiceEnd = voiceEnd + contents[i].duration;
        const subtitles = contents[i].subtitles;
        if (!subtitles) {
          continue;
        }
        for (let j = 0; j < subtitles.length; j++) {
          totleSubtitle.push(subtitles[j]);
        }
      } else {
        voiceStart = voiceEnd + contents[i].delay;
        voiceEnd = voiceEnd + contents[i].duration;
        const subtitles = contents[i].subtitles;
        if (!subtitles) {
          continue;
        }
        for (let j = 0; j < subtitles.length; j++) {
          totleSubtitle.push({ ...subtitles[j] });
          totleSubtitle[totleSubtitle.length - 1].audio_offset = totleSubtitle[totleSubtitle.length - 1].audio_offset + voiceStart * 1e3;
        }
      }
    }
    cacheCvs._subtitles = totleSubtitle;
  } else {
    cacheCvs._subtitles = null;
  }
}
async function initVideoStartTime(cacheCvs, tempTimestamp) {
  const currentTimeInClip = tempTimestamp - cacheCvs.startat;
  const vds = cacheCvs.getObjects("CustomVideo");
  for (let i = 0; i < vds.length; i++) {
    const clipDuration = parseFloat(new Decimal(vds[i]._end).minus(vds[i]._start).toString());
    let delayTime = 0;
    if (vds[i].animation) {
      delayTime = vds[i].animation.enter.delay;
    }
    let seekTime = 0;
    if (currentTimeInClip > delayTime) {
      if (vds[i]._loop) {
        seekTime = vds[i]._start + (currentTimeInClip - delayTime) % clipDuration;
      } else {
        if (currentTimeInClip < clipDuration + delayTime) {
          seekTime = vds[i]._start + (currentTimeInClip - delayTime);
        } else {
          seekTime = vds[i]._start + clipDuration;
        }
      }
    } else {
      seekTime = vds[i]._start;
    }
    await vds[i].seek(seekTime);
    vds[i].dirty = true;
  }
}
async function controlVideoWhenPreview(video, currentTimeInClip, startDelay, isSeek = false) {
  const realDuration = parseFloat(new Decimal(video._end).minus(video._start).toString());
  const videoDuration = realDuration / parseFloat(video._speed);
  if (isSeek) {
    let seekTime = 0;
    if (!video._loop) {
      if (currentTimeInClip >= videoDuration + startDelay) {
        seekTime = video._start + realDuration;
      } else if (currentTimeInClip < videoDuration + startDelay && currentTimeInClip > startDelay) {
        seekTime = video._start + currentTimeInClip / parseFloat(video._speed);
      }
    } else {
      let videoTime = 0;
      if (currentTimeInClip >= startDelay) {
        videoTime = currentTimeInClip - startDelay;
        seekTime = video._start + videoTime % videoDuration / parseFloat(video._speed);
      }
    }
    await video.seek(seekTime);
  } else {
    if (!video._loop) {
      if (currentTimeInClip >= videoDuration + startDelay) {
        video.pause();
      } else {
        video.play();
      }
    } else {
      if (!video.playtime) {
        video.playtime = 1;
      }
      if (currentTimeInClip >= videoDuration * video.playtime + startDelay) {
        await video.seek(video._start);
        video.playtime = video.playtime + 1;
      }
      video.play();
    }
  }
  video.dirty = true;
}
async function renderInCache(cacheCvs, timeStamp, seek2 = false, isPreview = false) {
  const objs = cacheCvs.getObjects();
  const currentTimeInClip = timeStamp - cacheCvs.startat;
  for (let i = 0; i < objs.length; i++) {
    const start = hasKey(objs[i], "_timelineStart") ? objs[i]._timelineStart : 0;
    const end = hasKey(objs[i], "_timelineEnd") ? objs[i]._timelineEnd : cacheCvs.duration;
    if (currentTimeInClip >= start && currentTimeInClip < end) {
      if (objs[i].visible === false && !objs[i].animator) {
        objs[i].visible = true;
        cacheCvs.renderAll();
      }
      if (objs[i].animations && objs[i].animations.length > 0) {
        if (!objs[i].animator) {
          const _animator = await animator(objs[i], cacheCvs, {
            animations: objs[i].animations,
            duration: (end - start) * 1e3
          });
          objs[i].animator = _animator;
        }
        if (objs[i].type === elementType.video || objs[i].type === elementType.sticker) {
          const sceneDurationInAnimator = objs[i].animator.params.duration;
          objs[i].animator.cleanup();
          objs[i].animator = null;
          if (objs[i].animations) {
            const _animator = await animator(objs[i], cacheCvs, {
              animations: objs[i].animations,
              duration: sceneDurationInAnimator
            });
            objs[i].animator = _animator;
          }
        }
        objs[i].animator.seek(currentTimeInClip * 1e3 - start * 1e3);
      }
    } else if (currentTimeInClip >= end) {
      if (objs[i].animator) {
        objs[i].animator.cleanup();
        objs[i].animator = null;
      }
      if (objs[i].visible === true) {
        objs[i].visible = false;
      }
    }
    if (objs[i].type === "CustomSticker" && currentTimeInClip >= start && currentTimeInClip < end) {
      objs[i].displayFrameByTimestamp((currentTimeInClip - start) * 1e3);
    }
    if (hasOldAnimation(objs[i]) && !objs[i].animator) {
      let hasEnter = false;
      let hasExit = false;
      let startDuration = 0;
      let startDelay = 0;
      if (hasEnterAnimation(objs[i])) {
        hasEnter = true;
        startDuration = objs[i].animation.enter.duration;
        startDelay = start;
      }
      let exitStartAt = 0;
      let exitDuration = 0;
      if (hasExitAnimation(objs[i])) {
        hasExit = true;
        exitStartAt = end - objs[i].animation.exit.duration;
        exitDuration = objs[i].animation.exit.duration;
      }
      if (currentTimeInClip >= end) {
        if (objs[i].isType(elementType.video)) {
          objs[i].pause(true);
        }
        if (objs[i].visible) {
          objs[i].visible = false;
        }
      } else {
        if (objs[i].type === "CustomVideo" && currentTimeInClip >= start) {
          await controlVideoWhenPreview(objs[i], currentTimeInClip, startDelay, seek2);
        }
        if (hasEnter) {
          if (currentTimeInClip <= startDelay + startDuration) {
            let process2 = (currentTimeInClip - startDelay) / startDuration;
            process2 = process2 < 0 ? 0 : process2;
            process2 = process2 > 1 ? 1 : process2;
            doAnimate(objs[i], { ...objs[i].animation.enter, props: objs[i].animation.to }, process2, cacheCvs.width, cacheCvs.height);
          } else {
            doAnimate(objs[i], { ...objs[i].animation.enter, props: objs[i].animation.to }, 1, cacheCvs.width, cacheCvs.height);
          }
        }
        if (hasExit) {
          if (currentTimeInClip >= exitStartAt) {
            let process2 = (currentTimeInClip - exitStartAt) / exitDuration;
            process2 = process2 < 0 ? 0 : process2;
            process2 = process2 > 1 ? 1 : process2;
            doAnimate(objs[i], { ...objs[i].animation.exit, props: objs[i].animation.to }, process2, cacheCvs.width, cacheCvs.height);
          }
        }
      }
    } else {
      if (objs[i].isType(elementType.video)) {
        if (currentTimeInClip >= start && currentTimeInClip < end) {
          await controlVideoWhenPreview(objs[i], currentTimeInClip, start, seek2);
        } else if (currentTimeInClip >= end) {
          objs[i].pause(true);
        }
      }
    }
  }
  const backend = fabric.fabric.filterBackend;
  if (backend && backend.evictCachesForKey) {
    for (let i = 0; i < objs.length; i++) {
      if (objs[i].type === "CustomVideo") {
        backend.evictCachesForKey(objs[i]._objects[0].cacheKey);
        backend.evictCachesForKey(objs[i]._objects[0].cacheKey + "_filtered");
        objs[i]._objects[0].applyFilters();
      }
    }
  }
  const bgVideo = cacheCvs.backgroundImage;
  if (bgVideo && bgVideo.isType(elementType.video)) {
    await controlVideoWhenPreview(bgVideo, currentTimeInClip, 0, seek2);
    if (backend && backend.evictCachesForKey) {
      backend.evictCachesForKey(bgVideo._objects[0].cacheKey);
      backend.evictCachesForKey(bgVideo._objects[0].cacheKey + "_filtered");
      bgVideo._objects[0].applyFilters();
    }
  }
  cacheCvs.renderAll();
}
function getTransitionFrame(progress, transitionName, params, fromFrame, toFrame) {
  let canvas = document.getElementById("glTempCvs");
  if (!canvas) {
    canvas = document.createElement("canvas");
    canvas.id = "glTempCvs";
  }
  canvas.width = fabCanvasArray[0].width;
  canvas.height = fabCanvasArray[0].height;
  const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
  gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
  const buffer = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
  gl.bufferData(
    gl.ARRAY_BUFFER,
    new Float32Array([-1, -1, -1, 4, 4, -1]),
    // see a-big-triangle
    gl.STATIC_DRAW
  );
  gl.viewport(0, 0, canvas.width, canvas.height);
  const from = createTexture(gl, fromFrame);
  from.minFilter = gl.LINEAR;
  from.magFilter = gl.LINEAR;
  const to = createTexture(gl, toFrame);
  to.minFilter = gl.LINEAR;
  to.magFilter = gl.LINEAR;
  const transitionSource = transitions.find((t) => t.name.toLowerCase() === transitionName.toLowerCase());
  const transition = _default(gl, transitionSource);
  transition.draw(progress, from, to, canvas.width, canvas.height, params);
  transition.dispose();
  return canvas;
}
function playBgm(idx, tempTimestamp, bgAudio) {
  const clipSeekTime = tempTimestamp - getClipStartTime(idx);
  const audio = getBgmAudioByIndex(idx);
  if (audio) {
    if (bgAudio) {
      bgAudio.volume = 0;
    }
    audio.currentTime = clipSeekTime % audio.duration;
    audio.play();
  } else {
    const bgmInfo = bgmList.get(fabCanvasArray[idx].bgmId);
    if (bgAudio) {
      if (bgmInfo.enabled) {
        bgAudio.volume = backgroundAudioVolume;
      } else {
        bgAudio.volume = 0;
      }
    }
  }
  if (bgAudio && bgAudio.paused) {
    bgAudio.play();
  }
}
const audioFadeIn = 2;
const audioFadeOut = 2;
let cacheCvs1 = null;
let cacheCvs2 = null;
let pauseResolve = null;
let inPlay = false;
let loadController = null;
async function previewAll(start, seek2 = false) {
  var _a;
  !seek2 && playEmitter.emit(playStates.loadResourceStart);
  try {
    loadController = null;
    loadController = new AbortController();
    await waitResourceLoadAndSetUi(false, false, true, loadController);
    let includeSpeech = false;
    const clips = fabCanvasArray;
    for (let i = 0; i < clips.length; i++) {
      const speechInfo = speechList.get(clips[i].speechId);
      const hasText = speechInfo.type === "default" && speechInfo.default.text || speechInfo.type === "conversation";
      if (clips[i].loadList.includes("speech") && hasText && !includeSpeech) {
        includeSpeech = true;
      }
      clips[i].loadList = [];
    }
  } catch (error) {
    const isAbort = ((_a = error == null ? void 0 : error.cause) == null ? void 0 : _a.reason) === "abort";
    if (isAbort) {
      return;
    }
    throw error;
  } finally {
    loadController = null;
  }
  setVideoSpeed(fabCanvasArray);
  const end = getVideoDuration();
  !seek2 && playEmitter.emit(playStates.loadResourceEnd, end);
  const bgAudio = document.querySelector(`#${Constants.BgMusicId}`);
  let idx = findClipByStart(start);
  if (!cacheCvs1 && !cacheCvs2) {
    cacheCvs2 = new fabric.fabric.StaticCanvas(null, {
      width: fabCanvasArray[0].width,
      height: fabCanvasArray[0].height,
      // backgroundColor: 'white',
      enableRetinaScaling: false
    });
    cacheCvs1 = new fabric.fabric.StaticCanvas(null, {
      width: fabCanvasArray[0].width,
      height: fabCanvasArray[0].height,
      // backgroundColor: 'white',
      enableRetinaScaling: false
    });
  }
  cacheCvs1.rendering = false;
  cacheCvs2.rendering = false;
  const desCvs = displayCvs;
  let cacheNow = null;
  cacheNow = cacheCvs1;
  cacheNow.rendering = true;
  cacheNow.startat = getClipStartTime(idx);
  const startTimestamp = performance.now() + performance.timeOrigin;
  let needDraw = true;
  let translating = false;
  let transitionAt = 0;
  const fadeInTime = audioFadeIn;
  const fadeOutTime = audioFadeOut;
  const fadeOutStartTime = end - fadeOutTime;
  let firstEnd = true;
  requestAnimationFrame(async function renderVideo() {
    if (pauseResolve) {
      pauseVideoAndReturnZero(cacheCvs1, false);
      pauseVideoAndReturnZero(cacheCvs2, false);
      pauseAllBgmAndReturnZero(false);
      pauseResolve();
      pauseResolve = null;
      inPlay = false;
      return;
    }
    let tempTimestamp = (performance.now() + performance.timeOrigin - startTimestamp) / 1e3 + start;
    let showTime = tempTimestamp;
    if (tempTimestamp > end) {
      showTime = end;
    }
    !seek2 && playEmitter.emit(playStates.playing, showTime);
    !seek2 && (inPlay = true);
    if (tempTimestamp >= cacheNow.startat + fabCanvasArray[idx].duration) {
      pauseVideoAndReturnZero(cacheNow);
      pauseStickers(cacheNow);
      pauseSceneBgmByIndexAndReturnZero(idx);
      cacheNow.rendering = false;
      cacheNow._subtitles = null;
      cacheNow.clear();
      if (tempTimestamp < end) {
        if (translating) {
          cacheNow = cacheCvs1.rendering ? cacheCvs1 : cacheCvs2;
        } else {
          needDraw = true;
          cacheNow = cacheCvs1.rendering ? cacheCvs2 : cacheCvs1;
          cacheNow.startat = tempTimestamp;
          cacheNow.rendering = true;
        }
        idx + 1 > fabCanvasArray.length - 1 ? idx = fabCanvasArray.length - 1 : idx = idx + 1;
      }
      translating = false;
    }
    if (tempTimestamp > end) {
      if (firstEnd) {
        firstEnd = false;
        tempTimestamp = end;
      } else {
        pauseAllBgmAndReturnZero();
        pauseVideoAndReturnZero(cacheCvs1);
        pauseVideoAndReturnZero(cacheCvs2);
        const copyClip = fabCanvasArray[0].toCanvasElement();
        desCvs.getContext().drawImage(copyClip, 0, 0);
        playEmitter.emit(playStates.playEnd);
        inPlay = false;
        return;
      }
    }
    let toVolume = 0.1;
    let targetAudio = bgAudio;
    toVolume = backgroundAudioVolume;
    const sceneAudio = getBgmAudioByIndex(idx);
    if (sceneAudio) {
      targetAudio = sceneAudio;
      const info = bgmList.get(fabCanvasArray[idx].bgmId);
      toVolume = info.volume;
    }
    const bgmInfo = bgmList.get(fabCanvasArray[idx].bgmId);
    if (targetAudio && bgmInfo.enabled) {
      if (tempTimestamp <= fadeInTime && targetAudio) {
        const rate = tempTimestamp / fadeInTime;
        if (rate >= 1) {
          targetAudio.volume = toVolume;
        } else {
          targetAudio.volume = toVolume * rate;
        }
      } else if (tempTimestamp >= fadeOutStartTime && targetAudio) {
        const rate = (tempTimestamp - fadeOutStartTime) / fadeOutTime;
        if (rate >= 1) {
          targetAudio.volume = 0;
        } else {
          targetAudio.volume = toVolume - toVolume * rate;
        }
      } else {
        targetAudio.volume = toVolume;
      }
    }
    if (needDraw) {
      if (!seek2) {
        playClipAudio(idx, tempTimestamp);
        playBgm(idx, tempTimestamp, bgAudio);
      }
      await initClip(idx, cacheNow);
      mergeSubtitleAndMountOnCacheCanvas(cacheNow);
      if (!seek2) {
        await initVideoStartTime(cacheNow, tempTimestamp);
      }
      needDraw = false;
    }
    if (!seek2) {
      const speechInfo = speechList.get(fabCanvasArray[idx].speechId);
      if (speechInfo.type === "conversation") {
        const tempTimestampInScene = tempTimestamp - getClipStartTime(idx);
        playConversation(tempTimestampInScene, speechInfo);
      }
    }
    if (!translating && idx !== fabCanvasArray.length - 1) {
      const ts = fabCanvasArray[idx].transition;
      if (ts && ts.name !== "none" && idx < fabCanvasArray.length - 1) {
        const transitionDuration = fabCanvasArray[idx].transition.duration;
        const cacheNowEndTime = cacheNow.startat + fabCanvasArray[idx].duration;
        if (cacheNowEndTime < end) {
          if (cacheNowEndTime - tempTimestamp <= transitionDuration && tempTimestamp < cacheNowEndTime) {
            transitionAt = getTransitionStartTimeByIdx(idx);
            const cacheFree = cacheCvs1.rendering ? cacheCvs2 : cacheCvs1;
            cacheFree.startat = getClipStartTime(idx + 1);
            pauseSceneBgmByIndexAndReturnZero(idx);
            if (!seek2) {
              playClipAudio(idx + 1, tempTimestamp);
              playBgm(idx + 1, tempTimestamp, bgAudio);
            }
            await initClip(idx + 1, cacheFree);
            mergeSubtitleAndMountOnCacheCanvas(cacheFree);
            cacheFree.rendering = true;
            translating = true;
          }
        }
      }
    }
    if (cacheCvs1.rendering) {
      await renderInCache(cacheCvs1, tempTimestamp, seek2, true);
    }
    if (cacheCvs2.rendering) {
      await renderInCache(cacheCvs2, tempTimestamp, seek2, true);
    }
    desCvs.getObjects("CustomImage").forEach((item) => {
      item.dispose();
    });
    if (translating) {
      const transitionName = fabCanvasArray[idx].transition.name;
      const params = fabCanvasArray[idx].transition.params;
      const fromCvs = cacheNow.toCanvasElement();
      let toCvs;
      if (cacheNow === cacheCvs1) {
        toCvs = cacheCvs2.toCanvasElement();
      } else {
        toCvs = cacheCvs1.toCanvasElement();
      }
      const gl = getTransitionFrame((tempTimestamp - transitionAt) / fabCanvasArray[idx].transition.duration, transitionName, params || {}, fromCvs, toCvs);
      const tempImg = new fabric.fabric.Image(gl, {
        width: fabCanvasArray[0].width,
        height: fabCanvasArray[0].height,
        left: 0,
        top: 0
      });
      desCvs.add(tempImg);
    } else {
      desCvs.getContext().drawImage(cacheNow.lowerCanvasEl, 0, 0);
    }
    if (!seek2) {
      requestAnimationFrame(renderVideo);
    }
  });
}
function pausePreview() {
  return new Promise((resolve, reject) => {
    pauseResolve = resolve;
  });
}
async function seek(timestamp) {
  if (inPlay) {
    await pausePreview();
  }
  await previewAll(timestamp, true);
}
function createCustomImagePromise(url, options) {
  return new Promise((resolve, reject) => {
    fabric.fabric.CustomImage.fromURL(url, (img) => {
      resolve(img);
    }, {
      ...options
    });
  });
}
function createCustomVideoPromise(url, options) {
  return new Promise((resolve, reject) => {
    fabric.fabric.CustomVideo.fromCoverURL(url, (video) => {
      var _a;
      if (!((_a = video._objects[0]) == null ? void 0 : _a._element)) {
        reject(new Error("not get frontCoverUrl"));
        return;
      }
      resolve(video);
    }, {
      crossOrigin: "anonymous",
      ...options
    });
  });
}
async function getImagesAndVideosInConfig(masterplateConfig) {
  const images = [];
  const videos = [];
  const scenes = masterplateConfig.clips;
  for (let i = 0; i < scenes.length; i++) {
    const scene = scenes[i];
    const layers = scene.layers;
    for (let j = 0; j < layers.length; j++) {
      if (layers[j].property.type === "CustomImage") {
        await pretreatmentElement(layers[j]);
        images.push({
          clipIdx: i,
          layerIdx: j,
          animation: layers[j].animation ? layers[j].animation : null,
          start: layers[j].start,
          stop: layers[j].stop,
          property: layers[j].property
        });
      } else if (layers[j].property.type === "CustomVideo") {
        await pretreatmentElement(layers[j]);
        videos.push({
          clipIdx: i,
          layerIdx: j,
          start: layers[j].start,
          stop: layers[j].stop,
          animation: layers[j].animation ? layers[j].animation : null,
          property: layers[j].property
        });
      }
    }
  }
  return { images, videos };
}
function fillReplaceElements(fillArr, fillLength, fillSource) {
  for (let i = 0; i < fillSource.length; i++) {
    fillArr.push(JSON.parse(JSON.stringify(fillSource[i])));
    if (fillArr.length === fillLength) return;
  }
  fillReplaceElements(fillArr, fillLength, fillSource);
}
function filterAnimation(obj) {
  var _a, _b;
  const tempAni = obj.animation;
  if (((_a = tempAni == null ? void 0 : tempAni.enter) == null ? void 0 : _a.name) === "none") {
    delete tempAni.enter;
  }
  if (((_b = tempAni == null ? void 0 : tempAni.exit) == null ? void 0 : _b.name) === "none") {
    delete tempAni.exit;
  }
  const keys = Object.keys(tempAni);
  if (keys.length === 0 || keys.length === 1 && keys[0] === "to") {
    delete obj.animation;
  }
}
function _fabricObjToLayerObj(obj, excludeProperty = []) {
  const _obj = fabricObjToLayerObj(obj);
  for (let i = 0; i < excludeProperty.length; i++) {
    delete _obj[excludeProperty[i]];
  }
  return _obj;
}
function getLayerConfig(element, dealWidthAnimation = true, needCheckAvatar = false) {
  let layer = null;
  const tempLayer = element;
  if (tempLayer.type === "textbox") {
    layer = {
      type: "object"
    };
    layer.property = _fabricObjToLayerObj(tempLayer, ["_selected", "_addIndex"]);
    layer.property.fontFamily = layer.property.fontFamily.split(",")[0].trim();
  } else if (tempLayer.type === "CustomIcon") {
    layer = {
      type: "object"
    };
    layer.property = _fabricObjToLayerObj(tempLayer, ["_selected", "_addIndex"]);
  } else if (tempLayer.type === "Avatar") ;
  else if (tempLayer.type === "CustomImage") {
    layer = {
      type: "object"
    };
    layer.property = _fabricObjToLayerObj(tempLayer, ["_selected", "_addIndex"]);
  } else if (tempLayer.type === "CustomVideo") {
    layer = {
      type: "video"
    };
    layer.property = _fabricObjToLayerObj(tempLayer, ["_selected", "_addIndex"]);
    layer.volume = layer.property._volume;
    layer.loop = layer.property._loop;
  } else if (tempLayer.type === "CustomSticker") {
    layer = {
      type: "object"
    };
    layer.property = _fabricObjToLayerObj(tempLayer, ["_selected", "_addIndex"]);
  }
  if (dealWidthAnimation && layer.type !== "avatar" && layer.property.animation) {
    delete layer.property.animation;
    layer.animation = { ...tempLayer.animation };
    filterAnimation(layer);
  }
  return layer;
}
function replaceText(speechs, config2) {
  for (let i = 0; i < config2.clips.length; i++) {
    const scene = config2.clips[i];
    scene.speech.default.text = speechs[i];
    delete scene.speech.default.resourceInfo;
    delete scene.speech.default.subtitles;
  }
}
let allAudioList = [];
function getAllAudioList() {
  return new Promise((resolve, reject) => {
    if (allAudioList.length > 0) {
      resolve(allAudioList);
    } else {
      jqAjaxPromiseWithHandleException({
        url: "/ai/audio/list-v3",
        type: "POST",
        data: {
          audio_type: "app"
        }
      }).then((res2) => {
        resolve(res2.data.list);
      });
    }
  });
}
async function getAudioList(data = {}) {
  if (data.gender === 0) {
    data.gender = 2;
  }
  if (!allAudioList.length) {
    allAudioList = await getAllAudioList();
  }
  if (data.audio_type) {
    delete data.audio_type;
  }
  const list = [];
  for (let i = 0; i < allAudioList.length; i++) {
    const item = allAudioList[i];
    let isPush = true;
    for (const key in data) {
      if (Object.hasOwnProperty.call(data, key)) {
        if (data[key] !== item[key]) {
          isPush = false;
          break;
        }
      }
    }
    if (isPush) {
      list.push(item);
    }
  }
  return list;
}
async function getModel(data = {}) {
  const models = await getAudioList(data);
  if (models.length > 0) {
    return models[0];
  } else {
    return null;
  }
}
async function replaceVoiceModel(lan, config2) {
  for (let i = 0; i < config2.clips.length; i++) {
    const scene = config2.clips[i];
    const oldProperty = JSON.parse(JSON.stringify(scene.speech.default.property));
    let audioId = 0;
    if (window.api_env === "dev") {
      audioId = oldProperty.gender === 1 ? 750 : 751;
    } else {
      audioId = oldProperty.gender === 1 ? 2364 : 2363;
    }
    const toProperty = await getModel({
      // id: oldProperty.gender === 1 ? 750 : 751
      id: audioId
      // country: lan,
      // is_free: 1
    });
    if (toProperty) {
      scene.speech.default.property = toProperty;
    }
    delete scene.speech.default.resourceInfo;
    delete scene.speech.default.subtitles;
  }
}
async function replaceGoods(replaceElements, masterplateConfig) {
  const toConfig = JSON.parse(JSON.stringify(masterplateConfig));
  let firstSceneTextStyle = null;
  initSubtitleConfig(toConfig);
  for (let i = 0; i < toConfig.clips.length; i++) {
    await initConfig(toConfig.clips[i], firstSceneTextStyle, true, speechList, bgmList);
    if (i === 0) {
      firstSceneTextStyle = { ...toConfig.clips[i].textStyle };
    }
  }
  replaceText(replaceElements.speechs, toConfig);
  replaceVoiceModel(replaceElements.lan, toConfig);
  const { images, videos } = await getImagesAndVideosInConfig(masterplateConfig);
  const replaceImages = replaceElements.images || [];
  const replaceVideos = replaceElements.videos || [];
  const replaceVideosButIsImages = [];
  const replaceImagesButIsVideos = [];
  if (videos && videos.length && replaceVideos.length) {
    if (videos.length > replaceVideos.length) {
      const _replaceVideos = JSON.parse(JSON.stringify(replaceVideos));
      fillReplaceElements(replaceVideos, videos.length, _replaceVideos);
    } else if (replaceVideos.length > videos.length) {
      replaceVideos.length = videos.length;
    }
  } else if (videos.length && !replaceVideos.length) {
    if (replaceImages.length) {
      const _replaceImages = JSON.parse(JSON.stringify(replaceImages));
      fillReplaceElements(replaceVideosButIsImages, videos.length, _replaceImages);
    }
  }
  if (images.length && replaceImages.length) {
    if (images.length > replaceImages.length) {
      const _replaceImages = JSON.parse(JSON.stringify(replaceImages));
      fillReplaceElements(replaceImages, images.length, _replaceImages);
    } else if (replaceImages.length > images.length) {
      replaceImages.length = images.length;
    }
  } else if (images.length && !replaceImages.length) {
    if (replaceVideos.length) {
      const _replaceVideos = JSON.parse(JSON.stringify(replaceVideos));
      fillReplaceElements(replaceImagesButIsVideos, images.length, _replaceVideos);
    }
  }
  if (replaceImages.length) {
    for (let i = 0; i < images.length; i++) {
      const data = await requestUrlByKey(replaceImages[i].key);
      const url = data.static_url || data.url;
      const _staticUrl = data.static_url;
      const sourceImage = await createCustomImagePromise(url, { _urlkey: replaceImages[i].key, _staticUrl });
      const beReplacedImage = await layerToFabricObj(images[i].property);
      beReplacedImage.animation = images[i].animation;
      const toW = beReplacedImage.getScaledWidth();
      const transform = fabric.fabric.util.saveObjectTransform(beReplacedImage);
      sourceImage.set(transform);
      sourceImage.scaleToWidth(toW);
      if (beReplacedImage.animations) {
        sourceImage.animations = JSON.parse(JSON.stringify(beReplacedImage.animations));
      }
      if (beReplacedImage.animation) {
        sourceImage.animation = JSON.parse(JSON.stringify(beReplacedImage.animation));
      }
      const layer = getLayerConfig(sourceImage);
      toConfig.clips[images[i].clipIdx].layers[images[i].layerIdx] = layer;
    }
  }
  if (replaceImagesButIsVideos.length) {
    for (let i = 0; i < images.length; i++) {
      const data = await requestUrlByKey(replaceImagesButIsVideos[i].key);
      const url = data.static_url || data.url;
      const _staticUrl = data.static_url;
      const frameData = await requestUrlByKey(replaceImagesButIsVideos[i].frameKey);
      const frameUrl = frameData.static_url || frameData.url;
      const staticFrontCoverUrl = data == null ? void 0 : data.static_url;
      const vdOptions = {
        _videoSrc: url,
        _frontCoverUrl: frameUrl,
        crossOrigin: "anonymous",
        _loaded: false,
        _volume: 0,
        _duration: parseInt(replaceImagesButIsVideos[i].duration),
        _start: 0,
        _end: parseInt(replaceImagesButIsVideos[i].duration),
        // _resourceList: options.resourceList,
        _speed: "1.0"
        // _porn: options?.porn || false
      };
      if (_staticUrl) {
        vdOptions._staticUrl = _staticUrl;
      } else {
        vdOptions._urlkey = replaceImagesButIsVideos[i].key;
      }
      if (staticFrontCoverUrl) {
        vdOptions._frontCoverStaticUrl = staticFrontCoverUrl;
      } else {
        vdOptions._frontCoverKey = replaceImagesButIsVideos[i].frameKey;
      }
      const sourceImage = await createCustomVideoPromise(frameUrl, vdOptions);
      const beReplacedImage = await layerToFabricObj(images[i].property);
      beReplacedImage.animation = images[i].animation;
      const toW = beReplacedImage.getScaledWidth();
      const transform = fabric.fabric.util.saveObjectTransform(beReplacedImage);
      sourceImage.set(transform);
      sourceImage.scaleToWidth(toW);
      if (beReplacedImage.animations) {
        sourceImage.animations = JSON.parse(JSON.stringify(beReplacedImage.animations));
      }
      if (beReplacedImage.animation) {
        sourceImage.animation = JSON.parse(JSON.stringify(beReplacedImage.animation));
      }
      const layer = getLayerConfig(sourceImage);
      toConfig.clips[images[i].clipIdx].layers[images[i].layerIdx] = layer;
    }
  }
  if (replaceVideos.length) {
    for (let i = 0; i < videos.length; i++) {
      const data = await requestUrlByKey(replaceVideos[i].key);
      const url = data.static_url || data.url;
      const _staticUrl = data.static_url;
      const frameData = await requestUrlByKey(replaceVideos[i].frameKey);
      const frameUrl = frameData.static_url || frameData.url;
      const staticFrontCoverUrl = data == null ? void 0 : data.static_url;
      const vdOptions = {
        _videoSrc: url,
        _frontCoverUrl: frameUrl,
        crossOrigin: "anonymous",
        _loaded: false,
        _volume: 0,
        _duration: parseInt(replaceVideos[i].duration),
        _start: 0,
        _end: parseInt(replaceVideos[i].duration),
        // _resourceList: options.resourceList,
        _speed: "1.0"
        // _porn: options?.porn || false
      };
      if (_staticUrl) {
        vdOptions._staticUrl = _staticUrl;
      } else {
        vdOptions._urlkey = replaceVideos[i].key;
      }
      if (staticFrontCoverUrl) {
        vdOptions._frontCoverStaticUrl = staticFrontCoverUrl;
      } else {
        vdOptions._frontCoverKey = replaceVideos[i].frameKey;
      }
      const sourceVideo = await createCustomVideoPromise(frameUrl, vdOptions);
      const beReplacedVideo = await layerToFabricObj(videos[i].property);
      beReplacedVideo.animation = videos[i].animation;
      const toW = beReplacedVideo.getScaledWidth();
      const transform = fabric.fabric.util.saveObjectTransform(beReplacedVideo);
      sourceVideo.set(transform);
      sourceVideo.scaleToWidth(toW);
      if (beReplacedVideo.animations) {
        sourceVideo.animations = JSON.parse(JSON.stringify(beReplacedVideo.animations));
      }
      if (beReplacedVideo.animation) {
        sourceVideo.animation = JSON.parse(JSON.stringify(beReplacedVideo.animation));
      }
      const layer = getLayerConfig(sourceVideo);
      toConfig.clips[videos[i].clipIdx].layers[videos[i].layerIdx] = layer;
      sourceVideo.destroySelf();
    }
  }
  if (replaceVideosButIsImages.length) {
    for (let i = 0; i < videos.length; i++) {
      const data = await requestUrlByKey(replaceVideosButIsImages[i].key);
      const url = data.static_url || data.url;
      const _staticUrl = data.static_url;
      const sourceImage = await createCustomImagePromise(url, { _urlkey: replaceVideosButIsImages[i].key, _staticUrl });
      const beReplacedVideo = await layerToFabricObj(videos[i].property);
      beReplacedVideo.animation = videos[i].animation;
      const toW = beReplacedVideo.getScaledWidth();
      const transform = fabric.fabric.util.saveObjectTransform(beReplacedVideo);
      sourceImage.set(transform);
      sourceImage.scaleToWidth(toW);
      if (beReplacedVideo.animations) {
        sourceImage.animations = JSON.parse(JSON.stringify(beReplacedVideo.animations));
      }
      if (beReplacedVideo.animation) {
        sourceImage.animation = JSON.parse(JSON.stringify(beReplacedVideo.animation));
      }
      const layer = getLayerConfig(sourceImage);
      toConfig.clips[videos[i].clipIdx].layers[videos[i].layerIdx] = layer;
    }
  }
  return toConfig;
}
function dataURLtoFile(urlData, fileName) {
  const bytes = window.atob(urlData.split(",")[1]);
  const mime = urlData.split(",")[0].match(/:(.*?);/)[1];
  const ab = new ArrayBuffer(bytes.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i);
  }
  return new File([ab], fileName, { type: mime });
}
function generateSceneThumbnail(index) {
  const dataUrl = fabCanvasArray[0].toDataURL({
    // format: 'jpeg',
    quality: 1,
    multiplier: 0.4
  });
  const a = document.createElement("a");
  a.innerText = "down";
  a.download = true;
  a.href = dataUrl;
  document.body.appendChild(a);
  return dataURLtoFile(dataUrl, "1.png");
}
function getVideoFrame() {
  return generateSceneThumbnail();
}
function dealwithTimelineInConfig(scene) {
  const duration = scene.duration;
  const objs = scene.layers;
  objs.forEach((obj) => {
    let start = hasKey(obj, "start") ? obj.start : null;
    const stop = hasKey(obj, "stop") ? obj.stop : null;
    if (start !== null) {
      if (start >= duration) {
        start = duration - 1;
        obj.start = start;
      }
    }
    if (stop !== null) {
      if (stop >= duration) {
        delete obj.stop;
      }
    }
  });
}
function refreshConfig(config2) {
  const clips = config2.clips;
  const videoDuration = getVideoDuration();
  config2.totalDuration = videoDuration;
  for (let i = 0; i < fabCanvasArray.length; i++) {
    clips[i].duration = fabCanvasArray[i].duration;
    clips[i].speech.default.duration = speechList.get(fabCanvasArray[i].speechId).default.duration;
    if (clips[i].transition.name === "none") {
      delete clips[i].transition;
    }
  }
  for (let i = 0; i < clips.length; i++) {
    dealwithTimelineInConfig(clips[i]);
  }
}
window.replaceGoods = replaceGoods;
window.loadFromJson = loadFromJson;
window.previewAll = previewAll;
window.pausePreview = pausePreview;
window.seek = seek;
window.getVideoFrame = getVideoFrame;
window.refreshConfig = refreshConfig;
